
function SvgComponent(props: any) {
    return (
        <svg
            width={499}
            height={452}
            viewBox="0 0 499 452"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <g clipPath="url(#clip0_874_76773)">
            <path
            d="M212.935 233.161l-.783-1.664-114.649 61.23.783 1.663 114.649-61.229z"
            fill="#fff"
            />
            <path
            d="M409.555 407.432l20.084 12.229 16.467-8.241-24.076-14.621-12.475 10.633z"
            fill="url(#paint0_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M425.897 397.463l-14.221-8.906c-.374-.266-.749-.266-1.123-.266s-.748.133-1.123.266l-14.096 7.975c-.749.399-1.123 1.329-1.123 2.127 0 .93.499 1.728 1.123 2.127l14.221 8.772c.374.133.749.266 1.123.266s.748-.133 1.123-.266l14.096-7.842c.749-.399 1.123-1.329 1.123-2.127.125-.93-.374-1.728-1.123-2.126z"
            fill="#fff"
            />
            <path
            d="M409.555 388.69l-14.096 7.842c-.25.133-.624.399-.749.665-.249.399-.374.93-.374 1.462 0 .798.624 1.595 1.247 1.994l14.097 8.64c.25.133.499.265.624.265h.374c.374 0 .749-.132 1.123-.265l13.972-7.71c.249-.133.499-.399.624-.531.374-.399.499-.931.499-1.463 0-.797-.624-1.595-1.248-1.993l-13.972-8.773c-.249-.133-.748-.266-.998-.266h-.374c-.25-.133-.499 0-.749.133z"
            fill="#F8F8F9"
            />
            <path
            d="M409.681 388.822l-13.972 7.843c-.25.133-.624.398-.749.664-.249.399-.374.931-.374 1.462 0 .665.748 1.595 1.372 1.861l13.847 8.507c.25.133.375.133.624.266h.374c.25 0 .749-.133.998-.399l13.723-7.576c.249-.133.499-.399.624-.532.374-.399.499-.93.374-1.462 0-.665-.749-1.595-1.248-1.861l-13.597-8.507c-.25-.133-.749-.399-.998-.399h-.375c-.124 0-.374 0-.623.133z"
            fill="#F1F1F3"
            />
            <path
            d="M409.805 389.088l-13.848 7.843c-.249.133-.623.398-.748.664-.374.399-.374.931-.25 1.33 0 .664.874 1.462 1.373 1.86l13.597 8.374c.25.133.375.133.624.133h.374c.25 0 .749-.266.998-.398l13.598-7.444c.125-.133.499-.399.624-.532.374-.398.499-.93.374-1.462 0-.664-.873-1.462-1.372-1.728l-13.348-8.374c-.25-.133-.749-.399-.998-.399h-.375c-.249-.132-.499 0-.623.133z"
            fill="#EAEBEC"
            />
            <path
            d="M409.805 389.222l-13.848 7.71c-.124.132-.623.398-.748.664-.374.399-.374.931-.25 1.329 0 .532.998 1.463 1.497 1.728l13.473 8.374c.25.133.375.133.624.133h.374c.25 0 .749-.266.998-.398l13.349-7.444c.124-.133.623-.399.623-.532.375-.398.499-.93.25-1.462 0-.532-.998-1.462-1.372-1.728l-13.099-8.108c-.125-.133-.749-.399-.998-.399h-.374c0-.133-.25 0-.499.133z"
            fill="#E3E4E6"
            />
            <path
            d="M409.93 389.355l-13.723 7.709c-.124.133-.748.399-.748.532-.374.399-.374.93-.125 1.329 0 .399 1.248 1.329 1.497 1.595l13.224 8.241c.249.133.374.133.623.133h.375c.124 0 .748-.266.998-.399l13.223-7.31c.125-.133.624-.399.624-.532.374-.399.499-.93.249-1.329 0-.399-1.122-1.329-1.497-1.595l-12.724-7.975c-.125-.133-.749-.399-.873-.399l-.25-.133c-.374 0-.624 0-.873.133z"
            fill="#DDDDE0"
            />
            <path
            d="M410.055 389.486l-13.598 7.577c-.124 0-.748.399-.748.532-.374.265-.374.93-.125 1.329 0 .266 1.372 1.329 1.622 1.462l12.974 8.108c.249.133.374.133.624.133l.249-.133c.125 0 .873-.399.873-.399l12.974-7.177c.125 0 .624-.399.624-.399.374-.266.499-.931.125-1.329 0-.266-1.248-1.33-1.497-1.462l-12.475-7.843c-.125-.133-.749-.399-.873-.399l-.25-.132c-.125 0-.374.132-.499.132z"
            fill="#D6D6DA"
            />
            <path
            d="M410.178 389.753l-13.473 7.577c-.124 0-.748.398-.748.531-.374.266-.374.931-.125 1.196 0 .266 1.497 1.197 1.622 1.33l12.849 7.975c.25.133.374.133.624 0l.249-.133c.125 0 .874-.399.874-.399l12.724-7.045.624-.398c.374-.266.499-.931.125-1.33 0-.265-1.373-1.196-1.497-1.329l-12.101-7.576c-.125 0-.749-.399-.873-.399l-.25-.133c-.249 0-.499 0-.624.133z"
            fill="#CFD0D3"
            />
            <path
            d="M410.18 389.886l-13.473 7.576s-.749.399-.749.532c-.374.266-.374.93 0 1.196 0 .133 1.622 1.197 1.747 1.197l12.6 7.842c.249.133.374.133.623 0l.25-.133.873-.399 12.6-6.912.624-.398c.374-.266.374-.931 0-1.197 0-.133-1.497-1.063-1.622-1.196l-11.851-7.444-.749-.531-.249-.133c-.125-.133-.375-.133-.624 0z"
            fill="#C8C9CD"
            />
            <path
            d="M410.927 390.02c-.25-.133-.374-.133-.624 0l-14.097 7.975c-.374.266-.374.93 0 1.196l14.222 8.773c.125.133.374.133.624 0l14.096-7.842c.375-.266.375-.931 0-1.197l-14.221-8.905z"
            fill="#C1C2C7"
            />
            <path
            d="M397.828 396.93l11.976-6.646c.749-.398 1.497-.398 2.246 0l11.851 7.311h1.996v1.728c0 .266-.125.532-.374.798l-13.224 7.576c-.748.399-1.497.399-2.245 0l-13.598-8.241c-.249-.133-.374-.399-.499-.798v-1.728h1.871z"
            fill="#0EA59D"
            />
            <path
            d="M411.052 408.096c-.375 0-.749-.133-1.123-.266l-13.598-8.241c-.249-.133-.499-.399-.499-.798V396.798h2.121l11.976-6.646a2.496 2.496 0 012.37 0l11.727 7.31h2.12v1.994c0 .266-.249.532-.499.798l-13.223 7.576c-.624.133-.998.266-1.372.266zm-15.095-9.57c0 .398.125.531.374.664l13.598 8.241a2.029 2.029 0 002.121 0l13.223-7.576c.25-.133.374-.399.374-.665v-1.595h-1.871l-11.851-7.311a2.033 2.033 0 00-2.121 0l-12.101 6.647h-1.871v1.595h.125z"
            fill="#131A2D"
            />
            <path
            d="M396.332 396.001l13.598-7.577c.748-.399 1.497-.399 2.245 0l13.349 8.241c.623.399.623 1.196 0 1.595l-13.224 7.577c-.748.398-1.497.398-2.245 0l-13.598-8.241c-.749-.399-.749-1.197-.125-1.595z"
            fill="#fff"
            />
            <path
            d="M425.399 397.995l-4.116 2.392-9.232 5.184c-.748.399-1.497.399-2.245 0l-9.606-5.848-3.244-1.861-.873-.532c-.624-.399-.624-1.196 0-1.595l13.598-7.577c.748-.398 1.497-.398 2.245 0l9.481 5.849 3.868 2.26c.748.531.748 1.329.124 1.728z"
            fill="#fff"
            />
            <path
            d="M411.053 405.97c-.374 0-.748-.133-1.122-.266l-9.606-5.848-3.992-2.393c-.374-.133-.499-.532-.499-.93 0-.399.249-.798.499-.931l13.598-7.576a2.496 2.496 0 012.37 0l9.481 5.848 3.867 2.26c.374.133.499.531.499.93s-.249.798-.499.931l-4.241 2.525-9.232 5.184c-.374.266-.748.266-1.123.266zm-.124-17.944c-.375 0-.749.133-.998.265l-13.598 7.577c-.25.133-.374.399-.374.665 0 .265.124.531.374.664l3.992 2.393 9.606 5.848a2.027 2.027 0 002.12 0l9.232-5.184 4.117-2.392a.74.74 0 00.374-.665c0-.266-.125-.532-.374-.664l-3.868-2.26-9.481-5.849c-.374-.265-.748-.398-1.122-.398z"
            fill="#000"
            />
            <path
            d="M368.263 257.764c-1.497 0-3.118-.532-4.366-1.463l-34.805-22.064.873-1.595 34.93 22.064c1.996 1.463 4.616 1.595 6.612.266l18.588-11.697.873 1.595-18.588 11.697c-1.372.798-2.744 1.197-4.117 1.197zM183.135 228.255l-11.352-7.843c-2.62-1.861-4.117-4.918-4.117-8.241.125-3.323 1.747-6.247 4.491-7.975l49.027-29.774c1.497-.931 2.495-2.659 2.495-4.52 0-1.86-.873-3.588-2.37-4.519l-22.83-14.355.874-1.595 22.829 14.355c1.996 1.329 3.243 3.589 3.243 6.114 0 2.526-1.247 4.786-3.368 6.115l-49.027 29.774c-2.245 1.329-3.493 3.722-3.617 6.38-.125 2.659 1.122 5.184 3.243 6.646l11.352 7.843-.873 1.595z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M479.166 343.895l-35.679 21.002-23.952-14.489 34.681-20.337 24.95 13.824z"
            fill="url(#paint1_linear_874_76773)"
            />
            <path
            d="M226.174 246.996l-22.954-15.153c-4.616-3.057-10.479-3.057-15.22 0l-13.099 8.507c-5.863 3.855-13.223 3.722-19.086-.133l-52.52-35.224 4.865-8.241 52.645 35.091c2.994 1.994 6.611 1.994 9.481.133l13.098-8.507c7.61-4.918 17.091-4.918 24.576.133l22.954 15.153-4.74 8.241zM215.049 296.701l-37.262-24.247-.91 1.588 37.261 24.248.911-1.589zM314.87 382.974l-55.264-38.547c-2.37-1.595-3.742-4.387-3.618-7.444.125-3.057 1.622-5.715 3.992-7.177l56.138-34.693.873 1.595-56.137 34.693a6.79 6.79 0 00-3.119 5.715c0 2.393.998 4.52 2.869 5.849l55.264 38.547-.998 1.462z"
            fill="#fff"
            />
            <path
            d="M393.588 319.704l-38.049-23.66c-1.996-1.196-4.491-1.196-6.487.266l-10.853 7.975c-5.364 3.988-12.475 4.12-18.089.532l-27.944-18.343 4.741-8.242 27.944 18.343c2.495 1.596 5.738 1.596 8.108-.265l10.854-7.976c4.74-3.456 11.102-3.721 16.217-.664l38.049 23.66-4.491 8.374zM180.639 379.119l-4.616-8.241 50.898-32.433c1.872-1.196 2.994-3.19 2.994-5.582 0-2.393-.998-4.387-2.869-5.716l-11.976-8.108c-4.74-3.19-7.36-8.507-7.235-14.489.124-5.981 3.118-11.165 7.859-14.089l31.437-19.008 4.491 8.374-31.437 19.008c-1.996 1.196-3.244 3.456-3.368 5.981 0 2.526.998 4.785 2.994 6.115l11.976 8.108c4.491 3.057 7.235 8.241 7.11 13.956-.124 5.716-2.869 10.9-7.485 13.691l-50.773 32.433zM287.427 264.409l-4.491-8.374 49.151-30.173c1.622-.93 2.62-2.658 2.745-4.652.124-1.994-.624-3.855-2.121-4.918l-7.111-5.716c-3.493-2.791-5.364-7.177-4.99-11.83.374-4.652 2.869-8.639 6.612-10.766l49.276-28.046 4.242 8.507-49.152 27.913c-1.497.93-1.871 2.392-1.871 3.057s0 2.127 1.372 3.323l7.111 5.716c3.867 3.19 5.988 8.108 5.738 13.292-.249 5.184-2.994 9.836-7.235 12.361l-49.276 30.306z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M490.644 304.684l-29.316 20.204-28.568-16.615 28.568-19.938 29.316 16.349z"
            fill="url(#paint2_linear_874_76773)"
            />
            <path
            d="M467.69 171.896l-38.423 23.792c-1.247.798-2.744.798-3.992 0l-30.189-18.475 43.787-25.92 28.817 16.881c1.373.664 1.373 2.791 0 3.722z"
            fill="url(#paint3_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M345.559 146.242l42.54-25.521c.374-.266.873-.399 1.372-.399.499 0 .874.133 1.373.399l58.882 34.294c.873.531 1.372 1.595 1.372 2.658s-.499 2.127-1.372 2.658l-42.54 25.388a2.299 2.299 0 01-1.248.399c-.499 0-.873-.133-1.372-.399l-58.882-34.16c-.873-.532-1.372-1.595-1.372-2.659-.125-1.196.374-2.127 1.247-2.658z"
            fill="#fff"
            />
            <path
            d="M388.223 120.988a2.304 2.304 0 011.248-.399c.374 0 .998.133 1.372.399l58.757 34.16c.499.266.874.931.998 1.462.125.266.125.798.125 1.064 0 .93-.748 1.994-1.497 2.525l-42.041 24.989a2.298 2.298 0 01-1.247.399h-.499c-.25 0-.499-.133-.749-.266l-58.882-34.16c-.499-.266-.873-.798-.998-1.33-.124-.398-.124-.797-.124-1.196 0-.93.748-1.994 1.497-2.525l42.04-25.122z"
            fill="#F8F8F9"
            />
            <path
            d="M388.349 121.119c.375-.265.749-.265 1.248-.265.374 0 .998.265 1.247.398l58.633 34.161c.499.266.873.93.873 1.462.125.266 0 .665 0 1.063 0 .798-.873 1.861-1.622 2.393l-41.541 24.723c-.25.133-.874.399-1.248.399h-.499c-.249 0-.499-.133-.748-.266l-58.882-34.16c-.499-.266-.874-.931-.874-1.33-.124-.266 0-.797 0-1.063 0-.798.998-1.994 1.622-2.393l41.791-25.122z"
            fill="#F1F1F3"
            />
            <path
            d="M388.473 121.386c.375-.266.749-.266 1.123-.266s.998.266 1.248.532l58.507 34.028c.499.265.749.93.749 1.462.125.265-.125.664-.125.93 0 .665-1.123 1.861-1.746 2.127l-41.043 24.457c-.25.133-.873.399-1.248.399-.124 0-.374.133-.499 0-.249 0-.499-.133-.748-.266l-58.882-34.16c-.499-.266-.749-.931-.749-1.463-.124-.265.125-.664.125-1.063 0-.665 1.123-1.861 1.747-2.26l41.541-24.457z"
            fill="#EAEBEC"
            />
            <path
            d="M388.598 121.652c.374-.133.748-.266.998-.266.249 0 .998.399 1.247.531l58.508 34.028c.499.266.748.931.624 1.462.124.266-.25.665-.25.931 0 .664-1.372 1.728-1.746 1.994l-40.544 24.191c-.25.133-.873.532-1.123.532-.125 0-.374.133-.499.133-.249 0-.499 0-.748-.133l-59.007-34.427c-.499-.266-.749-.93-.624-1.462-.125-.266.25-.664.25-.93 0-.665 1.372-1.728 1.871-2.127l41.043-24.457z"
            fill="#E3E4E6"
            />
            <path
            d="M388.723 121.785c.249-.133.623-.266.998-.133.249 0 1.122.398 1.247.531l58.258 33.895c.499.266.749 1.064.499 1.462 0 .133-.374.665-.374.798 0 .532-1.497 1.728-1.871 1.861l-40.045 23.793c-.125.132-.998.531-1.123.531-.124 0-.374.133-.499.133-.249 0-.499 0-.748-.133l-58.882-34.16c-.499-.266-.749-.931-.499-1.463-.125-.132.374-.664.374-.797 0-.532 1.497-1.728 1.871-1.994l40.794-24.324z"
            fill="#DDDDE0"
            />
            <path
            d="M388.847 122.05c.25-.133.624-.266.873-.133.125 0 1.123.532 1.248.532l58.133 33.762c.499.266.624 1.063.375 1.462 0 .133-.499.532-.499.665 0 .398-1.747 1.595-1.996 1.728l-39.546 23.527c-.125.132-.998.531-1.123.531 0 0-.374.133-.499.133-.249.133-.499 0-.748-.133l-58.882-34.16c-.499-.266-.624-1.064-.375-1.462 0-.133.499-.665.499-.798 0-.399 1.747-1.595 1.996-1.861l40.544-23.793z"
            fill="#D6D6DA"
            />
            <path
            d="M388.848 122.184c.25-.133.624-.133.874-.133.124 0 1.122.531 1.247.664l58.009 33.762c.499.266.624 1.064.249 1.462 0 .133-.623.532-.623.665 0 .266-1.872 1.462-2.121 1.595l-39.047 23.261c-.125 0-.998.532-1.123.532 0 0-.374.133-.499.133-.249.133-.499.133-.748-.133l-58.882-34.161c-.499-.266-.624-1.063-.25-1.462 0-.133.624-.665.624-.665 0-.265 1.996-1.595 2.121-1.727l40.169-23.793z"
            fill="#CFD0D3"
            />
            <path
            d="M388.972 122.449a.753.753 0 01.749 0s1.123.665 1.247.665l57.884 33.629c.499.266.499 1.063.125 1.462l-.748.532c0 .133-2.121 1.462-2.121 1.462l-38.548 22.862-.998.532s-.374.266-.499.266a.751.751 0 01-.748 0l-58.882-34.161c-.499-.266-.499-1.063-.125-1.462 0 0 .748-.532.748-.665s2.121-1.462 2.246-1.595l39.67-23.527z"
            fill="#C8C9CD"
            />
            <path
            d="M389.098 122.715a.751.751 0 01.748 0l58.882 34.293c.499.266.499 1.197 0 1.463l-42.54 25.387a.751.751 0 01-.748 0l-58.882-34.293c-.499-.266-.499-1.196 0-1.462l42.54-25.388z"
            fill="#C1C2C7"
            />
            <path
            d="M449.226 155.679l-3.243-.398-55.514-32.3c-.873-.532-1.871-.532-2.745 0l-40.044 23.793-1.996-.266v2.127c0 .398.124.664.499.93l57.884 33.895c.873.531 1.871.531 2.744 0l41.791-24.591c.375-.265.499-.531.499-.93v-2.26h.125z"
            fill="#0EA59D"
            />
            <path
            d="M405.564 183.859c-.499 0-.998-.133-1.373-.399l-57.884-33.895c-.374-.133-.499-.532-.623-.93v-2.393l2.12.266 39.92-23.66a2.78 2.78 0 012.87 0l55.513 32.3 3.244.398v2.393c0 .399-.25.665-.624.93l-41.791 24.591c-.499.266-.873.399-1.372.399zm-59.631-35.357c0 .398.125.664.499.797l57.884 33.895c.749.532 1.747.532 2.62 0l41.666-24.59c.25-.133.499-.399.499-.798v-1.994l-3.118-.398-55.514-32.3c-.749-.532-1.747-.399-2.62 0l-40.045 23.793-1.871-.266v1.861z"
            fill="#131A2D"
            />
            <path
            d="M448.727 154.616l-58.258-33.895c-.873-.532-1.871-.532-2.745 0l-41.417 24.59a1.052 1.052 0 000 1.861l57.884 33.895c.874.532 1.872.532 2.745 0l41.791-24.59c.624-.266.624-1.33 0-1.861z"
            fill="#fff"
            />
            <path
            d="M346.307 147.04l4.99 2.924 52.894 30.838c.873.531 1.871.531 2.744 0l36.926-21.799 3.867-2.26.998-.532c.749-.399.749-1.462 0-1.994l-58.258-33.894c-.873-.532-1.871-.532-2.744 0l-36.802 21.799-4.74 2.791c-.624.665-.624 1.728.125 2.127z"
            fill="#fff"
            />
            <path
            d="M405.564 181.466c-.499 0-.998-.133-1.373-.399l-52.894-30.837-4.99-2.925c-.374-.265-.623-.664-.623-1.063 0-.399.249-.93.623-1.063l4.741-2.792 36.676-21.932a2.784 2.784 0 012.87 0l58.258 33.895c.374.266.624.665.624 1.064 0 .531-.25.93-.624 1.063l-4.865 2.791-36.926 21.799c-.624.266-.998.399-1.497.399zm-59.132-34.559l4.99 2.924 52.894 30.837c.749.532 1.747.532 2.62 0l36.926-21.799 4.865-2.791c.25-.133.499-.532.499-.797 0-.399-.125-.665-.499-.798l-58.258-33.895c-.749-.531-1.747-.398-2.62 0l-41.417 24.724c-.249.132-.499.531-.499.797s.125.665.499.798z"
            fill="#131A2D"
            />
            <path
            d="M160.057 210.842l-38.423 23.793c-1.247.798-2.744.798-3.992 0l-30.314-18.476 43.787-25.919 28.818 16.88c1.497.798 1.497 2.925.124 3.722z"
            fill="url(#paint4_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M38.052 185.322l42.54-25.521c.374-.266.873-.399 1.372-.399.499 0 .873.133 1.372.399l58.882 34.294c.873.531 1.372 1.595 1.372 2.658s-.499 2.127-1.372 2.658l-42.664 25.255a2.3 2.3 0 01-1.248.399c-.499 0-.873-.133-1.372-.399l-58.882-34.16c-.873-.532-1.372-1.595-1.372-2.659 0-1.063.499-1.993 1.372-2.525z"
            fill="#fff"
            />
            <path
            d="M80.716 160.067c.374-.266.873-.399 1.247-.266.374 0 .998.133 1.372.399l58.757 34.161c.499.398.874.93.998 1.462.125.266.125.797.125 1.063 0 .93-.748 1.994-1.497 2.526l-42.04 24.989a2.307 2.307 0 01-1.248.398h-.499c-.25 0-.499-.133-.748-.265L38.3 190.373c-.498-.266-.873-.798-.997-1.329-.125-.399-.125-.798-.125-1.197 0-.93.748-1.993 1.497-2.525l42.04-25.255z"
            fill="#F8F8F9"
            />
            <path
            d="M80.841 160.2c.375-.265.749-.265 1.248-.265.374 0 .998.265 1.248.398l58.632 34.161c.499.266.873.93.873 1.462.125.266 0 .665 0 1.063 0 .798-.873 1.861-1.621 2.393l-41.542 24.723c-.25.133-.874.399-1.248.399h-.499c-.25 0-.499-.133-.748-.266l-58.882-34.16c-.5-.266-.873-.931-.873-1.463-.125-.265 0-.797 0-1.063 0-.797.997-1.994 1.621-2.392l41.791-24.99z"
            fill="#F1F1F3"
            />
            <path
            d="M80.966 160.466c.374-.266.748-.266 1.123-.266.374 0 .998.266 1.247.532l58.508 34.028c.499.265.748.93.748 1.462.125.266-.124.664-.124.93 0 .665-1.123 1.861-1.747 2.127l-40.918 24.457c-.25.133-.873.399-1.248.399-.124 0-.374.133-.499 0-.249 0-.498-.133-.748-.266l-58.882-34.027c-.499-.266-.748-.931-.748-1.463-.125-.265.124-.664.124-1.063 0-.665 1.123-1.861 1.747-2.26l41.417-24.59z"
            fill="#EAEBEC"
            />
            <path
            d="M81.09 160.599c.374-.133.748-.266.998-.266s.998.399 1.247.532l58.383 34.027c.499.266.749.931.624 1.463.125.265-.25.664-.25.93 0 .665-1.372 1.728-1.746 1.994L99.802 223.47c-.25.133-.873.532-1.123.532-.124 0-.374.133-.499.133-.25 0-.499 0-.748-.133l-59.007-34.294c-.499-.265-.748-.93-.624-1.462-.124-.265.25-.664.25-.93 0-.665 1.372-1.728 1.871-2.127l41.168-24.59z"
            fill="#E3E4E6"
            />
            <path
            d="M81.09 160.865c.25-.133.623-.266.998-.133.25 0 1.123.399 1.247.532l58.259 33.894c.499.266.748 1.064.499 1.462 0 .133-.375.665-.375.798 0 .532-1.497 1.728-1.871 1.861l-40.045 23.793c-.125.133-.998.531-1.123.531-.124 0-.374.133-.499.133-.249 0-.499 0-.748-.133l-58.882-34.16c-.499-.266-.748-.931-.499-1.462-.125-.133.374-.665.374-.798 0-.532 1.497-1.728 1.996-1.994l40.669-24.324z"
            fill="#DDDDE0"
            />
            <path
            d="M81.214 161.13c.25-.133.624-.265.874-.133.124 0 1.122.532 1.247.532l58.134 33.762c.499.266.623 1.063.374 1.462 0 .133-.499.532-.499.665 0 .398-1.747 1.595-1.996 1.728l-39.546 23.527c-.125.133-.998.531-1.123.531 0 0-.374.133-.499.133-.25.133-.499 0-.748-.133l-58.882-34.16c-.5-.266-.624-1.064-.374-1.462 0-.133.498-.665.498-.798 0-.399 1.747-1.595 1.996-1.861l40.544-23.793z"
            fill="#D6D6DA"
            />
            <path
            d="M81.34 161.263c.25-.133.624-.133.874-.133.125 0 1.123.532 1.247.664l58.009 33.762c.499.266.624 1.064.25 1.462 0 .133-.624.532-.624.665 0 .266-1.871 1.462-2.121 1.595l-39.047 23.261c-.124 0-.998.532-1.122.532 0 0-.375.133-.5.133-.249.133-.498.133-.748-.133L38.676 188.91c-.499-.266-.624-1.063-.25-1.462 0-.133.624-.664.624-.664 0-.266 1.996-1.595 2.121-1.728l40.17-23.793z"
            fill="#CFD0D3"
            />
            <path
            d="M81.464 161.529a.752.752 0 01.749 0s1.123.665 1.247.665l57.884 33.629c.499.266.499 1.063.125 1.462l-.749.532c0 .133-2.12 1.462-2.245 1.462l-38.548 22.862-.998.532s-.374.266-.499.266a.752.752 0 01-.748 0L38.8 188.778c-.5-.266-.5-1.063-.125-1.462 0 0 .748-.532.748-.665s2.121-1.462 2.246-1.595l39.795-23.527z"
            fill="#C8C9CD"
            />
            <path
            d="M81.59 161.662a.752.752 0 01.748 0l58.882 34.294c.499.266.499 1.196 0 1.462l-42.54 25.388a.752.752 0 01-.748 0L39.05 188.645c-.499-.266-.499-1.196 0-1.462l42.54-25.521z"
            fill="#C1C2C7"
            />
            <path
            d="M141.718 194.758l-3.243-.398-55.514-32.3c-.873-.532-1.871-.532-2.745 0l-40.044 23.793-1.996-.266v2.127c0 .398.124.664.499.93l58.008 33.762c.874.532 1.872.532 2.745 0l41.791-24.59c.375-.266.499-.532.499-.931v-2.127z"
            fill="#0EA59D"
            />
            <path
            d="M97.93 222.938c-.498 0-.997-.133-1.372-.399l-57.884-33.895c-.374-.133-.498-.532-.623-.93v-2.393l2.12.266 40.045-23.66a2.779 2.779 0 012.87 0l55.513 32.3 3.244.399v2.392c0 .399-.25.665-.624.931l-41.791 24.59c-.5.266-.998.399-1.497.399zm-59.505-35.357c0 .399.125.664.499.797l57.884 33.895c.748.532 1.746.532 2.62 0l41.791-24.59c.25-.133.499-.399.499-.798v-1.994l-3.119-.398-55.763-32.3c-.748-.532-1.746-.399-2.62 0l-40.044 23.793-1.872-.266v1.861h.125z"
            fill="#131A2D"
            />
            <path
            d="M141.095 193.695l-58.134-33.762c-.873-.532-1.871-.532-2.744 0L38.8 184.523a1.052 1.052 0 000 1.861l57.884 33.895c.873.532 1.87.532 2.744 0l41.791-24.59c.624-.399.624-1.595-.124-1.994z"
            fill="#fff"
            />
            <path
            d="M38.799 186.12l4.99 2.924 52.894 30.837c.873.532 1.871.532 2.744 0l36.926-21.799 3.867-2.259.998-.532c.749-.399.749-1.462 0-1.994L82.96 159.668c-.873-.531-1.871-.531-2.744 0l-36.801 21.799-4.741 2.792c-.624.398-.624 1.462.125 1.861z"
            fill="#fff"
            />
            <path
            d="M97.93 220.545c-.498 0-.997-.133-1.372-.399l-52.894-30.97-4.99-2.924c-.374-.266-.623-.665-.623-1.064s.25-.93.623-1.063l4.741-2.791 36.801-21.799a2.779 2.779 0 012.87 0l58.258 33.894c.374.266.624.665.624 1.064 0 .531-.25.93-.624 1.063l-4.865 2.791-36.927 21.799c-.623.266-1.122.399-1.621.399zM38.8 185.986l4.99 2.924 52.893 30.838c.749.531 1.747.531 2.62 0l36.926-21.799 4.865-2.792c.25-.133.499-.531.499-.797 0-.399-.124-.665-.499-.798L82.836 159.8c-.748-.531-1.746-.398-2.62 0L38.8 184.391c-.25.133-.499.531-.499.797.125.399.25.665.5.798z"
            fill="#131A2D"
            />
            <path
            d="M226.673 397.197L188.25 420.99c-1.248.798-2.745.798-3.992 0l-30.315-18.476 43.788-25.919 28.817 16.881c1.497.664 1.497 2.791.125 3.721z"
            fill="url(#paint5_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M104.542 371.544l42.54-25.521c.374-.266.873-.399 1.372-.399.499 0 .873.133 1.372.399l58.882 34.293c.874.532 1.373 1.595 1.373 2.659 0 1.063-.499 2.126-1.373 2.658l-42.539 25.388a2.304 2.304 0 01-1.248.399c-.499 0-.873-.133-1.372-.399l-59.007-34.294c-.873-.531-1.372-1.595-1.372-2.658s.499-1.994 1.372-2.525z"
            fill="#fff"
            />
            <path
            d="M147.205 346.288c.375-.266.874-.399 1.248-.266.374 0 .998.133 1.372.399l58.757 34.16c.499.399.874.931.998 1.462.125.266.125.798.125 1.064 0 .93-.748 1.994-1.497 2.525l-42.041 24.989a2.298 2.298 0 01-1.247.399h-.499c-.25 0-.499-.133-.749-.266l-59.006-34.16c-.499-.266-.874-.798-.998-1.33-.125-.398-.125-.797-.125-1.196 0-.93.748-1.994 1.497-2.525l42.165-25.255z"
            fill="#F8F8F9"
            />
            <path
            d="M147.332 346.421c.374-.266.748-.266 1.247-.266.374 0 .998.266 1.248.399l58.632 34.161c.499.265.873.93.873 1.462.125.266 0 .664 0 1.063 0 .798-.873 1.861-1.621 2.26l-41.542 24.723c-.25.133-.873.399-1.248.399h-.499c-.249 0-.499-.133-.748-.266l-58.882-34.161c-.499-.265-.873-.93-.873-1.462-.125-.266 0-.797 0-1.063 0-.798.998-1.994 1.621-2.393l41.792-24.856z"
            fill="#F1F1F3"
            />
            <path
            d="M147.456 346.687c.374-.266.748-.266 1.122-.266.375 0 .998.266 1.248.532l58.508 34.027c.499.266.748.931.748 1.462.125.266-.125.665-.125.931 0 .664-1.122 1.861-1.746 2.127l-41.043 24.457c-.249.133-.873.399-1.247.399-.125 0-.375.133-.499 0-.25 0-.499-.133-.749-.266l-58.882-34.161c-.499-.266-.748-.93-.748-1.462-.125-.266.124-.664.124-1.063 0-.665 1.123-1.861 1.747-2.26l41.542-24.457z"
            fill="#EAEBEC"
            />
            <path
            d="M147.582 346.952c.374-.133.749-.265.998-.265.25 0 .998.398 1.248.531l58.383 34.028c.499.266.748.93.623 1.462.125.266-.249.665-.249.93 0 .665-1.372 1.728-1.747 1.994l-40.543 24.192c-.25.133-.874.532-1.123.532-.125 0-.374.132-.499.132-.25 0-.499 0-.749-.132l-58.882-34.161c-.499-.266-.748-.931-.623-1.462-.125-.266.249-.665.249-.931 0-.664 1.372-1.728 1.871-2.126l41.043-24.724z"
            fill="#E3E4E6"
            />
            <path
            d="M147.707 347.085c.249-.132.624-.265.998-.132.249 0 1.123.398 1.247.531l58.259 33.895c.499.266.748 1.063.499 1.462 0 .133-.375.665-.375.798 0 .531-1.497 1.728-1.871 1.861l-40.045 23.792c-.124.133-.998.532-1.122.532-.125 0-.375.133-.499.133-.25 0-.499 0-.749-.133l-58.882-34.161c-.499-.265-.748-.93-.499-1.462-.125-.133.374-.664.374-.797 0-.532 1.497-1.728 1.996-1.994l40.669-24.325z"
            fill="#DDDDE0"
            />
            <path
            d="M147.831 347.352c.25-.133.624-.266.874-.133.124 0 1.122.532 1.247.532l58.134 33.762c.499.266.623 1.063.374 1.462 0 .133-.499.531-.499.664 0 .399-1.747 1.595-1.996 1.728l-39.546 23.527c-.125.133-.998.532-1.123.532 0 0-.374.133-.499.133-.249.133-.499 0-.748-.133l-58.882-34.161c-.499-.265-.624-1.063-.374-1.462 0-.133.499-.664.499-.797 0-.399 1.746-1.595 1.996-1.861l40.543-23.793z"
            fill="#D6D6DA"
            />
            <path
            d="M147.831 347.484c.25-.132.624-.132.873-.132.125 0 1.123.531 1.248.664l58.009 33.762c.499.266.623 1.063.249 1.462 0 .133-.624.532-.624.665 0 .266-1.871 1.462-2.12 1.595l-39.047 23.261c-.125 0-.998.532-1.123.532 0 0-.374.133-.499.133-.249.132-.499.132-.748-.133l-58.758-34.028c-.499-.266-.623-1.063-.249-1.462 0-.133.624-.665.624-.665 0-.266 1.996-1.595 2.12-1.728l40.045-23.926z"
            fill="#CFD0D3"
            />
            <path
            d="M147.955 347.75a.751.751 0 01.748 0s1.123.665 1.248.665l57.884 33.629c.499.265.499 1.063.124 1.462l-.748.531c0 .133-2.121 1.463-2.121 1.463l-38.548 22.995-.998.532s-.374.265-.499.265a.751.751 0 01-.748 0l-58.882-34.16c-.499-.266-.499-1.064-.125-1.462 0 0 .749-.532.749-.665s2.12-1.462 2.245-1.595l39.671-23.66z"
            fill="#C8C9CD"
            />
            <path
            d="M148.08 347.884a.753.753 0 01.749 0l58.882 34.293c.499.266.499 1.196 0 1.462l-42.54 25.388a.753.753 0 01-.749 0l-58.882-34.16c-.499-.266-.499-1.197 0-1.463l42.54-25.52z"
            fill="#C1C2C7"
            />
            <path
            d="M208.21 380.981l-3.243-.399-55.514-32.299c-.873-.532-1.871-.532-2.744 0l-40.045 23.792-1.996-.265v2.126c0 .399.125.665.499.931l57.884 33.894c.873.532 1.871.532 2.744 0l41.792-24.59c.374-.266.499-.532.499-.93v-2.26h.124z"
            fill="#0EA59D"
            />
            <path
            d="M164.548 409.16c-.499 0-.998-.133-1.372-.398l-57.884-33.895c-.375-.133-.499-.532-.624-.931v-2.392l2.121.266 40.044-23.66a2.78 2.78 0 012.87 0l55.513 32.299 3.244.399v2.393c0 .399-.25.664-.624.93l-41.791 24.591c-.624.265-.998.398-1.497.398zm-59.631-35.357c0 .399.125.665.499.798l57.76 33.895c.748.531 1.746.531 2.619 0l41.792-24.591c.249-.133.499-.398.499-.797v-1.994l-3.119-.399-55.514-32.299c-.748-.532-1.746-.399-2.62 0l-40.044 23.792-1.872-.265v1.86z"
            fill="#131A2D"
            />
            <path
            d="M207.712 379.917l-58.259-33.761c-.873-.532-1.871-.532-2.744 0l-41.417 24.59a1.052 1.052 0 000 1.861l57.884 33.895c.873.531 1.871.531 2.744 0l41.792-24.591c.623-.398.623-1.595 0-1.994z"
            fill="#fff"
            />
            <path
            d="M105.293 372.34l4.99 2.924 52.894 30.838c.873.532 1.871.532 2.744 0l36.926-21.799 3.868-2.26.998-.531c.748-.399.748-1.462 0-1.994l-58.259-33.629c-.873-.532-1.871-.532-2.744 0l-36.801 21.799-4.741 2.791c-.624.399-.624 1.462.125 1.861z"
            fill="#fff"
            />
            <path
            d="M164.548 406.767c-.499 0-.998-.133-1.372-.399l-52.894-30.838-4.99-2.924c-.375-.266-.624-.665-.624-1.063 0-.399.249-.931.624-1.064l4.74-2.791 36.801-21.799a2.78 2.78 0 012.87 0l58.258 33.895c.374.266.624.664.624 1.063 0 .399-.25.931-.624 1.064l-4.865 2.791-36.926 21.799c-.749.133-1.123.266-1.622.266zm-59.132-34.56l4.99 2.925 52.894 30.837c.749.532 1.747.532 2.62 0l36.926-21.799 4.865-2.791c.25-.133.499-.532.499-.798s-.124-.664-.499-.797l-58.383-33.762c-.748-.532-1.746-.399-2.619 0l-41.417 24.59c-.25.133-.499.532-.499.798.124.399.249.664.623.797z"
            fill="#131A2D"
            />
            <path
            d="M368.515 317.975l32.934-19.805c.374-.266.873-.399 1.372-.399.499 0 .873.133 1.372.399l54.142 31.369c.873.532 1.372 1.595 1.372 2.659 0 1.063-.499 2.126-1.372 2.658l-32.934 19.672a2.304 2.304 0 01-1.248.399c-.499 0-.873-.133-1.372-.399l-54.142-31.236c-.873-.532-1.372-1.595-1.372-2.658-.125-1.197.374-2.127 1.248-2.659z"
            fill="#fff"
            />
            <path
            d="M401.575 298.302c.374-.266.873-.399 1.247-.266.374 0 .998.133 1.372.399l54.017 31.369c.499.399.873.931.998 1.462.125.266.125.665.125 1.064 0 .93-.749 1.994-1.497 2.525l-32.435 19.407a2.299 2.299 0 01-1.248.399h-.499c-.249 0-.499-.133-.748-.266l-54.142-31.237c-.499-.266-.873-.797-.998-1.462-.124-.266-.124-.797-.124-1.063 0-.931.748-1.994 1.497-2.526l32.435-19.805z"
            fill="#F8F8F9"
            />
            <path
            d="M401.699 298.568c.374-.266.748-.266 1.247-.266.374 0 .998.266 1.248.399l53.892 31.237c.499.398.873.93.873 1.462.125.266 0 .664 0 .93 0 .798-.873 1.861-1.622 2.26l-31.936 19.14c-.249.133-.873.399-1.247.399h-.499c-.25 0-.499-.133-.749-.266l-54.141-31.236c-.499-.266-.874-.93-.874-1.462-.124-.266 0-.665 0-1.064 0-.797.874-1.993 1.622-2.392l32.186-19.141z"
            fill="#F1F1F3"
            />
            <path
            d="M401.823 298.701c.374-.266.748-.266 1.122-.266.375 0 .998.266 1.248.532l53.642 31.103c.499.399.749.931.749 1.463.125.265-.125.664-.125.93 0 .665-1.123 1.861-1.622 2.127L425.4 353.464c-.249.133-.873.399-1.247.399h-.499c-.25 0-.499-.133-.749-.266l-54.141-31.236c-.499-.266-.749-.93-.749-1.462-.124-.266.125-.665.125-.931 0-.664 1.123-1.86 1.747-2.259l31.936-19.008z"
            fill="#EAEBEC"
            />
            <path
            d="M401.947 298.968c.374-.133.748-.266.998-.266.249 0 .998.399 1.247.532l53.518 31.103c.499.399.749.93.624 1.462.125.133-.25.665-.25.798 0 .664-1.247 1.728-1.746 1.993L425.4 353.199c-.25.133-.873.532-1.123.532-.125 0-.374.133-.499.133-.249 0-.499 0-.748-.133l-54.017-31.369c-.499-.266-.749-.931-.624-1.462-.125-.266.25-.665.25-.931 0-.664 1.372-1.728 1.746-2.126l31.562-18.875z"
            fill="#E3E4E6"
            />
            <path
            d="M401.947 299.1c.25-.133.624-.266.998-.133.25 0 .998.399 1.248.532l53.393 30.97c.499.266.748 1.063.499 1.462 0 .133-.375.532-.375.798 0 .531-1.497 1.595-1.871 1.861L425.4 352.8c-.125.133-.873.531-1.123.531-.124 0-.374.133-.499.133-.249 0-.499 0-.748-.133l-53.892-31.236c-.499-.266-.749-1.063-.499-1.462-.125-.133.374-.665.374-.798 0-.531 1.497-1.727 1.871-1.993l31.063-18.742z"
            fill="#DDDDE0"
            />
            <path
            d="M402.074 299.366c.249-.132.623-.265.873-.132.125 0 1.123.531 1.247.531l53.269 30.971c.499.266.623 1.063.374 1.462 0 .133-.499.532-.499.664 0 .399-1.622 1.596-1.996 1.728l-29.815 18.078c-.125.133-.998.531-1.123.531l-.374.133c-.25.133-.499 0-.749-.133l-54.141-31.236c-.499-.266-.624-1.063-.375-1.462 0-.133.499-.665.499-.798 0-.398 1.747-1.595 1.996-1.861l30.814-18.476z"
            fill="#D6D6DA"
            />
            <path
            d="M402.198 299.632c.249-.133.624-.133.873-.133.125 0 1.123.531 1.248.664l53.143 30.838c.499.266.624 1.063.25 1.462 0 .133-.499.532-.499.665 0 .266-1.872 1.462-1.996 1.595l-29.566 17.678c-.125 0-.998.532-1.123.532l-.374.133c-.25.133-.499.133-.749-.133l-54.141-31.236c-.499-.266-.624-1.064-.25-1.463 0-.133.624-.531.624-.664 0-.266 1.871-1.595 2.121-1.595l30.439-18.343z"
            fill="#CFD0D3"
            />
            <path
            d="M402.321 299.764a.758.758 0 01.749 0l1.123.665 53.018 30.838c.499.266.499 1.063.125 1.462l-.624.532c0 .132-1.996 1.462-2.12 1.462l-29.067 17.412-.998.532-.374.266a.753.753 0 01-.749 0l-54.141-31.237c-.499-.265-.499-1.063-.125-1.462 0 0 .748-.531.748-.664s2.121-1.462 2.246-1.462l30.189-18.344z"
            fill="#C8C9CD"
            />
            <path
            d="M402.447 300.03a.751.751 0 01.748 0l54.142 31.369c.499.266.499 1.197 0 1.463l-32.934 19.672a.753.753 0 01-.749 0l-54.141-31.237c-.499-.265-.499-1.196 0-1.462l32.934-19.805z"
            fill="#C1C2C7"
            />
            <path
            d="M457.71 330.204l-3.119-.399-50.773-29.375c-.873-.532-1.871-.532-2.744 0l-30.439 18.077-1.996-.266v2.127c0 .399.124.665.499.931l53.018 30.97c.874.532 1.872.532 2.745 0l32.185-19.008c.375-.265.499-.531.499-.93v-2.127h.125z"
            fill="#0EA59D"
            />
            <path
            d="M423.653 352.667c-.499 0-.998-.133-1.372-.399l-53.019-30.97c-.374-.133-.499-.532-.623-.931v-2.392l1.996.266 30.314-18.078a2.783 2.783 0 012.869 0l50.649 29.376 3.243.399v2.392c-.125.399-.249.665-.624.931l-32.185 19.007c-.25.266-.749.399-1.248.399zm-54.765-32.433c0 .399.125.665.499.798l53.019 30.97c.748.532 1.746.532 2.62 0l32.185-19.007c.25-.133.499-.399.499-.798v-1.993l-3.119-.399-50.773-29.376c-.748-.531-1.746-.399-2.62 0l-30.439 18.21-1.871-.265v1.86z"
            fill="#131A2D"
            />
            <path
            d="M457.087 329.141l-53.269-30.971c-.873-.531-1.871-.531-2.744 0l-31.811 19.008a1.052 1.052 0 000 1.861l53.018 30.97c.874.532 1.872.532 2.745 0l32.185-19.007c.624-.399.624-1.462-.124-1.861z"
            fill="#fff"
            />
            <path
            d="M369.263 318.773l4.99 2.924 48.028 28.047c.874.531 1.872.531 2.745 0l27.32-16.084 3.867-2.259.998-.532c.749-.399.749-1.462 0-1.994l-53.393-30.97c-.873-.532-1.871-.532-2.744 0l-27.071 16.216-4.74 2.791a1.052 1.052 0 000 1.861z"
            fill="#fff"
            />
            <path
            d="M423.653 350.275c-.499 0-.998-.132-1.372-.398l-48.029-28.047-4.99-2.924c-.374-.266-.623-.664-.623-1.063 0-.399.249-.931.623-1.064l4.741-2.791 27.071-16.216a2.778 2.778 0 012.869 0l53.393 30.97c.374.266.624.665.624 1.064 0 .398-.25.93-.624 1.063l-4.865 2.791-27.321 16.084a2.299 2.299 0 01-1.497.531zm-54.266-31.635l4.99 2.925 48.029 28.046c.748.532 1.746.532 2.62 0l27.32-16.084 4.865-2.791c.25-.133.499-.532.499-.797 0-.399-.125-.665-.499-.798l-53.393-30.97c-.748-.532-1.746-.399-2.62 0l-31.811 19.007c-.249.133-.499.532-.499.798s.125.531.499.664z"
            fill="#131A2D"
            />
            <path
            d="M422.405 345.623c.873 0 1.622-.266 2.246-.665l22.954-13.956c.998-.665 1.746-1.728 1.746-2.924 0-1.197-.624-2.26-1.622-2.792L406.188 299.5c-.624-.399-1.497-.665-2.246-.665-.873 0-1.622.266-2.245.665l-22.954 13.956c-.998.665-1.747 1.728-1.747 2.924 0 1.197.624 2.26 1.622 2.792l41.542 25.786c.623.532 1.372.665 2.245.665z"
            fill="#fff"
            />
            <path
            d="M401.697 299.898l-22.579 13.691c-.998.531-1.747 1.728-1.747 2.658 0 .399 0 .931.125 1.329.125.532.624 1.064 1.123 1.462l41.541 25.787c.624.399 1.373.532 2.246.532h.499c.624 0 1.247-.266 1.746-.532l22.455-13.558c.998-.532 1.747-1.728 1.747-2.658 0-.399 0-.798-.125-1.197-.125-.664-.624-1.196-1.247-1.595l-41.417-25.653c-.624-.399-1.497-.665-2.246-.665-.624-.133-1.372 0-2.121.399z"
            fill="#F8F8F9"
            />
            <path
            d="M401.822 300.165l-22.206 13.425c-.873.532-1.871 1.595-1.871 2.525 0 .399-.125.931 0 1.197.125.531.374 1.063.998 1.462l41.542 25.786c.623.399 1.372.532 2.245.532h.499c.499 0 1.248-.399 1.747-.665l21.956-13.292c.873-.531 1.871-1.595 1.871-2.525 0-.399.125-.798 0-1.196-.125-.532-.374-1.064-.998-1.463l-41.168-25.52c-.499-.266-1.497-.798-2.12-.798-.998-.133-1.747.133-2.495.532z"
            fill="#F1F1F3"
            />
            <path
            d="M401.946 300.297l-21.831 13.159c-.749.399-1.872 1.595-1.996 2.393 0 .266-.25.797-.125 1.196 0 .532.249 1.064.873 1.462l41.542 25.787c.624.399 1.372.532 2.121.399.124 0 .249 0 .374-.133.374 0 1.247-.399 1.622-.665l21.457-13.026c.748-.399 1.871-1.595 1.871-2.393 0-.265.249-.797.125-1.063 0-.532-.25-1.063-.874-1.462l-40.668-25.255c-.374-.266-1.622-.798-2.121-.798-.873-.132-1.622 0-2.37.399z"
            fill="#EAEBEC"
            />
            <path
            d="M402.072 300.563l-21.457 13.027c-.624.398-1.996 1.595-1.996 2.259 0 .266-.375.798-.25 1.064-.125.531.125 1.063.749 1.462l41.541 25.786c.624.399 1.373.532 2.121.399.125 0 .25 0 .374-.133.375 0 1.248-.532 1.622-.664l20.958-12.628c.624-.399 1.996-1.595 1.996-2.26 0-.265.374-.797.25-.93.124-.532-.125-1.063-.749-1.462l-40.793-25.255c-.374-.266-1.622-.798-2.121-.931-.624-.265-1.497-.132-2.245.266z"
            fill="#E3E4E6"
            />
            <path
            d="M402.32 300.829l-21.083 12.76c-.499.266-2.121 1.595-2.121 2.127 0 .266-.499.797-.499.93-.249.399 0 1.064.499 1.329l41.542 25.787c.624.399 1.372.532 1.996.399.125 0 .25 0 .374-.133.25 0 1.248-.532 1.497-.665l20.459-12.361c.499-.266 1.996-1.462 1.996-1.994 0-.266.499-.665.375-.931.249-.531 0-1.063-.624-1.462l-40.544-25.122c-.249-.133-1.622-.93-1.996-.93-.374-.133-1.247-.133-1.871.266z"
            fill="#DDDDE0"
            />
            <path
            d="M402.445 301.094l-20.584 12.495c-.374.266-2.12 1.595-2.12 1.994 0 .133-.624.797-.624.93-.374.399-.25 1.064.374 1.329l41.542 25.787c.499.399 1.372.399 1.996.266.124 0 .249 0 .374-.133.25 0 1.247-.665 1.497-.665l19.96-12.095c.374-.266 2.121-1.463 2.121-1.861 0-.133.623-.665.499-.798.374-.399.249-1.063-.374-1.462l-40.295-24.989c-.249-.133-1.746-.931-1.996-.931-.873-.398-1.746-.265-2.37.133z"
            fill="#D6D6DA"
            />
            <path
            d="M402.57 301.36l-20.209 12.229c-.25.133-2.246 1.462-2.246 1.728 0 .133-.748.664-.748.797-.375.399-.375.931.249 1.33l41.542 25.786c.499.266 1.247.399 1.996.266.125 0 .25-.133.374-.133.125 0 1.248-.664 1.372-.797l19.461-11.83c.25-.133 2.121-1.462 2.121-1.728 0-.133.749-.665.624-.665.374-.399.374-1.063-.25-1.329l-40.044-24.856c-.125-.133-1.747-1.064-1.996-1.064-.749-.265-1.622-.133-2.246.266z"
            fill="#CFD0D3"
            />
            <path
            d="M402.695 301.626l-19.836 12.096c-.124.133-2.37 1.462-2.37 1.595l-.873.664c-.499.399-.499.931.125 1.33l41.541 25.786c.499.266 1.248.399 1.872.266.124 0 .249-.133.374-.133s1.247-.664 1.372-.797l18.962-11.431c.125-.133 2.246-1.463 2.246-1.596 0 0 .748-.531.748-.664.499-.399.499-.931-.125-1.329l-39.92-24.724c-.124 0-1.871-1.063-1.871-1.063-.748-.532-1.622-.399-2.245 0z"
            fill="#C8C9CD"
            />
            <path
            d="M446.606 327.678l-41.542-25.786c-.624-.399-1.622-.399-2.246 0l-22.954 13.957c-.623.398-.623.93 0 1.329l41.542 25.786c.624.399 1.622.399 2.246 0l22.954-13.956c.499-.399.499-1.064 0-1.33z"
            fill="#C1C2C7"
            />
            <path
            d="M405.065 300.829a1.748 1.748 0 00-1.622 0l-22.579 14.223c-1.123.664-1.123 2.525 0 3.323l41.042 24.856a1.748 1.748 0 001.622 0l22.58-13.824c1.123-.664 1.123-2.525 0-3.323l-41.043-25.255z"
            fill="#131A2D"
            />
            <path
            d="M380.739 317.444l41.042 24.856a1.748 1.748 0 001.622 0l1.372-.93 3.992-2.393 17.216-10.501c1.123-.664 1.123-2.525 0-3.323l-41.043-25.122a1.754 1.754 0 00-1.622 0l-22.579 14.09c-1.123.798-1.123 2.658 0 3.323z"
            fill="#0EA59D"
            />
            <path
            d="M422.654 342.566c-.249 0-.623-.133-.873-.266l-41.043-24.856c-.623-.398-.873-.93-.873-1.728 0-.664.374-1.329.873-1.728l22.58-14.222a1.424 1.424 0 011.747 0l41.042 25.122c.624.399.874.93.874 1.728 0 .664-.375 1.329-.874 1.728l-22.579 13.824c-.25.398-.499.398-.874.398zm-18.463-42.8c-.249 0-.499.133-.873.266l-22.58 14.222c-.499.266-.873.931-.873 1.595 0 .665.374 1.197.873 1.595l41.043 24.856a1.748 1.748 0 001.622 0l1.372-.93 3.992-2.393 17.216-10.5c.499-.266.873-.931.873-1.595 0-.665-.374-1.197-.873-1.595l-41.043-25.122c-.125-.266-.499-.399-.749-.399z"
            fill="#131A2D"
            />
            <path
            d="M391.842 319.038c.249-.133.499-.266.748-.266.25 0 .374 0 .624.133.125.133.249.266.125.399 0 .133-.25.266-.499.532-.25.133-.499.266-.749.266-.249 0-.374 0-.624-.133-.124-.133-.249-.266-.124-.399.124-.133.249-.399.499-.532zm.873.532c.249-.133.374-.266.374-.399s0-.133-.125-.266c-.124 0-.249-.133-.374 0-.125 0-.374.133-.499.266-.249.133-.374.266-.374.399s0 .133.125.266c.124 0 .249.133.374 0 .125 0 .249-.133.499-.266zM392.465 318.64l-.249.133-.125-.266-1.372.93-.125-.132 1.497-1.064.125.133.249.266zM390.344 317.311l-.25.133-.124-.266-1.373.93-.124-.133 1.497-1.063.124.133.25.266zM387.975 316.647c.249-.133.498-.266.748-.266.249 0 .374 0 .624.133.124.133.249.266.125.399 0 .132-.25.265-.499.531-.25.133-.499.266-.749.266-.249 0-.374 0-.624-.133-.124-.133-.249-.266-.125-.399a1.01 1.01 0 01.5-.531zm.748.531c.249-.133.374-.265.374-.398s0-.133-.124-.266c-.125 0-.25-.133-.375 0-.124 0-.374.133-.499.266-.249.133-.249.265-.374.398 0 .133 0 .133.125.266.125 0 .249.133.374 0 .25-.133.374-.133.499-.266zM390.079 319.907l.798-3.349-.121-.033-.798 3.349.121.033z"
            fill="#fff"
            />
            <path
            d="M428.019 326.616l6.238 3.722h.374l.374-.266 1.497-.93h.125l1.247-.798 1.373-.797c.249-.133.249-.532 0-.665l-6.238-3.855h-.374l-.25.133h-.124l-1.373.931-1.122.797h-.125l-1.372.798h-.125l-.25.133c-.124.266-.124.664.125.797z"
            fill="#0EA59D"
            />
            <path
            d="M433.01 328.61c0 .133 0 .266.125.266l1.871 1.329-1.871-1.329c0-.133-.125-.266-.125-.266l.249-.266 1.123-.664h.125l1.247-.665 1.123-.664a.362.362 0 01.499 0l1.996 1.329-2.121-1.329a.362.362 0 00-.499 0l-1.122.664-.624.399h-.125l-1.123.665h-.124l-.499.265c-.125 0-.125.133-.125.266z"
            fill="#fff"
            />
            <path
            d="M435.504 326.882v.133l2.37 1.329-2.245-1.462h-.125zM434.258 327.68l2.245 1.462h.125l-2.245-1.462h-.125zM428.145 325.818l1.497.931c.124 0 .249.133.249.133s.25 0 .25-.133l1.122-.665h.125l.499-.399h.125l.249-.132h.125l.25-.133h.124l.624-.399.25-.133c.124 0 .124-.133.124-.266s0-.266-.124-.266l-1.373-.93h-.124l1.372.93c.125 0 .125.133.125.266s0 .133-.125.266l-.998.665h-.125l-.249.132h-.125l-.873.532h-.125l-1.123.665a.362.362 0 01-.499 0l-1.247-1.064z"
            fill="#fff"
            />
            <path
            d="M430.889 324.224l1.746 1.063h.125-.125l-1.746-1.196v.133zM429.643 324.888l1.746 1.196h.125l-.125-.133-1.746-1.063zM434.88 327.28l-1.123-.797-.124-.133c0-.133 0-.133.124-.133l.624-.399c.125 0 .125-.133.125-.266s0-.133-.125-.265l-.873-.532.873.532.125.132s0 .133-.125.133l-.624.399c-.124 0-.124.133-.124.266s0 .133.124.266l1.123.797zM431.637 326.483s0 .133 0 0c0 .133 0 .133.124.133l.375.266 1.621 1.063-.873-.531-.873-.532-.25-.133c0-.133 0-.133-.124-.266l.124-.133.624-.531v-.133c0-.133 0-.133-.125-.266h-.249.125l.124.133v.133l-.623.399v.398zM405.564 310.4l19.337 11.697 2.744-1.728-19.336-11.697-2.745 1.728z"
            fill="#fff"
            />
            <path
            d="M424.9 322.23l-19.461-11.83 2.994-1.861 19.461 11.83-2.994 1.861zm-19.211-11.83l19.087 11.697 2.619-1.595-19.211-11.564-2.495 1.462z"
            fill="#000"
            />
            <path
            d="M405.814 325.952l8.109 4.918 1.248-.665-8.234-4.918-1.123.665z"
            fill="#fff"
            />
            <path
            d="M413.923 331.003l-8.234-5.051 1.373-.798 8.233 5.051-1.372.798zm-7.984-5.051l7.984 4.785.998-.665-7.984-4.785-.998.665z"
            fill="#000"
            />
            <path
            d="M404.316 327.28l19.711 12.095 1.123-.797-19.711-11.963-1.123.665z"
            fill="#fff"
            />
            <path
            d="M424.026 339.509l-19.96-12.096 1.373-.798 19.96 12.096-1.373.798zm-19.585-12.229l19.585 11.963.998-.665-19.585-11.963-.998.665z"
            fill="#000"
            />
            <path
            d="M428.643 333.927c.499-.399.998-.532 1.497-.665.499-.133.873 0 1.248.133.374.133.374.399.249.798-.125.398-.374.664-.873.93s-.998.532-1.497.665c-.499.133-.873 0-1.248-.133-.374-.133-.374-.399-.249-.798 0-.266.374-.664.873-.93zm1.622.93c.374-.266.624-.532.748-.664.125-.266 0-.399-.124-.532-.25-.133-.499-.133-.874-.133-.374.133-.623.266-1.122.532-.499.265-.624.531-.749.664-.125.266 0 .399.125.532.249.133.499.133.748.133.499 0 .874-.266 1.248-.532zM426.272 332.465c.499-.399.998-.532 1.497-.665.499-.133.873 0 1.248.133.374.133.374.399.249.798-.125.398-.374.664-.873.93s-.998.532-1.497.665c-.499.133-.873 0-1.248-.133-.374-.133-.374-.399-.249-.798 0-.266.374-.531.873-.93zm1.622 1.063c.374-.266.624-.532.748-.664.125-.266 0-.399-.124-.532-.25-.133-.499-.133-.874-.133-.374 0-.623.266-1.122.532-.375.265-.624.531-.749.664-.125.266 0 .399.125.532s.499.133.748.133c.25 0 .874-.266 1.248-.532zM421.657 329.673c.499-.399.998-.532 1.497-.665.499-.133.873 0 1.247.133.375.133.375.399.25.798a2.002 2.002 0 01-.873.93c-.499.266-.998.532-1.497.665-.499.133-.874 0-1.248-.133s-.374-.399-.249-.798c.124-.399.374-.531.873-.93zm1.622 1.063c.374-.266.623-.532.748-.664.125-.133 0-.399-.125-.532-.249-.133-.499-.133-.873-.133-.374.133-.624.266-1.123.532-.499.265-.623.531-.748.664s0 .399.125.532c.249.133.499.133.748.133.499-.133.873-.266 1.248-.532zM424.028 331.135c.499-.399.998-.532 1.497-.665.499-.133.873 0 1.247.133.375.133.375.399.25.798a2.002 2.002 0 01-.873.93c-.499.399-.998.532-1.497.665-.499.133-.874 0-1.248-.133s-.374-.399-.249-.798c0-.399.374-.664.873-.93zm1.622.93c.374-.266.623-.532.748-.664.125-.133 0-.399-.125-.532-.249-.133-.499-.133-.873-.133-.374.133-.624.266-1.123.532-.374.265-.623.531-.748.664-.125.266 0 .399.125.532.249.133.499.133.748.133.499-.133.873-.266 1.248-.532zM415.669 326.085c.499-.399.998-.532 1.497-.665.499-.133.873 0 1.247.133.374.133.374.399.25.798-.125.398-.375.664-.874.93s-.998.532-1.497.665c-.499.133-.873 0-1.247-.133-.374-.133-.374-.399-.25-.798.125-.398.375-.664.874-.93zm1.746.93c.374-.266.624-.531.749-.664.124-.133 0-.399-.125-.532-.25-.133-.499-.133-.873-.133-.375.133-.624.266-1.123.532-.374.266-.624.532-.749.664-.124.266 0 .399.125.532s.499.133.749.133c.499 0 .873-.266 1.247-.532zM418.04 327.414c.499-.399.998-.532 1.497-.665.499-.133.873 0 1.247.133.374.133.374.399.25.798a2 2 0 01-.874.93c-.499.399-.998.532-1.497.665-.499.133-.873 0-1.247-.133-.374-.133-.374-.399-.25-.798.125-.398.375-.531.874-.93zm1.746 1.063c.374-.265.624-.531.749-.664.124-.266 0-.399-.125-.532s-.499-.133-.873-.133c-.375.133-.624.266-1.123.532s-.624.532-.749.664c-.124.133 0 .399.125.532.25.133.499.133.749.133.499-.133.748-.266 1.247-.532zM413.299 324.756c.499-.399.998-.532 1.497-.665.499-.133.874 0 1.248.133s.374.399.249.798a1.997 1.997 0 01-.873.93c-.499.399-.998.532-1.497.665-.499.133-.873 0-1.247-.133-.375-.133-.375-.399-.25-.798 0-.399.374-.664.873-.93zm1.622.93c.374-.266.624-.531.749-.664.124-.133 0-.399-.125-.532-.25-.133-.499-.133-.873-.133-.375.133-.624.266-1.123.532s-.624.531-.749.664c-.124.133 0 .399.125.532.25.133.499.133.749.133.499-.133.873-.266 1.247-.532zM410.928 323.293c.499-.399.998-.532 1.497-.665.499-.133.874 0 1.248.133s.374.399.249.798a1.992 1.992 0 01-.873.93c-.499.266-.998.532-1.497.665-.499.133-.873 0-1.247-.133-.375-.133-.375-.399-.25-.798 0-.265.374-.664.873-.93zm1.622.93c.374-.265.624-.531.749-.664.124-.266 0-.399-.125-.532-.25-.133-.499-.133-.873-.133-.375.133-.624.266-1.123.532-.374.266-.624.532-.749.664-.124.266 0 .399.125.532.25.133.499.133.749.133.499 0 .873-.266 1.247-.532zM407.436 321.033c.499-.399.998-.532 1.497-.664.499-.133.873 0 1.248.132.374.133.374.399.249.798a1.993 1.993 0 01-.873.93c-.499.266-.998.532-1.497.665-.499.133-.873 0-1.248-.133-.374-.133-.374-.399-.249-.797 0-.399.374-.665.873-.931zm1.622.931c.374-.266.624-.532.748-.665.125-.133 0-.399-.124-.532-.125-.133-.499-.133-.874-.133-.374.133-.623.266-1.122.532-.499.266-.624.532-.749.665-.125.266 0 .398.125.531.249.133.499.133.748.133.499-.133.874-.266 1.248-.531zM405.065 319.571c.499-.399.998-.531 1.497-.664.499-.133.873 0 1.248.133.374.132.374.398.249.797a1.999 1.999 0 01-.873.931c-.499.265-.998.531-1.497.664-.499.133-.873 0-1.248-.133-.374-.133-.374-.399-.249-.797 0-.266.374-.665.873-.931zm1.622.931c.374-.266.624-.532.748-.665.125-.266 0-.399-.124-.532-.125-.133-.499-.133-.874-.133-.374.133-.623.266-1.122.532-.375.266-.624.532-.749.665-.125.266 0 .399.125.531.125.133.499.133.748.133.25 0 .874-.265 1.248-.531zM400.325 316.779c.499-.399.998-.531 1.497-.664.499-.133.873 0 1.247.133.375.132.375.398.25.797a1.999 1.999 0 01-.873.931c-.499.398-.998.531-1.497.664-.499.133-.874 0-1.248-.133s-.374-.399-.249-.797c.124-.399.374-.665.873-.931zm1.746 1.064c.375-.266.624-.532.749-.665s0-.399-.125-.532-.499-.133-.873-.133c-.374.133-.624.266-1.123.532s-.624.532-.748.665c-.125.266 0 .398.124.531.25.133.499.133.749.133.499-.133.873-.266 1.247-.531zM402.694 318.108c.499-.398.998-.531 1.497-.664.499-.133.873 0 1.247.133.375.133.375.398.25.797a1.999 1.999 0 01-.873.931c-.499.398-.998.531-1.497.664-.499.133-.874 0-1.248-.133s-.374-.398-.249-.797c.124-.266.374-.532.873-.931zm1.746 1.064c.375-.266.624-.532.749-.665.125-.266 0-.399-.125-.532s-.499-.133-.873-.133c-.374.133-.624.266-1.123.532a4.806 4.806 0 00-.748.665c-.125.266 0 .399.124.531.25.133.499.133.749.133.499-.133.873-.265 1.247-.531zM394.462 313.191c.499-.398.998-.531 1.497-.664.499-.133.873 0 1.247.133.374.133.374.398.25.797-.125.399-.375.665-.874.931-.499.265-.998.531-1.497.664-.499.133-.873 0-1.247-.133-.374-.133-.374-.398-.25-.797.125-.399.375-.665.874-.931zm1.621.931c.375-.266.624-.532.749-.665.125-.266 0-.399-.125-.531-.249-.133-.499-.133-.873-.133s-.624.265-1.123.531a4.806 4.806 0 00-.748.665c-.125.266 0 .399.124.532.125.132.499.132.749.132.499 0 .873-.265 1.247-.531zM396.831 314.52c.499-.398.998-.531 1.497-.664.499-.133.873 0 1.247.133.374.133.374.399.25.797-.125.399-.375.665-.874.931-.499.398-.998.531-1.497.664-.499.133-.873 0-1.247-.133-.374-.133-.374-.398-.25-.797 0-.266.375-.532.874-.931zm1.621 1.064c.375-.266.624-.532.749-.665.125-.266 0-.399-.125-.531-.125-.133-.499-.133-.873-.133-.374.133-.624.265-1.123.531a4.806 4.806 0 00-.748.665c-.125.266 0 .399.124.532.25.132.499.132.749.132.499-.132.873-.265 1.247-.531zM391.967 311.729c.499-.398.998-.531 1.497-.664.499-.133.874 0 1.248.133s.374.399.249.797a1.993 1.993 0 01-.873.931c-.499.398-.998.531-1.497.664-.499.133-.873 0-1.247-.133-.375-.133-.375-.398-.25-.797.125-.266.374-.532.873-.931zm1.747 1.064c.374-.266.624-.532.748-.665.125-.133 0-.399-.124-.531-.25-.133-.499-.133-.874-.133-.374 0-.623.265-1.122.531-.375.266-.624.532-.749.665-.125.266 0 .399.125.532.249.132.499.132.748.132.499-.132.874-.265 1.248-.531zM389.596 310.399c.499-.398.998-.531 1.497-.664.499-.133.874 0 1.248.133s.374.398.249.797a1.993 1.993 0 01-.873.931c-.499.265-.998.531-1.497.664-.499.133-.873 0-1.247-.133-.375-.133-.375-.398-.25-.797s.374-.665.873-.931zm1.747.931c.374-.266.624-.532.748-.665.125-.266 0-.399-.124-.531-.125-.133-.499-.133-.874-.133-.374.133-.623.265-1.122.531-.375.266-.624.532-.749.665-.125.266 0 .399.125.532.249.132.499.132.748.132.499-.132.874-.265 1.248-.531zM209.458 250.053l35.304-21.268c.374-.265.873-.398 1.372-.398.499 0 .998.133 1.497.398l67.241 44.529c.873.532 1.497 1.595 1.497 2.791 0 1.197-.624 2.26-1.497 2.792l-35.305 21.134c-.374.266-.873.399-1.372.399-.499 0-.998-.133-1.372-.399l-67.365-44.396c-.873-.531-1.497-1.595-1.497-2.791s.624-2.26 1.497-2.791z"
            fill="#fff"
            />
            <path
            d="M209.583 250.186l35.304-21.268c.375-.266.874-.398 1.373-.398s.998.265 1.372.398l67.115 44.396c.874.531 1.373 1.462 1.373 2.658 0 1.064-.499 1.994-1.373 2.526l-35.179 21.001c-.374.266-.998.399-1.372.399h-.624c-.25 0-.499-.133-.749-.266l-67.24-44.395c-.873-.532-1.372-1.463-1.372-2.526 0-.93.499-1.994 1.372-2.525z"
            fill="#F8F8F9"
            />
            <path
            d="M209.706 250.452l35.305-21.268c.374-.266.873-.399 1.247-.266.374 0 .998.266 1.372.532l66.991 44.263c.749.531 1.248 1.329 1.248 2.392 0 .931-.499 1.861-1.248 2.393l-34.93 21.001c-.374.133-.998.399-1.372.399h-.624c-.249 0-.499-.133-.748-.266l-67.241-44.395c-.748-.532-1.247-1.33-1.247-2.393 0-1.063.499-1.861 1.247-2.392z"
            fill="#F1F1F3"
            />
            <path
            d="M209.832 250.717l35.304-21.268c.374-.265.748-.265 1.247-.265.375 0 1.123.398 1.373.531l66.866 44.263c.748.399 1.122 1.329 1.122 2.127 0 .93-.499 1.728-1.122 2.126L279.816 299.1c-.249.133-.998.532-1.372.532-.125 0-.499.133-.624 0-.249 0-.499-.133-.748-.266l-67.24-44.396c-.749-.399-1.123-1.196-1.123-2.127 0-.93.374-1.727 1.123-2.126z"
            fill="#EAEBEC"
            />
            <path
            d="M209.957 250.851l35.304-21.268c.374-.266.749-.266 1.123-.266.249 0 1.123.399 1.372.532l66.617 44.13c.623.399.998 1.196.998 1.861 0 .797-.375 1.462-.998 1.861l-34.556 20.735c-.25.133-.998.532-1.248.532-.124 0-.499.133-.623.133-.25 0-.499 0-.749-.133l-67.24-44.396c-.624-.398-.998-1.063-.998-1.861 0-.797.374-1.462.998-1.86z"
            fill="#E3E4E6"
            />
            <path
            d="M210.083 251.115l35.304-21.267c.374-.266.748-.266 1.123-.133.249 0 1.122.532 1.372.665l66.492 43.997c.499.398.873 1.063.873 1.728 0 .664-.374 1.329-.873 1.728l-34.431 20.602c-.25.133-.998.532-1.248.532-.125 0-.499.133-.624.133-.249 0-.499 0-.748-.133l-67.24-44.396c-.624-.398-.874-.93-.874-1.728-.124-.664.25-1.329.874-1.728z"
            fill="#DDDDE0"
            />
            <path
            d="M210.081 251.382l35.304-21.267c.249-.133.624-.266.998-.133.125 0 1.123.531 1.247.664l66.367 43.997c.499.266.749.931.749 1.462 0 .532-.25 1.197-.749 1.462l-34.181 20.47c-.125.133-1.123.532-1.248.532-.124 0-.499.266-.623.133-.25.133-.499 0-.749-.133l-67.115-44.263c-.499-.266-.749-.93-.749-1.462 0-.532.374-1.196.749-1.462z"
            fill="#D6D6DA"
            />
            <path
            d="M210.206 251.648l35.304-21.268c.25-.133.624-.265.873-.133.125 0 1.123.665 1.248.665l66.242 43.864c.374.266.624.797.624 1.196 0 .532-.25.931-.624 1.196l-33.932 20.337c-.125 0-1.123.665-1.247.665l-.499.266c-.25.133-.499.133-.749-.133l-67.24-44.396c-.374-.266-.624-.797-.624-1.196 0-.399.25-.93.624-1.063z"
            fill="#CFD0D3"
            />
            <path
            d="M210.331 251.78l35.304-21.267c.25-.133.624-.133.874 0 0 0 1.247.664 1.247.797l66.118 43.731c.374.266.499.665.499 1.064 0 .398-.25.797-.499 1.063l-33.808 20.204s-1.122.664-1.247.664l-.499.266a.753.753 0 01-.749 0l-67.24-44.395c-.374-.266-.499-.665-.499-1.064 0-.398.25-.797.499-1.063z"
            fill="#C8C9CD"
            />
            <path
            d="M245.761 230.779a.751.751 0 01.748 0l67.24 44.529a1.037 1.037 0 010 1.595l-35.304 21.134a.751.751 0 01-.748 0l-67.241-44.395c-.499-.399-.499-1.197 0-1.595l35.305-21.268z"
            fill="#C1C2C7"
            />
            <path
            d="M314.248 273.979l-3.369-.399-63.622-42.402a2.778 2.778 0 00-2.869 0l-32.56 19.406-2.121-.265v2.259c0 .399.25.798.624.931l65.993 43.996a2.778 2.778 0 002.869 0l34.556-20.336c.374-.266.499-.532.623-.931v-2.259h-.124z"
            fill="#0EA59D"
            />
            <path
            d="M277.695 298.037c-.499 0-.998-.133-1.497-.398l-66.117-43.997c-.374-.266-.624-.532-.624-.931v-2.525l2.246.266 32.559-19.407c.998-.531 2.121-.531 2.994 0l63.623 42.402 3.493.532v2.525c-.125.399-.25.798-.624.931l-34.556 20.204c-.374.265-.873.398-1.497.398zm-67.864-45.592c0 .399.25.798.499.931l66.118 43.997c.873.531 1.871.531 2.744 0l34.556-20.337c.25-.133.499-.532.499-.798V274.112l-3.368-.399-63.623-42.402c-.873-.532-1.871-.532-2.744 0l-32.685 19.407-1.996-.266v1.993z"
            fill="#131A2D"
            />
            <path
            d="M313.624 272.782l-66.492-43.997a2.783 2.783 0 00-2.869 0l-34.057 20.337c-.749.399-.749 1.595 0 2.127l65.993 43.997a2.778 2.778 0 002.869 0l34.556-20.337c.873-.532.873-1.595 0-2.127z"
            fill="#fff"
            />
            <path
            d="M210.206 250.983l5.364 3.191 60.753 40.806a2.78 2.78 0 002.87 0l29.191-17.279 4.117-2.393 1.123-.665c.748-.398.748-1.595 0-2.126l-66.492-43.997a2.778 2.778 0 00-2.869 0l-29.067 17.412-4.99 2.925c-.749.398-.749 1.595 0 2.126z"
            fill="#fff"
            />
            <path
            d="M277.696 295.512c-.499 0-.998-.133-1.497-.399l-60.754-40.806-5.239-3.191a1.417 1.417 0 01-.624-1.196c0-.531.25-.93.624-1.196l4.99-2.924 29.067-17.413c.998-.532 2.12-.532 2.994 0l66.491 43.997c.375.266.624.664.624 1.196 0 .532-.249.931-.624 1.196l-5.239 3.058-29.192 17.279a3.278 3.278 0 01-1.621.399zm-67.365-44.661l5.364 3.19 60.753 40.806c.873.532 1.871.532 2.745 0l29.191-17.279 5.24-3.057c.374-.133.499-.532.499-.931s-.25-.665-.499-.93l-66.492-43.997c-.873-.532-1.871-.532-2.745 0l-29.066 17.413-4.99 2.924c-.25.133-.499.531-.499.93s.124.665.499.931z"
            fill="#131A2D"
            />
            <path
            d="M61.129 338.18l-38.423-22.863c-2.121-1.329-2.121-4.519 0-5.715l48.902-28.312c2.62-1.595 5.863-1.463 8.483 0l35.179 20.868c2.87 1.728 2.745 5.982 0 7.71l-48.902 28.445c-1.746.797-3.617.797-5.24-.133zM325.974 413.678l-37.799-22.463c-2.121-1.196-2.121-4.519 0-5.716l48.028-27.913a8.514 8.514 0 018.359 0l34.431 20.603c2.744 1.595 2.744 5.848 0 7.576l-48.154 27.913a4.586 4.586 0 01-4.865 0zM178.02 166.313l-34.431-20.47c-1.871-1.196-1.871-4.12 0-5.184l43.787-25.387a7.756 7.756 0 017.61 0l31.437 18.741c2.495 1.463 2.495 5.45 0 6.912l-43.912 25.521c-1.372.665-2.994.665-4.491-.133z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M72.982 290.727c-1.497 3.855 1.248 6.38 1.248 6.38l24.7 10.235-20.21-18.343c.125 0-4.241-2.126-5.738 1.728z"
            fill="url(#paint6_linear_874_76773)"
            />
            <path
            d="M71.61 293.385s.748 4.519 5.863 3.855c5.114-.665 5.863-3.988 5.863-3.988l-6.487-25.122-5.24 25.255z"
            fill="#0EA59D"
            />
            <path
            d="M76.474 297.373c-4.241 0-4.99-3.988-4.99-4.121l5.365-25.653 6.611 25.653s-.748 3.456-5.988 4.121h-.998zm-4.74-3.988c.125.399.873 4.387 5.738 3.722 4.74-.665 5.614-3.589 5.739-3.855l-6.362-24.457-5.115 24.59z"
            fill="#140035"
            />
            <path
            opacity={0.26}
            d="M76.725 268.13l.623 29.11c5.115-.665 2.87-4.919 2.745-6.912-.25-6.248-3.368-22.198-3.368-22.198z"
            fill="#303030"
            />
            <path
            opacity={0.3}
            d="M75.476 312.393c-2.12 5.317 1.373 8.773 1.373 8.773l33.682 15.286-27.196-26.186c.125 0-5.738-3.057-7.859 2.127z"
            fill="url(#paint7_linear_874_76773)"
            />
            <path
            d="M73.356 316.514s.998 6.247 7.984 5.316c6.986-.93 7.983-5.449 7.983-5.449l-8.857-34.56-7.11 34.693z"
            fill="#0EA59D"
            />
            <path
            d="M80.092 322.096c-5.864 0-6.861-5.45-6.861-5.583l7.235-35.224 8.982 35.091s-1.123 4.652-8.109 5.583c-.374.133-.873.133-1.247.133zm-6.612-5.583c.125.532 1.248 6.114 7.86 5.184 6.611-.798 7.858-4.918 7.983-5.317l-8.732-34.028-7.111 34.161z"
            fill="#140035"
            />
            <path
            opacity={0.26}
            d="M80.59 281.821l.873 40.009c6.986-.93 3.992-6.779 3.867-9.57-.499-8.507-4.74-30.439-4.74-30.439z"
            fill="#303030"
            />
            <path
            opacity={0.3}
            d="M37.178 305.082c-2.37 5.982 1.621 9.836 1.621 9.836l37.924 17.147-30.439-29.375c-.124.133-6.736-3.456-9.106 2.392z"
            fill="url(#paint8_linear_874_76773)"
            />
            <path
            d="M34.807 309.735s1.122 7.045 8.982 5.981c7.859-1.063 8.982-6.247 8.982-6.247l-9.98-38.813-7.984 39.079z"
            fill="#0EA59D"
            />
            <path
            d="M42.416 315.982c-6.611 0-7.61-6.115-7.61-6.248l8.11-39.477 10.104 39.344s-1.247 5.317-9.107 6.248c-.623.133-1.122.133-1.497.133zm-7.485-6.248c.125.532 1.373 6.912 8.858 5.849 7.36-.931 8.857-5.583 8.857-6.115l-9.855-38.281-7.86 38.547z"
            fill="#140035"
            />
            <path
            opacity={0.26}
            d="M42.916 270.789l.998 44.927c7.86-1.063 4.491-7.576 4.242-10.633-.5-9.704-5.24-34.294-5.24-34.294z"
            fill="#303030"
            />
            <path
            d="M397.455 258.56l-25.324-15.286c-1.372-.798-1.372-2.925 0-3.722l30.189-17.546c1.622-.93 3.743-.93 5.364 0l23.204 14.09c1.871 1.063 1.747 3.855 0 4.918l-30.314 17.546c-.874.531-2.121.531-3.119 0z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M383.234 235.698c-2.121 5.184 1.372 8.64 1.372 8.64l33.309 15.02-26.822-25.787s-5.738-3.19-7.859 2.127z"
            fill="url(#paint9_linear_874_76773)"
            />
            <path
            d="M381.238 239.685s.998 6.247 7.984 5.317c6.986-.93 7.984-5.45 7.984-5.45l-8.732-34.16-7.236 34.293z"
            fill="#0EA59D"
            />
            <path
            d="M387.85 245.135c-5.739 0-6.737-5.449-6.737-5.449l7.236-34.826 8.982 34.693s-1.123 4.652-8.109 5.582h-1.372zm-6.487-5.449c.125.531 1.247 5.981 7.734 5.183 6.487-.797 7.735-4.918 7.86-5.316l-8.608-33.496-6.986 33.629z"
            fill="#140035"
            />
            <path
            opacity={0.26}
            d="M388.35 205.392l.873 39.61c6.986-.93 3.867-6.646 3.742-9.437-.499-8.507-4.615-30.173-4.615-30.173z"
            fill="#303030"
            />
            <path
            opacity={0.3}
            d="M408.059 233.571c-1.372 3.456.874 5.583.874 5.583l21.706 9.836-17.465-16.748c0-.133-3.742-2.127-5.115 1.329z"
            fill="url(#paint10_linear_874_76773)"
            />
            <path
            d="M406.812 236.097s.624 3.987 5.115 3.455c4.491-.531 5.115-3.588 5.115-3.588l-5.738-22.198-4.492 22.331z"
            fill="#0EA59D"
            />
            <path
            d="M411.054 239.819c-3.868 0-4.367-3.589-4.492-3.589l4.741-22.863 5.863 22.863c0 .133-.748 3.057-5.239 3.589h-.873zm-4.117-3.722c.124.399.873 3.855 4.99 3.323 4.116-.532 4.99-3.057 4.99-3.323l-5.489-21.666-4.491 21.666z"
            fill="#140035"
            />
            <path
            opacity={0.26}
            d="M411.428 213.899l.499 25.653c4.491-.531 2.495-4.386 2.495-6.114-.25-5.45-2.994-19.539-2.994-19.539z"
            fill="#303030"
            />
            <path
            d="M205.092 371.942l7.235 4.652 46.657-27.116-8.608-5.45-45.284 27.914z"
            fill="url(#paint11_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M205.092 371.942l45.284-28.047V329.54l-45.284 27.913v14.489z"
            fill="#fff"
            />
            <path
            d="M204.842 372.208v-14.754h.125l45.533-28.18v14.755h-.124l-45.534 28.179zm.374-14.621v14.089l45.16-27.78v-14.09l-45.16 27.781z"
            fill="#000"
            />
            <path
            d="M210.08 363.035c.125.266.25.399.374.532.25 0 .499 0 .874-.266.499-.266.748-.664.998-1.196h.748c-.374.797-.998 1.462-1.746 1.994-.624.399-1.123.531-1.622.266-.374-.133-.624-.532-.624-1.197 0-.664.25-1.329.624-1.993a4.449 4.449 0 011.497-1.596c.624-.398.998-.398 1.372-.265.374.133.499.664.499 1.196v.399l-2.994 2.126zm0-.797l2.37-1.462c0-.266-.249-.532-.374-.532-.249 0-.499 0-.748.133-.375.133-.624.399-.749.798-.374.398-.499.797-.499 1.063zM214.072 360.111v-.798l2.994-1.861v.931l-2.994 1.728zM221.306 354.662c.25 0 .374 0 .624.265.125.133.249.399.249.665 0 .532-.124.93-.499 1.462-.374.532-.748.931-1.122 1.196l-2.37 1.463v-5.849l2.245-1.329c.499-.266.873-.399 1.123-.266.374.133.499.399.499.93-.125.399-.25.931-.749 1.463zm-.998-1.197l-1.247.798v1.595l1.247-.798c.25-.133.374-.266.499-.531.125-.266.25-.399.25-.665s-.125-.399-.25-.399c-.125-.133-.249-.133-.499 0zm.125 3.988c.249-.133.374-.266.499-.532s.249-.532.249-.664c0-.133-.124-.399-.249-.399-.125-.133-.374 0-.499.133l-1.497.93v1.595l1.497-1.063zM226.048 350.673l.873-.531v4.253l-.873.532v-.665c-.374.665-.749 1.196-1.372 1.595-.499.399-.998.399-1.373.266-.374-.133-.623-.665-.623-1.196 0-.665.249-1.329.623-1.994.375-.665.874-1.196 1.373-1.462.623-.399 1.122-.399 1.372-.133v-.665zm-2.121 4.387c.25.133.499 0 .873-.133.375-.266.624-.532.874-.931.249-.398.374-.797.374-1.196 0-.399-.125-.665-.374-.798-.25-.132-.499 0-.874.133a3.027 3.027 0 00-.873.931c-.249.399-.374.797-.374 1.196 0 .399.125.665.374.798zM230.041 348.148c.499-.266.873-.399 1.122-.266.25.133.375.532.375 1.064v2.658l-.874.532v-2.526c0-.266-.124-.531-.249-.531-.125-.133-.374 0-.624.132-.249.133-.499.399-.748.798-.25.399-.25.665-.25 1.063v2.26l-.873.532v-4.254l.873-.531v.531c.25-.664.624-1.196 1.248-1.462zM235.903 348.813l-.998.665-1.622-.931v1.994l-.873.532v-5.849l.873-.532v3.589l1.497-2.791.998-.665-1.746 3.19 1.871.798zM237.401 342.965l-.375.398c-.124.133-.249.133-.374 0-.125 0-.125-.133-.125-.265 0-.133 0-.266.125-.532l.374-.399c.125-.133.25-.133.375 0 .124 0 .124.133.124.266s-.124.266-.124.532zm-.874 5.449v-4.253l.874-.532v4.254l-.874.531zM240.519 341.634c.499-.265.873-.398 1.123-.265.249.132.374.531.374 1.063v2.658l-.873.532v-2.525c0-.266-.125-.532-.25-.532-.124-.133-.374 0-.623.133-.25.133-.499.399-.749.797-.249.399-.249.665-.249 1.064v2.259l-.874.532v-4.253l.874-.532v.532c.249-.532.623-1.064 1.247-1.463zM246.007 338.312l.873-.532v3.988c0 .664-.249 1.196-.624 1.861a5.469 5.469 0 01-1.497 1.462c-.873.532-1.497.665-1.871.133l.749-.931c.249.266.623.266 1.122 0 .375-.265.624-.531.874-.797.249-.399.374-.665.374-1.064v-.531c-.374.664-.749 1.196-1.372 1.595-.499.399-.998.399-1.373.266-.374-.133-.623-.532-.623-1.197 0-.664.249-1.196.623-1.86.375-.665.874-1.197 1.373-1.463.623-.398.998-.398 1.372-.133v-.797zm-2.121 4.386c.25.133.499 0 .873-.133.375-.265.624-.531.874-.93.249-.399.374-.798.374-1.196 0-.399-.125-.665-.374-.665-.25-.133-.499 0-.874.133a3.034 3.034 0 00-.873.93c-.249.399-.374.798-.374 1.197 0 .266.125.531.374.664z"
            fill="#000"
            />
            <path
            d="M313.373 187.182l8.483 5.45 31.188-19.407-8.483-5.582-31.188 19.539z"
            fill="url(#paint12_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M313.373 187.181l31.188-19.539v-14.356l-31.188 19.407v14.488z"
            fill="#fff"
            />
            <path
            d="M313.248 187.447v-14.754h.125l31.312-19.672v14.754h-.125l-31.312 19.672zm.25-14.621v14.089l30.813-19.406v-14.09l-30.813 19.407z"
            fill="#000"
            />
            <path
            d="M323.603 172.958c.25 0 .374 0 .624.266.249.266.249.399.249.665 0 .531-.124.93-.499 1.462-.374.531-.748.93-1.122 1.196l-2.371 1.462v-5.848l2.246-1.33c.499-.265.873-.398 1.123-.265.374.132.499.398.499.93-.25.532-.375.93-.749 1.462zm-1.123-1.196l-1.247.797v1.595l1.247-.797c.25-.133.375-.266.499-.532.125-.266.25-.399.25-.664 0-.266-.125-.399-.25-.399-.124-.133-.249-.133-.499 0zm.125 3.987c.25-.132.374-.265.499-.531s.25-.532.25-.665-.125-.399-.25-.399c-.125-.132-.374 0-.499.133l-1.497.931v1.595l1.497-1.064zM328.22 168.971l.873-.532v4.254l-.873.532v-.665c-.374.665-.749 1.196-1.372 1.595-.499.399-.998.399-1.373.266-.374-.133-.623-.665-.623-1.196 0-.665.249-1.33.623-1.994.375-.665.874-1.196 1.373-1.462.623-.399 1.122-.399 1.372-.133v-.665zm-2.121 4.387c.25.132.499 0 .873-.133.375-.266.624-.532.874-.931.249-.399.374-.797.374-1.196 0-.399-.125-.665-.374-.798-.25-.133-.499 0-.874.133a3.027 3.027 0 00-.873.931c-.249.398-.374.797-.374 1.196 0 .399.125.665.374.798zM332.211 166.445c.499-.266.873-.399 1.122-.266.25.133.375.532.375 1.063v2.659l-.874.532v-2.526c0-.266-.124-.532-.249-.532-.125-.133-.374 0-.624.133-.249.133-.499.399-.748.798a2.63 2.63 0 00-.25 1.063v2.26l-.873.532v-4.254l.873-.532v.532c.25-.665.624-1.196 1.248-1.462zM338.073 167.11l-.998.664-1.622-.93v1.994l-.873.531v-5.848l.873-.532v3.589l1.497-2.791.998-.665-1.746 3.19 1.871.798z"
            fill="#000"
            />
            <path
            d="M422.656 397.196l-4.117 2.526-5.24 3.19-8.483-4.785 10.729-6.647 3.243 1.861 3.868 2.393c.499.266.499 1.063 0 1.462z"
            fill="url(#paint13_linear_874_76773)"
            />
            <path
            d="M404.068 391.481c4.366-2.26 11.477-2.127 15.843.266 4.366 2.392 4.241 6.114-.125 8.374-4.366 2.26-11.477 2.127-15.843-.266-4.366-2.392-4.366-6.114.125-8.374z"
            fill="#fff"
            />
            <path
            d="M404.191 391.614c4.242-2.26 11.228-2.127 15.469.266 4.242 2.259 4.117 5.981-.124 8.241-4.367 2.127-11.228 2.127-15.469-.266-4.242-2.393-4.117-5.981.124-8.241z"
            fill="#F8F8F9"
            />
            <path
            d="M404.441 391.747c4.242-2.127 10.978-1.994 15.095.266 4.117 2.259 3.992 5.848-.125 7.975s-10.978 1.994-15.095-.266c-4.116-2.26-4.116-5.848.125-7.975z"
            fill="#F1F1F3"
            />
            <path
            d="M404.567 391.88c4.117-2.127 10.604-1.994 14.596.265 3.992 2.26 3.992 5.716-.125 7.71-4.117 2.127-10.604 1.994-14.596-.266-3.992-2.127-3.867-5.716.125-7.709z"
            fill="#EAEBEC"
            />
            <path
            d="M404.816 392.013c3.992-1.994 10.355-1.861 14.222.265 3.867 2.127 3.867 5.583-.125 7.577-3.992 1.994-10.354 1.861-14.221-.266-3.868-2.26-3.868-5.583.124-7.576z"
            fill="#E3E4E6"
            />
            <path
            d="M405.065 392.013c3.867-1.994 10.105-1.861 13.847.265 3.743 2.127 3.743 5.317-.124 7.311-3.868 1.994-10.105 1.861-13.848-.266-3.867-1.994-3.742-5.317.125-7.31z"
            fill="#DDDDE0"
            />
            <path
            d="M405.19 392.146c3.742-1.861 9.73-1.861 13.473.266 3.618 1.994 3.618 5.184-.125 7.178-3.742 1.994-9.73 1.861-13.473-.266-3.618-1.994-3.618-5.184.125-7.178z"
            fill="#D6D6DA"
            />
            <path
            d="M405.441 392.278c3.617-1.861 9.481-1.728 13.098.266 3.618 1.994 3.493 5.051-.124 6.912-3.618 1.861-9.481 1.728-13.099-.266-3.618-1.994-3.493-5.051.125-6.912z"
            fill="#CFD0D3"
            />
            <path
            d="M405.565 392.411c3.493-1.861 9.232-1.728 12.6.133 3.493 1.861 3.368 4.918-.125 6.646-3.493 1.861-9.231 1.728-12.599-.133-3.369-1.861-3.369-4.918.124-6.646z"
            fill="#C8C9CD"
            />
            <path
            d="M405.813 392.545c3.369-1.728 8.858-1.595 12.226.133 3.368 1.861 3.243 4.785-.125 6.513-3.368 1.728-8.857 1.595-12.225-.133-3.369-1.861-3.369-4.785.124-6.513z"
            fill="#C1C2C7"
            />
            <path
            d="M414.298 378.188c-4.616 0-4.865 4.519-6.737 6.513-1.122 1.196-3.617 1.196-4.99 4.12-2.37 4.918 1.123 8.773 2.495 9.57 1.622.931 3.369 1.728 5.115 1.994 2.62.266 11.851-.664 10.604-8.905-.499-3.323-3.119-13.292-6.487-13.292z"
            fill="#0EA59D"
            />
            <path
            d="M411.054 400.385h-.873c-1.622-.133-3.244-.797-5.24-1.993-1.123-.665-4.99-4.52-2.495-9.704.873-1.861 2.246-2.525 3.368-3.057.624-.266 1.123-.532 1.497-1.063.499-.532.874-1.329 1.373-2.26.998-1.994 2.12-4.253 5.364-4.253 3.493 0 6.113 9.836 6.612 13.159.374 2.392-.125 4.386-1.497 5.981-1.996 2.659-5.988 3.19-8.109 3.19zm3.243-22.064c-3.243 0-4.366 2.259-5.239 4.253a13.279 13.279 0 01-1.372 2.26c-.375.398-.998.664-1.622 1.063-1.123.532-2.495 1.196-3.368 3.057-2.495 5.051 1.372 8.773 2.495 9.438 1.871 1.196 3.493 1.728 5.114 1.86 1.497.133 6.487-.132 9.107-3.057 1.248-1.462 1.747-3.456 1.372-5.848-.499-3.323-3.118-13.026-6.487-13.026z"
            fill="#140035"
            />
            <path
            d="M420.785 391.346c-.499-3.19-2.87-11.697-5.489-12.893.249.266 1.122.931 1.621 2.659.25 1.063-.748 1.86-1.122 2.924-.25.531-.874 1.196.499 1.728 2.245.93 5.114 6.38 1.621 8.108-1.871.93-4.116 2.525-5.863 3.722-3.742 2.924-7.61-4.785-10.105-4.785.25 2.924 2.371 4.918 3.244 5.449 1.622.931 3.368 1.728 5.115 1.994 2.619.266 11.726-.532 10.479-8.906z"
            fill="#131A2D"
            />
            <path
            d="M412.8 387.891c-5.489-.798-7.236 1.329-7.236 2.658 0 1.728 2.62 2.659 4.367 2.526 1.122-.133 1.497-.798 2.37-1.595 1.746-1.861 4.865.398 4.865-.798 0-.93-2.744-2.525-4.366-2.791zM411.178 374.998c.624.265.624.797.873 1.063.25.266.624-.133.998.133.499.399.624.665.499 1.861 0 0-.624-.931-1.123-.798-.374.133-.873.266-1.247-.266-.25-.265-.374-.93-.499-1.196-.125-.266-.374-.266-.374-.266s.249-.797.873-.531z"
            fill="#131A2D"
            />
            <path
            d="M409.308 379.384c-.499-.399-.749-1.33-.499-1.994.374-.931.374-1.462 1.247-1.861.624-.133 1.497 0 1.872 1.063.374 1.064.998.665 1.497 1.728.249.399-.125 1.329 0 1.861.249 1.063 1.247 1.063.249 2.924-.249.399 1.123 1.861 1.123 1.861s-3.244.931-5.24-2.259c-.998-1.595.125-2.925-.249-3.323zM403.818 388.689c1.622-.665 6.362-2.127 7.111-1.994.748.133 2.495 1.861.748 3.589-1.122 1.063-6.362 1.462-7.734 1.063-.998-.399-1.497-1.994-.125-2.658z"
            fill="#131A2D"
            />
            <path
            d="M403.195 389.618c.624-1.595 2.245 0 2.121.532-.375 1.462-2.371 5.716-2.62 6.38-.25.665-.998.133-.873-.133 0-.133.374-1.595.748-3.456.374-1.86.374-2.658.624-3.323z"
            fill="#fff"
            />
            <path
            d="M402.321 396.929h-.249c-.25-.133-.375-.266-.375-.532 0-.133.374-1.595.749-3.456.374-1.861.499-2.658.748-3.456.25-.797.873-.797 1.123-.664.624.133 1.123.93 1.123 1.329-.25.93-1.248 3.19-1.996 4.785l-.749 1.595c0 .266-.249.399-.374.399zm.998-7.311c-.249.665-.374 1.595-.749 3.456-.374 1.861-.623 3.323-.748 3.456 0 0 .125.266.25.266.124 0 .374.133.498-.266l.749-1.595c.749-1.595 1.747-3.855 1.871-4.785 0-.266-.374-.93-.998-1.063-.249-.266-.623-.133-.873.531z"
            fill="#140035"
            />
            <path
            d="M405.564 390.283c-.125.532-.873 2.127-1.247 2.924-.874.133-1.747-.531-1.872-.664.25-.931.499-2.526.749-3.057.374-1.596 2.744-.266 2.37.797z"
            fill="#131A2D"
            />
            <path
            d="M399.951 397.461c.25 0 .873.266.998.399.499.133 1.123.133 1.497-.266l.374-.266s-.124.399-.249.665-.499.266-.499.266l.125-.266s-.125 0-.499.398c-.125.133-.624.266-1.497-.265-.624-.532-.25-.665-.25-.665z"
            fill="#fff"
            />
            <path
            d="M400.949 397.196c.499-.266.624-.532.998-1.595 0 0 .374.398.998.265 0 0-.125.266-.125.532s.125.532-.125.931c-.124.398-.623.398-.873.797-.125.266-.624.266-1.622-.266-.998-.531.25-.399.749-.664z"
            fill="#131A2D"
            />
            <path
            d="M409.432 379.649c.998-.133.748 1.196.623 2.26-.124 1.063-.249 2.259-.374 2.791-.374 1.196-1.247.797-1.247-.133s0-1.994.124-3.057c.125-1.595.375-1.728.874-1.861z"
            fill="#fff"
            />
            <path
            d="M409.057 385.498c-.374 0-.624-.399-.748-1.063 0-.931 0-2.127.124-3.19.125-1.463.375-1.728.874-1.728.249 0 .499 0 .623.132.375.399.25 1.197.125 2.127v.133c-.125 1.064-.249 2.127-.374 2.659-.125.797-.499.93-.624.93zm.499-5.716h-.125c-.374 0-.623.133-.748 1.595-.125 1.064-.125 2.127-.125 3.058 0 .531.25.797.499.797.25 0 .499-.266.624-.664.125-.399.249-1.595.374-2.526v-.133c.125-.664.25-1.728-.125-1.994-.124-.133-.249-.133-.374-.133z"
            fill="#140035"
            />
            <path
            d="M409.431 379.65c.998-.133.749 1.196.624 2.26 0 .398-.125.93-.249 1.462-.499.133-1.123-.133-1.497-.399v-1.728c.374-1.462.623-1.595 1.122-1.595z"
            fill="#131A2D"
            />
            <path
            d="M404.941 387.89c0-.133.624-.532.998-.798.374-.265 1.497-1.993 2.745-2.791.748-.532 1.372.399.748 1.063-.624.798-2.37 1.596-2.994 1.994-.249.133 0 .266-.374.532-.25.133-.25.399-.374.399-.25-.266.249-.665.124-.532a1.554 1.554 0 00-.623.665c-.125.265-.25.531-.25.266 0-.133-.125-.399-.125-.532s.125-.266.125-.266z"
            fill="#fff"
            />
            <path
            d="M404.941 388.82c-.125 0 0 0 0 0-.125-.265-.125-.265-.125-.398s-.125-.266-.125-.266c0-.133 0-.133.125-.133v-.133c-.125-.133.125-.266.873-.798l.125-.132.624-.665c.499-.665 1.247-1.462 2.121-1.994.374-.266.748-.133.873.133.249.266.249.665-.125 1.196-.499.665-1.622 1.197-2.37 1.728-.25.133-.374.266-.624.399 0 0-.125 0-.125.133s0 .266-.374.399l-.249.266c0 .133-.125.133-.125.133h-.125c-.125-.133-.125-.266 0-.266-.249.133-.249.266-.249.398.124-.132 0 0-.125 0zm0-1.063v.665c0 .133 0 .133.125.266 0 0 .124-.133.124-.266 0-.266.375-.532.624-.665h.125v.133c-.125.133-.125.266-.125.399 0-.133.125-.266.25-.266.249-.133.249-.266.249-.399 0 0 0-.133.125-.133.125-.133.374-.266.624-.399.748-.398 1.871-1.063 2.37-1.727.374-.399.249-.798.125-.931-.125-.133-.375-.266-.749 0-.748.532-1.497 1.329-1.996 1.994-.249.399-.499.665-.748.797l-.125.133c-.374 0-.873.399-.998.399z"
            fill="#140035"
            />
            <path
            d="M411.304 386.827c.749-.133 2.994.797 1.871 3.19-.623 1.329-5.613 3.589-6.986 3.589-1.122.133-2.12-1.329-.998-2.393 1.248-1.196 5.365-4.12 6.113-4.386z"
            fill="#131A2D"
            />
            <path
            d="M406.813 392.012c.499 1.329 1.247 5.981 1.497 6.646.249.665-.749.665-.749.532s-.624-1.595-1.372-3.19c-.749-1.728-1.123-2.526-1.248-3.19-.499-1.728 1.747-1.33 1.872-.798z"
            fill="#fff"
            />
            <path
            d="M407.81 399.322c-.125 0-.374 0-.374-.132 0-.133-.624-1.595-1.372-3.191-.749-1.728-1.123-2.525-1.248-3.19-.249-.797.25-1.063.499-1.196.624-.266 1.497.133 1.622.399.374.93.748 3.323 1.123 5.051.124.797.249 1.462.374 1.595.125.399 0 .664-.374.664h-.25zm-1.996-7.709h-.374c-.374.133-.499.532-.374 1.063.249.798.499 1.463 1.247 3.191.749 1.728 1.248 3.057 1.372 3.19 0 0 .25.133.375 0 .124 0 .374-.133.249-.532 0-.266-.125-.798-.374-1.728-.25-1.595-.749-4.121-1.123-5.051-.125 0-.624-.133-.998-.133z"
            fill="#140035"
            />
            <path
            d="M407.187 392.012c.124.532.499 1.994.623 2.924-.623.665-1.746.798-1.871.665-.374-.798-.873-2.393-1.123-2.924-.623-1.595 1.996-1.861 2.371-.665z"
            fill="#131A2D"
            />
            <path
            d="M408.308 381.776c.25-.532.624-1.329.873-1.728a.682.682 0 01.624-.399c.125 0 .25-.133.374-.133.624-.133 2.121.399 2.495 1.33.375.93.125 2.259.125 2.924 0 2.126.25 2.658.499 4.386-2.994 1.462-4.74-1.063-4.74-1.063 0-1.329.374-2.127.249-3.057 0-.665-.873-1.463-.499-2.26z"
            fill="#0EA59D"
            />
            <path
            d="M411.552 388.688c-1.871 0-2.994-1.462-2.994-1.462 0-.665.125-1.197.125-1.595.124-.532.124-.931.124-1.33 0-.265-.124-.531-.249-.797-.25-.532-.499-1.064-.25-1.462.25-.532.624-1.33.874-1.728.124-.266.374-.399.623-.532.125 0 .25-.133.375-.133.623-.133 2.245.399 2.619 1.329.25.798.25 1.728.125 2.393v.399c0 1.728.125 2.392.374 3.456 0 .265.125.531.125.93-.748.399-1.372.532-1.871.532zm-2.869-1.595c.124.266 1.871 2.259 4.615 1.063 0-.266-.124-.532-.124-.797-.25-1.064-.375-1.728-.375-3.456v-.532c0-.665.125-1.595-.124-2.393-.375-.93-1.872-1.462-2.495-1.329-.125 0-.25 0-.375.133-.249 0-.374.133-.499.399-.249.399-.623 1.196-.873 1.728-.249.399 0 .93.25 1.329.124.266.249.532.249.798 0 .531 0 .93-.125 1.462-.124.398-.124.93-.124 1.595z"
            fill="#140035"
            />
            <path
            d="M406.187 389.485l-1.123-.664h-.25l-.873.531c-.125 0-.125.133 0 .133l1.123.665h.249l.874-.532c.124 0 .124-.133 0-.133z"
            fill="#fff"
            />
            <path
            d="M412.301 389.087l-6.487-4.121h-.374l-4.616 2.792c-.125 0-.125.133 0 .266l6.487 4.12h.374l4.616-2.791c.125-.133.125-.266 0-.266z"
            fill="#fff"
            />
            <path
            d="M407.56 392.277h-.249l-6.487-4.121c-.125 0-.125-.133-.125-.133 0-.133 0-.133.125-.133l4.616-2.791c.124-.133.249-.133.374 0l6.487 4.121c.125 0 .125.132.125.132 0 .133 0 .133-.125.133l-4.616 2.792h-.125zm-1.871-7.311h-.125l-4.615 2.791 6.487 4.121h.249l4.616-2.791-6.487-4.121h-.125z"
            fill="#140035"
            />
            <path
            d="M406.314 386.829c-.124 0-.124.133 0 .133l2.371 1.595h.124l1.497-.931-2.495-1.595-1.497.798z"
            fill="#fff"
            />
            <path
            d="M408.684 388.69c-.125 0 0 0 0 0l-2.495-1.595-.125-.133s0-.133.125-.133l1.497-.798 2.62 1.728-1.622.931zm-2.37-1.728l2.37 1.595 1.372-.798-2.37-1.462-1.372.665z"
            fill="#140035"
            />
            <path
            d="M406.437 386.828l1.372-.797h-.125l-1.497.797c-.124 0-.124.133 0 .133l2.371 1.595h.124l-2.37-1.462s0-.133.125-.266zM412.302 389.221l-4.616 2.791-6.487-4.12v.133l6.487 4.12 4.616-2.791s.125 0 0-.133c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M410.055 389.885l-.249.133-.25-.133.25-.133v-.133l-.25.133-.249-.133.249-.133v-.133l-.249.133-.249-.133.249-.133v-.132l-.249.132-.25-.132.25-.133v-.133l-.25.133-.249-.133.249-.133v-.133l-.249.133-.25-.133.25-.133v-.133l-.25.133-.25-.133.25-.133v-.133l-.25.133-.249-.133.249-.133v-.133l-.249.133-.25-.133.25-.133v-.132l-.25.132-.249-.132.249-.133v-.133l-.249.133-.249-.133.249-.133v-.133l-.249.133-.25-.133.25-.133v-.133l-.25.133-.249-.133.249-.133v-.133l-.249.133-.25-.133.25-.133v-.133l-.25.133-.249-.133v.133l.249.133.25.133v.133l.124.133-.249.133-.998-.665v.133l.249.133-.249.133-.25-.133v.133l.125.133-2.62.399-.249-.133v.133l.124.133-.623.398-.25-.133v.133l.25.133.374-.266.374.266v.133l.125.133v.133l-.25.133-.249-.133.249-.133v-.133l-.249.133-.249-.133v.133l.249.133v.133l.249.133v.133l.25.133.249.133v.133l1.872 1.196v.133l.249.133v.133l.25.133v.132l.249.133v.133l.25.133.249.133.25-.133v-.133l.249-.133h.125l.25-.133.249-.132.249-.133v-.133l-.249.133-.624-.399.25-.133.249.133.25.133.249-.133.125.133 2.245-.532c0 .133 0 .133 0 0zm-5.488-2.658l-.25.133v.133h.125v.132l.125.133-.25.133-.499-.398v.132l.25.133-.25.133-.374-.266.249-.132.25-.133h.125l.249-.133.25.133c-.125-.133-.125-.133 0-.133-.125 0-.125 0 0 0 0 0-.125 0 0 0z"
            fill="#fff"
            />
            <path
            d="M403.07 387.225l-.375.133.25.133.249-.133-.124-.133z"
            fill="url(#paint14_linear_874_76773)"
            />
            <path
            d="M403.569 387.093c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133z"
            fill="url(#paint15_linear_874_76773)"
            />
            <path
            d="M403.818 386.826l-.25.133.25.133.249-.133-.249-.133z"
            fill="url(#paint16_linear_874_76773)"
            />
            <path
            d="M404.317 387.892c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.133-.25.133.25.133.374-.133c0 .133 0 .133 0 0 0 .133 0 .133 0 0 0 .133 0 .133 0 0z"
            fill="url(#paint17_linear_874_76773)"
            />
            <path
            d="M404.567 388.556c-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125.133.125.133 0 0z"
            fill="url(#paint18_linear_874_76773)"
            />
            <path
            d="M404.94 388.82c0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125.133.125 0 0 0z"
            fill="url(#paint19_linear_874_76773)"
            />
            <path
            d="M405.315 389.085c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125 0 .125 0 0 0z"
            fill="url(#paint20_linear_874_76773)"
            />
            <path
            d="M405.688 389.353c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125 0 .125 0 0 0z"
            fill="url(#paint21_linear_874_76773)"
            />
            <path
            d="M406.186 389.618c-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0l-.249-.132-.249.132.249.133.249-.133c.125 0 .125 0 0 0z"
            fill="url(#paint22_linear_874_76773)"
            />
            <path
            d="M406.561 389.884c0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125 0 .125 0 0 0z"
            fill="url(#paint23_linear_874_76773)"
            />
            <path
            d="M406.936 390.149c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.249.133.249.132.249-.132c.125 0 .125 0 0 0z"
            fill="url(#paint24_linear_874_76773)"
            />
            <path
            d="M407.312 390.417c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0l-.25-.133-.25.133.25.133.25-.133c.124 0 .124 0 0 0z"
            fill="url(#paint25_linear_874_76773)"
            />
            <path
            d="M407.81 390.684c0-.133 0 0 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.125-.133-.249.133.249.133h.25c.124 0 .124 0 0 0z"
            fill="url(#paint26_linear_874_76773)"
            />
            <path
            d="M408.184 389.619c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.374-.266-.249.133.249.133h.374c.125 0 .125 0 0 0z"
            fill="url(#paint27_linear_874_76773)"
            />
            <path
            d="M407.809 389.352c0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.374-.266-.249.133.249.133h.374z"
            fill="url(#paint28_linear_874_76773)"
            />
            <path
            d="M407.436 389.086c-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.374-.265-.25.132.25.133h.374z"
            fill="url(#paint29_linear_874_76773)"
            />
            <path
            d="M406.936 388.819c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0l-.374-.266-.25.133.25.133h.374c.125 0 .125 0 0 0z"
            fill="url(#paint30_linear_874_76773)"
            />
            <path
            d="M406.561 388.557c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.374-.266-.249.133.249.133h.374c.125 0 .125 0 0 0z"
            fill="url(#paint31_linear_874_76773)"
            />
            <path
            d="M406.188 388.289c0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0l-.374-.265-.25.133.25.132h.374z"
            fill="url(#paint32_linear_874_76773)"
            />
            <path
            d="M405.813 388.025c-.125-.133-.125-.133 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125-.133 0 0l-.374-.266-.25.133.25.133h.374z"
            fill="url(#paint33_linear_874_76773)"
            />
            <path
            d="M405.44 387.756c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.266-.25.133.25.133h.374z"
            fill="url(#paint34_linear_874_76773)"
            />
            <path
            d="M404.94 387.491c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.266-.25.133.25.133h.374c.125 0 .125 0 0 0z"
            fill="url(#paint35_linear_874_76773)"
            />
            <path
            d="M404.815 387.892c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125 0 .125 0 0 0z"
            fill="url(#paint36_linear_874_76773)"
            />
            <path
            d="M405.19 388.424c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.266-.25.133.25.133h.374c0 .133 0 .133 0 0z"
            fill="url(#paint37_linear_874_76773)"
            />
            <path
            d="M405.565 388.686c-.125 0 0 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.133-.25.133.25.133.374-.133c0 .133 0 0 0 0z"
            fill="url(#paint38_linear_874_76773)"
            />
            <path
            d="M405.938 388.953c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.266-.25.133.25.133h.374z"
            fill="url(#paint39_linear_874_76773)"
            />
            <path
            d="M406.311 389.218c-.125 0-.125 0 0 0l-.374-.266-.249.133.249.133h.374z"
            fill="url(#paint40_linear_874_76773)"
            />
            <path
            d="M406.686 389.486l-.374-.266-.25.133.25.133h.374c.125 0 .125 0 0 0 .125 0 .125 0 0 0z"
            fill="url(#paint41_linear_874_76773)"
            />
            <path
            d="M407.186 389.751c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.265-.25.132.25.133h.374z"
            fill="url(#paint42_linear_874_76773)"
            />
            <path
            d="M407.559 390.017c-.124 0 0 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.374-.266-.249.133.249.133h.374z"
            fill="url(#paint43_linear_874_76773)"
            />
            <path
            d="M407.685 389.618c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.25-.132-.249.132.249.133.25-.133c.124.133.124.133 0 0z"
            fill="url(#paint44_linear_874_76773)"
            />
            <path
            d="M407.186 389.353l-.249-.133-.249.133.249.133.249-.133c.125.133.125.133 0 0z"
            fill="url(#paint45_linear_874_76773)"
            />
            <path
            d="M406.811 389.219c0-.133 0 0 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125 0 .125 0 0 0z"
            fill="url(#paint46_linear_874_76773)"
            />
            <path
            d="M406.436 388.953c0-.132 0 0 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0l-.249-.132-.249.132.249.133.249-.133c.125 0 .125 0 0 0z"
            fill="url(#paint47_linear_874_76773)"
            />
            <path
            d="M406.063 388.686c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125 0 .125 0 0 0z"
            fill="url(#paint48_linear_874_76773)"
            />
            <path
            d="M405.688 388.424c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133z"
            fill="url(#paint49_linear_874_76773)"
            />
            <path
            d="M405.19 388.157c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.132.249-.132c.125 0 .125 0 0 0z"
            fill="url(#paint50_linear_874_76773)"
            />
            <path
            d="M408.06 389.884c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.25-.133-.249.133.249.133.25-.133c.124.133.124.133 0 0z"
            fill="url(#paint51_linear_874_76773)"
            />
            <path
            d="M407.934 390.282c-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.374-.266-.249.133.249.133h.374z"
            fill="url(#paint52_linear_874_76773)"
            />
            <path
            d="M404.692 388.157c-.125 0 0 0 0 0l-.374-.133-.25.133.25.132.374-.132c0 .133 0 .133 0 0 0 .133 0 .133 0 0 0 .133 0 0 0 0z"
            fill="url(#paint53_linear_874_76773)"
            />
            <path
            d="M405.065 387.093c-.124 0 0 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.249-.133-.25.133.25.133.249-.133c.125.133.125.133 0 0z"
            fill="url(#paint54_linear_874_76773)"
            />
            <path
            d="M405.44 387.358c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.249-.133-.25.133.25.133.249-.133c.125.133.125.133 0 0z"
            fill="url(#paint55_linear_874_76773)"
            />
            <path
            d="M405.813 387.623c-.124 0 0 0 0 0-.124 0-.124 0 0 0l-.249-.133-.25.133.25.133.249-.133c.125.133.125.133 0 0z"
            fill="url(#paint56_linear_874_76773)"
            />
            <path
            d="M406.313 387.892c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.249-.133-.25.133.25.133.249-.133c.125.133.125.133 0 0z"
            fill="url(#paint57_linear_874_76773)"
            />
            <path
            d="M406.687 388.157c-.125-.133 0-.133 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125-.133-.125-.133 0 0l-.25-.133-.249.133.249.132.25-.132c.124.133.124.133 0 0z"
            fill="url(#paint58_linear_874_76773)"
            />
            <path
            d="M407.061 388.424c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.249-.133-.25.133.25.133.249-.133c.125.133.125.133 0 0z"
            fill="url(#paint59_linear_874_76773)"
            />
            <path
            d="M407.435 388.686c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.25-.133-.249.133.249.133.25-.133c.124.133.124.133 0 0z"
            fill="url(#paint60_linear_874_76773)"
            />
            <path
            d="M407.935 388.953c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0l-.25-.132-.249.132.249.133.25-.133c.124.133.124.133 0 0z"
            fill="url(#paint61_linear_874_76773)"
            />
            <path
            d="M408.308 389.219c-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.25-.133-.249.133.249.133.25-.133c.124.133.124.133 0 0z"
            fill="url(#paint62_linear_874_76773)"
            />
            <path
            d="M408.683 389.485c0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0l-.25-.132-.249.132.249.133.25-.133c.124 0 .124 0 0 0z"
            fill="url(#paint63_linear_874_76773)"
            />
            <path
            d="M409.556 390.017c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.25-.133-.249.133.249.133.25-.133z"
            fill="url(#paint64_linear_874_76773)"
            />
            <path
            d="M409.058 389.752c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.25-.133-.249.133.249.133.25-.133c.124 0 .124 0 0 0z"
            fill="url(#paint65_linear_874_76773)"
            />
            <path
            d="M408.557 389.885c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.124-.133 0 0l-.374-.266-.249.133.249.133h.374c.125 0 .125 0 0 0z"
            fill="url(#paint66_linear_874_76773)"
            />
            <path
            d="M408.433 390.15c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.125-.133-.249.133.249.133h.25c.124.133.124.133 0 0z"
            fill="url(#paint67_linear_874_76773)"
            />
            <path
            d="M408.558 390.284c0 .133 0 .133 0 0l-.249.133.374.266.249-.133-.374-.266z"
            fill="url(#paint68_linear_874_76773)"
            />
            <path
            d="M408.434 390.55c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.374-.266-.249.133.623.399.25-.133-.25-.133z"
            fill="url(#paint69_linear_874_76773)"
            />
            <path
            d="M407.935 390.815l-.249.133.249.133.25-.133-.25-.133z"
            fill="url(#paint70_linear_874_76773)"
            />
            <path
            d="M408.059 391.213c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.374-.133-.249.133.249.133.374-.133z"
            fill="url(#paint71_linear_874_76773)"
            />
            <path
            d="M407.686 390.947c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.266-.25.133.25.133h.374z"
            fill="url(#paint72_linear_874_76773)"
            />
            <path
            d="M407.311 390.684c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.266-.249.133.249.133h.374c0 .133 0 .133 0 0z"
            fill="url(#paint73_linear_874_76773)"
            />
            <path
            d="M406.813 390.416l-.374-.265-.25.133.25.132h.374c0 .133 0 .133 0 0 0 .133 0 .133 0 0z"
            fill="url(#paint74_linear_874_76773)"
            />
            <path
            d="M406.438 390.149c-.125 0 0 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.133-.25.133.25.133.374-.133c0 .133 0 .133 0 0 0 .133 0 .133 0 0 0 .133 0 .133 0 0z"
            fill="url(#paint75_linear_874_76773)"
            />
            <path
            d="M406.063 390.017c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.374-.266v-.133l-.25-.133-.249-.133v-.133l-.25-.133v-.133l-.249-.132-.25.132 1.872 1.197-.25-.133z"
            fill="url(#paint76_linear_874_76773)"
            />
            <path
            d="M404.067 388.556c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.374-.133-.25.133.25.133.374-.133c0 .133 0 .133 0 0 0 .133 0 .133 0 0 0 .133 0 .133 0 0z"
            fill="url(#paint77_linear_874_76773)"
            />
            <path
            d="M403.444 388.289c0-.132 0-.132 0 0 0-.132 0-.132 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.124-.132-.125-.133-.25.133.25.132.249-.132v.132z"
            fill="url(#paint78_linear_874_76773)"
            />
            <path
            d="M404.067 388.291c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0l-.375-.266v-.133l-.249-.133-.25.133.125.133.25-.133v.133l-.25.133.499.266.25-.133c.124.133.124.133 0 0z"
            fill="url(#paint79_linear_874_76773)"
            />
            <path
            d="M403.195 387.756c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.25.133.125.133.25-.133.124.133-.124-.133z"
            fill="url(#paint80_linear_874_76773)"
            />
            <path
            d="M402.82 387.358c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.25.133.375.266.249-.133-.249-.133z"
            fill="url(#paint81_linear_874_76773)"
            />
            <path
            d="M404.44 386.296l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM404.815 386.56l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM405.19 386.694l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c.125.133.125.133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M405.688 386.958l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 .133 0 0zM406.063 387.226l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M406.438 387.49l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 .133 0 0zM406.813 387.756l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c.125.133.125 0 0 0zM407.311 388.024l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133c0 .133 0 0 0 0zM407.686 388.291l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 0 0 0zM407.81 388.423c-.125 0 0 0 0 0l-.374.133.249.133h.125l.249-.133-.249-.133zM408.432 388.82l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133c.125 0 .125 0 0 0zM408.932 389.085l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM409.307 389.353l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM409.68 389.618l-.249-.132h-.125l-.249.132.249.133h.125l.249-.133zM409.806 389.751l-.374.133.249.133h.125l.249-.133-.249-.133zM404.816 386.828l-.998-.665h-.125l-.25.133.998.665h.125l.25-.133c0 .133 0 .133 0 0zM405.19 387.094l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M405.565 387.358l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 .133 0 0zM405.94 387.624l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 0 0 0zM406.064 387.759l-.25.133.25.133h.125l.249-.133-.374-.133zM406.811 388.157l-.249-.133h-.125l-.249.133.249.132h.125l.249-.132c0 .133 0 0 0 0zM406.937 388.291c-.125 0 0 0 0 0l-.375.133.25.133h.125l.249-.133-.249-.133zM407.559 388.686l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133c0 .133 0 0 0 0zM408.059 388.953l-.249-.132h-.125l-.249.132.249.133h.125l.249-.133zM408.432 389.218l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM408.807 389.486l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM408.933 389.619c-.125 0 0 0 0 0l-.374.133.249.133h.125l.249-.133-.249-.133zM409.555 390.017l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133c.125 0 .125 0 0 0zM403.817 386.693l-.249-.132h-.125l-.25.132.25.133h.125l.249-.133zM404.192 386.958l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM403.318 386.827l-.249-.133h-.125l-.624.398.25.133h.125l.623-.398zM403.694 387.094l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c.125.133.125 0 0 0zM405.065 387.49l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M404.317 387.093l-.374.133h-.125l-.125.133.499.399h.125l.25-.133-.25-.133.25-.133-.25-.266zM405.44 387.756l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM405.813 388.024l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM406.188 388.291l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M406.312 388.291l-.374.133.249.133h.125l.249-.133-.249-.133zM407.061 388.82l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM407.436 389.085l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM407.809 389.353l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM408.309 389.618l-.249-.132h-.125l-.249.132.249.133h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M408.31 389.619l-.374.133.249.133h.125l.249-.133-.249-.133zM408.808 389.884c-.125 0 0 0 0 0l-.374.133.623.399h.125l.25-.133-.624-.399zM404.94 387.892l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM405.315 388.157l-.249-.133h-.125l-.25.133.25.132h.125l.249-.132zM405.439 388.288c0-.133 0-.133 0 0l-.375.133.25.133h.125l.249-.133-.249-.133zM406.188 388.686l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM406.561 388.953l-.249-.132h-.125l-.249.132.249.133h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M406.687 388.952c-.125 0 0 0 0 0l-.375.133.25.133h.125l.249-.133-.249-.133zM407.311 389.486l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133c.125 0 .125 0 0 0zM407.809 389.752l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM408.184 390.017l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM408.559 390.284l-.249-.133h-.125l-.249.133.249.132h.125l.249-.132zM408.683 390.284l-.374.133.374.266h.125l.249-.133-.374-.266zM403.444 387.358l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M403.568 387.357c-.125 0 0 0 0 0l-.375.133.375.265h.124l.25-.132-.374-.266zM404.317 387.892l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 0 0 0zM404.443 388.024l-.375.133.25.132h.125l.249-.132-.249-.133zM405.065 388.424l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c.125 0 .125 0 0 0zM405.565 388.686l-.374-.133h-.125l-.25.133.25.133h.125l.374-.133zM405.938 388.953l-.249-.132h-.125l-.25.132.25.133h.125l.249-.133zM406.311 389.218l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM406.686 389.486l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c.125 0 .125 0 0 0zM407.186 389.752l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM407.559 390.017l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM407.685 390.149c-.125-.133 0-.133 0 0l-.374.133.249.133h.125l.249-.133-.249-.133zM408.684 390.817l-.624-.399h-.125l-.249.133.623.399h.125l.25-.133zM402.57 387.226l-.249-.133h-.125l-.624.399.25.133h.125l.623-.399c.125.133.125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M403.069 387.491l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M403.319 387.756l-.124-.133h-.125l-.25.133.125.133h.125l.249-.133zM403.692 387.892l-.124-.133h-.125l-.25.133.125.133h.125l.249-.133c0 .133 0 0 0 0zM404.192 388.289l-.499-.265h-.125l-.25.133.499.265h.125l.25-.133c.124 0 .124 0 0 0zM404.692 388.556l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM405.065 388.82l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM405.191 388.952c-.125 0 0 0 0 0l-.375.133.25.133h.125l.249-.133-.249-.133zM405.813 389.353l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c.125 0 0 0 0 0zM406.311 389.618l-.249-.132h-.125l-.249.132.249.133h.125l.249-.133zM406.686 389.884l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM407.061 390.149l-.249-.133h-.125l-.249.133.249.132h.125l.249-.132zM407.436 390.417l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM407.934 390.683l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM408.307 390.947l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM402.819 387.892l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M402.945 387.891c-.125 0 0 0 0 0l-.25.133.25.133h.125l.249-.133-.374-.133zM403.569 388.424l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M403.693 388.423l-.375.133.25.133h.125l.249-.133-.249-.133zM406.062 389.883l-1.871-1.196h-.125l-.25.133 1.872 1.196h.124l.25-.133c0 .133 0 0 0 0zM406.438 390.149l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133c0 .133 0 0 0 0zM406.813 390.417l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133zM407.311 390.683l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM407.684 390.947l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133zM408.057 391.213l-.249-.133h-.125l-.249.133.249.133h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M406.688 386.03l-6.487-4.121c-.125 0-.125 0-.125.133l.749 5.583c0 .133.124.266.249.266l6.487 4.12c.125 0 .125 0 .125-.133l-.749-5.582-.249-.266z"
            fill="#fff"
            />
            <path
            d="M407.561 392.144l-6.612-4.253c-.125-.133-.249-.266-.249-.399l-.749-5.582c0-.133 0-.133.125-.133h.125l6.487 4.12c.124.133.249.266.249.399l.749 5.583c0 .265 0 .265-.125.265.125 0 0 0 0 0zm-7.36-10.234l.748 5.715c0 .133.125.266.125.266l6.487 4.121-.749-5.583c0-.133-.124-.266-.124-.266l-6.487-4.253z"
            fill="#140035"
            />
            <path
            d="M400.823 387.625c0 .133.125.266.25.266l6.487 4.121c.124 0 .124 0 .124-.133l-.124-.665c-2.371-2.392-4.741-4.785-7.236-7.178l.499 3.589z"
            fill="url(#paint82_linear_874_76773)"
            opacity={0.4}
            />
            <path
            d="M407.061 386.296c0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0 0-.133-.125-.133-.125-.133l-6.487-4.121-.125.133 6.487 4.121c0-.133.125-.133.25 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l.623 5.715v.133h.125v-.133l-.748-5.715z"
            fill="#131A2D"
            />
            <path
            d="M406.688 401.05c.125 0 .748-.133.998-.265.499-.266.998-.665.998-1.197 0-.133.125-.399.125-.399s.124.399.249.665-.249.532-.249.532l-.125-.399s-.125.133-.25.665c0 .265-.249.531-1.372.797-.624 0-.499-.266-.374-.399 0 0-.125.133 0 0z"
            fill="#fff"
            />
            <path
            d="M407.312 400.253c.249-.532.249-.798-.125-1.861 0 0 .499 0 .998-.399 0 0 .125.266.125.399.124.266.374.399.374.797.125.399-.25.665-.374 1.197 0 .266-.375.664-1.373.797-.873.133.125-.399.375-.93z"
            fill="#131A2D"
            />
            <path
            d="M411.802 380.314c.375 0 .874.133 1.123 1.596.25 1.329.374 2.126.374 3.057.125.93-.748.93-1.122-.133-.125-.399-.499-1.329-.749-2.127-.374-1.063-.624-2.393.374-2.393z"
            fill="#fff"
            />
            <path
            d="M412.925 385.631c-.249 0-.623-.265-.873-.797-.249-.399-.499-1.329-.748-2.26-.25-.664-.375-1.728-.125-2.127a.927.927 0 01.624-.265c.499 0 .873.133 1.247 1.595.25 1.329.374 2.126.374 3.057 0 .399-.124.797-.499.797.125 0 0 0 0 0zm-1.122-5.316c-.25 0-.375.132-.499.265-.25.266-.25.931.124 1.994.25.931.624 1.861.749 2.127.249.532.624.797.873.797.125 0 .25-.265.25-.664-.125-.931-.125-1.728-.375-3.057-.374-1.33-.748-1.462-1.122-1.462z"
            fill="#140035"
            />
            <path
            d="M411.802 380.315c.375 0 .874.133 1.123 1.595.125.665.125.798.25 1.33-.25.266-.998.398-1.497.266-.125-.266-.25-.532-.25-.931-.374-.93-.624-2.26.374-2.26z"
            fill="#0EA59D"
            />
            <path
            d="M411.803 383.638h-.25c-.125-.265-.249-.664-.249-.93-.25-.665-.375-1.728-.125-2.127a.923.923 0 01.624-.266c.499 0 .873.133 1.247 1.595v.266c.125.399.125.665.125 1.064-.374.266-.873.398-1.372.398zm-.125-.265c.499 0 1.123-.133 1.372-.266 0-.399-.125-.665-.125-1.064v-.265c-.249-1.33-.623-1.463-.998-1.463-.249 0-.374.133-.499.266-.249.266-.249.931.125 1.994-.125.266 0 .532.125.798z"
            fill="#140035"
            />
            <path
            d="M410.18 378.719c0-.664.998-.664.998-.664s-.124 1.595.499 1.861c0 0-.499 0-.873.398-.499.399-1.247.665-1.247.665s-.125-.931.124-1.063c.499-.399.499-.665.499-1.197z"
            fill="#fff"
            />
            <path
            d="M409.432 380.979c0-.399 0-1.064.124-1.196.375-.266.499-.399.499-.931 0-.133 0-.399.125-.399.25-.266.873-.265.873-.265h.125v.132s-.125 1.463.499 1.728l.25.133h-.375s-.499 0-.873.399c-.374.266-1.123.399-1.247.399zm1.621-2.791c-.124 0-.499-.001-.623.265-.125.133-.125.266-.125.399 0 .532 0 .798-.499 1.063-.125 0-.125.399-.125.931.25 0 .749-.266 1.123-.532.249-.266.499-.266.748-.399-.499-.398-.499-1.462-.499-1.727z"
            fill="#140035"
            />
            <path
            d="M410.556 376.593c.499.266.499.798.499.798s.249-.399.374.133c.125.531-.25.398-.25.531s0 .399-.374.798-.873.532-.998.399-.499-.798-.624-1.064c-.124-.266 0-.399-.124-.93 0-.798.998-.931 1.497-.665z"
            fill="#fff"
            />
            <path
            d="M409.932 379.251c-.125 0-.25-.133-.25-.133s-.124-.133-.124-.266c-.125-.266-.375-.665-.375-.798 0-.132 0-.265-.124-.398v-.532c0-.266.124-.399.249-.532.374-.266.873-.266 1.248-.133.374.266.499.532.499.665 0 0 .124-.133.249-.133s.125.133.25.399c0 .399-.125.532-.25.532 0 .265-.125.398-.374.797-.25.399-.749.532-.998.532zm.125-2.659c-.25 0-.499 0-.624.133s-.25.266-.25.399v.93c0 .133.25.532.375.798a.427.427 0 01.124.266h.125c.125 0 .624-.133.873-.399.375-.399.375-.532.375-.665v-.132h.124s.125 0 .125-.399c0-.133-.125-.266-.125-.266s-.124 0-.124.133l-.125.133v-.266s0-.399-.499-.665h-.374z"
            fill="#140035"
            />
            <path
            d="M408.56 387.891a.925.925 0 00.624-.266c.124-.133-.375.266-.499 0 0-.133.249 0 .374-.266.374-.399.374 0 .873-.399.624-.532 1.497-1.861 2.37-2.259.874-.399 1.123.398.749.93-.873.93-3.244 2.127-3.618 2.525-.374.399-.499.399-.499.266-.125-.133-.249 0-.374 0s-.25-.266-.374-.398c-.125 0 .124-.133.374-.133z"
            fill="#fff"
            />
            <path
            d="M408.934 388.555c-.125 0 0 0 0 0h-.25-.249c-.125 0-.125-.133-.25-.133 0-.133-.125-.133-.125-.133-.124 0-.124-.132-.124-.132 0-.133.249-.133.499-.133.124 0 .249 0 .374-.133-.125 0-.25 0-.25-.133v-.133l.125-.133c.125 0 .25-.133.25-.133.249-.133.374-.133.374-.133.125 0 .249 0 .499-.266l.624-.664c.499-.532 1.247-1.33 1.871-1.595.374-.133.748-.133.873.133.125.265.125.664-.125.93-.623.665-1.871 1.462-2.744 1.994-.499.266-.749.531-.873.531-.25.133-.375.266-.499.266zm-.125-.266s.125 0 0 0c.125.133.249 0 .499-.265.125-.133.499-.266.998-.532.873-.532 2.121-1.329 2.744-1.861.25-.266.25-.532.125-.797-.125-.266-.374-.266-.748 0-.624.265-1.248 1.063-1.872 1.595l-.623.664c-.25.266-.375.266-.499.266-.125 0-.125 0-.375.133-.124.133-.249.133-.374.133h.499v.133c-.125.133-.374.399-.624.399h-.249c.125 0 .125.132.249.265l.125.133h.125c-.125-.266 0-.266 0-.266z"
            fill="#140035"
            />
            <path
            d="M107.288 197.816c0-.665-.125-1.462-.624-2.26 0-.133-.125-.133-.125-.266l-.125-.133c0-.133-.124-.133-.249-.266v-.133a13.725 13.725 0 00-1.871-1.993c-.25-.133-.499-.399-.749-.532l-.125-.133c-.249-.133-.499-.266-.748-.532 0 0-.125 0-.125-.133-.374-.265-.624-.398-.998-.664-4.366-2.526-8.358-2.26-9.231-.665v.133l-.125.133c-.125 0-.374-.133-.624-.133s-.374-.133-.624-.133h-.499c-.25 0-.499 0-.873-.133h-.748l.124-.133.125-.132.125-.133.125-.133c.124 0 .374-.133.499-.133.124 0 .25-.133.374-.133.125 0 .125 0 .25-.133.124 0 .124 0 .249-.133.125 0 .25-.133.374-.133.125 0 .25-.133.374-.133 0 0 .125 0 .125-.133.125 0 .25-.133.374-.133 0 0 .125 0 .125-.133.125 0 .25-.133.374-.265h.125c.125-.133.25-.133.374-.266.125-.133.25-.133.25-.266 0 0 .125 0 .125-.133l.124-.133.375-.399s0-.133.124-.133l.125-.133v-.133s0-.132.125-.265v-.133-1.595c.125-.133.25-.133.374-.266.125-.133.25-.133.25-.266 0 0 .124 0 .124-.133l.125-.133.374-.399s0-.133.125-.133l.125-.132v-.133c.125 0 .125.133.25.133.124 0 .374.132.498.132.125 0 .25 0 .375.133.124 0 .25 0 .374.133h.125c.124 0 .25 0 .374.133h5.239c.125 0-24.201-15.95-24.201-15.95v.531c0 .133 0 .133.125.133 0 0 0 .133.124.133.125 0 0 .133.125.133l.125.133.125.133.374.399.125.133c-.125.266-.125.398-.125.664v.532h-.624c-3.867 0-6.861 1.329-7.984 2.791 0 0 0 .133-.125.133-.25.399-.374.798-.374 1.197v.265c-.374.133-.748.399-.998.532a1.829 1.829 0 01-.374-.532c-.125-.265-.374-.398-.624-.531.125 0 .25-.133.374-.133 0 0 .125 0 .125-.133.125 0 .25-.133.374-.133 0 0 .125 0 .125-.133.125 0 .25-.133.374-.266h.125c.125-.133.25-.133.374-.266.125-.133.25-.133.25-.265 0 0 .125-.001.125-.133l.124-.133.375-.399s0-.133.124-.133l.125-.133v-.133s0-.133.125-.266v-.133-2.658c0-.798-.624-1.595-1.747-2.393-.124 0-.25-.133-.25-.133l-.124-.132c-.125 0-.25-.133-.25-.133h-.124c-.749-.399-1.622-.665-2.62-.931-.25 0-.499-.133-.873-.133h-.25c-.25 0-.499 0-.873-.133h-1.247c-4.74 0-8.11 1.994-8.359 3.855v.266h-.124c-2.994.664-5.115 2.127-5.365 3.456v3.19s0 .133.125.266l.125.133s0 .133.125.133l.124.133.125.132c.125.133 0 .133.125.133-.374.133-.624.133-.873.266-1.872.798-3.12 1.861-3.244 2.924v2.659c0 .133 0 .266.125.399v.133s0 .132.125.265c0 0 0 .133.124.133.125 0 0 .133.125.133l.125.133.125.133.374.399c.125.133.374.266.499.399s.25.133.374.265c.125.133.25.133.374.266h.125c.125 0 .25.133.374.133h.125c.125 0 .125.133.25.133h.124c.125 0 .25.133.375.133.124 0 .374.133.499.133.124 0 .25.133.374.133.125 0 .25 0 .374.133h.125c.125 0 .25 0 .374.133h1.123v.93c0 .133 0 .133.125.266l.124.133.125.133.125.133.125.133.374.398c.125.133.25.266.499.399.125.133.25.133.374.266.125.133.25.133.374.266h.125c.125 0 .25.133.374.133h.125c.125 0 .125.133.25.133h.124c.125 0 .25.133.375.133.124 0 .374.133.499.133.124 0 .25.133.374.133.125 0 .25 0 .374.132h.125c.125 0 .25 0 .374.133H64.374v2.393s0 .133.124.266c0 0 0 .133.125.133s0 .133.125.133l.125.133.124.132.375.399c.124.133.374.266.499.399.124.133.25.133.374.266.125.133.25.133.499.266h.125c.124 0 .25.133.374.133h.125c.124 0 .124.132.25.132h.124c.125 0 .25.133.374.133.125 0 .125 0 .25.133-.5.266-.874.532-1.248.798-.624.532-.998 1.196-.998 1.861v2.924c0 .133 0 .133.125.266 0 0 0 .133.125.133 0 0 0 .133.124.133l.125.133s0 .133.125.133l.374.398c.125.133.374.266.5.399.124.133.249.133.373.266.125.133.25.133.375.266h.124c.125 0 .25.133.375.133h.124l.25.133h.125c.124 0 .25.133.374.133.125 0 .374.132.499.132s.25.133.374.133c.125 0 .25 0 .374.133h.125c.125 0 .25 0 .374.133H77.472c.125 0 .25 0 .375-.133.124 0 .374-.133.499-.133.124 0 .25-.133.374-.133.125 0 .125 0 .25-.132.124 0 .124-.001.249-.133.125 0 .25-.133.374-.133.125 0 .25-.133.374-.133 0 0 .125 0 .125-.133.125 0 .25-.133.374-.133h.125c.125 0 .25-.133.374-.266h.125c.125-.133.25-.133.374-.266.125-.133.25-.133.25-.266l.125-.133.124-.132.375-.399s0-.133.124-.133l.125-.133s0-.133.125-.133c0-.133 0-.133.125-.266v-.133-1.861s.124 0 .124.133h.125c.125 0 .125.133.25.133h.124c.125 0 .25.133.375.133.124 0 .374.133.499.133l.374.133c.125 0 .25 0 .374.133h.125c.125 0 .25 0 .374.133h5.739c.124 0 .25 0 .374-.133.125 0 .25 0 .374-.133.125 0 .374-.133.5-.133.124 0 .249-.133.373-.133.125 0 .125 0 .25-.133.125 0 .125 0 .25-.133.124 0 .249-.133.374-.133.124 0 .25-.133.374-.133 0 0 .125 0 .125-.132.124 0 .25-.133.374-.133 0 0 .125 0 .125-.133.124-.133.25-.133.374-.133h.125l.124.133s.125 0 .125.133c.125 0 .125.133.25.133 0 0 .124 0 .124.132.125.133.25.133.375.266h.124c.125 0 .125.133.25.133 0 0 .125 0 .125.133.124 0 .25.133.374.133l.125.133c.124 0 .25.133.25.133.124 0 .249.133.373.133h.125c.125 0 .125.133.25.133 0 0 .124 0 .124.133.125 0 .25.133.375.133.124 0 .124 0 .25.132.124 0 .124.133.249.133.124 0 .25.133.374.133h.125c.124 0 .249.133.374.133s.249.133.374.133.374.133.499.133.25 0 .374.133h2.87c.249 0 .374-.133.499-.133h.124c.125 0 .375-.133.499-.133 0 0 .125 0 .125-.133l.125-.133s.125 0 .125-.133l.124-.133.125-.132.25-.266.998-1.994.124-.133c-.249 1.063-.124.798-.124.532zm-27.445-3.589v1.329h-.125s-.125 0-.125-.133l-1.123-.399s.125 0 .125-.133c.125 0 .25-.133.374-.133h.125c.125-.132.25-.132.374-.265.125-.133.25-.133.25-.266s.125-.133.125 0c0-.133 0-.133 0 0 0-.133 0-.133 0 0zm.998-1.994v-.266h.249c-.125.133-.25.133-.25.266zm5.114-33.097v0z"
            fill="#BBBBBF"
            opacity={0.52}
            />
            <path
            d="M114.024 188.644l-16.217-9.438-16.218-9.437a2.235 2.235 0 00-.998-.266c-.374 0-.748.133-.998.266l-2.245 1.595c-.624.399-.998 1.196-.998 1.994 0 .797.374 1.595 1.122 1.993l16.218 9.305 16.217 9.304c.25.133.624.266.998.266.375 0 .749-.133.998-.266l2.246-1.462c.624-.399 1.123-1.196 1.123-1.994 0-.797-.624-1.462-1.248-1.86z"
            fill="#fff"
            />
            <path
            d="M77.348 171.629a2.062 2.062 0 00-.749 1.064c-.124.266-.124.531-.124.797 0 .798.623 1.462 1.122 1.861l15.22 8.773.748.399 16.093 9.304c.25.133.624.266.998.266h.125c.249 0 .374 0 .624-.133.124 0 .249-.133.249-.133l2.121-1.462a2.06 2.06 0 00.748-1.063c.125-.266.125-.532.125-.798 0-.797-.624-1.595-1.123-1.861l-15.22-8.773-.748-.398-16.092-9.305a2.235 2.235 0 00-.998-.266h-.125c-.25 0-.374 0-.624.133-.125 0-.25.133-.25.133l-2.12 1.462z"
            fill="#F8F8F9"
            />
            <path
            d="M77.472 171.762c-.374.266-.624.665-.624 1.064-.124.265 0 .531 0 .797 0 .665.749 1.462 1.248 1.728l15.095 8.64.748.399 15.843 9.171c.25.133.749.266.998.266h.125c.25 0 .374 0 .624-.133.125 0 .249-.133.249-.133l2.121-1.462c.374-.266.624-.665.749-1.063.124-.266 0-.532 0-.798 0-.664-.749-1.462-1.248-1.728l-15.22-8.64-.748-.398L81.59 170.3c-.25-.133-.749-.266-.998-.266h-.125c-.25 0-.374 0-.624.133-.124 0-.25.133-.25.133l-2.12 1.462z"
            fill="#F1F1F3"
            />
            <path
            d="M77.596 171.896c-.374.266-.624.665-.624 1.063-.124.133.125.532.125.665 0 .532.873 1.462 1.372 1.728l14.846 8.64.748.398 15.719 9.039c.249.133.748.399.998.399h.124c.25 0 .375 0 .624-.133.125 0 .25-.133.25-.133l2.12-1.462c.375-.266.624-.665.624-1.063.125-.133-.125-.532-.125-.665 0-.532-.873-1.462-1.247-1.728l-14.97-8.64-.749-.399-15.718-9.038c-.25-.133-.749-.399-.998-.399h-.125c-.25 0-.374 0-.624.133-.124 0-.25.133-.25.133l-2.12 1.462z"
            fill="#EAEBEC"
            />
            <path
            d="M77.598 172.029c-.374.266-.624.797-.5 1.063 0 .133.25.532.25.665 0 .399.998 1.329 1.373 1.595l14.72 8.507.749.399 15.593 8.905c.125.133.749.399.874.399h.124c.25 0 .375 0 .624-.133l.25-.133 2.12-1.462c.375-.266.624-.797.499-1.063 0-.133-.249-.532-.249-.665 0-.399-.998-1.329-1.372-1.595l-14.72-8.507-.75-.399-15.593-9.038c-.125-.133-.749-.399-.873-.399h-.125c-.25 0-.374 0-.624.133l-.25.133-2.12 1.595z"
            fill="#E3E4E6"
            />
            <path
            d="M77.722 172.294c-.374.266-.5.798-.374 1.064 0 .133.25.531.25.664 0 .399 1.122 1.329 1.496 1.462l14.596 8.374.748.399 15.345 8.906c.124.133.748.399.873.399h.748l.25-.133 2.121-1.462c.374-.266.499-.798.374-1.064 0-.133-.25-.532-.25-.664 0-.399-1.122-1.33-1.497-1.463l-14.595-8.374-.749-.398-15.344-8.906c-.125-.133-.749-.399-.873-.399h-.749l-.25.133-2.12 1.462z"
            fill="#DDDDE0"
            />
            <path
            d="M77.846 172.428c-.374.266-.499.797-.25 1.063 0 .133.375.399.375.532 0 .266 1.372 1.196 1.497 1.329l14.346 8.241.749.399 15.219 8.773c.125 0 .749.398.873.398h.749l.249-.133 1.996-1.462c.375-.266.499-.797.25-1.063 0-.133-.374-.399-.374-.532 0-.266-1.373-1.196-1.497-1.329l-14.347-8.374-.748-.399-15.22-8.773c-.124 0-.748-.398-.873-.398h-.125c-.25-.133-.374 0-.623 0l-.25.133-1.996 1.595z"
            fill="#D6D6DA"
            />
            <path
            d="M77.846 172.56c-.374.266-.499.797-.25 1.063 0 0 .5.399.5.532s1.497 1.196 1.621 1.196l14.222 8.108.748.399 14.97 8.64c.125 0 .749.399.874.399h.124c.125.133.375.133.624 0l.25-.133 1.996-1.329c.374-.266.499-.798.249-1.064 0 0-.499-.398-.499-.531s-1.497-1.197-1.622-1.197l-14.221-8.241-.749-.398-14.97-8.64c-.124 0-.748-.399-.873-.399h-.125c-.124-.133-.374-.133-.623 0l-.25.133-1.996 1.462z"
            fill="#CFD0D3"
            />
            <path
            d="M77.97 172.693c-.374.266-.374.798-.124 1.063l.499.399c0 .133 1.621 1.064 1.746 1.064l13.972 8.108.749.398 14.845 8.507.873.399h.125a.362.362 0 00.499 0l.25-.133 1.996-1.329c.374-.266.374-.798.124-1.063l-.499-.399c0-.133-1.621-1.064-1.746-1.196l-13.972-8.109-.749-.398-14.845-8.64-.873-.532h-.125c-.125-.133-.374-.133-.624 0l-.25.133-1.87 1.728z"
            fill="#C8C9CD"
            />
            <path
            d="M80.84 171.231a.362.362 0 00-.5 0l-2.245 1.595c-.374.265-.374.93 0 1.063l16.218 9.304 16.217 9.305a.362.362 0 00.499 0l2.246-1.462a.645.645 0 000-1.064l-16.218-9.437-16.217-9.304z"
            fill="#C1C2C7"
            />
            <path
            opacity={0.3}
            d="M131.987 195.821l-36.552 21.533-24.576-14.887 35.554-20.868 25.574 14.222z"
            fill="url(#paint83_linear_874_76773)"
            />
            <path
            d="M113.649 106.366c-.374-3.456-2.495-7.045-5.489-8.773l-24.077-14.09c-1.497-.93-2.994-.93-3.867-.265L78.719 84.3c.998-.664 2.37-.531 3.867.266l24.202 14.09c3.118 1.861 5.364 5.848 5.488 9.703 0 1.329.375 79.221.375 79.221 0 1.595 0 3.323-1.248 4.253l1.497-1.063c1.497-1.196 1.248-3.057 1.248-4.652 0-6.115-.125-76.031-.499-79.753z"
            fill="#131A2D"
            />
            <path
            d="M112.527 188.644c-.125 3.323-2.495 4.652-5.365 2.924l-13.098-7.709-9.481-5.583-1.996-1.196a5.571 5.571 0 01-1.373-1.064c-1.996-1.728-3.493-4.386-3.992-7.044-.124-.532-.124-1.064-.124-1.595V87.624c0-3.589 2.37-5.05 5.364-3.19l9.98 5.849 4.74 2.79 3.493 1.995 5.988 3.456a9.98 9.98 0 013.369 3.19c1.372 1.994 2.12 4.253 2.12 6.38l.375 80.55z"
            fill="#0EA59D"
            />
            <path
            d="M109.657 192.366c-.748 0-1.621-.266-2.37-.797l-24.7-14.356a5.567 5.567 0 01-1.373-1.063c-1.996-1.728-3.493-4.519-3.992-7.045-.124-.532-.124-1.063-.124-1.595V87.758c0-1.728.499-3.058 1.497-3.59.998-.664 2.495-.531 3.992.266l24.201 14.09c1.248.798 2.37 1.861 3.368 3.19 1.373 1.994 2.121 4.254 2.121 6.513 0 3.323.374 80.417.374 80.417 0 1.595-.623 2.792-1.621 3.323-.375.266-.874.399-1.373.399zM80.092 83.77c-.5 0-.998.133-1.497.399-.998.664-1.497 1.86-1.497 3.589v79.752c0 .532 0 1.063.124 1.595.5 2.526 1.996 5.184 3.868 6.912.499.399.873.797 1.372 1.063l24.576 14.489c1.497.797 2.744.93 3.742.398.873-.531 1.497-1.728 1.497-3.323 0-.398-.374-79.619-.374-80.417 0-2.126-.749-4.386-2.121-6.38-.873-1.329-2.121-2.392-3.368-3.19l-23.952-14.09c-.749-.531-1.622-.797-2.37-.797z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M78.219 166.712l33.308 18.875v-.133l-33.308-18.875v.133zM78.594 87.226l32.061 18.476.124-.133-32.06-18.609-.125.266zM101.547 182.53l4.865 2.658v-.133l-4.865-2.791v.266zM101.422 183.46l4.865 2.659v-.133l-4.865-2.791v.265zM101.422 184.391l4.865 2.658v-.133l-4.865-2.791v.266zM93.815 178.01c-.5-.265-.998.133-1.123.665-.125.665.25 1.329.873 1.462.125 0 .25.133.374.133.125 0 .25 0 .375-.133a.74.74 0 00.374-.664c0-.665-.374-1.33-.873-1.463zm.623 1.463c0 .265-.124.398-.374.531-.125.133-.374.133-.624 0-.374-.133-.748-.797-.623-1.196 0-.532.499-.798.873-.665s.873.798.748 1.33z"
            fill="#fff"
            />
            <path
            d="M110.406 102.378c.624 1.329.873 2.791.873 4.12l.374 80.949c-.124 3.323-2.12 4.387-5.114 2.659l-24.826-14.755c-1.372-.797-2.744-2.259-3.617-3.854.998 2.259 2.62 4.519 4.615 5.582l24.576 14.489c2.869 1.728 5.24.398 5.364-2.925l-.374-80.417c-.125-2.126-.748-4.12-1.871-5.848z"
            fill="#D1D2D6"
            />
            <path
            d="M110.156 102.112c.624 1.33.873 2.792.873 4.121l.375 80.816c-.125 3.323-2.121 4.386-4.99 2.658l-24.826-14.621c-1.372-.798-2.744-2.26-3.617-3.855.998 2.26 2.62 4.386 4.615 5.583l24.451 14.355c2.87 1.728 5.24.399 5.365-2.924l-.375-80.284c0-2.127-.748-4.121-1.871-5.849z"
            fill="url(#paint84_linear_874_76773)"
            />
            <path
            d="M110.031 101.846c.624 1.33.874 2.792.874 4.121l.374 80.683c-.125 3.323-2.121 4.386-4.99 2.658l-24.7-14.621c-1.373-.798-2.62-2.26-3.618-3.855.998 2.26 2.62 4.387 4.49 5.583l24.452 14.355c2.869 1.728 5.239.399 5.364-2.924l-.374-80.284c-.125-1.994-.874-3.988-1.872-5.716z"
            fill="url(#paint85_linear_874_76773)"
            />
            <path
            d="M109.782 101.581c.499 1.329.873 2.791.873 4.121l.374 80.682c-.125 3.323-2.121 4.387-4.99 2.659l-24.576-14.621c-1.372-.798-2.62-2.26-3.617-3.722.998 2.259 2.62 4.386 4.49 5.583l24.327 14.222c2.869 1.728 5.239.399 5.364-2.924l-.374-80.151c-.125-1.994-.749-4.121-1.871-5.849z"
            fill="url(#paint86_linear_874_76773)"
            />
            <path
            d="M109.532 101.314c.499 1.33.873 2.792.873 3.988l.374 80.55c-.125 3.323-2.121 4.386-4.99 2.658l-24.576-14.488c-1.372-.797-2.62-2.127-3.617-3.722.998 2.26 2.62 4.387 4.49 5.45l24.202 14.355c2.869 1.728 5.24.399 5.364-2.924l-.374-80.018c0-1.994-.624-4.121-1.746-5.849z"
            fill="url(#paint87_linear_874_76773)"
            />
            <path
            d="M109.407 101.048c.499 1.329.873 2.791.873 3.987l.374 80.417c-.124 3.324-2.12 4.387-4.99 2.659l-24.45-14.488c-1.373-.798-2.62-2.127-3.618-3.722.998 2.259 2.62 4.386 4.49 5.45l24.202 14.222c2.869 1.728 5.115.399 5.24-2.924l-.375-80.018c0-1.728-.748-3.855-1.746-5.583z"
            fill="url(#paint88_linear_874_76773)"
            />
            <path
            d="M109.157 100.783c.499 1.329.873 2.659.873 3.988l.375 80.417c-.125 3.323-2.121 4.253-4.99 2.658l-24.327-14.488c-1.372-.798-2.62-2.127-3.617-3.722.998 2.26 2.62 4.387 4.49 5.45l24.077 14.222c2.87 1.728 5.115.399 5.24-2.924l-.374-79.885c0-1.861-.624-3.988-1.747-5.716z"
            fill="url(#paint89_linear_874_76773)"
            />
            <path
            d="M108.909 100.517c.499 1.329.873 2.658.873 3.987l.375 80.284c-.125 3.323-2.121 4.254-4.99 2.659L80.84 173.091c-1.372-.797-2.62-2.126-3.617-3.721.998 2.259 2.62 4.386 4.49 5.449l24.077 14.223c2.87 1.728 5.115.399 5.24-2.924l-.374-79.753c0-1.994-.624-4.12-1.747-5.848z"
            fill="url(#paint90_linear_874_76773)"
            />
            <path
            d="M108.784 100.252c.499 1.329.874 2.658.874 3.988l.374 80.151c-.125 3.19-2.121 4.253-4.865 2.658L80.84 172.694c-1.372-.798-2.62-2.127-3.617-3.722.998 2.26 2.62 4.386 4.49 5.45l23.953 14.089c2.869 1.728 5.114.399 5.239-2.924l-.374-79.752c0-1.728-.749-3.855-1.747-5.583z"
            fill="url(#paint91_linear_874_76773)"
            />
            <path
            d="M108.535 99.985c.499 1.33.873 2.659.873 3.855l.374 80.151c-.125 3.19-2.121 4.254-4.865 2.659l-24.202-14.356c-1.372-.797-2.62-2.127-3.617-3.722.998 2.26 2.62 4.387 4.49 5.45l23.828 14.09c2.869 1.595 5.115.399 5.239-2.924l-.374-79.62c0-1.728-.624-3.855-1.746-5.583z"
            fill="url(#paint92_linear_874_76773)"
            />
            <path
            d="M101.423 151.691c-1.123 0-2.121.133-2.994.266h-5.365v2.127c.125 1.861 3.493 3.987 8.359 3.987 4.865 0 8.233-1.993 8.358-3.987v-2.127h-5.364c-.998-.266-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M101.422 158.072c-4.865 0-8.233-1.994-8.358-3.988v-2.393h5.49c.997-.133 1.995-.265 2.993-.265.998 0 1.996.132 2.994.265h5.364v2.26c-.374 2.127-3.742 4.121-8.483 4.121zm-8.358-3.988c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-2.127h-5.239c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.365v2.127h.125z"
            fill="#131A2D"
            />
            <path
            d="M93.938 155.811c.124.133.374.266.498.399v-4.253h-.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M94.561 156.343c-.25-.266-.499-.398-.624-.531v-3.988h.624v4.519zm-.499-.531c.125.133.25.265.374.265v-4.12h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M103.918 151.824v5.981c.125 0 .374 0 .499-.133v-5.715c-.25-.133-.374-.133-.499-.133z"
            fill="#0EA59D"
            />
            <path
            d="M103.793 157.939v-6.115h.125c.124 0 .249 0 .499.133h.124v5.982c-.249-.133-.499 0-.748 0zm.125-5.982v5.849c.124 0 .249 0 .374-.133v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M102.92 157.939h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M102.92 158.071v-6.38h.624v6.247c-.25 0-.375.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M107.41 156.742c.125-.133.374-.266.499-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M107.41 156.742v-4.918h.624v4.519c-.125.133-.374.266-.624.399zm.125-4.785v4.652c.125-.133.249-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M102.047 158.071h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M102.047 158.071v-6.513h.624v6.381c-.25.132-.375.132-.624.132zm.125-6.38v6.248h.374v-6.115c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M108.408 156.078c.25-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M108.283 156.211v-4.387h.624v3.855c-.125.133-.25.399-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M105.664 157.407c.125 0 .374-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M105.539 157.54v-5.716h.624v5.45c-.125.133-.25.133-.624.266zm.25-5.583v5.317c.124 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M104.791 157.672c.125 0 .374-.133.499-.133v-5.582h-.499v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M104.666 157.805v-5.848h.624v5.715c-.125 0-.374 0-.624.133zm.125-5.848v5.582c.125 0 .249 0 .374-.132v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M106.537 157.141c.125-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M106.537 157.141v-5.317h.624v5.051c-.25.133-.374.266-.624.266zm.125-5.184v5.051c.125 0 .249-.133.374-.133v-4.918h-.374z"
            fill="#131A2D"
            />
            <path
            d="M96.682 157.274c.124 0 .374.133.499.133v-5.45h-.5v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M97.305 157.539c-.25-.132-.499-.132-.623-.132v-5.45h.623v5.582zm-.623-.265c.124 0 .25.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M100.301 157.939h.499v-6.381h-.499v6.381z" fill="#0EA59D" />
            <path
            d="M100.8 158.071h-.624v-6.513h.624v6.513zm-.499-.132h.374v-6.248h-.374v6.248z"
            fill="#131A2D"
            />
            <path d="M101.174 151.691v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M101.423 158.071h-.249v-6.513h.748v6.513h-.499zm-.249-.132h.374v-6.248h-.374v6.248z"
            fill="#131A2D"
            />
            <path
            d="M93.064 154.084c0 .399.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M93.688 155.546l-.125-.133c-.374-.399-.499-.797-.624-1.196v-2.393h.749v3.722zm-.624-1.462c0 .399.125.797.5 1.196v-3.323h-.5v2.127z"
            fill="#131A2D"
            />
            <path
            d="M109.281 155.28c.25-.399.374-.798.499-1.064v-2.259h-.499v3.323z"
            fill="#0EA59D"
            />
            <path
            d="M109.156 155.413v-3.589h.624v2.26c0 .398-.249.664-.499 1.063l-.125.266zm.125-3.456v3.057c.25-.266.25-.665.374-.93v-2.127h-.374z"
            fill="#131A2D"
            />
            <path
            d="M94.81 156.476c.125.133.375.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M95.434 156.875c-.25-.133-.499-.266-.623-.399v-4.652h.623v5.051zm-.499-.399c.125.133.25.133.374.266v-4.785h-.374v4.519z"
            fill="#131A2D"
            />
            <path d="M99.3 157.938h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M99.924 158.071h-.623v-6.247h.623v6.247zm-.499-.265h.375v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M95.809 156.875c.124.133.374.133.499.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M96.307 157.274c-.25-.133-.499-.133-.623-.266v-5.184h.623v5.45zm-.499-.399c.125 0 .25.133.375.133v-5.051h-.375v4.918z"
            fill="#131A2D"
            />
            <path
            d="M97.555 157.539c.124 0 .374.133.499.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M98.178 157.805c-.25 0-.374-.133-.623-.133v-5.715h.623v5.848zm-.499-.266c.125 0 .25 0 .375.133v-5.715h-.375v5.582z"
            fill="#131A2D"
            />
            <path
            d="M98.428 157.806c.124 0 .374 0 .499.133v-6.115c-.125 0-.375 0-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M99.052 157.938c-.25 0-.375-.132-.624-.132v-5.982c.124 0 .374 0 .499-.133h.124v6.247zm-.5-.265c.125 0 .25 0 .375.133v-5.849c-.125 0-.25 0-.375.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M101.423 147.704c-4.866 0-8.359 2.127-8.359 3.987 0 1.861 3.493 3.988 8.359 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.86-3.493-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M101.423 155.812c-4.99 0-8.359-2.127-8.359-4.12 0-1.994 3.493-4.121 8.359-4.121 4.865 0 8.358 2.127 8.358 4.121 0 1.993-3.493 4.12-8.358 4.12zm0-7.975c-4.866 0-8.234 2.127-8.234 3.988 0 1.86 3.368 3.987 8.234 3.987 4.865 0 8.233-2.127 8.233-3.987 0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M95.934 154.749c.499.265 1.122.398 1.746.664l6.861-7.443c-.623-.133-1.372-.266-2.12-.266l-6.487 7.045zM100.674 155.812H101.921l5.988-6.38c-.249-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M98.677 155.413c-.125 0-.25 0-.5-.133-.249-.133-.623-.133-.873-.266-.249-.133-.623-.133-.873-.266-.124 0-.25-.133-.374-.133l-.25-.132c-.124 0-.124 0-.249-.133l-.749-.399c-.498-.266-.998-.665-1.496-1.064.374.532.748 1.064 1.247 1.33.125.133.25.133.374.266.125.132.25.132.374.265.125 0 .125.133.25.133l.25.133c.124 0 .249.133.374.133l.499.133c.124 0 .25.133.499.133.25.133.623.133.873.133s.624 0 .873.133h.873c-.249-.133-.623-.133-.873-.266h-.25zM102.794 155.413l-1.248.133h-.623c-.25 0-.375 0-.624.133.249 0 .374.133.624.133h1.871c.374 0 .873-.133 1.247-.266l1.123-.399h-1.247c-.25.266-.624.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M107.911 155.812c-1.123 0-2.121.133-2.994.266h-5.364v2.126c.124 1.861 3.493 3.988 8.358 3.988s8.233-1.994 8.358-3.988v-2.126h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M107.911 162.325c-4.865 0-8.234-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.374 1.994-3.743 4.121-8.483 4.121zm-8.358-4.121c.124 1.861 3.493 3.855 8.233 3.855 4.741 0 8.109-1.994 8.234-3.855v-1.994h-5.24c-.873-.265-1.871-.265-2.869-.265-.998 0-1.996.132-2.994.265h-5.364v1.994z"
            fill="#131A2D"
            />
            <path
            d="M100.426 159.932c.125.133.374.266.499.399v-4.254h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M101.05 160.464c-.25-.266-.499-.399-.624-.532v-3.988h.624v4.52zm-.499-.532l.374.399v-4.121h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M110.406 155.944v5.982c.125 0 .375 0 .499-.133v-5.849c-.249.133-.374.133-.499 0z"
            fill="#0EA59D"
            />
            <path
            d="M110.281 162.059v-6.115h.125c.125 0 .25 0 .374.133h.125v5.982h-.624zm.125-5.982v5.849c.125 0 .25 0 .374-.133v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M109.408 162.192h.499v-6.248h-.499v6.248z" fill="#0EA59D" />
            <path
            d="M109.408 162.192v-6.38h.624v6.247c-.25.133-.374.133-.624.133zm.125-6.248v6.115h.374v-5.982c-.125-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M114.023 160.863c.125-.133.375-.266.499-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M113.898 160.996v-4.918h.624v4.519c-.125.133-.374.266-.624.399zm.125-4.785v4.652c.125-.133.25-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M108.533 162.192h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M108.533 162.325v-6.513h.624v6.38c-.25 0-.374 0-.624.133zm.125-6.381v6.248h.374v-6.248h-.374z"
            fill="#131A2D"
            />
            <path
            d="M114.896 160.332c.25-.133.375-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M114.771 160.465v-4.387h.624v3.855c-.125.133-.249.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M112.152 161.661c.125 0 .375-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M112.152 161.66v-5.716h.624v5.45c-.249.133-.374.266-.624.266zm.125-5.45v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M111.279 161.794c.125 0 .375-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M111.154 161.927v-5.849h.624v5.716c-.125 0-.374.133-.624.133zm.125-5.716v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M113.025 161.262c.125-.133.375-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M113.025 161.395v-5.317h.624v5.051c-.249 0-.374.133-.624.266zm.125-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M103.17 161.528c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M103.794 161.794c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.624-.399c.125 0 .249.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M106.787 162.192h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M107.411 162.325h-.624v-6.513h.624v6.513zm-.624-.266h.374v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path d="M107.662 155.812v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M107.912 162.325h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.248h-.374v6.248z"
            fill="#131A2D"
            />
            <path
            d="M99.553 158.338c0 .398.25.797.623 1.329v-3.456h-.623v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M100.176 159.8l-.125-.133c-.374-.399-.499-.798-.623-1.196v-2.393h.748v3.722zm-.624-1.595c0 .399.125.797.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M115.77 159.401c.249-.399.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M115.645 159.533v-3.589h.623v2.26c0 .399-.249.665-.499 1.063l-.124.266zm.124-3.323v3.057c.25-.265.25-.664.375-.93v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M101.424 160.596c.125.133.374.266.499.266v-4.785h-.499v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M101.923 160.995c-.25-.133-.499-.266-.624-.398v-4.653h.624v5.051zm-.499-.398c.124.132.249.132.374.265v-4.652h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M105.914 162.059h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M106.413 162.192h-.624v-6.248h.624v6.248zm-.499-.133h.374v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M102.297 161.129c.125.133.374.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M102.796 161.394c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.266c.124 0 .249.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M104.043 161.794c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M104.667 161.927c-.25 0-.375-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.124 0 .249.133.374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M104.916 161.926c.125 0 .374 0 .499.133v-6.114c-.125 0-.374 0-.499.132v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M105.54 162.059c-.25 0-.374-.133-.624-.133v-5.982c.125 0 .374 0 .499-.132h.125v6.247zm-.499-.133c.125 0 .249 0 .374.133v-5.849c-.125 0-.249 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M107.911 151.824c-4.865 0-8.358 2.127-8.358 3.988 0 1.86 3.493 3.987 8.358 3.987s8.358-2.127 8.358-3.987c0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M107.911 160.065c-4.99 0-8.358-2.127-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121s8.358 2.127 8.358 4.121c0 1.993-3.493 4.12-8.358 4.12zm0-8.108c-4.865 0-8.234 2.127-8.234 3.988 0 1.86 3.369 3.987 8.234 3.987s8.233-2.127 8.233-3.987c0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M102.422 159.002c.499.266 1.123.398 1.746.664l6.862-7.31c-.624-.133-1.373-.266-2.121-.266l-6.487 6.912zM107.162 159.932h1.248l5.988-6.38c-.25-.133-.499-.399-.874-.531l-6.362 6.911z"
            fill="#fff"
            />
            <path
            d="M105.165 159.666c-.124 0-.249 0-.374-.133-.249-.133-.624-.133-.873-.266-.25-.133-.624-.133-.873-.265-.125 0-.25-.133-.375-.133l-.249-.133c-.125 0-.125-.133-.25-.133l-.748-.399c-.499-.266-.998-.665-1.497-1.063.374.531.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.125 0 .125.132.249.132l.25.133c.125 0 .249.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.375zM109.407 159.667l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.399h-1.247c-.374.133-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M119.388 164.451c-1.123 0-2.121.133-2.994.266h-5.365v2.127c.125 1.861 3.493 3.987 8.359 3.987 4.865 0 8.233-1.993 8.358-3.987v-2.127h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M119.387 170.964c-4.865 0-8.233-1.993-8.358-3.987v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.374 2.127-3.742 4.12-8.483 4.12zm-8.358-4.12c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-1.994h-5.239c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.365v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M111.902 168.572c.125.133.375.266.499.399v-4.253h-.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M112.526 169.104c-.249-.266-.499-.399-.624-.532v-3.987h.624v4.519zm-.499-.532c.125.133.25.266.374.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M121.883 164.718v5.981c.125 0 .374 0 .499-.133v-5.848h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M121.758 170.699v-6.114h.125c.124 0 .249 0 .374.133h.125v5.981h-.624zm.125-5.981v5.848c.124 0 .249 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M120.885 170.832h.499v-6.114h-.499v6.114z" fill="#0EA59D" />
            <path
            d="M120.885 170.832v-6.38h.624v6.247c-.25.133-.375.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M125.375 169.503c.125-.133.374-.266.499-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M125.375 169.636v-4.918h.624v4.519c-.125.133-.375.266-.624.399zm.125-4.786v4.653c.125-.133.249-.133.374-.266v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M120.012 170.832h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M120.012 170.965v-6.513h.623v6.38c-.249 0-.374.133-.623.133zm.124-6.38v6.247h.375v-6.114c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M126.373 168.971c.25-.133.374-.266.499-.399v-3.721h-.499v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M126.248 169.104v-4.386h.624v3.854c-.125.133-.25.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M123.629 170.3c.125 0 .374-.133.499-.133v-5.316h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M123.629 170.3v-5.715h.624v5.449c-.25.133-.375.266-.624.266zm.125-5.449v5.316c.124 0 .249-.133.374-.133v-5.183h-.374z"
            fill="#131A2D"
            />
            <path
            d="M122.756 170.433c.125 0 .374-.133.499-.133v-5.582h-.499v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M122.631 170.566v-5.848h.624v5.715c-.125 0-.375.133-.624.133zm.125-5.716v5.583c.124 0 .249 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M124.502 169.901c.125-.132.374-.132.499-.265v-4.918h-.499v5.183z"
            fill="#0EA59D"
            />
            <path
            d="M124.502 170.034v-5.316h.624v5.051c-.25.132-.375.132-.624.265zm.125-5.184v5.051c.124 0 .249-.132.374-.132v-4.786h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M114.646 170.167c.125 0 .375.133.499.133v-5.582h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M115.27 170.433c-.249-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.624-.399c.125 0 .25.133.375.133v-5.449h-.375v5.316z"
            fill="#131A2D"
            />
            <path d="M118.264 170.832h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M118.887 170.965h-.623v-6.513h.623v6.513zm-.623-.266h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M119.139 164.452v6.38h.623v-6.38h-.623z" fill="#0EA59D" />
            <path
            d="M119.388 170.965h-.249v-6.513h.873v6.513h-.624zm-.249-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M111.029 166.977c0 .399.25.798.624 1.33v-3.456h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M111.653 168.439l-.125-.133c-.374-.398-.499-.797-.624-1.196v-2.392h.749v3.721zm-.624-1.595c0 .399.125.798.499 1.197v-3.191h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M127.246 168.041c.25-.399.374-.798.499-1.064v-2.126h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M127.121 168.306v-3.588h.624v2.259c0 .399-.25.665-.499 1.064l-.125.265zm.125-3.456v3.058c.249-.266.249-.665.374-.931v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M112.775 169.237c.125.133.375.266.499.266v-4.785h-.499v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M113.399 169.636c-.249-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.125.133.25.133.374.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M117.393 170.699h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M117.891 170.832h-.623v-6.247h.623v6.247zm-.499-.133h.375v-6.114h-.375v6.114z"
            fill="#131A2D"
            />
            <path
            d="M113.773 169.768c.125.133.375.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M114.272 170.034c-.249-.132-.499-.132-.624-.265v-5.184h.624v5.449zm-.499-.265c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M115.52 170.433c.124 0 .374.133.499.133v-5.715h-.499v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M116.143 170.566c-.249 0-.374-.133-.623-.133v-5.715h.623v5.848zm-.499-.266c.125 0 .25.133.375.133v-5.583h-.375v5.45z"
            fill="#131A2D"
            />
            <path
            d="M116.393 170.566c.124 0 .374 0 .499.133v-6.114c-.125 0-.375 0-.499.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M117.016 170.699c-.249 0-.374-.133-.623-.133v-5.981c.124 0 .374 0 .499-.133h.124v6.247zm-.499-.133c.125 0 .25 0 .375.133v-5.848c-.125 0-.25 0-.375.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M119.388 160.464c-4.866 0-8.359 2.127-8.359 3.987 0 1.861 3.493 3.988 8.359 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.727-3.493-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M119.388 168.705c-4.99 0-8.359-2.127-8.359-4.121 0-1.993 3.493-4.12 8.359-4.12 4.865 0 8.358 2.127 8.358 4.12 0 1.994-3.493 4.121-8.358 4.121zm0-8.108c-4.866 0-8.234 2.127-8.234 3.987 0 1.861 3.368 3.988 8.234 3.988 4.865 0 8.233-2.127 8.233-3.988 0-1.86-3.368-3.987-8.233-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M113.898 167.642c.499.266 1.123.399 1.747.665l6.861-7.311c-.624-.133-1.372-.266-2.121-.266l-6.487 6.912zM118.639 168.572H119.886l5.988-6.38c-.249-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M116.644 168.307c-.125 0-.25 0-.499-.133-.25-.133-.624-.133-.874-.266-.249-.133-.623-.133-.873-.266-.125 0-.249-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.749-.398c-.499-.266-.998-.665-1.497-1.064.375.532.749 1.064 1.248 1.329.125.133.249.133.374.266s.25.133.374.266c.125 0 .125.133.25.133l.249.133c.125 0 .25.133.375.133l.499.133c.124 0 .249.133.499.133.249.133.623.133.873.133.249 0 .624 0 .873.133h.873c-.249-.133-.623-.133-.873-.266h-.249zM120.761 168.307l-1.248.133h-.624c-.249 0-.374 0-.623.133.249 0 .374.133.623.133H120.761c.374 0 .873-.133 1.247-.266l1.123-.399h-1.248a2.36 2.36 0 01-1.122.266z"
            fill="#fff"
            />
            <path
            d="M119.388 161.262c-1.123 0-2.121.133-2.994.266h-5.365v2.126c.125 1.861 3.493 3.988 8.359 3.988 4.865 0 8.233-1.994 8.358-3.988v-2.126h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M119.387 167.775c-4.865 0-8.233-1.994-8.358-3.988v-2.392h5.489c.749-.133 1.747-.133 2.869-.133.998 0 1.996.133 2.994.266h5.365v2.259c-.25 1.861-3.618 3.988-8.359 3.988zm-8.358-4.121c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-1.994h-5.239c-.998-.132-1.996-.265-2.994-.265-.998 0-1.996.133-2.994.265h-5.365v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M111.902 165.382c.125.133.375.266.499.399v-4.254h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M112.526 165.914c-.249-.266-.499-.399-.624-.532v-3.987h.624v4.519zm-.499-.532c.125.133.25.266.374.266v-4.121h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M121.883 161.528v5.981c.125 0 .374 0 .499-.133v-5.848h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M121.758 167.509v-6.114h.125c.124 0 .249 0 .374.133h.125v5.981h-.624zm.125-5.981v5.848c.124 0 .249 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M120.885 167.642h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M120.885 167.642v-6.38h.624v6.247c-.25.133-.375.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M125.375 166.312c.125-.132.374-.265.499-.265v-4.52h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M125.375 166.445v-4.918h.624v4.52c-.125.133-.375.265-.624.398zm.125-4.785v4.652c.125-.132.249-.132.374-.265v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M120.012 167.642h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M120.012 167.775v-6.513h.623v6.38c-.249 0-.374 0-.623.133zm.124-6.38v6.247h.375v-6.114c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M126.373 165.781c.25-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M126.248 165.914v-4.387h.624v3.855c-.125.133-.25.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M123.629 167.11c.125 0 .374-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M123.629 167.11v-5.715h.624v5.449c-.25.133-.375.266-.624.266zm.125-5.45v5.317c.124 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M122.756 167.243c.125 0 .374-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M122.631 167.376v-5.849h.624v5.716c-.125 0-.375.133-.624.133zm.125-5.716v5.583c.124 0 .249 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M124.502 166.711c.125-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M124.502 166.844v-5.317h.624v5.051c-.25 0-.375.133-.624.266zm.125-5.184v5.051c.124 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M114.646 166.977c.125 0 .375.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M115.27 167.243c-.249-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.624-.399c.125 0 .25.133.375.133v-5.45h-.375v5.317z"
            fill="#131A2D"
            />
            <path d="M118.264 167.642h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M118.887 167.775h-.623v-6.513h.623v6.513zm-.623-.266h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M119.139 161.262v6.38h.623v-6.38h-.623z" fill="#0EA59D" />
            <path
            d="M119.388 167.775c-.125 0-.125 0 0 0h-.249v-6.513h.873v6.513h-.624zm-.249-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M111.029 163.787c0 .399.25.931.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M111.653 165.249l-.125-.133c-.374-.399-.499-.797-.624-1.196v-2.393h.749v3.722zm-.624-1.595c0 .399.125.798.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M127.246 164.85c.25-.398.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M127.121 164.983v-3.588h.624v2.259c0 .399-.25.665-.499 1.064l-.125.265zm.125-3.323v3.058c.249-.266.249-.665.374-.931v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M112.775 166.047c.125.133.375.265.499.265v-4.785h-.499v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M113.399 166.446c-.249-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.125.133.25.133.374.266v-4.653h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M117.393 167.509h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M117.891 167.642h-.623v-6.247h.623v6.247zm-.499-.133h.375v-6.114h-.375v6.114z"
            fill="#131A2D"
            />
            <path
            d="M113.773 166.578c.125.133.375.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M114.272 166.844c-.249-.133-.499-.133-.624-.266v-5.183h.624v5.449zm-.499-.266c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M115.52 167.243c.124 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M116.143 167.376c-.249 0-.374-.133-.623-.133v-5.716h.623v5.849zm-.499-.266c.125 0 .25 0 .375.133v-5.583h-.375v5.45z"
            fill="#131A2D"
            />
            <path
            d="M116.393 167.376c.124 0 .374 0 .499.133v-6.114c-.125 0-.375 0-.499.132v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M117.016 167.509c-.249 0-.374-.133-.623-.133v-5.981c.124 0 .374 0 .499-.133h.124v6.247zm-.499-.133c.125 0 .25 0 .375.133v-5.849c-.125 0-.25 0-.375.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M119.388 157.274c-4.866 0-8.359 2.127-8.359 3.988 0 1.861 3.493 3.988 8.359 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M119.388 165.515c-4.99 0-8.359-2.126-8.359-4.12 0-1.994 3.493-4.121 8.359-4.121 4.865 0 8.358 2.127 8.358 4.121 0 1.994-3.493 4.12-8.358 4.12zm0-8.108c-4.866 0-8.234 2.127-8.234 3.988 0 1.861 3.368 3.988 8.234 3.988 4.865 0 8.233-2.127 8.233-3.988 0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M113.898 164.452c.499.266 1.123.399 1.747.665l6.861-7.311c-.624-.133-1.372-.266-2.121-.266l-6.487 6.912zM118.639 165.383H119.886l5.988-6.381c-.249-.133-.499-.398-.873-.531l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M116.644 165.116c-.125 0-.25 0-.499-.133-.25-.133-.624-.133-.874-.265-.249-.133-.623-.133-.873-.266-.125 0-.249-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.749-.399c-.499-.266-.998-.664-1.497-1.063.375.532.749 1.063 1.248 1.329.125.133.249.133.374.266s.25.133.374.266c.125 0 .125.133.25.133l.249.133c.125 0 .25.132.375.132l.499.133c.124 0 .249.133.499.133.249.133.623.133.873.133.249 0 .624 0 .873.133h.873c-.249-.133-.623-.133-.873-.266h-.249zM120.761 165.117l-1.248.133h-.624c-.249 0-.374 0-.623.133.249 0 .374.133.623.133H120.761c.374 0 .873-.133 1.247-.266l1.123-.398h-1.248a2.373 2.373 0 01-1.122.265z"
            fill="#fff"
            />
            <path
            d="M119.388 158.071c-1.123 0-2.121.133-2.994.266h-5.365v2.127c.125 1.861 3.493 3.987 8.359 3.987 4.865 0 8.233-1.993 8.358-3.987v-2.127h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M119.387 164.585c-4.865 0-8.233-1.994-8.358-3.988v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.374 2.127-3.742 4.121-8.483 4.121zm-8.358-3.988c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-1.994h-5.239c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.365v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M111.902 162.325c.125.133.375.266.499.399v-4.253h-.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M112.526 162.857c-.249-.266-.499-.399-.624-.531v-3.988h.624v4.519zm-.499-.664l.374.398v-4.12h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M121.883 158.338v5.981c.125 0 .374 0 .499-.133v-5.848h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M121.758 164.452v-6.114h.125c.124 0 .374 0 .499.133h.124v5.981a.751.751 0 00-.748 0zm.125-5.981v5.848c.124 0 .249 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M120.885 164.452h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M120.885 164.584v-6.38h.624v6.247c-.25 0-.375 0-.624.133zm.125-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M125.375 163.123c.125-.133.374-.266.499-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M125.375 163.256v-4.918h.624v4.519c-.125.133-.375.266-.624.399zm.125-4.785v4.652c.125-.133.249-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M120.012 164.451h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M120.012 164.584v-6.513h.623v6.38c-.249.133-.374.133-.623.133zm.124-6.38v6.247h.375v-6.114c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M126.373 162.591c.25-.133.374-.266.499-.399v-3.721h-.499v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M126.248 162.724v-4.386h.624v3.855c-.125.133-.25.265-.624.531zm.125-4.253v3.987l.374-.398v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M123.629 163.92c.125 0 .374-.132.499-.132v-5.317h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M123.629 164.053v-5.715h.624v5.45c-.25.133-.375.133-.624.265zm.125-5.582v5.317c.124 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M122.756 164.186c.125 0 .374-.133.499-.133v-5.582h-.499v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M122.631 164.186v-5.848h.624v5.715c-.125.133-.375.133-.624.133zm.125-5.715v5.582c.124 0 .249 0 .374-.132v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M124.502 163.655c.125-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M124.502 163.655v-5.317h.624v5.051c-.25.133-.375.266-.624.266zm.125-5.184v5.051c.124 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M114.646 163.788c.125 0 .375.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M115.27 164.053c-.249-.133-.499-.133-.624-.133v-5.449h.624v5.582zm-.624-.265c.125 0 .25.132.375.132v-5.449h-.375v5.317z"
            fill="#131A2D"
            />
            <path d="M118.264 164.451h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M118.887 164.584h-.623v-6.513h.623v6.513zm-.623-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M119.139 158.071v6.38h.623v-6.38h-.623z" fill="#0EA59D" />
            <path
            d="M119.388 164.584c-.125 0-.125 0 0 0h-.249v-6.513h.623v6.513h-.374zm-.249-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M111.029 160.597c0 .399.25.931.624 1.33v-3.456h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M111.653 162.06l-.125-.133c-.374-.399-.499-.798-.624-1.197v-2.392h.749v3.722zm-.624-1.595c0 .398.125.797.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M127.246 161.661c.25-.399.374-.798.499-1.064v-2.126h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M127.121 161.927v-3.589h.624v2.26c0 .398-.25.664-.499 1.063l-.125.266zm.125-3.456v3.057c.249-.266.249-.665.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M112.775 162.99c.125.133.375.266.499.266v-4.785h-.499v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M113.399 163.389c-.249-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.532c.125.133.25.133.374.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M117.393 164.451h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M117.891 164.584h-.623v-6.247h.623v6.247zm-.499-.266h.375v-6.114h-.375v6.114z"
            fill="#131A2D"
            />
            <path
            d="M113.773 163.389c.125.133.375.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M114.272 163.788c-.249-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M115.52 164.052c.124 0 .374.133.499.133v-5.715h-.499v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M116.143 164.318c-.249 0-.374-.133-.623-.133v-5.715h.623v5.848zm-.499-.266c.125 0 .25 0 .375.133v-5.582h-.375v5.449z"
            fill="#131A2D"
            />
            <path
            d="M116.393 164.318c.124 0 .374 0 .499.133v-6.114c-.125 0-.375 0-.499.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M117.016 164.451c-.249 0-.374-.133-.623-.133v-5.981c.124 0 .374 0 .499-.133h.124v6.247zm-.499-.265c.125 0 .25 0 .375.132v-5.848c-.125 0-.25 0-.375.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M119.388 154.217c-4.866 0-8.359 2.127-8.359 3.988 0 1.861 3.493 3.987 8.359 3.987 4.865 0 8.358-2.126 8.358-3.987 0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M119.388 162.325c-4.99 0-8.359-2.127-8.359-4.12 0-1.994 3.493-4.121 8.359-4.121 4.865 0 8.358 2.127 8.358 4.121 0 1.993-3.493 4.12-8.358 4.12zm0-8.108c-4.866 0-8.234 2.127-8.234 3.988 0 1.86 3.368 3.987 8.234 3.987 4.865 0 8.233-2.127 8.233-3.987 0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M113.898 161.262c.499.266 1.123.399 1.747.665l6.861-7.311c-.624-.132-1.372-.265-2.121-.265l-6.487 6.911zM118.639 162.326H119.886l5.988-6.38c-.249-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M116.644 161.926c-.125 0-.25 0-.499-.133-.25-.133-.624-.133-.874-.266-.249-.133-.623-.133-.873-.266-.125 0-.249-.133-.374-.133l-.25-.133c-.124 0-.124-.132-.249-.132l-.749-.399c-.499-.266-.998-.665-1.497-1.064.375.532.749 1.064 1.248 1.33.125.133.249.133.374.265.125.133.25.133.374.266.125 0 .125.133.25.133l.249.133c.125 0 .25.133.375.133l.499.133c.124 0 .249.133.499.133.249.133.623.133.873.133.249 0 .624 0 .873.133h.873c-.249-.133-.623-.133-.873-.266h-.249zM120.761 161.927l-1.248.133h-.624c-.249 0-.374 0-.623.133.249 0 .374.133.623.133H120.761c.374 0 .873-.133 1.247-.266l1.123-.399h-1.248c-.249.266-.623.266-1.122.266z"
            fill="#fff"
            />
            <path
            d="M128.37 157.008c-1.123 0-2.121.133-2.994.266h-5.364v2.126c.124 1.861 3.493 3.988 8.358 3.988s8.233-1.994 8.358-3.988v-2.126h-5.364c-.873-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M128.37 163.388c-4.865 0-8.234-1.994-8.358-3.987v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.25 2.126-3.618 4.12-8.483 4.12zm-8.234-3.987c.125 1.86 3.493 3.854 8.234 3.854 4.74 0 8.109-1.994 8.233-3.854v-2.127h-5.239c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v2.127h.124z"
            fill="#131A2D"
            />
            <path
            d="M121.01 161.128c.125.133.374.266.499.399v-4.254h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M121.634 161.66c-.25-.266-.499-.399-.624-.532v-3.988h.624v4.52zm-.624-.532c.125.133.249.266.374.266v-4.121h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M130.863 157.14v5.982c.125 0 .375 0 .499-.133v-5.716c-.124 0-.249 0-.499-.133z"
            fill="#0EA59D"
            />
            <path
            d="M130.863 163.255v-6.115h.125c.125 0 .25 0 .499.133h.125v5.982h-.749zm.125-5.982v5.849c.125 0 .25 0 .374-.133v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M129.992 163.255h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M129.867 163.388v-6.38h.624v6.247c-.125.133-.374.133-.624.133zm.125-6.248v6.115h.374v-5.982c0-.133-.125-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M134.482 162.058c.125-.133.375-.265.499-.265v-4.52h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M134.482 162.191v-4.918h.624v4.52c-.249.132-.374.132-.624.398zm.125-4.918v4.652c.125-.133.25-.132.374-.265v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M129.119 163.388h.499v-6.248h-.499v6.248z" fill="#0EA59D" />
            <path
            d="M128.994 163.388v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.125 0-.249 0-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M135.355 161.394c.25-.133.375-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M135.355 161.527v-4.387h.624v3.855c-.125.266-.374.399-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M132.736 162.723c.125 0 .375-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M132.611 162.856v-5.716h.624v5.45c-.125.133-.374.133-.624.266zm.125-5.583v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M131.738 162.989c.125 0 .375-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M131.738 163.122v-5.849h.624v5.716c-.249 0-.374 0-.624.133zm.125-5.849v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M133.609 162.457c.125-.133.375-.133.499-.265v-4.919h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M133.484 162.59v-5.317h.624v5.051c-.125 0-.374.133-.624.266zm.125-5.317v5.051c.125 0 .25-.133.374-.133v-4.918h-.374z"
            fill="#131A2D"
            />
            <path
            d="M123.629 162.59c.125 0 .374.133.499.133v-5.45h-.499v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M124.253 162.856c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.499-.266c.124 0 .249.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M127.246 163.388h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M127.87 163.388h-.624v-6.513h.624v6.513zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M128.246 157.008v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M128.371 163.388h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M120.012 159.4c0 .399.249.93.623 1.329v-3.456h-.623v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M120.635 160.862l-.125-.133c-.374-.399-.499-.797-.623-1.196v-2.393h.748v3.722zm-.499-1.462c0 .399.125.798.499 1.196v-3.323h-.499v2.127z"
            fill="#131A2D"
            />
            <path
            d="M136.354 160.596c.249-.399.374-.797.499-1.063v-2.26h-.499v3.323z"
            fill="#0EA59D"
            />
            <path
            d="M136.229 160.729v-3.589h.623v2.26c0 .399-.249.665-.499 1.063l-.124.266zm.124-3.456v3.057c.125-.265.25-.664.375-.93v-2.127h-.375z"
            fill="#131A2D"
            />
            <path
            d="M121.883 161.793c.125.132.374.265.499.265v-4.785h-.499v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M122.507 162.191c-.25-.133-.499-.265-.624-.398v-4.653h.624v5.051zm-.499-.398c.124.133.249.133.374.265v-4.785h-.374v4.52z"
            fill="#131A2D"
            />
            <path d="M126.373 163.255h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M126.997 163.388h-.624v-6.248h.624v6.248zm-.499-.133h.374v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M122.756 162.324c.125.133.374.133.499.266v-5.317h-.499v5.051z"
            fill="#0EA59D"
            />
            <path
            d="M123.38 162.59c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.124 0 .249.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M124.627 162.856c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M125.126 163.122c-.25 0-.375-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.124 0 .249.133.374.133v-5.716h-.374v5.583z"
            fill="#131A2D"
            />
            <path
            d="M125.5 163.122c.125 0 .374 0 .499.133v-6.115c-.125 0-.374 0-.499.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M126.124 163.255c-.25 0-.375-.133-.624-.133v-5.982c.125 0 .374 0 .499-.132h.125v6.247zm-.624-.133c.125 0 .249 0 .374.133v-5.982c-.125 0-.249 0-.374.133v5.716z"
            fill="#131A2D"
            />
            <path
            d="M128.37 153.021c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.368 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M128.37 161.262c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12s8.358 2.126 8.358 4.12c0 1.994-3.368 4.121-8.358 4.121zm0-8.109c-4.865 0-8.234 2.127-8.234 3.988 0 1.861 3.369 3.988 8.234 3.988s8.233-2.127 8.233-3.988c0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M123.006 160.065c.499.266 1.123.399 1.746.665l6.862-7.311c-.624-.133-1.373-.266-2.121-.266l-6.487 6.912zM127.746 161.128h1.248l5.988-6.38c-.25-.133-.499-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M125.749 160.729c-.124 0-.249 0-.499-.132-.249-.133-.623-.133-.873-.266-.249-.133-.624-.133-.873-.266-.125 0-.25-.133-.374-.133h-.125c-.125 0-.125-.133-.25-.133l-.748-.399c-.499-.266-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.125 0 .125.133.249.133l.25.133c.125 0 .249.133.374.133l.499.132c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266l-.375-.133zM129.866 160.863l-1.247.132h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.398h-1.247c-.25.133-.749.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M119.388 154.084c-1.123 0-2.121.133-2.994.266h-5.365v2.127c.125 1.86 3.493 3.987 8.359 3.987 4.865 0 8.233-1.994 8.358-3.987v-2.127h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M119.387 160.597c-4.865 0-8.233-1.994-8.358-3.987v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.374 2.126-3.742 4.12-8.483 4.12zm-8.358-4.12c.125 1.861 3.493 3.854 8.234 3.854 4.74 0 8.108-1.993 8.233-3.854v-1.994h-5.239c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.365v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M111.902 158.205c.125.133.375.266.499.399v-4.254h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M112.526 158.87c-.249-.266-.499-.399-.624-.532v-3.988h.624v4.52zm-.499-.665c.125.133.25.266.374.266v-4.121h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M121.883 154.351v5.981c.125 0 .374 0 .499-.133v-5.848h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M121.758 160.331v-6.114h.125c.124 0 .249 0 .499.133h.124v5.981h-.748zm.125-5.981v5.848c.124 0 .249 0 .374-.133v-5.715c-.125.133-.25 0-.374 0z"
            fill="#131A2D"
            />
            <path d="M120.885 160.465h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M120.885 160.464v-6.38h.624v6.247c-.25.133-.375.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.125 0-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M125.375 159.135c.125-.132.374-.265.499-.265v-4.52h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M125.375 159.268v-4.918h.624v4.52c-.125.133-.375.265-.624.398zm.125-4.785v4.652c.125-.132.249-.132.374-.265v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M120.012 160.464h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M120.012 160.597v-6.513h.623v6.38c-.249.133-.374.133-.623.133zm.124-6.38v6.247h.375v-6.114c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M126.373 158.604c.25-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M126.248 158.737v-4.387h.624v3.855c-.125.133-.25.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M123.629 159.933c.125 0 .374-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M123.629 159.932v-5.715h.624v5.449c-.25.133-.375.266-.624.266zm.125-5.45v5.317c.124 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M122.756 160.199c.125 0 .374-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M122.631 160.199v-5.849h.624v5.716c-.125 0-.375.133-.624.133zm.125-5.716v5.583c.124 0 .249 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M124.502 159.534c.125-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M124.502 159.667v-5.317h.624v5.051c-.25.133-.375.133-.624.266zm.125-5.184v5.051c.124 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M114.646 159.8c.125 0 .375.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M115.27 160.066c-.249-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.624-.399c.125 0 .25.133.375.133v-5.45h-.375v5.317z"
            fill="#131A2D"
            />
            <path d="M118.264 160.464h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M118.887 160.597h-.623v-6.513h.623v6.513zm-.623-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M119.139 154.084v6.38h.623v-6.38h-.623z" fill="#0EA59D" />
            <path
            d="M119.388 160.597c-.125 0-.125 0 0 0h-.249v-6.513h.748v6.513h-.499zm-.249-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M111.029 156.61c0 .399.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M111.653 158.072l-.125-.133c-.374-.399-.499-.797-.624-1.196v-2.393h.749v3.722zm-.624-1.595c0 .399.125.798.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M127.246 157.673c.25-.399.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M127.121 157.939v-3.589h.624v2.26c0 .399-.25.665-.499 1.063l-.125.266zm.125-3.456v3.057c.249-.265.249-.664.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M112.775 158.87c.125.133.375.265.499.265v-4.785h-.499v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M113.399 159.268c-.249-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.125.133.25.133.374.266v-4.653h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M117.393 160.331h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M117.891 160.464h-.623v-6.247h.623v6.247zm-.499-.133h.375v-6.114h-.375v6.114z"
            fill="#131A2D"
            />
            <path
            d="M113.773 159.401c.125.133.375.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M114.272 159.666c-.249-.133-.499-.133-.624-.266v-5.183h.624v5.449zm-.499-.266c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M115.52 160.066c.124 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M116.143 160.199c-.249 0-.374-.133-.623-.133v-5.716h.623v5.849zm-.499-.266c.125 0 .25 0 .375.133v-5.583h-.375v5.45z"
            fill="#131A2D"
            />
            <path
            d="M116.393 160.198c.124 0 .374 0 .499.133v-6.114c-.125 0-.375 0-.499.132v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M117.016 160.464c-.249 0-.374-.133-.623-.133v-5.982c.124 0 .374 0 .499-.132h.124v6.247zm-.499-.266c.125 0 .25 0 .375.133v-5.849c-.125 0-.25 0-.375.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M119.388 150.229c-4.866 0-8.359 2.127-8.359 3.988 0 1.861 3.493 3.987 8.359 3.987 4.865 0 8.358-2.126 8.358-3.987 0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M119.388 158.338c-4.99 0-8.359-2.127-8.359-4.121 0-1.994 3.493-4.12 8.359-4.12 4.865 0 8.358 2.126 8.358 4.12 0 1.994-3.493 4.121-8.358 4.121zm0-8.108c-4.866 0-8.234 2.126-8.234 3.987 0 1.861 3.368 3.988 8.234 3.988 4.865 0 8.233-2.127 8.233-3.988 0-1.861-3.368-3.987-8.233-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M113.898 157.274c.499.266 1.123.399 1.747.665l6.861-7.311c-.624-.133-1.372-.266-2.121-.266l-6.487 6.912zM118.639 158.205H119.886l5.988-6.38c-.249-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M116.644 157.939c-.125 0-.25 0-.499-.133-.25-.133-.624-.133-.874-.266-.249-.133-.623-.133-.873-.266-.125 0-.249-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.749-.399c-.499-.265-.998-.664-1.497-1.063.375.532.749 1.063 1.248 1.329.125.133.249.133.374.266s.25.133.374.266c.125 0 .125.133.25.133l.249.133c.125 0 .25.133.375.133l.499.133c.124 0 .249.133.499.133.249.133.623.133.873.133.249 0 .624-.001.873.132h.873c-.249-.133-.623-.132-.873-.265h-.249zM120.761 157.94l-1.248.133h-.624c-.249 0-.374 0-.623.133.249 0 .374.132.623.132H120.761c.374 0 .873-.132 1.247-.265l1.123-.399h-1.248a2.36 2.36 0 01-1.122.266z"
            fill="#fff"
            />
            <path
            d="M111.153 152.223c-1.123 0-2.121.133-2.994.266h-5.364v2.126c.125 1.861 3.493 3.988 8.358 3.988s8.234-1.994 8.358-3.988v-2.126h-5.364c-.873-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M111.153 158.736c-4.865 0-8.233-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.249 2.127-3.618 4.121-8.483 4.121zm-8.233-3.988c.124 1.861 3.493 3.855 8.233 3.855 4.741 0 8.109-1.994 8.234-3.855v-1.994h-5.24c-.998-.132-1.996-.265-2.994-.265-.998 0-1.996.133-2.994.265h-5.364v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M103.793 156.344c.125.133.374.266.499.399v-4.254h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M104.417 157.009c-.25-.266-.499-.399-.624-.532v-3.988h.624v4.52zm-.624-.665l.374.399v-4.121h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M113.648 152.489v5.982c.125 0 .375 0 .499-.133v-5.849h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M113.648 158.604v-6.115h.125c.125 0 .25 0 .499.133h.125v5.982c-.374-.133-.499-.133-.749 0zm.125-6.115v5.849c.125 0 .25 0 .374-.133v-5.716c-.124.133-.249.133-.374 0z"
            fill="#131A2D"
            />
            <path d="M112.775 158.604h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M112.65 158.603v-6.38h.624v6.38h-.624zm.125-6.247v6.114h.374v-5.981s-.124 0-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M117.266 157.274c.124-.133.374-.265.499-.265v-4.52h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M117.266 157.407v-4.918h.623v4.52c-.249.132-.374.265-.623.398zm.124-4.785v4.652c.125-.133.25-.133.375-.265v-4.387h-.375z"
            fill="#131A2D"
            />
            <path d="M111.902 158.603h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M111.777 158.736v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M118.139 156.743c.249-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M118.139 156.876v-4.387h.623v3.855c-.124.133-.374.266-.623.532zm.124-4.254v3.988l.375-.399v-3.589h-.375z"
            fill="#131A2D"
            />
            <path
            d="M115.52 158.072c.124 0 .374-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M115.395 158.205v-5.716h.623v5.45c-.124 0-.374.133-.623.266zm.124-5.583v5.317c.125 0 .25-.133.375-.133v-5.184h-.375z"
            fill="#131A2D"
            />
            <path
            d="M114.521 158.338c.125 0 .375-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M114.521 158.338v-5.849h.624v5.716c-.249.133-.374.133-.624.133zm.125-5.716v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M116.393 157.673c.124-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M116.268 157.806v-5.317h.748v5.051c-.249.133-.374.133-.748.266zm.124-5.184v5.051c.125 0 .25-.133.375-.133v-4.785h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M106.412 157.939c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M107.036 158.205c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.499-.266c.125 0 .249.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M110.029 158.603h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M110.653 158.736h-.624v-6.513h.624v6.513zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M110.904 152.223v6.38h.624v-6.38h-.374-.25z" fill="#0EA59D" />
            <path
            d="M111.154 158.736h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M102.795 154.749c0 .399.249.93.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M103.418 156.211l-.124-.133c-.375-.399-.499-.797-.624-1.196v-2.393h.748v3.722zm-.499-1.595c0 .399.125.798.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M119.012 155.812c.249-.399.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M119.012 156.078v-3.589h.623v2.26c0 .399-.249.665-.499 1.063l-.124.266zm.124-3.456v3.057c.125-.265.25-.664.375-.93v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M104.666 157.141c.125.133.374.266.499.266v-4.785h-.499v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M105.29 157.54c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.624-.531c.125.132.25.132.374.265v-4.652h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M109.158 158.603h.499v-6.248h-.499v6.248z" fill="#0EA59D" />
            <path
            d="M109.782 158.603h-.624v-6.248h.624v6.248zm-.499-.133h.374v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M105.539 157.54c.125.133.374.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M106.163 157.939c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.125 0 .249.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M107.41 158.204c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M107.909 158.47c-.25 0-.374-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.125 0 .249 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M108.283 158.337c.125 0 .374 0 .499.133v-6.115c-.125 0-.374 0-.499.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M108.907 158.603c-.25 0-.374-.133-.624-.133v-5.982c.125 0 .374 0 .499-.133h.125v6.248zm-.624-.266c.125 0 .25 0 .374.133v-5.849c-.124 0-.249 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M111.153 148.368c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M111.153 156.476c-4.99 0-8.358-2.126-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121s8.358 2.127 8.358 4.121c0 1.994-3.368 4.12-8.358 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.861-3.369-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M105.664 155.414c.499.266 1.123.399 1.747.664l6.861-7.31c-.624-.133-1.372-.266-2.121-.266l-6.487 6.912zM110.529 156.344h1.248l5.988-6.381c-.25-.133-.499-.398-.873-.531l-6.363 6.912z"
            fill="#fff"
            />
            <path
            d="M108.532 156.077c-.124 0-.249 0-.499-.133-.249-.133-.623-.133-.873-.266-.249-.132-.624-.132-.873-.265-.125 0-.25-.133-.374-.133l-.125-.133c-.125 0-.125-.133-.25-.133l-.748-.399c-.499-.266-.998-.664-1.497-1.063.374.531.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.125 0 .125.133.249.133l.25.132c.125 0 .249.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.375zM112.649 156.078l-1.247.133h-.624c-.249 0-.374 0-.624.133.25 0 .375.133.624.133h1.871c.375 0 .874-.133 1.248-.266l1.123-.399h-1.248c-.374.266-.748.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M108.409 148.103c-1.123 0-2.121.132-2.994.265h-5.364v2.127c.125 1.861 3.493 3.988 8.358 3.988s8.234-1.994 8.358-3.988v-2.127h-5.364c-.873-.265-1.871-.265-2.994-.265z"
            fill="#0EA59D"
            />
            <path
            d="M108.409 154.482c-4.865 0-8.233-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.525c-.249 1.861-3.618 3.855-8.483 3.855zm-8.233-3.988c.124 1.861 3.493 3.855 8.233 3.855 4.741 0 8.109-1.994 8.234-3.855v-1.993h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.993h.125z"
            fill="#131A2D"
            />
            <path
            d="M101.049 152.224c.125.133.374.266.499.399v-4.254h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M101.673 152.756c-.25-.266-.499-.399-.624-.532v-3.988h.624v4.52zm-.624-.532c.125.133.249.266.374.266v-4.121h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M110.904 148.236v5.982c.125 0 .375 0 .499-.133v-5.849c-.124.133-.249 0-.499 0z"
            fill="#0EA59D"
            />
            <path
            d="M110.904 154.351v-6.115h.125c.125 0 .25 0 .374.133h.125v5.982c-.249-.133-.374 0-.624 0zm.125-5.982v5.849c.125 0 .25 0 .374-.133v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M110.031 154.351h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M110.031 154.484v-6.38h.624v6.247c-.25 0-.374.133-.624.133zm.125-6.248v6.115h.374v-5.982c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M114.521 153.155c.125-.133.375-.266.499-.266v-4.52h-.499v4.786z"
            fill="#0EA59D"
            />
            <path
            d="M114.521 153.154v-4.918h.624v4.52c-.249.265-.374.265-.624.398zm.125-4.785v4.652c.125-.132.25-.132.374-.265v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M109.158 154.484h.499v-6.248h-.499v6.248z" fill="#0EA59D" />
            <path
            d="M109.033 154.483v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.125-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M115.395 152.49c.249-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M115.395 152.623v-4.387h.623v3.855c-.124.133-.374.399-.623.532zm.124-4.254v3.988l.375-.399v-3.589h-.375z"
            fill="#131A2D"
            />
            <path
            d="M112.775 153.819c.125 0 .375-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M112.65 153.952v-5.716h.624v5.45c-.125.133-.374.133-.624.266zm.125-5.583v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M111.777 154.084c.125 0 .375-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M111.777 154.217v-5.849h.624v5.716c-.249 0-.374 0-.624.133zm.125-5.849v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M113.648 153.552c.125-.133.375-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M113.523 153.685v-5.317h.624v4.918c-.125.133-.249.266-.624.399zm.125-5.317v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M103.793 153.686c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M104.292 153.952c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.499-.266c.124 0 .249.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M107.285 154.483h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M107.909 154.483h-.624v-6.513h.624v6.513zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M108.285 148.103v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M108.41 154.483h-.25v-6.513h.624v6.513h-.125-.249zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M100.051 150.496c0 .399.249.797.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M100.674 151.958l-.124-.133c-.375-.399-.499-.797-.624-1.196v-2.393h.748v3.722zm-.499-1.462c0 .399.125.798.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M116.393 151.693c.249-.399.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M116.268 151.825v-3.589h.623v2.393c0 .399-.249.665-.499 1.063l-.124.133zm.124-3.456v3.057c.25-.265.25-.664.375-.93v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M101.922 152.889c.125.133.374.266.499.266v-4.786h-.499v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M102.546 153.287c-.25-.133-.499-.266-.624-.398v-4.653h.624v5.051zm-.499-.398c.124.132.249.132.374.265v-4.652h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M106.412 154.351h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M107.036 154.484h-.624v-6.248h.624v6.248zm-.499-.266h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M102.795 153.421c.125.133.374.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M103.419 153.686c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.124 0 .249.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M104.668 153.951c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M105.167 154.217c-.25 0-.375-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.124 0 .249 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M105.539 154.218c.125 0 .374 0 .499.133v-6.115c-.125 0-.374 0-.499.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M106.163 154.351c-.25 0-.374-.133-.624-.133v-5.982c.125 0 .374 0 .499-.132h.125v6.247zm-.624-.266c.125 0 .25 0 .374.133v-5.849c-.124 0-.249 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M108.409 144.115c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M108.409 152.223c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.121 8.358-4.121s8.358 2.127 8.358 4.121c0 1.994-3.368 4.121-8.358 4.121zm0-7.976c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.861-3.369-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M103.045 151.159c.499.266 1.123.399 1.746.665l6.862-7.311c-.624-.133-1.373-.266-2.121-.266l-6.487 6.912zM107.785 152.222h1.248l5.988-6.38c-.25-.133-.499-.399-.874-.531l-6.362 6.911z"
            fill="#fff"
            />
            <path
            d="M105.79 151.824c-.125 0-.249 0-.499-.133-.249-.133-.624-.133-.873-.265-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.249-.133c-.125 0-.125-.133-.25-.133l-.748-.399c-.499-.266-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.125 0 .125.133.249.133l.25.133c.125 0 .249.132.374.132l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM109.905 151.824l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.398h-1.247c-.25.265-.749.265-1.123.265z"
            fill="#fff"
            />
            <path
            d="M104.792 144.381c-1.123 0-2.121.133-2.994.266h-5.364v2.127c.124 1.861 3.493 3.987 8.358 3.987s8.233-1.994 8.358-3.987v-2.127h-5.364c-.873-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M104.792 150.894c-4.865 0-8.234-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.25 2.126-3.618 4.12-8.483 4.12zm-8.234-3.988c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.109-1.994 8.233-3.855v-1.993h-5.239c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.993h.124z"
            fill="#131A2D"
            />
            <path
            d="M97.432 148.635c.124.133.374.266.499.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M98.055 149.167c-.25-.266-.499-.399-.623-.532v-3.988h.623v4.52zm-.499-.665l.375.399v-4.121h-.375v3.722z"
            fill="#131A2D"
            />
            <path
            d="M107.287 144.647v5.982c.125 0 .374 0 .499-.133v-5.849h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M107.287 150.762v-6.115h.125c.125 0 .249 0 .374.133h.125v5.849c-.25 0-.374 0-.624.133zm.125-6.115v5.849c.125 0 .249 0 .374-.133v-5.716c-.125.133-.249.133-.374 0z"
            fill="#131A2D"
            />
            <path d="M106.414 150.762h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M106.414 150.761v-6.38h.624v6.247c-.25.133-.374.133-.624.133zm.125-6.114v5.981h.374v-5.981h-.374z"
            fill="#131A2D"
            />
            <path
            d="M110.904 149.433c.25-.133.375-.266.499-.266v-4.52h-.499v4.786z"
            fill="#0EA59D"
            />
            <path
            d="M110.904 149.566v-4.919h.624v4.52c-.249.133-.374.266-.624.399zm.125-4.786v4.653c.125-.133.25-.133.374-.266v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M105.541 150.761h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M105.416 150.894v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.25-6.38v6.247h.374v-6.114c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M111.902 148.901c.25-.133.375-.266.499-.399v-3.721h-.499v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M111.777 149.034v-4.387h.624v3.855c-.125.133-.374.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M109.158 150.23c.125 0 .374-.133.499-.133v-5.316h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M109.033 150.363v-5.716h.624v5.45c-.125.133-.374.133-.624.266zm.125-5.583v5.317c.125 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M108.285 150.496c.125 0 .374-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M108.16 150.496v-5.849h.624v5.716c-.125.133-.374.133-.624.133zm.125-5.716v5.583c.125 0 .249 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M110.031 149.964c.125-.132.375-.132.499-.265v-4.918h-.499v5.183z"
            fill="#0EA59D"
            />
            <path
            d="M110.031 149.964v-5.317h.624v5.051c-.25.133-.374.133-.624.266zm.125-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M100.176 150.097c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M100.675 150.363c-.25-.133-.499-.133-.624-.133v-5.449h.624v5.582zm-.499-.266c.124 0 .249.133.374.133v-5.449h-.374v5.316z"
            fill="#131A2D"
            />
            <path d="M103.793 150.761h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M104.292 150.894h-.624v-6.513h.624v6.513zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M104.668 144.381v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M104.792 150.894h-.249v-6.513h.748v6.513h-.499zm-.124-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M96.434 146.907c0 .399.25.93.623 1.329v-3.456h-.623v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M97.182 148.369l-.125-.133c-.374-.399-.499-.797-.623-1.196v-2.393h.748v3.722zm-.624-1.595c0 .399.125.797.5 1.196v-3.19h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M112.775 147.97c.25-.398.375-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M112.65 148.236v-3.589h.624v2.26c0 .399-.249.665-.499 1.063l-.125.266zm.125-3.456v3.058c.25-.266.25-.665.374-.931v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M98.305 149.3c.124.133.374.265.499.265v-4.785h-.5v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M98.928 149.698c-.25-.133-.499-.266-.623-.399v-4.652h.623v5.051zm-.499-.531c.125.132.25.132.375.265v-4.652h-.375v4.387z"
            fill="#131A2D"
            />
            <path d="M102.797 150.761h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M103.421 150.894h-.624v-6.247h.624v6.247zm-.499-.266h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M99.178 149.699c.124.133.374.133.499.265v-5.183h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M99.802 150.097c-.25-.133-.5-.133-.624-.266v-5.184h.624v5.45zm-.5-.399c.125 0 .25.133.375.133v-5.051h-.375v4.918z"
            fill="#131A2D"
            />
            <path
            d="M101.049 150.362c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M101.673 150.628c-.25 0-.375-.133-.624-.133v-5.716h.624v5.849zm-.624-.266c.125 0 .249.133.374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M101.922 150.629c.125 0 .374 0 .499.133v-6.115c-.125 0-.374 0-.499.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M102.546 150.761c-.25 0-.375-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.499-.266c.124 0 .249 0 .374.133v-5.848c-.125 0-.25 0-.374.132v5.583z"
            fill="#131A2D"
            />
            <path
            d="M104.792 140.526c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M104.792 148.635c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12 4.99 0 8.358 2.126 8.358 4.12 0 1.994-3.368 4.121-8.358 4.121zm0-8.109c-4.865 0-8.234 2.127-8.234 3.988 0 1.861 3.369 3.988 8.234 3.988s8.233-2.127 8.233-3.988c.125-1.861-3.243-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M99.428 147.571c.499.266 1.122.399 1.746.665l6.861-7.311c-.623-.133-1.372-.266-2.12-.266l-6.487 6.912zM104.168 148.635H105.415l5.988-6.381c-.249-.133-.499-.398-.873-.531l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M102.171 148.235c-.125 0-.249 0-.374-.132-.25-.133-.624-.133-.873-.266-.25-.133-.624-.133-.874-.266-.124 0-.25-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.399c-.5-.266-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.374.266.125.133.25.133.375.266.124 0 .124.133.25.133l.249.133c.124 0 .25.133.374.133l.499.133c.125 0 .249.132.499.132.249.133.624.133.873.133.25 0 .624 0 .873.133h.874c-.25-.133-.624-.133-.874-.266h-.374zM106.288 148.236l-1.248.132h-.623c-.25 0-.375 0-.624.133.249 0 .374.133.624.133h1.871c.374 0 .873-.133 1.247-.266l1.123-.398h-1.247c-.25.266-.624.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M108.409 140.792c-1.123 0-2.121.133-2.994.266h-5.364v2.127c.125 1.86 3.493 3.987 8.358 3.987s8.234-1.994 8.358-3.987v-2.127h-5.364c-.873-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M108.409 147.305c-4.865 0-8.233-1.994-8.358-3.987v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.249 2.126-3.618 4.12-8.483 4.12zm-8.233-4.12c.124 1.861 3.493 3.854 8.233 3.854 4.741 0 8.109-1.993 8.234-3.854v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M101.049 144.913c.125.133.374.266.499.399v-4.253h-.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M101.673 145.444c-.25-.266-.499-.399-.624-.532v-3.987h.624v4.519zm-.624-.532l.374.399v-4.12h-.374v3.721z"
            fill="#131A2D"
            />
            <path
            d="M110.904 141.059v5.981c.125 0 .375 0 .499-.133v-5.848h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M110.904 147.039v-6.114h.125c.125 0 .25 0 .374.133h.125v5.981h-.624zm.125-5.981v5.848c.125 0 .25 0 .374-.133v-5.715c-.124.133-.249 0-.374 0z"
            fill="#131A2D"
            />
            <path d="M110.031 147.173h.499v-6.114h-.499v6.114z" fill="#0EA59D" />
            <path
            d="M110.031 147.172v-6.38h.624v6.247c-.25.133-.374.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.124 0-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M114.521 145.844c.125-.133.375-.266.499-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M114.521 145.977v-4.918h.624v4.519c-.249.133-.374.266-.624.399zm.125-4.785v4.652c.125-.133.25-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M109.158 147.172h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M109.033 147.305v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.125-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M115.395 145.312c.249-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M115.395 145.445v-4.386h.623v3.854c-.124.133-.374.266-.623.532zm.124-4.253v3.987l.375-.399v-3.588h-.375z"
            fill="#131A2D"
            />
            <path
            d="M112.775 146.64c.125 0 .375-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M112.65 146.64v-5.715h.624v5.45a.927.927 0 01-.624.265zm.125-5.449v5.316c.125 0 .25-.132.374-.132v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M111.777 146.774c.125 0 .375-.133.499-.133v-5.582h-.499v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M111.777 146.907v-5.848h.624v5.715c-.249 0-.374.133-.624.133zm.125-5.715v5.582c.125 0 .25 0 .374-.133v-5.449h-.374z"
            fill="#131A2D"
            />
            <path
            d="M113.648 146.242c.125-.132.375-.132.499-.265v-4.918h-.499v5.183z"
            fill="#0EA59D"
            />
            <path
            d="M113.523 146.375v-5.316h.624v5.051c-.125.132-.249.133-.624.265zm.125-5.183v5.05c.125 0 .25-.132.374-.132v-4.786h-.374v-.132z"
            fill="#131A2D"
            />
            <path
            d="M103.793 146.508c.125 0 .374.133.499.133v-5.582h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M104.292 146.774c-.25-.133-.499-.133-.624-.133v-5.449h.624v5.582zm-.499-.399c.124 0 .249.133.374.133v-5.449h-.374v5.316z"
            fill="#131A2D"
            />
            <path d="M107.285 147.172h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M107.909 147.305h-.624v-6.513h.624v6.513zm-.499-.266h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M108.285 140.792v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M108.41 147.305h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M100.051 143.318c0 .399.249.931.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M100.674 144.78l-.124-.133c-.375-.398-.499-.797-.624-1.196v-2.392h.748v3.721zm-.499-1.595c0 .399.125.798.499 1.197v-3.19h-.499v1.993z"
            fill="#131A2D"
            />
            <path
            d="M116.393 144.382c.249-.399.374-.798.499-1.064v-2.127h-.499v3.191z"
            fill="#0EA59D"
            />
            <path
            d="M116.268 144.647v-3.588h.623v2.259c0 .399-.249.665-.499 1.064l-.124.265zm.124-3.455v3.057c.25-.266.25-.665.375-.931v-1.994h-.375v-.132z"
            fill="#131A2D"
            />
            <path
            d="M101.922 145.578c.125.133.374.266.499.266v-4.785h-.499v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M102.546 145.976c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.124.133.249.133.374.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M106.412 147.039h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M107.036 147.172h-.624v-6.247h.624v6.247zm-.499-.133h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M102.795 146.108c.125.133.374.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M103.419 146.375c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.266c.124 0 .249.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M104.668 146.774c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M105.167 146.907c-.25 0-.375-.133-.624-.133v-5.715h.624v5.848zm-.499-.266c.124 0 .249 0 .374.133v-5.582h-.374v5.449z"
            fill="#131A2D"
            />
            <path
            d="M105.539 146.906c.125 0 .374 0 .499.133v-6.114c-.125 0-.374 0-.499.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M106.163 147.172c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.624-.266c.125 0 .25 0 .374.133v-5.848c-.124 0-.249 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M108.409 136.938c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M108.409 145.046c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12s8.358 2.126 8.358 4.12c0 1.994-3.368 4.121-8.358 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c.124-1.861-3.369-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M103.045 143.983c.499.266 1.123.399 1.746.665l6.862-7.311c-.624-.133-1.373-.266-2.121-.266l-6.487 6.912zM107.785 144.913h1.248l5.988-6.38c-.25-.133-.499-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M105.79 144.647c-.125 0-.249 0-.499-.133-.249-.133-.624-.133-.873-.266-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.249-.133c-.125 0-.125-.133-.25-.133l-.748-.399c-.499-.265-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.125 0 .125.133.249.133l.25.133c.125 0 .249.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.132h.873c-.25-.132-.624-.132-.873-.265h-.25zM109.905 144.648l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.132.624.132h1.871c.374 0 .873-.132 1.248-.265l1.122-.399h-1.247c-.25.133-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M103.046 137.602c-1.123 0-2.121.133-2.994.266h-5.365v2.126c.125 1.861 3.493 3.988 8.359 3.988 4.865 0 8.233-1.994 8.358-3.988v-2.126h-5.364c-.874-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M103.046 144.115c-4.866 0-8.234-1.994-8.359-3.988v-2.392h5.49c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.25 2.127-3.618 4.121-8.483 4.121zm-8.234-4.121c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.109-1.994 8.233-3.855V138h-5.239c-.998-.132-1.996-.265-2.994-.265-.998 0-1.996.133-2.994.265h-5.365v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M95.686 141.722c.124.133.374.266.498.399v-4.254h-.498v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M96.31 142.386c-.25-.265-.5-.398-.624-.531v-3.988h.623v4.519zm-.5-.664l.374.399V138h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M105.541 137.867v5.982c.125 0 .374 0 .499-.133v-5.849h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M105.541 143.982v-6.115h.125c.125 0 .249 0 .374.133h.125v5.982c-.25-.133-.374-.133-.624 0zm.125-6.115v5.849c.125 0 .249 0 .374-.133v-5.716c-.125.133-.249 0-.374 0z"
            fill="#131A2D"
            />
            <path d="M104.668 143.982h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M104.668 143.982v-6.38h.624v6.38h-.624zm.125-6.248v6.115h.374v-5.982c-.125 0-.25 0-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M109.158 142.652c.25-.133.374-.266.499-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M109.158 142.785v-4.918h.624v4.519c-.125.133-.374.266-.624.399zm.125-4.785v4.652c.125-.133.249-.133.374-.266V138h-.374z"
            fill="#131A2D"
            />
            <path d="M103.795 143.982h.499v-6.248h-.499v6.248z" fill="#0EA59D" />
            <path
            d="M103.795 144.115v-6.513h.624v6.38c-.25.133-.499.133-.624.133zm.125-6.381v6.248h.374v-6.115c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M110.156 142.121c.25-.133.375-.266.499-.399V138h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M110.031 142.254v-4.387h.624v3.855c-.125.133-.374.266-.624.532zm.125-4.254v3.988l.374-.399V138h-.374z"
            fill="#131A2D"
            />
            <path
            d="M107.412 143.45c.125 0 .374-.133.499-.133V138h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M107.287 143.45v-5.716h.624v5.45a.923.923 0 01-.624.266zm.125-5.45v5.317c.125 0 .249-.133.374-.133V138h-.374z"
            fill="#131A2D"
            />
            <path
            d="M106.539 143.716c.125 0 .374-.133.499-.133V138h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M106.414 143.716v-5.849h.624v5.716c-.125 0-.374.133-.624.133zm.125-5.716v5.583c.125 0 .249 0 .374-.133V138h-.374z"
            fill="#131A2D"
            />
            <path
            d="M108.285 143.051c.125-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M108.285 143.184v-5.317h.624v5.051c-.25.133-.374.133-.624.266zm.125-5.184v5.051c.125 0 .249-.133.374-.133v-4.785h-.374V138z"
            fill="#131A2D"
            />
            <path
            d="M98.43 143.317c.124 0 .374.133.499.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M98.928 143.583c-.25-.133-.499-.133-.623-.133V138h.623v5.583zm-.499-.399c.125 0 .25.133.375.133v-5.45h-.375v5.317z"
            fill="#131A2D"
            />
            <path d="M102.047 143.982h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M102.546 144.115h-.624v-6.513h.624v6.513zm-.499-.133h.374v-6.248h-.374v6.248z"
            fill="#131A2D"
            />
            <path d="M102.922 137.602v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M103.046 144.115h-.249v-6.513h.748v6.513h-.499zm-.124-.133h.374v-6.248h-.374v6.248z"
            fill="#131A2D"
            />
            <path
            d="M94.688 140.127c0 .398.249.797.623 1.329V138h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M95.436 141.589l-.125-.133c-.374-.399-.499-.797-.624-1.196v-2.393h.749v3.722zm-.624-1.595c0 .399.125.797.5 1.196V138h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M111.029 141.19c.25-.399.375-.797.499-1.063V138h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M110.904 141.456v-3.589h.624v2.26c0 .399-.249.664-.499 1.063l-.125.266zm.125-3.456v3.057c.25-.266.25-.664.374-.93v-1.994h-.374V138z"
            fill="#131A2D"
            />
            <path
            d="M96.559 142.386c.124.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M97.182 142.918c-.25-.133-.499-.266-.623-.399v-4.652h.623v5.051zm-.499-.532c.125.133.25.133.375.266V138h-.375v4.386z"
            fill="#131A2D"
            />
            <path d="M101.049 143.849h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M101.673 143.982h-.624v-6.248h.624v6.248zm-.499-.133h.374v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M97.557 142.918c.124.133.374.133.499.266V138h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M98.055 143.317c-.25-.133-.499-.133-.623-.266v-5.184h.623v5.45zm-.499-.399c.125 0 .25.133.375.133V138h-.375v4.918z"
            fill="#131A2D"
            />
            <path
            d="M99.303 143.583c.124 0 .374.133.499.133V138h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M99.927 143.716c-.25 0-.375-.133-.624-.133v-5.716h.624v5.849zm-.624-.266c.124 0 .25 0 .374.133V138h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M100.176 143.716c.125 0 .374 0 .499.133v-6.115c-.125 0-.374 0-.499.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M100.8 143.982c-.25 0-.375-.133-.624-.133v-5.982c.125 0 .374 0 .499-.133h.125v6.248zm-.499-.266c.124 0 .249 0 .374.133V138c-.125 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M103.046 133.747c-4.866 0-8.359 2.127-8.359 3.988 0 1.861 3.493 3.987 8.359 3.987 4.865 0 8.358-2.126 8.358-3.987 0-1.861-3.368-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M103.046 141.855c-4.99 0-8.359-2.126-8.359-4.12 0-1.994 3.493-4.121 8.359-4.121 4.865 0 8.358 2.127 8.358 4.121 0 1.994-3.368 4.12-8.358 4.12zm0-8.108c-4.866 0-8.234 2.127-8.234 3.988 0 1.861 3.368 3.987 8.234 3.987 4.865 0 8.233-2.126 8.233-3.987 0-1.861-3.243-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M97.682 140.793c.499.266 1.122.398 1.746.664l6.861-7.31c-.623-.133-1.372-.266-2.12-.266l-6.487 6.912zM102.422 141.722H103.669l5.988-6.38c-.249-.133-.499-.399-.873-.531l-6.362 6.911z"
            fill="#fff"
            />
            <path
            d="M100.425 141.456c-.125 0-.25 0-.5-.133-.249-.133-.623-.133-.873-.266-.249-.133-.623-.133-.873-.265-.124 0-.25-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.399c-.5-.266-.999-.665-1.498-1.063.375.531.749 1.063 1.248 1.329.125.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.132.25.132l.25.133c.124 0 .249.133.374.133l.499.133c.124 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .873.133h.874c-.25-.133-.624-.133-.874-.266h-.249zM104.542 141.456l-1.248.133h-.623c-.25 0-.375 0-.624.133.249 0 .374.133.624.133h1.871c.374 0 .873-.133 1.247-.266l1.123-.399h-1.247c-.25.133-.624.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M109.157 168.706c-1.123 0-2.121.133-2.994.266h-5.364v2.127c.125 1.861 3.493 3.987 8.358 3.987s8.234-1.994 8.358-3.987v-2.127h-5.364c-.998-.266-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M109.157 175.085c-4.865 0-8.234-1.993-8.358-3.987v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.374 2.127-3.743 4.12-8.483 4.12zm-8.358-3.987c.124 1.861 3.493 3.855 8.233 3.855 4.741 0 8.109-1.994 8.234-3.855v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M101.672 172.825c.125.133.374.266.499.399v-4.253h-.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M102.296 173.357c-.25-.266-.499-.399-.624-.531v-3.988h.624v4.519zm-.499-.664l.374.398v-4.12h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M111.652 168.838v5.981c.125 0 .375 0 .499-.133v-5.848h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M111.527 174.952v-6.114h.125c.125 0 .25 0 .499.133h.125v5.981c-.25-.133-.499 0-.749 0zm.125-5.981v5.848c.125 0 .25 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M110.654 174.952h.499v-6.114h-.499v6.114z" fill="#0EA59D" />
            <path
            d="M110.654 175.085v-6.38h.624v6.247c-.249 0-.374 0-.624.133zm.125-6.247v6.114h.374v-5.981c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M115.27 173.756c.124-.133.374-.266.499-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M115.145 173.756v-4.918h.623v4.519c-.124.133-.374.266-.623.399zm.124-4.785v4.652c.125-.133.25-.133.375-.266v-4.386h-.375z"
            fill="#131A2D"
            />
            <path d="M109.781 175.086h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M109.781 175.085v-6.513h.624v6.38c-.25.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M116.143 173.091c.249-.133.374-.266.499-.399v-3.721h-.499v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M116.018 173.224v-4.386h.623v3.855c-.124.133-.249.398-.623.531zm.124-4.253v3.987l.375-.398v-3.589h-.375z"
            fill="#131A2D"
            />
            <path
            d="M113.398 174.42c.125 0 .375-.132.499-.132v-5.317h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M113.398 174.553v-5.715h.624v5.45c-.249.133-.374.133-.624.265zm.125-5.582v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M112.525 174.686c.125 0 .375-.133.499-.133v-5.582h-.499v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M112.4 174.819v-5.848h.624v5.715c-.125 0-.374 0-.624.133zm.125-5.848v5.582c.125 0 .25 0 .374-.133v-5.449h-.374z"
            fill="#131A2D"
            />
            <path
            d="M114.271 174.155c.125-.133.375-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M114.271 174.155v-5.317h.624v5.051c-.249.133-.374.266-.624.266zm.125-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M104.416 174.288c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M105.04 174.553c-.25-.133-.499-.133-.624-.133v-5.449h.624v5.582zm-.624-.265c.125 0 .25.132.374.132v-5.449h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M108.033 174.952h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M108.657 175.085h-.624v-6.513h.624v6.513zm-.624-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M108.908 168.705v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M109.158 175.085h-.25v-6.513h.873v6.513h-.623zm-.25-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M100.799 171.097c0 .399.249.931.624 1.33v-3.456h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M101.422 172.56l-.124-.133c-.375-.399-.499-.798-.624-1.197v-2.392h.748v3.722zm-.623-1.462c0 .398.124.797.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M117.016 172.161c.249-.399.374-.798.499-1.064v-2.126h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M116.891 172.427v-3.589h.623v2.26c0 .398-.249.664-.499 1.063l-.124.266zm.124-3.456v3.057c.25-.266.25-.665.375-.93v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M102.545 173.49c.125.133.374.266.499.266v-4.785h-.499v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M103.169 173.889c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.124.133.249.133.374.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M107.162 174.952h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M107.661 175.085h-.624v-6.247h.624v6.247zm-.499-.266h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M103.543 173.889c.125.133.374.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M104.042 174.288c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.124 0 .249.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M105.289 174.553c.125 0 .374.133.499.133v-5.715h-.499v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M105.913 174.819c-.25 0-.374-.133-.624-.133v-5.715h.624v5.848zm-.499-.266c.125 0 .249 0 .374.133v-5.582h-.374v5.449z"
            fill="#131A2D"
            />
            <path
            d="M106.162 174.82c.125 0 .374 0 .499.132v-6.114c-.125 0-.374 0-.499.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M106.786 174.952c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.499-.265c.125 0 .249 0 .374.132v-5.848c-.125 0-.249 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M109.157 164.718c-4.865 0-8.358 2.127-8.358 3.987 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.86-3.493-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M109.157 172.826c-4.99 0-8.358-2.127-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121 4.99 0 8.358 2.127 8.358 4.121 0 1.993-3.493 4.12-8.358 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.86 3.368 3.987 8.233 3.987s8.234-2.127 8.234-3.987c0-1.861-3.369-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M103.668 171.763c.499.266 1.123.399 1.746.665l6.862-7.311c-.624-.133-1.373-.265-2.121-.265l-6.487 6.911zM108.408 172.826h1.248l5.988-6.38c-.25-.133-.499-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M106.413 172.428c-.125 0-.249 0-.499-.133-.249-.133-.624-.133-.873-.266-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.249-.133c-.125 0-.125-.133-.25-.133a271.07 271.07 0 01-.748-.398c-.499-.266-.998-.665-1.497-1.064.374.532.748 1.064 1.247 1.33.125.132.25.132.375.265.124.133.249.133.374.266.125 0 .125.133.249.133l.25.133c.125 0 .249.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM110.655 172.427l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.399h-1.247c-.374.266-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M109.157 165.648c-1.123 0-2.121.133-2.994.266h-5.364v2.127c.125 1.861 3.493 3.988 8.358 3.988s8.234-1.994 8.358-3.988v-2.127h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M109.157 172.029c-4.865 0-8.234-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.374 2.127-3.743 4.121-8.483 4.121zm-8.358-3.988c.124 1.861 3.493 3.855 8.233 3.855 4.741 0 8.109-1.994 8.234-3.855v-1.994h-5.24c-.998-.133-1.996-.265-2.994-.265-.998 0-1.996.132-2.994.265h-5.364v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M101.672 169.769c.125.133.374.266.499.399v-4.254h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M102.296 170.301c-.25-.266-.499-.399-.624-.532v-3.988h.624v4.52zm-.499-.532c.124.133.249.266.374.266v-4.121h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M111.652 165.781v5.982c.125 0 .375 0 .499-.133v-5.849c-.249.133-.374.133-.499 0z"
            fill="#0EA59D"
            />
            <path
            d="M111.527 171.896v-6.115h.125c.125 0 .25 0 .374.133h.125v5.982h-.624zm.125-5.982v5.849c.125 0 .25 0 .374-.133v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M110.654 171.897h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M110.654 172.029v-6.381h.624v6.248c-.249.133-.374.133-.624.133zm.125-6.248v6.115h.374v-5.982c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M115.27 170.699c.124-.132.374-.265.499-.265v-4.52h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M115.145 170.832v-4.918h.623v4.519c-.124.133-.374.266-.623.399zm.124-4.918v4.652c.125-.133.25-.133.375-.266v-4.386h-.375z"
            fill="#131A2D"
            />
            <path d="M109.781 172.029h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M109.781 172.029v-6.513h.624v6.38c-.25.133-.374.133-.624.133zm.125-6.248v6.248h.374v-6.115c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M116.143 170.035a1.75 1.75 0 00.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M116.018 170.168v-4.387h.623v3.855c-.124.266-.249.399-.623.532zm.124-4.254v3.988l.375-.399v-3.589h-.375z"
            fill="#131A2D"
            />
            <path
            d="M113.398 171.364c.125 0 .375-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M113.398 171.497v-5.716h.624v5.45c-.249.133-.374.133-.624.266zm.125-5.583v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M112.525 171.63c.125 0 .375-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M112.4 171.763v-5.849h.624v5.716c-.125 0-.374 0-.624.133zm.125-5.849v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M114.271 171.098c.125-.133.375-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M114.271 171.231v-5.317h.624v5.051c-.249 0-.374.133-.624.266zm.125-5.317v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M104.416 171.231c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M105.04 171.497c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.624-.266c.125 0 .25.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M108.033 172.029h.499v-6.381h-.499v6.381z" fill="#0EA59D" />
            <path
            d="M108.657 172.029h-.624v-6.513h.624v6.513zm-.624-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M108.908 165.648v6.381h.624v-6.381h-.624z" fill="#0EA59D" />
            <path
            d="M109.158 172.029c-.125 0-.125 0 0 0h-.25v-6.513h.624v6.513h-.374zm-.25-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M100.799 168.041c0 .399.249.797.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M101.422 169.503l-.124-.133c-.375-.399-.499-.797-.624-1.196v-2.393h.748v3.722zm-.623-1.462c0 .399.124.797.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M117.016 169.237c.249-.399.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M116.891 169.37v-3.589h.623v2.26c0 .399-.249.665-.499 1.063l-.124.266zm.124-3.456v3.057c.25-.265.25-.664.375-.93v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M102.545 170.433c.125.133.374.266.499.266v-4.785h-.499v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M103.169 170.832c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.124.133.249.133.374.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M107.162 171.896h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M107.661 172.029h-.624v-6.247h.624v6.247zm-.499-.132h.374v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M103.543 170.965c.125.133.374.133.499.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M104.042 171.231c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.124 0 .249.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M105.289 171.497c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M105.913 171.763c-.25 0-.374-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.125 0 .249.133.374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M106.162 171.764c.125 0 .374 0 .499.133v-6.115c-.125 0-.374 0-.499.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M106.786 171.896c-.25 0-.374-.133-.624-.133v-5.982c.125 0 .374 0 .499-.133h.125v6.248zm-.499-.133c.125 0 .249 0 .374.133v-5.849c-.125 0-.249 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M109.157 161.661c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M109.157 169.902c-4.99 0-8.358-2.126-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121 4.99 0 8.358 2.127 8.358 4.121 0 1.861-3.493 4.12-8.358 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.861-3.369-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M103.668 168.706c.499.266 1.123.399 1.746.664l6.862-7.31c-.624-.133-1.373-.266-2.121-.266l-6.487 6.912zM108.408 169.769h1.248l5.988-6.38c-.25-.133-.499-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M106.413 169.37c-.125 0-.249 0-.499-.133-.249-.133-.624-.133-.873-.266-.25-.132-.624-.132-.873-.265-.125 0-.25-.133-.375-.133l-.249-.133c-.125 0-.125 0-.25-.133l-.748-.399c-.499-.266-.998-.665-1.497-1.063.374.531.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.125 0 .125.133.249.133l.25.132c.125 0 .249.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM110.655 169.504l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.399h-1.247c-.374.133-.749.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M109.032 162.591c-1.122 0-2.12.133-2.994.266h-5.239v2.127c.125 1.861 3.493 3.854 8.358 3.854s8.234-1.993 8.358-3.854v-2.127h-5.489c-.873-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M109.032 168.971c-4.74 0-8.109-1.994-8.358-3.855v-2.392h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.124 1.993-3.493 3.987-8.358 3.987zm-8.233-3.987c.124 1.86 3.493 3.854 8.233 3.854 4.741 0 8.109-1.994 8.234-3.854v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.239v1.994z"
            fill="#131A2D"
            />
            <path
            d="M101.672 166.711c.125.133.374.266.499.399v-4.253h-.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M102.296 167.243c-.25-.266-.499-.399-.624-.532v-3.987h.624v4.519zm-.499-.532c.124.133.249.266.374.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M111.527 162.724v5.981c.125 0 .375 0 .499-.133v-5.848c-.124.133-.249 0-.499 0z"
            fill="#0EA59D"
            />
            <path
            d="M111.527 168.838v-6.114h.125c.125 0 .25 0 .499.133h.125v5.981c-.374-.133-.499 0-.749 0zm.125-5.981v5.848c.125 0 .25 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M110.654 168.838h.499v-6.114h-.499v6.114z" fill="#0EA59D" />
            <path
            d="M110.654 168.971v-6.38h.624v6.247c-.249 0-.374 0-.624.133zm.125-6.247v6.114h.374v-5.981c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M115.145 167.641c.124-.132.374-.265.499-.265v-4.387h-.499v4.652z"
            fill="#0EA59D"
            />
            <path
            d="M115.02 167.642v-4.918h.748v4.519c-.249.133-.374.266-.748.399zm.124-4.785v4.519c.125-.133.25-.133.375-.266v-4.386h-.375v.133z"
            fill="#131A2D"
            />
            <path d="M109.781 168.971h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M109.656 168.971v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114s-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M116.018 166.977a1.75 1.75 0 00.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M116.018 167.11v-4.386h.623v3.854c-.124.133-.374.399-.623.532zm.124-4.253v3.987l.375-.399v-3.588h-.375z"
            fill="#131A2D"
            />
            <path
            d="M113.398 168.306c.125 0 .375-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M113.273 168.439v-5.583h.624v5.45c-.125 0-.374 0-.624.133zm.125-5.583v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M112.4 168.572c.125 0 .375-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M112.4 168.705v-5.849h.624v5.716c-.249 0-.374 0-.624.133zm.125-5.849v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M114.271 168.041c.125-.133.375-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M114.146 168.041v-5.317h.624v5.051a.923.923 0 01-.624.266zm.125-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M104.416 168.173c.125 0 .374.133.499.133v-5.582h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M104.915 168.439c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.499-.266c.125 0 .249.133.374.133v-5.317h-.374v5.184z"
            fill="#131A2D"
            />
            <path d="M107.91 168.838h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M108.534 168.971h-.624v-6.38h.624v6.38zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M108.908 162.591v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M109.033 168.971h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M100.799 164.983c0 .399.249.798.624 1.33v-3.456h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M101.422 166.446l-.124-.133c-.375-.399-.499-.798-.624-1.197v-2.392h.748v3.722zm-.623-1.462c0 .398.124.797.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M116.891 166.179c.249-.398.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M116.891 166.312v-3.588h.623v2.259c0 .399-.249.665-.499 1.064l-.124.265zm.124-3.455v3.057c.125-.266.25-.665.375-.931v-1.994h-.375v-.132z"
            fill="#131A2D"
            />
            <path
            d="M102.545 167.376c.125.133.374.266.499.266v-4.786h-.499v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M103.169 167.775c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.124.133.249.133.374.266v-4.653h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M107.037 168.838h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M107.661 168.971h-.624v-6.38h.624v6.38zm-.499-.266h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M103.543 167.775c.125.132.374.132.499.265v-5.184h-.499v4.919z"
            fill="#0EA59D"
            />
            <path
            d="M104.042 168.173c-.25-.133-.499-.133-.624-.266v-5.051h.624v5.317zm-.499-.398c.124 0 .249.132.374.132v-5.051h-.374v4.919z"
            fill="#131A2D"
            />
            <path
            d="M105.289 168.439c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M105.913 168.705c-.25 0-.374-.133-.624-.133v-5.716h.624v5.849zm-.624-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M106.162 168.706c.125 0 .374 0 .499.133v-5.982c-.125 0-.374 0-.499.133v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M106.786 168.838c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.499-.266c.125 0 .249 0 .374.133v-5.848c-.125 0-.249 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M109.032 158.604c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.368 3.988 8.358 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.368-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M109.032 166.712c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12 4.99 0 8.358 2.126 8.358 4.12 0 1.994-3.368 4.121-8.358 4.121zm0-7.975c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.861-3.369-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M103.668 165.649c.499.265 1.123.398 1.746.531l6.862-7.31c-.624-.133-1.373-.266-2.121-.266l-6.487 7.045zM108.408 166.712h1.248l5.988-6.381c-.25-.132-.499-.398-.874-.531l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M106.411 166.314c-.124 0-.249 0-.374-.133-.249-.133-.624-.133-.873-.266-.25-.133-.499-.133-.873-.266-.125 0-.25-.133-.375-.133l-.249-.133c-.125 0-.125 0-.25-.133l-.748-.399c-.499-.265-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.125 0 .125.133.249.133l.25.133c.125 0 .249.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624-.001.874.132h.873c-.25-.133-.624-.132-.873-.265h-.375zM110.528 166.314l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.132.624.132h1.871c.374 0 .873-.132 1.248-.265l1.122-.399h-1.247c-.25.266-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M109.032 159.135c-1.122 0-2.12.133-2.994.266h-5.239v2.126c.125 1.861 3.493 3.855 8.358 3.855s8.234-1.994 8.358-3.855v-2.126h-5.489c-.873-.266-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M109.032 165.515c-4.74 0-8.109-1.994-8.358-3.855v-2.392h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.124 1.994-3.493 3.988-8.358 3.988zm-8.233-3.988c.124 1.861 3.493 3.855 8.233 3.855 4.741 0 8.109-1.994 8.234-3.855v-1.993h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.239v1.993z"
            fill="#131A2D"
            />
            <path
            d="M101.672 163.256c.125.133.374.266.499.399v-4.254h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M102.296 163.788c-.25-.266-.499-.399-.624-.532v-3.987h.624v4.519zm-.499-.665c.124.133.249.266.374.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M111.527 159.269v5.981c.125 0 .375 0 .499-.133v-5.848h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M111.527 165.383v-6.114h.125c.125 0 .25 0 .374.132h.125v5.982c-.249-.133-.374-.133-.624 0zm.125-5.982v5.849c.125 0 .25 0 .374-.133v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M110.654 165.382h.499v-6.114h-.499v6.114z" fill="#0EA59D" />
            <path
            d="M110.654 165.515v-6.38h.624v6.247c-.249 0-.374 0-.624.133zm.125-6.247v6.114h.374v-5.981c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M115.145 164.054c.124-.133.374-.266.499-.266v-4.387h-.499v4.653z"
            fill="#0EA59D"
            />
            <path
            d="M115.02 164.187v-4.918h.748v4.519c-.249.133-.374.266-.748.399zm.124-4.786v4.52c.125-.133.25-.133.375-.266v-4.386h-.375v.132z"
            fill="#131A2D"
            />
            <path d="M109.781 165.382h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M109.656 165.515v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c0-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M116.018 163.522c.249-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M116.018 163.655v-4.386h.623v3.854c-.124.133-.374.266-.623.532zm.124-4.254v3.988l.375-.399v-3.589h-.375z"
            fill="#131A2D"
            />
            <path
            d="M113.398 164.85c.125 0 .375-.133.499-.133V159.4h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M113.273 164.983V159.4h.624v5.45c-.125 0-.374 0-.624.133zm.125-5.583v5.317c.125 0 .25-.133.374-.133V159.4h-.374z"
            fill="#131A2D"
            />
            <path
            d="M112.4 165.117c.125 0 .375-.133.499-.133v-5.583h-.499v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M112.4 165.117v-5.848h.624v5.715c-.249.133-.374.133-.624.133zm.125-5.716v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M114.271 164.585c.125-.133.375-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M114.146 164.585v-5.316h.624v5.051a.927.927 0 01-.624.265zm.125-5.184v5.051c.125 0 .25-.132.374-.132v-4.786h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M104.416 164.718c.125 0 .374.133.499.133v-5.582h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M104.915 164.984c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.499-.266c.125 0 .249.133.374.133v-5.317h-.374v5.184z"
            fill="#131A2D"
            />
            <path d="M107.91 165.382h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M108.534 165.515h-.624v-6.38h.624v6.38zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M108.908 159.135v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M109.033 165.515h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M100.799 161.528c0 .399.249.798.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M101.422 162.99l-.124-.133c-.375-.398-.499-.797-.624-1.196v-2.392h.748v3.721zm-.623-1.462c0 .399.124.798.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M116.891 162.591c.249-.398.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M116.891 162.857v-3.588h.623v2.259c0 .399-.249.665-.499 1.064l-.124.265zm.124-3.456v3.058c.125-.266.25-.665.375-.931v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M102.545 163.921c.125.133.374.266.499.266v-4.786h-.499v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M103.169 164.32c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.532c.124.133.249.133.374.266v-4.653h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M107.037 165.382h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M107.661 165.515h-.624v-6.247h.624v6.247zm-.499-.266h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M103.543 164.318c.125.133.374.133.499.266V159.4h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M104.042 164.717c-.25-.133-.499-.133-.624-.266V159.4h.624v5.317zm-.499-.399c.124 0 .249.133.374.133V159.4h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M105.289 164.983c.125 0 .374.133.499.133V159.4h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M105.913 165.249c-.25 0-.374-.133-.624-.133V159.4h.624v5.849zm-.624-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M106.162 165.25c.125 0 .374 0 .499.133v-5.982c-.125 0-.374 0-.499.133v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M106.786 165.382c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.499-.266c.125 0 .249 0 .374.133v-5.848c-.125 0-.249 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M109.032 155.147c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.368 3.988 8.358 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.368-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M109.032 163.256c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12 4.99 0 8.358 2.126 8.358 4.12 0 1.994-3.368 4.121-8.358 4.121zm0-7.976c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.994-3.369-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M103.668 162.192c.499.266 1.123.399 1.746.532l6.862-7.311c-.624-.133-1.373-.266-2.121-.266l-6.487 7.045zM108.408 163.256h1.248l5.988-6.381c-.25-.132-.499-.398-.874-.531l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M106.411 162.857c-.124 0-.249 0-.374-.133-.249-.133-.624-.133-.873-.266-.25-.133-.499-.133-.873-.266-.125 0-.25-.133-.375-.133l-.249-.133c-.125 0-.125 0-.25-.133l-.748-.399c-.499-.265-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.125 0 .125.133.249.133l.25.133c.125 0 .249.133.374.133l.499.133c.125 0 .25.133.499.133.25.132.624.132.873.132.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.265h-.375zM110.528 162.857l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.132.624.132h1.871c.374 0 .873-.132 1.248-.265l1.122-.399h-1.247c-.25.266-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M94.686 167.908c-1.122 0-2.12.133-2.994.266h-5.364v2.127c.125 1.861 3.493 3.987 8.358 3.987 4.866 0 8.234-1.993 8.359-3.987v-2.127H97.68c-.998-.266-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M94.686 174.289c-4.865 0-8.233-1.994-8.358-3.988v-2.393h5.489c.998-.133 1.996-.265 2.994-.265.998 0 1.996.132 2.994.265h5.364v2.26c-.374 2.127-3.742 4.121-8.483 4.121zm-8.358-3.988c.125 1.861 3.493 3.855 8.233 3.855s8.109-1.994 8.234-3.855v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M87.201 172.03c.125.133.374.266.5.399v-4.254h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M87.825 172.562c-.25-.266-.5-.399-.624-.532v-3.988h.624v4.52zm-.5-.665l.375.399v-4.121h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M97.182 168.041v5.982c.124 0 .374 0 .499-.133v-5.849h-.5z"
            fill="#0EA59D"
            />
            <path
            d="M97.057 174.156v-6.248h.124c.125 0 .25 0 .5.133h.124v5.982c-.25 0-.499 0-.748.133zm.124-5.982v5.849c.125 0 .25 0 .375-.133v-5.716h-.375z"
            fill="#131A2D"
            />
            <path d="M96.184 174.156h.499v-6.115h-.5v6.115z" fill="#0EA59D" />
            <path
            d="M96.184 174.289v-6.381h.624v6.248c-.25 0-.375 0-.624.133zm.124-6.248v6.115h.375v-5.982c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M100.799 172.827c.249-.133.374-.265.499-.265v-4.52h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M100.674 172.96v-4.918h.624v4.52c-.125.132-.375.265-.624.398zm.125-4.785v4.652c.124-.133.249-.133.374-.265v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M95.309 174.289h.499v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M95.309 174.289v-6.513h.624v6.38c-.25.133-.375.133-.624.133zm.124-6.38v6.247h.375v-6.247h-.375z"
            fill="#131A2D"
            />
            <path
            d="M101.672 172.296c.249-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M101.547 172.429v-4.387h.624v3.855c-.125.133-.25.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M98.928 173.625c.124 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M98.928 173.758v-5.716h.624v5.45c-.25.133-.375.133-.624.266zm.124-5.583v5.317c.125 0 .25-.133.375-.133v-5.184h-.375z"
            fill="#131A2D"
            />
            <path
            d="M98.055 173.889c.124 0 .374-.132.499-.132v-5.583h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M97.93 174.023v-5.849h.623v5.716c-.124 0-.374 0-.623.133zm.124-5.849v5.583c.125 0 .25 0 .375-.133v-5.45h-.375z"
            fill="#131A2D"
            />
            <path
            d="M99.8 173.359c.126-.133.375-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M99.8 173.359v-5.317h.625v5.051c-.25.133-.375.266-.624.266zm.126-5.184v5.051c.124 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M89.945 173.492c.125 0 .375.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M90.57 173.758c-.25-.133-.5-.133-.625-.133v-5.45h.624v5.583zm-.625-.266c.125 0 .25.133.375.133v-5.45h-.375v5.317z"
            fill="#131A2D"
            />
            <path d="M93.563 174.156h.498v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M94.186 174.289h-.624v-6.513h.624v6.513zm-.624-.133h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M94.438 167.909v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M94.687 174.289c-.125 0-.125 0 0 0h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M86.328 170.302c0 .399.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M86.952 171.764l-.125-.133c-.374-.399-.5-.797-.624-1.196v-2.393h.749v3.722zm-.624-1.462c0 .399.125.797.499 1.196v-3.19h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M102.545 171.365c.249-.399.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M102.42 171.631v-3.589h.624v2.26c0 .399-.25.664-.499 1.063l-.125.266zm.249-3.456v3.057c.125-.266.25-.664.375-.93v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M88.2 172.694c.124.133.373.266.498.266v-4.785H88.2v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M88.698 173.093c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.531c.125.132.25.132.374.265v-4.652H88.2v4.387z"
            fill="#131A2D"
            />
            <path d="M92.69 174.155h.499v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M93.188 174.289h-.624v-6.381h.624v6.381zm-.499-.266h.375v-6.115h-.375v6.115z"
            fill="#131A2D"
            />
            <path
            d="M89.072 173.093c.125.133.374.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M89.571 173.492c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M90.818 173.757c.125 0 .375.133.5.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M91.442 174.023c-.25 0-.374-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M91.691 174.023c.125 0 .375 0 .5.133v-6.115c-.125 0-.375 0-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M92.315 174.156c-.25 0-.374-.133-.624-.133v-5.982c.125 0 .375 0 .5-.133h.124v6.248zm-.499-.266c.125 0 .25 0 .374.133v-5.849c-.124 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M94.686 163.921c-4.865 0-8.358 2.127-8.358 3.988 0 1.86 3.493 3.987 8.358 3.987 4.866 0 8.359-2.127 8.359-3.987 0-1.861-3.493-3.988-8.359-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M94.686 172.029c-4.99 0-8.358-2.127-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121 4.866 0 8.359 2.127 8.359 4.121 0 1.993-3.493 4.12-8.359 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.987 8.233 3.987 4.866 0 8.234-2.126 8.234-3.987 0-1.861-3.368-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M89.197 170.966c.5.265 1.123.398 1.747.664l6.861-7.31c-.624-.133-1.372-.266-2.12-.266l-6.488 6.912zM93.938 172.029H95.184l5.988-6.38c-.249-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M91.94 171.63c-.124 0-.249 0-.374-.133-.25-.133-.623-.133-.873-.266s-.624-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.132c-.125 0-.125 0-.25-.133l-.748-.399c-.499-.266-.998-.665-1.497-1.064.374.532.749 1.064 1.248 1.33.124.133.25.133.374.266.125.132.25.132.374.265.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.624-.133-.873-.266h-.374zM96.183 171.631l-1.248.133h-.624c-.25 0-.374 0-.624.133.25 0 .375.133.624.133H96.183c.374 0 .873-.133 1.247-.266l1.123-.399h-1.248c-.374.266-.748.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M94.686 164.852c-1.122 0-2.12.132-2.994.265h-5.364v2.127c.125 1.861 3.493 3.988 8.358 3.988 4.866 0 8.234-1.994 8.359-3.988v-2.127H97.68c-.998-.133-1.996-.265-2.994-.265z"
            fill="#0EA59D"
            />
            <path
            d="M94.686 171.231c-4.865 0-8.233-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.374 2.127-3.742 4.121-8.483 4.121zm-8.358-3.988c.125 1.861 3.493 3.855 8.233 3.855s8.109-1.994 8.234-3.855v-1.993h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.993h.125z"
            fill="#131A2D"
            />
            <path
            d="M87.201 168.971c.125.133.374.266.5.399v-4.254h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M87.825 169.503c-.25-.266-.5-.399-.624-.532v-3.988h.624v4.52zm-.5-.532c.126.133.25.266.375.266v-4.121h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M97.182 164.983v5.982c.124 0 .374 0 .499-.133v-5.849c-.25.133-.375 0-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M97.057 171.098v-6.115h.124c.125 0 .25 0 .5.133h.124v5.982h-.748zm.124-5.982v5.849c.125 0 .25 0 .375-.133v-5.716h-.375z"
            fill="#131A2D"
            />
            <path d="M96.184 171.098h.499v-6.115h-.5v6.115z" fill="#0EA59D" />
            <path
            d="M96.184 171.231v-6.38h.624v6.247c-.25.133-.375.133-.624.133zm.124-6.247v6.114h.375v-5.982c-.125-.132-.25-.132-.375-.132z"
            fill="#131A2D"
            />
            <path
            d="M100.799 169.901c.249-.133.374-.265.499-.265v-4.52h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M100.674 170.034v-4.918h.624v4.52c-.125.132-.375.132-.624.398zm.125-4.918v4.652c.124-.132.249-.132.374-.265v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M95.309 171.231h.499v-6.248h-.5v6.248z" fill="#0EA59D" />
            <path
            d="M95.309 171.231v-6.513h.624v6.38c-.25.133-.375.133-.624.133zm.124-6.38v6.247h.375v-6.114c-.125 0-.25 0-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M101.672 169.237c.249-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M101.547 169.37v-4.387h.624v3.855c-.125.266-.25.399-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M98.928 170.566c.124 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M98.928 170.699v-5.716h.624v5.45c-.25.133-.375.133-.624.266zm.124-5.583v5.317c.125 0 .25-.133.375-.133v-5.184h-.375z"
            fill="#131A2D"
            />
            <path
            d="M98.055 170.832c.124 0 .374-.133.499-.133v-5.583h-.5v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M97.93 170.965v-5.849h.623v5.716c-.124 0-.374 0-.623.133zm.124-5.849v5.583c.125 0 .25 0 .375-.133v-5.45h-.375z"
            fill="#131A2D"
            />
            <path
            d="M99.8 170.3c.126-.133.375-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M99.8 170.433v-5.317h.625v5.051c-.25 0-.375.133-.624.266zm.126-5.317v5.051c.124 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M89.945 170.433c.125 0 .375.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M90.57 170.699c-.25-.133-.5-.133-.625-.133v-5.45h.624v5.583zm-.625-.266c.125 0 .25.133.375.133v-5.45h-.375v5.317z"
            fill="#131A2D"
            />
            <path d="M93.563 171.231h.498v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M94.186 171.231h-.624v-6.513h.624v6.513zm-.624-.133h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M94.438 164.851v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M94.687 171.231h-.249v-6.513h.873v6.513h-.624zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M86.328 167.243c0 .399.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M86.952 168.705l-.125-.133c-.374-.399-.5-.797-.624-1.196v-2.393h.749v3.722zm-.624-1.462c0 .399.125.798.499 1.196v-3.19h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M102.545 168.44c.249-.399.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M102.42 168.572v-3.589h.624v2.26c0 .399-.25.665-.499 1.063l-.125.266zm.249-3.456v3.057c.125-.265.25-.664.375-.93v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M88.2 169.636c.124.132.373.265.498.265v-4.785H88.2v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M88.698 170.034c-.25-.133-.499-.265-.624-.398v-4.653h.624v5.051zm-.499-.398c.125.133.25.133.374.265v-4.652H88.2v4.387z"
            fill="#131A2D"
            />
            <path d="M92.691 171.098h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M93.19 171.231h-.624v-6.247h.624v6.247zm-.499-.133h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M89.072 170.168c.125.133.374.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M89.571 170.433c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M90.818 170.699c.125 0 .375.133.5.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M91.442 170.965c-.25 0-.374-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M91.691 170.965c.125 0 .375 0 .5.133v-6.115c-.125 0-.375 0-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M92.315 171.098c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .375 0 .5-.133h.124v6.247zm-.499-.133c.125 0 .25 0 .374.133v-5.849c-.124 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M94.686 160.863c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.988 8.358 3.988 4.866 0 8.359-2.127 8.359-3.988 0-1.861-3.493-3.988-8.359-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M94.686 169.104c-4.99 0-8.358-2.126-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121 4.866 0 8.359 2.127 8.359 4.121 0 1.994-3.493 4.12-8.359 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.987 8.233 3.987 4.866 0 8.234-2.126 8.234-3.987 0-1.861-3.368-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M89.197 167.908c.5.266 1.123.399 1.747.665l6.861-7.311c-.624-.133-1.372-.266-2.12-.266l-6.488 6.912zM93.938 168.971H95.184l5.988-6.38c-.249-.133-.499-.399-.873-.531l-6.362 6.911z"
            fill="#fff"
            />
            <path
            d="M91.94 168.572c-.124 0-.249 0-.374-.133-.25-.132-.623-.132-.873-.265s-.624-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125 0-.25-.133l-.748-.399c-.499-.266-.998-.664-1.497-1.063.374.532.749 1.063 1.248 1.329.124.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.132c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.624-.133-.873-.266h-.374zM96.183 168.706l-1.248.133h-.624c-.25 0-.374 0-.624.133.25 0 .375.133.624.133H96.183c.374 0 .873-.133 1.247-.266l1.123-.399h-1.248c-.374.133-.748.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M100.925 176.547c-1.123 0-2.121.133-2.994.266h-5.365v2.127c.125 1.861 3.493 3.987 8.359 3.987 4.865 0 8.233-1.993 8.358-3.987v-2.127h-5.364c-.874-.133-1.872-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M100.925 183.06c-4.866 0-8.234-1.994-8.359-3.988v-2.392h5.49c.997-.133 1.995-.266 2.993-.266.998 0 1.996.133 2.994.266h5.365v2.26c-.25 2.126-3.618 4.12-8.483 4.12zm-8.234-3.988c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-1.993h-5.239c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.365v1.993h.125z"
            fill="#131A2D"
            />
            <path
            d="M93.564 180.8c.125.133.375.266.5.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M94.188 181.332c-.25-.266-.499-.399-.624-.532v-3.988h.624v4.52zm-.624-.665c.125.133.25.266.375.266v-4.121h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M103.418 176.812v5.982c.125 0 .374 0 .499-.133v-5.849h-.499z"
            fill="#0EA59D"
            />
            <path
            d="M103.418 182.927v-6.115h.125c.124 0 .249.001.374.133h.125v5.982c-.25-.133-.375-.133-.624 0zm.125-6.115v5.849c.124 0 .249 0 .374-.133v-5.716c-.125.133-.25.133-.374 0z"
            fill="#131A2D"
            />
            <path d="M102.547 182.927h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M102.422 183.06v-6.38h.624v6.247c-.125 0-.375 0-.624.133zm.125-6.247v6.114h.374v-5.981c0-.133-.125-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M107.037 181.598c.125-.133.374-.266.499-.266v-4.52h-.499v4.786z"
            fill="#0EA59D"
            />
            <path
            d="M107.037 181.731v-4.919h.624v4.52c-.25.133-.374.266-.624.399zm.125-4.786v4.653c.125-.133.249-.133.374-.266v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M101.674 182.927h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M101.549 183.06v-6.513h.624v6.38c-.125.133-.375.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M107.91 181.066c.25-.133.374-.266.499-.399v-3.721h-.499v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M107.91 181.199v-4.387h.624v3.855c-.125.133-.374.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M105.291 182.395c.125 0 .374-.133.499-.133v-5.317h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M105.166 182.528v-5.716h.624v5.45c-.125.133-.374.133-.624.266zm.125-5.583v5.317c.125 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M104.293 182.661c.125 0 .374-.133.499-.133v-5.582h-.499v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M104.293 182.661v-5.849h.624v5.716c-.25.133-.375.133-.624.133zm.125-5.716v5.583c.124 0 .249 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M106.164 182.129c.125-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M106.039 182.129v-5.317h.624v5.051c-.125.133-.374.133-.624.266zm.125-5.184v5.051c.125 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M96.184 182.262c.124 0 .374.133.499.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M96.807 182.528c-.25-.133-.499-.133-.623-.133v-5.449h.623v5.582zm-.499-.266c.125 0 .25.133.375.133v-5.449h-.375v5.316z"
            fill="#131A2D"
            />
            <path d="M99.8 182.927h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M100.425 183.06h-.624v-6.513h.624v6.513zm-.5-.133h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M100.801 176.547v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M100.925 183.06h-.249v-6.513h.748v6.513h-.499zm-.124-.133h.374v-6.247h-.499v6.247h.125z"
            fill="#131A2D"
            />
            <path
            d="M92.566 179.072c0 .399.25.798.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M93.19 180.534l-.125-.133c-.374-.398-.499-.797-.624-1.196v-2.393h.749v3.722zm-.5-1.595c0 .399.126.798.5 1.197v-3.191h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M108.783 180.136c.25-.399.374-.798.499-1.064v-2.126h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M108.783 180.401v-3.589h.624v2.26c0 .399-.25.665-.499 1.064l-.125.265zm.125-3.456v3.058c.249-.266.249-.665.374-.931v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M94.438 181.465c.124.133.374.266.498.266v-4.785h-.499v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M95.061 181.863c-.25-.132-.499-.265-.624-.398v-4.653h.624v5.051zm-.499-.531c.125.133.25.133.374.266v-4.653h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M98.928 182.927h.499v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M99.552 183.06h-.624v-6.247h.623v6.247zm-.5-.266h.375v-6.114h-.375v6.114z"
            fill="#131A2D"
            />
            <path
            d="M95.31 181.864c.125.133.375.133.5.265v-5.183h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M95.934 182.262c-.25-.133-.499-.133-.623-.266v-5.184h.623v5.45zm-.499-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M97.182 182.528c.124 0 .374.133.499.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M97.68 182.794c-.25 0-.499-.133-.623-.133v-5.716h.623v5.849zm-.499-.266c.125 0 .25 0 .375.133v-5.583h-.375v5.45z"
            fill="#131A2D"
            />
            <path
            d="M98.055 182.794c.124 0 .374 0 .499.133v-6.115c-.125 0-.375.001-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M98.678 182.927c-.25 0-.374-.133-.623-.133v-5.981c.124 0 .374 0 .499-.133h.124v6.247zm-.623-.266c.124 0 .25 0 .374.133v-5.848c-.125 0-.25 0-.374.132v5.583z"
            fill="#131A2D"
            />
            <path
            d="M100.925 172.692c-4.866 0-8.359 2.127-8.359 3.988 0 1.861 3.493 3.987 8.359 3.987 4.865 0 8.358-2.126 8.358-3.987 0-1.861-3.368-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M100.925 180.8c-4.99 0-8.359-2.126-8.359-4.12 0-1.994 3.493-4.121 8.359-4.121 4.99 0 8.358 2.127 8.358 4.121 0 1.994-3.368 4.12-8.358 4.12zm0-8.108c-4.866 0-8.234 2.127-8.234 3.988 0 1.861 3.368 3.987 8.234 3.987 4.865 0 8.233-2.126 8.233-3.987 0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M95.436 179.737c.498.266 1.122.399 1.746.665l6.861-7.311c-.623-.133-1.372-.266-2.12-.266l-6.487 6.912zM100.301 180.801H101.548l5.988-6.381c-.249-.133-.499-.398-.873-.531l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M98.304 180.401c-.125 0-.25 0-.374-.132-.25-.133-.624-.133-.874-.266s-.623-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.25-.133l-.748-.399c-.499-.265-.998-.664-1.497-1.063.375.532.749 1.063 1.248 1.329.125.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.374.133l.499.133c.124 0 .25.132.499.132.25.133.623.133.873.133s.624 0 .873.133h.873c-.25-.133-.623-.133-.873-.266h-.374zM102.421 180.402l-1.248.133h-.623c-.25 0-.375 0-.624.132.249 0 .374.133.624.133h1.871c.374 0 .873-.133 1.247-.265l1.123-.399h-1.247c-.375.266-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M100.925 173.623c-1.123 0-2.121.133-2.994.266h-5.365v2.127c.125 1.861 3.493 3.987 8.359 3.987 4.865 0 8.233-1.994 8.358-3.987v-2.127h-5.364c-.874-.266-1.872-.266-2.994-.266z"
            fill="#fff"
            />
            <path
            d="M100.925 180.003c-4.866 0-8.234-1.993-8.359-3.987v-2.393h5.49c.997-.133 1.995-.266 2.993-.266.998 0 1.996.133 2.994.266h5.489v2.393c-.374 1.994-3.742 3.987-8.607 3.987zm-8.234-3.987c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-2.127h-5.239c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.24v2.127z"
            fill="#000"
            />
            <path
            d="M93.564 177.743c.125.133.375.266.5.399v-4.253h-.5v3.854z"
            fill="#fff"
            />
            <path
            d="M94.188 178.275c-.374-.266-.499-.399-.624-.532v-3.987h.624v4.519zm-.624-.532c.125.133.25.266.375.266v-3.987h-.374v3.721z"
            fill="#000"
            />
            <path
            d="M103.418 173.756v5.982c.125 0 .374 0 .499-.133v-5.849c-.125.133-.374 0-.499 0z"
            fill="#fff"
            />
            <path
            d="M103.418 179.87v-6.247h.125c.124 0 .249 0 .374.133h.125v5.981h-.125c-.125.133-.25.133-.499.133zm.125-5.981v5.848c.124 0 .249 0 .374-.133v-5.715h-.374z"
            fill="#000"
            />
            <path d="M102.547 179.87h.499v-6.114h-.499v6.114z" fill="#fff" />
            <path
            d="M102.422 180.003v-6.38h.748v6.247h-.124c-.125.133-.375.133-.624.133zm.249-6.247v6.114h.375v-5.981c-.125-.133-.25-.133-.375-.133z"
            fill="#000"
            />
            <path
            d="M107.037 178.674c.125-.133.374-.266.499-.266v-4.519h-.499v4.785z"
            fill="#fff"
            />
            <path
            d="M106.912 178.807v-4.918h.624v4.519c-.125.133-.25.133-.624.399zm.25-4.918v4.519c.124-.133.249-.133.374-.266v-4.386h-.374v.133z"
            fill="#000"
            />
            <path d="M101.674 180.003h.499v-6.247h-.499v6.247z" fill="#fff" />
            <path
            d="M101.549 180.003v-6.513h.748v6.513h-.748zm.125-6.38v6.247h.374v-6.114c-.125 0-.25 0-.374-.133z"
            fill="#000"
            />
            <path
            d="M107.91 178.009c.25-.133.374-.266.499-.399v-3.721h-.499v4.12z"
            fill="#fff"
            />
            <path
            d="M107.91 178.275v-4.386h.624v3.854c-.125.133-.374.266-.624.532zm.125-4.386v3.987l.374-.398v-3.589h-.374z"
            fill="#000"
            />
            <path
            d="M105.291 179.339c.125 0 .374-.133.499-.133v-5.317h-.499v5.45z"
            fill="#fff"
            />
            <path
            d="M105.166 179.472v-5.716h.624v5.45c-.125.133-.374.133-.624.266zm.125-5.583v5.317c.125 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#000"
            />
            <path
            d="M104.293 179.604c.125 0 .374-.133.499-.133v-5.582h-.499v5.715z"
            fill="#fff"
            />
            <path
            d="M104.293 179.737v-5.981h.624v5.715c-.25.133-.375.133-.624.266zm.125-5.848v5.582c.124 0 .249 0 .374-.132v-5.45h-.374z"
            fill="#000"
            />
            <path
            d="M106.164 179.073c.125-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#fff"
            />
            <path
            d="M106.039 179.206v-5.45h.624v5.051c-.125.133-.25.266-.624.399zm.125-5.317v5.051c.125 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#000"
            />
            <path
            d="M96.184 179.206c.124 0 .374.133.499.133v-5.583h-.5v5.45z"
            fill="#fff"
            />
            <path
            d="M96.807 179.472c-.25-.133-.499-.133-.623-.133v-5.583h.623v5.716zm-.499-.266c.125 0 .25.133.375.133v-5.317h-.375v5.184z"
            fill="#000"
            />
            <path d="M99.803 180.003h.499v-6.38h-.5v6.38z" fill="#fff" />
            <path
            d="M100.426 180.003h-.748v-6.513h.748v6.513zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#000"
            />
            <path d="M100.801 173.623v6.38h.624v-6.38h-.624z" fill="#fff" />
            <path
            d="M100.925 180.003c-.124 0 0 0 0 0h-.249v-6.513h.748v6.513h-.499zm-.124-.133h.374v-6.247h-.374v6.247z"
            fill="#000"
            />
            <path
            d="M92.566 176.015c0 .399.25.798.624 1.33v-3.456h-.624v2.126z"
            fill="#fff"
            />
            <path
            d="M93.19 177.61l-.125-.132c-.374-.399-.499-.798-.624-1.197v-2.392h.749v3.721zm-.5-1.595c0 .399.126.798.375 1.197v-3.19h-.374v1.993z"
            fill="#000"
            />
            <path
            d="M108.783 177.213c.25-.399.374-.798.499-1.064v-2.127h-.499v3.191z"
            fill="#fff"
            />
            <path
            d="M108.783 177.345v-3.589h.624v2.392c0 .399-.25.665-.499 1.064l-.125.133zm.125-3.456v2.924c.125-.266.249-.532.249-.797v-2.127h-.249z"
            fill="#000"
            />
            <path
            d="M94.438 178.408c.124.133.374.266.498.266v-4.785h-.499v4.519z"
            fill="#fff"
            />
            <path
            d="M95.061 178.807c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.125.133.25.133.374.266v-4.652h-.374v4.386z"
            fill="#000"
            />
            <path d="M98.93 179.87h.499v-6.247h-.5v6.247z" fill="#fff" />
            <path
            d="M99.553 180.003h-.748v-6.247h.748v6.247zm-.499-.266h.374v-6.114h-.374v6.114z"
            fill="#000"
            />
            <path
            d="M95.31 178.941c.125.133.375.133.5.266v-5.184h-.5v4.918z"
            fill="#fff"
            />
            <path
            d="M95.934 179.206c-.25-.133-.499-.133-.623-.266v-5.184h.623v5.45zm-.499-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#000"
            />
            <path
            d="M97.182 179.472c.124 0 .374.133.499.133v-5.716h-.5v5.583z"
            fill="#fff"
            />
            <path
            d="M97.805 179.738c-.25 0-.499-.133-.623-.133v-5.849h.623v5.982zm-.623-.266c.124 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#000"
            />
            <path
            d="M98.055 179.738c.124 0 .374 0 .499.132v-6.114c-.125 0-.375 0-.5.133v5.849z"
            fill="#fff"
            />
            <path
            d="M98.678 179.87c-.25 0-.499-.133-.624-.133h-.124v-5.981h.124c.125 0 .375 0 .5-.133h.124v6.247zm-.624-.266h.375v-5.848h-.375v5.848z"
            fill="#000"
            />
            <path
            d="M100.925 169.636c-4.866 0-8.359 2.126-8.359 3.987 0 1.861 3.493 3.988 8.359 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.368-3.987-8.358-3.987z"
            fill="#fff"
            />
            <path
            d="M100.924 177.877c-4.99 0-8.483-2.127-8.483-4.121 0-1.994 3.493-4.12 8.483-4.12s8.483 2.126 8.483 4.12c0 1.994-3.493 4.121-8.483 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988 0-1.861-3.368-3.987-8.234-3.987z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M95.436 176.681c.498.266 1.122.399 1.746.665l6.861-7.311c-.623-.133-1.372-.265-2.12-.265l-6.487 6.911zM100.301 177.744H101.548l5.988-6.38c-.249-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#9CD6CB"
            />
            <path
            d="M94.561 161.794c-1.122 0-2.12.133-2.994.266h-5.364v2.126c.125 1.861 3.493 3.855 8.358 3.855 4.866 0 8.234-1.994 8.359-3.855v-2.126h-5.365c-.873-.266-1.87-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M94.561 168.174c-4.74 0-8.108-1.994-8.358-3.855v-2.392h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.365v2.259c-.125 1.994-3.493 3.988-8.359 3.988zm-8.233-3.988c.125 1.861 3.493 3.855 8.233 3.855s8.109-1.994 8.234-3.855v-1.993h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.24v1.993z"
            fill="#131A2D"
            />
            <path
            d="M87.201 165.915c.125.133.374.266.5.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M87.825 166.447c-.25-.266-.5-.399-.624-.532v-3.987h.624v4.519zm-.5-.665c.126.133.25.266.375.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M97.057 161.928v5.981c.124 0 .374 0 .499-.133v-5.848c-.125.133-.25 0-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M97.057 168.042v-6.114h.124c.125 0 .25 0 .5.133h.124v5.981c-.374-.133-.499-.133-.748 0zm.124-5.981v5.848c.125 0 .25 0 .375-.133v-5.715h-.375z"
            fill="#131A2D"
            />
            <path d="M96.184 168.042h.499v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M96.184 168.174v-6.38h.624v6.247c-.25 0-.375 0-.624.133zm.124-6.247v6.114h.375v-5.981c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M100.674 166.846c.125-.133.374-.266.499-.266v-4.387h-.499v4.653z"
            fill="#0EA59D"
            />
            <path
            d="M100.674 166.846v-4.918h.624v4.519c-.25.133-.375.266-.624.399zm.125-4.785v4.519c.124-.133.249-.133.374-.266v-4.386h-.374v.133z"
            fill="#131A2D"
            />
            <path d="M95.31 168.175h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M95.186 168.174v-6.513h.624v6.38c-.126.133-.375.133-.624.133zm.124-6.38v6.247h.374v-6.114c0-.133-.124-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M101.547 166.181c.249-.133.374-.266.499-.399v-3.721h-.499v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M101.547 166.314v-4.386h.624v3.854c-.125.133-.375.266-.624.532zm.125-4.253v3.987l.374-.398v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M98.928 167.509c.124 0 .374-.133.499-.133v-5.316h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M98.803 167.642v-5.582h.624v5.449c-.125 0-.375 0-.624.133zm.124-5.582v5.316c.125 0 .25-.133.375-.133v-5.183h-.375z"
            fill="#131A2D"
            />
            <path
            d="M97.93 167.775c.124 0 .374-.133.499-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M97.93 167.908v-5.848h.623v5.715c-.25 0-.374 0-.623.133zm.124-5.848v5.582c.125 0 .25 0 .375-.133v-5.449h-.375z"
            fill="#131A2D"
            />
            <path
            d="M99.8 167.244c.126-.132.375-.132.5-.265v-4.918h-.5v5.183z"
            fill="#0EA59D"
            />
            <path
            d="M99.676 167.245v-5.317h.624v5.051c-.125.133-.25.266-.624.266zm.124-5.184v5.051c.125 0 .25-.133.375-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M89.945 167.377c.125 0 .375.133.5.133v-5.582h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M90.57 167.643c-.25-.132-.5-.132-.625-.132v-5.45h.624v5.582zm-.625-.265c.125 0 .25.133.375.133v-5.317h-.375v5.184z"
            fill="#131A2D"
            />
            <path d="M93.563 168.041h.498v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M94.061 168.174h-.624v-6.38h.624v6.38zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M94.438 161.794v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M94.562 168.174h-.249v-6.513h.748v6.513h-.499zm-.125-.133h.374v-6.247h-.249v6.247h-.125z"
            fill="#131A2D"
            />
            <path
            d="M86.328 164.187c0 .399.25.798.624 1.329v-3.455h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M86.952 165.65l-.125-.133c-.374-.399-.5-.798-.624-1.197v-2.392h.749v3.722zm-.624-1.463c0 .399.125.798.499 1.197v-3.19h-.5v1.993z"
            fill="#131A2D"
            />
            <path
            d="M102.42 165.251c.249-.399.374-.798.499-1.064v-2.126h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M102.42 165.517v-3.589h.624v2.259c0 .399-.25.665-.499 1.064l-.125.266zm.125-3.456v3.057c.124-.266.249-.665.374-.931v-1.993h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M88.074 166.58c.125.133.374.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M88.698 166.979c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.532c.125.133.25.133.374.266v-4.652H88.2v4.386z"
            fill="#131A2D"
            />
            <path d="M92.564 168.041h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M93.188 168.174h-.624v-6.247h.624v6.247zm-.499-.266h.375v-6.114h-.375v6.114z"
            fill="#131A2D"
            />
            <path
            d="M89.072 166.978c.125.133.374.133.5.265v-5.183h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M89.571 167.376c-.25-.133-.499-.133-.624-.265v-5.051h.624v5.316zm-.499-.398c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M90.818 167.642c.125 0 .375.133.5.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M91.442 167.908c-.25 0-.374-.133-.624-.133v-5.715h.624v5.848zm-.624-.266c.125 0 .25 0 .375.133v-5.583h-.375v5.45z"
            fill="#131A2D"
            />
            <path
            d="M91.691 167.909c.125 0 .375 0 .5.133v-5.982c-.125 0-.375 0-.5.133v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M92.315 168.041c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .375 0 .5-.133h.124v6.247zm-.499-.266c.125 0 .25 0 .374.133v-5.848c-.124 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M94.561 157.807c-4.865 0-8.358 2.127-8.358 3.988 0 1.86 3.368 3.987 8.358 3.987 4.866 0 8.359-2.127 8.359-3.987 0-1.861-3.369-3.988-8.359-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M94.561 165.915c-4.99 0-8.358-2.127-8.358-4.121 0-1.993 3.493-4.12 8.358-4.12 4.99 0 8.359 2.127 8.359 4.12.124 1.994-3.369 4.121-8.359 4.121zm0-7.975c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988 0-1.994-3.368-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M89.197 164.851c.5.266 1.123.399 1.747.532l6.861-7.311c-.624-.132-1.372-.265-2.12-.265l-6.488 7.044zM93.938 165.915H95.184l5.988-6.38c-.249-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M91.94 165.516c-.124 0-.249 0-.374-.133-.25-.133-.623-.133-.873-.266s-.624-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125 0-.25-.133l-.748-.398c-.499-.266-.998-.665-1.497-1.064.374.532.749 1.064 1.248 1.329.124.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.624-.133-.873-.266h-.374zM96.058 165.516l-1.248.133h-.624c-.25 0-.374 0-.624.133.25 0 .375.133.624.133H96.058c.374 0 .873-.133 1.247-.266l1.123-.399H97.18c-.25.266-.748.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M94.561 158.338c-1.122 0-2.12.133-2.994.266h-5.364v2.127c.125 1.861 3.493 3.854 8.358 3.854 4.866 0 8.234-1.993 8.359-3.854v-2.127h-5.365c-.873-.266-1.87-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M94.561 164.718c-4.74 0-8.108-1.994-8.358-3.855v-2.392h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.365v2.26c-.125 1.993-3.493 3.987-8.359 3.987zm-8.233-3.987c.125 1.86 3.493 3.854 8.233 3.854s8.109-1.994 8.234-3.854v-2.127h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.24v2.127z"
            fill="#131A2D"
            />
            <path
            d="M87.201 162.458c.125.133.374.266.5.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M87.825 162.99c-.25-.266-.5-.399-.624-.532v-3.987h.624v4.519zm-.5-.665c.126.133.25.266.375.266v-3.987h-.374v3.721z"
            fill="#131A2D"
            />
            <path
            d="M97.057 158.471v5.981c.124 0 .374 0 .499-.133v-5.715c-.125-.133-.25-.133-.5-.133z"
            fill="#0EA59D"
            />
            <path
            d="M97.057 164.585v-6.114h.124c.125 0 .25 0 .5.133h.124v5.981c-.374-.133-.499-.133-.748 0zm.124-5.981v5.848c.125 0 .25 0 .375-.133v-5.715h-.375z"
            fill="#131A2D"
            />
            <path d="M96.182 164.585h.499v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M96.182 164.585v-6.38h.624v6.247c-.25.133-.375.133-.624.133zm.124-6.114v6.114h.375v-5.981c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M100.674 163.256c.125-.133.374-.266.499-.266v-4.386h-.499v4.652z"
            fill="#0EA59D"
            />
            <path
            d="M100.674 163.389v-4.918h.624v4.519c-.25.133-.375.266-.624.399zm.125-4.785v4.519c.124-.133.249-.133.374-.266v-4.253h-.374z"
            fill="#131A2D"
            />
            <path d="M95.31 164.585h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M95.186 164.718v-6.513h.624v6.38c-.126.133-.375.133-.624.133zm.124-6.38v6.247h.374v-6.114c0-.133-.124-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M101.547 162.724c.249-.133.374-.266.499-.399v-3.721h-.499v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M101.547 162.857v-4.386h.624v3.854c-.125.133-.375.266-.624.532zm.125-4.253v3.987l.374-.399v-3.588h-.374z"
            fill="#131A2D"
            />
            <path
            d="M98.928 164.053c.124 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M98.803 164.186v-5.583h.624v5.45c-.125 0-.375 0-.624.133zm.124-5.583v5.317c.125 0 .25-.133.375-.133v-5.184h-.375z"
            fill="#131A2D"
            />
            <path
            d="M97.93 164.319c.124 0 .374-.133.499-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M97.93 164.319v-5.848h.623v5.715c-.25.133-.374.133-.623.133zm.124-5.715v5.582c.125 0 .25 0 .375-.133v-5.449h-.375z"
            fill="#131A2D"
            />
            <path
            d="M99.8 163.787c.126-.132.375-.133.5-.265v-4.918h-.5v5.183z"
            fill="#0EA59D"
            />
            <path
            d="M99.676 163.788v-5.317h.624v5.051c-.125.133-.25.133-.624.266zm.124-5.184v5.051c.125 0 .25-.133.375-.133v-4.918h-.374z"
            fill="#131A2D"
            />
            <path
            d="M89.945 163.92c.125 0 .375.133.5.133v-5.45h-.5v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M90.57 164.186c-.25-.133-.5-.133-.625-.133v-5.45h.624v5.583zm-.625-.266c.125 0 .25.133.375.133v-5.317h-.375v5.184z"
            fill="#131A2D"
            />
            <path d="M93.563 164.585h.498v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M94.061 164.718h-.624v-6.38h.624v6.38zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M94.438 158.338v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M94.562 164.718h-.249v-6.513h.623v6.513h-.125-.249zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M86.328 160.73c0 .399.25.798.624 1.329v-3.455h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M86.952 162.192l-.125-.132c-.374-.399-.5-.798-.624-1.197v-2.392h.749v3.721zm-.624-1.462c0 .399.125.798.499 1.197v-3.323h-.5v2.126z"
            fill="#131A2D"
            />
            <path
            d="M102.42 161.794c.249-.399.374-.798.499-1.064v-2.126h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M102.42 162.06v-3.589h.624v2.259c0 .399-.25.665-.499 1.064l-.125.266zm.125-3.456v3.057c.124-.266.249-.665.374-.931v-2.126h-.374z"
            fill="#131A2D"
            />
            <path
            d="M88.074 163.123c.125.133.374.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M88.698 163.522c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.532c.125.133.25.133.374.266v-4.652H88.2v4.386z"
            fill="#131A2D"
            />
            <path d="M92.564 164.585h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M93.188 164.718h-.624v-6.247h.624v6.247zm-.499-.266h.375v-6.114h-.375v6.114z"
            fill="#131A2D"
            />
            <path
            d="M89.072 163.521c.125.133.374.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M89.571 163.92c-.25-.133-.499-.133-.624-.265v-5.051h.624v5.316zm-.499-.398c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M90.818 164.186c.125 0 .375.133.5.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M91.442 164.452c-.25 0-.374-.133-.624-.133v-5.715h.624v5.848zm-.624-.266c.125 0 .25 0 .375.133v-5.715h-.375v5.582z"
            fill="#131A2D"
            />
            <path
            d="M91.691 164.452c.125 0 .375 0 .5.133v-5.981c-.125 0-.375 0-.5.132v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M92.315 164.585c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .375 0 .5-.133h.124v6.247zm-.499-.266c.125 0 .25 0 .374.133v-5.848c-.124 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M94.561 154.351c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.368 3.988 8.358 3.988 4.866 0 8.359-2.127 8.359-3.988 0-1.861-3.369-3.987-8.359-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M94.561 162.458c-4.99 0-8.358-2.127-8.358-4.121 0-1.993 3.493-4.12 8.358-4.12 4.99 0 8.359 2.127 8.359 4.12.124 1.994-3.369 4.121-8.359 4.121zm0-7.975c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988 0-1.994-3.368-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M89.197 161.395c.5.266 1.123.399 1.747.532l6.861-7.311c-.624-.132-1.372-.265-2.12-.265l-6.488 7.044zM93.938 162.458H95.184l5.988-6.38c-.249-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M91.94 162.06c-.124 0-.249 0-.374-.133-.25-.133-.623-.133-.873-.266s-.624-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125 0-.25-.133l-.748-.398c-.499-.266-.998-.665-1.497-1.064.374.532.749 1.064 1.248 1.329.124.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.624-.133-.873-.266h-.374zM96.058 162.06l-1.248.133h-.624c-.25 0-.374 0-.624.133.25 0 .375.133.624.133H96.058c.374 0 .873-.133 1.247-.266l1.123-.399H97.18c-.25.266-.748.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M93.563 153.42c-1.122 0-2.12.133-2.994.266h-5.364v2.126c.125 1.861 3.493 3.855 8.358 3.855 4.866 0 8.234-1.994 8.359-3.855v-2.126h-5.365c-.873-.133-1.87-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M93.563 159.799c-4.74 0-8.108-1.994-8.358-3.854v-2.393h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.365v2.393c-.125 1.86-3.493 3.854-8.359 3.854zm-8.233-3.987c.125 1.861 3.493 3.854 8.233 3.854s8.109-1.993 8.234-3.854v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.24v1.994z"
            fill="#131A2D"
            />
            <path
            d="M86.203 157.54c.125.133.374.266.5.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M86.827 158.072c-.25-.266-.5-.399-.624-.532v-3.987h.624v4.519zm-.5-.532c.126.133.25.266.375.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M96.059 153.553v5.981c.124 0 .374 0 .499-.133v-5.848c-.125.133-.25.133-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M96.059 159.667v-6.114h.124c.125 0 .25 0 .375.133h.124v5.981h-.623zm.124-5.981v5.848c.125 0 .25 0 .375-.133v-5.715h-.375z"
            fill="#131A2D"
            />
            <path d="M95.186 159.667h.498v-6.114h-.498v6.114z" fill="#0EA59D" />
            <path
            d="M95.186 159.8v-6.38h.624v6.247c-.25.133-.375.133-.624.133zm.124-6.247v6.114h.374v-5.981c-.124-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M99.676 158.471c.124-.133.374-.266.499-.266v-4.387h-.5v4.653z"
            fill="#0EA59D"
            />
            <path
            d="M99.55 158.604v-4.918h.625v4.519c-.125.133-.25.133-.624.399zm.25-4.786v4.52c.125-.133.25-.133.375-.266v-4.386H99.8v.132z"
            fill="#131A2D"
            />
            <path d="M94.313 159.8h.498v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M94.188 159.799v-6.513h.624v6.381c-.126.132-.375.132-.624.132zm.124-6.247v6.247h.374v-6.114c0-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M100.549 157.939c.249-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M100.549 158.072v-4.386h.624v3.854c-.125.133-.375.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M97.93 159.135c.124 0 .374-.133.499-.133v-5.316h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M97.805 159.268v-5.582h.623v5.449c-.124 0-.374 0-.623.133zm.124-5.45v5.317c.125 0 .25-.133.375-.133v-5.184h-.375z"
            fill="#131A2D"
            />
            <path
            d="M96.932 159.401c.124 0 .374-.133.499-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M96.932 159.534v-5.848h.623v5.715c-.25 0-.374 0-.623.133zm.124-5.716v5.583c.125 0 .25 0 .375-.133v-5.45h-.375z"
            fill="#131A2D"
            />
            <path
            d="M98.803 158.869c.124-.132.374-.132.499-.265v-4.918h-.5v5.183z"
            fill="#0EA59D"
            />
            <path
            d="M98.678 159.002v-5.316h.624v5.051c-.125 0-.375.132-.624.265zm.124-5.184v5.051c.125 0 .25-.132.375-.132v-4.786h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M88.947 159.002c.125 0 .374.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M89.446 159.268c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.499-.266c.125 0 .25.133.374.133v-5.317h-.374v5.184z"
            fill="#131A2D"
            />
            <path d="M92.441 159.8h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M93.065 159.8h-.624v-6.38h.624v6.38zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M93.44 153.42v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M93.564 159.799h-.249v-6.513h.748v6.513h-.499zm-.125-.133h.375v-6.247h-.375v6.247z"
            fill="#131A2D"
            />
            <path
            d="M85.33 155.812c0 .399.25.798.624 1.329v-3.455h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M85.954 157.275l-.125-.133c-.374-.399-.5-.798-.624-1.197v-2.392h.749v3.722zm-.624-1.463c0 .399.125.798.499 1.197v-3.19h-.5v1.993z"
            fill="#131A2D"
            />
            <path
            d="M101.422 157.009c.249-.398.374-.797.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M101.422 157.142v-3.589h.624v2.392c0 .399-.25.665-.499 1.064l-.125.133zm.125-3.323v3.057c.124-.266.249-.665.374-.931v-1.993h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M87.076 158.205c.125.133.374.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M87.7 158.604c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.399c.126.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M91.566 159.667h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M92.19 159.8h-.624v-6.247h.624v6.247zm-.499-.133h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M88.074 158.736c.125.133.374.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M88.573 159.002c-.25-.133-.499-.133-.624-.265v-5.051h.624v5.316zm-.499-.398c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M89.82 159.268c.125 0 .375.133.5.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M90.444 159.534c-.25 0-.374-.133-.624-.133v-5.715h.624v5.848zm-.624-.266c.125 0 .25 0 .375.133v-5.583h-.375v5.45z"
            fill="#131A2D"
            />
            <path
            d="M90.693 159.534c.125 0 .375 0 .5.133v-5.981c-.125 0-.375 0-.5.132v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M91.317 159.667c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .375 0 .5-.133h.124v6.247zm-.499-.133c.125 0 .25 0 .374.133v-5.848c-.124 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M93.563 149.564c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.368 3.988 8.358 3.988s8.359-2.127 8.359-3.988c0-1.994-3.369-3.988-8.359-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M93.563 157.673c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12 4.866 0 8.359 2.126 8.359 4.12 0 1.861-3.369 4.121-8.359 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988 0-1.861-3.368-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M88.2 156.476c.498.266 1.122.399 1.746.532l6.861-7.311c-.624-.132-1.372-.265-2.12-.265l-6.488 7.044zM92.94 157.54H94.186l5.988-6.38c-.25-.133-.499-.399-.873-.532l-6.363 6.912z"
            fill="#fff"
            />
            <path
            d="M90.943 157.141c-.125 0-.25 0-.375-.133-.25-.133-.623-.133-.873-.266s-.624-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125 0-.25-.133l-.748-.398c-.499-.266-.998-.665-1.497-1.064.374.532.749 1.064 1.248 1.329.124.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.624-.133-.873-.266h-.374zM95.06 157.275l-1.248.133h-.624c-.25 0-.374 0-.624.132.25 0 .375.133.624.133H95.06c.374 0 .873-.133 1.247-.265l1.123-.399h-1.248c-.25.133-.748.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M54.892 179.472c-1.123 0-2.121.133-2.995.266h-5.364v2.127c.125 1.861 3.493 3.988 8.358 3.988 4.866 0 8.234-1.994 8.359-3.988v-2.127h-5.364c-.998-.266-1.997-.266-2.995-.266z"
            fill="#0EA59D"
            />
            <path
            d="M54.891 185.852c-4.865 0-8.233-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.374 2.127-3.742 4.121-8.483 4.121zm-8.358-3.988c.125 1.861 3.493 3.855 8.233 3.855s8.11-1.994 8.234-3.855v-1.994h-5.24c-.997-.133-1.996-.265-2.994-.265-.998 0-1.995.132-2.993.265h-5.365v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M47.406 183.592c.125.133.375.266.5.399v-4.254h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M48.03 184.124c-.25-.266-.499-.399-.624-.532v-3.988h.624v4.52zm-.499-.532l.374.399v-4.121h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M57.387 179.604v5.982c.124 0 .374 0 .499-.133v-5.849c-.25.133-.375 0-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M57.262 185.719v-6.115h.124c.125 0 .25 0 .375.133h.124v5.982c-.124-.133-.374 0-.623 0zm.124-5.982v5.849c.125 0 .25 0 .375-.133v-5.716h-.375z"
            fill="#131A2D"
            />
            <path d="M56.389 185.719h.499v-6.115h-.5v6.115z" fill="#0EA59D" />
            <path
            d="M56.389 185.852v-6.381h.624v6.248c-.25 0-.375.133-.624.133zm.124-6.248v6.115h.375v-5.982c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M60.879 184.522c.125-.132.374-.265.499-.265v-4.52h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M60.879 184.522v-4.918h.624v4.52c-.125.265-.375.265-.624.398zm.125-4.785v4.652c.124-.133.25-.133.374-.265v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M55.514 185.852h.499v-6.248h-.5v6.248z" fill="#0EA59D" />
            <path
            d="M55.514 185.852v-6.513h.624v6.38c-.25.133-.375.133-.624.133zm.124-6.38v6.247h.375v-6.115c-.125-.132-.25-.132-.375-.132z"
            fill="#131A2D"
            />
            <path
            d="M61.877 183.858c.25-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M61.752 183.991v-4.387h.624v3.855c-.125.133-.25.399-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M59.133 185.187c.125 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M59.133 185.32v-5.716h.624v5.45c-.25.133-.375.133-.624.266zm.125-5.583v5.317c.124 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M58.26 185.453c.125 0 .374-.133.499-.133v-5.583h-.5v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M58.135 185.586v-5.849h.623v5.716c-.124 0-.374 0-.623.133zm.125-5.849v5.583c.124 0 .249 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M60.006 184.921c.125-.133.374-.133.499-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M60.006 185.054v-5.317h.624v5.051c-.25 0-.375.133-.624.266zm.125-5.317v5.051c.124 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M50.15 185.054c.125 0 .375.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M50.774 185.32c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.624-.266c.125 0 .25.133.375.133v-5.45h-.375v5.317z"
            fill="#131A2D"
            />
            <path d="M53.768 185.719h.499v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M54.391 185.852h-.623v-6.513h.623v6.513zm-.623-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M54.643 179.471v6.381h.623v-6.381h-.624z" fill="#0EA59D" />
            <path
            d="M54.892 185.852c-.125 0-.125 0 0 0h-.25v-6.513h.874v6.513h-.624zm-.25-.133h.375v-6.247h-.375v6.247z"
            fill="#131A2D"
            />
            <path
            d="M46.533 181.864c0 .399.25.797.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M47.157 183.326l-.125-.133c-.374-.399-.499-.797-.624-1.196v-2.393h.749v3.722zm-.624-1.462c0 .399.125.797.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M62.75 183.06c.25-.399.374-.798.499-1.063v-2.127h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M62.625 183.193v-3.589h.624v2.26c0 .399-.25.665-.5 1.063l-.124.266zm.125-3.456v3.057c.25-.266.25-.664.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M48.28 184.257c.124.133.373.265.498.265v-4.785h-.499v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M48.903 184.655c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.125.133.25.133.374.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M52.895 185.719h.498v-6.248h-.498v6.248z" fill="#0EA59D" />
            <path
            d="M53.393 185.852h-.623v-6.248h.623v6.248zm-.499-.266h.375v-6.115h-.375v6.115z"
            fill="#131A2D"
            />
            <path
            d="M49.277 184.655c.125.133.375.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M49.776 185.054c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M51.023 185.32c.125 0 .375.133.5.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M51.647 185.586c-.25 0-.499-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M51.897 185.586c.124 0 .374 0 .498.133v-6.115c-.124 0-.374 0-.498.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M52.52 185.719c-.25 0-.374-.133-.623-.133v-5.982c.124 0 .374 0 .498-.133h.125v6.248zm-.499-.266c.125 0 .25 0 .374.133v-5.849c-.124 0-.249 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M54.892 175.484c-4.866 0-8.359 2.127-8.359 3.988 0 1.861 3.493 3.987 8.358 3.987 4.866 0 8.359-2.126 8.359-3.987 0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M54.892 183.592c-4.99 0-8.359-2.126-8.359-4.12 0-1.994 3.493-4.121 8.358-4.121 4.866 0 8.359 2.127 8.359 4.121 0 1.994-3.493 4.12-8.358 4.12zm0-7.975c-4.866 0-8.234 2.127-8.234 3.988 0 1.861 3.368 3.987 8.233 3.987 4.866 0 8.234-2.126 8.234-3.987 0-1.994-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M49.402 182.529c.5.266 1.123.399 1.747.664l6.861-7.31c-.624-.133-1.372-.266-2.12-.266l-6.488 6.912zM54.143 183.592H55.39l5.988-6.38c-.25-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M52.145 183.193c-.124 0-.249 0-.498-.133-.25-.133-.624-.133-.874-.266-.25-.132-.623-.132-.873-.265-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125-.133-.25-.133l-.748-.399c-.499-.266-.998-.665-1.497-1.063.375.531.749 1.063 1.248 1.329.124.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.133.25.133l.25.132c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.623-.133-.873-.266h-.25zM56.388 183.193l-1.248.133h-.624c-.25 0-.374 0-.623.133.25 0 .374.133.623.133H56.388c.374 0 .873-.133 1.247-.266l1.123-.399H57.51c-.374.266-.748.266-1.122.266zM61.378 183.593c-1.123 0-2.121.133-2.994.266H53.02v2.126c.124 1.861 3.492 3.988 8.358 3.988 4.865 0 8.233-1.994 8.358-3.988v-2.126h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#fff"
            />
            <path
            d="M61.378 190.106c-4.865 0-8.234-1.994-8.358-3.988v-2.259h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.489v2.392c-.374 1.861-3.743 3.855-8.483 3.855zm-8.358-4.121c.124 1.861 3.492 3.855 8.233 3.855 4.74 0 8.109-1.994 8.234-3.855V183.859h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.24v2.126z"
            fill="#000"
            />
            <path
            d="M53.893 187.714c.124.133.374.266.499.399v-4.254h-.5v3.855z"
            fill="#fff"
            />
            <path
            d="M54.516 188.379c-.374-.266-.499-.399-.623-.532v-3.988h.623v4.52zm-.499-.665c.125.133.25.266.375.266v-3.988h-.375v3.722z"
            fill="#000"
            />
            <path
            d="M63.873 183.86v5.981c.125 0 .374 0 .499-.133v-5.848h-.499z"
            fill="#fff"
            />
            <path
            d="M63.748 189.84v-6.247h.125c.125 0 .25 0 .499.133h.124v5.981h-.124c-.125.133-.374.133-.624.133zm.125-5.981v5.848c.125 0 .25 0 .374-.133v-5.715c-.125.133-.25 0-.374 0z"
            fill="#000"
            />
            <path d="M63 189.974h.499v-6.115H63v6.115z" fill="#fff" />
            <path
            d="M62.875 189.973v-6.38h.748v6.247H63.5c-.25.133-.375.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.125 0-.25-.133-.374-.133z"
            fill="#000"
            />
            <path
            d="M67.49 188.645c.125-.133.375-.266.5-.266v-4.52h-.5v4.786z"
            fill="#fff"
            />
            <path
            d="M67.365 188.777v-4.918h.624v4.52c-.125.133-.374.266-.624.398zm.125-4.785v4.52c.125-.133.25-.133.374-.266v-4.387h-.374v.133z"
            fill="#000"
            />
            <path d="M62.002 189.974h.499v-6.248h-.499v6.248z" fill="#fff" />
            <path
            d="M62.002 190.106v-6.513h.749v6.513h-.749zm.125-6.38v6.247h.374v-6.114c-.125-.133-.25-.133-.374-.133z"
            fill="#000"
            />
            <path
            d="M68.363 188.113c.25-.133.374-.266.5-.399v-3.855h-.5v4.254z"
            fill="#fff"
            />
            <path
            d="M68.238 188.246v-4.387h.624v3.855c-.125.133-.25.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#000"
            />
            <path
            d="M65.62 189.442c.124 0 .373-.133.498-.133v-5.317h-.499v5.45z"
            fill="#fff"
            />
            <path
            d="M65.62 189.442v-5.583h.623v5.45c-.25 0-.374.133-.624.133zm.124-5.45v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#000"
            />
            <path
            d="M64.746 189.575c.125 0 .374-.133.5-.133v-5.583h-.5v5.716z"
            fill="#fff"
            />
            <path
            d="M64.621 189.708v-5.849h.624v5.716c-.125 0-.25.133-.624.133zm.25-5.716v5.583c.124 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#000"
            />
            <path
            d="M66.492 189.043c.125-.133.374-.133.5-.266v-4.918h-.5v5.184z"
            fill="#fff"
            />
            <path
            d="M66.492 189.176v-5.317h.624v5.051c-.125.133-.374.133-.624.266zm.125-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#000"
            />
            <path
            d="M56.637 189.309c.124 0 .374.133.499.133v-5.583h-.5v5.45z"
            fill="#fff"
            />
            <path
            d="M57.26 189.575c-.249-.133-.498-.133-.623-.133v-5.583h.623v5.716zm-.498-.399c.124 0 .249.133.374.133v-5.317h-.375v5.184z"
            fill="#000"
            />
            <path d="M60.254 189.973h.499v-6.38h-.5v6.38z" fill="#fff" />
            <path
            d="M60.877 190.106h-.748v-6.513h.748v6.513zm-.623-.266h.374v-6.247h-.374v6.247z"
            fill="#000"
            />
            <path d="M61.129 183.593v6.38h.624v-6.38h-.625z" fill="#fff" />
            <path
            d="M61.378 190.106h-.249v-6.513h.748v6.513h-.499zm-.124-.133h.374v-6.247h-.375v6.247z"
            fill="#000"
            />
            <path
            d="M53.02 186.119c0 .399.249.93.623 1.329v-3.589h-.623v2.26z"
            fill="#fff"
            />
            <path
            d="M53.643 187.581l-.125-.133c-.374-.399-.499-.797-.623-1.196v-2.393h.748v3.722zm-.624-1.595c0 .399.125.798.375 1.196v-3.19h-.375v1.994z"
            fill="#000"
            />
            <path
            d="M69.236 187.182c.25-.398.375-.797.5-1.063v-2.26h-.5v3.323z"
            fill="#fff"
            />
            <path
            d="M69.111 187.448v-3.589h.624v2.393c0 .399-.25.665-.499 1.063l-.125.133zm.25-3.456v2.925c.125-.266.25-.532.25-.798v-2.127h-.25z"
            fill="#000"
            />
            <path
            d="M54.89 188.379c.125.133.375.266.5.266v-4.786h-.5v4.52z"
            fill="#fff"
            />
            <path
            d="M55.39 188.91c-.25-.133-.5-.265-.624-.398v-4.653h.623v5.051zm-.5-.531c.125.133.25.133.375.266v-4.653h-.375v4.387z"
            fill="#000"
            />
            <path d="M59.38 189.84h.5v-6.247h-.5v6.247z" fill="#fff" />
            <path
            d="M60.004 189.974h-.748v-6.248h.748v6.248zm-.623-.133h.374v-6.115h-.374v6.115z"
            fill="#000"
            />
            <path
            d="M55.764 188.91c.124.133.374.133.499.266v-5.317h-.5v5.051z"
            fill="#fff"
            />
            <path
            d="M56.387 189.176c-.25-.133-.499-.133-.623-.266v-5.051h.623v5.317zm-.623-.266c.124 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#000"
            />
            <path
            d="M57.51 189.575c.125 0 .374.133.499.133v-5.849h-.5v5.716z"
            fill="#fff"
            />
            <path
            d="M58.133 189.708c-.249 0-.498-.133-.623-.133v-5.716h.623v5.849zm-.498-.266c.124 0 .249 0 .374.133v-5.583h-.374v5.45z"
            fill="#000"
            />
            <path
            d="M58.383 189.708c.125 0 .374 0 .499.133v-6.115c-.125 0-.374 0-.5.133v5.849z"
            fill="#fff"
            />
            <path
            d="M59.006 189.974c-.25 0-.499-.133-.623-.133h-.125v-5.982h.125c.124 0 .374 0 .499-.132h.124v6.247zm-.499-.266h.375v-5.849h-.375v5.849z"
            fill="#000"
            />
            <path
            d="M61.378 179.605c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.492 3.988 8.358 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.493-3.988-8.358-3.988z"
            fill="#fff"
            />
            <path
            d="M61.377 187.847c-4.99 0-8.483-2.127-8.483-4.121 0-1.994 3.494-4.121 8.483-4.121 4.99 0 8.483 2.127 8.483 4.121 0 1.994-3.492 4.121-8.483 4.121zm0-8.109c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988 0-1.861-3.368-3.988-8.234-3.988z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M55.889 186.783c.499.266 1.122.399 1.746.665l6.861-7.311c-.623-.133-1.372-.266-2.12-.266l-6.487 6.912z"
            fill="#9CD6CB"
            />
            <path
            opacity={0.3}
            d="M60.629 187.714H61.876l5.988-6.381c-.25-.132-.499-.398-.873-.531l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M87.825 179.073c-1.123 0-2.12.133-2.994.266h-5.364v2.127c.124 1.861 3.493 3.988 8.358 3.988s8.233-1.994 8.358-3.988v-2.127H90.82c-.873-.266-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M87.825 185.454c-4.865 0-8.234-1.994-8.358-3.988v-2.393h5.489c.998-.132 1.996-.265 2.994-.265.998 0 1.996.133 2.994.265h5.364v2.26c-.25 2.127-3.618 4.121-8.483 4.121zm-8.234-3.988c.125 1.861 3.494 3.855 8.234 3.855s8.109-1.994 8.233-3.855v-1.994H90.82c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.994h.124z"
            fill="#131A2D"
            />
            <path
            d="M80.465 183.195c.125.132.374.265.499.398v-4.253h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M80.964 183.726c-.25-.266-.5-.398-.624-.531v-3.988h.624v4.519zm-.5-.531l.375.398v-4.12h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M90.32 179.207v5.981c.125 0 .375 0 .5-.132v-5.849c-.125.133-.375 0-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M90.32 185.321v-6.114h.125c.125 0 .25 0 .374.133h.125v5.981c-.25-.133-.374 0-.624 0zm.125-5.981v5.848c.125 0 .25 0 .374-.132v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M89.447 185.321h.5v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M89.322 185.454v-6.38h.624v6.247c-.125 0-.374.133-.624.133zm.125-6.247v6.114h.374v-5.981c0-.133-.124-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M93.938 184.125c.124-.133.374-.266.498-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M93.813 184.125v-4.918h.748v4.519c-.25.266-.374.266-.749.399zm.249-4.785v4.652c.125-.133.25-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M88.574 185.454h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M88.45 185.454v-6.514h.623v6.381c-.125.133-.374.133-.624.133zm.124-6.381v6.248h.374v-6.115c-.124-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M94.81 183.46c.25-.133.375-.265.5-.398v-3.722h-.5v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M94.81 183.593v-4.386h.624v3.855c-.124.133-.374.398-.623.531zm.125-4.253v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M92.191 184.79c.125 0 .375-.133.5-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M92.066 184.923v-5.716h.624v5.45c-.125.133-.374.133-.624.266zm.125-5.583v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M91.193 185.054c.125 0 .375-.132.5-.132v-5.583h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M91.193 185.187v-5.848h.624v5.715c-.25 0-.374 0-.624.133zm.125-5.848v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M93.064 184.523c.125-.133.375-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M92.94 184.656v-5.317h.623v5.051c-.124 0-.374.133-.624.266zm.124-5.317v5.051c.125 0 .25-.133.375-.133v-4.785h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M83.084 184.657c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M83.708 184.923c-.25-.133-.5-.133-.624-.133v-5.45h.624v5.583zm-.5-.266c.126 0 .25.133.375.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M86.701 185.453h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M87.325 185.454H86.7v-6.514h.624v6.514zm-.5-.133h.375v-6.248h-.374v6.248z"
            fill="#131A2D"
            />
            <path d="M87.576 179.073v6.38h.624v-6.38h-.374-.25z" fill="#0EA59D" />
            <path
            d="M87.826 185.454c-.125 0 0 0 0 0h-.25v-6.514h.874v6.514h-.625zm-.125-.133h.374v-6.248h-.499v6.248h.125z"
            fill="#131A2D"
            />
            <path
            d="M79.467 181.467c0 .398.25.797.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M80.09 182.929l-.124-.133c-.375-.399-.5-.798-.624-1.196v-2.393h.748v3.722zm-.499-1.462c0 .398.125.797.5 1.196v-3.19h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M95.684 182.664c.25-.399.374-.798.499-1.064v-2.126h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M95.684 182.796v-3.589h.623v2.26c0 .398-.25.664-.499 1.063l-.124.266zm.124-3.456v3.057c.25-.266.25-.664.375-.93v-1.994h-.375v-.133z"
            fill="#131A2D"
            />
            <path
            d="M81.338 183.859c.125.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M81.962 184.258c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.624-.399c.125.133.25.133.374.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M85.828 185.321h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M86.452 185.454h-.624v-6.247h.624v6.247zm-.5-.265h.375v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M82.21 184.392c.126.133.375.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M82.835 184.657c-.25-.133-.5-.133-.624-.266v-5.184h.624v5.45zm-.5-.399c.125 0 .25.133.375.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M84.082 184.921c.125 0 .374.133.499.133v-5.715h-.499v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M84.58 185.187c-.249 0-.373-.133-.623-.133v-5.715h.624v5.848zm-.498-.265c.125 0 .25 0 .374.132v-5.582h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M84.955 185.188c.125 0 .374 0 .5.133v-6.114c-.126 0-.375 0-.5.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M85.579 185.321c-.25 0-.374-.132-.624-.132v-5.982c.125 0 .374 0 .5-.133h.124v6.247zm-.624-.265c.125 0 .25 0 .374.133v-5.849c-.124 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M87.825 175.087c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.987 8.358 3.987s8.358-2.126 8.358-3.987c0-1.861-3.368-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M87.825 183.194c-4.99 0-8.358-2.126-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121s8.358 2.127 8.358 4.121c0 1.994-3.368 4.12-8.358 4.12zm0-7.975c-4.865 0-8.234 2.127-8.234 3.988 0 1.861 3.369 3.987 8.234 3.987s8.233-2.126 8.233-3.987c0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M82.336 182.132c.499.265 1.123.398 1.746.664l6.862-7.31c-.624-.133-1.373-.266-2.121-.266l-6.487 6.912zM87.201 183.194h1.248l5.988-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M85.204 182.796c-.125 0-.25 0-.499-.133-.25-.133-.624-.133-.873-.266-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.25-.132c-.124 0-.124-.133-.249-.133l-.748-.399c-.5-.266-.998-.665-1.497-1.063.374.531.748 1.063 1.247 1.329.125.133.25.133.375.266.124.132.25.132.374.265.125 0 .125.133.25.133l.249.133c.125 0 .25.133.374.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM89.321 182.796l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.399h-1.247c-.374.266-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M88.448 176.016c-1.123 0-2.12.133-2.994.265H80.09v2.127c.125 1.861 3.493 3.988 8.358 3.988s8.234-1.994 8.358-3.988v-2.127h-5.364c-.998-.132-1.996-.265-2.994-.265z"
            fill="#0EA59D"
            />
            <path
            d="M88.448 182.529c-4.865 0-8.234-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.374 1.994-3.743 4.121-8.483 4.121zm-8.358-4.121c.124 1.861 3.493 3.855 8.233 3.855s8.109-1.994 8.234-3.855v-1.994h-5.24c-.998-.132-1.996-.265-2.994-.265-.998 0-1.996.133-2.994.265h-5.364v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M80.963 180.137c.125.133.374.266.499.399v-4.254h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M81.587 180.669c-.25-.266-.5-.399-.624-.532v-3.988h.624v4.52zm-.5-.532c.125.133.25.266.375.266v-4.121h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M90.943 176.149v5.982c.125 0 .375 0 .5-.133v-5.849c-.25.133-.375.133-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M90.818 182.264v-6.115h.125c.125 0 .25 0 .374.133h.125v5.982h-.624zm.125-5.982v5.849c.125 0 .25 0 .374-.133v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M89.945 182.264h.5v-6.115h-.5v6.115z" fill="#0EA59D" />
            <path
            d="M89.945 182.396v-6.38h.625v6.247c-.25.133-.375.133-.625.133zm.125-6.247v6.114h.374v-5.982c-.124-.132-.25-.132-.374-.132z"
            fill="#131A2D"
            />
            <path
            d="M94.563 181.066c.249-.133.374-.265.498-.265v-4.52h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M94.438 181.199v-4.918h.623v4.52c-.125.132-.374.265-.624.398zm.124-4.785v4.652c.125-.133.25-.133.374-.265v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M89.072 182.397h.5v-6.248h-.5v6.248z" fill="#0EA59D" />
            <path
            d="M89.072 182.529v-6.513h.624v6.38c-.25 0-.374 0-.624.133zm.125-6.38v6.247h.374v-6.115c-.124-.132-.25-.132-.374-.132z"
            fill="#131A2D"
            />
            <path
            d="M95.434 180.535c.25-.133.374-.266.499-.399v-3.722h-.5v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M95.309 180.668v-4.387h.623v3.855c-.124.133-.25.266-.623.532zm.124-4.254v3.988l.375-.399v-3.589h-.375z"
            fill="#131A2D"
            />
            <path
            d="M92.69 181.865c.124 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M92.69 181.865v-5.716h.623v5.45c-.25.133-.374.266-.624.266zm.124-5.45v5.317c.125 0 .25-.133.375-.133v-5.184h-.375z"
            fill="#131A2D"
            />
            <path
            d="M91.816 181.997c.125 0 .375-.133.5-.133v-5.583h-.5v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M91.691 182.13v-5.849h.624v5.716c-.125 0-.374.133-.624.133zm.125-5.716v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M93.563 181.465c.124-.133.374-.133.498-.266v-4.918h-.499v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M93.563 181.598v-5.317h.623v5.051c-.25 0-.374.133-.624.266zm.124-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M83.707 181.731c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M84.33 181.864c-.249-.133-.498-.133-.623-.133v-5.45h.624v5.583zm-.623-.266c.125 0 .25.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M87.326 182.396h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M87.95 182.529h-.624v-6.513h.624v6.513zm-.624-.266h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M88.2 176.016v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M88.449 182.529c-.125 0-.125 0 0 0h-.25v-6.646h.874v6.513h-.125c-.374.133-.374.133-.5.133zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M80.09 178.541c0 .399.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M80.713 180.003l-.124-.133c-.375-.398-.5-.797-.624-1.196v-2.393h.748v3.722zm-.623-1.595c0 .399.124.798.499 1.197v-3.191h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M96.307 179.605c.25-.399.374-.797.499-1.063v-2.127h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M96.182 179.738v-3.589h.623v2.26c0 .399-.25.665-.499 1.063l-.124.266zm.25-3.323v3.057c.249-.265.249-.664.373-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M81.96 180.802c.126.132.375.265.5.265v-4.785h-.5v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M82.46 181.2c-.25-.133-.5-.265-.624-.398v-4.653h.624v5.051zm-.5-.398c.125.133.25.133.375.265v-4.652h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M86.453 182.263h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M86.952 182.397h-.624v-6.248h.624v6.248zm-.5-.133h.375v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M82.836 181.333c.125.133.374.133.499.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M83.335 181.599c-.25-.133-.5-.133-.624-.266v-5.184h.624v5.45zm-.5-.399c.125 0 .25.133.375.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M84.582 181.997c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M85.206 182.13c-.25 0-.374-.133-.624-.133v-5.716h.624v5.849zm-.5-.266c.126 0 .25.133.375.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M85.453 182.131c.125 0 .374 0 .5.133v-6.115c-.126 0-.375 0-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M86.077 182.263c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .374 0 .5-.133h.124v6.247zm-.5-.133c.126 0 .25 0 .375.133v-5.849c-.125 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M88.448 172.028c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M88.448 180.269c-4.99 0-8.358-2.126-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121 4.99 0 8.358 2.127 8.358 4.121 0 1.994-3.493 4.12-8.358 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.987 8.233 3.987s8.234-2.126 8.234-3.987c0-1.861-3.369-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M82.959 179.073c.499.266 1.123.399 1.746.664l6.862-7.31c-.624-.133-1.372-.266-2.121-.266l-6.487 6.912zM87.7 180.136H88.946l5.988-6.38c-.25-.133-.5-.398-.874-.531l-6.362 6.911z"
            fill="#fff"
            />
            <path
            d="M85.704 179.737c-.125 0-.25 0-.499-.133-.25-.132-.624-.132-.873-.265-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.399c-.5-.266-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.375.266.124.133.25.133.374.266.125 0 .125.133.25.133l.249.133c.125 0 .25.133.374.133l.5.132c.124 0 .249.133.498.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM89.946 179.87l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.399H91.07c-.374.133-.749.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M87.202 172.959c-1.123 0-2.12.133-2.994.266h-5.364v2.127c.125 1.86 3.493 3.854 8.358 3.854s8.234-1.994 8.358-3.854v-2.127h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M87.202 179.339c-4.74 0-8.109-1.994-8.358-3.854v-2.393h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.25 1.993-3.618 3.987-8.358 3.987zm-8.233-3.987c.124 1.861 3.493 3.854 8.233 3.854s8.109-1.993 8.234-3.854v-2.127h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.24v2.127z"
            fill="#131A2D"
            />
            <path
            d="M79.842 177.079c.124.133.374.266.499.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M80.34 177.611c-.249-.266-.499-.399-.623-.532v-3.987h.624v4.519zm-.499-.532c.125.133.25.266.375.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M89.697 173.092v5.981c.125 0 .374 0 .5-.132v-5.716c-.25 0-.375 0-.5-.133z"
            fill="#0EA59D"
            />
            <path
            d="M89.572 179.206v-6.114h.125c.125 0 .25 0 .374.133h.125v5.981c-.125-.133-.374 0-.624 0zm.125-5.981v5.848c.125 0 .25 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M88.7 179.206h.498v-6.114H88.7v6.114z" fill="#0EA59D" />
            <path
            d="M88.7 179.339v-6.38h.623v6.247c-.25 0-.374.133-.624.133zm.124-6.247v6.114h.374v-5.981c-.124-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M93.19 178.01c.124-.133.374-.266.499-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M93.19 178.143v-4.918h.623v4.519c-.124.133-.374.133-.624.399zm.124-4.918v4.519c.125-.133.25-.133.375-.266v-4.253h-.375z"
            fill="#131A2D"
            />
            <path d="M87.826 179.339h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M87.826 179.339v-6.513h.624v6.38c-.25.133-.374.133-.624.133zm.125-6.247v6.247h.374v-6.114c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M94.188 177.345c.249-.133.374-.266.498-.399v-3.721h-.499v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M94.063 177.478v-4.386h.623v3.854c-.125.133-.25.399-.624.532zm.124-4.253v3.987l.374-.398v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M91.443 178.674c.125 0 .375-.133.5-.133v-5.316h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M91.443 178.807v-5.582h.624v5.449c-.25 0-.374 0-.624.133zm.125-5.582v5.316c.125 0 .25-.132.374-.132v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M90.57 178.94c.125 0 .375-.133.5-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M90.445 179.073v-5.848h.624v5.715c-.125 0-.374 0-.624.133zm.125-5.848v5.582c.125 0 .25 0 .374-.133v-5.449h-.374z"
            fill="#131A2D"
            />
            <path
            d="M92.316 178.409c.125-.133.375-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M92.316 178.541v-5.316h.624v5.051c-.25 0-.374.133-.624.265zm.125-5.316v5.051c.125 0 .25-.133.374-.133v-4.918h-.374z"
            fill="#131A2D"
            />
            <path
            d="M82.46 178.541c.126 0 .375.133.5.133v-5.449h-.5v5.316z"
            fill="#0EA59D"
            />
            <path
            d="M83.085 178.807c-.25-.133-.5-.133-.624-.133v-5.449h.624v5.582zm-.5-.266c.125 0 .25.133.375.133v-5.316h-.374v5.183z"
            fill="#131A2D"
            />
            <path d="M86.078 179.206h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M86.702 179.339h-.624v-6.38h.624v6.38zm-.624-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M86.953 172.959v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M87.203 179.339c-.125 0-.125 0 0 0h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M78.844 175.351c0 .399.25.798.624 1.33v-3.456h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M79.467 176.814l-.124-.133c-.375-.399-.5-.798-.624-1.197v-2.392h.748v3.722zm-.499-1.463c0 .399.125.798.5 1.197v-3.323h-.5v2.126z"
            fill="#131A2D"
            />
            <path
            d="M95.06 176.548c.25-.399.375-.798.5-1.064v-2.259h-.5v3.323z"
            fill="#0EA59D"
            />
            <path
            d="M94.936 176.681v-3.589h.623v2.259c0 .399-.25.665-.499 1.064l-.124.266zm.124-3.456v3.057c.125-.266.25-.665.374-.931v-2.126h-.374z"
            fill="#131A2D"
            />
            <path
            d="M80.715 177.744c.125.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M81.339 178.143c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.624-.399c.125.133.25.133.374.266v-4.785h-.374v4.519z"
            fill="#131A2D"
            />
            <path d="M85.207 179.206h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M85.706 179.339h-.624v-6.247h.624v6.247zm-.5-.266h.375v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M81.588 178.276c.125.133.374.133.499.266v-5.317h-.5v5.051z"
            fill="#0EA59D"
            />
            <path
            d="M82.212 178.542c-.25-.133-.5-.133-.624-.266v-5.051h.624v5.317zm-.5-.399c.125 0 .25.133.375.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M83.336 178.807c.125 0 .374.133.499.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M83.96 179.073c-.25 0-.375-.133-.624-.133v-5.715h.624v5.848zm-.5-.266c.125 0 .25.133.375.133v-5.715h-.374v5.582z"
            fill="#131A2D"
            />
            <path
            d="M84.332 179.073c.125 0 .374 0 .499.133v-5.981c-.125 0-.374 0-.499.133v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M84.83 179.206c-.249 0-.373-.133-.623-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.498-.266c.125 0 .25 0 .374.133v-5.848c-.125 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M87.202 168.972c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.368 3.988 8.358 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.493-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M87.202 177.213c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12s8.358 2.126 8.358 4.12c0 1.861-3.493 4.121-8.358 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.861-3.369-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M81.713 176.016c.499.266 1.123.399 1.746.532l6.862-7.31c-.624-.133-1.373-.266-2.121-.266l-6.487 7.044zM86.453 177.08h1.248l5.988-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M84.458 176.681c-.124 0-.25 0-.374-.133-.25-.133-.624-.133-.873-.266-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.25-.133c-.124 0-.124 0-.249-.133l-.748-.398c-.5-.266-.998-.665-1.497-1.064.374.532.748 1.064 1.247 1.329.125.133.25.133.375.266.124.133.249.133.374.266.124 0 .124.133.25.133l.249.133c.124 0 .25.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .873.133h.874c-.25-.133-.624-.133-.874-.266h-.374zM88.7 176.815l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.132.624.132H88.7c.374 0 .873-.132 1.248-.265l1.122-.399h-1.247c-.374.133-.749.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M88.323 169.502c-1.123 0-2.12.133-2.994.266h-5.364v2.127c.125 1.86 3.493 3.854 8.358 3.854s8.234-1.994 8.358-3.854v-2.127h-5.364c-.873-.266-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M88.323 175.882c-4.74 0-8.109-1.994-8.358-3.854v-2.393h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.124 1.993-3.493 3.987-8.358 3.987zm-8.233-3.987c.124 1.861 3.493 3.854 8.233 3.854s8.109-1.993 8.234-3.854v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.24v1.994z"
            fill="#131A2D"
            />
            <path
            d="M80.963 173.624c.125.133.374.266.499.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M81.587 174.155c-.25-.266-.5-.399-.624-.532v-3.987h.624v4.519zm-.5-.532c.125.133.25.266.375.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M90.818 169.636v5.981c.125 0 .375 0 .5-.133v-5.848c-.125.133-.25 0-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M90.818 175.75v-6.114h.125c.125 0 .25 0 .5.133h.124v5.981c-.374-.133-.5-.133-.749 0zm.125-5.981v5.848c.125 0 .25 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M89.945 175.749h.5v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M89.945 175.882v-6.38h.625v6.247c-.25 0-.375 0-.625.133zm.125-6.247v6.114h.374v-5.981c-.124-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M94.438 174.555c.124-.133.374-.266.498-.266v-4.387h-.499v4.653z"
            fill="#0EA59D"
            />
            <path
            d="M94.438 174.554v-4.918h.623v4.519c-.25.133-.374.266-.624.399zm.124-4.785v4.519c.125-.133.25-.133.374-.266v-4.386h-.374v.133z"
            fill="#131A2D"
            />
            <path d="M89.072 175.883h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M88.947 175.882v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c0-.133-.124-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M95.309 173.89c.25-.133.374-.266.499-.399v-3.721h-.5v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M95.309 174.022v-4.386h.623v3.854c-.124.133-.374.399-.623.532zm.124-4.253v3.987l.375-.398v-3.589h-.375z"
            fill="#131A2D"
            />
            <path
            d="M92.69 175.217c.124 0 .374-.133.499-.133v-5.316h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M92.564 175.35v-5.582h.624v5.449c-.124 0-.374 0-.624.133zm.125-5.582v5.316c.125 0 .25-.133.375-.133v-5.183h-.375z"
            fill="#131A2D"
            />
            <path
            d="M91.691 175.483c.125 0 .375-.133.5-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M91.691 175.616v-5.848h.624v5.715c-.25 0-.374 0-.624.133zm.125-5.848v5.582c.125 0 .25 0 .374-.133v-5.449h-.374z"
            fill="#131A2D"
            />
            <path
            d="M93.563 174.953c.124-.132.374-.132.498-.265v-4.918h-.499v5.183z"
            fill="#0EA59D"
            />
            <path
            d="M93.438 174.953v-5.317h.623v5.051c-.125.133-.25.266-.624.266zm.124-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M83.707 175.085c.125 0 .374.133.499.133v-5.582h-.499v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M84.33 175.352c-.249-.133-.498-.133-.623-.133v-5.449h.624v5.582zm-.623-.266c.125 0 .25.133.374.133v-5.317h-.374v5.184z"
            fill="#131A2D"
            />
            <path d="M87.326 175.75h.5v-6.381h-.5v6.381z" fill="#0EA59D" />
            <path
            d="M87.825 175.882H87.2v-6.38h.624v6.38zm-.5-.133h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M88.2 169.502v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M88.324 175.882h-.25v-6.513h.624v6.513h-.125-.25zm-.125-.133h.375v-6.247h-.375v6.247z"
            fill="#131A2D"
            />
            <path
            d="M80.09 171.896c0 .399.25.798.624 1.329v-3.455h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M80.713 173.358l-.124-.133c-.375-.399-.5-.798-.624-1.197v-2.392h.748v3.722zm-.623-1.463c0 .399.124.798.499 1.197v-3.19h-.5v1.993z"
            fill="#131A2D"
            />
            <path
            d="M96.182 173.092c.25-.398.374-.797.499-1.063v-2.127h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M96.182 173.225v-3.589h.623v2.259c0 .399-.25.665-.499 1.064l-.124.266zm.124-3.456v3.057c.125-.266.25-.665.25-.931v-1.993h-.25v-.133z"
            fill="#131A2D"
            />
            <path
            d="M81.836 174.289c.125.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M82.46 174.687c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.399c.125.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M86.328 175.749h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M86.952 175.882h-.624v-6.247h.624v6.247zm-.5-.266h.375v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M82.836 174.686c.125.133.374.133.499.265v-5.183h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M83.335 175.084c-.25-.133-.5-.133-.624-.265v-5.051h.624v5.316zm-.5-.398c.125 0 .25.133.375.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M84.582 175.35c.125 0 .374.133.499.133v-5.715h-.499v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M85.206 175.616c-.25 0-.374-.133-.624-.133v-5.715h.624v5.848zm-.624-.266c.125 0 .25.133.374.133V169.9h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M85.453 175.617c.125 0 .374 0 .5.133v-5.982c-.126 0-.375 0-.5.133v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M86.077 175.749c-.25 0-.374 0-.624-.133v-5.981c.125 0 .374 0 .5-.133h.124v6.247zm-.5-.266c.126 0 .25 0 .375.133v-5.848c-.125 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M88.323 165.515c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.368 3.988 8.358 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.368-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M88.323 173.623c-4.99 0-8.358-2.127-8.358-4.121 0-1.993 3.493-4.12 8.358-4.12 4.99 0 8.358 2.127 8.358 4.12 0 1.994-3.368 4.121-8.358 4.121zm0-7.975c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.994-3.369-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M82.959 172.559c.499.266 1.123.399 1.746.532l6.862-7.311c-.624-.132-1.372-.265-2.121-.265l-6.487 7.044zM87.7 173.623H88.946l5.988-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M85.704 173.224c-.124 0-.25 0-.374-.133-.25-.133-.624-.133-.873-.266-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.398c-.5-.266-.998-.665-1.497-1.064.374.532.748 1.064 1.247 1.329.125.133.25.133.375.266.124.133.25.133.374.266.125 0 .125.133.25.133l.249.133c.125 0 .25.133.374.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.375zM89.821 173.224l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.399h-1.247c-.25.266-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M87.327 164.584c-1.123 0-2.12.133-2.994.266h-5.364v2.127c.125 1.86 3.493 3.854 8.358 3.854s8.234-1.994 8.358-3.854v-2.127h-5.364c-.873-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M87.327 171.097c-4.74 0-8.109-1.994-8.358-3.855v-2.392h5.364c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.124 1.861-3.493 3.988-8.358 3.988zm-8.233-4.12c.124 1.86 3.493 3.854 8.233 3.854s8.109-1.994 8.234-3.854v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.24v1.994z"
            fill="#131A2D"
            />
            <path
            d="M79.967 168.704c.124.133.374.266.499.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M80.59 169.236c-.249-.266-.499-.399-.623-.532v-3.987h.624v4.519zm-.499-.532c.125.133.25.266.375.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M89.822 164.85v5.981c.125 0 .374 0 .5-.133v-5.848h-.5z"
            fill="#0EA59D"
            />
            <path
            d="M89.822 170.831v-6.114h.125c.125 0 .25 0 .374.133h.125v5.981h-.624zm.125-5.981v5.848c.125 0 .25 0 .374-.133v-5.715c-.124.133-.25 0-.374 0z"
            fill="#131A2D"
            />
            <path d="M88.95 170.831h.498v-6.114h-.499v6.114z" fill="#0EA59D" />
            <path
            d="M88.95 170.964v-6.38h.623v6.247c-.25.133-.374.133-.624.133zm.124-6.247v6.114h.374v-5.981c-.124 0-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M93.44 169.635c.124-.133.374-.266.499-.266v-4.387h-.5v4.653z"
            fill="#0EA59D"
            />
            <path
            d="M93.314 169.768v-4.918h.624v4.519c-.124.133-.25.266-.624.399zm.25-4.785v4.519c.125-.133.25-.133.374-.266v-4.386h-.374v.133z"
            fill="#131A2D"
            />
            <path d="M88.076 170.964h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M87.951 170.964v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.247v6.247h.374v-6.114c0-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M94.313 169.103c.249-.133.374-.266.498-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M94.313 169.236v-4.386h.623v3.854c-.125.133-.374.266-.624.532zm.124-4.253v3.987l.374-.399v-3.588h-.374z"
            fill="#131A2D"
            />
            <path
            d="M91.693 170.432c.125 0 .375-.133.5-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M91.568 170.432v-5.582h.624v5.449c-.125 0-.374.133-.624.133zm.125-5.449v5.316c.125 0 .25-.133.374-.133v-5.183h-.374z"
            fill="#131A2D"
            />
            <path
            d="M90.695 170.565c.125 0 .375-.133.5-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M90.695 170.698v-5.848h.624v5.715c-.25 0-.374.133-.624.133zm.125-5.715v5.582c.125 0 .25 0 .374-.133v-5.449h-.374z"
            fill="#131A2D"
            />
            <path
            d="M92.566 170.034c.125-.133.375-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M92.441 170.166v-5.316h.624v5.051c-.125 0-.374.133-.624.265zm.125-5.183v5.051c.125 0 .25-.133.374-.133v-4.786h-.374v-.132z"
            fill="#131A2D"
            />
            <path
            d="M82.71 170.299c.126 0 .375.133.5.133v-5.582h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M83.335 170.432c-.25-.133-.5-.133-.624-.133v-5.449h.624v5.582zm-.624-.266c.125 0 .25.133.374.133v-5.316h-.374v5.183z"
            fill="#131A2D"
            />
            <path d="M86.33 170.964h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M86.829 171.097h-.624v-6.38h.624v6.38zm-.5-.266h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M87.203 164.584v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M87.328 171.097h-.25v-6.513h.873v6.513h-.624zm-.125-.133h.374v-6.247h-.375v6.247z"
            fill="#131A2D"
            />
            <path
            d="M79.094 167.109c0 .399.25.798.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M79.717 168.571l-.124-.133c-.375-.398-.5-.797-.624-1.196v-2.392h.748v3.721zm-.623-1.595c0 .399.124.798.499 1.197v-3.19h-.5v1.993z"
            fill="#131A2D"
            />
            <path
            d="M95.186 168.173c.249-.399.374-.798.498-1.064v-2.127h-.498v3.191z"
            fill="#0EA59D"
            />
            <path
            d="M95.186 168.306v-3.589h.623v2.259c0 .399-.25.665-.499 1.064l-.124.266zm.124-3.323v3.057c.125-.266.25-.665.374-.931v-1.993h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M80.84 169.369c.125.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M81.464 169.768c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.399c.125.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M85.332 170.831h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M85.956 170.964h-.624v-6.247h.624v6.247zm-.5-.133h.375v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M81.838 169.9c.125.133.374.133.499.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M82.337 170.166c-.25-.132-.5-.132-.624-.265v-5.051h.624v5.316zm-.5-.398c.125 0 .25.133.375.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M83.584 170.565c.125 0 .374.133.499.133v-5.716h-.499v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M84.208 170.698c-.25 0-.374-.133-.624-.133v-5.715h.624v5.848zm-.624-.266c.125 0 .25.133.374.133v-5.582h-.374v5.449z"
            fill="#131A2D"
            />
            <path
            d="M84.457 170.699c.125 0 .374 0 .499.133v-5.981c-.125 0-.374 0-.499.133v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M85.08 170.831c-.249 0-.373-.133-.623-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.498-.133c.125 0 .25 0 .374.133v-5.848c-.125 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M87.327 160.73c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.368 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M87.327 168.838c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12s8.358 2.126 8.358 4.12c0 1.994-3.368 4.121-8.358 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.861-3.369-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M81.963 167.774c.499.266 1.123.399 1.746.532l6.862-7.311c-.624-.133-1.373-.266-2.121-.266l-6.487 7.045zM86.703 168.705h1.248l5.988-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M84.706 168.439c-.124 0-.25 0-.374-.133-.25-.133-.624-.133-.873-.266-.25-.133-.624-.133-.874-.266-.124 0-.249-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.399c-.5-.265-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.374.266.125.133.25.133.375.266.125 0 .125.133.25.133l.249.133c.124 0 .25.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624-.001.874.132h.873c-.25-.133-.624-.132-.873-.265h-.375zM88.823 168.44l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.132.624.132h1.871c.374 0 .873-.132 1.248-.265l1.122-.399h-1.247c-.25.133-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M72.854 189.042c-1.122 0-2.12.133-2.994.266h-5.364v2.127c.125 1.86 3.493 3.987 8.358 3.987 4.866 0 8.234-1.994 8.359-3.987v-2.127h-5.365c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M72.854 195.555c-4.865 0-8.233-1.994-8.358-3.987v-2.393h5.49c.997-.133 1.995-.266 2.993-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.374 2.126-3.742 4.12-8.483 4.12zm-8.358-4.12c.125 1.861 3.493 3.854 8.234 3.854 4.74 0 8.108-1.993 8.233-3.854v-1.994h-5.115c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.994z"
            fill="#131A2D"
            />
            <path
            d="M65.37 193.164c.124.132.373.265.498.398v-4.253h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M65.993 193.694c-.25-.265-.5-.398-.624-.531v-3.988h.624v4.519zm-.5-.531l.375.398v-4.12h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M75.35 189.309v5.981c.124 0 .374 0 .499-.133v-5.848h-.5z"
            fill="#0EA59D"
            />
            <path
            d="M75.225 195.289v-6.114h.124c.125 0 .25 0 .375.133h.124v5.981h-.623zm.124-5.981v5.848c.125 0 .25 0 .375-.132v-5.716h-.375z"
            fill="#131A2D"
            />
            <path d="M74.352 195.422h.499v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M74.352 195.422v-6.38h.624v6.248c-.25.132-.375.132-.624.132zm.124-6.247v6.115h.375v-5.982c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M78.967 194.094c.124-.133.374-.266.499-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M78.842 194.227v-4.918h.624v4.519c-.125.133-.375.266-.624.399zm.124-4.785v4.652c.125-.133.25-.133.375-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M73.478 195.422h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M73.478 195.555v-6.513h.625v6.38c-.25 0-.375.133-.624.133zm.125-6.38v6.247h.375v-6.247h-.375z"
            fill="#131A2D"
            />
            <path
            d="M79.84 193.562c.25-.133.374-.266.499-.399v-3.721h-.5v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M79.715 193.695v-4.386h.624v3.855c-.125.132-.25.265-.624.531zm.125-4.253v3.987l.374-.398v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M77.096 194.891c.124 0 .374-.133.499-.133v-5.316h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M77.096 194.891v-5.716h.623v5.45c-.249.133-.374.266-.623.266zm.124-5.45v5.317c.125 0 .25-.133.375-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M76.223 195.024c.124 0 .374-.132.499-.132v-5.583h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M76.098 195.157v-5.848h.623v5.715c-.124 0-.374.133-.623.133zm.124-5.715v5.582c.125 0 .25 0 .375-.132v-5.45h-.375z"
            fill="#131A2D"
            />
            <path
            d="M77.969 194.493c.125-.133.374-.133.499-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M77.969 194.625v-5.316h.624v5.051c-.25.133-.375.133-.624.265zm.125-5.183v5.051c.124 0 .249-.133.374-.133v-4.786h-.374v-.132z"
            fill="#131A2D"
            />
            <path
            d="M68.113 194.759c.125 0 .374.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M68.737 195.024c-.25-.132-.499-.132-.624-.132v-5.45h.624v5.582zm-.624-.398c.125 0 .25.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M71.732 195.422h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M72.356 195.555h-.624v-6.513h.624v6.513zm-.624-.265h.375v-6.115h-.375v6.115z"
            fill="#131A2D"
            />
            <path d="M72.606 189.042v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M72.855 195.555h-.249v-6.513h.748v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M64.496 191.568c0 .399.25.931.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M65.12 193.03l-.125-.133c-.374-.398-.5-.797-.624-1.196v-2.392h.749v3.721zm-.624-1.595c0 .399.125.798.499 1.197v-3.19h-.5v1.993z"
            fill="#131A2D"
            />
            <path
            d="M80.715 192.632c.25-.399.374-.798.499-1.064v-2.126h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M80.59 192.764v-3.589h.624v2.26c0 .398-.25.664-.5 1.063l-.124.266zm.125-3.323v3.057c.124-.266.25-.665.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M66.242 193.828c.125.133.374.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M66.866 194.226c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.399c.126.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M70.86 195.289h.498v-6.114h-.499v6.114z" fill="#0EA59D" />
            <path
            d="M71.358 195.422h-.624v-6.247h.624v6.247zm-.499-.133h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M67.242 194.36c.125.133.374.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M67.74 194.625c-.249-.133-.498-.133-.623-.266v-5.184h.624v5.45zm-.498-.266c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M68.988 195.024c.125 0 .374.133.5.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M69.612 195.157c-.25 0-.374-.133-.624-.133v-5.715h.624v5.848zm-.499-.265c.125 0 .25 0 .374.132v-5.582h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M69.861 195.156c.125 0 .375 0 .5.133v-6.114c-.125 0-.375 0-.5.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M70.485 195.29c-.25 0-.374-.133-.624-.133v-5.982c.125 0 .375 0 .5-.133h.124v6.248zm-.499-.133c.125 0 .25 0 .374.133v-5.849c-.124 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M72.854 185.055c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.493 3.988 8.358 3.988 4.866 0 8.359-2.127 8.359-3.988 0-1.861-3.493-3.987-8.359-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M72.854 193.296c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12 4.99 0 8.359 2.126 8.359 4.12 0 1.994-3.493 4.121-8.359 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988 0-1.861-3.368-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M67.365 192.233c.5.266 1.123.399 1.747.665l6.861-7.311c-.624-.133-1.372-.266-2.12-.266l-6.488 6.912zM72.107 193.163h1.248l5.988-6.38c-.25-.133-.5-.399-.873-.532l-6.363 6.912z"
            fill="#fff"
            />
            <path
            d="M70.11 192.897c-.124 0-.25 0-.499-.133-.25-.133-.623-.133-.873-.266s-.624-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125 0-.25-.133l-.748-.399c-.499-.265-.998-.664-1.497-1.063.374.532.749 1.063 1.248 1.329.124.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.132h.873c-.25-.132-.624-.132-.873-.265h-.25zM74.35 192.898l-1.247.133h-.624c-.25 0-.374 0-.623.133.249 0 .374.132.623.132H74.351c.374 0 .873-.132 1.247-.265l1.123-.399h-1.248c-.374.133-.748.266-1.123.266zM88.573 193.03c-1.123 0-2.12.132-2.994.265h-5.364v2.127c.125 1.861 3.493 3.988 8.358 3.988s8.234-1.994 8.358-3.988v-2.127h-5.364c-.873-.133-1.871-.265-2.994-.265z"
            fill="#fff"
            />
            <path
            d="M88.573 199.543c-4.865 0-8.233-1.994-8.358-3.988v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.489v2.393c-.374 1.861-3.743 3.988-8.608 3.988zm-8.233-4.121c.124 1.861 3.493 3.855 8.233 3.855s8.109-1.994 8.234-3.855v-2.127h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v2.127h.125z"
            fill="#000"
            />
            <path
            d="M81.213 197.151c.125.133.374.266.499.399v-4.254h-.5v3.855z"
            fill="#fff"
            />
            <path
            d="M81.837 197.682c-.375-.265-.5-.398-.624-.531v-3.988h.624v4.519zm-.624-.531c.125.133.25.266.374.266v-3.988h-.374v3.722z"
            fill="#000"
            />
            <path
            d="M91.066 193.163v5.982c.125 0 .375 0 .5-.133v-5.849a.362.362 0 01-.5 0z"
            fill="#fff"
            />
            <path
            d="M91.066 199.277v-6.114h.125c.125 0 .25 0 .5.133h.124v5.981h-.749zm.125-5.981v5.849c.125 0 .25 0 .374-.133v-5.716h-.374z"
            fill="#000"
            />
            <path d="M90.195 199.276h.5v-6.114h-.5v6.114z" fill="#fff" />
            <path
            d="M90.07 199.409v-6.38h.749v6.248h-.125c-.125.132-.374.132-.624.132zm.25-6.247v6.115h.374v-6.115h-.374z"
            fill="#000"
            />
            <path
            d="M94.686 198.081c.124-.133.374-.266.498-.266v-4.519h-.498v4.785z"
            fill="#fff"
            />
            <path
            d="M94.56 198.214v-5.051h.624v4.519c-.124.266-.25.399-.623.532zm.25-4.785v4.519c.125-.133.25-.133.374-.266v-4.386h-.374v.133z"
            fill="#000"
            />
            <path d="M89.32 199.41h.5v-6.247h-.5v6.247z" fill="#fff" />
            <path
            d="M89.195 199.41v-6.514h.749v6.514h-.749zm.125-6.248v6.248h.374v-6.248h-.374z"
            fill="#000"
            />
            <path
            d="M95.559 197.417c.25-.133.374-.266.499-.399v-3.722h-.5v4.121z"
            fill="#fff"
            />
            <path
            d="M95.559 197.682v-4.519h.623v3.855c-.124.266-.374.399-.623.664zm.124-4.253v3.988l.375-.399v-3.589h-.375z"
            fill="#000"
            />
            <path
            d="M92.94 198.746c.124 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#fff"
            />
            <path
            d="M92.814 198.879v-5.716h.624v5.45a.923.923 0 01-.624.266zm.125-5.45v5.317c.125 0 .25-.133.375-.133v-5.184h-.375z"
            fill="#000"
            />
            <path
            d="M91.941 199.012c.125 0 .375-.133.5-.133v-5.583h-.5v5.716z"
            fill="#fff"
            />
            <path
            d="M91.941 199.145v-5.982h.624v5.716c-.25.133-.374.133-.624.266zm.125-5.716v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#000"
            />
            <path
            d="M93.813 198.48c.124-.133.374-.133.498-.266v-4.918h-.499v5.184z"
            fill="#fff"
            />
            <path
            d="M93.688 198.613v-5.45h.623v5.051c-.125.133-.374.266-.624.399zm.124-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#000"
            />
            <path
            d="M83.832 198.613c.125 0 .374.133.499.133v-5.583h-.499v5.45z"
            fill="#fff"
            />
            <path
            d="M84.456 198.879c-.25-.133-.5-.133-.624-.133v-5.583h.624v5.716zm-.5-.266c.126 0 .25.133.375.133v-5.317h-.374v5.184z"
            fill="#000"
            />
            <path d="M87.45 199.409h.498v-6.38h-.499v6.38z" fill="#fff" />
            <path
            d="M88.073 199.542h-.749v-6.513h.749v6.513zm-.5-.265h.375v-6.115h-.374v6.115z"
            fill="#000"
            />
            <path d="M88.45 193.029v6.38h.623v-6.38h-.624z" fill="#fff" />
            <path
            d="M88.574 199.542h-.25v-6.513h.749v6.513h-.499zm-.125-.265h.374v-6.248h-.374v6.248z"
            fill="#000"
            />
            <path
            d="M80.215 195.423c0 .398.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#fff"
            />
            <path
            d="M80.838 197.018l-.124-.133c-.375-.399-.5-.798-.624-1.196v-2.526h.748v3.855zm-.499-1.595c0 .398.125.797.375 1.196v-3.19h-.375v1.994z"
            fill="#000"
            />
            <path
            d="M96.432 196.619c.25-.399.374-.798.499-1.064v-2.126h-.5v3.19z"
            fill="#fff"
            />
            <path
            d="M96.432 196.885v-3.722h.623v2.393c0 .398-.25.664-.499 1.063l-.124.266zm.124-3.456v2.924c.125-.266.25-.531.25-.797v-2.127h-.25z"
            fill="#000"
            />
            <path
            d="M82.086 197.815c.125.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#fff"
            />
            <path
            d="M82.71 198.214c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.399c.125.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#000"
            />
            <path d="M86.576 199.277h.5v-6.248h-.5v6.248z" fill="#fff" />
            <path
            d="M87.2 199.409h-.749v-6.247h.749v6.247zm-.5-.265h.375v-5.982H86.7v5.982z"
            fill="#000"
            />
            <path
            d="M82.959 198.347c.125.133.374.133.499.266v-5.184h-.499v4.918z"
            fill="#fff"
            />
            <path
            d="M83.583 198.613c-.25-.133-.5-.133-.624-.266v-5.184h.624v5.45zm-.5-.399c.126 0 .25.133.375.133v-5.051h-.374v4.918z"
            fill="#000"
            />
            <path
            d="M84.83 198.879c.125 0 .374.133.5.133v-5.716h-.5v5.583z"
            fill="#fff"
            />
            <path
            d="M85.454 199.145c-.25 0-.5-.133-.624-.133v-5.849h.624v5.982zm-.624-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#000"
            />
            <path
            d="M85.703 199.144c.125 0 .374 0 .5.132v-6.114c-.126 0-.375 0-.5.133v5.849z"
            fill="#fff"
            />
            <path
            d="M86.327 199.277c-.25 0-.5-.133-.624-.133h-.125v-5.982h.125c.125 0 .374 0 .499-.133h.125v6.248zm-.624-.266h.374v-5.849h-.374v5.849z"
            fill="#000"
            />
            <path
            d="M88.573 189.042c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.987 8.358 3.987s8.358-2.126 8.358-3.987c0-1.861-3.368-3.988-8.358-3.988z"
            fill="#fff"
            />
            <path
            d="M88.573 197.283c-4.99 0-8.483-2.127-8.483-4.12 0-1.994 3.493-4.121 8.483-4.121s8.483 2.127 8.483 4.121c0 1.86-3.493 4.12-8.483 4.12zm0-8.108c-4.865 0-8.234 2.127-8.234 3.988 0 1.86 3.369 3.987 8.234 3.987s8.233-2.127 8.233-3.987c0-1.861-3.368-3.988-8.233-3.988z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M83.084 196.087c.499.266 1.123.398 1.746.664l6.862-7.31c-.624-.133-1.372-.266-2.121-.266l-6.487 6.912zM87.95 197.15H89.196l5.988-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#9CD6CB"
            />
            <path
            d="M74.477 197.417c-1.122 0-2.12.133-2.994.266H66.12v2.127c.125 1.86 3.493 3.987 8.358 3.987 4.866 0 8.234-1.994 8.359-3.987v-2.127H77.47c-.873-.266-1.87-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M74.477 203.796c-4.865 0-8.233-1.993-8.358-3.987v-2.393h5.49c.997-.133 1.995-.266 2.993-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.25 2.127-3.617 4.12-8.483 4.12zm-8.233-3.987c.125 1.861 3.493 3.854 8.233 3.854s8.11-1.993 8.234-3.854v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266H66.12v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M67.117 201.536c.125.133.374.266.5.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M67.74 202.068c-.249-.266-.498-.399-.623-.532v-3.987h.624v4.519zm-.623-.532l.374.399v-4.12h-.374v3.721z"
            fill="#131A2D"
            />
            <path
            d="M76.973 197.549v5.981c.124 0 .374 0 .499-.133v-5.848c-.125.133-.375 0-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M76.973 203.663v-6.114h.124c.125 0 .25 0 .375.133h.124v5.981c-.25-.133-.374 0-.623 0zm.124-5.981v5.848c.125 0 .25 0 .375-.133v-5.715h-.375z"
            fill="#131A2D"
            />
            <path d="M76.1 203.663h.499v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M75.975 203.796v-6.38h.624v6.247c-.125 0-.375.133-.624.133zm.124-6.247v6.114h.375v-5.981c0-.133-.125-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M80.59 202.467c.125-.133.374-.266.499-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M80.465 202.6v-4.918h.624v4.519c-.125.133-.25.133-.624.399zm.25-4.918v4.652c.124-.133.249-.133.374-.266v-4.386h-.375z"
            fill="#131A2D"
            />
            <path d="M75.225 203.796h.499v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M75.1 203.796v-6.513h.624v6.38c-.125.133-.375.133-.624.133zm.124-6.38v6.247h.375v-6.114c-.125 0-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M81.463 201.802c.25-.132.374-.265.499-.398v-3.722h-.5v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M81.463 201.935v-4.386h.624v3.855c-.125.133-.375.399-.624.531zm.125-4.253v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M78.844 203.132c.125 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M78.719 203.265v-5.716h.624v5.45c-.125.133-.375.133-.624.266zm.125-5.583v5.317c.124 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M77.846 203.397c.124 0 .374-.133.499-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M77.846 203.53v-5.848h.623v5.715c-.249 0-.374 0-.623.133zm.124-5.848v5.582c.125 0 .25 0 .375-.133v-5.449h-.374z"
            fill="#131A2D"
            />
            <path
            d="M79.717 202.866c.124-.133.374-.133.499-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M79.592 202.998v-5.316h.624v5.051c-.125 0-.375.133-.624.265zm.124-5.316v5.051c.125 0 .25-.133.375-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M69.736 202.999c.125 0 .375.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M70.36 203.265c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.499-.266c.125 0 .25.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M73.353 203.796h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M73.977 203.796h-.624v-6.513h.624v6.513zm-.499-.133h.375v-6.247h-.375v6.247z"
            fill="#131A2D"
            />
            <path d="M74.228 197.416v6.38h.624v-6.38h-.374-.25z" fill="#0EA59D" />
            <path
            d="M74.478 203.796h-.249v-6.513h.873v6.513h-.624zm-.125-.133h.375v-6.247h-.375v6.247z"
            fill="#131A2D"
            />
            <path
            d="M66.12 199.809c0 .398.249.797.623 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M66.743 201.271l-.125-.133c-.374-.399-.5-.798-.624-1.196v-2.393h.749v3.722zm-.5-1.462c0 .398.125.797.5 1.196v-3.19h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M82.336 201.006c.25-.399.374-.798.499-1.064v-2.127h-.5v3.191z"
            fill="#0EA59D"
            />
            <path
            d="M82.336 201.138v-3.589h.624v2.259c0 .399-.25.665-.5 1.064l-.124.266zm.125-3.456v3.057c.124-.266.25-.665.374-.931v-1.993h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M67.99 202.201c.125.133.375.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M68.614 202.6c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.624-.399c.125.133.25.133.375.266v-4.652h-.375v4.386z"
            fill="#131A2D"
            />
            <path d="M72.48 203.663h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M73.104 203.796h-.623v-6.247h.623v6.247zm-.499-.266h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M68.863 202.733c.125.133.374.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M69.487 202.999c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M70.734 203.264c.125 0 .375.133.5.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M71.233 203.53c-.25 0-.374-.133-.624-.133v-5.715h.624v5.848zm-.499-.266c.125 0 .25 0 .374.133v-5.582h-.374v5.449z"
            fill="#131A2D"
            />
            <path
            d="M71.607 203.531c.125 0 .375-.001.5.132v-6.114c-.125 0-.375 0-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M72.231 203.663c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .375 0 .5-.133h.124v6.247zm-.624-.266c.125 0 .25 0 .375.133v-5.848c-.125 0-.25 0-.375.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M74.477 193.429c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.493 3.988 8.358 3.988 4.866 0 8.359-2.127 8.359-3.988 0-1.861-3.369-3.987-8.359-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M74.477 201.67c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12 4.866 0 8.359 2.126 8.359 4.12 0 1.994-3.369 4.121-8.359 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988.125-1.994-3.368-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M68.988 200.473c.5.266 1.123.399 1.747.665l6.861-7.311c-.624-.133-1.372-.265-2.12-.265l-6.488 6.911zM73.853 201.537h1.248l5.988-6.38c-.25-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M71.856 201.138c-.124 0-.25 0-.499-.133-.25-.133-.623-.133-.873-.266s-.624-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125-.133-.25-.133l-.748-.398c-.499-.266-.998-.665-1.497-1.064.374.532.749 1.064 1.248 1.33.124.132.25.132.374.265.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM75.974 201.271l-1.248.133h-.624c-.25 0-.374 0-.624.133.25 0 .375.132.624.132H75.974c.374 0 .873-.132 1.247-.265l1.123-.399h-1.248c-.374.133-.748.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M99.926 193.297c-.998-.532-1.871-.93-2.744-1.196l-4.74-2.659-.999 1.994c-.748 1.728 1.372 5.184 5.614 7.71 4.241 2.392 8.109 2.259 9.107.664l.998-1.994-4.741-2.658c-.624-.665-1.497-1.329-2.495-1.861z"
            fill="#0EA59D"
            />
            <path
            d="M103.294 200.874c-1.746 0-3.867-.532-6.237-1.861-4.242-2.393-6.363-5.849-5.739-7.71l.998-1.993 4.74 2.658c.874.266 1.872.665 2.745 1.196.873.532 1.747 1.064 2.495 1.728l4.741 2.659-.998 1.993c-.25.931-1.373 1.33-2.745 1.33zm-11.726-9.571c-.749 1.728 1.372 5.184 5.613 7.577 4.242 2.392 8.109 2.26 8.982.797l.874-1.861-4.616-2.658c-.749-.665-1.622-1.196-2.495-1.728s-1.871-.93-2.745-1.196l-4.74-2.659-.873 1.728z"
            fill="#131A2D"
            />
            <path
            d="M91.568 193.297c.125.265.125.398.25.664l1.871-3.722-.499-.265-1.622 3.323z"
            fill="#0EA59D"
            />
            <path
            d="M91.818 194.094c-.125-.398-.25-.531-.375-.797l1.747-3.456.624.266-1.996 3.987zm-.125-.797c0 .133.125.266.25.531l1.746-3.588-.374-.266-1.622 3.323z"
            fill="#131A2D"
            />
            <path
            d="M102.047 194.759l-2.62 5.317c.125 0 .375.133.5.133l2.619-5.184c-.249 0-.374-.133-.499-.266z"
            fill="#0EA59D"
            />
            <path
            d="M99.926 200.341c-.25-.132-.374-.132-.624-.132h-.124l2.744-5.45.125.133c.125.133.249.133.374.266h.125l-2.62 5.183zm-.374-.265c.125 0 .25.133.374.133l2.495-5.051c-.125-.133-.249-.133-.374-.266l-2.495 5.184z"
            fill="#131A2D"
            />
            <path
            d="M98.555 199.677c.124.133.374.133.499.266l2.744-5.45c-.125-.133-.249-.265-.499-.265l-2.744 5.449z"
            fill="#0EA59D"
            />
            <path
            d="M99.053 200.076c-.25-.133-.374-.133-.499-.266h-.124l2.869-5.582c.125.132.249.265.499.265l-2.745 5.583zm-.374-.399c.125 0 .25.133.374.133l2.62-5.317c-.125-.133-.249-.133-.374-.265l-2.62 5.449z"
            fill="#131A2D"
            />
            <path
            d="M103.045 200.873h.624l1.996-3.988-.499-.266-2.121 4.254z"
            fill="#0EA59D"
            />
            <path
            d="M103.294 200.873h-.249l2.245-4.387.624.266-1.996 3.988c-.374.133-.499.133-.624.133zm-.124-.133h.499l1.871-3.855-.374-.266-1.996 4.121z"
            fill="#131A2D"
            />
            <path
            d="M97.805 199.278c.124.133.374.133.499.266l2.744-5.583c-.125-.133-.249-.133-.499-.266l-2.744 5.583z"
            fill="#0EA59D"
            />
            <path
            d="M98.304 199.677c-.25-.133-.375-.133-.5-.266l2.87-5.716c.125.133.249.133.499.266l-2.87 5.716zm-.5-.399c.125 0 .25.133.375.133l2.744-5.45c-.124-.133-.249-.133-.374-.266l-2.744 5.583z"
            fill="#131A2D"
            />
            <path
            d="M104.168 200.74c.249 0 .499-.133.624-.133l1.621-3.323-.499-.266-1.746 3.722z"
            fill="#0EA59D"
            />
            <path
            d="M104.043 200.873l1.996-3.854.624.265-1.747 3.323c-.249.133-.499.266-.873.266zm1.996-3.722l-1.747 3.456c.125 0 .375-.133.499-.133l1.622-3.19-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M101.174 200.608c.125 0 .374.133.499.133l2.37-4.652-.499-.266-2.37 4.785z"
            fill="#0EA59D"
            />
            <path
            d="M101.797 200.741c-.249 0-.374-.133-.623-.133h-.125l2.495-5.051.624.265-2.371 4.919zm-.499-.133c.125 0 .25 0 .375.133l2.245-4.653-.374-.266-2.246 4.786z"
            fill="#131A2D"
            />
            <path
            d="M100.301 200.342c.125 0 .374.133.499.133l2.495-4.918-.499-.266-2.495 5.051z"
            fill="#0EA59D"
            />
            <path
            d="M100.799 200.608c-.249 0-.374-.133-.623-.133h-.125l2.62-5.184.623.266-2.495 5.051zm-.374-.266c.125 0 .25.133.374.133l2.371-4.785-.375-.266-2.37 4.918z"
            fill="#131A2D"
            />
            <path
            d="M102.172 200.741h.624l2.245-4.386-.499-.266-2.37 4.652z"
            fill="#0EA59D"
            />
            <path
            d="M102.67 200.874h-.748v-.133l2.37-4.652.624.266-2.246 4.519zm-.499-.133h.375l2.12-4.253-.374-.266-2.121 4.519z"
            fill="#131A2D"
            />
            <path
            d="M93.314 195.955l.375.399 2.495-4.918-.5-.266-2.37 4.785z"
            fill="#0EA59D"
            />
            <path
            d="M93.689 196.487l-.5-.532 2.37-4.785.624.266-2.495 5.051zm-.25-.532l.25.266 2.37-4.785-.374-.266-2.246 4.785z"
            fill="#131A2D"
            />
            <path
            d="M96.184 198.347c.124.133.25.133.499.266l2.869-5.583c-.125-.132-.374-.132-.5-.265l-2.868 5.582z"
            fill="#0EA59D"
            />
            <path
            d="M96.683 198.746c-.25-.133-.375-.266-.5-.266l2.87-5.715c.125.133.374.133.499.265l-2.87 5.716zm-.375-.399c.125.133.25.133.375.266l2.744-5.45c-.125 0-.25-.133-.374-.133l-2.745 5.317z"
            fill="#131A2D"
            />
            <path
            d="M99.8 193.297l-2.868 5.582.124.133c.125 0 .25.133.25.133l2.869-5.583c-.125 0-.25-.132-.25-.132 0-.133-.124-.133-.124-.133z"
            fill="#0EA59D"
            />
            <path
            d="M97.43 199.278c-.124-.133-.25-.133-.374-.133 0 0-.125 0-.125-.133h-.124l2.869-5.715h.249c.125 0 .125.133.125.133l.125.133-2.745 5.715zm-.374-.398c.25.132.25.132.374.132l2.745-5.449-.125-.133h-.125l-2.869 5.45z"
            fill="#131A2D"
            />
            <path
            d="M91.443 191.303c-.125.399-.125.931 0 1.462l1.497-3.057-.499-.266-.998 1.861z"
            fill="#0EA59D"
            />
            <path
            d="M91.443 192.898v-.132c-.125-.532-.125-1.064 0-1.463l.998-1.993.624.398-1.622 3.19zm.125-1.595c-.125.399-.25.798-.125 1.197l1.372-2.792-.374-.266-.873 1.861z"
            fill="#131A2D"
            />
            <path
            d="M105.291 200.475c.374-.133.749-.399.873-.797l.998-1.994-.374-.266-1.497 3.057z"
            fill="#0EA59D"
            />
            <path
            d="M105.166 200.608l1.622-3.19.499.266-.998 1.994c-.25.265-.499.531-.873.664l-.25.266zm1.622-2.924l-1.372 2.658c.249-.133.499-.399.623-.664l.874-1.861-.125-.133z"
            fill="#131A2D"
            />
            <path
            d="M92.066 194.361c.125.133.25.398.375.531l2.12-4.253-.499-.266-1.996 3.988z"
            fill="#0EA59D"
            />
            <path
            d="M92.44 195.025c-.124-.265-.249-.398-.374-.664l1.996-4.121.624.266-2.245 4.519zm-.249-.664c.125.133.125.266.25.399l1.996-4.121-.375-.266-1.87 3.988z"
            fill="#131A2D"
            />
            <path
            d="M95.436 197.816c.124.133.249.266.498.266l2.745-5.583c-.125-.133-.374-.133-.499-.266l-2.745 5.583z"
            fill="#0EA59D"
            />
            <path
            d="M95.934 198.348c-.249-.133-.374-.266-.498-.399l2.744-5.583c.125.133.374.133.5.266h.124l-2.87 5.716zm-.374-.532c.125.133.25.133.374.266l2.745-5.45c-.125 0-.25-.133-.374-.133l-2.745 5.317z"
            fill="#131A2D"
            />
            <path
            d="M92.691 195.158l.375.399 2.37-4.652-.5-.266-2.245 4.519z"
            fill="#0EA59D"
            />
            <path
            d="M93.066 195.822c-.25-.265-.375-.398-.375-.531l2.246-4.52.624.266-2.495 4.785zm-.375-.664c.125.133.125.266.25.399l2.245-4.52-.374-.266-2.12 4.387z"
            fill="#131A2D"
            />
            <path
            d="M93.938 196.619l.374.399 2.495-5.051-.5-.266-2.37 4.918z"
            fill="#0EA59D"
            />
            <path
            d="M94.436 197.151a1.738 1.738 0 01-.499-.399l2.496-5.051.623.266-2.62 5.184zm-.374-.532c.125.133.25.133.25.266l2.495-4.918-.374-.266-2.37 4.918z"
            fill="#131A2D"
            />
            <path
            d="M94.688 197.284l.374.399 2.62-5.317c-.125 0-.375-.133-.5-.133l-2.495 5.051z"
            fill="#0EA59D"
            />
            <path
            d="M95.186 197.683a1.738 1.738 0 01-.499-.399l2.62-5.183c.125 0 .374.133.5.133h.124l-2.745 5.449zm-.374-.399c.125.133.25.133.374.266l2.62-5.184c-.124 0-.25-.132-.374-.132l-2.62 5.05z"
            fill="#131A2D"
            />
            <path
            d="M101.673 189.84c-4.366-2.525-8.358-2.26-9.107-.664-.748 1.595 1.248 5.316 5.614 7.709 4.366 2.525 8.358 2.26 9.107.665.873-1.596-1.248-5.184-5.614-7.71z"
            fill="#0EA59D"
            />
            <path
            d="M104.292 198.879h-.249c-1.747 0-3.868-.664-5.864-1.861-1.996-1.196-3.742-2.658-4.74-4.253-.998-1.462-1.248-2.791-.873-3.722.499-.93 1.621-1.329 3.368-1.329 1.746 0 3.867.664 5.863 1.861 1.996 1.196 3.743 2.658 4.741 4.253.998 1.462 1.247 2.792.873 3.722-.499.93-1.622 1.329-3.119 1.329zm-8.732-10.766c-1.497 0-2.62.398-2.994 1.196-.375.797-.125 2.127.873 3.456.998 1.595 2.744 3.057 4.74 4.12 1.996 1.197 4.117 1.861 5.864 1.861 1.621 0 2.744-.398 3.243-1.196.374-.798.125-2.127-.873-3.456-.998-1.595-2.745-3.057-4.741-4.12-1.996-1.197-4.116-1.861-5.863-1.861h-.25z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M93.813 193.43c.374.532.748.931 1.372 1.462l9.356-3.057c-.499-.399-1.123-.93-1.747-1.329l-8.981 2.924zM97.557 196.62c.25.132.374.265.623.398.25.133.375.266.624.266l8.109-2.658c-.125-.266-.374-.532-.499-.931l-8.857 2.925z"
            fill="#fff"
            />
            <path
            d="M95.934 195.291c-.124-.133-.25-.266-.374-.266-.25-.266-.499-.399-.624-.664l-.623-.665c-.125-.133-.25-.266-.25-.399l-.125-.133-.124-.133c-.25-.265-.375-.531-.5-.797-.374-.532-.623-1.064-.873-1.728 0 .664.25 1.329.5 1.861.124.133.124.266.249.399.125.132.125.265.25.398 0 .133.124.133.124.266l.125.133c.125.133.25.266.25.399l.374.399.374.398c.25.266.499.399.748.665.25.133.5.399.749.532.25.133.499.265.873.398-.25-.265-.499-.398-.748-.664l-.375-.399zM99.552 197.417l-1.123-.532-.624-.266c-.25-.133-.374-.133-.623-.265.124.132.374.265.499.398l.25.133c.124.133.124.133.249.133.374.266.748.399 1.122.665l1.123.398c.374.133.873.133 1.248.133-.375-.265-.749-.398-1.123-.531-.25.133-.624 0-.998-.266z"
            fill="#fff"
            />
            <path
            d="M86.204 182.529c-1.123 0-2.12.133-2.994.266h-5.364v2.127c.124 1.861 3.493 3.987 8.358 3.987s8.234-1.993 8.358-3.987v-2.127h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M86.204 189.043c-4.865 0-8.234-1.994-8.358-3.988v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.375 2.127-3.743 4.121-8.483 4.121zm-8.358-3.988c.124 1.861 3.492 3.855 8.233 3.855 4.74 0 8.109-1.994 8.234-3.855v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.994h.124z"
            fill="#131A2D"
            />
            <path
            d="M78.719 186.783c.125.133.374.266.499.399v-4.254h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M79.343 187.315c-.25-.266-.5-.399-.624-.532v-3.987h.624v4.519zm-.5-.665l.375.399v-4.12h-.374v3.721z"
            fill="#131A2D"
            />
            <path
            d="M88.7 182.796v5.981c.124 0 .373 0 .498-.133v-5.848H88.7z"
            fill="#0EA59D"
            />
            <path
            d="M88.574 188.91v-6.114h.125c.125 0 .25 0 .374.133h.125v5.981c-.125-.133-.374-.133-.624 0zm.125-5.981v5.848c.125 0 .25 0 .374-.133v-5.715H88.7z"
            fill="#131A2D"
            />
            <path d="M87.826 188.91h.5v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M87.701 189.042v-6.513h.624v6.247c-.25.133-.374.133-.624.266zm.125-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M92.316 187.581c.125-.133.375-.266.5-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M92.191 187.714v-4.918h.624v4.519c-.125.133-.374.266-.624.399zm.125-4.785v4.652c.125-.133.25-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M86.828 188.91h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M86.828 189.042v-6.513h.624v6.38c-.25.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M93.19 187.049c.249-.133.374-.266.499-.399v-3.722h-.5v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M93.064 187.182v-4.386h.624v3.854c-.124.133-.25.266-.624.532zm.125-4.253v3.987l.374-.399v-3.588h-.374z"
            fill="#131A2D"
            />
            <path
            d="M90.445 188.378c.125 0 .375-.133.5-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M90.445 188.511v-5.715h.624v5.449c-.25.133-.374.133-.624.266zm.125-5.582v5.316c.125 0 .25-.133.374-.133v-5.183h-.374z"
            fill="#131A2D"
            />
            <path
            d="M89.572 188.644c.125 0 .374-.133.5-.133v-5.583h-.5v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M89.447 188.644v-5.848h.624v5.715c-.125.133-.25.133-.624.133zm.125-5.715v5.582c.125 0 .25 0 .374-.133v-5.449h-.374z"
            fill="#131A2D"
            />
            <path
            d="M91.318 188.112c.125-.133.375-.133.5-.265v-4.919h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M91.318 188.112v-5.316h.624v5.051c-.125.133-.374.133-.624.265zm.125-5.183v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M81.463 188.245c.125 0 .374.133.499.133v-5.582h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M82.087 188.511c-.25-.133-.5-.133-.624-.133v-5.45h.624v5.583zm-.5-.266c.125 0 .25.133.375.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M85.08 188.909h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M85.704 189.042h-.624v-6.513h.624v6.513zm-.624-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M85.955 182.529v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M86.205 189.042c-.125 0-.125 0 0 0h-.25v-6.513h.624v6.513h-.375zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M77.846 185.055c0 .399.25.798.623 1.329v-3.456h-.623v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M78.47 186.517l-.126-.132c-.374-.399-.498-.798-.623-1.197v-2.392h.748v3.721zm-.624-1.595c0 .399.124.798.498 1.197v-3.19h-.498v1.993z"
            fill="#131A2D"
            />
            <path
            d="M94.063 186.119c.249-.399.374-.798.498-1.064v-2.127h-.499v3.191z"
            fill="#0EA59D"
            />
            <path
            d="M94.063 186.385v-3.589h.498v2.259c0 .399-.249.665-.499 1.064v.266zm.124-3.456v3.057c.25-.266.25-.665.374-.931v-1.993h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M79.717 187.448c.124.133.374.266.499.266v-4.786h-.5v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M80.216 187.847c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.532c.125.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M84.209 188.91h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M84.708 189.043h-.624v-6.247h.624v6.247zm-.5-.266h.375v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M80.59 187.847c.125.132.374.132.499.265v-5.184h-.5v4.919z"
            fill="#0EA59D"
            />
            <path
            d="M81.214 188.245c-.25-.133-.5-.133-.624-.265v-5.184h.624v5.449zm-.624-.398c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M82.336 188.511c.125 0 .374.133.499.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M82.96 188.777c-.25 0-.375-.133-.624-.133v-5.716h.624v5.849zm-.5-.266c.125 0 .25 0 .375.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M83.209 188.777c.125 0 .374 0 .499.133v-6.114c-.125 0-.374 0-.499.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M83.833 188.91c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.5-.266c.126 0 .25 0 .375.133v-5.848c-.125 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M86.204 178.675c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.987 8.358 3.987s8.358-2.126 8.358-3.987c0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M86.204 186.783c-4.99 0-8.358-2.127-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121 4.99 0 8.358 2.127 8.358 4.121 0 1.993-3.493 4.12-8.358 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.86 3.368 3.987 8.233 3.987s8.234-2.127 8.234-3.987c0-1.861-3.369-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M80.715 185.72c.499.266 1.123.399 1.746.665l6.862-7.311c-.624-.132-1.373-.265-2.121-.265l-6.487 6.911zM85.455 186.783h1.248l5.988-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M83.46 186.384c-.125 0-.25 0-.5-.133-.248-.133-.623-.133-.872-.266-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.25-.133c-.124 0-.124-.132-.249-.132l-.748-.399c-.5-.266-.998-.665-1.497-1.064.374.532.748 1.064 1.247 1.33.125.133.25.133.374.265.125.133.25.133.375.266.124 0 .124.133.25.133l.249.133c.125 0 .25.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM87.7 186.385l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133H87.7c.374 0 .873-.133 1.248-.266l1.122-.399h-1.247c-.374.266-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M86.204 179.074c-1.123 0-2.12.133-2.994.266h-5.364v2.127c.124 1.861 3.493 3.987 8.358 3.987s8.234-1.993 8.358-3.987v-2.127h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M86.204 185.586c-4.865 0-8.234-1.993-8.358-3.987v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.375 2.127-3.743 4.12-8.483 4.12zm-8.358-4.12c.124 1.861 3.492 3.855 8.233 3.855 4.74 0 8.109-1.994 8.234-3.855v-1.994h-5.24c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.994h.124z"
            fill="#131A2D"
            />
            <path
            d="M78.719 183.194c.125.132.374.265.499.398v-4.253h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M79.343 183.858c-.25-.266-.5-.399-.624-.532v-3.987h.624v4.519zm-.5-.664c.125.132.25.265.375.265v-4.12h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M88.7 179.339v5.981c.124 0 .373 0 .498-.133v-5.848H88.7z"
            fill="#0EA59D"
            />
            <path
            d="M88.574 185.32v-6.114h.125c.125 0 .25 0 .374.133h.125v5.981h-.624zm.125-5.981v5.848c.125 0 .25 0 .374-.132v-5.716c-.124.133-.25 0-.374 0z"
            fill="#131A2D"
            />
            <path d="M87.826 185.453h.5v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M87.701 185.453v-6.38h.624v6.247c-.25.133-.374.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.125 0-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M92.316 184.124c.125-.133.375-.266.5-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M92.191 184.257v-4.918h.624v4.519c-.125.133-.374.266-.624.399zm.125-4.785v4.652c.125-.133.25-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M86.828 185.453h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M86.828 185.586v-6.513h.624v6.38c-.25.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M93.19 183.593c.249-.133.374-.266.499-.399v-3.721h-.5v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M93.064 183.725v-4.386h.624v3.855c-.124.132-.25.265-.624.531zm.125-4.253v3.987l.374-.398v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M90.445 184.922c.125 0 .375-.133.5-.133v-5.316h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M90.445 184.922v-5.716h.624v5.45c-.25.133-.374.266-.624.266zm.125-5.45v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M89.572 185.188c.125 0 .374-.133.5-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M89.447 185.187v-5.848h.624v5.715c-.125 0-.374.133-.624.133zm.125-5.715v5.582c.125 0 .25 0 .374-.132v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M91.318 184.523c.125-.133.375-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M91.318 184.656v-5.317h.624v5.051c-.125.133-.374.133-.624.266zm.125-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M81.463 184.789c.125 0 .374.133.499.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M82.087 185.054c-.25-.132-.5-.132-.624-.132v-5.45h.624v5.582zm-.5-.398c.125 0 .25.133.375.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M85.08 185.453h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M85.704 185.586h-.624v-6.513h.624v6.513zm-.624-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M85.955 179.073v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M86.205 185.586c-.125 0-.125 0 0 0h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.499v6.247h.125z"
            fill="#131A2D"
            />
            <path
            d="M77.846 181.599c0 .399.25.798.623 1.33v-3.456h-.623v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M78.47 183.061l-.126-.133c-.374-.399-.498-.798-.623-1.197v-2.392h.748v3.722zm-.624-1.595c0 .398.124.797.498 1.196v-3.19h-.498v1.994z"
            fill="#131A2D"
            />
            <path
            d="M94.063 182.663c.249-.399.374-.798.498-1.064v-2.126h-.499v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M94.063 182.928v-3.589h.498v2.26c0 .398-.249.664-.499 1.063v.266zm.124-3.456v3.057c.25-.266.25-.665.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M79.717 183.858c.124.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M80.216 184.39c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.532c.125.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M84.209 185.32h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M84.708 185.453h-.624v-6.247h.624v6.247zm-.5-.133h.375v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M80.59 184.391c.125.133.374.133.499.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M81.214 184.656c-.25-.133-.5-.133-.624-.266v-5.184h.624v5.45zm-.624-.266c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M82.336 185.055c.125 0 .374.133.499.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M82.96 185.187c-.25 0-.375-.133-.624-.133v-5.715h.624v5.848zm-.5-.265c.125 0 .25 0 .375.132v-5.582h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M83.209 185.187c.125 0 .374 0 .499.133v-5.981c-.125 0-.374 0-.499.133v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M83.833 185.453c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.5-.266c.126 0 .25 0 .375.133v-5.848c-.125 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M86.204 175.219c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.493-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M86.204 183.327c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12 4.99 0 8.358 2.126 8.358 4.12 0 1.994-3.493 4.121-8.358 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988s8.234-2.127 8.234-3.988c0-1.861-3.369-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M80.715 182.263c.499.266 1.123.399 1.746.665l6.862-7.311c-.624-.133-1.373-.265-2.121-.265l-6.487 6.911zM85.455 183.194h1.248l5.988-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M83.46 182.928c-.125 0-.25 0-.5-.133-.248-.133-.623-.133-.872-.266-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.398c-.5-.266-.998-.665-1.497-1.064.374.532.748 1.064 1.247 1.33.125.132.25.132.374.265.125.133.25.133.375.266.124 0 .124.133.25.133l.249.133c.125 0 .25.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .874.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM87.7 182.928l-1.247.133h-.624c-.25 0-.374 0-.624.133.25 0 .374.133.624.133H87.7c.374 0 .873-.133 1.248-.266l1.122-.399h-1.247c-.374.133-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M72.854 185.853c-1.122 0-2.12.132-2.994.265h-5.364v2.127c.125 1.861 3.493 3.988 8.358 3.988 4.866 0 8.234-1.994 8.359-3.988v-2.127h-5.365c-.998-.133-1.996-.265-2.994-.265z"
            fill="#0EA59D"
            />
            <path
            d="M72.854 192.365c-4.865 0-8.233-1.994-8.358-3.988v-2.392h5.49c.997-.133 1.995-.266 2.993-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.374 2.127-3.742 4.121-8.483 4.121zm-8.358-3.988c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-1.994h-5.115c-.998-.133-1.996-.265-2.994-.265-.998 0-1.996.132-2.994.265h-5.364v1.994z"
            fill="#131A2D"
            />
            <path
            d="M65.37 190.106c.124.133.373.266.498.398v-4.253h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M65.993 190.636c-.25-.265-.5-.398-.624-.531v-3.988h.624v4.519zm-.5-.664l.375.399v-4.121h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M75.35 186.117v5.982c.124 0 .374 0 .499-.133v-5.849h-.5z"
            fill="#0EA59D"
            />
            <path
            d="M75.225 192.232v-6.115h.124c.125 0 .25 0 .5.133h.124v5.982a.752.752 0 00-.748 0zm.124-5.982v5.849c.125 0 .25 0 .375-.133v-5.716h-.375z"
            fill="#131A2D"
            />
            <path d="M74.352 192.232h.499v-6.115h-.5v6.115z" fill="#0EA59D" />
            <path
            d="M74.352 192.365v-6.381h.624v6.248c-.25 0-.375 0-.624.133zm.124-6.248v6.115h.375v-5.982c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M78.967 190.903c.124-.133.374-.266.499-.266v-4.52h-.5v4.786z"
            fill="#0EA59D"
            />
            <path
            d="M78.842 191.035v-4.918h.624v4.519c-.125.133-.375.266-.624.399zm.124-4.785v4.519c.125-.133.25-.133.375-.265v-4.387h-.374v.133z"
            fill="#131A2D"
            />
            <path d="M73.478 192.232h.5v-6.248h-.5v6.248z" fill="#0EA59D" />
            <path
            d="M73.478 192.365v-6.513h.625v6.38c-.25.133-.375.133-.624.133zm.125-6.381v6.248h.375v-6.115c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M79.84 190.372c.25-.133.374-.266.499-.399v-3.722h-.5v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M79.715 190.504v-4.387h.624v3.855c-.125.133-.25.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M77.096 191.701c.124 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M77.096 191.833v-5.716h.623v5.45c-.249.133-.374.133-.623.266zm.124-5.583v5.317c.125 0 .25-.133.375-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M76.223 191.967c.124 0 .374-.133.499-.133v-5.583h-.5v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M76.098 191.966v-5.849h.623v5.716c-.124.133-.374.133-.623.133zm.124-5.716v5.583c.125 0 .25 0 .375-.133v-5.45h-.375z"
            fill="#131A2D"
            />
            <path
            d="M77.969 191.435c.125-.133.374-.133.499-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M77.969 191.434v-5.317h.624v5.051c-.25.133-.375.266-.624.266zm.125-5.184v5.051c.124 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M68.113 191.567c.125 0 .374.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M68.737 191.834c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.624-.266c.125 0 .25.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M71.732 192.232h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M72.356 192.365h-.624v-6.513h.624v6.513zm-.624-.133h.375v-6.248h-.375v6.248z"
            fill="#131A2D"
            />
            <path
            d="M72.606 185.985v6.38h.623v-6.38h-.374c-.125-.133-.125 0-.25 0z"
            fill="#0EA59D"
            />
            <path
            d="M72.855 192.365h-.249v-6.513h.623v6.513h-.374zm-.125-.133h.374v-6.248h-.374v6.248z"
            fill="#131A2D"
            />
            <path
            d="M64.496 188.378c0 .398.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M65.12 189.839l-.125-.133c-.374-.399-.5-.797-.624-1.196v-2.393h.749v3.722zm-.624-1.462c0 .399.125.797.499 1.196v-3.19h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M80.715 189.441c.25-.399.374-.797.499-1.063v-2.127h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M80.59 189.706v-3.589h.624v2.26c0 .399-.25.664-.5 1.063l-.124.266zm.125-3.456v3.057c.124-.266.25-.664.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M66.242 190.77c.125.133.374.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M66.866 191.168c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.532c.126.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M70.86 192.232h.498v-6.248h-.499v6.248z" fill="#0EA59D" />
            <path
            d="M71.358 192.365h-.624v-6.248h.624v6.248zm-.499-.266h.374v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M67.242 191.169c.125.133.374.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M67.74 191.567c-.249-.133-.498-.133-.623-.266v-5.184h.624v5.45zm-.498-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M68.988 191.833c.125 0 .374.133.5.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M69.612 192.099c-.25 0-.374-.133-.624-.133v-5.716h.624v5.849zm-.499-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M69.861 192.099c.125 0 .375 0 .5.133v-6.115c-.125 0-.375 0-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M70.485 192.232c-.25 0-.374-.133-.624-.133v-5.982c.125 0 .375 0 .5-.133h.124v6.248zm-.499-.266c.125 0 .25 0 .374.133v-5.849c-.124 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M72.854 181.997c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.987 8.358 3.987 4.866 0 8.359-2.126 8.359-3.987 0-1.861-3.493-3.988-8.359-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M72.854 190.105c-4.99 0-8.358-2.126-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121 4.99 0 8.359 2.127 8.359 4.121 0 1.994-3.493 4.12-8.359 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.987 8.233 3.987 4.866 0 8.234-2.126 8.234-3.987 0-1.861-3.368-3.988-8.234-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M67.365 189.042c.5.266 1.123.399 1.747.664l6.861-7.31c-.624-.133-1.372-.266-2.12-.266l-6.488 6.912zM72.107 190.105h1.248l5.988-6.38c-.25-.133-.5-.399-.873-.532l-6.363 6.912z"
            fill="#fff"
            />
            <path
            d="M70.11 189.707c-.124 0-.25 0-.499-.133-.25-.133-.623-.133-.873-.266s-.624-.133-.873-.265c-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125 0-.25-.133l-.748-.399c-.499-.266-.998-.665-1.497-1.063.374.531.749 1.063 1.248 1.329.124.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.132.25.132l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM74.35 189.707l-1.247.133h-.624c-.25 0-.374 0-.623.133.249 0 .374.133.623.133H74.351c.374 0 .873-.133 1.247-.266l1.123-.399h-1.248c-.374.266-.748.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M76.474 177.345c-1.123 0-2.121.133-2.995.266h-5.364v2.126c.125 1.861 3.493 3.988 8.359 3.988 4.865 0 8.233-1.994 8.358-3.988v-2.126h-5.364c-.999-.133-1.996-.266-2.995-.266z"
            fill="#0EA59D"
            />
            <path
            d="M76.473 183.858c-4.865 0-8.233-1.994-8.358-3.988v-2.392h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.259c-.374 1.994-3.742 4.121-8.483 4.121zm-8.358-4.121c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-1.993h-5.24c-.998-.133-1.995-.266-2.993-.266-.999 0-1.996.133-2.995.266H67.99v1.993h.125z"
            fill="#131A2D"
            />
            <path
            d="M68.988 181.465c.125.133.374.266.5.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M69.612 181.997c-.25-.266-.499-.399-.624-.532v-3.987h.624v4.519zm-.499-.532l.374.399v-4.12h-.374v3.721z"
            fill="#131A2D"
            />
            <path
            d="M78.969 177.478v5.981c.125 0 .374 0 .499-.133v-5.848c-.25.132-.374.132-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M78.844 183.592v-6.114h.125c.124 0 .249 0 .499.133h.124v5.981h-.748zm.125-5.981v5.848c.124 0 .249 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M77.97 183.726h.5v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M77.97 183.725v-6.38h.624v6.247c-.249.133-.374.133-.623.133zm.126-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M82.586 182.397c.125-.133.374-.266.499-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M82.46 182.53v-4.918h.625v4.519c-.125.133-.375.266-.624.399zm.126-4.786v4.653c.124-.133.25-.133.374-.266v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M77.098 183.725h.499v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M77.098 183.858v-6.513h.624v6.38c-.25 0-.375 0-.624.133zm.124-6.38v6.247h.375v-6.114c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M83.459 181.865c.25-.133.374-.266.499-.399v-3.722h-.499v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M83.334 181.998v-4.386h.624v3.854c-.125.133-.25.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M80.715 183.193c.125 0 .374-.133.499-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M80.715 183.193v-5.715h.624v5.45c-.25.132-.375.265-.624.265zm.125-5.449v5.316c.124 0 .25-.132.374-.132v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M79.842 183.327c.124 0 .374-.133.499-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M79.717 183.46v-5.848h.624v5.715c-.125 0-.375.133-.624.133zm.124-5.716v5.583c.125 0 .25 0 .375-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M81.588 182.795c.125-.132.374-.132.499-.265v-4.918h-.5v5.183z"
            fill="#0EA59D"
            />
            <path
            d="M81.588 182.928v-5.316h.624v5.051c-.25 0-.375.132-.624.265zm.125-5.184v5.051c.124 0 .25-.132.374-.132v-4.786h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M71.732 183.061c.125 0 .375.133.5.133v-5.582h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M72.356 183.327c-.25-.133-.499-.133-.624-.133v-5.45h.624v5.583zm-.624-.399c.125 0 .25.133.375.133v-5.449h-.375v5.316z"
            fill="#131A2D"
            />
            <path d="M75.35 183.725h.499v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M75.973 183.858h-.623v-6.513h.623v6.513zm-.623-.266h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M76.225 177.345v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M76.474 183.858h-.249v-6.513h.748v6.513h-.499zm-.25-.133h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M68.115 179.871c0 .399.25.931.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M68.739 181.333l-.125-.133c-.374-.398-.499-.797-.624-1.196v-2.392h.749v3.721zm-.624-1.595c0 .399.125.798.499 1.197v-3.191h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M84.332 180.934c.25-.399.374-.798.499-1.064v-2.127h-.499v3.191z"
            fill="#0EA59D"
            />
            <path
            d="M84.207 181.067v-3.589h.624v2.259c0 .399-.25.665-.5 1.064l-.124.266zm.125-3.323v3.057c.25-.266.25-.665.374-.931v-1.993h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M69.861 182.13c.125.133.375.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M70.485 182.529c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.399c.125.133.25.133.374.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M74.478 183.592h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M74.977 183.725h-.624v-6.247h.624v6.247zm-.499-.133h.375v-6.114h-.375v6.114z"
            fill="#131A2D"
            />
            <path
            d="M70.86 182.661c.124.133.374.133.498.266v-5.184h-.499v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M71.358 182.928c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.499-.399c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M72.606 183.327c.124 0 .374.133.499.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M73.23 183.46c-.25 0-.5-.133-.624-.133v-5.715h.623v5.848zm-.5-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M73.478 183.459c.125 0 .375 0 .5.133v-6.114c-.125 0-.375 0-.5.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M74.102 183.592c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .375 0 .5-.133h.124v6.247zm-.499-.133c.125 0 .25 0 .375.133v-5.848c-.125 0-.25 0-.375.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M76.474 173.357c-4.866 0-8.359 2.127-8.359 3.988 0 1.861 3.493 3.988 8.359 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.493-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M76.474 181.599c-4.99 0-8.359-2.127-8.359-4.121 0-1.994 3.493-4.121 8.359-4.121 4.865 0 8.358 2.127 8.358 4.121 0 1.861-3.493 4.121-8.358 4.121zm0-8.109c-4.866 0-8.234 2.127-8.234 3.988 0 1.861 3.368 3.988 8.234 3.988 4.865 0 8.233-2.127 8.233-3.988 0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M70.984 180.535c.5.266 1.123.399 1.747.665l6.861-7.311c-.624-.133-1.372-.266-2.12-.266l-6.488 6.912zM75.725 181.466H76.972l5.988-6.381c-.25-.133-.499-.398-.873-.531l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M73.73 181.067c-.125 0-.25 0-.5-.133-.249-.133-.623-.133-.873-.266s-.623-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.124 0-.124 0-.25-.133l-.748-.399c-.499-.265-.998-.664-1.497-1.063.375.532.749 1.063 1.248 1.329.124.133.25.133.374.266.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.499.133.249.132.623.132.873.132s.624 0 .873.133h.873c-.25-.133-.624-.133-.873-.265h-.25zM77.97 181.2l-1.248.133h-.624c-.25 0-.374 0-.623.133.25 0 .374.133.623.133H77.97c.374 0 .873-.133 1.247-.266l1.123-.398h-1.248c-.374.132-.748.132-1.122.265zM79.468 174.021c-1.123 0-2.121.133-2.994.266h-5.365v2.127c.125 1.861 3.493 3.988 8.359 3.988 4.865 0 8.233-1.994 8.358-3.988v-2.127h-5.364c-.998-.133-1.996-.266-2.994-.266z"
            fill="#fff"
            />
            <path
            d="M79.468 180.535c-4.866 0-8.234-1.994-8.359-3.988v-2.392h5.49c.997-.133 1.995-.266 2.993-.266.998 0 1.996.133 2.994.266h5.49v2.392c-.5 1.994-3.868 3.988-8.608 3.988zm-8.359-4.121c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.109-1.994 8.233-3.855v-2.127h-5.24c-.997-.132-1.995-.265-2.993-.265-.998 0-1.996.133-2.994.265h-5.24v2.127z"
            fill="#000"
            />
            <path
            d="M71.982 178.143c.125.133.375.266.5.399v-4.254h-.5v3.855z"
            fill="#fff"
            />
            <path
            d="M72.606 178.807c-.374-.265-.499-.398-.624-.531v-3.988h.624v4.519zm-.499-.664c.125.133.25.266.374.266v-3.988h-.374v3.722z"
            fill="#000"
            />
            <path
            d="M81.963 174.287v5.982c.125 0 .374 0 .499-.133v-5.849h-.5z"
            fill="#fff"
            />
            <path
            d="M81.838 180.402v-6.248h.125v.133-.133c.124 0 .374 0 .499.133h.124v5.982h-.124c-.125 0-.375 0-.624.133zm.125-6.115v5.849c.124 0 .25 0 .374-.133v-5.716c-.125.133-.25.133-.374 0z"
            fill="#000"
            />
            <path d="M80.965 180.402h.499v-6.114h-.5v6.114z" fill="#fff" />
            <path
            d="M80.965 180.402v-6.381h.748v6.248h-.124c-.25.133-.375.133-.624.133zm.125-6.248v6.115h.374v-5.982c-.125 0-.25 0-.374-.133z"
            fill="#000"
            />
            <path
            d="M85.58 179.073c.125-.133.374-.266.5-.266v-4.519h-.5v4.785z"
            fill="#fff"
            />
            <path
            d="M85.455 179.206v-4.918h.624v4.519c-.125.133-.374.266-.624.399zm.125-4.785v4.519c.125-.133.25-.133.374-.266v-4.386h-.374v.133z"
            fill="#000"
            />
            <path d="M80.092 180.402h.499v-6.248h-.5v6.248z" fill="#fff" />
            <path
            d="M80.092 180.535v-6.514h.748v6.514h-.748zm.124-6.381v6.248h.375v-6.115c-.125-.133-.25-.133-.374-.133z"
            fill="#000"
            />
            <path
            d="M86.453 178.541a1.72 1.72 0 00.5-.398v-3.722h-.5v4.12z"
            fill="#fff"
            />
            <path
            d="M86.328 178.674v-4.386h.749v3.855c-.25.133-.375.266-.749.531zm.125-4.253v3.988l.374-.399v-3.589h-.374z"
            fill="#000"
            />
            <path
            d="M83.709 179.871c.125 0 .374-.133.499-.133v-5.317h-.499v5.45z"
            fill="#fff"
            />
            <path
            d="M83.584 180.004v-5.716h.624v5.45c-.125 0-.25.133-.624.266zm.25-5.583v5.317c.124 0 .249-.133.374-.133v-5.184h-.374z"
            fill="#000"
            />
            <path
            d="M82.836 180.136c.125 0 .374-.132.499-.132v-5.583h-.5v5.715z"
            fill="#fff"
            />
            <path
            d="M82.71 180.136v-5.982h.625v5.716a.923.923 0 01-.624.266zm.126-5.716v5.583c.124 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#000"
            />
            <path
            d="M84.582 179.471c.125-.133.374-.133.499-.266v-4.918h-.499v5.184z"
            fill="#fff"
            />
            <path
            d="M84.582 179.604v-5.45h.624v5.051c-.25.266-.374.266-.624.399zm.125-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#000"
            />
            <path
            d="M74.727 179.738c.124 0 .374.133.499.133v-5.583h-.5v5.45z"
            fill="#fff"
            />
            <path
            d="M75.35 180.004c-.25-.133-.499-.133-.623-.133v-5.583h.623v5.716zm-.499-.399c.125 0 .25.133.375.133v-5.317h-.375v5.184z"
            fill="#000"
            />
            <path d="M78.346 180.402h.499v-6.38h-.5v6.38z" fill="#fff" />
            <path
            d="M78.97 180.535h-.749v-6.514h.748v6.514zm-.624-.266h.374v-6.248h-.374v6.248z"
            fill="#000"
            />
            <path d="M79.219 174.021v6.381h.624v-6.381h-.625z" fill="#fff" />
            <path
            d="M79.468 180.535c-.124 0-.124 0 0 0h-.25v-6.514h.75v6.514h-.5zm-.124-.133h.374v-6.248h-.374v6.248z"
            fill="#000"
            />
            <path
            d="M71.11 176.548c0 .398.249.93.623 1.329v-3.456h-.624v2.127z"
            fill="#fff"
            />
            <path
            d="M71.733 178.01l-.125-.133c-.374-.399-.499-.798-.624-1.196v-2.393h.749v3.722zm-.624-1.595c0 .399.125.797.374 1.196v-3.19h-.374v1.994z"
            fill="#000"
            />
            <path
            d="M87.328 177.611c.25-.399.374-.798.5-1.063v-2.127h-.5v3.19z"
            fill="#fff"
            />
            <path
            d="M87.203 177.877v-3.589h.624v2.393c0 .398-.25.664-.5 1.063l-.124.133zm.25-3.456v2.924c.124-.266.25-.531.25-.797v-2.127h-.25z"
            fill="#000"
            />
            <path
            d="M72.856 178.807c.124.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#fff"
            />
            <path
            d="M73.48 179.339c-.25-.133-.5-.266-.624-.399v-4.652h.623v5.051zm-.5-.532c.125.133.25.133.374.266v-4.652h-.374v4.386z"
            fill="#000"
            />
            <path d="M77.473 180.269h.499v-6.248h-.5v6.248z" fill="#fff" />
            <path
            d="M77.971 180.402h-.748v-6.248h.748v6.248zm-.499-.133h.374v-6.115h-.374v6.115z"
            fill="#000"
            />
            <path
            d="M73.853 179.339c.125.133.375.133.5.266v-5.184h-.5v4.918z"
            fill="#fff"
            />
            <path
            d="M74.477 179.738c-.25-.133-.499-.133-.624-.266v-5.184h.624v5.45zm-.624-.399c.125 0 .25.133.375.133v-5.051h-.374v4.918z"
            fill="#000"
            />
            <path
            d="M75.6 180.004c.124 0 .374.132.499.132v-5.715h-.5v5.583z"
            fill="#fff"
            />
            <path
            d="M76.223 180.136c-.25 0-.499-.133-.623-.133v-5.849h.623v5.982zm-.499-.266c.125 0 .25 0 .375.133v-5.583h-.375v5.45z"
            fill="#000"
            />
            <path
            d="M76.473 180.136c.124 0 .374 0 .499.133v-6.115c-.125 0-.375 0-.5.133v5.849z"
            fill="#fff"
            />
            <path
            d="M77.096 180.402c-.25 0-.499-.133-.624-.133h-.124v-5.982h.124c.125 0 .375 0 .5-.133h.124v6.248zm-.499-.266h.374v-5.849h-.374v5.849z"
            fill="#000"
            />
            <path
            d="M79.468 170.167c-4.866 0-8.359 2.127-8.359 3.988 0 1.861 3.493 3.987 8.359 3.987 4.865 0 8.358-2.126 8.358-3.987 0-1.861-3.493-3.988-8.358-3.988z"
            fill="#fff"
            />
            <path
            d="M79.467 178.275c-4.99 0-8.483-2.126-8.483-4.12 0-1.994 3.493-4.121 8.483-4.121s8.483 2.127 8.483 4.121c0 1.994-3.617 4.12-8.483 4.12zm0-8.108c-4.865 0-8.233 2.127-8.233 3.988 0 1.861 3.368 3.987 8.233 3.987 4.866 0 8.234-2.126 8.234-3.987 0-1.861-3.368-3.988-8.234-3.988z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M73.978 177.212c.5.266 1.123.398 1.747.664l6.861-7.31c-.623-.133-1.372-.266-2.12-.266l-6.487 6.912zM78.719 178.142H79.966l5.988-6.38c-.25-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#9CD6CB"
            />
            <path
            d="M81.837 184.789c-1.123 0-2.121.133-2.994.266h-5.365v2.127c.125 1.861 3.494 3.988 8.359 3.988s8.233-1.994 8.358-3.988v-2.127h-5.364c-.874-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M81.837 191.303c-4.865 0-8.234-1.994-8.359-3.988v-2.393h5.49c.998-.133 1.995-.266 2.993-.266.999 0 1.996.133 2.995.266h5.364v2.26c-.25 1.994-3.618 4.121-8.483 4.121zm-8.234-4.121c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-1.994h-5.24c-.997-.133-1.995-.266-2.993-.266-.998 0-1.996.133-2.994.266h-5.365v1.994h.125z"
            fill="#131A2D"
            />
            <path
            d="M74.477 188.91c.124.133.374.265.499.398v-4.253h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M75.1 189.441c-.25-.265-.499-.398-.623-.531v-3.988h.623v4.519zm-.623-.531l.374.398v-4.12h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M84.332 184.922v5.982c.125 0 .374 0 .499-.133v-5.849c-.125.133-.25.133-.499 0z"
            fill="#0EA59D"
            />
            <path
            d="M84.332 191.036v-6.114h.125c.125 0 .25 0 .374.133h.125v5.981h-.624zm.125-5.981v5.849c.125 0 .25 0 .374-.133v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M83.459 191.037h.499v-6.115h-.499v6.115z" fill="#0EA59D" />
            <path
            d="M83.459 191.17v-6.381h.624v6.248c-.25.133-.374.133-.624.133zm.125-6.248v6.115h.374v-5.982c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M87.95 189.84c.124-.133.373-.266.498-.266v-4.519h-.499v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M87.95 189.973v-4.918h.623v4.519c-.25.133-.374.266-.624.399zm.124-4.918v4.652c.125-.133.25-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M82.584 191.17h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M82.459 191.17v-6.514h.624v6.381c-.125.133-.374.133-.624.133zm.125-6.248v6.248h.374v-6.115c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M88.822 189.309c.25-.133.374-.266.5-.399v-3.722h-.5v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M88.822 189.441v-4.386h.624v3.855c-.125.133-.374.265-.624.531zm.125-4.386v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M86.203 190.505c.125 0 .374-.133.5-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M86.078 190.638v-5.716h.624v5.45a.923.923 0 01-.624.266zm.125-5.583v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M85.205 190.771c.125 0 .374-.133.5-.133v-5.583h-.5v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M85.205 190.903v-5.848h.624v5.716c-.25 0-.374 0-.624.132zm.125-5.848v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M87.076 190.239c.125-.133.374-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M86.951 190.372v-5.317h.624v5.051c-.125 0-.25.133-.624.266zm.125-5.317v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M77.22 190.372c.126 0 .375.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M77.72 190.638c-.25-.133-.5-.133-.624-.133v-5.45h.623v5.583zm-.5-.266c.125 0 .25.133.375.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M80.713 191.17h.499v-6.381h-.5v6.381z" fill="#0EA59D" />
            <path
            d="M81.337 191.17h-.624v-6.514h.624v6.514zm-.5-.133h.375v-6.248h-.374v6.248z"
            fill="#131A2D"
            />
            <path d="M81.713 184.789v6.381h.624v-6.381h-.625z" fill="#0EA59D" />
            <path
            d="M81.837 191.302h-.25v-6.513h.875v6.513h-.625zm-.124-.265h.374v-6.248h-.375v6.248z"
            fill="#131A2D"
            />
            <path
            d="M73.478 187.182c0 .398.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M74.102 188.644l-.125-.133c-.374-.399-.499-.798-.624-1.196v-2.393h.749v3.722zm-.499-1.462c0 .399.125.797.499 1.196v-3.19h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M89.82 188.378c.25-.399.375-.798.5-1.064v-2.126h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M89.695 188.511v-3.589h.624v2.26c0 .399-.25.664-.499 1.063l-.125.266zm.125-3.456v3.057c.25-.266.25-.664.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M75.35 189.574c.124.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M75.973 189.973c-.25-.133-.499-.266-.623-.399v-4.652h.623v5.051zm-.499-.399c.125.133.25.133.375.266v-4.652h-.375v4.386z"
            fill="#131A2D"
            />
            <path d="M79.84 191.037h.499v-6.248h-.5v6.248z" fill="#0EA59D" />
            <path
            d="M80.464 191.17h-.624v-6.248h.624v6.248zm-.5-.133h.375v-6.115h-.374v6.115z"
            fill="#131A2D"
            />
            <path
            d="M76.223 190.106c.124.133.374.133.499.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M76.846 190.372c-.25-.133-.499-.133-.623-.266v-5.184h.623v5.45zm-.499-.399c.125 0 .25.133.375.133v-5.051h-.375v4.918z"
            fill="#131A2D"
            />
            <path
            d="M78.094 190.638c.125 0 .374.133.499.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M78.593 190.903c-.25 0-.375-.132-.624-.132v-5.716h.624v5.848zm-.5-.265c.125 0 .25 0 .375.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M78.967 190.904c.124 0 .374 0 .499.133v-6.115c-.125 0-.374 0-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M79.59 191.037c-.249 0-.374-.133-.623-.133v-5.982c.124 0 .374 0 .499-.133h.125v6.248zm-.623-.133c.124 0 .25 0 .374.133v-5.849c-.125 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M81.837 180.802c-4.865 0-8.359 2.126-8.359 3.987 0 1.861 3.494 3.988 8.359 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M81.837 189.043c-4.99 0-8.359-2.127-8.359-4.121 0-1.994 3.494-4.12 8.359-4.12s8.358 2.126 8.358 4.12c.125 1.861-3.368 4.121-8.358 4.121zm0-8.108c-4.865 0-8.234 2.126-8.234 3.987 0 1.861 3.369 3.988 8.234 3.988s8.233-2.127 8.233-3.988c.125-1.861-3.368-3.987-8.233-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M76.473 187.846c.499.266 1.122.399 1.746.665l6.861-7.311c-.623-.133-1.372-.265-2.12-.265l-6.487 6.911zM81.213 188.91H82.46l5.988-6.38c-.25-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M79.216 188.511c-.125 0-.25 0-.5-.133-.249-.133-.623-.133-.872-.266-.25-.133-.624-.133-.874-.266-.124 0-.25-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.398c-.5-.266-.998-.665-1.497-1.064.374.532.748 1.064 1.247 1.33.125.132.25.132.374.265.125.133.25.133.375.266.124 0 .124.133.25.133l.249.133c.124 0 .25.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .873.133h.874c-.25-.133-.624-.133-.874-.266h-.25zM83.333 188.645l-1.248.133h-.623c-.25 0-.375 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.247-.266l1.123-.399h-1.247c-.25.133-.749.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M72.854 181.864c-1.122 0-2.12.133-2.994.266h-5.364v2.127c.125 1.861 3.493 3.987 8.358 3.987 4.866 0 8.234-1.993 8.359-3.987v-2.127h-5.365c-.998-.133-1.996-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M72.854 188.377c-4.865 0-8.233-1.993-8.358-3.987v-2.393h5.49c.997-.133 1.995-.266 2.993-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.374 2.127-3.742 4.12-8.483 4.12zm-8.358-4.12c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.108-1.994 8.233-3.855v-1.994h-5.115c-.998-.133-1.996-.266-2.994-.266-.998 0-1.996.133-2.994.266h-5.364v1.994z"
            fill="#131A2D"
            />
            <path
            d="M65.37 185.985c.124.133.373.265.498.398v-4.253h-.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M65.993 186.649c-.25-.266-.5-.399-.624-.531v-3.988h.624v4.519zm-.5-.664c.126.133.25.265.375.265v-4.12h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M75.35 182.13v5.981c.124 0 .374 0 .499-.133v-5.848h-.5z"
            fill="#0EA59D"
            />
            <path
            d="M75.225 188.111v-6.114h.124c.125 0 .25 0 .375.133h.124v5.981h-.623zm.124-5.981v5.849c.125 0 .25 0 .375-.133v-5.716c-.125.133-.25 0-.375 0z"
            fill="#131A2D"
            />
            <path d="M74.352 188.244h.499v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M74.352 188.244v-6.38h.624v6.248c-.25.132-.375.132-.624.132zm.124-6.247v6.115h.375v-5.982c-.125 0-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M78.967 186.915c.124-.133.374-.266.499-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M78.842 187.048v-4.918h.624v4.519c-.125.133-.375.266-.624.399zm.124-4.785v4.652c.125-.133.25-.133.375-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M73.478 188.244h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M73.478 188.377v-6.513h.625v6.38c-.25.133-.375.133-.624.133zm.125-6.38v6.247h.375v-6.114c-.125-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M79.84 186.383c.25-.133.374-.266.499-.399v-3.721h-.5v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M79.715 186.516v-4.386h.624v3.855c-.125.133-.25.265-.624.531zm.125-4.253v3.987l.374-.398v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M77.096 187.712c.124 0 .374-.132.499-.132v-5.317h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M77.096 187.713v-5.716h.623v5.45c-.249.133-.374.266-.623.266zm.124-5.45v5.317c.125 0 .25-.133.375-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M76.223 187.978c.124 0 .374-.133.499-.133v-5.582h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M76.098 187.978v-5.848h.623v5.715c-.124 0-.374.133-.623.133zm.124-5.715v5.582c.125 0 .25 0 .375-.132v-5.45h-.375z"
            fill="#131A2D"
            />
            <path
            d="M77.969 187.314c.125-.133.374-.133.499-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M77.969 187.447v-5.317h.624v5.051c-.25.133-.375.133-.624.266zm.125-5.184v5.051c.124 0 .249-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M68.113 187.58c.125 0 .374.133.5.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M68.737 187.845c-.25-.132-.499-.132-.624-.132v-5.45h.624v5.582zm-.624-.398c.125 0 .25.133.374.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M71.732 188.244h.5v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M72.356 188.377h-.624v-6.513h.624v6.513zm-.624-.133h.375v-6.247h-.375v6.247z"
            fill="#131A2D"
            />
            <path d="M72.606 181.864v6.38h.623v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M72.855 188.377h-.249v-6.513h.873v6.513h-.624zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M64.496 184.389c0 .399.25.931.624 1.33v-3.456h-.624v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M65.12 185.852l-.125-.133c-.374-.399-.5-.798-.624-1.197v-2.392h.749v3.722zm-.624-1.595c0 .398.125.797.499 1.196v-3.19h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M80.715 185.453c.25-.399.374-.798.499-1.064v-2.126h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M80.59 185.719v-3.589h.624v2.26c0 .398-.25.664-.5 1.063l-.124.266zm.125-3.456v3.057c.124-.266.25-.665.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M66.242 186.649c.125.133.374.266.5.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M66.866 187.181c-.25-.133-.5-.266-.624-.399v-4.652h.624v5.051zm-.5-.532c.126.133.25.133.375.266v-4.652h-.374v4.386z"
            fill="#131A2D"
            />
            <path d="M70.86 188.112h.498v-6.248h-.499v6.248z" fill="#0EA59D" />
            <path
            d="M71.358 188.244h-.624v-6.247h.749v6.247h-.125zm-.499-.133h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M67.242 187.181c.125.133.374.133.5.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M67.74 187.447c-.249-.133-.498-.133-.623-.266v-5.184h.624v5.45zm-.498-.266c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M68.988 187.845c.125 0 .374.133.5.133v-5.715h-.5v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M69.612 187.978c-.25 0-.499-.133-.624-.133v-5.715h.624v5.848zm-.499-.265c.125 0 .25 0 .374.132v-5.582h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M69.861 187.979c.125 0 .375 0 .5.132v-6.114c-.125 0-.375 0-.5.133v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M70.485 188.244c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .375 0 .5-.133h.124v6.247zm-.499-.265c.125 0 .25 0 .374.132v-5.848c-.124 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M72.854 178.01c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.493 3.988 8.358 3.988 4.866 0 8.359-2.127 8.359-3.988 0-1.861-3.493-3.987-8.359-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M72.854 186.118c-4.99 0-8.358-2.127-8.358-4.121 0-1.993 3.493-4.12 8.358-4.12 4.99 0 8.359 2.127 8.359 4.12 0 1.994-3.493 4.121-8.359 4.121zm0-8.108c-4.865 0-8.233 2.127-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988 0-1.86-3.368-3.987-8.234-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M67.365 185.055c.5.266 1.123.398 1.747.664l6.861-7.31c-.624-.133-1.372-.266-2.12-.266l-6.488 6.912zM72.107 185.985h1.248l5.988-6.38c-.25-.133-.5-.399-.873-.532l-6.363 6.912z"
            fill="#fff"
            />
            <path
            d="M70.11 185.719c-.124 0-.25 0-.499-.133-.25-.133-.623-.133-.873-.266s-.624-.133-.873-.266c-.125 0-.25-.133-.374-.133l-.25-.133c-.125 0-.125 0-.25-.133l-.748-.398c-.499-.266-.998-.665-1.497-1.064.374.532.749 1.064 1.248 1.33.124.132.25.132.374.265.125.133.25.133.374.266.125 0 .125.133.25.133l.25.133c.124 0 .249.133.373.133l.5.133c.124 0 .249.133.498.133.25.133.624.133.874.133s.623 0 .873.133h.873c-.25-.133-.624-.133-.873-.266h-.25zM74.35 185.719l-1.247.133h-.624c-.25 0-.374 0-.623.133.249 0 .374.133.623.133H74.351c.374 0 .873-.133 1.247-.266l1.123-.399h-1.248c-.374.133-.748.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M64.622 180.003c-1.123 0-2.12.133-2.994.266h-5.364v2.127c.124 1.861 3.493 3.987 8.358 3.987s8.233-1.993 8.358-3.987v-2.127h-5.364c-.873-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M64.622 186.516c-4.865 0-8.234-1.994-8.358-3.987v-2.393h5.489c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.364v2.26c-.25 2.126-3.618 4.12-8.483 4.12zm-8.234-3.987c.125 1.86 3.493 3.854 8.234 3.854 4.74 0 8.109-1.994 8.233-3.854v-1.994h-5.24c-.997-.133-1.995-.266-2.993-.266-.998 0-1.996.133-2.994.266h-5.364v1.994h.124z"
            fill="#131A2D"
            />
            <path
            d="M57.262 184.123c.124.133.374.266.499.399v-4.253h-.5v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M57.886 184.788c-.25-.266-.5-.399-.624-.532v-3.987h.623v4.519zm-.624-.665l.374.399v-4.121h-.374v3.722z"
            fill="#131A2D"
            />
            <path
            d="M67.117 180.269v5.981c.125 0 .374 0 .5-.133v-5.848h-.5z"
            fill="#0EA59D"
            />
            <path
            d="M67.117 186.383v-6.114h.125c.125 0 .25 0 .374.132h.125v5.982c-.25-.133-.374-.133-.624 0zm.125-6.114v5.848c.125 0 .25 0 .374-.133v-5.715c-.125.132-.25.132-.374 0z"
            fill="#131A2D"
            />
            <path d="M66.244 186.384h.5v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M66.12 186.383v-6.38h.623v6.247c-.125.133-.374.133-.624.133zm.249-6.114v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M70.734 185.054c.125-.133.375-.266.5-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M70.734 185.187v-4.918h.624v4.519c-.25.133-.374.266-.624.399zm.125-4.786v4.653c.125-.133.25-.133.374-.266v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M65.371 186.383h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M65.246 186.516v-6.513h.624v6.38c-.125.133-.374.133-.624.133zm.125-6.38v6.247h.374v-6.114c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M71.607 184.522c.25-.133.375-.266.5-.399v-3.722h-.5v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M71.607 184.655v-4.386h.624v3.854c-.125.133-.374.266-.624.532zm.125-4.254v3.988l.374-.399v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M68.988 185.851c.125 0 .374-.133.5-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M68.863 185.984v-5.715h.624v5.449c-.125.133-.374.133-.624.266zm.125-5.583v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M67.99 186.117c.125 0 .375-.133.5-.133v-5.583h-.5v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M67.99 186.117v-5.848h.624v5.715c-.25.133-.374.133-.624.133zm.125-5.716v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M69.861 185.452c.125-.133.375-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M69.736 185.585v-5.316h.624v5.051c-.125.132-.25.132-.624.265zm.125-5.184v5.051c.125 0 .25-.132.374-.132v-4.786h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M59.88 185.718c.126 0 .375.133.5.133v-5.582h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M60.505 185.984c-.25-.133-.5-.133-.624-.133v-5.45h.624v5.583zm-.5-.266c.125 0 .25.133.375.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M63.498 186.383h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M64.122 186.516h-.624v-6.513h.624v6.513zm-.5-.133h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M64.498 180.003v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M64.623 186.516h-.25v-6.513h.874v6.513h-.624zm-.125-.133h.374v-6.247h-.375v6.247z"
            fill="#131A2D"
            />
            <path
            d="M56.264 182.528c0 .399.25.931.623 1.329v-3.456h-.623v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M56.887 183.99l-.125-.133c-.374-.398-.499-.797-.623-1.196v-2.392h.748v3.721zm-.499-1.595c0 .399.125.798.5 1.197v-3.191h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M72.606 183.591c.249-.398.374-.797.499-1.063v-2.127h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M72.48 183.857v-3.588h.624v2.259c0 .399-.25.665-.499 1.064l-.124.265zm.125-3.456v3.058c.25-.266.25-.665.374-.931v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M58.135 184.921c.125.133.374.266.499.266v-4.786h-.5v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M58.758 185.32c-.249-.133-.498-.266-.623-.399v-4.652h.623v5.051zm-.498-.532c.124.133.249.133.374.266v-4.653h-.374v4.387z"
            fill="#131A2D"
            />
            <path d="M62.627 186.383h.499v-6.247h-.499v6.247z" fill="#0EA59D" />
            <path
            d="M63.25 186.516h-.623v-6.247h.749v6.247h-.125zm-.498-.266h.374v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M59.008 185.319c.125.133.374.133.499.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M59.632 185.718c-.25-.133-.5-.133-.624-.266v-5.183h.624v5.449zm-.5-.398c.125 0 .25.132.375.132v-5.051h-.374v4.919z"
            fill="#131A2D"
            />
            <path
            d="M60.879 185.984c.125 0 .374.133.499.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M61.378 186.25c-.25 0-.375-.133-.624-.133v-5.716h.624v5.849zm-.5-.266c.125 0 .25 0 .375.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M61.752 186.117c.125 0 .374 0 .499.133v-6.114c-.125 0-.374 0-.499.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M62.376 186.383c-.25 0-.374-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.624-.266c.125 0 .25 0 .374.133v-5.848c-.124 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M64.622 176.149c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M64.622 184.257c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.493-4.12 8.358-4.12 4.99 0 8.358 2.126 8.358 4.12 0 1.994-3.368 4.121-8.358 4.121zm0-8.108c-4.865 0-8.234 2.126-8.234 3.987 0 1.861 3.369 3.988 8.234 3.988s8.233-2.127 8.233-3.988c0-1.861-3.368-3.987-8.233-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M59.258 183.194c.499.266 1.123.399 1.746.664l6.862-7.31c-.624-.133-1.373-.266-2.121-.266l-6.487 6.912zM63.998 184.257h1.248l5.988-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M62.001 183.859c-.124 0-.25 0-.374-.133-.25-.133-.624-.133-.873-.266-.25-.133-.624-.133-.873-.266-.125 0-.25-.133-.375-.133l-.25-.133c-.124 0-.124 0-.249-.133l-.748-.399c-.5-.265-.998-.664-1.497-1.063.374.532.748 1.063 1.247 1.329.125.133.25.133.374.266.125.133.25.133.375.266.124 0 .124.133.25.133l.249.133c.125 0 .25.133.374.133l.499.133c.125 0 .25.133.499.133.25.132.624.132.873.132.25 0 .624 0 .873.133h.874c-.25-.133-.624-.133-.873-.265H62zM66.118 183.858l-1.247.133h-.624c-.25 0-.374 0-.624.132.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.265l1.122-.399h-1.247c-.25.266-.749.266-1.123.266z"
            fill="#fff"
            />
            <path
            d="M61.878 175.884c-1.123 0-2.121.132-2.994.265H53.52v2.127c.124 1.861 3.492 3.988 8.358 3.988 4.865 0 8.233-1.994 8.358-3.988v-2.127h-5.364c-.873-.265-1.871-.265-2.994-.265z"
            fill="#0EA59D"
            />
            <path
            d="M61.878 182.263c-4.865 0-8.234-1.994-8.358-3.987v-2.393h5.488c.998-.133 1.996-.266 2.994-.266.998 0 1.996.133 2.994.266h5.365v2.26c-.25 2.126-3.618 4.12-8.483 4.12zm-8.234-3.987c.125 1.86 3.493 3.854 8.234 3.854 4.74 0 8.109-1.994 8.233-3.854v-1.994h-5.24c-.997-.133-1.995-.266-2.993-.266-.998 0-1.996.133-2.994.266H53.52v1.994h.124z"
            fill="#131A2D"
            />
            <path
            d="M54.518 180.004c.124.133.374.266.499.399v-4.254h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M55.141 180.535c-.25-.266-.499-.399-.623-.532v-3.987h.623v4.519zm-.623-.532c.124.133.25.266.374.266v-4.12h-.374v3.854z"
            fill="#131A2D"
            />
            <path
            d="M64.373 176.016v5.981c.125 0 .374 0 .499-.133v-5.848c-.125.133-.25 0-.499 0z"
            fill="#0EA59D"
            />
            <path
            d="M64.373 182.13v-6.114h.125v.133-.133c.124 0 .374 0 .499.133h.124v5.981c-.374-.133-.498 0-.748 0zm.125-5.981v5.848c.124 0 .25 0 .374-.133v-5.715h-.374z"
            fill="#131A2D"
            />
            <path d="M63.5 182.13h.499v-6.114H63.5v6.114z" fill="#0EA59D" />
            <path
            d="M63.5 182.263v-6.38h.624v6.247c-.25 0-.374.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M67.99 180.934c.125-.133.375-.266.5-.266v-4.52h-.5v4.786z"
            fill="#0EA59D"
            />
            <path
            d="M67.99 181.067v-4.919h.624v4.52c-.25.133-.374.133-.624.399zm.125-4.919v4.653c.125-.133.25-.133.374-.266v-4.387h-.374z"
            fill="#131A2D"
            />
            <path d="M62.627 182.263h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M62.502 182.263v-6.513h.749v6.38c-.25.133-.5.133-.749.133zm.125-6.38v6.247H63v-6.114c0-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M68.863 180.27c.25-.133.374-.266.5-.399v-3.722h-.5v4.121z"
            fill="#0EA59D"
            />
            <path
            d="M68.863 180.402v-4.386h.624v3.854c-.125.133-.374.399-.624.532zm.125-4.253v3.987l.374-.399v-3.588h-.374z"
            fill="#131A2D"
            />
            <path
            d="M66.244 181.599c.125 0 .374-.133.5-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M66.12 181.731v-5.715h.623v5.449c-.125.133-.374.133-.624.266zm.124-5.582v5.316c.125 0 .25-.133.374-.133v-5.183h-.374z"
            fill="#131A2D"
            />
            <path
            d="M65.371 181.864c.125 0 .374-.133.5-.133v-5.583h-.5v5.716z"
            fill="#0EA59D"
            />
            <path
            d="M65.246 181.997v-5.849h.624v5.716c-.25 0-.374 0-.624.133zm.125-5.849v5.583c.125 0 .25 0 .374-.133v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M67.117 181.332c.125-.133.374-.133.5-.265v-4.919h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M66.992 181.465v-5.317h.624v5.051c-.125 0-.25.133-.624.266zm.125-5.317v5.051c.125 0 .25-.132.374-.132v-4.786h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M57.262 181.465c.124 0 .374.133.499.133v-5.582h-.5v5.449z"
            fill="#0EA59D"
            />
            <path
            d="M57.76 181.732c-.249-.133-.498-.133-.623-.133v-5.45h.623v5.583zm-.498-.266c.124 0 .249.133.374.133v-5.45h-.375v5.317z"
            fill="#131A2D"
            />
            <path d="M60.756 182.263h.499v-6.38h-.5v6.38z" fill="#0EA59D" />
            <path
            d="M61.38 182.263h-.624v-6.38h.624v6.38zm-.5-.133h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M61.754 175.883v6.38h.624v-6.38h-.625z" fill="#0EA59D" />
            <path
            d="M61.878 182.263h-.249v-6.513h.748v6.513h-.499zm-.124-.133h.374v-6.247h-.499v6.247h.125z"
            fill="#131A2D"
            />
            <path
            d="M53.52 178.276c0 .399.249.931.623 1.329v-3.456h-.623v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M54.143 179.737l-.125-.133c-.374-.398-.499-.797-.623-1.196v-2.392h.748v3.721zm-.499-1.462c0 .399.125.798.499 1.197v-3.191h-.499v1.994z"
            fill="#131A2D"
            />
            <path
            d="M69.861 179.472c.25-.399.375-.797.5-1.063v-2.127h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M69.736 179.604v-3.588h.624v2.259c0 .399-.25.665-.499 1.064l-.125.265zm.125-3.455v3.057c.25-.266.25-.665.374-.931v-1.994h-.374v-.132z"
            fill="#131A2D"
            />
            <path
            d="M55.39 180.669c.125.133.375.266.5.266v-4.786h-.5v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M56.014 181.067c-.25-.133-.499-.266-.623-.399v-4.652h.623v5.051zm-.499-.399c.125.133.25.133.375.266v-4.653h-.375v4.387z"
            fill="#131A2D"
            />
            <path d="M59.883 182.13h.499v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M60.507 182.263h-.624v-6.38h.624v6.38zm-.5-.266h.375v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M56.264 181.2c.124.133.374.133.499.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M56.887 181.465c-.25-.133-.499-.133-.623-.265v-5.184h.623v5.449zm-.499-.398c.125 0 .25.133.375.133v-5.051h-.375v4.918z"
            fill="#131A2D"
            />
            <path
            d="M58.135 181.731c.125 0 .374.133.499.133v-5.716h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M58.758 181.997c-.249 0-.374-.133-.623-.133v-5.716h.623v5.849zm-.623-.266c.125 0 .25 0 .374.133v-5.583h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M59.008 181.997c.125 0 .374 0 .499.133v-6.114c-.125 0-.374 0-.5.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M59.632 182.13c-.25 0-.375-.133-.624-.133v-5.981c.125 0 .374 0 .499-.133h.125v6.247zm-.5-.266c.125 0 .25 0 .375.133v-5.848c-.125 0-.25 0-.374.133v5.582z"
            fill="#131A2D"
            />
            <path
            d="M61.878 171.896c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.492 3.988 8.358 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.368-3.987-8.358-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M61.878 180.004c-4.99 0-8.358-2.127-8.358-4.121 0-1.994 3.492-4.12 8.358-4.12 4.865 0 8.358 2.126 8.358 4.12.125 1.994-3.368 4.121-8.358 4.121zm0-7.975c-4.865 0-8.234 2.126-8.234 3.987 0 1.861 3.369 3.988 8.234 3.988s8.233-2.127 8.233-3.988c.125-1.994-3.368-3.987-8.233-3.987z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M56.514 178.941c.499.266 1.122.399 1.746.665l6.861-7.311c-.623-.133-1.372-.266-2.12-.266l-6.487 6.912zM61.254 180.004H62.5l5.988-6.381c-.25-.132-.499-.398-.873-.531l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M59.259 179.605c-.125 0-.25 0-.374-.133-.25-.133-.624-.133-.873-.266-.25-.133-.624-.133-.874-.266-.124 0-.25-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.399c-.5-.265-.998-.664-1.498-1.063.375.532.749 1.063 1.248 1.329.125.133.25.133.374.266.125.133.25.133.375.266.124 0 .124.133.249.133l.25.133c.124 0 .249.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.623.133.873.133s.624 0 .873.132h.873c-.249-.132-.623-.132-.873-.265h-.374zM63.376 179.738l-1.248.132h-.623c-.25 0-.375 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.247-.266l1.123-.398H64.5c-.25.133-.749.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M58.26 172.162c-1.122 0-2.12.133-2.993.266h-5.365v2.126c.125 1.861 3.493 3.988 8.359 3.988 4.865 0 8.233-1.994 8.358-3.988v-2.126h-5.364c-.874-.133-1.872-.266-2.994-.266z"
            fill="#fff"
            />
            <path
            d="M58.26 178.675c-4.865 0-8.233-1.993-8.358-3.987v-2.393h5.49c.997-.133 1.995-.266 2.993-.266.998 0 1.996.133 2.994.266h5.49v2.393c-.375 1.994-3.743 3.987-8.608 3.987zm-8.233-3.987c.125 1.861 3.493 3.854 8.234 3.854 4.74 0 8.108-1.993 8.233-3.854v-2.127h-5.24c-.997-.133-1.995-.266-2.993-.266-.998 0-1.996.133-2.994.266h-5.365v2.127h.125z"
            fill="#000"
            />
            <path
            d="M50.9 176.415c.125.133.375.266.5.399v-4.253h-.5v3.854z"
            fill="#fff"
            />
            <path
            d="M51.524 176.947c-.374-.266-.499-.399-.624-.532v-3.987h.624v4.519zm-.499-.665c.125.133.25.266.374.266v-3.987h-.374v3.721z"
            fill="#000"
            />
            <path
            d="M60.756 172.428v5.981c.125 0 .374 0 .499-.133v-5.848h-.5z"
            fill="#fff"
            />
            <path
            d="M60.756 178.542v-6.247h.125v.133-.133c.124 0 .374 0 .499.133h.124v5.981h-.124c-.25 0-.375 0-.624.133zm.125-5.981v5.848c.124 0 .25 0 .374-.133v-5.715h-.374z"
            fill="#000"
            />
            <path d="M59.883 178.542h.499v-6.114h-.5v6.114z" fill="#fff" />
            <path
            d="M59.883 178.675v-6.38h.748v6.247h-.124c-.25 0-.375 0-.624.133zm.125-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#000"
            />
            <path
            d="M64.373 177.213c.125-.133.374-.266.499-.266v-4.519h-.499v4.785z"
            fill="#fff"
            />
            <path
            d="M64.373 177.346v-4.918h.624v4.519c-.125.133-.374.266-.624.399zm.125-4.785v4.519c.124-.133.25-.133.374-.266v-4.386h-.374v.133z"
            fill="#000"
            />
            <path d="M59.01 178.542h.499v-6.247h-.5v6.247z" fill="#fff" />
            <path
            d="M58.885 178.674v-6.513h.748v6.513h-.748zm.25-6.38v6.248h.373v-6.115c-.124-.133-.249-.133-.374-.133z"
            fill="#000"
            />
            <path
            d="M65.371 176.681c.25-.133.374-.266.5-.398v-3.722h-.5v4.12z"
            fill="#fff"
            />
            <path
            d="M65.246 176.814v-4.386h.624v3.854c-.125.133-.25.266-.624.532zm.125-4.253v3.987l.374-.398v-3.589h-.374z"
            fill="#000"
            />
            <path
            d="M62.627 178.01c.125 0 .374-.133.499-.133v-5.316h-.499v5.449z"
            fill="#fff"
            />
            <path
            d="M62.502 178.143v-5.715h.624v5.449c-.125.133-.25.133-.624.266zm.25-5.582v5.316c.124 0 .249-.132.374-.132v-5.184h-.374z"
            fill="#000"
            />
            <path
            d="M61.754 178.276c.125 0 .374-.133.499-.133v-5.582h-.5v5.715z"
            fill="#fff"
            />
            <path
            d="M61.629 178.409v-5.981h.624v5.715c-.125.133-.375.133-.624.266zm.125-5.848v5.582c.124 0 .25 0 .374-.133v-5.449h-.374z"
            fill="#000"
            />
            <path
            d="M63.5 177.745c.125-.133.374-.133.499-.266v-4.918H63.5v5.184z"
            fill="#fff"
            />
            <path
            d="M63.5 177.745v-5.45h.624v5.051c-.25.266-.374.399-.624.399zm.125-5.184v5.051c.124 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#000"
            />
            <path
            d="M53.645 177.877c.124 0 .374.133.498.133v-5.582h-.498v5.449z"
            fill="#fff"
            />
            <path
            d="M54.268 178.143c-.25-.133-.499-.133-.623-.133v-5.582h.623v5.715zm-.623-.266c.124 0 .249.133.374.133v-5.316h-.374v5.183z"
            fill="#000"
            />
            <path d="M57.264 178.541h.499v-6.38h-.5v6.38z" fill="#fff" />
            <path
            d="M57.762 178.674h-.748v-6.513h.748v6.513zm-.499-.133h.374v-6.247h-.374v6.247z"
            fill="#000"
            />
            <path d="M58.137 172.161v6.381h.623v-6.381h-.624z" fill="#fff" />
            <path
            d="M58.261 178.674h-.25v-6.513h.75v6.513h-.5zm-.125-.133h.375v-6.247h-.375v6.247z"
            fill="#000"
            />
            <path
            d="M49.902 174.688c0 .398.25.93.624 1.329v-3.456h-.624v2.127z"
            fill="#fff"
            />
            <path
            d="M50.65 176.15l-.124-.133c-.374-.399-.499-.798-.624-1.197v-2.392h.749v3.722zm-.623-1.596c0 .399.125.798.374 1.197v-3.19h-.374v1.993z"
            fill="#000"
            />
            <path
            d="M66.244 175.751c.25-.399.374-.798.5-1.063v-2.127h-.5v3.19z"
            fill="#fff"
            />
            <path
            d="M66.12 176.017v-3.589h.623v2.392c0 .399-.25.665-.5 1.064l-.124.133zm.124-3.456v2.924c.125-.266.25-.532.25-.798V172.561h-.25z"
            fill="#000"
            />
            <path
            d="M51.773 177.08c.125.133.375.266.5.266v-4.785h-.5v4.519z"
            fill="#fff"
            />
            <path
            d="M52.397 177.479c-.25-.133-.499-.266-.624-.399v-4.652h.624v5.051zm-.499-.532c.125.133.25.133.374.266v-4.652h-.374v4.386z"
            fill="#000"
            />
            <path d="M56.266 178.542h.499v-6.247h-.5v6.247z" fill="#fff" />
            <path
            d="M56.89 178.675h-.749v-6.247h.748v6.247zm-.5-.266h.374v-6.114h-.374v6.114z"
            fill="#000"
            />
            <path
            d="M52.773 177.479c.125.133.375.133.5.265v-5.183h-.5v4.918z"
            fill="#fff"
            />
            <path
            d="M53.272 177.877c-.25-.132-.499-.132-.624-.265v-5.184h.624v5.449zm-.499-.398c.125 0 .25.133.374.133v-5.051h-.374v4.918z"
            fill="#000"
            />
            <path
            d="M54.518 178.143c.124 0 .374.133.499.133v-5.715h-.5v5.582z"
            fill="#fff"
            />
            <path
            d="M55.141 178.409c-.25 0-.499-.133-.623-.133v-5.848h.623v5.981zm-.499-.266c.125 0 .25 0 .375.133v-5.582h-.375v5.449z"
            fill="#000"
            />
            <path
            d="M55.39 178.409c.125 0 .375 0 .5.133v-6.114c-.125 0-.375 0-.5.133v5.848z"
            fill="#fff"
            />
            <path
            d="M56.014 178.542c-.25 0-.499-.133-.624-.133h-.124v-5.981h.124c.125 0 .375 0 .5-.133h.124v6.247zm-.499-.266h.374v-5.848h-.374v5.848z"
            fill="#000"
            />
            <path
            d="M58.26 168.307c-4.865 0-8.358 2.126-8.358 3.987 0 1.861 3.493 3.988 8.359 3.988 4.865 0 8.358-2.127 8.358-3.988 0-1.861-3.368-3.987-8.358-3.987z"
            fill="#fff"
            />
            <path
            d="M58.26 176.415c-4.99 0-8.483-2.127-8.483-4.121 0-1.993 3.493-4.12 8.483-4.12s8.483 2.127 8.483 4.12c0 1.994-3.493 4.121-8.483 4.121zm0-8.108c-4.865 0-8.233 2.126-8.233 3.987 0 1.861 3.368 3.988 8.233 3.988 4.866 0 8.234-2.127 8.234-3.988.125-1.861-3.244-3.987-8.234-3.987z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M52.897 175.352c.498.266 1.122.399 1.746.665l6.861-7.311c-.623-.133-1.372-.266-2.12-.266l-6.487 6.912zM57.637 176.415H58.884l5.988-6.38c-.25-.133-.499-.399-.873-.532l-6.362 6.912z"
            fill="#9CD6CB"
            />
            <path
            d="M63.749 168.44c-1.123 0-2.12.133-2.994.266H55.39v2.127c.124 1.861 3.493 3.987 8.358 3.987s8.233-1.993 8.358-3.987v-2.127h-5.364c-.873-.133-1.871-.266-2.994-.266z"
            fill="#0EA59D"
            />
            <path
            d="M63.749 174.953c-4.865 0-8.234-1.994-8.358-3.988v-2.393h5.489c.998-.132 1.996-.265 2.994-.265.998 0 1.996.133 2.994.265h5.364v2.26c-.25 1.994-3.618 4.121-8.483 4.121zm-8.234-4.121c.125 1.861 3.493 3.855 8.234 3.855 4.74 0 8.109-1.994 8.233-3.855v-1.994h-5.24c-.997-.133-1.995-.266-2.993-.266-.998 0-1.996.133-2.994.266H55.39v1.994h.124z"
            fill="#131A2D"
            />
            <path
            d="M56.389 172.561c.124.132.374.265.499.398v-4.253h-.5v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M57.012 173.092c-.25-.266-.499-.398-.623-.531v-3.988h.623v4.519zm-.623-.531c.124.133.25.265.374.265v-4.12h-.374v3.855z"
            fill="#131A2D"
            />
            <path
            d="M66.244 168.573v5.981c.125 0 .374 0 .5-.132v-5.849c-.126.133-.25.133-.5 0z"
            fill="#0EA59D"
            />
            <path
            d="M66.244 174.687v-6.114h.125c.125 0 .25 0 .374.133h.125v5.981h-.624zm.125-5.981v5.848c.125 0 .25 0 .374-.132v-5.716h-.374z"
            fill="#131A2D"
            />
            <path d="M65.371 174.687h.5v-6.114h-.5v6.114z" fill="#0EA59D" />
            <path
            d="M65.371 174.82v-6.38h.624v6.247c-.25.133-.374.133-.624.133zm.125-6.247v6.114h.374v-5.981c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M69.861 173.49c.125-.133.375-.266.5-.266v-4.519h-.5v4.785z"
            fill="#0EA59D"
            />
            <path
            d="M69.861 173.623v-4.918h.624v4.519c-.25.133-.374.266-.624.399zm.125-4.785v4.652c.125-.133.25-.133.374-.266v-4.386h-.374z"
            fill="#131A2D"
            />
            <path d="M64.496 174.82h.5v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M64.371 174.82v-6.514h.624v6.381c-.125.133-.374.133-.624.133zm.125-6.248v6.248h.374v-6.115c-.125-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M70.734 172.958c.25-.132.375-.265.5-.398v-3.722h-.5v4.12z"
            fill="#0EA59D"
            />
            <path
            d="M70.734 173.091v-4.386h.624v3.855c-.125.132-.374.265-.624.531zm.125-4.253v3.987l.374-.398v-3.589h-.374z"
            fill="#131A2D"
            />
            <path
            d="M68.115 174.156c.125 0 .375-.133.5-.133v-5.317h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M67.99 174.289v-5.716h.624v5.45a.923.923 0 01-.624.266zm.125-5.45v5.317c.125 0 .25-.133.374-.133v-5.184h-.374z"
            fill="#131A2D"
            />
            <path
            d="M67.117 174.42c.125 0 .374-.132.5-.132v-5.583h-.5v5.715z"
            fill="#0EA59D"
            />
            <path
            d="M67.117 174.553v-5.848h.624v5.715c-.25 0-.374 0-.624.133zm.125-5.715v5.582c.125 0 .25 0 .374-.132v-5.45h-.374z"
            fill="#131A2D"
            />
            <path
            d="M68.988 173.889c.125-.133.374-.133.5-.266v-4.918h-.5v5.184z"
            fill="#0EA59D"
            />
            <path
            d="M68.863 174.022v-5.317h.749v5.051c-.25 0-.374.133-.749.266zm.125-5.184v5.051c.125 0 .25-.133.374-.133v-4.785h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M59.133 174.155c.125 0 .374.133.499.133v-5.583h-.5v5.45z"
            fill="#0EA59D"
            />
            <path
            d="M59.632 174.288c-.25-.133-.5-.133-.624-.133v-5.45h.624v5.583zm-.5-.266c.125 0 .25.133.375.133v-5.45h-.374v5.317z"
            fill="#131A2D"
            />
            <path d="M62.625 174.82h.499v-6.38h-.499v6.38z" fill="#0EA59D" />
            <path
            d="M63.249 174.953h-.624v-6.513h.624v6.513zm-.5-.266h.375v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path d="M63.625 168.44v6.38h.624v-6.38h-.624z" fill="#0EA59D" />
            <path
            d="M63.75 174.953h-.25v-6.513h.749v6.513h-.499zm-.125-.133h.374v-6.247h-.374v6.247z"
            fill="#131A2D"
            />
            <path
            d="M55.39 170.832c0 .398.25.93.624 1.329v-3.456h-.623v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M56.014 172.427l-.125-.133c-.374-.399-.499-.798-.623-1.197v-2.392h.748v3.722zm-.499-1.595c0 .398.125.797.5 1.196v-3.19h-.5v1.994z"
            fill="#131A2D"
            />
            <path
            d="M71.732 172.029c.25-.399.375-.798.5-1.064v-2.126h-.5v3.19z"
            fill="#0EA59D"
            />
            <path
            d="M71.607 172.162v-3.589h.624v2.26c0 .398-.25.664-.499 1.063l-.125.266zm.125-3.323v3.057c.25-.266.25-.665.374-.93v-1.994h-.374v-.133z"
            fill="#131A2D"
            />
            <path
            d="M57.262 173.225c.124.133.374.266.499.266v-4.785h-.5v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M57.886 173.624c-.25-.133-.5-.266-.624-.399v-4.652h.623v5.051zm-.5-.399c.125.133.25.133.375.266v-4.652h-.375v4.386z"
            fill="#131A2D"
            />
            <path d="M61.754 174.687h.499v-6.247h-.5v6.247z" fill="#0EA59D" />
            <path
            d="M62.378 174.82h-.624v-6.247h.624v6.247zm-.5-.133h.375v-6.114h-.374v6.114z"
            fill="#131A2D"
            />
            <path
            d="M58.135 173.757c.125.133.374.133.499.266v-5.184h-.5v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M58.758 174.023c-.249-.133-.498-.133-.623-.266v-5.184h.623v5.45zm-.498-.399c.124 0 .249.133.374.133v-5.051h-.374v4.918z"
            fill="#131A2D"
            />
            <path
            d="M60.006 174.421c.125 0 .374.132.499.132v-5.715h-.5v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M60.63 174.553c-.25 0-.375-.133-.624-.133v-5.715h.624v5.848zm-.624-.265c.125 0 .25.132.374.132v-5.582h-.374v5.45z"
            fill="#131A2D"
            />
            <path
            d="M60.879 174.554c.125 0 .374 0 .499.133v-6.114c-.125 0-.374 0-.5.133v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M61.503 174.687c-.25 0-.375-.132-.624-.132v-5.982c.125 0 .374 0 .499-.133h.125v6.247zm-.624-.132c.125 0 .25 0 .374.132v-5.848c-.125 0-.25 0-.374.133v5.583z"
            fill="#131A2D"
            />
            <path
            d="M63.749 164.452c-4.865 0-8.358 2.127-8.358 3.988 0 1.861 3.493 3.988 8.358 3.988s8.358-2.127 8.358-3.988c0-1.861-3.368-3.988-8.358-3.988z"
            fill="#0EA59D"
            />
            <path
            d="M63.749 172.693c-4.99 0-8.358-2.126-8.358-4.12 0-1.994 3.493-4.121 8.358-4.121 4.99 0 8.358 2.127 8.358 4.121 0 1.994-3.368 4.12-8.358 4.12zm0-8.108c-4.865 0-8.234 2.127-8.234 3.988 0 1.861 3.369 3.988 8.234 3.988s8.233-2.127 8.233-3.988c0-1.861-3.368-3.988-8.233-3.988z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M58.385 171.497c.499.266 1.123.399 1.746.664l6.862-7.31c-.624-.133-1.373-.266-2.121-.266l-6.487 6.912zM63.125 172.56H64.372l5.989-6.38c-.25-.133-.5-.399-.874-.532l-6.362 6.912z"
            fill="#fff"
            />
            <path
            d="M61.128 172.161c-.125 0-.25 0-.374-.133-.25-.133-.624-.133-.873-.266-.25-.132-.624-.132-.874-.265-.124 0-.25-.133-.374-.133l-.25-.133c-.124 0-.124-.133-.249-.133l-.748-.399c-.5-.266-.998-.664-1.497-1.063.374.531.748 1.063 1.247 1.329.125.133.25.133.374.266.125.133.25.133.375.266.124 0 .124.133.25.133l.249.265c.124 0 .25.133.374.133l.499.133c.125 0 .25.133.499.133.25.133.624.133.873.133.25 0 .624 0 .873.133h.874c-.25-.133-.624-.133-.874-.266l-.374-.133zM65.245 172.295l-1.248.133h-.623c-.25 0-.375 0-.624.133.25 0 .374.133.624.133h1.871c.374 0 .873-.133 1.248-.266l1.122-.399h-1.247c-.25.133-.749.133-1.123.266z"
            fill="#fff"
            />
            <path
            d="M110.406 102.378c.624 1.329.873 2.791.873 4.12l.374 80.949c-.124 3.323-2.12 4.387-5.114 2.659l-24.826-14.755c-1.372-.797-2.744-2.259-3.617-3.854.998 2.259 2.62 4.519 4.615 5.582l24.576 14.489c2.869 1.728 5.24.398 5.364-2.925l-.374-80.417c-.125-2.126-.748-4.12-1.871-5.848z"
            fill="#D1D2D6"
            />
            <path
            d="M110.156 102.112c.624 1.33.873 2.792.873 4.121l.375 80.816c-.125 3.323-2.121 4.386-4.99 2.658l-24.826-14.621c-1.372-.798-2.744-2.26-3.617-3.855.998 2.26 2.62 4.386 4.615 5.583l24.451 14.355c2.87 1.728 5.24.399 5.365-2.924l-.375-80.284c0-2.127-.748-4.121-1.871-5.849z"
            fill="url(#paint93_linear_874_76773)"
            />
            <path
            d="M110.031 101.846c.624 1.33.874 2.792.874 4.121l.374 80.683c-.125 3.323-2.121 4.386-4.99 2.658l-24.7-14.621c-1.373-.798-2.62-2.26-3.618-3.855.998 2.26 2.62 4.387 4.49 5.583l24.452 14.355c2.869 1.728 5.239.399 5.364-2.924l-.374-80.284c-.125-1.994-.874-3.988-1.872-5.716z"
            fill="url(#paint94_linear_874_76773)"
            />
            <path
            d="M109.782 101.581c.499 1.329.873 2.791.873 4.121l.374 80.682c-.125 3.323-2.121 4.387-4.99 2.659l-24.576-14.621c-1.372-.798-2.62-2.26-3.617-3.722.998 2.259 2.62 4.386 4.49 5.583l24.327 14.222c2.869 1.728 5.239.399 5.364-2.924l-.374-80.151c-.125-1.994-.749-4.121-1.871-5.849z"
            fill="url(#paint95_linear_874_76773)"
            />
            <path
            d="M109.532 101.314c.499 1.33.873 2.792.873 3.988l.374 80.55c-.125 3.323-2.121 4.386-4.99 2.658l-24.576-14.488c-1.372-.797-2.62-2.127-3.617-3.722.998 2.26 2.62 4.387 4.49 5.45l24.202 14.355c2.869 1.728 5.24.399 5.364-2.924l-.374-80.018c0-1.994-.624-4.121-1.746-5.849z"
            fill="url(#paint96_linear_874_76773)"
            />
            <path
            d="M109.407 101.048c.499 1.329.873 2.791.873 3.987l.374 80.417c-.124 3.324-2.12 4.387-4.99 2.659l-24.45-14.488c-1.373-.798-2.62-2.127-3.618-3.722.998 2.259 2.62 4.386 4.49 5.45l24.202 14.222c2.869 1.728 5.115.399 5.24-2.924l-.375-80.018c0-1.728-.748-3.855-1.746-5.583z"
            fill="url(#paint97_linear_874_76773)"
            />
            <path
            d="M109.157 100.783c.499 1.329.873 2.659.873 3.988l.375 80.417c-.125 3.323-2.121 4.253-4.99 2.658l-24.327-14.488c-1.372-.798-2.62-2.127-3.617-3.722.998 2.26 2.62 4.387 4.49 5.45l24.077 14.222c2.87 1.728 5.115.399 5.24-2.924l-.374-79.885c0-1.861-.624-3.988-1.747-5.716z"
            fill="url(#paint98_linear_874_76773)"
            />
            <path
            d="M108.909 100.517c.499 1.329.873 2.658.873 3.987l.375 80.284c-.125 3.323-2.121 4.254-4.99 2.659L80.84 173.091c-1.372-.797-2.62-2.126-3.617-3.721.998 2.259 2.62 4.386 4.49 5.449l24.077 14.223c2.87 1.728 5.115.399 5.24-2.924l-.374-79.753c0-1.994-.624-4.12-1.747-5.848z"
            fill="url(#paint99_linear_874_76773)"
            />
            <path
            d="M108.784 100.252c.499 1.329.874 2.658.874 3.988l.374 80.151c-.125 3.19-2.121 4.253-4.865 2.658L80.84 172.694c-1.372-.798-2.62-2.127-3.617-3.722.998 2.26 2.62 4.386 4.49 5.45l23.953 14.089c2.869 1.728 5.114.399 5.239-2.924l-.374-79.752c0-1.728-.749-3.855-1.747-5.583z"
            fill="url(#paint100_linear_874_76773)"
            />
            <path
            d="M108.535 99.985c.499 1.33.873 2.659.873 3.855l.374 80.151c-.125 3.19-2.121 4.254-4.865 2.659l-24.202-14.356c-1.372-.797-2.62-2.127-3.617-3.722.998 2.26 2.62 4.387 4.49 5.45l23.828 14.09c2.869 1.595 5.115.399 5.239-2.924l-.374-79.62c0-1.728-.624-3.855-1.746-5.583z"
            fill="url(#paint101_linear_874_76773)"
            />
            <path
            d="M103.17 134.146l-24.7-14.356c-.25-.132-.374 0-.374.266l.25 8.507c0 .266.124.798.373 1.196.25.399.5.798.749.931l24.576 14.222c.124 0 .249.133.249 0 0 0 .125-.132.125-.265l-.25-8.374c0-.266-.124-.798-.374-1.197-.125-.531-.374-.797-.624-.93zm.624 1.462l.25 8.374c0 .133 0 .133-.125.133l-24.7-14.223c-.125 0-.125-.133-.25-.265-.125-.133-.125-.266-.125-.399l-.25-8.507v-.133h.126l24.7 14.355c.125 0 .125.133.249.266.125.133.125.266.125.399z"
            fill="#fff"
            />
            <g opacity={0.6} fill="#131A2D">
            <path d="M80.092 124.576l.748.398v1.595l.624.266v-1.595l.624.399v-.532l-1.996-1.063v.532zM81.963 127.234l.624.399.124-.266.749.399.125.398.748.399-.748-2.658-.749-.399-.873 1.728zm1.497 0l-.5-.266.25-.665.25.931zM85.206 127.766v-.798l-.624-.399v2.127l.624.399v-.532l.374-.133.374 1.197.874.398-.874-1.728.874-.398-.874-.532-.748.399zM87.078 130.158l1.747 1.063v-.398l-1.123-.665v-.532l.998.665v-.399l-.998-.664v-.266l1.123.531v-.398l-1.747-1.064v2.127zM91.445 131.885l-.374-1.462-.874-.531v2.126l.5.399v-1.728l.498 1.861.5.399.374-1.462v1.595l.498.398v-2.126l-.873-.532-.25 1.063zM94.064 132.152c-.374-.266-.624-.266-.873-.133-.25.133-.25.266-.25.665 0 .265 0 .531.125.664.125.266.25.399.374.532.125.133.375.266.624.532.25.132.374.265.624.265s.25 0 .374-.133c.125-.132.125-.265.125-.531 0-.399-.125-.665-.25-.931-.124-.266-.499-.664-.873-.93zm.374 1.329c0 .266 0 .399-.124.399h-.375c-.124-.133-.25-.133-.374-.399-.125-.133-.125-.266-.125-.532 0-.265 0-.398.125-.398h.374c.125.133.25.133.375.398.124.133.124.399.124.532zM96.933 135.076l-.749-1.728-.623-.266v2.127l.623.266v-1.064l.749 1.595.623.399v-2.127l-.623-.398v1.196zM97.932 136.671l1.87 1.063v-.532l-1.122-.664v-.399l.998.532v-.399l-.998-.532v-.399l1.123.665v-.399l-1.871-1.063v2.127zM101.05 137.071l-.374-.931-.748-.532.873 1.728v.931l.624.399v-.931l.873-.664-.749-.532-.499.532zM102.422 139.33l.624.266v-.532l-.624-.266v.532zM102.422 137.602l.125 1.063.374.266.125-.93v-.532l-.624-.399v.532z" />
            </g>
            <path
            d="M79.719 124.842l.624.399v1.595l.623.399v-1.595l.749.399v-.532l-1.996-1.196v.531z"
            fill="#fff"
            />
            <path
            d="M81.09 127.368l-.748-.532v-1.595l-.748-.399v-.664l2.12 1.329v.665l-.623-.399v1.595zm-.623-.665l.499.266v-1.595l.624.399v-.399l-1.871-1.063v.398l.623.399.125 1.595z"
            fill="#000"
            />
            <path
            d="M81.59 127.501l.624.399.124-.266.749.399.125.399.748.399-.748-2.659-.749-.399-.873 1.728zm1.372 0l-.499-.265.25-.665.25.93z"
            fill="#fff"
            />
            <path
            d="M83.96 129.096l-.873-.531-.125-.399-.624-.399v.266l-.748-.532.873-1.728.749.532.748 2.791zm-.748-.664l.499.266-.749-2.393-.624-.399-.748 1.462.499.266.125-.266.873.532.125.532zm-.125-.798l-.624-.398.374-.931.25 1.329zm-.5-.398l.25.132-.124-.531-.125.399z"
            fill="#000"
            />
            <path
            d="M84.708 128.032v-.797l-.624-.399v2.127l.624.399v-.532l.374-.133.499 1.196.748.399-.748-1.728.748-.399-.873-.531-.748.398z"
            fill="#fff"
            />
            <path
            d="M86.58 130.558l-.999-.665-.374-1.063-.25.133v.532l-.748-.532v-2.26l.748.532v.665l.624-.399.998.664-.873.399.873 1.994zm-.999-.797l.624.398-.748-1.728.748-.266-.748-.398-.749.398v-.93l-.499-.266v1.994l.499.266v-.399l.499-.266.374 1.197z"
            fill="#000"
            />
            <path
            d="M86.58 130.426l1.871 1.063v-.399l-1.247-.664v-.399l1.123.531v-.398l-1.123-.665v-.266l1.123.665v-.532l-1.747-1.063v2.127z"
            fill="#fff"
            />
            <path
            d="M88.451 131.621l-1.996-1.196v-2.26l1.871 1.064v.664l-.998-.531v.132l.998.665v.665l-.998-.665v.266l1.123.665v.531zm-1.746-1.196l1.621.93v-.265l-1.122-.665v-.532l.998.665v-.266l-.998-.665v-.531l1.122.664v-.266l-1.621-.93v1.861z"
            fill="#000"
            />
            <path
            d="M90.947 132.153l-.374-1.462-.874-.532v2.127l.624.399v-1.595l.374 1.861.5.265.373-1.462v1.728l.624.266v-2.127l-.873-.531-.374 1.063z"
            fill="#fff"
            />
            <path
            d="M92.194 133.881l-.624-.399v-1.196l-.374 1.063-.623-.398-.25-1.33v1.064l-.624-.399v-2.26l.998.532.25 1.329.25-.93.997.531v2.393zm-.499-.532l.375.266v-1.994l-.375-.265v1.993zm-.998-.531l.374.266.5-1.596-.375-.132-.374 1.196-.374-1.728-.25-.133.5 2.127zm-.873-.532l.374.266v-1.994l-.374-.266v1.994z"
            fill="#000"
            />
            <path
            d="M93.566 132.418c-.374-.265-.624-.265-.873-.132-.25.132-.25.265-.25.664 0 .266 0 .532.125.665.125.266.25.399.374.531.125.133.375.266.624.532.25.133.374.266.624.266.125 0 .25 0 .374-.133.125-.133.125-.266.125-.532 0-.398-.125-.664-.25-.93a3.018 3.018 0 00-.873-.931zm.5 1.33c0 .266 0 .398-.126.398h-.374c-.125-.132-.25-.132-.374-.398-.125-.133-.125-.266-.125-.532s0-.399.125-.399h.374c.125.133.25.133.374.399 0 .133.125.399.125.532z"
            fill="#fff"
            />
            <path
            d="M94.19 134.944c-.25 0-.374-.133-.624-.266s-.499-.266-.624-.531c-.124-.133-.25-.399-.374-.665-.125-.266-.125-.532-.125-.797 0-.399.125-.665.375-.665.25-.133.499 0 .873.133.374.266.624.532.873.797.25.266.25.665.25 1.064 0 .266 0 .398-.125.531-.125.399-.25.399-.5.399zm-1.248-2.658h-.124c-.125.133-.25.266-.25.531 0 .266 0 .399.125.665s.25.399.374.532c.125.133.374.266.624.398.25.133.374.266.624.266.124 0 .25 0 .25-.133.124-.133.124-.265.124-.531s-.125-.665-.25-.931c-.124-.266-.499-.531-.748-.797-.374.133-.624 0-.749 0zm.874 1.994c-.125 0-.125 0-.25-.133l-.374-.399c-.125-.133-.125-.399-.125-.532 0-.266 0-.399.125-.399h.374l.374.399c.125.133.125.399.125.532 0 .266 0 .399-.125.532h-.124zm-.5-1.33c-.124 0-.124.133-.124.399s0 .399.125.532c.124.133.124.266.25.266.124 0 .249.133.249 0 0 0 .124-.133.124-.399 0-.133 0-.399-.124-.532-.125-.133-.125-.266-.25-.266h-.25z"
            fill="#000"
            />
            <path
            d="M96.435 135.342l-.749-1.595-.624-.398v2.126l.624.399v-1.196l.749 1.595.623.399v-2.127l-.623-.399v1.196z"
            fill="#fff"
            />
            <path
            d="M97.183 136.805l-.748-.399-.624-1.329v.93l-.749-.399v-2.259l.749.398.748 1.463v-1.064l.749.399-.125 2.26zm-.624-.532l.5.266v-1.994l-.5-.266v1.329l-.873-1.861-.499-.265v1.993l.5.266v-1.329l.873 1.861z"
            fill="#000"
            />
            <path
            d="M97.559 136.938l1.746 1.063v-.531l-1.123-.665v-.399l.998.665v-.532l-.998-.531v-.399l1.123.664v-.398l-1.746-1.064v2.127z"
            fill="#fff"
            />
            <path
            d="M99.43 138.134l-1.996-1.197v-2.259l1.87 1.063v.665l-.997-.665v.133l.998.665v.664l-.998-.664v.265l1.123.665v.665zm-1.872-1.197l1.622.931v-.266l-1.123-.665v-.531l.998.664v-.266l-.873-.797v-.532l1.123.665v-.266l-1.622-.93-.125 1.993z"
            fill="#000"
            />
            <path
            d="M100.677 137.337l-.499-.93-.748-.399.873 1.728v.797l.624.399v-.93l.873-.665-.749-.399-.374.399z"
            fill="#fff"
            />
            <path
            d="M101.051 139.065l-.748-.399v-.93l-.873-1.861.998.532.374.93.374-.399.873.532-.873.798-.125.797zm-.623-.532l.499.266v-.797l.748-.665-.624-.399-.499.532-.499-1.063-.499-.266.749 1.595.125.797z"
            fill="#000"
            />
            <path
            d="M101.924 137.869l.125 1.064.499.265.124-.93v-.532l-.748-.266v.399z"
            fill="#fff"
            />
            <path
            d="M102.548 139.331l-.499-.399-.125-1.064v-.664l.748.399v.531l-.124 1.197zm-.375-.399l.25.133.125-.798v-.399l-.499-.265v.398l.124.931z"
            fill="#000"
            />
            <path
            d="M102.049 139.596l.499.266v-.532l-.499-.266v.532z"
            fill="#fff"
            />
            <path
            d="M102.672 139.995l-.748-.399v-.664l.748.398v.665zm-.623-.532l.499.266v-.399l-.499-.133v.266z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M312.75 274.51l-28.693 16.881-19.211-11.697 27.819-16.349 20.085 11.165z"
            fill="url(#paint102_linear_874_76773)"
            />
            <path
            d="M294.911 266.668l-20.21 12.361v-65.795l20.21-12.229v65.663z"
            fill="#131A2D"
            />
            <path
            d="M273.206 279.163l-38.548-25.654v-66.593l38.548 24.059v68.188z"
            fill="#0EA59D"
            />
            <path
            d="M273.33 279.296l-38.797-25.787v-66.726h.125l38.672 24.059v68.454zm-38.547-25.787l38.423 25.521v-68.055l-38.423-23.926v66.46z"
            fill="#131A2D"
            />
            <path
            opacity={0.1}
            d="M253.994 199.012l1.872 1.063-21.208 22.597v-3.058l19.336-20.602zM234.658 212.57v-25.654l15.22 9.437-15.22 16.217zM234.658 232.375v-2.659l25.324-26.983 1.622.931-26.946 28.711zM237.901 255.635l-3.368-2.259v-4.786l36.677-39.078 1.996 1.196v7.178c-11.727 12.76-23.453 25.255-35.305 37.749zM269.463 239.02l-21.707 23.129-1.871-1.197 22.704-24.191c-.249.797.25 1.728.874 2.259zM258.359 269.194l-2.121-1.33 16.966-18.077v3.589a861.14 861.14 0 01-14.845 15.818z"
            fill="#F2F7FA"
            />
            <path
            d="M294.911 258.826l-3.243-1.994 3.243-1.994v3.988zM294.911 254.838l-3.243-1.861 3.243-1.994v3.855z"
            fill="#131A2D"
            />
            <path
            d="M294.911 250.983l-3.243-1.993 3.243-1.861v3.854zM294.911 247.129l-3.243-1.994 3.243-1.993v3.987zM294.911 243.142l-3.243-1.861 3.243-1.994v3.855zM294.911 239.286l-3.243-1.993 3.243-1.861v3.854zM294.911 235.431l-3.243-1.994 3.243-1.994v3.988z"
            fill="#131A2D"
            />
            <path
            d="M294.911 231.444l-3.243-1.861 3.243-1.994v3.855z"
            fill="#131A2D"
            />
            <path
            d="M294.911 228.121l-3.243-1.994 3.243-1.861v3.855zM294.911 224.266l-3.243-1.994 3.243-1.994v3.988z"
            fill="#131A2D"
            />
            <path
            d="M294.911 220.279l-3.243-1.861 3.243-1.994v3.855zM294.911 216.424l-3.243-1.994 3.243-1.861v3.855z"
            fill="#131A2D"
            />
            <path
            d="M294.911 212.57l-3.243-1.994 3.243-1.994v3.988z"
            fill="#131A2D"
            />
            <path
            d="M294.911 208.582l-3.243-1.861 3.243-1.993v3.854z"
            fill="#131A2D"
            />
            <path
            d="M294.911 204.727l-3.243-1.994 3.243-1.861v3.855z"
            fill="#322C8D"
            />
            <path
            d="M234.658 249.655v-3.988l3.244 1.994-3.244 1.994zM234.658 245.666v-3.854l3.244 1.993-3.244 1.861z"
            fill="#131A2D"
            />
            <path
            d="M234.658 241.812v-3.988l3.244 1.994-3.244 1.994zM234.658 237.824v-3.854l3.244 1.994-3.244 1.86zM234.658 233.97v-3.988l3.244 1.994-3.244 1.994zM234.658 229.982v-3.855l3.244 1.994-3.244 1.861zM234.658 226.127v-3.987l3.244 1.993-3.244 1.994z"
            fill="#131A2D"
            />
            <path
            d="M234.658 222.273v-3.988l3.244 1.994-3.244 1.994z"
            fill="#131A2D"
            />
            <path
            d="M234.658 218.418v-3.987l3.244 1.993-3.244 1.994z"
            fill="#131A2D"
            />
            <path
            d="M234.658 214.564v-3.988l3.244 1.994-3.244 1.994zM234.658 210.575v-3.854l3.244 1.994-3.244 1.86z"
            fill="#131A2D"
            />
            <path
            d="M234.658 206.721v-3.855l3.244 1.994-3.244 1.861z"
            fill="#131A2D"
            />
            <path
            d="M234.658 202.999v-3.987l3.244 1.994-3.244 1.993zM234.658 199.012v-3.855l3.244 1.994-3.244 1.861z"
            fill="#131A2D"
            />
            <path
            d="M234.658 195.29v-3.987l3.244 1.994-3.244 1.993z"
            fill="#131A2D"
            />
            <path
            d="M234.657 253.775l-.749-.532v-68.321l.749.266v68.587z"
            fill="#fff"
            />
            <path
            d="M234.781 253.908l-.873-.532v-68.454l.873.266v68.72zm-.873-.665l.624.399v-68.321l-.624-.266v68.188z"
            fill="#131A2D"
            />
            <path
            d="M273.828 210.976v68.72l-.873-.532V210.71l.873.266z"
            fill="#fff"
            />
            <path
            d="M273.953 279.828l-.998-.665v-68.587l.998.399v68.853zm-.873-.665l.748.532v-68.587l-.748-.266v68.321z"
            fill="#131A2D"
            />
            <path
            d="M274.701 279.296l-.873.399v-68.72l.873-.266v68.587zM295.536 266.535l-.749.266v-68.188l.749-.399v68.321zM272.956 263.345l-38.298-25.388v-.398l38.298 25.52v.266zM272.956 251.781l-38.298-25.521v-.266l38.298 25.521v.266zM272.956 247.793l-38.298-25.387v-.399l38.298 25.521v.265zM272.956 243.939l-38.298-25.521v-.266l38.298 25.521v.266zM272.956 255.769l-38.298-25.521v-.266l38.298 25.521v.266zM272.956 259.756l-38.298-25.52v-.266l38.298 25.388v.398zM272.956 232.375l-38.298-25.521v-.266l38.298 25.388v.399zM272.956 228.387l-38.298-25.521v-.265l38.298 25.52v.266zM272.956 224.665l-38.298-25.521v-.266l38.298 25.521v.266zM272.956 220.81l-38.298-25.521v-.266l38.298 25.388v.399z"
            fill="#131A2D"
            />
            <path
            d="M272.956 216.691l-38.298-24.724v-4.386l38.298 25.521v3.589z"
            fill="#fff"
            />
            <path
            d="M273.081 216.824l-38.423-24.856v-4.52l38.423 25.654v3.722zm-38.298-24.989l38.173 24.723v-3.456l-38.173-25.388v4.121zM272.956 236.229l-38.298-25.521v-.266l38.298 25.521v.266zM272.956 240.084l-38.298-25.387v-.399l38.298 25.521v.265z"
            fill="#131A2D"
            />
            <path
            d="M294.786 254.971l-20.085 12.228v-.265l20.085-12.229v.266z"
            fill="url(#paint103_linear_874_76773)"
            />
            <path
            d="M294.786 250.983l-20.085 12.361v-.399l20.085-12.228v.266z"
            fill="url(#paint104_linear_874_76773)"
            />
            <path
            d="M294.786 258.958l-20.085 12.229v-.266l20.085-12.362v.399z"
            fill="url(#paint105_linear_874_76773)"
            />
            <path
            d="M294.786 263.212l-20.085 12.362v-.399l20.085-12.229v.266z"
            fill="url(#paint106_linear_874_76773)"
            />
            <path
            d="M294.786 239.419l-20.085 12.229v-.266l20.085-12.229v.266z"
            fill="url(#paint107_linear_874_76773)"
            />
            <path
            d="M294.786 235.432l-20.085 12.361v-.398l20.085-12.229v.266z"
            fill="url(#paint108_linear_874_76773)"
            />
            <path
            d="M294.786 231.709l-20.085 12.229v-.266l20.085-12.229v.266z"
            fill="url(#paint109_linear_874_76773)"
            />
            <path
            d="M294.786 228.121l-20.085 12.229v-.266l20.085-12.361v.398z"
            fill="url(#paint110_linear_874_76773)"
            />
            <path
            d="M294.786 224.266l-20.085 12.361v-.398L294.786 224v.266z"
            fill="url(#paint111_linear_874_76773)"
            />
            <path
            d="M294.786 220.544l-20.085 12.229v-.266l20.085-12.361v.398z"
            fill="url(#paint112_linear_874_76773)"
            />
            <path
            d="M294.786 216.69l-20.085 12.362v-.399l20.085-12.229v.266z"
            fill="url(#paint113_linear_874_76773)"
            />
            <path
            d="M294.786 212.968l-20.085 12.229v-.266l20.085-12.229v.266z"
            fill="#F2F7FA"
            />
            <path
            d="M294.786 209.113l-20.085 12.362v-.399l20.085-12.228v.265z"
            fill="url(#paint114_linear_874_76773)"
            />
            <path
            d="M294.786 204.859l-20.085 12.229v-3.722l20.085-12.228v3.721z"
            fill="#fff"
            />
            <path
            d="M274.701 217.221v-3.854l20.085-12.362v3.855l-20.085 12.361zm.125-3.722v3.589l19.835-12.228v-3.589l-19.835 12.228z"
            fill="#131A2D"
            />
            <path
            d="M294.786 243.407l-20.085 12.228v-.266l20.085-12.361v.399z"
            fill="url(#paint115_linear_874_76773)"
            />
            <path
            d="M294.786 247.262l-20.085 12.361v-.266l20.085-12.361v.266z"
            fill="url(#paint116_linear_874_76773)"
            />
            <path
            d="M272.956 267.333l-38.298-25.521v-.266l38.298 25.388v.399zM272.956 271.187l-38.298-25.388v-.399l38.298 25.521v.266zM234.658 253.642v-3.988l3.244 1.994-3.244 1.994z"
            fill="#131A2D"
            />
            <path
            d="M272.956 275.174l-38.298-25.388v-.398l38.298 25.52v.266zM296.284 200.872l-22.206 13.159v-1.329l22.206-13.159v1.329zM274.078 214.032l-41.791-25.787v-1.329l41.791 25.787v1.329z"
            fill="#131A2D"
            />
            <path
            d="M296.657 199.41l-22.954 13.558v-.931l22.954-13.558v.931z"
            fill="url(#paint117_linear_874_76773)"
            />
            <path
            d="M273.704 212.968l-42.29-26.052v-.931l42.29 26.053v.93z"
            fill="#fff"
            />
            <path
            d="M273.829 213.101l-42.415-26.052v-1.064h.125l42.29 26.053v1.063zm-42.29-26.185l42.165 25.919v-.797l-42.165-25.92v.798z"
            fill="#131A2D"
            />
            <path
            d="M296.658 198.48l-22.954 13.558-42.29-26.053 23.952-14.089 41.292 26.584z"
            fill="#fff"
            />
            <path
            d="M273.704 212.038l-42.415-26.053h.125l23.952-14.089 41.417 26.717-23.079 13.425zm-42.041-26.053l42.166 25.92 22.829-13.425-41.167-26.584-23.828 14.089z"
            fill="#131A2D"
            />
            <path
            d="M270.835 203.265c-3.119-.532-5.614-1.994-6.612-3.987-.624-1.197-.624-2.393-.125-3.589 1.372-3.19 6.487-5.051 11.477-4.254 3.119.532 5.614 1.994 6.612 3.988.624 1.196.624 2.392.125 3.456-1.123 2.658-4.99 4.386-9.107 4.386-.749.266-1.497.133-2.37 0zm-5.863-7.045c-.375.931-.375 1.728.124 2.659.873 1.595 3.119 2.924 5.863 3.456 4.491.797 9.357-.931 10.479-3.589.375-.798.375-1.728-.124-2.526-.874-1.728-3.119-2.924-5.988-3.456-.749-.133-1.497-.133-2.246-.133-3.617-.132-7.11 1.33-8.108 3.589z"
            fill="#0EA59D"
            />
            <path
            d="M273.205 203.531c-.749 0-1.622 0-2.37-.133-3.119-.532-5.614-1.994-6.612-3.987-.624-1.197-.624-2.393-.125-3.589 1.372-3.19 6.612-5.051 11.602-4.254 3.243.532 5.738 1.994 6.737 3.988.623 1.196.623 2.392.124 3.589-1.247 2.658-4.99 4.386-9.356 4.386zm.125-12.096c-4.117 0-7.984 1.728-9.107 4.387-.499 1.196-.499 2.392.125 3.456.998 1.993 3.493 3.456 6.611 3.854.749.133 1.622.133 2.371.133 4.241 0 7.984-1.861 9.107-4.386.499-1.196.498-2.26-.125-3.456-.998-1.994-3.493-3.456-6.612-3.988-.873.133-1.622 0-2.37 0zm-.125 11.166c-.749 0-1.497 0-2.246-.133-2.869-.399-5.114-1.728-5.987-3.456-.499-.931-.5-1.728-.125-2.659.998-2.259 4.366-3.854 8.233-3.854.749 0 1.497 0 2.246.133 2.869.398 5.114 1.728 5.988 3.456.499.93.499 1.728.124 2.658-.873 2.26-4.491 3.855-8.233 3.855zm-8.109-6.248c-.374.798-.374 1.728.125 2.526.873 1.595 3.119 2.924 5.863 3.323 4.491.797 9.232-.931 10.354-3.589.375-.797.375-1.728-.124-2.525-.874-1.596-3.119-2.925-5.864-3.456-.748-.133-1.497-.133-2.245-.133-3.867 0-7.111 1.595-8.109 3.854z"
            fill="#131A2D"
            />
            <path
            d="M278.694 198.613l1.248-.798-7.236-4.652-1.247.798 2.744 1.728-3.618 2.126-2.994-1.993-1.247.797 7.235 4.652 1.248-.797-2.994-1.861 3.493-2.127 3.368 2.127z"
            fill="#0EA59D"
            />
            <path
            d="M273.579 201.404l-7.485-4.652 1.497-.93 2.994 1.86 3.493-1.993-2.745-1.728 1.497-.931 7.361 4.785-1.373.798-3.368-2.127-3.368 1.994 2.994 1.994-1.497.93zm-7.111-4.785l7.111 4.519 1.122-.664-2.994-1.994 3.618-2.26 3.369 2.127 1.122-.665-7.11-4.519-1.123.798 2.744 1.728-3.742 2.126-2.994-1.86-1.123.664zM256.614 183.859l-4.616 2.658v-4.386l4.616-2.658v4.386z"
            fill="#131A2D"
            />
            <path
            d="M251.999 186.517l-8.483-5.184v-4.386l8.483 5.183v4.387z"
            fill="#fff"
            />
            <path
            d="M252.123 186.65l-8.607-5.317v-4.52l8.607 5.317v4.52zm-8.483-5.45l8.359 5.184v-4.121l-8.359-5.184v4.121z"
            fill="#131A2D"
            />
            <path
            d="M256.614 179.472l-4.615 2.659-8.483-5.184 4.865-2.792 8.233 5.317z"
            fill="#fff"
            />
            <path
            d="M251.998 182.264l-8.607-5.317 4.99-2.925 8.358 5.45-4.741 2.792zm-8.358-5.317l8.358 5.184 4.491-2.659-8.108-5.184-4.741 2.659zM262.976 188.91l-3.369 1.994v-3.19l3.369-1.994v3.19z"
            fill="#131A2D"
            />
            <path
            d="M259.607 190.903l-6.238-3.855v-3.19l6.238 3.855v3.19z"
            fill="#fff"
            />
            <path
            d="M259.607 191.036l-6.238-3.855v-3.323l6.238 3.855v3.323zm-6.113-3.988l5.988 3.722v-2.924l-5.988-3.722v2.924z"
            fill="#131A2D"
            />
            <path
            d="M262.975 185.72l-3.368 1.994-6.238-3.855 3.493-1.994 6.113 3.855z"
            fill="#fff"
            />
            <path
            d="M259.607 187.847l-6.238-3.855 3.618-2.127 6.113 3.988-3.493 1.994zm-5.988-3.988l5.988 3.722 3.243-1.861-5.863-3.855-3.368 1.994zM270.586 277.302l-5.738 3.323v-1.861l5.738-3.19v1.728z"
            fill="#131A2D"
            />
            <path
            d="M264.847 278.764l-31.312-21.001 5.739-3.323 31.312 21.134-5.739 3.19z"
            fill="#fff"
            />
            <path
            d="M264.847 278.897l-31.437-21.135 5.863-3.323 31.313 21.135h-.125l-5.614 3.323zm-31.187-21.135l31.187 21.002 5.489-3.19-31.063-21.002-5.613 3.19z"
            fill="#131A2D"
            />
            <path
            d="M264.847 280.625l-31.312-21.134v-1.728l31.312 21.001v1.861zM268.467 274.244l-3.617 1.994v-1.595l3.617-1.994v1.595z"
            fill="#131A2D"
            />
            <path
            d="M264.848 274.643l-26.946-18.077 3.618-1.994 26.946 18.077-3.618 1.994z"
            fill="#fff"
            />
            <path
            d="M264.848 274.643l-27.071-18.21h.125l3.618-1.994 27.071 18.211h-.125l-3.618 1.993zm-26.821-18.077l26.821 17.944 3.493-1.86-26.821-18.078-3.493 1.994zM264.848 276.239l-26.946-18.077v-1.595l26.946 18.077v1.595z"
            fill="#131A2D"
            />
            <path
            d="M260.48 269.992c0 .265.125.531.499.797.624.399 1.747.532 2.371.133.374-.133.499-.399.499-.665v-.531l-3.369-.133v.399z"
            fill="#131A2D"
            />
            <path
            d="M263.35 268.927c-.624-.398-1.747-.531-2.37-.133-.624.399-.624 1.064 0 1.463.623.398 1.746.531 2.37.133.624-.399.624-1.064 0-1.463z"
            fill="#fff"
            />
            <path
            d="M260.73 269.326c0 .266.125.399.374.665.499.399 1.497.399 1.996.133.25-.133.375-.399.375-.532v-19.406l-2.87-.133v19.273h.125z"
            fill="#fff"
            />
            <path
            d="M262.227 270.39c-.374 0-.873-.133-1.123-.266-.249-.133-.499-.399-.499-.665v-19.406h.125l2.869.133v19.406c0 .266-.124.532-.499.665-.124.133-.499.133-.873.133zm-1.497-20.337v19.273c0 .266.125.399.374.532.499.399 1.373.399 1.996.133.25-.133.375-.266.375-.532v-19.273l-2.745-.133z"
            fill="#131A2D"
            />
            <path
            d="M263.101 249.521c-.499-.398-1.497-.398-1.996-.133-.499.266-.499.798 0 1.197.499.398 1.497.398 1.996.133.623-.266.623-.798 0-1.197z"
            fill="#D4D4D4"
            />
            <path
            d="M251.248 263.877c0 .265.125.531.499.797.624.399 1.747.532 2.37.133.375-.133.499-.399.499-.665v-.664l-3.368-.133v.532z"
            fill="#131A2D"
            />
            <path
            d="M254.117 262.813c-.623-.399-1.746-.532-2.37-.133-.624.399-.624 1.064 0 1.462.624.399 1.747.532 2.37.133.749-.398.749-1.063 0-1.462z"
            fill="#fff"
            />
            <path
            d="M251.498 263.212c0 .266.125.399.374.664.499.399 1.497.399 1.996.133.25-.133.374-.399.374-.531v-19.407l-2.869-.133v19.274h.125z"
            fill="#fff"
            />
            <path
            d="M253.12 264.275c-.374 0-.873-.133-1.123-.266-.249-.133-.499-.399-.499-.665v-19.406h.125l2.869.133v19.406c0 .266-.125.532-.499.665-.249 0-.499.133-.873.133zm-1.497-20.337v19.273c0 .266.125.399.374.532.499.399 1.372.399 1.996.133.25-.133.374-.266.374-.532v-19.273l-2.744-.133z"
            fill="#131A2D"
            />
            <path
            d="M253.993 243.407c-.499-.399-1.497-.399-1.996-.133-.499.266-.499.798 0 1.196.499.399 1.497.399 1.996.133a.665.665 0 000-1.196z"
            fill="#D4D4D4"
            />
            <path
            d="M241.893 257.63c0 .266.124.532.499.798.623.399 1.746.531 2.37.133.374-.133.499-.399.499-.665v-.532l-3.368-.133v.399z"
            fill="#131A2D"
            />
            <path
            d="M244.762 256.434c-.624-.399-1.747-.532-2.37-.133-.624.399-.624 1.063 0 1.462.623.399 1.746.532 2.37.133.748-.266.748-.931 0-1.462z"
            fill="#fff"
            />
            <path
            d="M242.267 256.965c0 .266.125.399.375.665.499.398 1.497.398 1.996.132.249-.132.374-.398.374-.531v-19.407l-2.869-.133v19.274h.124z"
            fill="#fff"
            />
            <path
            d="M243.764 258.028c-.374 0-.873-.133-1.122-.266-.25-.132-.499-.398-.499-.664v-19.407l2.994.133v19.407c0 .266-.125.531-.499.664-.25 0-.499.133-.874.133zm-1.497-20.337v19.274c0 .266.125.399.375.532.499.398 1.372.398 1.996.133.249-.133.374-.266.374-.532v-19.274l-2.745-.133z"
            fill="#131A2D"
            />
            <path
            d="M244.638 237.027c-.499-.399-1.497-.399-1.996-.133-.499.266-.499.798 0 1.196.499.399 1.497.399 1.996.133.499-.266.499-.797 0-1.196z"
            fill="#D4D4D4"
            />
            <path
            d="M265.221 253.509l4.615-2.526v-2.525l-4.615 2.658v2.393z"
            fill="#131A2D"
            />
            <path
            d="M265.221 253.51L237.9 235.167v-2.127l27.321 18.343v2.127z"
            fill="#fff"
            />
            <path
            d="M265.22 253.643l-27.445-18.476v-2.26l.125.133 27.445 18.343v2.26h-.125zm-27.32-18.476l27.196 18.21v-1.994l-27.196-18.21v1.994z"
            fill="#131A2D"
            />
            <path
            d="M235.281 231.445l4.242-2.393 16.342-.797-5.614 3.722-14.97-.532z"
            fill="#fff"
            />
            <path
            d="M250.375 232.109l-15.344-.532 4.491-2.525 16.717-.931-5.864 3.988zm-14.845-.665l14.721.532 5.364-3.722-16.093.93-3.992 2.26z"
            fill="#131A2D"
            />
            <path
            d="M272.332 251.117l-4.241 2.393-17.216-21.932.873-1.063 4.117-2.26 16.467 22.862z"
            fill="#131A2D"
            />
            <path
            d="M268.09 253.51l-32.809-22.065 16.467-.931 16.342 22.996z"
            fill="#fff"
            />
            <path
            d="M268.464 253.776l-.374-.266-33.059-22.198 16.717-.93 16.716 23.394zm-32.934-22.198l32.31 21.666-16.092-22.597-16.218.931z"
            fill="#131A2D"
            />
            <path
            d="M261.103 246.066l-19.585-13.159h.873l17.839 11.963.873 1.196z"
            fill="#131A2D"
            />
            <path
            d="M260.232 244.87l-17.839-11.963 8.857-.532 8.982 12.495z"
            fill="#fff"
            />
            <path
            d="M260.481 245.136l-18.338-12.362 9.231-.532 9.107 12.894zm-17.839-12.096l17.34 11.697-8.608-12.096-8.732.399z"
            fill="#131A2D"
            />
            <path
            d="M244.137 234.103l7.984-.532-.873-1.196-8.857.532 1.871 1.329-.125-.133zM246.758 185.586c0-.797-.249-1.595-.748-2.392a6.912 6.912 0 00-1.872-1.994l-3.368-2.127-1.622.931s1.248 1.595 1.373 1.861c0 0 .124.132.374.265v5.849c-.25-.133-.25-.133-.374-.133l-.499.266.873.93 2.495 1.595.249-.398.499.265v.133l.624 1.33 1.497-.931c.499-.133.749-.664.749-1.462 0-.93-.375-1.861-1.123-2.791.624 0 .873-.399.873-1.197zm-3.368-1.462l1.123 1.064c-.125 0-.25 0-.499-.133l-1.747-1.064v-.531c.749.398 1.123.664 1.123.664zm-.873 3.589v-2.127l1.871 1.197c-.25.133-.499.398-.499.398v1.064s0 .266.125.531l-1.497-1.063zM268.215 201.271l3.244-2.392-1.996-1.196-1.622.93.25.133-1.497 1.063v-4.12l-1.747-1.064-1.622.931v-1.994l-1.746-1.063-1.622.93 1.622 1.064v3.588l-3.743-7.975-1.247-.797-1.622.93s.998 1.861 1.622 3.057v4.652l-.873-.797.873 3.456 1.622-.931v-3.19a192.252 192.252 0 011.996 3.456l.249-1.063.624 1.462-.25.266.624 3.19 1.622-.93v-7.178l1.622 1.063v6.38l-.125-.265-.499 1.329.748 1.728 1.622-.931v-1.994l.998 3.058 2.495 3.057 1.622-.931-3.244-6.912zm-1.746-.797l.249.399-.249.133v-.532z"
            fill="#131A2D"
            />
            <path
            d="M250.502 185.32l-1.622.931.873.93-2.245 5.317h.124l-.249.133.374 1.861 1.622-.931.374-.797 1.871 1.196.125-.664.499.265c.25 1.064.499 1.728.499 1.861.125.266.499 1.462.499 1.462l-.873.532 1.871 1.196 1.622-.93-2.994-11.165-2.37-1.197zm-.125 5.849l.499-1.329c.125.664.374 1.329.499 2.126l-.998-.797z"
            fill="#131A2D"
            />
            <path
            d="M244.388 187.846c.749.931 1.123 1.861 1.123 2.792 0 .797-.25 1.196-.749 1.462-.499.133-1.122 0-1.871-.532l-3.618-2.392v-9.172l3.369 2.127c.748.532 1.372 1.063 1.871 1.994.499.797.748 1.595.748 2.392-.124.798-.374 1.197-.873 1.329zm-1.871-3.854l-1.747-1.064v1.994l1.747 1.064c.249.133.499.265.624.133.124-.133.249-.266.249-.532s-.125-.532-.249-.931a1.565 1.565 0 00-.624-.664zm.249 5.981c.25.133.499.266.749.133.249-.133.249-.266.249-.664 0-.266-.124-.665-.249-.931s-.374-.532-.749-.797l-1.996-1.197v2.127l1.996 1.329z"
            fill="#0EA59D"
            />
            <path
            d="M244.263 192.233a2.3 2.3 0 01-1.497-.532l-3.743-2.393v-9.437l3.493 2.26a6.9 6.9 0 011.872 1.994c.499.797.748 1.595.748 2.392 0 .798-.249 1.196-.748 1.329.748.931 1.122 1.861 1.122 2.792 0 .797-.249 1.329-.873 1.462 0 .133-.249.133-.374.133zm-5.115-2.925l3.618 2.393c.748.532 1.372.665 1.871.532.499-.133.749-.665.749-1.329 0-.931-.375-1.861-1.123-2.792v-.266h.125c.499-.133.748-.531.748-1.196 0-.797-.249-1.462-.748-2.26-.499-.797-1.123-1.462-1.872-1.86l-3.243-2.127v8.905h-.125zm4.117.931c-.125 0-.374-.133-.499-.266l-1.996-1.329v-2.393l2.121 1.329c.249.133.499.399.748.798.25.399.25.665.25.93 0 .399-.125.532-.375.665 0 .266-.124.266-.249.266zm-2.37-1.595l1.871 1.196c.249.133.499.266.624.133.124-.133.249-.266.249-.532 0-.265-.125-.664-.249-.93-.125-.266-.375-.532-.749-.798l-1.871-1.196v2.127h.125zm2.12-2.393c-.124 0-.374 0-.499-.133l-1.746-1.063v-2.26l1.871 1.197c.25.133.499.398.749.797.124.266.249.665.249.931 0 .265-.125.531-.249.664-.25-.133-.375-.133-.375-.133zm-2.12-1.329l1.621 1.063c.25.133.499.133.624.133.125-.133.25-.265.25-.531s-.125-.532-.25-.798a1.548 1.548 0 00-.624-.664l-1.621-1.064v1.861z"
            fill="#131A2D"
            />
            <path
            d="M252.122 197.682l-.499-1.994-3.493-2.259-.499 1.329-1.871-1.196 2.994-7.311 2.121 1.329 2.994 11.166-1.747-1.064zm-3.368-5.583l2.37 1.463-1.247-4.52-1.123 3.057z"
            fill="#0EA59D"
            />
            <path
            d="M254.118 199.011l-1.996-1.329-.499-1.994-3.368-2.126-.499 1.329-1.996-1.197 3.119-7.31 2.245 1.462 2.994 11.165zm-1.871-1.462l1.622 1.063-2.994-10.899-1.996-1.329-2.994 7.178 1.746 1.063.499-1.329 3.493 2.259.624 1.994zm-.998-3.722l-2.62-1.595 1.248-3.19 1.372 4.785zm-2.495-1.728l2.121 1.33-1.123-4.121-.998 2.791z"
            fill="#131A2D"
            />
            <path
            d="M259.857 193.43l1.747 1.064v9.171l-1.248-.797-3.742-7.976v5.583l-1.747-1.063v-9.172l1.248.798 3.742 7.975v-5.583z"
            fill="#0EA59D"
            />
            <path
            d="M261.603 203.797l-1.372-.93-3.618-7.709v5.449l-1.871-1.196v-9.437l1.372.93 3.618 7.709v-5.449l1.871 1.196v9.437zm-1.247-1.063l1.123.798v-9.039l-1.622-1.063v5.848l-3.867-8.241-1.123-.798v9.039l1.622 1.063v-5.848l3.867 8.241z"
            fill="#131A2D"
            />
            <path
            d="M269.961 208.981l-1.996-1.197-3.119-6.247v4.386l-1.746-1.063v-9.172l1.746 1.064v4.12l2.994-2.126 1.996 1.196-3.243 2.393 3.368 6.646z"
            fill="#0EA59D"
            />
            <path
            d="M270.086 209.247l-2.121-1.462-2.994-5.982v4.121l-1.871-1.197v-9.437l1.871 1.196v3.988l2.869-2.127 2.121 1.329-3.244 2.393 3.369 7.178zm-2.121-1.462l1.746 1.063-3.243-6.646 3.119-2.393-1.872-1.196-2.994 2.26v-4.121l-1.621-1.063v9.038l1.621 1.064v-4.652l3.244 6.646z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M369.637 144.647c0-.93.748-1.994 2.121-2.924.124-.133.249-.133.374-.266.125 0 .125-.133.249-.133.125 0 .25-.133.375-.133h.124a17.556 17.556 0 013.119-1.063h.125c.374-.133.624-.133.998-.133h.249c.375 0 .624-.133.998-.133h1.622c.624 0 1.248 0 1.871.133h.25c1.123 0 2.245.133 3.243.266.125-.133.375-.266.499-.399.125-.133.25-.133.375-.266.124 0 .124-.133.249-.133s.25-.133.374-.133h.125a17.529 17.529 0 013.119-1.063h.125c.374-.133.623-.133.998-.133h.249c.374 0 .624-.133.998-.133h1.622c5.115 0 8.857 1.861 9.98 3.855.125 0 .374-.133.499-.133.374-.133.748-.133 1.123-.133h.249c.374 0 .624-.133.998-.133h1.497c1.871 0 3.493.266 4.99.665.873-.399 1.871-.798 3.119-1.064.374-.133.748-.133 1.123-.133h.249c.374 0 .624-.133.998-.133h1.497c5.988 0 10.23 2.659 10.23 4.918v2.925c0 .133 0 .265-.125.398v.133c0 .133 0 .133-.125.266 0 .133-.125.133-.125.133 0 .133-.124.133-.124.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.125.133-.374.399-.624.532-.124.133-.249.266-.499.266-.124.133-.374.266-.499.266h-.124c-.125.133-.25.133-.499.266h-.125c-.125 0-.25.132-.374.132 0 0-.125 0-.125.133-.125 0-.25.133-.499.133-.25.133-.374.133-.624.266-.125 0-.249.133-.499.133-.125 0-.249 0-.374.133h-.25c-.124 0-.249 0-.499.133H422.531v.399c0 .133 0 .266-.125.398v.133c0 .133 0 .133-.125.266 0 .133-.124.133-.124.266s-.125.133-.125.266-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.399-.623.532-.125.133-.25.266-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.132-.249.132-.125 0-.125 0-.25.133-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H408.684c-.125 0-.25 0-.499-.133h-.125v2.26c0 .133 0 .265-.125.398v.133c0 .133 0 .133-.125.266 0 .133-.124.133-.124.266s-.125.133-.125.266-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.399-.623.532-.125.133-.25.266-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.132-.374.132 0 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133H395.335 393.963c-.125 0-.374 0-.499-.133-.125 0-.249 0-.499-.133-.249 0-.499-.133-.624-.133-.124 0-.249-.133-.499-.133-.124 0-.124 0-.249-.133-.125 0-.25-.133-.374-.133-.125 0-.25-.133-.499-.133-.125 0-.25-.132-.375-.132-.124 0-.124 0-.249-.133s-.25-.133-.499-.266c0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266h-.125c-.125-.133-.249-.266-.499-.266-.125-.133-.249-.133-.374-.266l-.125-.133-.125-.133-.499-.531-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.124-.398v-.399h-2.994-1.373c-.124 0-.374 0-.499-.133-.124 0-.249 0-.499-.133-.249 0-.499-.133-.623-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.125 0-.249-.133-.374-.133s-.25-.133-.499-.133c-.125 0-.25-.133-.374-.133 0 0-.125 0-.125-.132-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266h-.125c-.125-.133-.374-.266-.499-.266-.125-.133-.249-.133-.374-.266l-.125-.133-.125-.133c-.124 0-.124-.133-.249-.133-.25 0-.499-.132-.624-.132s-.249-.133-.499-.133c-.125 0-.125 0-.249-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.499-.133-.124 0-.249-.133-.374-.133s-.125 0-.249-.133c-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.133-.125-.133-.25-.133-.374-.266h-.125c-.125-.132-.374-.265-.499-.265-.125-.133-.25-.133-.374-.266l-.125-.133-.125-.133-.499-.532-.125-.133c0-.133-.124-.133-.124-.266 0 0 0-.132-.125-.132 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-1.595c-.124-.133-.249-.133-.374-.266s-.249-.133-.374-.266l-.125-.133-.125-.133-.499-.531-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.124-.398v-2.659c1.871-1.329 1.871-1.462 1.871-1.462z"
            fill="#fff"
            />
            <path
            opacity={0.3778}
            d="M369.761 144.647c0-.93.749-1.994 1.996-2.924.125-.133.25-.133.375-.266.124 0 .124-.133.249-.133s.25-.133.374-.133h.125a17.529 17.529 0 013.119-1.063h.125c.374-.133.623-.133.998-.133h.249c.374 0 .624-.133.998-.133h1.622c.624 0 1.247 0 1.871.133h.25c1.122 0 2.245.133 3.243.266.125-.133.374-.266.499-.399s.25-.133.374-.266c.125 0 .125-.133.25-.133s.249-.133.374-.133h.125a17.529 17.529 0 013.119-1.063h.124c.375-.133.624-.133.998-.133h.25c.374 0 .624-.133.998-.133H394.088c5.114 0 8.857 1.861 9.855 3.855.125 0 .374-.133.499-.133.374-.133.748-.133 1.123-.133h.249c.374 0 .624-.133.998-.133h1.497c1.871 0 3.493.266 4.99.665.873-.399 1.871-.798 3.119-1.064.374-.133.748-.133 1.123-.133h.249c.374 0 .624-.133.998-.133h1.497c5.988 0 10.23 2.659 10.23 4.918v2.925c0 .133 0 .265-.125.398v.133c0 .133 0 .133-.125.266 0 .133-.125.133-.125.133 0 .133-.124.133-.124.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.125.133-.374.266-.624.532-.124.133-.249.266-.499.266-.124.133-.374.266-.499.266h-.124c-.125.133-.25.133-.499.266h-.125c-.125 0-.25.132-.374.132 0 0-.125 0-.125.133-.125 0-.25.133-.499.133-.25.133-.374.133-.624.266-.125 0-.249.133-.499.133-.125 0-.249 0-.374.133h-.25c-.124 0-.249 0-.499.133H422.406v.399c0 .133 0 .266-.125.398v.133c0 .133 0 .133-.125.266 0 .133-.124.133-.124.266s-.125.133-.125.266-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.399-.623.532-.125.133-.25.266-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.132-.249.132-.125 0-.125 0-.25.133-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H408.559c-.125 0-.25 0-.499-.133h-.125v2.26c0 .133 0 .265-.125.398v.133c0 .133 0 .133-.125.266 0 .133-.124.133-.124.133 0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.266-.623.532-.125.133-.25.266-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.132-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133H395.21 393.838c-.125 0-.249 0-.499-.133-.125 0-.249 0-.499-.133-.249 0-.374-.133-.624-.133-.124 0-.249-.133-.499-.133-.124 0-.124 0-.249-.133-.125 0-.25-.133-.374-.133-.125 0-.25-.132-.499-.132-.125 0-.25-.133-.375-.133-.124 0-.124 0-.249-.133s-.25-.133-.499-.266c0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266h-.125c-.125-.133-.249-.266-.499-.266-.125-.133-.249-.133-.374-.266l-.125-.133-.125-.132-.499-.532-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.265-.124-.398v-.399h-2.994-1.373c-.124 0-.249 0-.499-.133-.124 0-.249 0-.499-.133-.249 0-.374-.133-.623-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.125 0-.249-.133-.374-.133s-.25-.133-.499-.133c-.125 0-.25-.132-.374-.132 0 0-.125 0-.125-.133-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266h-.125c-.125-.133-.249-.266-.499-.266-.125-.133-.249-.133-.374-.266l-.125-.133-.125-.133c-.124 0-.124-.132-.249-.132-.25 0-.374-.133-.624-.133-.125 0-.249-.133-.499-.133-.125 0-.125 0-.249-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.499-.133-.124 0-.249-.133-.374-.133s-.125 0-.249-.133c-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.133-.125-.133-.25-.133-.374-.265h-.125c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.374-.266l-.125-.133-.125-.133-.499-.532-.125-.133c0-.133-.124-.133-.124-.265 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-1.595c-.124-.133-.249-.133-.374-.266s-.249-.133-.374-.266l-.125-.133-.125-.132-.499-.532-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.265-.124-.398v-2.659c2.12-1.196 2.12-1.329 2.12-1.329z"
            fill="#F8F8F9"
            />
            <path
            opacity={0.4556}
            d="M369.885 144.514c0-.93.748-1.994 1.996-2.924.125-.133.249-.133.374-.266.125 0 .125-.133.25-.133.124 0 .249-.133.374-.133h.125c.873-.398 1.871-.797 3.118-1.063h.125c.374-.133.624-.133.998-.133h.25c.374 0 .623-.133.998-.133h1.621c.624 0 1.248 0 1.872.133h.249c1.123 0 2.246.133 3.244.266.124-.133.374-.266.499-.399.124-.133.249-.133.374-.266.125 0 .125-.133.249-.133.125 0 .25-.133.375-.133h.124c.874-.398 1.872-.797 3.119-1.063h.125c.374-.133.624-.133.998-.133h.249c.375 0 .624-.133.998-.133h1.622c4.99 0 8.733 1.861 9.855 3.855.125 0 .375-.133.499-.133.375-.133.749-.133 1.123-.133h.25c.374 0 .623-.133.998-.133H408.433c1.871 0 3.493.266 4.99.665.873-.399 1.871-.798 2.994-1.064.374-.133.748-.133 1.122-.133h.25c.374 0 .624-.133.998-.133h1.497c5.988 0 10.105 2.526 10.105 4.919v2.924c0 .133 0 .266-.125.399v.133c0 .132 0 .132-.125.265l-.125.133c0 .133-.124.133-.124.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.532c-.125.132-.374.265-.624.531-.124.133-.249.266-.499.266-.124.133-.374.266-.499.266h-.124c-.125.133-.25.133-.499.266h-.125c-.125 0-.25.133-.374.133 0 0-.125 0-.125.133-.125 0-.25.133-.499.133-.25.132-.374.132-.624.265-.125 0-.249.133-.499.133-.125 0-.249 0-.374.133h-.25c-.124 0-.249 0-.499.133H422.28v.399c0 .133 0 .266-.125.399v.133c0 .132 0 .132-.125.265 0 .133-.124.133-.124.266s-.125.133-.125.266-.125.133-.125.266c0 0 0 .133-.125.133l-.499.532c-.124.132-.374.398-.623.531-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.249.133-.125 0-.125 0-.25.133-.125 0-.249.133-.499.133-.249.132-.374.132-.624.265-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H408.433c-.125 0-.25 0-.499-.133h-.125v2.26c0 .133 0 .266-.125.399v.133c0 .132 0 .132-.125.265l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.532c-.124.132-.374.265-.623.531-.125.133-.25.266-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.132-.374.132-.624.265-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133H396.457h-1.123H393.962c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.132-.124 0-.249-.133-.374-.133s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133s-.125 0-.25-.133c-.124-.133-.249-.133-.499-.266 0 0-.124 0-.124-.133-.125-.133-.25-.133-.375-.266h-.124c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.375-.265l-.124-.133-.125-.133-.499-.532-.125-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.124-.133 0-.133-.125-.133-.125-.265v-.133c0-.133 0-.266-.125-.399v-.399h-2.869H382.485c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.124 0-.249-.132-.374-.132s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133 0 0-.125 0-.125-.133-.125-.133-.249-.133-.499-.266 0 0-.125 0-.125-.133-.124-.133-.249-.133-.374-.266h-.125c-.124-.133-.249-.266-.499-.266-.124-.133-.249-.133-.374-.265l-.125-.133-.124-.133c-.125 0-.125-.133-.125-.133-.25 0-.374-.133-.624-.133-.125 0-.249-.133-.499-.133-.125 0-.125 0-.249-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.499-.133-.124 0-.249-.133-.374-.133s-.125 0-.249-.133c-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.132-.125-.133-.25-.133-.374-.266h-.125c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.374-.266l-.125-.133-.125-.133-.499-.532-.125-.132c0-.133-.124-.133-.124-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-1.595c-.124-.133-.249-.133-.374-.266s-.249-.133-.374-.265l-.125-.133-.125-.133-.499-.532-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.265v-.133c0-.133 0-.266-.124-.399v-2.659c1.871-1.196 1.871-1.196 1.871-1.329z"
            fill="#F1F1F3"
            />
            <path
            opacity={0.5333}
            d="M370.011 144.514c0-.93.748-1.994 1.996-2.791.125-.133.249-.133.374-.266.125 0 .125-.133.25-.133.124 0 .249-.133.374-.133h.125c.873-.399 1.871-.797 3.118-1.063h.125c.374-.133.624-.133.998-.133h.25c.374 0 .623-.133.998-.133h1.621c.624 0 1.248 0 1.747.133h.249c1.123 0 2.246.133 3.244.266.125-.133.374-.266.499-.399s.249-.133.374-.266c.125 0 .125-.133.25-.133.124 0 .249-.133.374-.133h.125c.873-.399 1.871-.797 3.118-1.063h.125c.374-.133.624-.133.998-.133h.25c.374 0 .623-.133.998-.133h1.621c4.99 0 8.733 1.861 9.731 3.855.125 0 .374-.133.499-.133.374-.133.748-.133.998-.133h.249c.375 0 .624-.133.998-.133h1.497c1.872 0 3.493.266 4.866.665.873-.399 1.871-.798 2.994-1.064.374-.133.748-.133.998-.133h.249c.374 0 .624-.133.998-.133h1.497c5.988 0 10.105 2.526 10.105 4.918v2.925c0 .133 0 .265-.125.398v.133c0 .133 0 .133-.125.266l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.266-.623.532-.125.133-.25.266-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.132-.374.132 0 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-1.248v.399c0 .133 0 .266-.125.398v.133c0 .133 0 .133-.124.266 0 .133-.125.133-.125.133 0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.124.133l-.499.531c-.125.133-.375.399-.624.532-.125.133-.25.266-.499.266-.125.133-.374.133-.499.266h-.125c-.125.133-.249.133-.499.266h-.125c-.124 0-.249.133-.249.133-.125 0-.125 0-.125.132-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H408.06c-.125 0-.25 0-.499-.133h-.125v2.26c0 .133 0 .266-.125.398v.133c0 .133 0 .133-.125.266l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.266-.623.532-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.132-.499.132-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H393.589c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.124 0-.249-.132-.374-.132s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133s-.125 0-.25-.133c-.124-.133-.249-.133-.499-.266 0 0-.124 0-.124-.133-.125-.133-.25-.133-.375-.266h-.124c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.375-.266l-.124-.132-.125-.133-.499-.532-.125-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.124-.133 0-.133-.125-.133-.125-.266v-.133c0-.132 0-.265-.125-.398v-.399h-2.869H382.112c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.124 0-.249-.133-.374-.133s-.249-.132-.499-.132c-.125 0-.249-.133-.374-.133 0 0-.125 0-.125-.133-.125-.133-.249-.133-.499-.266 0 0-.125 0-.125-.133-.124-.133-.249-.133-.374-.266h-.125c-.124-.133-.249-.266-.499-.266-.124-.133-.249-.133-.374-.266l-.125-.133-.124-.132-.125-.133c-.25 0-.374-.133-.624-.133-.125 0-.249-.133-.499-.133-.125 0-.125 0-.249-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.499-.133-.124 0-.249-.133-.374-.133s-.125 0-.249-.133c-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.133-.125-.132-.25-.132-.374-.265h-.125c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.374-.266l-.125-.133-.125-.133-.499-.532-.125-.133c0-.132-.124-.132-.124-.265 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-1.595c-.124-.133-.249-.133-.374-.266s-.249-.133-.374-.266l-.125-.132-.125-.133-.499-.532-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.132 0-.265-.124-.398v-2.659c2.37-1.196 2.37-1.196 2.37-1.329z"
            fill="#EAEBEC"
            />
            <path
            opacity={0.6111}
            d="M370.136 144.514c0-.93.748-1.994 1.996-2.791.124-.133.249-.133.374-.266.125 0 .125-.133.249-.133.125 0 .25-.133.375-.133h.124c.874-.399 1.872-.797 3.119-1.063h.125c.374-.133.624-.133.998-.133h.249c.375 0 .624-.133.998-.133h1.497c.624 0 1.248 0 1.747.133h.249c1.123 0 2.246.133 3.244.266.125-.133.374-.266.499-.399s.249-.133.374-.266c.125 0 .125-.133.25-.133.124 0 .249-.133.374-.133h.125c.873-.399 1.871-.797 3.118-1.063h.125c.374-.133.624-.133.998-.133h.25c.249 0 .623-.133.998-.133h1.621c4.99 0 8.733 1.861 9.731 3.722.125 0 .374-.133.499-.133.374-.133.748-.133.998-.133h.249c.375 0 .624-.133.998-.133h1.497c1.872 0 3.493.266 4.866.665.873-.399 1.871-.798 2.994-1.064.374-.133.748-.133.998-.133h.249c.374 0 .624-.133.998-.133h1.497c5.863 0 10.105 2.526 10.105 4.918v2.925c0 .133 0 .266-.125.398v.133c0 .133 0 .133-.125.266l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.266-.623.532-.125.133-.25.266-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.132-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-1.248v.399c0 .133 0 .266-.125.399v.132c0 .133 0 .133-.124.266 0 .133-.125.133-.125.133 0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.124.133l-.499.532c-.125.132-.375.265-.624.531-.125.133-.25.266-.499.266-.125.133-.374.133-.499.266h-.125c-.125.133-.249.133-.499.266h-.125c-.124 0-.249.133-.249.133s-.125 0-.125.133c-.125 0-.249.132-.499.132-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H408.06c-.125 0-.25 0-.499-.133h-.125v2.26c0 .133 0 .266-.125.399v.132c0 .133 0 .133-.125.266l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.532c-.124.132-.374.398-.623.531-.125.133-.25.266-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.132-.374.132-.624.265-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133H396.084h-1.123H393.589c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.132-.124 0-.249-.133-.374-.133s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133s-.125 0-.25-.133c-.124-.133-.249-.133-.499-.266 0 0-.124 0-.124-.133-.125-.133-.25-.133-.375-.266h-.124c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.375-.265l-.124-.133-.125-.133-.499-.532-.125-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.124-.133 0-.133-.125-.133-.125-.266v-.132c0-.133 0-.266-.125-.399v-.399h-2.869H382.112c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.124 0-.249-.132-.374-.132s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133 0 0-.125 0-.125-.133-.125-.133-.249-.133-.499-.266 0 0-.125 0-.125-.133-.124-.133-.249-.133-.374-.266h-.125c-.124-.133-.249-.266-.499-.266-.124-.133-.249-.133-.374-.266l-.125-.132-.124-.133-.125-.133c-.25 0-.374-.133-.624-.133-.125 0-.249-.133-.499-.133-.125 0-.125 0-.249-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.499-.133-.124 0-.249-.133-.374-.133s-.125 0-.249-.133c-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.132-.125-.133-.25-.133-.374-.266h-.125c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.374-.266l-.125-.133-.125-.133-.499-.532-.125-.132c0-.133-.124-.133-.124-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-1.595c-.124-.133-.249-.133-.374-.266s-.249-.133-.374-.265l-.125-.133-.125-.133-.499-.532-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.132c0-.133 0-.266-.124-.399v-2.659c2.495-1.063 2.495-1.196 2.495-1.196z"
            fill="#E3E4E6"
            />
            <path
            opacity={0.6889}
            d="M370.26 144.381c0-.93.749-1.994 1.996-2.791.125-.133.25-.133.375-.266.124 0 .124-.133.249-.133s.25-.133.374-.133h.125c.873-.399 1.871-.798 3.119-1.063h.125c.374-.133.623-.133.998-.133h.249c.374 0 .624-.133.998-.133h1.497c.624 0 1.248 0 1.747.133h.249c1.123 0 2.246.133 3.244.266.124-.133.374-.266.499-.399.124-.133.249-.133.374-.266.125 0 .125-.133.249-.133.125 0 .25-.133.375-.133h.124c.874-.399 1.872-.797 3.119-1.063h.125c.374-.133.624-.133.998-.133h.249c.25 0 .624-.133.998-.133h1.622c4.99 0 8.608 1.861 9.731 3.722.124 0 .374-.133.499-.133.374-.133.748-.133.998-.133h.249c.374 0 .624-.133.998-.133h1.497c1.871 0 3.493.266 4.865.665.874-.399 1.872-.798 2.994-1.064.375-.133.749-.133.998-.133h.25c.374 0 .624-.133.998-.133h1.497c5.863 0 9.98 2.526 9.98 4.785v2.925c0 .133 0 .266-.125.398v.133c0 .133 0 .133-.125.266l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.266-.623.532-.125.133-.25.133-.499.266-.125.133-.375.133-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.132-.499.132-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-1.248v.399c0 .133 0 .266-.125.399v.132c0 .133 0 .133-.124.266l-.125.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.124.133l-.499.532c-.125.132-.375.265-.624.531-.125.133-.25.133-.499.266-.125.133-.374.133-.499.266h-.125c-.125.133-.249.133-.499.266h-.125c-.124 0-.249.133-.249.133-.125 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.132-.374.132-.624.265-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H408.06c-.125 0-.25 0-.499-.133h-.125v2.127c0 .133 0 .266-.125.399v.133c0 .133 0 .133-.125.265l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.532c-.124.133-.374.265-.623.531-.125.133-.25.133-.499.266-.125.133-.375.133-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.133-.374.133-.624.265-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133H396.084h-1.123H393.589c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.132-.499-.132-.125 0-.125 0-.25-.133-.124 0-.249-.133-.374-.133s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133s-.125 0-.25-.133c-.124-.133-.249-.133-.499-.266 0 0-.124 0-.124-.133-.125-.133-.25-.133-.375-.266h-.124c-.125-.133-.25-.266-.499-.266-.125-.132-.25-.132-.375-.265l-.124-.133-.125-.133-.499-.532-.125-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.124-.133 0-.132-.125-.132-.125-.265v-.133c0-.133 0-.266-.125-.399v-.399h-1.746-1.123H382.112c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.132-.124 0-.249-.133-.374-.133s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133 0 0-.125 0-.125-.133-.125-.133-.249-.133-.499-.266 0 0-.125 0-.125-.133-.124-.133-.249-.133-.374-.266h-.125c-.124-.133-.249-.266-.499-.266-.124-.132-.249-.133-.374-.265l-.125-.133-.124-.133-.125-.133c-.25 0-.374-.133-.624-.133-.125 0-.249-.133-.499-.133-.125 0-.125 0-.249-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.499-.133-.124 0-.249-.133-.374-.133 0 0-.125 0-.249-.133-.125-.133-.25-.133-.499-.265 0 0-.125 0-.125-.133-.125-.133-.25-.133-.374-.266h-.125c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.374-.266l-.125-.133-.125-.133-.499-.531-.125-.133c0-.133-.124-.133-.124-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-1.595c-.124-.133-.249-.133-.374-.266-.125-.132-.249-.132-.374-.265l-.125-.133-.125-.133-.499-.532-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.265v-.133c0-.133 0-.266-.124-.399v-2.659c2.619-.797 2.619-.797 2.619-.93z"
            fill="#DDDDE0"
            />
            <path
            opacity={0.7667}
            d="M370.51 144.381c0-.93.748-1.994 1.996-2.791.124-.133.249-.133.374-.266.125 0 .125-.133.249-.133.125 0 .25-.133.375-.133h.124c.874-.399 1.872-.798 2.994-1.063h.125c.374-.133.624-.133.998-.133h.25c.249 0 .623-.133.998-.133H380.49c.623 0 1.247 0 1.746.133h.25c1.122 0 2.245.133 3.243.266.125-.133.374-.266.499-.399s.25-.133.374-.266c.125 0 .125-.133.25-.133s.249-.133.374-.133h.125c.873-.399 1.871-.797 2.994-1.063h.125c.374-.133.623-.133.998-.133h.249c.25 0 .624-.133.998-.133h1.622c4.99 0 8.608 1.861 9.606 3.722.124 0 .374-.133.499-.133.374-.133.623-.133.998-.133h.249c.374 0 .624-.133.998-.133h1.497c1.871 0 3.493.266 4.865.665.874-.399 1.872-.798 2.994-.931.375-.133.624-.133.998-.133h.25c.374 0 .624-.133.998-.133h1.497c5.863 0 9.98 2.526 9.98 4.785v2.925c0 .133 0 .265-.125.398v.133c0 .133 0 .133-.125.266l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.531c-.124.133-.374.266-.623.532-.125.133-.25.133-.499.266-.125.133-.375.133-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.132-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-1.248v.399c0 .133 0 .266-.125.398v.133c0 .133 0 .133-.124.266l-.125.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.124.133l-.499.531c-.125.133-.375.266-.624.532-.125.133-.25.133-.499.266-.125.133-.374.133-.499.266h-.125c-.125.133-.249.133-.499.266h-.125c-.124 0-.249.133-.249.133s-.125 0-.125.133c-.125 0-.249.132-.499.132-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H407.935c-.125 0-.25 0-.499-.133h-.125v2.127c0 .133 0 .266-.125.399v.133c0 .132 0 .132-.125.265l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.532c-.124.132-.374.265-.623.531-.125.133-.25.133-.499.266-.125.133-.375.266-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.132-.374.132-.624.265-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133H395.959h-1.123H393.464c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.132-.124 0-.249-.133-.374-.133s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133s-.125 0-.25-.133c-.124-.133-.249-.133-.499-.266 0 0-.124 0-.124-.133-.125-.133-.25-.133-.375-.266h-.124c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.375-.265l-.124-.133-.125-.133-.499-.532-.125-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.124-.133 0-.133-.125-.133-.125-.265v-.133c0-.133 0-.266-.125-.399v-.399h-1.746-1.123H381.987c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.124 0-.249-.132-.374-.132s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133 0 0-.125 0-.125-.133-.125-.133-.249-.133-.499-.266 0 0-.125 0-.125-.133-.124-.133-.249-.133-.374-.266h-.125c-.124-.133-.249-.266-.499-.266-.124-.133-.249-.133-.374-.265l-.125-.133-.124-.133-.125-.133c-.25 0-.374-.133-.624-.133-.125 0-.249-.133-.499-.133-.125 0-.125 0-.249-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.499-.133-.124 0-.249-.133-.374-.133 0 0-.125 0-.249-.133-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.132-.125-.133-.25-.133-.374-.266h-.125c-.125-.133-.25-.266-.499-.266-.125-.133-.25-.133-.374-.266l-.125-.133-.125-.133-.499-.532-.125-.132c0-.133-.124-.133-.124-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-1.595c-.124-.133-.249-.133-.374-.266s-.249-.133-.374-.265l-.125-.133-.125-.133-.499-.532-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.132c0-.133 0-.266-.124-.399v-2.659c2.994-.93 2.994-.93 2.994-1.063z"
            fill="#D6D6DA"
            />
            <path
            opacity={0.8444}
            d="M370.634 144.381c0-.93.749-1.994 1.996-2.791.125-.133.25-.133.374-.266.125 0 .125-.133.25-.133s.249-.133.374-.133h.125c.873-.399 1.871-.797 2.994-1.063h.125c.374-.133.623-.133.998-.133h.249c.25 0 .624-.133.998-.133h1.497c.624 0 1.248 0 1.747.133h.249c1.123 0 2.246.133 3.119.266.125-.133.249-.266.499-.399.125-.133.249-.133.374-.133s.125-.133.25-.133c.124 0 .249-.133.374-.133h.125c.873-.399 1.871-.797 2.994-1.063h.124c.375-.133.624-.133.998-.133h.25c.249 0 .624-.133.998-.133H394.337c4.865 0 8.607 1.861 9.605 3.722.125 0 .375-.133.499-.133.375-.133.624-.133.998-.133h.25c.374 0 .624-.133.998-.133h1.497c1.746 0 3.493.266 4.865.665.873-.399 1.871-.798 2.994-.931.374-.133.624-.133.998-.133h.25c.374 0 .623-.133.998-.133H419.786c5.863 0 9.855 2.526 9.855 4.785v2.792c0 .133 0 .266-.125.399v.132c0 .133 0 .133-.125.266l-.124.133c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.532c-.124.132-.374.265-.623.531-.125.133-.25.133-.499.266-.125.133-.375.133-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.132-.499.132-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-1.248v.399c0 .133 0 .266-.125.399v.133c0 .132 0 .132-.124.265l-.125.133c0 .133-.125.133-.125.133 0 .133-.125.133-.125.266 0 0 0 .133-.124.133l-.499.532c-.125.133-.375.266-.624.531-.125.133-.25.133-.499.266-.125.133-.374.133-.499.266h-.125c-.125.133-.249.133-.499.266h-.125c-.124 0-.249.133-.249.133s-.125 0-.125.133c-.125 0-.249.133-.499.133-.249.133-.374.133-.624.265-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133h-5.614H407.81c-.125 0-.25 0-.499-.133h-.125v2.127c0 .133 0 .266-.125.399v.133c0 .133 0 .133-.125.266l-.124.132c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.125.133l-.499.532c-.124.133-.374.266-.623.531-.125.133-.25.133-.499.266-.125.133-.375.133-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.133-.499.133-.124 0-.249 0-.374.132h-.249c-.125 0-.25 0-.499.133H395.834h-1.123H393.339c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.132-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.124 0-.249-.133-.374-.133s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133s-.125 0-.25-.133c-.124-.133-.249-.133-.499-.266 0 0-.124 0-.124-.133-.125-.133-.25-.133-.375-.266h-.124c-.125-.132-.25-.265-.499-.265-.125-.133-.25-.133-.375-.266l-.124-.133-.125-.133-.499-.532-.125-.133c0-.133-.125-.133-.125-.266 0 0 0-.132-.124-.132 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-1.063h-1.746-1.123H381.862c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.133-.624-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.124 0-.249-.133-.374-.133s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133 0 0-.125 0-.125-.133-.125-.133-.249-.133-.499-.265 0 0-.125 0-.125-.133-.124-.133-.249-.133-.374-.266h-.125c-.124-.133-.249-.266-.499-.266-.124-.133-.249-.133-.374-.266l-.125-.133-.124-.133-.125-.133c-.25 0-.374-.133-.624-.133-.125 0-.249-.132-.499-.132-.125 0-.125 0-.249-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.499-.133-.124 0-.249-.133-.374-.133 0 0-.125 0-.249-.133-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.133-.125-.133-.25-.133-.374-.266h-.125c-.125-.133-.25-.266-.499-.266-.125-.132-.25-.132-.374-.265l-.125-.133-.125-.133-.499-.532-.125-.133c0-.133-.124-.133-.124-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.265v-.133c0-.133 0-.266-.125-.399v-1.595c-.124-.133-.249-.133-.374-.266s-.249-.133-.374-.266l-.125-.133-.125-.133-.499-.531-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.124-.399v-2.525c3.243-.266 3.243-.399 3.243-.399z"
            fill="#CFD0D3"
            />
            <path
            opacity={0.9222}
            d="M370.759 144.248c0-.93.749-1.994 1.996-2.791.125-.133.25-.133.375-.266.124 0 .124-.133.249-.133s.25-.133.374-.133h.125c.873-.399 1.871-.797 2.994-1.063h.125c.374 0 .624-.133.998-.133h.249c.25 0 .624-.133.998-.133h1.497c.624 0 1.248 0 1.747.133h.249c1.123 0 2.121.133 3.119.266a1.75 1.75 0 01.499-.399c.125-.133.25-.133.374-.133.125 0 .125-.133.25-.133s.249-.133.374-.133h.125c.873-.399 1.871-.797 2.994-1.063h.125c.374-.133.623-.133.998-.133h.249c.25 0 .624-.133.873-.133h1.622c4.865 0 8.483 1.728 9.606 3.722.125 0 .374-.133.499-.133.374-.133.624-.133.998-.133h.249c.375 0 .624-.133.998-.133h1.497c1.747 0 3.369.266 4.866.665.873-.399 1.871-.798 2.994-.931.374-.133.623-.133.998-.133h.249c.374 0 .624-.133.998-.133h1.497c5.863 0 9.855 2.526 9.855 4.785v2.792c0 .133 0 .266-.124.398v.133c0 .133 0 .133-.125.266l-.125.133c0 .133-.125.133-.125.266s-.124.133-.124.266c0 0 0 .133-.125.133l-.499.531c-.125.133-.374.266-.624.532-.125.133-.249.133-.499.266-.125.133-.374.133-.499.266h-.125c-.124.133-.249.133-.499.266h-.124c-.125 0-.25.133-.375.133 0 0-.124 0-.124.133-.125 0-.25.132-.375.132-.249.133-.374.133-.623.266-.125 0-.25.133-.499.133-.125 0-.25 0-.375.133h-.249c-.125 0-.25 0-.499.133h-1.248v.399c0 .133 0 .266-.124.399v.132c0 .133 0 .133-.125.266l-.125.133-.125.133c0 .133-.124.133-.124.266 0 0 0 .133-.125.133l-.499.532c-.125.133-.374.265-.624.531-.125.133-.249.133-.374.266s-.374.133-.499.266h-.125c-.125.133-.249.133-.499.266h-.125c-.124 0-.249.133-.249.133s-.125 0-.125.133c-.125 0-.249.133-.499.133-.249.132-.374.133-.624.265-.124 0-.249.133-.499.133-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.375.133h-5.364H408.434c-.125 0-.25 0-.499-.133h-.125v2.127c0 .133 0 .266-.125.399v.133c0 .133 0 .133-.124.266l-.125.132c0 .133-.125.133-.125.266s-.125.133-.125.266c0 0 0 .133-.124.133l-.499.532c-.125.133-.375.266-.624.531-.125.133-.25.133-.374.266-.125.133-.375.133-.499.266h-.125c-.125.133-.25.133-.499.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.133-.499.133-.249.133-.374.133-.624.266-.124 0-.249.132-.499.132-.124 0-.249 0-.374.133h-.249c-.125 0-.25 0-.499.133H396.583h-1.123H394.088c-.125 0-.25 0-.499-.133-.125 0-.25 0-.499-.133-.25 0-.375-.132-.624-.132-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.124 0-.249-.133-.374-.133s-.249-.133-.499-.133c-.125 0-.249-.133-.374-.133s-.125 0-.25-.133c-.124-.133-.249-.133-.499-.266 0 0-.124 0-.124-.133-.125-.133-.25-.133-.375-.266h-.124c-.125-.133-.25-.265-.499-.265-.125-.133-.25-.133-.375-.266l-.124-.133-.125-.133-.499-.532-.125-.133c0-.133-.125-.133-.125-.266 0 0 0-.132-.124-.132 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.125-.399v-.399h-1.746-1.123-1.248c-.124 0-.249 0-.499-.133-.124 0-.249 0-.499-.133-.249 0-.374-.133-.623-.133-.125 0-.25-.132-.499-.132-.125 0-.125 0-.25-.133-.125 0-.249-.133-.374-.133s-.25-.133-.499-.133c-.125 0-.25-.133-.374-.133 0 0-.125 0-.125-.133-.125-.133-.25-.133-.499-.266 0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266h-.125c-.125-.133-.249-.265-.374-.265-.125-.133-.25-.133-.374-.266l-.125-.133-.125-.133-.125-.133c-.249 0-.374-.133-.623-.133-.125 0-.25-.133-.499-.133-.125 0-.125 0-.25-.133-.125 0-.249-.133-.374-.133s-.25-.133-.499-.133c-.125 0-.25-.133-.374-.133 0 0-.125 0-.25-.133-.125-.132-.249-.132-.374-.265 0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266h-.125c-.125-.133-.249-.266-.499-.266-.125-.133-.249-.133-.374-.266l-.125-.133-.125-.133-.499-.531-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.124-.399v-1.595c-.125-.133-.25-.133-.375-.265-.124-.133-.249-.133-.374-.266l-.125-.133-.124-.133c-.125-.133-.375-.399-.375-.532l-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.132-.125-.132-.125-.265v-.133c0-.133 0-.266-.124-.399v-2.526c2.12-.93 2.12-.93 2.12-1.063z"
            fill="#C8C9CD"
            />
            <path
            d="M370.883 144.248c0-.93.748-1.993 1.996-2.791.125-.133.249-.133.374-.266.125 0 .125-.133.25-.133.124 0 .249-.133.374-.133h.125c.873-.398 1.871-.797 2.994-1.063h.124c.375-.133.624-.133.998-.133h.25c.249 0 .624-.133.998-.133h1.497c.624 0 1.247 0 1.746.133h.25c1.123 0 2.121.133 3.119.266.124-.133.249-.266.499-.399.124-.133.249-.133.374-.133s.125-.133.249-.133c.125 0 .25-.133.375-.133h.124c.874-.398 1.872-.797 2.994-1.063h.125c.374 0 .624-.133.998-.133h.25c.249 0 .623-.133.873-.133h1.497c4.865 0 8.483 1.728 9.481 3.722.125 0 .374-.133.499-.133.374-.133.624-.133.998-.133h.249c.375 0 .624-.133.998-.133h1.497c1.747 0 3.369.266 4.741.665.873-.399 1.871-.798 2.994-.931.374-.133.624-.133.998-.133h.249c.375 0 .624-.133.998-.133h1.497c5.739 0 9.856 2.526 9.856 4.786v2.658c0 .133 0 .266-.125.399v.133c0 .133 0 .133-.125.266l-.125.133c0 .132-.124.132-.124.265s-.125.133-.125.266c0 0 0 .133-.125.133l-.374.399c-.125.133-.374.266-.624.532-.125.132-.249.132-.374.265s-.374.133-.499.266h-.125c-.125.133-.249.133-.374.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.133-.374.133-.25.133-.374.133-.624.133-.125 0-.249.133-.374.133s-.25 0-.374.133h-.25c-.125 0-.249 0-.374.133h-1.123v.398c0 .133 0 .266-.125.399v.133c0 .133 0 .133-.124.266l-.125.133-.125.133c0 .133-.125.133-.125.265 0 0 0 .133-.124.133l-.375.399c-.124.133-.374.266-.623.532-.125.133-.25.133-.375.266-.124.133-.374.133-.499.266h-.124c-.125.132-.25.132-.375.265h-.124c-.125 0-.25.133-.25.133s-.125 0-.125.133c-.124 0-.249.133-.374.133-.249.133-.374.133-.624.133-.124 0-.249.133-.374.133s-.249 0-.374.133h-.25c-.124 0-.249 0-.374.133h-4.99-1.123c-.124 0-.249 0-.499-.133h-.124v2.127c0 .133 0 .265-.125.398v.133c0 .133 0 .133-.125.266l-.125.133c0 .133-.124.133-.124.133 0 .133-.125.133-.125.266 0 0 0 .133-.125.133l-.374.399c-.125.132-.374.265-.624.531-.125.133-.249.133-.374.266s-.374.133-.499.266h-.125c-.125.133-.249.133-.374.266h-.125c-.125 0-.249.133-.374.133 0 0-.125 0-.125.133-.125 0-.249.132-.374.132-.25.133-.374.133-.624.133-.125 0-.249.133-.374.133s-.25 0-.374.133h-.25c-.125 0-.249 0-.374.133H399.326h-.998-1.123c-.125 0-.249 0-.499-.133-.125 0-.249 0-.374-.133-.25 0-.374-.133-.624-.133-.125 0-.249-.133-.374-.133s-.125 0-.25-.132c-.124 0-.249-.133-.374-.133s-.249-.133-.374-.133-.25-.133-.374-.133c-.125 0-.125 0-.25-.133s-.249-.133-.374-.266c0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266h-.125c-.125-.133-.249-.266-.374-.266-.125-.132-.25-.132-.374-.265l-.125-.133-.125-.133c-.125-.133-.374-.399-.374-.532l-.125-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.124-.133 0-.133-.125-.133-.125-.265v-.133c0-.133 0-.266-.125-.399v-.399H389.221h-.998-1.123c-.124 0-.249 0-.499-.133-.124 0-.249 0-.374-.133-.249 0-.374-.133-.624-.133-.124 0-.249-.133-.374-.133s-.125 0-.249-.132c-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.374-.133s-.249-.133-.374-.133c0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266 0 0-.125 0-.125-.133-.125-.133-.249-.133-.374-.266h-.125c-.125-.133-.249-.266-.374-.266-.125-.133-.25-.133-.374-.265l-.125-.133-.125-.133-.125-.133c-.249 0-.374-.133-.623-.133-.125 0-.25-.133-.375-.133-.124 0-.124 0-.249-.133-.125 0-.25-.133-.374-.133-.125 0-.25-.133-.375-.133-.124 0-.249-.133-.374-.133 0 0-.125 0-.249-.133-.125-.133-.25-.133-.375-.266 0 0-.124 0-.124-.132-.125-.133-.25-.133-.375-.266h-.124c-.125-.133-.25-.266-.375-.266-.124-.133-.249-.133-.374-.266l-.125-.133-.124-.133c-.125-.133-.375-.399-.375-.531l-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.266v-.133c0-.133 0-.266-.124-.399v-1.595c-.125-.133-.25-.133-.375-.266-.124-.132-.249-.133-.374-.265l-.125-.133-.124-.133c-.125-.133-.375-.399-.375-.532l-.124-.133c0-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.133-.125-.265v-.133c0-.133 0-.266-.124-.399v-2.526c-3.119.133-3.119.133-3.119 0z"
            fill="#C1C2C7"
            />
            <path
            d="M419.414 143.982c1.247 0 2.495.133 3.493.266h6.237v2.526c-.125 2.259-4.117 4.652-9.855 4.652-5.739 0-9.606-2.393-9.855-4.652v-2.526h6.237c1.248-.133 2.495-.266 3.743-.266z"
            fill="#0EA59D"
            />
            <path
            d="M419.414 151.559c-5.614 0-9.606-2.393-9.855-4.652v-2.792h6.362c1.123-.265 2.245-.265 3.493-.265 1.247 0 2.37.133 3.493.265h6.362v2.659c-.249 2.392-4.241 4.785-9.855 4.785zm-9.731-4.785c.125 2.26 4.117 4.519 9.731 4.519s9.606-2.392 9.73-4.519v-2.526h-6.237c-1.123-.265-2.246-.265-3.493-.265-1.248 0-2.37.132-3.493.265h-6.238v2.526z"
            fill="#131A2D"
            />
            <path
            d="M428.145 148.768c-.125.133-.374.399-.624.532v-5.051h.624v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M427.396 149.433v-5.317h.749v4.652c-.125.266-.374.399-.749.665zm.125-5.051v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M416.421 144.115v7.045c-.25 0-.375-.133-.624-.133v-6.779c.249 0 .499 0 .624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M416.545 151.293c-.249 0-.499-.133-.748-.133v-7.045h.125c.124 0 .374 0 .499-.133h.124v7.311zm-.623-.266c.124 0 .374 0 .499.133v-6.912c-.125 0-.375 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M417.542 151.426c-.25 0-.375 0-.624-.133v-7.178c.249 0 .374 0 .624-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M417.666 151.426c-.249 0-.499 0-.748-.133v-7.31c.249 0 .374 0 .624-.133h.124v7.576zm-.623-.266h.499v-7.177h-.499v7.177z"
            fill="#131A2D"
            />
            <path
            d="M412.303 149.831c-.249-.133-.374-.266-.623-.399v-5.184h.623v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M412.303 149.964c-.374-.133-.499-.266-.748-.399v-5.317h.748v5.716zm-.624-.532c.125.133.25.133.499.266v-5.45h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M418.542 151.426h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M418.666 151.559h-.873v-7.577h.873v7.577zm-.624-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M411.18 149.167c-.249-.133-.499-.399-.623-.532v-4.386h.623v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M411.305 149.3a4.05 4.05 0 01-.748-.664v-4.52h.748v5.184zm-.624-.664c.125.132.25.265.499.398v-4.652h-.499v4.254z"
            fill="#131A2D"
            />
            <path
            d="M414.425 150.761c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M414.424 150.894c-.249-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.399c.124 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M415.423 151.027c-.25 0-.375-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M415.547 151.16c-.249 0-.499-.133-.748-.133v-6.779h.748v6.912zm-.623-.399c.124 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M413.301 150.362c-.249-.133-.374-.133-.623-.265v-5.849h.623v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M413.426 150.495c-.374-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.624-.398c.125.132.375.132.499.265v-5.848h-.499v5.583z"
            fill="#131A2D"
            />
            <path
            d="M424.903 150.628c-.249.133-.374.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M424.279 150.894v-6.646h.749v6.38c-.25.133-.499.133-.749.266zm.125-6.513v6.247c.125 0 .374-.133.499-.133v-6.114h-.499z"
            fill="#131A2D"
            />
            <path d="M420.661 151.426h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M420.037 151.559v-7.577h.873v7.577h-.873zm.125-7.577v7.311h.499v-7.311a.362.362 0 01-.499 0z"
            fill="#131A2D"
            />
            <path d="M419.663 143.982v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M419.413 151.559h-.499v-7.709h.873v7.709h-.374zm-.374-.133h.499v-7.443h-.499v7.443z"
            fill="#131A2D"
            />
            <path
            d="M429.268 146.907c0 .532-.249 1.064-.623 1.463v-4.121h.623v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M428.52 148.503v-4.387h.873v2.659c0 .531-.25.93-.624 1.462l-.249.266zm.124-4.121v3.722c.375-.399.499-.931.499-1.329v-2.526h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M410.183 148.104c-.25-.399-.499-.931-.499-1.329v-2.526h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M410.182 148.37l-.124-.133c-.25-.399-.499-.798-.499-1.329v-2.792h.623v4.254zm-.499-1.595c0 .398.125.797.375 1.063v-3.589h-.375v2.526z"
            fill="#131A2D"
            />
            <path
            d="M427.024 149.565c-.249.133-.374.266-.624.399v-5.716h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M426.4 150.097v-5.849h.749v5.45l-.749.399zm.125-5.716v5.45c.125-.133.374-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M421.784 151.293h-.624v-7.311c.25 0 .374 0 .624.133v7.178z"
            fill="#0EA59D"
            />
            <path
            d="M421.035 151.426v-7.444h.125c.249 0 .374 0 .624.133h.124v7.311h-.873zm.125-7.311v7.178h.499v-7.045c-.125-.133-.25-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M426.026 150.23c-.249.133-.374.133-.624.266v-6.114h.624v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M425.277 150.496v-6.38h.749v5.982c-.25.265-.374.265-.749.398zm.125-6.114v5.981c.125 0 .374-.132.499-.265v-5.716h-.499z"
            fill="#131A2D"
            />
            <path
            d="M423.905 150.894c-.25 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M423.156 151.16v-6.912h.749v6.779c-.25 0-.375 0-.749.133zm.125-6.779v6.646c.125 0 .374-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M422.782 151.161c-.25 0-.374.133-.624.133v-7.045c.25 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M422.158 151.293v-7.311h.125c.249 0 .374.133.624.133v7.045c-.25.133-.499.133-.749.133zm.125-7.045v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M419.414 139.33c5.738 0 9.855 2.526 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785s-9.855-2.525-9.855-4.785c0-2.259 4.116-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M419.414 148.9c-5.863 0-9.855-2.525-9.855-4.785 0-2.259 4.116-4.785 9.855-4.785 5.863 0 9.855 2.526 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785zm0-9.437c-5.739 0-9.731 2.525-9.731 4.652 0 2.26 3.992 4.652 9.731 4.652 5.738 0 9.73-2.525 9.73-4.652 0-2.259-3.992-4.652-9.73-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M425.774 147.571c-.623.266-1.372.532-2.12.665l-8.109-8.64c.748-.133 1.622-.266 2.495-.399l7.734 8.374zM420.161 148.767H418.664l-6.986-7.443c.374-.266.623-.399.998-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M422.532 148.369c.125 0 .374-.133.499-.133.374-.133.624-.133.998-.266s.624-.266.998-.399c.125 0 .374-.133.499-.133l.249-.133c.125 0 .125-.132.25-.132.374-.133.624-.266.998-.532.624-.399 1.247-.798 1.746-1.196a4.454 4.454 0 01-1.497 1.595c-.124.133-.249.265-.499.265-.124.133-.374.133-.499.266-.124 0-.124.133-.249.133l-.25.133c-.124.133-.374.133-.499.266l-.499.133c-.124 0-.374.133-.499.133-.374.133-.748.133-1.122.266-.375 0-.749 0-1.123.133h-1.123c.374-.133.749-.133.998-.266l.624-.133zM417.668 148.501l1.372.133.749.133c.249 0 .499.133.748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.499 0 .998 0 1.497.133z"
            fill="#fff"
            />
            <path
            d="M411.802 148.902c1.248 0 2.495.133 3.493.266h6.238v2.526c-.125 2.259-4.117 4.652-9.855 4.652-5.614 0-9.606-2.393-9.856-4.652v-2.526h6.238c1.247-.133 2.495-.266 3.742-.266z"
            fill="#0EA59D"
            />
            <path
            d="M411.803 156.478c-5.614 0-9.606-2.393-9.856-4.652v-2.792h6.363c1.122-.265 2.245-.265 3.493-.265 1.247 0 2.37.132 3.493.265h6.362v2.659c-.25 2.392-4.242 4.785-9.855 4.785zm-9.731-4.785c.125 2.259 4.117 4.652 9.731 4.652 5.613 0 9.605-2.393 9.73-4.519V149.3h-6.237c-1.123-.266-2.246-.266-3.493-.266-1.248 0-2.371.133-3.493.266h-6.238v2.393z"
            fill="#131A2D"
            />
            <path
            d="M420.411 153.687c-.125.133-.374.399-.624.532v-5.051h.624v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M419.787 154.352v-5.317h.749v4.652c-.25.266-.375.399-.749.665zm.125-5.051v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M408.809 149.035v7.045c-.249 0-.374-.133-.623-.133v-6.779c.249 0 .499 0 .623-.133z"
            fill="#0EA59D"
            />
            <path
            d="M408.934 156.213c-.249 0-.499-.133-.748-.133v-7.045h.124c.125 0 .375 0 .499-.133h.125v7.311zm-.624-.266c.125 0 .375 0 .499.133v-6.912c-.124 0-.374 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M409.932 156.212c-.249 0-.374 0-.623-.133v-7.178c.249 0 .374 0 .623-.132v7.443z"
            fill="#0EA59D"
            />
            <path
            d="M409.932 156.345c-.25 0-.499 0-.749-.133h-.124v-7.311h.124c.25 0 .375 0 .624-.132h.125v7.576zm-.624-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M404.567 154.75c-.249-.133-.374-.266-.624-.399v-5.184h.624v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M404.692 154.883c-.374-.133-.499-.266-.749-.399v-5.317h.749v5.716zm-.624-.532c.125.133.374.133.499.266V149.3h-.499v5.051z"
            fill="#131A2D"
            />
            <path d="M410.928 156.346h-.623v-7.444h.623v7.444z" fill="#0EA59D" />
            <path
            d="M411.053 156.479h-.873v-7.577h.873v7.577zm-.624-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M403.569 154.086c-.249-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M403.694 154.219c-.374-.266-.624-.399-.749-.665v-4.519h.749v5.184zm-.624-.665c.125.133.25.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M406.688 155.68c-.249 0-.374-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M406.813 155.813c-.25-.133-.499-.133-.749-.266v-6.38h.749v6.646zm-.624-.399c.125 0 .374.133.499.133V149.3h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M407.811 155.946c-.249 0-.374-.133-.623-.133v-6.646h.623v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M407.811 156.079c-.249-.133-.499-.133-.749-.133v-6.779h.749v6.912zm-.624-.399c.125 0 .374.133.499.133V149.3h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M405.69 155.281c-.249-.133-.374-.133-.624-.265v-5.849h.624v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M405.69 155.414c-.374-.133-.499-.266-.749-.266v-5.981h.749v6.247zm-.624-.531c.125.132.374.133.499.265V149.3h-.499v5.583z"
            fill="#131A2D"
            />
            <path
            d="M417.292 155.547c-.25.133-.375.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M416.668 155.813v-6.646h.748v6.513c-.249 0-.499 0-.748.133zm.125-6.513v6.38c.124 0 .374-.133.499-.133V149.3h-.499z"
            fill="#131A2D"
            />
            <path d="M413.05 156.346h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M412.426 156.479v-7.577h.873v7.577h-.125c-.249-.133-.499 0-.748 0zm.125-7.577v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M412.051 148.902v7.444h-.623v-7.444h.623z" fill="#0EA59D" />
            <path
            d="M411.802 156.478h-.499v-7.709h.748v7.709h-.249zm-.375-.133h.499v-7.311h-.374-.125v7.311z"
            fill="#131A2D"
            />
            <path
            d="M421.534 151.694c0 .531-.25 1.063-.624 1.462v-4.121h.624v2.659z"
            fill="#0EA59D"
            />
            <path
            d="M420.785 153.422v-4.387h.873v2.659c0 .531-.249.93-.623 1.462l-.25.266zm.25-4.121v3.722c.374-.399.499-.931.499-1.329v-2.393h-.499z"
            fill="#131A2D"
            />
            <path
            d="M402.446 153.022c-.249-.398-.499-.93-.499-1.329v-2.525h.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M402.571 153.288l-.125-.133c-.249-.398-.499-.797-.499-1.329v-2.791h.624v4.253zm-.499-1.595c0 .399.125.798.374 1.064v-3.456h-.374v2.392z"
            fill="#131A2D"
            />
            <path
            d="M419.413 154.484c-.25.133-.374.266-.624.399v-5.716h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M418.664 155.016v-5.849h.749v5.45c-.125.133-.375.133-.749.399zm.25-5.716v5.45c.124-.133.374-.133.499-.266V149.3h-.499z"
            fill="#131A2D"
            />
            <path
            d="M414.173 156.213h-.624v-7.311c.249 0 .374 0 .624.133v7.178z"
            fill="#0EA59D"
            />
            <path
            d="M413.424 156.345v-7.576h.125c.249 0 .374 0 .623.132h.125v7.311h-.125c-.249.133-.499.133-.748.133zm.125-7.311v7.178h.499v-7.045c-.125-.133-.25-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M418.415 155.016c-.25.133-.374.133-.624.266v-6.114h.624v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M417.666 155.415v-6.38h.749v5.981c-.25.266-.499.266-.749.399zm.125-6.114v5.981c.125 0 .374-.133.499-.266v-5.715h-.499z"
            fill="#131A2D"
            />
            <path
            d="M416.294 155.813c-.25 0-.375.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M415.545 156.079v-6.912h.748v6.779c-.249 0-.374 0-.748.133zm.125-6.779v6.646c.124 0 .374-.133.499-.133V149.3h-.499z"
            fill="#131A2D"
            />
            <path
            d="M415.171 156.08c-.25 0-.375.133-.624.133v-7.045c.249 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M414.547 156.213v-7.311h.125c.249 0 .374.133.623.133v7.045c-.249.133-.499.133-.748.133zm.125-7.045v6.912c.124 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M411.803 144.249c5.738 0 9.855 2.526 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785-5.864 0-9.856-2.525-9.856-4.785 0-2.259 4.117-4.785 9.856-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M411.803 153.819c-5.864 0-9.856-2.525-9.856-4.785 0-2.259 4.117-4.785 9.856-4.785 5.738 0 9.855 2.526 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785zm0-9.57c-5.739 0-9.731 2.526-9.731 4.652 0 2.26 3.992 4.652 9.731 4.652 5.738 0 9.73-2.525 9.73-4.652 0-2.126-3.992-4.652-9.73-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M418.165 152.49c-.624.266-1.372.532-2.121.665l-8.108-8.64c.748-.133 1.621-.266 2.495-.399l7.734 8.374zM412.549 153.687H411.052l-6.986-7.443c.25-.266.624-.399.998-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M414.921 153.288c.124 0 .374-.133.499-.133.374-.133.623-.133.998-.266.374-.133.623-.266.998-.399.124 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.623-.266.998-.531.623-.399 1.247-.798 1.746-1.197a4.438 4.438 0 01-1.497 1.595c-.125.133-.249.266-.499.266-.125.133-.374.133-.499.266-.125 0-.125.133-.249.133l-.25.133c-.125.133-.374.133-.499.266l-.499.133c-.125 0-.374.133-.499.133-.374.132-.748.132-1.123.265-.374 0-.748 0-1.122.133h-1.123c.374-.133.748-.133.998-.266l.624-.132zM410.056 153.287l1.373.133.748.133c.25 0 .499.133.749.133-.25.133-.499.133-.749.133h-2.245c-.499 0-.998-.133-1.497-.266a5.864 5.864 0 01-1.373-.532c.5 0 .999 0 1.498.133s.997.133 1.496.133z"
            fill="#fff"
            />
            <path
            d="M380.74 143.451c1.247 0 2.495.133 3.493.266h6.237v2.526c-.124 2.259-4.116 4.652-9.855 4.652-5.614 0-9.606-2.393-9.855-4.652v-2.526h6.237c1.248-.133 2.371-.266 3.743-.266z"
            fill="#0EA59D"
            />
            <path
            d="M380.74 151.028c-5.614 0-9.606-2.393-9.855-4.653v-2.791h6.362c1.123-.266 2.246-.266 3.493-.266 1.248 0 2.37.133 3.493.266h6.362v2.658c-.249 2.393-4.241 4.786-9.855 4.786zm-9.73-4.653c.124 2.26 4.116 4.52 9.73 4.52 5.614 0 9.606-2.393 9.731-4.52v-2.525h-6.238c-1.123-.266-2.245-.266-3.493-.266-1.247 0-2.37.133-3.493.266h-6.237v2.525z"
            fill="#131A2D"
            />
            <path
            d="M389.346 148.369c-.124.133-.374.398-.623.531v-5.051h.623v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M388.723 149.033v-5.316h.748v4.652c-.249.266-.499.399-.748.664zm.124-5.184v4.786c.125-.133.375-.266.499-.399v-4.387h-.499z"
            fill="#131A2D"
            />
            <path
            d="M377.747 143.718v7.044c-.25 0-.374-.133-.624-.133v-6.779c.25-.132.374-.132.624-.132z"
            fill="#0EA59D"
            />
            <path
            d="M377.872 150.895c-.25 0-.499-.133-.749-.133v-7.044h.125c.125 0 .374 0 .499-.133h.125v7.31zm-.624-.265c.125 0 .374 0 .499.132v-6.911c-.125 0-.374 0-.499.132v6.647z"
            fill="#131A2D"
            />
            <path
            d="M378.745 150.894c-.25 0-.374 0-.624-.133v-7.177c.25 0 .374 0 .624-.133v7.443z"
            fill="#0EA59D"
            />
            <path
            d="M378.869 151.027c-.249 0-.499 0-.748-.133h-.125v-7.31h.125c.249 0 .374 0 .624-.133h.124v7.576zm-.623-.265h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M373.505 149.432c-.25-.133-.375-.266-.624-.398v-5.184h.624v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M373.629 149.565c-.374-.133-.499-.266-.748-.399v-5.316h.748v5.715zm-.623-.531c.124.132.374.132.499.265v-5.449h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M379.866 151.028h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M379.99 151.027h-.873v-7.576h.873v7.576zm-.623-.133h.499v-7.31h-.499v7.31z"
            fill="#131A2D"
            />
            <path
            d="M372.507 148.767c-.25-.132-.499-.398-.624-.531v-4.387h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M372.506 148.9a3.98 3.98 0 01-.748-.664v-4.519h.748v5.183zm-.623-.797c.124.133.249.266.499.399v-4.653h-.499v4.254z"
            fill="#131A2D"
            />
            <path
            d="M375.626 150.23c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M375.75 150.363c-.374-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.399c.124 0 .249.133.499.133v-6.248h-.499v6.115z"
            fill="#131A2D"
            />
            <path
            d="M376.749 150.496c-.25 0-.375-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M376.749 150.628c-.25-.132-.5-.132-.749-.132v-6.779h.749v6.911zm-.624-.265c.125 0 .374.133.499.133v-6.514h-.499v6.381z"
            fill="#131A2D"
            />
            <path
            d="M374.628 149.964c-.25-.133-.375-.133-.624-.266v-5.849h.624v6.115z"
            fill="#0EA59D"
            />
            <path
            d="M374.627 149.964c-.374-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.623-.399c.124.133.249.133.499.266v-5.849h-.499v5.583z"
            fill="#131A2D"
            />
            <path
            d="M386.229 150.097c-.249.133-.374.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M385.48 150.363v-6.646h.749v6.513c-.25 0-.374.133-.749.133zm.125-6.514v6.381c.125 0 .374-.133.499-.133v-6.115h-.499v-.133z"
            fill="#131A2D"
            />
            <path d="M381.987 150.894h-.624v-7.443h.624v7.443z" fill="#0EA59D" />
            <path
            d="M381.238 151.027v-7.576h.874v7.576h-.874zm.125-7.443v7.31h.499v-7.31h-.499z"
            fill="#131A2D"
            />
            <path d="M380.864 143.451v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M380.739 151.028h-.499v-7.71h.749v7.71h-.25zm-.374-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M390.471 146.375c0 .532-.249 1.063-.623 1.462v-4.12h.623v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M389.723 148.103v-4.386h.873v2.658c0 .532-.25.93-.749 1.462l-.124.266zm.124-4.254v3.722c.375-.399.499-.93.499-1.329v-2.525h-.499v.132z"
            fill="#131A2D"
            />
            <path
            d="M371.384 147.704c-.25-.399-.499-.93-.499-1.329v-2.526h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M371.509 147.97l-.125-.133c-.25-.399-.499-.797-.499-1.329v-2.791h.624v4.253zm-.499-1.595c0 .399.124.797.374 1.063v-3.589h-.374v2.526z"
            fill="#131A2D"
            />
            <path
            d="M388.35 149.166c-.249.133-.374.266-.623.399v-5.716h.623v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M387.602 149.565v-5.848h.748v5.449c-.249.133-.374.266-.748.399zm.124-5.716v5.45c.125-.133.375-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M382.985 150.895c-.249 0-.374 0-.624.133v-7.311c.25 0 .375 0 .624.133v7.045z"
            fill="#0EA59D"
            />
            <path
            d="M382.361 151.027v-7.576h.125c.25 0 .374 0 .624.133h.125v7.31h-.125c-.25 0-.499.133-.749.133zm.125-7.443v7.178h.499v-7.045c-.125 0-.374 0-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M387.227 149.698c-.249.133-.374.133-.623.266v-6.115h.623v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M386.604 150.097v-6.38h.748v5.981l-.748.399zm.124-6.248v5.982c.125 0 .375-.133.499-.266v-5.716h-.499z"
            fill="#131A2D"
            />
            <path
            d="M385.106 150.495c-.249 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M384.482 150.628v-6.911h.749v6.779c-.25.132-.499.132-.749.132zm.125-6.779v6.647c.125 0 .25-.133.499-.133v-6.514h-.499z"
            fill="#131A2D"
            />
            <path
            d="M384.108 150.629c-.249 0-.374.133-.624.133v-7.044c.25 0 .375 0 .624.132v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M383.359 150.895v-7.31h.125c.25 0 .374.133.624.133v7.044c-.25 0-.374.133-.749.133zm.125-7.177v6.912c.125 0 .374 0 .499-.133v-6.779c-.125.133-.249.133-.499 0z"
            fill="#131A2D"
            />
            <path
            d="M380.74 138.932c5.739 0 9.855 2.525 9.855 4.785 0 2.259-3.992 4.785-9.855 4.785s-9.855-2.526-9.855-4.785c0-2.393 3.992-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M380.74 148.502c-5.863 0-9.855-2.526-9.855-4.785 0-2.26 4.117-4.785 9.855-4.785 5.739 0 9.855 2.525 9.855 4.785 0 2.259-4.116 4.785-9.855 4.785zm0-9.57c-5.738 0-9.73 2.525-9.73 4.652 0 2.26 3.992 4.652 9.73 4.652 5.739 0 9.731-2.525 9.731-4.652 0-2.127-3.992-4.652-9.731-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M387.103 147.173c-.624.266-1.373.532-2.121.664l-8.109-8.639a108.54 108.54 0 012.495-.399l7.735 8.374zM381.489 148.37H379.992l-6.986-7.444c.249-.266.624-.399.998-.531l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M383.858 147.971c.125 0 .374-.133.499-.133.374-.133.624-.133.998-.266s.624-.265.998-.398c.125 0 .374-.133.499-.133l.25-.133c.124 0 .124-.133.249-.133.374-.133.624-.266.998-.532.624-.399 1.248-.797 1.747-1.196a4.472 4.472 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266-.125 0-.125.133-.25.133l-.249.132c-.125.133-.375.133-.499.266l-.499.133c-.125 0-.375.133-.499.133-.375.133-.749.133-1.123.266-.374 0-.749 0-1.123.133h-1.123c.375-.133.749-.133.998-.266l.624-.133zM378.994 147.971l1.372.133.749.133c.249 0 .499 0 .748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.499 0 .998.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M379.992 139.995c1.247 0 2.495.133 3.493.266h6.237v2.525c-.125 2.26-4.117 4.653-9.855 4.653-5.614 0-9.606-2.393-9.855-4.653v-2.525h6.237c1.372-.266 2.495-.266 3.743-.266z"
            fill="#0EA59D"
            />
            <path
            d="M379.992 147.572c-5.614 0-9.606-2.393-9.855-4.653v-2.791h6.362c1.123-.266 2.245-.266 3.493-.266 1.247 0 2.37.133 3.493.266h6.362v2.659c-.249 2.392-4.241 4.785-9.855 4.785zm-9.731-4.785c.125 2.259 4.117 4.652 9.731 4.652s9.606-2.393 9.73-4.52v-2.525h-6.237c-1.123-.266-2.246-.266-3.493-.266-1.248 0-2.37.133-3.493.266h-6.238v2.393z"
            fill="#131A2D"
            />
            <path
            d="M388.725 144.781c-.124.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M387.977 145.446v-5.317h.748v4.652c-.125.266-.374.399-.748.665zm.124-5.051v4.785c.125-.133.375-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M377.124 140.128v7.045c-.25 0-.375-.133-.624-.133v-6.779c.249 0 .374 0 .624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M377.124 147.306c-.25 0-.5-.133-.749-.133v-7.045h.125c.125 0 .249 0 .499-.133h.125v7.311zm-.624-.266c.125 0 .374 0 .499.133v-6.912c-.125 0-.374 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M378.12 147.306c-.25 0-.374 0-.624-.133v-7.178c.25 0 .374 0 .624-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M378.244 147.439c-.249 0-.499 0-.748-.133h-.125v-7.311h.125c.249 0 .374 0 .624-.133h.124v7.577zm-.623-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M372.882 145.844c-.25-.133-.375-.266-.624-.399v-5.184h.624v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M372.881 145.976c-.374-.133-.499-.266-.748-.398v-5.317h.748v5.715zm-.623-.531c.124.133.249.133.499.266v-5.45h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M379.245 147.439h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M379.244 147.572h-.873v-7.577h.873v7.577zm-.623-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M371.759 145.18c-.25-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M371.883 145.313a4.016 4.016 0 01-.748-.665v-4.519h.748v5.184zm-.624-.665c.125.133.25.266.5.399v-4.652h-.5v4.253z"
            fill="#131A2D"
            />
            <path
            d="M375.003 146.775c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M375.002 146.775c-.249-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.266c.124 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M376.001 147.04c-.25 0-.375-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M376.125 147.173c-.249-.133-.499-.133-.748-.133v-6.779h.748v6.912zm-.623-.399c.124 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M373.88 146.375c-.25-.133-.375-.133-.624-.266v-5.848h.624v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M374.004 146.508c-.249-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.623-.532c.124.133.374.133.499.266v-5.848h-.499v5.582z"
            fill="#131A2D"
            />
            <path
            d="M385.481 146.641c-.249.133-.374.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M384.857 146.907v-6.646h.749v6.38c-.25.133-.499.133-.749.266zm.125-6.513v6.247c.125 0 .374-.133.499-.133v-6.114h-.499z"
            fill="#131A2D"
            />
            <path d="M381.364 147.439h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M380.615 147.572v-7.577h.873v7.577h-.124c-.25-.133-.499 0-.749 0zm.125-7.577v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M380.241 139.995v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M379.991 147.572h-.499v-7.71h.873v7.71h-.374zm-.249-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M389.848 142.787c0 .532-.249 1.064-.623 1.462v-4.12h.623v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M389.1 144.515v-4.386h.873v2.658c0 .532-.25.931-.624 1.462l-.249.266zm.124-4.12v3.722c.375-.399.499-.931.499-1.33v-2.525h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M370.761 144.116c-.25-.398-.499-.93-.499-1.329v-2.525h.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M370.76 144.382l-.124-.133c-.25-.398-.499-.797-.499-1.329v-2.791h.623v4.253zm-.499-1.595c0 .399.125.798.375 1.064v-3.589h-.375v2.525z"
            fill="#131A2D"
            />
            <path
            d="M387.602 145.578c-.249.132-.374.265-.623.398v-5.715h.623v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M386.979 146.109v-5.848h.748v5.449c-.249.133-.499.133-.748.399zm.124-5.715v5.449c.125-.133.375-.133.499-.265v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M382.362 147.306h-.624v-7.311c.25 0 .375 0 .624.133v7.178z"
            fill="#0EA59D"
            />
            <path
            d="M381.613 147.439v-7.444h.125c.25 0 .374 0 .624.133h.125v7.311h-.874zm.25-7.311v7.178h.499v-7.045c-.25-.133-.374-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M386.604 146.11c-.249.133-.374.133-.624.266v-6.114h.624v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M385.855 146.509v-6.38h.749v5.981c-.25.266-.374.266-.749.399zm.125-6.114v5.981c.125 0 .374-.133.499-.266v-5.715h-.499z"
            fill="#131A2D"
            />
            <path
            d="M384.483 146.907c-.249 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M383.734 147.173v-6.912h.749v6.779c-.25 0-.374 0-.749.133zm.25-6.779v6.646c.125 0 .374-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M383.36 147.174c-.249 0-.374.133-.624.133v-7.045c.25 0 .375.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M382.736 147.306v-7.311h.125c.25 0 .374.133.624.133v7.045c-.25.133-.499.133-.749.133zm.125-7.045v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M379.992 135.343c5.738 0 9.855 2.525 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785-5.739 0-9.855-2.525-9.855-4.785 0-2.26 4.116-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M379.992 144.913c-5.863 0-9.855-2.525-9.855-4.785 0-2.26 4.116-4.785 9.855-4.785 5.863 0 9.855 2.525 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785zm0-9.57c-5.739 0-9.731 2.525-9.731 4.652 0 2.26 3.992 4.652 9.731 4.652 5.738 0 9.73-2.525 9.73-4.652 0-2.127-3.992-4.652-9.73-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M386.354 143.584c-.623.266-1.372.532-2.12.665l-8.109-8.64a108.54 108.54 0 012.495-.399l7.734 8.374zM380.864 144.78H379.367l-6.986-7.444c.374-.265.624-.398.998-.531l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M383.11 144.382c.125 0 .374-.133.499-.133.374-.133.624-.133.998-.265.374-.133.624-.266.998-.399.125 0 .374-.133.499-.133l.25-.133c.124 0 .124-.133.249-.133.374-.133.624-.266.998-.532.624-.398 1.248-.797 1.747-1.196a4.463 4.463 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266-.125 0-.125.133-.25.133l-.249.133c-.125.133-.375.133-.499.265l-.499.133c-.125 0-.375.133-.499.133-.375.133-.749.133-1.123.266-.374 0-.749 0-1.123.133h-1.123c.375-.133.749-.133.998-.266l.624-.133zM378.246 144.382l1.372.133.749.133c.249 0 .499.133.748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.624.133.998.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M381.488 136.273c1.248 0 2.371.133 3.493.266h6.238v2.525c-.125 2.26-4.117 4.652-9.731 4.652-5.613 0-9.605-2.392-9.73-4.652v-2.525h6.237c.998-.133 2.246-.266 3.493-.266z"
            fill="#0EA59D"
            />
            <path
            d="M381.488 143.849c-5.614 0-9.606-2.393-9.855-4.652v-2.792h6.362c1.123-.265 2.246-.265 3.493-.265 1.248 0 2.37.133 3.493.265h6.362v2.659c-.249 2.525-4.241 4.785-9.855 4.785zm-9.73-4.652c.124 2.259 4.116 4.519 9.73 4.519 5.614 0 9.481-2.392 9.731-4.519v-2.526h-6.238c-1.123-.266-2.245-.266-3.493-.266-1.247 0-2.37.133-3.493.266h-6.237v2.526z"
            fill="#131A2D"
            />
            <path
            d="M390.096 141.191c-.124.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M389.473 141.856v-5.184h.748v4.652c-.249.133-.499.266-.748.532zm.124-5.051v4.785c.125-.133.375-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M378.495 136.54v7.045c-.25 0-.374-.133-.624-.133v-6.779c.25 0 .499-.133.624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M378.62 143.718c-.25 0-.499-.133-.749-.133v-6.912h.125c.125 0 .249 0 .499-.133h.125v7.178zm-.624-.266c.125 0 .374 0 .499.133v-6.779c-.125 0-.25 0-.499.133v6.513z"
            fill="#131A2D"
            />
            <path
            d="M379.618 143.717c-.25 0-.374 0-.624-.133v-7.178c.25 0 .374 0 .624-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M379.617 143.85c-.249 0-.499 0-.748-.133h-.125v-7.311h.125c.249 0 .374 0 .624-.133h.124v7.577zm-.623-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M374.378 142.254c-.25-.133-.375-.266-.624-.398v-5.184h.624v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M374.377 142.387c-.374-.133-.499-.266-.748-.399v-5.316h.748v5.715zm-.623-.531c.124.132.249.132.499.265v-5.316h-.499v5.051z"
            fill="#131A2D"
            />
            <path d="M380.616 143.849h-.624v-7.31h.624v7.31z" fill="#0EA59D" />
            <path
            d="M380.74 143.85h-.873v-7.444h.873v7.444zm-.623-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M373.255 141.591c-.25-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M373.379 141.724a4.016 4.016 0 01-.748-.665v-4.519h.748v5.184zm-.623-.665c.124.133.249.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M376.499 143.053c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M376.499 143.186c-.25-.133-.5-.133-.749-.266v-6.38h.749v6.646zm-.624-.399c.125 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M377.497 143.318c-.25 0-.374-.133-.624-.133v-6.513h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M377.622 143.451c-.25-.133-.499-.133-.749-.133v-6.646h.749v6.779zm-.624-.266c.125 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M375.376 142.787c-.25-.133-.375-.133-.624-.266v-5.848h.624v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M375.5 142.787c-.374-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.623-.399c.124.133.249.133.499.266v-5.848h-.499v5.582z"
            fill="#131A2D"
            />
            <path
            d="M386.977 142.92c-.249.133-.374.133-.623.133v-6.513h.623v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M386.229 143.186v-6.646h.748v6.38c-.249.133-.374.266-.748.266zm.249-6.38v6.247c.125 0 .374-.133.499-.133v-6.114h-.499z"
            fill="#131A2D"
            />
            <path d="M382.735 143.717h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M382.111 143.85v-7.577h.874v7.577h-.874zm.125-7.444v7.311h.499v-7.178c-.249-.133-.374-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M381.739 136.406v7.444h-.624v-7.444h.374c0-.132.125 0 .25 0z"
            fill="#0EA59D"
            />
            <path
            d="M381.489 143.85h-.499v-7.577h.749v7.577h-.25zm-.374-.133h.499v-7.311h-.374v7.311h-.125z"
            fill="#131A2D"
            />
            <path
            d="M391.219 139.198c0 .532-.249 1.064-.623 1.462v-4.12h.623v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M390.471 140.926v-4.386h.873v2.658c0 .532-.25.931-.624 1.462l-.249.266zm.124-4.12v3.721c.375-.398.499-.93.499-1.329v-2.525h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M372.257 140.528c-.25-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M372.257 140.793l-.125-.133c-.25-.398-.499-.797-.499-1.329v-2.791h.624v4.253zm-.499-1.595c0 .399.124.798.374 1.064v-3.589h-.374v2.525z"
            fill="#131A2D"
            />
            <path
            d="M389.098 141.989c-.249.133-.374.266-.623.399v-5.715h.623v5.316z"
            fill="#0EA59D"
            />
            <path
            d="M388.35 142.388v-5.848h.748v5.45c-.249.132-.374.265-.748.398zm.124-5.582v5.449c.125-.133.375-.133.499-.265v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M383.86 143.717h-.624v-7.311c.25 0 .375 0 .624.133v7.178z"
            fill="#0EA59D"
            />
            <path
            d="M383.111 143.85v-7.444h.125c.25 0 .374 0 .624.133h.125v7.311h-.125c-.25-.133-.499 0-.749 0zm.125-7.311v7.178h.499v-7.045c-.125-.133-.374-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M387.975 142.521c-.249.133-.374.133-.623.266v-6.114h.623v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M387.352 142.92v-6.38h.748v5.981l-.748.399zm.124-6.114v5.848c.125 0 .375-.133.499-.266v-5.715h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M385.854 143.319c-.249 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M385.23 143.452v-6.912h.749v6.779c-.25.133-.499.133-.749.133zm.125-6.646v6.646c.125 0 .374-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M384.858 143.451c-.249 0-.374.133-.624.133v-7.045c.25 0 .375.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M384.109 143.717v-7.311h.125c.25 0 .374.133.624.133v7.045c-.25 0-.374.133-.749.133zm.25-7.045v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M381.488 131.754c5.739 0 9.731 2.525 9.731 4.785 0 2.26-3.992 4.785-9.731 4.785-5.738 0-9.73-2.525-9.73-4.785 0-2.26 3.992-4.785 9.73-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M381.488 141.324c-5.738 0-9.855-2.525-9.855-4.785 0-2.26 3.992-4.785 9.855-4.785 5.739 0 9.855 2.525 9.855 4.785 0 2.26-4.116 4.785-9.855 4.785zm0-9.57c-5.738 0-9.73 2.392-9.73 4.652 0 2.26 3.992 4.652 9.73 4.652 5.739 0 9.731-2.392 9.731-4.652 0-2.127-3.992-4.652-9.731-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M387.851 139.995c-.624.266-1.372.532-2.121.665l-7.984-8.507c.749-.133 1.622-.266 2.37-.399l7.735 8.241zM382.237 141.191H380.74l-6.986-7.443c.249-.266.624-.399.998-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M384.608 140.792c.125 0 .374-.133.499-.133.374-.132.624-.132.998-.265s.624-.266.998-.399c.125 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.624-.266.873-.532.624-.398 1.248-.797 1.747-1.196a4.463 4.463 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266-.125 0-.125.133-.25.133l-.249.133c-.125.133-.375.133-.499.266l-.499.132c-.125 0-.375.133-.499.133-.375.133-.749.133-1.123.266-.374 0-.749 0-1.123.133h-1.123c.375-.133.749-.133.998-.266l.749-.133zM379.742 140.792l1.373.133.748.133c.25 0 .499 0 .749.133-.25.133-.499.133-.749.133h-2.245c-.499 0-.998-.133-1.373-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.374 0 .873.133 1.372.133z"
            fill="#fff"
            />
            <path
            d="M380.117 132.284c1.248 0 2.37.133 3.493.266h6.238v2.526c-.125 2.259-4.117 4.652-9.731 4.652s-9.606-2.393-9.73-4.652v-2.526h6.237c.998-.133 2.121-.266 3.493-.266z"
            fill="#0EA59D"
            />
            <path
            d="M380.117 139.861c-5.614 0-9.606-2.393-9.855-4.652v-2.792h6.362c1.123-.266 2.245-.266 3.493-.266 1.247 0 2.37.133 3.493.266h6.362v2.659c-.374 2.392-4.241 4.785-9.855 4.785zm-9.731-4.785c.125 2.259 4.117 4.519 9.731 4.519s9.481-2.393 9.73-4.519v-2.526h-6.237c-1.123-.266-2.246-.266-3.493-.266-1.248 0-2.37.133-3.493.266h-6.238v2.526z"
            fill="#131A2D"
            />
            <path
            d="M388.725 137.069c-.124.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M387.977 137.734v-5.184h.748v4.652c-.125.133-.374.266-.748.532zm.249-5.051v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M377.124 132.55v7.045c-.25 0-.375-.133-.624-.133v-6.779c.249-.133.499-.133.624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M377.249 139.595c-.25 0-.5-.133-.749-.133v-6.912h.125c.125 0 .374 0 .499-.133h.125v7.178zm-.624-.266c.125 0 .374 0 .499.133v-6.779c-.125 0-.374 0-.499.133v6.513z"
            fill="#131A2D"
            />
            <path
            d="M378.247 139.595c-.25 0-.374 0-.624-.133v-7.178c.25 0 .374 0 .624-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M378.246 139.728c-.249 0-.499 0-.748-.133h-.125v-7.311h.125c.249 0 .374 0 .624-.133h.124v7.577zm-.623-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M372.882 138.132c-.25-.133-.375-.266-.624-.399v-5.183h.624v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M373.006 138.265c-.374-.133-.499-.266-.748-.399v-5.316h.748v5.715zm-.623-.532c.124.133.249.133.499.266v-5.317h-.499v5.051z"
            fill="#131A2D"
            />
            <path d="M379.245 139.728h-.624v-7.311h.624v7.311z" fill="#0EA59D" />
            <path
            d="M379.369 139.861h-.873v-7.444h.873v7.444zm-.623-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M371.884 137.468c-.25-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M372.008 137.601a4.016 4.016 0 01-.748-.665v-4.519h.748v5.184zm-.623-.665c.124.133.249.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M375.003 139.063c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M375.127 139.063c-.249-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.266c.124 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M376.126 139.33c-.25 0-.375-.133-.624-.133v-6.513h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M376.125 139.463c-.249-.133-.499-.133-.748-.133v-6.646h.748v6.779zm-.623-.399c.124 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M374.005 138.664c-.25-.133-.375-.133-.624-.266v-5.848h.624v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M374.004 138.797c-.374-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.623-.532c.124.133.249.133.499.266v-5.848h-.499v5.582z"
            fill="#131A2D"
            />
            <path
            d="M385.606 138.93c-.249.132-.374.132-.624.132v-6.513h.624v6.381z"
            fill="#0EA59D"
            />
            <path
            d="M384.857 139.196v-6.646h.749v6.38c-.25.133-.374.133-.749.266zm.125-6.514v6.248c.125 0 .374-.133.499-.133v-6.115h-.499z"
            fill="#131A2D"
            />
            <path d="M381.364 139.728h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M380.615 139.861v-7.577h.873v7.577h-.124c-.25-.133-.375-.133-.749 0zm.125-7.444v7.311h.499v-7.178c-.125-.133-.25-.133-.499-.133z"
            fill="#131A2D"
            />
            <path d="M380.241 132.284v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M380.116 139.861h-.499v-7.71h.873v7.577h-.124l-.25.133zm-.374-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M389.848 135.075c0 .532-.249 1.064-.623 1.463v-4.121h.623v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M389.1 136.803v-4.386h.873v2.658c0 .532-.25.931-.624 1.463l-.249.265zm.124-4.12v3.722c.375-.399.499-.931.499-1.33v-2.525h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M370.761 136.405c-.25-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M370.885 136.67l-.124-.132c-.25-.399-.499-.798-.499-1.33v-2.791h.623v4.253zm-.499-1.595c0 .399.125.798.375 1.064v-3.589h-.375v2.525z"
            fill="#131A2D"
            />
            <path
            d="M387.602 137.867c-.249.133-.374.265-.623.398v-5.715h.623v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M386.979 138.398v-5.848h.748V138c-.249.132-.374.132-.748.398zm.124-5.715v5.449c.125-.132.375-.132.499-.265v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M382.362 139.595c-.249 0-.374 0-.624.133v-7.311c.25 0 .375 0 .624.133v7.045z"
            fill="#0EA59D"
            />
            <path
            d="M381.738 139.728v-7.444h.125c.25 0 .374 0 .624.133h.125v7.311h-.874zm.125-7.311v7.178h.499v-7.045c-.249-.133-.374-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M386.604 138.398c-.249.133-.374.133-.624.266v-6.114h.624v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M385.855 138.797v-6.38h.749v5.981c-.125.266-.374.266-.749.399zm.25-6.114v5.981c.125 0 .374-.133.499-.266v-5.715h-.499z"
            fill="#131A2D"
            />
            <path
            d="M384.483 139.196c-.249 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M383.859 139.462v-6.912h.749v6.779c-.25 0-.499 0-.749.133zm.125-6.779v6.646c.125 0 .25-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M383.485 139.462c-.249 0-.374.133-.624.133v-7.045c.25 0 .375.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M382.736 139.595v-7.311h.125c.25 0 .374.133.624.133v7.045c-.25.133-.374.133-.749.133zm.125-7.045v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M380.117 127.633c5.738 0 9.73 2.525 9.73 4.785 0 2.26-3.992 4.785-9.73 4.785-5.739 0-9.855-2.525-9.855-4.785 0-2.26 3.992-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M380.117 137.203c-5.739 0-9.855-2.525-9.855-4.785 0-2.26 3.992-4.785 9.855-4.785 5.738 0 9.855 2.525 9.855 4.785-.125 2.26-4.117 4.785-9.855 4.785zm0-9.437c-5.739 0-9.731 2.392-9.731 4.652 0 2.26 3.992 4.652 9.731 4.652 5.738 0 9.73-2.392 9.73-4.652-.124-2.26-4.116-4.652-9.73-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M386.48 135.874c-.624.266-1.373.532-2.121.665l-7.984-8.507c.749-.133 1.622-.266 2.37-.399l7.735 8.241zM380.866 137.07H379.369l-6.986-7.444c.249-.265.624-.398.998-.531l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M383.235 136.671c.125 0 .374-.133.499-.133.374-.133.624-.133.998-.265.374-.133.624-.266.998-.399.125 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.624-.266.873-.532.624-.398 1.248-.797 1.747-1.196a4.463 4.463 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266-.125 0-.125.133-.25.133l-.249.133c-.125.133-.375.133-.499.265l-.499.133c-.125 0-.375.133-.499.133-.375.133-.749.133-1.123.266-.374 0-.749 0-1.123.133h-1.123c.375-.133.749-.133.998-.266l.749-.133zM378.371 136.671l1.372.133.749.133c.249 0 .499 0 .748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.372-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.374.133.873.133 1.372.133z"
            fill="#fff"
            />
            <path
            d="M381.238 126.57c1.248 0 2.371.133 3.493.266h6.238v2.526c-.125 2.259-4.117 4.652-9.731 4.652-5.613 0-9.605-2.393-9.73-4.652v-2.526h6.237c1.123-.133 2.246-.266 3.493-.266z"
            fill="#0EA59D"
            />
            <path
            d="M381.238 134.147c-5.614 0-9.606-2.393-9.855-4.652v-2.792h6.362c1.123-.266 2.246-.265 3.493-.265 1.248 0 2.37.132 3.493.265h6.362v2.659c-.249 2.392-4.241 4.785-9.855 4.785zm-9.73-4.785c.124 2.259 4.116 4.519 9.73 4.519 5.614 0 9.481-2.393 9.731-4.519v-2.526h-6.238c-1.123-.266-2.245-.266-3.493-.266-1.247 0-2.37.133-3.493.266h-6.237v2.526z"
            fill="#131A2D"
            />
            <path
            d="M389.846 131.355c-.124.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M389.223 132.02v-5.184h.748v4.652c-.249.133-.374.266-.748.532zm.124-5.051v4.785c.125-.133.375-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M378.37 126.836v7.045c-.25 0-.374-.133-.624-.133v-6.779c.125-.133.374-.133.624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M378.37 133.881c-.25 0-.499-.133-.749-.133v-6.912h.125c.125 0 .249 0 .499-.133h.125v7.178zm-.624-.266c.125 0 .374 0 .499.133v-6.779c-.125 0-.374 0-.499.133v6.513z"
            fill="#131A2D"
            />
            <path
            d="M379.368 133.881c-.25 0-.374 0-.624-.133v-7.045c.25 0 .374 0 .624-.133v7.311z"
            fill="#0EA59D"
            />
            <path
            d="M379.492 134.014c-.249 0-.499 0-.748-.133h-.125v-7.178h.125c.249 0 .374 0 .624-.133h.124v7.444zm-.623-.266h.499v-7.045h-.499v7.045z"
            fill="#131A2D"
            />
            <path
            d="M374.128 132.419c-.25-.133-.375-.266-.624-.399v-5.184h.624v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M374.127 132.552c-.374-.133-.499-.266-.748-.399v-5.317h.748v5.716zm-.623-.532c.124.133.249.133.499.266v-5.317h-.499v5.051z"
            fill="#131A2D"
            />
            <path d="M380.366 134.014h-.624v-7.311h.624v7.311z" fill="#0EA59D" />
            <path
            d="M380.49 134.147h-.873v-7.444h.873v7.444zm-.623-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M373.005 131.754c-.25-.133-.499-.399-.624-.531v-4.387h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M373.129 131.887a4.016 4.016 0 01-.748-.665v-4.519h.748v5.184zm-.623-.665c.124.133.249.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M376.249 133.349c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M376.248 133.482c-.249-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.399c.124 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M377.247 133.615c-.25 0-.374-.133-.624-.133v-6.513h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M377.372 133.748c-.25-.133-.499-.133-.749-.133v-6.646h.749v6.779zm-.624-.399c.125 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M375.126 132.95c-.25-.133-.375-.133-.624-.266v-5.848h.624v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M375.25 133.083c-.374-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.623-.399c.124.133.249.133.499.266v-5.848h-.499v5.582z"
            fill="#131A2D"
            />
            <path
            d="M386.727 133.216c-.249.133-.374.133-.623.133v-6.513h.623v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M385.979 133.482v-6.646h.748v6.38c-.125.133-.374.133-.748.266zm.249-6.513v6.247c.125 0 .374-.133.499-.133v-6.114h-.499z"
            fill="#131A2D"
            />
            <path d="M382.485 134.014h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M381.861 134.147v-7.577h.874v7.577h-.125c-.25-.133-.499 0-.749 0zm.125-7.444v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M381.487 126.57v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M381.237 134.147h-.499v-7.709h.749v7.576h-.125c0 .133-.125.133-.125.133zm-.374-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M390.969 129.495c0 .531-.249 1.063-.623 1.462v-4.121h.623v2.659z"
            fill="#0EA59D"
            />
            <path
            d="M390.221 131.09v-4.387h.873v2.659c0 .531-.25.93-.624 1.462l-.249.266zm.124-4.121v3.722c.375-.399.499-.931.499-1.329v-2.526h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M372.007 130.691c-.25-.399-.499-.931-.499-1.329v-2.526h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M372.132 130.957l-.125-.133c-.25-.399-.499-.798-.499-1.33v-2.791h.624v4.254zm-.624-1.595c0 .398.125.797.374 1.063v-3.589h-.374v2.526z"
            fill="#131A2D"
            />
            <path
            d="M388.848 132.153c-.249.133-.374.266-.623.399v-5.716h.623v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M388.1 132.684v-5.848h.748v5.45c-.125.133-.374.266-.748.398zm.249-5.715v5.45c.125-.133.374-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M383.608 133.881h-.624v-7.311c.25 0 .375 0 .624.133v7.178z"
            fill="#0EA59D"
            />
            <path
            d="M382.859 134.014v-7.444h.125c.25 0 .374 0 .624.133h.125v7.311h-.874zm.125-7.311v7.178h.499v-7.178h-.499z"
            fill="#131A2D"
            />
            <path
            d="M387.725 132.685c-.249.133-.374.133-.623.266v-6.115h.623v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M387.102 133.083v-6.38h.748v5.982c-.249.265-.499.265-.748.398zm.124-6.114v5.981c.125 0 .375-.133.499-.265v-5.716h-.499z"
            fill="#131A2D"
            />
            <path
            d="M385.729 133.482c-.249 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M384.98 133.748v-6.912h.749v6.779c-.25 0-.499 0-.749.133zm.125-6.779v6.646c.125 0 .374-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M384.606 133.748c-.249 0-.374.133-.624.133v-7.178c.25 0 .375.133.624.133v6.912z"
            fill="#0EA59D"
            />
            <path
            d="M383.982 133.881v-7.178h.125c.25 0 .374.133.624.133v7.045h-.749zm.125-7.045v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M381.238 121.918c5.739 0 9.731 2.525 9.731 4.785 0 2.26-3.992 4.785-9.731 4.785-5.738 0-9.73-2.525-9.73-4.785 0-2.26 3.992-4.785 9.73-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M381.238 131.488c-5.738 0-9.855-2.525-9.855-4.785 0-2.26 3.992-4.785 9.855-4.785 5.739 0 9.855 2.525 9.855 4.785 0 2.26-4.116 4.785-9.855 4.785zm0-9.437c-5.738 0-9.73 2.392-9.73 4.652 0 2.26 3.992 4.652 9.73 4.652 5.739 0 9.731-2.392 9.731-4.652 0-2.26-3.992-4.652-9.731-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M387.601 130.159c-.624.266-1.372.532-2.121.665l-7.984-8.507c.749-.133 1.622-.266 2.37-.399l7.735 8.241zM381.987 131.355H380.49l-6.986-7.443c.249-.266.624-.399.998-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M384.358 130.956c.125 0 .374-.132.499-.132.374-.133.624-.133.998-.266s.624-.266.998-.399c.125 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.624-.266.873-.531.624-.399 1.248-.798 1.747-1.197a4.455 4.455 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266-.125 0-.125.133-.25.133l-.249.133c-.125.133-.375.133-.499.266l-.499.133c-.125 0-.375.132-.499.132-.375.133-.749.133-1.123.266-.374 0-.749 0-1.123.133h-1.123c.375-.133.749-.133.998-.266l.749-.133zM379.492 131.089l1.373.133.748.133c.25 0 .499 0 .749.133-.25.133-.499.133-.749.133h-2.245c-.499 0-.998-.133-1.373-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.499 0 .873 0 1.372.133z"
            fill="#fff"
            />
            <path
            d="M398.33 155.282c1.247 0 2.495.133 3.493.266h6.237v2.526c-.125 2.259-4.117 4.652-9.855 4.652-5.614 0-9.606-2.393-9.855-4.652v-2.526h6.237c1.248-.133 2.495-.266 3.743-.266z"
            fill="#0EA59D"
            />
            <path
            d="M398.33 162.858c-5.614 0-9.606-2.393-9.855-4.652v-2.792h6.362c1.123-.266 2.245-.266 3.493-.266 1.247 0 2.37.133 3.493.266h6.362v2.659c-.249 2.392-4.241 4.785-9.855 4.785zm-9.731-4.785c.125 2.259 4.117 4.519 9.731 4.519s9.606-2.393 9.73-4.519v-2.526h-6.237c-1.123-.266-2.246-.266-3.493-.266-1.248 0-2.37.133-3.493.266h-6.238v2.526z"
            fill="#131A2D"
            />
            <path
            d="M407.061 160.067c-.125.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M406.312 160.732v-5.317h.749v4.652a3.993 3.993 0 01-.749.665zm.125-5.051v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M395.337 155.415v7.178c-.25 0-.375-.133-.624-.133v-6.779c.249-.133.499-.133.624-.266z"
            fill="#0EA59D"
            />
            <path
            d="M395.461 162.593c-.249 0-.499-.133-.748-.133v-7.045h.125c.124 0 .374 0 .499-.133h.124v7.311zm-.623-.266c.124 0 .374 0 .499.133v-6.912c-.125 0-.375 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M396.46 162.726c-.25 0-.375 0-.624-.133v-7.178c.249 0 .374 0 .624-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M396.459 162.725c-.249 0-.499 0-.748-.133h-.125v-7.311h.125c.249 0 .374 0 .623-.133h.125v7.577zm-.624-.133h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M391.219 161.13c-.249-.133-.374-.266-.623-.399v-5.184h.623v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M391.219 161.263c-.374-.133-.499-.266-.748-.399v-5.317h.748v5.716zm-.624-.532c.125.133.25.133.499.266v-5.45h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M397.458 162.726h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M397.582 162.859h-.873v-7.577h.873v7.577zm-.624-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M390.096 160.466c-.249-.133-.499-.399-.623-.532v-4.386h.623v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M390.221 160.599c-.374-.266-.624-.399-.748-.665v-4.519h.748v5.184zm-.624-.665c.125.133.25.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M393.216 162.06c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M393.34 162.193c-.249-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.399c.124 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M394.339 162.326c-.25 0-.375-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M394.463 162.459c-.249-.133-.499-.133-.748-.133v-6.779h.748v6.912zm-.623-.399c.124 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M392.217 161.661c-.249-.133-.374-.133-.623-.266v-5.848h.623v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M392.342 161.794c-.374-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.623-.399c.124.133.374.133.498.266v-5.848h-.498v5.582z"
            fill="#131A2D"
            />
            <path
            d="M403.819 161.927c-.249.133-.374.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M403.195 162.193v-6.646h.749v6.513c-.25 0-.499 0-.749.133zm.125-6.513v6.38c.125 0 .374-.133.499-.133v-6.114h-.499v-.133z"
            fill="#131A2D"
            />
            <path d="M399.577 162.726h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M398.953 162.859v-7.577h.873v7.577h-.873zm.125-7.577v7.311h.499v-7.311c-.25.133-.374.133-.499 0z"
            fill="#131A2D"
            />
            <path d="M398.581 155.282v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M398.331 162.858h-.499v-7.71h.873v7.71h-.374zm-.374-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M408.186 158.207c0 .531-.249 1.063-.624 1.462v-4.121h.624v2.659z"
            fill="#0EA59D"
            />
            <path
            d="M407.438 159.801v-4.386h.873v2.658c0 .532-.25.931-.624 1.463l-.249.265zm.124-4.12v3.722c.375-.399.499-.931.499-1.33v-2.525h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M389.099 159.403c-.25-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M389.098 159.669l-.124-.133c-.25-.399-.499-.798-.499-1.33v-2.791h.623v4.254zm-.499-1.596c0 .399.125.798.375 1.064v-3.589h-.375v2.525z"
            fill="#131A2D"
            />
            <path
            d="M405.94 160.864c-.249.133-.374.266-.624.398v-5.715h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M405.316 161.395v-5.848h.749v5.45l-.749.398zm.125-5.715v5.45c.125-.133.374-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M400.7 162.593h-.624v-7.311c.25 0 .374 0 .624.133v7.178z"
            fill="#0EA59D"
            />
            <path
            d="M399.951 162.725v-7.577h.125c.249 0 .374 0 .624.133h.124v7.311h-.124c-.25.133-.375.133-.749.133zm.125-7.311v7.178h.499v-7.045c-.125-.133-.25-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M404.942 161.53c-.249.133-.374.133-.624.266v-6.114h.624v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M404.193 161.795v-6.38h.749v5.981c-.25.266-.374.266-.749.399zm.125-6.114v5.981c.125 0 .374-.133.499-.266v-5.715h-.499z"
            fill="#131A2D"
            />
            <path
            d="M402.821 162.193c-.249 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M402.072 162.459v-6.912h.749v6.779c-.25 0-.374 0-.749.133zm.125-6.779v6.646c.125 0 .374-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M401.698 162.46c-.25 0-.374.133-.624.133v-7.045c.25 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M401.074 162.593v-7.311h.125c.249 0 .374.133.624.133v7.045c-.25.133-.499.133-.749.133zm.125-7.045v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M398.33 150.629c5.738 0 9.855 2.525 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785-5.739 0-9.855-2.525-9.855-4.785 0-2.26 4.116-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M398.33 160.199c-5.863 0-9.855-2.525-9.855-4.785 0-2.26 4.116-4.785 9.855-4.785 5.863 0 9.855 2.525 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785zm0-9.437c-5.739 0-9.731 2.525-9.731 4.652 0 2.127 3.992 4.652 9.731 4.652 5.738 0 9.73-2.525 9.73-4.652 0-2.127-3.992-4.652-9.73-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M404.692 158.87c-.623.266-1.372.532-2.12.665l-8.109-8.64c.748-.133 1.622-.266 2.495-.399l7.734 8.374zM399.077 160.067H397.58l-6.986-7.444c.249-.265.624-.398.998-.531l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M401.448 159.668c.125 0 .374-.133.499-.133.374-.132.624-.132.998-.265s.624-.266.998-.399c.125 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.624-.266.998-.532.624-.398 1.247-.797 1.746-1.196a4.446 4.446 0 01-1.497 1.595c-.124.133-.249.266-.499.266-.124.133-.374.133-.499.266-.124 0-.124.133-.249.133l-.25.133c-.124.133-.374.133-.499.266l-.499.132c-.124 0-.374.133-.499.133-.374.133-.748.133-1.122.266-.375 0-.749 0-1.123.133h-1.123c.374-.133.749-.133.998-.266l.624-.133zM396.584 159.8l1.372.133.749.133c.249 0 .499 0 .748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.499 0 .998 0 1.497.133z"
            fill="#fff"
            />
            <path
            d="M382.611 147.704c1.247 0 2.495.133 3.493.266h6.237v2.525c-.124 2.26-4.116 4.653-9.855 4.653-5.738 0-9.606-2.393-9.855-4.653v-2.525h6.237c1.373-.133 2.495-.266 3.743-.266z"
            fill="#0EA59D"
            />
            <path
            d="M382.611 155.281c-5.614 0-9.606-2.393-9.855-4.653v-2.791h6.362c1.123-.266 2.246-.266 3.493-.266 1.248 0 2.37.133 3.493.266h6.362v2.659c-.249 2.392-4.116 4.785-9.855 4.785zm-9.73-4.785c.124 2.259 4.116 4.519 9.73 4.519 5.614 0 9.606-2.393 9.731-4.519v-2.526h-6.238c-1.123-.266-2.245-.266-3.493-.266-1.247 0-2.37.133-3.493.266h-6.237v2.526z"
            fill="#131A2D"
            />
            <path
            d="M391.342 152.49c-.124.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M390.594 153.155v-5.317h.748v4.652c-.124.266-.374.399-.748.665zm.125-5.051v4.785c.124-.133.374-.266.498-.399v-4.386h-.498z"
            fill="#131A2D"
            />
            <path
            d="M379.741 147.838v7.045c-.25 0-.374-.133-.624-.133v-6.779c.25 0 .374 0 .624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M379.741 155.016c-.25 0-.499-.133-.749-.133v-6.912h.125c.125 0 .374 0 .499-.133h.125v7.178zm-.624-.266c.125 0 .374 0 .499.133v-6.912c-.125 0-.374 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M380.739 155.015c-.25 0-.374 0-.624-.133v-7.178c.25 0 .374 0 .624-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M380.864 155.148c-.25 0-.499 0-.749-.133v-7.311c.25 0 .374 0 .624-.133h.125v7.577zm-.624-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M375.501 153.553c-.25-.133-.375-.266-.624-.399v-5.184h.624v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M375.5 153.685c-.374-.133-.499-.266-.748-.398v-5.317h.748v5.715zm-.623-.531c.124.133.374.133.499.265v-5.449h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M381.862 155.148h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M381.862 155.281h-.874v-7.577h.874v7.577zm-.624-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M374.378 152.888c-.25-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M374.502 153.021a4.016 4.016 0 01-.748-.665v-4.386h.748v5.051zm-.623-.665c.124.133.249.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M377.622 154.483c-.25 0-.374-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M377.622 154.616c-.375-.133-.499-.133-.749-.266v-6.38h.749v6.646zm-.624-.399c.125 0 .249.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M378.62 154.749c-.25 0-.374-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M378.745 154.882c-.25-.133-.499-.133-.749-.133v-6.779h.749v6.912zm-.624-.399c.125 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M376.499 154.084c-.25-.133-.375-.133-.624-.266v-5.848h.624v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M376.624 154.217c-.25-.133-.5-.266-.749-.266v-5.981h.749v6.247zm-.624-.399c.125.133.374.133.499.266v-5.848H376v5.582z"
            fill="#131A2D"
            />
            <path
            d="M388.1 154.35c-.249.133-.374.133-.623.133v-6.513h.623v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M387.477 154.616v-6.646h.748v6.513c-.249 0-.374 0-.748.133zm.124-6.513v6.38c.125 0 .375-.133.499-.133v-6.114h-.499v-.133z"
            fill="#131A2D"
            />
            <path d="M383.983 155.148h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M383.234 155.281v-7.577h.874v7.577h-.874zm.125-7.577v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M382.86 147.704v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M382.61 155.281h-.499v-7.71h.749v7.71h-.125-.125zm-.249-.133h.499v-7.311h-.374-.125v7.311z"
            fill="#131A2D"
            />
            <path
            d="M392.467 150.495c0 .532-.249 1.064-.623 1.463v-3.988h.623v2.525z"
            fill="#0EA59D"
            />
            <path
            d="M391.719 152.223v-4.253h.873v2.658c0 .532-.25.931-.749 1.462l-.124.133zm.124-4.12v3.721c.375-.398.499-.93.499-1.329v-2.525h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M373.38 151.825c-.25-.399-.499-.93-.499-1.329v-2.526h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M373.38 152.091l-.125-.133c-.25-.399-.499-.797-.499-1.329v-2.791h.624v4.253zm-.499-1.595c0 .399.124.798.374 1.063v-3.588h-.374v2.525z"
            fill="#131A2D"
            />
            <path
            d="M390.221 153.287c-.249.132-.374.265-.623.398v-5.715h.623v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M389.598 153.818v-5.848h.748v5.449l-.748.399zm.124-5.715v5.449c.125-.133.375-.133.499-.265v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M384.981 155.015c-.249 0-.374 0-.624.133v-7.31c.25 0 .375 0 .624.133v7.044z"
            fill="#0EA59D"
            />
            <path
            d="M384.357 155.148v-7.577h.125c.25 0 .374 0 .624.133h.125v7.311h-.125c-.374.133-.499.133-.749.133zm.125-7.311v7.178h.499v-7.045c-.249-.133-.374-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M389.223 153.818c-.249.133-.374.133-.623.266v-6.114h.623v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M388.475 154.217v-6.247h.748v5.981c-.125.133-.374.133-.748.266zm.249-6.114v5.981c.125 0 .374-.133.499-.266v-5.715h-.499z"
            fill="#131A2D"
            />
            <path
            d="M387.102 154.616c-.249 0-.374.133-.623.133v-6.779h.623v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M386.354 154.882v-6.912h.748v6.779c-.249 0-.374 0-.748.133zm.249-6.779v6.646c.125 0 .25-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M386.104 154.883c-.249 0-.374.133-.624.133v-7.045c.25 0 .375.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M385.355 155.015v-7.311h.125c.25 0 .374.133.624.133v7.045c-.25.133-.499.133-.749.133zm.125-7.045v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M382.611 143.052c5.739 0 9.855 2.525 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785s-9.855-2.525-9.855-4.785c.125-2.26 4.117-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M382.611 152.622c-5.863 0-9.855-2.525-9.855-4.785 0-2.26 4.117-4.785 9.855-4.785 5.739 0 9.855 2.525 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785zm0-9.57c-5.738 0-9.73 2.525-9.73 4.652 0 2.127 3.992 4.652 9.73 4.652 5.739 0 9.731-2.525 9.731-4.652 0-2.127-3.992-4.652-9.731-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M388.974 151.293c-.624.266-1.373.532-2.121.665l-8.109-8.64a108.54 108.54 0 012.495-.399l7.735 8.374zM383.485 152.489H381.988l-6.986-7.444c.249-.265.624-.398.998-.531l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M385.731 152.091c.125 0 .374-.133.499-.133.374-.133.624-.133.998-.266.374-.132.624-.265.998-.398.125 0 .374-.133.499-.133l.25-.133c.124 0 .124-.133.249-.133.374-.133.624-.266.998-.532.624-.398 1.248-.797 1.747-1.196a4.463 4.463 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266-.125 0-.125.133-.25.133l-.249.133c-.125.132-.375.132-.499.265l-.499.133c-.125 0-.375.133-.499.133-.375.133-.749.133-1.123.266-.374 0-.749 0-1.123.133h-1.123c.375-.133.749-.133.998-.266l.624-.133zM380.865 152.09l1.372.133.749.133c.249 0 .499 0 .748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.266-.499-.133-.998-.266-1.372-.532.499 0 .998 0 1.497.133.624.133.998.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M382.611 143.584c1.247 0 2.495.133 3.493.266h6.237v2.526c-.124 2.259-4.116 4.652-9.855 4.652-5.738 0-9.606-2.393-9.855-4.652v-2.526h6.237c1.373-.133 2.495-.266 3.743-.266z"
            fill="#fff"
            />
            <path
            d="M382.611 151.161c-5.614 0-9.606-2.393-9.855-4.653v-2.791h6.362c1.123-.266 2.246-.266 3.493-.266 1.248 0 2.37.133 3.493.266h6.362v2.791c-.249 2.26-4.241 4.653-9.855 4.653zm-9.73-4.786c.124 2.26 4.116 4.52 9.73 4.52 5.614 0 9.606-2.393 9.731-4.52v-2.392h-6.238c-1.123-.266-2.245-.266-3.493-.266-1.247 0-2.37.133-3.493.266h-6.237v2.392z"
            fill="#000"
            />
            <path
            d="M391.344 148.369c-.124.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#fff"
            />
            <path
            d="M390.596 149.166v-5.316h.748v4.652c-.249.133-.374.399-.624.532l-.124.132zm.249-5.183v4.785a1.75 1.75 0 01.499-.399v-4.386h-.499z"
            fill="#000"
            />
            <path
            d="M379.743 143.85v7.044c-.25 0-.374-.133-.624-.133v-6.778c.25-.133.374-.133.624-.133z"
            fill="#fff"
            />
            <path
            d="M379.742 150.895c-.374 0-.499-.133-.748-.133h-.125v-7.045h.125c.125 0 .374 0 .499-.133h.125v7.311h.124zm-.623-.266c.124 0 .249 0 .499.133v-6.779c-.125 0-.25 0-.499.133v6.513z"
            fill="#000"
            />
            <path
            d="M380.741 151.028c-.25 0-.374 0-.624-.133v-7.178c.25 0 .374 0 .624-.133v7.444z"
            fill="#fff"
            />
            <path
            d="M380.865 151.028c-.249 0-.499 0-.748-.133h-.125v-7.311h.125c.249 0 .374 0 .624-.133h.124v7.577zm-.623-.133h.499v-7.178h-.499v7.178z"
            fill="#000"
            />
            <path
            d="M375.501 149.432c-.25-.133-.375-.266-.624-.398v-5.184h.624v5.582z"
            fill="#fff"
            />
            <path
            d="M375.625 149.698l-.124-.133c-.25-.133-.375-.266-.624-.399v-5.316h.748v5.848zm-.623-.664c.124.132.249.132.499.265v-5.316h-.499v5.051z"
            fill="#000"
            />
            <path d="M381.864 151.028h-.624v-7.444h.624v7.444z" fill="#fff" />
            <path
            d="M381.863 151.16h-.873v-7.576h.873v7.576zm-.623-.265h.499v-7.311h-.499v7.311z"
            fill="#000"
            />
            <path
            d="M374.378 148.768c-.25-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#fff"
            />
            <path
            d="M374.502 149.034l-.124-.133c-.25-.133-.499-.399-.624-.532v-4.519h.748v5.184zm-.623-.798c.124.133.249.266.499.399v-4.652h-.499v4.253z"
            fill="#000"
            />
            <path
            d="M377.622 150.363c-.25 0-.374-.133-.624-.266v-6.247h.624v6.513z"
            fill="#fff"
            />
            <path
            d="M377.622 150.496c-.375-.133-.499-.133-.749-.266v-6.38h.749v6.646zm-.624-.399c.125 0 .249.133.499.133v-6.247h-.499v6.114z"
            fill="#000"
            />
            <path
            d="M378.62 150.629c-.25 0-.374-.133-.624-.133v-6.646h.624v6.779z"
            fill="#fff"
            />
            <path
            d="M378.744 150.761c-.374-.132-.499-.132-.748-.132h-.125v-6.779h.749v6.911h.124zm-.623-.398c.124 0 .249.133.499.133v-6.513h-.499v6.38z"
            fill="#000"
            />
            <path
            d="M376.499 149.964c-.25-.133-.375-.133-.624-.266v-5.848h.624v6.114z"
            fill="#fff"
            />
            <path
            d="M376.624 150.097c-.375-.133-.5-.266-.749-.266v-5.981h.749v6.247zm-.624-.399c.125.133.249.133.499.133v-5.848H376v5.715z"
            fill="#000"
            />
            <path
            d="M388.1 150.231c-.249.132-.374.132-.623.132v-6.513h.623v6.381z"
            fill="#fff"
            />
            <path
            d="M387.477 150.497v-6.779h.748v6.513c-.249.133-.499.266-.748.266zm.124-6.513v6.247c.125 0 .25-.133.499-.133v-6.114h-.499z"
            fill="#000"
            />
            <path d="M383.983 151.028h-.624v-7.444h.624v7.444z" fill="#fff" />
            <path
            d="M383.234 151.161v-7.71h.874v7.577h-.125c-.25.133-.499.133-.749.133zm.125-7.444v7.311h.499v-7.311h-.499z"
            fill="#000"
            />
            <path d="M382.862 143.584v7.444h-.624v-7.444h.624z" fill="#fff" />
            <path
            d="M382.612 151.161h-.499v-7.71h.749v7.71h-.125-.125zm-.249-.133h.374v-7.311h-.499v7.311h.125z"
            fill="#000"
            />
            <path
            d="M392.467 146.508c0 .532-.249 1.063-.623 1.462v-4.12h.623v2.658z"
            fill="#fff"
            />
            <path
            d="M391.719 148.236v-4.386h.873v2.791c0 .532-.25.93-.749 1.462l-.124.133zm.124-4.253v3.721c.25-.398.499-.797.499-1.196v-2.525h-.499z"
            fill="#000"
            />
            <path
            d="M373.38 147.705c-.25-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#fff"
            />
            <path
            d="M373.505 147.97l-.125-.265c-.25-.399-.499-.798-.499-1.33v-2.791h.748v4.386h-.124zm-.624-1.595c0 .399.125.665.374 1.064v-3.456h-.374v2.392z"
            fill="#000"
            />
            <path
            d="M390.221 149.167c-.249.133-.374.266-.623.399v-5.716h.623v5.317z"
            fill="#fff"
            />
            <path
            d="M389.598 149.699v-5.981h.748v5.582c-.249.133-.374.266-.624.399h-.124zm.124-5.715v5.449c.125-.133.25-.133.499-.265v-5.184h-.499z"
            fill="#000"
            />
            <path
            d="M384.983 150.895c-.249 0-.374 0-.624.132v-7.31c.25 0 .375 0 .624.133v7.045z"
            fill="#fff"
            />
            <path
            d="M384.234 151.16v-7.576h.125c.25 0 .374 0 .624.133h.125v7.443h-.125c-.25-.132-.374-.132-.749 0zm.25-7.443v7.178h.499v-7.045c-.25-.133-.374-.133-.499-.133z"
            fill="#000"
            />
            <path
            d="M389.223 149.831c-.249.133-.374.133-.623.266v-6.115h.623v5.849z"
            fill="#fff"
            />
            <path
            d="M388.475 150.23v-6.38h.748v5.981c-.125.133-.374.266-.748.399zm.249-6.247v5.981c.125 0 .25-.133.499-.133v-5.848h-.499z"
            fill="#000"
            />
            <path
            d="M387.102 150.497c-.249 0-.374.133-.623.133v-6.779h.623v6.646z"
            fill="#fff"
            />
            <path
            d="M386.354 150.763v-7.045h.748v6.912h-.125s-.249.133-.623.133zm.249-6.779v6.646c.125 0 .25-.133.499-.133v-6.513h-.499z"
            fill="#000"
            />
            <path
            d="M386.104 150.762c-.249 0-.374.133-.624.133v-7.044c.25 0 .375.133.624.133v6.778z"
            fill="#fff"
            />
            <path
            d="M385.355 151.028v-7.31h.125c.25 0 .374.133.624.133h.125v7.044h-.125c-.25 0-.499 0-.749.133zm.125-7.177v6.912c.125 0 .25 0 .499-.133v-6.646c-.125 0-.374-.133-.499-.133z"
            fill="#000"
            />
            <path
            d="M382.611 138.932c5.739 0 9.855 2.525 9.855 4.785 0 2.259-3.992 4.785-9.855 4.785s-9.855-2.526-9.855-4.785c.125-2.26 4.117-4.785 9.855-4.785z"
            fill="#fff"
            />
            <path
            d="M382.611 148.502c-5.863 0-9.855-2.526-9.855-4.785 0-2.26 4.117-4.785 9.855-4.785 5.739 0 9.855 2.525 9.855 4.785 0 2.259-3.992 4.785-9.855 4.785zm0-9.437c-5.738 0-9.73 2.392-9.73 4.652 0 2.259 3.992 4.652 9.73 4.652 5.739 0 9.731-2.393 9.731-4.652 0-2.26-3.992-4.652-9.731-4.652z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M388.974 147.173c-.624.266-1.373.532-2.121.664l-8.109-8.639a108.54 108.54 0 012.495-.399l7.735 8.374zM383.485 148.37H381.988l-6.986-7.444c.249-.266.624-.399.998-.531l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M385.731 147.971c.125 0 .374-.133.499-.133.374-.133.624-.133.998-.266s.624-.265.998-.398c.125 0 .374-.133.499-.133l.25-.133c.124 0 .124-.133.249-.133.374-.133.624-.266.998-.532.624-.399 1.248-.797 1.747-1.196a4.472 4.472 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.133-.375.133-.499.266-.125 0-.125.133-.25.133l-.249.132c-.125.133-.375.133-.499.266l-.499.133c-.125 0-.375.133-.499.133-.375.133-.749.133-1.123.266-.374 0-.749 0-1.123.133h-1.123c.375-.133.749-.133.998-.266l.624-.133zM380.865 148.104l1.372.133.749.133c.249 0 .499.132.748.132-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.265-.499-.133-.998-.266-1.372-.532.499 0 .998 0 1.497.133.624 0 .998 0 1.497.133z"
            fill="#fff"
            />
            <path
            d="M398.33 151.56c1.247 0 2.495.133 3.493.266h6.237v2.525c-.125 2.26-4.117 4.652-9.855 4.652-5.614 0-9.606-2.392-9.855-4.652v-2.392h6.237a17.906 17.906 0 013.743-.399z"
            fill="#0EA59D"
            />
            <path
            d="M398.33 159.136c-5.614 0-9.606-2.392-9.855-4.652v-2.791h6.362c1.123-.266 2.245-.266 3.493-.266 1.247 0 2.37.133 3.493.266h6.362v2.658c-.249 2.393-4.241 4.785-9.855 4.785zm-9.731-4.785c.125 2.26 4.117 4.519 9.731 4.519s9.606-2.392 9.73-4.519v-2.393h-6.237c-1.123-.265-2.246-.265-3.493-.265-1.248 0-2.37.133-3.493.265h-6.238v2.393z"
            fill="#131A2D"
            />
            <path
            d="M407.061 156.477c-.125.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M406.312 157.142v-5.317h.749v4.652c-.249.133-.374.399-.749.665zm.125-5.184v4.785c.125-.133.374-.266.499-.398v-4.387h-.499z"
            fill="#131A2D"
            />
            <path
            d="M395.337 151.826v7.045c-.25 0-.375-.133-.624-.133v-6.779c.249-.133.499-.133.624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M395.461 159.004c-.249 0-.499-.133-.748-.133v-7.045h.125c.124 0 .374 0 .499-.133h.124v7.311zm-.623-.266c.124 0 .374 0 .499.133v-6.912c-.125 0-.375 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M396.46 159.003c-.25 0-.375 0-.624-.133v-7.178c.249 0 .374 0 .624-.132v7.443z"
            fill="#0EA59D"
            />
            <path
            d="M396.459 159.136c-.249 0-.499 0-.748-.133h-.125v-7.311h.125c.249 0 .374 0 .623-.132h.125v7.576zm-.624-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M391.219 157.541c-.249-.133-.374-.266-.623-.399v-5.184h.623v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M391.219 157.674c-.374-.133-.499-.266-.748-.399v-5.317h.748v5.716zm-.624-.532c.125.133.25.133.499.266v-5.45h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M397.458 159.003h-.624v-7.443h.624v7.443z" fill="#0EA59D" />
            <path
            d="M397.582 159.136h-.873v-7.576h.873v7.576zm-.624-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M390.096 156.876c-.249-.133-.499-.399-.623-.532v-4.386h.623v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M390.221 157.009c-.374-.266-.624-.399-.748-.664v-4.52h.748v5.184zm-.624-.797c.125.132.25.265.499.398v-4.652h-.499v4.254z"
            fill="#131A2D"
            />
            <path
            d="M393.216 158.338c-.25 0-.375-.133-.624-.266v-6.114h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M393.34 158.471c-.249-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.399c.124 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M394.339 158.604c-.25 0-.375-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M394.463 158.737c-.249-.133-.499-.133-.748-.133v-6.779h.748v6.912zm-.623-.266c.124 0 .374.133.499.133v-6.646h-.499v6.513z"
            fill="#131A2D"
            />
            <path
            d="M392.217 157.939c-.249-.132-.374-.132-.623-.265v-5.716h.623v5.981z"
            fill="#0EA59D"
            />
            <path
            d="M392.342 158.072c-.374-.132-.499-.265-.748-.265v-5.982h.748v6.247zm-.623-.398c.124.133.249.133.498.266v-5.982h-.498v5.716z"
            fill="#131A2D"
            />
            <path
            d="M403.819 158.205c-.249.133-.374.133-.624.133v-6.38h.624v6.247z"
            fill="#0EA59D"
            />
            <path
            d="M403.195 158.471v-6.646h.749v6.513c-.25 0-.499.133-.749.133zm.125-6.513v6.38c.125 0 .374-.133.499-.133v-6.247h-.499z"
            fill="#131A2D"
            />
            <path d="M399.577 159.003h-.624v-7.443h.624v7.443z" fill="#0EA59D" />
            <path
            d="M398.953 159.136v-7.576h.873v7.576h-.873zm.125-7.444v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M398.581 151.56v7.443h-.624v-7.443h.624z" fill="#0EA59D" />
            <path
            d="M398.331 159.136h-.499v-7.709h.749v7.709h-.25zm-.374-.133h.499v-7.31h-.499v7.31z"
            fill="#131A2D"
            />
            <path
            d="M408.186 154.484c0 .531-.249 1.063-.624 1.462v-3.988h.624v2.526z"
            fill="#0EA59D"
            />
            <path
            d="M407.438 156.212v-4.387h.873v2.659c0 .531-.25.93-.624 1.462l-.249.266zm.124-4.254v3.722c.375-.399.499-.931.499-1.329v-2.393h-.499z"
            fill="#131A2D"
            />
            <path
            d="M389.099 155.814c-.25-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M389.098 155.947l-.124-.133c-.25-.399-.499-.798-.499-1.329v-2.792h.623v4.254zm-.499-1.595c0 .399.125.797.375 1.063v-3.456h-.375v2.393z"
            fill="#131A2D"
            />
            <path
            d="M405.94 157.275c-.249.133-.374.266-.624.399v-5.716h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M405.316 157.674v-5.849h.749v5.45l-.749.399zm.125-5.716v5.45c.125-.133.374-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M400.7 158.87c-.25 0-.374 0-.624.133v-7.311c.25 0 .374 0 .624.133v7.045z"
            fill="#0EA59D"
            />
            <path
            d="M399.951 159.136v-7.576h.125c.249 0 .374 0 .624.132h.124v7.311h-.124c-.25 0-.375 0-.749.133zm.125-7.444v7.178h.499v-7.045c-.125 0-.25-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M404.942 157.807c-.249.132-.374.132-.624.265v-6.114h.624v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M404.193 158.205v-6.38h.749v5.982c-.25.133-.374.265-.749.398zm.125-6.247v5.982c.125 0 .374-.133.499-.266v-5.716h-.499z"
            fill="#131A2D"
            />
            <path
            d="M402.821 158.471c-.249 0-.374.133-.624.133v-6.646h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M402.072 158.737v-6.912h.749v6.779c-.25 0-.374.133-.749.133zm.125-6.779v6.646c.125 0 .374-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M401.698 158.738c-.25 0-.374.133-.624.133v-7.045c.25 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M401.074 159.004v-7.311h.125c.249 0 .374.133.624.133v7.045c-.25 0-.499 0-.749.133zm.125-7.178v6.912c.125 0 .374 0 .499-.133v-6.646c-.25 0-.374-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M398.33 146.907c5.738 0 9.855 2.526 9.855 4.785 0 2.26-3.992 4.786-9.855 4.786-5.739 0-9.855-2.526-9.855-4.786 0-2.259 4.116-4.785 9.855-4.785z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M404.692 155.281c-.623.266-1.372.532-2.12.665l-8.109-8.64c.748-.133 1.622-.266 2.495-.399l7.734 8.374zM399.077 156.477H397.58l-6.986-7.443c.249-.266.624-.399.998-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M401.448 156.079c.125 0 .374-.133.499-.133.374-.133.624-.133.998-.266s.624-.266.998-.399c.125 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.624-.266.998-.531.624-.399 1.247-.798 1.746-1.197a4.438 4.438 0 01-1.497 1.595c-.124.133-.249.266-.499.266-.124.133-.374.133-.499.266-.124 0-.124.133-.249.133l-.25.133c-.124.133-.374.133-.499.266l-.499.133c-.124 0-.374.133-.499.133-.374.132-.748.132-1.122.265-.375 0-.749 0-1.123.133h-1.123c.374-.133.749-.133.998-.266l.624-.132zM396.584 156.078l1.372.133.749.133c.249 0 .499 0 .748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.499 0 .998.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M394.087 141.457c1.248 0 2.495.133 3.493.266h6.238v2.525c-.125 2.26-4.117 4.653-9.855 4.653-5.614 0-9.606-2.393-9.856-4.653v-2.525h6.238c1.247-.133 2.495-.266 3.742-.266z"
            fill="#0EA59D"
            />
            <path
            d="M394.088 149.033c-5.614 0-9.606-2.392-9.856-4.652v-2.791h6.363c1.122-.266 2.245-.266 3.493-.266 1.247 0 2.37.133 3.493.266h6.362v2.658c-.25 2.526-4.242 4.785-9.855 4.785zm-9.731-4.652c.125 2.26 4.117 4.519 9.731 4.519 5.613 0 9.605-2.392 9.73-4.519v-2.525h-6.237c-1.123-.266-2.246-.266-3.493-.266-1.248 0-2.371.133-3.493.266h-6.238v2.525z"
            fill="#131A2D"
            />
            <path
            d="M402.819 146.375c-.125.133-.374.399-.624.531v-5.051h.624v4.52z"
            fill="#0EA59D"
            />
            <path
            d="M402.07 147.039v-5.316h.749v4.652c-.25.266-.374.399-.749.664zm.125-5.183v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M391.094 141.724v7.044c-.249 0-.374-.132-.623-.132v-6.779c.249 0 .499-.133.623-.133z"
            fill="#0EA59D"
            />
            <path
            d="M391.219 148.9c-.249 0-.499-.132-.748-.132v-7.045h.124c.125 0 .375 0 .499-.133h.125v7.31zm-.624-.265c.125 0 .375 0 .499.133v-6.912c-.124 0-.374 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M392.217 148.901c-.249 0-.374 0-.623-.133v-7.178c.249 0 .374 0 .623-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M392.217 149.034c-.249 0-.499 0-.748-.133h-.125v-7.311h.125c.249 0 .374 0 .623-.133h.125v7.577zm-.624-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M386.977 147.438c-.249-.133-.374-.266-.623-.399v-5.184h.623v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M386.977 147.571c-.374-.133-.499-.266-.748-.399v-5.317h.748v5.716zm-.624-.532c.125.133.25.133.499.266v-5.45h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M393.214 149.034h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M393.338 149.034h-.873v-7.577h.873v7.577zm-.624-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M385.854 146.774c-.249-.133-.499-.399-.624-.532v-4.387h.624v4.919z"
            fill="#0EA59D"
            />
            <path
            d="M385.979 146.907c-.374-.266-.624-.399-.749-.665v-4.519h.749v5.184zm-.624-.665c.125.133.25.266.499.399v-4.653h-.499v4.254z"
            fill="#131A2D"
            />
            <path
            d="M388.973 148.236c-.249 0-.374-.133-.623-.266v-6.247h.623v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M389.098 148.369c-.249-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.624-.399c.125 0 .375.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M390.096 148.634c-.249 0-.374-.132-.623-.132v-6.647h.623v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M390.221 148.635c-.249-.133-.499-.133-.748-.133v-6.779h.748v6.912zm-.624-.266c.125 0 .375.133.499.133v-6.514h-.499v6.381z"
            fill="#131A2D"
            />
            <path
            d="M387.975 147.97c-.249-.133-.374-.133-.623-.266v-5.849h.623v6.115z"
            fill="#0EA59D"
            />
            <path
            d="M388.1 148.103c-.374-.133-.499-.266-.748-.266v-5.982h.748v6.248zm-.624-.532c.125.133.375.133.499.266v-5.849h-.499v5.583z"
            fill="#131A2D"
            />
            <path
            d="M399.577 148.103c-.25.133-.374.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M398.953 148.502v-6.647h.749v6.514c-.25-.133-.499 0-.749.133zm.125-6.647v6.381c.125 0 .374-.133.499-.133v-6.115h-.499v-.133z"
            fill="#131A2D"
            />
            <path d="M395.335 149.034h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M394.711 149.034v-7.577h.873v7.577h-.873zm.125-7.444v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M394.337 141.457v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M394.087 149.034h-.499v-7.71h.748v7.71h-.249zm-.374-.133h.499v-7.311h-.375v7.311h-.124z"
            fill="#131A2D"
            />
            <path
            d="M403.944 144.381c0 .532-.249 1.063-.624 1.462v-4.12h.624v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M403.07 146.109v-4.386h.874v2.658c0 .532-.25.931-.624 1.462l-.25.266zm.25-4.253v3.721c.374-.398.499-.93.499-1.329v-2.525h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M384.856 145.71c-.249-.399-.499-.93-.499-1.329v-2.526h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M384.856 145.976l-.125-.133c-.249-.399-.499-.797-.499-1.329v-2.791h.624v4.253zm-.499-1.595c0 .399.125.798.374 1.063v-3.588h-.374v2.525z"
            fill="#131A2D"
            />
            <path
            d="M401.698 147.172c-.25.133-.374.266-.624.399v-5.716h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M401.074 147.571v-5.848h.749v5.449l-.749.399zm.125-5.715v5.449c.125-.133.374-.133.499-.266v-5.183h-.499z"
            fill="#131A2D"
            />
            <path
            d="M396.458 148.901c-.25 0-.375 0-.624.133v-7.31c.249 0 .374 0 .624.133v7.044z"
            fill="#0EA59D"
            />
            <path
            d="M395.709 149.034v-7.577h.125c.249 0 .374 0 .623.133h.125v7.311h-.125c-.249.133-.374.133-.748.133zm.125-7.311v7.178h.499v-7.045c-.125-.133-.25-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M400.7 147.704c-.25.133-.374.133-.624.266v-6.115h.624v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M399.951 148.103v-6.38h.749v5.981c-.25.133-.375.266-.749.399zm.125-6.247v5.981c.125 0 .374-.133.499-.266v-5.715h-.499z"
            fill="#131A2D"
            />
            <path
            d="M398.579 148.502c-.25 0-.374.132-.624.132v-6.779h.624v6.647z"
            fill="#0EA59D"
            />
            <path
            d="M397.83 148.767v-6.912h.749v6.779c-.25 0-.375 0-.749.133zm.125-6.912v6.647c.125 0 .374-.133.499-.133v-6.514h-.499z"
            fill="#131A2D"
            />
            <path
            d="M397.456 148.768c-.25 0-.374.133-.624.133v-7.045c.25 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M396.832 148.9v-7.31h.125c.249 0 .374.133.624.133v7.045c-.25 0-.499.132-.749.132zm.125-7.044v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M394.088 136.938c5.738 0 9.855 2.525 9.855 4.785 0 2.259-3.992 4.785-9.855 4.785-5.739 0-9.856-2.526-9.856-4.785 0-2.393 4.117-4.785 9.856-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M394.088 146.508c-5.864 0-9.856-2.526-9.856-4.785 0-2.26 4.117-4.785 9.856-4.785 5.863 0 9.855 2.525 9.855 4.785 0 2.259-3.992 4.785-9.855 4.785zm0-9.57c-5.739 0-9.731 2.525-9.731 4.652 0 2.259 3.992 4.652 9.731 4.652 5.738 0 9.73-2.526 9.73-4.652 0-2.127-3.992-4.652-9.73-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M400.45 145.179c-.624.266-1.372.531-2.121.664l-8.108-8.64c.748-.132 1.621-.265 2.495-.398l7.734 8.374zM394.835 146.376H393.338l-6.986-7.444c.374-.266.623-.399.998-.532l7.485 7.976z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M397.206 145.977c.125 0 .374-.133.499-.133.374-.133.623-.133.998-.266.374-.133.624-.266.998-.399.125 0 .374-.132.499-.132l.249-.133c.125 0 .125-.133.25-.133.374-.133.624-.266.998-.532.624-.399 1.247-.798 1.746-1.196a4.454 4.454 0 01-1.497 1.595c-.125.133-.249.266-.499.266-.125.133-.374.133-.499.265-.124 0-.125.133-.249.133l-.25.133c-.124.133-.374.133-.499.266l-.499.133c-.125 0-.374.133-.499.133-.374.133-.748.133-1.122.266-.375 0-.749 0-1.123.133h-1.123c.374-.133.749-.133.998-.266l.624-.133zM392.342 145.977l1.372.133.748.133c.25 0 .499.133.749.133-.25.132-.499.132-.749.132h-2.245c-.499 0-.998-.132-1.497-.265a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.499 0 .998.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M390.595 137.603c1.248 0 2.495.132 3.493.265h6.238v2.526c-.125 2.26-4.117 4.652-9.855 4.652-5.739 0-9.606-2.392-9.856-4.652v-2.526h6.238c1.247-.133 2.495-.265 3.742-.265z"
            fill="#0EA59D"
            />
            <path
            d="M390.595 145.179c-5.613 0-9.605-2.392-9.855-4.652v-2.791h6.362c1.123-.266 2.246-.266 3.493-.266 1.248 0 2.371.133 3.493.266h6.363v2.658c-.25 2.393-4.242 4.785-9.856 4.785zm-9.73-4.652c.125 2.26 4.117 4.519 9.73 4.519 5.614 0 9.606-2.392 9.731-4.519v-2.526h-6.238c-1.122-.265-2.245-.265-3.493-.265-1.247 0-2.37.132-3.493.265h-6.237v2.526z"
            fill="#131A2D"
            />
            <path
            d="M399.204 142.52c-.125.133-.374.399-.624.532v-5.051h.624v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M398.58 143.185v-5.317h.749v4.652c-.25.266-.375.399-.749.665zm.125-5.184v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M387.602 137.869v7.045c-.249 0-.374-.133-.623-.133v-6.779c.249-.133.499-.133.623-.133z"
            fill="#0EA59D"
            />
            <path
            d="M387.727 145.047c-.249 0-.499-.133-.748-.133v-7.045h.124c.125 0 .375 0 .499-.133h.125v7.311zm-.624-.266c.125 0 .375 0 .499.133v-6.912c-.124 0-.374 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M388.725 145.046c-.249 0-.374 0-.623-.133v-7.178c.249 0 .374 0 .623-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M388.725 145.179c-.25 0-.499 0-.749-.133h-.124v-7.311h.124c.25 0 .375 0 .624-.133h.125v7.577zm-.624-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M383.36 143.583c-.249-.133-.374-.265-.624-.398v-5.184h.624v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M383.485 143.716c-.374-.133-.499-.266-.749-.398v-5.317h.749v5.715zm-.624-.531c.125.133.25.133.499.265v-5.449h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M389.723 145.179h-.623v-7.444h.623v7.444z" fill="#0EA59D" />
            <path
            d="M389.848 145.179h-.873v-7.577h.873v7.577zm-.624-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M382.362 142.919c-.249-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M382.362 143.052c-.374-.266-.624-.399-.749-.665v-4.519h.749v5.184zm-.624-.798c.125.133.25.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M385.481 144.381c-.249-.133-.374-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M385.606 144.514c-.25-.133-.499-.133-.749-.266v-6.38h.749v6.646zm-.624-.399c.125 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M386.604 144.647c-.249 0-.374-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M386.604 144.78c-.25-.133-.499-.133-.749-.133v-6.779h.749v6.912zm-.624-.266c.125 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M384.483 144.115c-.249-.133-.374-.133-.624-.266V138h.624v6.115z"
            fill="#0EA59D"
            />
            <path
            d="M384.483 144.115c-.374-.133-.499-.266-.749-.266v-5.981h.749v6.247zm-.624-.399c.125.133.25.133.499.266v-5.848h-.499v5.582z"
            fill="#131A2D"
            />
            <path
            d="M396.085 144.248c-.25.133-.375.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M395.336 144.514v-6.646h.748v6.513c-.124 0-.374.133-.748.133zm.249-6.513v6.38c.125 0 .375-.133.499-.133v-6.114h-.499v-.133z"
            fill="#131A2D"
            />
            <path d="M391.842 145.046h-.623v-7.444h.623v7.444z" fill="#0EA59D" />
            <path
            d="M391.219 145.179v-7.577h.873v7.577h-.873zm.125-7.444v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M390.844 137.603v7.443h-.623v-7.443h.623z" fill="#0EA59D" />
            <path
            d="M390.595 145.179h-.499v-7.71h.748v7.71h-.249zm-.375-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M400.327 140.526c0 .532-.25 1.064-.624 1.462v-4.12h.624v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M399.578 142.254v-4.386h.873v2.658c0 .532-.249.931-.623 1.462l-.25.266zm.125-4.253v3.722c.374-.399.499-.931.499-1.33v-2.525h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M381.239 141.855c-.249-.399-.499-.93-.499-1.329V138h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M381.364 142.121l-.125-.133c-.249-.399-.499-.797-.499-1.329v-2.791h.624v4.253zm-.499-1.595c0 .399.125.798.374 1.063v-3.588h-.374v2.525z"
            fill="#131A2D"
            />
            <path
            d="M398.206 143.318c-.25.132-.374.265-.624.398v-5.715h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M397.457 143.716v-5.848h.749v5.45c-.125.133-.375.266-.749.398zm.25-5.715v5.45c.124-.133.374-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M392.967 145.046h-.623v-7.311c.249 0 .374 0 .623.133v7.178z"
            fill="#0EA59D"
            />
            <path
            d="M392.219 145.179v-7.577h.125c.249 0 .374 0 .623.133h.125v7.311h-.125c-.249 0-.499.133-.748.133zm.125-7.444v7.178h.498v-7.045c-.124 0-.374 0-.498-.133z"
            fill="#131A2D"
            />
            <path
            d="M397.083 143.849c-.25.133-.375.133-.624.266V138h.624v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M396.459 144.248v-6.38h.748v5.981l-.748.399zm.125-6.247v5.981c.124 0 .374-.133.499-.266v-5.715h-.499z"
            fill="#131A2D"
            />
            <path
            d="M394.962 144.647c-.25 0-.375.132-.624.132V138h.624v6.647z"
            fill="#0EA59D"
            />
            <path
            d="M394.338 144.78v-6.912h.748v6.779c-.249.133-.499.133-.748.133zm.125-6.779v6.646c.124 0 .374-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M393.964 144.781c-.25 0-.375.133-.624.133v-7.045c.249 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M393.215 145.047v-7.311h.125c.249 0 .374.133.623.133v7.045c-.249 0-.374.133-.748.133zm.249-7.178v6.912c.125 0 .375 0 .499-.133v-6.779c-.249.133-.374.133-.499 0z"
            fill="#131A2D"
            />
            <path
            d="M390.595 132.95c5.739 0 9.856 2.525 9.856 4.785 0 2.26-3.992 4.785-9.856 4.785-5.863 0-9.855-2.525-9.855-4.785 0-2.26 3.992-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M390.595 142.653c-5.863 0-9.855-2.525-9.855-4.785 0-2.26 4.117-4.785 9.855-4.785 5.739 0 9.856 2.525 9.856 4.785 0 2.26-4.117 4.785-9.856 4.785zm0-9.57c-5.738 0-9.73 2.525-9.73 4.652 0 2.26 3.992 4.652 9.73 4.652 5.739 0 9.731-2.525 9.731-4.652 0-2.127-3.992-4.652-9.731-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M396.958 141.324c-.624.266-1.372.532-2.121.665l-8.108-8.64c.748-.133 1.621-.266 2.495-.399l7.734 8.374zM391.344 142.52H389.847l-6.986-7.444c.25-.265.624-.398.998-.531l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M393.715 142.121c.125 0 .375-.133.5-.133.374-.133.623-.133.997-.265.375-.133.624-.266.998-.399.125 0 .375-.133.5-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.623-.266.997-.532.624-.398 1.248-.797 1.747-1.196a4.446 4.446 0 01-1.497 1.595c-.125.133-.249.266-.499.266-.125.133-.374.133-.499.266-.125 0-.125.133-.249.133l-.25.133c-.125.133-.374.133-.499.265l-.499.133c-.125 0-.374.133-.499.133-.374.133-.749.133-1.123.266-.374 0-.748 0-1.123.133h-1.122c.374-.133.748-.133.998-.266l.623-.133zM388.849 142.122l1.373.133.748.133c.25 0 .499.133.749.133-.25.133-.499.133-.749.133h-2.245c-.499 0-.998-.133-1.497-.266a5.847 5.847 0 01-1.373-.532c.499 0 .998 0 1.497.133.499 0 .998.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M387.726 150.23c1.248 0 2.495.133 3.493.266h6.238v2.525c-.125 2.26-4.117 4.652-9.856 4.652-5.613 0-9.605-2.392-9.855-4.652v-2.525h6.238c1.247-.133 2.495-.266 3.742-.266z"
            fill="#0EA59D"
            />
            <path
            d="M387.726 157.807c-5.613 0-9.605-2.393-9.855-4.653v-2.791h6.362c1.123-.266 2.246-.266 3.493-.266 1.248 0 2.371.133 3.493.266h6.363v2.658c-.25 2.393-4.242 4.786-9.856 4.786zm-9.73-4.786c.125 2.26 4.117 4.52 9.73 4.52 5.614 0 9.606-2.393 9.731-4.52v-2.392h-6.238c-1.122-.266-2.245-.266-3.493-.266-1.247 0-2.37.133-3.493.266h-6.237v2.392z"
            fill="#131A2D"
            />
            <path
            d="M396.333 155.148c-.125.133-.375.399-.624.532v-5.051h.624v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M395.709 155.68v-5.317h.748v4.652c-.249.266-.374.532-.748.665zm.125-5.051v4.785c.124-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M384.733 150.496v7.044c-.249 0-.374-.133-.624-.133v-6.778c.25-.133.499-.133.624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M384.858 157.541c-.25 0-.499-.133-.749-.133v-7.045h.125c.125 0 .25 0 .499-.133h.125v7.311zm-.624-.266c.125 0 .374 0 .499.133v-6.912c-.125 0-.374 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M385.856 157.673c-.249 0-.374 0-.624-.133v-7.177c.25 0 .375 0 .624-.133v7.443z"
            fill="#0EA59D"
            />
            <path
            d="M385.856 157.674c-.25 0-.499 0-.749-.133h-.125v-7.311h.125c.25 0 .374 0 .624-.133h.125v7.577zm-.624-.133h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M380.491 156.211c-.25-.133-.374-.266-.624-.399v-5.184h.624v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M380.616 156.211c-.375-.133-.499-.266-.749-.399v-5.316h.749v5.715zm-.624-.531c.125.132.374.132.499.265v-5.316h-.499v5.051z"
            fill="#131A2D"
            />
            <path d="M386.854 157.673h-.624v-7.443h.624v7.443z" fill="#0EA59D" />
            <path
            d="M386.979 157.806h-.874v-7.576h.874v7.576zm-.624-.132h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M379.493 155.413c-.25-.132-.499-.398-.624-.531v-4.387h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M379.493 155.68c-.375-.266-.624-.399-.749-.665v-4.519h.749v5.184zm-.624-.798c.125.133.249.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M382.612 157.009c-.249 0-.374-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M382.737 157.142c-.25-.133-.499-.133-.749-.266v-6.38h.749v6.646zm-.624-.399c.125 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M383.735 157.274c-.249 0-.374-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M383.735 157.407c-.25-.132-.499-.132-.749-.132v-6.779h.749v6.911zm-.624-.265c.125 0 .374.133.499.133v-6.646h-.499v6.513z"
            fill="#131A2D"
            />
            <path
            d="M381.614 156.61c-.25-.133-.374-.133-.624-.266v-5.848h.624v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M381.614 156.743c-.375-.133-.499-.266-.749-.266v-5.981h.749v6.247zm-.624-.399c.125.133.249.133.499.266v-5.981h-.499v5.715z"
            fill="#131A2D"
            />
            <path
            d="M393.216 156.876c-.25.132-.375.132-.624.132v-6.513h.624v6.381z"
            fill="#0EA59D"
            />
            <path
            d="M392.467 157.141v-6.646h.748v6.513c-.124 0-.374.133-.748.133zm.249-6.513v6.38c.125 0 .375-.132.499-.132v-6.248h-.499z"
            fill="#131A2D"
            />
            <path d="M388.973 157.674h-.623v-7.444h.623v7.444z" fill="#0EA59D" />
            <path
            d="M388.35 157.806v-7.576h.873v7.576h-.873zm.124-7.443v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M387.975 150.23v7.444h-.623v-7.444h.623z" fill="#0EA59D" />
            <path
            d="M387.726 157.807h-.499v-7.71h.873v7.71h-.374zm-.375-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M397.458 153.154c0 .532-.25 1.063-.624 1.462v-4.12h.624v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M396.709 154.882v-4.386h.873v2.658c0 .532-.249.93-.624 1.462l-.249.266zm.125-4.253v3.721c.374-.398.499-.93.499-1.329v-2.392h-.499z"
            fill="#131A2D"
            />
            <path
            d="M378.37 154.483c-.249-.398-.499-.93-.499-1.329v-2.525h.499v3.854z"
            fill="#0EA59D"
            />
            <path
            d="M378.495 154.616l-.125-.133c-.249-.398-.499-.797-.499-1.329v-2.791h.624v4.253zm-.499-1.595c0 .399.125.798.374 1.064v-3.456h-.374v2.392z"
            fill="#131A2D"
            />
            <path
            d="M395.337 155.945c-.25.133-.375.266-.624.399v-5.716h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M394.588 156.344v-5.848h.748v5.449c-.124.133-.374.266-.748.399zm.249-5.715v5.449c.125-.133.375-.133.499-.266v-5.183h-.499z"
            fill="#131A2D"
            />
            <path
            d="M390.096 157.541c-.249 0-.374 0-.623.132v-7.31c.249 0 .374 0 .623.133v7.045z"
            fill="#0EA59D"
            />
            <path
            d="M389.348 157.806v-7.576h.124c.25 0 .375 0 .624.133h.125v7.311h-.125c-.249 0-.499 0-.748.132zm.124-7.443v7.178h.499v-7.045c-.124-.133-.374-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M394.214 156.477c-.25.133-.375.133-.624.266v-6.115h.624v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M393.59 156.876v-6.381h.748v5.982l-.748.399zm.125-6.248v5.982c.124 0 .374-.133.499-.266v-5.716h-.499z"
            fill="#131A2D"
            />
            <path
            d="M392.092 157.141c-.249 0-.374.133-.623.133v-6.779h.623v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M391.469 157.407v-6.912h.748v6.779c-.249 0-.499.133-.748.133zm.125-6.779v6.646c.124 0 .374-.133.498-.133v-6.513h-.498z"
            fill="#131A2D"
            />
            <path
            d="M391.094 157.407c-.249 0-.374.133-.623.133v-7.044c.249 0 .374.133.623.133v6.778z"
            fill="#0EA59D"
            />
            <path
            d="M390.346 157.673v-7.31h.124c.25 0 .375.133.624.133v7.045c-.249 0-.374 0-.748.132zm.249-7.177v6.912c.125 0 .374 0 .499-.133v-6.646c-.249 0-.374-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M387.726 145.577c5.739 0 9.856 2.526 9.856 4.785 0 2.26-3.992 4.785-9.856 4.785-5.738 0-9.855-2.525-9.855-4.785 0-2.259 3.992-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M387.726 155.147c-5.863 0-9.855-2.525-9.855-4.785 0-2.259 4.117-4.785 9.855-4.785 5.864 0 9.856 2.526 9.856 4.785 0 2.26-4.117 4.785-9.856 4.785zm0-9.437c-5.738 0-9.73 2.526-9.73 4.652 0 2.127 3.992 4.653 9.73 4.653 5.739 0 9.731-2.526 9.731-4.653 0-2.126-3.992-4.652-9.731-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M394.089 153.951c-.624.266-1.372.532-2.121.665l-8.109-8.64c.749-.133 1.622-.266 2.495-.399l7.735 8.374zM388.475 155.148H386.978l-6.986-7.443c.25-.266.624-.399.998-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M390.844 154.617c.125 0 .375-.133.499-.133.375-.133.624-.133.998-.266.375-.133.624-.266.998-.399.125 0 .375-.133.499-.133l.25-.132c.125 0 .125-.133.249-.133.375-.133.624-.266.998-.532.624-.399 1.248-.798 1.747-1.196a4.454 4.454 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.132-.374.132-.499.265-.125 0-.125.133-.25.133l-.249.133c-.125.133-.374.133-.499.266l-.499.133c-.125 0-.374.133-.499.133-.374.133-.749.133-1.123.266-.374 0-.748 0-1.123.133h-1.122c.374-.133.748-.133.998-.266l.623-.133zM385.98 154.749l1.373.133.748.133c.25 0 .499.133.749.133-.25.133-.499.133-.749.133h-2.245c-.499 0-.998-.133-1.497-.266-.499-.133-.998-.266-1.373-.531.499 0 .998 0 1.497.133.499 0 .998 0 1.497.132z"
            fill="#fff"
            />
            <path
            d="M398.33 146.908c1.247 0 2.495.133 3.493.266h6.237v2.526c-.125 2.259-4.117 4.652-9.855 4.652-5.614 0-9.606-2.393-9.855-4.652v-2.526h6.237c1.248-.266 2.495-.266 3.743-.266z"
            fill="#0EA59D"
            />
            <path
            d="M398.33 154.484c-5.614 0-9.606-2.393-9.855-4.652v-2.791h6.362c1.123-.266 2.245-.266 3.493-.266 1.247 0 2.37.133 3.493.266h6.362v2.658c-.249 2.392-4.241 4.785-9.855 4.785zm-9.731-4.785c.125 2.26 4.117 4.519 9.731 4.519s9.606-2.392 9.73-4.519v-2.526h-6.237c-1.123-.265-2.246-.265-3.493-.265-1.248 0-2.37.133-3.493.265h-6.238v2.526z"
            fill="#131A2D"
            />
            <path
            d="M407.061 151.693c-.125.133-.374.399-.623.532v-5.051h.623v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M406.312 152.358v-5.317h.749v4.652a3.993 3.993 0 01-.749.665zm.125-5.051v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M395.337 147.041v7.045c-.25 0-.375-.133-.624-.133v-6.779c.249 0 .499-.133.624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M395.461 154.219c-.249 0-.499-.133-.748-.133v-7.045h.125c.124 0 .374 0 .499-.133h.124v7.311zm-.623-.266c.124 0 .374 0 .499.133v-6.912c-.125 0-.375 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M396.46 154.218c-.25 0-.375 0-.624-.133v-7.178c.249 0 .374 0 .624-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M396.459 154.351c-.249 0-.499 0-.748-.133h-.125v-7.311h.125c.249 0 .374 0 .623-.133h.125v7.577zm-.624-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M391.219 152.755c-.249-.133-.374-.266-.623-.398v-5.184h.623v5.582z"
            fill="#0EA59D"
            />
            <path
            d="M391.219 152.888c-.374-.132-.499-.265-.748-.398v-5.317h.748v5.715zm-.624-.531c.125.133.375.133.499.266v-5.45h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M397.458 154.352h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M397.582 154.351h-.873v-7.577h.873v7.577zm-.624-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M390.096 152.092c-.249-.133-.499-.399-.623-.532v-4.386h.623v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M390.221 152.225a4.016 4.016 0 01-.748-.665v-4.519h.748v5.184zm-.624-.665c.125.133.25.266.499.399v-4.652h-.499v4.253z"
            fill="#131A2D"
            />
            <path
            d="M393.216 153.687c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M393.34 153.687c-.249-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.266c.124 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M394.339 153.953c-.25 0-.375-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M394.463 153.953c-.249-.133-.499-.133-.748-.133v-6.779h.748v6.912zm-.623-.266c.124 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M392.217 153.287c-.249-.133-.374-.133-.623-.266v-5.848h.623v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M392.342 153.42c-.374-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.623-.532c.124.133.249.133.498.266v-5.848h-.498v5.582z"
            fill="#131A2D"
            />
            <path
            d="M403.819 153.421c-.249.133-.374.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M403.195 153.82v-6.646h.749v6.513c-.25 0-.499 0-.749.133zm.125-6.513v6.38c.125 0 .374-.133.499-.133v-6.114h-.499v-.133z"
            fill="#131A2D"
            />
            <path d="M399.577 154.352h-.624v-7.444h.624v7.444z" fill="#0EA59D" />
            <path
            d="M398.953 154.485v-7.577h.873v7.577h-.124a.753.753 0 00-.749 0zm.125-7.577v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M398.581 146.908v7.444h-.624v-7.444h.624z" fill="#0EA59D" />
            <path
            d="M398.331 154.484h-.499v-7.71h.873v7.71h-.374zm-.374-.266h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M408.186 149.699c0 .532-.249 1.064-.624 1.463v-4.121h.624v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M407.438 151.427v-4.386h.873v2.658c0 .532-.25.931-.624 1.463l-.249.265zm.124-4.12v3.722c.375-.399.499-.931.499-1.33v-2.525h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M389.099 151.029c-.25-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M389.098 151.294l-.124-.132c-.25-.399-.499-.798-.499-1.33v-2.791h.623v4.253zm-.499-1.595c0 .399.125.798.375 1.064v-3.589h-.375v2.525z"
            fill="#131A2D"
            />
            <path
            d="M405.94 152.49c-.249.133-.374.266-.624.398v-5.715h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M405.316 153.021v-5.848h.749v5.45c-.25 0-.499.133-.749.398zm.125-5.715v5.45c.125-.133.374-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M400.7 154.219c-.25 0-.374 0-.624.133v-7.311c.25 0 .374 0 .624.133v7.045z"
            fill="#0EA59D"
            />
            <path
            d="M399.951 154.351v-7.577h.125c.249 0 .374 0 .624.133h.124v7.311h-.124c-.25.133-.375.133-.749.133zm.125-7.311v7.178h.499v-7.045c-.125-.133-.25-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M404.942 153.022c-.249.133-.374.133-.624.266v-6.114h.624v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M404.193 153.421v-6.38h.749v5.981c-.25.266-.374.266-.749.399zm.125-6.114v5.981c.125 0 .374-.133.499-.266v-5.715h-.499z"
            fill="#131A2D"
            />
            <path
            d="M402.821 153.819c-.249 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M402.072 154.085v-6.912h.749v6.779c-.25 0-.374 0-.749.133zm.125-6.779v6.646c.125 0 .374-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M401.698 154.086c-.25 0-.374.133-.624.133v-7.045c.25 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M401.074 154.219v-7.311h.125c.249 0 .374.133.624.133v7.045c-.25.133-.499.133-.749.133zm.125-7.045v6.912c.125 0 .374 0 .499-.133v-6.779h-.499z"
            fill="#131A2D"
            />
            <path
            d="M398.33 142.255c5.738 0 9.855 2.525 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785-5.739 0-9.855-2.525-9.855-4.785 0-2.26 4.116-4.785 9.855-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M398.33 151.825c-5.863 0-9.855-2.525-9.855-4.785 0-2.26 4.116-4.785 9.855-4.785 5.863 0 9.855 2.525 9.855 4.785 0 2.26-3.992 4.785-9.855 4.785zm0-9.57c-5.739 0-9.731 2.525-9.731 4.652 0 2.26 3.992 4.652 9.731 4.652 5.738 0 9.73-2.525 9.73-4.652 0-2.127-3.992-4.652-9.73-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M404.692 150.496c-.623.266-1.372.532-2.12.665l-8.109-8.64c.748-.133 1.622-.266 2.495-.399l7.734 8.374zM399.077 151.693H397.58l-6.986-7.444c.249-.265.624-.398.998-.531l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M401.448 151.294c.125 0 .374-.133.499-.133.374-.132.624-.132.998-.265s.624-.266.998-.399c.125 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.624-.266.998-.532.624-.398 1.247-.797 1.746-1.196a4.446 4.446 0 01-1.497 1.595c-.124.133-.249.266-.499.266-.124.133-.374.133-.499.266-.124 0-.124.133-.249.133l-.25.133c-.124.133-.374.133-.499.266l-.499.132c-.124 0-.374.133-.499.133-.374.133-.748.133-1.122.266-.375 0-.749 0-1.123.133h-1.123c.374-.133.749-.133.998-.266l.624-.133zM396.584 151.294l1.372.133.749.133c.249 0 .499.133.748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.499.133.998.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M407.935 144.647c1.248 0 2.495.133 3.493.266h6.238v2.526c-.125 2.259-4.117 4.652-9.856 4.652-5.738 0-9.605-2.393-9.855-4.652v-2.526h6.238c1.247-.133 2.495-.266 3.742-.266z"
            fill="#fff"
            />
            <path
            d="M407.935 152.224c-5.613 0-9.605-2.393-9.855-4.652v-2.792h6.362c1.123-.265 2.246-.265 3.493-.265 1.248 0 2.371.133 3.493.265h6.363v2.792c-.25 2.392-4.242 4.652-9.856 4.652zm-9.73-4.652c.125 2.259 4.117 4.519 9.73 4.519 5.614 0 9.606-2.392 9.731-4.519v-2.526h-6.238c-1.122-.266-2.245-.266-3.493-.266-1.247 0-2.37.133-3.493.266h-6.237v2.526z"
            fill="#000"
            />
            <path
            d="M416.544 149.565c-.125.133-.375.399-.624.532v-5.051h.624v4.519z"
            fill="#fff"
            />
            <path
            d="M415.92 150.23v-5.317h.748v4.652c-.124.133-.374.399-.623.532l-.125.133zm.125-5.184v4.785c.124-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#000"
            />
            <path
            d="M404.942 144.914v7.045c-.249 0-.374-.133-.624-.133v-6.779c.25-.133.499-.133.624-.133z"
            fill="#fff"
            />
            <path
            d="M405.067 152.092c-.375 0-.499-.133-.749-.133h-.125v-7.045h.125c.125 0 .25 0 .499-.133h.25v7.311zm-.624-.266c.125 0 .249 0 .499.133v-6.779c-.125 0-.25 0-.499.133v6.513z"
            fill="#000"
            />
            <path
            d="M406.065 152.091c-.249 0-.374 0-.624-.133v-7.177c.25 0 .375 0 .624-.133v7.443z"
            fill="#fff"
            />
            <path
            d="M406.065 152.224c-.25 0-.499 0-.749-.133h-.125v-7.311h.125c.25 0 .374 0 .624-.133h.125v7.577zm-.624-.266h.499v-7.178h-.499v7.178z"
            fill="#000"
            />
            <path
            d="M400.7 150.629c-.25-.133-.374-.266-.624-.399v-5.184h.624v5.583z"
            fill="#fff"
            />
            <path
            d="M400.825 150.762l-.125-.133c-.25-.133-.374-.266-.624-.399v-5.317h.749v5.849zm-.624-.532c.125.133.249.133.499.266v-5.317h-.499v5.051z"
            fill="#000"
            />
            <path d="M407.061 152.224h-.623v-7.444h.623v7.444z" fill="#fff" />
            <path
            d="M407.186 152.224h-.874v-7.577h.874v7.577zm-.624-.133h.499v-7.311h-.499v7.311z"
            fill="#000"
            />
            <path
            d="M399.702 149.964c-.25-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#fff"
            />
            <path
            d="M399.827 150.097l-.125-.133c-.25-.133-.499-.399-.624-.532v-4.519h.749v5.184zm-.624-.798c.125.133.249.266.499.399v-4.652h-.499v4.253z"
            fill="#000"
            />
            <path
            d="M402.819 151.426c-.249 0-.374-.133-.624-.266v-6.247h.624v6.513z"
            fill="#fff"
            />
            <path
            d="M402.944 151.559c-.374-.133-.499-.133-.749-.266v-6.38h.749v6.646zm-.624-.399c.125 0 .25.133.499.133v-6.247h-.499v6.114z"
            fill="#000"
            />
            <path
            d="M403.944 151.825c-.249 0-.374-.133-.624-.133v-6.646h.624v6.779z"
            fill="#fff"
            />
            <path
            d="M403.944 151.825c-.375-.133-.499-.133-.749-.133h-.125v-6.779h.749v6.912h.125zm-.624-.266c.125 0 .249.133.499.133v-6.513h-.499v6.38z"
            fill="#000"
            />
            <path
            d="M401.823 151.16c-.25-.133-.374-.133-.624-.266v-5.848h.624v6.114z"
            fill="#fff"
            />
            <path
            d="M401.948 151.293c-.375-.133-.499-.266-.749-.266v-5.981h.749v6.247zm-.624-.532c.125.133.249.133.499.133v-5.848h-.499v5.715z"
            fill="#000"
            />
            <path
            d="M413.425 151.293c-.25.133-.375.133-.624.133v-6.513h.624v6.38z"
            fill="#fff"
            />
            <path
            d="M412.676 151.692v-6.779h.748v6.513c-.124 0-.374.133-.748.266zm.249-6.646v6.247c.125 0 .25-.133.499-.133v-6.114h-.499z"
            fill="#000"
            />
            <path d="M409.182 152.091h-.623v-7.444h.623v7.444z" fill="#fff" />
            <path
            d="M408.434 152.224v-7.709h.873v7.576h-.125c-.125.133-.374.133-.748.133zm.249-7.444v7.311h.499v-7.311h-.499z"
            fill="#000"
            />
            <path d="M408.184 144.647v7.444h-.623v-7.444h.623z" fill="#fff" />
            <path
            d="M407.935 152.224h-.499v-7.709h.873v7.709h-.374zm-.375-.133h.375v-7.311h-.375v7.311z"
            fill="#000"
            />
            <path
            d="M417.667 147.572c0 .531-.25 1.063-.624 1.462v-4.121h.624v2.659z"
            fill="#fff"
            />
            <path
            d="M416.918 149.299v-4.386h.873v2.791c0 .532-.249.931-.748 1.463l-.125.132zm.249-4.253v3.722c.25-.399.499-.798.499-1.196v-2.526h-.499z"
            fill="#000"
            />
            <path
            d="M398.579 148.903c-.249-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#fff"
            />
            <path
            d="M398.704 149.168l-.125-.266c-.249-.399-.499-.798-.499-1.329v-2.792h.749v4.387h-.125zm-.499-1.595c0 .398.125.664.374 1.063v-3.456h-.374v2.393z"
            fill="#000"
            />
            <path
            d="M415.546 150.363c-.25.133-.375.266-.624.398v-5.715h.624v5.317z"
            fill="#fff"
            />
            <path
            d="M414.797 150.895v-5.982h.748v5.45c-.124.133-.374.266-.748.532zm.249-5.849v5.45c.125-.133.25-.133.499-.266v-5.184h-.499z"
            fill="#000"
            />
            <path
            d="M410.305 152.091h-.623v-7.311c.249 0 .374 0 .623.133v7.178z"
            fill="#fff"
            />
            <path
            d="M409.557 152.224v-7.577h.124c.25 0 .375 0 .624.133h.125v7.444h-.873zm.124-7.311v7.045h.499v-7.045h-.499z"
            fill="#000"
            />
            <path
            d="M414.423 150.895c-.25.133-.375.133-.624.265v-6.114h.624v5.849z"
            fill="#fff"
            />
            <path
            d="M413.799 151.293v-6.38h.748v5.982l-.748.398zm.125-6.247v5.981c.124 0 .249-.132.499-.132v-5.716h-.499v-.133z"
            fill="#000"
            />
            <path
            d="M412.426 151.692c-.249 0-.374.133-.623.133v-6.779h.623v6.646z"
            fill="#fff"
            />
            <path
            d="M411.678 151.958v-7.045h.748v6.779h-.125c-.124.133-.374.133-.623.266zm.124-6.912v6.513c.125 0 .25-.133.499-.133v-6.513h-.499v.133z"
            fill="#000"
            />
            <path
            d="M411.303 151.826c-.249 0-.374.133-.623.133v-7.045c.249 0 .374.133.623.133v6.779z"
            fill="#fff"
            />
            <path
            d="M410.555 152.092v-7.311h.124c.25 0 .375.133.624.133h.125v7.045h-.125c-.125 0-.374.133-.748.133zm.249-7.045v6.912c.125 0 .25 0 .499-.133v-6.779h-.499z"
            fill="#000"
            />
            <path
            d="M407.935 140.128c5.739 0 9.856 2.525 9.856 4.785 0 2.26-3.992 4.785-9.856 4.785-5.738 0-9.855-2.525-9.855-4.785 0-2.392 3.992-4.785 9.855-4.785z"
            fill="#fff"
            />
            <path
            d="M407.935 149.698c-5.863 0-9.855-2.525-9.855-4.785 0-2.26 4.117-4.785 9.855-4.785 5.864 0 9.856 2.525 9.856 4.785 0 2.127-3.992 4.785-9.856 4.785zm0-9.57c-5.738 0-9.73 2.393-9.73 4.652 0 2.26 3.992 4.652 9.73 4.652 5.739 0 9.731-2.392 9.731-4.652 0-2.127-3.992-4.652-9.731-4.652z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M414.298 148.369c-.624.266-1.372.532-2.121.665l-8.109-8.64a108.54 108.54 0 012.495-.399l7.735 8.374zM408.684 149.566H407.187l-6.986-7.443c.374-.266.624-.399.998-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M411.055 149.167c.125 0 .375-.132.499-.132.375-.133.624-.133.998-.266.375-.133.624-.266.998-.399.125 0 .375-.133.499-.133l.25-.133c.125 0 .125-.133.249-.133.375-.133.624-.266.998-.532.624-.398 1.248-.797 1.747-1.196a4.446 4.446 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.133-.374.133-.499.266-.125 0-.125.133-.25.133l-.249.133c-.125.133-.374.133-.499.266l-.499.133c-.125 0-.374.132-.499.132-.374.133-.749.133-1.123.266-.374 0-.748 0-1.123.133h-1.122c.374-.133.748-.133.998-.266l.623-.133zM406.189 149.167l1.373.133.748.133c.25 0 .499.133.749.133-.25.133-.499.133-.749.133h-2.245c-.499 0-.998-.133-1.497-.266a5.847 5.847 0 01-1.373-.532c.499 0 .998 0 1.497.133.499 0 .998.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M411.179 139.729c1.248 0 2.495.133 3.493.266h6.238v2.658c-.125 2.26-4.117 4.652-9.856 4.652-5.738 0-9.605-2.392-9.855-4.652v-2.525h6.238a17.041 17.041 0 013.742-.399z"
            fill="#0EA59D"
            />
            <path
            d="M411.179 147.305c-5.613 0-9.605-2.392-9.855-4.652v-2.791h6.362c1.123-.266 2.246-.266 3.493-.266 1.248 0 2.371.133 3.493.266h6.363v2.658c-.25 2.393-4.242 4.785-9.856 4.785zm-9.855-4.652c.125 2.26 4.117 4.519 9.731 4.519 5.613 0 9.605-2.392 9.73-4.519v-2.526h-6.237c-1.123-.265-2.246-.265-3.493-.265-1.248 0-2.371.132-3.493.265h-6.238v2.526z"
            fill="#131A2D"
            />
            <path
            d="M419.788 144.647c-.125.133-.374.399-.624.532v-5.051h.624v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M419.164 145.312v-5.317h.749v4.652c-.25.133-.499.399-.749.665zm.125-5.184v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M408.186 139.995v7.045c-.249 0-.374-.133-.624-.133v-6.779c.25-.133.375-.133.624-.133z"
            fill="#0EA59D"
            />
            <path
            d="M408.311 147.173c-.249 0-.499-.133-.749-.133v-7.045h.125c.125 0 .374 0 .499-.133h.125v7.311zm-.624-.266c.125 0 .374 0 .499.133v-6.912c-.125 0-.374 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M409.184 147.173c-.249 0-.374 0-.623-.133v-7.178c.249 0 .374 0 .623-.133v7.444z"
            fill="#0EA59D"
            />
            <path
            d="M409.309 147.306c-.25 0-.499 0-.749-.133h-.124v-7.31h.124c.25 0 .375 0 .624-.133h.125v7.576zm-.624-.266h.499v-7.177h-.499v7.177z"
            fill="#131A2D"
            />
            <path
            d="M403.944 145.711c-.249-.133-.374-.266-.624-.399v-5.184h.624v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M404.069 145.844c-.374-.133-.499-.266-.749-.399v-5.317h.749v5.716zm-.624-.532c.125.133.374.133.499.266v-5.45h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M410.307 147.173h-.623v-7.444h.623v7.444z" fill="#0EA59D" />
            <path
            d="M410.307 147.306h-.873v-7.577h.873v7.577zm-.624-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M402.946 145.046c-.249-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M402.946 145.179c-.374-.266-.624-.399-.749-.665v-4.519h.749v5.184zm-.624-.797c.125.132.25.265.499.398v-4.652h-.499v4.254z"
            fill="#131A2D"
            />
            <path
            d="M406.065 146.508c-.249 0-.374-.133-.624-.266v-6.247h.624v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M406.19 146.641c-.25-.133-.499-.133-.749-.266v-6.38h.749v6.646zm-.624-.399c.125 0 .374.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M407.063 146.774c-.249 0-.374-.133-.624-.133v-6.646h.624v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M407.188 146.907c-.25-.133-.499-.133-.749-.133v-6.779h.749v6.912zm-.624-.266c.125 0 .374.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M405.067 146.109c-.249-.132-.374-.132-.624-.265v-5.849h.624v6.114z"
            fill="#0EA59D"
            />
            <path
            d="M405.067 146.242c-.374-.133-.499-.265-.749-.265v-5.982h.749v6.247zm-.624-.398c.125.133.25.133.499.265v-5.848h-.499v5.583z"
            fill="#131A2D"
            />
            <path
            d="M416.669 146.375c-.25.133-.375.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M415.92 146.641v-6.646h.748v6.513c-.249 0-.374.133-.748.133zm.125-6.513v6.38c.124 0 .374-.133.499-.133v-6.114h-.499v-.133z"
            fill="#131A2D"
            />
            <path d="M412.426 147.173h-.623v-7.444h.623v7.444z" fill="#0EA59D" />
            <path
            d="M411.678 147.306v-7.577h.873v7.577h-.873zm.124-7.444v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M411.303 139.73v7.443h-.623v-7.443h.623z" fill="#0EA59D" />
            <path
            d="M411.179 147.306h-.499v-7.709h.748v7.709h-.249zm-.375-.133h.499v-7.31h-.499v7.31z"
            fill="#131A2D"
            />
            <path
            d="M420.911 142.653c0 .532-.25 1.064-.624 1.462v-4.12h.624v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M420.162 144.382v-4.387h.873v2.659c0 .531-.249.93-.623 1.462l-.25.266zm.125-4.254v3.855c.374-.399.499-.931.499-1.329v-2.526h-.499z"
            fill="#131A2D"
            />
            <path
            d="M401.823 143.984c-.249-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M401.948 144.116l-.125-.133c-.249-.399-.499-.798-.499-1.329v-2.792h.624v4.254zm-.624-1.462c0 .398.125.797.374 1.063v-3.589h-.374v2.526z"
            fill="#131A2D"
            />
            <path
            d="M418.79 145.445c-.25.133-.374.266-.624.399v-5.716h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M418.041 145.844v-5.849h.749v5.45c-.25.133-.375.266-.749.399zm.125-5.716v5.45c.125-.133.374-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M413.425 147.173c-.25 0-.375 0-.624.133v-7.311c.249 0 .374 0 .624.133v7.045z"
            fill="#0EA59D"
            />
            <path
            d="M412.801 147.306v-7.577h.125c.249 0 .374 0 .623.133h.125v7.311h-.125c-.249 0-.499 0-.748.133zm.125-7.444v7.178h.499v-7.045c-.25 0-.375-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M417.667 145.976c-.25.133-.375.133-.624.266v-6.114h.624v5.848z"
            fill="#0EA59D"
            />
            <path
            d="M417.043 146.375v-6.38h.748v5.982l-.748.398zm.125-6.247v5.981c.124 0 .374-.132.499-.265v-5.716h-.499z"
            fill="#131A2D"
            />
            <path
            d="M415.546 146.641c-.25 0-.375.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M414.922 146.907v-6.912h.748v6.779c-.249 0-.499.133-.748.133zm.125-6.779v6.646c.124 0 .249-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M414.548 146.907c-.25 0-.375.133-.624.133v-7.045c.249 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M413.799 147.173v-7.311h.125c.249 0 .374.133.623.133v7.045c-.249 0-.374 0-.748.133zm.125-7.178v6.912c.124 0 .374 0 .499-.133v-6.779c-.125.133-.25.133-.499 0z"
            fill="#131A2D"
            />
            <path
            d="M411.179 135.077c5.739 0 9.856 2.526 9.856 4.786 0 2.259-3.992 4.785-9.856 4.785-5.738 0-9.855-2.526-9.855-4.785 0-2.26 3.992-4.786 9.855-4.786z"
            fill="#0EA59D"
            />
            <path
            d="M411.179 144.648c-5.863 0-9.855-2.526-9.855-4.785 0-2.26 4.117-4.786 9.855-4.786 5.739 0 9.856 2.526 9.856 4.786 0 2.259-4.117 4.785-9.856 4.785zm0-9.438c-5.738 0-9.73 2.526-9.73 4.653 0 2.126 3.992 4.652 9.73 4.652 5.739 0 9.731-2.526 9.731-4.652 0-2.127-4.117-4.653-9.731-4.653z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M417.542 143.451c-.624.266-1.372.532-2.121.665l-8.109-8.64c.749-.133 1.622-.266 2.496-.399l7.734 8.374zM411.928 144.647H410.431l-6.986-7.443c.375-.266.624-.399.998-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M414.298 144.249c.124 0 .374-.132.499-.132.374-.133.623-.133.998-.266.374-.133.623-.266.998-.399.124 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.623-.266.998-.532.623-.398 1.247-.797 1.746-1.196a4.446 4.446 0 01-1.497 1.595c-.125.133-.249.266-.499.266-.125.133-.374.133-.499.266-.125 0-.125.133-.249.133l-.25.133c-.125.133-.374.133-.499.266l-.499.133c-.125 0-.374.132-.499.132-.374.133-.748.133-1.123.266-.374 0-.748 0-1.122.133h-1.123c.374-.133.748-.133.998-.266l.624-.133zM409.308 144.249l1.373.133.748.133c.25 0 .499.133.749.133-.25.133-.499.133-.749.133h-2.245c-.499 0-.998-.133-1.497-.266-.499-.133-.998-.266-1.373-.532.499 0 .998 0 1.497.133.624 0 1.123.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M415.296 135.477c1.248 0 2.495.132 3.493.265h6.238v2.526c-.125 2.26-4.117 4.652-9.855 4.652-5.739 0-9.606-2.392-9.856-4.652v-2.526h6.238c1.372-.133 2.495-.265 3.742-.265z"
            fill="#0EA59D"
            />
            <path
            d="M415.297 143.052c-5.614 0-9.606-2.392-9.856-4.652v-2.791h6.363c1.122-.266 2.245-.266 3.493-.266 1.247 0 2.37.133 3.493.266h6.362v2.658c-.25 2.393-4.117 4.785-9.855 4.785zm-9.731-4.652c.125 2.26 4.117 4.519 9.731 4.519 5.613 0 9.605-2.392 9.73-4.519v-2.525h-6.237c-1.123-.266-2.246-.266-3.493-.266-1.248 0-2.371.133-3.493.266h-6.238v2.525z"
            fill="#131A2D"
            />
            <path
            d="M424.03 140.394c-.125.133-.374.399-.624.532v-5.051h.624v4.519z"
            fill="#0EA59D"
            />
            <path
            d="M423.281 141.059v-5.317h.749v4.652c-.125.133-.375.399-.749.665zm.25-5.184v4.785c.125-.133.374-.266.499-.399v-4.386h-.499z"
            fill="#131A2D"
            />
            <path
            d="M412.428 135.742v7.045c-.249 0-.374-.133-.623-.133v-6.779c.249-.133.374-.133.623-.133z"
            fill="#0EA59D"
            />
            <path
            d="M412.428 142.92c-.249 0-.499-.133-.748-.133v-7.045h.124c.125 0 .375 0 .499-.133h.125v7.311zm-.624-.266c.125 0 .375 0 .499.133v-6.912c-.124 0-.374 0-.499.133v6.646z"
            fill="#131A2D"
            />
            <path
            d="M413.426 142.92c-.249 0-.374 0-.623-.133v-7.178c.249 0 .374 0 .623-.132v7.443z"
            fill="#0EA59D"
            />
            <path
            d="M413.551 143.053c-.25 0-.499 0-.749-.133h-.124v-7.311h.124c.25 0 .375 0 .624-.132h.125v7.576zm-.624-.266h.499v-7.178h-.499v7.178z"
            fill="#131A2D"
            />
            <path
            d="M408.186 141.458c-.249-.133-.374-.266-.624-.399v-5.184h.624v5.583z"
            fill="#0EA59D"
            />
            <path
            d="M408.186 141.591c-.374-.133-.499-.266-.748-.399v-5.317h.748v5.716zm-.624-.532c.125.133.374.133.499.266v-5.45h-.499v5.184z"
            fill="#131A2D"
            />
            <path d="M414.55 142.92h-.624v-7.443h.624v7.443z" fill="#0EA59D" />
            <path
            d="M414.549 143.053h-.873v-7.576h.873v7.576zm-.624-.133h.499v-7.311h-.499v7.311z"
            fill="#131A2D"
            />
            <path
            d="M407.063 140.793c-.249-.133-.499-.399-.624-.532v-4.386h.624v4.918z"
            fill="#0EA59D"
            />
            <path
            d="M407.188 140.926c-.374-.266-.624-.399-.749-.665v-4.519h.749v5.184zm-.624-.797c.125.132.25.265.499.398v-4.652h-.499v4.254z"
            fill="#131A2D"
            />
            <path
            d="M410.307 142.255c-.249 0-.374-.133-.623-.266v-6.247h.623v6.513z"
            fill="#0EA59D"
            />
            <path
            d="M410.307 142.388c-.374-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.624-.399c.125 0 .375.133.499.133v-6.247h-.499v6.114z"
            fill="#131A2D"
            />
            <path
            d="M411.305 142.521c-.249 0-.374-.133-.623-.133v-6.646h.623v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M411.43 142.654c-.249-.133-.499-.133-.748-.133v-6.779h.748v6.912zm-.624-.266c.125 0 .375.133.499.133v-6.513h-.499v6.38z"
            fill="#131A2D"
            />
            <path
            d="M409.184 141.857c-.249-.133-.374-.133-.623-.266v-5.849h.623v6.115z"
            fill="#0EA59D"
            />
            <path
            d="M409.309 141.989c-.374-.132-.499-.265-.748-.265v-5.982h.748v6.247zm-.624-.398c.125.133.25.133.499.266v-5.849h-.499v5.583z"
            fill="#131A2D"
            />
            <path
            d="M420.911 142.122c-.25.133-.374.133-.624.133v-6.513h.624v6.38z"
            fill="#0EA59D"
            />
            <path
            d="M420.162 142.388v-6.646h.749v6.513c-.25 0-.375.133-.749.133zm.125-6.513v6.38c.125 0 .374-.133.499-.133v-6.114h-.499v-.133z"
            fill="#131A2D"
            />
            <path d="M416.669 142.92h-.624v-7.443h.624v7.443z" fill="#0EA59D" />
            <path
            d="M415.92 143.053v-7.576h.873v7.576h-.873zm.125-7.444v7.311h.499v-7.311h-.499z"
            fill="#131A2D"
            />
            <path d="M415.546 135.477v7.443h-.624v-7.443h.624z" fill="#0EA59D" />
            <path
            d="M415.296 143.052h-.499v-7.709h.748v7.709h-.249zm-.25-.133h.499v-7.31h-.374-.125v7.31z"
            fill="#131A2D"
            />
            <path
            d="M425.153 138.4c0 .532-.249 1.064-.624 1.462v-4.12h.624v2.658z"
            fill="#0EA59D"
            />
            <path
            d="M424.404 140.129v-4.387h.874v2.659c0 .531-.25.93-.749 1.462l-.125.266zm.125-4.254v3.722c.374-.399.499-.931.499-1.329v-2.526h-.499v.133z"
            fill="#131A2D"
            />
            <path
            d="M406.065 139.731c-.249-.399-.499-.931-.499-1.33v-2.525h.499v3.855z"
            fill="#0EA59D"
            />
            <path
            d="M406.19 139.863l-.125-.133c-.249-.399-.499-.798-.499-1.329v-2.792h.624v4.254zm-.624-1.462c0 .398.125.797.375 1.063v-3.589h-.375v2.526z"
            fill="#131A2D"
            />
            <path
            d="M422.907 141.192c-.25.133-.374.266-.624.399v-5.716h.624v5.317z"
            fill="#0EA59D"
            />
            <path
            d="M422.283 141.591v-5.849h.749v5.45l-.749.399zm.125-5.716v5.45c.125-.133.374-.133.499-.266v-5.184h-.499z"
            fill="#131A2D"
            />
            <path
            d="M417.667 142.92h-.624v-7.311c.249 0 .374 0 .624.133v7.178z"
            fill="#0EA59D"
            />
            <path
            d="M417.043 143.053v-7.576h.125c.249 0 .374 0 .623.132h.125v7.311h-.125c-.249 0-.499 0-.748.133zm.125-7.444v7.178h.499v-7.045c-.25 0-.375-.133-.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M421.909 141.724c-.25.132-.374.132-.624.265v-6.114h.624v5.849z"
            fill="#0EA59D"
            />
            <path
            d="M421.16 142.122v-6.38h.749v5.982c-.125.133-.375.265-.749.398zm.25-6.247v5.982c.124-.133.374-.133.499-.266v-5.716h-.499z"
            fill="#131A2D"
            />
            <path
            d="M419.788 142.388c-.25 0-.374.133-.624.133v-6.779h.624v6.646z"
            fill="#0EA59D"
            />
            <path
            d="M419.164 142.654v-6.912h.749v6.779c-.375 0-.499.133-.749.133zm.125-6.779v6.646c.125 0 .249-.133.499-.133v-6.513h-.499z"
            fill="#131A2D"
            />
            <path
            d="M418.79 142.654c-.25 0-.374.133-.624.133v-7.045c.25 0 .374.133.624.133v6.779z"
            fill="#0EA59D"
            />
            <path
            d="M418.041 142.92v-7.311h.125c.249 0 .374.133.624.133v7.045c-.25 0-.499 0-.749.133zm.125-7.178v6.912c.125 0 .374 0 .499-.133v-6.779a.362.362 0 01-.499 0z"
            fill="#131A2D"
            />
            <path
            d="M415.297 130.823c5.738 0 9.855 2.526 9.855 4.785 0 2.26-3.992 4.786-9.855 4.786-5.864 0-9.856-2.526-9.856-4.786.125-2.259 4.117-4.785 9.856-4.785z"
            fill="#0EA59D"
            />
            <path
            d="M415.297 140.394c-5.864 0-9.856-2.526-9.856-4.786 0-2.259 4.117-4.785 9.856-4.785 5.738 0 9.855 2.526 9.855 4.785 0 2.26-3.992 4.786-9.855 4.786zm0-9.438c-5.739 0-9.731 2.526-9.731 4.652 0 2.26 3.992 4.653 9.731 4.653 5.738 0 9.73-2.526 9.73-4.653 0-2.259-3.992-4.652-9.73-4.652z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M421.784 139.197c-.624.266-1.372.532-2.121.665l-8.108-8.64c.748-.133 1.621-.266 2.495-.399l7.734 8.374zM416.17 140.393h-1.496l-6.986-7.443c.249-.266.623-.399.997-.532l7.485 7.975z"
            fill="#fff"
            />
            <path
            opacity={0.3}
            d="M418.415 139.995c.124 0 .374-.133.499-.133.374-.133.623-.133.998-.266.374-.133.623-.266.998-.399.124 0 .374-.133.499-.133l.249-.133c.125 0 .125-.133.25-.133.374-.133.623-.266.998-.531.623-.399 1.247-.798 1.746-1.197a4.438 4.438 0 01-1.497 1.595c-.125.133-.249.266-.499.266-.125.133-.374.133-.499.266-.125 0-.125.133-.249.133l-.25.133c-.125.133-.374.133-.499.266l-.499.133c-.125 0-.374.133-.499.133-.374.132-.748.132-1.123.265-.374 0-.748 0-1.122.133h-1.123c.374-.133.748-.133.998-.266l.624-.132zM413.551 139.995l1.372.133.748.133c.25 0 .499.133.749.133-.25.133-.499.133-.749.133h-2.245c-.499 0-.998-.133-1.497-.266a5.84 5.84 0 01-1.372-.532c.499 0 .998 0 1.497.133.623 0 1.122.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M400.326 131.754c1.247 0 2.495.133 3.493.266h6.237v2.658c-.125 2.26-4.117 4.652-9.855 4.652-5.614 0-9.606-2.392-9.855-4.652v-2.525h6.237c1.372-.266 2.495-.399 3.743-.399z"
            fill="#fff"
            />
            <path
            d="M400.326 139.33c-5.614 0-9.606-2.392-9.855-4.652v-2.791h6.362c1.123-.266 2.245-.266 3.493-.266 1.247 0 2.37.133 3.493.266h6.362v2.791c-.249 2.26-4.117 4.652-9.855 4.652zm-9.731-4.785c.125 2.26 4.117 4.52 9.731 4.52s9.606-2.393 9.73-4.52v-2.525h-6.237c-1.123-.266-2.246-.266-3.493-.266-1.248 0-2.37.133-3.493.266h-6.238v2.525z"
            fill="#000"
            />
            <path
            d="M409.059 136.672c-.124.133-.374.398-.623.531v-5.051h.623v4.52z"
            fill="#fff"
            />
            <path
            d="M408.311 137.336v-5.316h.748v4.652c-.249.133-.374.399-.624.531l-.124.133zm.249-5.184v4.786c.125-.133.25-.266.499-.399v-4.387h-.499z"
            fill="#000"
            />
            <path
            d="M397.458 132.021v7.044c-.25 0-.375-.133-.624-.133v-6.779c.249-.132.374-.132.624-.132z"
            fill="#fff"
            />
            <path
            d="M397.457 139.198c-.374 0-.499-.133-.748-.133h-.125v-7.044h.125c.124 0 .374 0 .499-.133h.124v7.31h.125zm-.624-.398c.125 0 .25 0 .499.132v-6.778c-.124 0-.249 0-.499.132v6.514z"
            fill="#000"
            />
            <path
            d="M398.456 139.197c-.25 0-.374 0-.624-.132v-7.178c.25 0 .374 0 .624-.133v7.443z"
            fill="#fff"
            />
            <path
            d="M398.58 139.33c-.249 0-.499 0-.748-.133h-.125v-7.31h.125c.249 0 .374 0 .624-.133h.124v7.576zm-.623-.265h.499v-7.045h-.499v7.045z"
            fill="#000"
            />
            <path
            d="M393.216 137.735c-.25-.133-.375-.266-.624-.399v-5.184h.624v5.583z"
            fill="#fff"
            />
            <path
            d="M393.34 137.868l-.124-.133c-.25-.133-.375-.266-.624-.399v-5.317h.748v5.849zm-.623-.665c.124.133.249.133.499.266v-5.317h-.499v5.051z"
            fill="#000"
            />
            <path d="M399.579 139.197h-.624v-7.443h.624v7.443z" fill="#fff" />
            <path
            d="M399.578 139.33h-.873v-7.576h.873v7.576zm-.623-.265h.499v-7.311h-.499v7.311z"
            fill="#000"
            />
            <path
            d="M392.092 137.07c-.249-.133-.499-.398-.623-.531v-4.387h.623v4.918z"
            fill="#fff"
            />
            <path
            d="M392.217 137.203l-.125-.132c-.249-.133-.499-.399-.623-.532v-4.519h.748v5.183zm-.623-.797c.124.133.249.266.498.399v-4.653h-.498v4.254z"
            fill="#000"
            />
            <path
            d="M395.337 138.533c-.25 0-.375-.133-.624-.266v-6.247h.624v6.513z"
            fill="#fff"
            />
            <path
            d="M395.461 138.666c-.374-.133-.499-.133-.748-.266v-6.38h.748v6.646zm-.623-.399c.124 0 .249.133.499.133v-6.248h-.499v6.115z"
            fill="#000"
            />
            <path
            d="M396.335 138.798c-.25 0-.375-.132-.624-.132v-6.646h.624v6.778z"
            fill="#fff"
            />
            <path
            d="M396.459 138.931c-.374-.133-.499-.133-.748-.133h-.125v-6.778h.748v6.911h.125zm-.624-.265c.125 0 .25.132.499.132v-6.513h-.499v6.381z"
            fill="#000"
            />
            <path
            d="M394.214 138.134c-.25-.133-.375-.133-.624-.266v-5.848h.624v6.114z"
            fill="#fff"
            />
            <path
            d="M394.338 138.267c-.374-.133-.499-.266-.748-.266v-5.981h.748v6.247zm-.623-.399c.124.133.249.133.499.133v-5.849h-.499v5.716z"
            fill="#000"
            />
            <path
            d="M405.94 138.399c-.249.133-.374.133-.624.133v-6.513h.624v6.38z"
            fill="#fff"
            />
            <path
            d="M405.191 138.665v-6.646h.749v6.513c-.25 0-.374.133-.749.133zm.125-6.513v6.247c.125 0 .374-.132.499-.132v-6.115h-.499z"
            fill="#000"
            />
            <path d="M401.698 139.198h-.624v-7.444h.624v7.444z" fill="#fff" />
            <path
            d="M400.949 139.33v-7.709h.873v7.577h-.124c-.25.133-.499.132-.749.132zm.125-7.443v7.311h.499v-7.178c-.125-.133-.25-.133-.499-.133z"
            fill="#000"
            />
            <path d="M400.575 131.754v7.444h-.624v-7.444h.624z" fill="#fff" />
            <path
            d="M400.325 139.33h-.499v-7.709h.873v7.709h-.374zm-.249-.132h.374v-7.311h-.374v7.311z"
            fill="#000"
            />
            <path
            d="M410.182 134.678c0 .532-.249 1.063-.623 1.462v-4.12h.623v2.658z"
            fill="#fff"
            />
            <path
            d="M409.434 136.406v-4.386h.873v2.791c0 .532-.25.93-.749 1.462l-.124.133zm.124-4.254v3.722c.25-.399.499-.797.499-1.196v-2.526h-.499z"
            fill="#000"
            />
            <path
            d="M391.095 136.008c-.25-.399-.499-.93-.499-1.329v-2.526h.499v3.855z"
            fill="#fff"
            />
            <path
            d="M391.219 136.274l-.124-.266c-.25-.399-.499-.797-.499-1.329v-2.791h.748v4.386h-.125zm-.623-1.728c0 .399.124.665.374 1.063v-3.455h-.374v2.392z"
            fill="#000"
            />
            <path
            d="M408.061 137.469c-.249.133-.374.266-.623.399v-5.716h.623v5.317z"
            fill="#fff"
            />
            <path
            d="M407.312 137.868v-5.848h.749v5.449c-.25.133-.374.266-.749.399zm.125-5.716v5.45c.125-.133.25-.133.499-.266v-5.184h-.499z"
            fill="#000"
            />
            <path
            d="M402.696 139.064c-.249 0-.374 0-.624.133v-7.31c.25 0 .375 0 .624.133v7.044z"
            fill="#fff"
            />
            <path
            d="M401.947 139.33v-7.576h.125c.25 0 .374 0 .624.133h.125v7.443h-.125c-.125-.133-.374 0-.749 0zm.25-7.443v7.178h.499v-7.045c-.25 0-.374 0-.499-.133z"
            fill="#000"
            />
            <path
            d="M406.938 138.001c-.249.133-.374.133-.624.266v-6.115h.624v5.849z"
            fill="#fff"
            />
            <path
            d="M406.189 138.4v-6.38h.749v5.981c-.125.133-.374.266-.749.399zm.25-6.248v5.982c.125 0 .249-.133.499-.133v-5.716h-.499v-.133z"
            fill="#000"
            />
            <path
            d="M404.817 138.666c-.249 0-.374.132-.624.132v-6.778h.624v6.646z"
            fill="#fff"
            />
            <path
            d="M404.068 138.931v-6.911h.749v6.778h-.125c0 .133-.249.133-.624.133zm.25-6.779v6.514c.125 0 .249-.133.499-.133v-6.513h-.499v.132z"
            fill="#000"
            />
            <path
            d="M403.819 138.932c-.249 0-.374.133-.624.133v-7.044c.25 0 .375.132.624.132v6.779z"
            fill="#fff"
            />
            <path
            d="M403.07 139.198v-7.31h.125c.25 0 .374.133.624.133h.125v7.044h-.125c-.25 0-.499 0-.749.133zm.125-7.177v6.911c.125 0 .25 0 .499-.132v-6.779c-.125.133-.249.133-.499 0z"
            fill="#000"
            />
            <path
            d="M400.326 127.102c5.738 0 9.855 2.525 9.855 4.785 0 2.259-3.992 4.785-9.855 4.785-5.739 0-9.855-2.526-9.855-4.785.124-2.26 4.116-4.785 9.855-4.785z"
            fill="#fff"
            />
            <path
            d="M400.326 136.672c-5.863 0-9.855-2.526-9.855-4.785 0-2.26 4.116-4.785 9.855-4.785 5.863 0 9.855 2.525 9.855 4.785 0 2.259-3.992 4.785-9.855 4.785zm0-9.438c-5.739 0-9.731 2.393-9.731 4.653 0 2.259 3.992 4.652 9.731 4.652 5.738 0 9.73-2.393 9.73-4.652 0-2.26-3.992-4.653-9.73-4.653z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M406.813 135.476c-.623.265-1.372.531-2.12.664l-8.109-8.64c.748-.133 1.622-.266 2.495-.398l7.734 8.374zM401.198 136.673H399.701l-6.986-7.444c.249-.266.624-.399.998-.532l7.485 7.976z"
            fill="#9CD6CB"
            />
            <path
            opacity={0.3}
            d="M403.444 136.273c.125 0 .374-.133.499-.133.374-.133.624-.133.998-.266s.624-.266.998-.399c.125 0 .374-.133.499-.133l.25-.132c.124 0 .124-.133.249-.133.374-.133.624-.266.998-.532.624-.399 1.248-.798 1.747-1.196a4.472 4.472 0 01-1.497 1.595c-.125.133-.25.266-.499.266-.125.132-.375.132-.499.265-.125 0-.125.133-.25.133l-.249.133c-.125.133-.375.133-.499.266l-.499.133c-.125 0-.375.133-.499.133-.375.133-.749.133-1.123.266-.374 0-.749 0-1.123.133h-1.123c.375-.133.749-.133.998-.266l.624-.133zM398.58 136.274l1.372.133.749.132c.249 0 .499 0 .748.133-.249.133-.499.133-.748.133h-2.246c-.499 0-.998-.133-1.497-.266-.499-.132-.998-.265-1.372-.531.499 0 .998 0 1.497.133.624 0 1.123.133 1.497.133z"
            fill="#fff"
            />
            <path
            d="M322.232 144.781v.93c0 .266 0 .665-.125.93 0 .266-.124.532-.124.798-.125.399-.25.797-.375 1.329-.124.399-.249.665-.374.931-.499.93-1.123 1.728-1.996 2.259l-.249.133-.375.266-.124.133-2.495 1.462-1.123-.399-.374-.133.873-.797h-.25l-1.122-.399c-.25-.133-.499-.266-.749-.266-.125-.133-.374-.133-.499-.266-.374-.265-.748-.398-1.123-.664-4.491-3.323-7.485-9.172-7.984-14.887 0-.532-.124-1.197-.124-1.728v-1.064c0-.265 0-.531.124-.797 0-.399.125-.798.25-1.196.125-.266.125-.665.249-.931 0-.133.125-.133.125-.266l-.374-.664-.25-.399 2.994-1.728c.499-.266 1.123-.532 1.747-.532.499-.133 1.123-.133 1.746 0 .25 0 .375 0 .624.133.125 0 .25 0 .374.133l1.123.399c.25.133.499.266.749.266.249.133.623.266.873.531.249.133.374.266.624.399.249.133.499.399.748.665.125.133.374.266.499.399.25.265.499.398.624.664.125.133.249.266.374.532l.624.664c.125.133.249.399.374.532.125.266.374.532.499.798.125.133.25.398.374.531.125.266.375.532.499.798 0 .133.125.133.125.266s.125.133.125.266l.374.797c.125.133.25.399.25.532l.374.797c.125.133.125.399.249.532l.375.797c.124.266.124.399.249.665s.25.532.25.93c.124.266.124.399.124.665.125.266.125.665.25.931 0 .265.125.398.125.664s.124.665.124.931c0 .265 0 .398.125.664v1.064z"
            fill="#fff"
            />
            <path
            d="M315.869 154.084l-1.746-.664.873-.798-1.123-.399c-.249-.133-.499-.266-.748-.266-.125-.133-.374-.133-.499-.265-.374-.266-.749-.399-1.123-.665-4.366-3.19-7.485-9.039-8.109-14.887 0-.665-.124-1.196-.124-1.728v-1.063c0-.266 0-.532.124-.798.125-.399.125-.798.25-1.196.125-.266.125-.665.249-.931 0-.133 0-.133.125-.266l-.624-1.063 3.119-1.861c.499-.266 1.123-.399 1.747-.532.499-.132 1.122-.132 1.746 0 .25 0 .374 0 .624.133.125 0 .249 0 .374.133l1.123.399c.249.133.499.133.748.266.25.133.624.266.874.532.124.133.374.265.623.398.25.133.499.399.749.665.125.133.374.266.499.399.249.266.499.398.624.664l.499.532c.249.266.374.532.623.665.125.133.25.265.375.531.249.266.374.532.499.798.124.133.249.266.374.532.125.265.374.531.499.797l.125.133s0 .133.124.133c0 .133.125.133.125.266l.374.797c.125.133.25.399.25.532l.374.797v.133c.125.133.125.399.25.532l.374.798c.125.265.125.398.249.664.125.266.25.665.25.931 0 .133.125.398.125.664.124.266.124.665.249.931 0 .266.125.398.125.664 0 .399.125.665.125.931s0 .398.124.664V145.71c0 .399 0 .665-.124.931 0 .265-.125.531-.125.797-.125.399-.25.931-.374 1.329-.125.399-.25.665-.375 1.064-.499 1.063-1.122 1.861-1.996 2.392l-.124.133h-.125l-.624.399-2.62 1.329zm-1.372-.664l1.372.531 3.369-1.994a6.797 6.797 0 001.996-2.259c.124-.266.249-.665.374-.931l.374-1.196c0-.266.125-.532.125-.797 0-.266.125-.665.125-.931v-.133-.797-1.064c0-.266 0-.399-.125-.664 0-.266-.125-.665-.125-.931s-.125-.399-.125-.664c-.124-.266-.124-.665-.249-.931 0-.266-.125-.399-.125-.664-.125-.266-.125-.532-.249-.931-.125-.266-.125-.399-.25-.664l-.374-.798c-.125-.133-.125-.399-.25-.532v-.133l-.374-.797c-.125-.133-.125-.399-.249-.532l-.375-.797c0-.133-.124-.133-.124-.266 0 0 0-.133-.125-.133l-.125-.133c-.125-.266-.249-.532-.499-.798a1.836 1.836 0 00-.374-.531c-.125-.266-.374-.532-.499-.798-.125-.133-.25-.399-.374-.531-.125-.266-.375-.399-.624-.665a1.81 1.81 0 01-.374-.532l-.624-.664c-.125-.133-.25-.266-.499-.399-.25-.266-.499-.399-.749-.532-.249-.133-.374-.266-.623-.399-.25-.132-.624-.398-.874-.531-.249-.133-.499-.266-.748-.266l-1.123-.399c-.125 0-.249 0-.374-.133-.25 0-.374-.133-.624-.133a3.87 3.87 0 00-1.746 0c-.624.133-1.248.266-1.747.532l-2.869 1.728.624 1.063c0 .133-.125.133-.125.266-.125.266-.25.665-.25.931-.124.398-.249.797-.249 1.196 0 .266-.125.532-.125.797v.931c0 .532 0 1.196.125 1.728.499 5.848 3.742 11.564 7.984 14.754.374.266.748.532 1.123.665.124.133.374.133.499.265.249.133.499.266.748.266l1.123.399h.374l-.998.931z"
            fill="#000"
            />
            <path
            d="M321.982 147.438c-.124.399-.249.798-.374 1.33l-6.612 3.987-1.372.798-.374-.798.624-.398 8.108-4.919z"
            fill="#fff"
            />
            <path
            d="M313.624 153.553l-.499-.931.749-.398 8.233-4.918v.133c-.125.398-.249.93-.374 1.329l-8.109 4.785zm-.25-.931l.375.665 7.859-4.652c.125-.266.25-.665.25-1.063l-8.484 5.05z"
            fill="#000"
            />
            <path
            d="M317.369 131.488l-11.727 7.045c-.125-.266-.249-.532-.249-.798l11.477-6.912c0 .266.249.399.499.665z"
            fill="#fff"
            />
            <path
            d="M305.517 138.666l-.125-.266c-.125-.266-.125-.399-.25-.665l-.124-.133h.124l11.477-6.912c.25.266.375.532.624.665v.133h-.125l-11.601 7.178zm-.125-.931c.125.266.125.399.249.665l11.477-6.912c-.124-.133-.249-.399-.499-.532l-11.227 6.779z"
            fill="#000"
            />
            <path
            d="M318.241 132.817l-11.976 7.178-.374-.798 11.851-7.177c.125.265.374.531.499.797z"
            fill="#fff"
            />
            <path
            d="M306.14 140.128c-.125-.399-.25-.665-.374-.931v-.133l11.976-7.177c.249.266.374.531.499.797v.133l-12.101 7.311zm-.25-.931c.125.266.125.399.25.665l11.851-7.178c-.125-.133-.249-.399-.374-.664l-11.727 7.177z"
            fill="#000"
            />
            <path
            d="M312.252 127.367l-8.483 5.184-.873.532-.375-.798 1.497-.93 7.236-4.253c.249 0 .624.132.998.265z"
            fill="#fff"
            />
            <path
            d="M302.77 133.082l-.499-.93 8.733-5.317 1.123.399.124.133-9.481 5.715zm-.249-.797l.374.664.749-.398 8.358-5.051c-.25-.133-.624-.266-.873-.266l-8.608 5.051z"
            fill="#000"
            />
            <path
            d="M318.988 134.013l-12.225 7.311-.374-.798 12.1-7.31c.25.399.375.532.499.797z"
            fill="#fff"
            />
            <path
            d="M306.763 141.59c-.125-.399-.25-.665-.374-.931v-.133l12.225-7.31v.133c.125.266.374.531.499.797v.133l-12.35 7.311zm-.25-.931c.125.266.25.399.25.665l12.101-7.178c-.125-.266-.25-.399-.375-.664l-11.976 7.177z"
            fill="#000"
            />
            <path
            d="M301.773 130.956l.375.665 2.12-1.33 2.994-1.728 2.994-1.861a3.899 3.899 0 00-1.746 0l-2.994 1.728-1.497.931-2.121 1.196-.125.399z"
            fill="#fff"
            />
            <path
            d="M302.147 131.753l-.499-.797.25-.266 6.612-3.988c.499-.133 1.122-.133 1.746 0h.25l-8.359 5.051zm-.249-.797l.249.531 7.735-4.652h-1.372l-6.612 3.988v.133z"
            fill="#000"
            />
            <path
            d="M315.122 129.228l-10.853 6.513-.374-.797 10.479-6.247c.249.132.499.265.748.531z"
            fill="#fff"
            />
            <path
            d="M304.269 135.874l-.499-.93 10.603-6.38c.25.133.499.398.749.664l.125.133-10.978 6.513zm-.25-.93l.374.665 10.729-6.381c-.25-.133-.374-.398-.624-.531l-10.479 6.247z"
            fill="#000"
            />
            <path
            d="M316.244 130.292l-11.227 6.779-.374-.798 11.102-6.646c.125.266.375.532.499.665z"
            fill="#fff"
            />
            <path
            d="M305.017 137.203l-.499-.93 11.227-6.646c.25.266.499.399.624.665l.125.132h-.125l-11.352 6.779zm-.375-.797l.375.665 11.102-6.647-.499-.531-10.978 6.513z"
            fill="#000"
            />
            <path
            d="M313.75 128.297l-10.229 6.115-.375-.798.499-.266 9.357-5.582c.249.133.499.265.748.531z"
            fill="#fff"
            />
            <path
            d="M303.52 134.545l-.499-.931 9.856-5.981c.249.133.623.266.873.531l.125.133-10.355 6.248zm-.249-.931l.374.665 10.105-5.982-.749-.398-9.73 5.715z"
            fill="#000"
            />
            <path
            d="M322.109 143.052l-10.604 6.38-.374-.798 10.853-6.513c0 .266.125.532.125.931z"
            fill="#fff"
            />
            <path
            d="M311.505 149.432l-.499-.93h.125l10.978-6.647v.133c0 .399.124.665.124.931l-10.728 6.513zm-.25-.798l.375.665 10.479-6.247c0-.266-.125-.532-.125-.798l-10.729 6.38z"
            fill="#000"
            />
            <path
            d="M320.361 136.805l-12.101 7.311c-.125-.266-.499-.266-.748-.532l12.475-7.576c.249.266.249.531.374.797z"
            fill="#fff"
            />
            <path
            d="M308.26 144.249c-.125-.133-.249-.266-.374-.266-.125-.133-.25-.133-.374-.266v-.133l12.599-7.576v.133l.375.797v.133h-.125l-12.101 7.178zm-.499-.665c.125.133.125.133.25.133.124 0 .249.133.374.266l11.976-7.178c-.125-.266-.25-.398-.25-.664l-12.35 7.443z"
            fill="#000"
            />
            <path
            d="M319.736 135.475l-12.225 7.311c0-.133-.125-.133-.125-.266-.125-.133-.125-.399-.249-.532l12.225-7.31.374.797z"
            fill="#fff"
            />
            <path
            d="M307.511 142.919c-.125-.133-.125-.133-.125-.266 0 0 0-.133-.125-.133 0-.133-.125-.266-.125-.266 0-.132-.124-.132-.124-.265v-.133l12.35-7.444v.133l.374.798v.132h-.125l-12.1 7.444zm-.25-.93s0 .133 0 0c.125.265.125.265.25.398 0 0 0 .133.124.133v.133l12.101-7.31c-.125-.266-.249-.399-.374-.665l-12.101 7.311z"
            fill="#000"
            />
            <path
            d="M321.235 149.697c-.499.931-1.122 1.728-1.996 2.26l-.249.133-.374.266-.125.133-2.495 1.462-1.123-.399 6.362-3.855z"
            fill="#fff"
            />
            <path
            d="M315.87 154.084l-1.372-.532 6.861-4.12-.124.265c-.499 1.064-1.123 1.861-1.996 2.393l-.874.532-2.495 1.462zm-.998-.532l.998.399 3.369-1.994c.748-.532 1.372-1.196 1.746-1.994l-6.113 3.589z"
            fill="#000"
            />
            <path
            d="M322.232 145.444v.133c0 .266 0 .665-.124.931l-8.858 5.317-.249.132-.25-.398-.249-.399 9.73-5.716z"
            fill="#fff"
            />
            <path
            d="M312.876 152.223l-.499-.93 9.855-5.981v.265c0 .399 0 .665-.125.931l-9.231 5.715zm-.125-.664l.25.399.249-.133 8.857-5.317c0-.266 0-.532.125-.931l-9.481 5.716v.266z"
            fill="#000"
            />
            <path
            d="M320.985 138.266l-11.851 7.045c-.125-.266-.374-.531-.499-.797l11.976-7.178c.125.399.249.665.374.93z"
            fill="#fff"
            />
            <path
            d="M309.134 145.577l-.125-.133c-.125-.266-.249-.399-.374-.665v-.132l12.225-7.311v.133c.125.266.25.532.375.93v.133h-.125l-11.976 7.045zm-.374-.93c.124.132.249.398.374.531l11.726-7.045c-.124-.265-.124-.398-.249-.664l-11.851 7.178z"
            fill="#000"
            />
            <path
            d="M322.233 144.78l-9.98 5.982-.374-.798 10.354-6.247v1.063z"
            fill="#fff"
            />
            <path
            d="M312.253 150.895l-.499-.931h.125l10.479-6.247v1.196l-10.105 5.982zm-.374-.931l.374.665 9.855-5.982v-.797l-10.229 6.114z"
            fill="#000"
            />
            <path
            d="M321.858 141.324l-11.103 6.646-.374-.798 11.227-6.779c.125.399.125.665.25.931z"
            fill="#fff"
            />
            <path
            d="M310.755 148.103l-.499-.93h.125l11.352-6.779v.132c.125.266.125.665.249.931l-11.227 6.646zm-.25-.93l.375.664 10.978-6.513c0-.266-.125-.532-.125-.798l-11.228 6.647z"
            fill="#000"
            />
            <path
            d="M321.484 139.729l-11.477 6.912c-.125-.266-.374-.532-.499-.665l11.726-7.044c0 .265.125.531.25.797z"
            fill="#fff"
            />
            <path
            d="M310.007 146.773c-.25-.266-.375-.531-.624-.797v-.133l11.851-7.178v.133c.125.266.25.665.25.93v.133l-11.477 6.912zm-.375-.797c.125.266.25.398.499.531l11.353-6.779c-.125-.265-.125-.531-.25-.664l-11.602 6.912z"
            fill="#000"
            />
            <path
            d="M319.113 147.438c-.125 2.392-.998 5.051-2.994 6.38-1.996 1.329-4.366.797-6.362-.266-.374-.266-.873-.532-1.248-.798-.124-.132-.249-.265-.374-.265-1.372-1.064-2.495-2.393-3.618-3.722-.623-.931-1.247-1.994-1.871-3.057-1.247-2.393-1.996-5.051-2.245-7.71-.25-2.525 0-5.317 1.497-7.31 1.372-1.861 3.493-2.26 5.613-1.728.375.133.749.265 1.248.398.873.399 1.746.798 2.495 1.33 1.372 1.063 2.62 2.392 3.618 3.721.499.665.873 1.33 1.247 1.861l.125.133c1.746 3.19 2.994 7.178 2.869 11.033z"
            fill="#fff"
            />
            <path
            d="M313.499 154.749c-1.497 0-2.869-.665-3.742-1.064-.375-.266-.874-.532-1.248-.797-.125-.133-.249-.266-.374-.266-1.372-1.064-2.495-2.26-3.618-3.855-.748-.93-1.247-1.994-1.871-3.057-1.248-2.393-1.996-5.051-2.246-7.71-.249-2.126-.124-5.183 1.622-7.443 1.248-1.728 3.368-2.393 5.739-1.861.374.133.873.266 1.247.399.873.266 1.622.797 2.495 1.329 1.248.93 2.495 2.26 3.618 3.855.374.531.873 1.196 1.247 1.994v.132c1.996 3.722 3.119 7.71 2.87 11.166-.125 2.791-1.248 5.317-2.994 6.513-.998.399-1.872.665-2.745.665zm-7.36-26.053c-1.622 0-2.994.665-3.992 1.994-1.622 2.127-1.747 5.184-1.497 7.31a21.11 21.11 0 002.245 7.577c.499 1.063 1.123 2.127 1.872 3.057.998 1.462 2.245 2.791 3.493 3.722.124.133.249.266.374.266.374.266.748.531 1.247.797 1.373.798 3.992 1.861 6.238.266 1.746-1.196 2.869-3.589 2.994-6.38.125-3.456-.873-7.311-2.869-11.032v-.266c-.375-.665-.749-1.33-1.248-1.861-1.123-1.595-2.245-2.792-3.493-3.722-.748-.532-1.622-1.063-2.495-1.329a14.937 14.937 0 00-1.247-.399h-1.622z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M311.379 130.424l-6.736 18.077c-.624-.93-1.248-1.994-1.872-3.057l6.113-16.482c.873.532 1.622.93 2.495 1.462zM316.244 136.406l-6.487 17.147c-.375-.266-.874-.532-1.248-.798-.125-.133-.249-.266-.374-.266l6.861-18.21c.499.665.873 1.33 1.248 1.861-.125.133-.125.133 0 .266z"
            fill="#9CD6CB"
            />
            <path
            opacity={0.39}
            d="M305.516 128.563s4.116.399 8.732 4.785c-.125 0-2.495-5.582-8.732-4.785z"
            fill="url(#paint118_linear_874_76773)"
            />
            <path
            opacity={0.39}
            d="M314.746 134.013s2.745 4.253 4.366 10.899c-.124-.133-.748-7.31-4.366-10.899z"
            fill="url(#paint119_linear_874_76773)"
            />
            <path
            d="M311.003 95.6c-.124 0-.249.133-.249.398v27.116c0 .266.125.399.249.399.125 0 .25-.133.25-.399V95.998c0-.266-.125-.398-.25-.398z"
            fill="#131A2D"
            />
            <path
            d="M310.504 98.922v-2.659l.25-.133-.874-.531-.249.133v2.392c0 .532.125.93.499 1.064l.873.531c-.249-.133-.499-.399-.499-.797z"
            fill="#fff"
            />
            <path
            d="M310.878 99.852l-.873-.532c-.374-.265-.499-.664-.499-1.196v-2.392l.374-.266.998.664-.374.266v2.526c.125.398.249.664.374.93zm-1.247-3.987v2.26c0 .53.124.93.499 1.063l.499.265c-.125-.133-.125-.265-.125-.398v-2.792l.249-.133-.748-.398-.374.133z"
            fill="#000"
            />
            <path
            d="M315.495 92.144l-.25.132v2.659c0 .133 0 .266-.125.266 0 .133-.124.266-.124.399 0 .132-.125.265-.125.398s-.125.266-.125.266c0 .133-.125.133-.249.266l-.125.133-.125.133c-.125.133-.125.133-.249.133l-2.62 1.595c-.125 0-.125.133-.25.133h-.249v.133l.374.265h.624s.125 0 .125-.133l2.619-1.594c.125 0 .125-.133.25-.133l.125-.133.124-.133.125-.133s0-.133.125-.133c0 0 0-.133.125-.133v-.665-.265-.133-2.659l.249-.133-.249-.531z"
            fill="#0EA59D"
            />
            <path
            d="M311.503 99.587h-.124-.125-.125l-.374-.266v-.399h.249c.125 0 .125-.133.25-.133l2.62-1.595c.124 0 .124-.133.249-.133l.125-.133.249-.265c.125-.133.125-.266.25-.266.125-.133.125-.266.125-.399s.124-.266.124-.399 0-.133.125-.266v-2.658l.374-.266.998.665-.374.266v3.721s0 .133-.125.133c0 0 0 .133-.124.133v.133l-.125.133-.125.133h-.125c-.124.133-.124.133-.249.133l-2.62 1.595c-.125 0-.125.133-.249.133h-.874c.125 0 0 0 0 0zm-.249-.266c.125 0 .125 0 0 0h.374s.125 0 .125-.133l2.62-1.595c.124 0 .124-.133.249-.133h.125l.125-.133.124-.133v-.133s0-.133.125-.133c0 0 0-.132.125-.132v-1.064-2.658l.249-.133-.748-.399-.25.133v2.658c0 .133 0 .266-.124.266h-.125.125c0 .133-.125.266-.125.399s-.125.266-.125.266c-.125.133-.125.266-.249.266 0 .133-.125.133-.25.266l-.125.132c-.124.133-.124.133-.249.133l-2.62 1.595c-.125 0-.125.133-.249.133h-.125v.133l.998.4z"
            fill="#131A2D"
            />
            <path
            d="M316.118 92.808V95.2c0 .93-.624 1.994-1.373 2.526l-2.619 1.595c-.749.399-1.373.133-1.373-.798v-2.392l-.249.133v2.392c0 1.064.748 1.595 1.622.93l2.619-1.594c.874-.532 1.622-1.861 1.622-3.057v-2.393l-.249.266z"
            fill="#fff"
            />
            <path
            d="M311.377 99.986c-.125 0-.374 0-.499-.133-.374-.266-.499-.665-.499-1.197v-2.392l.374-.266v2.525c0 .4.125.665.374.798.25.133.499.133.874-.133l2.619-1.595c.749-.399 1.248-1.462 1.248-2.393v-2.392l.374-.266v2.525c0 1.064-.748 2.526-1.622 3.058l-2.619 1.595a.926.926 0 01-.624.266zm-.873-3.59v2.26c0 .532.124.93.499 1.064.249.133.623.133 1.122-.133l2.62-1.595c.873-.532 1.622-1.861 1.622-2.925v-2.26l-.125.134v2.26c0 .93-.624 2.126-1.372 2.525l-2.62 1.595c-.374.266-.748.266-.998.133-.249-.133-.374-.532-.374-.93v-2.26l-.374.133z"
            fill="#000"
            />
            <path
            d="M302.397 95.6V92.94l.249-.133-.873-.532-.25.133v2.393c0 .531.125.93.499 1.063l.874.532c-.25-.133-.499-.399-.499-.798z"
            fill="#0EA59D"
            />
            <path
            d="M302.771 96.53l-.874-.532c-.374-.266-.499-.664-.499-1.196v-2.393l.375-.265.998.664-.375.266V95.6c.125.398.25.664.375.93zm-1.248-3.988v2.26c0 .532.125.93.499 1.063l.499.266c-.125-.133-.125-.266-.125-.399v-2.791l.25-.133-.749-.399-.374.133z"
            fill="#131A2D"
            />
            <path
            d="M307.386 88.82l-.25.133v2.659c0 .133 0 .266-.125.266 0 .132-.124.265-.124.398s-.125.266-.125.399-.125.266-.125.266c0 .133-.125.133-.249.266l-.125.133-.125.132c-.125.134-.125.134-.249.134l-2.62 1.595c-.125 0-.125.132-.25.132h-.124v.133l.374.266h.499s.125 0 .125-.133l2.619-1.595c.125 0 .125-.133.25-.133l.125-.133.124-.132.125-.133s0-.133.125-.133c0 0 0-.133.125-.133v-.665-.266-.133-2.658l.249-.133-.249-.532z"
            fill="url(#paint120_linear_874_76773)"
            />
            <path
            d="M308.01 89.485v2.392c0 .93-.624 1.994-1.372 2.526l-2.62 1.595c-.748.398-1.372.133-1.372-.798v-2.392l-.25.132v2.393c0 1.064.749 1.595 1.622.93l2.62-1.595c.873-.531 1.622-1.86 1.622-3.057V89.22l-.25.266z"
            fill="#fff"
            />
            <path
            d="M303.269 96.662c-.124 0-.374 0-.499-.133-.374-.266-.499-.664-.499-1.196v-2.392l.375-.266V95.2c0 .399.124.665.374.798.249.133.499.133.873-.133l2.62-1.595c.748-.399 1.247-1.462 1.247-2.393v-2.392l.375-.266v2.525c0 1.064-.749 2.526-1.622 3.057l-2.62 1.596a.923.923 0 01-.624.265zm-.873-3.589v2.26c0 .532.125.93.499 1.064.25.132.624.132 1.123-.134l2.62-1.595c.873-.531 1.621-1.86 1.621-2.924v-2.26l-.124.134v2.26c0 .93-.624 2.126-1.373 2.525l-2.619 1.595c-.375.266-.749.266-.998.133-.25-.133-.375-.532-.375-.93v-2.26l-.374.132z"
            fill="#000"
            />
            <path
            d="M302.646 98.39l2.371 1.463V97.46l-2.371-1.462v2.393z"
            fill="#fff"
            />
            <path
            d="M305.016 99.986l-2.495-1.463v-2.525l2.495 1.462v2.526zm-2.245-1.728l2.245 1.329V97.46l-2.245-1.329v2.127z"
            fill="#000"
            />
            <path
            d="M302.646 95.998l2.371 1.462.873-.532-2.246-1.462-.998.532z"
            fill="#0EA59D"
            />
            <path
            d="M305.016 97.593l-2.495-1.463 1.123-.664 2.495 1.462-1.123.665zm-2.245-1.596l2.245 1.33.749-.532-2.246-1.33-.748.532z"
            fill="#131A2D"
            />
            <path
            d="M305.016 99.853l.873-.665v-2.26l-.873.532v2.393z"
            fill="#fff"
            />
            <path
            d="M304.891 99.986V97.46l1.122-.664v2.525l-1.122.665zm.249-2.526v2.127l.749-.531v-2.127l-.749.531z"
            fill="#000"
            />
            <path
            d="M316.492 91.878l-.25.266-.249.266-.25.266-4.74 2.924c-.125.133-.25.133-.374.266h-.125c-.125 0-.25.133-.25.133-.124 0-.124 0-.249.133h-.125c-.125 0-.249.132-.374.132v1.728c.125 0 .249 0 .374-.133h.25c.124 0 .249-.132.249-.132h.125c.125 0 .249-.133.374-.266l4.741-2.924c.124 0 .124-.133.249-.133s.125-.133.25-.266l.249-.266c.125-.133.125-.133.125-.266h9.606c1.247 0 2.12-.797 2.12-1.728h-11.851c.25-.266.125-.133.125 0zM306.888 96.131c-.125 0-.375-.133-.499-.133h-.125c-.25 0-.374-.133-.624-.266-.249-.133-.374-.133-.499-.266l-2.495-1.595c-.748-.398-1.123-.93-1.247-1.595h-11.602v.798c0 .532.624 1.063 1.247 1.063h10.355c.124.532.499 1.064 1.122 1.595l2.495 1.595c.125.133.375.133.499.266.125 0 .375.133.499.133h1.373v-1.728c.124.133-.125.133-.499.133.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M316.868 90.549c-.125-.532-.499-1.064-1.123-1.595l-2.495-1.595c-.748-.399-1.622-.665-2.495-.665v-8.24h-1.622v8.373c-.623.133-1.122.266-1.621.665l-4.741 2.924a2.369 2.369 0 00-.998.93h-11.851v1.064h11.602c.124.532.499 1.196 1.122 1.595l2.495 1.595c.749.399 1.622.665 2.495.665v7.443h1.622v-7.576c.624-.133 1.123-.266 1.622-.665l4.74-2.924c.499-.266.749-.665.998-.93h11.852v-1.064h-11.602z"
            fill="#0EA59D"
            />
            <path
            d="M307.636 103.707v-7.443a4.304 4.304 0 01-2.495-.798l-2.495-1.595c-.624-.399-1.123-.93-1.247-1.595h-11.602V91.08h11.851c.25-.266.499-.665.998-.93l4.741-2.925c.499-.266.998-.532 1.497-.664v-8.375h1.871v8.242c.873 0 1.746.266 2.495.664l2.495 1.595c.624.399 1.123.93 1.247 1.595h11.602v1.197h-11.851c-.25.398-.499.664-.998.93l-4.741 2.924c-.499.266-.998.532-1.497.665v7.576h-1.871v.133zm-17.714-11.43h11.601c.125.53.499 1.063 1.123 1.461l2.495 1.595c.624.4 1.497.665 2.495.665h.125v7.576h1.497v-7.576c.624-.133 1.123-.266 1.622-.532l4.74-2.924c.499-.266.749-.532.998-.93h11.851v-.93h-11.601c-.125-.533-.499-1.064-1.123-1.463l-2.495-1.595c-.624-.399-1.497-.665-2.495-.665h-.125v-8.241h-1.497v8.241c-.624.133-1.123.266-1.622.665l-4.74 2.924c-.374.266-.749.532-.998.93h-11.851v.798z"
            fill="#131A2D"
            />
            <path
            d="M312.876 89.75l-.748-.53c-.375-.267-.998-.4-1.622-.4h-.624l-.624.133c-.374.133-.748.133-.998.399l-2.994 1.86c-.748.4-.748 1.596 0 1.995l.749.531c.374.266.998.4 1.622.4h.623l.624-.134c.374-.133.749-.133.998-.398l2.994-1.861c.749-.4.749-1.463 0-1.994z"
            fill="#fff"
            />
            <path
            d="M308.385 94.137h-.623c-.624 0-1.248-.266-1.622-.398l-.749-.532c-.374-.266-.623-.665-.623-1.064 0-.398.249-.797.623-1.063l2.994-1.86c.25-.134.624-.267.998-.4l.624-.132h.624c.624 0 1.247.265 1.622.398l.748.532c.374.266.624.665.624 1.063 0 .4-.25.798-.624 1.064l-2.994 1.86c-.249.133-.624.266-.998.4l-.624.132zm1.497-5.184l-.623.133c-.375.133-.624.133-.874.399l-2.994 1.86c-.249.134-.499.533-.499.931 0 .4.125.665.499.93l.749.532c.374.266.998.4 1.622.4h.623l.499-.134c.375-.133.749-.133.874-.398l2.994-1.861c.249-.133.499-.532.499-.93 0-.4-.125-.665-.499-.931l-.749-.532c-.374-.266-.998-.399-1.497-.399h-.624z"
            fill="#000"
            />
            <path
            d="M309.258 99.321c-6.862 0-7.86 4.653-7.86 4.653v.531c-.124 2.659 2.745 4.918 6.862 4.918 4.366 0 7.859-2.525 7.859-5.317v-.93c-.499-2.127-1.622-3.855-6.861-3.855zm-.998 9.172c-2.371 0-4.367-.798-5.365-2.127-.499-.665-.748-1.329-.499-2.127.375-2.126 3.493-3.987 6.986-3.987 2.121 0 4.117.664 5.115 1.861.499.531.873 1.196.873 1.861-.124 2.525-3.493 4.519-7.11 4.519z"
            fill="#131A2D"
            />
            <path
            d="M308.634 105.037c-.874 0-1.497-.399-1.497-.931v1.463c0 .531.623 1.063 1.497 1.063.873 0 1.621-.532 1.621-1.063v-1.463c.125.399-.748.931-1.621.931z"
            fill="#131A2D"
            />
            <path
            d="M308.883 103.043c-.873 0-1.621.532-1.621 1.063-.125.532.623 1.064 1.497 1.064.873 0 1.621-.532 1.621-1.064 0-.664-.623-1.063-1.497-1.063z"
            fill="#fff"
            />
            <path
            d="M308.633 105.303c-.499 0-.998-.133-1.372-.532a1.05 1.05 0 01-.249-.665c.124-.664.873-1.063 1.746-1.063.499 0 .998.133 1.248.532.124.133.249.398.249.664 0 .532-.748 1.064-1.622 1.064zm.25-2.26c-.749 0-1.497.399-1.622.93 0 .133 0 .399.125.532.249.266.748.532 1.247.532.874 0 1.497-.399 1.622-1.064 0-.133 0-.398-.125-.531-.374-.133-.748-.399-1.247-.399z"
            fill="#000"
            />
            <path
            d="M309.382 103.042c-.249-.266-.748-.266-1.123 0-.124.133-.249.266-.249.399v.532c0 .133.125.265.249.398.25.266.749.266 1.123 0 .125-.133.25-.265.25-.398v-.532c-.125-.266-.125-.399-.25-.399z"
            fill="#202124"
            />
            <path
            d="M312.999 100.916h-.374l-4.117 2.658-.623.399c-.125 0-.25.133-.25 0l-.499-.133h-.249l-3.369 1.994s-.124.133 0 .266c.125.133.375.399.624.532.125.133.25.133.374 0l4.491-2.925.624-.398h.25l.499.133h.249l3.119-1.994c.125-.133.125-.266.125-.266s-.749-.133-.874-.266z"
            fill="#202124"
            />
            <path
            d="M313.001 100.65h-.25l-4.117 2.659-.623.399c-.125 0-.25.132-.25 0l-.499-.133h-.249l-3.369 2.126c-.124 0-.124.133-.124.266.124.133.374.399.623.532.125.133.25.133.375 0l4.491-2.924.623-.399h.25l.499.133h.249l3.119-1.994c.125 0 .125-.133 0-.266-.374-.133-.624-.266-.748-.399z"
            fill="#131A2D"
            />
            <path
            d="M309.382 103.043c-.124-.133-.374-.133-.499-.133-.249 0-.374 0-.623.133-.375.266-.375.532-.125.798.249.265.748.265 1.123 0 .374-.266.374-.665.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M309.257 98.523c-3.867 0-7.36 1.994-7.859 4.786-.499 2.924 2.495 5.316 6.861 5.316 4.367 0 7.86-2.525 7.86-5.316 0-2.659-3.119-4.786-6.862-4.786zm-.998 9.172c-2.37 0-4.366-.798-5.364-2.127-.499-.664-.748-1.329-.499-2.126.374-2.127 3.493-3.988 6.986-3.988 2.121 0 4.117.664 5.115 1.861.499.531.873 1.196.873 1.861-.125 2.525-3.493 4.519-7.111 4.519z"
            fill="#fff"
            />
            <path
            d="M302.646 101.049l-.499-.133c-.499.665-.873 1.329-.998 2.127-.125.797-.125 1.462.249 2.259l.624-.133c-.249-.664-.374-1.329-.249-1.993 0-.798.374-1.462.873-2.127z"
            fill="#D3D3D3"
            />
            <path
            d="M302.644 101.049l-.499-.133c-.499.665-.873 1.329-.998 2.127-.125.797-.125 1.462.249 2.259l.624-.133c-.249-.664-.374-1.329-.249-1.993 0-.798.374-1.462.873-2.127z"
            fill="#fff"
            />
            <path
            d="M301.148 105.435c-.249-.797-.374-1.595-.249-2.392.124-.798.499-1.462.998-2.127l.623.133-.124.133c-.499.664-.749 1.196-.874 1.861-.124.664-.124 1.329.125 1.994v.132l-.499.266zm.998-4.386c-.499.665-.873 1.329-.998 1.994-.125.664-.125 1.462.125 2.126l.499-.132c-.25-.665-.25-1.33-.125-1.994.125-.665.374-1.329.873-1.861l-.374-.133z"
            fill="#000"
            />
            <path
            d="M301.023 103.84v.797c0 .798.25 1.462.25 1.462l.249-.132v-.532l.25-.133v-.133l-.624.133c-.125-.532-.125-.93-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M301.647 103.84c0-.266 0-.399.125-.664.125-.665.499-1.33.998-1.994v-.133c-.499.664-.873 1.329-.998 1.994-.125.265-.249.531-.125.797z"
            fill="url(#paint121_linear_874_76773)"
            />
            <path
            d="M328.096 84.3c-6.862 0-7.86 4.653-7.86 4.653v.532c-.124 2.658 2.745 4.918 6.862 4.918 4.366 0 7.859-2.526 7.859-5.317v-.93s-1.622-3.855-6.861-3.855zm-.998 9.172c-2.371 0-4.367-.797-5.365-2.126-.499-.665-.748-1.33-.499-2.127.375-2.127 3.493-3.988 6.986-3.988 2.121 0 4.117.665 5.115 1.861.499.532.873 1.196.873 1.861-.124 2.393-3.368 4.52-7.11 4.52z"
            fill="#131A2D"
            />
            <path
            d="M327.597 90.016c-.874 0-1.497-.398-1.497-.93v1.462c0 .532.623 1.063 1.497 1.063.873 0 1.621-.531 1.621-1.063v-1.462c0 .532-.748.93-1.621.93z"
            fill="#131A2D"
            />
            <path
            d="M327.721 87.889c-.873 0-1.621.531-1.621 1.063-.125.532.623 1.063 1.497 1.063.873 0 1.621-.531 1.621-1.063 0-.532-.623-1.063-1.497-1.063z"
            fill="#fff"
            />
            <path
            d="M327.596 90.148c-.499 0-.998-.133-1.372-.531a1.05 1.05 0 01-.249-.665c.124-.665.873-1.063 1.746-1.063.499 0 .998.133 1.248.531.124.133.249.4.249.665 0 .532-.748 1.063-1.622 1.063zm.125-2.126c-.748 0-1.497.398-1.622.93 0 .133 0 .399.125.532.25.266.749.531 1.248.531.873 0 1.497-.398 1.621-1.063 0-.133 0-.399-.124-.532-.25-.266-.749-.398-1.248-.398z"
            fill="#000"
            />
            <path
            d="M328.22 87.889c-.25-.266-.749-.266-1.123 0-.125.133-.249.266-.249.399v.531c0 .133.124.266.249.399.25.266.749.266 1.123 0 .125-.133.249-.266.249-.399v-.531c0-.133-.124-.266-.249-.4z"
            fill="#202124"
            />
            <path
            d="M331.837 85.763h-.374l-4.117 2.658-.624.399c-.124 0-.249.133-.249 0l-.499-.133h-.25l-3.368 1.994s-.125.133 0 .266c.125.132.374.398.624.531.125.133.249.133.374 0l4.491-2.924.624-.399h.249l.499.133h.25l3.119-1.994c.124-.132.124-.266.124-.266s-.623-.132-.873-.265z"
            fill="#202124"
            />
            <path
            d="M331.836 85.497h-.249l-4.117 2.659-.624.398c-.124 0-.249.133-.249 0l-.499-.133h-.25l-3.368 2.127c-.125 0-.125.133-.125.266.125.133.375.399.624.532.125.132.25.132.374 0l4.491-2.925.624-.398h.25l.499.133h.249l3.119-1.994c.125 0 .125-.133 0-.266-.374 0-.499-.266-.749-.399z"
            fill="#131A2D"
            />
            <path
            d="M328.22 87.89c-.125-.133-.374-.133-.499-.133s-.374 0-.624.133c-.374.266-.374.531-.124.797.249.266.748.266 1.122 0 .375-.266.499-.531.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M328.095 83.503c-3.867 0-7.36 1.994-7.859 4.785-.499 2.924 2.495 5.317 6.861 5.317s7.859-2.526 7.859-5.317c.125-2.791-2.994-4.785-6.861-4.785zm-.998 9.171c-2.37 0-4.366-.797-5.364-2.126-.499-.665-.749-1.33-.499-2.127.374-2.127 3.493-3.988 6.986-3.988 2.121 0 4.117.665 5.115 1.861.499.532.873 1.197.873 1.861-.125 2.393-3.368 4.52-7.111 4.52z"
            fill="#fff"
            />
            <path
            d="M321.484 86.028l-.499-.133c-.499.665-.874 1.33-.998 2.127-.125.798-.125 1.462.249 2.26l.624-.133c-.25-.665-.374-1.33-.25-1.994.125-.93.375-1.595.874-2.127z"
            fill="#D3D3D3"
            />
            <path
            d="M321.484 86.028l-.499-.133c-.499.665-.874 1.33-.998 2.127-.125.798-.125 1.462.249 2.26l.624-.133c-.25-.665-.374-1.33-.25-1.994.125-.93.375-1.595.874-2.127z"
            fill="#fff"
            />
            <path
            d="M320.111 90.282c-.25-.797-.374-1.595-.25-2.393.125-.797.499-1.462.998-2.126l.624.133-.125.132c-.499.665-.748 1.197-.873 1.861-.125.665-.125 1.33.125 1.994v.133l-.499.266zm.873-4.386c-.499.664-.873 1.329-.998 1.993-.125.665-.125 1.463.125 2.127l.499-.133c-.25-.664-.25-1.329-.125-1.994.125-.664.374-1.329.873-1.86l-.374-.133z"
            fill="#000"
            />
            <path
            d="M319.861 88.686v.798c0 .798.25 1.462.25 1.462l.249-.133v-.531l.25-.133v-.133l-.624.133c0-.4-.125-.93-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M320.484 88.82c0-.266 0-.4.125-.665.125-.665.499-1.33.998-1.994v-.133c-.499.665-.873 1.33-.998 1.994-.125.266-.125.532-.125.798z"
            fill="url(#paint122_linear_874_76773)"
            />
            <path
            d="M310.381 71.807c-6.862 0-7.86 4.652-7.86 4.652v.531c-.124 2.659 2.745 4.919 6.862 4.919 4.366 0 7.859-2.526 7.859-5.317v-.93s-1.622-3.855-6.861-3.855zm-.998 9.171c-2.371 0-4.367-.797-5.365-2.127-.499-.664-.748-1.329-.499-2.126.375-2.127 3.494-3.988 6.987-3.988 2.12 0 4.116.665 5.114 1.861.499.532.873 1.196.873 1.86-.124 2.393-3.493 4.52-7.11 4.52z"
            fill="#131A2D"
            />
            <path
            d="M309.755 77.522c-.873 0-1.497-.398-1.497-.93v1.462c0 .532.624 1.063 1.497 1.063.873 0 1.622-.531 1.622-1.063v-1.462c.124.532-.749.93-1.622.93z"
            fill="#131A2D"
            />
            <path
            d="M310.006 75.395c-.873 0-1.621.532-1.621 1.064-.125.531.624 1.063 1.497 1.063.873 0 1.621-.532 1.621-1.063 0-.532-.623-1.064-1.497-1.064z"
            fill="#fff"
            />
            <path
            d="M309.757 77.655c-.499 0-.998-.133-1.373-.532a1.055 1.055 0 01-.249-.664c.125-.665.873-1.064 1.746-1.064.499 0 .998.133 1.248.532.125.133.249.399.249.664.125.532-.748 1.064-1.621 1.064zm.249-2.127c-.748 0-1.497.399-1.622.93 0 .133 0 .4.125.532.25.266.749.532 1.248.532.873 0 1.497-.399 1.621-1.063 0-.133 0-.4-.124-.532a2.02 2.02 0 00-1.248-.399z"
            fill="#000"
            />
            <path
            d="M310.505 75.396c-.249-.266-.748-.266-1.123 0-.124.133-.249.266-.249.398v.532c0 .133.125.266.249.399.25.266.749.266 1.123 0 .125-.133.25-.266.25-.399v-.532c-.125-.132-.125-.265-.25-.398z"
            fill="#202124"
            />
            <path
            d="M314.122 73.269h-.374l-4.117 2.658-.623.399c-.125 0-.25.133-.25 0l-.499-.133h-.249l-3.369 1.994s-.124.133 0 .266c.125.132.375.398.624.531.125.133.25.133.374 0l4.491-2.924.624-.399h.25l.499.133h.249l3.119-1.994c.125-.133.125-.398.125-.398s-.749 0-.874-.133z"
            fill="#202124"
            />
            <path
            d="M314.122 73.136h-.25l-4.117 2.658-.623.399c-.125 0-.25.133-.25 0l-.499-.133h-.249l-3.369 2.127c-.124 0-.124.133-.124.266.124.132.374.398.623.531.125.133.25.133.375 0l4.491-2.924.623-.399h.25l.499.133h.249l3.119-1.994c.125 0 .125-.133 0-.266-.374-.132-.624-.265-.748-.398z"
            fill="#131A2D"
            />
            <path
            d="M310.505 75.396c-.124-.133-.374-.133-.499-.133-.124 0-.374 0-.623.133-.375.266-.375.531-.125.797.249.266.748.266 1.123 0 .374-.266.374-.531.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M310.38 71.01c-3.867 0-7.36 1.994-7.859 4.785-.499 2.924 2.495 5.317 6.861 5.317 4.367 0 7.86-2.526 7.86-5.317 0-2.791-3.119-4.785-6.862-4.785zm-.998 9.171c-2.37 0-4.366-.797-5.364-2.126-.499-.665-.748-1.33-.499-2.127.374-2.127 3.493-3.988 6.986-3.988 2.121 0 4.117.665 5.115 1.861.499.532.873 1.196.873 1.861-.125 2.393-3.493 4.52-7.111 4.52z"
            fill="#fff"
            />
            <path
            d="M303.769 73.534l-.499-.133c-.499.665-.873 1.33-.998 2.127-.125.798-.125 1.462.249 2.26l.624-.133c-.249-.665-.374-1.33-.249-1.994 0-.797.374-1.462.873-2.127z"
            fill="#D3D3D3"
            />
            <path
            d="M303.767 73.534l-.499-.133c-.499.665-.873 1.33-.998 2.127-.125.798-.125 1.462.249 2.26l.624-.133c-.249-.665-.374-1.33-.249-1.994 0-.797.374-1.462.873-2.127z"
            fill="#fff"
            />
            <path
            d="M302.271 77.788c-.249-.798-.374-1.595-.249-2.393.124-.797.499-1.462.998-2.126l.623.132-.124.133c-.499.665-.749 1.197-.874 1.861-.124.665-.124 1.33.125 1.994v.133l-.499.266zm.998-4.386c-.499.664-.873 1.329-.998 1.993-.125.665-.125 1.462.125 2.127h.499c-.25-.665-.25-1.33-.125-1.994.125-.664.374-1.329.873-1.86l-.374-.267z"
            fill="#000"
            />
            <path
            d="M302.146 76.326v.798c0 .797.25 1.462.25 1.462l.249-.133v-.532l.25-.133v-.266l-.624.133c-.125-.398-.125-.93-.125-1.329z"
            fill="#131A2D"
            />
            <path
            d="M302.77 76.326c0-.266 0-.4.124-.665.125-.665.499-1.33.998-1.994v-.133c-.499.665-.873 1.33-.998 1.994-.124.266-.124.532-.124.797z"
            fill="url(#paint123_linear_874_76773)"
            />
            <path
            d="M291.043 85.764c-6.861 0-7.859 4.652-7.859 4.652v.532c-.125 2.658 2.744 4.918 6.861 4.918 4.366 0 7.859-2.526 7.859-5.317v-.93s-1.746-3.855-6.861-3.855zm-.998 9.038c-2.37 0-4.366-.797-5.364-2.127-.499-.664-.749-1.329-.499-2.126.374-2.127 3.493-3.988 6.986-3.988 2.12 0 4.116.665 5.114 1.861.499.532.874 1.196.874 1.861-.25 2.525-3.493 4.52-7.111 4.52z"
            fill="#131A2D"
            />
            <path
            d="M290.419 91.478c-.873 0-1.497-.398-1.497-.93v1.462c0 .532.624 1.063 1.497 1.063.873 0 1.622-.531 1.622-1.063v-1.462c.124.399-.749.93-1.622.93z"
            fill="#131A2D"
            />
            <path
            d="M290.671 89.352c-.874 0-1.622.531-1.622 1.063-.125.532.624 1.063 1.497 1.063.873 0 1.622-.531 1.622-1.063 0-.532-.749-1.063-1.497-1.063z"
            fill="#fff"
            />
            <path
            d="M290.421 91.611c-.499 0-.998-.133-1.373-.532a1.055 1.055 0 01-.249-.664c.125-.665.873-1.063 1.746-1.063.499 0 .998.132 1.248.531.125.133.249.399.249.665 0 .531-.748 1.063-1.621 1.063zm.249-2.127c-.748 0-1.497.4-1.622.93 0 .134 0 .4.125.533.25.265.749.531 1.248.531.873 0 1.497-.398 1.621-1.063 0-.133 0-.399-.124-.532a2.02 2.02 0 00-1.248-.398z"
            fill="#000"
            />
            <path
            d="M291.169 89.353c-.249-.266-.748-.266-1.123 0-.124.133-.249.266-.249.398v.532c0 .133.125.266.249.399.25.266.749.266 1.123 0 .125-.133.25-.266.25-.399v-.532c-.125-.133-.125-.265-.25-.398z"
            fill="#202124"
            />
            <path
            d="M294.661 87.226h-.374l-4.117 2.658-.623.399c-.125 0-.25.133-.25 0l-.499-.133h-.249l-3.369 1.994s-.124.133 0 .265c.125.133.375.4.624.532.125.133.25.133.374 0l4.491-2.924.624-.399h.25l.499.133h.249l3.119-1.994c.125-.133.125-.398.125-.398s-.624 0-.874-.133z"
            fill="#202124"
            />
            <path
            d="M294.661 86.96h-.25l-4.117 2.658-.623.4c-.125 0-.25.132-.25 0l-.499-.134h-.249l-3.369 2.127c-.124 0-.124.133-.124.266.124.133.374.399.623.531.125.133.25.133.375 0l4.491-2.924.623-.398h.25l.499.132h.249l3.119-1.993c.125 0 .125-.133 0-.266-.249 0-.499-.266-.748-.399z"
            fill="#131A2D"
            />
            <path
            d="M291.167 89.352c-.124-.133-.374-.133-.499-.133-.249 0-.374 0-.623.133-.375.266-.375.531-.125.797.249.266.748.266 1.123 0 .374-.266.374-.664.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M291.044 84.833c-3.867 0-7.36 1.994-7.859 4.785-.499 2.924 2.495 5.317 6.861 5.317 4.367 0 7.86-2.526 7.86-5.317 0-2.658-3.119-4.785-6.862-4.785zm-.998 9.171c-2.37 0-4.366-.797-5.364-2.126-.499-.665-.748-1.33-.499-2.127.374-2.127 3.493-3.988 6.986-3.988 2.121 0 4.117.665 5.115 1.861.499.532.873 1.197.873 1.861-.249 2.526-3.493 4.52-7.111 4.52z"
            fill="#fff"
            />
            <path
            d="M284.433 87.491l-.499-.133c-.499.665-.873 1.33-.998 2.127-.125.798-.125 1.462.249 2.26l.624-.133c-.249-.665-.374-1.33-.249-1.994 0-.93.374-1.595.873-2.127z"
            fill="#D3D3D3"
            />
            <path
            d="M284.433 87.491l-.499-.133c-.499.665-.873 1.33-.998 2.127-.125.798-.125 1.462.249 2.26l.624-.133c-.249-.665-.374-1.33-.249-1.994 0-.93.374-1.595.873-2.127z"
            fill="#fff"
            />
            <path
            d="M282.935 91.745c-.249-.798-.374-1.595-.249-2.393.124-.797.499-1.462.998-2.126l.623.133-.124.132c-.499.665-.749 1.197-.874 1.861-.124.665-.124 1.33.125 1.994v.133l-.499.266zm.998-4.386c-.499.664-.873 1.329-.998 1.993-.125.665-.125 1.462.125 2.127l.499-.133c-.25-.665-.25-1.33-.125-1.994.125-.664.374-1.329.873-1.86l-.374-.133z"
            fill="#000"
            />
            <path
            d="M282.686 90.15v.797c0 .797.249 1.462.249 1.462l.25-.133v-.531l.249-.133v-.133l-.624.133c0-.4-.124-.93-.124-1.463z"
            fill="#131A2D"
            />
            <path
            d="M283.309 90.15c0-.266 0-.399.124-.665.125-.665.499-1.33.998-1.994v-.133c-.499.665-.873 1.33-.998 1.994 0 .266-.124.532-.124.798z"
            fill="url(#paint124_linear_874_76773)"
            />
            <path
            d="M309.63 153.819c.25 0 .375-.133.25-.399v-26.186c0-.133 0-.398.125-.531l1.372-3.855c0-.133 0-.399-.25-.399-.124 0-.374 0-.374.266l-1.247 3.722c-.125.266-.125.532-.125.797v26.186c-.125.266 0 .399.249.399z"
            fill="#131A2D"
            />
            <path
            d="M312.376 127.5c.125 0 .125 0 .25-.133.124-.133-.125-1.329-.125-1.329l-.998-3.456c-.125-.133-.25-.133-.374 0-.125.133-.125.266 0 .399l.998 3.456.124.93c0 .133 0 .133.125.133z"
            fill="#131A2D"
            />
            <path
            d="M199.226 298.303l.749.398-.874 1.463-31.437 46.522-.873-.532 32.435-47.851z"
            fill="#322C8D"
            />
            <path
            d="M166.917 317.045l31.562-18.609c.623-.398 1.372.133 1.372.931v27.514c0 .399-.25.665-.499.931l-31.562 18.609c-.624.399-1.372-.133-1.372-.931v-27.514c0-.399.125-.798.499-.931z"
            fill="#131A2D"
            />
            <path
            d="M167.54 317.31l31.562-18.609c.624-.399 1.372.133 1.372.93v27.515c0 .399-.249.665-.499.931l-31.562 18.608c-.623.399-1.372-.133-1.372-.93V318.24c0-.398.125-.797.499-.93z"
            fill="#fff"
            />
            <path
            d="M167.914 346.819c-.249 0-.374 0-.499-.133-.374-.266-.499-.532-.499-1.063v-27.515c0-.399.25-.798.624-1.063l31.562-18.609c.374-.266.748-.133 1.122 0 .375.266.499.531.499 1.063v27.515c0 .398-.249.797-.623 1.063l-31.562 18.609c-.25.133-.374.133-.624.133zm31.562-48.117c-.125 0-.25 0-.374.132l-31.562 18.609c-.25.133-.374.399-.374.798v27.514c0 .266.124.532.374.798a.751.751 0 00.748 0l31.562-18.609c.25-.133.374-.399.374-.797v-27.515c0-.266-.124-.532-.374-.798-.125-.132-.249-.132-.374-.132z"
            fill="#131A2D"
            />
            <path
            d="M191.992 309.468l5.489-3.19c.125 0 .249 0 .249.133v4.785s0 .133-.124.133l-5.489 3.19c-.125 0-.25 0-.25-.133v-4.785c.125 0 .125-.133.125-.133z"
            fill="#0EA59D"
            />
            <path
            d="M192.117 314.652c-.125 0 0 0 0 0-.25-.132-.25-.132-.25-.265v-4.786c0-.132 0-.132.125-.265l5.489-3.19h.249c.125 0 .125.132.125.265v4.785c0 .133 0 .133-.125.266l-5.613 3.19zm5.489-8.374l-5.489 3.323V314.652h.124l5.489-3.19v-.133l-.124-5.051c.124 0 .124 0 0 0zM198.728 318.241c-.125.266-.249.532-.499.665-.249.132-.374.132-.499 0-.125-.133-.125-.532-.125-.931 0-.532.125-.93.25-1.196.125-.266.249-.399.499-.532.249-.133.374-.133.499 0s.125.532.125.931c-.125.398-.125.797-.25 1.063zm-.249-1.861c-.125-.133-.125-.133-.25 0s-.249.266-.249.399c-.125.133-.125.532-.125.93 0 .399 0 .665.125.798.124.133.124.133.249 0s.25-.266.25-.399.124-.532.124-.93c0-.399 0-.665-.124-.798zM197.107 319.172c-.125.265-.249.531-.499.664-.249.133-.374.133-.499 0s-.125-.531-.125-.93c0-.532.125-.931.25-1.197.125-.265.249-.398.499-.531.249-.133.374-.133.499 0s.125.531.125.93c-.125.399-.125.798-.25 1.064zm-.249-1.861c-.125-.133-.125-.133-.25 0l-.374.398c-.125.133-.125.532-.125.931s0 .665.125.797c.125.133.125.133.249 0 .125-.132.25-.265.25-.398.125-.133.125-.532.125-.931.124-.399.124-.664 0-.797zM195.361 320.235c-.125.266-.249.532-.499.665-.249.133-.374.133-.499 0s-.125-.532-.125-.931c0-.531.125-.93.25-1.196.125-.266.249-.399.499-.532.249-.133.374-.133.499 0s.125.532.125.931c0 .398-.125.797-.25 1.063zm-.125-1.861c-.124-.133-.124-.133-.249 0s-.25.266-.25.399c-.124.133-.124.532-.124.93 0 .399 0 .665.124.798.125.133.125.133.25 0s.249-.266.249-.399.125-.532.125-.93c0-.399 0-.665-.125-.798zM193.74 321.166c-.125.266-.25.531-.499.664-.25.133-.374.133-.499 0s-.125-.531-.125-.93c0-.532.125-.931.25-1.196.124-.266.249-.399.499-.532.249-.133.374-.133.499 0 .124.133.124.532.124.93 0 .399-.124.798-.249 1.064zm-.125-1.861c-.125-.133-.125-.133-.249 0-.125.133-.25.266-.25.399-.125.133-.125.531-.125.93s0 .665.125.798.125.133.25 0c.124-.133.249-.266.249-.399.125-.133.125-.532.125-.931 0-.398-.125-.664-.125-.797zM191.369 322.627c-.125.266-.25.531-.499.664-.25.133-.374.133-.499 0s-.125-.531-.125-.93c0-.532.125-.931.25-1.196.124-.266.249-.399.499-.532.249-.133.374-.133.499 0 .124.133.124.532.124.93-.124.399-.124.798-.249 1.064zm-.25-1.861c-.124-.133-.124-.133-.249 0l-.374.399c-.125.133-.125.531-.125.93s0 .665.125.798c.124.132.124.132.249 0 .125-.133.25-.266.25-.399.124-.133.124-.532.124-.931.125-.398.125-.664 0-.797zM189.746 323.557c-.125.266-.25.532-.499.665-.25.133-.374.133-.499 0s-.125-.532-.125-.93c0-.532.125-.931.25-1.197.124-.266.249-.399.499-.531.249-.133.374-.133.499 0 .124.132.124.531.124.93-.124.399-.124.798-.249 1.063zm-.25-1.861c-.124-.132-.124-.132-.249 0l-.374.399c-.125.133-.125.532-.125.931 0 .398 0 .664.125.797.124.133.124.133.249 0s.25-.266.25-.399c.124-.132.124-.531.124-.93.125-.399.125-.665 0-.798zM188 324.489c-.125.266-.25.532-.499.665-.25.133-.375.133-.499 0-.125-.133-.125-.532-.125-.931 0-.532.125-.93.249-1.196.125-.266.25-.399.499-.532.25-.133.375-.133.499 0 .125.133.125.532.125.931 0 .398-.125.797-.249 1.063zm-.125-1.861c-.125-.133-.125-.133-.25 0l-.374.399c-.125.133-.125.532-.125.93 0 .399 0 .665.125.798s.125.133.25 0c.124-.133.249-.266.249-.399.125-.133.125-.532.125-.93.125-.399.125-.665 0-.798zM186.379 325.552c-.125.265-.25.531-.499.664-.25.133-.375.133-.499 0-.125-.133-.125-.532-.125-.93 0-.532.125-.931.249-1.197.125-.265.25-.398.499-.531.25-.133.375-.133.499 0 .125.133.125.531.125.93s-.125.798-.249 1.064zm-.125-1.861c-.125-.133-.125-.133-.25 0l-.374.398c-.125.133-.125.532-.125.931s0 .664.125.797.125.133.25 0c.124-.133.249-.265.249-.398.125-.133.125-.532.125-.931.125-.399 0-.664 0-.797zM184.008 327.013c-.125.266-.25.532-.499.665-.25.133-.375.133-.499 0-.125-.133-.125-.532-.125-.93 0-.532.125-.931.249-1.197a1.01 1.01 0 01.499-.531c.25-.133.375-.133.499 0 .125.133.125.531.125.93-.125.266-.125.665-.249 1.063zm-.25-1.86c-.125-.133-.125-.133-.249 0l-.375.398c-.124.133-.124.532-.124.931s0 .664.124.797c.125.133.125.133.25 0s.249-.266.249-.398c.125-.133.125-.532.125-.931.125-.532.125-.797 0-.797zM182.386 327.944c-.124.266-.249.532-.499.665-.249.133-.374.133-.499 0-.124-.133-.124-.532-.124-.931 0-.531.124-.93.249-1.196.125-.266.25-.399.499-.532.25-.133.374-.133.499 0s.125.532.125.931c-.125.398-.125.797-.25 1.063zm-.249-1.861c-.125-.133-.125-.133-.25 0l-.374.399c-.125.133-.125.532-.125.93 0 .399 0 .665.125.798s.125.133.25 0c.124-.133.249-.266.249-.399.125-.133.125-.532.125-.93.125-.399.125-.665 0-.798zM180.64 328.875c-.124.266-.249.531-.499.664-.249.133-.374.133-.499 0-.124-.133-.124-.531-.124-.93 0-.532.124-.931.249-1.196.125-.266.25-.399.499-.532.25-.133.374-.133.499 0s.125.532.125.93c0 .399-.125.798-.25 1.064zm-.124-1.861c-.125-.133-.125-.133-.25 0l-.374.399c-.125.133-.125.531-.125.93s0 .665.125.798.125.133.249 0c.125-.133.25-.266.25-.399s.125-.532.125-.931c.124-.398.124-.664 0-.797zM179.017 329.805c-.124.266-.249.532-.499.665-.249.133-.374.133-.499 0-.124-.133-.124-.532-.124-.93 0-.532.124-.931.249-1.197a1.01 1.01 0 01.499-.531c.25-.133.374-.133.499 0s.125.531.125.93-.125.798-.25 1.063zm-.124-1.86c-.125-.133-.125-.133-.25 0-.125.132-.249.265-.249.398s-.125.532-.125.931c0 .398 0 .664.125.797.124.133.124.133.249 0s.25-.266.25-.399c.124-.132.124-.531.124-.93s-.124-.665-.124-.797zM176.648 331.267c-.125.266-.249.532-.499.665-.249.133-.374.133-.499 0s-.125-.532-.125-.931c0-.531.125-.93.25-1.196.125-.266.249-.399.499-.531.249-.133.374-.133.499 0 .125.132.125.531.125.93-.125.399-.125.797-.25 1.063zm-.249-1.861c-.125-.132-.125-.132-.25 0-.125.133-.249.266-.249.399-.125.133-.125.532-.125.931 0 .398 0 .664.125.797.124.133.124.133.249 0s.25-.266.25-.399c.124-.132.124-.531.124-.93s0-.665-.124-.798zM175.027 332.331c-.125.266-.249.531-.499.664-.249.133-.374.133-.499 0s-.125-.531-.125-.93c0-.532.125-.93.25-1.196.125-.266.249-.399.499-.532.249-.133.374-.133.499 0s.125.532.125.93c-.125.266-.125.665-.25 1.064zm-.249-1.861c-.125-.133-.125-.133-.25 0s-.249.266-.249.399c-.125.133-.125.531-.125.93s0 .665.125.798c.124.133.124.133.249 0s.25-.266.25-.399c.124-.133.124-.532.124-.931 0-.531 0-.797-.124-.797zM173.279 333.26c-.125.266-.25.532-.499.665-.25.133-.374.133-.499 0s-.125-.532-.125-.93c0-.532.125-.931.25-1.197.124-.265.249-.398.499-.531.249-.133.374-.133.499 0 .124.133.125.531.125.93s-.125.798-.25 1.063zm-.125-1.86c-.124-.133-.124-.133-.249 0l-.374.398c-.125.133-.125.532-.125.931s0 .664.125.797c.124.133.124.133.249 0s.249-.265.249-.398c.125-.133.125-.532.125-.931.125-.399.125-.664 0-.797zM171.658 334.191c-.125.266-.25.532-.499.665-.25.133-.374.133-.499 0s-.125-.532-.125-.931c0-.531.125-.93.25-1.196.124-.266.249-.399.499-.532.249-.133.374-.133.499 0 .124.133.124.532.124.931s-.124.797-.249 1.063zm-.125-1.861c-.125-.133-.125-.133-.249 0-.125.133-.25.266-.25.399-.125.133-.125.532-.125.93 0 .399 0 .665.125.798s.125.133.25 0c.124-.133.249-.266.249-.399.125-.133.125-.531.125-.93s-.125-.665-.125-.798zM198.104 325.551c-.125.266-.25.399-.375.399-.124.133-.249.133-.374 0s-.125-.399-.125-.665c0-.398 0-.664.125-.93l.374-.399c.125-.133.25-.133.375 0 .124.133.124.399.124.665 0 .531-.124.797-.124.93zm-.125-1.329c0-.133-.125-.133-.25 0-.124 0-.124.133-.249.266s-.125.399-.125.664c0 .266 0 .532.125.532 0 .133.125.133.249 0 .125 0 .125-.133.25-.266 0-.133.125-.398.125-.664s-.125-.399-.125-.532zM196.856 326.349c-.125.266-.25.399-.375.399-.124.133-.249.133-.374 0s-.125-.399-.125-.665c0-.399 0-.664.125-.93l.374-.399c.125-.133.25-.133.375 0 .124.133.124.399.124.665 0 .398 0 .664-.124.93zm-.125-1.329c0-.133-.125-.133-.25 0-.124 0-.124.133-.249.266 0 .133-.125.398-.125.664s0 .532.125.532c0 .133.125.133.249 0 .125 0 .125-.133.25-.266 0-.133.125-.399.125-.664 0-.266 0-.532-.125-.532zM195.733 327.147l-.499-1.728.125-.133.499 1.861h-.125zM195.11 327.413c-.125.265-.25.398-.375.398-.124.133-.249.133-.374 0s-.125-.398-.125-.664c0-.399 0-.665.125-.931l.374-.399c.125-.132.25-.132.375 0 .124.133.124.399.124.665 0 .399 0 .665-.124.931zm-.125-1.463c0-.133-.125-.133-.25 0-.124 0-.124.133-.249.266 0 .133-.125.399-.125.665s0 .532.125.532c0 .132.125.132.249 0 .125 0 .125-.133.25-.266s.125-.399.125-.665c-.125-.133-.125-.399-.125-.532zM193.862 328.077c-.125.265-.25.398-.375.398-.124.133-.249.133-.374 0s-.125-.398-.125-.664c0-.399 0-.665.125-.931l.374-.398c.125-.133.25-.133.375 0 .124.132.124.398.124.664 0 .399 0 .665-.124.931zm-.125-1.33c0-.133-.125-.133-.25 0-.124 0-.124.133-.249.266 0 .133-.125.399-.125.665s0 .532.125.532c0 .132.125.132.249 0 .125 0 .125-.133.25-.266 0-.133.125-.399.125-.665s0-.532-.125-.532z"
            fill="#131A2D"
            />
            <path
            d="M195.859 311.595h.249l1.622-.93-1.622.93h-.249c0-.133-.125-.133-.125-.266v-3.456c0-.133.125-.266.125-.398l1.622-1.064-1.622 1.064c-.125.132-.25.265-.25.398V311.063c.125.399.125.532.25.532z"
            fill="#131A2D"
            />
            <path
            d="M195.734 309.07l1.872-1.063v-.133l-1.872 1.196zM195.734 310.398l1.872-1.196-1.872 1.064v.132zM192.117 314.12l1.122-.798c.125 0 .125-.132.125-.132V309.734c0-.133 0-.133-.125-.266h-.249l-1.123.664 1.123-.664h.249l.125.133v3.323c0 .133-.125.266-.249.398l-.998.798z"
            fill="#131A2D"
            />
            <path
            d="M192.117 311.462l1.372-.798.125-.133h-.125l-1.372.931zM192.117 312.658l1.372-.798h.125v-.132h-.125l-1.372.93zM195.734 309.735l-.998.531h-.125l-.125-.133v-.664c0-.133 0-.133-.124-.133h-.125l-.749.399.749-.399h.125s.124 0 .124.133v.664c0 .133 0 .133.125.133h.25l.873-.531zM193.988 311.861h.125l.374-.133 1.372-.797-.624.398-.748.399-.25.133h-.249v-.797s0-.133-.125-.133h-.125.25v.664c-.125.133-.125.133 0 .266-.125-.133-.125-.133 0 0-.125 0-.125 0 0 0 0 0-.125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.662 326.88l19.96-11.829v-3.589l-19.96 11.83v3.588z"
            fill="#0EA59D"
            />
            <path
            d="M169.537 327.014v-3.722l20.085-11.83v3.722l-20.085 11.83zm.125-3.589v3.323l19.835-11.697v-3.323l-19.835 11.697zM177.021 335.122l7.735-4.519v-1.33l-7.735 4.52v1.329zM171.283 341.369l13.473-7.975v-1.33l-13.473 7.976v1.329zM463.323 289.263h-1.373v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.734 4.785.125-.132-1.497-.133v.664c0 .133 0 .266.249.266l20.834 12.628c.249.132.748.132.997 0l8.858-5.583c.124-.133.249-.266.249-.399l-.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M463.073 288.998L442.24 276.37c-.25-.133-.749-.133-.998 0l-8.857 5.583c-.25.133-.375.532 0 .664l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.25-.266.25-.531 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 295.379c-.25 0-.375 0-.499-.133l-20.834-12.627c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399l8.858-5.583c.374-.265.873-.265 1.122 0l20.834 12.628c.124.133.249.266.249.399s-.125.266-.249.398l-8.858 5.583c-.249.133-.374.133-.623.133zm-11.852-19.141c-.124 0-.374 0-.499.133l-8.857 5.583c-.125.133-.125.133-.125.266s0 .133.125.133l20.833 12.627c.25.133.624.133.874 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628s-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M460.078 288.733c.374-.266.374-.532.125-.665l-16.717-10.235c-.249-.133-.748-.133-.998 0-.249.133-.748.133-.998 0-.249-.133-.748-.133-.998 0l-5.489 3.456c-.249.133-.249.399 0 .665.25.133.25.398 0 .664h-.124c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.399 0-.665l-.249-.133c-.374-.399-.374-.664-.125-.797z"
            fill="url(#paint125_linear_874_76773)"
            />
            <path
            d="M443.488 283.947c-.624 1.064-.5 2.26.374 3.323 1.247 1.595 3.867 2.127 5.863 1.197.749-.399 1.372-.931 1.746-1.595.624-1.064.499-2.26-.374-3.323-1.247-1.595-3.867-2.127-5.863-1.197-.749.399-1.372.931-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M449.474 288.068c1.871-.797 2.37-2.658 1.247-4.12-1.123-1.462-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.248 4.121 1.123 1.462 3.618 1.861 5.365 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 288.599c-1.373 0-2.745-.532-3.493-1.595-.499-.665-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.126 1.871-.798 4.241-.399 5.489 1.063.499.665.748 1.462.499 2.26-.25.93-.873 1.595-1.871 2.126-.624.399-1.248.532-1.996.532zm-.25-5.981c-.624 0-1.247.133-1.871.398-.873.399-1.497 1.064-1.747 1.861-.124.665 0 1.33.499 1.994 1.123 1.329 3.493 1.861 5.24 1.064.873-.399 1.497-1.064 1.746-1.861.125-.665 0-1.33-.499-1.994-.748-.931-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 281.422c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .623-.399.623-.93.124-1.329-.499-.399-1.497-.399-2.12 0z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 283.017c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665 0-.265.25-.664.499-.797.624-.399 1.622-.399 2.246-.133.249.133.499.399.499.665 0 .265-.25.664-.499.797a2.02 2.02 0 01-1.248.399zm-.748-1.595a.739.739 0 00-.375.664c0 .133.125.399.375.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.374-.664 0-.133-.125-.399-.374-.532-.499-.399-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M452.717 288.733c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .624-.399.624-.931.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 290.461a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.398-.499-.664s.249-.665.499-.798c.623-.399 1.621-.399 2.245-.133.25.133.499.399.499.665s-.249.665-.499.797a2.014 2.014 0 01-1.247.399zm.249-1.861c-.374 0-.748.133-1.122.266a.74.74 0 00-.375.665c0 .133.125.399.375.531.499.266 1.497.266 1.996 0 .249-.132.499-.398.499-.664 0-.133-.125-.399-.375-.532-.249-.266-.624-.266-.998-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.323 288.201h-1.373v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.734 4.785.125-.133-1.497-.133v.665c0 .133 0 .266.249.266l20.834 12.627c.249.133.748.133.997 0l8.858-5.583c.124-.133.249-.266.249-.398l-.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M463.073 287.935l-20.833-12.627c-.25-.133-.749-.133-.998 0l-8.857 5.582c-.25.133-.375.532 0 .665l20.833 12.627c.249.133.748.133.998 0l8.857-5.582c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 294.316c-.25 0-.375 0-.499-.133l-20.834-12.628c-.124-.133-.249-.266-.249-.399s.125-.398.249-.398l8.858-5.583c.374-.266.873-.266 1.122 0l20.834 12.627c.124.133.249.266.249.399s-.125.266-.249.399l-8.858 5.583c-.249.133-.374.133-.623.133zm-11.852-19.141c-.124 0-.374 0-.499.133l-8.857 5.583c-.125.132-.125.132-.125.265s0 .133.125.133l20.833 12.628c.25.133.624.133.874 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M460.078 287.669c.374-.266.374-.532.125-.664l-16.717-10.235c-.249-.133-.748-.133-.998 0-.249.133-.748.133-.998 0-.249-.133-.748-.133-.998 0l-5.489 3.456c-.249.132-.249.398 0 .664.25.133.25.399 0 .665h-.124c-.25.133-.25.399 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.399 0-.664l-.249-.133c-.374-.399-.374-.665-.125-.798z"
            fill="url(#paint126_linear_874_76773)"
            />
            <path
            d="M443.488 282.885c-.624 1.063-.5 2.26.374 3.323 1.247 1.595 3.867 2.127 5.863 1.196.749-.399 1.372-.93 1.746-1.595.624-1.063.499-2.259-.374-3.323-1.247-1.595-3.867-2.127-5.863-1.196-.749.399-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M449.474 287.006c1.871-.798 2.37-2.659 1.247-4.121-1.123-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.248 4.12 1.123 1.462 3.618 1.861 5.365 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 287.537c-1.373 0-2.745-.532-3.493-1.595-.499-.665-.749-1.463-.499-2.26.249-.931.873-1.595 1.871-2.127 1.871-.797 4.241-.399 5.489 1.064.499.664.748 1.462.499 2.259-.25.931-.873 1.595-1.871 2.127-.624.399-1.248.532-1.996.532zm-.25-5.982c-.624 0-1.247.133-1.871.399-.873.399-1.497 1.063-1.747 1.861-.124.664 0 1.329.499 1.994 1.123 1.329 3.493 1.861 5.24 1.063.873-.399 1.497-1.063 1.746-1.861.125-.664 0-1.329-.499-1.994-.748-.93-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 280.359c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.623-.398.623-.93.124-1.329-.499-.399-1.497-.266-2.12.133z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 281.954c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665 0-.265.25-.664.499-.797.624-.399 1.622-.399 2.246 0 .249.133.499.399.499.664 0 .266-.25.665-.499.798-.375.133-.749.266-1.248.266zm-.748-1.595a.739.739 0 00-.375.664c0 .133.125.399.375.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.374-.665 0-.132-.125-.398-.374-.531-.499-.399-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M452.717 287.668c-.624.399-.624.931-.125 1.329.624.399 1.497.266 2.121 0 .624-.398.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 289.397a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.399-.499-.665s.249-.664.499-.797c.623-.399 1.621-.399 2.245-.133.25.133.499.399.499.664 0 .266-.249.665-.499.798a2.014 2.014 0 01-1.247.399zm.249-1.861c-.374 0-.748.133-1.122.266a.738.738 0 00-.375.664c0 .133.125.399.375.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.499-.665 0-.133-.125-.398-.375-.531-.249-.266-.624-.266-.998-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.323 287.137h-1.373v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.734 4.785.125-.132-1.497-.133v.664c0 .133 0 .266.249.266l20.834 12.628c.249.132.748.132.997 0l8.858-5.583c.124-.133.249-.266.249-.399l-.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M463.073 286.872l-20.833-12.628c-.25-.133-.749-.133-.998 0l-8.857 5.583c-.25.133-.375.532 0 .664l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.25-.266.25-.531 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 293.252c-.25 0-.375 0-.499-.133l-20.834-12.627c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399l8.858-5.583c.374-.265.873-.265 1.122 0l20.834 12.628c.124.133.249.266.249.399s-.125.266-.249.398l-8.858 5.583c-.249.133-.374.133-.623.133zm-11.852-19.141c-.124 0-.374 0-.499.133l-8.857 5.583c-.125.133-.125.133-.125.266s0 .133.125.133l20.833 12.627c.25.133.624.133.874 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628s-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M460.078 286.606c.374-.266.374-.532.125-.665l-16.717-10.235c-.249-.133-.748-.133-.998 0-.249.133-.748.133-.998 0-.249-.133-.748-.133-.998 0l-5.489 3.456c-.249.133-.249.399 0 .665.25.133.25.399 0 .665h-.124c-.25.132-.25.398 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.399 0-.665l-.249-.133c-.374-.398-.374-.664-.125-.797z"
            fill="url(#paint127_linear_874_76773)"
            />
            <path
            d="M443.488 281.821c-.624 1.064-.5 2.26.374 3.323 1.247 1.596 3.867 2.127 5.863 1.197.749-.399 1.372-.931 1.746-1.595.624-1.064.499-2.26-.374-3.323-1.247-1.595-3.867-2.127-5.863-1.197-.749.399-1.372.931-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M449.474 285.941c1.871-.797 2.37-2.658 1.247-4.12-1.123-1.462-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.248 4.121 1.123 1.462 3.618 1.861 5.365 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 286.472c-1.373 0-2.745-.532-3.493-1.595-.499-.664-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.126 1.871-.798 4.241-.399 5.489 1.063.499.665.748 1.462.499 2.26-.25.93-.873 1.595-1.871 2.126-.624.399-1.248.532-1.996.532zm-.25-5.981c-.624 0-1.247.133-1.871.399-.873.398-1.497 1.063-1.747 1.86-.124.665 0 1.33.499 1.994 1.123 1.329 3.493 1.861 5.24 1.064.873-.399 1.497-1.064 1.746-1.861.125-.665 0-1.33-.499-1.994-.748-.931-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 279.296c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.623-.399.623-.931.124-1.329-.499-.399-1.497-.266-2.12.133z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 280.89c-.374 0-.748-.133-.998-.266-.249-.132-.499-.398-.499-.664s.25-.665.499-.798c.624-.398 1.622-.398 2.246 0 .249.133.499.399.499.665s-.25.665-.499.797c-.375.133-.749.266-1.248.266zm-.748-1.595a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.265 1.497.265 1.996-.133.249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.499-.265-1.497-.133-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M452.717 286.606c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .624-.399.624-.931.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 288.334a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.398-.499-.664s.249-.665.499-.798c.623-.398 1.621-.398 2.245-.133.25.133.499.399.499.665s-.249.665-.499.797a2.014 2.014 0 01-1.247.399zm.249-1.861c-.374 0-.748.133-1.122.266a.74.74 0 00-.375.665c0 .133.125.399.375.531.499.266 1.497.266 1.996 0 .249-.132.499-.398.499-.664 0-.133-.125-.399-.375-.532-.249-.266-.624-.266-.998-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.323 286.074h-1.373v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.734 4.785.125-.133-1.497-.133v.665c0 .133 0 .266.249.266l20.834 12.627c.249.133.748.133.997 0l8.858-5.583c.124-.133.249-.265.249-.398l-.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M463.073 285.808l-20.833-12.627c-.25-.133-.749-.133-.998 0l-8.857 5.582c-.25.133-.375.532 0 .665l20.833 12.627c.249.133.748.133.998 0l8.857-5.582c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 292.189c-.25 0-.375 0-.499-.133l-20.834-12.628c-.124-.133-.249-.266-.249-.399 0-.132.125-.265.249-.398l8.858-5.583c.374-.266.873-.266 1.122 0l20.834 12.627c.124.133.249.266.249.399s-.125.266-.249.399l-8.858 5.583c-.249.133-.374.133-.623.133zm-11.852-19.141c-.124 0-.374 0-.499.133l-8.857 5.583c-.125.133-.125.133-.125.265 0 .133 0 .133.125.133l20.833 12.628c.25.133.624.133.874 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M460.078 285.542c.374-.266.374-.532.125-.664l-16.717-10.235c-.249-.133-.748-.133-.998 0-.249.133-.748.133-.998 0-.249-.133-.748-.133-.998 0l-5.489 3.456c-.249.133-.249.398 0 .664.25.133.25.399 0 .665h-.124c-.25.133-.25.399 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.399 0-.664l-.374-.266c-.249-.266-.249-.532 0-.665z"
            fill="url(#paint128_linear_874_76773)"
            />
            <path
            d="M443.488 280.758c-.624 1.063-.5 2.26.374 3.323 1.247 1.595 3.867 2.127 5.863 1.196.749-.398 1.372-.93 1.746-1.595.624-1.063.499-2.259-.374-3.323-1.247-1.595-3.867-2.127-5.863-1.196-.749.399-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M449.474 284.879c1.871-.798 2.37-2.659 1.247-4.121-1.123-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.248 4.12 1.123 1.463 3.618 1.861 5.365 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 285.41c-1.373 0-2.745-.532-3.493-1.595-.499-.665-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.127 1.871-.797 4.241-.399 5.489 1.064.499.664.748 1.462.499 2.259-.25.931-.873 1.595-1.871 2.127-.624.399-1.248.532-1.996.532zm-.25-5.982c-.624 0-1.247.133-1.871.399-.873.399-1.497 1.063-1.747 1.861-.124.665 0 1.329.499 1.994 1.123 1.329 3.493 1.861 5.24 1.063.873-.399 1.497-1.063 1.746-1.861.125-.664 0-1.329-.499-1.994-.748-.93-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 278.232c-.624.399-.624.931-.125 1.329.624.399 1.497.266 2.121-.133.623-.398.623-.93.124-1.329-.499-.399-1.497-.266-2.12.133z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 279.827c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665 0-.265.25-.664.499-.797.624-.399 1.622-.399 2.246 0 .249.133.499.399.499.664 0 .266-.25.665-.499.798-.375.133-.749.266-1.248.266zm-.748-1.595a.739.739 0 00-.375.664c0 .133.125.399.375.532.499.266 1.497.266 1.996-.133.249-.133.499-.399.374-.664 0-.133-.125-.399-.374-.532-.499-.266-1.497-.133-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M452.717 285.542c-.624.399-.624.931-.125 1.329.624.399 1.497.266 2.121 0 .624-.398.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 287.271a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.399-.499-.665 0-.265.249-.664.499-.797.623-.399 1.621-.399 2.245-.133.25.133.499.399.499.664 0 .266-.249.665-.499.798a2.014 2.014 0 01-1.247.399zm.249-1.861c-.374 0-.748.133-1.122.266a.739.739 0 00-.375.664c0 .133.125.399.375.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.499-.665 0-.133-.125-.398-.375-.531-.249-.266-.624-.266-.998-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.323 285.011h-1.373v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.734 4.786.125-.133-1.497-.133v.664c0 .133 0 .266.249.266l20.834 12.628c.249.132.748.132.997 0l8.858-5.583c.124-.133.249-.266.249-.399l-.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M463.073 284.746l-20.833-12.628c-.25-.133-.749-.133-.998 0l-8.857 5.583c-.25.133-.375.532 0 .665l20.833 12.627c.249.133.748.133.998 0l8.857-5.583c.25-.266.25-.531 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 291.126c-.25 0-.375 0-.499-.133l-20.834-12.627c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399l8.858-5.582c.374-.266.873-.266 1.122 0l20.834 12.627c.124.133.249.266.249.399s-.125.266-.249.398l-8.858 5.583c-.249.133-.374.133-.623.133zm-11.852-19.14c-.124 0-.374 0-.499.132l-8.857 5.583c-.125.133-.125.133-.125.266s0 .133.125.133l20.833 12.627c.25.133.624.133.874 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628s-.25-.132-.375-.132z"
            fill="#131A2D"
            />
            <path
            d="M460.078 284.48c.374-.266.374-.532.125-.665l-16.717-10.235c-.249-.133-.748-.133-.998 0-.249.133-.748.133-.998 0-.249-.133-.748-.133-.998 0l-5.489 3.456c-.249.133-.249.399 0 .665.25.133.25.398 0 .664h-.124c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.399 0-.665l-.249-.133c-.374-.399-.374-.664-.125-.797z"
            fill="url(#paint129_linear_874_76773)"
            />
            <path
            d="M443.488 279.695c-.624 1.064-.5 2.26.374 3.323 1.247 1.596 3.867 2.127 5.863 1.197.749-.399 1.372-.931 1.746-1.595.624-1.064.499-2.26-.374-3.323-1.247-1.595-3.867-2.127-5.863-1.197-.749.399-1.372.931-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M449.474 283.815c1.871-.797 2.37-2.658 1.247-4.12-1.123-1.462-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.248 4.121 1.123 1.462 3.618 1.861 5.365 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 284.346c-1.373 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.126 1.871-.798 4.241-.399 5.489 1.063.499.665.748 1.462.499 2.26-.25.93-.873 1.595-1.871 2.127-.624.398-1.248.531-1.996.531zm-.25-5.981c-.624 0-1.247.133-1.871.399-.873.398-1.497 1.063-1.747 1.86-.124.665 0 1.33.499 1.994 1.123 1.329 3.493 1.861 5.24 1.064.873-.399 1.497-1.064 1.746-1.861.125-.665 0-1.33-.499-1.994-.748-.931-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 277.17c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.623-.399.623-.931.124-1.329-.499-.399-1.497-.266-2.12.133z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 278.764c-.374 0-.748-.133-.998-.266-.249-.132-.499-.398-.499-.664s.25-.665.499-.798c.624-.398 1.622-.398 2.246 0 .249.133.499.399.499.665s-.25.665-.499.797c-.375.133-.749.266-1.248.266zm-.748-1.595a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.265 1.497.265 1.996 0 .249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.499-.398-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M452.717 284.48c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .624-.399.624-.931.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 286.208a2.23 2.23 0 01-.998-.266c-.25-.132-.499-.398-.499-.664s.249-.665.499-.798c.623-.398 1.621-.398 2.245-.133.25.133.499.399.499.665s-.249.665-.499.798a2.305 2.305 0 01-1.247.398zm.249-1.861c-.374 0-.748.133-1.122.266a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.265 1.497.265 1.996 0 .249-.133.499-.399.499-.665 0-.133-.125-.399-.375-.532-.249-.266-.624-.266-.998-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.323 283.947h-1.373v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.734 4.785.125-.133-1.497-.133v.665c0 .133 0 .266.249.266l20.834 12.627c.249.133.748.133.997 0l8.858-5.583c.124-.132.249-.265.249-.398l-.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M463.073 283.681l-20.833-12.627c-.25-.133-.749-.133-.998 0l-8.857 5.582c-.25.133-.375.532 0 .665l20.833 12.628c.249.132.748.132.998 0l8.857-5.583c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 290.062c-.25 0-.375 0-.499-.133l-20.834-12.628c-.124-.133-.249-.266-.249-.399 0-.132.125-.265.249-.398l8.858-5.583c.374-.266.873-.266 1.122 0l20.834 12.628c.124.132.249.265.249.398s-.125.266-.249.399l-8.858 5.583c-.249.133-.374.133-.623.133zm-11.852-19.141c-.124 0-.374 0-.499.133l-8.857 5.583c-.125.133-.125.133-.125.265 0 .133 0 .133.125.133l20.833 12.628c.25.133.624.133.874 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M460.078 283.415c.374-.266.374-.531.125-.664l-16.717-10.235c-.249-.133-.748-.133-.998 0-.249.133-.748.133-.998 0-.249-.133-.748-.133-.998 0l-5.489 3.456c-.249.133-.249.398 0 .664.25.133.25.399 0 .665h-.124c-.25.133-.25.399 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.398 0-.664l-.249-.133c-.374-.399-.374-.665-.125-.798z"
            fill="url(#paint130_linear_874_76773)"
            />
            <path
            d="M443.488 278.631c-.624 1.063-.5 2.26.374 3.323 1.247 1.595 3.867 2.127 5.863 1.196.749-.398 1.372-.93 1.746-1.595.624-1.063.499-2.259-.374-3.323-1.247-1.595-3.867-2.126-5.863-1.196-.749.399-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M449.474 282.752c1.871-.798 2.37-2.659 1.247-4.121-1.123-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.248 4.12 1.248 1.33 3.618 1.861 5.365 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 283.283c-1.373 0-2.745-.532-3.493-1.595-.499-.665-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.127 1.871-.797 4.241-.398 5.489 1.064.499.664.748 1.462.499 2.259-.25.931-.873 1.595-1.871 2.127-.624.399-1.248.532-1.996.532zm-.25-5.982c-.624 0-1.247.133-1.871.399-.873.399-1.497 1.063-1.747 1.861-.124.665 0 1.329.499 1.994 1.123 1.329 3.493 1.861 5.24 1.063.873-.399 1.497-1.063 1.746-1.861.125-.664 0-1.329-.499-1.994-.748-.93-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 275.971c-.624.399-.624.931-.125 1.33.624.398 1.497.265 2.121 0 .623-.399.623-.931.124-1.33-.499-.398-1.497-.265-2.12 0z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 277.7c-.374 0-.748-.132-.998-.265-.249-.133-.499-.399-.499-.665s.25-.665.499-.798c.624-.398 1.622-.398 2.246-.132.249.132.499.398.499.664s-.25.665-.499.798a2.019 2.019 0 01-1.248.398zm-.748-1.595a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.499-.398-1.497-.265-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M452.717 283.416c-.624.399-.624.931-.125 1.329.624.399 1.497.266 2.121 0 .624-.398.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 285.144a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.399-.499-.665 0-.265.249-.664.499-.797.623-.399 1.621-.399 2.245-.133.25.133.499.399.499.665 0 .265-.249.664-.499.797a2.014 2.014 0 01-1.247.399zm.249-1.861c-.374 0-.748.133-1.122.266a.739.739 0 00-.375.664c0 .133.125.399.375.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.499-.665 0-.132-.125-.398-.375-.531-.249-.266-.624-.266-.998-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.323 282.884h-1.373v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.734 4.786.125-.133-1.497-.133v.664c0 .133 0 .266.249.266l20.834 12.628c.249.133.748.133.997 0l8.858-5.583c.124-.133.249-.266.249-.399l-.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M463.073 282.619l-20.833-12.628c-.25-.133-.749-.133-.998 0l-8.857 5.583c-.25.133-.375.532 0 .665l20.833 12.627c.249.133.748.133.998 0l8.857-5.583c.25-.265.25-.531 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 288.999c-.25 0-.375 0-.499-.133l-20.834-12.627c-.124-.133-.249-.266-.249-.399s.125-.399.249-.399l8.858-5.582c.374-.266.873-.266 1.122 0l20.834 12.627c.124.133.249.266.249.399s-.125.266-.249.399l-8.858 5.582c-.249.133-.374.133-.623.133zm-11.852-19.14c-.124 0-.374 0-.499.132l-8.857 5.583c-.125.133-.125.133-.125.266s0 .133.125.133l20.833 12.627c.25.133.624.133.874 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628c0-.132-.25-.132-.375-.132z"
            fill="#131A2D"
            />
            <path
            d="M460.078 282.353c.374-.266.374-.532.125-.665l-16.717-10.235c-.249-.132-.748-.132-.998 0-.249.133-.748.133-.998 0-.249-.132-.748-.132-.998 0l-5.489 3.456c-.249.133-.249.399 0 .665.25.133.25.399 0 .665h-.124c-.25.133-.25.398 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.399 0-.665l-.249-.133c-.374-.398-.374-.664-.125-.797z"
            fill="url(#paint131_linear_874_76773)"
            />
            <path
            d="M443.488 277.568c-.624 1.063-.5 2.259.374 3.323 1.247 1.595 3.867 2.126 5.863 1.196.749-.399 1.372-.931 1.746-1.595.624-1.064.499-2.26-.374-3.323-1.247-1.595-3.867-2.127-5.863-1.197-.749.399-1.372.931-1.746 1.596z"
            fill="#fff"
            />
            <path
            d="M449.474 281.688c1.871-.797 2.37-2.658 1.247-4.12-1.123-1.462-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.248 4.121 1.248 1.329 3.618 1.861 5.365 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 282.219c-1.373 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.596 1.871-2.127 1.871-.798 4.241-.399 5.489 1.063.499.665.748 1.462.499 2.26-.25.93-.873 1.595-1.871 2.127-.624.398-1.248.531-1.996.531zm-.25-5.981c-.624 0-1.247.133-1.871.399-.873.398-1.497 1.063-1.747 1.86-.124.665 0 1.33.499 1.994 1.123 1.329 3.493 1.861 5.24 1.064.873-.399 1.497-1.064 1.746-1.861.125-.665 0-1.329-.499-1.994-.748-1.063-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 274.91c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.623-.399.623-.93.124-1.329-.499-.266-1.497-.133-2.12.133z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 276.637c-.374 0-.748-.133-.998-.265-.249-.133-.499-.399-.499-.665s.25-.665.499-.798c.624-.398 1.622-.398 2.246 0 .249.133.499.399.499.665s-.25.665-.499.798c-.375.132-.749.265-1.248.265zm-.748-1.595a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.265 1.497.265 1.996-.133.249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.499-.265-1.497-.132-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M452.717 282.352c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .624-.399.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 284.08a2.23 2.23 0 01-.998-.266c-.25-.132-.499-.398-.499-.664s.249-.665.499-.798c.623-.398 1.621-.398 2.245-.133.25.133.499.399.499.665s-.249.665-.499.798a2.02 2.02 0 01-1.247.398zm.249-1.861c-.374 0-.748.133-1.122.266a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.265 1.497.265 1.996 0 .249-.133.499-.399.499-.665 0-.133-.125-.399-.375-.532-.249-.266-.624-.266-.998-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.323 281.821h-1.373v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.734 4.785.125-.133-1.497-.133v.665c0 .133 0 .266.249.266l20.834 12.627c.249.133.748.133.997 0l8.858-5.583c.124-.132.249-.265.249-.398l-.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M463.073 281.554l-20.833-12.627c-.25-.133-.749-.133-.998 0l-8.857 5.583c-.25.132-.375.531 0 .664l20.833 12.628c.249.132.748.132.998 0l8.857-5.583c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 287.936c-.25 0-.375 0-.499-.133l-20.834-12.628c-.124-.133-.249-.266-.249-.398 0-.133.125-.266.249-.399l8.858-5.583c.374-.266.873-.266 1.122 0l20.834 12.628c.124.132.249.265.249.398s-.125.266-.249.399l-8.858 5.583c-.249.133-.374.133-.623.133zm-11.852-19.141c-.124 0-.374 0-.499.133l-8.857 5.583c-.125.133-.125.133-.125.266 0 .132 0 .132.125.132l20.833 12.628c.25.133.624.133.874 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627c0-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M460.078 281.289c.374-.266.374-.531.125-.664l-16.717-10.235c-.249-.133-.748-.133-.998 0-.249.133-.748.133-.998 0-.249-.133-.748-.133-.998 0l-5.489 3.456c-.249.133-.249.398 0 .664.25.133.25.399 0 .665h-.124c-.25.133-.25.399 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.398 0-.664l-.249-.133c-.374-.399-.374-.665-.125-.798z"
            fill="url(#paint132_linear_874_76773)"
            />
            <path
            d="M443.488 276.504c-.624 1.063-.5 2.26.374 3.323 1.247 1.595 3.867 2.127 5.863 1.196.749-.398 1.372-.93 1.746-1.595.624-1.063.499-2.259-.374-3.323-1.247-1.595-3.867-2.126-5.863-1.196-.749.399-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M449.474 280.625c1.871-.798 2.37-2.659 1.247-4.121-1.123-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.248 4.12 1.123 1.463 3.618 1.861 5.365 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 281.156c-1.373 0-2.745-.532-3.493-1.595-.499-.665-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.127 1.871-.797 4.241-.398 5.489 1.064.499.664.748 1.462.499 2.259-.25.931-.873 1.595-1.871 2.127-.624.399-1.248.532-1.996.532zm-.25-5.982c-.624 0-1.247.133-1.871.399-.873.399-1.497 1.063-1.747 1.861-.124.665 0 1.329.499 1.994 1.123 1.329 3.493 1.861 5.24 1.063.873-.399 1.497-1.063 1.746-1.861.125-.664 0-1.329-.499-1.994-.748-1.063-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 273.846c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.623-.398.623-.93.124-1.329-.499-.399-1.497-.133-2.12.133z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 275.574c-.374 0-.748-.132-.998-.265-.249-.133-.499-.399-.499-.665s.25-.665.499-.797c.624-.399 1.622-.399 2.246-.133.249.133.499.398.499.664s-.25.665-.499.798a2.019 2.019 0 01-1.248.398zm-.748-1.595a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.499-.398-1.497-.398-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M452.717 281.29c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .624-.399.624-.931.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 283.018a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.399-.499-.665 0-.265.249-.664.499-.797.623-.399 1.621-.399 2.245-.133.25.133.499.399.499.665 0 .265-.249.664-.499.797a2.014 2.014 0 01-1.247.399zm.249-1.861c-.374 0-.748.133-1.122.266a.739.739 0 00-.375.664c0 .133.125.399.375.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.499-.665 0-.132-.125-.398-.375-.531-.249-.266-.624-.266-.998-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.323 280.758h-1.373v.398l-19.586-11.963c-.249-.132-.748-.132-.998 0l-7.734 4.786.125-.133-1.497-.133v.664c0 .133 0 .266.249.266l20.834 12.628c.249.133.748.133.997 0l8.858-5.583c.124-.133.249-.266.249-.399l-.124-.531z"
            fill="#131A2D"
            />
            <path
            d="M463.073 280.492l-20.833-12.628c-.25-.133-.749-.133-.998 0l-8.857 5.583c-.25.133-.375.532 0 .665l20.833 12.627c.249.133.748.133.998 0l8.857-5.583c.25-.265.25-.531 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M453.592 286.872c-.25 0-.375 0-.499-.133l-20.834-12.627c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399l8.858-5.582c.374-.266.873-.266 1.122 0l20.834 12.627c.124.133.249.266.249.399s-.125.266-.249.399l-8.858 5.582c-.249.133-.374.133-.623.133zm-11.852-19.14c-.124 0-.374 0-.499.133l-8.857 5.582c-.125.133-.125.133-.125.266s0 .133.125.133l20.833 12.627c.25.133.624.133.874 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627c0-.133-.25-.133-.375-.133z"
            fill="#131A2D"
            />
            <path
            d="M460.078 280.226c.374-.266.374-.532.125-.665l-16.717-10.235c-.249-.133-.748-.133-.998 0-.249.133-.748.133-.998 0-.249-.133-.748-.133-.998 0l-5.489 3.456c-.249.133-.249.399 0 .665.25.133.25.399 0 .664h-.124c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.249-.133.748-.133.998 0l.249.133c.25.133.749.133.998 0l5.489-3.323c.25-.133.25-.399 0-.665l-.249-.133c-.374-.398-.374-.664-.125-.797z"
            fill="#fff"
            />
            <path
            d="M454.339 285.144c-.249 0-.374 0-.499-.133l-.249-.133a1.007 1.007 0 00-.874 0h-.124c-.25.133-.749.133-1.123 0l-16.717-10.235c-.124-.133-.249-.266-.249-.398 0-.133.125-.266.249-.399h.125c.125 0 .125-.133.125-.266s0-.133-.125-.133c-.125-.133-.249-.266-.249-.399s.124-.266.249-.399l5.489-3.455c.25-.133.749-.133 1.123 0 .249.132.624.132.873 0 .25-.133.749-.266 1.123 0l16.716 10.234c.125.133.25.266.25.399s-.125.266-.25.399h-.124c-.125 0-.125.133-.125.266s0 .133.125.133l.249.133c.125.133.25.265.25.398s-.125.266-.25.399l-5.489 3.323c-.125.266-.249.266-.499.266zm-1.123-.532c.25 0 .375 0 .499.133l.25.133c.249.133.624.133.873 0l5.489-3.323c.125 0 .125-.133.125-.266s0-.133-.125-.133l-.249-.265c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399h.124c.125 0 .125-.133.125-.266s0-.133-.125-.133l-16.716-10.235a1.005 1.005 0 00-.873 0c-.25.133-.749.266-1.123 0a1.005 1.005 0 00-.873 0l-5.489 3.456c-.125 0-.125.133-.125.266s0 .133.125.133c.124.133.249.266.249.399s-.125.266-.249.399h-.125c-.125 0-.125.133-.125.265 0 .133 0 .133.125.133l16.716 10.235c.25.133.624.133.874 0h.124c0-.133.25-.133.499-.133z"
            fill="#131A2D"
            />
            <path
            d="M443.488 275.442c-.624 1.063-.5 2.259.374 3.323 1.247 1.595 3.867 2.126 5.863 1.196.749-.399 1.372-.931 1.746-1.595.624-1.064.499-2.26-.374-3.323-1.247-1.595-3.867-2.127-5.863-1.196-.749.398-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M449.474 279.561c1.871-.797 2.37-2.658 1.247-4.12-1.123-1.462-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.248 4.121 1.123 1.462 3.618 1.861 5.365 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M447.604 280.092c-1.373 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.595 1.871-2.127 1.871-.798 4.241-.399 5.489 1.063.499.665.748 1.462.499 2.26-.25.93-.873 1.595-1.871 2.127-.624.398-1.248.531-1.996.531zm-.25-5.981c-.624 0-1.247.133-1.871.399-.873.398-1.497 1.063-1.747 1.861-.124.664 0 1.329.499 1.993 1.123 1.33 3.493 1.861 5.24 1.064.873-.399 1.497-1.064 1.746-1.861.125-.665 0-1.329-.499-1.994-.748-1.063-1.996-1.462-3.368-1.462z"
            fill="#131A2D"
            />
            <path
            d="M440.493 272.783c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.623-.399.623-.93.124-1.329-.499-.266-1.497-.133-2.12.133z"
            fill="#0EA59D"
            />
            <path
            d="M441.366 274.51c-.374 0-.748-.132-.998-.265-.249-.133-.499-.399-.499-.665s.25-.665.499-.798c.624-.398 1.622-.398 2.246 0 .249.133.499.399.499.665s-.25.665-.499.798c-.375.133-.749.265-1.248.265zm-.748-1.595a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.266 1.497.266 1.996-.133.249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.499-.265-1.497-.265-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M452.717 280.226c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .624-.399.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M453.591 281.954c-.375 0-.749-.133-.998-.265-.25-.133-.499-.399-.499-.665s.249-.665.499-.798c.623-.398 1.621-.398 2.245-.133.25.133.499.399.499.665s-.249.665-.499.798a2.02 2.02 0 01-1.247.398zm.249-1.861c-.374 0-.748.133-1.122.266a.74.74 0 00-.375.665c0 .133.125.399.375.532.499.265 1.497.265 1.996 0 .249-.133.499-.399.499-.665 0-.133-.125-.399-.375-.532-.249-.266-.624-.266-.998-.266zM451.846 294.848h-1.372v.398l-19.586-11.962c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.133-1.497-.133v.664c0 .133 0 .266.25.266l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.531z"
            fill="#131A2D"
            />
            <path
            d="M451.597 294.581l-20.834-12.628c-.249-.132-.748-.132-.998 0l-8.857 5.583c-.249.133-.374.532 0 .665l20.833 12.627c.25.133.749.133.998 0l8.858-5.582c.249-.133.249-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M442.115 301.094c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.399.25-.399l8.857-5.582c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25 0-.499.133-.624.133zm-11.851-19.14c-.125 0-.375 0-.499.132l-8.858 5.583c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628c0-.132-.25-.132-.374-.132z"
            fill="#131A2D"
            />
            <path
            d="M448.601 294.315c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.399 0 .665h-.125c-.25.132-.25.398 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.265-.374-.531-.125-.797z"
            fill="url(#paint133_linear_874_76773)"
            />
            <path
            d="M432.011 289.663c-.624 1.064-.499 2.26.374 3.324 1.248 1.595 3.867 2.126 5.863 1.196.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.197a3.012 3.012 0 00-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M437.997 293.651c1.871-.797 2.37-2.658 1.248-4.12-1.123-1.462-3.493-1.861-5.365-1.063-1.871.797-2.37 2.658-1.247 4.12 1.247 1.462 3.618 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M436.127 294.182c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.595 1.871-2.127 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.127-.624.398-1.372.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.398-1.497 1.063-1.746 1.861-.125.664 0 1.329.499 1.993 1.122 1.33 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.93-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M429.016 287.004c-.624.399-.624.931-.125 1.33.624.398 1.497.265 2.121 0 .624-.399.624-.931.125-1.33-.499-.398-1.497-.398-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M429.89 288.733a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.399-.499-.665 0-.265.249-.664.499-.797.623-.399 1.621-.399 2.245-.133.25.133.499.399.499.665 0 .265-.249.664-.499.797a2.014 2.014 0 01-1.247.399zm-.749-1.595a.74.74 0 00-.374.664c0 .133.125.399.374.532.499.266 1.497.266 1.996-.133a.738.738 0 00.374-.664c0-.133-.124-.399-.374-.532-.499-.266-1.497-.266-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M441.243 294.449c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .623-.399.623-.931.124-1.329a2.027 2.027 0 00-2.12 0z"
            fill="#0EA59D"
            />
            <path
            d="M442.116 296.043c-.374 0-.748-.132-.998-.265-.249-.133-.499-.399-.499-.665s.25-.665.499-.797c.624-.399 1.622-.399 2.246-.133.249.133.499.398.499.664s-.25.665-.499.798c-.375.398-.874.398-1.248.398zm.25-1.86c-.375 0-.749.133-1.123.265-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.125-.132-.499-.265-.873-.265z"
            fill="#131A2D"
            />
            <path
            d="M451.846 293.784h-1.372v.398l-19.586-11.962c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.133-1.497-.133v.664c0 .133 0 .266.25.266l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.531z"
            fill="#131A2D"
            />
            <path
            d="M451.597 293.518l-20.834-12.628c-.249-.132-.748-.132-.998 0l-8.857 5.583c-.249.133-.374.532 0 .665l20.833 12.627c.25.133.749.133.998 0l8.858-5.582c.249-.266.249-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M442.115 300.031c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.582c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25 0-.375.133-.624.133zm-11.851-19.14c-.125 0-.375 0-.499.132l-8.858 5.583c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628c0-.132-.25-.132-.374-.132z"
            fill="#131A2D"
            />
            <path
            d="M448.601 293.252c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.399 0 .665h-.125c-.25.132-.25.398 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.265-.374-.531-.125-.797z"
            fill="url(#paint134_linear_874_76773)"
            />
            <path
            d="M432.011 288.6c-.624 1.064-.499 2.26.374 3.324 1.248 1.595 3.867 2.126 5.863 1.196.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.197a3.012 3.012 0 00-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M437.997 292.588c1.871-.797 2.37-2.658 1.248-4.12-1.123-1.462-3.493-1.861-5.365-1.063-1.871.797-2.37 2.658-1.247 4.12 1.123 1.462 3.618 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M436.127 293.119c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.595 1.871-2.127 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.127-.624.398-1.372.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.398-1.497 1.063-1.746 1.861-.125.664 0 1.329.499 1.993 1.122 1.33 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.93-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M429.016 285.941c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.624-.399.624-.93.125-1.329-.499-.266-1.497-.266-2.121.133z"
            fill="#0EA59D"
            />
            <path
            d="M429.89 287.668a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.398-.499-.664s.249-.665.499-.798c.623-.399 1.621-.399 2.245 0 .25.133.499.399.499.665s-.249.664-.499.797c-.374.133-.748.266-1.247.266zm-.749-1.595a.74.74 0 00-.374.665c0 .133.125.398.374.531.499.266 1.497.266 1.996-.133.25-.132.374-.398.374-.664 0-.133-.124-.399-.374-.532-.499-.266-1.497-.266-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M441.243 293.384c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .623-.399.623-.93.124-1.329a2.027 2.027 0 00-2.12 0z"
            fill="#0EA59D"
            />
            <path
            d="M442.116 294.98c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665s.25-.665.499-.797c.624-.399 1.622-.399 2.246-.133.249.133.499.398.499.664s-.25.665-.499.798c-.375.399-.874.399-1.248.399zm.25-1.861c-.375 0-.749.133-1.123.265-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.125-.132-.499-.265-.873-.265z"
            fill="#131A2D"
            />
            <path
            d="M451.846 292.721h-1.372v.399l-19.586-11.963c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.132-1.497-.133v.664c0 .133 0 .266.25.266l20.833 12.628c.249.132.748.132.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.532z"
            fill="#131A2D"
            />
            <path
            d="M451.597 292.455l-20.834-12.628c-.249-.133-.748-.133-.998 0l-8.857 5.583c-.249.133-.374.532 0 .664l20.833 12.628c.25.133.749.133.998 0l8.858-5.583c.249-.266.249-.531 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M442.115 298.968c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.583c.374-.266.873-.266 1.123 0l20.833 12.628c.125.133.249.266.249.399 0 .132-.124.398-.249.398l-8.857 5.583c-.25 0-.499.133-.624.133zm-11.851-19.141c-.125 0-.375 0-.499.133l-8.858 5.583c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.583c.125-.132.125-.132.125-.265s0-.133-.125-.133l-20.833-12.628c0-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M448.601 292.189c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.398 0 .664h-.125c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.266-.374-.532-.125-.797z"
            fill="url(#paint135_linear_874_76773)"
            />
            <path
            d="M432.011 287.537c-.624 1.064-.499 2.26.374 3.323 1.248 1.595 3.867 2.127 5.863 1.197.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.324-1.248-1.595-3.868-2.126-5.864-1.196a3.012 3.012 0 00-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M437.997 291.525c1.871-.797 2.37-2.658 1.248-4.12-1.123-1.462-3.493-1.861-5.365-1.064-1.871.798-2.37 2.659-1.247 4.121 1.123 1.462 3.618 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M436.127 292.056c-1.372 0-2.745-.532-3.493-1.595-.499-.664-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.126 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.126-.624.399-1.372.532-1.996.532zm-.25-5.981c-.623 0-1.247.133-1.871.398-.873.399-1.497 1.064-1.746 1.861-.125.665 0 1.33.499 1.994 1.122 1.329 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.33-.499-1.994-.749-.931-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M429.016 284.877c-.624.399-.624.931-.125 1.329.624.399 1.497.266 2.121 0 .624-.398.624-.93.125-1.329-.499-.399-1.497-.399-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M429.89 286.606a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.399-.499-.665s.249-.664.499-.797c.623-.399 1.621-.399 2.245-.133.25.133.499.399.499.664 0 .266-.249.665-.499.798a2.014 2.014 0 01-1.247.399zm-.749-1.595a.739.739 0 00-.374.664c0 .133.125.399.374.532.499.266 1.497.266 1.996 0 .25-.133.374-.399.374-.665 0-.133-.124-.398-.374-.531-.499-.399-1.497-.399-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M441.243 292.322c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .623-.399.623-.931.124-1.329a2.027 2.027 0 00-2.12 0z"
            fill="#0EA59D"
            />
            <path
            d="M442.116 293.916c-.374 0-.748-.133-.998-.266-.249-.132-.499-.398-.499-.664s.25-.665.499-.798c.624-.398 1.622-.398 2.246-.133.249.133.499.399.499.665s-.25.665-.499.798c-.375.398-.874.398-1.248.398zm.25-1.861c-.375 0-.749.133-1.123.266-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.265 1.497.265 1.996 0 .249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.125-.133-.499-.266-.873-.266z"
            fill="#131A2D"
            />
            <path
            d="M451.846 291.658h-1.372v.398l-19.586-11.962c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.133-1.497-.133v.665c0 .132 0 .265.25.265l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.531z"
            fill="#131A2D"
            />
            <path
            d="M451.597 291.391l-20.834-12.627c-.249-.133-.748-.133-.998 0l-8.857 5.582c-.249.133-.374.532 0 .665l20.833 12.627c.25.133.749.133.998 0l8.858-5.582c.249-.266.249-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M442.115 297.904c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.582c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25 0-.499.133-.624.133zm-11.851-19.14c-.125 0-.375 0-.499.133l-8.858 5.582c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627c0-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M448.601 291.125c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.132-.749-.132-.998 0-.25.133-.749.133-.998 0-.25-.132-.749-.132-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.399 0 .665h-.125c-.25.132-.25.398 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.265-.374-.531-.125-.797z"
            fill="url(#paint136_linear_874_76773)"
            />
            <path
            d="M432.011 286.474c-.624 1.063-.499 2.259.374 3.323 1.248 1.595 3.867 2.126 5.863 1.196.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.197a3.01 3.01 0 00-1.746 1.596z"
            fill="#fff"
            />
            <path
            d="M437.997 290.462c1.871-.798 2.37-2.659 1.248-4.121-1.123-1.462-3.493-1.861-5.365-1.063-1.871.797-2.37 2.658-1.247 4.12 1.247 1.462 3.618 1.861 5.364 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M436.127 290.992c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.595 1.871-2.127 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.463.499 2.26-.249.93-.873 1.595-1.871 2.127-.624.399-1.372.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.399-1.497 1.063-1.746 1.861-.125.664 0 1.329.499 1.993 1.122 1.33 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.93-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M429.016 283.814c-.624.399-.624.931-.125 1.33.624.398 1.497.266 2.121 0 .624-.399.624-.931.125-1.33-.499-.398-1.497-.398-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M429.89 285.542a2.23 2.23 0 01-.998-.265c-.25-.133-.499-.399-.499-.665s.249-.665.499-.798c.623-.398 1.621-.398 2.245 0 .25.133.499.399.499.665s-.249.665-.499.798c-.374.133-.748.265-1.247.265zm-.749-1.595a.74.74 0 00-.374.665c0 .133.125.399.374.532.499.266 1.497.266 1.996 0 .25-.133.374-.399.374-.665 0-.133-.124-.399-.374-.532-.499-.398-1.497-.398-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M441.243 291.258c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .623-.399.623-.93.124-1.329a2.027 2.027 0 00-2.12 0z"
            fill="#0EA59D"
            />
            <path
            d="M442.116 292.853c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665s.25-.664.499-.797c.624-.399 1.622-.399 2.246-.133.249.133.499.398.499.664s-.25.665-.499.798c-.375.399-.874.399-1.248.399zm.25-1.861c-.375 0-.749.133-1.123.266-.25.132-.374.398-.374.664 0 .133.124.399.374.532.499.266 1.497.266 1.996 0 .249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.531-.125-.133-.499-.266-.873-.266z"
            fill="#131A2D"
            />
            <path
            d="M451.846 290.593h-1.372v.399l-19.586-11.963c-.25-.133-.749-.133-.998 0l-7.735 4.786.125-.133-1.497-.133v.664c0 .133 0 .266.25.266l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.532z"
            fill="#131A2D"
            />
            <path
            d="M451.597 290.328L430.763 277.7c-.249-.133-.748-.133-.998 0l-8.857 5.583c-.249.133-.374.532 0 .665l20.833 12.627c.25.133.749.133.998 0l8.858-5.583c.249-.265.249-.531 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M442.115 296.708c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.582c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25.133-.375.133-.624.133zM430.264 277.7c-.125 0-.375 0-.499.133l-8.858 5.583c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628c0-.133-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M448.603 290.062c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.399 0 .664h-.125c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.266-.374-.531-.125-.797z"
            fill="#fff"
            />
            <path
            d="M442.865 295.113c-.25 0-.375 0-.499-.133l-.25-.133a1.005 1.005 0 00-.873 0h-.125c-.249.133-.748.133-1.123 0l-16.716-10.235c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399h.125c.124 0 .124-.132.124-.265s0-.133-.124-.133c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l5.489-3.456c.249-.133.748-.133 1.122 0 .25.133.624.133.874 0 .374-.133.748-.266 1.122 0l16.717 10.235c.125.133.249.266.249.399s-.124.266-.249.399h-.125c-.125 0-.125.133-.125.266 0 .132 0 .132.125.132l.25.133c.124.133.249.266.249.399s-.125.266-.249.399l-5.489 3.323c-.125.133-.25.266-.499.266zm-1.123-.665c.249 0 .374 0 .499.133l.249.133c.25.133.624.133.874 0l5.489-3.323c.124 0 .124-.133.124-.266s0-.133-.124-.133l-.25-.133c-.125-.133-.249-.266-.249-.398 0-.133.124-.266.249-.399h.125c.125 0 .125-.133.125-.266s0-.133-.125-.133l-16.717-10.235a1.005 1.005 0 00-.873 0c-.249.133-.748.266-1.123 0a1.005 1.005 0 00-.873 0l-5.489 3.456c-.125 0-.125.133-.125.266s0 .133.125.133c.125.133.25.266.25.399s-.125.265-.25.398h-.125c-.124 0-.124.133-.124.266s0 .133.124.133l16.717 10.235c.249.133.624.133.873 0h.125c0-.133.249-.266.499-.266z"
            fill="#131A2D"
            />
            <path
            d="M432.011 285.409c-.624 1.064-.499 2.26.374 3.323 1.248 1.595 3.867 2.127 5.863 1.197.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.197a3.012 3.012 0 00-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M437.997 289.398c1.871-.797 2.37-2.658 1.248-4.12-1.123-1.462-3.493-1.861-5.365-1.064-1.871.798-2.37 2.659-1.247 4.121 1.247 1.462 3.618 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M436.127 289.929c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.126 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.127-.624.398-1.372.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.398-1.497 1.063-1.746 1.86-.125.665 0 1.33.499 1.994 1.122 1.329 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.33-.499-1.994-.749-.931-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M429.016 282.751c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.624-.399.624-.93.125-1.329-.499-.266-1.497-.266-2.121.133z"
            fill="#0EA59D"
            />
            <path
            d="M429.89 284.479a2.23 2.23 0 01-.998-.266c-.25-.133-.499-.398-.499-.664s.249-.665.499-.798c.623-.399 1.621-.399 2.245 0 .25.133.499.399.499.665s-.249.664-.499.797c-.374.133-.748.266-1.247.266zm-.749-1.595a.74.74 0 00-.374.665c0 .133.125.399.374.531.499.266 1.497.266 1.996-.132.25-.133.374-.399.374-.665 0-.133-.124-.399-.374-.532-.499-.266-1.497-.266-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M441.243 290.196c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121 0 .623-.399.623-.931.124-1.329a2.027 2.027 0 00-2.12 0z"
            fill="#0EA59D"
            />
            <path
            d="M442.116 291.79c-.374 0-.748-.133-.998-.266-.249-.132-.499-.398-.499-.664s.25-.665.499-.798c.624-.398 1.622-.398 2.246-.133.249.133.499.399.499.665s-.25.665-.499.798c-.375.398-.874.398-1.248.398zm.25-1.861c-.375 0-.749.133-1.123.266-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.265 1.497.265 1.996 0 .249-.133.499-.399.374-.665 0-.133-.125-.399-.374-.532-.125-.133-.499-.266-.873-.266zM448.852 306.013h-1.372v.398l-19.586-11.962c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.133-1.497-.133v.664c0 .133 0 .266.25.266l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.531z"
            fill="#131A2D"
            />
            <path
            d="M448.602 305.747l-20.833-12.628c-.249-.132-.748-.132-.998 0l-8.857 5.583c-.25.133-.374.532 0 .665l20.833 12.627c.25.133.749.133.998 0l8.857-5.582c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 312.127c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.582c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25.133-.375.133-.624.133zm-11.851-19.14c-.125 0-.375 0-.499.133l-8.858 5.582c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.628c.249.132.623.132.873 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M445.607 305.481c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.399 0 .665h-.125c-.25.132-.25.398 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.398-.374-.664-.125-.797z"
            fill="url(#paint137_linear_874_76773)"
            />
            <path
            d="M429.017 300.697c-.624 1.063-.499 2.259.374 3.323 1.248 1.595 3.867 2.126 5.863 1.196.749-.399 1.373-.93 1.747-1.595.624-1.063.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.196-.748.398-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M435.005 304.816c1.871-.797 2.37-2.658 1.247-4.12-1.122-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.247 4.12 1.247 1.329 3.617 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 305.348c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.595 1.871-2.127 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.127-.624.398-1.372.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.398-1.497 1.063-1.746 1.861-.125.664 0 1.329.499 1.993 1.122 1.33 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.93-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 298.17c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.624-.398.624-.93.125-1.329-.499-.266-1.497-.266-2.121.133z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 299.766c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665s.25-.664.499-.797c.624-.399 1.622-.399 2.246 0 .249.133.499.398.499.664s-.25.665-.499.798c-.374.133-.749.266-1.248.266zm-.748-1.595c-.25.132-.374.398-.374.664 0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.399-.374-.531-.499-.399-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M438.248 305.481c-.623.399-.623.93-.124 1.329.623.399 1.497.266 2.12 0 .624-.399.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 307.21c-.374 0-.749-.133-.998-.266-.25-.133-.499-.399-.499-.665s.249-.665.499-.797c.624-.399 1.622-.399 2.246-.133.249.133.499.398.499.664s-.25.665-.499.798a2.304 2.304 0 01-1.248.399zm-.873-1.596c-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.399-.374-.532-.499-.398-1.372-.398-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M448.851 304.949h-1.372v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.984 4.785.125-.133-1.497-.133v.665c0 .133 0 .266.25.266l20.833 12.627c.249.133.748.133.998 0l8.857-5.582c.125-.133.25-.266.25-.399l.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M448.602 304.683l-20.833-12.627c-.249-.133-.748-.133-.998 0l-8.857 5.582c-.25.133-.374.532 0 .665l20.833 12.628c.25.132.749.132.998 0l8.857-5.583c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 311.064c-.25 0-.374 0-.499-.133l-20.833-12.628c-.125-.133-.25-.266-.25-.399 0-.132.125-.265.25-.398l8.857-5.583c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.583c-.25.133-.375.133-.624.133zm-11.851-19.141c-.125 0-.375 0-.499.133l-8.858 5.583c-.124.133-.124.133-.124.265 0 .133 0 .133.124.133l20.834 12.628c.249.133.623.133.873 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M445.607 304.418c.375-.266.375-.532.125-.664l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.398 0 .664.249.133.249.399 0 .665h-.125c-.25.133-.25.399 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.664l-.25-.133c-.374-.399-.374-.665-.125-.798z"
            fill="url(#paint138_linear_874_76773)"
            />
            <path
            d="M429.017 299.633c-.624 1.063-.499 2.26.374 3.323 1.248 1.595 3.867 2.127 5.863 1.196.749-.398 1.373-.93 1.747-1.595.624-1.063.499-2.259-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.196-.748.399-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M435.005 303.754c1.871-.798 2.37-2.659 1.247-4.121-1.122-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.247 4.12 1.247 1.33 3.617 1.861 5.364 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 304.285c-1.372 0-2.745-.532-3.493-1.595-.499-.665-.749-1.463-.499-2.26.249-.93.873-1.595 1.871-2.127 1.871-.797 4.242-.399 5.489 1.064.499.664.749 1.462.499 2.259-.249.931-.873 1.595-1.871 2.127-.624.399-1.372.532-1.996.532zm-.25-5.982a4.74 4.74 0 00-1.871.399c-.873.399-1.497 1.063-1.746 1.861-.125.664 0 1.329.499 1.994 1.122 1.329 3.493 1.861 5.239 1.063.873-.399 1.497-1.063 1.747-1.861.124-.664 0-1.329-.499-1.994-.749-.93-1.996-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 297.107c-.624.399-.624.931-.125 1.329.624.399 1.497.266 2.121-.133.624-.398.624-.93.125-1.329-.499-.399-1.497-.266-2.121.133z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 298.702c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665 0-.265.25-.664.499-.797.624-.399 1.622-.399 2.246 0 .249.133.499.399.499.664 0 .266-.25.665-.499.798-.374.133-.749.266-1.248.266zm-.748-1.595a.738.738 0 00-.374.664c0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.132-.125-.398-.374-.531-.499-.399-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M438.248 304.417c-.623.399-.623.931-.124 1.329.623.399 1.497.266 2.12 0 .624-.398.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 306.146c-.374 0-.749-.133-.998-.266-.25-.133-.499-.399-.499-.665s.249-.664.499-.797c.624-.399 1.622-.399 2.246-.133.249.133.499.399.499.664 0 .266-.25.665-.499.798a2.304 2.304 0 01-1.248.399zm-.873-1.595c-.25.133-.374.398-.374.664 0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.398-.374-.531-.499-.399-1.372-.399-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M448.852 303.885h-1.372v.399l-19.586-11.963c-.25-.133-.749-.133-.998 0l-7.735 4.786.125-.133-1.497-.133v.664c0 .133 0 .266.25.266l20.833 12.628c.249.132.748.132.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.532z"
            fill="#131A2D"
            />
            <path
            d="M448.602 303.619l-20.833-12.627c-.249-.133-.748-.133-.998 0l-8.857 5.583c-.25.133-.374.531 0 .664l20.833 12.628c.25.133.749.133.998 0l8.857-5.583c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 310c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.582c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25.133-.375.133-.624.133zm-11.851-19.14c-.125 0-.375 0-.499.132l-8.858 5.583c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628s-.25-.132-.374-.132z"
            fill="#131A2D"
            />
            <path
            d="M445.607 303.354c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.398 0 .664h-.125c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.399-.374-.664-.125-.797z"
            fill="url(#paint139_linear_874_76773)"
            />
            <path
            d="M429.017 298.569c-.624 1.063-.499 2.259.374 3.323 1.248 1.595 3.867 2.126 5.863 1.196.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.197-.748.399-1.372.931-1.746 1.596z"
            fill="#fff"
            />
            <path
            d="M435.005 302.689c1.871-.797 2.37-2.658 1.247-4.12-1.122-1.462-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.247 4.121 1.247 1.329 3.617 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 303.22c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.596 1.871-2.127 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.127-.624.398-1.372.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.398-1.497 1.063-1.746 1.86-.125.665 0 1.33.499 1.994 1.122 1.329 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.931-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 296.044c-.624.398-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.624-.399.624-.931.125-1.329-.499-.399-1.497-.266-2.121.133z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 297.638c-.374 0-.748-.133-.998-.265-.249-.133-.499-.399-.499-.665s.25-.665.499-.798c.624-.398 1.622-.398 2.246 0 .249.133.499.399.499.665s-.25.665-.499.798c-.374.132-.749.265-1.248.265zm-.748-1.595c-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.265 1.497.265 1.996-.133a.74.74 0 00.374-.665c0-.133-.125-.399-.374-.532-.499-.265-1.497-.133-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M438.248 303.353c-.623.399-.623.93-.124 1.329.623.399 1.497.266 2.12 0 .624-.399.624-.93.125-1.329-.499-.399-1.497-.399-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 305.081c-.374 0-.749-.133-.998-.266-.25-.132-.499-.398-.499-.664s.249-.665.499-.798c.624-.398 1.622-.398 2.246-.133.249.133.499.399.499.665s-.25.665-.499.798a2.31 2.31 0 01-1.248.398zm.249-1.861c-.374 0-.748.133-1.122.266-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.265 1.497.265 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.399-.374-.532-.125-.266-.499-.266-.874-.266z"
            fill="#131A2D"
            />
            <path
            d="M448.852 302.822h-1.372v.399l-19.586-11.963c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.133-1.497-.133v.665c0 .133 0 .266.25.266l20.833 12.627c.249.133.748.133.998 0l8.857-5.583c.125-.132.25-.265.25-.398l-.125-.532z"
            fill="#131A2D"
            />
            <path
            d="M448.602 302.556l-20.833-12.627c-.249-.133-.748-.133-.998 0l-8.857 5.582c-.25.133-.374.532 0 .665l20.833 12.628c.25.132.749.132.998 0l8.857-5.583c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 308.937c-.25 0-.374 0-.499-.133l-20.833-12.628c-.125-.133-.25-.266-.25-.399 0-.132.125-.265.25-.398l8.857-5.583c.374-.266.873-.266 1.123 0l20.833 12.628c.125.132.249.265.249.398s-.124.266-.249.399l-8.857 5.583c-.25.133-.375.133-.624.133zm-11.851-19.141c-.125 0-.375 0-.499.133l-8.858 5.583c-.124.133-.124.133-.124.265 0 .133 0 .133.124.133l20.834 12.628c.249.133.623.133.873 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M445.607 302.29c.375-.266.375-.531.125-.664l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.398 0 .664.249.133.249.399 0 .665h-.125c-.25.133-.25.399 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.398 0-.664l-.25-.133c-.374-.399-.374-.665-.125-.798z"
            fill="url(#paint140_linear_874_76773)"
            />
            <path
            d="M429.017 297.506c-.624 1.063-.499 2.26.374 3.323 1.248 1.595 3.867 2.127 5.863 1.196.749-.398 1.373-.93 1.747-1.595.624-1.063.499-2.259-.374-3.323-1.248-1.595-3.868-2.126-5.864-1.196-.748.399-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M435.005 301.626c1.871-.798 2.37-2.659 1.247-4.121-1.122-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.247 4.12 1.247 1.33 3.617 1.861 5.364 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 302.158c-1.372 0-2.745-.532-3.493-1.595-.499-.665-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.127 1.871-.797 4.242-.398 5.489 1.064.499.664.749 1.462.499 2.259-.249.931-.873 1.595-1.871 2.127-.624.399-1.372.532-1.996.532zm-.25-5.982a4.74 4.74 0 00-1.871.399c-.873.399-1.497 1.063-1.746 1.861-.125.665 0 1.329.499 1.994 1.122 1.329 3.493 1.861 5.239 1.063.873-.399 1.497-1.063 1.747-1.861.124-.664 0-1.329-.499-1.994-.749-.93-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 294.98c-.624.399-.624.931-.125 1.329.624.399 1.497.266 2.121-.133.624-.398.624-.93.125-1.329-.499-.399-1.497-.266-2.121.133z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 296.576c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665 0-.265.25-.664.499-.797.624-.399 1.622-.399 2.246 0 .249.133.499.399.499.665 0 .265-.25.664-.499.797-.374.133-.749.266-1.248.266zm-.748-1.595a.738.738 0 00-.374.664c0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.664c0-.133-.125-.399-.374-.532-.499-.399-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M438.248 302.29c-.623.399-.623.931-.124 1.329.623.399 1.497.266 2.12 0 .624-.398.624-.93.125-1.329a2.033 2.033 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 304.019c-.374 0-.749-.133-.998-.266-.25-.133-.499-.399-.499-.665 0-.265.249-.664.499-.797.624-.399 1.622-.399 2.246-.133.249.133.499.399.499.665 0 .265-.25.664-.499.797a2.304 2.304 0 01-1.248.399zm-.873-1.595a.738.738 0 00-.374.664c0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.132-.125-.398-.374-.531-.499-.399-1.372-.399-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M448.852 301.759h-1.372v.399l-19.586-11.963c-.25-.133-.749-.133-.998 0l-7.735 4.786.125-.133-1.497-.133v.664c0 .133 0 .266.25.266l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.532z"
            fill="#131A2D"
            />
            <path
            d="M448.602 301.494l-20.833-12.628c-.249-.133-.748-.133-.998 0l-8.857 5.583c-.25.133-.374.531 0 .664l20.833 12.628c.25.133.749.133.998 0l8.857-5.583c.25-.266.25-.532 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 307.874c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.582c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25.133-.375.133-.624.133zm-11.851-19.14c-.125 0-.375 0-.499.132l-8.858 5.583c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628s-.25-.132-.374-.132z"
            fill="#131A2D"
            />
            <path
            d="M445.607 301.228c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.398 0 .664h-.125c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.399-.374-.664-.125-.797z"
            fill="url(#paint141_linear_874_76773)"
            />
            <path
            d="M429.017 296.443c-.624 1.063-.499 2.259.374 3.323 1.248 1.595 3.867 2.126 5.863 1.196.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.197-.748.399-1.372.931-1.746 1.596z"
            fill="#fff"
            />
            <path
            d="M435.005 300.563c1.871-.797 2.37-2.658 1.247-4.12-1.122-1.462-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.247 4.121 1.247 1.329 3.617 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 301.094c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.596 1.871-2.127 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.127-.624.398-1.372.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.398-1.497 1.063-1.746 1.86-.125.665 0 1.33.499 1.994 1.122 1.329 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.93-1.996-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 293.917c-.624.399-.624.931-.125 1.329.624.399 1.497.266 2.121 0 .624-.398.624-.93.125-1.329-.499-.532-1.497-.399-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 295.512c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.664 0-.266.25-.665.499-.798.624-.399 1.622-.399 2.246-.133.249.133.499.399.499.665s-.25.664-.499.797a2.017 2.017 0 01-1.248.399zm-.748-1.595c-.25.133-.374.399-.374.665 0 .132.124.398.374.531.499.266 1.497.266 1.996 0a.74.74 0 00.374-.664c0-.133-.125-.399-.374-.532-.499-.399-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M438.248 301.227c-.623.399-.623.93-.124 1.329.623.399 1.497.266 2.12 0 .624-.399.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 302.955c-.374 0-.749-.133-.998-.266-.25-.132-.499-.398-.499-.664s.249-.665.499-.798c.624-.398 1.622-.398 2.246-.133.249.133.499.399.499.665s-.25.665-.499.798a2.31 2.31 0 01-1.248.398zm.249-1.861c-.374 0-.748.133-1.122.266-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.265 1.497.265 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.399-.374-.532-.125-.266-.499-.266-.874-.266z"
            fill="#131A2D"
            />
            <path
            d="M448.852 300.696h-1.372v.399l-19.586-11.963c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.133-1.497-.133v.665c0 .133 0 .265.25.265l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.531z"
            fill="#131A2D"
            />
            <path
            d="M448.602 300.43l-20.833-12.627c-.249-.133-.748-.133-.998 0l-8.857 5.582c-.25.133-.374.532 0 .665l20.833 12.627c.25.133.749.133.998 0l8.857-5.582c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 306.81c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.398l8.857-5.583c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25.133-.375.133-.624.133zm-11.851-19.14c-.125 0-.375 0-.499.133l-8.858 5.582c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.628c.249.133.623.133.873 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M445.607 300.164c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.132-.749-.132-.998 0-.25.133-.749.133-.998 0-.25-.132-.749-.132-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.399 0 .665h-.125c-.25.133-.25.398 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.132c-.374-.399-.374-.665-.125-.798z"
            fill="url(#paint142_linear_874_76773)"
            />
            <path
            d="M429.017 295.379c-.624 1.063-.499 2.259.374 3.323 1.248 1.595 3.867 2.127 5.863 1.196.749-.399 1.373-.93 1.747-1.595.624-1.063.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.196-.748.399-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M435.005 299.5c1.871-.798 2.37-2.659 1.247-4.121-1.122-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.247 4.12 1.247 1.329 3.617 1.861 5.364 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 300.031c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.595 1.871-2.127 1.871-.797 4.242-.399 5.489 1.063.499.665.749 1.463.499 2.26-.249.931-.873 1.595-1.871 2.127v-.133.133c-.624.399-1.248.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.399-1.497 1.063-1.746 1.861-.125.664 0 1.329.499 1.994 1.122 1.329 3.493 1.86 5.239 1.063.873-.399 1.497-1.063 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.93-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 292.854c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.624-.399.624-.93.125-1.329-.499-.399-1.497-.266-2.121.133z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 294.449c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665s.25-.664.499-.797c.624-.399 1.622-.399 2.246 0 .249.133.499.398.499.664s-.25.665-.499.798c-.374.133-.749.266-1.248.266zm-.748-1.595c-.25.133-.374.398-.374.664 0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.398-.374-.531-.499-.399-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M438.248 300.163c-.623.399-.623.931-.124 1.329.623.399 1.497.266 2.12 0 .624-.398.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 301.892c-.374 0-.749-.133-.998-.266-.25-.133-.499-.399-.499-.665s.249-.664.499-.797c.624-.399 1.622-.399 2.246-.133.249.133.499.398.499.664s-.25.665-.499.798a2.304 2.304 0 01-1.248.399zm.249-1.861c-.374 0-.748.133-1.122.266-.25.133-.374.398-.374.664 0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.398-.374-.531-.125-.266-.499-.266-.874-.266z"
            fill="#131A2D"
            />
            <path
            d="M448.851 299.632h-1.372v.399l-19.586-11.963c-.249-.133-.748-.133-.998 0l-7.984 4.785.125-.133-1.497-.132v.664c0 .133 0 .266.25.266l20.833 12.627c.249.133.748.133.998 0l8.857-5.582c.125-.133.25-.266.25-.399l.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M448.602 299.368l-20.833-12.628c-.249-.133-.748-.133-.998 0l-8.857 5.583c-.25.133-.374.531 0 .664l20.833 12.628c.25.133.749.133.998 0l8.857-5.583c.25-.266.25-.532 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 305.747c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.583c.374-.265.873-.265 1.123 0l20.833 12.628c.125.133.249.266.249.399s-.124.265-.249.398l-8.857 5.583c-.25.133-.375.133-.624.133zm-11.851-19.141c-.125 0-.375 0-.499.133l-8.858 5.583c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.628s-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M445.607 299.101c.375-.265.375-.531.125-.664l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.132.249.398 0 .664h-.125c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.132.748.132.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.399-.374-.665-.125-.798z"
            fill="url(#paint143_linear_874_76773)"
            />
            <path
            d="M429.017 294.316c-.624 1.064-.499 2.26.374 3.323 1.248 1.595 3.867 2.127 5.863 1.197.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.197-.748.399-1.372.931-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M435.005 298.436c1.871-.797 2.37-2.658 1.247-4.12-1.122-1.463-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.247 4.121 1.247 1.329 3.617 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 298.968c-1.372 0-2.745-.532-3.493-1.595-.499-.665-.749-1.462-.499-2.26.249-.93.873-1.595 1.871-2.126 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.126-.624.399-1.372.532-1.996.532zm-.25-5.981c-.623 0-1.247.132-1.871.398-.873.399-1.497 1.064-1.746 1.861-.125.665 0 1.329.499 1.994 1.122 1.329 3.493 1.861 5.239 1.063.873-.398 1.497-1.063 1.747-1.86.124-.665 0-1.33-.499-1.994-.749-.931-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 291.79c-.624.399-.624.931-.125 1.33.624.398 1.497.265 2.121-.133.624-.399.624-.931.125-1.329-.499-.399-1.497-.266-2.121.132z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 293.385c-.374 0-.748-.133-.998-.266-.249-.133-.499-.398-.499-.664s.25-.665.499-.798c.624-.399 1.622-.399 2.246 0 .249.133.499.399.499.665s-.25.664-.499.797c-.374.133-.749.266-1.248.266zm-.748-1.595c-.25.133-.374.399-.374.665 0 .133.124.399.374.531.499.266 1.497.266 1.996 0 .249-.132.374-.398.374-.664 0-.133-.125-.399-.374-.532-.499-.399-1.497-.266-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M438.248 299.101c-.623.398-.623.93-.124 1.329.623.399 1.497.266 2.12 0 .624-.399.624-.931.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 300.829c-.374 0-.749-.133-.998-.266-.25-.133-.499-.398-.499-.664s.249-.665.499-.798c.624-.399 1.622-.399 2.246-.133.249.133.499.399.499.665s-.25.664-.499.797a2.304 2.304 0 01-1.248.399zm.249-1.861c-.374 0-.748.133-1.122.266-.25.133-.374.399-.374.665 0 .133.124.398.374.531.499.266 1.497.266 1.996 0a.739.739 0 00.374-.664c0-.133-.125-.399-.374-.532-.125-.266-.499-.266-.874-.266z"
            fill="#131A2D"
            />
            <path
            d="M448.852 298.569h-1.372v.399l-19.586-11.963c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.133-1.497-.133v.665c0 .133 0 .265.25.265l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.399l-.125-.531z"
            fill="#131A2D"
            />
            <path
            d="M448.602 298.303l-20.833-12.627c-.249-.133-.748-.133-.998 0l-8.857 5.582c-.25.133-.374.532 0 .665l20.833 12.627c.25.133.749.133.998 0l8.857-5.582c.25-.266.25-.532 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 304.683c-.25 0-.374 0-.499-.132l-20.833-12.628c-.125-.133-.25-.266-.25-.399s.125-.266.25-.398l8.857-5.583c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.583c-.25.132-.375.132-.624.132zm-11.851-19.14c-.125 0-.375 0-.499.133l-8.858 5.582c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.628c.249.133.623.133.873 0l8.857-5.583c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M445.607 298.037c.375-.266.375-.532.125-.665l-16.716-10.234c-.25-.133-.749-.133-.998 0-.25.132-.749.132-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.455c-.25.133-.25.399 0 .665.249.133.249.399 0 .665h-.125c-.25.133-.25.398 0 .664l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.132c-.374-.399-.374-.665-.125-.798z"
            fill="url(#paint144_linear_874_76773)"
            />
            <path
            d="M429.017 293.253c-.624 1.063-.499 2.259.374 3.323 1.248 1.595 3.867 2.127 5.863 1.196.749-.399 1.373-.93 1.747-1.595.624-1.063.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.196-.748.399-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M435.005 297.373c1.871-.798 2.37-2.659 1.247-4.121-1.122-1.462-3.493-1.861-5.364-1.063-1.871.797-2.37 2.658-1.247 4.12 1.247 1.329 3.617 1.861 5.364 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 297.905c-1.372 0-2.745-.532-3.493-1.595-.499-.665-.749-1.463-.499-2.26.249-.931.873-1.595 1.871-2.127 1.871-.797 4.242-.399 5.489 1.063.499.665.749 1.463.499 2.26-.249.931-.873 1.595-1.871 2.127-.624.399-1.248.532-1.996.532zm-.25-5.982a4.74 4.74 0 00-1.871.399c-.873.399-1.497 1.063-1.746 1.861-.125.664 0 1.329.499 1.994 1.122 1.329 3.493 1.86 5.239 1.063.873-.399 1.497-1.063 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.93-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 290.726c-.624.399-.624.931-.125 1.33.624.398 1.497.265 2.121 0 .624-.399.624-.931.125-1.33-.499-.531-1.497-.398-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 292.322c-.374 0-.748-.133-.998-.266-.249-.133-.499-.399-.499-.665s.25-.664.499-.797c.624-.399 1.622-.399 2.246 0 .249.133.499.399.499.664 0 .266-.25.665-.499.798-.374.133-.749.266-1.248.266zm-.748-1.595c-.25.133-.374.398-.374.664 0 .133.124.399.374.532.499.266 1.497.266 1.996-.133a.74.74 0 00.374-.665c0-.132-.125-.398-.374-.531-.499-.266-1.497-.133-1.996.133z"
            fill="#131A2D"
            />
            <path
            d="M438.248 298.036c-.623.399-.623.931-.124 1.329.623.399 1.497.266 2.12 0 .624-.398.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 299.765c-.374 0-.749-.133-.998-.266-.25-.133-.499-.399-.499-.665s.249-.664.499-.797c.624-.399 1.622-.399 2.246-.133.249.133.499.399.499.664 0 .266-.25.665-.499.798a2.304 2.304 0 01-1.248.399zm.249-1.861c-.374 0-.748.133-1.122.266-.25.133-.374.398-.374.664 0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.398-.374-.531-.125-.266-.499-.266-.874-.266z"
            fill="#131A2D"
            />
            <path
            d="M448.852 297.506h-1.372v.399l-19.586-11.963c-.25-.133-.749-.133-.998 0l-7.735 4.785.125-.133-1.497-.133v.665c0 .133 0 .265.25.265l20.833 12.628c.249.133.748.133.998 0l8.857-5.583c.125-.133.25-.266.25-.398l-.125-.532z"
            fill="#131A2D"
            />
            <path
            d="M448.602 297.24l-20.833-12.628c-.249-.133-.748-.133-.998 0l-8.857 5.583c-.25.133-.374.532 0 .665l20.833 12.627c.25.133.749.133.998 0l8.857-5.583c.25-.265.25-.531 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M439.121 303.62c-.25 0-.374 0-.499-.133l-20.833-12.627c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399l8.857-5.582c.374-.266.873-.266 1.123 0l20.833 12.627c.125.133.249.266.249.399s-.124.266-.249.399l-8.857 5.582c-.25.133-.375.133-.624.133zm-11.851-19.14c-.125 0-.375 0-.499.133l-8.858 5.582c-.124.133-.124.133-.124.266s0 .133.124.133l20.834 12.627c.249.133.623.133.873 0l8.857-5.582c.125-.133.125-.133.125-.266s0-.133-.125-.133l-20.833-12.627s-.25-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M445.609 296.975c.375-.266.375-.532.125-.665l-16.716-10.235c-.25-.133-.749-.133-.998 0-.25.133-.749.133-.998 0-.25-.133-.749-.133-.998 0l-5.489 3.456c-.25.133-.25.399 0 .665.249.133.249.399 0 .664h-.125c-.25.133-.25.399 0 .665l16.716 10.235c.25.133.749.133.998 0h.125c.25-.133.749-.133.998 0l.25.133c.249.133.748.133.998 0l5.489-3.323c.249-.133.249-.399 0-.665l-.25-.133c-.374-.398-.374-.664-.125-.797z"
            fill="#fff"
            />
            <path
            d="M439.87 301.893c-.249 0-.374 0-.499-.133l-.249-.133a1.005 1.005 0 00-.873 0h-.125c-.25.133-.749.133-1.123 0l-16.716-10.235c-.125-.133-.25-.266-.25-.398 0-.133.125-.266.25-.399h.124c.125 0 .125-.133.125-.266s0-.133-.125-.133c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399l5.489-3.455c.25-.133.749-.133 1.123 0 .25.132.624.132.873 0 .375-.133.749-.266 1.123 0l16.717 10.234c.124.133.249.266.249.399s-.125.266-.249.399h-.125c-.125 0-.125.133-.125.266s0 .133.125.133l.249.133c.125.133.25.265.25.398s-.125.266-.25.399l-5.489 3.323c-.124.266-.249.266-.499.266zm-1.122-.532c.249 0 .374 0 .499.133l.249.133c.25.133.624.133.873 0l5.489-3.323c.125 0 .125-.133.125-.266s0-.133-.125-.133l-.249-.133c-.125-.132-.25-.265-.25-.398s.125-.266.25-.399h.125c.124 0 .124-.133.124-.266s0-.133-.124-.133l-16.842-10.368a1.005 1.005 0 00-.873 0c-.249.133-.748.266-1.123 0a1.005 1.005 0 00-.873 0l-5.489 3.456c-.125 0-.125.133-.125.266s0 .133.125.133c.125.133.25.266.25.399s-.125.266-.25.399h-.125c-.124 0-.124.133-.124.265 0 .133 0 .133.124.133l16.717 10.235c.249.133.624.133.873 0h.125c.125-.133.374-.133.624-.133z"
            fill="#131A2D"
            />
            <path
            d="M429.017 292.19c-.624 1.063-.499 2.259.374 3.323 1.248 1.595 3.867 2.126 5.863 1.196.749-.399 1.373-.931 1.747-1.595.624-1.064.499-2.26-.374-3.323-1.248-1.595-3.868-2.127-5.864-1.196-.748.398-1.372.93-1.746 1.595z"
            fill="#fff"
            />
            <path
            d="M435.005 296.31c1.871-.797 2.37-2.658 1.247-4.12-1.122-1.462-3.493-1.861-5.364-1.064-1.871.798-2.37 2.659-1.247 4.121 1.247 1.329 3.617 1.861 5.364 1.063z"
            fill="#0EA59D"
            />
            <path
            d="M433.133 296.841c-1.372 0-2.745-.531-3.493-1.595-.499-.664-.749-1.462-.499-2.259.249-.931.873-1.595 1.871-2.127 1.871-.798 4.242-.399 5.489 1.063.499.665.749 1.462.499 2.26-.249.93-.873 1.595-1.871 2.127-.624.398-1.372.531-1.996.531zm-.25-5.981a4.74 4.74 0 00-1.871.399c-.873.398-1.497 1.063-1.746 1.861-.125.664 0 1.329.499 1.993 1.122 1.33 3.493 1.861 5.239 1.064.873-.399 1.497-1.064 1.747-1.861.124-.665 0-1.329-.499-1.994-.749-.93-2.121-1.462-3.369-1.462z"
            fill="#131A2D"
            />
            <path
            d="M426.022 289.531c-.624.399-.624.93-.125 1.329.624.399 1.497.266 2.121-.133.624-.399.624-.93.125-1.329-.499-.266-1.497-.133-2.121.133z"
            fill="#0EA59D"
            />
            <path
            d="M426.895 291.258c-.374 0-.748-.132-.998-.265-.249-.133-.499-.399-.499-.665s.25-.665.499-.797c.624-.399 1.622-.399 2.246 0 .249.132.499.398.499.664s-.25.665-.499.798c-.374.133-.749.265-1.248.265zm-.748-1.595c-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.266 1.497.266 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.399-.374-.532-.499-.398-1.497-.265-1.996 0z"
            fill="#131A2D"
            />
            <path
            d="M438.248 296.974c-.623.399-.623.93-.124 1.329.623.399 1.497.266 2.12 0 .624-.399.624-.93.125-1.329a2.029 2.029 0 00-2.121 0z"
            fill="#0EA59D"
            />
            <path
            d="M439.122 298.702c-.374 0-.749-.133-.998-.265-.25-.133-.499-.399-.499-.665s.249-.665.499-.798c.624-.398 1.622-.398 2.246-.132.249.132.499.398.499.664s-.25.665-.499.798a2.31 2.31 0 01-1.248.398zm-.873-1.595c-.25.133-.374.399-.374.665 0 .133.124.399.374.532.499.265 1.497.265 1.996 0a.74.74 0 00.374-.665c0-.133-.125-.399-.374-.532-.499-.398-1.372-.398-1.996 0z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M197.98 383.373l-23.453 13.823-15.843-9.57 22.829-13.425 16.467 9.172z"
            fill="url(#paint145_linear_874_76773)"
            />
            <path
            d="M142.466 365.295s-2.869 3.057.25 5.317c3.118 2.259 19.086 11.298 22.455 13.292 3.368 1.994 8.982 1.063 9.73-1.197 1.123-3.323-1.497-3.987-4.241-5.981-2.745-1.994-22.705-12.229-24.576-11.83-1.996.266-2.495-.399-3.618.399z"
            fill="#fff"
            />
            <path
            d="M142.591 365.295s-2.869 2.924.374 5.184c3.119 2.26 18.962 11.165 22.331 13.159 3.368 1.994 8.732 1.063 9.481-1.196 1.122-3.323-1.497-3.855-4.242-5.849-2.744-1.994-22.455-12.096-24.451-11.697-1.871.266-2.37-.266-3.493.399z"
            fill="#F9F9F9"
            />
            <path
            d="M142.716 365.296s-2.745 2.791.374 5.051c3.119 2.259 18.837 11.165 22.205 13.159 3.369 1.994 8.608 1.063 9.357-1.064 1.122-3.323-1.373-3.854-4.117-5.848-2.745-1.994-22.33-11.963-24.326-11.697-1.996.399-2.495-.266-3.493.399z"
            fill="#F3F3F4"
            />
            <path
            d="M142.84 365.428s-2.62 2.792.499 5.051c3.119 2.26 18.713 11.033 22.081 13.027 3.368 1.993 8.358 1.063 9.107-1.064 1.122-3.19-1.373-3.722-4.117-5.715-2.745-1.994-22.206-11.963-24.077-11.564-1.996.132-2.495-.399-3.493.265z"
            fill="#ECEDEE"
            />
            <path
            d="M142.839 365.429s-2.495 2.658.624 4.918c3.119 2.259 18.588 10.899 21.956 12.893 3.368 1.994 8.234 1.063 8.982-1.063 1.123-3.19-1.247-3.722-3.992-5.716-2.744-1.994-22.081-11.83-23.952-11.564-1.996.532-2.495-.133-3.618.532z"
            fill="#E6E7E8"
            />
            <path
            d="M142.965 365.561s-2.371 2.658.623 4.785c3.119 2.26 18.463 10.9 21.832 12.893 3.368 1.994 7.984 1.064 8.732-1.063 1.123-3.19-1.247-3.722-3.867-5.583-2.745-1.993-21.956-11.83-23.827-11.431-1.872.266-2.371-.266-3.493.399z"
            fill="#E0E0E3"
            />
            <path
            d="M143.09 365.56s-2.246 2.526.748 4.653c2.994 2.259 18.338 10.766 21.707 12.76 3.243 1.994 7.859 1.196 8.483-.93 1.122-3.191-1.123-3.589-3.868-5.583-2.619-1.861-21.831-11.697-23.702-11.431-1.871.266-2.37-.133-3.368.531z"
            fill="#DADADD"
            />
            <path
            d="M143.214 365.694s-2.246 2.392.873 4.652c2.994 2.127 18.213 10.767 21.457 12.627 3.243 1.861 7.61 1.197 8.358-.93 1.123-3.19-1.123-3.589-3.742-5.45-2.62-1.861-21.707-11.697-23.578-11.298-1.871.266-2.37-.266-3.368.399z"
            fill="#D3D4D7"
            />
            <path
            d="M143.338 365.694s-2.121 2.393.873 4.519c2.994 2.127 18.089 10.634 21.333 12.628 3.243 1.861 7.485 1.196 8.108-.931 1.123-3.19-1.122-3.455-3.742-5.316-2.62-1.861-21.582-11.564-23.328-11.299-1.747.399-2.246-.265-3.244.399z"
            fill="#CDCED2"
            />
            <path
            d="M143.339 365.694s-1.996 2.26.998 4.387c2.994 2.126 17.964 10.633 21.208 12.494 3.243 1.861 7.235 1.197 7.984-.93 1.123-3.19-.998-3.456-3.618-5.317-2.62-1.861-21.332-11.431-23.203-11.165-1.872.531-2.371 0-3.369.531z"
            fill="#C7C8CC"
            />
            <path
            d="M172.406 382.044s-1.123.797-1.372.93c0 0 .124 0 .124-.133l.25-.266c.125-.133.125-.133.125-.266l.124-.132c0-.133.125-.133.125-.266 0 0 0-.133.125-.133v-.133-.266-.133c.125-.399.125-.797.125-1.196v-.133-.665s0-11.83-.125-25.786v-1.197-11.298-.797-11.83c0-7.976-.125-14.622-.125-17.546v-.93-.798c-.125-2.392-1.123-4.918-2.744-6.779l-.25-.266-.249-.265-.25-.266c-.125-.133-.374-.266-.499-.399-.125 0-.125-.133-.249-.133h-.125c-.125 0-.125-.133-.25-.133-.124-.133-.249-.133-.374-.266l-5.239-3.057-3.119-1.728-4.242-2.393-8.857-5.183c-.748-.399-1.497-.665-2.121-.665h-.499c-.124 0-.124 0-.249.133-.125 0-.125 0-.25.133-.124 0-.124.133-.249.133.125-.133.998-.665 1.247-.931.874-.531 2.121-.531 3.493.266l21.333 12.495c2.495 1.462 4.491 4.652 4.74 7.709.125 1.196.25 10.501.25 21.932v48.782c.623 1.196.748 2.791-.624 3.855z"
            fill="#131A2D"
            />
            <path
            d="M172.281 380.183c0 .399 0 .665-.125 1.063v.532s0 .133-.124.133c0 .133-.125.133-.125.266l-.125.133c0 .133-.125.133-.125.266 0 .132-.124.132-.124.132l-.125.133-.125.133c-.873.665-2.121.665-3.618-.133l-.499-.265-5.863-3.456-.748-.399-1.248-.798-3.243-1.861-4.866-2.791-1.122-.664-2.495-1.463-1.747-1.063a2.704 2.704 0 01-.998-.665c-.125 0-.125-.133-.249-.133-.125-.132-.375-.265-.499-.398-.25-.266-.624-.665-.874-1.064-1.122-1.462-1.871-3.057-2.12-4.785-.125-.399-.125-.93-.125-1.329v-70.448c0-1.595.499-2.658 1.372-3.19.125 0 .125-.133.25-.133 0 0 .124 0 .249-.133.125 0 .125 0 .25-.133h.499c.623 0 1.372.266 2.12.665l8.858 5.184 4.241 2.392 3.119 1.728 5.239 3.057c.125.133.25.133.375.266.124 0 .124.133.249.133h.125c.125 0 .125.133.249.133.125.133.374.266.499.399l.25.266c.125 0 .125.133.249.266l.25.265c.125.133.249.266.249.399.25.266.375.399.499.665 1.123 1.728 1.872 3.722 1.872 5.715V311.862c0 3.323 0 9.437.124 16.615V353.599c.125 13.026.125 24.324.125 26.451v.133z"
            fill="#0EA59D"
            />
            <path
            d="M169.661 383.506c-.624 0-1.372-.266-2.121-.664l-.499-.266-21.332-12.495c-.374-.133-.624-.399-.998-.664-.125 0-.125-.133-.249-.133l-.125-.133-.375-.399c-.249-.266-.623-.665-.873-1.063-1.122-1.462-1.871-3.19-2.121-4.786-.124-.531-.124-.93-.124-1.329v-70.448c0-1.462.499-2.658 1.372-3.19.125 0 .125-.133.25-.133.124 0 .124 0 .249-.133h.125c.124 0 .125 0 .249-.133h.499c.624 0 1.373.266 2.121.665l21.332 12.495c.125.133.25.133.374.265.125 0 .125.133.25.133h.125c.124 0 .124.133.249.133.125.133.375.266.499.399l.25.266.125.133.124.133.25.266c.124.132.249.265.249.398.125.133.375.399.499.665 1.248 1.728 1.871 3.855 1.871 5.716V311.862c0 3.057.001 8.64.125 15.02V353.599c.125 14.355.125 24.59.125 26.451v.399c0 .399 0 .665-.125 1.063v.532c0 .133 0 .133-.125.133 0 .133-.124.133-.124.266l-.125.133c0 .133-.125.133-.249.266 0 .133-.125.132-.125.132l-.125.133-.125.133c-.249.133-.873.266-1.372.266zm-27.32-95.57c-.873.532-1.248 1.595-1.248 3.057v70.448c0 .399 0 .931.125 1.33.25 1.595.998 3.323 2.121 4.652.249.399.499.664.873 1.063l.374.399.125.133s.125.133.25.133c.374.266.748.531.997.664l21.707 12.761c1.372.797 2.62.797 3.493.133l.125-.133.125-.133.124-.133c.125-.133.125-.133.125-.266l.125-.133c0-.133.124-.133.124-.266v-.133-.265-.266c.125-.399.125-.665.125-1.064v-.398c0-1.861 0-11.963-.125-26.452v-12.494-.798V326.35c0-6.38-.124-11.83-.124-15.02v-.93-.931-.797c0-1.861-.749-3.988-1.872-5.583-.249-.266-.374-.532-.498-.664-.125-.133-.25-.266-.25-.399l-.249-.266-.125-.133-.125-.133c-.125 0-.125-.133-.25-.266-.124-.133-.374-.266-.498-.398-.125 0-.125-.133-.25-.133-.125-.133-.125-.133-.25-.133-.124-.133-.249-.133-.374-.266l-21.332-12.495c-.748-.398-1.497-.664-2.121-.664h-.499s-.125 0-.249.133c-.125 0-.125 0-.25.133-.124.398-.249.398-.249.531z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M141.842 360.776l29.441 16.748v-.133l-29.441-16.748v.133zM142.217 290.461l28.318 16.349.125-.133-28.443-16.349v.133zM162.426 374.733l4.366 2.392v-.133l-4.241-2.392-.125.133zM162.426 375.53l4.241 2.526.125-.266-4.366-2.393v.133zM162.301 376.327l4.366 2.526v-.266l-4.241-2.393-.125.133zM155.688 370.746c-.499-.133-.873.133-.998.664-.125.532.25 1.197.749 1.33h.249c.125 0 .25 0 .374-.133.125-.133.25-.399.375-.665 0-.399-.25-1.063-.749-1.196zm.25 1.728a.362.362 0 01-.499 0c-.375-.133-.624-.665-.624-1.064 0-.398.374-.664.748-.531.375.133.624.664.624 1.063 0 .266-.125.532-.249.532zM146.582 365.694l-1.871.266v.133l1.497 2.127.125-.133-1.497-1.994 1.746-.266v-.133z"
            fill="#fff"
            />
            <path
            d="M187.001 368.884l-28.443-17.944c-.374-.266-.748-.266-1.122-.266-.375 0-.749.133-1.123.266l-33.807 21.001c-.749.399-1.123 1.33-1.123 2.127 0 .931.499 1.728 1.123 2.127l28.443 17.811c.374.133.748.266 1.122.266.375 0 .749-.133 1.123-.266l33.807-20.868c.749-.399 1.123-1.33 1.123-2.127.125-.798-.374-1.595-1.123-2.127z"
            fill="#fff"
            />
            <path
            d="M156.438 351.207l-33.807 21.001c-.374.266-.749.665-.873 1.196-.125.266-.125.665-.125.931 0 .797.624 1.728 1.247 1.994l28.194 17.545c.249.133.374.133.624.266h.499c.374 0 .748-.133 1.122-.399l33.558-20.735c.499-.266.749-.798.873-1.197.125-.266.125-.531.125-.93 0-.798-.624-1.728-1.247-1.994l-28.069-17.546c-.25-.132-.749-.398-1.123-.398h-.374c-.125.133-.374.133-.624.266z"
            fill="#F8F8F9"
            />
            <path
            d="M156.562 351.471l-33.807 21.002c-.374.265-.748.797-.748 1.196-.125.266 0 .665 0 .93 0 .665.748 1.595 1.372 1.994l27.944 17.413c.249.133.374.133.624.133h.499c.249 0 .748-.266.998-.399l33.433-20.736c.499-.266.748-.797.748-1.196.125-.266 0-.532 0-.797 0-.665-.748-1.596-1.247-1.994l-27.695-17.413c-.249-.133-.748-.399-.998-.399h-.374c-.374 0-.624.133-.749.266z"
            fill="#F1F1F3"
            />
            <path
            d="M156.687 351.605l-33.808 21.001c-.374.266-.623.798-.623 1.197-.125.266.124.531.124.797 0 .665.998 1.595 1.373 1.861l27.569 17.28c.25.133.375.133.624.133h.374c.25 0 .874-.266.998-.399l33.309-20.603c.499-.266.623-.797.623-1.196.125-.133-.124-.532-.124-.798 0-.664-.874-1.595-1.373-1.86l-27.32-17.147c-.249-.133-.748-.399-.998-.399h-.374c0-.133-.25 0-.374.133z"
            fill="#EAEBEC"
            />
            <path
            d="M156.686 351.738l-33.807 21.001c-.374.266-.624.798-.499 1.197-.125.133.25.531.25.797 0 .532 1.122 1.462 1.497 1.728l27.32 17.014c.249.133.374.133.624.133h.374c.249 0 .873-.266.998-.399l33.183-20.47c.499-.265.624-.797.499-1.196 0-.133-.249-.532-.249-.664 0-.532-.998-1.463-1.497-1.728l-26.821-16.881c-.125-.133-.749-.399-.998-.399-.125 0-.25-.133-.375 0 0-.266-.249-.266-.499-.133z"
            fill="#E3E4E6"
            />
            <path
            d="M156.811 351.87l-33.807 21.002c-.374.266-.624.797-.374 1.196 0 .133.374.532.374.665 0 .399 1.247 1.462 1.622 1.595l27.07 16.881c.25.133.375.133.624.133.125 0 .374-.133.374-.133.125 0 .874-.399.998-.399l33.059-20.47c.499-.266.624-.797.499-1.196 0-.133-.249-.532-.249-.665 0-.398-1.248-1.462-1.497-1.595l-26.447-16.615c-.125-.133-.749-.399-.998-.399-.125 0-.25-.132-.375-.132-.499 0-.623 0-.873.132z"
            fill="#DDDDE0"
            />
            <path
            d="M156.937 352.136l-33.807 21.002c-.374.266-.499.797-.374 1.196 0 .133.374.532.374.665 0 .266 1.372 1.329 1.622 1.462l26.696 16.748c.25.133.375.133.624.133l.374-.133c.125 0 .874-.399.998-.532l32.934-20.337c.375-.266.499-.93.375-1.196 0-.133-.375-.532-.375-.532 0-.265-1.372-1.329-1.621-1.462l-26.073-16.349c-.125-.133-.749-.399-.873-.399l-.375-.133c-.124-.266-.374-.266-.499-.133z"
            fill="#D6D6DA"
            />
            <path
            d="M156.937 352.27l-33.683 21.001c-.374.266-.499.931-.249 1.197 0 .133.499.531.499.531 0 .266 1.622 1.33 1.746 1.462l26.447 16.483c.25.133.375.133.624 0l.374-.133c.125 0 .874-.399.998-.532l32.81-20.204c.374-.266.499-.93.249-1.196 0 0-.499-.399-.499-.532 0-.266-1.497-1.329-1.622-1.329l-25.698-16.084c-.125 0-.749-.531-.873-.531l-.375-.133a.751.751 0 00-.748 0z"
            fill="#CFD0D3"
            />
            <path
            d="M157.06 352.402l-33.807 21.001c-.374.266-.499.931-.125 1.197l.624.531c0 .133 1.747 1.197 1.871 1.33l26.198 16.349c.249.133.374.133.624 0l.374-.133s.873-.532.998-.532l32.684-20.204c.375-.265.499-.93.125-1.196l-.499-.399c0-.133-1.622-1.196-1.746-1.196l-25.325-15.818-.873-.531-.374-.133c-.25-.399-.499-.399-.749-.266z"
            fill="#C8C9CD"
            />
            <path
            d="M157.809 352.668c-.249-.133-.374-.133-.623 0l-33.808 21.002c-.374.266-.374.93 0 1.196l28.568 17.679c.125.132.374.132.624 0l33.807-20.869c.374-.266.374-.93 0-1.196l-28.568-17.812z"
            fill="#C1C2C7"
            />
            <path
            d="M189.746 369.018l-3.992 2.525v-1.728l3.992-2.392v1.595z"
            fill="#B9C1ED"
            />
            <path
            d="M185.755 369.815l-28.943-17.811 3.993-2.393 28.942 17.812-3.992 2.392z"
            fill="url(#paint146_linear_874_76773)"
            />
            <path
            d="M185.755 371.543l-28.943-17.811v-1.728l28.943 17.811v1.728z"
            fill="#CBD3FA"
            />
            <path
            d="M185.503 366.492l-2.245 1.463v-1.596l2.245-1.329v1.462z"
            fill="#B9C1ED"
            />
            <path
            d="M183.259 366.359l-24.825-15.286 2.245-1.329 24.825 15.286-2.245 1.329z"
            fill="url(#paint147_linear_874_76773)"
            />
            <path
            d="M183.259 367.955l-24.825-15.419v-1.462l24.825 15.286v1.595z"
            fill="#CBD3FA"
            />
            <path
            d="M156.312 389.62l29.566-18.21v-3.456l-29.566 18.21v3.456z"
            fill="#131A2D"
            />
            <path
            d="M177.895 364.1c0 .266.124.531.499.664.623.399 1.621.399 2.245 0 .25-.133.499-.398.499-.664v-.532h-3.119v.532h-.124z"
            fill="#B9C1ED"
            />
            <path
            d="M180.514 362.903c-.624-.398-1.622-.398-2.245 0-.624.399-.624.931 0 1.33.623.398 1.621.398 2.245 0 .624-.399.624-.931 0-1.33z"
            fill="#fff"
            />
            <path
            d="M178.145 363.434c0 .266.124.399.374.532.499.266 1.372.266 1.871 0 .25-.133.374-.399.374-.532v-17.811h-2.619v17.811z"
            fill="#CBD3FA"
            />
            <path
            d="M180.39 345.092c-.499-.266-1.372-.266-1.871 0-.499.266-.499.797 0 1.196.499.266 1.372.266 1.871 0 .499-.399.499-.93 0-1.196z"
            fill="#D4D4D4"
            />
            <path
            d="M169.412 358.784c0 .265.125.531.499.664.624.399 1.622.399 2.246 0 .249-.133.499-.399.499-.664v-.532h-3.244v.532z"
            fill="#5766C4"
            />
            <path
            d="M172.157 357.72c-.624-.399-1.622-.399-2.246 0-.624.399-.624.931 0 1.329.624.399 1.622.399 2.246 0 .499-.398.499-.93 0-1.329z"
            fill="#fff"
            />
            <path
            d="M169.662 358.251c0 .266.125.399.374.532.499.265 1.373.265 1.872 0 .249-.133.374-.399.374-.532v-17.812h-2.62v17.812z"
            fill="#CBD3FA"
            />
            <path
            d="M171.908 339.907c-.499-.265-1.373-.265-1.872 0-.499.266-.499.798 0 1.197.499.266 1.373.266 1.872 0 .499-.399.499-.931 0-1.197z"
            fill="#D4D4D4"
            />
            <path
            d="M160.805 353.599c0 .266.124.532.499.665.623.399 1.621.399 2.245 0 .25-.133.499-.399.499-.665v-.531h-3.119v.531h-.124z"
            fill="#5766C4"
            />
            <path
            d="M163.549 352.403c-.623-.399-1.621-.399-2.245 0-.624.399-.624.931 0 1.329.624.399 1.622.399 2.245 0 .499-.398.499-.93 0-1.329z"
            fill="#fff"
            />
            <path
            d="M161.055 352.934c0 .266.124.399.374.532.499.266 1.372.266 1.871 0 .25-.133.374-.399.374-.532v-17.811h-2.619v17.811z"
            fill="#CBD3FA"
            />
            <path
            d="M163.3 334.591c-.499-.266-1.372-.266-1.871 0-.499.266-.499.798 0 1.196.499.266 1.372.266 1.871 0 .499-.398.499-.93 0-1.196z"
            fill="#D4D4D4"
            />
            <path
            d="M182.262 348.681l4.241-2.659v-2.259l-4.241 2.658v2.26z"
            fill="#5766C4"
            />
            <path
            d="M182.262 348.68l-25.2-15.551v-1.994l25.2 15.551v1.994z"
            fill="#fff"
            />
            <path
            d="M185.006 348.415l-30.315-18.609 15.095-1.595 15.22 20.204z"
            fill="#fff"
            />
            <path
            d="M188.873 346.022l-3.868 2.393-15.843-19.274.624-.93 3.992-2.393 15.095 20.204zM156.313 389.621l-28.942-17.679v-3.588l28.942 17.811v3.456z"
            fill="#131A2D"
            />
            <path
            d="M156.312 389.62l-3.992 2.392v-1.728l3.992-2.392v1.728z"
            fill="#131A2D"
            />
            <path
            d="M152.321 390.285l-28.817-17.678 3.867-2.526 28.942 17.811-3.992 2.393z"
            fill="#fff"
            />
            <path
            d="M152.321 390.419l-28.942-17.812 4.117-2.525 28.942 17.811-4.117 2.526zm-28.693-17.812l28.693 17.679 3.742-2.393-28.692-17.678-3.743 2.392z"
            fill="#131A2D"
            />
            <path
            d="M152.321 392.012l-28.817-17.811v-1.596l28.817 17.679v1.728zM154.566 386.696l-2.121 1.329v-1.462l2.121-1.462v1.595z"
            fill="#131A2D"
            />
            <path
            d="M185.879 367.954l-28.942-17.679-29.316 18.211 2.121 1.329-2.246 1.462 24.95 15.286 2.121-1.462 1.871 1.196 29.441-18.343z"
            fill="#fff"
            />
            <path
            d="M152.446 386.563l-24.95-15.419 2.246-1.329-2.246-1.329h.125l29.441-18.343 28.942 17.811h-.125l-29.441 18.343-1.746-1.063-2.246 1.329zm-24.825-15.286l24.7 15.153 2.246-1.329 1.746 1.063 29.317-18.21-28.693-17.679-29.316 18.211 2.245 1.329-2.245 1.462z"
            fill="#131A2D"
            />
            <path
            d="M152.446 388.025l-24.95-15.286v-1.462l24.95 15.286v1.462z"
            fill="#131A2D"
            />
            <path
            d="M157.31 359.314c.374 0 .748 0 1.123.133h2.12v.798c0 .664-1.372 1.462-3.243 1.462-1.871 0-3.244-.798-3.244-1.462v-.798h2.121c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 361.839c-1.871 0-3.119-.797-3.244-1.462V359.314h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c-.124.798-1.497 1.595-3.243 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M160.179 360.909s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.805 361.174v-1.861h.374v1.596c-.125.132-.125.132-.374.265zm.249-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M156.312 359.313v2.393h-.25v-2.26c.125 0 .125 0 .25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.312 361.839h-.25v-2.525h.375v2.525h-.125zm-.125-.266l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M156.685 361.706h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.685 361.839h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.939 361.308c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.939 361.308c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125.133.125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.935 361.839h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M157.06 361.839h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.566 361.042c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 361.174c-.125-.133-.25-.133-.375-.265v-1.596h.375v1.861zm-.125-.398c0 .133 0 .133 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.564 361.573c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.689 361.573c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.937 361.574h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M156.062 361.706c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.25-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M155.189 361.441c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.314 361.573c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.266s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M159.056 361.44h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.807 361.706v-2.392h.374v2.259c-.125 0-.25 0-.374.133zm.124-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.685 361.707h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.436 361.839v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.31 359.314v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M157.31 361.839h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.554 360.245c0 .133-.125.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M160.18 360.909v-1.596h.374v.931c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M154.191 360.644c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 360.909l-.125-.133c-.125-.133-.125-.266-.125-.399v-1.064h.25v1.596zm-.25-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.804 361.175c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 361.44v-2.127h.374v1.861c-.125.133-.25.133-.374.266zm.124-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M158.058 361.706h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.809 361.839v-2.526h.374v2.393c-.25.133-.25.133-.374.133zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 361.308c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.182 361.573v-2.26h.374v1.994c-.125.133-.25.133-.374.266zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.683 361.573h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M158.434 361.706v-2.393h.374v2.26c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.433 361.707h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M158.059 361.839v-2.526h.374v2.393c-.125 0-.125 0-.374.133zm.249-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M157.31 357.72c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.248-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 361.042c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.373-1.595 3.244-1.595 1.996 0 3.368.931 3.368 1.595 0 .665-1.497 1.595-3.368 1.595zm0-3.19c-1.871 0-3.119.798-3.119 1.462 0 .665 1.248 1.463 3.119 1.463 1.871 0 3.119-.798 3.119-1.463 0-.664-1.373-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.431 360.511c-.25.133-.499.133-.749.266l-2.62-2.792c.25 0 .499-.132.749-.132l2.62 2.658zM157.559 360.909h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.308 360.777h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.686 360.777h.997-.997c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M162.175 362.239c.374 0 .749 0 1.123.133h2.121v.798c0 .797-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 364.765c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.249.797-1.497 1.595-3.368 1.595zm-3.244-1.595c0 .664 1.373 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M165.044 363.836s-.124.132-.249.132v-1.728h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 364.101v-1.861h.374v1.596c-.125.132-.249.132-.374.265zm.125-1.728v1.463h.124l-.124-1.463z"
            fill="#131A2D"
            />
            <path
            d="M161.177 362.24v2.393h-.249v-2.26c.124 0 .249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.302 364.767h-.249v-2.393h.374v2.393h-.125zm-.249-.266l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M161.552 364.633h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.552 364.766h-.249v-2.526h.374v2.526h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.804 364.235c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.804 364.235c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266s0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.925 364.633h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.925 364.766h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 363.969c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 364.102c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.399s0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.429 364.5c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.554 364.5c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.802 364.501h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.927 364.634c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M160.179 364.368c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M160.179 364.5c-.125-.132-.249-.132-.249-.132v-1.994h.374v2.126h-.125zm-.125-.265l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M163.921 364.367h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.672 364.634v-2.26h.374v2.26c-.125-.133-.125-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.55 364.633h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.301 364.766v-2.659h.374v2.526c-.125.133-.249.133-.374.133zm.125-2.526v2.393h.124l-.124-2.393c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path d="M162.175 362.24v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M162.175 364.766h-.249v-2.659h.374v2.659h-.125zm-.124-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M165.417 363.172c0 .133-.124.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M165.168 363.836v-1.595h.374v.931c0 .133-.125.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M159.056 363.571c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 363.836l-.125-.133c-.124-.133-.124-.265-.124-.398v-1.064h.249v1.595zm-.249-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.669 364.102c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.42 364.368v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.923 364.633h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.674 364.766v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 364.235c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.047 364.501v-2.26h.374v2.127c-.125 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 364.5h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.422 364.633v-2.393h.374v2.26c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.298 364.633h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M163.049 364.766v-2.526h.374v2.393c-.249 0-.249 0-.374.133zm.125-2.393v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M162.175 360.644c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 363.834c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.058c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.296 363.436c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.424 363.834h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M163.173 363.702h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.551 363.701h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.249.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M167.04 365.163c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 367.688c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121c.374-.133.748-.133 1.122-.133.375 0 .749 0 1.123.133h2.121v.931c0 .797-1.372 1.595-3.244 1.595zm-3.118-1.595c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.91 366.759s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 367.024v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M166.042 365.164v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.167 367.556h-.249v-2.393h.374v2.393h-.125zm-.249-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.416 367.557h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 367.689h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.669 367.025c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 367.157c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266s0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.791 367.556h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.791 367.689h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 366.891c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.421 367.024c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399s.124.133 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.419 367.423c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.419 367.423c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.124-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M165.792 367.423h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.792 367.556c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M165.044 367.29c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M165.044 367.29c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.133l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.912 367.29h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.662 367.423v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.541 367.555h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M167.166 367.688v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.166 365.162v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M167.041 367.688h-.25v-2.659h.374v2.659h-.124zm0-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.285 366.094c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 366.758v-1.595h.374v.931c0 .133-.124.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M164.047 366.492c-.125-.132-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M164.046 366.758l-.124-.133c-.125-.133-.125-.266-.125-.399V365.163h.249v1.595zm-.124-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M169.535 367.024c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.285 367.289v-1.993h.374v1.861c-.124 0-.124 0-.374.132zm.125-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.789 367.556h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.539 367.689v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.287 367.157c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 367.423v-2.26h.374v1.994c-.124.133-.124.133-.374.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.537 367.424h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.287 367.556v-2.393h.374v2.26c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M168.164 367.557h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.914 367.689v-2.526h.374v2.393c-.124 0-.249 0-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M167.04 363.568c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 366.758c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595.125.798-1.248 1.595-3.244 1.595zm0-3.057c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463.125-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M169.161 366.36c-.249.133-.499.133-.748.265l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM167.289 366.758h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M168.038 366.626h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.132-.125.133-.25 0-.375 0h-.374c.125 0 .25.001.374-.132v-.133zM166.541 366.626h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M171.906 368.089c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.906 370.613c-1.872 0-3.119-.797-3.244-1.462V368.088h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.463 3.119 1.463 1.871 0 3.118-.798 3.118-1.463v-.797h-1.871a7.089 7.089 0 00-2.37 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M174.775 369.683s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M174.525 369.949v-1.861h.375v1.595c-.125.133-.125.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.033 368.088v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.033 370.48h-.25v-2.392h.374v2.392h-.124zm-.25-.132c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M171.283 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.408 370.613h-.25v-2.525h.374v2.525h-.124zm-.25-.265c0 .132.125.132 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.535 369.949c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 370.082c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M171.656 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.781 370.613h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M169.287 369.816c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.286 369.949c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399c.125 0 .125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M170.285 370.348c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M170.41 370.348c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.25-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M170.658 370.347h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M170.658 370.48c-.125 0-.25 0-.25-.132v-2.26h.374v2.392h-.124zm-.125-.265c0 .133 0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M169.91 370.215c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 370.215c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.133l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M173.777 370.215h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M173.527 370.348v-2.26h.375v2.26h-.375zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M172.404 370.481h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M172.154 370.613v-2.658h.375v2.526c-.25.132-.25.132-.375.132zm.125-2.525v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M172.031 368.088v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M171.906 370.613h-.25v-2.658h.375v2.658h-.125zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M175.15 369.018c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M174.9 369.683v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M168.912 369.417c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 369.683l-.125-.133c-.125-.133-.125-.266-.125-.399V368.088h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M174.525 369.949c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M174.15 370.082v-1.994h.375v1.861c-.125 0-.125.133-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M172.779 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.404 370.613v-2.525h.375v2.525h-.375zm.125-2.525v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M174.152 370.082c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M173.902 370.348v-2.26h.375v2.127c-.25 0-.25 0-.375.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M173.404 370.348h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M173.154 370.481v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M173.029 370.48h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M172.779 370.481v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M171.906 366.493c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M171.905 369.684c-1.996 0-3.368-.798-3.368-1.596 0-.797 1.372-1.595 3.368-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.596-3.244 1.596zm0-3.058c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463.125-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M174.026 369.284c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM172.279 369.683h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M173.029 369.55h.124c.125 0 .25 0 .375-.132.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.132h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM171.406 369.55h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M157.31 357.853c.374 0 .748 0 1.123.133h2.12v.798c0 .797-1.372 1.462-3.243 1.462-1.871 0-3.244-.798-3.244-1.462v-.798h2.121c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 360.379c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.931c-.124.93-1.497 1.595-3.243 1.595zm-3.244-1.595c0 .664 1.373 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462v-.798h-1.996c-.374-.133-.749-.133-1.123-.133s-.748 0-1.123.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M160.179 359.448s-.125.133-.249.133v-1.595h.249v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M159.805 359.713v-1.86h.374v1.595c-.125.133-.125.265-.374.265zm.249-1.595v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path d="M156.312 357.985v2.393h-.25v-2.393h.25z" fill="#0EA59D" />
            <path
            d="M156.312 360.378h-.25v-2.393h.375v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.685 360.379h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.685 360.378h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.939 359.846c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.939 359.979c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.935 360.379h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.06 360.378h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.566 359.581c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 359.713c-.125-.132-.25-.265-.375-.265v-1.595h.375v1.86zm-.125-.265l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.564 360.112c-.125 0-.125 0-.25-.133v-1.994h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M155.689 360.245c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.266s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.937 360.246h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M156.062 360.245c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M155.189 359.979c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.314 360.112c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M159.056 360.112h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.807 360.245v-2.26h.374v2.26c-.125-.133-.25 0-.374 0zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.685 360.378h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.436 360.378v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.31 357.853v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M157.31 360.378h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.554 358.784c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M160.18 359.448v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.33v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M154.191 359.316c-.125-.133-.125-.266-.125-.399v-.931h.125v1.33z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 359.448l-.125-.133c-.125-.133-.125-.266-.125-.399V357.853h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.804 359.713c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 359.979v-1.994h.374v1.861c-.125 0-.25 0-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M158.058 360.379h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.809 360.378v-2.525h.374v2.525h-.374zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 359.98c-.125 0-.125 0-.249.133v-2.127h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.182 360.112v-2.259h.374v2.126c-.125 0-.25.133-.374.133zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.683 360.113h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.434 360.245v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.127v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.433 360.246h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M158.059 360.378v-2.525h.374v2.392c-.125.133-.125.133-.374.133zm.249-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M157.31 356.39c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.797 1.248-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 359.581c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.996 0 3.368.797 3.368 1.595 0 .797-1.497 1.595-3.368 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.373-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.431 359.05c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM157.559 359.448h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.308 359.315h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.686 359.315h.997-.997c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M162.175 360.776c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 363.302c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12c.375-.132.749-.132 1.123-.132s.749 0 1.123.132h2.121v.931c-.125.797-1.373 1.595-3.244 1.595zm-3.243-1.595c0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462v-.798h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M165.044 362.371s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 362.637v-1.861h.374v1.595c-.125.133-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M161.177 360.909v2.393h-.249v-2.26c.124-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.302 363.302h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M161.55 363.302h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.55 363.302h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.804 362.77c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.804 362.903c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.925 363.302h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.925 363.302h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 362.504c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 362.637c-.125-.133-.25-.133-.374-.266v-1.595h.374v1.861zm-.25-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.429 363.036c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.554 363.169c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.802 363.17h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.927 363.169c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M160.179 362.904c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M160.179 363.036c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.125-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M163.921 363.036h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.672 363.169v-2.26h.374v2.26c-.125-.133-.125-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.548 363.301h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.299 363.301v-2.658h.374v2.525c-.125.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path d="M162.175 360.775v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M162.175 363.301h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.419 361.707c0 .133-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M165.17 362.371v-1.595h.374v.931c0 .133-.125.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M159.056 362.239c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 362.371l-.125-.133c-.124-.132-.124-.265-.124-.398v-1.064h.249v1.595zm-.249-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.669 362.637c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.42 362.903v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.923 363.169h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.674 363.302v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 362.904c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.047 363.036v-2.26h.374v2.127c-.125 0-.249.133-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 363.036h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.422 363.169v-2.393h.374v2.26c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.298 363.169h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M163.049 363.302v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M162.175 359.314c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 362.505c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596zm0-3.191c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.296 361.973c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.424 362.371h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M163.173 362.239h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.551 362.239h.998-.998c-.125 0-.375 0-.499-.132-.125 0-.25-.133-.499-.133h.499c.249.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M167.04 363.701c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 366.227c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121c.374-.133.748-.133 1.122-.133.375 0 .749 0 1.123.133h2.121v.931c0 .797-1.372 1.595-3.244 1.595zm-3.118-1.595c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.91 365.296s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 365.562v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M166.042 363.834v2.392h-.249v-2.259c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.167 366.226h-.249v-2.392h.374v2.392h-.125zm-.249-.266s.125.133 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M166.416 366.094h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 366.227h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.669 365.695c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 365.828c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.791 366.226h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M166.791 366.227h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 365.429c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.421 365.562c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266s.124 0 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.419 365.961c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.419 366.094c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.124-.266l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M165.792 366.094h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.792 366.094c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M165.044 365.828c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M165.044 365.961c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.912 365.961h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.662 366.094v-2.26h.374v2.26c-.249-.133-.249-.133-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.541 366.227h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M167.166 366.227v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.166 363.701v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M167.041 366.227h-.25v-2.659h.374v2.659h-.124zm0-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.285 364.631c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 365.296v-1.595h.374v.931c0 .133-.124.265-.249.531l-.125.133zm.125-1.462v1.063c0-.132.125-.132.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M164.047 365.03c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M164.046 365.296l-.124-.133c-.125-.133-.125-.266-.125-.398v-1.064h.249v1.595zm-.124-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M169.535 365.562c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.285 365.828v-1.994h.374v1.861c-.124 0-.124 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.789 366.094h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.539 366.227v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.287 365.828c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 365.961v-2.26h.374v2.127c-.124 0-.124 0-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.537 365.961h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.287 366.094v-2.393h.374v2.26c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M168.164 366.094h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.914 366.227v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M167.04 362.239c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 365.429c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.372 1.463 3.118 1.463 1.747 0 3.119-.798 3.119-1.463 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M169.161 364.898c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.289 365.296h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M168.038 365.164h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.541 365.163h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M171.906 366.625c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.463-3.243 1.463-1.872 0-3.244-.798-3.244-1.463v-.797h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.906 369.151c-1.872 0-3.119-.798-3.244-1.463V366.625h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.125.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.871a7.089 7.089 0 00-2.37 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M174.775 368.221s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M174.525 368.487v-1.861h.375v1.595c-.125.133-.125.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.033 366.758v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.033 369.151h-.25v-2.393h.374v2.393h-.124zm-.25-.266c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M171.281 369.019h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.406 369.152h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.535 368.619c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 368.752c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.399c0 .133.125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M171.656 369.152h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.781 369.152h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.287 368.354c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.286 368.487c-.124-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399c.125.133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M170.285 368.886c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M170.41 369.019c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.25-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M170.658 369.019h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M170.658 369.019c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M169.91 368.752c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 368.885c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M173.777 368.753h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M173.527 369.019v-2.26h.375v2.26c-.125-.133-.25-.133-.375 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M172.404 369.151h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M172.154 369.151v-2.659h.375v2.526c-.25.133-.25.133-.375.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M172.031 366.625v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M171.906 369.151h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M175.148 367.557c0 .132-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M174.898 368.221v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M168.912 367.955c-.125-.133-.125-.266-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 368.221l-.125-.133c-.125-.133-.125-.265-.125-.398v-1.064h.25v1.595zm-.125-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M174.525 368.486c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M174.15 368.752v-1.994h.375v1.861c-.125 0-.125 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M172.779 369.019h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.404 369.151v-2.525h.375v2.525h-.375zm.125-2.392v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M174.15 368.62c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M173.9 368.886v-2.26h.375v2.127c-.25 0-.25 0-.375.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M173.402 368.886h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M173.152 369.019v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M173.029 369.019h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.779 369.152v-2.526h.375v2.393c-.125 0-.25.133-.375.133zm.125-2.393v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M171.906 365.029c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.664 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M171.905 368.352c-1.996 0-3.368-.797-3.368-1.595 0-.797 1.372-1.595 3.368-1.595 1.996 0 3.244.798 3.244 1.595.125.665-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462.125-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M174.026 367.822c-.249.132-.499.132-.748.265l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.659zM172.279 368.22h-.499l-2.37-2.526c.125 0 .25-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M173.029 368.087h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.132h-.749c.125 0 .25 0 .375-.132v-.133zM171.406 368.087h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.132-.499-.132h.499c.125 0 .374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M157.31 356.391c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 359.049c-1.871 0-3.119-.797-3.244-1.462V356.524h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c-.124.798-1.497 1.595-3.243 1.595zm-3.244-1.728c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.664h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.664z"
            fill="#131A2D"
            />
            <path
            d="M160.179 358.12s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.805 358.386v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.249-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.312 356.525v2.392h-.25v-2.259c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.312 358.917h-.25v-2.392h.375v2.392h-.125zm-.125-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M156.685 358.916h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.685 358.916h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.939 358.386c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.939 358.518c-.125-.132-.25-.132-.25-.132v-1.861h.375v1.993h-.125zm-.25-.265c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.935 358.917h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.06 359.05h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.566 358.253c-.125 0-.125-.133-.25-.133v-1.463h.25v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 358.386c-.125-.133-.25-.133-.375-.266v-1.595h.375v1.861zm-.125-.399l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.564 358.651c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.689 358.783c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.25-.266c0 .133.125.133 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.937 358.784h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M156.062 358.917c-.125 0-.25 0-.25-.132v-2.26h.375v2.392h-.125zm-.25-.265l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M155.189 358.518c-.125 0-.125 0-.25-.132v-1.861h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M155.314 358.651c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.25-.265c0 .132.125.132 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M159.056 358.651h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.807 358.784v-2.259h.374v2.259h-.374zm.124-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.685 358.916h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.436 359.049v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.31 356.391v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M157.31 359.049h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.554 357.455c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M160.18 358.12v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M154.191 357.853c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 357.986l-.125-.133c-.125-.133-.125-.266-.125-.399V356.391h.25v1.595zm-.25-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.804 358.385c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 358.518v-1.994h.374v1.861c-.125 0-.25.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M158.058 358.917h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 359.05v-2.525h.374v2.392c-.25 0-.25 0-.374.133zm.124-2.525v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.431 358.517c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.182 358.651v-2.26h.374v2.127c-.125.133-.25.133-.374.133zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.683 358.784h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.434 358.917v-2.392h.374v2.259c-.125 0-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M158.433 358.784h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M158.059 358.917v-2.526h.374v2.393c-.125.133-.125.133-.374.133zm.249-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M157.31 354.929c1.871 0 3.243.797 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.798 1.248-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 358.119c-1.996 0-3.244-.797-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.996 0 3.368.797 3.368 1.595-.125.798-1.497 1.595-3.368 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.798-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.431 357.72c-.25.133-.499.133-.749.266l-2.62-2.792c.25 0 .499-.132.749-.132l2.62 2.658zM157.559 358.119h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.308 357.986h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.686 357.987h.997-.997c-.125 0-.375 0-.499-.133-.125-.133-.25-.133-.499-.133h.499c.124.133.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M162.175 359.314c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 361.973c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.249.797-1.497 1.595-3.368 1.595zm-3.244-1.728c0 .664 1.373 1.462 3.119 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M165.044 360.91s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 361.309v-1.861h.374v1.595c-.125 0-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M161.177 359.447v2.393h-.249v-2.26c.124-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.302 361.84h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M161.55 361.84h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.55 361.84h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.804 361.308c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.804 361.441c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.925 361.84h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.925 361.973h-.249v-2.659h.374v2.659h-.125zm-.124-.266l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 361.042c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 361.175c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.429 361.575c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.554 361.707c-.125 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.265c.124 0 .124.132 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.802 361.707h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.927 361.839c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.266s.124 0 0 0l.124-1.993h-.124v1.993z"
            fill="#131A2D"
            />
            <path
            d="M160.179 361.441c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M160.179 361.574c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.125-.266s0 .133 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M163.921 361.574h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.672 361.707v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.55 361.84h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.301 361.973v-2.659h.374v2.526c-.125.133-.249.133-.374.133zm.125-2.526v2.393h.124l-.124-2.393c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path d="M162.175 359.314v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M162.175 361.973h-.249v-2.659h.374v2.659h-.125zm-.124-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M165.419 360.377c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M165.17 361.042v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.266l-.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M159.056 360.777c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 360.909l-.125-.133c-.124-.133-.124-.266-.124-.398v-1.064h.249v1.595zm-.249-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M164.669 361.175c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.42 361.441v-1.994h.374v1.861c-.125 0-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.923 361.84h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.674 361.84v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 361.442c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.047 361.574v-2.26h.374v2.127c-.125.133-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 361.708h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.422 361.84v-2.393h.374v2.26c-.249 0-.249 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.298 361.707h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M163.049 361.84v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M162.175 357.853c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 361.043c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.296 360.644c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.426 360.909h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M163.173 360.777h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.551 360.91h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.249.132.374.132.499.265z"
            fill="#fff"
            />
            <path
            d="M167.04 362.239c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374 0 .748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 364.898c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.125.797-1.497 1.595-3.369 1.595zm-3.118-1.728c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.91 363.836s-.125.132-.25.132v-1.728h.25v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 364.235v-1.861h.374v1.595c-.124 0-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M166.042 362.374v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.167 364.767h-.249v-2.393h.374v2.393h-.125zm-.249-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.417 364.767h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M166.542 364.766h-.249v-2.526h.374v2.526h-.125zm-.249-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.671 364.235c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.796 364.368c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.791 364.767h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.791 364.766h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 363.969c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.421 364.102c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.266s.124 0 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.419 364.5c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.419 364.633c-.124 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.124-.265l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M165.792 364.634h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.792 364.767c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M165.044 364.368c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M165.044 364.5c-.124 0-.249-.132-.249-.132v-1.994h.374v2.126h-.125zm-.124-.265l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.912 364.5h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M168.662 364.633v-2.259h.374v2.259h-.374zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M167.541 364.766h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M167.166 364.899v-2.659h.374v2.526c-.124 0-.249 0-.374.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.166 362.24v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M167.041 364.899h-.25v-2.659h.374v2.659h-.124zm0-.266l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.285 363.304c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 363.969v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M164.047 363.702c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M164.046 363.835l-.124-.133c-.125-.133-.125-.265-.125-.398v-1.064h.249v1.595zm-.124-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.535 364.102c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.285 364.368v-1.994h.374v1.861c-.124 0-.124 0-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.789 364.767h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.539 364.766v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.287 364.367c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 364.5v-2.26h.374v2.127c-.124.133-.124.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.537 364.634h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.287 364.766v-2.392h.374v2.259c-.124 0-.249 0-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M168.164 364.633h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.914 364.766v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127c0 .133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.04 360.776c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 363.967c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.93 3.244 1.595 0 .664-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462.125-.665-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M169.161 363.436c-.249.132-.499.132-.748.265l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM167.291 363.834h-.499l-2.37-2.525c.125 0 .249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M168.038 363.702h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.541 363.834h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.133.249.133.499.266z"
            fill="#fff"
            />
            <path
            d="M171.906 365.164c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.906 367.689c-1.872 0-3.119-.797-3.244-1.462V365.164h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.931-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462v-.797h-1.871a7.089 7.089 0 00-2.37 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M174.775 366.759s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M174.525 367.157v-1.861h.375v1.595c-.125 0-.125.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.033 365.296v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.033 367.689h-.25v-2.393h.374v2.393h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M171.281 367.689h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M171.406 367.689h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M169.537 367.158c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.662 367.29c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M171.656 367.689h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M171.781 367.689h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M169.287 366.892c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.286 367.025c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M170.285 367.423c-.125 0-.125 0-.25-.132v-2.127h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M170.41 367.556c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.25-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M170.658 367.556h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M170.658 367.556c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M169.91 367.29c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 367.423c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M173.777 367.423h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M173.527 367.556v-2.26h.375v2.26c-.125-.133-.25 0-.375 0zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M172.404 367.688h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M172.154 367.688v-2.658h.375v2.526c-.25.132-.25.132-.375.132zm.125-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M172.031 365.163v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M171.906 367.688h-.25v-2.658h.375v2.658h-.125zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M175.15 366.094c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M174.9 366.892v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M168.912 366.626c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 366.759l-.125-.133c-.125-.133-.125-.266-.125-.399V365.164h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M174.525 367.025c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M174.15 367.29v-1.993h.375v1.861c-.125 0-.125 0-.375.132zm.125-1.86v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M172.779 367.689h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M172.404 367.689v-2.525h.375v2.525h-.375zm.125-2.392v2.259h.125l-.125-2.259c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M174.152 367.29c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M173.902 367.423v-2.259h.375v2.127c-.25 0-.25.132-.375.132zm.125-1.993v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M173.402 367.556h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M173.152 367.689v-2.392h.375v2.259c-.125 0-.25 0-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M173.029 367.556h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M172.779 367.689v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.392v2.126h.125l-.125-2.126c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M171.906 363.702c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M171.905 366.891c-1.996 0-3.368-.797-3.368-1.595 0-.797 1.372-1.595 3.368-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M174.026 366.361c-.249.132-.499.132-.748.265l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.659zM172.279 366.759h-.499l-2.37-2.526c.125-.132.25-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M173.029 366.627h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.132h-.749c.125 0 .25 0 .375-.132v-.133zM171.406 366.626h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M157.31 355.062c.374 0 .748 0 1.123.132h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.25-.132.624-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 357.587c-1.871 0-3.119-.797-3.244-1.462V355.062h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c-.124.798-1.497 1.595-3.243 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M160.179 356.657s-.125.132-.249.132v-1.727h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.805 356.923v-1.861h.374v1.596c-.125.132-.125.132-.374.265zm.249-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M156.312 355.062v2.392h-.25v-2.26c.125-.132.125-.132.25-.132z"
            fill="#0EA59D"
            />
            <path
            d="M156.312 357.455h-.25v-2.393h.375v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.685 357.454h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.685 357.588h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.939 357.055c-.125 0-.125-.132-.25-.132v-1.728h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M154.939 357.055c-.125-.133-.25-.133-.25-.133v-1.86h.375v1.993h-.125zm-.25-.266c.125 0 .125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.935 357.454h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.06 357.587h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.566 356.79c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 356.922c-.125-.133-.25-.265-.375-.265v-1.595h.375v1.86zm-.125-.398s0 .133 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.564 357.321c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.689 357.321c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.25-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.937 357.321h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M156.062 357.454c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M155.189 357.188c-.125 0-.125 0-.25-.133v-1.86h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M155.314 357.188c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.25-.133s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M159.056 357.188h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.807 357.322v-2.26h.374v2.26h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.685 357.454h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.436 357.587v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.31 355.062v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M157.31 357.587h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.554 355.992c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M160.18 356.657v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M154.191 356.391c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 356.657l-.125-.133c-.125-.133-.125-.266-.125-.399V355.062h.25v1.595zm-.25-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.804 356.922c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 357.188v-1.994h.374v1.861c-.125 0-.25 0-.374.133zm.124-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M158.058 357.454h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 357.588v-2.526h.374v2.526h-.374zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 357.055c-.125 0-.125 0-.249.133v-1.993h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M159.182 357.321v-2.259h.374v2.126c-.125 0-.25 0-.374.133zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.683 357.321h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.434 357.455v-2.393h.374v2.26c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.433 357.454h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M158.059 357.588v-2.526h.374v2.393c-.125 0-.125 0-.374.133zm.249-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M157.31 353.467c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.248-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 356.657c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.996 0 3.368.797 3.368 1.595 0 .797-1.497 1.595-3.368 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.373-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.431 356.258c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM157.559 356.656h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.308 356.524h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.686 356.524h.997-.997c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M162.175 357.985c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 360.511c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121a7.142 7.142 0 012.37 0h2.121v.931c-.249.797-1.497 1.595-3.368 1.595zm-3.244-1.595c0 .664 1.373 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M165.044 359.58s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 359.846v-1.861h.374v1.595c-.125.133-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M161.177 357.985v2.393h-.249v-2.26c.124-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.302 360.378h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M161.55 360.378h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.55 360.511h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.804 359.846c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.804 359.979c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.925 360.378h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.925 360.511h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 359.714c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 359.846c-.125-.133-.25-.133-.374-.266v-1.595h.374v1.861zm-.25-.399s0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.429 360.245c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.554 360.245c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.802 360.246h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.927 360.378c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266c0 .133.124.133 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M160.179 360.113c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M160.179 360.112c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.125-.133l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M163.921 360.112h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.672 360.245v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.548 360.379h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.299 360.511v-2.658h.374v2.525c-.125.133-.249.133-.374.133zm.125-2.526v2.393h.124l-.124-2.393c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path d="M162.175 357.986v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M162.175 360.511h-.249v-2.658h.374v2.658h-.125zm-.124-.133c.124 0 .124 0 0 0l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M165.417 358.916c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M165.168 359.58v-1.595h.374v.931c0 .133-.125.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.124-.266.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M159.056 359.315c-.124-.133-.124-.265-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 359.58l-.125-.133c-.124-.132-.124-.265-.124-.398v-1.064h.249v1.595zm-.249-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.669 359.847c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.42 359.979v-1.994h.374v1.861c-.125.133-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.923 360.378h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.674 360.511v-2.526h.374v2.526h-.374zm.125-2.526v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 359.98c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.047 360.245v-2.26h.374v2.127c-.125 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 360.245h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.422 360.378v-2.393h.374v2.26c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.298 360.378h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M163.049 360.378v-2.393h.374v2.393h-.374zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M162.175 356.39c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 359.581c-1.996 0-3.243-.931-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.93 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.296 359.183c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.424 359.581h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M163.173 359.449h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.551 359.448h.998-.998c-.125 0-.375 0-.499-.132-.125 0-.25-.133-.499-.133h.499c.249.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M167.04 360.91c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 363.436c-1.871 0-3.118-.798-3.243-1.463V360.91h2.121c.374-.133.748-.133 1.122-.133.375 0 .749 0 1.123.133h2.121v.93c0 .798-1.372 1.596-3.244 1.596zm-3.118-1.596c0 .665 1.372 1.463 3.118 1.463 1.747 0 3.119-.798 3.119-1.463v-.797h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M169.91 362.505s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 362.77v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M166.042 360.91v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.167 363.302h-.249v-2.393h.374v2.393h-.125zm-.249-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.416 363.303h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 363.435h-.25v-2.526h.374v2.526h-.124zm-.25-.266l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.669 362.771c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 362.903c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.791 363.303h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.791 363.435h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 362.638c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.421 362.77c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s.124 0 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.419 363.17c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.419 363.169c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.124-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M165.792 363.169h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M165.792 363.302c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266c.125 0 .125.133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M165.044 363.037c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M165.044 363.036c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.133l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.912 363.037h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.662 363.169v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.539 363.302h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M167.164 363.435v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.166 360.909v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M167.041 363.435h-.25v-2.659h.374v2.659h-.124c.124 0 0 0 0 0zm0-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.285 361.84c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 362.504v-1.595h.374v.931c0 .133-.124.265-.249.531l-.125.133zm.125-1.462v1.063c0-.132.125-.132.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M164.047 362.239c-.125-.132-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M164.046 362.504l-.124-.132c-.125-.133-.125-.266-.125-.399v-1.064h.249v1.595zm-.124-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.535 362.771c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.285 362.903v-1.994h.374v1.861c-.124 0-.124.133-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.789 363.303h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.539 363.435v-2.526h.374v2.526h-.374zm.125-2.526v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.287 362.904c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 363.036v-2.26h.374v2.127c-.124.133-.124.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.537 363.17h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.287 363.302v-2.393h.374v2.26c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M168.164 363.302h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.914 363.302v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M167.04 359.314c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 362.505c-1.996 0-3.243-.931-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595.125.798-1.248 1.596-3.244 1.596zm0-3.058c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M169.161 362.106c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM167.289 362.505h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M168.038 362.372h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.541 362.372h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M171.906 363.834c.374 0 .748 0 1.122.133h2.121v.798c0 .664-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.906 366.36c-1.872 0-3.119-.798-3.244-1.463V363.834h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.125.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.871a7.089 7.089 0 00-2.37 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M174.775 365.43s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M174.525 365.696v-1.861h.375v1.595c-.125 0-.125.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.033 363.835v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.033 366.228h-.25v-2.393h.374v2.393h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M171.283 366.228h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.408 366.36h-.25v-2.525h.374v2.525h-.124zm-.25-.266s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M169.535 365.696c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 365.829c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M171.656 366.228h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.781 366.36h-.25v-2.525h.375v2.525h-.125zm-.25-.132s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.287 365.563c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.286 365.696c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M170.285 365.962c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M170.41 366.094c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.25-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M170.658 366.095h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M170.658 366.227c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.125-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M169.91 365.962c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 365.962c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.266c0 .133 0 .133 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M173.777 365.962h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M173.527 366.095v-2.26h.375v2.26h-.375zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M172.404 366.228h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M172.154 366.361v-2.659h.375v2.526c-.25.133-.25.133-.375.133zm.125-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M172.031 363.835v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M171.906 366.361h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M175.15 364.765c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M174.9 365.43v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M168.912 365.164c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 365.297l-.125-.133c-.125-.133-.125-.266-.125-.398v-1.064h.25v1.595zm-.125-.531v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M174.527 365.696c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M174.152 365.829v-1.994h.375v1.861c-.125 0-.125.133-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M172.779 366.228h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.404 366.36v-2.525h.375v2.525c-.125-.132-.125 0-.375 0zm.125-2.525v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M174.152 365.829c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M173.902 365.962v-2.26h.375v2.127c-.25.133-.25.133-.375.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M173.402 366.095h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M173.152 366.228v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M173.029 366.095h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.779 366.228v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M171.906 362.24c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M171.905 365.43c-1.996 0-3.368-.93-3.368-1.595 0-.797 1.372-1.595 3.368-1.595 1.996 0 3.244.931 3.244 1.595.125.798-1.248 1.595-3.244 1.595zm0-3.057c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462.125-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M174.026 365.032c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM172.279 365.43h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M173.029 365.299h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.132h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.132zM171.406 365.297h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.125 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M157.31 353.601c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 356.126c-1.871 0-3.119-.798-3.244-1.462V353.6h2.121c.374-.132.749-.132 1.123-.132s.748 0 1.123.132h2.12v.931c-.124.797-1.497 1.595-3.243 1.595zm-3.244-1.595c0 .664 1.373 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462v-.798h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M160.179 355.196s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.805 355.461v-1.86h.374v1.595c-.125.133-.125.133-.374.265zm.249-1.727v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.312 353.733v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.312 356.126h-.25v-2.393h.375v2.393h-.125zm-.125-.266s0 .133 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.687 355.993h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.687 356.126h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.939 355.595c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.939 355.727c-.125-.132-.25-.132-.25-.132v-1.861h.375v1.993h-.125zm-.25-.265c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.935 356.126h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.06 356.126h-.249V353.6h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.566 355.329c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 355.462c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.564 355.86c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.689 355.994c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.266s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.937 355.994h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M156.062 355.993c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M155.189 355.727c-.125 0-.125 0-.25-.132v-1.861h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M155.314 355.86c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M159.056 355.86h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.807 355.993v-2.26h.374v2.26c-.125-.133-.25-.133-.374 0zm.124-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.685 356.126h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.436 356.126v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.31 353.601v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M157.31 356.126h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.554 354.531c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M160.18 355.196v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M154.191 354.93c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 355.196l-.125-.133c-.125-.133-.125-.266-.125-.399V353.601h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.804 355.462c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 355.727v-1.994h.374v1.861c-.125 0-.25 0-.374.133zm.124-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M158.058 355.994h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.809 356.126v-2.525h.374v2.392c-.25.133-.25.133-.374.133zm.124-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.431 355.728c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.182 355.86v-2.259h.374v2.126c-.125 0-.25 0-.374.133zm.124-2.126v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M158.683 355.86h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.434 355.993v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M158.433 355.994h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M158.059 356.126v-2.525h.374v2.392c-.125.133-.125.133-.374.133zm.249-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M157.31 352.138c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.248-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 355.328c-1.996 0-3.244-.931-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.996 0 3.368.93 3.368 1.595-.125.664-1.497 1.595-3.368 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.431 354.796c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM157.559 355.195h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.308 355.062h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.686 355.062h.997-.997c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M162.175 356.523c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 359.048c-1.871 0-3.119-.797-3.244-1.462V356.523h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.249.798-1.497 1.595-3.368 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.798h-1.996a7.142 7.142 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M165.044 358.119s-.124.133-.249.133v-1.595h.249v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 358.385v-1.861h.374v1.595c-.125.133-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path d="M161.177 356.657v2.393h-.249v-2.393h.249z" fill="#0EA59D" />
            <path
            d="M161.302 359.051h-.249v-2.393h.374v2.393h-.125zm-.249-.266l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M161.55 358.917h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.55 359.05h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.804 358.518c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.804 358.651c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.925 359.05h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.925 359.05h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 358.252c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 358.385c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.398c0 .132 0 .132 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M160.429 358.784c-.125 0-.125 0-.249-.133v-1.994h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M160.554 358.918c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.802 358.917h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M160.927 358.917c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M160.179 358.651c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M160.179 358.784c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.125-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M163.921 358.651h-.249v-1.994h.249v1.994z" fill="#0EA59D" />
            <path
            d="M163.672 358.918v-2.26h.374v2.26c-.125-.133-.125-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.548 359.049h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.299 359.049v-2.658h.374v2.525c-.125.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path d="M162.175 356.523v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M162.175 359.049h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.417 357.455c0 .132-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M165.168 358.119v-1.595h.374v.931c0 .133-.125.266-.249.532l-.125.132zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M159.056 357.854c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 358.12l-.125-.133c-.124-.133-.124-.266-.124-.399V356.525h.249v1.595zm-.249-.665v.266-1.063.797z"
            fill="#131A2D"
            />
            <path
            d="M164.669 358.385c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.42 358.651v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.923 358.917h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.674 359.05v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 358.518c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.047 358.784v-2.26h.374v2.127c-.125 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 358.784h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.422 358.917v-2.392h.374v2.259c-.249.133-.249.133-.374.133zm.125-2.259v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path d="M163.298 358.917h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M163.049 359.05v-2.526h.374v2.393c-.249 0-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M162.175 354.929c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 358.252c-1.996 0-3.243-.931-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .664-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.373 1.462 3.119 1.462 1.747 0 3.119-.798 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.296 357.72c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.424 358.118h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M163.173 357.986h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133-.124.133-.249 0-.374 0h-.374c.125 0 .249 0 .374-.133v-.133zM161.551 357.987h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M167.04 359.449c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 361.975c-1.871 0-3.118-.798-3.243-1.462V359.45h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.369 1.595zm-3.118-1.595c0 .665 1.372 1.462 3.118 1.462 1.747 0 3.119-.797 3.119-1.462v-.798h-1.996c-.748-.132-1.622-.132-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.91 361.043s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 361.309v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M166.042 359.448v2.393h-.249v-2.26c.125 0 .249 0 .249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.167 361.974h-.249v-2.393h.374v2.393h-.125zm-.249-.266s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.416 361.841h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 361.974h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.669 361.442c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 361.442c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266c0 .133 0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.791 361.974h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.791 361.974h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 361.176c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.421 361.309c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399c0 .133.124.133 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.419 361.708c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.419 361.708c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.124-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M165.792 361.841h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M165.792 361.841c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M165.044 361.576c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M165.044 361.709c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.91 361.575h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.66 361.841v-2.26h.374v2.26c-.249-.133-.249-.133-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.539 361.842h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M167.164 361.974v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393c.125.133.125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.166 359.449v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M167.041 361.974h-.25v-2.659h.374v2.659h-.124zm0-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.283 360.379c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M170.033 361.043v-1.595h.374v.931c0 .133-.124.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M164.047 360.778c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M164.046 361.044l-.124-.133c-.125-.133-.125-.266-.125-.399v-1.064h.249v1.596zm-.124-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.535 361.31c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.285 361.576v-1.994h.374v1.861c-.124 0-.124 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.789 361.841h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.539 361.974v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.287 361.442c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 361.708v-2.26h.374v2.127c-.124 0-.124 0-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.537 361.708h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.287 361.841v-2.393h.374v2.26c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M168.164 361.841h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.914 361.974v-2.526h.374v2.393c-.124 0-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M167.04 357.854c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.665 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 361.177c-1.996 0-3.243-.93-3.243-1.595 0-.664 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462.125-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M169.161 360.646c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.289 361.044h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M168.038 360.912h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.541 360.911h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.125.265.249.265.499.265z"
            fill="#fff"
            />
            <path
            d="M171.906 362.372c.374 0 .748 0 1.122.133h2.121v.798c0 .664-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.906 364.898c-1.872 0-3.119-.798-3.244-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.125.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.871a7.089 7.089 0 00-2.37 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M174.775 363.967s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M174.525 364.233v-1.861h.375v1.595c-.125.133-.125.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.033 362.372v2.393h-.25v-2.26c.125 0 .125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.033 364.898h-.25v-2.393h.374v2.393h-.124zm-.25-.266c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M171.281 364.765h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.406 364.898h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.535 364.367c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 364.367c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s.125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M171.656 364.765h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.781 364.898h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.287 364.101c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.286 364.234c-.124-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399c.125.133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M170.285 364.632c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M170.41 364.632c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.25-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M170.658 364.632h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M170.658 364.766c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M169.91 364.499c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 364.631c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.25-.265l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M173.777 364.499h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M173.527 364.765v-2.26h.375v2.26c-.125-.133-.25-.133-.375 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M172.404 364.765h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M172.154 364.898v-2.659h.375v2.526c-.25.133-.25.133-.375.133zm.125-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M172.031 362.372v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M171.906 364.898h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M175.148 363.303c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M174.898 363.968v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M168.912 363.702c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 363.968l-.125-.133c-.125-.133-.125-.266-.125-.399V362.373h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M174.525 364.233c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M174.15 364.499v-1.994h.375v1.861c-.125 0-.125 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M172.779 364.765h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.404 364.898v-2.526h.375v2.526h-.375zm.125-2.393v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M174.15 364.367c-.125 0-.125 0-.25.132v-1.993h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M173.9 364.633v-2.26h.375v1.994c-.25.133-.25.133-.375.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M173.402 364.632h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M173.152 364.765v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M173.029 364.765h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.779 364.898v-2.526h.375v2.393c-.125 0-.25 0-.375.133zm.125-2.393v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M171.906 360.776c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M171.905 363.966c-1.996 0-3.368-.797-3.368-1.595 0-.797 1.372-1.595 3.368-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.057c-1.871 0-3.118.798-3.118 1.462 0 .665 1.372 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M174.026 363.569c-.249.132-.499.132-.748.265l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.659zM172.279 363.967h-.499l-2.37-2.525c.125-.133.25-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M173.029 363.835h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.132h-.749c.125 0 .25 0 .375-.132v-.133zM171.406 363.834h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M152.07 362.638c.374 0 .748 0 1.122.133h2.121v.798c0 .797-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 365.164c-1.872 0-3.119-.798-3.244-1.463V362.638h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c0 .931-1.372 1.596-3.243 1.596zm-3.119-1.596c0 .665 1.372 1.463 3.119 1.463 1.871 0 3.118-.798 3.118-1.463v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M154.939 364.233s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 364.631v-1.86h.375v1.595c-.125 0-.25.132-.375.265zm.125-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M151.072 362.77v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.197 365.162h-.25v-2.392h.375v2.392h-.125zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M151.447 365.162h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.572 365.162h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.699 364.631c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.824 364.764c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.82 365.162h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.945 365.162h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.326 364.365c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.45 364.498c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266s.125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.449 364.897c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M150.449 365.03c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.125-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.822 365.03h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.822 365.029c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M150.074 364.764c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 364.896c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.25-.266l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M153.941 364.896h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.691 365.029v-2.259h.375v2.259c-.25-.133-.25 0-.375 0zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.57 365.163h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M152.195 365.162v-2.658h.375v2.525c-.125.133-.125.133-.375.133zm.125-2.392v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.195 362.637v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 365.162h-.25v-2.658h.375v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M155.314 363.567c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 364.365v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M149.076 364.099c-.125-.133-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M149.076 364.232l-.125-.133c-.125-.133-.125-.266-.125-.399V362.637h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.566 364.497c-.125 0-.125.133-.25.133v-1.86h.25v1.727z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 364.764v-1.994h.375v1.861c-.125 0-.125 0-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.818 365.162h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.568 365.162v-2.525h.375v2.525h-.375zm.125-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M154.316 364.764c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 364.896v-2.259h.375v2.126c-.125 0-.125.133-.375.133zm.125-1.993v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M153.568 365.029h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M153.318 365.162v-2.392h.375v2.259c-.125 0-.25 0-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M153.193 365.029h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.943 365.162v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M152.07 361.176c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.872 0-3.244-.798-3.244-1.595 0-.798 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 364.366c-1.996 0-3.244-.931-3.244-1.595 0-.665 1.372-1.595 3.244-1.595 1.996 0 3.368.797 3.368 1.595 0 .797-1.372 1.595-3.368 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M154.191 363.834c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM152.318 364.233h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M153.068 364.1h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.623-.399a1.002 1.002 0 01-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.57 364.1h.998-.998c-.124 0-.374 0-.499-.133-.124-.133-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.935 365.562c.374 0 .748.001 1.123.133h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.132.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 368.088c-1.871 0-3.119-.797-3.244-1.462V365.563h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.872c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.797h-.125z"
            fill="#131A2D"
            />
            <path
            d="M159.804 367.159s-.125.132-.249.132v-1.728h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 367.423v-1.861h.374v1.596c-.125.132-.125.265-.374.265zm.124-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M156.062 365.696v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.062 368.09h-.25v-2.393h.375v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.312 368.088h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.437 368.088h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.564 367.557c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 367.691c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.685 368.088h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.81 368.088h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.316 367.29c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 367.423c-.125-.133-.25-.265-.375-.265v-1.596h.375v1.861zm-.125-.265l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.314 367.823c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.439 367.956c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.687 367.956h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M155.687 367.955c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.939 367.69c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 367.824c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.806 367.823h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.557 367.957v-2.259h.374v2.259c-.125-.133-.25-.133-.374 0zm.124-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.433 368.089h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M157.184 368.088v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.06 365.563v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M156.935 368.088h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.179 366.493c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.93 367.158v-1.596h.374v.931c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.941 367.025c-.125-.133-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 367.158l-.125-.133c-.125-.133-.125-.266-.125-.399v-1.064h.25v1.596zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.554 367.424c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 367.691v-1.994h.374v1.861c-.25 0-.25 0-.374.133zm.124-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.808 367.956h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.559 368.088v-2.526h.374v2.526h-.374zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 367.69c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 367.822v-2.26h.374v2.127c-.125 0-.25.133-.374.133zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.431 367.822h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M158.182 367.955v-2.393h.374v2.26c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.058 367.955h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.809 368.088v-2.526h.374v2.393c-.125.133-.25.133-.374.133zm.124-2.393v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.935 364.101c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 367.292c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595.125.664-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.372 1.462 3.119 1.462 1.746 0 3.119-.798 3.119-1.462.124-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.056 366.759c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .498-.132.748-.132l2.62 2.658zM157.311 367.157h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.058 367.025h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.437 367.025h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125 0 .375.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.925 368.488c.374 0 .749 0 1.123.132h2.121v.798c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.798h2.12c.25-.132.624-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 371.013c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.931c-.125.797-1.373 1.595-3.244 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M164.794 370.082s-.124.133-.249.133v-1.595h.249v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 370.348v-1.861h.374v1.595c-.125.133-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path d="M160.927 368.619v2.393h-.249v-2.393h.249z" fill="#0EA59D" />
            <path
            d="M160.927 371.012h-.249v-2.393h.374v2.393h-.125zm-.125-.266s0 .133 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.302 371.013h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.302 371.013h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.556 370.48c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 370.613c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.675 371.013h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.675 371.013h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 370.215c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 370.348c-.125-.133-.25-.133-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.179 370.746c-.125 0-.125 0-.249-.133v-1.994h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M160.304 370.879c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.552 370.88h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M160.677 370.88c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.929 370.613c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.929 370.746c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path
            d="M163.671 370.746c-.124 0-.124 0-.249.133v-2.26h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M163.422 370.879v-2.26h.374v2.26c-.125-.133-.249-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.3 371.013h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.051 371.012v-2.658h.374v2.525c-.125.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M161.925 368.487v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.925 371.012h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.169 369.418c0 .133-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 370.082v-1.595h.374v.931c0 .133-.125.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.806 369.816c-.124-.133-.124-.265-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.931 370.083l-.125-.133c-.124-.133-.124-.266-.124-.399V368.488h.249v1.595zm-.249-.665v.266-1.064.798z"
            fill="#131A2D"
            />
            <path
            d="M164.419 370.347c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.17 370.613v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.673 370.88h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.424 371.013v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 370.614c-.124 0-.124 0-.249.133v-2.127h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M163.797 370.747v-2.26h.374v2.127c-.125 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 370.747h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.049 370.88v-2.393h.374v2.26c-.125.133-.125.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.048 370.88h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M162.799 371.013v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M161.925 367.024c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 370.215c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596zm0-3.191c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.046 369.684c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.176 370.081h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.923 369.949h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.303 369.949h.998-.998c-.125 0-.375 0-.499-.132-.125 0-.25-.133-.499-.133h.499c.249.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M166.79 371.411c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 373.937c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.25.797-1.497 1.595-3.369 1.595zm-3.118-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.66 373.004s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.41 373.271v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M165.792 371.542v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M165.917 373.935h-.249v-2.393h.374v2.393h-.125zm-.249-.266l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.166 373.802h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.291 373.936h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.419 373.403c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.544 373.536c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.541 373.936h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 373.936h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.044 373.138c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.169 373.271c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399c0 .133 0 .133 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.167 373.67c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.167 373.804c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M165.417 373.803h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.542 373.803c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M164.794 373.536c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 373.669c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.662 373.669h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.287 373.802v-2.26h.374v2.26c-.124-.133-.124-.133-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.164 373.935h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M166.914 373.935v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M166.916 371.409v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M166.791 373.935h-.25v-2.659h.374v2.659h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.033 372.34c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M169.783 373.005v-1.595h.374v.931c0 .132-.124.265-.249.531l-.125.133zm.125-1.462v1.063c0-.132.125-.133.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M163.672 372.739c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M163.796 373.005l-.124-.133c-.125-.133-.125-.266-.125-.398v-1.064h.249v1.595zm-.124-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M169.285 373.27c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.035 373.536v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.539 373.802h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.289 373.936v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M168.912 373.404c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.662 373.67v-2.26h.374v2.127c-.124 0-.124 0-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.287 373.669h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.037 373.803v-2.393h.374v2.26c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M167.912 373.802h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.662 373.936v-2.526h.374v2.393c-.124 0-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M166.79 369.816c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.665 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 373.138c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .665-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.372 1.462 3.118 1.462 1.747 0 3.119-.797 3.119-1.462 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.911 372.607c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.041 373.006h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M167.788 372.873h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.166 372.872h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M152.07 361.177c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 363.835c-1.872 0-3.119-.797-3.244-1.462V361.31h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.728c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M154.939 362.905s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 363.17v-1.86h.375v1.595c-.125 0-.25.133-.375.265zm.125-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M151.072 361.31v2.392h-.25v-2.26c.125-.132.25-.132.25-.132z"
            fill="#0EA59D"
            />
            <path
            d="M151.197 363.703h-.25v-2.392h.375v2.392h-.125zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M151.445 363.702h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.57 363.835h-.25v-2.525h.375v2.525h-.125zm-.25-.266l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.699 363.17c-.125 0-.125-.132-.25-.132v-1.728h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M149.824 363.304c-.125-.133-.25-.133-.25-.133v-1.86h.374v1.993h-.124zm-.25-.265l.125-1.596h-.125v1.596z"
            fill="#131A2D"
            />
            <path d="M151.82 363.702h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.945 363.835h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.326 363.038c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.45 363.17c-.124-.132-.249-.265-.374-.265v-1.595h.374v1.86zm-.249-.398s.125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M150.449 363.436c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M150.449 363.569c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.125-.266c0 .133 0 .133 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.822 363.569h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.822 363.702c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M150.074 363.304c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 363.436c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.25-.266c0 .133 0 .133 0 0l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M153.941 363.436h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.691 363.569v-2.259h.375v2.259h-.375zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.57 363.702h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M152.195 363.835v-2.658h.375v2.525c-.125.133-.125.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.195 361.309v2.526h-.25v-2.526c.125 0 .125-.133.25 0 0 0-.125-.133 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 363.835h-.25v-2.658h.375v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M155.312 362.24c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M155.062 362.905v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M149.076 362.639c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M149.076 362.772l-.125-.133c-.125-.133-.125-.266-.125-.399V361.177h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.564 363.171c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.314 363.303v-1.993h.375v1.86c-.125 0-.125.133-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.818 363.702h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.568 363.835v-2.525h.375v2.525c-.125-.133-.25-.133-.375 0zm.125-2.525v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M154.316 363.303c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 363.436v-2.259h.375v1.994c-.125.265-.125.265-.375.265zm.125-1.993v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M153.566 363.569h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M153.316 363.702v-2.392h.375v2.259c-.125 0-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M153.193 363.569h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.943 363.702v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M152.07 359.715c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.872 0-3.244-.798-3.244-1.595 0-.798 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 362.905c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.372-1.595 3.244-1.595 1.996 0 3.368.797 3.368 1.595 0 .797-1.372 1.595-3.368 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .664 1.247 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462.125-.798-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M154.191 362.506c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM152.318 362.905h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M153.068 362.772h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.623-.398a1.005 1.005 0 01-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.57 362.772h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125 0 .25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.935 364.102c.374 0 .748 0 1.123.132h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374 0 .749-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 366.759c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121c.374-.132.749-.132 1.123-.132s.748 0 1.123.132h2.12v.931c0 .797-1.372 1.595-3.243 1.595zm-3.119-1.728c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.798h-1.872a7.142 7.142 0 00-2.37 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M159.804 365.828s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 366.094v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.062 364.233v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.062 366.626h-.25v-2.393h.375v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.312 366.627h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.437 366.626h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.566 366.094c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.691 366.227c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.687 366.626h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.812 366.759h-.25v-2.526h.375v2.526h-.125zm-.25-.266s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.316 365.83c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 365.962c-.125-.133-.25-.133-.375-.266v-1.595h.375v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.314 366.361c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.439 366.494c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.266s0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.689 366.494h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.689 366.626c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.939 366.227c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 366.36c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125.133 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.806 366.36h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.557 366.493v-2.26h.374v2.26h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.433 366.627h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.184 366.759v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M157.06 364.102v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M156.935 366.759h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.179 365.165c0 .133-.125.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.93 365.828v-1.595h.374v.931c0 .133-.125.266-.25.532l-.124.132zm.124-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.941 365.563c-.125-.132-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 365.696l-.125-.133c-.125-.133-.125-.266-.125-.399V364.101h.25v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.554 365.961c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 366.227v-1.994h.374v1.861c-.25 0-.25.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.808 366.627h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.559 366.627v-2.526h.374v2.526h-.374zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 366.228c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 366.361v-2.26h.374v1.994c-.125.266-.25.266-.374.266zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.433 366.493h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M158.184 366.626v-2.393h.374v2.26c-.125 0-.25 0-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.058 366.494h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 366.626v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.935 362.638c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.797 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 365.829c-1.996 0-3.244-.798-3.244-1.596 0-.797 1.373-1.595 3.244-1.595 1.871 0 3.243.798 3.243 1.595 0 .798-1.247 1.596-3.243 1.596zm0-3.191c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462.124-.665-1.248-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.056 365.431c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .498-.133.748-.133l2.62 2.659zM157.311 365.828h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.058 365.563h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.437 365.696h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.133.375.133.499.266z"
            fill="#fff"
            />
            <path
            d="M161.925 367.024c.374 0 .749 0 1.123.133h2.121v.798c0 .797-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 369.684c-1.871 0-3.119-.798-3.243-1.463V367.158h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.931c-.125.797-1.373 1.595-3.244 1.595zm-3.243-1.728c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.665h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.665z"
            fill="#131A2D"
            />
            <path
            d="M164.794 368.62s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 369.018v-1.861h.374v1.596c-.125 0-.249.132-.374.265zm.125-1.728v1.463h.124l-.124-1.463z"
            fill="#131A2D"
            />
            <path
            d="M160.927 367.158v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.927 369.55h-.249v-2.392h.374v2.392h-.125zm-.125-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M161.302 369.55h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.302 369.55h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.556 369.019c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 369.152c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.677 369.55h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.677 369.683h-.249v-2.525h.374v2.525h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.181 368.753c-.125 0-.125-.133-.249-.133v-1.463h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 368.886c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M160.179 369.284c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.304 369.417c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.552 369.417h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.677 369.55c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.929 369.152c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.929 369.284c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 369.284h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.422 369.417v-2.259h.374v2.259h-.374zm.125-2.126v1.993h.124l-.124-1.993z"
            fill="#131A2D"
            />
            <path d="M162.3 369.55h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M162.051 369.683v-2.658h.374v2.525c-.125 0-.249 0-.374.133zm.125-2.525v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M161.925 367.025v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M161.925 369.683h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.169 368.088c0 .133-.124.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 368.753v-1.596h.374v.931c0 .133-.125.266-.249.532l-.125.133zm.125-1.463v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.806 368.487c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.931 368.62l-.125-.133c-.124-.133-.124-.266-.124-.399V367.025h.249v1.595zm-.249-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.421 368.885c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 369.151v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.673 369.55h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.424 369.55v-2.525h.374v2.525h-.374zm.125-2.392v2.259h.124l-.124-2.259z"
            fill="#131A2D"
            />
            <path
            d="M164.046 369.151c-.124 0-.124 0-.249.133v-1.993h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M163.797 369.284v-2.259h.374v2.126c-.125.133-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 369.417h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M163.049 369.55v-2.393h.374v2.26c-.125 0-.125 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.048 369.417h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.799 369.55v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.392v2.126h.124l-.124-2.126c0 .132 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.925 365.563c1.871 0 3.244.798 3.244 1.596 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.596 3.243-1.596z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 368.755c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.931 3.244 1.595 0 .665-1.373 1.596-3.244 1.596zm0-3.191c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.046 368.221c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.176 368.619h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.923 368.487h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.303 368.619h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.249.132.374.132.499.265z"
            fill="#fff"
            />
            <path
            d="M166.79 369.949c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374 0 .748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 372.475c-1.871 0-3.118-.798-3.243-1.463V369.949h2.121c.374-.133.748-.133 1.122-.133.375 0 .749 0 1.123.133h2.121v.931c-.125.93-1.372 1.595-3.244 1.595zm-3.118-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.66 371.544s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.41 371.943v-1.861h.374v1.595c-.124 0-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M165.792 370.082v2.392h-.249v-2.259c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M165.917 372.474h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.166 372.475h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.291 372.474h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.419 371.943c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.544 372.075c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.541 372.474h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M166.541 372.474h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 371.677c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.171 371.81c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.169 372.209c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.169 372.342c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M165.417 372.341h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.542 372.474c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M164.794 372.076c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 372.208c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.662 372.209h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.287 372.341v-2.26h.374v2.26c-.124-.133-.124 0-.374 0zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.166 372.475h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M166.916 372.475v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M166.916 369.949v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M166.791 372.475h-.25v-2.526h.374v2.659h-.124v-.133zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.035 370.879c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M169.785 371.676v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M163.672 371.41c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M163.796 371.543l-.124-.133c-.125-.133-.125-.265-.125-.398v-1.064h.249v1.595zm-.124-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.285 371.81c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.035 372.075v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.539 372.475h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M167.289 372.475v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M168.912 372.075c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.662 372.208v-2.26h.374v1.994c-.124.133-.124.266-.374.266zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.289 372.341h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M168.039 372.474v-2.393h.374v2.26c-.249 0-.249 0-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M167.914 372.342h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.664 372.475v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M166.79 368.486c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 371.676c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.372 1.462 3.118 1.462 1.747 0 3.119-.797 3.119-1.462 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.911 371.145c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.039 371.543h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M167.788 371.411h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.166 371.411h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.249.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M152.07 359.848c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 362.374c-1.872 0-3.119-.798-3.244-1.463V359.848h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c0 .798-1.372 1.596-3.243 1.596zm-3.119-1.596c0 .665 1.372 1.463 3.119 1.463 1.871 0 3.118-.798 3.118-1.463v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M154.939 361.443s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 361.709v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M151.072 359.848v2.392h-.25v-2.259c.125 0 .25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.197 362.24h-.25v-2.392h.375v2.392h-.125zm-.25-.133s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M151.445 362.24h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.57 362.373h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.699 361.841c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.824 361.841c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.82 362.24h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.945 362.373h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.326 361.576c-.125 0-.125-.133-.25-.133v-1.463h.25v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M149.45 361.709c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.449 362.107c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M150.449 362.107c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.822 362.107h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.822 362.24c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M150.074 361.974c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 361.974c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.25-.133l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M153.941 361.974h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.691 362.107v-2.259h.375v2.259h-.375zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M152.57 362.24h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M152.195 362.373v-2.658h.375v2.525c-.125.133-.125.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.195 359.848v2.525h-.25v-2.525h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 362.373h-.125v-2.658h.375v2.658h-.25zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M155.312 360.778c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M155.062 361.443v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M149.076 361.177c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M149.076 361.443l-.125-.133c-.125-.133-.125-.266-.125-.399V359.848h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.564 361.709c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.314 361.976v-1.994h.375v1.861c-.125 0-.125 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.818 362.24h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.568 362.373v-2.525h.375v2.525h-.375zm.125-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M154.316 361.841c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 362.107v-2.259h.375v2.126c-.125 0-.125 0-.375.133zm.125-2.126v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M153.566 362.107h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M153.316 362.24v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M153.193 362.24h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.943 362.373v-2.525h.375v2.392c-.125 0-.25 0-.375.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M152.07 358.25c1.871 0 3.243.798 3.243 1.596 0 .797-1.372 1.595-3.243 1.595-1.872 0-3.244-.798-3.244-1.595 0-.798 1.372-1.596 3.244-1.596z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 361.441c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.372-1.596 3.244-1.596 1.996 0 3.368.931 3.368 1.596 0 .664-1.372 1.595-3.368 1.595zm0-3.058c-1.872 0-3.119.798-3.119 1.463 0 .664 1.247 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462.125-.665-1.247-1.463-3.118-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M154.191 361.043c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM152.318 361.442h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M153.068 361.308h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.623-.399-.124.266-.249.399-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.57 361.31h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.935 362.771c.374 0 .748 0 1.123.133h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 365.297c-1.871 0-3.119-.797-3.244-1.462V362.772h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.872c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.797h-.125z"
            fill="#131A2D"
            />
            <path
            d="M159.804 364.366s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 364.631v-1.86h.374v1.595c-.125.132-.125.132-.374.265zm.124-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M156.062 362.771v2.392h-.25v-2.26c.125-.133.125-.132.25-.132z"
            fill="#0EA59D"
            />
            <path
            d="M156.062 365.163h-.25v-2.392h.375v2.392h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.312 365.163h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M156.437 365.296h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.564 364.631c-.125 0-.125-.133-.25-.133v-1.727h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 364.764c-.125-.133-.25-.133-.25-.133v-1.86h.375v1.993h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.685 365.163h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.81 365.296h-.249v-2.525h.374v2.525h-.125zm-.249-.133s.124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 364.5c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 364.632c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.125-.399s0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.314 365.03c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.439 365.03c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.25-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.687 365.031h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M155.687 365.163c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.939 364.898c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 364.897c-.125 0-.25-.132-.25-.132v-1.994h.375v2.126h-.125zm-.25-.132s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.806 364.897h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.557 365.03v-2.259h.374v2.259h-.374zm.124-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.433 365.163h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.184 365.296v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.06 362.771v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M156.935 365.296h-.249v-2.658h.374v2.658h-.125c.125 0 .125 0 0 0zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.179 363.702c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.93 364.366v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.941 364.101c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 364.366l-.125-.133c-.125-.133-.125-.266-.125-.399V362.771h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.554 364.632c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 364.765v-1.994h.374v1.861c-.25.133-.25.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.808 365.163h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.559 365.296v-2.525h.374v2.525h-.374zm.124-2.525v2.259h.125l-.125-2.259c0 .132 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M159.181 364.765c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 365.03v-2.259h.374v2.126c-.125 0-.25 0-.374.133zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.433 365.03h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.184 365.163v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.058 365.163h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 365.163v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.935 361.177c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 364.367c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.93 3.243 1.595.125.797-1.247 1.595-3.243 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462.124-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.056 363.968c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .498-.132.748-.132l2.62 2.658zM157.311 364.366h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.058 364.234h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.437 364.235h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.375.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.925 365.696c.374 0 .749 0 1.123.132h2.121v.798c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.798h2.12c.25-.132.624-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 368.221c-1.871 0-3.119-.797-3.243-1.462V365.696h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.93c-.125.798-1.373 1.595-3.244 1.595zm-3.243-1.595c0 .665 1.372 1.462 3.118 1.462 1.747 0 3.119-.797 3.119-1.462v-.797h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M164.794 367.291s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 367.556v-1.86h.374v1.595c-.125.133-.249.133-.374.265zm.125-1.728v1.463h.124l-.124-1.463z"
            fill="#131A2D"
            />
            <path
            d="M160.927 365.696v2.392h-.249v-2.26c.124-.132.124-.132.249-.132z"
            fill="#0EA59D"
            />
            <path
            d="M160.927 368.088h-.249v-2.392h.374v2.392h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.3 368.088h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.3 368.221h-.249v-2.526h.374v2.526h-.125zm-.124-.266l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.554 367.556c-.125 0-.125-.132-.249-.132v-1.728h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M159.554 367.689c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.675 368.088h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.675 368.221h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 367.423c-.125 0-.125-.132-.249-.132v-1.463h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 367.556c-.125-.132-.25-.265-.374-.265v-1.595h.374v1.86zm-.125-.398l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M160.179 367.955c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.304 367.955c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.552 367.955h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M160.677 368.088c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.266s0 .133 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.929 367.822c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.929 367.822c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 367.822h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.422 367.955v-2.259h.374v2.259h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.3 368.088h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M162.051 368.221v-2.658h.374v2.525c-.125.133-.249.133-.374.133zm.125-2.525v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M161.925 365.695v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.925 368.221h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.169 366.626c0 .133-.124.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 367.291v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.463v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.806 367.025c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.931 367.291l-.125-.133c-.124-.133-.124-.266-.124-.399V365.696h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M164.419 367.556c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.17 367.689v-1.993h.374v1.86c-.125 0-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.673 368.088h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.424 368.221v-2.525h.374v2.525h-.374zm.125-2.525v2.259h.124l-.124-2.259z"
            fill="#131A2D"
            />
            <path
            d="M164.046 367.689c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.797 367.822v-2.259h.374v2.126c-.125.133-.249.133-.374.133zm.125-1.993v1.86h.124l-.124-1.86z"
            fill="#131A2D"
            />
            <path d="M163.421 367.955h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.047 368.088v-2.392h.374v2.259c-.125.133-.125.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.048 368.088h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.799 368.088v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.259v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path
            d="M161.925 364.101c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 367.292c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.046 366.892c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM162.176 367.29h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.923 367.158h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.303 367.158h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M166.79 368.62c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.931H166.79z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 371.146c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121c.374-.133.748-.133 1.122-.133.375 0 .749 0 1.123.133h2.121v.931c-.125.797-1.372 1.595-3.244 1.595zm-3.118-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.66 370.215s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.41 370.481v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path d="M165.792 368.62v2.393h-.249v-2.393h.249z" fill="#0EA59D" />
            <path
            d="M165.917 371.013h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.166 371.013h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.291 371.146h-.25v-2.526h.374v2.526h-.124zm-.25-.266l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.419 370.481c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.544 370.614c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.541 371.013h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 371.146h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 370.348c-.124 0-.124-.133-.249-.133v-1.595h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.171 370.481c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.167 370.747c-.124 0-.124 0-.249-.133v-1.994h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M165.167 370.88c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M165.417 370.88h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M165.542 371.013c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M164.794 370.747c-.124 0-.124 0-.249-.133v-1.994h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 370.747c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.133l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.662 370.747h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.287 370.88v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.166 371.013h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.916 371.145v-2.658h.374v2.526c-.124.132-.249.132-.374.132zm.125-2.525v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M166.916 368.62v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M166.791 371.146h-.25v-2.659h.374v2.659h-.124zm-.125-.133c.125 0 .125 0 0 0l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.033 369.551c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M169.783 370.215v-1.595h.374v.931c0 .132-.124.265-.249.531l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M163.672 369.949c-.125-.133-.125-.266-.125-.398v-.931h.125v1.329z"
            fill="#0EA59D"
            />
            <path
            d="M163.796 370.215l-.124-.133c-.125-.133-.125-.266-.125-.399V368.62h.249v1.595zm-.124-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M169.285 370.481c-.125 0-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.035 370.614v-1.994h.374v1.861c-.124 0-.249.133-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.539 371.013h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.289 371.146v-2.526h.374v2.526c-.124-.133-.249 0-.374 0zm.125-2.526v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M168.912 370.614c-.125 0-.125 0-.25.133v-2.127h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M168.662 370.747v-2.127h.374v2.127h-.374zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.287 370.88h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.037 371.013v-2.393h.374v2.26c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M167.914 370.88h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M167.664 371.013v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M166.79 367.024c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 370.215c-1.996 0-3.243-.931-3.243-1.596 0-.664 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.596-3.244 1.596zm0-3.058c-1.871 0-3.118.798-3.118 1.462 0 .665 1.372 1.463 3.118 1.463 1.747 0 3.119-.798 3.119-1.463 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.911 369.816c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM167.039 370.215h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M167.788 370.082h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.166 370.082h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M152.07 358.384c.374 0 .748 0 1.122.132h2.121v.798c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.132.748-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 360.909c-1.872 0-3.119-.798-3.244-1.462v-1.064h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.931c0 .797-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.996c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M154.939 359.978s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 360.244v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M151.072 358.516v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.197 360.908h-.25v-2.392h.375v2.392h-.125zm-.25-.266c0 .133.125.133 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M151.447 360.908h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.572 360.909h-.25v-2.526h.375v2.526h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.699 360.377c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.824 360.509c-.125-.132-.25-.132-.25-.132v-1.861h.374v1.993h-.124zm-.25-.265l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.82 360.908h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.945 360.908h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.326 360.111c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.45 360.244c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266s.125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.449 360.643c-.125 0-.125 0-.25-.132v-2.127h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M150.449 360.777c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.822 360.775h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.822 360.776c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M150.074 360.509c-.125 0-.125 0-.25-.132v-1.861h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 360.642c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.25-.265l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.941 360.642h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.691 360.775v-2.26h.375v2.26c-.25-.133-.25-.133-.375 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.57 360.908h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M152.195 360.908v-2.658h.375v2.526c-.125.132-.125.132-.375.132zm.125-2.392v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.195 358.383v2.525h-.25v-2.525h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 360.908h-.25v-2.658h.375v2.658h-.125zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.314 359.313c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 359.978v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M149.076 359.845c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M149.076 359.978l-.125-.133c-.125-.133-.125-.266-.125-.399V358.383h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.564 360.244c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.314 360.509v-1.993h.375v1.861c-.125 0-.125 0-.375.132zm.125-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.818 360.776h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.568 360.908v-2.525h.375v2.525h-.375zm.125-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M154.316 360.509c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 360.642v-2.259h.375v2.127c-.125 0-.125 0-.375.132zm.125-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.566 360.643h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.316 360.776v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M153.193 360.776h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.943 360.908v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M152.07 356.922c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 360.112c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.996 0 3.368.798 3.368 1.595 0 .798-1.372 1.595-3.368 1.595zm0-3.19c-1.872 0-3.119.798-3.119 1.462 0 .665 1.372 1.463 3.119 1.463 1.871 0 3.118-.798 3.118-1.463 0-.664-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M154.191 359.581c-.25.132-.499.132-.749.265l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.659zM152.318 359.979h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M153.068 359.846h.124c.125 0 .25 0 .375-.133.124 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.132s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.57 359.846h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.935 361.31c.374 0 .748 0 1.123.132h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.132.749-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 363.835c-1.871 0-3.119-.797-3.244-1.462V361.31h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.872a7.089 7.089 0 00-2.37 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.804 362.905s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 363.17v-1.86h.374v1.595c-.125.133-.125.133-.374.265zm.124-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M156.062 361.442v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.062 363.835h-.25v-2.393h.375v2.393h-.125zm-.125-.266l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.312 363.702h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M156.437 363.836h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.564 363.303c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 363.436c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.685 363.835h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.81 363.835h-.249v-2.525h.374v2.525h-.125zm-.249-.133s.124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.316 363.037c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 363.17c-.125-.132-.25-.132-.375-.265v-1.595h.375v1.86zm-.125-.398c0 .133 0 .133 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.314 363.569c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.439 363.703c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.687 363.702h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M155.687 363.702c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.939 363.436c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 363.569c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.806 363.569h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.557 363.702v-2.259h.374v2.259c-.125-.133-.25-.133-.374 0zm.124-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.433 363.835h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M157.184 363.834v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.06 361.31v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M156.935 363.834h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.179 362.24c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.93 362.905v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.941 362.639c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 362.905l-.125-.133c-.125-.133-.125-.266-.125-.399V361.31h.25v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.554 363.17c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 363.436v-1.994h.374v1.861c-.25 0-.25 0-.374.133zm.124-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.808 363.702h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.559 363.836v-2.525h.374v2.525h-.374zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 363.304c-.125 0-.125 0-.249.132v-1.993h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 363.569v-2.259h.374v1.993c-.125.133-.25.133-.374.266zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.431 363.569h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.182 363.702v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.058 363.702h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 363.836v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.393v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.935 359.848c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 363.038c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462.124-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.056 362.506c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .498-.133.748-.133l2.62 2.658zM157.311 362.905h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.058 362.772h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.437 362.771h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.375.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.925 364.234c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 366.759c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.931c-.125.797-1.373 1.595-3.244 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M164.794 365.828s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 366.094v-1.861h.374v1.595c-.125.133-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.927 364.367v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.927 366.76h-.249v-2.393h.374v2.393h-.125zm-.125-.266l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.302 366.626h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.302 366.759h-.249v-2.526h.374v2.526h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.556 366.228c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 366.361c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.399c0 .133 0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.677 366.76h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.677 366.759h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 365.962c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 366.094c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.399c0 .133 0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.179 366.494c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.304 366.628c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.554 366.626h-.249V364.5h.249v2.126z" fill="#0EA59D" />
            <path
            d="M160.679 366.626c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.929 366.361c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.929 366.494c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 366.361h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.422 366.628v-2.26h.374v2.26c-.125-.133-.249-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.3 366.627h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M162.051 366.759v-2.658h.374v2.525c-.125.133-.249.133-.374.133zm.125-2.392v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M161.925 364.234v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.925 366.759h-.249v-2.658h.249v2.658zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.169 365.164c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 365.828v-1.595h.374v.931c0 .133-.125.265-.249.531l-.125.133zm.125-1.462v1.063c0-.132.124-.132.124-.265l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.806 365.563c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.931 365.828l-.125-.133c-.124-.133-.124-.266-.124-.398v-1.064h.249v1.595zm-.249-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M164.421 366.095c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 366.361v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.673 366.626h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.424 366.759v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 366.228c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.797 366.493v-2.26h.374v2.127c-.125 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 366.493h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.049 366.626v-2.393h.374v2.26c-.125.133-.125.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.048 366.626h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.799 366.759v-2.526h.374v2.393c-.249 0-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M161.925 362.638c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.664 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 365.961c-1.996 0-3.243-.93-3.243-1.595 0-.664 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.798-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.046 365.43c-.25.133-.499.133-.749.265l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM162.176 365.828h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.923 365.696h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.303 365.695h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M166.79 367.157c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 369.683c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.25.797-1.497 1.595-3.369 1.595zm-3.118-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.66 368.752s-.125.133-.25.133v-1.595h.25v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M169.41 369.019v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M165.792 367.157v2.393h-.249v-2.26c.125 0 .249 0 .249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M165.917 369.683h-.249v-2.393h.374v2.393h-.125zm-.249-.266l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.166 369.55h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.291 369.683h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.419 369.151c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.544 369.151c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266c0 .133 0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.541 369.55h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 369.683h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 368.885c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.171 369.018c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399c0 .133 0 .133 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.167 369.417c-.124 0-.124 0-.249-.133v-1.994h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M165.167 369.417c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M165.417 369.417h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.542 369.55c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.133s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M164.794 369.285c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 369.418c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.662 369.285h-.25v-1.994h.25v1.994z" fill="#0EA59D" />
            <path
            d="M168.287 369.551v-2.26h.374v2.26c-.124-.133-.124-.133-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.164 369.55h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M166.914 369.683v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M166.916 367.157v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M166.791 369.683h-.25v-2.659h.374v2.659h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.033 368.088c0 .132-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M169.783 368.752v-1.595h.374v.931c0 .133-.124.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M163.672 368.487c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M163.796 368.753l-.124-.133c-.125-.133-.125-.266-.125-.399V367.158h.249v1.595zm-.124-.665v.266-1.063.797z"
            fill="#131A2D"
            />
            <path
            d="M169.285 369.019c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.035 369.285v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.539 369.55h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.289 369.683v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M168.912 369.151c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.662 369.417v-2.26h.374v2.127c-.124 0-.124 0-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.287 369.417h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.037 369.55v-2.393h.374v2.26c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M167.914 369.55h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.664 369.683v-2.526h.374v2.393c-.124 0-.249 0-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M166.79 365.562c1.872 0 3.244.798 3.244 1.596 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.596 3.243-1.596z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 368.886c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462 0-.665-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.911 368.354c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.041 368.752h-.499l-2.37-2.525c.125 0 .249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M167.788 368.62h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.166 368.619h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.249.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M152.07 356.923c.374 0 .748 0 1.122.133h2.121v.798c0 .664-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.374 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 359.582c-1.872 0-3.119-.798-3.244-1.463V357.056h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c0 .798-1.372 1.596-3.243 1.596zm-3.119-1.728c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M154.939 358.518s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 358.917v-1.861h.375v1.595c-.125 0-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M151.072 357.056v2.393h-.25v-2.26c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.197 359.449h-.25v-2.393h.375v2.393h-.125zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M151.445 359.449h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.57 359.449h-.25v-2.526h.375v2.526h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.699 358.917c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.824 359.049c-.125-.132-.25-.132-.25-.132v-1.861h.374v1.993h-.124zm-.25-.265l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.82 359.448h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.945 359.581h-.25v-2.525h.375v2.525h-.125zm-.25-.266l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.326 358.651c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.45 358.784c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266s.125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.449 359.183c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M150.449 359.316c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.822 359.315h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.822 359.448c-.125 0-.25 0-.25-.132v-2.26h.375v2.392h-.125zm-.25-.265c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M150.074 359.05c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 359.183c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.941 359.183h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.691 359.316v-2.26h.375v2.26h-.375zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.57 359.449h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M152.195 359.582v-2.659h.375v2.526c-.125 0-.125.133-.375.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.195 356.923v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 359.582h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.314 357.986c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 358.651v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M149.076 358.386c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M149.076 358.518l-.125-.133c-.125-.133-.125-.266-.125-.399V356.923h.25v1.595zm-.125-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M154.564 358.784c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.314 359.05v-1.994h.375v1.861c-.125 0-.125 0-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.818 359.449h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.568 359.449v-2.526h.375v2.526h-.375zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M154.316 359.051c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 359.183v-2.26h.375v1.994c-.125.266-.125.266-.375.266zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.566 359.316h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.316 359.448v-2.392h.375v2.26c-.125 0-.25 0-.375.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M153.193 359.316h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.943 359.449v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.393v2.127h.125l-.125-2.127c0 .133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.07 355.46c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.596-3.243 1.596-1.872 0-3.244-.798-3.244-1.596 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 358.651c-1.996 0-3.244-.798-3.244-1.596 0-.797 1.372-1.595 3.244-1.595 1.996 0 3.368.798 3.368 1.595 0 .798-1.372 1.596-3.368 1.596zm0-3.191c-1.872 0-3.119.798-3.119 1.463 0 .664 1.247 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462.125-.665-1.247-1.463-3.118-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M154.191 358.119c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM152.318 358.518h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M153.068 358.385h.124c.125 0 .25 0 .375-.133.124 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.132s-.125.001-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.57 358.518h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.133.25.133.499.266z"
            fill="#fff"
            />
            <path
            d="M156.935 359.847c.374 0 .748 0 1.123.133h2.12v.798c0 .664-1.372 1.462-3.243 1.462-1.871 0-3.244-.798-3.244-1.462v-.798h2.121c.374 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 362.373c-1.871 0-3.119-.798-3.244-1.463V359.847h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .931-1.372 1.596-3.243 1.596zm-3.119-1.596c0 .665 1.372 1.463 3.119 1.463 1.746 0 3.119-.798 3.119-1.463v-.797h-1.872a7.089 7.089 0 00-2.37 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.804 361.443s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 361.841v-1.861h.374v1.596c-.125 0-.125.132-.374.265zm.124-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M156.062 359.98v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.062 362.373h-.25v-2.393h.375v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.312 362.373h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.437 362.373h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.566 361.841c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.691 361.974c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.687 362.373h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.812 362.373h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 361.576c-.125 0-.125-.133-.25-.133v-1.463h.25v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 361.709c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.314 362.108c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.439 362.24c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.25-.265l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.689 362.24h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.689 362.373c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.939 361.974c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 362.107c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.806 362.107h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.557 362.24v-2.26h.374v2.26c-.125-.133-.25 0-.374 0zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.433 362.373h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.184 362.373v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.06 359.848v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M156.935 362.373h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.179 360.778c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.93 361.576v-1.596h.374v.931c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.941 361.31c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 361.443l-.125-.133c-.125-.133-.125-.266-.125-.399V359.848h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.554 361.708c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 361.975v-1.994h.374v1.861c-.25 0-.25 0-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.808 362.373h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.559 362.373v-2.525h.374v2.525h-.374zm.124-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.181 361.974c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 362.107v-2.259h.374v2.126c-.125 0-.25.133-.374.133zm.124-1.993v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M158.433 362.24h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M158.184 362.374v-2.393h.374v2.26c-.125 0-.25 0-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.058 362.24h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 362.373v-2.526h.374v2.393c-.125.133-.25.133-.374.133zm.124-2.393v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.935 358.384c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 361.574c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.056 361.043c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .498-.133.748-.133l2.62 2.658zM157.311 361.442h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.058 361.308h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.624-.399-.125.266-.25.399-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.437 361.309h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.375.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.925 362.771c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 365.297c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.931c-.125.93-1.373 1.595-3.244 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M164.794 364.366s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 364.765v-1.861h.374v1.595c-.125 0-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.927 362.904v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.927 365.296h-.249v-2.392h.374v2.392h-.125zm-.125-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M161.3 365.297h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.3 365.296h-.249v-2.525h.374v2.525h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.554 364.765c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.554 364.898c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.675 365.297h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.675 365.296h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 364.499c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 364.631c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.179 365.031c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.304 365.164c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.552 365.164h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.677 365.163c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.929 364.898c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.929 365.031c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 365.031h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.422 365.164v-2.26h.374v2.26c-.125-.133-.249 0-.374 0zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.3 365.296h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.051 365.296v-2.659h.374v2.526c-.125.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M161.925 362.771v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M161.925 365.296h-.249v-2.659h.374v2.659h-.125zm-.124-.133s.124 0 0 0l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M165.169 363.702c0 .133-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 364.499v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.266l-.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M158.806 364.233c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.931 364.365l-.125-.133c-.124-.133-.124-.265-.124-.398v-1.064h.249v1.595zm-.249-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.419 364.632c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.17 364.898v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.673 365.297h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.424 365.296v-2.525h.374v2.525h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 364.898c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.797 365.03v-2.26h.374v2.127c-.125 0-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 365.164h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.049 365.297v-2.393h.374v2.26c-.125 0-.125 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.046 365.163h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.797 365.296v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M161.925 361.309c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 364.5c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .664-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.046 363.968c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.176 364.366h-.499l-2.37-2.525c.124 0 .249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.923 364.234h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133-.124.133-.249 0-.374 0h-.374c.125 0 .249 0 .374-.133v-.133zM161.303 364.233h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.249.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M166.79 365.695c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 368.22c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.25.797-1.497 1.595-3.369 1.595zm-3.118-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.66 367.291s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.41 367.558v-1.861h.374v1.595c-.124.133-.249.266-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M165.792 365.829v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M165.917 368.222h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.167 368.222h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M166.292 368.222h-.249v-2.526h.374v2.526h-.125zm-.249-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.419 367.69c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.544 367.823c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.541 368.222h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 368.222h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 367.424c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.171 367.557c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.169 367.956c-.124 0-.124 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M165.169 368.09c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M165.417 368.089h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.542 368.089c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M164.794 367.823c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 367.957c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.662 367.956h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.287 368.089v-2.26h.374v2.26c-.124-.133-.124-.133-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.166 368.222h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M166.916 368.221v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M166.916 365.696v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M166.791 368.221h-.25v-2.659h.374v2.659h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.035 366.627c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M169.785 367.291v-1.595h.374v.931c0 .133-.124.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M163.672 367.158c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M163.796 367.291l-.124-.133c-.125-.133-.125-.265-.125-.398v-1.064h.249v1.595zm-.124-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.285 367.557c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.035 367.823v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.539 368.089h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.289 368.223v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M168.912 367.823c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.662 367.956v-2.26h.374v2.127c-.124 0-.124.133-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.289 367.956h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.039 368.09v-2.393h.374v2.26c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M167.914 368.089h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.664 368.223v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M166.79 364.233c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 367.424c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.596-3.244 1.596zm0-3.191c-1.871 0-3.118.798-3.118 1.463 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462 0-.665-1.247-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.911 366.892c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.039 367.29h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M167.788 367.158h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.166 367.157h.998-.998c-.125 0-.374 0-.499-.132-.125 0-.25-.133-.499-.133h.499c.249.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M146.956 365.962c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.249 0 .623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 368.62c-1.871 0-3.119-.797-3.243-1.462V366.095h2.12a7.095 7.095 0 012.371 0h2.12v.93c-.249.798-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.826 367.69s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 367.956v-1.861h.374v1.595c-.124 0-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.958 366.095v2.393h-.249v-2.26c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.083 368.488h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M146.332 368.488h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.332 368.621h-.25v-2.659h.374v2.659h-.124zm-.125-.266l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.585 367.956c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.585 368.089c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.707 368.488h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.707 368.621h-.25v-2.659h.374v2.659h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.212 367.823c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 367.956c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M145.21 368.222c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.335 368.355c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.583 368.355h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.708 368.487c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M144.96 368.089c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.96 368.222c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.125.133.125.133 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.703 368.222h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.453 368.355v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.332 368.488h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M147.082 368.621v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path
            d="M146.957 366.095v2.526h-.25v-2.526c.125 0 .125-.132.25 0 0 0 0-.132 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M146.957 368.621h-.25v-2.659h.374v2.659h-.124zm-.125-.133s.125 0 0 0l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M150.201 367.025c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 367.69v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.838 367.424c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 367.557l-.124-.133c-.125-.133-.125-.266-.125-.398v-1.064h.249v1.595zm-.249-.531v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M149.451 367.956c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 368.089v-1.994h.374v1.861c-.124 0-.249.133-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.705 368.488h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.455 368.621v-2.659h.374v2.526c-.124 0-.249 0-.374.133zm.125-2.526v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 368.089c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 368.222v-2.26h.374v2.127c-.124.133-.249.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 368.354h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M148.078 368.488v-2.393h.374v2.26c-.124 0-.124.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M148.08 368.355h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.83 368.488v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.956 364.499c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 367.689c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595zm0-3.057c-1.871 0-3.118.797-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.797-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M149.077 367.29c-.249.133-.499.133-.748.266l-2.62-2.924c.249 0 .499-.133.748-.133l2.62 2.791zM147.205 367.689h-.499l-2.37-2.526c.125-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.954 367.556h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.132.249-.132.25-.133.375-.266.624-.399-.125.266-.249.399-.499.531l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM146.332 367.557h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.822 368.885c.374 0 .748.001 1.122.133h2.121v.798c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.798h2.121c.374 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 371.544c-1.872 0-3.119-.798-3.244-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.25.797-1.497 1.595-3.368 1.595zm-3.119-1.728c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.118-.797 3.118-1.462v-.798h-1.996c-.748-.133-1.621-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M154.691 370.612s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 370.878v-1.861h.375v1.595c-.125 0-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.824 369.017v2.393h-.25v-2.26c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.949 371.41h-.25v-2.393h.374v2.393h-.124zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M151.199 371.411h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.324 371.411h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.451 370.878c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 371.011c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.574 371.41h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.574 371.543h-.25v-2.526h.374v2.526h-.124zm-.125-.266s0 .133 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 370.613c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.202 370.746c-.124-.133-.249-.265-.374-.265v-1.596h.374v1.861zm-.249-.265s.125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M150.201 371.145c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M150.201 371.278c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.125-.266c0 .133 0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.449 371.278h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.574 371.41c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.25-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.826 371.011c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 371.144c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.125-.266s0 .133 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.693 371.144h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.318 371.277v-2.26h.375v2.26h-.375zm.25-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.197 371.411h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M151.947 371.544v-2.659h.375v2.526c-.125.133-.25.133-.375.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.947 368.885v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 371.544h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.066 369.949c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 370.612v-1.595h.375v.931c0 .133-.125.266-.25.531l-.125.133zm.125-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M148.703 370.347c-.125-.132-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 370.481l-.125-.133c-.125-.133-.125-.266-.125-.399v-1.064h.25v1.596zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M154.316 370.745c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 371.011v-1.994h.375v1.861c-.125 0-.25.133-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.57 371.411h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.32 371.411v-2.526h.375v2.526h-.375zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M153.943 371.012c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 371.145v-2.26h.375v2.127c-.125.133-.125.133-.375.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.32 371.277h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.07 371.41v-2.393h.375v2.26c-.25 0-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.945 371.278h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.695 371.411v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.822 367.423c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 370.614c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.372-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595.125.797-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.942 370.215c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM152.07 370.613h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.82 370.347h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.623-.399-.124.266-.249.399-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.197 370.48h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.133.374.133.499.266z"
            fill="#fff"
            />
            <path
            d="M156.687 371.81c.374 0 .748 0 1.123.132h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374 0 .749-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 374.467c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121a7.142 7.142 0 012.37 0h2.121v.931c-.125.797-1.497 1.595-3.368 1.595zm-3.119-1.728c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.798h-1.996c-.749-.132-1.622-.132-2.246 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M159.556 373.406s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.307 373.804v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.814 371.943v2.393h-.25v-2.26c0-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.814 374.336h-.25v-2.393h.375v2.393h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.064 374.336h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.189 374.336h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.316 373.803c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 373.936c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.437 374.335h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.562 374.468h-.25v-2.526h.375v2.526h-.125zm-.25-.266l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.068 373.538c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.068 373.671c-.125-.132-.25-.132-.375-.265v-1.595h.375v1.86zm-.25-.265c.125 0 .125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.066 374.07c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.066 374.203c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.439 374.202h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.439 374.335c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.691 373.936c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 374.069c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.558 374.07h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.309 374.203v-2.26h.374v2.26h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.185 374.336h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.936 374.469v-2.658h.374v2.525c-.25 0-.25.133-.374.133zm.124-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M156.812 371.811v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M156.687 374.469h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.931 372.873c0 .133-.125.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.682 373.537v-1.595h.374v.931c0 .133-.125.266-.25.532l-.124.132zm.124-1.462v1.064c0-.133.125-.266.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.693 373.272c-.125-.132-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 373.406l-.125-.133c-.125-.133-.125-.266-.125-.399V371.811h.25v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.306 373.671c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 373.937v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.56 374.336h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.186 374.336v-2.525h.374v2.525h-.374zm.124-2.393v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.933 373.937c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.684 374.07v-2.259h.374v2.126c-.25.133-.25.133-.374.133zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.183 374.203h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M157.934 374.336v-2.393h.374v2.26c-.125 0-.25 0-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.81 374.203h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.561 374.336v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.392v2.126h.125l-.125-2.126c.125.133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.687 370.347c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 373.537c-1.996 0-3.369-.798-3.369-1.595 0-.798 1.373-1.595 3.369-1.595 1.996 0 3.243.93 3.243 1.595.125.797-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .664 1.247 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.808 373.006c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.936 373.405h-.499l-2.371-2.526c.125 0 .25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.808 373.272h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.187 373.406h.998-.998c-.124 0-.374-.001-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.133.25.133.499.266z"
            fill="#fff"
            />
            <path
            d="M161.677 374.734c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 377.26c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121a7.142 7.142 0 012.37 0h2.121v.931c-.249.93-1.622 1.595-3.368 1.595zm-3.244-1.595c0 .664 1.373 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M164.546 376.331s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 376.731v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.679 374.868v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.679 377.262h-.249v-2.393h.374v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.052 377.261h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.052 377.261h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.306 376.729c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.306 376.862c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M161.302 377.261h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.427 377.261h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M158.933 376.463c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M158.933 376.596c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M159.929 376.996c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.054 377.13c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.304 377.127h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M160.304 377.261c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.556 376.862c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.681 376.996c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266s.124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 376.995h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.174 377.128v-2.26h.374v2.26c-.125-.133-.249 0-.374 0zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.05 377.261h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M161.801 377.261v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M161.675 374.735v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.675 377.261h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M164.919 375.666c0 .133-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 376.464v-1.595h.374v.931c0 .132-.125.265-.249.531l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.265l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.558 376.197c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.558 376.33l-.125-.133c-.124-.133-.124-.266-.124-.399V374.735h.249v1.595zm-.125-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M164.171 376.596c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M163.922 376.863v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.425 377.26h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.176 377.261v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M163.796 376.862c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.547 376.995v-2.26h.374v2.127c-.125 0-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.048 377.128h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M162.799 377.26v-2.392h.374v2.26c-.125 0-.249 0-.374.132zm.125-2.259v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M162.8 377.129h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.426 377.262v-2.526h.374v2.393c-.125.133-.125.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.677 373.271c1.871 0 3.244.798 3.244 1.596 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.596 3.243-1.596z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 376.462c-1.996 0-3.243-.931-3.243-1.595 0-.798 1.372-1.596 3.243-1.596 1.871 0 3.244.798 3.244 1.596 0 .664-1.373 1.595-3.244 1.595zm0-3.191c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.248-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M163.673 375.931c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM161.926 376.329h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.675 376.196h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.053 376.197h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.956 364.632c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 367.157c-1.871 0-3.118-.797-3.243-1.462V364.632h2.121c.374-.133.748-.133 1.122-.133.375 0 .749 0 1.123.133h2.121v.93c-.125.798-1.372 1.595-3.244 1.595zm-3.243-1.595c0 .665 1.372 1.463 3.119 1.463 1.871 0 3.118-.798 3.118-1.463v-.797h-1.996c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M149.826 366.227s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 366.493v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.958 364.632v2.392h-.249v-2.259c.125 0 .125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.083 367.025h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M146.333 367.024h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M146.333 367.158h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.585 366.626c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.585 366.626c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266s0 .133 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.707 367.024h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.707 367.158h-.25v-2.526h.374v2.526h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.212 366.36c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 366.493c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s0 .133 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M145.21 366.891c-.124 0-.124 0-.249-.132v-2.127h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M145.335 366.891c-.124 0-.249-.132-.249-.132v-2.127h.374v2.259h-.125zm-.249-.132s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.583 366.892h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.708 367.025c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.96 366.759c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.96 366.892c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.703 366.759h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.453 366.892v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.332 367.026h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.082 367.159v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M146.957 364.634v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.957 367.159h-.25v-2.658h.374v2.658h-.124zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M150.201 365.563c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 366.227v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.838 365.962c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 366.227l-.124-.133c-.125-.133-.125-.266-.125-.399V364.632h.249v1.595zm-.249-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M149.451 366.493c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 366.759v-2.127h.374v1.861c-.124.133-.249.133-.374.266zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.705 367.024h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 367.158v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 366.626c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 366.891v-2.259h.374v2.127c-.124 0-.249 0-.374.132zm.125-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.455 366.892h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M148.08 367.025v-2.393h.374v2.26c-.124.133-.124.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M148.08 367.024h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.83 367.158v-2.526h.374v2.393c-.249 0-.249 0-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.956 363.037c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 366.227c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595zm0-3.057c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M149.077 365.829c-.249.133-.499.133-.748.265l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM147.205 366.227h-.499l-2.37-2.526c.125-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.954 366.095h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.132h-.749c.125 0 .25 0 .374-.132v-.133zM146.332 366.094h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.822 367.557c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 370.081c-1.872 0-3.119-.798-3.244-1.462V367.556h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.25.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.118-.797 3.118-1.462v-.798h-1.996c-.748-.132-1.621-.132-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M154.691 369.152s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 369.418v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.824 367.557v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.949 369.949h-.25v-2.392h.374v2.392h-.124zm-.25-.132s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M151.197 369.949h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.322 370.082h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.451 369.418c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 369.551c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.572 369.95h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.572 370.083h-.25v-2.526h.375v2.526h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 369.284c-.125 0-.125-.132-.25-.132v-1.463h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.202 369.418c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.199 369.817c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 369.816c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.449 369.816h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.574 369.949c-.125 0-.25 0-.25-.132v-2.26h.374v2.392h-.124zm-.25-.132c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.826 369.683c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 369.683c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.125-.133l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M153.693 369.684h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.318 369.817v-2.26h.375v2.26h-.375zm.25-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.195 369.949h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.945 370.082v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.947 367.557v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 370.082h-.25v-2.658h.375v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M155.064 368.487c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M154.814 369.152v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.703 368.886c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 369.152l-.125-.133c-.125-.133-.125-.266-.125-.399V367.557h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.316 369.417c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 369.55v-1.993h.375v1.861c-.125.132-.25.132-.375.132zm.125-1.86v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.57 369.95h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.32 370.082v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.525v2.26h.125l-.125-2.26c.125.133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M153.943 369.55c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 369.816v-2.259h.375v2.126c-.125 0-.125 0-.375.133zm.125-2.126v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M153.318 369.817h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.068 369.949v-2.392h.375v2.26c-.25.132-.25.132-.375.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.945 369.949h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.695 369.949v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M151.822 365.961c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.872 0-3.244-.798-3.244-1.595 0-.798 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 369.151c-1.996 0-3.244-.931-3.244-1.595 0-.798 1.372-1.595 3.244-1.595 1.871 0 3.243.93 3.243 1.595.125.797-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .664 1.247 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462 0-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.942 368.752c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM152.07 369.151h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.82 369.018h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.132.374-.265.623-.398a1.002 1.002 0 01-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.197 369.019h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.687 370.48c.374 0 .748 0 1.123.133h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 373.006c-1.871 0-3.119-.797-3.244-1.462V370.481h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.798h-1.996c-.749-.132-1.622-.132-2.246 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M159.554 372.077s-.125.132-.249.132v-1.728h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 372.343v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.812 370.481v2.393h-.25v-2.26c.001-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.812 372.875h-.25v-2.393h.375v2.393h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.062 372.874h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.187 373.007h-.249v-2.526h.374v2.526h-.125zm-.249-.266s.124.133 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.314 372.342c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.439 372.475c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.437 372.874h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.562 373.007h-.25v-2.526h.375v2.526h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.066 372.209c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 372.342c-.125-.133-.25-.265-.375-.265v-1.596h.375v1.861zm-.25-.398c.125 0 .125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.064 372.741c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 372.742c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.437 372.741h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M155.437 372.874c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.266c0 .133 0 .133 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M154.689 372.608c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.814 372.608c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.133l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.556 372.608h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.307 372.741v-2.259h.374v2.259h-.374zm.124-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.183 372.874h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.934 373.008v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M156.81 370.482v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M156.685 373.008h-.249v-2.658h.374v2.658h-.125c.125 0 .125 0 0 0zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.929 371.412c0 .133-.125.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.68 372.077v-1.596h.374v.931c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.691 371.811c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.691 372.077l-.125-.133c-.125-.133-.125-.266-.125-.399v-1.064h.25v1.596zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.306 372.342c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 372.475v-1.994h.374v1.861c-.125 0-.125.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.558 372.874h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.184 373.008v-2.526h.374v2.526h-.374zm.124-2.526v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.931 372.475c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 372.741v-2.259h.374v2.126c-.25 0-.25 0-.374.133zm.124-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.183 372.741h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M157.934 372.875v-2.393h.374v2.26c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.808 372.875h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.559 372.875v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.687 368.886c1.871 0 3.243.798 3.243 1.596 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.596 3.244-1.596z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 372.078c-1.996 0-3.369-.931-3.369-1.595 0-.798 1.373-1.595 3.369-1.595 1.996 0 3.243.797 3.243 1.595.125.797-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.808 371.678c-.25.133-.499.133-.749.266l-2.62-2.792c.25 0 .499-.132.749-.132l2.62 2.658zM156.936 372.076h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.808 371.944h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.187 371.944h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.677 373.406c.374 0 .749 0 1.123.132h2.121v.798c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.798h2.12c.25-.132.624-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 375.93c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.931c-.125.797-1.497 1.595-3.244 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M164.546 375s-.124.133-.249.133v-1.728h.249V375z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 375.266v-1.861h.374V375c-.125 0-.125.133-.374.266zm.125-1.728V375h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.679 373.405v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.679 375.798h-.249v-2.393h.374v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.052 375.798h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.052 375.931h-.249v-2.526h.374v2.526h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.306 375.266c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.306 375.399c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M161.302 375.798h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.427 375.931h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M158.933 375.133c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M158.933 375.266c-.125-.133-.25-.133-.374-.266v-1.595h.374v1.861zm-.125-.399l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M159.929 375.531c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.054 375.665c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.304 375.665h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.304 375.798c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.556 375.532c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.681 375.532c-.125 0-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.249-.133s.124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 375.532h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.174 375.665v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.05 375.797h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M161.801 375.93v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.525v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M161.677 373.405v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.677 375.93h-.249v-2.659h.374v2.659h-.125zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M164.919 374.336c0 .132-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 375v-1.595h.374v.931c0 .133-.125.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.558 374.735c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M158.558 375.001l-.125-.133c-.124-.133-.124-.266-.124-.399V373.406h.249v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.171 375.266c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M163.922 375.399v-1.993h.374v1.86c-.125 0-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.425 375.798h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.176 375.931v-2.526h.374v2.526c-.249-.133-.249 0-.374 0zm.125-2.526v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M163.798 375.399c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.549 375.531v-2.26h.374v1.994c-.125.266-.249.266-.374.266zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.048 375.665h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M162.799 375.798v-2.393h.374v2.26c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M162.8 375.664h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.426 375.797v-2.525h.374v2.392c-.125.133-.125.133-.374.133zm.125-2.259v2.126h.124l-.124-2.126c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.677 371.811c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 375.001c-1.996 0-3.243-.931-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.871 0 3.244.93 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M163.673 374.602c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM161.926 375h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.675 374.868h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.053 374.867h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.124 0 .374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M146.956 363.171c.375 0 .749 0 1.123.133h2.121v.797c0 .798-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 365.696c-1.871 0-3.119-.798-3.243-1.463V363.17h2.12a7.095 7.095 0 012.371 0h2.12v.93c-.249.798-1.497 1.596-3.368 1.596zm-3.243-1.596c0 .665 1.372 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.826 364.766s-.125.133-.25.133v-1.595h.25v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 365.032v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path d="M145.958 363.303v2.393h-.249v-2.393h.249z" fill="#0EA59D" />
            <path
            d="M146.083 365.696h-.249v-2.393h.374v2.393h-.125zm-.249-.266c0 .133 0 .133 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M146.332 365.696h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.332 365.696h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M144.585 365.164c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.585 365.297c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.707 365.696h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.707 365.696h-.25v-2.525h.374v2.525h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M144.212 364.899c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 365.032c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M145.21 365.43c-.124 0-.124 0-.249-.133v-1.994h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M145.335 365.563c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.583 365.563h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M145.708 365.563c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M144.96 365.297c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.96 365.43c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.703 365.43h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.453 365.563v-2.26h.374v2.26c-.124-.133-.249-.133-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.332 365.696h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M147.082 365.696v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.957 363.17v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M146.957 365.696h-.25v-2.658h.374v2.658h-.124zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M150.201 364.101c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 364.766v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.838 364.633c-.125-.133-.125-.266-.125-.399v-.93h.125v1.329z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 364.766l-.124-.133c-.125-.133-.125-.266-.125-.399V363.171h.249v1.595zm-.249-.665v.266-1.063.797z"
            fill="#131A2D"
            />
            <path
            d="M149.451 365.031c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 365.297v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.705 365.563h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 365.696v-2.525h.374v2.525h-.374zm.125-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.078 365.298c-.125 0-.125 0-.25.132v-2.126h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 365.43v-2.259h.374v2.126c-.124 0-.249 0-.374.133zm.125-2.126v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M148.453 365.43h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.078 365.563v-2.392h.374v2.259c-.124.133-.124.133-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M148.08 365.563h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M147.83 365.696v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M146.956 361.708c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 364.898c-1.996 0-3.243-.931-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.872 0 3.244.93 3.244 1.595 0 .664-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462 0-.665-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M149.077 364.366c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM147.205 364.765h-.499l-2.37-2.526c.125-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.954 364.632h.125c.125 0 .25 0 .374-.132.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.132h-.25s-.125.001-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM146.332 364.633h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.822 366.093c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 368.618c-1.872 0-3.119-.797-3.244-1.462V366.093h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.25.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.118-.797 3.118-1.462v-.797h-1.996c-.748-.133-1.621-.133-2.245 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.691 367.689s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 367.955v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.824 366.228v2.392h-.25v-2.26c.125-.132.25-.132.25-.132z"
            fill="#0EA59D"
            />
            <path
            d="M150.949 368.62h-.25v-2.392h.374v2.392h-.124zm-.25-.266s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M151.197 368.486h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.322 368.619h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.451 368.088c-.125 0-.125-.132-.25-.132v-1.728h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 368.221c-.125-.133-.25-.133-.25-.133v-1.86h.374v1.993h-.124zm-.25-.265l.125-1.596h-.125v1.596z"
            fill="#131A2D"
            />
            <path d="M151.572 368.619h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.572 368.619h-.25v-2.525h.375v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.078 367.822c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.202 367.955c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266s.125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.199 368.353c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 368.487c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.125-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.449 368.487h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.574 368.486c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M149.826 368.222c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 368.354c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.125-.266l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M153.693 368.354h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.318 368.487v-2.259h.375v2.259c-.125-.133-.125-.133-.375 0zm.25-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M152.195 368.619h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.945 368.619v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.392v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.947 366.094v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 368.619h-.25v-2.658h.375v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M155.064 367.024c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.814 367.689v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.703 367.423c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 367.689l-.125-.133c-.125-.133-.125-.266-.125-.399V366.094h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.316 367.956c-.125 0-.125.132-.25.132v-1.86h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 368.221v-1.993h.375v1.86c-.125 0-.25 0-.375.133zm.125-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.57 368.486h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.32 368.619v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M153.943 368.087c-.125 0-.125 0-.25.133v-1.993h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 368.353v-2.259h.375v1.994c-.125.132-.125.132-.375.265zm.125-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.318 368.353h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M153.068 368.486v-2.392h.375v2.259c-.25.133-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M152.945 368.486h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.695 368.619v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M151.822 364.631c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 367.821c-1.996 0-3.244-.93-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.871 0 3.243.798 3.243 1.595.125.665-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.798-3.119 1.462 0 .665 1.372 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462 0-.664-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.942 367.29c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM152.07 367.689h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.82 367.556h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.132h-.25c-.125 0-.249 0-.374.133s-.25 0-.374 0h-.375c.125 0 .25 0 .375-.133v-.132zM151.197 367.556h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.687 369.019c.374 0 .748 0 1.123.132h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.132.749-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 371.544c-1.871 0-3.119-.797-3.244-1.462V369.019h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.556 370.612s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.307 370.878v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.814 369.151v2.393h-.25v-2.26c0-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.814 371.544h-.25v-2.393h.375v2.393h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.062 371.41h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.187 371.543h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.316 371.012c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 371.145c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.399c0 .133.125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.437 371.544h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.562 371.543h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.068 370.746c-.125 0-.125-.132-.25-.132v-1.463h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.068 370.878c-.125-.132-.25-.265-.375-.265v-1.595h.375v1.86zm-.25-.398c.125.133.125.133 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.064 371.278c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 371.412c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.439 371.411h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.439 371.41c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.691 371.145c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 371.278c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.558 371.145h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.309 371.412v-2.26h.374v2.26c-.125-.133-.25-.133-.374 0zm.124-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.185 371.545h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M156.936 371.545v-2.659h.374v2.526c-.25.133-.25.133-.374.133zm.124-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M156.812 369.02v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M156.687 371.545h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.929 369.949c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.68 370.613v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.693 370.347c-.125-.132-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 370.612l-.125-.133c-.125-.132-.125-.265-.125-.398v-1.064h.25v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.306 370.879c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 371.145v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.124-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.56 371.41h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.186 371.543v-2.525h.374v2.525h-.374zm.124-2.393v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.931 371.012c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 371.277v-2.259h.374v1.993c-.25.133-.25.133-.374.266zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.183 371.277h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M157.934 371.41v-2.393h.374v2.26c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.808 371.41h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.559 371.543v-2.525h.374v2.392c-.125 0-.25.133-.374.133zm.124-2.393v2.127h.125l-.125-2.127c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.687 367.423c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.797 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 370.747c-1.996 0-3.369-.931-3.369-1.595 0-.665 1.373-1.595 3.369-1.595 1.996 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .664 1.247 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.808 370.215c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.936 370.613h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.808 370.48h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.187 370.48h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.677 371.943c.374 0 .749 0 1.123.133h2.121v.797c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.12c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 374.467c-1.871 0-3.119-.797-3.244-1.462V371.942h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.249.798-1.622 1.595-3.368 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.124z"
            fill="#131A2D"
            />
            <path
            d="M164.546 373.537s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 373.803v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.679 371.942v2.393h-.249v-2.26c.124 0 .124 0 .249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.679 374.468h-.249v-2.393h.374v2.393h-.125zm-.125-.266l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.052 374.335h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.052 374.468h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.306 373.936c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.306 373.936c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266c.124.133.124.133 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M161.302 374.468h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.427 374.468h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M158.933 373.67c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M158.933 373.803c-.125-.133-.25-.133-.374-.266v-1.595h.374v1.861zm-.125-.398c0 .132 0 .132 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M159.929 374.202c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.054 374.202c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.304 374.202h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.304 374.335c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.556 374.07c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.681 374.203c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266s.124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 374.069h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.174 374.335v-2.26h.374v2.26c-.125-.133-.249-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.05 374.336h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M161.801 374.469v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.526v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M161.675 371.943v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.675 374.469h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M164.919 372.873c0 .133-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 373.537v-1.595h.374v.931c0 .133-.125.266-.249.532l-.125.132zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.558 373.271c-.124-.132-.124-.265-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.558 373.537l-.125-.132c-.124-.133-.124-.266-.124-.399v-1.064h.249v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.171 373.804c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M163.922 374.07v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.425 374.335h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.176 374.468v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M163.796 373.936c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.547 374.202v-2.26h.374v1.994c-.125.133-.249.133-.374.266zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.048 374.202h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M162.799 374.335v-2.393h.374v2.26c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M162.8 374.335h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.426 374.468v-2.526h.374v2.393c-.125 0-.125 0-.374.133zm.125-2.393v2.127h.124l-.124-2.127c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.677 370.347c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.665 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 373.67c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.596 3.243-1.596 1.871 0 3.244.798 3.244 1.596 0 .664-1.373 1.595-3.244 1.595zm0-3.191c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.248-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M163.673 373.138c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM161.926 373.536h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.675 373.404h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.053 373.406h.998-.998c-.125 0-.375-.001-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.265.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.956 361.707c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.463-3.244 1.463-1.871 0-3.243-.798-3.243-1.463v-.797h2.121c.249 0 .623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 364.364c-1.871 0-3.119-.797-3.243-1.462V361.839h2.12a7.095 7.095 0 012.371 0h2.12v.93c-.249.798-1.497 1.595-3.368 1.595zm-3.243-1.728c0 .665 1.372 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463v-.664h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.664h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.826 363.302s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 363.701v-1.861h.374v1.595c-.124 0-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.958 361.84v2.393h-.249v-2.26c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.083 364.233h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M146.332 364.232h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.332 364.233h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.585 363.701c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.585 363.834c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.707 364.233h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.707 364.365h-.25v-2.525h.374v2.525h-.124zm-.25-.265c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.212 363.435c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 363.568c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M145.21 363.967c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.335 364.1c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266s.125.133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.583 364.1h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M145.708 364.232c-.124 0-.249 0-.249-.132v-2.26h.374v2.392h-.125zm-.249-.265l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.96 363.834c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.96 363.967c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.703 363.967h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.453 364.1v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.332 364.233h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M147.082 364.365v-2.658h.374v2.526c-.124 0-.249.132-.374.132zm.125-2.525v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.957 361.707v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M146.957 364.365h-.25v-2.658h.374v2.658h-.124zm-.125-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M150.201 362.771c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 363.435v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.838 363.17c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 363.302l-.124-.133c-.125-.133-.125-.266-.125-.399V361.707h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.451 363.568c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 363.834v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.705 364.232h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 364.233v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 363.835c-.125 0-.125 0-.25.132v-1.993h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 363.967v-2.26h.374v1.994c-.124.266-.249.266-.374.266zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 364.1h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M148.078 364.232v-2.392h.374v2.26c-.124 0-.124 0-.374.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M148.08 364.1h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.83 364.233v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127c0 .133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M146.956 360.244c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 363.434c-1.996 0-3.243-.93-3.243-1.595 0-.665 1.372-1.595 3.243-1.595 1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M149.077 363.037c-.249.133-.499.133-.748.265l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM147.205 363.302h-.499l-2.37-2.526c.125-.132.249-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.954 363.17h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.132h-.749c.125 0 .25 0 .374-.132v-.133zM146.332 363.302h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.133.374.133.499.266z"
            fill="#fff"
            />
            <path
            d="M151.822 364.633c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 367.158c-1.872 0-3.119-.797-3.244-1.462V364.633h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c-.125.931-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.463 3.119 1.463 1.746 0 3.118-.798 3.118-1.463v-.797h-1.996c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.691 366.228s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 366.627v-1.861h.375v1.595c-.125 0-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.824 364.765v2.393h-.25v-2.26c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.949 367.158h-.25v-2.392h.374v2.392h-.124zm-.25-.133s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M151.199 367.158h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.324 367.158h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.453 366.626c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.578 366.759c-.125-.132-.25-.132-.25-.132v-1.861h.374v1.993h-.124zm-.25-.265l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.574 367.157h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.574 367.158h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 366.36c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.202 366.493c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266s.125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.201 366.892c-.125 0-.125 0-.25-.132v-2.127h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M150.201 367.026c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.449 367.025h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.574 367.158c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.25-.266c.125 0 .125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M149.826 366.759c-.125 0-.125 0-.25-.132v-1.861h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 366.892c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.125-.265l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.693 366.892h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.318 367.025v-2.259h.375v2.259c-.125-.133-.125 0-.375 0zm.25-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M152.197 367.159h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.947 367.16v-2.659h.375v2.526c-.125.133-.25.133-.375.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.947 364.634v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 367.16h-.125v-2.659h.375v2.659h-.25zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.066 365.696c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 366.36v-1.595h.375v.931c0 .133-.125.266-.25.531l-.125.133zm.125-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M148.703 366.095c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 366.227l-.125-.133c-.125-.133-.125-.266-.125-.399V364.632h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.316 366.493c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 366.759v-1.993h.375v1.861c-.125 0-.25 0-.375.132zm.125-1.86v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.57 367.157h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M152.32 367.158v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M153.943 366.759c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 366.892v-2.26h.375v1.994c-.125.133-.125.266-.375.266zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.32 367.025h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.07 367.158v-2.392h.375v2.259-.133.133c-.25 0-.25 0-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M152.945 367.024h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.695 367.158v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.822 363.17c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.872 0-3.244-.798-3.244-1.595 0-.798 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 366.36c-1.996 0-3.244-.797-3.244-1.595 0-.798 1.372-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.942 365.828c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM152.07 366.227h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.82 366.094h.124c.125 0 .25 0 .375-.133.124 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.132s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.197 366.094h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.687 367.556c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 370.08c-1.871 0-3.119-.797-3.244-1.462V367.555h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.931-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.556 369.152s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.307 369.55v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.814 367.689v2.393h-.25v-2.26c0-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.814 370.082h-.25v-2.393h.375v2.393h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.064 370.082h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.189 370.082h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 369.55c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 369.683c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.437 370.082h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.562 370.082h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.068 369.284c-.125 0-.125-.132-.25-.132v-1.463h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.068 369.418c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.25-.266c.125 0 .125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.066 369.816c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.066 369.949c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.439 369.949h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.439 369.949c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.691 369.684c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 369.816c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.558 369.816h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.309 369.949v-2.26h.374v2.26c-.125-.133-.25 0-.374 0zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.185 370.082h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.936 370.081v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M156.812 367.557v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M156.687 370.081h-.249v-2.658h.374v2.658h-.125c.125 0 .125 0 0 0zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.931 368.487c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.682 369.284v-1.595h.374v.931c0 .133-.125.266-.25.532l-.124.132zm.124-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.693 369.019c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 369.152l-.125-.133c-.125-.133-.125-.266-.125-.399V367.557h.25v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.306 369.417c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 369.683v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.56 370.082h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.186 370.082v-2.525h.374v2.525h-.374zm.124-2.392v2.259h.125l-.125-2.259c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.933 369.683c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.684 369.816v-2.259h.374v2.126c-.25 0-.25.133-.374.133zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.183 369.949h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M157.934 370.082v-2.393h.374v2.26c-.125 0-.25 0-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.81 369.949h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.561 370.082v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.392v2.126h.125l-.125-2.126c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.687 366.094c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 369.284c-1.996 0-3.369-.798-3.369-1.595 0-.798 1.373-1.595 3.369-1.595 1.996 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .664 1.247 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.808 368.752c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.936 369.151h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.81 369.018h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.187 369.019h.998-.998c-.124 0-.374 0-.499-.133-.124-.133-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.677 370.479c.374 0 .749.001 1.123.133h2.121v.798c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.798h2.12c.25-.132.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 373.005c-1.871 0-3.119-.797-3.243-1.462V370.48h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.93c-.125.93-1.497 1.595-3.244 1.595zm-3.243-1.595c0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462v-.797h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M164.546 372.076s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 372.342v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.679 370.614v2.392h-.249v-2.259c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.679 373.006h-.249v-2.392h.374v2.392h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.052 373.006h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.052 373.006h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.306 372.475c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.306 372.608c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M161.302 373.006h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.427 373.006h-.249v-2.525h.374v2.525h-.125zm-.249-.133s.124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M158.933 372.208c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M158.933 372.342c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M159.929 372.74c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.054 372.874c-.125 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.266l.124-1.993h-.124v1.993z"
            fill="#131A2D"
            />
            <path d="M160.304 372.873h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.304 372.873c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M159.556 372.608c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.681 372.741c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266s.124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 372.741h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.174 372.873v-2.259h.374v2.259c-.125-.132-.249 0-.374 0zm.125-2.259v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.05 373.005h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M161.801 373.005v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.392v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M161.677 370.48v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M161.677 373.005h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M164.919 371.411c0 .133-.124.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 372.076v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.266l-.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M158.558 371.943c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M158.558 372.076l-.125-.133c-.124-.133-.124-.266-.124-.399V370.481h.249v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M164.171 372.342c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M163.922 372.607v-1.993h.374v1.86c-.125 0-.249 0-.374.133zm.125-1.993v1.727h.124l-.124-1.727z"
            fill="#131A2D"
            />
            <path d="M162.425 372.873h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.176 373.006v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.392v2.259h.124l-.124-2.259z"
            fill="#131A2D"
            />
            <path
            d="M163.796 372.607c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.547 372.74v-2.259h.374v1.994c-.125.132-.249.265-.374.265zm.125-2.126v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.048 372.74h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M162.799 372.873v-2.392h.374v2.259c-.125.133-.249.133-.374.133zm.125-2.259v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path d="M162.8 372.873h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.426 373.006v-2.525h.374v2.392c-.125.133-.125.133-.374.133zm.125-2.392v2.126h.124l-.124-2.126c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.677 369.017c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 372.208c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M163.673 371.677c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.132.748-.132l2.62 2.658zM161.926 372.075h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.675 371.942h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.053 371.942h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.956 360.379c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 362.904c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121c.374-.133.748-.133 1.122-.133.375 0 .749 0 1.123.133h2.121v.931c-.125.797-1.372 1.595-3.244 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.996c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M149.826 361.973s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 362.238v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.958 360.377v2.393h-.249v-2.26c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.083 362.77h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M146.332 362.77h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.332 362.902h-.25v-2.525h.374v2.525h-.124zm-.125-.265s0 .133 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.585 362.238c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.585 362.371c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.707 362.77h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.707 362.902h-.25v-2.525h.374v2.525h-.124zm-.25-.132c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.212 362.106c-.124 0-.124-.133-.249-.133v-1.463h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 362.238c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399s0 .133 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M145.21 362.637c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.335 362.637c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.583 362.637h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.708 362.77c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266c0 .133 0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.96 362.504c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.96 362.504c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.703 362.504h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.453 362.637v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.332 362.77h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M147.082 362.903v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.957 360.378v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.957 362.903h-.25v-2.659h.374v2.659h-.124zm-.125-.133s.125 0 0 0l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M150.201 361.308c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 361.972v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.838 361.707c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 361.972l-.124-.133c-.125-.133-.125-.266-.125-.399V360.377h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.451 362.238c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 362.371v-1.994h.374v1.861c-.124 0-.249.133-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.705 362.771h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.455 362.902v-2.525h.374v2.525h-.374zm.125-2.525v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 362.371c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 362.637v-2.26h.374v2.127c-.124 0-.249 0-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.455 362.637h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M148.08 362.77v-2.393h.374v2.26c-.124.133-.124.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M148.08 362.771h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.83 362.77v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.956 358.784c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 361.974c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595zm0-3.057c-1.871 0-3.118.797-3.118 1.462 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M149.077 361.574c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM147.205 361.973h-.499l-2.37-2.526c.125-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.954 361.841h.125c.125 0 .25 0 .374-.132.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.132h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM146.332 361.84h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.822 363.303c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.93H151.822z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 365.828c-1.872 0-3.119-.797-3.244-1.462V363.303h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c-.125.798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.118-.797 3.118-1.462v-.797h-1.996c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.691 364.898s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 365.164v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path d="M150.824 363.302v2.393h-.25v-2.393h.25z" fill="#0EA59D" />
            <path
            d="M150.949 365.695h-.25v-2.392h.374v2.392h-.124zm-.25-.133s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M151.197 365.695h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.322 365.828h-.25v-2.525h.375v2.525h-.125zm-.25-.266l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.451 365.164c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 365.297c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.572 365.695h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.572 365.828h-.25v-2.525h.375v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.078 365.031c-.125 0-.125-.133-.25-.133v-1.595h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.202 365.163c-.124-.133-.249-.265-.374-.265v-1.596h.374v1.861zm-.249-.398s.125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M150.199 365.429c-.125 0-.125 0-.25-.133v-1.994h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 365.562c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.449 365.562h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M150.574 365.695c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.25-.266c.125 0 .125.133 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M149.826 365.429c-.125 0-.125 0-.25-.132v-1.994h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 365.429c-.125 0-.25-.132-.25-.132v-1.994h.374v2.126h-.124zm-.125-.132l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.693 365.429h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.318 365.562v-2.259h.375v2.259h-.375zm.25-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M152.195 365.695h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.945 365.828v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.947 363.303v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 365.828h-.25v-2.658h.375v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M155.066 364.233c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 364.898v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.703 364.632c-.125-.133-.125-.266-.125-.399v-.93h.125v1.329z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 364.898l-.125-.133c-.125-.133-.125-.266-.125-.399V363.303h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.316 365.164c-.125 0-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 365.297v-1.994h.375v1.861c-.125 0-.25.133-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.57 365.695h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.32 365.828v-2.525h.375v2.392c-.125 0-.25.133-.375.133zm.125-2.525v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M153.943 365.297c-.125 0-.125 0-.25.132v-2.126h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 365.429v-2.126h.375v2.126h-.375zm.125-1.993v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.318 365.562h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M153.068 365.695v-2.392h.375v2.259c-.25.133-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M152.945 365.695h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.695 365.695v-2.392h.375v2.392h-.375zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M151.822 361.708c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 364.898c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.871 0 3.243.798 3.243 1.595.125.798-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .665 1.372 1.462 3.119 1.462 1.746 0 3.118-.797 3.118-1.462 0-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.942 364.499c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM152.07 364.898h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.82 364.765h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.623-.399-.124.266-.249.399-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.197 364.766h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.687 366.227c.374 0 .748 0 1.123.132h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.132.749-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 368.752c-1.871 0-3.119-.797-3.244-1.462V366.227h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.375-.133-.749-.133-1.123-.133s-.749 0-1.123.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.556 367.823s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.307 368.089v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.814 366.228v2.392h-.25v-2.26c0-.132.125-.132.25-.132z"
            fill="#0EA59D"
            />
            <path
            d="M155.814 368.62h-.25v-2.392h.375v2.392h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.064 368.62h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M156.189 368.753h-.25v-2.525h.375v2.525h-.125zm-.25-.266s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 368.088c-.125 0-.125-.132-.25-.132v-1.728h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 368.221c-.125-.133-.25-.133-.25-.133v-1.86h.375v1.993h-.125zm-.25-.265s.125 0 0 0l.125-1.596h-.125v1.596z"
            fill="#131A2D"
            />
            <path d="M156.437 368.62h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.562 368.753h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.068 367.956c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.068 368.088c-.125-.132-.25-.265-.375-.265v-1.595h.375v1.86zm-.25-.398c.125 0 .125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M155.066 368.353c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.066 368.487c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.439 368.488h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.439 368.62c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.691 368.221c-.125 0-.125 0-.25-.133v-1.86h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 368.354c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.25-.266c0 .133 0 .133 0 0l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M158.558 368.354h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.309 368.487v-2.259h.374v2.259h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.185 368.619h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.936 368.752v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M156.812 366.227v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M156.687 368.752h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.929 367.159c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.68 367.823v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.693 367.557c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 367.689l-.125-.133c-.125-.133-.125-.266-.125-.399V366.094h.25v1.595zm-.125-.532v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.306 368.089c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 368.221v-1.993h.374v1.86c-.125 0-.125.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.56 368.62h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.186 368.753v-2.525h.374v2.525c-.125-.133-.25-.133-.374 0zm.124-2.525v2.259h.125l-.125-2.259c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.933 368.221c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.684 368.353v-2.259h.374v2.126c-.25.133-.25.133-.374.133zm.124-1.993v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M158.183 368.487h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.934 368.62v-2.392h.374v2.259c-.125 0-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.81 368.486h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.561 368.619v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.687 364.631c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 367.821c-1.996 0-3.369-.798-3.369-1.595 0-.798 1.373-1.595 3.369-1.595 1.996 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.808 367.423c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.936 367.822h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.81 367.689h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.187 367.689h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.133.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.677 369.017c.374 0 .749 0 1.123.133h2.121v.797c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.12c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 371.675c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121a7.142 7.142 0 012.37 0h2.121v.931c-.249.797-1.622 1.595-3.368 1.595zm-3.244-1.728c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.798h-1.996a7.142 7.142 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M164.546 370.744s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 371.009v-1.861h.374v1.596c-.125 0-.125.132-.374.265zm.125-1.728v1.463h.124l-.124-1.463z"
            fill="#131A2D"
            />
            <path
            d="M160.679 369.149v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.679 371.541h-.249v-2.392h.374v2.392h-.125zm-.125-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M161.052 371.542h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.052 371.542h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.306 371.01c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.306 371.142c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M161.302 371.542h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.427 371.674h-.249v-2.525h.374v2.525h-.125zm-.249-.133s.124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M158.933 370.877c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M158.933 371.009c-.125-.133-.25-.265-.374-.265v-1.596h.374v1.861zm-.125-.398l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M159.929 371.276c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.054 371.409c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c0 .133 0 .133 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.304 371.409h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.304 371.541c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M159.556 371.143c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.681 371.275c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266s.124.133 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 371.276h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.174 371.408v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.05 371.542h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M161.801 371.675v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.525v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M161.677 369.016v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.677 371.675h-.249v-2.659h.374v2.659h-.125zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M164.921 370.08c0 .133-.124.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.547 370.744v-1.596h.374v.931c0 .133-.125.266-.249.532l-.125.133zm.125-1.463v1.064c0-.133.124-.266.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.558 370.479c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.558 370.612l-.125-.133c-.124-.133-.124-.266-.124-.399V369.017h.249v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.171 371.01c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M163.922 371.142v-1.994h.374v1.861c-.125 0-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.425 371.542h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.176 371.674v-2.526h.374v2.393c-.249 0-.249 0-.374.133zm.125-2.526v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M163.798 371.144c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.549 371.276v-2.26h.374v2.127c-.125.133-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.048 371.409h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M162.799 371.541v-2.393h.374v2.26c-.125 0-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M162.8 371.409h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.426 371.542v-2.525h.374v2.392c-.125.133-.125.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.677 367.556c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 370.746c-1.996 0-3.243-.931-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.871 0 3.244.931 3.244 1.595 0 .798-1.373 1.596-3.244 1.596zm0-3.191c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M163.673 370.347c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM161.926 370.745h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.675 370.613h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.053 370.613h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M141.716 369.418c.374 0 .749 0 1.123.133h2.121v.797c0 .665-1.373 1.463-3.244 1.463-1.871 0-3.243-.798-3.243-1.463v-.797h2.12c.375-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 371.944c-1.871 0-3.119-.798-3.243-1.463V369.418h2.12a7.095 7.095 0 012.371 0h2.12v.93c-.124.798-1.497 1.596-3.368 1.596zm-3.119-1.596c0 .665 1.373 1.463 3.119 1.463 1.747 0 3.119-.798 3.119-1.463v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.124z"
            fill="#131A2D"
            />
            <path
            d="M144.585 371.013s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.336 371.279v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M140.843 369.418v2.393h-.249v-2.26c.124 0 .124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M140.843 371.943h-.249v-2.392h.374v2.392h-.125zm-.249-.265c.124 0 .124 0 0 0l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M141.091 371.81h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M141.216 371.943h-.249v-2.525h.374v2.525h-.125zm-.249-.133s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M139.345 371.412c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M139.47 371.412c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266s.124.133 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M141.466 371.81h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M141.591 371.943h-.249v-2.525h.374v2.525h-.125zm-.249-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.097 371.146c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M139.097 371.279c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.399c.125 0 .125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M140.095 371.677c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M140.095 371.677c-.125 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M140.468 371.678h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M140.468 371.811c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M139.72 371.546c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M139.845 371.678c-.125 0-.249-.132-.249-.132v-1.994h.374v2.126h-.125zm-.249-.265l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M143.587 371.544h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M143.338 371.678v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M142.214 371.81h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M141.965 371.943v-2.659h.374v2.526c-.249.133-.249.133-.374.133zm.125-2.526v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M141.841 369.418v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M141.716 371.943h-.249v-2.659h.374v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M144.958 370.348c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M144.709 371.013v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.266l-.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M138.722 370.747c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M138.722 371.013l-.125-.133c-.124-.133-.124-.266-.124-.399V369.418h.249v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M144.335 371.28c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M143.961 371.546v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M142.589 371.81h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M142.215 371.943v-2.525h.374v2.525h-.374zm.125-2.392v2.26h.124l-.124-2.26c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M143.962 371.412c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M143.713 371.678v-2.26h.374v2.127c-.249 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M143.212 371.677h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M142.963 371.81v-2.392h.374v2.259c-.125.133-.249.133-.374.133zm.125-2.259v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path d="M142.837 371.811h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.588 371.943v-2.525h.374v2.393c-.125 0-.249 0-.374.132zm.125-2.392v2.127h.124l-.124-2.127c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M141.716 367.823c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.665 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 371.012c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.931 3.244 1.595 0 .665-1.248 1.595-3.244 1.595zm0-3.057c-1.871 0-3.119.798-3.119 1.462 0 .665 1.373 1.462 3.119 1.462 1.747 0 3.119-.797 3.119-1.462 0-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M143.837 370.613c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM141.965 371.012h-.499l-2.37-2.526c.124-.132.249-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M142.839 370.88h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.132h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.132zM141.217 370.88h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.706 372.34c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 374.865c-1.871 0-3.118-.797-3.243-1.462V372.34h2.121c.374-.133.748-.133 1.122-.133.375 0 .749 0 1.123.133h2.121v.93c-.125.798-1.372 1.595-3.244 1.595zm-3.243-1.595c0 .665 1.372 1.463 3.119 1.463 1.871 0 3.118-.798 3.118-1.463v-.797h-1.996c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M149.576 373.936s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 374.201v-1.86h.374v1.595c-.124.133-.124.133-.374.265zm.25-1.727v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.708 372.341v2.392h-.249v-2.259c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M145.708 374.733h-.249v-2.392h.374v2.392h-.125zm-.124-.133l.124-2.126h-.124v2.126z"
            fill="#131A2D"
            />
            <path d="M146.082 374.733h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.082 374.866h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M144.335 374.201c-.124 0-.124-.132-.249-.132v-1.728h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M144.335 374.334c-.124-.133-.249-.133-.249-.133v-1.86h.374v1.993h-.125zm-.124-.265s0 .132 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.332 374.733h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.457 374.866h-.25v-2.525h.374v2.525h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M143.962 374.068c-.124 0-.124-.132-.249-.132v-1.463h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 374.201c-.125-.132-.249-.265-.374-.265v-1.595h.374v1.86zm-.125-.398s0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M144.96 374.6c-.124 0-.124 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M145.085 374.6c-.124 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.133s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M145.333 374.6h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.458 374.733c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.585 374.467c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.71 374.467c-.124 0-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M148.453 374.467h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M148.203 374.6v-2.259h.374v2.259h-.374zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M147.082 374.732h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M146.832 374.865v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M146.707 372.34v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.707 374.865h-.25v-2.658h.374v2.658h-.124zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M149.951 373.271c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 373.936v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.588 373.671c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M143.712 373.936l-.124-.133c-.125-.133-.125-.266-.125-.399V372.341h.249v1.595zm-.249-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M149.201 374.201c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.951 374.467v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.455 374.733h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.205 374.866v-2.525h.374v2.525h-.374zm.125-2.525v2.259h.125l-.125-2.259c0 .132 0 .132 0 0z"
            fill="#131A2D"
            />
            <path
            d="M148.828 374.334c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 374.6v-2.259h.374v2.126c-.124 0-.249 0-.374.133zm.125-2.126v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M148.08 374.6h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M147.83 374.733v-2.392h.374v2.259c-.124.133-.249.133-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M147.83 374.733h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 374.866v-2.525h.374v2.392c-.124 0-.124 0-.374.133zm.25-2.392v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path
            d="M146.706 370.746c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 373.936c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595zm0-3.057c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.664-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M148.827 373.537c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM146.955 373.936h-.499l-2.37-2.526c.125-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.704 373.803h.125c.125 0 .25 0 .374-.133.125 0 .25-.132.375-.132h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.132s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM146.082 373.803h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.572 375.267c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.93H151.572z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 377.792c-1.872 0-3.119-.797-3.244-1.462V375.267h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c-.125.798-1.372 1.595-3.243 1.595zm-3.244-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.996c-.375-.133-.749-.133-1.123-.133s-.749 0-1.123.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.441 376.861s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 377.127v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path d="M150.574 375.266v2.393h-.25v-2.393h.25z" fill="#0EA59D" />
            <path
            d="M150.699 377.659h-.25v-2.392h.374v2.392h-.124zm-.25-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M150.947 377.659h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M150.947 377.792h-.25v-2.525h.375v2.525h-.125zm-.125-.266c0 .133 0 .133 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.201 377.127c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 377.26c-.125-.133-.25-.133-.25-.133v-1.86h.374v1.993h-.124zm-.125-.265l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.322 377.659h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.322 377.792h-.25v-2.525h.375v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M148.828 376.994c-.125 0-.125-.133-.25-.133v-1.595h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.952 377.127c-.124-.132-.249-.132-.374-.265v-1.595h.374v1.86zm-.249-.398s0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M149.826 377.526c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M149.951 377.526c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.199 377.526h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M150.324 377.659c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.25-.266c0 .133.125.133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.576 377.393c-.125 0-.125 0-.25-.133v-1.994h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 377.393c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.125-.133l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.443 377.393h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.068 377.526v-2.259h.375v2.259h-.375zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M151.947 377.659h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.697 377.792v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.697 375.267v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 377.792h-.25v-2.658h.375v2.658h-.125zm-.125-.133c.125 0 .125 0 0 0l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M154.816 376.197c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 376.861v-1.595h.375v.931c0 .133-.125.266-.25.531l-.125.133zm.125-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M148.453 376.595c-.125-.133-.125-.266-.125-.398v-.931h.125v1.329z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 376.861l-.125-.133c-.125-.132-.125-.265-.125-.398v-1.064h.25v1.595zm-.25-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M154.066 377.127c-.125 0-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.816 377.26v-1.993h.375v1.86c-.125 0-.25.133-.375.133zm.125-1.86v1.727h.125l-.125-1.727z"
            fill="#131A2D"
            />
            <path d="M152.32 377.659h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.07 377.792v-2.525h.375v2.525h-.375zm.125-2.525v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 377.26c-.125 0-.125 0-.25.133v-2.127h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 377.526v-2.26h.375v1.994c-.125.133-.25.133-.375.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.07 377.526h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M152.82 377.659v-2.393h.375v2.26c-.25.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.695 377.659h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.445 377.659v-2.393h.375v2.393h-.375zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.572 373.671c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.872 0-3.244-.798-3.244-1.595 0-.798 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 376.861c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.372-1.595 3.244-1.595 1.996 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .664 1.247 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462 0-.665-1.372-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.692 376.462c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM151.82 376.861h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.57 376.728h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.623-.398a1.002 1.002 0 01-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM150.947 376.729h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.437 378.19c.374 0 .748 0 1.123.133h2.12v.798c0 .664-1.372 1.462-3.243 1.462-1.871 0-3.244-.798-3.244-1.462v-.798h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 380.716c-1.871 0-3.119-.798-3.244-1.462V378.191h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.798h-1.996a7.095 7.095 0 00-2.371 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M159.306 379.784s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.057 380.05v-1.861h.374v1.595c-.125.133-.25.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.439 378.189v2.393h-.25v-2.26c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.564 380.582h-.25v-2.393h.375v2.393h-.125zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M155.814 380.582h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M155.939 380.715h-.25v-2.526h.375v2.526h-.125zm-.25-.266l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.068 380.05c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.193 380.183c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.187 380.582h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.187 380.715h-.249v-2.526h.374v2.526h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M153.693 379.917c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 380.05c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.25-.398s.125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M154.816 380.316c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 380.449c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.189 380.449h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.189 380.582c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.25-.266c.125 0 .125.133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.441 380.316c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 380.316c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.125-.133l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.308 380.316h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.059 380.449v-2.26h.374v2.26h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M156.937 380.582h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M156.562 380.715v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.562 378.189v2.526h-.249v-2.526h.249s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 380.715h-.249v-2.659h.374v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M159.681 379.12c0 .133-.125.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.432 379.784v-1.595h.374v.931c0 .133-.125.266-.25.532l-.124.132zm.124-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.443 379.519c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 379.784l-.125-.132c-.125-.133-.125-.266-.125-.399v-1.064h.25v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M158.931 380.05c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 380.183v-1.994h.374v1.861c-.125 0-.125.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.185 380.582h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.936 380.715v-2.526h.374v2.393c-.125 0-.25.133-.374.133zm.124-2.526v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.683 380.183c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.309 380.316v-2.26h.374v2.127c-.125.133-.125.133-.374.133zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M157.935 380.449h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M157.686 380.582v-2.393h.374v2.26c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.56 380.582h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.311 380.582v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M156.437 376.595c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 379.785c-1.996 0-3.244-.931-3.244-1.595 0-.665 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .664 1.372 1.462 3.119 1.462 1.746 0 3.119-.798 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.558 379.386c-.25.133-.499.133-.749.266l-2.62-2.792c.25 0 .499-.132.749-.132l2.62 2.658zM156.686 379.784h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.435 379.652h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM155.937 379.654h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M141.716 367.956c.374 0 .749 0 1.123.133h2.121v.797c0 .665-1.373 1.463-3.244 1.463-1.871 0-3.243-.798-3.243-1.463v-.797h2.12c.375-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 370.481c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.931c0 .797-1.373 1.595-3.244 1.595zm-3.119-1.595c0 .664 1.373 1.462 3.119 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996c-.374-.133-.749-.133-1.123-.133s-.748 0-1.123.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M144.585 369.55s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.336 369.816v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M140.843 368.089v2.392h-.249v-2.259c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M140.843 370.481h-.249v-2.392h.374v2.392h-.125zm-.249-.132c.124 0 .124 0 0 0l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M141.091 370.48h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M141.216 370.481h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.345 369.95c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M139.47 370.083c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266s.124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M141.466 370.48h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M141.591 370.481h-.249v-2.526h.374v2.526h-.125zm-.249-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.097 369.683c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M139.097 369.816c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.266c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M140.093 370.215c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M140.093 370.348c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M140.468 370.347h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M140.468 370.348c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M139.72 370.083c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M139.845 370.216c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M143.587 370.216h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M143.338 370.349v-2.26h.374v2.26c-.125-.133-.249-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M142.214 370.482h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M141.965 370.481v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M141.841 367.956v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M141.716 370.481h-.249v-2.659h.374v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M144.958 368.885c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M144.709 369.55v-1.595h.374v.931c0 .132-.125.265-.249.531l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.265l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M138.722 369.417c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M138.722 369.55l-.125-.133c-.124-.133-.124-.266-.124-.399V367.955h.249v1.595zm-.125-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M144.335 369.817c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M143.961 370.083v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M142.589 370.348h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.215 370.481v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M143.962 370.082c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M143.713 370.215v-2.26h.374v1.994c-.249.133-.249.133-.374.266zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M143.212 370.215h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M142.963 370.348v-2.393h.374v2.26c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M142.837 370.348h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.588 370.481v-2.526h.374v2.393c-.125.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M141.716 366.493c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 369.683c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.798-3.119 1.462 0 .665 1.373 1.462 3.119 1.462 1.747 0 3.119-.797 3.119-1.462 0-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M143.837 369.152c-.25.132-.499.133-.749.265l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM141.965 369.55h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M142.839 369.418h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.132h-.748c.125 0 .249 0 .374-.132v-.133zM141.217 369.418h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.706 370.877c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.463-3.244 1.463-1.871 0-3.243-.798-3.243-1.463v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 373.403c-1.871 0-3.119-.798-3.243-1.463V370.877h2.12a7.095 7.095 0 012.371 0h2.12v.93c-.249.798-1.497 1.596-3.368 1.596zm-3.243-1.596c0 .665 1.372 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.576 372.475s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 372.741v-1.861h.374v1.595c-.124.133-.124.133-.374.266zm.25-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.708 371.013v2.393h-.249v-2.26c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M145.708 373.405h-.249v-2.392h.374v2.392h-.125zm-.124-.266s0 .133 0 0l.124-2.126h-.124v2.126z"
            fill="#131A2D"
            />
            <path d="M146.083 373.273h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M146.083 373.405h-.249v-2.525h.374v2.525h-.125zm-.124-.133l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M144.335 372.874c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.335 373.006c-.124-.132-.249-.132-.249-.132v-1.861h.374v1.993h-.125zm-.124-.265l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.332 373.406h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.457 373.406h-.25v-2.526h.374v2.526h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M143.962 372.609c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 372.741c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M144.96 373.14c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.085 373.273c-.124 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.266s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M145.333 373.272h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.458 373.272c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.585 373.006c-.124 0-.124.001-.249-.132v-1.861h.249v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M144.71 373.139c-.124 0-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.249-.265c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 373.139h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M148.203 373.272v-2.259h.374v2.259c-.124-.133-.249-.133-.374 0zm.125-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M147.082 373.405h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M146.832 373.405v-2.658h.374v2.526c-.124.132-.249.132-.374.132zm.125-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M146.707 370.88v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.707 373.405h-.25v-2.658h.374v2.658h-.124zm-.125-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M149.951 371.811c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 372.475v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.588 372.21c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M143.712 372.475l-.124-.133c-.125-.133-.125-.266-.125-.399V370.88h.249v1.595zm-.249-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M149.201 372.741c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.951 373.007v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.455 373.273h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.205 373.406v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M148.828 372.875c-.125 0-.125 0-.25.132v-1.993h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 373.14v-2.26h.374v1.994c-.124.133-.249.133-.374.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.08 373.14h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M147.83 373.272v-2.392h.374v2.26c-.124.132-.249.132-.374.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M147.83 373.272h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 373.405v-2.525h.374v2.392c-.124.133-.124.133-.374.133zm.25-2.392v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path
            d="M146.706 369.416c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 372.605c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.664-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M148.827 372.075c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM146.955 372.473h-.499l-2.37-2.526c.125-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.704 372.34h.125c.125 0 .25 0 .374-.132.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.132h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM146.082 372.341h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.572 373.804c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.249-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 376.329c-1.872 0-3.119-.797-3.244-1.462V373.804h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.25.798-1.497 1.595-3.368 1.595zm-3.244-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.441 375.399s-.125.133-.25.133v-1.595h.25v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 375.665v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path d="M150.574 373.937v2.392h-.25v-2.392h.25z" fill="#0EA59D" />
            <path
            d="M150.699 376.329h-.25v-2.392h.374v2.392h-.124zm-.25-.266l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M150.949 376.196h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M150.949 376.329h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.201 375.798c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 375.93c-.125-.133-.25-.133-.25-.133v-1.86h.374v1.993h-.124zm-.125-.398c0 .133 0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.324 376.329h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.324 376.329h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M148.828 375.532c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M148.952 375.665c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399c0 .133 0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M149.826 376.063c-.125 0-.125 0-.25-.133v-1.993h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M149.951 376.196c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.25-.266c.125 0 .125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.199 376.196h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M150.324 376.196c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.25-.133s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M149.576 375.931c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 376.063c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.125-.266l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M153.443 375.93h-.25v-1.993h.25v1.993z" fill="#0EA59D" />
            <path
            d="M153.068 376.196v-2.259h.375v2.259c-.125-.133-.125-.133-.375 0zm.125-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M151.947 376.329h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.697 376.329v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.392v2.392h.125l-.125-2.392c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.697 373.804v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 376.329h-.25v-2.658h.375v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M154.816 374.734c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 375.399v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462V375c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.453 375.133c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 375.399l-.125-.133c-.125-.133-.125-.266-.125-.399V373.804h.25v1.595zm-.25-.665V375v-1.063.797z"
            fill="#131A2D"
            />
            <path
            d="M154.066 375.664c-.125 0-.125.133-.25.133v-1.86h.25v1.727z"
            fill="#0EA59D"
            />
            <path
            d="M153.816 375.93v-1.993h.375v1.86c-.125 0-.25 0-.375.133zm.125-1.993v1.727h.125l-.125-1.727z"
            fill="#131A2D"
            />
            <path d="M152.32 376.196h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.07 376.329v-2.525h.375v2.525h-.375zm.125-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 375.797c-.125 0-.125 0-.25.133v-1.993h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 376.063v-2.259h.375v2.126c-.125 0-.25 0-.375.133zm.125-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.07 376.063h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M152.82 376.196v-2.392h.375v2.259c-.25.133-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M152.695 376.196h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.445 376.329v-2.525h.375v2.392c-.25 0-.25.133-.375.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M151.572 372.208c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 375.531c-1.996 0-3.244-.931-3.244-1.595 0-.665 1.372-1.595 3.244-1.595 1.996 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .665 1.372 1.462 3.119 1.462 1.746 0 3.118-.797 3.118-1.462 0-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.692 374.999c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM151.82 375.398h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.57 375.265h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.623-.399-.124.266-.249.399-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM150.947 375.266h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.125 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.437 376.728c.374 0 .748 0 1.123.132h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.132.749-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 379.253c-1.871 0-3.119-.797-3.244-1.462V376.728h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.996a7.095 7.095 0 00-2.371 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M159.306 378.323s-.125.132-.249.132v-1.727h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.057 378.588v-1.86h.374v1.595c-.125.132-.25.133-.374.265zm.124-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M155.439 376.728v2.392h-.25v-2.26c.125 0 .25 0 .25-.132z"
            fill="#0EA59D"
            />
            <path
            d="M155.564 379.253h-.25v-2.393h.375v2.393h-.125zm-.25-.266s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M155.814 379.12h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M155.939 379.253h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.066 378.722c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 378.721c-.125-.133-.25-.133-.25-.133v-1.86h.375v1.993h-.125zm-.25-.266c0 .133 0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.187 379.254h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.187 379.253h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M153.693 378.456c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 378.588c-.125-.132-.25-.265-.375-.265v-1.595h.375v1.86zm-.25-.398c0 .133.125.133 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M154.816 378.987c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 378.987c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.189 378.988h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.189 379.12c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.441 378.854c-.125 0-.125 0-.25-.133v-1.86h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 378.987c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.125-.266l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M158.308 378.854h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.059 379.12v-2.26h.374v2.26c-.25-.133-.25-.133-.374 0zm.124-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M156.937 379.12h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.562 379.253v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.562 376.728v2.525h-.249v-2.525h.249s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 379.253h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.679 377.659c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.43 378.323v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.443 378.058c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 378.323l-.125-.133c-.125-.133-.125-.266-.125-.399V376.728h.25v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M158.931 378.588c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 378.854v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.124-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.185 379.12h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.936 379.253v-2.525h.374v2.525h-.374zm.124-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.683 378.722c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.309 378.987v-2.259h.374v2.126c-.125 0-.125 0-.374.133zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M157.933 378.987h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.684 379.12v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.56 379.12h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.311 379.253v-2.525h.374v2.392c-.125 0-.25 0-.374.133zm.124-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M156.437 375.133c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.665 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 378.455c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.373-1.595 3.244-1.595 1.871 0 3.243.798 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.798-3.119 1.463 0 .664 1.372 1.462 3.119 1.462 1.746 0 3.119-.798 3.119-1.462.124-.665-1.248-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.558 377.924c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.686 378.322h-.499l-2.371-2.525c.125 0 .25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.435 378.19h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM155.937 378.19h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M141.716 366.494c.374 0 .749 0 1.123.133h2.121v.797c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.12c.375 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 369.152c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.124.797-1.497 1.595-3.368 1.595zm-3.119-1.728c0 .664 1.373 1.462 3.119 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M144.585 368.089s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.336 368.488v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M140.843 366.627v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M140.843 369.02h-.249v-2.393h.374v2.393h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M141.093 369.019h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.218 369.019h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.124 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.345 368.488c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M139.47 368.621c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266s.124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M141.466 369.02h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.591 369.153h-.249v-2.526h.374v2.526h-.125zm-.249-.266l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.097 368.221c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M139.097 368.354c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.266c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M140.095 368.753c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M140.095 368.887c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.125-.266s0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M140.468 368.887h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M140.468 369.02c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M139.72 368.621c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M139.845 368.754c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266s0 .133 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M143.587 368.754h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M143.338 368.887v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M142.214 369.019h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M141.965 369.152v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.525v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M141.841 366.493v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M141.716 369.152h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M144.96 367.558c0 .132-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M144.711 368.222v-1.595h.374v.931c0 .133-.125.265-.249.531l-.125.133zm.125-1.462v1.063c0-.132.124-.132.124-.265l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M138.722 367.957c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M138.722 368.089l-.125-.133c-.124-.133-.124-.266-.124-.399V366.494h.249v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M144.335 368.355c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M143.961 368.621v-1.994h.374v1.861c-.125 0-.125.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M142.589 369.019h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.215 369.019v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M143.962 368.621c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M143.713 368.753v-2.259h.374v1.993c-.249.266-.249.266-.374.266zm.125-1.993v1.86h.124l-.124-1.86z"
            fill="#131A2D"
            />
            <path d="M143.214 368.887h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M142.965 369.02v-2.393h.374v2.26c-.125 0-.249 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M142.839 368.886h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.59 369.019v-2.525h.374v2.392c-.125.133-.249.133-.374.133zm.125-2.392v2.126h.124l-.124-2.126c.124.133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M141.716 365.03c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 368.22c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595.124.797-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M143.837 367.822c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM141.965 368.087h-.499l-2.37-2.525c.124 0 .249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M142.839 367.955h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM141.217 368.088h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.125.132.249.132.499.265z"
            fill="#fff"
            />
            <path
            d="M146.706 369.417c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.249 0 .623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 372.074c-1.871 0-3.119-.797-3.243-1.462V369.549h2.12a7.095 7.095 0 012.371 0h2.12v.93c-.249.798-1.497 1.595-3.368 1.595zm-3.243-1.728c0 .665 1.372 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.576 371.013s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 371.412v-1.861h.374v1.595c-.124 0-.124.133-.374.266zm.25-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.708 369.552v2.392h-.249v-2.259c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M145.708 371.944h-.249v-2.392h.374v2.392h-.125zm-.124-.133l.124-2.126h-.124v2.126z"
            fill="#131A2D"
            />
            <path d="M146.083 371.943h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M146.083 371.943h-.249v-2.525h.374v2.525h-.125zm-.124-.132l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.335 371.413c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.335 371.546c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.332 371.943h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.457 371.943h-.25v-2.525h.374v2.525h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M143.962 371.146c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 371.279c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M144.96 371.678c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.085 371.81c-.124 0-.249-.132-.249-.132v-2.127h.374v2.259h-.125zm-.249-.265s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.333 371.811h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.458 371.944c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M144.585 371.546c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.71 371.678c-.124 0-.249-.132-.249-.132v-1.994h.374v2.126h-.125zm-.249-.265c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 371.678h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M148.203 371.811v-2.259h.374v2.259h-.374zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M147.082 371.943h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M146.832 371.943v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.707 369.418v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.707 372.076h-.25v-2.658h.374v2.658h-.124zm-.125-.265l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M149.951 370.482c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 371.147v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.588 370.88c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.712 371.013l-.124-.133c-.125-.133-.125-.266-.125-.399V369.418h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.201 371.28c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.951 371.546v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.455 371.942h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.205 371.942v-2.525h.374v2.525h-.374zm.125-2.392v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M148.828 371.545c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 371.678v-2.26h.374v2.127c-.124 0-.249.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.08 371.811h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M147.83 371.944v-2.392h.374v2.259c-.124 0-.249 0-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M147.83 371.81h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 371.943v-2.525h.374v2.393c-.124.132-.124.132-.374.132zm.25-2.392v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.706 367.955c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 371.145c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M148.827 370.613c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM146.955 371.012h-.499l-2.37-2.526c.125-.132.249-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.704 370.88h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.132h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.132zM146.082 371.012h.998-.998c-.125 0-.374 0-.499-.133s-.25-.133-.499-.133h.499c.125.133.374.133.499.266z"
            fill="#fff"
            />
            <path
            d="M151.572 372.343c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.249 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 374.868c-1.872 0-3.119-.797-3.244-1.462V372.343h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c-.125.931-1.372 1.595-3.243 1.595zm-3.244-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.664h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.664z"
            fill="#131A2D"
            />
            <path
            d="M154.441 373.938s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 374.336v-1.86h.375v1.595c-.125 0-.25.133-.375.265zm.125-1.727v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.574 372.476v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.699 374.868h-.25v-2.392h.374v2.392h-.124zm-.25-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M150.949 374.868h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M150.949 374.868h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.203 374.336c-.125 0-.125-.132-.25-.132v-1.728h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M149.203 374.47c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.324 374.868h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.324 374.868h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M148.828 374.071c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M148.952 374.204c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M149.826 374.602c-.125 0-.125 0-.25-.132v-2.127h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M149.951 374.735c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.25-.266c.125 0 .125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.199 374.736h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.324 374.735c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.25-.133s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M149.576 374.469c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 374.602c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.125-.266l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M153.443 374.602h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.068 374.735v-2.259h.375v2.259c-.125-.132-.125 0-.375 0zm.125-2.126v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M151.947 374.868h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.697 374.868v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.392v2.392h.125l-.125-2.392c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.697 372.343v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 374.868h-.25v-2.658h.375v2.658h-.125zm-.125-.133c.125 0 .125 0 0 0l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M154.816 373.273c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 374.071v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.453 373.805c-.125-.133-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 373.938l-.125-.133c-.125-.133-.125-.266-.125-.399V372.343h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.068 374.204c-.125 0-.125.132-.25.132v-1.86h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 374.47v-1.994h.375v1.861c-.125 0-.25 0-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.32 374.868h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.07 374.868v-2.525h.375v2.525h-.375zm.125-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 374.47c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 374.602v-2.259h.375v2.127c-.125 0-.25.132-.375.132zm.125-1.993v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.07 374.735h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M152.82 374.868v-2.392h.375v2.259c-.25 0-.25.001-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M152.695 374.735h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.445 374.868v-2.525h.375v2.392c-.25.133-.25.133-.375.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M151.572 370.88c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 374.07c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.996 0 3.243.798 3.243 1.595 0 .665-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.798-3.119 1.462 0 .665 1.247 1.463 3.119 1.463 1.871 0 3.118-.798 3.118-1.463 0-.664-1.372-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.692 373.538c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM151.822 373.937h-.499l-2.37-2.526c.125 0 .25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.57 373.803h.124c.125 0 .25 0 .375-.133.124 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.132s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM150.947 373.804h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.437 375.266c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 377.791c-1.871 0-3.119-.797-3.244-1.462V375.266h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.931-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.996a7.095 7.095 0 00-2.371 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M159.306 376.86s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.057 377.127v-1.861h.374v1.595c-.125.133-.25.266-.374.266zm.124-1.596v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M155.439 375.399v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.564 377.791h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M155.812 377.791h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M155.937 377.791h-.249v-2.525h.374v2.525h-.125zm-.249-.133l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.066 377.26c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 377.392c-.125-.133-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.25-.265l.125-1.596h-.125v1.596z"
            fill="#131A2D"
            />
            <path d="M156.187 377.791h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.187 377.791h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 376.993c-.125 0-.125-.132-.25-.132v-1.463h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 377.127c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.25-.266s.125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M154.816 377.525c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 377.658c-.125 0-.25-.133-.25-.133v-2.259h.375v2.392h-.125zm-.125-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.189 377.659h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.189 377.658c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.441 377.392c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 377.525c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.125-.266l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M158.308 377.525h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.059 377.658v-2.392h.374v2.26c-.25 0-.25.132-.374.132zm.124-2.126v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M156.937 377.791h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.562 377.791v-2.658h.375v2.526c-.125.132-.25.132-.375.132zm.125-2.392v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.562 375.266v2.525h-.249v-2.525h.249s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 377.791h-.249v-2.658h.374v2.658h-.125c.125 0 0 0 0 0zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M159.681 376.196c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.432 376.861v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.329v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.443 376.729c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 376.861l-.125-.133c-.125-.133-.125-.266-.125-.399V375.266h.25v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M158.931 377.127c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 377.393v-2.127h.374v1.861c-.125.133-.125.133-.374.266zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.185 377.658h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.936 377.791v-2.525h.374v2.525h-.374zm.124-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.683 377.393c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.309 377.525v-2.259h.374v2.126c-.125 0-.125.133-.374.133zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M157.933 377.525h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.684 377.658v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.127v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.56 377.658h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.311 377.791v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M156.437 373.804c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 376.994c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.558 376.462c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.686 376.861h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.435 376.727h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM155.939 376.728h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M141.716 365.163c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.375-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 367.689c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.124.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.373 1.462 3.119 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M144.585 366.759s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.336 367.024v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M140.843 365.163v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M140.843 367.556h-.249v-2.393h.374v2.393h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M141.091 367.556h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.216 367.689h-.249v-2.526h.374v2.526h-.125zm-.249-.266c0 .133.125.133 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.345 367.025c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M139.47 367.157c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266s.124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M141.466 367.557h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.591 367.689h-.249v-2.526h.374v2.526h-.125zm-.249-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.097 366.891c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M139.097 367.024c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.399c.125 0 .125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M140.093 367.423c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M140.093 367.423c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M140.468 367.423h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M140.468 367.556c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.266c0 .133 0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M139.72 367.29c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M139.845 367.29c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.133l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M143.587 367.291h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M143.338 367.423v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M142.214 367.555h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M141.965 367.688v-2.659h.374v2.526c-.249.133-.249.133-.374.133zm.125-2.526v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M141.841 365.162v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M141.716 367.688h-.249v-2.659h.374v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M144.958 366.094c0 .133-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M144.709 366.758v-1.595h.374v.931c0 .133-.125.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M138.722 366.492c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M138.722 366.758l-.125-.133c-.124-.133-.124-.266-.124-.399V365.163h.249v1.595zm-.125-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M144.335 367.024c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M143.961 367.157v-1.994h.374v1.861c-.125 0-.125.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M142.589 367.556h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.215 367.689v-2.526h.374v2.526h-.374zm.125-2.526v2.26h.124l-.124-2.26c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M143.96 367.157c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M143.711 367.423v-2.26h.374v2.127c-.249 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M143.212 367.424h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M142.963 367.556v-2.393h.374v2.26c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M142.837 367.555h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.588 367.555v-2.526h.374v2.393c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M141.716 363.568c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 366.757c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.057c-1.871 0-3.119.798-3.119 1.462 0 .665 1.373 1.463 3.119 1.463 1.747 0 3.119-.798 3.119-1.463.125-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M143.837 366.359c-.25.133-.499.133-.749.265l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM141.965 366.758h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M142.839 366.626h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.132h-.748c.125 0 .249.001.374-.132v-.133zM141.217 366.625h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.706 368.089c.375 0 .749 0 1.123.133h2.121v.797c0 .798-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 370.613c-1.871 0-3.119-.797-3.243-1.462V368.088h2.12a7.095 7.095 0 012.371 0h2.12v.93c-.249.798-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .665 1.372 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.576 369.683s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 369.949v-1.861h.374v1.595c-.124.133-.124.133-.374.266zm.25-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.708 368.088v2.393h-.249v-2.26c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M145.708 370.481h-.249v-2.393h.374v2.393h-.125zm-.124-.133l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M146.082 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.082 370.613h-.25v-2.525h.374v2.525h-.124zm-.125-.265l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.335 369.949c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.335 370.082c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.332 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.457 370.613h-.25v-2.525h.374v2.525h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M143.962 369.816c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 369.949c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.125-.399l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M144.96 370.348c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.085 370.348c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.333 370.348h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.458 370.481c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266s0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.585 370.215c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.71 370.215c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 370.215h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.203 370.348v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.082 370.481h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M146.832 370.613v-2.658h.374v2.526c-.124.132-.249.132-.374.132zm.125-2.525v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.707 368.088v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.707 370.614h-.25v-2.659h.374v2.659h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M149.951 369.018c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 369.683v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.588 369.417c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.712 369.683l-.124-.133c-.125-.133-.125-.266-.125-.399V368.088h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.201 369.949c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.951 370.082v-1.994h.374v1.861c-.124 0-.249.133-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.455 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.205 370.613v-2.525h.374v2.525h-.374zm.125-2.525v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M148.828 370.082c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 370.215v-2.26h.374v2.127c-.124.133-.249.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.078 370.348h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M147.828 370.48v-2.392h.374v2.26c-.124.132-.249.132-.374.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M147.83 370.48h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 370.481v-2.526h.374v2.393c-.124.133-.124.133-.374.133zm.25-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.706 366.493c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 369.684c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.931 3.244 1.595 0 .798-1.372 1.596-3.244 1.596zm0-3.058c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463 0-.664-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M148.827 369.284c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM146.955 369.683h-.499l-2.37-2.526c.125-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.704 369.55h.125c.125 0 .25 0 .374-.132.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.132h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM146.082 369.55h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.572 371.012c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.463-3.243 1.463-1.872 0-3.244-.798-3.244-1.463v-.797h2.121c.249-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 373.538c-1.872 0-3.119-.798-3.244-1.463V371.012h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.25.798-1.497 1.596-3.368 1.596zm-3.244-1.596c0 .665 1.372 1.463 3.119 1.463 1.746 0 3.119-.798 3.119-1.463v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.441 372.607s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 372.873v-1.861h.375v1.595c-.125 0-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.574 371.012v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.699 373.404h-.25v-2.392h.374v2.392h-.124zm-.25-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M150.947 373.405h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M150.947 373.537h-.25v-2.525h.375v2.525h-.125zm-.125-.266l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.201 372.873c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 373.006c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.322 373.404h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.322 373.537h-.25v-2.525h.375v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M148.828 372.74c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M148.952 372.873c-.124-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M149.826 373.139c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M149.951 373.271c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M150.199 373.271h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.324 373.404c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.25-.266s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M149.576 373.138c-.125 0-.125 0-.25-.133v-1.86h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 373.138c-.125 0-.25-.132-.25-.132v-1.994h.374v2.126h-.124zm-.125-.265c0 .133 0 .133 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.443 373.138h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.068 373.271v-2.259h.375v2.259h-.375zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M151.947 373.404h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.697 373.537v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.697 371.011v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 373.537h-.25v-2.658h.375v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M154.816 371.942c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 372.607v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.453 372.341c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 372.607l-.125-.133c-.125-.133-.125-.266-.125-.399V371.012h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.066 372.873c-.125 0-.125.132-.25.132v-1.86h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M153.816 373.006v-1.994h.375v1.861c-.125 0-.25.133-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.32 373.404h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.07 373.537v-2.525h.375v2.525c-.125-.133-.25-.133-.375 0zm.125-2.525v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 373.005c-.125 0-.125 0-.25.133v-1.993h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 373.138v-2.259h.375v2.126c-.125.133-.25.133-.375.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.07 373.271h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M152.82 373.404v-2.392h.375v2.259c-.25 0-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M152.695 373.271h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.445 373.404v-2.525h.375v2.392c-.25.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.572 369.416c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 372.605c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.996 0 3.243.798 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.798-3.119 1.462 0 .665 1.372 1.462 3.119 1.462 1.746 0 3.118-.797 3.118-1.462 0-.664-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.692 372.208c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM151.822 372.607h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.57 372.474h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.623-.399-.124.266-.249.399-.499.531l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM150.947 372.474h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.133.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.437 373.805c.374 0 .748 0 1.123.133h2.12v.797c0 .798-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 376.462c-1.871 0-3.119-.797-3.244-1.462V373.937h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.728c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.996a7.095 7.095 0 00-2.371 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M159.306 375.532s-.125.132-.249.132v-1.727h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.057 375.797v-1.86h.374v1.595c-.125 0-.25.132-.374.265zm.124-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path d="M155.439 373.937v2.392h-.25v-2.392h.25z" fill="#0EA59D" />
            <path
            d="M155.564 376.329h-.25v-2.392h.375v2.392h-.125zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M155.814 376.329h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M155.939 376.329h-.25v-2.526h.375v2.526h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.066 375.797c-.125 0-.125-.133-.25-.133v-1.727h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 375.93c-.125-.133-.25-.133-.25-.133v-1.86h.375v1.993h-.125zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.187 376.329h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.187 376.462h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M153.693 375.664c-.125 0-.125-.132-.25-.132v-1.595h.25v1.727z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 375.797c-.125-.133-.25-.265-.375-.265v-1.595h.375v1.86zm-.25-.398s.125 0 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M154.816 376.063c-.125 0-.125 0-.25-.133v-1.993h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 376.196c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.125-.266c0 .133 0 .133 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.189 376.196h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M155.189 376.329c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.441 375.93c-.125 0-.125 0-.25-.133v-1.86h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 376.063c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.125-.266c0 .133 0 .133 0 0l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M158.308 376.063h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.059 376.196v-2.259h.374v2.259h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M156.937 376.329h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.562 376.462v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.562 373.804v2.525h-.249v-2.525h.249s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 376.462h-.249v-2.658h.374v2.658h-.125c.125 0 0 0 0 0zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.681 374.867c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.432 375.532v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.443 375.266c-.125-.133-.125-.266-.125-.399v-.93h.125v1.329z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 375.399l-.125-.133c-.125-.133-.125-.266-.125-.399v-.93h.25v1.462zm-.125-.665V375v-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M158.933 375.797c-.125 0-.125.133-.249.133v-1.993h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M158.684 375.93v-1.993h.374v1.86c-.125 0-.125.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.185 376.329h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.936 376.462v-2.525h.374v2.525c-.125-.133-.25-.133-.374 0zm.124-2.525v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.683 375.93c-.125 0-.125 0-.249.133v-2.126h.249v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M158.309 376.063v-2.126h.374v2.126h-.374zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M157.935 376.196h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.686 376.329v-2.392h.374v2.259c-.125 0-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.56 376.196h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.311 376.329v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M156.437 372.342c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 375.532c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.93 3.243 1.595.125.797-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462.124-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.558 375.133c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.688 375.531h-.499l-2.371-2.525c.125-.133.25-.133.375-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.435 375.399h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM155.937 375.4h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.133.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M141.716 363.702c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.375-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 366.228c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.124.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.373 1.462 3.119 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M144.585 365.296s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.336 365.562v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M140.843 363.834v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M140.843 366.227h-.249v-2.393h.374v2.393h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M141.091 366.094h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.216 366.227h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.345 365.695c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M139.47 365.828c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.399c0 .133.124.133 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M141.466 366.228h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.591 366.226h-.249v-2.525h.374v2.525h-.125zm-.249-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.097 365.43c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M139.097 365.562c-.125-.133-.25-.133-.374-.266v-1.595h.374v1.861zm-.25-.399c.125.133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M140.093 365.961c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M140.093 366.094c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M140.468 366.095h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M140.468 366.094c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M139.72 365.828c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M139.845 365.961c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M143.587 365.828h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M143.338 366.094v-2.26h.374v2.26c-.125-.133-.249-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M142.214 366.227h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M141.965 366.227v-2.659h.374v2.526c-.249.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M141.841 363.701v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M141.716 366.227h-.249v-2.659h.374v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M144.958 364.632c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M144.709 365.296v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.266l-.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M138.722 365.032c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M138.722 365.296l-.125-.132c-.124-.133-.124-.266-.124-.399v-1.064h.249v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M144.335 365.562c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M143.961 365.828v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M142.589 366.094h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.215 366.227v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M143.96 365.696c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M143.711 365.961v-2.26h.374v2.127c-.249 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M143.212 365.961h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M142.963 366.094v-2.393h.374v2.26c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M142.837 366.094h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.588 366.227v-2.526h.374v2.393c-.125 0-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M141.716 362.106c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 365.429c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.931 3.244 1.595.124.665-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.798-3.119 1.462 0 .665 1.248 1.463 3.119 1.463 1.871 0 3.119-.798 3.119-1.463 0-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M143.837 364.899c-.25.133-.499.133-.749.265l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM141.965 365.297h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M142.839 365.164h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM141.217 365.164h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.706 366.625c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.463-3.244 1.463-1.871 0-3.243-.798-3.243-1.463v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 369.151c-1.871 0-3.119-.798-3.243-1.463V366.625h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.249.797-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.576 368.221s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 368.487v-1.861h.374v1.595c-.124.133-.124.133-.374.266zm.25-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.708 366.625v2.393h-.249v-2.26c.125 0 .125 0 .249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M145.708 369.15h-.249v-2.392h.374v2.392h-.125zm-.124-.265l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M146.083 369.019h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M146.083 369.151h-.249v-2.525h.374v2.525h-.125zm-.124-.133l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M144.335 368.62c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.335 368.62c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266c0 .133 0 .133 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.332 369.151h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.457 369.152h-.25v-2.526h.374v2.526h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M143.962 368.354c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 368.487c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.125-.399c0 .133 0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M144.96 368.886c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.085 368.885c-.124 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.133s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M145.333 369.018h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M145.458 369.019c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.585 368.752c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.71 368.885c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 368.753h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.203 369.018v-2.259h.374v2.259c-.124-.132-.249-.132-.374 0zm.125-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.082 369.018h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M146.832 369.151v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.707 366.625v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.707 369.151h-.25v-2.659h.374v2.659h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M149.951 367.556c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 368.221v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.588 367.955c-.125-.133-.125-.266-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.712 368.221l-.124-.133c-.125-.133-.125-.265-.125-.398v-1.064h.249v1.595zm-.249-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M149.201 368.486c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.951 368.752v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.455 369.018h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.205 369.151v-2.525h.374v2.525h-.374zm.125-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M148.828 368.62c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 368.886v-2.26h.374v1.994c-.124.133-.249.133-.374.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.08 368.886h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M147.83 369.019v-2.393h.374v2.26c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M147.83 369.018h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 369.151v-2.525h.374v2.392c-.124 0-.124.133-.374.133zm.25-2.392v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path
            d="M146.706 365.029c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 368.352c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M148.827 367.822c-.249.132-.499.132-.748.265l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM146.955 368.22h-.499l-2.37-2.526c.125-.132.249-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.704 368.087h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.132h-.749c.125 0 .25 0 .374-.132v-.133zM146.082 368.087h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.572 369.55c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.249-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 372.075c-1.872 0-3.119-.797-3.244-1.462V369.55h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c-.125.798-1.372 1.595-3.243 1.595zm-3.244-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.441 371.146s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 371.412v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.574 369.551v2.392h-.25v-2.259c.125 0 .25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.699 372.076h-.25v-2.392h.374v2.392h-.124zm-.25-.266l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M150.947 371.943h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M150.947 372.076h-.25v-2.525h.375v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.203 371.544c-.125 0-.125-.132-.25-.132v-1.728h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M149.203 371.545c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.125-.266s0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.324 371.943h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.324 372.076h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M148.828 371.278c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M148.952 371.412c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M149.826 371.81c-.125 0-.125 0-.25-.132v-2.127h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M149.951 371.81c-.125 0-.25-.132-.25-.132v-2.127h.374v2.259h-.124zm-.25-.132c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.199 371.81h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.324 371.943c-.125 0-.25 0-.25-.133v-2.259h.374v2.392h-.124zm-.25-.133s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M149.576 371.677c-.125 0-.125 0-.25-.133v-1.86h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 371.81c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.125-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.443 371.678h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.068 371.943v-2.259h.375v2.259c-.125-.133-.125-.133-.375 0zm.125-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M151.947 371.942h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.697 372.075v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.697 369.55v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 372.075h-.25v-2.658h.375v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M154.816 370.481c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 371.146v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.453 370.88c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 371.146l-.125-.133c-.125-.133-.125-.266-.125-.399V369.551h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.066 371.412c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M153.816 371.677v-1.993h.375v1.86c-.125 0-.25 0-.375.133zm.125-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.32 371.943h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.07 372.076v-2.525h.375v2.525h-.375zm.125-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 371.544c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 371.81v-2.259h.375v2.127c-.125 0-.25 0-.375.132zm.125-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.07 371.81h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M152.82 371.943v-2.392h.375v2.259c-.25.133-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M152.695 371.943h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.445 372.076v-2.525h.375v2.392c-.25 0-.25 0-.375.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M151.572 367.955c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 371.145c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.996 0 3.243.931 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.798-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462 0-.664-1.372-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.692 370.746c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM151.82 371.145h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.57 371.012h.124c.125 0 .25 0 .375-.133.124 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.132s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM150.947 371.012h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.437 372.474c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 374.999c-1.871 0-3.119-.797-3.244-1.462V372.474h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.996a7.095 7.095 0 00-2.371 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M159.306 374.07s-.125.133-.249.133v-1.595h.249v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M159.057 374.336v-1.861h.374v1.595c-.125.133-.25.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.439 372.475v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.564 374.867h-.25v-2.393h.375v2.393h-.125zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M155.814 374.867h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M155.939 375h-.25v-2.525h.375V375h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.066 374.336c-.125 0-.125-.133-.25-.133v-1.595h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 374.468c-.125-.133-.25-.133-.25-.133v-1.86h.375v1.993h-.125zm-.25-.265s0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.187 374.867h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.187 375h-.249v-2.525h.374V375h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 374.202c-.125 0-.125-.132-.25-.132v-1.463h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 374.335c-.125-.132-.25-.265-.375-.265v-1.595h.375v1.86zm-.25-.398s.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M154.816 374.734c-.125 0-.125 0-.25-.133v-1.993h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 374.735c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.189 374.734h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M155.189 374.867c-.125 0-.25 0-.25-.132v-2.26h.375v2.392h-.125zm-.25-.132c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.441 374.601c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 374.601c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.125-.133l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M158.308 374.601h-.249v-1.994h.249v1.994z" fill="#0EA59D" />
            <path
            d="M158.059 374.734v-2.259h.374v2.259h-.374zm.124-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M156.937 374.868h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M156.562 375v-2.658h.375v2.526c-.125.132-.25.132-.375.132zm.125-2.525v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.562 372.475V375h-.249v-2.525h.249s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 375h-.249v-2.658h.374V375h-.125c.125 0 0 0 0 0zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M159.679 373.405c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.43 374.07v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.443 373.804c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 374.07l-.125-.133c-.125-.133-.125-.266-.125-.399V372.475h.25v1.595zm-.125-.665v.266-1.063.797z"
            fill="#131A2D"
            />
            <path
            d="M158.931 374.337c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 374.601v-1.993h.374v1.861c-.125 0-.125 0-.374.132zm.124-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.185 374.867h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.936 375v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.683 374.468c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.309 374.734v-2.259h.374v2.126c-.125 0-.125 0-.374.133zm.124-2.126v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M157.935 374.734h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M157.686 374.867v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M157.56 374.867h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.311 375v-2.525h.374v2.392c-.125 0-.25 0-.374.133zm.124-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M156.437 370.88c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 374.07c-1.996 0-3.244-.93-3.244-1.595 0-.797 1.373-1.595 3.244-1.595 1.871 0 3.243.798 3.243 1.595.125.798-1.247 1.595-3.243 1.595zm0-3.057c-1.871 0-3.119.798-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462.124-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.558 373.671c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.686 374.07h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.435 373.938h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM155.939 373.937h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M157.31 352.138c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 354.663c-1.871 0-3.119-.797-3.244-1.462V352.138h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c-.124.93-1.497 1.595-3.243 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.798h-1.996c-.749-.132-1.622-.132-2.246 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M160.179 353.734s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.805 354v-1.861h.374v1.595c-.125.133-.125.266-.374.266zm.249-1.595v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.312 352.271v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.312 354.664h-.25v-2.393h.375v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.685 354.664h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.685 354.664h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.939 354.132c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.939 354.265c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.935 354.664h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.06 354.664h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.566 353.867c-.125 0-.125-.133-.25-.133v-1.463h.25v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 354c-.125-.133-.25-.133-.375-.266v-1.595h.375V354zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.564 354.398c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.689 354.531c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.266s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.937 354.531h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M156.062 354.531c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M155.189 354.265c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.314 354.398c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M159.056 354.398h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.807 354.531v-2.26h.374v2.26c-.125-.133-.25 0-.374 0zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.685 354.663h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.436 354.663v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M157.31 352.138v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M157.31 354.663h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.554 353.069c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M160.18 353.734v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.329v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M154.191 353.601c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 353.734l-.125-.133c-.125-.133-.125-.266-.125-.399V352.139h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.804 353.999c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 354.265v-1.994h.374v1.861c-.125 0-.25 0-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M158.058 354.531h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 354.664v-2.526h.374v2.393c-.25.133-.25.133-.374.133zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 354.265c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.182 354.398v-2.259h.374v2.126c-.125 0-.25.133-.374.133zm.124-1.993v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M158.683 354.398h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.434 354.664v-2.393h.374v2.26c-.125 0-.25 0-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.433 354.531h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M158.059 354.664v-2.526h.374v2.393c-.125.133-.125.133-.374.133zm.249-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M157.31 350.676c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.248-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 353.866c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.996 0 3.368.797 3.368 1.595 0 .797-1.497 1.595-3.368 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.665-1.373-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.431 353.334c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM157.559 353.733h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.308 353.6h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.686 353.601h.997-.997c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M162.175 355.061c.374 0 .749 0 1.123.133h2.121v.798c0 .797-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 357.587c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.931c-.125.797-1.373 1.595-3.244 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M165.044 356.657s-.124.132-.249.132v-1.727h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 356.922v-1.86h.374v1.595c-.125.132-.249.132-.374.265zm.125-1.728v1.463h.124l-.124-1.463z"
            fill="#131A2D"
            />
            <path
            d="M161.177 355.195v2.392h-.249v-2.259c.124-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.302 357.587h-.249v-2.392h.374v2.392h-.125zm-.249-.133l.124-2.126h-.124v2.126z"
            fill="#131A2D"
            />
            <path d="M161.55 357.587h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.55 357.587h-.249v-2.525h.374v2.525h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.804 357.055c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.804 357.188c-.125-.133-.249-.133-.249-.133v-1.86h.374v1.993h-.125zm-.125-.265l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.925 357.587h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.925 357.587h-.249v-2.525h.374v2.525h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 356.79c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 356.922c-.125-.133-.25-.265-.374-.265v-1.595h.374v1.86zm-.25-.265l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M160.429 357.321c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.554 357.454c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.802 357.454h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.927 357.454c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.133s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M160.179 357.188c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M160.179 357.321c-.125 0-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.125-.266l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M163.921 357.321h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M163.672 357.454v-2.259h.374v2.259c-.125-.133-.125-.133-.374 0zm.125-2.259v1.993h.124l-.124-1.993z"
            fill="#131A2D"
            />
            <path d="M162.548 357.586h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M162.299 357.586v-2.658h.374v2.525c-.125.133-.249.133-.374.133zm.125-2.392v2.392h.124l-.124-2.392c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path d="M162.175 355.061v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M162.175 357.586h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.417 355.992c0 .133-.124.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M165.168 356.657v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.463v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M159.056 356.523c-.124-.132-.124-.265-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 356.657l-.125-.133c-.124-.133-.124-.266-.124-.399V355.062h.249v1.595zm-.249-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.669 356.922c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.42 357.188v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.923 357.454h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.674 357.587v-2.525h.374v2.525h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 357.188c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.047 357.321v-2.259h.374v2.126c-.125 0-.249.133-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 357.321h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M163.422 357.454v-2.392h.374v2.259c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.298 357.454h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M163.049 357.587v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M162.175 353.6c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 356.791c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.296 356.258c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.424 356.656h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M163.173 356.524h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.551 356.524h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M167.04 357.985c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 360.511c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.125.797-1.497 1.595-3.369 1.595zm-3.118-1.595c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M169.91 359.583s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 359.848v-1.86h.374v1.595c-.124.133-.249.133-.374.265zm.125-1.728v1.463h.125l-.125-1.463z"
            fill="#131A2D"
            />
            <path
            d="M166.042 358.12v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.167 360.513h-.249v-2.525h.374v2.525h-.125zm-.249-.266s.125.133 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.417 360.38h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M166.542 360.513h-.249v-2.525h.374v2.525h-.125zm-.249-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M164.671 359.981c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.796 360.115c-.124-.133-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.791 360.513h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M166.791 360.513h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 359.715c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.421 359.848c-.125-.132-.249-.265-.374-.265v-1.595h.374v1.86zm-.249-.265s.124 0 0 0l.124-1.33h-.124v1.33z"
            fill="#131A2D"
            />
            <path
            d="M165.419 360.247c-.124 0-.124 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M165.419 360.38c-.124 0-.249-.133-.249-.133v-2.259h.374v2.392h-.125zm-.124-.265l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M165.792 360.38h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.792 360.38c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M165.044 360.114c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M165.044 360.247c-.124 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.912 360.247h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.662 360.38v-2.392h.374v2.259c-.249 0-.249 0-.374.133zm.125-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.541 360.513h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M167.166 360.513v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.392v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.166 357.988v2.525h-.25v-2.525h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M167.041 360.513h-.25v-2.658h.374v2.658h-.124c.124 0 0 0 0 0zm0-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M170.285 358.918c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 359.583v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M164.047 359.317c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M164.046 359.583l-.124-.133c-.125-.133-.125-.266-.125-.399V357.988h.249v1.595zm-.124-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.535 359.848c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.285 360.114v-2.126h.374v1.86c-.124.133-.124.133-.374.266zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.789 360.38h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M167.539 360.513v-2.525h.374v2.525h-.374zm.125-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.287 359.981c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 360.247v-2.259h.374v1.993c-.124.133-.124.133-.374.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.537 360.247h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M168.287 360.38v-2.392h.374v2.259c-.124.133-.249.133-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M168.164 360.38h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M167.914 360.513v-2.525h.374v2.392c-.124.133-.249.133-.374.133zm.125-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M167.04 356.524c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 359.715c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.596-3.244 1.596zm0-3.191c-1.871 0-3.118.798-3.118 1.463 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462.125-.665-1.247-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M169.161 359.183c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.291 359.581h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M168.038 359.449h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.541 359.448h.998-.998c-.125 0-.374 0-.499-.132-.125 0-.25-.133-.499-.133h.499c.125.265.249.265.499.265z"
            fill="#fff"
            />
            <path
            d="M171.906 360.91c.374 0 .748 0 1.122.133h2.121v.798c0 .664-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.906 363.435c-1.872 0-3.119-.798-3.244-1.462V360.91h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462v-.798h-1.871a7.142 7.142 0 00-2.37 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M174.775 362.505s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M174.525 362.77v-1.861h.375v1.595c-.125.133-.125.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.033 361.042v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.033 363.435h-.25v-2.393h.374v2.393h-.124zm-.25-.266c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M171.283 363.302h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.408 363.435h-.25v-2.526h.374v2.526h-.124zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.537 362.903c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.662 363.036c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.399c0 .133.125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M171.656 363.436h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.781 363.435h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.287 362.638c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.286 362.77c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399c.125.133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M170.285 363.169c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M170.41 363.302c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.25-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M170.658 363.302h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M170.658 363.302c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M169.91 363.036c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 363.169c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M173.777 363.036h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M173.527 363.302v-2.26h.375v2.26c-.125-.133-.25-.133-.375 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M172.404 363.435h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M172.154 363.435v-2.659h.375v2.526c-.25.133-.25.133-.375.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M172.031 360.909v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M171.906 363.435h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M175.15 361.84c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M174.9 362.504v-1.595h.375v.931c0 .133-.125.265-.25.531l-.125.133zm.125-1.462v1.063c0-.132.125-.132.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M168.912 362.239c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 362.504l-.125-.133c-.125-.133-.125-.266-.125-.398v-1.064h.25v1.595zm-.125-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M174.527 362.77c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M174.152 363.036v-1.994h.375v1.861c-.125 0-.125 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M172.779 363.302h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.404 363.435v-2.526h.375v2.526h-.375zm.125-2.393v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M174.152 362.904c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M173.902 363.169v-2.26h.375v2.127c-.25 0-.25 0-.375.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M173.404 363.169h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M173.154 363.302v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M173.029 363.303h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.779 363.435v-2.526h.375v2.393c-.125 0-.25.133-.375.133zm.125-2.393v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M171.906 359.314c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.596-3.243 1.596-1.872 0-3.244-.798-3.244-1.596 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M171.905 362.637c-1.996 0-3.368-.797-3.368-1.595 0-.797 1.372-1.595 3.368-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463.125-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M174.026 362.106c-.249.133-.499.133-.748.266l-2.62-2.792c.25 0 .499-.133.749-.133l2.619 2.659zM172.279 362.504h-.499l-2.37-2.525c.125-.133.25-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M173.029 362.372h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM171.406 362.372h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M152.07 355.461c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 358.12c-1.872 0-3.119-.797-3.244-1.462V355.595h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.728c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M154.939 357.19s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 357.456v-1.861h.375v1.595c-.125 0-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M151.072 355.594v2.393h-.25v-2.26c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.197 357.987h-.25v-2.392h.375v2.392h-.125zm-.25-.133s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M151.445 357.988h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.57 357.988h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.699 357.455c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.824 357.589c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.82 357.987h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.945 358.12h-.25v-2.525h.375v2.525h-.125zm-.25-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.326 357.323c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.45 357.456c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s.125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.449 357.722c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M150.449 357.855c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.125-.265c0 .132 0 .132 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.822 357.854h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.822 357.987c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M150.074 357.588c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 357.721c-.125 0-.25-.132-.25-.132v-1.994h.374v2.126h-.124zm-.25-.265c0 .133 0 .133 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.941 357.721h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.691 357.854v-2.259h.375v2.259h-.375zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M152.57 357.988h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M152.195 358.121v-2.659h.375v2.526c-.125.133-.125.133-.375.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.195 355.462v2.525h-.25v-2.525c.125.133.125 0 .25 0 0 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 358.121h-.125v-2.659h.375v2.659h-.25zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.312 356.525c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M155.062 357.19v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M149.076 356.925c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M149.076 357.058l-.125-.133c-.125-.133-.125-.266-.125-.399V355.463h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.564 357.456c-.125 0-.125.132-.25.132v-1.86h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.314 357.589v-1.994h.375v1.861c-.125 0-.125.133-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.818 357.987h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.568 358.12v-2.525h.375v2.525c-.125-.132-.25-.132-.375 0zm.125-2.525v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M154.316 357.589c-.125 0-.125 0-.25.133v-1.993h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 357.723v-2.26h.375v1.994c-.125.266-.125.266-.375.266zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.566 357.854h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.316 357.987v-2.392h.375v2.259c-.125 0-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M153.193 357.854h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.943 357.988v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M152.07 353.998c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 357.188c-1.996 0-3.244-.93-3.244-1.595 0-.665 1.372-1.595 3.244-1.595 1.996 0 3.368.798 3.368 1.595 0 .798-1.372 1.595-3.368 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.797-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M154.191 356.79c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM152.318 357.189h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M153.068 357.055h.124c.125 0 .25 0 .375-.133.124 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.132s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.57 357.056h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125 0 .25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.935 358.384c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.463-3.243 1.463-1.871 0-3.244-.798-3.244-1.463v-.797h2.121c.374 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 361.042c-1.871 0-3.119-.797-3.244-1.462V358.517h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.728c0 .665 1.372 1.463 3.119 1.463 1.746 0 3.119-.798 3.119-1.463v-.797h-1.872a7.089 7.089 0 00-2.37 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.804 359.979s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 360.378v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.062 358.517v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.062 360.909h-.25v-2.392h.375v2.392h-.125zm-.125-.132l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.312 360.91h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.437 360.91h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.564 360.378c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 360.511c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.685 360.909h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.81 361.042h-.249v-2.525h.374v2.525h-.125zm-.249-.266s.124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 360.112c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 360.245c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.314 360.644c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.439 360.777c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.25-.266s0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.687 360.776h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M155.687 360.909c-.125 0-.249 0-.249-.132v-2.26h.374v2.392h-.125zm-.125-.265l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.939 360.511c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 360.643c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.25-.265s.125.132 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.806 360.644h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.557 360.776v-2.259h.374v2.259h-.374zm.124-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.433 360.91h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M157.184 361.042v-2.658h.374v2.526c-.25.132-.25.132-.374.132zm.124-2.525v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M157.06 358.384v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M156.935 361.042h-.249v-2.658h.374v2.658h-.125zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M160.179 359.447c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.93 360.112v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.941 359.847c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 359.979l-.125-.133c-.125-.133-.125-.266-.125-.399V358.384h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.554 360.245c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 360.511v-1.994h.374v1.861c-.25 0-.25.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.808 360.91h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.559 360.91v-2.526h.374v2.526h-.374zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 360.512c-.125 0-.125 0-.249.132v-1.993h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 360.644v-2.26h.374v2.127c-.125.133-.25.133-.374.133zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.433 360.777h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M158.184 360.909v-2.392h.374v2.26c-.125 0-.25 0-.374.132zm.124-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.058 360.777h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.809 360.91v-2.526h.374v2.393c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.935 356.922c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 360.112c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462.124-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.056 359.714c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .498-.133.748-.133l2.62 2.658zM157.311 359.979h-.499l-2.371-2.526c.125 0 .25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.058 359.846h.125c.124 0 .249 0 .374-.133.125 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.132s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.435 359.98h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.498-.133h.498c.125 0 .375.133.499.266z"
            fill="#fff"
            />
            <path
            d="M161.925 361.31c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 363.97c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.931c-.125.797-1.373 1.595-3.244 1.595zm-3.243-1.728c0 .664 1.372 1.462 3.118 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M164.794 362.905s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 363.304v-1.861h.374v1.595c-.125 0-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.927 361.443v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.927 363.836h-.249v-2.393h.374v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.3 363.836h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.3 363.836h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.554 363.304c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.554 363.437c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.675 363.836h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.675 363.969h-.249v-2.526h.374v2.526h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 363.038c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 363.171c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.179 363.57c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.304 363.703c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.552 363.703h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.677 363.836c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.929 363.437c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.929 363.57c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 363.57h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.422 363.703v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.3 363.836h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.051 363.969v-2.659h.374v2.526c-.125 0-.249 0-.374.133zm.125-2.526v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M161.925 361.31v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.925 363.969h-.249v-2.659h.374v2.659h-.125zm-.124-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M165.169 362.373c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 363.038v-1.595h.374v.931c0 .132-.125.265-.249.531l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.265l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.806 362.772c-.124-.132-.124-.265-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.931 362.905l-.125-.133c-.124-.132-.124-.265-.124-.398v-1.064h.249v1.595zm-.249-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.419 363.171c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.17 363.437v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.673 363.836h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.424 363.836v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 363.437c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.797 363.57v-2.26h.374v2.127c-.125.133-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.421 363.703h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.047 363.836v-2.393h.374v2.26c-.125 0-.125 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.048 363.703h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.799 363.836v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127c0 .133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.925 359.847c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 363.038c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.046 362.506c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM162.176 362.904h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.923 362.772h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.303 362.904h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.133.374.133.499.266z"
            fill="#fff"
            />
            <path
            d="M166.79 364.232c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374 0 .748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 366.758c-1.871 0-3.118-.798-3.243-1.462V364.233h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.25.93-1.497 1.595-3.369 1.595zm-3.118-1.595c0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462v-.798h-1.996c-.748-.132-1.622-.132-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.66 365.829s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.41 366.228v-1.861h.374v1.595c-.124 0-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M165.792 364.367v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M165.917 366.76h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.166 366.76h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.291 366.76h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.419 366.228c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.544 366.361c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.541 366.76h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 366.76h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.044 365.962c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.169 366.095c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.266l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.167 366.494c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.167 366.627c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M165.417 366.627h-.249V364.5h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.542 366.627c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M164.794 366.361c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 366.495c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.662 366.494h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.287 366.628v-2.26h.374v2.26c-.124-.133-.124 0-.374 0zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.164 366.76h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M166.914 366.76v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M166.916 364.234v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M166.791 366.76h-.25v-2.658h.374v2.658h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.033 365.165c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M169.783 365.963v-1.595h.374v.931c0 .133-.124.265-.249.531l-.125.133zm.125-1.462v1.063c0-.132.125-.132.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M163.672 365.697c-.125-.133-.125-.266-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M163.796 365.829l-.124-.132c-.125-.133-.125-.266-.125-.399v-1.064h.249v1.595zm-.124-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.285 366.095c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.035 366.362v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.539 366.76h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.289 366.76v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M168.912 366.361c-.125 0-.125 0-.25.133V364.5h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.662 366.494v-2.26h.374v2.127c-.124 0-.124.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.287 366.627h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.037 366.761v-2.393h.374v2.26c-.249 0-.249 0-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M167.914 366.627h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.664 366.76v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M166.79 362.771c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 365.961c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .664-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462 0-.665-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.911 365.43c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.039 365.828h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M167.788 365.695h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.166 365.696h.998-.998c-.125 0-.374 0-.499-.133s-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.956 358.918c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 361.443c-1.871 0-3.119-.798-3.243-1.463V358.917h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.249.797-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.826 360.513s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 360.779v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.958 358.918v2.392h-.249v-2.259c.125 0 .125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.083 361.311h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M146.332 361.31h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.332 361.443h-.25v-2.525h.374v2.525h-.124zm-.125-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.585 360.911c-.124 0-.124-.132-.249-.132v-1.728h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M144.585 360.912c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266s0 .133 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.707 361.31h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.707 361.443h-.25v-2.525h.374v2.525h-.124zm-.25-.132c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.212 360.646c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 360.779c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s0 .133 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M145.21 361.177c-.124 0-.124 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M145.335 361.177c-.124 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.133s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M145.583 361.177h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M145.708 361.311c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.96 361.045c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.96 361.177c-.124 0-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M148.703 361.044h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M148.453 361.178v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.332 361.31h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M147.082 361.444v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.957 358.918v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.957 361.443h-.25v-2.658h.374v2.658h-.124zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M150.201 359.848c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 360.513v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.838 360.247c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 360.513l-.124-.133c-.125-.133-.125-.266-.125-.399V358.918h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.451 360.779c-.125 0-.125.132-.25.132v-1.86h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 361.044v-1.993h.374v1.86c-.124 0-.249 0-.374.133zm.125-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.705 361.31h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 361.443v-2.525h.374v2.525h-.374zm.125-2.392v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 360.911c-.125 0-.125 0-.25.133v-1.993h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 361.178v-2.26h.374v2.127c-.124 0-.249 0-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 361.177h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M148.078 361.311v-2.393h.374v2.26c-.124.133-.124.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M148.08 361.31h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.83 361.443v-2.525h.374v2.393c-.249 0-.249 0-.374.132zm.125-2.392v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.956 357.323c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.665 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 360.513c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595zm0-3.057c-1.871 0-3.118.797-3.118 1.462 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M149.077 360.114c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM147.205 360.512h-.499l-2.37-2.526c.125-.132.249-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.954 360.38h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.132h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.132zM146.332 360.38h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.822 361.84c.374 0 .748 0 1.122.133h2.121v.798c0 .664-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 364.365c-1.872 0-3.119-.797-3.244-1.462V361.84h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.25.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.463 3.119 1.463 1.746 0 3.118-.798 3.118-1.463v-.797h-1.996c-.748-.133-1.621-.133-2.245 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.691 363.436s-.125.133-.25.133v-1.595h.25v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 363.701v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.824 361.84v2.393h-.25v-2.26c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.949 364.233h-.25v-2.393h.374v2.393h-.124zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M151.197 364.233h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.322 364.366h-.25v-2.526h.375v2.526h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.451 363.702c-.125 0-.125-.133-.25-.133v-1.595h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 363.834c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.572 364.233h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.572 364.365h-.25v-2.525h.375v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.078 363.569c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.202 363.701c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.199 364.1c-.125 0-.125 0-.25-.133v-1.993h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 364.1c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.449 364.1h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.574 364.232c-.125 0-.25 0-.25-.132v-2.26h.374v2.392h-.124zm-.25-.132c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.826 363.967c-.125 0-.125 0-.25-.132v-1.861h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 363.967c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.125-.133l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.693 363.967h-.25v-1.993h.25v1.993z" fill="#0EA59D" />
            <path
            d="M153.318 364.1v-2.26h.375v2.26h-.375zm.25-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.195 364.233h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M151.945 364.365v-2.658h.375v2.526c-.125.132-.25.132-.375.132zm.125-2.525v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.947 361.84v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 364.365h-.25v-2.658h.375v2.658h-.125zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.064 362.771c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.814 363.435v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.703 363.17c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 363.435l-.125-.133c-.125-.133-.125-.266-.125-.399V361.84h.25v1.595zm-.125-.665v.266-1.063.797z"
            fill="#131A2D"
            />
            <path
            d="M154.316 363.702c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 363.834v-1.994h.375v1.861c-.125.133-.25.133-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.57 364.233h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.32 364.365v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.525v2.26h.125l-.125-2.26c.125.133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M153.943 363.835c-.125 0-.125 0-.25.132v-1.993h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 364.1v-2.26h.375v2.127c-.125 0-.125 0-.375.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.318 364.1h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.068 364.232v-2.392h.375v2.26c-.25.132-.25.132-.375.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.945 364.232h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.695 364.233v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.822 360.244c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 363.434c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.871 0 3.243.798 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.798-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.664-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.942 363.036c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM152.07 363.435h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.82 363.303h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.132h-.749c.125 0 .25.001.375-.132v-.133zM151.197 363.302h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.687 364.765c.374 0 .748 0 1.123.133h2.12v.798c0 .664-1.372 1.462-3.243 1.462-1.871 0-3.244-.798-3.244-1.462v-.798h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 367.29c-1.871 0-3.119-.797-3.244-1.462V364.765h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.375-.133-.749-.133-1.123-.133s-.749 0-1.123.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.556 366.36s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.307 366.625v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.812 364.764v2.392h-.25v-2.259c.001-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.812 367.156h-.25v-2.392h.375v2.392h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M156.062 367.156h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M156.187 367.289h-.249v-2.525h.374v2.525h-.125zm-.249-.266s.124.133 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 366.626c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 366.757c-.125-.132-.25-.132-.25-.132v-1.861h.375v1.993h-.125zm-.25-.265s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.437 367.157h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.562 367.289h-.25v-2.659h.375v2.659h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.068 366.492c-.125 0-.125-.133-.25-.133v-1.463h.25v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M154.068 366.625c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.25-.399c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.064 367.024c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 367.024c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.439 367.023h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.439 367.156c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.125-.266c0 .133 0 .133 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M154.691 366.891c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 366.89c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.25-.133l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M158.558 366.891h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.309 367.024v-2.26h.374v2.26h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.185 367.156h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M156.936 367.289v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M156.812 364.765v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M156.687 367.289h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.929 365.694c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.68 366.359v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.693 366.093c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 366.359l-.125-.133c-.125-.133-.125-.266-.125-.399V364.764h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.306 366.624c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 366.757v-1.993h.374v1.861c-.125 0-.125.132-.374.132zm.124-1.86v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.56 367.157h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.186 367.289v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.525v2.259h.125l-.125-2.259c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.931 366.757c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 367.023v-2.259h.374v2.126c-.25 0-.25 0-.374.133zm.124-2.126v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M158.183 367.024h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.934 367.156v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M157.808 367.157h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.559 367.156v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.687 363.17c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 366.36c-1.996 0-3.369-.797-3.369-1.595 0-.798 1.373-1.595 3.369-1.595 1.996 0 3.243.93 3.243 1.595.125.798-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.808 365.961c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.936 366.36h-.499l-2.371-2.526c.125 0 .25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.81 366.227h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.187 366.227h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.677 367.689c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 370.214c-1.871 0-3.119-.797-3.244-1.462V367.689h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.249.798-1.622 1.595-3.368 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.798h-1.996a7.142 7.142 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M164.546 369.284s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 369.55v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.679 367.689v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.679 370.082h-.249v-2.393h.374v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.054 370.082h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.054 370.215h-.249v-2.526h.374v2.526h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.306 369.55c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.306 369.683c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M161.302 370.082h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.427 370.215h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M158.933 369.417c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M158.933 369.55c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.398l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M159.931 369.816c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.056 369.949c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.304 369.949h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.304 370.082c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.556 369.816c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.681 369.816c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.133s.124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 369.816h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.174 369.949v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.05 370.082h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M161.801 370.215v-2.659h.374v2.526c-.249.133-.249.133-.374.133zm.125-2.526v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M161.677 367.689v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.677 370.215h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M164.921 368.62c0 .133-.124.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.547 369.284v-1.595h.374v.931c0 .133-.125.266-.249.532l-.125.132zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.558 369.019c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M158.558 369.284l-.125-.132c-.124-.133-.124-.266-.124-.399v-1.064h.249v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.171 369.55c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M163.922 369.683v-1.994h.374v1.861c-.125 0-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.425 370.082h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.176 370.215v-2.526h.374v2.393c-.249 0-.249.133-.374.133zm.125-2.526v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M163.798 369.684c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.549 369.816v-2.259h.374v1.993c-.125.266-.249.266-.374.266zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.05 369.949h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M162.801 370.082v-2.393h.374v2.26c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M162.8 369.949h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.426 370.082v-2.526h.374v2.393c-.125.133-.125.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.677 366.094c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 369.284c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M163.673 368.885c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.132.748-.132l2.62 2.658zM161.926 369.283h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.675 369.151h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.053 369.152h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M141.716 362.239c.374 0 .749 0 1.123.132h2.121v.798c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.798h2.12c.375-.132.749-.132 1.123-.132z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 364.764c-1.871 0-3.119-.798-3.243-1.463V362.238h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.124.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.373 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M144.585 363.836s-.124.132-.249.132v-1.728h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M144.336 364.101v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M140.843 362.374v2.392h-.249v-2.259c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M140.843 364.766h-.249v-2.392h.374v2.392h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.126h-.124v2.126z"
            fill="#131A2D"
            />
            <path d="M141.091 364.767h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.216 364.766h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.345 364.235c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M139.47 364.368c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266s.124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M141.466 364.767h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.591 364.766h-.249v-2.526h.374v2.526h-.125zm-.249-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.097 363.969c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M139.097 364.101c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.266c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M140.095 364.5c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M140.095 364.634c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M140.468 364.633h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M140.468 364.633c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M139.72 364.368c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M139.845 364.5c-.125 0-.249-.132-.249-.132v-1.994h.374v2.126h-.125zm-.249-.265l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M143.587 364.501h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M143.338 364.633v-2.259h.374v2.259c-.125-.132-.249-.132-.374 0zm.125-2.259v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M142.214 364.766h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M141.965 364.766v-2.659h.374v2.526c-.249.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M141.841 362.24v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M141.716 364.766h-.249v-2.659h.374v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M144.958 363.172c0 .132-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M144.709 363.835v-1.595h.374v.931c0 .133-.125.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M138.722 363.702c-.124-.133-.124-.265-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M138.722 363.836l-.125-.133c-.124-.133-.124-.266-.124-.399v-1.064h.249v1.596zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M144.335 364.102c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M143.961 364.368v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M142.589 364.633h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.215 364.766v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M143.962 364.367c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M143.713 364.5v-2.26h.374v2.127c-.249 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M143.212 364.5h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M142.963 364.633v-2.393h.374v2.26c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M142.837 364.633h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.588 364.766v-2.526h.374v2.393c-.125.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M141.716 360.776c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 363.966c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.798-3.119 1.462 0 .665 1.248 1.463 3.119 1.463 1.871 0 3.119-.798 3.119-1.463.125-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M143.837 363.436c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM141.965 363.834h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M142.839 363.702h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM141.217 363.7h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.125.265.249.265.499.265z"
            fill="#fff"
            />
            <path
            d="M146.706 365.164c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 367.689c-1.871 0-3.119-.797-3.243-1.462V365.164h2.12a7.095 7.095 0 012.371 0h2.12v.93c-.249.798-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.576 366.759s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 367.025v-1.861h.374v1.595c-.124.133-.124.133-.374.266zm.25-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.708 365.296v2.393h-.249v-2.26c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M145.708 367.689h-.249v-2.393h.374v2.393h-.125zm-.124-.266s0 .133 0 0l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M146.082 367.556h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.082 367.689h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M144.335 367.158c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.335 367.29c-.124-.132-.249-.132-.249-.132v-1.861h.374v1.993h-.125zm-.124-.265l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.332 367.689h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.457 367.689h-.25v-2.525h.374v2.525h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M143.962 366.892c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 367.025c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M144.96 367.423c-.124 0-.124 0-.249-.132v-2.127h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M145.085 367.556c-.124 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.266s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M145.333 367.556h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.458 367.556c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M144.585 367.29c-.124 0-.124 0-.249-.132v-1.861h.249v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M144.71 367.423c-.124 0-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.249-.265c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 367.423h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.203 367.556v-2.26h.374v2.26c-.124-.133-.249-.133-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.082 367.688h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M146.832 367.689v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.707 365.163v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.707 367.688h-.25v-2.658h.374v2.658h-.124zm-.125-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M149.951 366.094c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 366.759v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.588 366.493c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.712 366.759l-.124-.133c-.125-.133-.125-.266-.125-.399V365.164h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.201 367.025c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.951 367.29v-1.993h.374v1.861c-.124 0-.249 0-.374.132zm.125-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.455 367.556h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.205 367.689v-2.525h.374v2.525h-.374zm.125-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M148.828 367.158c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 367.423v-2.259h.374v2.127c-.124 0-.249 0-.374.132zm.125-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.078 367.424h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M147.828 367.556v-2.392h.374v2.259c-.124.133-.249.133-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M147.83 367.556h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 367.689v-2.525h.374v2.392c-.124.133-.124.133-.374.133zm.25-2.392v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path
            d="M146.706 363.702c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 366.892c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.372 1.596-3.244 1.596zm0-3.191c-1.871 0-3.118.798-3.118 1.463 0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462 0-.665-1.372-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M148.827 366.361c-.249.132-.499.132-.748.265l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM146.955 366.759h-.499l-2.37-2.526c.125-.132.249-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.704 366.627h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.132h-.749c.125 0 .25 0 .374-.132v-.133zM146.082 366.626h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.572 368.089c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.249-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 370.614c-1.872 0-3.119-.798-3.244-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.25.797-1.497 1.595-3.368 1.595zm-3.244-1.595c0 .664 1.372 1.462 3.119 1.462 1.746 0 3.119-.798 3.119-1.462v-.798h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M154.441 369.683s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 369.949v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.574 368.221v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.699 370.613h-.25v-2.392h.374v2.392h-.124zm-.25-.266l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M150.949 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M150.949 370.614h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.201 370.082c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 370.215c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.125-.399c0 .133 0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.324 370.613h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.324 370.614h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M148.828 369.816c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M148.952 369.949c-.124-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399c0 .133 0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M149.826 370.348c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M149.951 370.48c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.25-.265c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.199 370.48h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.324 370.48c-.125 0-.25 0-.25-.132v-2.26h.374v2.392h-.124zm-.25-.132s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.576 370.215c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 370.347c-.125 0-.25-.132-.25-.132v-1.994h.374v2.126h-.124zm-.125-.265l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.443 370.215h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.068 370.48v-2.26h.375v2.26c-.125-.133-.125-.133-.375 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M151.947 370.613h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.697 370.613v-2.658h.375v2.526c-.125.132-.25.132-.375.132zm.125-2.392v2.392h.125l-.125-2.392c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.697 368.088v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 370.613h-.25v-2.658h.375v2.658h-.125zm-.125-.132c.125 0 .125 0 0 0l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M154.816 369.018c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 369.683v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.453 369.417c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 369.683l-.125-.133c-.125-.133-.125-.266-.125-.399V368.088h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.066 369.949c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M153.816 370.215v-1.994h.375v1.861c-.125 0-.25 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.32 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.07 370.613v-2.525h.375v2.525h-.375zm.125-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 370.082c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 370.348v-2.26h.375v1.994c-.125.133-.25.133-.375.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.07 370.348h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M152.82 370.48v-2.392h.375v2.26c-.25.132-.25.132-.375.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.695 370.481h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.445 370.614v-2.526h.375v2.393c-.25 0-.25.133-.375.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.572 366.493c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 369.817c-1.996 0-3.244-.797-3.244-1.595 0-.798 1.372-1.595 3.244-1.595 1.996 0 3.243.797 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462 0-.665-1.372-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.692 369.284c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM151.822 369.683h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.57 369.55h.124c.125 0 .25 0 .375-.132.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.132h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM150.947 369.55h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.437 371.011c.374 0 .748 0 1.123.133h2.12v.798c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 373.537c-1.871 0-3.119-.797-3.244-1.462V371.012h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.798h-1.996a7.148 7.148 0 00-2.371 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M159.306 372.607s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.057 372.873v-1.861h.374v1.595c-.125.133-.25.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.439 371.012v2.392h-.25v-2.259c.125 0 .25 0 .25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.564 373.537h-.25v-2.392h.375v2.392h-.125zm-.25-.266s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M155.812 373.404h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M155.937 373.537h-.249v-2.525h.374v2.525h-.125zm-.249-.133l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.066 373.006c-.125 0-.125-.132-.25-.132v-1.728h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 373.006c-.125-.132-.25-.132-.25-.132v-1.861h.375v1.993h-.125zm-.25-.265c0 .133 0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.187 373.538h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.187 373.538h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 372.741c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 372.874c-.125-.133-.25-.133-.375-.266v-1.595h.375v1.861zm-.25-.399c0 .133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M154.816 373.272c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 373.272c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.189 373.272h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M155.189 373.405c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M154.441 373.139c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 373.271c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.125-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.308 373.138h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.059 373.404v-2.259h.374v2.259c-.25-.133-.25-.133-.374 0zm.124-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M156.937 373.405h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M156.562 373.537v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.562 371.013v2.525h-.249v-2.525h.249s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 373.538h-.249v-2.659h.374v2.659h-.125c.125 0 0 0 0 0zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M159.681 371.943c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.432 372.608v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.443 372.342c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 372.608l-.125-.133c-.125-.133-.125-.266-.125-.399V371.013h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M158.931 372.873c-.125 0-.125.132-.249.132v-1.86h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 373.137v-1.993h.374v1.86c-.125 0-.125 0-.374.133zm.124-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.185 373.404h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.936 373.537v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.683 373.006c-.125 0-.125 0-.249.133v-1.993h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M158.309 373.272v-2.259h.374v2.126c-.125 0-.125 0-.374.133zm.124-2.126v1.86h.125l-.125-1.86z"
            fill="#131A2D"
            />
            <path d="M157.933 373.271h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.684 373.404v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M157.56 373.404h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.311 373.537v-2.525h.374v2.392c-.125 0-.25 0-.374.133zm.124-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M156.437 369.416c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.797 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 372.739c-1.996 0-3.244-.931-3.244-1.595 0-.665 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.372 1.462 3.119 1.462 1.746 0 3.119-.798 3.119-1.462.124-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.558 372.207c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.688 372.607h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.435 372.473h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.624-.399-.125.266-.25.399-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM155.937 372.474h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M157.31 350.676c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 353.201c-1.871 0-3.119-.797-3.244-1.462V350.676h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c-.124.931-1.497 1.595-3.243 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M160.179 352.271s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.805 352.669v-1.86h.374v1.595c-.125 0-.125.133-.374.265zm.249-1.727v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.312 350.809v2.392h-.25v-2.259c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.312 353.201h-.25v-2.392h.375v2.392h-.125zm-.125-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M156.685 353.201h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.685 353.201h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.939 352.669c-.125 0-.125-.132-.25-.132v-1.728h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M154.939 352.802c-.125-.133-.25-.133-.25-.133v-1.86h.375v1.993h-.125zm-.25-.265c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.935 353.201h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.06 353.201h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.566 352.404c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 352.537c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.564 352.935c-.125 0-.125 0-.25-.132v-2.127h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.689 353.068c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.25-.266s.125 0 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.937 353.068h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M156.062 353.201c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M155.189 352.802c-.125 0-.125 0-.25-.133v-1.86h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M155.314 352.936c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M159.056 352.935h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.807 353.068v-2.259h.374v2.259c-.125-.133-.25 0-.374 0zm.124-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.685 353.201h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.436 353.201v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.392v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.31 350.676v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M157.31 353.201h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.554 351.739c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M160.18 352.404v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M154.191 352.138c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 352.271l-.125-.133c-.125-.133-.125-.266-.125-.399V350.676h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.804 352.537c-.125 0-.125.132-.249.132v-1.86h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 352.802v-1.993h.374v1.86c-.125 0-.25 0-.374.133zm.124-1.86v1.727h.125l-.125-1.727z"
            fill="#131A2D"
            />
            <path d="M158.058 353.201h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 353.201v-2.525h.374v2.392c-.25.133-.25.133-.374.133zm.124-2.392v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.431 352.803c-.125 0-.125 0-.249.132v-1.993h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.182 352.935v-2.259h.374v2.127c-.125 0-.25.132-.374.132zm.124-1.993v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.683 353.068h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.434 353.201v-2.392h.374v2.259c-.125 0-.25 0-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M158.433 353.068h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M158.059 353.201v-2.525h.374v2.392c-.125.133-.125.133-.374.133zm.249-2.392v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path
            d="M157.31 349.214c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.797 1.248-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 352.404c-1.996 0-3.244-.93-3.244-1.595 0-.797 1.373-1.595 3.244-1.595 1.996 0 3.368.931 3.368 1.595-.125.665-1.497 1.595-3.368 1.595zm0-3.19c-1.871 0-3.119.798-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.664-1.373-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.431 351.873c-.25.132-.499.132-.749.265l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.659zM157.559 352.271h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.308 352.138h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.624-.399-.125.266-.25.399-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.686 352.138h.997-.997c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M162.175 353.599c.374 0 .749 0 1.123.133h2.121v.797c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.12c.25 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 356.124c-1.871 0-3.119-.797-3.244-1.462V353.599h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.249.931-1.497 1.595-3.368 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.124z"
            fill="#131A2D"
            />
            <path
            d="M165.044 355.195s-.124.133-.249.133V353.6h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 355.594v-1.861h.374v1.595c-.125 0-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M161.177 353.733v2.392h-.249v-2.259c.124-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.302 356.125h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M161.55 356.125h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.55 356.125h-.249V353.6h.374v2.525h-.125zm-.124-.133l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.804 355.594c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.804 355.726c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.925 356.125h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.925 356.125h-.249V353.6h.374v2.525h-.125zm-.124-.133l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.431 355.327c-.125 0-.125-.132-.249-.132v-1.463h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 355.461c-.125-.133-.25-.266-.374-.266V353.6h.374v1.861zm-.25-.266l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M160.429 355.859c-.125 0-.125 0-.249-.133V353.6h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.554 355.993c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.802 355.993h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.927 355.992c-.125 0-.249 0-.249-.133V353.6h.374v2.392h-.125zm-.249-.133s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M160.179 355.726c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M160.179 355.859c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.125-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M163.921 355.859h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M163.672 355.992v-2.26h.374v2.26c-.125-.133-.125 0-.374 0zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.55 356.125h-.249V353.6h.249v2.525z" fill="#0EA59D" />
            <path
            d="M162.301 356.125v-2.658h.374v2.525c-.125.133-.249.133-.374.133zm.125-2.392v2.392h.124l-.124-2.392c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path d="M162.175 353.6v2.525h-.249V353.6h.249z" fill="#0EA59D" />
            <path
            d="M162.175 356.125h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.419 354.53c0 .133-.124.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M165.17 355.327v-1.595h.374v.931c0 .133-.125.266-.249.532l-.125.132zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M159.056 355.063c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 355.195l-.125-.133c-.124-.133-.124-.266-.124-.399V353.6h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M164.669 355.461c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.42 355.726v-1.993h.374v1.861c-.125 0-.249 0-.374.132zm.125-1.86v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.923 356.125h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.674 356.125V353.6h.374v2.525h-.374zm.125-2.392v2.259h.124l-.124-2.259z"
            fill="#131A2D"
            />
            <path
            d="M164.296 355.727c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.047 355.859V353.6h.374v1.993c-.125.133-.249.266-.374.266zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.673 355.992h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M163.424 356.125v-2.393h.374v2.26c-.249 0-.249 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.298 355.992h-.249V353.6h.249v2.392z" fill="#0EA59D" />
            <path
            d="M163.049 356.125V353.6h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.392v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path
            d="M162.175 352.137c1.871 0 3.244.797 3.244 1.595 0 .798-1.373 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 355.327c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.296 354.795c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM162.424 355.194h-.499l-2.37-2.526c.124-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M163.173 355.061h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.551 355.062h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M167.04 356.524c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 359.049c-1.871 0-3.118-.798-3.243-1.462V356.524h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.93-1.497 1.595-3.369 1.595zm-3.118-1.595c0 .665 1.372 1.462 3.118 1.462 1.747 0 3.119-.797 3.119-1.462v-.798h-1.996c-.748-.132-1.622-.132-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.91 358.12s-.125.133-.25.133v-1.595h.25v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 358.386v-1.861h.374v1.595c-.124.133-.249.266-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path d="M166.042 356.657v2.393h-.249v-2.393h.249z" fill="#0EA59D" />
            <path
            d="M166.167 359.051h-.249v-2.393h.374v2.393h-.125zm-.249-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.416 359.051h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 359.051h-.25v-2.526h.374v2.526h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.669 358.518c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 358.652c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.791 359.051h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.791 359.051h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 358.253c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.421 358.386c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266s.124 0 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.419 358.784c-.124 0-.124 0-.249-.133v-1.994h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M165.419 358.918c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.124-.266l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M165.792 358.918h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M165.792 358.918c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M165.044 358.651c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M165.044 358.784c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.912 358.784h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.662 358.918v-2.26h.374v2.26c-.249-.133-.249 0-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.541 359.05h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M167.166 359.05v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.166 356.524v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M167.041 359.05h-.25v-2.658h.374v2.658h-.124zm0-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M170.285 357.456c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 358.12v-1.595h.374v.931c0 .133-.124.265-.249.531l-.125.133zm.125-1.462v1.063c0-.132.125-.132.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M164.047 357.987c-.125-.133-.125-.265-.125-.398v-.931h.125v1.329z"
            fill="#0EA59D"
            />
            <path
            d="M164.046 358.12l-.124-.132c-.125-.133-.125-.266-.125-.399v-1.064h.249v1.595zm-.124-.664v.266-1.064.798z"
            fill="#131A2D"
            />
            <path
            d="M169.535 358.385c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.285 358.652v-1.994h.374v1.861c-.124 0-.124 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.789 358.918h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.539 359.051v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.287 358.652c-.125 0-.125 0-.25.133v-2.127h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 358.785v-2.26h.374v1.994c-.124.133-.124.266-.374.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.537 358.785h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.287 358.918v-2.393h.374v2.26c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M168.164 358.918h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M167.914 359.051v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M167.04 355.062c1.872 0 3.244.798 3.244 1.596 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.596 3.243-1.596z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 358.254c-1.996 0-3.243-.931-3.243-1.595 0-.665 1.372-1.596 3.243-1.596 1.996 0 3.244.798 3.244 1.596 0 .797-1.248 1.595-3.244 1.595zm0-3.191c-1.871 0-3.118.798-3.118 1.463 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462.125-.665-1.247-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M169.161 357.72c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM167.289 358.118h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M168.038 357.986h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.132.375-.265.624-.398-.125.266-.249.398-.499.531l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.541 357.987h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M171.906 359.448c.374 0 .748 0 1.122.133h2.121v.798c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.798h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.906 361.974c-1.872 0-3.119-.798-3.244-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.125.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.871a7.089 7.089 0 00-2.37 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M174.775 361.044s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M174.525 361.309v-1.861h.375v1.595c-.125.133-.125.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.033 359.581v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.033 361.974h-.25v-2.393h.374v2.393h-.124zm-.25-.266c.125.133.125.133 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M171.283 361.974h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.408 361.974h-.25v-2.526h.374v2.526h-.124zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.535 361.442c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 361.575c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M171.656 361.974h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M171.781 361.974h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.287 361.176c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.286 361.309c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M170.285 361.708c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M170.41 361.841c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.25-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M170.658 361.842h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M170.658 361.841c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M169.91 361.575c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 361.708c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M173.777 361.708h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M173.527 361.841v-2.26h.375v2.26c-.125-.133-.25-.133-.375 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M172.404 361.974h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M172.154 361.974v-2.659h.375v2.526c-.25.133-.25.133-.375.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M172.031 359.448v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M171.906 361.974h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M175.15 360.379c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M174.9 361.044v-1.596h.375v.931c0 .133-.125.266-.25.532l-.125.133zm.125-1.463v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M168.912 360.911c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 361.043l-.125-.133c-.125-.133-.125-.266-.125-.399V359.448h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M174.527 361.309c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M174.152 361.575v-1.994h.375v1.861c-.125 0-.125 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M172.779 361.842h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.404 361.974v-2.526h.375v2.526h-.375zm.125-2.393v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M174.152 361.576c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M173.902 361.708v-2.26h.375v2.127c-.25 0-.25 0-.375.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M173.402 361.709h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M173.152 361.841v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M173.029 361.842h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.779 361.974v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.393v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M171.906 357.985c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M171.905 361.175c-1.996 0-3.368-.797-3.368-1.595 0-.797 1.372-1.595 3.368-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M174.026 360.645c-.249.133-.499.133-.748.266l-2.62-2.792c.25 0 .499-.133.749-.133l2.619 2.659zM172.279 361.043h-.499l-2.37-2.525c.125-.133.25-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M173.029 360.911h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM171.406 360.91h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.132-.499-.132h.499c.125.265.374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M152.07 354.131c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.462-3.243 1.462-1.872 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 356.656c-1.872 0-3.119-.797-3.244-1.462V354.131h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M154.939 355.726s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 355.992v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M151.072 354.131v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.197 356.523h-.25v-2.392h.375v2.392h-.125zm-.25-.133s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M151.447 356.523h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.572 356.656h-.25v-2.525h.375v2.525h-.125zm-.25-.265l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.699 355.992c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.824 356.125c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.82 356.523h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.945 356.656h-.25v-2.658h.375v2.658h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.326 355.859c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.45 355.991c-.124-.132-.249-.265-.374-.265v-1.595h.374v1.86zm-.249-.398s.125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.449 356.391c-.125 0-.125-.001-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M150.449 356.391c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.822 356.39h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.822 356.523c-.125 0-.25 0-.25-.132v-2.26h.375v2.392h-.125zm-.25-.265c.125 0 .125.132 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M150.074 356.257c-.125 0-.125 0-.25-.132v-1.861h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 356.257c-.125 0-.25-.133-.25-.133v-1.993h.374v2.126h-.124zm-.25-.133l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M153.941 356.257h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.691 356.39v-2.259h.375v2.259h-.375zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M152.57 356.523h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M152.195 356.656v-2.658h.375v2.525c-.125.133-.125.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.195 354.131v2.525h-.25v-2.525h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 356.656h-.125v-2.658h.375v2.658h-.25zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M155.314 355.061c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 355.726v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M149.076 355.46c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M149.076 355.726l-.125-.133c-.125-.133-.125-.266-.125-.399V354.131h.25v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M154.564 355.992c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.314 356.124v-1.993h.375v1.86c-.125 0-.125.133-.375.133zm.125-1.86v1.727h.125l-.125-1.727z"
            fill="#131A2D"
            />
            <path d="M152.818 356.523h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.568 356.656v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M154.316 356.125c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 356.257v-2.259h.375v1.994c-.125.265-.125.265-.375.265zm.125-1.993v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.566 356.391h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.316 356.523v-2.392h.375v2.26c-.125.132-.25.132-.375.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M153.193 356.523h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.943 356.524v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M152.07 352.536c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 355.726c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.996 0 3.368.798 3.368 1.595 0 .798-1.372 1.595-3.368 1.595zm0-3.057c-1.872 0-3.119.798-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.664-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M154.191 355.328c-.25.133-.499.133-.749.265l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.659zM152.318 355.726h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M153.068 355.593h.124c.125 0 .25 0 .375-.132.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125-.001-.125.132h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM151.57 355.593h.998-.998c-.124 0-.374 0-.499-.133-.124-.133-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.935 357.057c.374 0 .748 0 1.123.133h2.12v.797c0 .798-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 359.581c-1.871 0-3.119-.797-3.244-1.462V357.056h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.872c-.374-.133-.748-.133-1.122-.133-.375 0-.749 0-1.123.133h-1.996v.797h-.125z"
            fill="#131A2D"
            />
            <path
            d="M159.804 358.652s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 358.917v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.062 357.057v2.392h-.25v-2.259c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.062 359.449h-.25v-2.393h.375v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.31 359.449h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.435 359.582h-.249v-2.525h.374v2.525h-.125zm-.249-.266c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.564 358.918c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 359.05c-.125-.132-.25-.132-.25-.132v-1.861h.375v1.993h-.125zm-.25-.265c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.685 359.449h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.81 359.582h-.249v-2.525h.374v2.525h-.125zm-.249-.133s.124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 358.785c-.125 0-.125-.133-.25-.133v-1.463h.25v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 358.918c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.125-.399l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.314 359.182c-.125 0-.125.001-.25-.132v-2.127h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M155.439 359.316c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.25-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.687 359.316h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M155.687 359.449c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M154.939 359.183c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 359.183c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.25-.265c0 .132.125.132 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.806 359.183h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.557 359.316v-2.259h.374v2.259h-.374zm.124-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.433 359.449h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M157.184 359.581v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.06 357.057v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M156.935 359.581h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.179 357.987c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M159.93 358.652v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.941 358.386c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 358.652l-.125-.133c-.125-.133-.125-.266-.125-.399V357.057h.25v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M159.554 358.917c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 359.05v-1.993h.374v1.861c-.25 0-.25.132-.374.132zm.124-1.86v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.808 359.449h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.559 359.582v-2.526h.374v2.526c-.25-.133-.25-.133-.374 0zm.124-2.526v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 359.05c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 359.183v-2.26h.374v2.127c-.125.133-.25.133-.374.133zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.431 359.316h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.182 359.449v-2.393h.374v2.26c-.125 0-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.058 359.316h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.809 359.449v-2.526h.374v2.393c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.935 355.461c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 358.651c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .664 1.372 1.462 3.119 1.462 1.746 0 3.119-.798 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.056 358.252c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .498-.133.748-.133l2.62 2.658zM157.309 358.651h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.058 358.518h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.435 358.518h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.498-.133h.498c.125.133.375.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.925 359.847c.374 0 .749 0 1.123.133h2.121v.797c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.12c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 362.505c-1.871 0-3.119-.797-3.243-1.462V359.98h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.93c-.125.798-1.373 1.595-3.244 1.595zm-3.243-1.728c0 .665 1.372 1.462 3.118 1.462 1.747 0 3.119-.797 3.119-1.462v-.797h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M164.794 361.576s-.124.132-.249.132v-1.728h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 361.842v-1.861h.374v1.595c-.125 0-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.927 359.98v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.927 362.374h-.249v-2.393h.374v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.302 362.373h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.302 362.373h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.556 361.841c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 361.975c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.677 362.373h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.677 362.507h-.249v-2.526h.374v2.526h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.181 361.709c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 361.842c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.398l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M160.179 362.107c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.304 362.24c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c0 .133.124.133 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.554 362.241h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.679 362.374c-.125 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.929 361.974c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.929 362.108c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.124.133.124.133 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 362.107h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.422 362.241v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.3 362.373h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.051 362.506v-2.659h.374v2.526c-.125.133-.249.133-.374.133zm.125-2.526v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M161.925 359.847v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.925 362.506h-.249v-2.658h.374v2.658h-.125zm-.124-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M165.169 360.912c0 .133-.124.399-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 361.576v-1.595h.374v.931c0 .133-.125.266-.249.532l-.125.132zm.125-1.462v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.806 361.31c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.931 361.443l-.125-.133c-.124-.133-.124-.266-.124-.399V359.848h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M164.421 361.842c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 361.975v-1.994h.374v1.861c-.125 0-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.673 362.373h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.424 362.507v-2.526h.374v2.526c-.249-.133-.249-.133-.374 0zm.125-2.526v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 361.974c-.124 0-.124 0-.249.133v-1.993h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M163.797 362.108v-2.26h.374v2.127c-.125.133-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 362.24h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.049 362.374v-2.393h.374v2.26c-.125 0-.125.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.048 362.24h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.799 362.373v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.259v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path
            d="M161.925 358.384c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 361.574c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.046 361.176c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM162.176 361.574h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.925 361.441h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.303 361.442h.998-.998c-.125 0-.375 0-.499-.133-.125-.133-.25-.133-.499-.133h.499c.249.133.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M166.79 362.771c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.374 0 .748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 365.43c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.25.797-1.497 1.595-3.369 1.595zm-3.118-1.728c0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462v-.798h-1.996c-.748-.133-1.622-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.66 364.366s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.41 364.765v-1.861h.374v1.595c-.124 0-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M165.792 362.904v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M165.917 365.297h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.167 365.297h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M166.292 365.297h-.249v-2.526h.374v2.526h-.125zm-.249-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.419 364.765c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.544 364.898c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.541 365.297h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 365.429h-.25v-2.525h.374v2.525h-.124zm-.125-.266l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M164.046 364.499c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.171 364.632c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.266l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.167 365.031c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M165.167 365.164c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266c.125 0 .125.133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M165.417 365.164h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.542 365.296c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.265s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M164.794 364.898c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 365.031c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266s0 .133 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.662 365.031h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.287 365.164v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.166 365.297h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M166.916 365.43v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M166.916 362.771v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M166.791 365.43h-.25v-2.659h.374v2.659h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.033 363.834c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M169.783 364.499v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M163.672 364.234c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M163.796 364.366l-.124-.133c-.125-.133-.125-.265-.125-.398v-1.064h.249v1.595zm-.124-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.285 364.632c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.035 364.898v-1.994h.374v1.861c-.124 0-.249.133-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.539 365.297h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.289 365.297v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M168.912 364.899c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.662 365.031v-2.26h.374v2.127c-.124.133-.124.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.287 365.164h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.037 365.296v-2.392h.374v2.259c-.249 0-.249 0-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M167.914 365.164h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.664 365.297v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M166.79 361.31c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 364.5c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462 0-.665-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.911 364.101c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.039 364.366h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M167.788 364.234h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.166 364.367h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.249.132.374.132.499.265z"
            fill="#fff"
            />
            <path
            d="M146.956 357.455c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 359.981c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.249.797-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.826 359.051s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 359.317v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.958 357.456v2.393h-.249v-2.26c.125 0 .125 0 .249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.083 359.982h-.249v-2.392h.374v2.392h-.125zm-.249-.265l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M146.332 359.849h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.332 359.982h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.585 359.45c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.585 359.45c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266c0 .133 0 .133 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.707 359.981h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.707 359.982h-.25v-2.526h.374v2.526h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.212 359.184c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 359.317c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.399c0 .133 0 .133 0 0l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M145.21 359.716c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.335 359.849c-.124 0-.249-.132-.249-.132v-2.127h.374v2.259h-.125zm-.249-.265s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.583 359.849h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.708 359.849c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.96 359.583c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.96 359.716c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.703 359.583h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.453 359.849v-2.259h.374v2.259c-.124-.132-.249-.132-.374 0zm.125-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.332 359.848h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M147.082 359.981v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393c0 .133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path d="M146.957 357.456v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M146.957 359.981h-.25v-2.658h.374v2.658h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M150.201 358.386c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 359.051v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.838 358.785c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 359.051l-.124-.133c-.125-.133-.125-.266-.125-.399V357.456h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.451 359.317c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 359.583v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.705 359.848h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.455 359.982v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 359.45c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 359.716v-2.26h.374v2.127c-.124 0-.249 0-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 359.716h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M148.078 359.849v-2.393h.374v2.26c-.124.133-.124.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M148.08 359.848h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.83 359.982v-2.526h.374v2.393c-.249 0-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.956 355.86c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 359.183c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.665-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M149.077 358.652c-.249.132-.499.132-.748.265l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.659zM147.205 359.05h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.954 358.917h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.132h-.749c.125 0 .25.001.374-.132v-.133zM146.332 358.917h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.822 360.378c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.463-3.243 1.463-1.872 0-3.244-.798-3.244-1.463v-.797h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 362.903c-1.872 0-3.119-.797-3.244-1.462V360.378h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.25.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.463 3.119 1.463 1.746 0 3.118-.798 3.118-1.463v-.797h-1.996c-.748-.133-1.621-.133-2.245 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M154.691 361.972s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 362.238v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.824 360.378v2.393h-.25v-2.26c.125 0 .25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.949 362.903h-.25v-2.392h.374v2.392h-.124zm-.25-.266s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M151.199 362.77h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.324 362.902h-.25v-2.525h.374v2.525h-.124zm-.25-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.453 362.371c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.578 362.371c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.574 362.77h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.574 362.902h-.25v-2.525h.374v2.525h-.124zm-.125-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 362.106c-.125 0-.125-.133-.25-.133v-1.463h.25v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M149.202 362.238c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399c0 .133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.201 362.637c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M150.201 362.637c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.449 362.637h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.574 362.77c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.826 362.505c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 362.637c-.125 0-.25-.132-.25-.132v-1.994h.374v2.126h-.124zm-.125-.265l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.693 362.505h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.318 362.77v-2.259h.375v2.259c-.125-.133-.125-.133-.375 0zm.25-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.197 362.77h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M151.947 362.902v-2.658h.375v2.525c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.947 360.378v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 362.903h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.066 361.308c0 .133-.125.399-.25.532v-1.33h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 361.972v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.703 361.707c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 361.972l-.125-.133c-.125-.133-.125-.266-.125-.399V360.377h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.316 362.239c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 362.505v-1.994h.375v1.861c-.125 0-.25 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.57 362.77h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.32 362.902v-2.525h.375v2.525h-.375zm.125-2.392v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M153.943 362.371c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 362.637v-2.26h.375v1.994c-.125.133-.125.133-.375.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.32 362.637h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.07 362.77v-2.393h.375v2.26c-.25.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.945 362.77h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.695 362.902v-2.525h.375v2.393c-.125 0-.25 0-.375.132zm.125-2.392v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.822 358.783c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 361.973c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.871 0 3.243.931 3.243 1.595.125.798-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.798-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462 0-.664-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.942 361.574c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM152.07 361.973h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.82 361.841h.124c.125 0 .25 0 .375-.132.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.132h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133s-.25 0-.374 0h-.375c.125 0 .25 0 .375-.133v-.133zM151.197 361.84h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.687 363.303c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 365.828c-1.871 0-3.119-.797-3.244-1.462V363.303h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.375-.133-.749-.133-1.123-.133s-.749 0-1.123.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.556 364.898s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.307 365.164v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.814 363.303v2.392h-.25v-2.259c0-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.814 365.695h-.25v-2.392h.375v2.392h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M156.064 365.695h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M156.189 365.828h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 365.296c-.125 0-.125-.133-.25-.133v-1.727h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 365.297c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266s.125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.437 365.695h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.562 365.828h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.068 365.031c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.068 365.164c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.25-.399c.125 0 .125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.066 365.562c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.066 365.562c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.439 365.562h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M155.439 365.695c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M154.691 365.43c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 365.429c-.125 0-.25-.132-.25-.132v-1.994h.375v2.126h-.125zm-.25-.132l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.558 365.429h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.309 365.562v-2.259h.374v2.259h-.374zm.124-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.185 365.695h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.936 365.828v-2.658h.374v2.525c-.25.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M156.812 363.303v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M156.687 365.828h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.931 364.233c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.682 364.898v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.693 364.632c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 364.898l-.125-.133c-.125-.133-.125-.266-.125-.399V363.303h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.306 365.163c-.125 0-.125.133-.249.133v-1.86h.249v1.727z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 365.429v-2.126h.374v1.861c-.125.133-.125.133-.374.265zm.124-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.56 365.695h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.186 365.828v-2.525h.374v2.525h-.374zm.124-2.392v2.259h.125l-.125-2.259c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.933 365.296c-.125 0-.125 0-.249.133v-1.993h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M158.684 365.562v-2.259h.374v1.994c-.25.132-.25.132-.374.265zm.124-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.183 365.562h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.934 365.695v-2.392h.374v2.259c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M157.81 365.695h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.561 365.828v-2.525h.374v2.392c-.125 0-.25 0-.374.133zm.124-2.392v2.126h.125l-.125-2.126c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.687 361.708c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.797 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 364.898c-1.996 0-3.369-.797-3.369-1.595 0-.797 1.373-1.595 3.369-1.595 1.996 0 3.243.93 3.243 1.595 0 .665-1.247 1.595-3.243 1.595zm0-3.057c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.808 364.499c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.936 364.898h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.81 364.765h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.132.25-.132.249-.133.374-.266.624-.399-.125.266-.25.399-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.187 364.766h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.677 366.226c.374 0 .749 0 1.123.133h2.121v.797c0 .798-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.12c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 368.751c-1.871 0-3.119-.797-3.244-1.462V366.226h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.249.798-1.622 1.595-3.368 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.124z"
            fill="#131A2D"
            />
            <path
            d="M164.546 367.822s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 368.087v-1.86h.374v1.595c-.125.133-.125.133-.374.265zm.125-1.728v1.463h.124l-.124-1.463z"
            fill="#131A2D"
            />
            <path
            d="M160.679 366.227v2.392h-.249v-2.26c.124-.132.124-.132.249-.132z"
            fill="#0EA59D"
            />
            <path
            d="M160.679 368.619h-.249v-2.392h.374v2.392h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.052 368.619h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.052 368.752h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.306 368.087c-.125 0-.125-.132-.249-.132v-1.728h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M159.306 368.22c-.125-.133-.249-.133-.249-.133v-1.86h.374v1.993h-.125zm-.249-.265c.124 0 .124 0 0 0l.124-1.596h-.124v1.596z"
            fill="#131A2D"
            />
            <path d="M161.302 368.619h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.427 368.752h-.249v-2.525h.374v2.525h-.125zm-.249-.133s.124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M158.933 367.956c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M158.933 368.088c-.125-.132-.25-.265-.374-.265v-1.595h.374v1.86zm-.125-.398s0 .133 0 0l.125-1.33h-.125v1.33z"
            fill="#131A2D"
            />
            <path
            d="M159.929 368.486c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.054 368.486c-.125 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.133l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.304 368.488h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.304 368.62c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.556 368.355c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.681 368.354c-.125 0-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.249-.133s.124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 368.354h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.174 368.486v-2.259h.374v2.259h-.374zm.125-2.126v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.05 368.619h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M161.801 368.753v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.525v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M161.677 366.227v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M161.677 368.752h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M164.921 367.159c0 .133-.124.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.547 367.823v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.463v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M158.558 367.558c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M158.558 367.823l-.125-.133c-.124-.133-.124-.266-.124-.399V366.228h.249v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M164.171 368.089c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M163.922 368.222v-1.994h.374v1.861c-.125.133-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.425 368.619h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.176 368.752v-2.525h.374v2.392c-.249.133-.249.133-.374.133zm.125-2.525v2.259h.124l-.124-2.259c0 .132 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M163.798 368.222c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.549 368.487v-2.259h.374v2.126c-.125 0-.249 0-.374.133zm.125-2.127v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.048 368.486h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M162.799 368.619v-2.392h.374v2.259c-.125.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M162.8 368.619h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.426 368.619v-2.525h.374v2.392c-.125.133-.125.133-.374.133zm.125-2.259v2.126h.124l-.124-2.126c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.677 364.631c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 367.821c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M163.673 367.423c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM161.926 367.822h-.499l-2.37-2.526c.124-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.675 367.689h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.053 367.689h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M141.716 360.778c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.375 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 363.304c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.124.93-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.373 1.462 3.119 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M144.585 362.372s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.336 362.77v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M140.843 360.909v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M140.843 363.302h-.249v-2.393h.374v2.393h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M141.091 363.302h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.216 363.302h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.345 362.77c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M139.47 362.903c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266s.124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M141.466 363.302h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.591 363.302h-.249v-2.526h.374v2.526h-.125zm-.249-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.097 362.504c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M139.097 362.637c-.125-.133-.25-.133-.374-.266v-1.595h.374v1.861zm-.25-.266c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M140.093 363.036c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M140.093 363.169c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M140.468 363.17h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M140.468 363.169c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M139.72 362.903c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M139.845 363.036c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M143.587 363.036h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M143.338 363.169v-2.26h.374v2.26c-.125-.133-.249 0-.374 0zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M142.214 363.301h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M141.965 363.301v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.393v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M141.841 360.775v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M141.716 363.301h-.249v-2.658h.374v2.658h-.125zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M144.958 361.707c0 .133-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M144.709 362.504v-1.595h.374v.931c0 .133-.125.265-.249.531l-.125.133zm.125-1.462v1.063c0-.132.124-.265.124-.265l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M138.722 362.239c-.124-.132-.124-.265-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M138.722 362.372l-.125-.133c-.124-.133-.124-.266-.124-.399V360.777h.249v1.595zm-.125-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M144.335 362.637c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M143.961 362.903v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M142.589 363.302h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.215 363.302v-2.525h.374v2.525h-.374zm.125-2.392v2.259h.124l-.124-2.259c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M143.96 362.904c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M143.711 363.036v-2.26h.374v2.127c-.249 0-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M143.212 363.169h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M142.963 363.302v-2.393h.374v2.26c-.125 0-.249 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M142.837 363.169h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.588 363.302v-2.526h.374v2.393c-.125.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M141.716 359.314c1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596-1.871 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 362.505c-1.996 0-3.243-.931-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.931 3.244 1.595.124.665-1.248 1.596-3.244 1.596zm0-3.191c-1.871 0-3.119.798-3.119 1.463 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462.125-.665-1.248-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M143.837 361.973c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM141.965 362.371h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M142.839 362.239h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM141.217 362.239h.998-.998c-.125 0-.374 0-.499-.132-.125 0-.25-.133-.499-.133h.499c.125.265.249.265.499.265z"
            fill="#fff"
            />
            <path
            d="M146.706 363.701c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 366.227c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.249.797-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.576 365.296s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 365.562v-1.861h.374v1.595c-.124.133-.124.266-.374.266zm.25-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.708 363.834v2.392h-.249v-2.259c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M145.708 366.226h-.249v-2.392h.374v2.392h-.125zm-.124-.133l.124-2.126h-.124v2.126z"
            fill="#131A2D"
            />
            <path d="M146.083 366.226h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M146.083 366.226h-.249v-2.525h.374v2.525h-.125zm-.124-.132l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.335 365.695c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.335 365.828c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.332 366.226h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.457 366.226h-.25v-2.525h.374v2.525h-.124zm-.25-.132c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M143.962 365.429c-.124 0-.124-.133-.249-.133v-1.463h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 365.562c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M144.96 365.961c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.085 366.093c-.124 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.265s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.333 366.093h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M145.458 366.094c-.124 0-.249-.001-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.585 365.828c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.71 365.96c-.124 0-.249-.132-.249-.132v-1.994h.374v2.126h-.125zm-.249-.265c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 365.96h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M148.203 366.093v-2.26h.374v2.26c-.124-.133-.249 0-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.082 366.226h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M146.832 366.227v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.707 363.701v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.707 366.226h-.25v-2.658h.374v2.658h-.124zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M149.951 364.631c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 365.296v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.588 365.163c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.712 365.296l-.124-.133c-.125-.133-.125-.266-.125-.399V363.701h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.201 365.562c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.951 365.827v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.455 366.094h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.205 366.226v-2.525h.374v2.525h-.374zm.125-2.392v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M148.828 365.827c-.125 0-.125 0-.25.133v-1.993h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 365.961v-2.26h.374v2.127c-.124 0-.249.133-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.08 365.961h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M147.83 366.094v-2.393h.374v2.26c-.124.132-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M147.83 366.094h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.455 366.226v-2.525h.374v2.393c-.124.132-.124.132-.374.132zm.25-2.392v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.706 362.239c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 365.429c-1.996 0-3.243-.931-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .664-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.665-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M148.827 364.898c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM146.955 365.296h-.499l-2.37-2.526c.125-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.704 365.164h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM146.082 365.163h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.572 366.626c.374 0 .748 0 1.122.133h2.121v.797c0 .798-1.372 1.463-3.243 1.463-1.872 0-3.244-.798-3.244-1.463v-.797h2.121c.249-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.571 369.152c-1.871 0-3.118-.798-3.243-1.463V366.626h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.25.798-1.497 1.596-3.369 1.596zm-3.243-1.596c0 .665 1.372 1.463 3.119 1.463 1.871 0 3.118-.798 3.118-1.463v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M154.441 368.222s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 368.488v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.574 366.76v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.699 369.151h-.25v-2.392h.374v2.392h-.124zm-.25-.265c0 .132 0 .132 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M150.947 369.153h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M150.947 369.152h-.25v-2.525h.375v2.525h-.125zm-.125-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.201 368.621c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 368.753c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.322 369.153h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.322 369.152h-.25v-2.525h.375v2.525h-.125zm-.125-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M148.828 368.355c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M148.952 368.488c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M149.826 368.887c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M149.951 369.019c-.125 0-.25-.133-.25-.133v-2.126h.374v2.259h-.124zm-.25-.265c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.199 369.019h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.324 369.02c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.25-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.576 368.754c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 368.886c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.125-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.443 368.886h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.068 369.018v-2.259h.375v2.259c-.125-.132-.125-.132-.375 0zm.125-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M151.945 369.152h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M151.695 369.153v-2.659h.375v2.526c-.125.133-.25.133-.375.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.697 366.627v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 369.153h-.25v-2.659h.375v2.659h-.125zm-.125-.133c.125 0 .125 0 0 0l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M154.814 367.558c0 .132-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M154.564 368.222v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.453 368.089c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 368.222l-.125-.133c-.125-.133-.125-.266-.125-.399V366.627h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M154.066 368.488c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M153.816 368.753v-1.994h.375v1.861c-.125 0-.25 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.32 369.02h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.07 369.152v-2.525h.375v2.525h-.375zm.125-2.392v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M153.693 368.753c-.125 0-.125 0-.25.133v-1.993h.25v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 368.887v-2.26h.375v2.127c-.125 0-.25 0-.375.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.068 368.887h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M152.818 369.02v-2.393h.375v2.26c-.25.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.693 369.02h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.443 369.152v-2.525h.375v2.393c-.25.132-.25.132-.375.132zm.125-2.392v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.572 365.165c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 368.354c-1.996 0-3.244-.93-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.996 0 3.243.931 3.243 1.595 0 .665-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.798-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462 0-.664-1.372-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.692 367.822c-.249.133-.499.133-.748.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.658zM151.82 368.221h-.499l-2.37-2.526c.125-.132.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.57 368.089h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.132h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.132zM150.947 368.088h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.125 0 .374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.437 369.55c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 372.074c-1.871 0-3.119-.797-3.244-1.462V369.549h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.996a7.095 7.095 0 00-2.371 0h-1.996v.797h.125z"
            fill="#131A2D"
            />
            <path
            d="M159.306 371.145s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.057 371.41v-1.861h.374v1.595c-.125.133-.25.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.439 369.682v2.393h-.25v-2.26c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.564 372.075h-.25v-2.392h.375v2.392h-.125zm-.25-.266s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M155.812 371.942h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M155.937 372.075h-.249v-2.526h.374v2.526h-.125zm-.249-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.066 371.543c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 371.676c-.125-.133-.25-.132-.25-.132v-1.861h.375v1.993h-.125zm-.25-.265l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.187 372.075h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.187 372.074h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 371.278c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 371.41c-.125-.133-.25-.133-.375-.266v-1.595h.375v1.861zm-.25-.399c0 .133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M154.816 371.808c-.125 0-.125 0-.25-.132v-2.127h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 371.942c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.125-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.189 371.941h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M155.189 371.942c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.441 371.676c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 371.809c-.125 0-.25-.133-.25-.133v-1.993h.375v2.126h-.125zm-.125-.265l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.308 371.809h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.059 371.942v-2.259h.374v2.259c-.25-.133-.25-.133-.374 0zm.124-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M156.935 372.074h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.561 372.073v-2.658h.374v2.526c-.125.132-.25.132-.374.132zm.124-2.392v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.562 369.549v2.525h-.249v-2.525h.249s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 372.073h-.249v-2.658h.374v2.658h-.125zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M159.679 370.48c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.43 371.144v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.443 370.879c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 371.144l-.125-.133c-.125-.133-.125-.266-.125-.399V369.549h.25v1.595zm-.125-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M158.931 371.41c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.682 371.676v-1.993h.374v1.861c-.125 0-.125-.001-.374.132zm.124-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.185 371.943h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.936 372.075v-2.526h.374v2.393c-.125.133-.25.133-.374.133zm.124-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.683 371.544c-.125 0-.125-.001-.249.132v-1.993h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.309 371.808v-2.259h.374v1.994c-.125.133-.125.133-.374.265zm.124-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M157.933 371.809h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M157.684 371.942v-2.393h.374v2.26c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.56 371.942h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.311 372.075v-2.526h.374v2.393c-.125.133-.25.133-.374.133zm.124-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M156.437 368.087c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 371.277c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462 0-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.558 370.746c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.686 371.144h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.435 371.012h.125c.124 0 .249 0 .374-.133.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.132h-.748c.124 0 .249 0 .374-.132v-.133zM155.937 371.012h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M157.31 349.214c.374 0 .748 0 1.123.133h2.12v.798c0 .664-1.372 1.462-3.243 1.462-1.871 0-3.244-.798-3.244-1.462v-.798h2.121c.25 0 .624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 351.872c-1.871 0-3.119-.797-3.244-1.462V349.347h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c-.124.798-1.497 1.595-3.243 1.595zm-3.244-1.728c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M160.179 350.942s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.805 351.209v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.249-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.312 349.348v2.392h-.25v-2.259c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.312 351.74h-.25v-2.392h.375v2.392h-.125zm-.125-.133l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M156.687 351.74h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.687 351.739h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.939 351.208c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.939 351.341c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.935 351.74h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.06 351.873h-.249v-2.526h.374v2.526h-.125zm-.249-.266c.124.133.124.133 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.566 350.943c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 351.075c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.564 351.474c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.689 351.607c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.25-.266c0 .133.125.133 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.937 351.607h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M156.062 351.74c-.125 0-.25 0-.25-.133v-2.259h.375v2.392h-.125zm-.25-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M155.189 351.341c-.125 0-.125 0-.25-.132v-1.861h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M155.314 351.474c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266s.125.133 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M159.056 351.474h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.807 351.607v-2.26h.374v2.26h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.685 351.74h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M157.436 351.872v-2.658h.374v2.525c-.125.133-.25.133-.374.133zm.124-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M157.31 349.214v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M157.31 351.872h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.554 350.278c0 .133-.125.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M160.18 350.943v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M154.191 350.676c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 350.809l-.125-.133c-.125-.133-.125-.266-.125-.399V349.214h.25v1.595zm-.25-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.804 351.076c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 351.341v-1.993h.374v1.861c-.125 0-.25.132-.374.132zm.124-1.86v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M158.058 351.74h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 351.74v-2.526h.374v2.393c-.25.133-.25.133-.374.133zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M159.431 351.34c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.182 351.474v-2.26h.374v1.994c-.125.266-.25.266-.374.266zm.124-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.683 351.607h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M158.434 351.74v-2.392h.374v2.259c-.125 0-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M158.433 351.607h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M158.059 351.74v-2.526h.374v2.393c-.125.133-.125.133-.374.133zm.249-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M157.31 347.751c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.248-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M157.31 350.941c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.996 0 3.368.797 3.368 1.595 0 .797-1.497 1.595-3.368 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462 0-.665-1.373-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.431 350.542c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM157.559 350.941h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.308 350.674h.125c.124 0 .249 0 .374-.132.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.132h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.686 350.809h.997-.997c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.133.374.133.499.266z"
            fill="#fff"
            />
            <path
            d="M162.175 352.138c.374 0 .749 0 1.123.133h2.121v.797c0 .798-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.12c.25 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 354.795c-1.871 0-3.119-.797-3.244-1.462V352.27h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.249.798-1.497 1.595-3.368 1.595zm-3.244-1.728c0 .665 1.373 1.462 3.119 1.462 1.747 0 3.119-.797 3.119-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.124z"
            fill="#131A2D"
            />
            <path
            d="M165.044 353.733s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 354.131v-1.86h.374v1.595c-.125 0-.249.132-.374.265zm.125-1.728v1.463h.124l-.124-1.463z"
            fill="#131A2D"
            />
            <path
            d="M161.177 352.271v2.392h-.249v-2.26c.124-.132.249-.132.249-.132z"
            fill="#0EA59D"
            />
            <path
            d="M161.302 354.663h-.249v-2.392h.374v2.392h-.125zm-.249-.133l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M161.552 354.663h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.552 354.663h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.804 354.131c-.125 0-.125-.133-.249-.133v-1.727h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M159.804 354.264c-.125-.133-.249-.133-.249-.133v-1.86h.374v1.993h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.925 354.663h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.925 354.796h-.249v-2.525h.374v2.525h-.125zm-.124-.266l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.431 353.866c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 353.999c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.429 354.397c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.554 354.53c-.125 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.266c.124 0 .124.133 0 0l.124-1.993h-.124v1.993z"
            fill="#131A2D"
            />
            <path d="M160.802 354.53h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M160.927 354.663c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.266s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M160.179 354.264c-.125 0-.125 0-.249-.133v-1.86h.249v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M160.179 354.397c-.125-.133-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.125-.266l.125-1.86h-.125v1.86z"
            fill="#131A2D"
            />
            <path d="M163.921 354.397h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M163.672 354.53v-2.259h.374v2.259h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.55 354.663h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M162.301 354.796v-2.659h.374v2.526c-.125 0-.249 0-.374.133zm.125-2.526v2.393h.124l-.124-2.393c.124 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path d="M162.175 352.138v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M162.175 354.796h-.249v-2.659h.374v2.659h-.125zm-.124-.133l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M165.419 353.201c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M165.17 353.866v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.463v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M159.056 353.6c-.124-.133-.124-.266-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 353.732l-.125-.133c-.124-.133-.124-.266-.124-.398v-1.064h.249v1.595zm-.249-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M164.669 353.998c-.124 0-.124.133-.249.133v-1.86h.249v1.727z"
            fill="#0EA59D"
            />
            <path
            d="M164.42 354.264v-1.993h.374v1.86c-.125 0-.249 0-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.923 354.663h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.674 354.663v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 354.265c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.047 354.397v-2.259h.374v2.126c-.125.133-.249.133-.374.133zm.125-1.993v1.86h.124l-.124-1.86z"
            fill="#131A2D"
            />
            <path d="M163.671 354.53h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M163.422 354.663v-2.392h.374v2.259c-.249 0-.249 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.298 354.53h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M163.049 354.663v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127c0 .133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M162.175 350.676c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M162.175 353.866c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.373 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.798-3.119 1.462 0 .665 1.373 1.462 3.119 1.462 1.747 0 3.119-.797 3.119-1.462 0-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.296 353.334c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM162.424 353.733h-.499l-2.37-2.526c.124-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M163.173 353.6h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.553 353.733h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.133.374.133.499.266z"
            fill="#fff"
            />
            <path
            d="M167.04 355.062c.375 0 .749 0 1.123.132h2.121v.798c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.798h2.121c.374 0 .748-.132 1.122-.132z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 357.587c-1.871 0-3.118-.797-3.243-1.462V355.062h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.93-1.497 1.595-3.369 1.595zm-3.118-1.595c0 .665 1.372 1.462 3.118 1.462 1.747 0 3.119-.797 3.119-1.462v-.665h-1.996c-.748-.132-1.622-.132-2.245 0h-1.996v.665z"
            fill="#131A2D"
            />
            <path
            d="M169.91 356.657s-.125.132-.25.132v-1.727h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 357.055v-1.861h.374v1.595c-.124 0-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M166.042 355.194v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.167 357.587h-.249v-2.393h.374v2.393h-.125zm-.249-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.416 357.587h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M166.541 357.587h-.25v-2.525h.374v2.525h-.124zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.669 357.055c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 357.188c-.124-.133-.249-.133-.249-.133v-1.86h.374v1.993h-.125zm-.249-.265l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.791 357.587h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M166.791 357.587h-.25v-2.525h.374v2.525h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.296 356.79c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.421 356.922c-.125-.133-.249-.133-.374-.265v-1.595h.374v1.86zm-.249-.265s.124 0 0 0l.124-1.33h-.124v1.33z"
            fill="#131A2D"
            />
            <path
            d="M165.419 357.321c-.124 0-.124 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M165.419 357.454c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.124-.266l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M165.792 357.454h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.792 357.587c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M165.044 357.188c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M165.044 357.321c-.124 0-.249-.133-.249-.133v-1.993h.374v2.126h-.125zm-.124-.266l.124-1.86h-.124v1.86z"
            fill="#131A2D"
            />
            <path d="M168.912 357.321h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.662 357.454v-2.259h.374v2.259c-.249-.133-.249 0-.374 0zm.125-2.126v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M167.539 357.586h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M167.164 357.586v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.392v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M167.166 355.061v2.525h-.25v-2.525h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M167.041 357.586h-.25v-2.658h.374v2.658h-.124zm0-.133l.124-2.392h-.124v2.392z"
            fill="#131A2D"
            />
            <path
            d="M170.283 355.992c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M170.033 356.79v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M164.047 356.523c-.125-.132-.125-.265-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M164.046 356.657l-.124-.133c-.125-.133-.125-.266-.125-.399V355.062h.249v1.595zm-.124-.665v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.535 356.922c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.285 357.188v-1.993h.374v1.86c-.124 0-.124 0-.374.133zm.125-1.86v1.727h.125l-.125-1.727z"
            fill="#131A2D"
            />
            <path d="M167.789 357.587h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M167.539 357.587v-2.525h.374v2.392c-.124.133-.249.133-.374.133zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M169.287 357.188c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 357.321v-2.259h.374v2.126c-.124 0-.124.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.537 357.454h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.287 357.587v-2.392h.374v2.259c-.124 0-.249 0-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M168.164 357.454h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M167.914 357.588v-2.526h.374v2.393c-.124.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M167.04 353.6c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M167.04 356.791c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.797-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462.125-.665-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M169.161 356.258c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM167.289 356.656h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M168.038 356.524h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.398-.125.265-.249.398-.499.531l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.541 356.524h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.249.266.499.266z"
            fill="#fff"
            />
            <path
            d="M171.906 357.985c.374 0 .748 0 1.122.133h2.121v.798c0 .797-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.374 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.906 360.511c-1.872 0-3.119-.798-3.244-1.462v-1.064h2.121a7.142 7.142 0 012.37 0h2.121v.931c-.125.93-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.871a7.089 7.089 0 00-2.37 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M174.775 359.582s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M174.525 359.981v-1.861h.375v1.595c-.125 0-.125.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.033 358.119v2.393h-.25v-2.26c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M171.033 360.513h-.25v-2.393h.374v2.393h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M171.281 360.512h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M171.406 360.513h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.535 359.98c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M169.66 360.113c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s.125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M171.656 360.513h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M171.781 360.513h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M169.287 359.715c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.286 359.848c-.124-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.266c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M170.285 360.247c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M170.41 360.38c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.25-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M170.658 360.38h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M170.658 360.38c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M169.91 360.113c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M170.035 360.246c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M173.777 360.246h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M173.527 360.379v-2.26h.375v2.26c-.125-.133-.25 0-.375 0zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M172.404 360.513h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M172.154 360.513v-2.659h.375v2.526c-.25.133-.25.133-.375.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M172.031 357.987v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M171.906 360.513h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M175.148 358.916c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M174.898 359.714v-1.595h.375v.931c0 .133-.125.265-.25.531l-.125.133zm.125-1.462v1.063c0-.133.125-.132.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M168.912 359.449c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M168.912 359.582l-.125-.133c-.125-.132-.125-.265-.125-.398v-1.064h.25v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M174.525 359.847c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M174.15 360.113v-1.994h.375v1.861c-.125 0-.125 0-.375.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M172.779 360.513h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M172.404 360.513v-2.526h.375v2.526h-.375zm.125-2.393v2.26h.125l-.125-2.26c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M174.15 360.114c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M173.9 360.247v-2.26h.375v2.127c-.25 0-.25.133-.375.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M173.402 360.379h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M173.152 360.512v-2.393h.375v2.26c-.125 0-.25 0-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M173.029 360.38h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M172.779 360.513v-2.525h.375v2.392c-.125.133-.25.133-.375.133zm.125-2.393v2.127h.125l-.125-2.127c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M171.906 356.524c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M171.905 359.715c-1.996 0-3.368-.798-3.368-1.596 0-.797 1.372-1.595 3.368-1.595 1.996 0 3.244.798 3.244 1.595 0 .798-1.248 1.596-3.244 1.596zm0-3.191c-1.871 0-3.118.798-3.118 1.463 0 .664 1.247 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462.125-.665-1.247-1.463-3.119-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M174.026 359.183c-.249.133-.499.133-.748.266l-2.62-2.792c.25 0 .499-.133.749-.133l2.619 2.659zM172.279 359.581h-.499l-2.37-2.525c.125-.133.25-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M173.029 359.449h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM171.406 359.448h.998-.998c-.125 0-.374 0-.499-.132-.125 0-.249-.133-.499-.133h.499c.125 0 .374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M152.07 352.669c.374 0 .748 0 1.122.133h2.121v.798c0 .664-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 355.195c-1.872 0-3.119-.798-3.244-1.462v-1.064h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.931c0 .797-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M154.939 354.264s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 354.53v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M151.072 352.669v2.393h-.25v-2.26c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.197 355.062h-.25v-2.393h.375v2.393h-.125zm-.25-.133s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M151.445 355.062h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.57 355.194h-.25v-2.525h.375v2.525h-.125zm-.25-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.699 354.53c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.824 354.663c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.266s0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.82 355.062h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.945 355.194h-.25v-2.525h.375v2.525h-.125zm-.25-.132l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.326 354.397c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.45 354.53c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399s.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.449 354.929c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M150.449 354.929c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.822 354.929h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.822 355.062c-.125 0-.25 0-.25-.133v-2.26h.375v2.393h-.125zm-.25-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M150.074 354.796c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 354.796c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.25-.133l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.941 354.796h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.691 354.929v-2.26h.375v2.26h-.375zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.57 355.062h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.195 355.195v-2.659h.375v2.526c-.125.133-.125.133-.375.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M152.195 352.669v2.526h-.25v-2.526h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 355.195h-.125v-2.659h.375v2.659h-.25zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.314 353.6c0 .132-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 354.264v-1.595h.375v.931c0 .133-.125.265-.25.531l-.125.133zm.125-1.462v1.063c0-.132.125-.132.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M149.076 353.999c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M149.076 354.264l-.125-.132c-.125-.133-.125-.266-.125-.399v-1.064h.25v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M154.564 354.53c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.314 354.796v-2.127h.375v1.861c-.125.133-.125.133-.375.266zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.818 355.062h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.568 355.195v-2.526h.375v2.526h-.375zm.125-2.526v2.26h.125l-.125-2.26c.125.133 0 .133 0 0z"
            fill="#131A2D"
            />
            <path
            d="M154.316 354.663c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 354.929v-2.26h.375v1.994c-.125.133-.125.133-.375.266zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.566 354.929h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M153.316 355.062v-2.393h.375v2.26c-.125.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M153.193 355.062h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.943 355.195v-2.526h.375v2.393c-.125 0-.25 0-.375.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M152.07 351.074c1.871 0 3.243.798 3.243 1.596 0 .797-1.372 1.595-3.243 1.595-1.872 0-3.244-.798-3.244-1.595 0-.798 1.372-1.596 3.244-1.596z"
            fill="#0EA59D"
            />
            <path
            d="M152.07 354.265c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.372-1.596 3.244-1.596 1.996 0 3.368.798 3.368 1.596 0 .797-1.372 1.595-3.368 1.595zm0-3.058c-1.872 0-3.119.798-3.119 1.463 0 .664 1.372 1.462 3.119 1.462 1.871 0 3.118-.798 3.118-1.462 0-.665-1.247-1.463-3.118-1.463z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M154.191 353.865c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM152.318 354.264h-.499l-2.37-2.526c.125-.133.25-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M153.068 354.132h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.132h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.132zM151.57 354.131h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125 0 .25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.935 355.595c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.463-3.243 1.463-1.871 0-3.244-.798-3.244-1.463v-.797h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 358.12c-1.871 0-3.119-.797-3.244-1.462V355.595h2.121c.374-.133.749-.133 1.123-.133s.748 0 1.123.133h2.12v.93c0 .798-1.372 1.595-3.243 1.595zm-3.119-1.595c0 .665 1.372 1.462 3.119 1.462 1.746 0 3.119-.797 3.119-1.462v-.797h-1.872a7.089 7.089 0 00-2.37 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.804 357.19s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.555 357.456v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M156.062 355.595v2.392h-.25v-2.259c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.062 357.988h-.25v-2.393h.375v2.393h-.125zm-.125-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.312 357.987h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.437 358.12h-.249v-2.525h.374v2.525h-.125zm-.249-.266c.124.133.124.133 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.564 357.455c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.689 357.589c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.687 357.987h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M156.812 358.12h-.25v-2.525h.375v2.525h-.125zm-.25-.133s.125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.316 357.323c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.316 357.456c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.125-.399s0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.314 357.854c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M155.439 357.854c-.125 0-.25-.133-.25-.133v-2.126h.375v2.259h-.125zm-.25-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M155.687 357.854h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M155.687 357.987c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.266c0 .133 0 .133 0 0l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M154.939 357.721c-.125 0-.125 0-.25-.133v-1.86h.25v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M155.064 357.721c-.125 0-.25-.132-.25-.132v-1.994h.375v2.126h-.125zm-.25-.132s.125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.806 357.721h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M158.557 357.854v-2.26h.374v2.26h-.374zm.124-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M157.433 357.987h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M157.184 358.121v-2.659h.374v2.526c-.25.133-.25.133-.374.133zm.124-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M157.06 355.596v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M156.935 358.121h-.249v-2.658h.374v2.658h-.125c.125 0 .125 0 0 0zm0-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M160.179 356.525c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.93 357.19v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.941 356.924c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.941 357.19l-.125-.133c-.125-.133-.125-.266-.125-.399V355.595h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M159.554 357.456c-.125 0-.125.132-.249.132v-1.86h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M159.305 357.588v-1.994h.374v1.861c-.25 0-.25.133-.374.133zm.124-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.808 357.987h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.559 358.12v-2.525h.374v2.525h-.374zm.124-2.525v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.181 357.588c-.125 0-.125 0-.249.133v-1.993h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 357.854v-2.259h.374v2.126c-.125 0-.25 0-.374.133zm.124-2.126v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.433 357.854h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M158.184 357.987v-2.393h.374v2.26c-.125.133-.25.133-.374.133zm.124-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M158.058 357.988h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.809 357.988v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.259v2.126h.125l-.125-2.126c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.935 353.998c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.797 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.935 357.188c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.373-1.595 3.244-1.595 1.871 0 3.243.798 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462.124-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M159.056 356.79c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .498-.133.748-.133l2.62 2.658zM157.311 357.189h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M158.058 357.055h.125c.124 0 .249 0 .374-.133.125 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.132s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.437 357.056h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125 0 .375.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.925 358.517c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 361.042c-1.871 0-3.119-.797-3.243-1.462V358.517h2.12c.375-.133.749-.133 1.123-.133s.749 0 1.123.133h2.121v.93c-.125.798-1.373 1.595-3.244 1.595zm-3.243-1.595c0 .665 1.372 1.463 3.118 1.463 1.747 0 3.119-.798 3.119-1.463v-.797h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M164.794 360.112s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.545 360.378v-1.861h.374v1.595c-.125.133-.249.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.927 358.517v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.927 360.909h-.249v-2.392h.374v2.392h-.125zm-.125-.132l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.3 360.909h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.3 361.042h-.249v-2.525h.374v2.525h-.125zm-.124-.266l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.556 360.378c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.556 360.511c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M161.675 360.909h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.675 361.042h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.181 360.245c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.181 360.378c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.125-.399l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M160.179 360.644c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M160.304 360.777c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133s.124 0 0 0l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path d="M160.552 360.776h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M160.677 360.909c-.125 0-.249 0-.249-.132v-2.26h.374v2.392h-.125zm-.249-.265l.124-1.994h-.124v1.994z"
            fill="#131A2D"
            />
            <path
            d="M159.929 360.643c-.125 0-.125 0-.249-.132v-1.861h.249v1.993z"
            fill="#0EA59D"
            />
            <path
            d="M159.929 360.644c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.671 360.644h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M163.422 360.777v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.3 360.91h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M162.051 361.042v-2.658h.374v2.526c-.125.132-.249.132-.374.132zm.125-2.525v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M161.925 358.517v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M161.925 361.042h-.249v-2.658h.374v2.658h-.125zm-.124-.132s.124 0 0 0l.124-2.393h-.124v2.393z"
            fill="#131A2D"
            />
            <path
            d="M165.169 359.447c0 .133-.124.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M164.795 360.112v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.266l-.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M158.806 359.846c-.124-.133-.124-.266-.124-.399v-.797h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M158.931 360.112l-.125-.133c-.124-.133-.124-.266-.124-.399V358.517h.249v1.595zm-.249-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M164.419 360.378c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M164.17 360.511v-1.994h.374v1.861c-.125 0-.249.133-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.673 360.909h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.424 361.042v-2.525h.374v2.525c-.249-.133-.249 0-.374 0zm.125-2.525v2.259h.124l-.124-2.259z"
            fill="#131A2D"
            />
            <path
            d="M164.046 360.512c-.124 0-.124 0-.249.132v-1.993h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.797 360.644v-2.26h.374v2.127c-.125.133-.249.133-.374.133zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 360.777h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M163.049 360.909v-2.392h.374v2.26c-.125.132-.125.132-.374.132zm.125-2.259v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M163.048 360.91h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M162.799 360.91v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M161.925 356.922c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.925 360.112c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595zm0-3.057c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462 0-.665-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M164.046 359.714c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM162.176 360.112h-.499l-2.37-2.526c.124-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.923 359.979h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.265.624-.398-.125.265-.25.398-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.301 359.98h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M166.79 361.443c.375 0 .749 0 1.123.133h2.121v.797c0 .665-1.372 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.121c.374-.133.748-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 363.968c-1.871 0-3.118-.798-3.243-1.462v-1.064h2.121c.374-.132.748-.132 1.122-.132.375 0 .749 0 1.123.132h2.121v.931c-.125.797-1.372 1.595-3.244 1.595zm-3.118-1.595c0 .665 1.372 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462v-.798h-1.996c-.374-.133-.748-.133-1.123-.133-.374 0-.748 0-1.122.133h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M169.66 363.038s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M169.41 363.304v-1.861h.374v1.595c-.124 0-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M165.792 361.443v2.393h-.249v-2.26c.125-.133.249-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M165.917 363.836h-.249v-2.393h.374v2.393h-.125zm-.249-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M166.167 363.836h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M166.292 363.969h-.249v-2.526h.374v2.526h-.125zm-.249-.266l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.419 363.304c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M164.544 363.437c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M166.541 363.836h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M166.541 363.969h-.25v-2.526h.374v2.526h-.124zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M164.046 363.171c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.171 363.304c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M165.169 363.57c-.124 0-.124 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M165.169 363.703c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M165.417 363.703h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M165.542 363.836c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.266s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M164.794 363.437c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M164.794 363.57c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.124-.266c0 .133 0 .133 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M168.662 363.57h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M168.287 363.703v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M167.166 363.836h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M166.916 363.97v-2.658h.374v2.525c-.124.133-.249.133-.374.133zm.125-2.526v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M166.916 361.443v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M166.791 363.969h-.25v-2.658h.374v2.658h-.124zm-.125-.133c.125 0 .125 0 0 0l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M170.035 362.374c0 .133-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M169.785 363.038v-1.595h.374v.931c0 .133-.124.266-.249.531l-.125.133zm.125-1.462v1.064c0-.133.125-.133.125-.266l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M163.672 362.773c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M163.796 362.906l-.124-.133c-.125-.133-.125-.266-.125-.399V361.311h.249v1.595zm-.124-.532v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M169.285 363.304c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.035 363.437v-1.994h.374v1.861c-.124 0-.249.133-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M167.539 363.836h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M167.289 363.969v-2.526h.374v2.526c-.124-.133-.249-.133-.374 0zm.125-2.526v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M168.912 363.437c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M168.662 363.57v-2.259h.374v2.126c-.124.133-.124.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M168.289 363.703h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M168.039 363.836v-2.393h.374v2.26c-.249 0-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M167.914 363.702h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M167.664 363.836v-2.525h.374v2.392c-.124.133-.249.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M166.79 359.848c1.872 0 3.244.797 3.244 1.595 0 .797-1.372 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M166.79 363.038c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.931 3.244 1.595 0 .665-1.248 1.596-3.244 1.596zm0-3.058c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.463 3.118 1.463 1.872 0 3.119-.798 3.119-1.463 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.911 362.639c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM167.039 363.037h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M167.788 362.905h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM166.166 362.905h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.249.133.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M146.956 355.991c.375 0 .749 0 1.123.133h2.121v.798c0 .664-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.249-.133.623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 358.517c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.249.797-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.826 357.586s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 357.852v-1.861h.374v1.595c-.124.133-.249.133-.374.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.958 356.123v2.393h-.249v-2.26c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.083 358.516h-.249v-2.393h.374v2.393h-.125zm-.249-.266s0 .133 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M146.333 358.384h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M146.333 358.517h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.585 357.984c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.585 358.117c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.707 358.518h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M146.707 358.517h-.25v-2.526h.374v2.526h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.212 357.72c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 357.852c-.125-.133-.249-.133-.374-.266v-1.595h.374v1.861zm-.249-.266l.124-1.329h-.124v1.329z"
            fill="#131A2D"
            />
            <path
            d="M145.21 358.251c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.335 358.385c-.124 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.249-.266s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.583 358.385h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M145.708 358.384c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.249-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.96 358.117c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.96 358.25c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.703 358.25h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.453 358.383v-2.26h.374v2.26c-.124-.133-.249-.133-.374 0zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.332 358.518h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M147.082 358.518v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.957 355.992v2.526h-.25v-2.526h.25z" fill="#0EA59D" />
            <path
            d="M146.957 358.518h-.25v-2.659h.374v2.659h-.124zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M150.201 356.923c0 .132-.125.398-.25.531v-1.329h.25v.798z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 357.586v-1.595h.374v.931c0 .133-.124.266-.249.531l-.125.133zm.125-1.462v1.063c0-.132.125-.132.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M143.838 357.322c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 357.586l-.124-.133c-.125-.133-.125-.265-.125-.398v-1.064h.249v1.595zm-.249-.664v.265-.93.665z"
            fill="#131A2D"
            />
            <path
            d="M149.453 357.851c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M149.203 358.117v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.705 358.384h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.455 358.517v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 358.119c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 358.251v-2.26h.374v2.127c-.124 0-.249 0-.374.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.455 358.251h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M148.08 358.384v-2.393h.374v2.26c-.124.133-.124.133-.374.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M148.08 358.384h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.83 358.517v-2.526h.374v2.393c-.249.133-.249.133-.374.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.956 354.529c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.956 357.719c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.872 0 3.244.798 3.244 1.595 0 .665-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.664-1.372-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M149.077 357.188c-.249.133-.499.133-.748.266l-2.62-2.792c.249 0 .499-.133.748-.133l2.62 2.659zM147.205 357.586h-.499l-2.37-2.525c.125-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.954 357.454h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.133h-.749c.125 0 .25 0 .374-.133v-.133zM146.332 357.453h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.125 0 .374.265.499.265z"
            fill="#fff"
            />
            <path
            d="M151.822 358.916c.374 0 .748 0 1.122.133h2.121v.797c0 .665-1.372 1.463-3.243 1.463-1.872 0-3.244-.798-3.244-1.463v-.797h2.121c.374-.133.748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 361.441c-1.872 0-3.119-.798-3.244-1.463V358.915h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.25.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.746 0 3.118-.798 3.118-1.462v-.798h-1.996c-.748-.133-1.621-.133-2.245 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M154.691 360.512s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 360.778v-1.861h.375v1.595c-.125.133-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.824 359.05v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.949 361.442h-.25v-2.392h.374v2.392h-.124zm-.25-.265s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M151.197 361.309h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M151.322 361.442h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M149.451 360.911c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 361.044c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.25-.399c0 .133 0 .133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.572 361.443h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.572 361.443h-.25v-2.526h.375v2.526h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.078 360.645c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.202 360.778c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.399c0 .133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M150.199 361.176c-.125 0-.125 0-.25-.133v-2.126h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M150.199 361.309c-.125 0-.25-.132-.25-.132v-2.127h.374v2.259h-.124zm-.125-.265l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.449 361.31h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M150.574 361.31c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.826 361.044c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.826 361.177c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.125-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.693 361.043h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M153.318 361.309v-2.259h.375v2.259c-.125-.132-.125-.132-.375 0zm.25-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M152.195 361.443h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M151.945 361.443v-2.659h.375v2.526c-.125.133-.25.133-.375.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.947 358.917v2.525h-.25v-2.525h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 361.443h-.25v-2.659h.375v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M155.064 359.847c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.814 360.512v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.703 360.246c-.125-.133-.125-.266-.125-.398v-.798h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.828 360.512l-.125-.133c-.125-.133-.125-.265-.125-.398v-1.064h.25v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M154.316 360.778c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M154.066 361.044v-1.994h.375v1.861c-.125 0-.25 0-.375.133zm.125-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.57 361.31h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.32 361.443v-2.526h.375v2.393c-.125.133-.25.133-.375.133zm.125-2.393v2.26h.125l-.125-2.26c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M153.943 360.911c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 361.177v-2.26h.375v2.127c-.125 0-.125 0-.375.133zm.125-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.318 361.176h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M153.068 361.31v-2.393h.375v2.26c-.25.133-.25.133-.375.133zm.125-2.26v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.945 361.309h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M152.695 361.442v-2.525h.375v2.393c-.125 0-.25.132-.375.132zm.125-2.392v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.822 357.321c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.822 360.644c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.871 0 3.243.798 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.798-3.119 1.462 0 .665 1.372 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462 0-.664-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.942 360.113c-.249.132-.499.132-.748.265l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.659zM152.07 360.511h-.499l-2.37-2.526c.125-.132.25-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.82 360.379h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.132h-.25c-.125 0-.249.001-.374.133h-.749c.125 0 .25 0 .375-.133v-.132zM151.197 360.379h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.687 361.84c.374 0 .748 0 1.123.133h2.12v.797c0 .665-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 364.365c-1.871 0-3.119-.797-3.244-1.462V361.84h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.125.798-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .665 1.372 1.463 3.119 1.463 1.871 0 3.119-.798 3.119-1.463v-.797h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.797z"
            fill="#131A2D"
            />
            <path
            d="M159.556 363.436s-.125.133-.249.133v-1.595h.249v1.462z"
            fill="#0EA59D"
            />
            <path
            d="M159.307 363.701v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.814 361.84v2.392h-.25v-2.259s.125 0 .25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.814 364.366h-.25v-2.392h.375v2.392h-.125zm-.25-.265c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M156.064 364.233h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M156.189 364.366h-.25v-2.526h.375v2.526h-.125zm-.25-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.316 363.835c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 363.834c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266c0 .133.125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.437 364.366h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.562 364.366h-.25v-2.526h.375v2.526h-.125zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M154.068 363.569c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.068 363.701c-.125-.133-.25-.133-.375-.266v-1.595h.375v1.861zm-.25-.399c.125.133.125.133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M155.066 364.1c-.125 0-.125 0-.25-.133v-1.993h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M155.066 364.1c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.133l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.439 364.1h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M155.439 364.232c-.125 0-.25 0-.25-.132v-2.26h.375v2.392h-.125zm-.125-.132l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.691 363.968c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 364.101c-.125 0-.25-.133-.25-.133v-1.994h.375v2.127h-.125zm-.25-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.558 363.968h-.249v-1.994h.249v1.994z" fill="#0EA59D" />
            <path
            d="M158.309 364.233v-2.259h.374v2.259c-.125-.133-.25-.133-.374 0zm.124-2.259v1.993h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M157.185 364.233h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M156.936 364.365v-2.658h.374v2.526c-.25.132-.25.132-.374.132zm.124-2.525v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M156.812 361.84v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M156.687 364.365h-.249v-2.658h.374v2.658h-.125zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M159.931 362.771c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.682 363.435v-1.595h.374v.931c0 .132-.125.265-.25.531l-.124.133zm.124-1.462v1.063c0-.133.125-.265.125-.265l-.125-.798z"
            fill="#131A2D"
            />
            <path
            d="M153.693 363.17c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M153.693 363.435l-.125-.133c-.125-.133-.125-.266-.125-.399V361.84h.25v1.595zm-.125-.665v.266-1.063.797z"
            fill="#131A2D"
            />
            <path
            d="M159.306 363.701c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.932 363.967v-1.993h.374v1.861c-.125 0-.125 0-.374.132zm.124-1.993v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.56 364.232h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.186 364.365v-2.525h.374v2.525h-.374zm.124-2.392v2.259h.125l-.125-2.259c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.933 363.835c-.125 0-.125 0-.249.132v-1.993h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.684 364.1v-2.26h.374v2.127c-.25 0-.25 0-.374.133zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M158.183 364.1h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M157.934 364.232v-2.392h.374v2.26c-.125.132-.25.132-.374.132zm.124-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.81 364.233h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M157.561 364.365v-2.525h.374v2.392c-.125 0-.25.133-.374.133zm.124-2.392v2.127h.125l-.125-2.127c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.687 360.245c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.871 0-3.244-.797-3.244-1.595 0-.664 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.687 363.568c-1.996 0-3.369-.798-3.369-1.595 0-.798 1.373-1.595 3.369-1.595 1.996 0 3.243.93 3.243 1.595.125.665-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.797-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462.125-.665-1.247-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.808 363.037c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.936 363.436h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.81 363.302h.125c.124 0 .249 0 .374-.133.125 0 .249-.132.374-.132h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.132s-.125 0-.125.133h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133h-.748c.124 0 .249 0 .374-.133v-.133zM156.187 363.303h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M161.677 364.766c.374 0 .749 0 1.123.133h2.121v.797c0 .665-1.373 1.462-3.244 1.462-1.871 0-3.243-.797-3.243-1.462v-.797h2.12c.25-.133.624-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 367.291c-1.871 0-3.119-.797-3.244-1.462V364.766h2.121a7.089 7.089 0 012.37 0h2.121v.93c-.249.798-1.622 1.595-3.368 1.595zm-3.244-1.595c0 .665 1.373 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462v-.797h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.797h.124z"
            fill="#131A2D"
            />
            <path
            d="M164.546 366.359s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M164.172 366.625v-1.861h.374v1.595c-.125.133-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M160.679 364.765v2.392h-.249v-2.259c.124 0 .124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M160.679 367.29h-.249v-2.393h.374v2.393h-.125zm-.125-.266l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M161.052 367.156h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M161.052 367.289h-.249v-2.525h.374v2.525h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.259h-.124v2.259z"
            fill="#131A2D"
            />
            <path
            d="M159.306 366.757c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M159.306 366.757c-.125-.132-.249-.132-.249-.132v-1.861h.374v1.993h-.125zm-.249-.265c.124 0 .124.133 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M161.302 367.157h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M161.427 367.289h-.249v-2.659h.374v2.659h-.125zm-.249-.133s.124 0 0 0l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M158.933 366.492c-.125 0-.125-.133-.249-.133v-1.463h.249v1.596z"
            fill="#0EA59D"
            />
            <path
            d="M158.933 366.625c-.125-.133-.25-.133-.374-.266v-1.595h.374v1.861zm-.125-.399s0 .133 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M159.929 367.024c-.125 0-.125 0-.249-.133v-2.126h.249v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M160.054 367.023c-.125 0-.249-.133-.249-.133v-2.126h.374v2.259h-.125zm-.249-.133l.124-1.993h-.124v1.993z"
            fill="#131A2D"
            />
            <path d="M160.304 367.023h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M160.304 367.156c-.125 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.125-.133l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path
            d="M159.556 366.891c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M159.681 367.023c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266s.124 0 0 0l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M163.423 366.891h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M163.174 367.157v-2.26h.374v2.26c-.125-.133-.249-.133-.374 0zm.125-2.26v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M162.05 367.156h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M161.801 367.289v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.525v2.392h.124l-.124-2.392z"
            fill="#131A2D"
            />
            <path d="M161.677 364.765v2.525h-.249v-2.525h.249z" fill="#0EA59D" />
            <path
            d="M161.677 367.289h-.249v-2.658h.374v2.658h-.125zm-.125-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M164.921 365.694c0 .133-.124.399-.249.532v-1.33h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M164.547 366.359v-1.595h.374v.93c0 .133-.125.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.124-.133.124-.266l-.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M158.558 366.093c-.124-.133-.124-.266-.124-.399v-.798h.124v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M158.558 366.359l-.125-.133c-.124-.133-.124-.266-.124-.399V364.764h.249v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M164.171 366.625c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M163.922 366.891v-1.994h.374v1.861c-.125 0-.249 0-.374.133zm.125-1.994v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M162.425 367.157h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.176 367.289v-2.658h.374v2.525c-.249.133-.249.133-.374.133zm.125-2.392v2.259h.124l-.124-2.259z"
            fill="#131A2D"
            />
            <path
            d="M163.796 366.757c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M163.547 367.023v-2.259h.374v2.126c-.125 0-.249 0-.374.133zm.125-2.126v1.86h.124l-.124-1.86z"
            fill="#131A2D"
            />
            <path d="M163.048 367.024h-.249v-2.259h.249v2.259z" fill="#0EA59D" />
            <path
            d="M162.799 367.156v-2.392h.374v2.259c-.125.133-.249.133-.374.133zm.125-2.259v2.126h.124l-.124-2.126z"
            fill="#131A2D"
            />
            <path d="M162.8 367.156h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M162.426 367.289v-2.525h.374v2.392c-.125 0-.125 0-.374.133zm.125-2.392v2.126h.124l-.124-2.126c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M161.677 363.17c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M161.677 366.36c-1.996 0-3.243-.798-3.243-1.596 0-.797 1.372-1.595 3.243-1.595 1.871 0 3.244.798 3.244 1.595 0 .798-1.373 1.596-3.244 1.596zm0-3.058c-1.871 0-3.119.798-3.119 1.462 0 .665 1.373 1.463 3.119 1.463 1.747 0 3.119-.798 3.119-1.463 0-.664-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M163.673 365.961c-.25.133-.499.133-.749.266l-2.619-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM161.926 366.36h-.499l-2.37-2.526c.124-.133.249-.133.374-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M162.675 366.227h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.132.374-.265.624-.398a1.01 1.01 0 01-.499.531l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM161.053 366.227h.998-.998c-.125 0-.375 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.124.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M141.716 359.315c.374 0 .749 0 1.123.133h2.121v.798c0 .664-1.373 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.12c.375 0 .749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 361.974c-1.871 0-3.119-.798-3.243-1.462v-1.064h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.124.797-1.497 1.595-3.368 1.595zm-3.119-1.728c0 .664 1.373 1.462 3.119 1.462 1.747 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.124z"
            fill="#131A2D"
            />
            <path
            d="M144.585 360.91s-.124.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M144.336 361.309v-1.861h.374v1.595c-.125 0-.125.133-.374.266zm.125-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M140.843 359.449v2.393h-.249v-2.26c.124-.133.124-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M140.843 361.841h-.249v-2.393h.374v2.393h-.125zm-.249-.133c.124 0 .124 0 0 0l.124-2.127h-.124v2.127z"
            fill="#131A2D"
            />
            <path d="M141.091 361.841h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M141.216 361.841h-.249v-2.526h.374v2.526h-.125zm-.249-.133s.125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.345 361.31c-.125 0-.125-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M139.47 361.442c-.125-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.249-.266s.124 0 0 0l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M141.466 361.841h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M141.591 361.974h-.249v-2.659h.374v2.659h-.125zm-.249-.266l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M139.097 361.043c-.125 0-.125-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M139.097 361.176c-.125-.133-.25-.266-.374-.266v-1.595h.374v1.861zm-.25-.266c.125 0 .125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M140.095 361.575c-.125 0-.125 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M140.095 361.708c-.125 0-.249-.133-.249-.133v-2.127h.374v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M140.468 361.708h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M140.468 361.841c-.124 0-.249 0-.249-.133v-2.26h.374v2.393h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M139.72 361.443c-.125 0-.125 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M139.845 361.575c-.125 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266l.124-1.861h-.124v1.861z"
            fill="#131A2D"
            />
            <path d="M143.587 361.576h-.249v-2.127h.249v2.127z" fill="#0EA59D" />
            <path
            d="M143.338 361.708v-2.26h.374v2.26h-.374zm.125-2.127v1.994h.124l-.124-1.994z"
            fill="#131A2D"
            />
            <path d="M142.214 361.841h-.249v-2.526h.249v2.526z" fill="#0EA59D" />
            <path
            d="M141.965 361.974v-2.659h.374v2.526c-.249 0-.249 0-.374.133zm.125-2.526v2.393h.124l-.124-2.393z"
            fill="#131A2D"
            />
            <path d="M141.841 359.315v2.526h-.249v-2.526h.249z" fill="#0EA59D" />
            <path
            d="M141.716 361.974h-.249v-2.659h.374v2.659h-.125zm0-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M144.96 360.379c0 .133-.124.398-.249.531v-1.329h.249v.798z"
            fill="#0EA59D"
            />
            <path
            d="M144.711 361.044v-1.596h.374v.931c0 .133-.125.266-.249.532l-.125.133zm.125-1.463v1.064c0-.133.124-.133.124-.266l-.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M138.722 360.777c-.124-.133-.124-.265-.124-.398v-.798h.124v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M138.722 360.91l-.125-.132c-.124-.133-.124-.266-.124-.399v-1.064h.249v1.595zm-.125-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M144.335 361.177c-.124 0-.124.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M143.961 361.442v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.125-1.861v1.728h.124l-.124-1.728z"
            fill="#131A2D"
            />
            <path d="M142.589 361.841h-.249v-2.393h.249v2.393z" fill="#0EA59D" />
            <path
            d="M142.215 361.841v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.124l-.124-2.26c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M143.962 361.442c-.124 0-.124 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M143.713 361.575v-2.26h.374v1.994c-.249.266-.249.266-.374.266zm.125-1.994v1.861h.124l-.124-1.861z"
            fill="#131A2D"
            />
            <path d="M143.212 361.709h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M142.963 361.841v-2.393h.374v2.26c-.125 0-.249 0-.374.133zm.125-2.26v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path d="M142.839 361.708h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M142.59 361.841v-2.526h.374v2.393c-.125.133-.249.133-.374.133zm.125-2.393v2.127h.124l-.124-2.127c.124.133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M141.716 357.853c1.871 0 3.244.797 3.244 1.595 0 .797-1.373 1.595-3.244 1.595-1.871 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M141.716 361.043c-1.996 0-3.243-.798-3.243-1.595 0-.798 1.372-1.595 3.243-1.595 1.996 0 3.244.797 3.244 1.595 0 .797-1.248 1.595-3.244 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .665 1.248 1.462 3.119 1.462 1.871 0 3.119-.797 3.119-1.462.125-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M143.837 360.512c-.25.133-.499.133-.749.266l-2.619-2.792c.249 0 .499-.132.748-.132l2.62 2.658zM141.965 360.91h-.499l-2.37-2.525c.124-.133.249-.133.374-.133l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M142.839 360.777h.125c.125 0 .249 0 .374-.133.125 0 .25-.133.374-.133h.375c.124 0 .249-.133.249-.133.25-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.133h-.249s-.125 0-.125.133h-.249c-.125 0-.25 0-.375.133h-.748c.125 0 .249 0 .374-.133v-.133zM141.217 360.91h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.132-.499-.132h.499c.125.132.249.132.499.265z"
            fill="#fff"
            />
            <path
            d="M146.706 362.238c.375 0 .749 0 1.123.133h2.121v.798c0 .797-1.372 1.462-3.244 1.462-1.871 0-3.243-.798-3.243-1.462v-.798h2.121c.249 0 .623-.133 1.122-.133z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 364.764c-1.871 0-3.119-.798-3.243-1.463V362.238h2.12a7.095 7.095 0 012.371 0h2.12v.931c-.249.93-1.497 1.595-3.368 1.595zm-3.243-1.595c0 .664 1.372 1.462 3.118 1.462 1.872 0 3.119-.798 3.119-1.462v-.798h-1.996a7.089 7.089 0 00-2.37 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M149.576 363.834s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 364.234v-1.861h.374v1.595c-.124 0-.124.133-.374.266zm.25-1.728v1.462h.124l-.124-1.462z"
            fill="#131A2D"
            />
            <path
            d="M145.708 362.372v2.392h-.249v-2.259c.125-.133.125-.133.249-.133z"
            fill="#0EA59D"
            />
            <path
            d="M145.708 364.764h-.249v-2.392h.374v2.392h-.125zm-.124-.133l.124-2.126h-.124v2.126z"
            fill="#131A2D"
            />
            <path d="M146.083 364.764h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M146.083 364.765h-.249v-2.526h.374v2.526h-.125zm-.124-.133l.124-2.26h-.124v2.26z"
            fill="#131A2D"
            />
            <path
            d="M144.337 364.233c-.124 0-.124-.133-.249-.133v-1.728h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M144.337 364.366c-.124-.133-.249-.133-.249-.133v-1.861h.374v1.994h-.125zm-.124-.266l.124-1.595h-.124v1.595z"
            fill="#131A2D"
            />
            <path d="M146.332 364.764h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M146.457 364.765h-.25v-2.526h.374v2.526h-.124zm-.25-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M143.962 363.967c-.124 0-.124-.133-.249-.133v-1.462h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M143.962 364.1c-.125-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.125-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M144.96 364.499c-.124 0-.124 0-.249-.133v-2.127h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M145.085 364.632c-.124 0-.249-.132-.249-.132v-2.127h.374v2.259h-.125zm-.249-.265s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M145.333 364.631h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M145.458 364.764c-.124 0-.249 0-.249-.133v-2.259h.374v2.392h-.125zm-.249-.265l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M144.585 364.366c-.124 0-.124 0-.249-.133v-1.861h.249v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M144.71 364.499c-.124 0-.249-.133-.249-.133v-1.994h.374v2.127h-.125zm-.249-.266c.125 0 .125 0 0 0l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M148.453 364.499h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M148.203 364.631v-2.259h.374v2.259c-.124-.132-.249 0-.374 0zm.125-2.126v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M147.082 364.765h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M146.832 364.765v-2.659h.374v2.526c-.124.133-.249.133-.374.133zm.125-2.393v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M146.707 362.24v2.525h-.25v-2.525h.25z" fill="#0EA59D" />
            <path
            d="M146.707 364.765h-.25v-2.659h.25v2.659zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M149.951 363.169c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 363.967v-1.595h.374v.93c0 .133-.124.266-.249.532l-.125.133zm.125-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M143.588 363.701c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M143.712 363.834l-.124-.133c-.125-.133-.125-.266-.125-.399V362.239h.249v1.595zm-.249-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M149.203 364.1c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M148.953 364.366v-1.994h.374v1.861c-.124 0-.249 0-.374.133zm.125-1.861v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M147.457 364.764h-.25v-2.392h.25v2.392z" fill="#0EA59D" />
            <path
            d="M147.207 364.765v-2.526h.374v2.526h-.374zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M148.828 364.366c-.125 0-.125 0-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 364.499v-2.26h.374v2.127c-.124 0-.249.133-.374.133zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M148.08 364.631h-.25v-2.259h.25v2.259z" fill="#0EA59D" />
            <path
            d="M147.83 364.764v-2.392h.374v2.259c-.124 0-.249 0-.374.133zm.125-2.259v2.126h.125l-.125-2.126z"
            fill="#131A2D"
            />
            <path d="M147.83 364.632h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M147.455 364.765v-2.526h.374v2.393c-.124.133-.124.133-.374.133zm.25-2.393v2.127h.124l-.124-2.127z"
            fill="#131A2D"
            />
            <path
            d="M146.706 360.776c1.872 0 3.244.798 3.244 1.595 0 .798-1.372 1.595-3.244 1.595-1.871 0-3.243-.797-3.243-1.595 0-.797 1.247-1.595 3.243-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M146.706 363.966c-1.996 0-3.243-.797-3.243-1.595 0-.797 1.372-1.595 3.243-1.595 1.996 0 3.244.798 3.244 1.595 0 .665-1.372 1.595-3.244 1.595zm0-3.19c-1.871 0-3.118.798-3.118 1.462 0 .665 1.247 1.462 3.118 1.462 1.872 0 3.119-.797 3.119-1.462 0-.664-1.247-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M148.827 363.435c-.249.133-.499.133-.748.266l-2.62-2.791c.249 0 .499-.133.748-.133l2.62 2.658zM146.955 363.834h-.499l-2.37-2.526c.125-.132.249-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M147.704 363.701h.125c.125 0 .25 0 .374-.133.125 0 .25-.133.375-.133h.374c.125 0 .249-.133.249-.133.25-.133.375-.266.624-.399-.125.266-.249.399-.499.532l-.125.133s-.124 0-.124.133h-.25s-.125 0-.125.133h-.249c-.125 0-.25 0-.374.132h-.749c.125 0 .25 0 .374-.132v-.133zM146.082 363.701h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.25-.133-.499-.133h.499c.125.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M151.572 365.164c.374 0 .748 0 1.122.133h2.121v.798c0 .664-1.372 1.462-3.243 1.462-1.872 0-3.244-.798-3.244-1.462v-.798h2.121c.249 0 .748-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 367.689c-1.872 0-3.119-.798-3.244-1.462v-1.064h2.121c.374-.133.748-.133 1.123-.133.374 0 .748 0 1.122.133h2.121v.931c-.125.93-1.372 1.595-3.243 1.595zm-3.244-1.595c0 .664 1.372 1.462 3.119 1.462 1.746 0 3.119-.798 3.119-1.462v-.798h-1.996c-.749-.133-1.622-.133-2.246 0h-1.996v.798z"
            fill="#131A2D"
            />
            <path
            d="M154.441 366.759s-.125.133-.25.133v-1.728h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 367.158v-1.861h.375v1.595c-.125 0-.25.133-.375.266zm.125-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M150.574 365.297v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M150.699 367.689h-.25v-2.393h.374v2.393h-.124zm-.25-.133l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path d="M150.947 367.69h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M150.947 367.69h-.25v-2.526h.375v2.526h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M149.201 367.158c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M149.201 367.291c-.125-.133-.25-.133-.25-.133v-1.861h.374v1.994h-.124zm-.125-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M151.322 367.69h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M151.322 367.69h-.25v-2.526h.375v2.526h-.125zm-.125-.133l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path
            d="M148.828 366.892c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M148.952 367.025c-.124-.133-.249-.266-.374-.266v-1.595h.374v1.861zm-.249-.266l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M149.826 367.424c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M149.951 367.557c-.125 0-.25-.133-.25-.133v-2.127h.374v2.26h-.124zm-.25-.266c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M150.199 367.556h-.25v-2.126h.25v2.126z" fill="#0EA59D" />
            <path
            d="M150.324 367.557c-.125 0-.25 0-.25-.133v-2.26h.374v2.393h-.124zm-.25-.133s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M149.576 367.291c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M149.576 367.424c-.125 0-.25-.133-.25-.133v-1.994h.374v2.127h-.124zm-.125-.266l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M153.443 367.424h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M153.068 367.557v-2.26h.375v2.26c-.125-.133-.125 0-.375 0zm.125-2.127v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M151.945 367.689h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M151.695 367.689v-2.659h.375v2.526c-.125.133-.25.133-.375.133zm.125-2.393v2.393h.125l-.125-2.393c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M151.697 365.163v2.526h-.25v-2.526h.25c-.125 0-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 367.689h-.25v-2.659h.375v2.659h-.125zm-.125-.133l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M154.816 366.094c0 .133-.125.399-.25.532v-1.329h.25v.797z"
            fill="#0EA59D"
            />
            <path
            d="M154.566 366.892v-1.595h.375v.93c0 .133-.125.266-.25.532l-.125.133zm.125-1.462v1.063c0-.133.125-.266.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M148.453 366.626c-.125-.133-.125-.266-.125-.399v-.797h.125v1.196z"
            fill="#0EA59D"
            />
            <path
            d="M148.578 366.759l-.125-.133c-.125-.132-.125-.265-.125-.398v-1.064h.25v1.595zm-.25-.664v.266-.931.665z"
            fill="#131A2D"
            />
            <path
            d="M154.066 367.025c-.125 0-.125.133-.25.133v-1.861h.25v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M153.816 367.29v-1.993h.375v1.861c-.125 0-.25 0-.375.132zm.125-1.86v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M152.32 367.69h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.07 367.69v-2.526h.375v2.526h-.375zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path
            d="M153.693 367.291c-.125 0-.125 0-.25.132v-1.993h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 367.424v-2.26h.375v1.994c-.125.133-.25.266-.375.266zm.125-1.994v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M153.068 367.557h-.25v-2.26h.25v2.26z" fill="#0EA59D" />
            <path
            d="M152.818 367.689v-2.392h.375v2.26c-.25 0-.25 0-.375.132zm.125-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M152.695 367.557h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M152.445 367.69v-2.526h.375v2.393c-.25.133-.25.133-.375.133zm.125-2.393v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M151.572 363.702c1.871 0 3.243.798 3.243 1.595 0 .798-1.372 1.595-3.243 1.595-1.872 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M151.572 366.891c-1.996 0-3.244-.797-3.244-1.595 0-.797 1.372-1.595 3.244-1.595 1.996 0 3.243.798 3.243 1.595 0 .798-1.247 1.595-3.243 1.595zm0-3.19c-1.872 0-3.119.798-3.119 1.462 0 .665 1.247 1.462 3.119 1.462 1.871 0 3.118-.797 3.118-1.462 0-.664-1.372-1.462-3.118-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M153.692 366.361c-.249.132-.499.132-.748.265l-2.62-2.791c.25 0 .499-.133.749-.133l2.619 2.659zM151.82 366.759h-.499l-2.37-2.526c.125-.132.25-.132.374-.132l2.495 2.658z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M152.57 366.627h.124c.125 0 .25 0 .375-.133.124 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.623-.399a1.004 1.004 0 01-.499.532l-.124.133s-.125 0-.125.133h-.25s-.124 0-.124.133h-.25c-.125 0-.249 0-.374.132h-.749c.125 0 .25 0 .375-.132v-.133zM150.947 366.626h.998-.998c-.125 0-.374 0-.499-.133-.125 0-.249-.133-.499-.133h.499c.25.266.374.266.499.266z"
            fill="#fff"
            />
            <path
            d="M156.437 368.088c.374 0 .748 0 1.123.133h2.12v.797c0 .798-1.372 1.462-3.243 1.462-1.871 0-3.244-.797-3.244-1.462v-.797h2.121c.374-.133.749-.133 1.123-.133z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 370.613c-1.871 0-3.119-.798-3.244-1.462v-1.064h2.121a7.089 7.089 0 012.37 0h2.121v.931c-.125.797-1.497 1.595-3.368 1.595zm-3.119-1.595c0 .664 1.372 1.462 3.119 1.462 1.746 0 3.119-.798 3.119-1.462v-.798h-1.996a7.095 7.095 0 00-2.371 0h-1.996v.798h.125z"
            fill="#131A2D"
            />
            <path
            d="M159.306 369.683s-.125.133-.249.133v-1.728h.249v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M159.057 369.949v-1.861h.374v1.595c-.125.133-.25.266-.374.266zm.124-1.728v1.462h.125l-.125-1.462z"
            fill="#131A2D"
            />
            <path
            d="M155.439 368.221v2.392h-.25v-2.259c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M155.564 370.613h-.25v-2.392h.375v2.392h-.125zm-.25-.133s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path d="M155.814 370.614h-.25v-2.393h.25v2.393z" fill="#0EA59D" />
            <path
            d="M155.939 370.613h-.25v-2.525h.375v2.525h-.125zm-.25-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M154.066 370.081c-.125 0-.125-.133-.25-.133v-1.728h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M154.191 370.214c-.125-.133-.25-.133-.25-.133v-1.861h.375v1.994h-.125zm-.25-.266l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path d="M156.187 370.613h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.187 370.613h-.249v-2.525h.374v2.525h-.125zm-.125-.133l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.693 369.816c-.125 0-.125-.133-.25-.133v-1.462h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M153.818 369.949c-.125-.133-.25-.266-.375-.266v-1.595h.375v1.861zm-.25-.266s.125 0 0 0l.125-1.329h-.125v1.329z"
            fill="#131A2D"
            />
            <path
            d="M154.816 370.348c-.125 0-.125 0-.25-.133v-2.127h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M154.816 370.481c-.125 0-.25-.133-.25-.133v-2.127h.375v2.26h-.125zm-.125-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M155.189 370.481h-.25v-2.127h.25v2.127z" fill="#0EA59D" />
            <path
            d="M155.189 370.48c-.125 0-.25 0-.25-.132v-2.26h.375v2.392h-.125zm-.25-.132c.125 0 .125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path
            d="M154.441 370.214c-.125 0-.125 0-.25-.133v-1.861h.25v1.994z"
            fill="#0EA59D"
            />
            <path
            d="M154.441 370.347c-.125 0-.25-.132-.25-.132v-1.994h.375v2.126h-.125zm-.125-.265l.125-1.861h-.125v1.861z"
            fill="#131A2D"
            />
            <path d="M158.308 370.347h-.249v-2.126h.249v2.126z" fill="#0EA59D" />
            <path
            d="M158.059 370.48v-2.259h.374v2.259c-.25-.133-.25-.133-.374 0zm.124-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M156.937 370.613h-.249v-2.525h.249v2.525z" fill="#0EA59D" />
            <path
            d="M156.562 370.613v-2.658h.375v2.526c-.125.132-.25.132-.375.132zm.125-2.392v2.392h.125l-.125-2.392c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M156.562 368.088v2.525h-.249v-2.525h.249s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 370.613h-.249v-2.658h.374v2.658h-.125c.125 0 0 0 0 0zm0-.132l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M159.679 369.018c0 .133-.125.399-.249.532v-1.329h.249v.797z"
            fill="#0EA59D"
            />
            <path
            d="M159.43 369.683v-1.595h.374v.93c0 .133-.125.266-.25.532l-.124.133zm.124-1.462v1.063c0-.133.125-.133.125-.266l-.125-.797z"
            fill="#131A2D"
            />
            <path
            d="M153.443 369.551c-.125-.133-.125-.266-.125-.399v-.798h.125v1.197z"
            fill="#0EA59D"
            />
            <path
            d="M153.443 369.683l-.125-.133c-.125-.133-.125-.266-.125-.399V368.088h.25v1.595zm-.125-.665v.266-.93.664z"
            fill="#131A2D"
            />
            <path
            d="M158.933 369.948c-.125 0-.125.133-.249.133v-1.861h.249v1.728z"
            fill="#0EA59D"
            />
            <path
            d="M158.684 370.215v-1.994h.374v1.861c-.125 0-.125 0-.374.133zm.124-1.994v1.728h.125l-.125-1.728z"
            fill="#131A2D"
            />
            <path d="M157.185 370.48h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M156.936 370.613v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.392v2.259h.125l-.125-2.259c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M158.683 370.215c-.125 0-.125 0-.249.133v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M158.309 370.348v-2.26h.374v2.127c-.125 0-.125.133-.374.133zm.124-2.127v1.861h.125l-.125-1.861z"
            fill="#131A2D"
            />
            <path d="M157.933 370.348h-.249v-2.26h.249v2.26z" fill="#0EA59D" />
            <path
            d="M157.684 370.48v-2.392h.374v2.26c-.125.132-.25.132-.374.132zm.124-2.259v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path d="M157.56 370.48h-.249v-2.392h.249v2.392z" fill="#0EA59D" />
            <path
            d="M157.311 370.613v-2.525h.374v2.392c-.125.133-.25.133-.374.133zm.124-2.392v2.127h.125l-.125-2.127z"
            fill="#131A2D"
            />
            <path
            d="M156.437 366.626c1.871 0 3.243.797 3.243 1.595 0 .797-1.372 1.595-3.243 1.595-1.871 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M156.437 369.816c-1.996 0-3.244-.798-3.244-1.595 0-.798 1.373-1.595 3.244-1.595 1.871 0 3.243.797 3.243 1.595 0 .797-1.247 1.595-3.243 1.595zm0-3.19c-1.871 0-3.119.797-3.119 1.462 0 .664 1.248 1.462 3.119 1.462 1.871 0 3.119-.798 3.119-1.462.124-.665-1.248-1.462-3.119-1.462z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M158.558 369.284c-.25.133-.499.133-.749.266l-2.62-2.791c.25 0 .499-.133.749-.133l2.62 2.658zM156.686 369.683h-.499l-2.371-2.526c.125-.133.25-.133.375-.133l2.495 2.659z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M157.435 369.55h.125c.124 0 .249 0 .374-.132.125 0 .249-.133.374-.133h.374c.125 0 .25-.133.25-.133.249-.133.374-.266.624-.399-.125.266-.25.399-.499.532l-.125.133s-.125 0-.125.132h-.249s-.125 0-.125.133h-.25c-.124 0-.249 0-.374.133s-.249 0-.374 0h-.374c.124 0 .249 0 .374-.133v-.133zM155.937 369.55h.998-.998c-.124 0-.374 0-.499-.133-.124 0-.249-.133-.499-.133h.499c.125.266.25.266.499.266z"
            fill="#fff"
            />
            <path
            d="M149.078 381.911c0 .266.125.532.499.665.624.399 1.622.399 2.246 0 .249-.133.499-.399.499-.665v-.531h-3.119v.531h-.125z"
            fill="#131A2D"
            />
            <path
            d="M151.698 380.715c-.624-.399-1.622-.399-2.246 0-.624.399-.624.93 0 1.329.624.399 1.622.399 2.246 0 .623-.266.623-.93 0-1.329z"
            fill="#fff"
            />
            <path
            d="M149.328 381.381c0 .266.125.398.374.531.499.266 1.373.266 1.872 0 .249-.133.374-.398.374-.531v-17.812h-2.62v17.812z"
            fill="#fff"
            />
            <path
            d="M150.575 382.177c-.374 0-.748-.132-.998-.265a.74.74 0 01-.374-.665v-17.944h2.745v17.944a.74.74 0 01-.375.665c-.249.265-.623.265-.998.265zm-1.247-18.608v17.811c0 .133.125.399.374.532.499.265 1.248.265 1.747 0 .249-.133.374-.266.374-.532v-17.811h-2.495z"
            fill="#131A2D"
            />
            <path
            d="M151.574 362.903c-.499-.265-1.373-.265-1.872 0-.499.266-.499.798 0 1.197.499.266 1.373.266 1.872 0 .499-.399.499-.931 0-1.197z"
            fill="#D4D4D4"
            />
            <path
            d="M140.594 376.729c0 .266.125.531.499.664.624.399 1.621.399 2.245 0 .25-.133.499-.398.499-.664v-.532h-3.119v.532h-.124z"
            fill="#131A2D"
            />
            <path
            d="M143.213 375.532c-.623-.399-1.621-.399-2.245 0-.624.399-.624.931 0 1.329.624.399 1.622.399 2.245 0 .624-.265.624-.93 0-1.329z"
            fill="#fff"
            />
            <path
            d="M140.842 376.065c0 .266.125.399.374.532.499.266 1.372.266 1.871 0 .25-.133.375-.399.375-.532v-17.811h-2.62v17.811z"
            fill="#fff"
            />
            <path
            d="M142.214 376.995c-.374 0-.748-.133-.998-.266a.74.74 0 01-.374-.665V358.12h2.744v17.944c0 .266-.124.532-.374.665-.374.133-.748.266-.998.266zm-1.247-18.609v17.811c0 .133.124.399.374.532.499.266 1.247.266 1.746 0 .25-.133.375-.266.375-.532v-17.811h-2.495z"
            fill="#131A2D"
            />
            <path
            d="M143.087 357.721c-.499-.266-1.372-.266-1.871 0-.499.265-.499.797 0 1.196.499.266 1.372.266 1.871 0 .499-.399.499-.931 0-1.196z"
            fill="#D4D4D4"
            />
            <path
            d="M131.986 371.413c0 .265.125.531.499.664.624.399 1.622.399 2.246 0 .249-.133.499-.399.499-.664v-.532h-3.244v.532z"
            fill="#131A2D"
            />
            <path
            d="M134.606 370.216c-.624-.399-1.622-.399-2.246 0-.623.399-.623.931 0 1.329.624.399 1.622.399 2.246 0 .624-.266.624-.93 0-1.329z"
            fill="#fff"
            />
            <path
            d="M132.236 370.879c0 .266.125.399.375.532.499.266 1.372.266 1.871 0 .249-.133.374-.399.374-.532v-17.811h-2.62v17.811z"
            fill="#fff"
            />
            <path
            d="M133.609 371.677a2.23 2.23 0 01-.998-.266.738.738 0 01-.375-.664v-17.945h2.745v17.945a.739.739 0 01-.374.664c-.375.266-.749.266-.998.266zm-1.248-18.609v17.812c0 .133.125.398.374.531.499.266 1.248.266 1.747 0 .249-.133.374-.265.374-.531v-17.812h-2.495z"
            fill="#131A2D"
            />
            <path
            d="M134.482 352.403c-.499-.265-1.372-.265-1.871 0-.499.266-.499.798 0 1.197.499.266 1.372.266 1.871 0 .499-.399.499-.931 0-1.197z"
            fill="#D4D4D4"
            />
            <path
            d="M153.441 366.492l4.242-2.525v-2.26l-4.242 2.526v2.259z"
            fill="#131A2D"
            />
            <path
            d="M153.442 366.493l-25.2-15.552v-1.861l25.2 15.419v1.994z"
            fill="#fff"
            />
            <path
            d="M153.441 366.626l-25.324-15.552v-2.127h.125l25.199 15.552v2.127zm-25.199-15.685l25.075 15.419v-1.728l-25.075-15.419v1.728z"
            fill="#131A2D"
            />
            <path
            d="M173.777 325.818l-15.219 1.595-3.868 2.393-24.95 15.552-3.867 2.392 13.847-.266 5.115-3.854 23.703-14.09 5.239-3.722z"
            fill="#fff"
            />
            <path
            d="M125.623 347.75l4.117-2.525 24.825-15.286 4.117-2.525 15.344-1.728-5.364 3.987-23.703 14.09-5.114 3.854-14.222.133zm29.441-17.944l-.249.133-24.95 15.419-3.618 2.259 13.598-.265 5.114-3.855 23.703-14.09 4.99-3.589-14.845 1.596-3.743 2.392z"
            fill="#131A2D"
            />
            <path
            d="M159.929 363.967l-3.867 2.392-15.843-19.406.748-.931 3.868-2.392 15.094 20.337z"
            fill="#131A2D"
            />
            <path
            d="M156.063 366.359l-30.19-18.609 15.095-1.728 15.095 20.337z"
            fill="#fff"
            />
            <path
            d="M156.436 366.625l-.374-.133-30.439-18.742 15.344-1.728 15.469 20.603zm-30.314-18.875l29.691 18.343-14.846-19.938-14.845 1.595z"
            fill="#131A2D"
            />
            <path
            d="M149.575 359.846l-17.964-11.032.749-.133 16.467 10.102.748 1.063z"
            fill="#131A2D"
            />
            <path
            d="M148.828 358.783l-16.467-10.102 8.234-.93 8.233 11.032z"
            fill="#fff"
            />
            <path
            d="M149.077 359.049l-.374-.133-16.592-10.235 8.483-.93 8.483 11.298zm-16.467-10.368l15.968 9.837-7.984-10.634-7.984.797zM185.005 348.415l-11.477-22.597-28.692 17.812 15.095 20.337 25.074-15.552z"
            fill="#131A2D"
            />
            <path
            d="M143.838 355.195l.748-.266.624.797-.499.532-.873-1.063zM146.457 356.788l.749-.266.374.798-.499.399-.624-.931zM144.96 361.441l.749-.266-.874-1.064-.249.665.374.665zM147.954 363.302l.748-.266-1.497-1.196v.797l.749.665zM138.848 352.004l.623-.265.749.93-.499.266-.873-.931zM139.846 358.251l.624-.266-.624-1.063s-.623.133-.623.266c.124 0 .623 1.063.623 1.063zM140.219 353.865l.624-.133 1.122 3.988-.249.266-1.497-4.121zM141.592 353.732l.748-.133.499.531-.623.665-.624-1.063zM142.714 359.979l.624-.266-.499-1.196-.624.398.499 1.064zM138.348 357.321l.624-.266-.998-.93-.374.532.748.664zM134.98 355.194l.748-.266-.873-.664-.25.398.375.532zM129.99 346.554l.624-.266 2.62 2.127-.998.133-2.246-1.994zM132.734 350.941l.749-.266.374 2.791-.624.266-.499-2.791z"
            fill="#131A2D"
            />
            <path
            d="M143.338 354.263v5.449l-1.123-.664-1.746-5.051c0 .664.124 3.987.124 3.987l-1.122-.664v-5.45l1.122.665 1.747 5.051c0-.665-.125-3.988-.125-3.988l1.123.665zM137.475 350.542l1.497 6.513-1.123-.798-.249-1.462-1.497-.93-.25 1.063-1.123-.665 1.622-4.519 1.123.798zm-1.248 2.525l.998.665-.124-.532-.375-1.994a744.36 744.36 0 01-.374 1.595l-.125.266zM133.732 350.94c.374.399.624.931.624 1.463 0 1.063-.873 1.063-1.871.398l-1.872-1.196v-5.45l1.747 1.064c.499.265.998.664 1.247 1.063.375.399.499.93.499 1.462 0 .532-.249.931-.623.798.124.265.249.398.249.398zm-1.372 1.064c.624.399.873.266.873-.133 0-.266-.125-.532-.249-.665-.125-.133-.375-.399-.624-.531l-.624-.399v1.462l.624.266zm-.624-3.988v1.196l.499.266c.499.399.749.266.749-.133 0-.265-.125-.398-.25-.664-.125-.133-.249-.266-.499-.399l-.499-.266zM148.328 357.321l-1.497 1.197 1.872 4.519-1.248-.798-1.247-3.057-.499.532v1.462l-1.123-.798v-5.449l1.123.664v2.26l1.497-1.329 1.122.797z"
            fill="#131A2D"
            />
            <path
            d="M142.715 354.396v5.449l-1.123-.664-1.746-5.051c0 .664.124 3.987.124 3.987l-1.122-.664v-5.45l1.122.665 1.747 5.051c0-.665-.125-3.988-.125-3.988l1.123.665z"
            fill="#0EA59D"
            />
            <path
            d="M142.715 360.111l-1.248-.797-1.622-4.653c0 1.064.125 3.456.125 3.589v.133l-1.247-.797v-5.716l1.247.798 1.622 4.652c0-1.063-.125-3.456-.125-3.589v-.133l1.248.798v5.715zm-1.123-.93l.998.664v-5.316l-.873-.532c0 .664.124 3.323.124 3.855v.132l-.124-.132-1.747-5.051-.998-.665v5.317l.873.531c0-.664-.124-3.323-.124-3.854v-.133l.124.133 1.747 5.051z"
            fill="#131A2D"
            />
            <path
            d="M136.727 350.807l1.497 6.513-1.123-.797-.249-1.462-1.497-.931-.25 1.064-1.123-.665 1.622-4.519 1.123.797zm-1.123 2.526l.998.664-.125-.531-.374-1.994-.374 1.595-.125.266z"
            fill="#0EA59D"
            />
            <path
            d="M138.473 357.452l-1.372-.797-.249-1.462-1.373-.931-.249 1.064-1.248-.798 1.622-4.652 1.497.93 1.372 6.646zm-1.247-.93l.998.665-1.497-6.248-1.248-.797-1.497 4.386.998.665.25-1.064 1.622.931.374 1.462zm-.499-2.393l-1.248-.797.125-.532.374-1.595v-.133l.125.133c0 .266.125.532.125.798.125.398.125.797.249 1.196l.25.93zm-1.123-.93l.873.532-.124-.399c-.125-.399-.125-.798-.25-1.196 0-.133-.125-.399-.125-.532-.124.399-.249.93-.374 1.329v.266z"
            fill="#131A2D"
            />
            <path
            d="M133.109 351.206c.374.399.624.931.624 1.462 0 1.064-.874 1.064-1.872.399l-1.871-1.196v-5.45l1.747 1.064c.499.265.998.664 1.247 1.063.374.399.499.93.499 1.462 0 .532-.249.93-.624.798 0 .265.125.398.25.398zm-1.497.931c.624.398.873.266.873-.133 0-.266-.125-.532-.249-.665-.125-.133-.375-.399-.624-.531l-.624-.399v1.462l.624.266zm-.624-3.855v1.196l.499.266c.499.399.749.266.749-.133 0-.266-.125-.399-.25-.664-.125-.133-.249-.266-.499-.399l-.499-.266z"
            fill="#0EA59D"
            />
            <path
            d="M132.984 353.732c-.374 0-.873-.266-1.248-.532l-1.871-1.196v-5.716l1.747 1.063c.499.399.998.665 1.247 1.064.374.399.624.93.624 1.462 0 .266-.125.532-.25.797-.124.133-.124.133-.249.133l.249.266c.25.399.624.931.624 1.595 0 .399-.125.665-.374.931-.25.133-.374.133-.499.133zm-2.994-1.728l1.746 1.063c.749.399 1.248.532 1.497.399.25-.133.25-.399.25-.798 0-.664-.25-1.196-.624-1.462l-.249-.266v-.133h.124c.125 0 .25 0 .375-.133a1.05 1.05 0 00.249-.664c0-.532-.125-.931-.499-1.329-.249-.399-.748-.665-1.247-1.064l-1.622-.93v5.317zm2.245.531c-.124 0-.374-.133-.623-.265l-.624-.399v-1.595l.748.398c.25.133.499.399.624.532.25.266.25.532.25.798s0 .398-.125.398c0 .133-.125.133-.25.133zm-.499-.398c.375.265.624.265.749.265s.125-.132.125-.265c0-.266-.125-.399-.25-.665-.125-.133-.374-.399-.624-.532l-.499-.266v1.197l.499.266zm.375-2.127c-.125 0-.375-.133-.499-.266l-.499-.399v-1.462l.623.399c.25.133.375.266.624.399.125.266.25.398.25.664 0 .133 0 .399-.125.399-.25.266-.374.266-.374.266zm-.998-.532l.499.266c.249.133.499.266.623.133 0 0 .125-.133.125-.266 0-.266-.125-.399-.249-.532-.125-.132-.25-.265-.499-.398l-.375-.266-.124 1.063z"
            fill="#131A2D"
            />
            <path
            d="M147.705 357.587l-1.497 1.196 1.747 4.52-1.248-.798-1.123-3.057-.623.399v1.595l-1.123-.798v-5.449l1.123.664v2.26l1.497-1.329 1.247.797z"
            fill="#0EA59D"
            />
            <path
            d="M148.079 363.436l-1.372-.931-1.123-3.057-.499.399v1.595l-1.247-.798v-5.715l1.247.797v2.127l1.373-1.329 1.372.797-1.497 1.329 1.746 4.786zm-1.247-1.064l.998.665-1.747-4.254 1.497-1.196-1.122-.664-1.497 1.329-.125-.133v-2.26l-.998-.664v5.316l.998.665v-1.329l.624-.532 1.372 3.057zM135.48 350.011l.624-.266 1.372.798-.748.265-1.248-.797z"
            fill="#131A2D"
            />
            <path
            d="M189.746 367.29l-8.982-5.45v-10.9l4.117-2.525 3.867-2.393-15.095-20.204-15.094 1.728-3.868 2.393-13.597 8.374 14.346-1.196 15.344 20.071-3.992 2.525-1.372.931 3.618 1.993v.798s.374-.266.499-.399l.249.133v.931l-.374.398.374.266v.931l-.249.265.249.133v.931s-.124.266-.249.399l.249.132v.931l-.249.266.249.133v.93s-.249.399-.374.532l.249.133v.797s-.124.266-.249.399l.249.133v.93l4.117 2.526v3.323h.125l11.602-7.045 3.867-2.392v-1.861h.374zm-11.602-7.045l-2.993-1.861v-.399c0-.664-1.123-1.462-2.87-1.595v-.266l5.863-3.589v7.71z"
            fill="#0EA59D"
            opacity={0.3}
            />
            <path
            d="M170.285 303.887c.499 1.196.748 2.525.748 3.589l.374 71.511c-.124 2.924-1.871 3.855-4.491 2.393l-21.956-13.027c-1.247-.664-2.37-1.994-3.243-3.323.873 1.994 2.37 3.988 3.992 4.918l21.706 12.761c2.62 1.462 4.616.266 4.741-2.659l-.374-71.112c.124-1.728-.499-3.456-1.497-5.051z"
            fill="#D1D2D6"
            />
            <path
            d="M170.16 303.621c.499 1.196.748 2.526.748 3.589l.374 71.511c-.124 2.925-1.871 3.855-4.491 2.393l-21.956-13.026c-1.247-.665-2.37-1.994-3.243-3.323.873 1.993 2.37 3.987 3.992 4.918l21.706 12.76c2.62 1.462 4.616.266 4.741-2.658l-.374-70.98a9.93 9.93 0 00-1.497-5.184z"
            fill="url(#paint148_linear_874_76773)"
            />
            <path
            d="M169.91 303.488c.499 1.197.748 2.526.748 3.589l.375 71.379c-.125 2.924-1.872 3.854-4.491 2.392l-21.832-12.893c-1.247-.665-2.37-1.994-3.243-3.323.873 1.994 2.37 3.855 3.992 4.918l21.582 12.76c2.619 1.462 4.615.266 4.74-2.658l-.374-70.98c.125-1.861-.499-3.589-1.497-5.184z"
            fill="url(#paint149_linear_874_76773)"
            />
            <path
            d="M169.785 303.222c.499 1.196.749 2.392.749 3.589l.374 71.245c-.125 2.924-1.871 3.855-4.366 2.393l-21.707-12.894c-1.247-.664-2.37-1.993-3.243-3.323.873 1.994 2.37 3.855 3.992 4.918l21.457 12.628c2.495 1.462 4.616.266 4.74-2.659l-.374-70.846c-.125-1.728-.624-3.456-1.622-5.051z"
            fill="url(#paint150_linear_874_76773)"
            />
            <path
            d="M169.537 302.956c.499 1.196.749 2.393.749 3.589l.374 71.245c-.125 2.925-1.871 3.855-4.366 2.393l-21.707-12.893c-1.247-.665-2.37-1.994-3.243-3.323.873 1.993 2.37 3.854 3.992 4.918l21.457 12.627c2.495 1.462 4.615.266 4.74-2.525l-.374-70.714c0-1.994-.624-3.722-1.622-5.317z"
            fill="url(#paint151_linear_874_76773)"
            />
            <path
            d="M169.412 302.823c.499 1.197.749 2.393.749 3.589l.374 71.113c-.125 2.924-1.871 3.854-4.366 2.392l-21.582-12.76c-1.247-.665-2.37-1.994-3.243-3.323.873 1.994 2.37 3.855 3.992 4.785l21.332 12.627c2.495 1.463 4.616.266 4.616-2.525l-.375-70.714c0-1.861-.499-3.722-1.497-5.184z"
            fill="url(#paint152_linear_874_76773)"
            />
            <path
            d="M169.162 302.558c.499 1.196.749 2.392.749 3.588l.374 71.113c-.125 2.924-1.871 3.855-4.366 2.393l-21.582-12.761c-1.247-.664-2.37-1.861-3.243-3.323.873 1.994 2.37 3.855 3.992 4.785l21.332 12.628c2.495 1.462 4.491.266 4.616-2.526l-.375-70.581c.125-1.993-.499-3.721-1.497-5.316z"
            fill="url(#paint153_linear_874_76773)"
            />
            <path
            d="M169.038 302.291c.499 1.196.749 2.393.749 3.456l.374 70.98c-.125 2.924-1.871 3.854-4.366 2.259l-21.458-12.76c-1.247-.665-2.37-1.861-3.118-3.323.873 1.994 2.245 3.855 3.992 4.785l21.207 12.495c2.495 1.462 4.491.265 4.616-2.526l-.374-70.581c-.125-1.462-.624-3.19-1.622-4.785z"
            fill="url(#paint154_linear_874_76773)"
            />
            <path
            d="M168.913 302.025c.499 1.197.748 2.393.748 3.456l.375 70.847c-.125 2.924-1.872 3.722-4.367 2.26l-21.457-12.628c-1.247-.664-2.37-1.861-3.118-3.323.873 1.994 2.245 3.855 3.992 4.785l21.207 12.495c2.495 1.462 4.491.266 4.616-2.526l-.374-70.448c-.125-1.462-.749-3.323-1.622-4.918z"
            fill="url(#paint155_linear_874_76773)"
            />
            <path
            d="M168.663 301.893c.499 1.196.749 2.392.749 3.456l.374 70.846c-.125 2.925-1.871 3.722-4.366 2.26l-21.332-12.628c-1.248-.664-2.371-1.86-3.119-3.323.873 1.994 2.245 3.855 3.867 4.786l21.083 12.494c2.495 1.462 4.491.266 4.615-2.525l-.374-70.315c0-1.728-.499-3.589-1.497-5.051z"
            fill="url(#paint156_linear_874_76773)"
            />
            <g opacity={0.3} fill="#fff">
            <path d="M143.09 336.319c.998-.133 1.996-.399 2.994-.665.998-.266 1.996-.664 2.744-1.196.874-.665 1.996-1.063 2.994-1.063 1.123 0 2.121.265 2.994.93-.873-.532-1.996-.532-2.994-.532a6.328 6.328 0 00-2.744 1.064c-.873.664-1.996 1.063-2.994 1.196a7.237 7.237 0 01-2.994.266zM163.922 342.034c.249.798.748 1.329 1.247 1.861.499.532 1.123.931 1.747 1.329.624.399 1.372.931 1.746 1.728.125.399.25.798.25 1.197 0 .398 0 .797-.125 1.196-.125-.798-.249-1.595-.624-2.127-.374-.665-.998-1.063-1.621-1.329-.624-.399-1.373-.931-1.747-1.462-.374-.798-.748-1.595-.873-2.393zM146.207 329.938c.624 0 1.248-.133 1.871-.399.624-.266 1.123-.664 1.622-1.063.499-.399.873-.931 1.372-1.329a11.291 11.291 0 011.622-1.064c1.248-.531 2.62-.532 3.867-.133a8.852 8.852 0 013.369 1.994c-.998-.797-2.246-1.329-3.493-1.595-1.248-.266-2.495-.266-3.618.266-.624.266-1.123.532-1.622.93-.499.399-.873.931-1.372 1.33-.998.664-2.246 1.329-3.618 1.063zM142.715 324.489c.998-.266 1.871-.532 2.744-.931.499-.133.874-.398 1.248-.531a5.689 5.689 0 011.247-.665 3.895 3.895 0 01-.998 1.063c-.374.266-.873.532-1.247.798-.499.133-.998.266-1.372.399-.624-.133-1.123-.133-1.622-.133zM159.93 322.23c1.122-.133 2.37.133 3.368.93.998.798 1.497 2.127 1.497 3.456 0 1.197.374 2.393.873 3.456.25.532.624.931 1.123 1.329.374.399.873.798 1.372 1.064-1.123-.399-2.121-1.064-2.869-2.127-.749-1.063-1.123-2.393-1.123-3.589-.125-1.196-.499-2.392-1.247-3.19-.624-.93-1.872-1.329-2.994-1.329zM154.691 331.931c1.123-.398 2.371-.531 3.618-.265.624.133 1.248.398 1.747.664.623.399.998.931 1.372 1.462.125.266.249.665.374.931l.125.399.125.398c.249.532.623 1.064.873 1.595.249.532.748.931 1.247 1.33.499.398.998.664 1.622.93-1.247-.266-2.37-.93-3.119-1.994-.499-.531-.748-1.063-1.122-1.595l-.25-.399-.125-.531-.374-.798c-.249-.531-.624-.93-1.123-1.329-.499-.266-.998-.532-1.621-.665-.998-.265-2.246-.265-3.369-.133zM163.549 316.646a8.624 8.624 0 00-1.871-2.393c-.624-.797-1.373-1.462-2.246-1.86-.873-.532-1.746-.798-2.744-.798-.998 0-1.872.266-2.62.798-1.622 1.063-2.495 3.057-4.242 4.253-.873.532-1.746 1.063-2.744 1.196-.25 0-.499.133-.749.133h-2.245l1.497-.133.748-.133c.25 0 .499-.133.749-.133.998-.132 1.871-.664 2.62-1.196a15.607 15.607 0 001.996-2.127c.623-.797 1.247-1.595 2.12-2.259a5.522 5.522 0 012.87-.798c.998 0 1.996.399 2.869.931 1.746 1.063 3.119 2.791 3.992 4.519zM145.834 310.798c.374 0 .748 0 1.123-.133.374 0 .748-.133 1.122-.266a10.757 10.757 0 002.121-1.063c.624-.399 1.248-.931 1.871-1.462.25-.266.624-.532.874-.798.249-.266.499-.664.873-.93-.25.399-.499.664-.749 1.063-.249.266-.499.665-.748.931-.624.664-1.248 1.196-1.871 1.595-.749.398-1.497.797-2.246 1.063-.748.133-1.497.266-2.37 0zM164.172 308.007c.748.266 1.372.797 1.871 1.329.499.665.873 1.329 1.248 2.127.249.797.374 1.595.499 2.392v1.197c0 .398-.125.797-.125 1.196v-1.196c0-.399 0-.798-.125-1.197-.125-.797-.249-1.595-.499-2.259-.249-.665-.624-1.462-.998-1.994-.748-.665-1.247-1.196-1.871-1.595z" />
            </g>
            <path
            d="M404.941 162.99c1.248.133.749 1.861.374 3.19-.499 1.33-.998 2.925-1.247 3.456-.749 1.462-1.747.665-1.622-.664.125-1.33.624-2.393.998-4.121.499-1.728.998-1.861 1.497-1.861z"
            fill="#fff"
            />
            <path
            d="M403.195 170.567h-.249c-.374-.133-.624-.798-.624-1.463.125-.797.375-1.595.624-2.525.125-.532.25-.931.374-1.595.499-1.994.998-2.127 1.622-1.994.374 0 .624.133.748.399.375.664.001 1.861-.374 2.924l-.124.266c-.499 1.329-.998 2.791-1.248 3.323-.125.532-.499.665-.749.665zm1.622-7.444c-.499 0-.873.266-1.247 1.994l-.375 1.595c-.249.93-.499 1.728-.623 2.525-.125.665.124 1.197.499 1.33.374.132.624-.133.998-.798.249-.532.748-1.994 1.247-3.323l.125-.266c.374-.93.624-2.127.374-2.791-.124-.266-.374-.266-.623-.399-.25.133-.25.133-.375.133z"
            fill="#000"
            />
            <path
            d="M404.691 176.548c1.373.532 6.487-.664 7.361-.93 1.372-.399 1.871-2.924-.499-3.323-1.996-.399-5.489-.931-6.487-.665-1.622.399-3.369 3.988-.375 4.918z"
            fill="#131A2D"
            />
            <path
            d="M405.316 175.352c1.123-1.064.624-2.127.375-2.659-.749-1.196-4.117-4.12-5.864-4.519-.873-.266-2.495.532-1.621 2.392.873 1.595 4.99 6.779 7.11 4.786z"
            fill="#3B349E"
            />
            <path
            d="M408.933 158.471c.998 1.595.249 3.987.374 5.184.125 1.063 1.622 1.993.499 3.721 0 0-.125-1.196-.873-1.462-.749-.266-1.622-.664-1.872-2.658-.124-1.064 0-2.792 0-3.855-.124-.93-.499-1.196-.499-1.196s1.373-1.329 2.371.266z"
            fill="#131A2D"
            />
            <path
            d="M403.569 165.382c.499-1.063.998-1.595 1.248-2.26 0 0 .748-.265.998-.398.873-.133 2.869.531 3.243 1.861.375 1.329-.499 2.658 0 7.31-4.491 2.127-5.613-1.595-5.613-1.595 0-1.063.374-1.063.374-2.392.125-.798-.749-1.462-.25-2.526z"
            fill="#0EA59D"
            />
            <path
            d="M406.564 172.692c-.499 0-.998-.132-1.373-.265-1.247-.665-1.621-1.861-1.621-1.994 0-.532.124-.798.249-1.064.125-.265.25-.664.25-1.196 0-.266-.125-.664-.25-.93-.249-.532-.374-1.064-.125-1.728.25-.665.499-1.064.874-1.462.124-.266.374-.532.499-.798 0 0 .748-.266.998-.399.873-.133 2.869.665 3.368 1.994.249.532.125 1.196 0 1.994-.125 1.063-.374 2.658 0 5.317-1.248.266-2.121.531-2.869.531zm-2.994-2.259c0 .133.374 1.329 1.497 1.861.998.531 2.245.398 3.867-.399-.25-2.658-.125-4.121 0-5.317.125-.797.125-1.329 0-1.994-.499-1.196-2.37-1.993-3.244-1.861-.249 0-.873.266-.998.399l-.374.798c-.249.398-.499.93-.748 1.462-.25.532-.125 1.063.124 1.595.125.266.25.664.25 1.063 0 .665-.125.931-.25 1.329 0 .266-.124.532-.124 1.064z"
            fill="#131A2D"
            />
            <path
            d="M411.803 172.827c-.873-.133-6.113 2.259-6.986 2.525-.873.266-.25 1.329 0 1.329.249-.133 6.113-.797 7.111-1.063 2.12-.798.748-2.791-.125-2.791z"
            fill="#fff"
            />
            <path
            d="M404.816 176.681c-.125 0-.125 0-.249-.133-.125-.133-.375-.532-.25-.797 0-.133.125-.399.499-.532.25-.133.998-.399 1.871-.665 1.872-.797 4.367-1.861 5.115-1.861.499 0 1.248.798 1.248 1.462 0 .399-.125 1.064-1.123 1.33-.624.266-3.493.531-5.364.797-.874.266-1.622.399-1.747.399.125 0 .125 0 0 0zm6.986-3.855c-.624 0-3.243 1.064-5.115 1.861-.873.399-1.497.665-1.871.665-.249.133-.374.133-.374.399 0 .265.125.531.249.664l.125.133c.125 0 .624-.133 1.747-.266 1.871-.266 4.74-.664 5.364-.797.998-.266 1.123-.798 1.123-1.197-.125-.797-.749-1.329-1.248-1.462z"
            fill="#000"
            />
            <path
            d="M411.801 172.561c-.873 0-1.996.664-2.744.93-.125 1.329.624 2.525.748 2.791 1.123-.266 1.373-.398 2.121-.664 2.121-.665.998-3.057-.125-3.057z"
            fill="#131A2D"
            />
            <path
            d="M403.444 179.074c-.125-.133-.125-.399-.125-.532-.125-.266-.25-.531-.25-.797-.125-.665 0-1.595.499-2.127.125-.133.125-.133.25-.133-.25 0-.375-.133-.749 0s-.374.399-.374.665l.125.133s-.125.398-.25.398c-.124.266-.374.798.125 2.26.374.798.624.532.624.532l.125-.399z"
            fill="#fff"
            />
            <path
            d="M403.818 177.744c.374-.664.748-.797 2.12-1.196 0 0-.499-.665-.249-1.462 0 0-.499.133-1.123.266s-.624-.133-1.247 0c-.499.133-.25.531-.375.93-.124.266-.499 1.064.125 2.526.499 1.196.374-.399.749-1.064z"
            fill="#131A2D"
            />
            <path
            d="M400.199 168.574c.749.532 2.994 5.981 3.493 6.912.499.797-.623 1.196-.873.93-.124-.266-3.992-5.051-4.491-5.981-.998-1.994 1.248-2.393 1.871-1.861z"
            fill="#fff"
            />
            <path
            d="M403.07 176.549c-.125 0-.25 0-.25-.133 0 0-.499-.665-1.122-1.329-1.248-1.595-3.119-3.988-3.493-4.52-.624-1.063-.25-1.595 0-1.861.499-.531 1.497-.531 1.871-.132.499.398 1.746 3.057 2.62 5.051.374.93.748 1.595.873 1.86.125.266.125.532 0 .665.125.266-.25.399-.499.399zm-3.618-8.108c-.374 0-.748.133-.998.398-.249.266-.499.798 0 1.728.374.665 2.246 2.925 3.368 4.52.624.93.998 1.329 1.123 1.462h.125a.682.682 0 00.624-.399c.124-.133.124-.399 0-.532-.125-.265-.499-.93-.874-1.861-.873-1.86-2.12-4.652-2.619-5.051-.125-.265-.499-.265-.749-.265z"
            fill="#000"
            />
            <path
            d="M400.325 168.44c.624.665.998 1.994 1.372 2.659-.748 1.063-2.12 1.462-2.37 1.462-.624-1.063-.748-1.196-1.123-1.994-.998-1.994 1.373-2.924 2.121-2.127z"
            fill="#433BB4"
            />
            <path
            d="M402.322 179.207c.125-.133.25-.133.499-.266l.749-.399c.499-.399.998-1.196.998-1.994v-.398c.249.133.374.133.499.531.124.266 0 .532-.125.798h-.125l-.124.399c-.125.398-.25.797-1.498 1.462-.748.399-.748-.133-.748-.133s-.125.133-.125 0z"
            fill="#fff"
            />
            <path
            d="M402.946 178.01c.125-.798 0-1.064-.749-2.393 0 0 .749-.133 1.123-.93 0 0 .25.531.624 1.063.374.532.624.399.873.931.25.398-.125.664-.249.93-.125.399-.25 1.196-1.622 1.728s-.125-.532 0-1.329z"
            fill="#131A2D"
            />
            <path d="M405.441 165.117l-.25-.266.874-.399-.624.665z" fill="#fff" />
            <path
            d="M405.44 165.25l-.499-.532 1.248-.531-.749 1.063zm-.124-.399l.249.266.374-.399-.623.133z"
            fill="#000"
            />
            <path
            d="M405.565 162.858c.249-.266.374-.399.374-1.063 0-.931 1.247-.931 1.247-.931s-.499 2.127.499 2.393c0 0-.998.266-1.497.797-.249.133-.374.266-.623.266-.25.133-.624.266-.624.266l-.25-.665s.25-.664.499-.797c.125 0 .375-.133.375-.266z"
            fill="#fff"
            />
            <path
            d="M405.066 164.718l-.375-.797s.25-.665.499-.798c.125-.133.125-.133.25-.133l.125-.133c.249-.266.374-.399.374-1.063 0-.266.125-.399.249-.665.375-.399 1.123-.399 1.123-.399h.125v.133s-.374 1.994.499 2.26h.249l-.249.133s-.998.266-1.372.797h-.125c-.125.133-.374.133-.499.266-.374.266-.873.399-.873.399zm-.25-.665l.25.532c.124 0 .374-.133.623-.266.25 0 .375-.133.499-.266l.125-.132c.374-.399.998-.665 1.248-.798-.749-.399-.499-1.861-.375-2.26-.249 0-.623 0-.873.266-.125.133-.249.266-.249.532 0 .797-.125.93-.375 1.196l-.124.133c-.125 0-.125.133-.25.133-.249.266-.374.798-.499.93z"
            fill="#000"
            />
            <path
            d="M406.563 163.92c-.125 0-.125.133-.25.133-.249.133-.374.266-.623.266-.25.133-.624.266-.624.266l-.25-.665s.125-.266.25-.399c.374.399.873.399 1.497.399z"
            fill="#fff"
            />
            <path
            d="M405.066 164.718l-.375-.798s.125-.265.25-.398v-.133c.374.266.873.398 1.497.266h.249l-.249.132c-.125 0-.125.133-.125.133h-.125c-.124.133-.374.133-.499.266-.124.399-.623.532-.623.532zm-.25-.665l.25.532c.124 0 .374-.133.623-.266.25 0 .375-.133.499-.266l.125-.133c-.499 0-.998-.133-1.372-.265 0 .132-.125.265-.125.398z"
            fill="#000"
            />
            <path
            d="M404.816 164.718s-.125.133-.25.133c0-.133.125-.532.125-.532l.125.399z"
            fill="#fff"
            />
            <path
            d="M404.566 164.983c0-.266.125-.664.125-.664v-.266l.25.664h-.125c.125.133-.125.133-.25.266zm.125-.399v.133h.125l-.125-.133z"
            fill="#000"
            />
            <path
            d="M404.941 164.85l.374.532-.749.93v-1.196l.375-.266z"
            fill="#fff"
            />
            <path
            d="M404.441 166.579v-1.463l.499-.132.499.531-.998 1.064zm.25-1.463v.931l.624-.798-.375-.398-.249.265z"
            fill="#000"
            />
            <path
            d="M406.188 157.938c.749 0 1.871.399 1.871 1.728 0 .532-.873 2.659-.873 1.994v-.664s-.873.265-1.247 0c-.749-.399-1.373-.665-1.373-1.462 0-.931.624-1.596 1.622-1.596z"
            fill="#131A2D"
            />
            <path
            d="M404.567 159.668c0-.798 1.497-.798 1.871-.399.499.399.499 1.063.499 1.063s.374-.532.374.266c0 .797-.374.399-.374.665 0 .265-.125.398-.499.93-.499.399-1.247.399-1.372.266-.125-.266-.499-1.064-.624-1.462-.125-.266 0-.266 0-.665.125-.266.125-.532.125-.664z"
            fill="#fff"
            />
            <path
            d="M405.564 162.591h-.249c-.125 0-.125-.133-.125-.133 0-.133-.125-.266-.249-.399-.125-.398-.375-.797-.375-.93v-.399-.266-.399-.265c0-.266.125-.532.375-.532.499-.266 1.372-.133 1.621.133.375.399.499.797.499.93.125 0 .125-.133.25 0 .125 0 .125.266.125.532 0 .532-.125.532-.375.532 0 .266-.124.531-.623.93-.125.133-.624.266-.874.266zm0-3.456c-.249 0-.374 0-.623.133-.25.133-.25.266-.25.399V160.863c0 .133.25.665.374.93.125.266.125.399.25.532h.125c.249.133.748 0 1.122-.399.499-.398.499-.664.499-.797v-.133h.125c.125 0 .25 0 .25-.399 0-.266-.125-.399-.125-.399s-.125.133-.25.133l-.124.133v-.266s0-.531-.499-1.063h-.874z"
            fill="#000"
            />
            <path
            d="M406.813 161.129a2.04 2.04 0 00-.124-1.462c0-.133-.125-.266-.125-.398.374.398.374.93.374.93s.374-.532.374.266c0 .797-.374.399-.374.664 0 .266-.125.399-.499.931-.374.266-.873.399-1.123.399h.375a1.925 1.925 0 001.122-1.33z"
            fill="#131A2D"
            />
            <path
            d="M402.321 173.491l-1.248-.797h-.374l-.998.664c-.125 0-.125.133 0 .266l1.247.798h.375l.998-.665c.124-.133.124-.266 0-.266z"
            fill="#fff"
            />
            <path
            d="M409.183 173.092l-7.36-4.785c-.125-.133-.25-.133-.375 0l-5.239 3.19c-.125.133-.125.133 0 .266l7.36 4.785c.125.133.25.133.374 0l5.24-3.19c.125-.133.125-.266 0-.266z"
            fill="#fff"
            />
            <path
            d="M403.818 176.681h-.249l-7.36-4.785c-.125 0-.125-.133-.125-.133 0-.133 0-.133.125-.266l5.239-3.19a.362.362 0 01.499 0l7.36 4.785c.125 0 .125.133.125.133 0 .133 0 .133-.125.266l-5.239 3.19c-.125-.133-.25 0-.25 0zm-2.12-8.374h-.125l-5.24 3.19 7.361 4.785h.249l5.24-3.19-7.361-4.785h-.124z"
            fill="#140035"
            />
            <path
            d="M402.322 170.566c-.125 0-.125.133 0 .266l2.62 1.728h.125l1.621-1.063-2.869-1.861-1.497.93z"
            fill="#fff"
            />
            <path
            d="M405.066 172.56l-2.744-1.728-.125-.133c0-.133 0-.133.125-.133l1.622-.93 2.994 1.861-1.872 1.063c.125 0 0 0 0 0zm-2.619-1.994c-.125.133-.125.133 0 0-.125.133-.125.133 0 0l2.619 1.861 1.498-.93-2.62-1.728-1.497.797z"
            fill="#140035"
            />
            <path
            d="M402.572 170.566l1.497-.797h-.125l-1.622.93c-.125 0-.125.133 0 .266l2.62 1.728h.125l-2.62-1.728c0-.266 0-.399.125-.399z"
            fill="#131A2D"
            />
            <path
            d="M409.184 173.225l-5.24 3.19-7.36-4.785v.133l7.36 4.785 5.24-3.19s.124 0 0-.133c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M406.687 174.022l-.249.133-.374-.265.249-.133v-.133l-.249.133-.375-.266.25-.133v-.133l-.25.133-.374-.266.25-.133v-.133l-.25.133-.374-.266.249-.133v-.133l-.249.133-.374-.265.249-.133v-.133l-.249.133-.375-.266.25-.133v-.133l-.25.133-.374-.266.25-.133v-.133l-.25.133-.374-.266.249-.133v-.133l-.249.133-.374-.266.249-.132v-.133l-.249.133-.375-.266.25-.133v-.133l-.25.133-.374-.266.25-.133v-.133l-.25.133-.374-.266.249-.133v-.133l-.249.133-.374-.266.249-.133v-.132l-.249.132-.375-.265.25-.133v-.133l-.25.133-.374-.266v.133l.374.266.375.265v.133l.124.133-.249.133-1.123-.664v.133l.374.265-.249.133-.374-.266v.133l.249.133-.624.399-.249-.133v.133l.249.133-.623.399-.25-.133v.133l.25.133.374-.266.374.266v.133l.125.133v.132l-.25.133-.374-.265.25-.133v-.133l-.25.133-.374-.266v.133l.374.266v.132l.374.266v.133l.375.266v.133l.374.266v.133l2.121 1.329v.133l.374.266v.133l.374.265v.133l.374.266v.133l.375.266v.133l.249.133.25-.133v-.133l.249-.133v-.133h.125l.249-.133.25-.133v-.133l.249-.133v-.132l-.249.132-.749-.398.25-.133v-.133l.249.133v.133l.375.266.249-.133v-.133l.125.133.748.265c0 .133 0 .133 0 0zm-6.237-3.057l-.374.266v.133l.124-.133v.133l.125.133-.249.133-.624-.399v.133l.249.133-.249.133-.374-.266.249-.133.25-.133v-.133l.124.133.25-.133v-.133l.249.133h.25c-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0v-.133.133z"
            fill="#fff"
            />
            <path
            d="M398.829 170.965c0-.133 0-.133 0 0l-.374.133.374.266.25-.133-.25-.266z"
            fill="url(#paint157_linear_874_76773)"
            />
            <path
            d="M399.327 170.7c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.124-.133v.133l-.25.133.374.266.25-.133-.125-.133z"
            fill="url(#paint158_linear_874_76773)"
            />
            <path
            d="M399.578 170.434l-.25.133.374.266.25-.133-.374-.266z"
            fill="url(#paint159_linear_874_76773)"
            />
            <path
            d="M400.202 171.63c-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0l-.499-.133-.25.133.374.266.375-.266c0 .133 0 .133 0 0 0 .133 0 .133 0 0 0 .133 0 .133 0 0z"
            fill="url(#paint160_linear_874_76773)"
            />
            <path
            d="M400.325 172.427c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.124-.133v.133l-.25.133.374.266.25-.133-.125-.133z"
            fill="url(#paint161_linear_874_76773)"
            />
            <path
            d="M400.825 172.694c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.124-.133v.133l-.25.133.374.266.25-.133-.125-.133z"
            fill="url(#paint162_linear_874_76773)"
            />
            <path
            d="M401.323 173.092c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.124-.133v.133l-.25.133.374.266.25-.133-.125-.133z"
            fill="url(#paint163_linear_874_76773)"
            />
            <path
            d="M401.698 173.359c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.124-.133v.133l-.25.133.374.266.25-.133-.125-.133z"
            fill="url(#paint164_linear_874_76773)"
            />
            <path
            d="M402.196 173.624c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133v.133l-.25.133.375.265.249-.133-.125-.132z"
            fill="url(#paint165_linear_874_76773)"
            />
            <path
            d="M402.696 173.89c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.124-.133-.125-.133v.133l-.25.133.375.266.249-.133-.125-.133z"
            fill="url(#paint166_linear_874_76773)"
            />
            <path
            d="M403.069 174.156c-.124 0-.124 0 0 0l-.124-.133-.125-.133v.133l-.25.133.375.266.249-.133-.125-.133z"
            fill="url(#paint167_linear_874_76773)"
            />
            <path
            d="M403.569 174.554c0-.133 0 0 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133v.133l-.25.133.375.266.249-.133-.125-.133z"
            fill="url(#paint168_linear_874_76773)"
            />
            <path
            d="M404.069 174.821c-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133v.133l-.25.133.375.266.124-.266.125.133-.125-.133z"
            fill="url(#paint169_linear_874_76773)"
            />
            <path
            d="M404.567 173.624c-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.249-.133-.25.133.375.265.249-.132z"
            fill="url(#paint170_linear_874_76773)"
            />
            <path
            d="M404.069 173.359c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.249-.133v.133l-.25.133.375.266.249-.266c.125 0 .125 0 0 0z"
            fill="url(#paint171_linear_874_76773)"
            />
            <path
            d="M403.569 173.092c0-.133 0 0 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0l-.125-.133-.249-.133v.133l-.25.133.375.266.249-.266c.125 0 .125 0 0 0z"
            fill="url(#paint172_linear_874_76773)"
            />
            <path
            d="M403.194 172.694c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.249-.133v.133l-.25.133.375.266.249-.266c0 .133 0 .133 0 0z"
            fill="url(#paint173_linear_874_76773)"
            />
            <path
            d="M402.696 172.427c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.249-.133v.133l-.25.133.375.266.249-.266c.125 0 .125 0 0 0z"
            fill="url(#paint174_linear_874_76773)"
            />
            <path
            d="M402.196 172.162c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.125-.133 0 0l-.125-.133-.249-.133v.133l-.25.133.375.265.249-.265c.125 0 .125 0 0 0z"
            fill="url(#paint175_linear_874_76773)"
            />
            <path
            d="M401.823 171.896c-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.249-.133v.133l-.25.133.374.266.25-.266z"
            fill="url(#paint176_linear_874_76773)"
            />
            <path
            d="M401.323 171.498c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.249-.133v.133l-.25.133.374.265.25-.265c.125.132 0 .132 0 0z"
            fill="url(#paint177_linear_874_76773)"
            />
            <path
            d="M400.825 171.232c-.125 0-.125 0 0 0l-.125-.133-.249-.133-.25.133.374.266.25-.133c.125.133.125.133 0 0z"
            fill="url(#paint178_linear_874_76773)"
            />
            <path
            d="M400.7 171.63c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.124-.132v.132l-.25.133.374.266.25-.133-.125-.133z"
            fill="url(#paint179_linear_874_76773)"
            />
            <path
            d="M401.075 172.427c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.499-.266-.25.133.374.266.375-.133z"
            fill="url(#paint180_linear_874_76773)"
            />
            <path
            d="M401.448 172.561l-.374-.266-.25.133.374.266.25-.133c.125.133.125.133 0 0 .125.133.125.133 0 0 .125.133.125.133 0 0z"
            fill="url(#paint181_linear_874_76773)"
            />
            <path
            d="M401.948 172.959c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.499-.265-.25.133.374.265.375-.133z"
            fill="url(#paint182_linear_874_76773)"
            />
            <path
            d="M402.446 173.225c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.499-.266v.133l-.25.133.375.266.374-.266z"
            fill="url(#paint183_linear_874_76773)"
            />
            <path
            d="M402.946 173.492c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.499-.266v.133l-.25.133.375.266.374-.266c0 .133 0 .133 0 0 0 .133 0 0 0 0z"
            fill="url(#paint184_linear_874_76773)"
            />
            <path
            d="M403.319 173.89c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.499-.266-.25.133.375.266.374-.133z"
            fill="url(#paint185_linear_874_76773)"
            />
            <path
            d="M403.819 174.156c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.125-.133 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.499-.266v.133l-.25.133.375.266.374-.266z"
            fill="url(#paint186_linear_874_76773)"
            />
            <path
            d="M403.944 173.756c-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint187_linear_874_76773)"
            />
            <path
            d="M403.444 173.492c0-.133 0 0 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133v.133l-.25.133.375.266.249-.133-.125-.133z"
            fill="url(#paint188_linear_874_76773)"
            />
            <path
            d="M402.946 173.092c-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint189_linear_874_76773)"
            />
            <path
            d="M402.571 172.827c-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint190_linear_874_76773)"
            />
            <path
            d="M402.071 172.561c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint191_linear_874_76773)"
            />
            <path
            d="M401.573 172.295c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.124-.133-.25.133.374.266.25-.133h-.125z"
            fill="url(#paint192_linear_874_76773)"
            />
            <path
            d="M401.198 171.896c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.124-.133-.25.133.374.266.25-.133h-.125z"
            fill="url(#paint193_linear_874_76773)"
            />
            <path
            d="M404.317 174.023c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint194_linear_874_76773)"
            />
            <path
            d="M404.319 174.421c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.499-.265v.132l-.25.133.375.266.374-.266z"
            fill="url(#paint195_linear_874_76773)"
            />
            <path
            d="M400.575 172.029c-.125 0 0 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.499-.133v.133l-.25.133.374.265.375-.398z"
            fill="url(#paint196_linear_874_76773)"
            />
            <path
            d="M400.95 170.832c0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0-.125-.132-.125-.132 0 0l-.125-.132-.124-.133v.133l-.25.132.374.266.25-.133-.125-.133z"
            fill="url(#paint197_linear_874_76773)"
            />
            <path
            d="M401.448 171.098c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.124-.133-.25.133.374.266.25-.133h-.125z"
            fill="url(#paint198_linear_874_76773)"
            />
            <path
            d="M401.823 171.365l-.125-.133-.124-.133v.133l-.25.133.374.266.25-.133-.125-.133z"
            fill="url(#paint199_linear_874_76773)"
            />
            <path
            d="M402.321 171.763c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint200_linear_874_76773)"
            />
            <path
            d="M402.821 172.03c-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133v.133l-.25.133.375.266.249-.133-.125-.133z"
            fill="url(#paint201_linear_874_76773)"
            />
            <path
            d="M403.319 172.294c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.132-.25.132.375.266.249-.133h-.125z"
            fill="url(#paint202_linear_874_76773)"
            />
            <path
            d="M403.694 172.561c-.124 0 0 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint203_linear_874_76773)"
            />
            <path
            d="M404.192 172.959c0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132 0-.132 0 0 0-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0-.124-.132-.124-.132 0 0l-.124-.132-.125-.133-.25.133.375.265.249-.133h-.125z"
            fill="url(#paint204_linear_874_76773)"
            />
            <path
            d="M404.692 173.225c-.124 0 0 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint205_linear_874_76773)"
            />
            <path
            d="M405.065 173.492c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint206_linear_874_76773)"
            />
            <path
            d="M406.065 174.023c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.124-.133-.125-.133v.133l-.25.133.375.266.249-.133-.125-.133z"
            fill="url(#paint207_linear_874_76773)"
            />
            <path
            d="M405.565 173.756c-.124 0 0 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.124-.133-.125-.133-.25.133.375.266.249-.133h-.125z"
            fill="url(#paint208_linear_874_76773)"
            />
            <path
            d="M405.065 173.89c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.125-.133-.249-.133v.133l-.25.133.375.266.249-.266c0 .133 0 .133 0 0z"
            fill="url(#paint209_linear_874_76773)"
            />
            <path
            d="M404.817 174.289c-.124 0 0 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.124-.133-.125-.133v.133l-.25.133.375.265.249-.133-.125-.132z"
            fill="url(#paint210_linear_874_76773)"
            />
            <path
            d="M404.941 174.421c0 .133 0 .133 0 0l-.25.133.375.266.249-.133-.374-.266z"
            fill="url(#paint211_linear_874_76773)"
            />
            <path
            d="M404.692 174.82c0-.133 0 0 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.374-.266v.133l-.25.133.749.399.249-.133-.249-.133z"
            fill="url(#paint212_linear_874_76773)"
            />
            <path
            d="M404.193 174.953l-.25.133.375.266.249-.133-.374-.266z"
            fill="url(#paint213_linear_874_76773)"
            />
            <path
            d="M404.317 175.485l-.374-.266v.133l-.25.133.25.133.374-.133z"
            fill="url(#paint214_linear_874_76773)"
            />
            <path
            d="M403.944 175.219c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.499-.266v.133l-.25.133.375.266.374-.266z"
            fill="url(#paint215_linear_874_76773)"
            />
            <path
            d="M403.444 174.953c0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0 0-.133 0-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.499-.266v.133l-.25.133.375.265.374-.265z"
            fill="url(#paint216_linear_874_76773)"
            />
            <path
            d="M403.071 174.687c-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.499-.266v.133l-.25.133.375.266.374-.266z"
            fill="url(#paint217_linear_874_76773)"
            />
            <path
            d="M402.571 174.288c-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.499-.132v.132l-.25.133.375.266.374-.399z"
            fill="url(#paint218_linear_874_76773)"
            />
            <path
            d="M402.072 174.022c-.125 0 0 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-.499-.266v-.132l-.375-.266v-.133l-.374-.266v-.133l-.374-.266v-.133l-.374-.266v.133l-.25.133 2.121 1.329.125.266z"
            fill="url(#paint219_linear_874_76773)"
            />
            <path
            d="M399.827 172.428c0 .133 0 .133 0 0 0 .133 0 .133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0l-.499-.133v.133l-.25.133.374.266.375-.399c0 .133 0 .133 0 0 0 .133 0 .133 0 0 0 .133 0 .133 0 0z"
            fill="url(#paint220_linear_874_76773)"
            />
            <path
            d="M399.204 172.162c-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.124-.133v.133l-.25.133.374.265.25-.132-.125-.133z"
            fill="url(#paint221_linear_874_76773)"
            />
            <path
            d="M399.951 172.162c-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0-.125-.133-.125-.133 0 0l-.125-.133-.374-.266v-.133l-.249-.133v.133l-.25.133.25.133.249-.133v.133l-.249.133.499.399.249-.133v-.133z"
            fill="url(#paint222_linear_874_76773)"
            />
            <path
            d="M398.952 171.497c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0-.124-.133-.124-.133 0 0l-.124-.132v.132l-.25.133.125.133.249-.133v-.133z"
            fill="url(#paint223_linear_874_76773)"
            />
            <path
            d="M398.454 171.099c-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0-.124 0-.124 0 0 0l-.124-.133v.133l-.25.133.374.266.25-.133-.25-.266z"
            fill="url(#paint224_linear_874_76773)"
            />
            <path
            d="M400.327 169.769l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c0 .133 0 .133 0 0zM400.7 170.168l-.375-.265h-.124l-.25.133.374.265h.125l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M401.2 170.433l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133zM401.698 170.7l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M402.073 170.965l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c0 .133 0 0 0 0zM402.571 171.365l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M403.071 171.63l-.374-.265h-.125l-.25.132.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M403.444 171.896l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM403.944 172.162l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 0 0 0zM404.068 172.295l-.375.133.375.266h.124l.25-.133-.374-.266z"
            fill="#131A2D"
            />
            <path
            d="M404.817 172.827l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M405.315 173.092l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM405.815 173.359l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M406.19 173.624l-.374-.266h-.125l-.25.133.375.265h.124l.25-.132c.125.132.125 0 0 0zM406.314 173.757l-.375.133.375.266h.124l.25-.133-.374-.266zM400.7 170.567l-1.123-.665h-.124l-.25.133 1.123.665h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M401.075 170.832l-.375-.265h-.124l-.25.133.374.265h.125l.25-.133c0 .133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M401.573 171.098l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c0 .133 0 .133 0 0zM402.073 171.498l-.375-.266h-.124l-.25.133.374.265h.125l.25-.132z"
            fill="#131A2D"
            />
            <path
            d="M402.197 171.497c-.125 0-.125 0 0 0l-.375.133.375.266h.124l.25-.133-.374-.266z"
            fill="#131A2D"
            />
            <path
            d="M402.946 172.03l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM403.07 172.161c-.125 0 0 0 0 0l-.375.133.375.266h.124l.25-.133-.374-.266z"
            fill="#131A2D"
            />
            <path
            d="M403.819 172.694l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM404.319 172.959l-.374-.265h-.125l-.25.133.375.265h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M404.817 173.225l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M405.19 173.492l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 0 0 0zM405.316 173.624l-.375.133.375.266h.124l.25-.133-.374-.266zM406.19 174.156l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM399.454 170.3l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c.124.133.124 0 0 0zM399.952 170.7l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133zM398.953 170.567l-.249-.133h-.125l-.624.399.25.133h.124l.624-.399c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M399.454 170.832l-.375-.265h-.124l-.25.133.374.265h.125l.25-.133c.124 0 .124 0 0 0zM400.95 171.232l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M400.202 170.699c-.125 0-.125 0 0 0l-.499.266h-.125l-.125.133.624.399h.125l.249-.133-.249-.133.374-.266-.374-.266zM401.325 171.498l-.375-.266h-.124l-.25.133.374.265h.125l.25-.132c.124.132.124 0 0 0zM401.823 171.896l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M402.321 172.162l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M402.447 172.161c-.125 0 0 0 0 0l-.375.133.375.266h.124l.25-.133-.374-.266z"
            fill="#131A2D"
            />
            <path
            d="M403.196 172.694l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M403.694 172.959l-.374-.265h-.125l-.25.133.375.265h.124l.25-.133c0 .133 0 .133 0 0zM404.194 173.359l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M404.567 173.624l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM404.693 173.757c0-.133 0-.133 0 0l-.375.133.375.266h.124l.25-.133-.374-.266z"
            fill="#131A2D"
            />
            <path
            d="M405.191 174.023l-.375.133.749.398h.125l.249-.133-.748-.398zM400.825 171.63l-.375-.265h-.124l-.25.132.374.266h.125l.25-.133c0 .133 0 .133 0 0zM401.325 172.03l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M401.448 172.029c-.124 0 0 0 0 0l-.374.133.374.266h.125l.25-.133-.375-.266z"
            fill="#131A2D"
            />
            <path
            d="M402.198 172.561l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M402.696 172.827l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 0 0 0zM402.822 172.959c-.125 0 0 0 0 0l-.375.133.375.266h.124l.25-.133-.374-.266z"
            fill="#131A2D"
            />
            <path
            d="M403.569 173.492l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M404.069 173.756l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM404.567 174.023l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M404.942 174.289l-.374-.266h-.125l-.25.133.375.265h.124l.25-.132c0 .132 0 .132 0 0zM405.066 174.421l-.375.133.375.266h.124l.25-.133-.374-.266zM399.079 171.098l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133zM399.202 171.099l-.374.133.374.266h.125l.25-.133-.375-.266zM400.077 171.763l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c.124 0 .124 0 0 0zM400.325 171.764c-.124 0-.124 0 0 0l-.374.133.374.266h.125l.25-.133-.375-.266z"
            fill="#131A2D"
            />
            <path
            d="M401.075 172.294l-.375-.265h-.124l-.25.132.374.266h.125l.25-.133c0 .133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M401.448 172.561l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c.124.133.124.133 0 0zM401.948 172.959l-.375-.265h-.124l-.25.133.374.265h.125l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M402.446 173.225l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM402.946 173.492l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M403.319 173.756l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 0 0 0zM403.819 174.156l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M403.945 174.156c-.125 0 0 0 0 0l-.375.132.375.266h.124l.25-.133-.374-.265zM405.066 174.954l-.748-.399h-.125l-.25.133.749.399h.125l.249-.133c.125 0 .125 0 0 0zM398.205 170.965l-.249-.133h-.125l-.624.399.25.133h.124l.624-.399c0 .133 0 0 0 0zM398.704 171.365l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133zM399.077 171.497l-.125-.132h-.124l-.25.132.125.133h.125l.249-.133c0 .133 0 0 0 0zM399.329 171.763l-.25-.133h-.124l-.25.133.25.133h.124l.25-.133c.125 0 .125 0 0 0zM400.076 172.163l-.499-.399h-.124l-.25.133.499.399h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M400.45 172.427l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c.124.133.124 0 0 0zM400.95 172.827l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M401.073 172.826l-.374.133.374.266h.125l.25-.133-.375-.266z"
            fill="#131A2D"
            />
            <path
            d="M401.823 173.359l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M402.321 173.624l-.374-.266h-.125l-.25.133.375.265h.124l.25-.132c0 .132 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M402.821 173.89l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 .133 0 0zM403.196 174.289l-.374-.266h-.125l-.25.133.375.265h.124l.25-.132c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M403.694 174.554l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM404.194 174.821l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M404.692 175.085l-.374-.265h-.125l-.25.133.375.265h.124l.25-.133c0 .133 0 .133 0 0zM398.454 171.63l-.375-.265h-.124l-.25.132.374.266h.125l.25-.133zM398.579 171.764c-.124 0 0 0 0 0l-.374.133.374.266h.125l.25-.133-.375-.266z"
            fill="#131A2D"
            />
            <path
            d="M399.327 172.162l-.375-.266h-.124l-.25.133.374.266h.125l.25-.133c0 .133 0 .133 0 0zM399.452 172.295l-.374.133.374.266h.125l.25-.133-.375-.266zM402.073 174.023l-2.121-1.329h-.124l-.25.133 2.121 1.329h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M402.571 174.289l-.374-.266h-.125l-.25.133.375.265h.124l.25-.132z"
            fill="#131A2D"
            />
            <path
            d="M403.071 174.554l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133c0 .133 0 0 0 0zM403.444 174.953l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM403.944 175.219l-.374-.266h-.125l-.25.133.375.266h.124l.25-.133zM404.317 175.485l-.249-.133h-.125l-.25.133.25.133h.125l.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M402.821 169.636l-7.36-4.785c-.125-.133-.125 0-.125.133l.873 6.38c0 .133.125.266.25.399l7.36 4.785c.125.133.125 0 .125-.133l-.874-6.38c0-.266-.124-.399-.249-.399z"
            fill="#fff"
            />
            <path
            d="M403.819 176.548l-7.485-4.785c-.125-.133-.25-.266-.25-.399l-.873-6.38c0-.133 0-.133.125-.266h.249l7.36 4.785c.125.133.25.266.25.399l.873 6.38c0 .133-.125.266-.249.266.124 0 0 0 0 0zm-8.359-11.564l.874 6.38c0 .133.124.266.124.266l7.361 4.785-.874-6.38c0-.133-.124-.266-.124-.266l-7.361-4.785z"
            fill="#140035"
            />
            <path
            d="M396.208 171.365c0 .133.125.266.249.398l7.361 4.786c.124.133.124 0 .124-.133l-.124-.798c-2.745-2.658-5.489-5.45-8.109-8.108l.499 3.855z"
            fill="url(#paint225_linear_874_76773)"
            opacity={0.4}
            />
            <path
            d="M403.194 169.769v-.133l-7.36-4.785-.125.133 7.36 4.785s0 .133.125 0c-.125.133-.125.133 0 0-.125.133-.125.133 0 0-.125.133-.125.133 0 0l-.125.133.873 6.38v.133l.125-.133v-.133l-.873-6.38c0 .133 0 .133 0 0 0 .133 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M410.306 169.504c-.249-1.197-.374-1.994-.748-3.722-.499-1.861-.873-1.994-1.372-1.994-1.373 0-1.123 1.994-.624 3.19.374.931.624 1.728.873 2.393-1.746.266-4.241 1.329-4.74 1.462h-.375l.125.797c.125 0 .374 0 .499-.133.25 0-.374.133-.374.399v.133c.125 0 .249-.133.624-.266.748-.133.249-.398 1.247-.531.998-.133 3.119 0 4.242-.532.249-.133.499-.266.499-.399.124-.133.124-.399.124-.797z"
            fill="#fff"
            />
            <path
            d="M403.444 172.162l-.124-.266c0-.133.124-.133.249-.266h-.249l-.125-.93h.249c.25 0 .749-.266 1.373-.399.998-.266 2.245-.797 3.243-.93 0-.133-.125-.266-.125-.399-.249-.532-.499-1.196-.748-1.861-.374-.93-.624-2.127-.25-2.791.125-.266.499-.399.874-.399.623 0 .998.133 1.497 1.994.249 1.196.374 1.861.623 2.658.125.266.125.665.25 1.063.125.399 0 .798-.125 1.064-.125.133-.374.266-.624.399-.873.398-2.12.398-3.243.398h-1.123c-.499 0-.499.133-.624.266-.124.133-.249.266-.499.266-.249 0-.374.133-.499.133.125 0 0 0 0 0zm0-.266c.125.133.125.133 0 0 .125 0 .375-.133.499-.133.375 0 .375-.133.499-.266.125-.133.25-.265.749-.265h1.123c.998 0 2.37 0 3.118-.399.25-.133.375-.266.499-.399.125-.266.25-.532.125-.93-.125-.399-.125-.665-.249-1.064a16.215 16.215 0 00-.624-2.658c-.499-1.861-.873-1.861-1.372-1.861-.375 0-.624.133-.749.399-.374.664-.125 1.861.25 2.658.249.665.499 1.329.748 1.861 0 .133.125.266.125.399v.133h-.125c-.998.133-2.37.664-3.368.93-.624.266-1.248.399-1.497.399h-.25l.125.664h.499s0 .133-.125.133c.375.133.125.266 0 .399z"
            fill="#000"
            />
            <path
            d="M403.07 169.503c-.125 0-.125 0 0 0-.125 0-.125 0 0 0l-5.614-3.589c0-.133-.125-.133 0-.265 0-.133.125.132.499.265.748.266.125.532.998.798.998.133 2.994.399 4.241 1.063.998.532.624 1.861-.124 1.728z"
            fill="#fff"
            />
            <path
            d="M403.07 169.636h-.124l-5.614-3.589c-.125-.133-.125-.266 0-.398l.125-.133h.124c.125 0 .125.133.375.265.374.133.374.266.499.399.124.133.124.266.623.399.125 0 .375 0 .499.133 1.123.133 2.745.399 3.743 1.063.624.399.748.931.624 1.329-.25.266-.499.532-.874.532zm0-.133c.25 0 .499-.133.624-.531.125-.399 0-.931-.624-1.197-.998-.531-2.619-.797-3.742-1.063-.25 0-.374 0-.499-.133-.125 0-.25 0-.25-.133l4.491 3.057c0-.133-.124-.133 0 0 0-.133 0-.133 0 0zm-5.613-3.722l.873.532s0-.133-.125-.133c0-.133-.125-.266-.374-.266-.25-.133-.374-.133-.374-.265v.132z"
            fill="#000"
            />
            <path
            opacity={0.3}
            d="M498.752 306.944v6.646l-16.716 12.628-23.952-14.489 25.449-15.286 15.219 10.501z"
            fill="url(#paint226_linear_874_76773)"
            />
            <path
            d="M485.529 299.102c-8.858 2.26-16.842 6.779-23.204 13.026-.25.266-.748.399-.998.266-3.368-1.329-5.489-2.393-9.356-3.456-.374-.133-.624-.93-.374-1.196 6.487-7.311 13.473-12.628 22.954-15.818.374-.133.998 0 1.372.133 3.493 2.127 6.861 3.722 9.855 5.849.25.398.125 1.196-.249 1.196z"
            fill="#131A2D"
            />
            <path
            d="M485.529 298.437c-8.857 2.26-16.841 6.779-23.204 13.026-.249.266-.748.399-.998.266-3.368-1.329-5.489-2.393-9.356-3.456-.374-.133-.499-.399-.249-.665 6.487-7.31 13.348-13.026 22.829-16.349.374-.133.998 0 1.372.133 3.493 2.127 6.737 4.254 9.855 6.513.25.266.125.532-.249.532z"
            fill="#0EA59D"
            />
            <path
            d="M461.702 311.995h-.374c-.998-.399-1.996-.798-2.869-1.196-1.996-.798-3.867-1.596-6.487-2.26-.25 0-.374-.133-.374-.399 0-.133 0-.266.124-.532 7.61-8.507 14.471-13.425 22.83-16.349.374-.133.998 0 1.372.133a116.074 116.074 0 019.855 6.513c.25.133.25.266.25.399s-.125.266-.375.266c-8.732 2.127-16.716 6.646-23.078 13.026-.25.266-.624.399-.874.399zm13.349-20.603h-.375c-8.358 2.924-15.219 7.709-22.829 16.349-.125.133-.125.266-.125.266 0 .133.125.266.375.266 2.744.665 4.615 1.462 6.611 2.26.874.398 1.747.797 2.87 1.196.249.133.748 0 .998-.266a51.437 51.437 0 0123.203-13.159c.125 0 .25-.133.25-.133 0-.133 0-.133-.125-.266a157.787 157.787 0 00-9.731-6.513h-1.122z"
            fill="#131A2D"
            />
            <path
            d="M482.035 298.171c.125 0 .125 0 0 0 .374.265.374.531 0 .664-6.986 2.26-13.348 5.982-18.712 10.767-.25.266-.749.266-.998.133-.25-.133-.749 0-.998.265-.25.266-.749.399-.998.266-2.121-.797-2.87-1.462-5.115-2.126-.374-.133-.374-.399-.125-.665.25-.266.25-.532-.125-.665h-.124c-.375-.133-.375-.398-.125-.664 5.489-5.583 10.604-10.102 17.964-13.026.374-.133.873-.133 1.247.132h.125c.374.133.873.266 1.248.133.124 0 .249-.133.249-.133.374-.132.873-.132 1.248.133 2.12 1.33 4.116 2.526 5.988 3.855.249.133.249.399-.125.532-.125 0-.25 0-.25.133-.499-.133-.623 0-.374.266z"
            fill="#fff"
            />
            <path
            d="M460.454 310.267h-.374c-.873-.399-1.622-.665-2.246-.931-.873-.399-1.621-.797-2.869-1.196-.249 0-.374-.133-.374-.266s0-.266.125-.532c.124-.133.124-.266.124-.398 0-.133-.124-.133-.249-.266h-.125c-.249 0-.374-.133-.374-.266s0-.266.125-.532c5.863-5.981 10.853-10.235 18.088-13.026.375-.133.998-.133 1.248.133h.125c.249.133.873.266 1.122.133.125 0 .25-.133.25-.133.374-.133.998-.133 1.247.133 1.996 1.196 4.117 2.525 5.988 3.854.25.133.25.266.25.399s-.125.266-.374.266c-.125 0-.25 0-.25.133-.125 0-.249.133-.249.133s0 .133.124.266h.125c.25.133.25.266.25.399 0 .132-.125.265-.375.265-6.861 2.127-13.348 5.849-18.712 10.767-.25.266-.749.399-1.123.266-.249-.133-.748 0-.998.133.125.266-.125.266-.499.266zm12.6-17.413c-.125 0-.374 0-.499.133-7.111 2.791-12.101 7.045-17.964 13.026-.125.133-.125.266-.125.266l.25.266h.124c.25 0 .375.133.375.266s0 .265-.125.531c-.125.133-.125.266-.125.399s.125.133.25.266c1.372.399 2.12.797 2.994 1.196.623.266 1.247.665 2.245.931.25.133.749 0 .998-.266h.125c.249-.266.748-.399 1.123-.266.249.133.748 0 .998-.133 5.364-4.918 11.851-8.64 18.712-10.767.125 0 .25-.132.25-.132s0-.133-.125-.266h-.125c-.249-.133-.249-.266-.249-.399s.124-.266.374-.266c.125 0 .249 0 .249-.133.125 0 .25-.133.25-.133s0-.133-.125-.266c-1.996-1.329-3.992-2.658-5.988-3.854-.249-.133-.873-.266-1.123-.133-.124 0-.249.133-.249.133-.374.133-.998.133-1.248-.133h-.124c-.624-.133-.998-.266-1.123-.266z"
            fill="#131A2D"
            />
            <path
            d="M462.699 302.957c-.748-1.064-.748-2.393.125-3.589 1.372-1.861 4.615-2.659 6.986-1.728.998.399 1.622.93 1.996 1.595.624 1.063.374 2.26-.499 3.323-1.497 1.728-4.242 2.525-6.487 1.861a4.191 4.191 0 01-2.121-1.462z"
            fill="#fff"
            />
            <path
            d="M469.56 298.172c2.121.798 2.62 2.658 1.372 4.121-1.247 1.462-3.867 2.259-5.988 1.595-2.12-.665-2.994-2.526-1.746-4.121 1.372-1.728 4.241-2.393 6.362-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M466.566 304.153c-.499 0-.998-.133-1.497-.266-1.123-.398-1.996-1.063-2.245-1.993-.25-.798-.125-1.595.499-2.26 1.247-1.728 4.116-2.393 6.362-1.595 1.123.399 1.871 1.063 1.996 1.994.125.797-.125 1.462-.624 2.259-1.123 1.197-2.869 1.861-4.491 1.861zm1.123-6.247c-1.747 0-3.493.665-4.366 1.861a2.727 2.727 0 00-.499 2.127c.249.93.998 1.595 2.12 1.861 1.996.531 4.616-.133 5.864-1.596.623-.664.748-1.329.623-2.126-.249-.798-.873-1.462-1.996-1.861-.499-.133-1.122-.266-1.746-.266z"
            fill="#131A2D"
            />
            <path
            d="M459.705 306.413c-.749-.266-.873-.931-.374-1.462.623-.532 1.746-.665 2.495-.399.748.266.873.93.249 1.462-.624.532-1.622.665-2.37.399z"
            fill="#0EA59D"
            />
            <path
            d="M460.454 306.679c-.25 0-.624 0-.873-.133a1.303 1.303 0 01-.749-.665c0-.266.125-.532.374-.797.624-.532 1.747-.665 2.495-.399.375.133.624.399.624.664 0 .266-.125.532-.374.798-.25.266-.873.532-1.497.532zm-.749-.399c.749.266 1.747.133 2.371-.399.249-.266.374-.399.374-.665 0-.265-.25-.398-.624-.664-.748-.266-1.746-.133-2.37.399-.25.265-.374.398-.374.664.124.399.249.532.623.665z"
            fill="#131A2D"
            />
            <path
            d="M473.429 297.507c-.749-.399-.749-.931 0-1.33.748-.265 1.871-.265 2.619.133.749.399.624.931 0 1.33-.748.265-1.871.133-2.619-.133z"
            fill="#0EA59D"
            />
            <path
            d="M474.925 297.906c-.499 0-1.122-.133-1.497-.399-.374-.266-.623-.532-.623-.798s.249-.531.623-.664c.749-.266 1.872-.266 2.62.266.374.265.499.531.499.797s-.249.532-.624.665c-.249 0-.623.133-.998.133zm-1.497-.532c.624.399 1.747.399 2.495.133.375-.133.499-.266.499-.532s-.124-.399-.499-.664c-.623-.399-1.871-.532-2.495-.133-.249.133-.499.265-.499.531s.25.532.499.665z"
            fill="#131A2D"
            />
            <path
            d="M451.845 304.285h1.622v.399L474.3 290.86c.375-.132.874-.132 1.123 0l8.857 5.45-.124-.133 1.621-.266v.798c0 .133-.124.266-.249.399l-23.703 14.621c-.374.133-.873.133-1.122 0l-8.733-6.247c-.125-.133-.249-.266-.249-.399l.124-.798z"
            fill="#131A2D"
            />
            <path
            d="M452.095 304.02l22.206-14.621c.374-.133.873-.133 1.122 0l10.23 6.247c.374.266.374.531 0 .664l-23.703 14.622c-.249.133-.873.133-1.122 0l-8.733-6.248c-.374-.133-.374-.398 0-.664z"
            fill="#0EA59D"
            />
            <path
            d="M461.451 311.33c-.249 0-.499 0-.623-.133l-8.733-6.247c-.249-.133-.249-.266-.249-.399 0-.132.124-.265.249-.398l22.206-14.622c.374-.265.873-.133 1.247 0l10.23 6.248c.249.133.249.266.249.398 0 .133-.125.266-.249.399l-23.703 14.621c-.249 0-.374.133-.624.133zm13.349-21.932c-.25 0-.375 0-.499.133l-22.206 14.622c-.125.133-.125.133-.125.266 0 .132.125.265.25.265l8.732 6.248c.375.133.749.266 1.123 0l23.703-14.622c.124-.133.124-.133.124-.265 0-.133-.124-.266-.249-.266l-10.23-6.248c-.124-.133-.374-.133-.623-.133z"
            fill="#131A2D"
            />
            <path
            d="M455.464 303.754c-.375-.265-.375-.531-.125-.797l17.59-11.697c.249-.133.873-.133 1.122 0 .25.133.874.266 1.123 0 .25-.133.749-.133 1.123 0l6.237 3.855c.375.132.375.531 0 .664-.249.133-.249.532 0 .665h.125c.374.133.374.531 0 .664l-19.087 11.697c-.249.133-.748.133-1.122 0h-.125c-.25-.133-.749-.133-1.123 0l-.249.133c-.25.133-.749.133-1.123 0l-4.741-3.854c-.374-.133-.374-.532 0-.665l.25-.133c.499 0 .499-.266.125-.532z"
            fill="#fff"
            />
            <path
            d="M460.579 309.337c-.25 0-.375 0-.624-.133l-4.741-3.855c-.124-.133-.249-.265-.249-.398s.125-.266.249-.399l.25-.133c.125-.133.125-.133.125-.266s-.125-.266-.25-.266h-.125c-.124-.133-.249-.266-.249-.398 0-.133.125-.266.249-.399l17.59-11.697a1.076 1.076 0 011.248 0c.249.133.748.133.998 0 .374-.266.873-.133 1.247 0l6.238 3.854c.124.133.249.266.249.399s-.125.266-.249.399c-.125.133-.25.133-.25.266s.125.266.25.266h.124c.125.133.25.266.25.398 0 .133-.125.266-.25.399l-19.086 11.697c-.375.266-.874.133-1.123 0h-.125c-.249-.133-.748-.133-.998 0l-.249.133c-.125.133-.375.133-.499.133zm12.974-18.077c-.25 0-.375 0-.499.133l-17.59 11.697c-.125.133-.25.133-.25.266s.125.265.25.265h.125c.124.133.249.266.249.399s-.125.266-.249.399l-.25.133c-.125.133-.125.133-.125.266s.125.266.25.266l4.74 3.854c.25.133.749.133.998 0l.25-.133c.374-.265.873-.265 1.123 0h.124c.25.133.749.133.998 0l19.087-11.697c.125-.133.25-.133.25-.266 0-.132-.125-.265-.25-.265h-.125c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399c.125-.133.25-.133.25-.266s-.125-.266-.25-.266l-6.237-3.854c-.25-.133-.749-.133-.998 0-.374.266-.873.133-1.248 0-.249-.133-.499-.133-.623-.133z"
            fill="#131A2D"
            />
            <path
            d="M472.928 298.171a3.386 3.386 0 01-.374 3.722c-1.497 1.861-4.366 2.525-6.737 1.462-.873-.399-1.621-1.063-1.996-1.861a3.386 3.386 0 01.375-3.722c1.497-1.861 4.366-2.525 6.736-1.462.874.532 1.622 1.197 1.996 1.861z"
            fill="#fff"
            />
            <path
            d="M466.069 302.957c-2.121-.931-2.745-3.058-1.497-4.653 1.247-1.595 3.992-2.259 6.113-1.329 2.12.931 2.744 3.057 1.497 4.652-1.248 1.595-4.117 2.26-6.113 1.33z"
            fill="#0EA59D"
            />
            <path
            d="M468.188 303.488a6.665 6.665 0 01-2.245-.399c-1.123-.532-1.871-1.329-2.121-2.26-.249-.797 0-1.728.624-2.525 1.247-1.728 4.117-2.26 6.113-1.329 1.122.531 1.871 1.329 2.12 2.259.25.798 0 1.728-.623 2.526-.749 1.063-2.371 1.728-3.868 1.728zm.25-6.912c-1.497 0-2.994.664-3.867 1.728-.499.664-.749 1.595-.624 2.392.249.931.998 1.728 1.996 2.26 1.996.93 4.74.399 5.988-1.196.499-.665.748-1.595.624-2.393-.25-.93-.998-1.728-1.996-2.26-.624-.398-1.373-.531-2.121-.531z"
            fill="#131A2D"
            />
            <path
            d="M476.296 295.246c.748.399.748 1.064.125 1.462-.624.399-1.747.399-2.495 0-.749-.398-.749-1.063-.125-1.462.624-.531 1.746-.399 2.495 0z"
            fill="#0EA59D"
            />
            <path
            d="M475.299 297.107c-.499 0-.998-.132-1.373-.398-.374-.266-.623-.532-.623-.931 0-.266.124-.531.499-.797.623-.399 1.871-.399 2.495 0 .374.266.623.531.623.93 0 .266-.124.532-.499.798-.249.266-.748.398-1.122.398zm-.375-2.126c-.374 0-.748.133-1.122.266-.25.132-.375.398-.375.664s.25.532.499.798c.624.398 1.747.398 2.371 0a.74.74 0 00.374-.665c0-.266-.25-.532-.499-.797-.25-.133-.749-.266-1.248-.266z"
            fill="#131A2D"
            />
            <path
            d="M462.448 303.754c.749.399.749 1.063.125 1.462s-1.746.399-2.495 0c-.748-.399-.748-1.063-.125-1.462.624-.532 1.747-.399 2.495 0z"
            fill="#0EA59D"
            />
            <path
            d="M461.326 305.615c-.499 0-.998-.133-1.372-.399-.374-.266-.624-.531-.624-.93 0-.266.125-.532.499-.798.624-.398 1.871-.398 2.495.133.374.266.624.532.624.931 0 .266-.125.531-.499.797-.25.133-.624.266-1.123.266zm-.249-2.127c-.375 0-.749.133-1.123.266-.25.133-.374.399-.374.665s.249.531.499.797c.748.399 1.746.399 2.37 0a.739.739 0 00.374-.664c0-.266-.249-.532-.499-.798-.374-.133-.748-.266-1.247-.266z"
            fill="#131A2D"
            />
            <path
            d="M451.845 302.823h1.622v.398l20.833-13.823c.375-.133.874-.133 1.123 0l8.857 5.449-.124-.133 1.621-.265v.797c0 .133-.124.266-.249.399l-23.703 14.621c-.374.133-.873.133-1.122 0l-8.733-6.247c-.125-.133-.249-.266-.249-.399l.124-.797z"
            fill="#131A2D"
            />
            <path
            d="M452.095 302.424l22.206-14.621c.374-.133.873-.133 1.122 0l10.23 6.247c.374.266.374.532 0 .665l-23.703 14.621c-.249.133-.873.133-1.122 0l-8.733-6.247c-.374-.133-.374-.399 0-.665z"
            fill="#0EA59D"
            />
            <path
            d="M461.451 309.735c-.249 0-.499 0-.623-.133l-8.733-6.247c-.249-.133-.249-.266-.249-.399s.124-.266.249-.399l22.206-14.621c.374-.266.873-.133 1.247 0l10.23 6.247c.249.133.249.266.249.399s-.125.266-.249.399l-23.703 14.621c-.249 0-.374.133-.624.133zm13.349-21.932c-.25 0-.375 0-.499.133l-22.206 14.621c-.125.133-.125.133-.125.266s.125.266.25.266l8.732 6.247c.375.133.749.266 1.123 0l23.703-14.621c.124-.133.124-.133.124-.266s-.124-.266-.249-.266l-10.23-6.247c-.124-.133-.374-.133-.623-.133z"
            fill="#131A2D"
            />
            <path
            d="M455.464 302.158c-.375-.266-.375-.532-.125-.798l17.59-11.697c.249-.133.873-.133 1.122 0 .25.133.874.266 1.123 0 .25-.133.749-.133 1.123 0l6.237 3.855c.375.133.375.532 0 .664-.249.133-.249.532 0 .665h.125c.374.133.374.532 0 .665l-19.087 11.697c-.249.133-.748.133-1.122 0h-.125c-.25-.133-.749-.133-1.123 0l-.249.133c-.25.133-.749.133-1.123 0l-4.741-3.855c-.374-.133-.374-.532 0-.665l.25-.133c.499 0 .499-.265.125-.531z"
            fill="#fff"
            />
            <path
            d="M460.579 307.74c-.25 0-.375 0-.624-.133l-4.741-3.854c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399l.25-.133c.125-.133.125-.133.125-.266 0-.132-.125-.265-.25-.265h-.125c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399l17.59-11.697c.374-.266.873-.133 1.248 0 .249.133.748.133.998 0 .374-.266.873-.133 1.247 0l6.238 3.855c.124.133.249.266.249.399 0 .132-.125.265-.249.398-.125.133-.25.133-.25.266s.125.266.25.266h.124c.125.133.25.266.25.399s-.125.266-.25.398l-19.086 11.698c-.375.265-.874.132-1.123 0h-.125c-.249-.133-.748-.133-.998 0l-.249.132c-.125.133-.375.133-.499.133zm12.974-18.077c-.25 0-.375 0-.499.133l-17.59 11.697c-.125.133-.25.133-.25.266s.125.266.25.266h.125c.124.133.249.266.249.399 0 .132-.125.265-.249.398l-.25.133c-.125.133-.125.133-.125.266s.125.266.25.266l4.74 3.855c.25.133.749.133.998 0l.25-.133c.374-.266.873-.266 1.123 0h.124c.25.133.749.133.998 0l19.087-11.697c.125-.133.25-.133.25-.266s-.125-.266-.25-.266h-.125c-.124-.133-.249-.266-.249-.399s.125-.266.249-.399c.125-.132.25-.132.25-.265s-.125-.266-.25-.266l-6.237-3.855c-.25-.133-.749-.133-.998 0-.374.266-.873.133-1.248 0-.249-.133-.499-.133-.623-.133z"
            fill="#131A2D"
            />
            <path
            d="M472.928 296.575a3.385 3.385 0 01-.374 3.722c-1.497 1.861-4.366 2.526-6.737 1.462-.873-.398-1.621-1.063-1.996-1.861a3.384 3.384 0 01.375-3.721c1.497-1.861 4.366-2.526 6.736-1.462.874.531 1.622 1.196 1.996 1.86z"
            fill="#fff"
            />
            <path
            d="M466.069 301.361c-2.121-.931-2.745-3.057-1.497-4.652 1.247-1.595 3.992-2.26 6.113-1.33 2.12.931 2.744 3.058 1.497 4.653-1.373 1.595-4.117 2.259-6.113 1.329z"
            fill="#0EA59D"
            />
            <path
            d="M468.188 301.893a6.665 6.665 0 01-2.245-.399c-1.123-.532-1.871-1.329-2.121-2.26-.249-.797 0-1.728.624-2.525 1.247-1.595 4.117-2.26 6.113-1.33 1.122.532 1.871 1.33 2.12 2.26.25.798 0 1.728-.623 2.526-.749 1.063-2.371 1.728-3.868 1.728zm.25-6.912c-1.497 0-2.994.664-3.867 1.728-.499.664-.749 1.595-.624 2.392.249.931.998 1.728 1.996 2.26 1.996.93 4.74.399 5.988-1.196.499-.665.748-1.596.624-2.393-.25-.93-.998-1.728-1.996-2.26-.624-.398-1.373-.531-2.121-.531z"
            fill="#131A2D"
            />
            <path
            d="M476.296 293.65c.748.399.748 1.064.125 1.463-.624.398-1.747.398-2.495 0-.749-.399-.749-1.064-.125-1.463.624-.531 1.746-.398 2.495 0z"
            fill="#0EA59D"
            />
            <path
            d="M475.299 295.512c-.499 0-.998-.133-1.373-.399-.374-.266-.623-.532-.623-.93 0-.266.124-.532.499-.798.623-.399 1.871-.399 2.495 0 .374.266.623.532.623.93 0 .266-.124.532-.499.798-.249.266-.748.399-1.122.399zm-.375-2.127c-.374 0-.748.133-1.122.266a.739.739 0 00-.375.664c0 .266.25.532.499.798.624.399 1.747.399 2.371 0a.74.74 0 00.374-.665c0-.265-.25-.531-.499-.797-.25-.133-.749-.266-1.248-.266z"
            fill="#131A2D"
            />
            <path
            d="M462.448 302.157c.749.399.749 1.064.125 1.463-.624.398-1.746.398-2.495 0-.748-.399-.748-1.064-.125-1.463.624-.398 1.747-.398 2.495 0z"
            fill="#0EA59D"
            />
            <path
            d="M461.326 304.018c-.499 0-.998-.133-1.372-.398-.374-.266-.624-.532-.624-.931 0-.266.125-.531.499-.797.624-.399 1.871-.399 2.495.133.374.265.624.531.624.93 0 .266-.125.532-.499.798-.25.265-.624.265-1.123.265zm-.249-2.126c-.375 0-.749.133-1.123.266-.25.132-.374.398-.374.664s.249.532.499.798c.748.398 1.746.398 2.37 0a.74.74 0 00.374-.665c0-.266-.249-.532-.499-.797-.374-.133-.748-.266-1.247-.266z"
            fill="#131A2D"
            />
            <path
            d="M450.474 293.254c.499.265.998.398 1.497.664 0 .133-.125.133-.125.266 8.733 0 15.469-2.26 22.705-6.38.249-.133.748-.133 1.122.133 2.62 1.861 5.489 3.722 8.608 5.45 0 0 0-.133-.125-.133.624-.133 1.123-.266 1.747-.266v.797c0 .133 0 .266-.25.399a56.087 56.087 0 01-27.569 9.437c-.375 0-.998-.132-1.248-.531-2.994-2.925-4.117-5.849-6.612-8.773-.124-.133-.124-.266-.124-.399.249-.399.374-.531.374-.664z"
            fill="#131A2D"
            />
            <path
            d="M450.849 293.12c9.107.133 16.342-2.392 23.952-6.912.249-.133.748-.133 1.123 0 2.994 2.127 6.237 4.121 9.855 6.115.374.133.374.531.125.797-7.984 5.45-17.341 8.906-27.321 9.703-.374 0-.998-.132-1.247-.531-2.994-2.925-4.117-5.849-6.612-8.773-.374-.133-.249-.399.125-.399z"
            fill="#0EA59D"
            />
            <path
            d="M458.334 302.956c-.375 0-.874-.265-1.248-.531-1.746-1.728-2.869-3.456-3.992-5.051a32.519 32.519 0 00-2.62-3.589c-.124-.266-.124-.399-.124-.399 0-.133.124-.133.374-.133h.624c8.233 0 15.344-2.127 23.328-6.912.374-.133.873-.133 1.123 0 3.118 2.26 6.362 4.254 9.73 6.115.25.133.374.266.374.398 0 .133-.124.266-.249.399-7.984 5.583-17.465 8.906-27.32 9.703.124 0 .124 0 0 0zm-7.485-9.836c-.125 0-.25 0-.25.133 0 0 0 .133.125.266a32.744 32.744 0 012.62 3.589c1.122 1.728 2.245 3.323 3.992 5.051.249.266.873.532 1.247.399 9.731-.798 19.212-4.121 27.196-9.704.124-.132.124-.132.124-.265s-.124-.266-.249-.266a110.798 110.798 0 01-9.855-6.115c-.25-.133-.749-.265-.998 0-7.984 4.786-15.095 6.912-23.329 6.912h-.623z"
            fill="#131A2D"
            />
            <path
            d="M454.218 294.317c-.125 0-.125 0 0 0-.25-.399-.25-.532.124-.532 7.361-.398 12.85-2.392 19.087-5.848.25-.133.749-.133.998.133.25.266.749.266.998 0 .25-.133.749-.133.998 0 1.871 1.329 3.867 2.525 5.988 3.855.374.132.374.531 0 .664-.249.266-.249.532 0 .665h.125c.374.133.374.531 0 .664-6.612 3.988-14.097 6.779-21.831 7.71-.375 0-.874-.133-1.123-.399 0 0-.125 0-.125-.133-.249-.266-.748-.399-1.123-.399h-.249c-.374 0-.873-.133-1.123-.398-1.746-1.728-2.744-3.722-3.493-5.317-.125-.266-.125-.532.25-.532h.249c.374.399.374.133.25-.133z"
            fill="#fff"
            />
            <path
            d="M460.704 301.894c-.375 0-.873-.133-1.123-.399l-.125-.133c-.249-.266-.748-.399-1.122-.399h-.25c-.374 0-.998-.133-1.248-.399-1.746-1.727-2.619-3.588-3.492-5.316-.125-.133-.125-.399-.125-.399.124-.133.249-.133.374-.133h.249c.125 0 .25 0 .25-.133 0 0 0-.133-.125-.266l-.125-.133c-.124-.133-.124-.398-.124-.398 0-.133.249-.266.374-.266 7.61-.399 13.099-2.659 19.087-5.716.374-.133.873-.133 1.122.133.25.133.749.266.999 0 .374-.133.873-.133 1.122 0 1.996 1.329 3.992 2.658 5.988 3.855.125.133.25.266.25.398 0 .133-.125.266-.25.399s-.249.133-.249.266.124.266.249.266h.125c.125.133.25.266.25.399s-.125.266-.25.398c-6.737 4.121-14.097 6.779-21.831 7.71.124.266 0 .266 0 .266zm-2.246-1.064c.375 0 .874.133 1.123.399l.125.133c.249.266.748.399 1.123.399 7.734-1.064 15.094-3.589 21.831-7.71.125-.133.249-.133.249-.265 0-.133-.124-.266-.249-.266h-.125c-.125-.133-.25-.266-.25-.399s.125-.266.25-.399.25-.133.25-.266-.125-.266-.25-.266c-1.996-1.196-3.992-2.525-5.988-3.854-.249-.133-.749-.133-.998 0-.374.133-.873.133-1.123 0-.249-.133-.623-.266-.998 0-5.863 3.19-11.477 5.45-19.087 5.848-.124 0-.249 0-.249.133 0 0 0 .133.125.266l.124.133c.125.133.125.399.125.399 0 .133-.249.266-.374.266h-.25c-.124 0-.249 0-.249.133 0 0 0 .132.125.265.873 1.728 1.746 3.589 3.493 5.184.249.266.748.399 1.123.399l.124-.532z"
            fill="#131A2D"
            />
            <path
            d="M472.555 294.45c.499 1.197.249 2.526-.874 3.456-1.746 1.462-5.114 1.462-7.235-.133-.873-.531-1.372-1.329-1.622-1.994-.374-1.196.125-2.259 1.248-3.057 1.746-1.196 4.615-1.329 6.736-.133.873.532 1.497 1.197 1.747 1.861z"
            fill="#fff"
            />
            <path
            d="M464.82 297.373c-1.871-1.329-1.996-3.19-.374-4.253 1.622-1.063 4.241-1.196 6.113-.133 1.871 1.063 2.37 3.19.748 4.519-1.622 1.33-4.616 1.197-6.487-.133z"
            fill="#0EA59D"
            />
            <path
            d="M468.312 298.57a6.403 6.403 0 01-3.493-1.063c-.998-.665-1.497-1.595-1.497-2.393 0-.797.375-1.462 1.123-1.993 1.622-1.197 4.366-1.197 6.238-.133.998.664 1.621 1.462 1.746 2.525 0 .798-.249 1.595-.998 2.127-.873.532-1.996.93-3.119.93zm-.873-6.247c-1.123 0-2.245.266-2.994.931-.748.531-1.123 1.196-1.123 1.86 0 .798.499 1.595 1.497 2.26 1.871 1.329 4.866 1.329 6.362.133.624-.532.999-1.196.874-1.994-.125-.93-.624-1.728-1.622-2.392-.873-.532-1.871-.798-2.994-.798z"
            fill="#131A2D"
            />
            <path
            d="M476.297 291.924c.624.398.624 1.063 0 1.462s-1.747.266-2.495-.266c-.624-.532-.624-1.063 0-1.462.748-.266 1.746-.133 2.495.266z"
            fill="#0EA59D"
            />
            <path
            d="M475.299 293.652c-.499 0-1.123-.133-1.497-.532-.375-.266-.499-.532-.499-.931 0-.265.249-.531.623-.664.749-.399 1.747-.266 2.495.266.375.266.499.531.499.93 0 .266-.249.532-.499.665-.499.266-.748.266-1.122.266zm-.499-2.127c-.375 0-.624 0-.874.133-.249.133-.499.399-.499.531a.74.74 0 00.375.665c.623.399 1.746.532 2.37.266.249-.133.499-.399.499-.532 0-.266-.125-.531-.499-.797-.374 0-.873-.266-1.372-.266z"
            fill="#131A2D"
            />
            <path
            d="M460.954 297.241c.623.532.498 1.196-.25 1.196-.749.133-1.871-.266-2.495-.797-.624-.532-.374-1.064.374-1.197.624-.133 1.747.133 2.371.798z"
            fill="#0EA59D"
            />
            <path
            d="M460.329 298.57c-.749 0-1.747-.399-2.246-.931a1.486 1.486 0 01-.374-.93c.125-.266.374-.399.748-.532.749-.133 1.872.266 2.495.798.375.266.499.664.375.93-.125.266-.375.399-.749.532 0 .133-.125.133-.249.133zm-1.622-2.127h-.25c-.374 0-.499.133-.623.399 0 .266 0 .398.374.664.624.532 1.622.931 2.37.798.374 0 .499-.133.624-.399a.74.74 0 00-.374-.665c-.499-.531-1.373-.797-2.121-.797z"
            fill="#131A2D"
            />
            <path
            opacity={0.3}
            d="M217.315 142.653l-22.579 15.551-21.832-12.76 21.832-15.286 22.579 12.495z"
            fill="url(#paint227_linear_874_76773)"
            />
            <path
            d="M170.91 136.007c-.25.665-.374 1.329-.624 1.861l-.998 3.323-1.247-.399c-.998-.399-1.497-2.791-.749-5.716.873-2.924 2.62-4.785 3.618-4.519l1.247.399-.998 3.323c.125.399 0 1.063-.249 1.728z"
            fill="#0EA59D"
            />
            <path
            d="M169.288 141.19l-1.372-.398c-.998-.399-1.497-2.925-.624-5.849.873-2.791 2.37-4.652 3.493-4.652h.125l1.247.399-.998 3.323c-.124.664-.249 1.196-.374 1.86-.125.665-.374 1.197-.748 1.861l-.749 3.456zm-1.123-.398l1.123.265.873-3.323c.25-.531.499-1.196.624-1.861.125-.664.25-1.329.374-1.86l.874-3.323-1.123-.266c-.998-.266-2.745 1.595-3.618 4.519-.624 3.057-.125 5.45.873 5.849z"
            fill="#131A2D"
            />
            <path
            d="M167.416 139.863c0-.133-.125-.266-.125-.399l2.37.664-.124.266-2.121-.531z"
            fill="#0EA59D"
            />
            <path
            d="M169.537 140.527l-2.121-.665c0-.132-.125-.265-.125-.398v-.133l2.495.664-.249.532zm-2.121-.665l1.996.532v-.133l-2.121-.664c.125.133.125.133.125.265z"
            fill="#131A2D"
            />
            <path
            d="M171.285 134.412l-3.244-.931c0-.133.125-.265.125-.265l3.119.93v.266z"
            fill="#0EA59D"
            />
            <path
            d="M171.284 134.545l-3.368-.931v-.133c0-.133.125-.265.125-.265l3.243.93v.133c.125 0 0 .133 0 .266zm-3.243-1.064l3.119.931v-.266l-2.994-.798s0 .133-.125.133z"
            fill="#131A2D"
            />
            <path
            d="M167.791 134.013c0-.133.125-.266.125-.266l3.368.93v.399l-3.493-1.063z"
            fill="#0EA59D"
            />
            <path
            d="M171.159 135.076l-3.493-1.063v-.133c0-.133.125-.266.125-.266l3.368.93c.125.266.125.399 0 .532zm-3.243-1.063l3.243.93v-.266l-3.243-.93v.266z"
            fill="#131A2D"
            />
            <path
            d="M169.289 131.487l.25-.266 2.37.665-.125.266-2.495-.665z"
            fill="#0EA59D"
            />
            <path
            d="M171.909 132.285l-2.745-.798.125-.133.249-.265 2.495.664-.124.532zm-2.495-.798l2.495.665v-.133l-2.371-.665-.124.133z"
            fill="#131A2D"
            />
            <path
            d="M167.541 134.678c0-.133.125-.266.125-.266l3.368.93c0 .133 0 .266-.125.266l-3.368-.93z"
            fill="#0EA59D"
            />
            <path
            d="M171.034 135.741l-3.618-1.063c0-.133.125-.266.125-.266l3.493.93c.125 0 .125.133 0 .399zm-3.368-1.196l3.368.93v-.265l-3.368-.931v.266z"
            fill="#131A2D"
            />
            <path
            d="M169.662 131.09c.125-.133.25-.133.374-.266l1.996.532-.124.265-2.246-.531z"
            fill="#0EA59D"
            />
            <path
            d="M172.032 131.755l-2.495-.665.125-.133c.125-.133.249-.133.374-.266l2.121.665-.125.399zm-2.121-.665l2.121.532v-.133l-1.996-.532s-.125 0-.125.133z"
            fill="#131A2D"
            />
            <path
            d="M168.539 132.551c0-.133.125-.266.25-.266l2.869.798-.125.266-2.994-.798z"
            fill="#0EA59D"
            />
            <path
            d="M171.533 133.481l-3.119-.93v-.133c.125-.133.125-.266.25-.266l2.994.798-.125.531zm-2.869-1.063l2.869.797v-.132l-2.745-.798c-.124 0-.124.133-.124.133z"
            fill="#131A2D"
            />
            <path
            d="M168.291 133.083c0-.133.125-.266.125-.266l2.994.931-.125.265-2.994-.93z"
            fill="#0EA59D"
            />
            <path
            d="M171.41 134.014l-3.244-.931v-.133c0-.133.125-.266.125-.266l3.119.931v.399zm-3.119-1.064l2.994.798v-.133l-2.994-.798c.125 0 .125.133 0 .133z"
            fill="#131A2D"
            />
            <path
            d="M168.914 132.019l.25-.265 2.744.797-.125.266-2.869-.798z"
            fill="#0EA59D"
            />
            <path
            d="M171.783 132.95l-2.994-.798v-.133l.25-.265 2.744.797v.399zm-2.869-.931l2.62.798v-.133l-2.62-.797c.125 0 .125 0 0 .132z"
            fill="#131A2D"
            />
            <path
            d="M167.043 138.001v-.399l2.994.798-.125.266-2.869-.665z"
            fill="#0EA59D"
            />
            <path
            d="M170.037 138.932l-2.994-.798v-.532l3.119.931-.125.399zm-2.994-.931l2.869.798v-.133l-2.869-.798v.133z"
            fill="#131A2D"
            />
            <path
            d="M167.291 135.741c0-.133 0-.266.125-.266l3.493.931c0 .133-.125.266-.125.266l-3.493-.931z"
            fill="#0EA59D"
            />
            <path
            d="M170.784 136.805l-3.493-1.064c0-.133 0-.266.125-.266l3.493 1.064v.133c-.125-.133-.125 0-.125.133zm-3.368-1.197l3.368.931s0-.133.125-.133l-3.368-.931c-.125 0-.125.133-.125.133z"
            fill="#131A2D"
            />
            <path
            d="M170.909 136.14l-3.493-.93v-.133-.266l3.493.931v.398s0-.132 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M170.909 136.273l-3.618-1.063v-.399l3.493 1.064v.265c.25-.132.25 0 .125.133zm-3.368-1.196l3.368.931v-.133l-3.368-.931v.133z"
            fill="#131A2D"
            />
            <path
            d="M168.165 140.792c-.25-.133-.374-.266-.624-.532l1.871.532-.124.399-1.123-.399z"
            fill="#0EA59D"
            />
            <path
            d="M169.412 141.191l-1.247-.399c-.25-.133-.375-.266-.624-.531l-.125-.133 2.121.531-.125.532zm-1.247-.532l1.122.266.125-.266-1.622-.531c0 .398.25.531.375.531z"
            fill="#131A2D"
            />
            <path
            d="M170.412 130.691c.25-.133.499-.133.624-.133l1.247.399-.124.266-1.747-.532z"
            fill="#0EA59D"
            />
            <path
            d="M172.158 131.222l-1.996-.532.125-.133c.249-.132.499-.132.624-.132l1.247.398v.399zm-1.622-.532l1.497.399v-.133l-1.122-.266c0-.133-.125-.133-.375 0z"
            fill="#131A2D"
            />
            <path
            d="M167.168 139.196c0-.133 0-.265-.125-.398l2.62.797-.125.266-2.37-.665z"
            fill="#0EA59D"
            />
            <path
            d="M169.663 139.994l-2.495-.665c0-.133 0-.266-.125-.398v-.133l2.744.797-.124.399zm-2.495-.798l2.37.665v-.133l-2.495-.665c.125 0 .125.133.125.133z"
            fill="#131A2D"
            />
            <path
            d="M167.168 136.274v-.399l3.368.93c0 .133-.125.266-.125.266l-3.243-.797z"
            fill="#0EA59D"
            />
            <path
            d="M170.536 137.337l-3.493-.931v-.531l3.493.93v.133c.125.133.125.266 0 .399zm-3.244-1.063l3.244.93s0-.133.125-.133l-3.244-.93c-.125 0-.125 0-.125.133z"
            fill="#131A2D"
            />
            <path
            d="M167.043 138.665v-.398l2.869.797-.125.266-2.744-.665z"
            fill="#0EA59D"
            />
            <path
            d="M169.787 139.463l-2.869-.798v-.531l2.994.797-.125.532zm-2.62-.93l2.62.797v-.133l-2.744-.797c.124 0 .124.133.124.133z"
            fill="#131A2D"
            />
            <path
            d="M167.043 137.469v-.399l3.119.931-.125.265-2.994-.797z"
            fill="#0EA59D"
            />
            <path
            d="M170.162 138.399l-3.119-.93v-.532h.125l3.243.931-.249.531zm-2.994-1.063l2.994.798v-.133l-2.994-.798v.133z"
            fill="#131A2D"
            />
            <path
            d="M167.043 136.805v-.399l3.243.931c0 .133-.124.266-.124.266l-3.119-.798z"
            fill="#0EA59D"
            />
            <path
            d="M170.286 137.868l-3.243-.93v-.532l3.368.931v.133c0 .133 0 .265-.125.398zm-3.118-1.063l3.118.93s0-.132.125-.132l-3.119-.931c-.124 0-.124 0-.124.133z"
            fill="#131A2D"
            />
            <path
            d="M173.154 136.671c-.873 3.057-2.619 4.785-3.742 4.519-1.123-.266-1.622-2.791-.749-5.848.874-3.057 2.62-4.785 3.743-4.52 1.123.266 1.497 2.792.748 5.849z"
            fill="#0EA59D"
            />
            <path
            d="M169.661 141.324h-.249c-.25-.133-.624-.399-.749-.798-.624-1.063-.624-3.19 0-5.184.873-3.057 2.745-4.918 3.743-4.519.249.133.623.399.748.797.624 1.064.624 3.19 0 5.184-.873 2.659-2.495 4.52-3.493 4.52zm2.495-10.501c-.998 0-2.62 1.728-3.368 4.519-.624 1.994-.624 3.988 0 5.051.249.399.374.532.748.665.998.266 2.745-1.462 3.618-4.52.624-1.993.624-3.987 0-5.051-.249-.398-.374-.531-.748-.664h-.25z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M168.291 138.931v-1.196l5.24-3.058c0 .399-.125.931-.25 1.33l-4.99 2.924zM168.539 135.741c0-.133.125-.266.125-.399s.125-.266.125-.399l4.615-2.658c0 .133.125.399.125.665l-4.99 2.791z"
            fill="#fff"
            />
            <path
            d="M174.529 116.468l18.837-11.564c.249-.133.249-.266.249-.399v6.114c0 .133-.124.399-.249.532l-14.721 8.906a3.391 3.391 0 01-4.865-1.463c-.499-.797-.125-1.595.749-2.126z"
            fill="#131A2D"
            />
            <path
            d="M192.991 110.619c0-.931-.998-1.595-1.871-1.064l-16.716 10.235c-.874.532-1.248 1.462-.749 2.26.998 1.861 3.119 2.525 4.865 1.462l14.347-8.773v-4.12h.124z"
            fill="#0EA59D"
            />
            <path
            d="M176.898 124.043c-.374 0-.623 0-.998-.133-.998-.266-1.746-.93-2.245-1.861-.125-.398-.25-.664-.125-1.063.125-.532.499-.93.998-1.196l16.717-10.235a1.074 1.074 0 011.247 0c.374.266.624.664.624 1.196v3.988l-14.346 8.773c-.624.265-1.248.531-1.872.531zm14.846-14.621c-.25 0-.375 0-.624.133l-16.717 10.235c-.499.266-.748.664-.873 1.196-.125.399 0 .665.125.93.499.931 1.247 1.596 2.121 1.861.873.266 1.871.133 2.619-.398l14.347-8.773v-3.988c0-.399-.25-.797-.624-1.063 0-.133-.125-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M173.03 115.537l18.837-11.564c.374-.266 1.123-.266 1.497 0 .374.266.374.664 0 .93l-18.837 11.564c-1.123.665-1.123 1.861 0 2.526 1.123.664 2.994.664 4.117 0l18.837-11.564c.374-.266 1.123-.266 1.497 0 .374.266.374.664 0 .93l-18.837 11.564c-1.996 1.197-4.741 1.728-6.986 0-1.996-1.462-2.121-3.19-.125-4.386z"
            fill="#131A2D"
            />
            <path
            d="M188.625 107.96a7.992 7.992 0 01-.624 1.861l-.748 3.323-1.248-.266c-.998-.398-1.746-2.791-.998-5.848.624-3.057 2.246-4.918 3.368-4.652l1.248.266-.749 3.323c0 .664-.124 1.329-.249 1.993z"
            fill="#0EA59D"
            />
            <path
            d="M187.378 113.277l-1.372-.398c-.998-.399-1.622-2.792-.998-5.849.623-3.057 2.245-4.918 3.368-4.785l1.247.266-.748 3.456c0 .664-.125 1.329-.25 1.861-.124.664-.374 1.329-.623 1.861l-.624 3.588zm-1.248-.531l1.123.266.749-3.323c.249-.532.374-1.197.623-1.861.125-.665.25-1.33.25-1.861l.748-3.323-1.122-.266c-.998-.133-2.62 1.595-3.244 4.652-.748 3.057-.125 5.45.873 5.716z"
            fill="#131A2D"
            />
            <path
            d="M185.381 111.948c0-.133-.125-.266-.125-.399l2.37.532-.125.266-2.12-.399z"
            fill="#0EA59D"
            />
            <path
            d="M187.501 112.613l-2.245-.532c0-.133-.125-.266-.125-.399v-.132l2.495.664-.125.399zm-2.121-.665l1.996.532v-.266l-2.12-.532c0 .133.124.133.124.266z"
            fill="#131A2D"
            />
            <path
            d="M188.874 106.366l-3.243-.798c0-.133.125-.266.125-.266l3.243.798c-.125 0-.125.133-.125.266z"
            fill="#0EA59D"
            />
            <path
            d="M188.874 106.499l-3.368-.798v-.133c0-.132.125-.265.125-.265l3.243.797v.399zm-3.243-1.063l3.118.797v-.266l-3.118-.797c.124.133 0 .266 0 .266z"
            fill="#131A2D"
            />
            <path
            d="M185.381 106.1c0-.133.125-.266.125-.266l3.368.797v.399l-3.493-.93z"
            fill="#0EA59D"
            />
            <path
            d="M188.874 107.03l-3.493-.93v-.133c0-.133.125-.266.125-.266l3.493.93c-.125.133-.125.133-.125.399zm-3.368-1.063l3.243.797v-.266l-3.243-.797v.266z"
            fill="#131A2D"
            />
            <path
            d="M186.754 103.442l.249-.266 2.495.664-.124.266-2.62-.664z"
            fill="#0EA59D"
            />
            <path
            d="M189.373 104.239l-2.744-.665.125-.133.249-.265 2.495.664-.125.399zm-2.619-.798l2.495.665v-.266l-2.371-.532-.124.133z"
            fill="#131A2D"
            />
            <path
            d="M185.256 106.631c0-.133 0-.266.125-.266l3.493.93v.399l-3.618-1.063z"
            fill="#0EA59D"
            />
            <path
            d="M188.749 107.561l-3.618-.93c0-.133 0-.266.125-.266l3.617.93c-.124 0-.124.133-.124.266zm-3.493-.93l3.368.797v-.265l-3.368-.798c.124.133 0 .133 0 .266z"
            fill="#131A2D"
            />
            <path
            d="M187.129 102.91c.125-.133.249-.133.374-.266l1.996.532-.125.266-2.245-.532z"
            fill="#0EA59D"
            />
            <path
            d="M189.499 103.575l-2.495-.665.125-.133c.124-.133.249-.133.374-.266l2.121.532-.125.532zm-2.246-.665l2.121.532v-.266l-1.996-.532c0 .133 0 .266-.125.266z"
            fill="#131A2D"
            />
            <path
            d="M186.006 104.504c0-.133.125-.266.125-.266l2.869.798-.125.265-2.869-.797z"
            fill="#0EA59D"
            />
            <path
            d="M189.125 105.302l-3.119-.798v-.133c0-.133.125-.266.125-.266l2.994.798v.399zm-2.994-.931l2.869.665v-.266l-2.869-.665c.124.133 0 .266 0 .266z"
            fill="#131A2D"
            />
            <path
            d="M185.756 105.036c0-.133.125-.265.125-.265l3.118.797-.124.266-3.119-.798z"
            fill="#0EA59D"
            />
            <path
            d="M188.999 105.834l-3.243-.798v-.133c0-.133.125-.266.125-.266l3.118.798v.399zm-3.118-.931l2.994.798v-.266l-2.994-.798v.266z"
            fill="#131A2D"
            />
            <path
            d="M186.381 103.973c.125-.133.125-.266.249-.266l2.745.664-.125.266-2.869-.664z"
            fill="#0EA59D"
            />
            <path
            d="M189.25 104.77l-2.994-.797v-.133c.125-.133.125-.266.249-.266l2.87.665-.125.531zm-2.745-.797l2.745.664v-.265l-2.62-.665c-.125.133-.125.133-.125.266z"
            fill="#131A2D"
            />
            <path
            d="M184.883 110.088v-.399l2.994.798-.125.266-2.869-.665z"
            fill="#0EA59D"
            />
            <path
            d="M187.877 110.885l-2.994-.798v-.532l3.119.798-.125.532zm-2.994-.798l2.869.665v-.266l-2.869-.665v.266z"
            fill="#131A2D"
            />
            <path
            d="M185.008 107.694v-.398l3.493.93c0 .133 0 .266-.125.266l-3.368-.798z"
            fill="#0EA59D"
            />
            <path
            d="M188.501 108.758l-3.618-.931v-.398l3.618.93c.124 0 0 .133 0 .399zm-3.493-1.063l3.368.797v-.266l-3.368-.797c.124.133 0 .266 0 .266z"
            fill="#131A2D"
            />
            <path
            d="M188.626 108.094l-3.493-.931v-.133-.266l3.493.931v.399c0-.133 0-.133 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M188.626 108.094l-3.618-.931v-.399l3.618.931v.399zm-3.493-.931l3.368.798v-.133l-3.368-.798c.124 0 0 0 0 .133z"
            fill="#131A2D"
            />
            <path
            d="M186.132 112.745c-.25-.133-.499-.266-.624-.531l1.871.531-.125.399-1.122-.399z"
            fill="#0EA59D"
            />
            <path
            d="M187.379 113.144l-1.373-.266c-.249-.133-.374-.266-.623-.531l-.125-.133 2.121.531v.399zm-1.248-.399l1.123.266v-.266l-1.622-.398c.125.132.374.265.499.398z"
            fill="#131A2D"
            />
            <path
            d="M187.752 102.511c.249-.133.499-.133.624-.133l1.247.266v.266l-1.871-.399z"
            fill="#0EA59D"
            />
            <path
            d="M189.623 103.043l-1.996-.532.125-.133c.249-.133.499-.133.623-.133l1.248.266v.532zm-1.622-.532l1.497.399v-.133l-1.123-.266h-.374z"
            fill="#131A2D"
            />
            <path
            d="M185.133 111.284c0-.133-.125-.266-.125-.399l2.62.664-.125.266-2.37-.531z"
            fill="#0EA59D"
            />
            <path
            d="M187.627 112.081l-2.619-.665c0-.133-.125-.266-.125-.399v-.132l2.744.664v.532zm-2.495-.798l2.371.665v-.266l-2.495-.665c.124.133.124.133.124.266z"
            fill="#131A2D"
            />
            <path
            d="M184.883 108.359v-.398l3.368.797c0 .133-.125.266-.125.266l-3.243-.665z"
            fill="#0EA59D"
            />
            <path
            d="M188.376 109.29l-3.493-.93v-.532l3.618.93v.133c-.125.133-.125.133-.125.399zm-3.368-1.063l3.243.797s0-.133.125-.133l-3.244-.797c-.124 0-.124.133-.124.133z"
            fill="#131A2D"
            />
            <path
            d="M185.008 110.752v-.399l2.869.665-.125.266-2.744-.532z"
            fill="#0EA59D"
            />
            <path
            d="M187.752 111.416l-2.869-.665v-.532l2.994.798-.125.399zm-2.744-.798l2.619.665v-.266l-2.744-.665a.425.425 0 01.125.266z"
            fill="#131A2D"
            />
            <path
            d="M184.883 109.423v-.399l3.119.798-.125.266-2.994-.665z"
            fill="#0EA59D"
            />
            <path
            d="M188.001 110.353l-3.243-.797v-.532l3.243.798v.531zm-3.118-.93l2.994.797v-.265l-2.994-.798v.266z"
            fill="#131A2D"
            />
            <path
            d="M184.883 108.891v-.399l3.368.797c0 .133-.125.266-.125.266l-3.243-.664z"
            fill="#0EA59D"
            />
            <path
            d="M188.126 109.821l-3.368-.797v-.532l3.493.93v.133s-.125.133-.125.266zm-3.243-.93l3.118.797s0-.133.125-.133l-3.119-.797c-.124 0-.124 0-.124.133z"
            fill="#131A2D"
            />
            <path
            d="M190.744 108.493c-.748 3.057-2.37 4.918-3.368 4.652-.998-.266-1.746-2.658-1.123-5.848.749-3.058 2.371-4.919 3.369-4.653 1.122.266 1.871 2.792 1.122 5.849z"
            fill="#0EA59D"
            />
            <path
            d="M187.627 113.278h-.25c-1.123-.266-1.871-2.791-1.123-5.849.375-1.462.874-2.791 1.622-3.588.624-.798 1.372-1.197 1.871-1.064 1.123.266 1.872 2.791 1.123 5.849-.374 1.462-.873 2.791-1.622 3.589-.499.664-1.122 1.063-1.621 1.063zm1.871-10.501c-.499 0-.998.399-1.622 1.064-.624.93-1.247 2.126-1.497 3.588-.624 3.058 0 5.45.998 5.716.499.133 1.123-.266 1.747-1.063.623-.931 1.247-2.127 1.497-3.589.623-3.057 0-5.45-.998-5.716h-.125z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M186.131 110.885c0-.399-.125-.798-.125-1.197l4.99-3.323c0 .399 0 .931-.125 1.329l-4.74 3.191zM186.254 107.827c0-.133 0-.266.125-.399 0-.132.124-.265.124-.398l4.367-2.925c0 .133.124.399.124.665l-4.74 3.057z"
            fill="#fff"
            />
            <path
            d="M215.57 90.15c-.748.132-1.372.132-1.996.132l-3.493.532-.125-1.462c-.124-1.197 1.996-2.925 5.115-3.456 3.119-.4 5.614.531 5.863 1.728l.125 1.462-3.493.532c-.748.265-1.372.398-1.996.531z"
            fill="#fff"
            />
            <path
            d="M209.957 90.814l-.25-1.595c0-1.33 2.121-2.925 5.24-3.456 3.118-.4 5.613.531 5.863 1.728l.249 1.462-3.617.531c-.624.266-1.248.4-1.996.532-.624.133-1.373.133-1.996.133l-3.493.665zm-.125-1.462l.125 1.329 3.493-.532c.623 0 1.372 0 1.996-.133.623-.133 1.372-.266 1.996-.532l3.493-.531-.125-1.33c-.25-1.196-2.62-2.26-5.739-1.728-3.243.532-5.239 2.127-5.239 3.457z"
            fill="#131A2D"
            />
            <path
            d="M210.33 88.154l.25-.265.374 2.791h-.374l-.25-2.526z"
            fill="#fff"
            />
            <path
            d="M210.579 90.68l-.374-2.658.374-.399.125-.133.374 2.925-.499.265zm-.124-2.525l.249 2.392h.25l-.375-2.658c0 .133-.124.133-.124.266z"
            fill="#131A2D"
            />
            <path
            d="M217.067 89.75l-.499-3.854h.375l.499 3.855c-.125-.133-.25 0-.375 0z"
            fill="#fff"
            />
            <path
            d="M217.067 89.883l-.499-4.12h.499l.499 3.854h-.124c-.125.133-.25.133-.375.266zm-.374-3.987l.499 3.721c.125 0 .125 0 .25-.133l-.499-3.721c-.125.133-.125.133-.25.133z"
            fill="#131A2D"
            />
            <path
            d="M216.07 85.896h.375l.499 3.988c-.125 0-.25 0-.375.133l-.499-4.12z"
            fill="#fff"
            />
            <path
            d="M216.444 90.016l-.499-4.253h.499l.499 4.12c-.124 0-.249 0-.499.133zm-.374-4.12l.499 3.854h.25l-.499-3.854h-.25z"
            fill="#131A2D"
            />
            <path
            d="M219.062 86.294c.125 0 .25.133.375.133l.374 2.924h-.374l-.375-3.057z"
            fill="#fff"
            />
            <path
            d="M219.437 89.484l-.375-3.323h.125c.125 0 .25.133.374.133l.375 2.924-.499.266zm-.25-3.19l.374 2.924h.25l-.374-2.791c-.125 0-.25 0-.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M215.445 85.896h.375l.499 4.12c-.125 0-.25 0-.375.134l-.499-4.254z"
            fill="#fff"
            />
            <path
            d="M215.944 90.15l-.499-4.254h.499l.499 4.254c-.249-.133-.374-.133-.499 0zm-.499-4.254l.499 3.988h.25l-.499-3.988h-.25z"
            fill="#131A2D"
            />
            <path
            d="M219.688 86.561c.124.133.249.133.374.266l.249 2.393h-.374l-.249-2.659z"
            fill="#fff"
            />
            <path
            d="M219.937 89.352l-.375-2.924h.125c.125.133.25.133.375.266l.374 2.525-.499.133zm-.125-2.658l.374 2.525h.25l-.25-2.392c-.249 0-.374-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M217.816 85.897h.375l.499 3.456h-.375l-.499-3.456z"
            fill="#fff"
            />
            <path
            d="M218.19 89.618l-.499-3.721h.499l.499 3.588-.499.133zm-.249-3.589l.499 3.456h.249l-.374-3.323c-.249-.133-.374-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M217.191 85.896h.375l.499 3.59h-.375l-.499-3.59z"
            fill="#fff"
            />
            <path
            d="M217.69 89.617l-.499-3.854h.499l.499 3.721-.499.133zm-.374-3.721l.499 3.588h.25l-.499-3.588h-.25z"
            fill="#131A2D"
            />
            <path
            d="M218.439 86.03c.125 0 .25 0 .375.132l.374 3.19h-.374l-.375-3.323z"
            fill="#fff"
            />
            <path
            d="M218.813 89.485l-.499-3.589h.125c.125 0 .25.133.374.133l.499 3.456h-.499zm-.249-3.323l.374 3.19h.25l-.375-3.057c-.124-.133-.249-.133-.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M211.953 86.826c.125 0 .25-.133.374-.133l.499 3.59h-.374l-.499-3.457z"
            fill="#fff"
            />
            <path
            d="M212.327 90.415l-.499-3.589c.125 0 .25-.133.374-.133h.125l.499 3.722h-.499zm-.249-3.456l.374 3.456h.249l-.499-3.456c0-.133-.124-.133-.124 0z"
            fill="#131A2D"
            />
            <path
            d="M214.322 86.03c.125 0 .25 0 .375-.133l.499 4.12h-.375l-.499-3.987z"
            fill="#fff"
            />
            <path
            d="M214.696 90.283l-.499-4.254c.125 0 .25 0 .375-.132l.499 4.253h-.125c.125.133 0 .133-.25.133zm-.374-4.12l.499 3.987h.25l-.499-3.988c-.125-.133-.125 0-.25 0z"
            fill="#131A2D"
            />
            <path
            d="M215.321 90.15l-.499-4.12h.375l.499 4.12h-.25-.125z"
            fill="#fff"
            />
            <path
            d="M215.321 90.15l-.499-4.254h.624l.499 4.254h-.624zm-.374-4.12l.499 3.987h.25l-.499-3.988h-.25z"
            fill="#131A2D"
            />
            <path
            d="M209.832 89.351c0-.266.125-.531.25-.93l.249 2.26h-.374l-.125-1.33z"
            fill="#fff"
            />
            <path
            d="M209.957 90.814l-.25-1.595c0-.266.125-.532.25-.93l.124-.134.375 2.526-.499.133zm0-1.462l.124 1.329h.25l-.25-1.994c-.124.133-.124.399-.124.665z"
            fill="#131A2D"
            />
            <path
            d="M220.311 87.092c.249.265.374.398.374.664l.125 1.462h-.25l-.249-2.126z"
            fill="#fff"
            />
            <path
            d="M220.56 89.219l-.249-2.393.124.133c.25.266.375.399.375.665v.132l.249 1.463h-.499zm-.125-1.994l.25 1.86h.125l-.125-1.329c0-.266-.125-.398-.25-.531z"
            fill="#131A2D"
            />
            <path
            d="M210.83 87.624c.125-.133.25-.133.374-.266l.375 3.19h-.375l-.374-2.924z"
            fill="#fff"
            />
            <path
            d="M211.204 90.549l-.374-3.058c.125-.132.25-.132.374-.265h.125l.374 3.323h-.499zm-.249-2.925l.374 2.792h.25l-.375-2.925c-.124 0-.249 0-.249.133z"
            fill="#131A2D"
            />
            <path
            d="M213.699 86.162c.125 0 .25 0 .374-.133l.499 4.12h-.374l-.499-3.987z"
            fill="#fff"
            />
            <path
            d="M214.198 90.283l-.499-4.12c.125 0 .25 0 .374-.134h.125l.499 4.254h-.499zm-.499-3.988l.499 3.855h.25l-.499-3.988s-.125.133-.25.133z"
            fill="#131A2D"
            />
            <path
            d="M211.453 87.225c.125-.133.25-.133.374-.133l.375 3.456h-.375l-.374-3.323z"
            fill="#fff"
            />
            <path
            d="M211.827 90.548l-.374-3.323c.125-.133.25-.133.374-.133h.125l.499 3.589-.624-.133zm-.374-3.323l.374 3.19h.25l-.374-3.19c-.125-.133-.125 0-.25 0z"
            fill="#131A2D"
            />
            <path
            d="M212.576 86.56c.125 0 .25-.132.374-.132l.499 3.722h-.374l-.499-3.59z"
            fill="#fff"
            />
            <path
            d="M212.95 90.415l-.499-3.854c.125 0 .25-.133.374-.133h.125l.499 3.854-.499.133zm-.374-3.721l.499 3.588h.249l-.499-3.588c-.124-.133-.124-.133-.249 0z"
            fill="#131A2D"
            />
            <path
            d="M213.076 86.427c.125 0 .25-.133.374-.133l.499 3.988h-.374l-.499-3.855z"
            fill="#fff"
            />
            <path
            d="M214.074 90.282h-.374l-.499-3.988c.125 0 .25-.133.374-.133h.125l.374 4.12zm-.374-.133h.25l-.499-3.855c-.125 0-.125 0-.25.133l.499 3.722z"
            fill="#131A2D"
            />
            <path
            d="M215.82 92.675c-3.244.532-5.739-.664-5.863-1.86-.125-1.197 1.871-3.058 5.114-3.456 3.244-.532 5.739.664 5.864 1.86.249 1.33-1.872 3.058-5.115 3.456z"
            fill="#fff"
            />
            <path
            d="M214.323 92.94c-.998 0-1.872-.132-2.62-.398-1.123-.399-1.747-.93-1.747-1.595-.124-1.33 1.996-3.057 5.24-3.589 1.497-.266 2.994-.133 4.117.266 1.122.399 1.746.93 1.871 1.595.125 1.33-1.996 3.057-5.24 3.589-.623 0-1.122.133-1.621.133zm2.37-5.582c-.499 0-.998 0-1.497.133-3.244.532-5.24 2.127-5.115 3.456.125.665.749 1.196 1.747 1.595 1.122.399 2.619.532 3.992.266 3.243-.532 5.239-2.127 5.114-3.456-.124-.665-.748-1.196-1.746-1.595-.749-.266-1.622-.399-2.495-.399z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M211.703 88.554c.374-.266.749-.399 1.123-.532l5.115 4.121c-.375.133-.874.266-1.373.399l-4.865-3.988zM214.697 87.49c.125 0 .25 0 .499-.133h.499l4.491 3.59c-.124.132-.374.265-.499.398l-4.99-3.855z"
            fill="#fff"
            />
            <path
            d="M237.401 115.404c-.375-.93-.749-1.86-.874-2.658l-1.996-4.652 1.622-.798c1.497-.531 4.241 1.595 6.113 5.716 1.871 4.12 1.497 7.842.125 8.64l-1.622.797-1.996-4.652a10.558 10.558 0 01-1.372-2.393z"
            fill="#0EA59D"
            />
            <path
            d="M240.769 122.582l-1.996-4.652c-.499-.798-.998-1.595-1.372-2.525-.375-.931-.749-1.728-.874-2.659l-1.996-4.652 1.747-.931c1.497-.531 4.366 1.595 6.113 5.716 1.871 4.121 1.621 7.842.249 8.64l-1.871 1.063zm-6.238-14.355l1.996 4.519c.25.931.499 1.728.874 2.659.374.93.873 1.727 1.372 2.392l1.996 4.519 1.622-.797c1.372-.798 1.621-4.387-.25-8.507-1.746-4.121-4.616-6.247-5.988-5.583l-1.622.798z"
            fill="#131A2D"
            />
            <path
            d="M237.773 107.562c.125.132.375.132.499.265l-3.243 1.595-.25-.398 2.994-1.462z"
            fill="#0EA59D"
            />
            <path
            d="M235.029 109.555l-.25-.531 2.994-1.462c.125.132.375.132.499.265h.125l-3.368 1.728zm-.125-.531l.125.265 2.994-1.462c-.125-.133-.25-.133-.374-.265l-2.745 1.462z"
            fill="#131A2D"
            />
            <path
            d="M238.523 117.531l4.491-2.26c0 .133.125.266.125.532l-4.366 2.127c-.125-.133-.25-.266-.25-.399z"
            fill="#0EA59D"
            />
            <path
            d="M238.773 117.93c-.125-.133-.125-.266-.25-.399l-.125-.133 4.616-2.259v.133c0 .133.125.265.125.531l-4.366 2.127zm-.25-.399c.125.133.125.266.25.266l4.241-2.127c0-.133 0-.265-.125-.398l-4.366 2.259z"
            fill="#131A2D"
            />
            <path
            d="M242.764 114.474c0 .133.125.265.125.531l-4.616 2.26c-.125-.133-.125-.266-.25-.399l4.741-2.392z"
            fill="#0EA59D"
            />
            <path
            d="M238.273 117.265c-.125-.133-.25-.266-.25-.532l4.741-2.392v.133c0 .133.125.266.125.531l-4.616 2.26zm-.125-.532c0 .133.125.266.125.266l4.491-2.259c0-.133-.125-.266-.125-.399l-4.491 2.392z"
            fill="#131A2D"
            />
            <path
            d="M243.387 118.727v.532l-3.368 1.595-.249-.399 3.617-1.728z"
            fill="#0EA59D"
            />
            <path
            d="M240.019 120.987l-.249-.531 3.742-1.861v.664l-3.493 1.728zm0-.398l.125.265 3.243-1.595v-.398l-3.368 1.728z"
            fill="#131A2D"
            />
            <path
            d="M242.391 113.677c0 .133.124.266.124.399l-4.74 2.392c-.125-.133-.125-.266-.25-.399l4.866-2.392z"
            fill="#0EA59D"
            />
            <path
            d="M237.9 116.601c-.125-.133-.125-.399-.25-.532l4.866-2.392c0 .133.124.266.124.399l-4.74 2.525zm-.125-.532c0 .133.125.266.125.266l4.616-2.259c0-.133-.125-.266-.125-.399l-4.616 2.392z"
            fill="#131A2D"
            />
            <path
            d="M243.388 119.658c0 .266-.124.399-.124.665l-2.745 1.329-.249-.399 3.118-1.595z"
            fill="#0EA59D"
            />
            <path
            d="M240.394 121.785l-.249-.532 3.243-1.595v.133c0 .266-.125.399-.125.665l-2.869 1.329zm-.125-.532l.125.266 2.745-1.329c0-.133.124-.266.124-.399l-2.994 1.462z"
            fill="#131A2D"
            />
            <path
            d="M243.388 116.866c0 .133 0 .399.125.532l-3.992 1.994-.25-.399 4.117-2.127z"
            fill="#0EA59D"
            />
            <path
            d="M239.396 119.525l-.25-.532 4.242-2.127v.133c0 .133 0 .399.125.532l-4.117 1.994zm-.125-.532l.125.266 3.867-1.994v-.399l-3.992 2.127z"
            fill="#131A2D"
            />
            <path
            d="M243.14 116.068c0 .133.124.399.124.532l-4.241 2.127-.25-.399 4.367-2.26z"
            fill="#0EA59D"
            />
            <path
            d="M239.023 118.727l-.25-.532 4.367-2.127v.133c0 .133.124.399.124.532l-4.241 1.994zm0-.532l.125.266 4.116-1.994c0-.133 0-.266-.124-.399l-4.117 2.127z"
            fill="#131A2D"
            />
            <path
            d="M243.388 117.797v.532l-3.742 1.86-.25-.398 3.992-1.994z"
            fill="#0EA59D"
            />
            <path
            d="M239.771 120.322l-.25-.531 3.992-1.994v.664l-3.742 1.861zm-.125-.531l.125.266 3.618-1.861v-.399l-3.743 1.994z"
            fill="#131A2D"
            />
            <path
            d="M239.896 109.289l.375.399-4.117 2.127-.25-.399 3.992-2.127z"
            fill="#0EA59D"
            />
            <path
            d="M236.029 111.815l-.25-.532 4.117-1.994.374.399-4.241 2.127zm-.125-.399l.125.266 3.992-1.994-.25-.266-3.867 1.994z"
            fill="#131A2D"
            />
            <path
            d="M241.766 112.081c.125.133.125.266.25.399l-4.741 2.392c0-.133-.125-.265-.125-.398l4.616-2.393z"
            fill="#0EA59D"
            />
            <path
            d="M237.15 115.005c-.125-.266-.125-.398-.25-.531l4.866-2.393c.124.133.124.266.249.399l-4.865 2.525zm0-.531c0 .133.125.265.125.398l4.615-2.259c0-.133-.124-.266-.124-.266l-4.616 2.127z"
            fill="#131A2D"
            />
            <path
            d="M237.275 115.271l4.741-2.393s0 .133.125.133c0 .133.124.133.124.266l-4.74 2.392c0-.133-.125-.133-.125-.266 0 0 0-.132-.125-.132z"
            fill="#0EA59D"
            />
            <path
            d="M237.525 115.802c0-.133 0-.133-.125-.133 0 0 0-.133-.125-.133v-.265l4.866-2.393v.266c0 .133.124.133.124.266v.133l-4.74 2.259zm-.125-.531s0 .133 0 0a.423.423 0 01.125.265l4.616-2.392c0-.133 0-.133-.125-.266v-.133l-4.616 2.526z"
            fill="#131A2D"
            />
            <path
            d="M236.153 107.429a1.627 1.627 0 011.122 0l-2.619 1.329-.25-.532 1.747-.797z"
            fill="#0EA59D"
            />
            <path
            d="M234.656 108.758l-.25-.664 1.747-.931a1.627 1.627 0 011.122 0h.125l-2.744 1.595zm-.125-.531l.125.398 2.37-1.196c-.374-.133-.749-.133-.998 0l-1.497.798z"
            fill="#131A2D"
            />
            <path
            d="M243.015 120.854c-.125.399-.374.665-.624.798l-1.622.798-.124-.399 2.37-1.197z"
            fill="#0EA59D"
            />
            <path
            d="M240.644 122.449l-.249-.532 2.619-1.329-.124.133c-.125.399-.375.664-.624.797l-1.622.931zm0-.399l.125.266 1.622-.798c.249-.133.374-.266.499-.531l-2.246 1.063z"
            fill="#131A2D"
            />
            <path
            d="M238.522 108.094l.375.399-3.618 1.86-.25-.398 3.493-1.861z"
            fill="#0EA59D"
            />
            <path
            d="M235.404 110.353l-.25-.531 3.493-1.728.375.399h.124l-3.742 1.86zm-.125-.531l.125.266 3.493-1.728c-.125-.133-.25-.133-.374-.266l-3.244 1.728z"
            fill="#131A2D"
            />
            <path
            d="M241.391 111.416c.125.133.125.266.25.399l-4.616 2.392c0-.133-.125-.265-.125-.531l4.491-2.26z"
            fill="#0EA59D"
            />
            <path
            d="M236.9 114.207c-.125-.265-.125-.398-.125-.531l4.616-2.26c.125.133.125.266.25.399l-4.741 2.392zm-.125-.531c0 .133.125.266.125.398l4.616-2.259c0-.133-.125-.266-.125-.266l-4.616 2.127z"
            fill="#131A2D"
            />
            <path
            d="M239.272 108.759l.374.399-3.867 1.993-.25-.398 3.743-1.994z"
            fill="#0EA59D"
            />
            <path
            d="M235.654 111.151l-.25-.531 3.868-1.861.374.399-3.992 1.993zm0-.531l.125.266 3.742-1.861-.249-.266-3.618 1.861z"
            fill="#131A2D"
            />
            <path
            d="M240.394 109.954c.124.133.249.266.249.399l-4.366 2.127-.25-.399 4.367-2.127z"
            fill="#0EA59D"
            />
            <path
            d="M236.402 112.613l-.25-.532 4.242-2.127c.125.133.249.266.249.399l-4.241 2.26zm-.125-.532l.125.266 4.241-2.127c-.124-.133-.124-.266-.249-.266l-4.117 2.127z"
            fill="#131A2D"
            />
            <path
            d="M240.894 110.618c.124.133.124.266.249.399l-4.491 2.26c0-.133-.125-.266-.125-.532l4.367-2.127z"
            fill="#0EA59D"
            />
            <path
            d="M236.652 113.409c-.125-.265-.125-.398-.125-.531l4.367-2.26c.124.133.124.266.249.399l-4.491 2.392zm0-.531c0 .133 0 .266.125.399l4.366-2.127c-.125-.133-.125-.266-.249-.266l-4.242 1.994z"
            fill="#131A2D"
            />
            <path
            d="M234.407 116.866c-1.871-4.253-1.497-7.975-.124-8.639 1.497-.665 4.366 1.462 6.237 5.582 1.871 4.254 1.497 7.975.125 8.64-1.497.798-4.366-1.329-6.238-5.583z"
            fill="#0EA59D"
            />
            <path
            d="M240.021 122.714c-1.622 0-3.992-2.126-5.614-5.848-.873-1.994-1.372-3.988-1.247-5.716 0-1.595.499-2.658 1.247-3.057 1.497-.797 4.366 1.462 6.238 5.716.873 1.993 1.372 3.987 1.247 5.715 0 1.595-.499 2.659-1.247 3.057-.125.133-.375.133-.624.133zm-5.489-5.848c1.871 4.253 4.74 6.38 6.113 5.582.748-.398 1.122-1.462 1.122-2.924 0-1.728-.374-3.722-1.247-5.582-1.871-4.254-4.741-6.381-6.113-5.583-.748.399-1.123 1.462-1.123 2.924-.124 1.595.375 3.589 1.248 5.583z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M237.776 109.556c.374.398.748.797 1.122 1.329l-2.994 8.64c-.374-.532-.748-1.064-.998-1.728l2.87-8.241zM240.27 113.277c.124.133.124.399.249.532s.125.399.25.532l-2.62 7.576c-.25-.133-.499-.399-.749-.531l2.87-8.109z"
            fill="#fff"
            />
            <path
            d="M180.266 109.422c-.124.266-.249.399-.499.664 0 0-.124 0-.124-.132-.25 3.854.873 7.044 3.243 10.5.125.133 0 .399-.125.532-1.247 1.063-2.37 2.393-3.617 3.589h.124c0 .266.125.532.125.797h-.499c-.125 0-.125 0-.249-.133-3.119-3.854-4.866-8.241-4.866-12.627 0-.133.125-.399.375-.532 1.871-1.196 3.742-1.595 5.613-2.658h.499z"
            fill="#131A2D"
            />
            <path
            d="M180.267 109.688c-.374 4.121.873 7.444 3.493 11.032.125.133.125.399-.125.532-1.372 1.196-2.744 2.659-3.992 4.121a.362.362 0 01-.499 0c-3.118-3.722-4.865-8.109-4.99-12.628 0-.133.125-.399.375-.532 1.871-1.196 3.742-1.595 5.489-2.658.249-.133.374-.133.249.133z"
            fill="#0EA59D"
            />
            <path
            d="M179.394 125.372c-.125 0-.25 0-.25-.132-3.119-3.855-4.865-8.242-5.115-12.628 0-.133.125-.399.375-.532a23.763 23.763 0 013.243-1.595c.749-.266 1.497-.664 2.246-1.063.124-.133.249-.133.374 0 0 0 .125.133.125.266-.375 3.855.748 7.045 3.368 10.899.125.133.125.399-.125.532-1.497 1.329-2.744 2.658-3.992 4.121 0 .132-.125.132-.249.132zm.748-15.817h-.125c-.748.399-1.497.797-2.245 1.063-.998.399-2.121.931-3.244 1.595-.124.133-.249.266-.249.532.125 4.386 1.871 8.773 4.99 12.495l.125.132c.124 0 .124 0 .249-.132 1.248-1.463 2.62-2.792 3.992-4.121.125-.133.125-.266 0-.399-2.62-3.987-3.742-7.31-3.493-11.165.125 0 .125 0 0 0 .125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M179.518 111.017c.25-.133.374-.133.374.133 0 3.323 1.123 5.848 2.87 8.773.124.132 0 .398-.125.398-.125.133-.125.266-.125.532.125.133.125.399 0 .532-.873.797-1.746 1.595-2.495 2.525-.125.133-.374.133-.374 0-.125-.133-.25-.133-.374 0-.125.133-.375.133-.375 0-2.245-3.057-3.617-6.513-3.992-10.102 0-.133.125-.399.25-.532.125-.132.249-.398.249-.531v-.133c0-.133.125-.399.25-.532 1.123-.664 2.37-1.063 3.368-1.329.25 0 .25 0 .25.133v.133c-.125.133 0 .133.249 0z"
            fill="#fff"
            />
            <path
            d="M179.767 124.043c-.124 0-.249 0-.249-.133l-.125-.133s-.125 0-.125.133c-.124.133-.124.133-.249.133s-.25 0-.25-.133c-2.37-3.19-3.617-6.513-3.992-10.102 0-.133.125-.399.25-.531.125-.133.249-.266.249-.399v-.133c0-.133.125-.399.375-.532 1.122-.664 2.245-1.063 3.368-1.329h.249s.125.133 0 .133v.266h.125c.125 0 .25-.133.25 0l.124.133c0 3.456 1.123 5.981 2.87 8.772.124.133.124.399-.125.532-.125.133-.125.266 0 .399s.125.399 0 .532c-.873.797-1.747 1.728-2.495 2.525 0-.133-.125-.133-.25-.133zm-.374-.399c.125 0 .25 0 .25.133l.124.133s.125 0 .125-.133c.749-.93 1.622-1.728 2.495-2.525.125-.133.125-.266 0-.399s-.125-.399.125-.532c.125-.133.125-.265 0-.398-1.747-2.792-2.869-5.317-2.994-8.773v-.133h-.125c-.125 0-.249.133-.249 0l-.125-.133v-.133-.133h-.25c-1.122.266-2.245.665-3.243 1.329-.125.133-.25.266-.25.399v.133c0 .133-.124.399-.249.532s-.25.266-.25.398c.375 3.456 1.747 6.912 3.992 10.102l.125.133s.125 0 .125-.133c.125.133.249.133.374.133z"
            fill="#131A2D"
            />
            <path
            d="M178.769 119.258c-.748.133-1.497 0-2.121-.532-.873-.797-.748-2.392.25-3.19.374-.398.873-.531 1.247-.664.749-.133 1.373.133 1.872.664.748.798.748 2.127-.125 3.058-.25.398-.624.531-1.123.664z"
            fill="#fff"
            />
            <path
            d="M177.272 115.668c.873-.797 1.996-.797 2.62 0a2.155 2.155 0 01-.125 2.792c-.748.797-1.996.93-2.744.133-.749-.798-.624-2.127.249-2.925z"
            fill="#0EA59D"
            />
            <path
            d="M178.27 119.125c-.499 0-.998-.133-1.248-.532-.374-.399-.499-.798-.499-1.329 0-.665.25-1.197.749-1.728.873-.798 2.121-.798 2.744 0a2.155 2.155 0 01-.124 2.791c-.499.665-1.123.798-1.622.798zm.374-3.988c-.499 0-.998.133-1.372.532-.499.398-.749.93-.749 1.595 0 .531.125.93.499 1.196.749.665 1.872.665 2.62-.133.749-.798.749-1.861.125-2.658-.25-.266-.624-.532-1.123-.532z"
            fill="#131A2D"
            />
            <path
            d="M180.267 120.986c-.25.266-.749.266-.874 0-.249-.266-.124-.798.25-1.063.374-.266.748-.266.873.132.125.266 0 .665-.249.931z"
            fill="#0EA59D"
            />
            <path
            d="M179.767 121.252c-.249 0-.374-.133-.499-.266a.9.9 0 01.25-1.196c.125-.133.374-.266.624-.133.124 0 .249.133.374.265.249.399.125.798-.25 1.197-.124.133-.249.133-.499.133zm.25-1.462c-.125 0-.25 0-.374.132a1.08 1.08 0 00-.25 1.064c.125.133.125.266.374.266.125 0 .375 0 .499-.133.25-.266.375-.665.25-.931s-.25-.398-.499-.398z"
            fill="#131A2D"
            />
            <path
            d="M177.522 113.941c-.374.266-.749.133-.749-.133 0-.399.25-.798.624-1.063.374-.266.749-.133.749.132 0 .399-.25.798-.624 1.064z"
            fill="#0EA59D"
            />
            <path
            d="M177.147 114.206h-.249c-.125 0-.25-.132-.25-.398 0-.399.25-.931.624-1.197.25-.132.499-.132.624-.132s.249.132.249.398c0 .399-.249.931-.623 1.064-.125.133-.25.265-.375.265zm.624-1.595c-.125 0-.249 0-.374.133-.374.266-.624.665-.624 1.064 0 .133.125.133.125.266.125 0 .374 0 .499-.133.374-.266.624-.665.499-1.064 0-.133-.125-.133-.125-.266.125 0 0 0 0 0zM188.874 110.088c-.249.133-.499.266-.624.399l-.124-.133c-1.747 3.456-1.996 6.779-1.248 10.899 0 .133-.125.399-.249.399-1.497.399-3.119 1.063-4.741 1.728h.125c0 .266-.125.532-.125.797-.125-.133-.249-.133-.374-.265-.125 0-.125-.133-.125-.133-1.247-4.918-1.123-9.571.624-13.691.125-.133.249-.266.499-.399 2.245-.266 3.992.133 6.113.133.124 0 .249 0 .249.133-.125 0-.125.133 0 .133z"
            fill="#131A2D"
            />
            <path
            d="M188.875 110.221c-1.996 3.589-2.121 7.177-1.247 11.431 0 .133-.125.399-.25.399-1.746.531-3.493 1.196-5.364 1.993-.125.133-.374 0-.374-.265-1.248-4.786-1.248-9.571.374-13.691.125-.133.249-.266.499-.399 2.245-.266 3.992.133 5.988.133.374.266.374.266.374.399z"
            fill="#0EA59D"
            />
            <path
            d="M181.888 124.178h-.124c-.125 0-.125-.133-.125-.266-1.372-4.918-1.123-9.703.499-13.69.125-.133.374-.399.624-.399 1.247-.133 2.495 0 3.617 0 .749 0 1.622.133 2.495.133.125 0 .25 0 .25.133v.265c-1.871 3.323-2.121 6.779-1.248 11.432 0 .265-.124.398-.249.531a31.215 31.215 0 00-5.24 1.994c-.374-.133-.374-.133-.499-.133zm2.121-14.222c-.499 0-.873 0-1.372.133-.25 0-.374.133-.499.265-1.622 3.988-1.747 8.773-.374 13.558 0 .133 0 .133.124.133h.25a37.445 37.445 0 015.364-1.994c.125 0 .25-.132.25-.265-.998-4.786-.624-8.241 1.247-11.564v-.133s-.125-.133-.125 0c-.873 0-1.746 0-2.495-.133h-2.37z"
            fill="#131A2D"
            />
            <path
            d="M187.503 111.152c.249 0 .374.133.249.266-1.247 2.924-1.372 5.715-.873 9.304 0 .133-.125.399-.249.399-.125 0-.25.266-.25.399s-.125.399-.249.399c-1.123.398-2.246.664-3.244 1.196-.125 0-.374 0-.374-.266 0-.133-.25-.266-.374-.266-.125.133-.375 0-.375-.266-.873-3.854-.748-7.576.375-10.899 0-.133.249-.266.499-.399h.124c.25 0 .375-.133.499-.399v-.133c0-.133.25-.265.499-.265 1.373-.133 2.62.132 3.493.265.25 0 .25.133.25.266v.133c-.25.266-.125.266 0 .266z"
            fill="#fff"
            />
            <path
            d="M182.762 123.114h-.124c-.125 0-.125-.133-.125-.265 0-.133 0-.133-.125-.133h-.374c-.125 0-.125-.133-.125-.266-.873-3.855-.748-7.577.374-11.033 0-.133.25-.398.499-.398h.125c.125 0 .374-.133.374-.266v-.133c.125-.133.25-.399.499-.399 1.248-.133 2.495 0 3.618.266.125 0 .25 0 .25.133v.399h.124c.125 0 .25 0 .25.133v.265c-1.372 3.058-1.372 5.982-.873 9.172 0 .266-.125.399-.25.399s-.249.133-.249.266c0 .265-.125.398-.25.531a94.065 94.065 0 00-3.243 1.196c-.25.133-.25.133-.375.133zm-.499-.531h.125c.125 0 .125.133.125.266 0 .132 0 .132.125.132h.124c1.123-.398 2.121-.797 3.244-1.196.125 0 .249-.133.249-.266 0-.265.125-.398.25-.531.125 0 .249-.133.249-.266-.499-3.323-.499-6.115.874-9.305v-.133h-.125c-.125 0-.25 0-.25-.132v-.399-.133l-.249-.133c-1.123-.266-2.246-.399-3.493-.266-.125 0-.374.133-.374.266v.133c-.125.133-.25.399-.499.399h-.125c-.125 0-.374.133-.374.265-1.123 3.323-1.248 7.045-.375 10.9 0 .133 0 .133.125.133h.125c.125.266.249.266.249.266z"
            fill="#131A2D"
            />
            <path
            d="M183.634 118.329c-.749-.133-1.372-.665-1.622-1.462-.374-1.197.25-2.393 1.497-2.792.499-.133.998-.133 1.372 0 .749.266 1.248.798 1.373 1.462.249 1.064-.25 2.26-1.373 2.659-.374.266-.748.266-1.247.133z"
            fill="#fff"
            />
            <path
            d="M183.634 114.34c1.122-.398 2.12.266 2.37 1.197.249.93-.25 1.994-1.248 2.392-.998.399-2.12 0-2.619-1.063-.25-.93.374-2.127 1.497-2.526z"
            fill="#0EA59D"
            />
            <path
            d="M184.008 118.195c-.873 0-1.622-.531-1.871-1.329a2.04 2.04 0 01.124-1.462c.25-.532.749-.931 1.373-1.196 1.122-.399 2.245.133 2.495 1.196.249 1.063-.25 2.127-1.248 2.525-.249.266-.499.266-.873.266zm.249-3.854c-.249 0-.374 0-.623.132-.624.133-.998.532-1.248 1.064-.249.399-.249.93-.125 1.329.375.93 1.497 1.462 2.495 1.063.998-.398 1.497-1.329 1.248-2.392a1.824 1.824 0 00-1.747-1.196z"
            fill="#131A2D"
            />
            <path
            d="M184.258 120.589c-.374.133-.748-.133-.748-.399 0-.399.249-.798.624-.931a.554.554 0 01.748.532c0 .399-.249.665-.624.798z"
            fill="#0EA59D"
            />
            <path
            d="M184.009 120.721c-.125 0-.25 0-.375-.133-.124-.133-.249-.266-.249-.399 0-.399.249-.797.624-.93.249 0 .499 0 .623.133.125.133.25.266.25.398 0 .399-.25.798-.624.931h-.249zm.249-1.462h-.125c-.374.133-.623.531-.623.797 0 .133.124.266.249.399a.362.362 0 00.499 0c.374-.133.624-.532.624-.797 0-.133-.125-.266-.25-.399h-.374z"
            fill="#131A2D"
            />
            <path
            d="M184.51 113.012c-.375 0-.749-.133-.624-.532s.499-.665.998-.665c.374 0 .748.133.624.532-.125.266-.499.532-.998.665z"
            fill="#0EA59D"
            />
            <path
            d="M184.384 113.012c-.25 0-.375 0-.499-.133-.125-.133-.125-.266-.125-.399.125-.399.499-.664.998-.797.249 0 .499 0 .624.133.124.132.124.265 0 .398-.125.399-.499.665-.998.798.124 0 .124 0 0 0zm.623-1.196c-.499 0-.998.398-.998.664v.266c.125.133.25.133.499.133.375 0 .749-.399.874-.665v-.266c0-.132-.125-.132-.375-.132zM174.529 118.86c1.122.665 2.993.665 4.116 0l18.838-11.564c.374-.266 1.122-.266 1.496 0 .375.266.375.665 0 .931l-18.837 11.564c-1.996 1.196-4.74 1.728-6.986 0l1.373-.931z"
            fill="#131A2D"
            />
            <path
            d="M173.28 119.79c1.996 1.196 4.74 1.196 6.611 0l18.962-11.564c.25-.133.25-.266.25-.399v23.128c0 1.595-.749 3.058-2.121 3.855l-16.966 10.368c-1.996 1.196-5.115 1.595-6.986.399-.873-.532-1.372-1.728-1.497-2.393v-25.521c.125.665.749 1.462 1.747 2.127z"
            fill="#0EA59D"
            />
            <path
            d="M176.024 146.241c-1.123 0-2.121-.266-2.994-.797-.873-.532-1.372-1.595-1.497-2.526v-25.52h.125c0 .664.624 1.595 1.622 2.259 1.871 1.196 4.615 1.196 6.611 0l18.962-11.564c.125-.133.25-.266.25-.399h.125v23.129c0 1.595-.874 3.19-2.121 3.987l-16.966 10.368c-1.123.665-2.62 1.063-4.117 1.063zm-4.366-28.179v24.989c.125.798.499 1.861 1.372 2.393 1.996 1.196 5.115.797 6.986-.399l16.966-10.368c1.248-.797 2.121-2.259 2.121-3.854v-22.73c0 .133-.125.133-.25.133l-18.962 11.564c-1.996 1.196-4.74 1.196-6.736 0-.624-.399-1.248-1.063-1.497-1.728z"
            fill="#131A2D"
            />
            <path
            d="M194.488 120.987l4.616-2.792a1.079 1.079 0 011.248 0l.249.133-6.736 7.71-.749-.399c-.374-.266-.499-.665-.499-1.329 0-1.196.873-2.659 1.871-3.323z"
            fill="#131A2D"
            />
            <path
            d="M195.361 121.253l4.866-2.924a.422.422 0 01.623.399v2.525c0 .665-.374 1.33-.998 1.728l-4.74 2.925c-.499.265-.998.398-1.248.133-.499-.266-.623-1.064-.499-2.127.375-1.064.998-2.127 1.996-2.659z"
            fill="#0EA59D"
            />
            <path
            d="M194.363 126.305c-.249 0-.374 0-.499-.133-.499-.399-.748-1.197-.499-2.26.25-1.196.998-2.127 1.996-2.791l4.866-2.925c.124-.133.374-.133.623 0 .125.133.25.266.25.532v2.526c0 .797-.374 1.462-.998 1.86l-4.741 2.925c-.499.133-.748.266-.998.266zm.998-5.051a4.69 4.69 0 00-1.746 2.658c-.25.93-.125 1.728.374 1.994.25.133.749.133 1.123-.133l4.74-2.924c.499-.399.874-.931.874-1.595v-2.526c0-.133 0-.266-.125-.266h-.374l-4.866 2.792z"
            fill="#131A2D"
            />
            <path
            d="M195.111 122.449c.499-.399.998 0 .998.665 0 .664-.499 1.462-.998 1.861-.499.398-.998 0-.998-.665s.375-1.595.998-1.861z"
            fill="#131A2D"
            />
            <path
            d="M195.237 122.848c.499-.265.873 0 .873.532s-.374 1.196-.873 1.595c-.499.266-.874 0-.874-.532.125-.664.499-1.329.874-1.595z"
            fill="#fff"
            />
            <path
            d="M194.987 124.975c-.124 0-.124 0-.249-.133a1.05 1.05 0 01-.25-.665c0-.532.375-1.329.874-1.595.249-.133.499-.133.623 0 .125.133.25.399.25.665 0 .531-.374 1.329-.873 1.595-.125.133-.25.133-.375.133zm.375-2.127c-.499.266-.749.93-.749 1.462 0 .266.125.399.25.532.124.133.374 0 .499 0 .499-.266.748-.931.748-1.462 0-.266-.125-.399-.249-.532a.362.362 0 00-.499 0z"
            fill="#131A2D"
            />
            <path
            d="M190.745 125.639c-.125-.532-.249-1.197-.624-1.595-.374-.532-.998-.798-1.621-.798a3.28 3.28 0 00-1.622.399c-.998.532-1.622 1.329-2.246 2.26-.623.93-.998 1.86-1.247 2.924v.133c0 .133.125.133.249.133l1.872-1.197 1.871-1.196c-.624.266-1.248.665-1.996 1.063l-1.497.798c.249-.798.748-1.462 1.123-2.127.249-.399.623-.797.998-1.063.374-.266.748-.665 1.122-.798.375-.266.874-.398 1.248-.266.374 0 .748.133.998.532.249.266.374.798.499 1.196v1.463c-.125.93-.499 1.86-.998 2.791l-.749 1.196a3.913 3.913 0 01-.998 1.064c-.374.265-.748.531-1.247.664-.374.133-.873.133-1.248.133-.374-.133-.748-.399-.873-.93-.249-.399-.249-.931-.374-1.463v-.132c0-.133-.125-.133-.25 0-.873.664-1.746 1.196-2.619 1.86.873-.398 1.746-.93 2.495-1.462 0 .399.124.931.249 1.33.25.531.624 1.063 1.123 1.196.499.266 1.123.133 1.622 0a2.923 2.923 0 001.372-.798c.374-.266.748-.664 1.123-1.063.374-.399.623-.798.873-1.329.499-.931.873-1.994 1.123-3.057a2.54 2.54 0 00.249-1.861z"
            fill="#fff"
            />
            <path
            d="M185.381 133.747c-.249 0-.499 0-.873-.133-.499-.266-.998-.664-1.123-1.196-.125-.399-.249-.798-.249-1.329-.874.531-1.747.93-2.495 1.329v-.133c.873-.665 1.746-1.196 2.619-1.861.125-.133.25 0 .25.133v.133c0 .532.125 1.063.249 1.462.25.399.499.665.874.798.374.133.748.133 1.247-.133.374-.133.749-.399 1.123-.665a3.94 3.94 0 00.998-1.063c.374-.399.624-.798.748-1.197.499-.93.874-1.86.998-2.791.125-.532.125-1.063 0-1.462-.124-.532-.249-.93-.499-1.196-.249-.266-.623-.532-.998-.532-.374 0-.748.133-1.247.266-.374.133-.749.399-1.123.797-.374.266-.624.665-.998 1.064a8.056 8.056 0 00-1.123 1.994l1.248-.665c.748-.399 1.372-.665 1.996-1.063v.133c-.499.398-1.123.797-1.871 1.196l-1.872 1.196h-.249c-.125 0-.125 0-.125-.133v-.266c.25-1.063.749-1.993 1.248-2.924a9.039 9.039 0 012.245-2.26 3.658 3.658 0 011.622-.398c.624 0 1.247.265 1.622.797.374.399.623 1.064.623 1.728.125.532.125 1.064 0 1.728a6.969 6.969 0 01-1.122 3.057c-.25.399-.499.931-.874 1.33-.374.398-.748.797-1.122 1.063-.499.399-.998.664-1.373.797.25.399-.124.399-.374.399zm-2.121-2.791c0 .664.125 1.063.25 1.462.249.532.624.93 1.123 1.196.623.266 1.247.133 1.621 0 .499-.133.874-.399 1.373-.797.374-.266.748-.665 1.122-1.064.375-.398.624-.93.874-1.329.499-.93.873-1.994 1.122-3.057a4.028 4.028 0 000-1.728c-.124-.665-.249-1.196-.623-1.595-.375-.399-.998-.798-1.497-.665-.499 0-.998.133-1.497.399-.874.532-1.622 1.196-2.246 2.26-.624.93-.998 1.861-1.247 2.924v.133l.124.133h.125l1.871-1.196c.375-.266.624-.399.998-.665-.374.133-.623.399-.998.532l-1.621.797v-.133c.249-.797.748-1.462 1.122-2.126.25-.399.624-.798.998-1.064.375-.399.749-.664 1.123-.797.499-.266.873-.399 1.248-.399.374 0 .748.133 1.122.532.25.265.375.797.499 1.196v1.462c-.124.93-.499 1.861-.998 2.791-.249.399-.499.798-.873 1.197a3.939 3.939 0 01-.998 1.063c-.374.399-.873.532-1.247.665-.499.132-.874.132-1.248.132-.374-.132-.748-.398-.998-.93-.125-.399-.249-.93-.374-1.462h-.125c-.624.399-1.123.797-1.746 1.196a3.986 3.986 0 011.621-1.063zM230.042 103.175c-.249 0-.374 0-.624.133v.133c-2.994-.93-4.99-2.392-7.11-4.519-.125-.133-.25-.133-.375-.133-.998.399-2.245.665-3.368.93-.125-.132-.374-.132-.499-.265 0 .133 0 .133-.125.266v.132c2.246 2.659 5.115 4.786 8.483 5.982h.499c1.248-.665 1.872-1.595 2.994-2.26l.125-.133v-.266z"
            fill="#131A2D"
            />
            <path
            d="M229.918 103.043c-3.119-.93-5.365-2.393-7.485-4.652-.125-.133-.25-.133-.375-.133-1.247.399-2.495.797-3.867 1.063-.125 0-.125.133-.125.266 2.246 2.658 5.115 4.785 8.359 5.981h.499c1.247-.664 1.871-1.595 2.994-2.259.124-.133.124-.133 0-.266z"
            fill="#0EA59D"
            />
            <path
            d="M226.675 105.701h-.25c-3.243-1.196-6.112-3.323-8.358-5.981 0 0-.125-.133 0-.266 0-.133.125-.133.125-.133 1.247-.266 2.62-.664 3.867-1.063.125 0 .374 0 .374.133 2.371 2.525 4.616 3.854 7.485 4.652.125 0 .125.133.125.133s0 .133-.125.133c-.499.266-.873.664-1.247.93-.499.399-.998.931-1.747 1.329 0 .133-.124.133-.249.133zm-4.491-7.31c-.125 0 0 0 0 0-1.372.398-2.62.797-3.992 1.063h-.125v.133c2.246 2.658 5.115 4.785 8.358 5.981h.375c.748-.398 1.247-.93 1.746-1.329.374-.266.749-.664 1.248-.93-2.87-.798-5.115-2.26-7.485-4.785 0-.133 0-.133-.125-.133z"
            fill="#131A2D"
            />
            <path
            d="M228.67 103.176c.124-.133.124-.133 0-.266-2.495-.931-4.117-2.127-5.988-3.855-.125-.133-.25-.133-.375-.133-.124 0-.249 0-.374-.133s-.249-.133-.374-.133c-.749.266-1.497.532-2.37.665-.125 0-.125.133-.125.266.125.133 0 .266-.125.266s-.125.133-.125.265c1.872 1.994 4.117 3.722 6.737 4.786h.374c.125 0 .25-.133.374 0h.499c.749-.399 1.248-.931 1.622-1.463.125-.133.125-.133 0-.133h-.125c.25 0 .25-.132.375-.132z"
            fill="#fff"
            />
            <path
            d="M225.925 105.169h-.249c-2.495-1.063-4.866-2.791-6.737-4.785 0 0-.125-.133-.125-.266s.125-.133.125-.133h.125c.125 0 0 0 0-.133s-.125-.133-.125-.265c0-.133.125-.133.125-.133.748-.266 1.622-.4 2.37-.665.125 0 .374 0 .374.133.125.133.25.133.25.133.125 0 .374 0 .374.133 1.747 1.595 3.368 2.924 5.863 3.855.125 0 .125.132.125.132s0 .133-.125.133h.125s.125 0 .125.133 0 .133-.125.133c-.499.532-.873 1.064-1.622 1.462a.362.362 0 01-.499 0h-.499c.375.133.25.133.125.133zm-4.241-6.247c-.874.266-1.622.532-2.495.665h-.125v.132c0 .133.125.133.125.266s-.125.133-.125.133h-.125v.133c1.871 1.994 4.117 3.722 6.737 4.785h.374c.125 0 .374-.133.499 0h.499c.748-.398 1.247-.93 1.622-1.462h-.125c-.125 0-.125-.133-.125-.133s0-.133.125-.133c-2.62-.93-4.242-2.259-5.988-3.854-.125-.133-.25-.133-.25-.133-.124 0-.374 0-.374-.133 0-.266-.125-.266-.249-.266z"
            fill="#131A2D"
            />
            <path
            d="M222.433 101.448c-.249.399-.249.798 0 1.196.499.665 1.622.931 2.495.665.374-.133.624-.266.749-.532.249-.399.124-.797-.125-1.196-.499-.665-1.497-.931-2.246-.665-.374.133-.748.266-.873.532z"
            fill="#fff"
            />
            <path
            d="M224.803 103.176c.748-.266.998-.93.499-1.462-.499-.532-1.372-.797-2.121-.665-.748.133-1.123.798-.624 1.463.499.664 1.497.93 2.246.664z"
            fill="#0EA59D"
            />
            <path
            d="M224.18 103.309c-.624 0-1.372-.266-1.622-.797-.249-.266-.249-.532-.124-.798.124-.266.374-.532.873-.665.748-.132 1.621.133 2.12.665.25.266.25.532.25.798a1.306 1.306 0 01-.748.664c-.25.133-.5.133-.749.133zm-.499-2.127h-.499c-.374.133-.624.266-.748.665-.125.266 0 .532.124.798.375.531 1.373.797 2.121.531.374-.133.624-.399.624-.664 0-.266 0-.532-.25-.665-.124-.532-.748-.665-1.372-.665z"
            fill="#131A2D"
            />
            <path
            d="M221.435 100.119c-.25.133-.375.266-.125.532.249.133.624.266.873.133.25-.133.25-.266.125-.532-.25-.133-.624-.133-.873-.133z"
            fill="#0EA59D"
            />
            <path
            d="M221.934 100.916a.925.925 0 01-.624-.266c-.124-.133-.124-.266-.124-.398 0-.133.124-.266.249-.266.25-.133.624 0 .873.133.125.133.125.265.125.398s-.125.266-.249.266c-.125.133-.25.133-.25.133zm-.499-.664c-.125 0-.125.132-.249.132 0 .133 0 .133.124.266.125.133.499.266.749.133.125 0 .125-.133.249-.133 0 0 0-.133-.124-.266-.125-.132-.499-.265-.749-.132z"
            fill="#131A2D"
            />
            <path
            d="M226.175 103.441c-.249.133-.249.399 0 .399.25.133.624.133.874 0 .249-.133.249-.399 0-.399a1.014 1.014 0 00-.874 0z"
            fill="#0EA59D"
            />
            <path
            d="M226.55 104.106c-.125 0-.25 0-.375-.133-.249-.133-.249-.266-.249-.266 0-.133.125-.266.249-.266.25-.132.624-.132.998 0 .125 0 .25.133.25.266s-.125.266-.25.266c-.249 0-.499.133-.623.133zm.124-.665c-.124 0-.374 0-.499.133-.124 0-.124.133-.124.133s0 .133.124.133c.25.133.624.133.874 0 .124 0 .124-.133.124-.133s0-.133-.124-.133c-.125-.133-.25-.133-.375-.133zM256.862 115.803c-.125.133-.374.266-.499.266v-.133c-1.996 2.658-2.994 5.317-3.618 8.507 0 .133-.124.266-.249.266-1.123.398-2.246.797-3.493 1.329-.125.133-.25.399-.25.531-.124 0-.124-.132-.249-.132v-.133c.374-3.722 1.746-7.444 3.867-10.634.125-.133.25-.266.374-.266 1.497-.266 2.495.133 3.868 0h.124c.125.266.125.266.125.399z"
            fill="#131A2D"
            />
            <path
            d="M256.862 115.936c-2.12 2.791-3.243 5.582-3.742 8.905 0 .133-.125.266-.25.266a30.897 30.897 0 00-3.992 1.595c-.124 0-.249 0-.249-.133.374-3.722 1.622-7.443 3.742-10.633.125-.133.25-.266.375-.266 1.497-.266 2.495.133 3.867 0 .249 0 .374.133.249.266z"
            fill="#0EA59D"
            />
            <path
            d="M248.878 126.703c-.125 0-.125 0 0 0-.125-.133-.25-.133-.125-.266.374-3.722 1.746-7.444 3.742-10.634.125-.133.25-.266.499-.266.874-.133 1.622-.133 2.246 0 .499 0 .998.133 1.622 0 .124 0 .124 0 .124.133v.266c-1.996 2.525-3.118 5.184-3.742 8.906 0 .133-.125.265-.25.398-1.497.399-2.744.931-4.116 1.463zm5.114-11.033c-.374 0-.748 0-1.122.133-.125 0-.25.133-.375.266a23.061 23.061 0 00-3.742 10.501v.133h.125c1.247-.665 2.619-1.064 3.992-1.596.124 0 .249-.132.249-.265.624-3.722 1.747-6.381 3.743-8.906h-1.747c-.374-.266-.748-.266-1.123-.266z"
            fill="#131A2D"
            />
            <path
            d="M255.739 116.601c.124 0 .249.133.124.133-1.621 2.392-2.37 4.519-2.869 7.177 0 .133-.125.266-.249.266-.125 0-.25.133-.25.266s-.125.266-.249.266c-.749.266-1.622.531-2.371.93-.124 0-.249 0-.249-.133s-.125-.266-.25-.133c-.124 0-.249 0-.249-.133.499-2.924 1.497-5.848 2.994-8.506.125-.133.249-.266.374-.266s.25-.133.374-.266l.125-.133c.125-.133.25-.266.374-.266.874-.133 1.622 0 2.246.133.125 0 .125.133.125.133l-.125.133c0 .399 0 .399.125.399z"
            fill="#fff"
            />
            <path
            d="M249.627 125.905c-.125-.133-.125-.133-.125-.266v-.133h-.374s-.125-.133 0-.266a25.442 25.442 0 012.994-8.506c.124-.133.249-.266.374-.266s.249-.133.374-.266l.125-.133c.125-.133.249-.266.374-.266.873-.133 1.622 0 2.246.133.124 0 .124 0 .124.133v.133l-.124.133v.133c.124 0 .124 0 .124.133v.265c-1.621 2.393-2.37 4.653-2.869 7.178 0 .133-.125.266-.249.399-.125 0-.25.133-.25.266s-.125.266-.249.399c-.749.132-1.497.398-2.495.797.124 0 .124 0 0 0zm-.125-.532c.125.133.125.133.125.266v.133h.124c.749-.399 1.622-.664 2.371-.93.124 0 .249-.133.249-.266s.125-.266.25-.399c.124 0 .249-.133.249-.266.499-2.525 1.248-4.785 2.869-7.177v-.133c-.124 0-.124 0-.124-.133v-.266l.124-.133h-.124c-.624-.133-1.373-.266-2.246-.133-.125 0-.249.133-.374.266l-.125.133c-.125.133-.249.266-.374.266s-.25.133-.374.265c-1.497 2.659-2.62 5.45-2.994 8.507v.133h.124l.25-.133c-.125 0-.125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M251.373 122.183c-.499-.133-.748-.531-.748-1.063 0-.93.873-1.861 1.746-2.127.375-.133.624-.133.874 0 .374.133.623.532.499 1.064-.125.797-.749 1.728-1.497 2.126-.25 0-.499.133-.874 0z"
            fill="#fff"
            />
            <path
            d="M252.497 119.125c.748-.266 1.372.133 1.247.93-.124.798-.623 1.595-1.372 1.861-.748.266-1.372 0-1.372-.797-.125-.798.624-1.728 1.497-1.994z"
            fill="#0EA59D"
            />
            <path
            d="M251.748 122.05c-.249 0-.374 0-.499-.133-.249-.133-.374-.532-.374-.798 0-.797.749-1.728 1.622-1.994.374-.133.748-.133.998.133.249.133.374.532.249.798-.124.797-.748 1.595-1.497 1.994h-.499zm1.123-2.925c-.125 0-.25 0-.499.133-.749.266-1.497 1.197-1.497 1.861 0 .266.125.532.249.665.25.133.624.133.998 0 .749-.266 1.248-1.064 1.373-1.861 0-.266 0-.532-.25-.798h-.374z"
            fill="#131A2D"
            />
            <path
            d="M251.249 123.91c-.249.133-.499 0-.374-.399.125-.265.374-.664.624-.664.249-.133.499.133.374.399a1.559 1.559 0 01-.624.664z"
            fill="#0EA59D"
            />
            <path
            d="M251.124 124.044c-.124 0-.124 0-.249-.133s-.125-.266-.125-.399c.125-.265.374-.664.624-.797h.374c.125.133.125.266.125.399-.125.265-.374.664-.624.664 0 .266-.125.266-.125.266zm.499-1.196h-.124c-.25.133-.499.399-.624.664v.266h.249c.25-.133.499-.399.624-.664v-.266c0 .133 0 0-.125 0z"
            fill="#131A2D"
            />
            <path
            d="M253.369 118.062c-.25 0-.374-.133-.25-.398.125-.266.499-.532.749-.532.249 0 .374.133.249.399-.125.133-.374.398-.748.531z"
            fill="#0EA59D"
            />
            <path
            d="M253.244 118.062c-.124 0-.249 0-.249-.133 0 0-.125-.132 0-.398s.499-.532.873-.532c.125 0 .25 0 .374.133v.399c-.124.266-.499.531-.998.531.125 0 .125 0 0 0zm.749-.93c-.374 0-.749.266-.873.532 0 .133-.125.133 0 .265 0 0 .124.133.249 0 .25 0 .624-.265.749-.531 0-.133.124-.133 0-.266h-.125zM239.397 141.59c-.125-.266-.125-.532-.249-.797h.124c-2.495-3.324-5.239-5.184-8.732-6.647-.125 0-.25-.265-.25-.398-.124-1.595-.374-3.19-.623-4.785-.25-.133-.375-.399-.624-.532l.249-.266h.125c4.117 1.462 7.984 4.121 11.103 7.577.125.132.249.398.249.664-.124 1.994-.748 3.323-.998 5.051 0 .133 0 .133-.124.133h-.25z"
            fill="#131A2D"
            />
            <path
            d="M239.272 141.457c-2.62-3.456-5.489-5.45-9.231-7.045-.125 0-.25-.266-.25-.399-.125-1.728-.374-3.588-.873-5.449 0-.133.125-.266.249-.266a27.333 27.333 0 0111.103 7.443c.125.133.25.399.25.665-.125 1.994-.749 3.19-.998 5.051 0 .133-.125.133-.25 0z"
            fill="#0EA59D"
            />
            <path
            d="M239.397 141.59s-.125 0-.125-.133c-2.495-3.19-5.239-5.317-9.231-7.045-.125-.133-.25-.266-.375-.532-.124-1.861-.499-3.589-.748-5.45 0-.133 0-.265.125-.265 0 0 .124-.133.249 0 4.242 1.462 8.109 3.987 11.103 7.443.125.133.249.399.249.665-.124 1.196-.249 2.126-.499 2.924-.124.665-.374 1.329-.499 1.994-.124.399-.124.399-.249.399zm-10.23-13.16c-.124 0-.124 0 0 0-.124 0-.124.133-.124.133.374 1.861.623 3.589.873 5.45 0 .133.125.266.249.399 3.992 1.728 6.737 3.722 9.232 7.045h.125v-.133c.124-.798.249-1.462.499-1.994.249-.931.499-1.861.499-2.924 0-.133-.125-.399-.125-.532-3.244-3.456-6.986-5.981-11.228-7.444z"
            fill="#131A2D"
            />
            <path
            d="M238.773 139.861c0 .266-.125.266-.249.133-2.246-2.658-4.491-4.12-7.485-5.45-.125-.133-.25-.265-.25-.398s-.125-.399-.249-.399c-.125 0-.25-.266-.25-.399-.125-1.063-.249-2.26-.499-3.323 0-.133.125-.266.25-.266.124 0 .249 0 .249-.266 0-.133.125-.265.25-.265 3.243 1.329 6.237 3.323 8.857 5.981.125.133.249.399.249.532s.125.398.25.531l.125.133c.124.133.249.399.249.532-.125 1.196-.499 2.127-.748 2.791-.125.133-.125.133-.25 0 0 0 0-.133-.125-.133-.374.133-.374.133-.374.266z"
            fill="#fff"
            />
            <path
            d="M238.648 140.127s-.125 0-.125-.133c-2.37-2.791-4.616-4.253-7.485-5.45a1.822 1.822 0 01-.374-.531c0-.133-.125-.266-.25-.399-.124-.133-.374-.266-.374-.399-.125-1.063-.249-2.259-.499-3.323 0-.133 0-.133.125-.266h.374v-.133c0-.133 0-.133.125-.265h.249c3.369 1.329 6.363 3.323 8.858 5.981.124.133.249.399.249.665 0 .132.125.398.25.531l.124.133c.125.133.25.399.25.665-.125 1.196-.374 1.994-.749 2.791 0 .133-.124.133-.124.133-.125 0-.125 0-.125-.133 0 0 0-.133-.125-.133h-.125v.133c-.124.133-.249.133-.249.133zm-8.857-10.368c-.125 0-.125.133-.125.133.249 1.064.374 2.26.499 3.323 0 .133.125.266.249.399.125.133.375.266.375.532 0 .133.124.265.249.398 2.745 1.33 5.115 2.792 7.485 5.583h.125v-.133c0-.133.125-.133.125-.133s.124 0 .249.133c0 0 0 .133.125.133h.125v-.133c.374-.797.623-1.728.748-2.791 0-.133-.125-.399-.125-.532l-.124-.133a1.05 1.05 0 01-.25-.664c0-.133-.125-.399-.249-.532-2.62-2.659-5.614-4.652-8.858-5.982h-.124v.133c0 .133 0 .133-.125.266h-.374c.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M233.408 132.95c.249-.531.748-.797 1.372-.664.998.266 1.996 1.462 2.121 2.791 0 .532 0 .931-.25 1.196-.249.532-.748.665-1.372.399-.998-.266-1.746-1.329-1.996-2.525 0-.532 0-.931.125-1.197z"
            fill="#fff"
            />
            <path
            d="M236.651 134.943c.125 1.063-.499 1.728-1.372 1.462-.873-.266-1.622-1.196-1.746-2.259-.125-1.064.374-1.861 1.247-1.595.998.132 1.747 1.329 1.871 2.392z"
            fill="#0EA59D"
            />
            <path
            d="M235.779 136.538c-.125 0-.25 0-.375-.133-.873-.266-1.621-1.329-1.871-2.392-.125-.532 0-1.064.374-1.463.25-.265.624-.398.998-.265.874.265 1.747 1.329 1.872 2.525 0 .532-.125 1.063-.375 1.329-.249.266-.374.399-.623.399zm-1.248-3.988a.925.925 0 00-.624.266c-.249.266-.374.798-.249 1.329.125 1.064.873 1.994 1.746 2.26.375.133.624.133.874-.133.249-.266.374-.664.374-1.196-.125-1.063-.998-2.26-1.747-2.393-.249-.133-.249-.133-.374-.133z"
            fill="#131A2D"
            />
            <path
            d="M231.537 132.286c0-.399.125-.532.499-.399s.624.664.624.93c0 .399-.25.532-.499.399-.374-.133-.624-.532-.624-.93z"
            fill="#0EA59D"
            />
            <path
            d="M232.41 133.349h-.249c-.374-.133-.624-.665-.624-1.063 0-.266 0-.399.125-.532s.249-.133.374 0c.374.133.624.665.624 1.063 0 .266 0 .399-.125.532h-.125zm-.873-1.063c0 .398.25.797.624.93.125 0 .249.133.249 0 .125 0 .125-.133.125-.399 0-.398-.249-.797-.624-.93h-.249c0 .133-.125.266-.125.399z"
            fill="#131A2D"
            />
            <path
            d="M237.65 136.539c0-.399.25-.532.499-.266.25.266.499.798.499 1.197 0 .398-.249.531-.499.265-.249-.265-.499-.797-.499-1.196z"
            fill="#0EA59D"
            />
            <path
            d="M238.399 137.868c-.125 0-.25 0-.25-.133-.249-.266-.499-.798-.499-1.196 0-.266.125-.399.25-.399s.249 0 .374.133c.25.266.499.797.499 1.196-.125.133-.125.399-.374.399.125 0 0 0 0 0zm-.624-1.329c0 .398.125.797.374 1.063.125.133.25.133.25.133.125 0 .125-.133.125-.266 0-.399-.125-.93-.375-1.063-.124-.133-.249-.133-.249-.133-.125 0-.125.133-.125.266zM199.479 101.58c.124 0 .249-.133.499-.133v.133c1.871-1.728 2.994-3.722 3.867-6.114 0-.133.125-.133.249-.266.874-.133 1.872-.266 2.87-.532l.374-.399.125.133v.133c-.749 2.791-2.246 5.583-4.367 7.71-.124.132-.249.132-.374.132-1.247 0-1.996-.398-2.994-.531h-.125c-.124-.133-.124-.133-.124-.266z"
            fill="#131A2D"
            />
            <path
            d="M199.603 101.58c1.996-1.86 3.244-3.855 3.992-6.38 0-.133.125-.133.25-.266.998-.133 2.121-.399 3.243-.665.125 0 .125 0 .125.133-.748 2.792-2.245 5.45-4.241 7.71-.125.133-.25.133-.375.133-1.122 0-1.996-.399-2.994-.532-.124 0-.124-.133 0-.133z"
            fill="#0EA59D"
            />
            <path
            d="M202.597 102.378c-.748 0-1.247-.133-1.871-.266-.374-.133-.749-.266-1.248-.266-.124 0-.124-.133-.124-.133s0-.133.124-.133c1.872-1.728 3.119-3.589 3.992-6.38 0-.133.125-.266.25-.266 1.123-.133 2.121-.399 3.243-.665h.25v.133a16.797 16.797 0 01-4.366 7.71c.124.133-.125.266-.25.266zm-2.994-.798c.499.133.873.133 1.248.266.499.133 1.122.266 1.746.266.125 0 .25 0 .25-.133a17.739 17.739 0 004.241-7.71h-.125c-1.122.266-2.12.532-3.243.665-.125 0-.125.133-.25.133-.748 2.924-1.996 4.785-3.867 6.513z"
            fill="#131A2D"
            />
            <path
            d="M200.476 101.181c-.125 0-.125-.133-.125-.133 1.497-1.595 2.37-3.19 3.119-5.184 0-.133.125-.133.249-.133.125 0 .25-.133.25-.266s.125-.133.249-.266c.624-.132 1.373-.265 1.996-.398.125 0 .125 0 .125.133s0 .133.125.133.125 0 .125.133c-.749 2.26-1.872 4.386-3.493 6.114-.125.133-.25.133-.375.133-.124 0-.249 0-.374.133v.133c-.125.133-.249.133-.374.133-.749 0-1.248-.266-1.747-.399-.124 0-.124-.133 0-.133h.125c.25-.133.25-.133.125-.133z"
            fill="#fff"
            />
            <path
            d="M202.223 101.979c-.749 0-1.248-.266-1.747-.399 0 0-.124 0-.124-.133 0 0 0-.133.124-.133h.125c-.125 0-.125 0-.125-.133v-.133c1.622-1.595 2.495-3.19 3.119-5.184 0-.133.125-.266.25-.266.124 0 .124-.133.249-.133 0-.133.125-.266.25-.266.623-.132 1.372-.265 1.996-.398h.124v.133h.125v.133c-.748 2.26-1.871 4.386-3.493 6.247-.125.133-.249.133-.374.133s-.25 0-.25.133l-.124.133c.249.266 0 .266-.125.266zm-1.747-.532c.499.266 1.123.399 1.747.532.125 0 .249-.001.249-.133v-.133c.125-.133.25-.133.375-.133.124 0 .249 0 .249-.133 1.497-1.861 2.745-3.855 3.493-6.115h-.125V95.2c-.623.132-1.372.265-1.996.398-.124 0-.124.133-.249.133 0 .133-.125.266-.25.266-.124 0-.124.133-.249.133-.749 1.86-1.622 3.589-3.244 5.184.125 0 .125 0 .125.133.125-.266.125-.133-.125 0z"
            fill="#131A2D"
            />
            <path
            d="M204.593 97.46c.375.132.499.53.375.93-.125.664-.874 1.329-1.622 1.462-.25 0-.499 0-.749-.133-.249-.133-.374-.532-.249-.93.125-.665.748-1.197 1.497-1.463.249 0 .624 0 .748.133z"
            fill="#fff"
            />
            <path
            d="M203.471 99.586c-.623.133-.998-.266-.873-.93.125-.532.749-1.197 1.372-1.33.624-.132 1.123.266.998.798-.249.798-.873 1.462-1.497 1.462z"
            fill="#0EA59D"
            />
            <path
            d="M203.221 99.719a.926.926 0 01-.624-.266c-.124-.133-.124-.399-.124-.664.124-.665.748-1.197 1.372-1.33.374-.133.624 0 .873.266.125.133.25.399.125.665-.125.664-.749 1.196-1.497 1.329h-.125zm.998-2.127h-.249c-.624.133-1.123.665-1.248 1.197 0 .265 0 .398.125.531s.374.266.748.133c.624-.133 1.248-.664 1.373-1.196 0-.266 0-.399-.125-.532-.25-.133-.499-.133-.624-.133z"
            fill="#131A2D"
            />
            <path
            d="M204.968 96.13c.249 0 .374.133.249.266a.681.681 0 01-.624.399c-.249 0-.374-.133-.249-.266a.681.681 0 01.624-.399z"
            fill="#0EA59D"
            />
            <path
            d="M204.593 96.927c-.125 0-.249 0-.249-.132v-.266c.124-.266.374-.399.623-.532.125 0 .25 0 .375.133v.266c-.125.266-.499.531-.749.531zm.374-.797c-.249 0-.498.266-.498.399v.133h.249c.25 0 .499-.266.499-.4v-.132h-.25z"
            fill="#131A2D"
            />
            <path
            d="M202.473 100.384c.25 0 .25.133.125.399-.125.132-.499.265-.749.265-.249 0-.249-.133-.124-.398.249-.133.623-.266.748-.266z"
            fill="#0EA59D"
            />
            <path
            d="M201.974 101.049c-.249 0-.249-.133-.249-.133s0-.133.124-.266c.125-.133.499-.399.749-.399.125 0 .249 0 .249.133 0 0 0 .133-.124.266-.125.266-.499.399-.749.399zm.499-.665a.925.925 0 00-.624.266s-.124.133 0 .133c0 0 .125 0 .125.133.25 0 .499-.133.624-.266 0 0 .125-.133 0-.133.125 0 0-.133-.125-.133zM244.136 99.986c.125-.133.125-.266.25-.4h.124c.375-2.658.125-4.917-.623-7.31 0-.133 0-.266.124-.399a18.756 18.756 0 001.872-2.392v-.532h.249s.125 0 .125.133c1.123 2.791 1.497 5.849 1.247 8.906 0 .133-.124.266-.249.398-.998.798-1.747.93-2.745 1.596h-.124c-.25.132-.25 0-.25 0z"
            fill="#131A2D"
            />
            <path
            d="M244.137 99.853c.499-2.792.125-5.184-.748-7.71 0-.133 0-.266.124-.266.749-.797 1.373-1.727 2.121-2.658.125-.133.125-.133.25 0a17.611 17.611 0 011.247 8.906c0 .133-.125.266-.249.398-.998.798-1.747.931-2.62 1.596-.125-.133-.25-.133-.125-.266z"
            fill="#0EA59D"
            />
            <path
            d="M244.137 100.119c-.125 0-.125-.133-.125-.133.374-2.659.25-4.918-.748-7.71 0-.133 0-.266.124-.398a21.38 21.38 0 002.121-2.659c0-.133.125-.133.125-.133s.125 0 .125.133a19.655 19.655 0 011.372 8.906c0 .133-.125.266-.25.399-.499.398-1.122.664-1.621.93-.25.133-.624.266-1.123.665.125 0 0 0 0 0zm1.497-10.9l-2.246 2.791s-.124.133 0 .266c.998 2.792 1.123 5.051.749 7.71.374-.266.748-.4 1.123-.665.499-.266.998-.532 1.497-.93.124-.133.124-.266.124-.266.375-3.19 0-6.115-1.247-8.906.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M244.51 98.921c-.125.133-.125 0-.125-.133.25-2.26 0-4.12-.623-6.114 0-.133 0-.266.124-.266.125-.133.125-.266.125-.266v-.266c.499-.531.873-1.063 1.372-1.595.125-.133.125-.133.25 0 0 .133.125.133.249 0 .125-.133.125-.133.25 0 .748 2.26 1.123 4.653.998 7.045 0 .133-.125.266-.125.399-.125.133-.125.266-.125.399v.133c0 .132-.124.265-.124.398-.624.4-1.123.665-1.622.798-.125 0-.125 0-.125-.133-.374-.266-.374-.266-.499-.399.25 0 .125 0 0 0z"
            fill="#fff"
            />
            <path
            d="M244.76 99.32c-.125 0 0 0 0 0l-.125-.133v-.133h-.125s-.124 0 0-.133c.25-2.392-.124-4.12-.623-6.114 0-.133 0-.266.124-.399 0 0 .125-.133 0-.266 0-.133 0-.266.125-.398.499-.532.873-1.064 1.372-1.596l.125-.132s.125 0 .125.132l.125-.132s.124 0 .124.132a19.567 19.567 0 01.998 7.178c0 .133-.124.266-.124.399-.125 0-.125.133-.125.266v.133c0 .133-.125.266-.25.398-.623.4-1.122.532-1.746.798zm-.125-.532c.125 0 .125.133.125.133v.133c.499-.133.998-.398 1.622-.797.124 0 .124-.133.124-.266v-.133c0-.133.125-.266.125-.399.125 0 .125-.133.125-.266.125-2.392-.25-4.785-.998-7.044l-.125.132s-.125 0-.125-.133c-.374.532-.873 1.064-1.372 1.596 0 0-.125.132 0 .265 0 .133 0 .266-.125.4 0 0-.124.132 0 .265.624 1.994.874 3.722.624 6.114 0 0-.125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M245.509 93.34c.374-.133.748 0 .873.399.374.664.125 1.595-.374 2.26-.25.265-.374.398-.624.398-.374 0-.624-.133-.748-.532-.25-.664-.125-1.462.249-2.126a.681.681 0 01.624-.4z"
            fill="#fff"
            />
            <path
            d="M245.883 95.864c-.499.532-.998.399-1.247-.133-.25-.531-.125-1.329.249-1.86.374-.532.998-.532 1.248 0 .374.531.249 1.462-.25 1.993z"
            fill="#0EA59D"
            />
            <path
            d="M245.259 96.263c-.374 0-.499-.266-.623-.532-.25-.531-.125-1.462.249-1.993.25-.266.499-.4.749-.4.249 0 .374.134.499.4.249.531.124 1.462-.375 2.126 0 .266-.249.4-.499.4zm.375-2.791a.681.681 0 00-.624.399c-.374.531-.499 1.329-.25 1.86.125.266.25.4.375.4a.68.68 0 00.623-.4c.499-.531.624-1.462.375-1.86 0-.266-.25-.4-.499-.4.124 0 .124 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M245.012 92.01c.125-.133.375-.133.375.133s0 .532-.125.798c-.125.132-.374.132-.374-.133-.125-.266 0-.665.124-.798z"
            fill="#0EA59D"
            />
            <path
            d="M245.011 93.074c-.125 0-.249-.133-.249-.266 0-.266 0-.531.249-.797.125-.133.25-.133.25-.133.124 0 .124.133.249.266.125.266 0 .664-.249.797-.125 0-.125.133-.25.133zm0-1.063c-.125.133-.249.399-.125.665 0 .132 0 .132.125.132 0 0 .125 0 .125-.133.125-.132.249-.531.125-.664 0-.133 0-.133-.125-.133 0 .133 0 .133-.125.133z"
            fill="#131A2D"
            />
            <path
            d="M245.634 96.927c.125-.133.374-.133.374.133s-.124.532-.374.665c-.125.133-.374.133-.374-.133s.249-.399.374-.665z"
            fill="#0EA59D"
            />
            <path
            d="M245.509 97.991c-.124 0-.124 0 0 0-.124 0-.249-.133-.249-.266 0-.265.125-.531.374-.797.125-.133.25-.133.25-.133s.124.133.124.266c0 .266-.124.664-.374.797 0 .133-.125.133-.125.133zm.375-1.063s-.125 0-.125.133c-.125.133-.25.398-.374.664v.133h.124c.125-.133.375-.398.375-.664v-.266z"
            fill="#131A2D"
            />
            <path
            d="M320.984 391.348l20.085 12.228 22.705-11.697-24.077-14.754-18.713 14.223z"
            fill="url(#paint228_linear_874_76773)"
            opacity={0.3}
            />
            <g clipPath="url(#clip1_874_76773)">
            <path
                style={{ mixBlendMode: "multiply" }}
                d="M290.931 381.201l7.441 4.539a.914.914 0 00.994 0l60.663-37.651-8.613-5.159-60.471 36.448a1.023 1.023 0 00-.365.382 1.11 1.11 0 00-.008 1.053c.086.161.21.295.359.388z"
                fill="url(#paint229_linear_874_76773)"
            />
            <path
                d="M332.459 359.225a13.618 13.618 0 00-2.571.234h-4.615v1.884c.121 1.619 3.032 3.382 7.186 3.382 4.153 0 7.1-1.763 7.185-3.382v-1.884h-4.636a13.56 13.56 0 00-2.549-.234z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 362.788c.135.121.291.249.454.37v-3.699h-.454v3.329zM334.617 359.391v5.167l.455-.084v-5.015h-.064l-.391-.068zM333.838 364.657l.461-.046v-5.295l-.461-.053v5.394zM337.713 363.567l.454-.273v-3.835h-.454v4.108zM333.062 364.717h.455v-5.454h-.455v5.454zM338.488 363.068c.16-.12.312-.251.455-.394v-3.215h-.455v3.609zM336.166 364.202l.454-.151v-4.592h-.454v4.743zM335.393 364.407c.149 0 .305-.069.454-.114v-4.834h-.454v4.948zM336.939 363.93l.455-.204v-4.267h-.455v4.471zM328.412 364.089l.462.151v-4.781h-.462v4.63zM331.516 364.694h.454v-5.462h-.454v5.462zM332.289 359.225v5.5h.454v-5.493h-.454v-.007zM325.273 361.342c.049.416.223.804.497 1.105v-3.026h-.497v1.921zM339.268 362.303c.21-.274.34-.608.376-.96v-1.884h-.376v2.844zM326.865 363.37l.455.257v-4.168h-.455v3.911zM330.748 364.618l.454.053v-5.394l-.454.053v5.288zM327.639 363.779c.149.068.298.136.461.197v-4.539h-.461v4.342zM329.193 364.323c.149.046.299.076.455.114v-4.978h-.455v4.864zM329.967 364.498l.454.083v-5.205l-.454.076v5.046z"
                fill="#3A3A3A"
            />
            <path
                d="M332.46 362.72c3.929 0 7.114-1.524 7.114-3.405 0-1.88-3.185-3.404-7.114-3.404s-7.114 1.524-7.114 3.404c0 1.881 3.185 3.405 7.114 3.405z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 355.987c4.032 0 7.043 1.763 7.043 3.329 0 1.566-3.011 3.328-7.043 3.328-4.033 0-7.044-1.755-7.044-3.328 0-1.574 3.011-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.838-7.186 3.48 0 1.641 2.954 3.48 7.186 3.48 4.231 0 7.192-1.831 7.192-3.48s-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 355.903c-.862-.001-1.722.08-2.571.242h-4.615v1.884c.121 1.619 3.032 3.382 7.186 3.382 4.153 0 7.1-1.763 7.185-3.382v-1.884h-4.636a13.569 13.569 0 00-2.549-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 359.467c.144.133.296.256.454.37v-3.691h-.454v3.321zM334.617 356.047v5.167l.455-.083v-4.986h-.064c-.114-.03-.256-.045-.391-.098zM333.838 361.343l.461-.053v-5.243l-.461-.053v5.349zM337.713 360.246c.163-.083.312-.174.454-.265v-3.835h-.454v4.1zM333.062 361.396h.455v-5.447h-.455v5.447zM338.488 359.754a4.23 4.23 0 00.455-.393v-3.215h-.455v3.608zM336.166 360.889l.454-.159v-4.584h-.454v4.743zM335.393 361.093l.454-.113v-4.834h-.454v4.947zM336.939 360.586l.455-.197v-4.243h-.455v4.44zM328.412 360.775l.462.144v-4.773h-.462v4.629zM331.516 361.381h.454v-5.462h-.454v5.462zM332.289 355.911v5.5h.454v-5.5h-.454zM325.273 358.029c.052.415.226.802.497 1.105v-2.988h-.497v1.883zM339.268 358.982c.212-.271.345-.602.383-.953v-1.883h-.383v2.836zM326.865 360.049c.142.091.298.174.455.257v-4.16h-.455v3.903zM330.748 361.343c.149 0 .298 0 .454.045v-5.424l-.454.083v5.296zM327.639 360.465l.461.189v-4.539h-.461v4.35zM329.193 361.01l.455.106v-4.97h-.455v4.864zM329.967 361.184l.454.075v-5.212l-.454.076v5.061z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 359.406c-4.196 0-7.1-1.793-7.1-3.404 0-1.612 2.918-3.405 7.1-3.405 4.182 0 7.1 1.793 7.1 3.405 0 1.611-2.904 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 352.673c4.032 0 7.043 1.755 7.043 3.328 0 1.574-3.011 3.329-7.043 3.329-4.033 0-7.044-1.763-7.044-3.329 0-1.566 3.011-3.328 7.044-3.328zm0-.152c-4.26 0-7.186 1.831-7.186 3.48 0 1.65 2.954 3.48 7.186 3.48 4.231 0 7.192-1.838 7.192-3.48 0-1.641-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 352.59a12.989 12.989 0 00-2.571.242h-4.615v1.876c.121 1.619 3.032 3.382 7.186 3.382 4.153 0 7.1-1.763 7.185-3.382v-1.876h-4.636a12.927 12.927 0 00-2.549-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 356.153c.135.121.291.25.454.371v-3.692h-.454v3.321zM334.617 352.756v5.167l.455-.083v-5.008h-.064l-.391-.076zM333.838 358.022l.461-.053v-5.258l-.461-.053v5.364zM337.713 356.932l.454-.272v-3.828h-.454v4.1zM333.062 358.082h.455v-5.454h-.455v5.454zM338.488 356.433a4.23 4.23 0 00.455-.393v-3.208h-.455v3.601zM336.166 357.56l.454-.151v-4.577h-.454v4.728zM335.393 357.772c.149 0 .305-.068.454-.113v-4.827h-.454v4.94zM336.939 357.296l.455-.205v-4.259h-.455v4.464zM328.412 357.454l.462.152v-4.774h-.462v4.622zM331.516 358.06h.454v-5.462h-.454v5.462zM332.289 352.59v5.5h.454v-5.5h-.454zM325.273 354.708c.05.416.224.803.497 1.105v-2.981h-.497v1.876zM339.268 355.669c.212-.274.345-.608.383-.961v-1.876h-.383v2.837zM326.865 356.736l.455.257v-4.161h-.455v3.904zM330.748 357.984l.454.053v-5.393l-.454.053v5.287zM327.639 357.144c.149.068.298.137.461.197v-4.539h-.461v4.342zM329.193 357.689l.455.113v-4.97h-.455v4.857zM329.967 357.862l.454.084v-5.213l-.454.084v5.045z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 356.085c-4.196 0-7.1-1.793-7.1-3.404 0-1.612 2.918-3.405 7.1-3.405 4.182 0 7.1 1.793 7.1 3.405 0 1.611-2.904 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 349.352c4.032 0 7.043 1.763 7.043 3.329 0 1.566-3.011 3.367-7.043 3.367-4.033 0-7.044-1.756-7.044-3.329 0-1.574 3.011-3.329 7.044-3.329v-.038zm0-.151c-4.26 0-7.186 1.838-7.186 3.48s2.954 3.48 7.186 3.48c4.231 0 7.192-1.831 7.192-3.48s-2.954-3.442-7.192-3.442v-.038z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 349.238c-.862-.001-1.722.08-2.571.242h-4.615v1.884c.121 1.619 3.032 3.382 7.186 3.382 4.153 0 7.1-1.763 7.185-3.382v-1.853h-4.636a13.506 13.506 0 00-2.549-.273z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 352.832a4.7 4.7 0 00.454.37v-3.691h-.454v3.321zM334.617 349.443v5.167l.455-.083v-5.016h-.064a3.995 3.995 0 00-.391-.068zM333.838 354.708l.461-.053v-5.295l-.461-.053v5.401zM337.713 353.611c.163-.083.312-.174.454-.265v-3.835h-.454v4.1zM333.062 354.761h.455v-5.447h-.455v5.447zM338.488 353.119a4.23 4.23 0 00.455-.393v-3.215h-.455v3.608zM336.166 354.247c.156-.046.305-.091.454-.152v-4.584h-.454v4.736zM335.393 354.458l.454-.113v-4.834h-.454v4.947zM336.939 353.974l.455-.196v-4.267h-.455v4.463zM328.412 354.141l.462.143v-4.773h-.462v4.63zM331.516 354.746h.454v-5.462h-.454v5.462zM332.289 349.276v5.5h.454v-5.5h-.454zM325.273 351.395c.052.415.226.802.497 1.105v-3.026h-.497v1.921zM339.268 352.348c.212-.271.345-.603.383-.954v-1.883h-.383v2.837zM326.865 353.414c.142.091.298.174.455.258v-4.161h-.455v3.903zM330.748 354.67l.454.045v-5.386c-.156 0-.305 0-.454.045v5.296zM327.639 353.83l.461.189v-4.539h-.461v4.35zM329.193 354.375l.455.106v-4.97h-.455v4.864zM329.967 354.535l.454.076v-5.19l-.454.076v5.038z"
                fill="#3A3A3A"
            />
            <path
                d="M332.46 352.771c3.929 0 7.114-1.524 7.114-3.404s-3.185-3.404-7.114-3.404-7.114 1.524-7.114 3.404 3.185 3.404 7.114 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 346.039c4.032 0 7.043 1.755 7.043 3.329 0 1.573-3.011 3.328-7.043 3.328-4.033 0-7.044-1.762-7.044-3.328 0-1.566 3.011-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.83-7.186 3.48 0 1.649 2.954 3.48 7.186 3.48 4.231 0 7.192-1.839 7.192-3.48 0-1.642-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 345.955a13.619 13.619 0 00-2.571.235h-4.615v1.883c.121 1.619 3.032 3.382 7.186 3.382 4.153 0 7.1-1.763 7.185-3.382v-1.861h-4.636a13.57 13.57 0 00-2.549-.257z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 349.519c.135.121.291.249.454.37v-3.676h-.454v3.306zM334.617 346.122v5.167l.455-.083v-4.993h-.064l-.391-.091zM333.838 351.387l.461-.045v-5.296l-.461-.053v5.394zM337.713 350.298l.454-.272v-3.813h-.454v4.085zM333.062 351.448h.455v-5.455h-.455v5.455zM338.488 349.799c.16-.12.312-.251.455-.394v-3.192h-.455v3.586zM336.166 350.933l.454-.151v-4.569h-.454v4.72zM335.393 351.138c.149 0 .305-.068.454-.114v-4.811h-.454v4.925zM336.939 350.661l.455-.204v-4.244h-.455v4.448zM328.412 350.82l.462.151v-4.758h-.462v4.607zM331.516 351.425h.454v-5.462h-.454v5.462zM332.289 345.956v5.5h.454v-5.5h-.454zM325.273 348.074a2 2 0 00.497 1.104v-2.965h-.497v1.861zM339.268 349.027c.213-.27.347-.602.383-.953v-1.861h-.383v2.814zM326.865 350.101l.455.258v-4.146h-.455v3.888zM330.748 351.349l.454.053v-5.394l-.454.053v5.288zM327.639 350.51c.149.068.298.136.461.196v-4.493h-.461v4.297zM329.193 351.055l.455.113v-4.955h-.455v4.842zM329.967 351.229l.454.083V346.1l-.454.113v5.016z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 349.45c-4.196 0-7.1-1.793-7.1-3.404s2.918-3.404 7.1-3.404c4.182 0 7.1 1.793 7.1 3.404s-2.904 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 342.718c4.032 0 7.043 1.762 7.043 3.328 0 1.566-3.011 3.329-7.043 3.329-4.033 0-7.044-1.755-7.044-3.329 0-1.573 3.011-3.328 7.044-3.328zm0-.152c-4.26 0-7.186 1.839-7.186 3.48 0 1.642 2.954 3.48 7.186 3.48 4.231 0 7.192-1.8 7.192-3.48 0-1.679-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 342.43a12.989 12.989 0 00-2.571.242h-4.615v1.876c.121 1.619 3.032 3.382 7.186 3.382 4.153 0 7.1-1.763 7.185-3.382v-1.861h-4.636a12.935 12.935 0 00-2.549-.257z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 346.009c.135.121.291.249.454.37v-3.691h-.454v3.321zM334.617 342.612v5.167l.455-.083v-5.008h-.064l-.391-.076zM333.838 347.877l.461-.045v-5.296l-.461-.053v5.394zM337.713 346.788l.454-.273v-3.827h-.454v4.1zM333.062 347.938h.455v-5.455h-.455v5.455zM338.488 346.288c.16-.119.312-.25.455-.393v-3.207h-.455v3.6zM336.166 347.423l.454-.151v-4.585h-.454v4.736zM335.393 347.627c.149 0 .305-.068.454-.113v-4.826h-.454v4.939zM336.939 347.151l.455-.205v-4.259h-.455v4.464zM328.412 347.31l.462.151v-4.773h-.462v4.622zM331.516 347.915h.454v-5.484h-.454v5.484zM332.289 342.431v5.499h.454v-5.499h-.454zM325.273 344.564a2 2 0 00.497 1.104v-2.98h-.497v1.876zM339.268 345.524c.212-.273.345-.607.383-.96v-1.876h-.383v2.836zM326.865 346.591c.142.091.298.174.455.257v-4.16h-.455v3.903zM330.748 347.839l.454.053v-5.394l-.454.053v5.288zM327.639 346.969c.149.068.298.136.461.197v-4.539h-.461v4.342zM329.193 347.544c.149.046.299.076.455.114v-4.97h-.455v4.856zM329.967 347.726l.454.083v-5.212l-.454.075v5.054z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 345.94c-4.196 0-7.1-1.793-7.1-3.404s2.918-3.404 7.1-3.404c4.182 0 7.1 1.793 7.1 3.404s-2.904 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 339.207c4.032 0 7.043 1.763 7.043 3.329 0 1.566-3.011 3.328-7.043 3.328-4.147 0-7.044-1.755-7.044-3.328 0-1.574 3.011-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.838-7.186 3.48 0 1.641 2.954 3.479 7.186 3.479 4.231 0 7.192-1.83 7.192-3.479 0-1.65-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 339.124c-.862-.001-1.722.08-2.571.242h-4.615v1.884c.121 1.619 3.032 3.381 7.186 3.381 4.153 0 7.1-1.762 7.185-3.381v-1.846h-4.636a13.597 13.597 0 00-2.549-.28z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 342.688c.144.133.296.256.454.37v-3.654h-.454v3.284zM334.617 339.298v5.167l.455-.083v-4.978h-.064c-.114-.068-.256-.083-.391-.106zM333.838 344.564l.461-.053v-5.296l-.461-.053v5.402zM337.713 343.467c.163-.083.312-.174.454-.265v-3.798h-.454v4.063zM333.062 344.617h.455v-5.447h-.455v5.447zM338.488 342.975a4.23 4.23 0 00.455-.393v-3.178h-.455v3.571zM336.166 344.11c.156-.053.305-.099.454-.159v-4.547h-.454v4.706zM335.393 344.314l.454-.113v-4.797h-.454v4.91zM336.939 343.83l.455-.197v-4.229h-.455v4.426zM328.412 343.996l.462.144v-4.736h-.462v4.592zM331.516 344.602h.454v-5.462h-.454v5.462zM332.289 339.132v5.5h.454v-5.5h-.454zM325.273 341.25c.054.416.23.803.505 1.105v-2.951h-.497l-.008 1.846zM339.268 342.203c.212-.271.345-.602.383-.953v-1.846h-.383v2.799zM326.865 343.27c.142.091.298.174.455.257v-4.123h-.455v3.866zM330.748 344.525c.149 0 .298.038.454.046v-5.386l-.454.053v5.287zM327.639 343.686l.461.189v-4.471h-.461v4.282zM329.193 344.231l.455.106v-4.933h-.455v4.827zM329.967 344.404l.454.076v-5.205l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M332.46 342.627c3.929 0 7.114-1.524 7.114-3.404s-3.185-3.405-7.114-3.405-7.114 1.525-7.114 3.405 3.185 3.404 7.114 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 335.894c4.032 0 7.043 1.756 7.043 3.329 0 1.574-3.011 3.329-7.043 3.329-4.147 0-7.044-1.755-7.044-3.329 0-1.573 3.011-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.831-7.186 3.48s2.954 3.48 7.186 3.48c4.231 0 7.192-1.838 7.192-3.48s-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 335.811a13.618 13.618 0 00-2.571.234h-4.615v1.884c.121 1.619 3.032 3.381 7.186 3.381 4.153 0 7.1-1.762 7.185-3.381v-1.884h-4.636a13.56 13.56 0 00-2.549-.234z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 339.404c.135.121.291.249.454.37v-3.729h-.454v3.359zM334.617 335.978v5.166l.455-.083v-5.015h-.064l-.391-.068zM333.838 341.243l.461-.046v-5.295l-.461-.053v5.394zM337.713 340.16l.454-.272v-3.843h-.454v4.115zM333.062 341.295h.455v-5.446h-.455v5.446zM338.488 339.653c.16-.119.312-.25.455-.393v-3.215h-.455v3.608zM336.166 340.788l.454-.151v-4.592h-.454v4.743zM335.393 340.992c.149 0 .305-.068.454-.113v-4.834h-.454v4.947zM336.939 340.516l.455-.204v-4.267h-.455v4.471zM328.412 340.675l.462.151v-4.781h-.462v4.63zM331.516 341.28h.454v-5.462h-.454v5.462zM332.289 335.811v5.5h.454v-5.5h-.454zM325.273 337.929c.049.416.223.804.497 1.105v-3.026h-.497v1.921zM339.268 338.889c.212-.273.345-.607.383-.96v-1.884h-.383v2.844zM326.865 339.956l.455.257v-4.168h-.455v3.911zM330.748 341.204l.454.053v-5.394l-.454.053v5.288zM327.639 340.365c.149.068.298.136.461.196v-4.539h-.461v4.343zM329.193 340.917l.455.113v-4.985h-.455v4.872zM329.967 341.083l.454.084v-5.205l-.454.076v5.045z"
                fill="#3A3A3A"
            />
            <path
                d="M332.46 339.306c3.929 0 7.114-1.525 7.114-3.405s-3.185-3.404-7.114-3.404-7.114 1.524-7.114 3.404 3.185 3.405 7.114 3.405z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 332.596c4.032 0 7.043 1.762 7.043 3.328 0 1.566-3.011 3.329-7.043 3.329-4.147 0-7.044-1.755-7.044-3.329 0-1.573 3.011-3.328 7.044-3.328zm0-.152c-4.26 0-7.186 1.839-7.186 3.48 0 1.642 2.954 3.48 7.186 3.48 4.231 0 7.192-1.831 7.192-3.48s-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 332.489c-.862-.001-1.722.08-2.571.242h-4.615v1.884c.121 1.619 3.032 3.382 7.186 3.382 4.153 0 7.1-1.763 7.185-3.382v-1.884h-4.636a13.569 13.569 0 00-2.549-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 336.053c.144.134.296.257.454.371v-3.692h-.454v3.321zM334.617 332.664v5.167l.455-.083v-5.016h-.064c-.114-.03-.256-.045-.391-.068zM333.838 337.929l.461-.038v-5.295h-.461v5.333zM337.713 336.833a5.54 5.54 0 00.454-.265v-3.836h-.454v4.101zM333.062 337.982h.455v-5.447h-.455v5.447zM338.488 336.379c.159-.122.31-.253.455-.394v-3.253h-.455v3.647zM336.166 337.476l.454-.159v-4.585h-.454v4.744zM335.393 337.68l.454-.114v-4.834h-.454v4.948zM336.939 337.196l.455-.197v-4.267h-.455v4.464zM328.412 337.362l.462.144v-4.774h-.462v4.63zM331.516 337.967h.454v-5.462h-.454v5.462zM332.289 332.497v5.5h.454v-5.5h-.454zM325.273 334.616c.052.415.226.802.497 1.104v-3.026h-.497v1.922zM339.268 335.569c.212-.271.345-.602.383-.953v-1.884h-.383v2.837zM326.865 336.636c.142.091.298.174.455.257v-4.161h-.455v3.904zM330.748 337.891l.454.045v-5.386l-.454.045v5.296zM327.639 337.052l.461.189v-4.539h-.461v4.35zM329.193 337.597l.455.106v-4.971h-.455v4.865zM329.967 337.77l.454.075v-5.204l-.454.075v5.054z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 335.992c-4.196 0-7.1-1.793-7.1-3.404s2.918-3.404 7.1-3.404c4.182 0 7.1 1.793 7.1 3.404s-2.904 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 329.259c4.032 0 7.043 1.756 7.043 3.329 0 1.574-3.011 3.321-7.043 3.321-4.033 0-7.044-1.755-7.044-3.313 0-1.559 3.011-3.329 7.044-3.329v-.008zm0-.158c-4.26 0-7.186 1.838-7.186 3.487s2.954 3.48 7.186 3.48c4.231 0 7.192-1.838 7.192-3.472s-2.954-3.495-7.192-3.495z"
                fill="#3A3A3A"
            />
            <path
                d="M332.459 329.176a13.618 13.618 0 00-2.571.234h-4.615v1.884c.121 1.619 3.032 3.382 7.186 3.382 4.153 0 7.1-1.763 7.185-3.382v-1.884h-4.636a13.644 13.644 0 00-2.549-.234z"
                fill="#3A3A3A"
            />
            <path
                d="M326.092 332.74c.135.121.291.249.454.37v-3.699h-.454v3.329zM334.617 329.343v5.167l.455-.084v-5.015h-.064l-.391-.068zM333.838 334.608l.461-.053v-5.258l-.461-.053v5.364zM337.713 333.519l.454-.272v-3.836h-.454v4.108zM333.062 334.661h.455v-5.447h-.455v5.447zM338.488 333.02c.161-.129.313-.271.455-.424v-3.185h-.455v3.609zM336.166 334.154l.454-.151v-4.592h-.454v4.743zM335.393 334.359c.149 0 .305-.068.454-.114v-4.834h-.454v4.948zM336.939 333.882l.455-.204v-4.267h-.455v4.471zM328.412 334.041l.462.151v-4.781h-.462v4.63zM331.516 334.646h.454v-5.462h-.454v5.462zM332.289 329.176v5.5h.454v-5.5h-.454zM325.273 331.295c.052.416.229.804.505 1.104v-2.988h-.497l-.008 1.884zM339.268 332.248c.213-.27.347-.602.383-.953v-1.884h-.383v2.837zM326.865 333.353l.455.257v-4.199h-.455v3.942zM330.748 334.57l.454.053v-5.394l-.454.053v5.288zM327.639 333.73c.149.068.298.136.461.197v-4.539h-.461v4.342zM329.193 334.275l.455.114v-4.978h-.455v4.864zM329.967 334.448l.454.084v-5.213l-.454.084v5.045z"
                fill="#3A3A3A"
            />
            <path
                d="M332.46 332.671c3.929 0 7.114-1.524 7.114-3.404 0-1.881-3.185-3.405-7.114-3.405s-7.114 1.524-7.114 3.405c0 1.88 3.185 3.404 7.114 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M332.459 325.938c4.032 0 7.043 1.763 7.043 3.329 0 1.566-3.011 3.329-7.043 3.329-4.033 0-7.044-1.755-7.044-3.329 0-1.574 3.011-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.831-7.186 3.48s2.954 3.48 7.186 3.48c4.231 0 7.192-1.831 7.192-3.48s-2.954-3.48-7.192-3.48zM320.099 366.563a13.445 13.445 0 00-2.57.242h-4.615v1.883c.085 1.619 3.018 3.382 7.185 3.382 4.168 0 7.1-1.763 7.185-3.382v-1.883h-4.615a13.608 13.608 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 370.133c.135.121.291.25.454.371v-3.699h-.454v3.328zM322.229 366.737v5.197l.454-.083v-5.046l-.454-.068zM321.461 372.002l.461-.053v-5.295l-.461-.015v5.363zM325.338 370.913l.454-.273v-3.835h-.454v4.108zM320.688 372.055h.461v-5.416h-.461v5.416zM326.111 370.421c.162-.118.314-.249.455-.394v-3.222h-.455v3.616zM323.791 371.548l.454-.151v-4.592h-.454v4.743zM323.016 371.752c.156 0 .305-.068.454-.113v-4.834h-.454v4.947zM324.564 371.276l.455-.204v-4.267h-.455v4.471zM316.045 371.434c.142.053.298.099.454.144v-4.773h-.454v4.629zM319.141 372.04h.454v-5.462h-.454v5.462zM319.914 366.57v5.5h.454v-5.5h-.454zM312.9 368.688c.043.416.216.805.49 1.105v-3.026h-.497l.007 1.921zM326.886 369.665c.214-.271.347-.603.383-.954v-1.906h-.39l.007 2.86zM314.49 370.716c.149.083.298.174.462.257v-4.168h-.462v3.911zM318.365 371.934l.455.053v-5.348l-.455.053v5.242zM315.264 371.125c.149.068.298.136.461.196v-4.539h-.461v4.343zM316.818 371.669l.455.114v-4.978h-.455v4.864zM317.592 371.843l.454.076v-5.205l-.454.083v5.046z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 370.065c-4.189 0-7.1-1.793-7.1-3.404s2.925-3.404 7.1-3.404 7.1 1.793 7.1 3.381c0 1.589-2.918 3.427-7.1 3.427z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 363.333c4.033 0 7.043 1.755 7.043 3.329 0 1.573-3.01 3.328-7.043 3.328s-7.043-1.755-7.043-3.328c0-1.574 3.01-3.329 7.043-3.329zm0-.151c-4.26 0-7.185 1.83-7.185 3.48 0 1.649 2.925 3.479 7.185 3.479s7.178-1.83 7.178-3.502c0-1.672-2.918-3.457-7.178-3.457z"
                fill="#3A3A3A"
            />
            <path
                d="M320.099 363.249a12.979 12.979 0 00-2.57.242h-4.615v1.876c.085 1.627 3.018 3.39 7.185 3.39 4.168 0 7.1-1.763 7.185-3.39v-1.876h-4.615a13.123 13.123 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 366.812c.144.133.296.257.454.371v-3.692h-.454v3.321zM322.229 363.416v5.174l.454-.083v-5.015l-.454-.076zM321.461 368.689l.461-.053v-5.296l-.461-.053v5.402zM325.338 367.591c.152-.08.299-.171.441-.272v-3.828h-.455l.014 4.1zM320.688 368.742h.461v-5.447h-.461v5.447zM326.111 367.1c.162-.12.314-.254.455-.401v-3.208h-.455v3.609zM323.791 368.227l.454-.151v-4.585h-.454v4.736zM323.016 368.439l.454-.114v-4.834h-.454v4.948zM324.564 367.955c.155-.059.307-.128.455-.205v-4.259h-.455v4.464zM316.045 368.151c.142.053.298.099.454.144v-4.804h-.454v4.66zM319.141 368.719h.454v-5.462h-.454v5.462zM319.914 363.249v5.5h.454v-5.492h-.454v-.008zM312.9 365.367c.042.417.214.806.49 1.105v-2.981h-.497l.007 1.876zM326.886 366.328c.214-.273.347-.607.383-.961v-1.876h-.39l.007 2.837zM314.49 367.395c.149.091.298.174.462.257v-4.161h-.462v3.904zM318.365 368.65l.455.046v-5.394l-.455.053v5.295zM315.264 367.811l.461.189v-4.539h-.461v4.35zM316.818 368.356l.455.105v-4.97h-.455v4.865zM317.592 368.529l.454.076V363.4l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 366.752c-4.189 0-7.1-1.801-7.1-3.404 0-1.604 2.925-3.405 7.1-3.405s7.1 1.793 7.1 3.405c0 1.611-2.918 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 360.019c4.033 0 7.043 1.755 7.043 3.329 0 1.573-3.024 3.291-7.043 3.291-4.018 0-7.043-1.755-7.043-3.321 0-1.566 3.01-3.329 7.043-3.329v.03zm0-.189c-4.26 0-7.185 1.838-7.185 3.488 0 1.649 2.925 3.51 7.185 3.51s7.193-1.839 7.193-3.48c0-1.642-2.933-3.518-7.193-3.518z"
                fill="#3A3A3A"
            />
            <path
                d="M320.099 359.928a13.445 13.445 0 00-2.57.242h-4.615v1.884c.085 1.618 3.018 3.381 7.185 3.381 4.168 0 7.1-1.763 7.185-3.381v-1.884h-4.615a13.608 13.608 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 363.491c.144.136.296.262.454.378v-3.699h-.454v3.321zM322.229 360.102v5.166l.454-.083v-5.015l-.454-.068zM321.461 365.367l.461-.053v-5.295l-.461-.061v5.409zM325.338 364.278l.454-.273v-3.835h-.454v4.108zM320.688 365.42h.461v-5.446h-.461v5.446zM326.111 363.778c.162-.117.314-.249.455-.393v-3.215h-.455v3.608zM323.791 364.913l.454-.151v-4.592h-.454v4.743zM323.016 365.125l.454-.113v-4.842h-.454v4.955zM324.564 364.641l.455-.204v-4.267h-.455v4.471zM316.045 364.8c.142.053.298.098.454.143v-4.773h-.454v4.63zM319.141 365.405h.454v-5.462h-.454v5.462zM319.914 359.936v5.499h.454v-5.499h-.454zM312.9 362.054c.043.416.216.804.49 1.104v-2.988h-.497l.007 1.884zM326.886 363.007a1.84 1.84 0 00.383-.953v-1.884h-.39l.007 2.837zM314.49 364.081c.149.083.298.174.462.257v-4.168h-.462v3.911zM318.365 365.329l.455.053v-5.394l-.455.053v5.288zM315.264 364.49c.149.068.298.136.461.196v-4.539h-.461v4.343zM316.819 365.034l.44.091v-4.955h-.454l.014 4.864zM317.592 365.208l.454.076v-5.205l-.454.083v5.046z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 363.431c-4.189 0-7.1-1.793-7.1-3.405 0-1.611 2.925-3.404 7.1-3.404s7.1 1.793 7.1 3.404c0 1.612-2.918 3.405-7.1 3.405z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 356.698c4.033 0 7.043 1.755 7.043 3.329 0 1.573-3.01 3.328-7.043 3.328s-7.043-1.755-7.043-3.328c0-1.574 3.01-3.329 7.043-3.329zm0-.151c-4.26 0-7.185 1.831-7.185 3.48s2.925 3.48 7.185 3.48 7.193-1.831 7.193-3.48-2.933-3.48-7.193-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M320.099 356.614a12.906 12.906 0 00-2.57.243h-4.615v1.876c.085 1.626 3.018 3.366 7.185 3.366 4.168 0 7.1-1.763 7.185-3.389v-1.853h-4.615a13.048 13.048 0 00-2.57-.243z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 360.177c.144.134.296.257.454.371v-3.692h-.454v3.321zM322.229 356.804v5.174l.454-.083v-5.038l-.454-.053zM321.461 362.054l.461-.053v-5.296l-.461-.053v5.402zM325.338 360.957c.157-.08.309-.171.454-.273v-3.828h-.454v4.101zM320.688 362.099h.461v-5.439h-.461v5.439zM326.111 360.465c.162-.12.314-.254.455-.401v-3.208h-.455v3.609zM323.791 361.592l.454-.151v-4.585h-.454v4.736zM323.016 361.804l.454-.113v-4.835h-.454v4.948zM324.564 361.343c.155-.059.307-.127.455-.205v-4.281h-.455v4.486zM316.045 361.486l.454.144v-4.774h-.454v4.63zM319.141 362.099h.454v-5.477h-.454v5.477zM319.914 356.614v5.485h.454v-5.477h-.454v-.008zM312.898 358.733c.046.414.221.801.497 1.097v-2.974h-.497v1.877zM326.886 359.694c.213-.274.346-.608.383-.961v-1.876h-.39l.007 2.837zM314.49 360.76c.149.091.298.174.462.257v-4.161h-.462v3.904zM318.365 362.015l.455.046v-5.394l-.455.053v5.295zM315.264 361.176l.461.189v-4.539h-.461v4.35zM316.818 361.721l.455.106v-4.97h-.455v4.864zM317.592 361.895l.454.076v-5.167l-.454.075v5.016z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 360.117c-4.189 0-7.1-1.8-7.1-3.404 0-1.604 2.925-3.404 7.1-3.404s7.1 1.793 7.1 3.404-2.918 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 353.384c4.033 0 7.043 1.756 7.043 3.329 0 1.574-3.024 3.321-7.043 3.321-4.018 0-7.057-1.717-7.057-3.321s3.01-3.329 7.043-3.329h.014zm0-.158c-4.26 0-7.185 1.838-7.185 3.487s2.925 3.48 7.185 3.48 7.193-1.838 7.193-3.48-2.933-3.487-7.193-3.487z"
                fill="#3A3A3A"
            />
            <path
                d="M320.099 353.293c-.862-.001-1.722.08-2.57.242h-4.615v1.884c.085 1.619 3.018 3.381 7.185 3.381 4.168 0 7.1-1.762 7.185-3.381v-1.884h-4.615a13.775 13.775 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 356.857c.143.136.294.26.454.371v-3.692h-.454v3.321zM322.229 353.468v5.167l.454-.084v-5.015l-.454-.068zM321.461 358.733l.461-.053v-5.258l-.461-.061v5.372zM325.338 357.644l.454-.272v-3.836h-.454v4.108zM320.688 358.786h.461v-5.447h-.461v5.447zM326.111 357.145c.162-.118.314-.249.455-.394v-3.215h-.455v3.609zM323.791 358.317l.454-.151v-4.63h-.454v4.781zM323.016 358.484l.454-.114v-4.834h-.454v4.948zM324.564 358.007l.455-.204v-4.267h-.455v4.471zM316.045 358.166c.142.053.298.098.454.144v-4.774h-.454v4.63zM319.141 358.771h.454v-5.462h-.454v5.462zM319.914 353.301v5.5h.454v-5.5h-.454zM312.9 355.42c.043.415.216.804.49 1.104v-3.026h-.497l.007 1.922zM326.886 356.373c.214-.27.347-.602.383-.953v-1.884h-.39l.007 2.837zM314.49 357.44c.149.09.298.181.462.264v-4.168h-.462v3.904zM318.365 358.694l.455.053v-5.393l-.455.052v5.288zM315.264 357.855l.461.197v-4.539h-.461v4.342zM316.818 358.4l.455.114v-4.978h-.455v4.864zM317.592 358.574l.454.076v-5.205l-.454.084v5.045z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 356.804c-4.189 0-7.1-1.793-7.1-3.405 0-1.611 2.897-3.404 7.1-3.404 4.203 0 7.1 1.793 7.1 3.404 0 1.612-2.918 3.405-7.1 3.405z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 350.063c4.033 0 7.043 1.755 7.043 3.329 0 1.574-3.01 3.329-7.043 3.329s-7.043-1.755-7.043-3.329c0-1.574 3.01-3.329 7.043-3.329zm0-.151c-4.26 0-7.185 1.831-7.185 3.48s2.925 3.48 7.185 3.48 7.193-1.831 7.193-3.48-2.933-3.48-7.193-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M320.099 350.207a12.979 12.979 0 00-2.57.242h-4.615v1.876c.085 1.619 3.018 3.382 7.185 3.382 4.168 0 7.1-1.763 7.185-3.382v-1.876h-4.615a13.123 13.123 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 353.778c.135.121.291.249.454.371v-3.7h-.454v3.329zM322.229 350.373v5.167l.454-.083v-5.008l-.454-.076zM321.461 355.639c.156 0 .312 0 .461-.045v-5.296l-.461-.053v5.394zM325.338 354.534l.454-.272v-3.813h-.454v4.085zM320.688 355.7h.461v-5.455h-.461v5.455zM326.111 354.05c.163-.115.316-.247.455-.393v-3.208h-.455v3.601zM323.791 355.185l.454-.151v-4.585h-.454v4.736zM323.016 355.389c.156 0 .305-.068.454-.113v-4.827h-.454v4.94zM324.564 354.913l.455-.205v-4.259h-.455v4.464zM316.045 355.071l.454.152v-4.774h-.454v4.622zM319.141 355.677h.454v-5.462h-.454v5.462zM319.914 350.207v5.5h.454v-5.492h-.454v-.008zM312.9 352.325c.042.417.214.806.49 1.105v-2.981h-.497l.007 1.876zM326.886 353.286c.213-.274.346-.608.383-.961v-1.876h-.39l.007 2.837zM314.49 354.353c.149.091.298.174.462.257v-4.161h-.462v3.904zM318.365 355.601l.455.053v-5.394l-.455.053v5.288zM315.264 354.761c.149.068.298.136.461.197v-4.539h-.461v4.342zM316.818 355.291c.149.045.299.075.455.113v-4.955h-.455v4.842zM317.592 355.48l.454.083v-5.205l-.454.076v5.046z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 353.702c-4.189 0-7.1-1.793-7.1-3.404 0-1.612 2.925-3.404 7.1-3.404s7.1 1.792 7.1 3.404c0 1.611-2.918 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 346.97c4.033 0 7.043 1.762 7.043 3.328 0 1.566-3.024 3.329-7.043 3.329-4.018 0-7.043-1.755-7.043-3.329 0-1.573 2.996-3.328 7.043-3.328zm0-.152c-4.26 0-7.185 1.839-7.185 3.48 0 1.642 2.925 3.48 7.185 3.48s7.193-1.831 7.193-3.48-2.933-3.48-7.193-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M320.099 346.864a12.905 12.905 0 00-2.57.242h-4.615v1.876c.085 1.626 3.018 3.389 7.185 3.389 4.168 0 7.1-1.763 7.185-3.389v-1.876h-4.615a12.972 12.972 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 350.427c.144.133.296.256.454.37v-3.692h-.454v3.322zM322.229 347.03v5.175l.454-.083v-5.016l-.454-.076zM321.461 352.302l.461-.053v-5.28h-.461v5.333zM325.338 351.206c.163-.091.312-.174.454-.273v-3.828h-.454v4.101zM320.688 352.355h.461v-5.447h-.461v5.447zM326.111 350.752c.162-.12.314-.254.455-.401v-3.246h-.455v3.647zM323.791 351.841l.454-.151v-4.585h-.454v4.736zM323.016 352.053l.454-.113v-4.835h-.454v4.948zM324.564 351.569a4.3 4.3 0 00.455-.204v-4.26h-.455v4.464zM316.045 351.735l.454.144v-4.774h-.454v4.63zM319.141 352.333h.454v-5.462h-.454v5.462zM319.914 346.863v5.5h.454v-5.492h-.454v-.008zM312.9 348.982c.042.416.214.805.49 1.104v-2.981h-.497l.007 1.877zM326.886 349.942c.214-.273.347-.607.383-.96v-1.877h-.39l.007 2.837zM314.49 351.009c.149.091.298.174.462.257v-4.161h-.462v3.904zM318.365 352.264l.455.046v-5.394l-.455.053v5.295zM315.264 351.425l.461.189v-4.539h-.461v4.35zM316.818 351.97l.455.106v-4.971h-.455v4.865zM317.592 352.144l.454.075v-5.204l-.454.075v5.054z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 350.366c-4.189 0-7.1-1.801-7.1-3.412s2.925-3.404 7.1-3.404 7.1 1.8 7.1 3.419-2.918 3.397-7.1 3.397z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 343.632c4.033 0 7.043 1.756 7.043 3.322s-3.01 3.328-7.043 3.328-7.043-1.755-7.043-3.328c0-1.574 2.996-3.322 7.043-3.322zm0-.158c-4.26 0-7.185 1.838-7.185 3.48 0 1.641 2.925 3.487 7.185 3.487s7.178-1.838 7.178-3.472-2.918-3.495-7.178-3.495z"
                fill="#3A3A3A"
            />
            <path
                d="M320.099 343.626c-.862-.001-1.722.08-2.57.242h-4.615v1.884c.085 1.619 3.018 3.381 7.185 3.381 4.168 0 7.1-1.762 7.185-3.381v-1.884h-4.615a13.775 13.775 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 347.188c.144.133.296.257.454.371v-3.692h-.454v3.321zM322.229 343.8v5.167l.454-.083v-5.016l-.454-.068zM321.461 349.065l.461-.053v-5.296l-.461-.053v5.402zM325.338 347.967c.163-.083.312-.174.454-.264v-3.836h-.454v4.1zM320.688 349.118h.461v-5.447h-.461v5.447zM326.111 347.476c.162-.118.314-.249.455-.394v-3.215h-.455v3.609zM323.791 348.61c.156-.052.305-.098.454-.158v-4.585h-.454v4.743zM323.016 348.815l.454-.114v-4.834h-.454v4.948zM324.564 348.331l.455-.197v-4.267h-.455v4.464zM316.045 348.482c.142.053.298.098.454.144v-4.759h-.454v4.615zM319.141 349.103h.454v-5.462h-.454v5.462zM319.914 343.633v5.5h.454v-5.5h-.454zM312.9 345.752c.045.415.217.803.49 1.104v-3.026h-.497l.007 1.922zM326.886 346.704c.214-.27.347-.602.383-.953v-1.884h-.39l.007 2.837zM314.49 347.771c.149.091.298.174.462.257v-4.161h-.462v3.904zM318.365 349.026c.149 0 .298.038.455.046v-5.386l-.455.053v5.287zM315.264 348.187l.461.189v-4.539h-.461v4.35zM316.818 348.732l.455.106v-4.971h-.455v4.865zM317.592 348.905l.454.076v-5.205l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 347.128c-4.189 0-7.1-1.793-7.1-3.404 0-1.612 2.925-3.405 7.1-3.405s7.1 1.793 7.1 3.405c0 1.611-2.918 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 340.395c4.033 0 7.043 1.756 7.043 3.329 0 1.574-3.01 3.329-7.043 3.329-4.146 0-7.043-1.755-7.043-3.329 0-1.573 3.01-3.329 7.043-3.329zm0-.151c-4.26 0-7.185 1.831-7.185 3.48s2.925 3.48 7.185 3.48 7.193-1.831 7.193-3.48-2.933-3.48-7.193-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M320.099 340.479a13.445 13.445 0 00-2.57.242h-4.615v1.883c.085 1.619 3.018 3.382 7.185 3.382 4.168 0 7.1-1.763 7.185-3.382v-1.883h-4.615a13.608 13.608 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M313.709 344.042c.143.135.294.259.454.37v-3.691h-.454v3.321zM322.229 340.652v5.167l.454-.083v-5.016l-.454-.068zM321.461 345.917l.461-.053v-5.258l-.461-.06v5.371zM325.338 344.829l.454-.273v-3.835h-.454v4.108zM320.688 345.97h.461v-5.447h-.461v5.447zM326.111 344.329c.162-.117.314-.249.455-.393v-3.215h-.455v3.608zM323.791 345.456l.454-.151v-4.584h-.454v4.735zM323.016 345.668l.454-.113v-4.834h-.454v4.947zM324.564 345.192l.455-.205v-4.266h-.455v4.471zM316.045 345.351c.142.052.298.098.454.143v-4.773h-.454v4.63zM319.141 345.955h.454v-5.462h-.454v5.462zM319.914 340.486v5.5h.454v-5.5h-.454zM312.9 342.604c.043.416.216.805.49 1.105v-3.026h-.497l.007 1.921zM326.886 343.558a1.84 1.84 0 00.383-.954v-1.883h-.39l.007 2.837zM314.49 344.632c.149.083.298.174.462.257v-4.168h-.462v3.911zM318.365 345.88l.455.053v-5.394l-.455.053v5.288zM315.264 345.041l.461.196v-4.539h-.461v4.343zM316.818 345.585l.455.113v-4.977h-.455v4.864zM317.592 345.759l.454.076v-5.205l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M320.098 343.981c-4.189 0-7.1-1.793-7.1-3.404s2.925-3.404 7.1-3.404 7.1 1.793 7.1 3.404-2.918 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M320.099 337.248c4.033 0 7.043 1.755 7.043 3.329 0 1.573-3.024 3.366-7.043 3.366-4.018 0-7.043-1.755-7.043-3.329 0-1.573 3.01-3.328 7.043-3.328v-.038zm0-.151c-4.26 0-7.185 1.83-7.185 3.48 0 1.649 2.925 3.48 7.185 3.48s7.193-1.831 7.193-3.48c0-1.65-2.933-3.442-7.193-3.442v-.038zM307.709 373.787a13.14 13.14 0 00-2.571.242h-4.615v1.877c.114 1.626 3.025 3.389 7.179 3.389 4.153 0 7.1-1.763 7.185-3.389v-1.877h-4.615a13.067 13.067 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M301.34 377.35c.144.133.296.257.454.371v-3.692h-.454v3.321zM309.867 373.954v5.175l.455-.084v-5.015h-.036l-.419-.076zM309.094 379.227l.454-.053v-5.296l-.454-.053v5.402zM312.998 378.13c.157-.081.309-.172.454-.273v-3.828h-.454v4.101zM308.312 379.279h.462v-5.447h-.462v5.447zM313.709 377.638c.162-.122.317-.256.461-.401v-3.208h-.461v3.609zM311.416 378.742l.454-.151v-4.562h-.454v4.713zM310.641 378.977l.454-.114v-4.834h-.454v4.948zM312.189 378.493c.155-.059.307-.127.455-.205v-4.259h-.455v4.464zM303.67 378.659l.454.144v-4.774h-.454v4.63zM306.764 379.257h.454v-5.462h-.454v5.462zM307.539 373.787v5.5h.49v-5.492h-.462l-.028-.008zM300.525 375.905c.042.417.214.806.49 1.105v-2.981h-.497l.007 1.876zM314.511 376.866c.213-.274.346-.607.383-.961v-1.876h-.39l.007 2.837zM302.113 377.933c.149.091.298.174.462.257v-4.161h-.462v3.904zM305.99 379.188l.455.046v-5.394l-.455.053v5.295zM302.889 378.349l.461.189v-4.539h-.461v4.35zM304.479 378.894l.454.106v-4.971h-.454v4.865zM305.188 379.068l.454.075v-5.205l-.454.076v5.054z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 377.29c-4.189 0-7.1-1.801-7.1-3.412s2.926-3.397 7.1-3.397c4.175 0 7.1 1.793 7.1 3.397 0 1.604-2.904 3.412-7.1 3.412z"
                fill="#0EA59D"
            />
            <path
                d="M307.709 370.557c4.032 0 7.043 1.755 7.043 3.321 0 1.566-3.011 3.352-7.043 3.352-4.147 0-7.044-1.748-7.044-3.329 0-1.581 3.011-3.321 7.044-3.321v-.023zm0-.159c-4.26 0-7.186 1.839-7.186 3.48 0 1.642 2.954 3.488 7.186 3.488 4.231 0 7.192-1.838 7.192-3.488 0-1.649-2.954-3.457-7.192-3.457v-.023z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 370.467c-.862-.001-1.722.08-2.571.242h-4.615v1.884c.114 1.618 3.025 3.381 7.179 3.381 4.153 0 7.1-1.763 7.185-3.381v-1.884h-4.615a13.542 13.542 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M301.34 374.029c.142.136.294.259.454.371v-3.692h-.454v3.321zM309.867 370.641v5.167l.455-.084v-5.015h-.036l-.419-.068zM309.094 375.906l.454-.053v-5.295l-.454-.061v5.409zM312.998 374.808c.163-.083.312-.174.454-.265v-3.835h-.454v4.1zM308.312 375.959h.462v-5.447h-.462v5.447zM313.709 374.317c.162-.12.317-.251.461-.394v-3.215h-.461v3.609zM311.416 375.451l.454-.151v-4.592h-.454v4.743zM310.641 375.656l.454-.114v-4.834h-.454v4.948zM312.189 375.179l.455-.219v-4.252h-.455v4.471zM303.67 375.338c.142.053.298.098.454.144v-4.774h-.454v4.63zM306.764 375.943h.454v-5.462h-.454v5.462zM307.539 370.474v5.499h.49v-5.499H307.539zM300.525 372.592c.043.416.216.804.49 1.104v-2.988h-.497l.007 1.884zM314.511 373.545c.214-.27.347-.602.383-.953v-1.884h-.39l.007 2.837zM302.113 374.612c.149.09.298.181.462.264v-4.168h-.462v3.904zM305.99 375.868l.455.053v-5.394l-.455.053v5.288zM302.889 375.028l.461.197v-4.539h-.461v4.342zM304.479 375.572l.454.114v-4.978h-.454v4.864zM305.188 375.716l.454.076v-5.175l-.454.076v5.023z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 373.969c-4.189 0-7.1-1.793-7.1-3.405 0-1.611 2.926-3.404 7.1-3.404 4.175 0 7.1 1.793 7.1 3.404 0 1.612-2.904 3.405-7.1 3.405z"
                fill="#0EA59D"
            />
            <path
                d="M307.709 367.235c4.032 0 7.043 1.755 7.043 3.329 0 1.573-3.011 3.329-7.043 3.329-4.147 0-7.044-1.756-7.044-3.329 0-1.574 3.011-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.831-7.186 3.48s2.954 3.48 7.186 3.48c4.231 0 7.192-1.831 7.192-3.48s-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 367.153a12.989 12.989 0 00-2.571.242h-4.615v1.876c.121 1.626 3.032 3.419 7.186 3.419 4.153 0 7.1-1.763 7.185-3.389v-1.906h-4.615a12.979 12.979 0 00-2.57-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M301.34 370.716a4.7 4.7 0 00.454.37v-3.691h-.454v3.321zM309.867 367.319v5.175l.455-.084v-5.015h-.036l-.419-.076zM309.094 372.592l.454-.053v-5.296l-.454-.053v5.402zM312.998 371.495c.163-.091.312-.174.454-.273v-3.827h-.454v4.1zM308.312 372.645h.462v-5.447h-.462v5.447zM313.709 371.003c.162-.122.317-.256.461-.401v-3.207h-.461v3.608zM311.416 372.13l.454-.151v-4.584h-.454v4.735zM310.641 372.342l.454-.113v-4.834h-.454v4.947zM312.189 371.858c.157-.068.313-.129.455-.204v-4.259h-.455v4.463zM303.67 372.024l.454.144v-4.773h-.454v4.629zM306.764 372.622h.454v-5.462h-.454v5.462zM307.539 367.152v5.538h.49v-5.53h-.462l-.028-.008zM300.525 369.271c.042.416.214.805.49 1.104v-2.98h-.497l.007 1.876zM314.511 370.232c.213-.274.346-.608.383-.961v-1.876h-.39l.007 2.837zM302.113 371.298c.149.091.298.174.462.257v-4.16h-.462v3.903zM305.99 372.555l.455.045v-5.394l-.455.053v5.296zM302.889 371.714l.461.189v-4.508h-.461v4.319zM304.479 372.259l.454.106v-4.97h-.454v4.864zM305.188 372.433l.454.075v-5.204l-.454.09v5.039z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 370.647c-4.189 0-7.1-1.793-7.1-3.404s2.926-3.404 7.1-3.404c4.175 0 7.1 1.8 7.1 3.404 0 1.604-2.904 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M307.709 363.923c4.032 0 7.043 1.755 7.043 3.321 0 1.566-3.011 3.328-7.043 3.328-4.147 0-7.044-1.755-7.044-3.328 0-1.574 3.011-3.321 7.044-3.321zm0-.159c-4.26 0-7.186 1.838-7.186 3.48 0 1.641 2.954 3.487 7.186 3.487 4.231 0 7.192-1.823 7.192-3.487 0-1.665-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 363.832c-.862-.001-1.722.08-2.571.242h-4.615v1.884c.114 1.619 3.025 3.381 7.179 3.381 4.153 0 7.1-1.762 7.185-3.381v-1.884h-4.615a13.709 13.709 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M301.34 367.395c.142.136.294.26.454.371v-3.692h-.454v3.321zM309.867 364.006v5.167l.455-.083v-5.016h-.036l-.419-.068zM309.094 369.271l.454-.053v-5.258l-.454-.061v5.372zM312.998 368.152c.163-.083.312-.174.454-.265v-3.813h-.454v4.078zM308.312 369.324h.462v-5.447h-.462v5.447zM313.709 367.683c.162-.12.317-.251.461-.394v-3.215h-.461v3.609zM311.416 368.817l.454-.151v-4.592h-.454v4.743zM310.641 369.022l.454-.114v-4.834h-.454v4.948zM312.189 368.538l.455-.197v-4.267h-.455v4.464zM303.67 368.704c.142.053.298.098.454.144v-4.774h-.454v4.63zM306.764 369.309h.454v-5.462h-.454v5.462zM307.539 363.839v5.5h.49v-5.5H307.539zM300.525 365.958c.043.416.216.804.49 1.104v-3.026h-.497l.007 1.922zM314.511 366.911c.214-.27.347-.602.383-.953v-1.884h-.39l.007 2.837zM302.113 367.978c.149.091.298.181.462.265v-4.169h-.462v3.904zM305.99 369.233l.455.053v-5.393l-.455.053v5.287zM302.889 368.393l.461.197v-4.539h-.461v4.342zM304.479 368.908l.454.114v-4.948h-.454v4.834zM305.188 369.112l.454.076v-5.205l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 367.334c-4.189 0-7.1-1.793-7.1-3.404 0-1.612 2.926-3.405 7.1-3.405 4.175 0 7.1 1.793 7.1 3.405 0 1.611-2.904 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M307.709 360.586c4.032 0 7.043 1.755 7.043 3.328 0 1.574-3.011 3.329-7.043 3.329-4.033 0-7.044-1.755-7.044-3.329 0-1.573 3.011-3.328 7.044-3.328zm0-.151c-4.26 0-7.186 1.83-7.186 3.479 0 1.65 2.954 3.48 7.186 3.48 4.231 0 7.192-1.83 7.192-3.48 0-1.649-2.954-3.479-7.192-3.479z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 360.518a12.989 12.989 0 00-2.571.242h-4.615v1.876c.114 1.626 3.025 3.389 7.179 3.389 4.153 0 7.1-1.763 7.185-3.389v-1.876h-4.615a13.067 13.067 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M301.34 364.081c.144.133.296.257.454.371v-3.692h-.454v3.321zM309.867 360.685v5.197l.455-.076v-5.046h-.036l-.419-.075zM309.094 365.957l.454-.053v-5.295l-.454-.023v5.371zM312.998 364.86c.163-.091.312-.174.454-.272v-3.828h-.454v4.1zM308.312 366.01h.462v-5.424h-.462v5.424zM313.709 364.368c.162-.122.317-.256.461-.401v-3.207h-.461v3.608zM311.416 365.495l.454-.151v-4.584h-.454v4.735zM310.641 365.707l.454-.113v-4.834h-.454v4.947zM312.189 365.223c.157-.068.313-.128.455-.204v-4.259h-.455v4.463zM303.67 365.39l.454.143v-4.773h-.454v4.63zM306.764 365.987h.454v-5.462h-.454v5.462zM307.539 360.519v5.499h.49v-5.492h-.462l-.028-.007zM300.525 362.636c.042.416.214.805.49 1.104v-2.98h-.497l.007 1.876zM314.511 363.612c.213-.274.346-.608.383-.961v-1.891h-.39l.007 2.852zM302.113 364.663c.149.091.298.174.462.258v-4.161h-.462v3.903zM305.99 365.919l.455.046v-5.379l-.455.053v5.28zM302.889 365.079l.461.19v-4.54h-.461v4.35zM304.479 365.624l.454.106v-4.97h-.454v4.864zM305.188 365.798l.454.076v-5.205l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 364.013c-4.189 0-7.1-1.793-7.1-3.405 0-1.611 2.926-3.404 7.1-3.404 4.175 0 7.1 1.801 7.1 3.404 0 1.604-2.904 3.405-7.1 3.405z"
                fill="#0EA59D"
            />
            <path
                d="M307.709 357.288c4.032 0 7.043 1.755 7.043 3.321 0 1.566-3.011 3.329-7.043 3.329-4.033 0-7.044-1.755-7.044-3.329 0-1.573 3.011-3.321 7.044-3.321zm0-.159c-4.26 0-7.186 1.838-7.186 3.48s2.954 3.488 7.186 3.488c4.231 0 7.192-1.839 7.192-3.511 0-1.672-2.954-3.48-7.192-3.48v.023z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 357.25c-.862-.001-1.722.08-2.571.242h-4.615v1.884c.114 1.619 3.025 3.381 7.179 3.381 4.153 0 7.1-1.762 7.185-3.381v-1.884h-4.615a13.709 13.709 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M301.34 360.813c.144.133.296.257.454.371v-3.692h-.454v3.321zM309.867 357.424v5.167l.455-.083v-5.016h-.036l-.419-.068zM309.094 362.69l.454-.053v-5.296l-.454-.053v5.402zM312.998 361.592c.163-.083.312-.174.454-.264v-3.836h-.454v4.1zM308.312 362.743h.462v-5.447h-.462v5.447zM313.709 361.101c.162-.12.317-.251.461-.394v-3.215h-.461v3.609zM311.416 362.235l.454-.151v-4.592h-.454v4.743zM310.641 362.44l.454-.114v-4.834h-.454v4.948zM312.189 361.956l.455-.197v-4.267h-.455v4.464zM303.67 362.099c.142.053.298.099.454.144v-4.751h-.454v4.607zM306.764 362.727h.454v-5.462h-.454v5.462zM307.539 357.258v5.5h.49v-5.5H307.539zM300.525 359.376c.045.415.217.803.49 1.104v-3.026h-.497l.007 1.922zM314.511 360.329c.214-.27.347-.602.383-.953v-1.884h-.39l.007 2.837zM302.113 361.396c.149.091.298.181.462.265v-4.169h-.462v3.904zM305.99 362.651l.455.046v-5.386l-.455.053v5.287zM302.889 361.812l.461.197v-4.539h-.461v4.342zM304.479 362.357l.454.113v-4.978h-.454v4.865zM305.188 362.53l.454.076v-5.205l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 360.753c-4.189 0-7.1-1.793-7.1-3.404 0-1.612 2.926-3.405 7.1-3.405 4.175 0 7.1 1.793 7.1 3.405 0 1.611-2.904 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M307.709 354.019c4.032 0 7.043 1.756 7.043 3.329 0 1.574-3.011 3.329-7.043 3.329-4.033 0-7.044-1.763-7.044-3.329 0-1.566 3.011-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.831-7.186 3.48s2.954 3.48 7.186 3.48c4.231 0 7.192-1.831 7.192-3.48s-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 353.854a12.989 12.989 0 00-2.571.242h-4.615v1.876c.114 1.619 3.025 3.389 7.179 3.389 4.153 0 7.1-1.77 7.185-3.389v-1.876h-4.615a13.067 13.067 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M301.34 357.417c.135.121.291.249.454.37v-3.691h-.454v3.321zM309.867 354.02v5.167l.455-.084v-5.008h-.036l-.419-.075zM309.094 359.284l.454-.045v-5.295l-.454-.053v5.393zM312.998 358.196l.454-.272v-3.828h-.454v4.1zM308.312 359.345h.462v-5.454h-.462v5.454zM313.709 357.697c.162-.12.317-.251.461-.394v-3.207h-.461v3.601zM311.416 358.831l.454-.151v-4.584h-.454v4.735zM310.641 359.073l.454-.121v-4.856h-.454v4.977zM312.189 358.559l.455-.204v-4.259h-.455v4.463zM303.67 358.726l.454.143v-4.773h-.454v4.63zM306.764 359.323h.454v-5.462h-.454v5.462zM307.539 353.854v5.499h.49v-5.492h-.462l-.028-.007zM300.525 355.972c.042.416.214.805.49 1.104v-2.98h-.497l.007 1.876zM314.511 356.933c.213-.274.346-.608.383-.961v-1.876h-.39l.007 2.837zM302.113 357.999c.149.091.298.174.462.257v-4.16h-.462v3.903zM305.99 359.247l.455.053v-5.394l-.455.053v5.288zM302.889 358.408c.149.068.298.136.461.196v-4.539h-.461v4.343zM304.479 358.952c.149.046.298.076.454.114v-4.97h-.454v4.856zM305.188 359.134l.454.076v-5.205l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M307.709 357.349c-4.189 0-7.1-1.793-7.1-3.405 0-1.611 2.926-3.404 7.1-3.404 4.175 0 7.1 1.793 7.1 3.404 0 1.612-2.904 3.405-7.1 3.405z"
                fill="#0EA59D"
            />
            <path
                d="M307.709 350.615c4.032 0 7.043 1.763 7.043 3.329 0 1.566-3.011 3.328-7.043 3.328-4.033 0-7.044-1.755-7.044-3.328 0-1.574 3.011-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.838-7.186 3.48 0 1.641 2.954 3.48 7.186 3.48 4.231 0 7.192-1.831 7.192-3.48s-2.954-3.48-7.192-3.48zM295.334 381.012c-.862-.001-1.722.08-2.571.242h-4.615v1.876c.114 1.619 3.032 3.382 7.179 3.382 4.146 0 7.1-1.763 7.185-3.382v-1.884h-4.615a13.617 13.617 0 00-2.563-.234z"
                fill="#3A3A3A"
            />
            <path
                d="M288.965 384.567c.145.136.299.26.461.371v-3.692h-.461v3.321zM297.492 381.179v5.167l.455-.084v-5.015h-.036l-.419-.068zM296.719 386.443l.454-.053v-5.295l-.454-.061v5.409zM300.588 385.346c.163-.083.312-.174.461-.264v-3.836h-.461v4.1zM295.959 386.496h.454v-5.446l-.454-.038v5.484zM301.361 384.855c.163-.12.317-.251.462-.394v-3.215h-.462v3.609zM299.039 385.989l.454-.151v-4.592h-.454v4.743zM298.266 386.194l.454-.114v-4.834h-.454v4.948zM299.814 385.709l.455-.196v-4.267h-.455v4.463zM291.293 385.876c.142.053.298.098.454.144v-4.774h-.454v4.63zM294.389 386.481h.454v-5.469h-.454v5.469zM295.164 381.012v5.499h.462v-5.499h-.462zM288.148 383.13c.049.415.224.803.497 1.104v-3.026h-.497v1.922zM302.142 384.083c.209-.273.339-.604.376-.953v-1.884h-.383l.007 2.837zM289.746 385.15c.142.09.291.181.454.264v-4.168h-.454v3.904zM293.615 386.405l.455.053v-5.394l-.455.053v5.288zM290.52 385.55l.454.197v-4.539h-.454v4.342zM292.068 386.11l.455.106v-4.97h-.455v4.864zM292.842 386.307l.454.076v-5.228l-.454.076v5.076z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 384.507c-4.189 0-7.1-1.793-7.1-3.404 0-1.612 2.926-3.405 7.1-3.405 4.175 0 7.1 1.793 7.1 3.405 0 1.611-2.925 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M295.334 377.774c4.032 0 7.05 1.755 7.05 3.329 0 1.573-3.018 3.328-7.05 3.328-4.033 0-7.044-1.755-7.044-3.328 0-1.574 3.018-3.329 7.044-3.329zm0-.151c-4.26 0-7.186 1.831-7.186 3.48s2.954 3.48 7.186 3.48c4.231 0 7.192-1.831 7.192-3.48s-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 377.691a12.989 12.989 0 00-2.571.242h-4.615v1.876c.114 1.626 3.032 3.389 7.179 3.389 4.146 0 7.1-1.763 7.185-3.389v-1.876h-4.615a13.067 13.067 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M288.965 381.254c.147.133.301.257.461.37v-3.691h-.461v3.321zM297.492 377.857v5.175l.455-.083v-5.016h-.036l-.419-.076zM296.719 383.13l.454-.053v-5.296l-.454-.052v5.401zM300.588 382.033c.163-.091.312-.174.461-.272v-3.828h-.461v4.1zM295.959 383.183h.454v-5.447h-.454v5.447zM301.361 381.541c.163-.122.317-.256.462-.401v-3.207h-.462v3.608zM299.039 382.668l.469-.143v-4.592h-.455l-.014 4.735zM298.266 382.88l.454-.121v-4.826h-.454v4.947zM299.814 382.396c.157-.068.313-.129.455-.204v-4.259h-.455v4.463zM291.293 382.562l.454.144v-4.773h-.454v4.629zM294.389 383.16h.454v-5.462h-.454v5.462zM295.164 377.69v5.5h.462v-5.492h-.462v-.008zM288.148 379.809c.048.416.222.804.497 1.104v-2.98h-.497v1.876zM302.142 380.77a1.95 1.95 0 00.376-.961v-1.876h-.383l.007 2.837zM289.746 381.836c.142.091.291.174.454.257v-4.16h-.454v3.903zM293.615 383.093l.455.045v-5.394l-.455.053v5.296zM290.52 382.245l.454.196v-4.539h-.454v4.343zM292.068 382.797l.455.106v-4.97h-.455v4.864zM292.842 382.971l.454.076v-5.205l-.454.076v5.053z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 381.185c-4.189 0-7.1-1.792-7.1-3.404 0-1.611 2.926-3.404 7.1-3.404 4.175 0 7.1 1.8 7.1 3.404 0 1.604-2.925 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M295.334 374.46c4.032 0 7.05 1.755 7.05 3.321 0 1.566-3.018 3.329-7.05 3.329-4.033 0-7.044-1.755-7.044-3.329 0-1.573 3.018-3.321 7.044-3.321zm0-.158c-4.26 0-7.186 1.838-7.186 3.479 0 1.642 2.954 3.488 7.186 3.488 4.231 0 7.192-1.838 7.192-3.488 0-1.649-2.954-3.479-7.192-3.479z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 374.37c-.862-.001-1.722.08-2.571.242h-4.615v1.861c.114 1.619 3.032 3.382 7.179 3.382 4.146 0 7.1-1.763 7.185-3.382v-1.861h-4.615a13.709 13.709 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M288.965 377.933c.147.133.301.257.461.371v-3.692h-.461v3.321zM297.492 374.544v5.167l.455-.084v-5.015h-.036l-.419-.068zM296.719 379.809l.454-.053v-5.296l-.454-.053v5.402zM300.588 378.743c.163-.083.312-.174.461-.265v-3.866h-.461v4.131zM295.959 379.862h.454v-5.447h-.454v5.447zM301.361 378.221c.163-.12.317-.251.462-.394v-3.215h-.462v3.609zM299.039 379.356l.454-.152v-4.592h-.454v4.744zM298.266 379.56l.454-.114v-4.834h-.454v4.948zM299.814 379.076l.455-.197v-4.267h-.455v4.464zM291.293 379.242c.142.053.298.098.454.144v-4.774h-.454v4.63zM294.389 379.847h.454v-5.462h-.454v5.462zM295.164 374.377v5.5h.462v-5.5h-.462zM288.148 376.473c.046.424.221.82.497 1.127v-2.988h-.497v1.861zM302.142 377.449c.212-.279.343-.618.376-.976v-1.861h-.383l.007 2.837zM289.746 378.516c.142.091.291.174.454.257v-4.161h-.454v3.904zM293.615 379.771l.455.045v-5.386l-.455.053v5.288zM290.52 378.932c.142.068.298.129.454.189v-4.539h-.454v4.35zM292.068 379.499l.455.114v-5.001h-.455v4.887zM292.842 379.651l.454.075v-5.205l-.454.076v5.054z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 377.873c-4.189 0-7.1-1.793-7.1-3.404 0-1.612 2.926-3.405 7.1-3.405 4.175 0 7.1 1.793 7.1 3.405 0 1.611-2.925 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M295.334 371.177c4.032 0 7.05 1.755 7.05 3.328 0 1.574-3.018 3.329-7.05 3.329-4.033 0-7.044-1.801-7.044-3.367 0-1.565 3.018-3.29 7.044-3.29zm0-.152c-4.26 0-7.186 1.831-7.186 3.48s2.954 3.48 7.186 3.48c4.231 0 7.192-1.831 7.192-3.48s-2.954-3.48-7.192-3.48z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 371.057a12.989 12.989 0 00-2.571.242h-4.615v1.876c.114 1.627 3.032 3.389 7.179 3.389 4.146 0 7.1-1.762 7.185-3.389v-1.876h-4.615a13.067 13.067 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M288.965 374.62c.142.121.291.25.461.371v-3.692h-.461v3.321zM297.492 371.223v5.167l.455-.076v-5.015h-.036l-.419-.076zM296.719 376.473l.454-.053v-5.243l-.454-.053v5.349zM300.588 375.399c.163-.091.312-.174.461-.272v-3.828h-.461v4.1zM295.959 376.549h.454v-5.454h-.454v5.454zM301.361 374.907c.163-.122.317-.256.462-.401v-3.207h-.462v3.608zM299.039 376.035l.454-.152v-4.584h-.454v4.736zM298.266 376.246l.454-.121v-4.826h-.454v4.947zM299.814 375.762l.455-.204v-4.259h-.455v4.463zM291.293 375.929l.454.143v-4.773h-.454v4.63zM294.389 376.526h.454v-5.462h-.454v5.462zM295.164 371.057v5.499h.462v-5.492h-.462v-.007zM288.148 373.175c.048.416.222.805.497 1.104v-2.98h-.497v1.876zM302.142 374.136c.208-.276.338-.609.376-.961v-1.876h-.383l.007 2.837zM289.746 375.202c.142.091.291.174.454.258v-4.161h-.454v3.903zM293.615 376.473l.455.053v-5.417l-.455.068v5.296zM290.52 375.618l.454.19v-4.539h-.454v4.349zM292.068 376.163l.455.106v-4.97h-.455v4.864zM292.842 376.336l.454.076v-5.235l-.454.075v5.084z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 374.552c-4.189 0-7.1-1.793-7.1-3.405 0-1.611 2.926-3.404 7.1-3.404 4.175 0 7.1 1.801 7.1 3.404 0 1.604-2.925 3.405-7.1 3.405z"
                fill="#0EA59D"
            />
            <path
                d="M295.334 367.826c4.032 0 7.05 1.755 7.05 3.321 0 1.566-3.018 3.329-7.05 3.329-4.033 0-7.044-1.786-7.044-3.299s3.018-3.321 7.044-3.321v-.03zm0-.159c-4.232 0-7.186 1.838-7.186 3.51 0 1.672 2.954 3.488 7.186 3.488 4.231 0 7.192-1.869 7.192-3.488s-2.954-3.48-7.192-3.48v-.03z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 367.735c-.862-.001-1.722.08-2.571.242h-4.615v1.884c.114 1.619 3.032 3.382 7.179 3.382 4.146 0 7.1-1.763 7.185-3.382v-1.884h-4.615a13.709 13.709 0 00-2.563-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M288.965 371.299c.147.133.301.257.461.37v-3.691h-.461v3.321zM297.492 367.909v5.167l.455-.083v-5.016h-.036l-.419-.068zM296.719 373.175l.454-.053v-5.296l-.454-.053v5.402zM300.588 372.078c.163-.083.312-.174.461-.265v-3.835h-.461v4.1zM295.959 373.227h.454v-5.447h-.454v5.447zM301.361 371.586c.163-.119.317-.251.462-.393v-3.215h-.462v3.608zM299.039 372.691l.454-.152v-4.561h-.454v4.713zM298.266 372.925l.454-.113v-4.834h-.454v4.947zM299.814 372.441l.455-.197v-4.266h-.455v4.463zM291.293 372.607c.142.053.298.099.454.144v-4.773h-.454v4.629zM294.389 373.212h.454v-5.462h-.454v5.462zM295.164 367.743v5.5h.462v-5.5h-.462zM288.148 369.861c.051.416.225.803.497 1.105v-2.988h-.497v1.883zM302.142 370.814a1.89 1.89 0 00.376-.953v-1.883h-.383l.007 2.836zM289.746 371.881c.146.096.298.182.454.257v-4.16h-.454v3.903zM293.615 373.137l.455.045v-5.386l-.455.053v5.288zM290.52 372.297c.142.068.298.129.454.189v-4.539h-.454v4.35zM292.068 372.842l.455.106v-4.97h-.455v4.864zM292.842 373.016l.454.075v-5.205l-.454.076v5.054z"
                fill="#3A3A3A"
            />
            <path
                d="M295.334 371.238c-4.189 0-7.1-1.793-7.1-3.404s2.926-3.404 7.1-3.404c4.175 0 7.1 1.793 7.1 3.404s-2.925 3.404-7.1 3.404z"
                fill="#0EA59D"
            />
            <path
                d="M295.334 364.505c4.032 0 7.05 1.755 7.05 3.328 0 1.574-3.018 3.344-7.05 3.344-4.033 0-7.044-1.778-7.044-3.344 0-1.566 3.018-3.328 7.044-3.328zm0-.151c-4.232.015-7.186 1.83-7.186 3.479 0 1.65 2.954 3.48 7.186 3.48 4.231 0 7.192-1.838 7.192-3.48 0-1.641-2.954-3.464-7.192-3.464v-.015z"
                fill="#3A3A3A"
            />
            <path
                style={{ mixBlendMode: "multiply" }}
                d="M305.898 390.846l26.568 16.484a.948.948 0 00.994 0l51.83-32.242-27.768-17.097-51.624 31.04a1.026 1.026 0 00-.353.386 1.108 1.108 0 000 1.043c.084.159.206.292.353.386z"
                fill="url(#paint230_linear_874_76773)"
            />
            <path
                d="M364.04 380.716l-25.56-15.72a1.71 1.71 0 00-1.203-.226 1.778 1.778 0 00-1.062.642l-4.757 6.015a12.38 12.38 0 01-3.224 2.874l-21.847 13.406c-.19.116-.348.284-.458.487a1.409 1.409 0 000 1.332c.11.203.268.371.458.488l25.944 15.962c.273.169.583.258.898.258.316 0 .625-.089.898-.258l22.827-14.063a12.3 12.3 0 003.159-2.799l4.395-5.5c.172-.213.298-.464.368-.735a2.026 2.026 0 00-.259-1.601 1.852 1.852 0 00-.577-.562z"
                fill="#3A3A3A"
            />
            <path
                d="M307.411 386.413h-1.647v2.512h1.647v-2.512zM364.942 379.824h-1.647v2.512h1.647v-2.512z"
                fill="#3A3A3A"
            />
            <path
                d="M364.041 378.205l-25.56-15.712a1.701 1.701 0 00-1.203-.229 1.77 1.77 0 00-1.062.645l-4.757 5.999c-.909 1.148-2 2.119-3.223 2.867l-21.847 13.42a1.295 1.295 0 00-.437.485 1.403 1.403 0 000 1.3c.104.199.255.366.437.485l25.943 15.962c.274.167.583.255.898.255.316 0 .625-.088.899-.255l22.826-14.026a12.267 12.267 0 003.16-2.799l4.395-5.492c.171-.214.297-.465.367-.736a2.022 2.022 0 00-.259-1.605 1.837 1.837 0 00-.577-.564z"
                fill="#DBE0E6"
            />
            <path
                d="M333.233 403.798a1.82 1.82 0 01-.937-.265l-25.943-15.962a1.368 1.368 0 01-.483-.515 1.476 1.476 0 010-1.406 1.36 1.36 0 01.483-.515l21.861-13.413a12.051 12.051 0 003.202-2.814l4.757-6.052a1.844 1.844 0 011.118-.683c.437-.079.886.01 1.267.252l25.56 15.72c.24.145.446.345.604.586.158.24.264.514.311.804.047.289.033.586-.04.868a2.045 2.045 0 01-.385.768l-4.395 5.492a12.446 12.446 0 01-3.195 2.807l-22.855 14.063a1.79 1.79 0 01-.93.265zm4.36-41.487a1.65 1.65 0 00-.722.17 1.756 1.756 0 00-.592.473l-4.75 6.014a12.372 12.372 0 01-3.244 2.89l-21.861 13.405a1.231 1.231 0 00-.429.462 1.326 1.326 0 000 1.255c.103.191.25.351.429.462l25.936 15.955a1.654 1.654 0 001.725 0l22.834-14.064a12.272 12.272 0 003.138-2.783l4.402-5.5c.164-.206.283-.447.35-.707a1.939 1.939 0 00-.251-1.538 1.766 1.766 0 00-.553-.539l-25.56-15.713a1.648 1.648 0 00-.852-.242z"
                fill="#3A3A3A"
            />
            <path
                d="M327.81 398.904l-3.5-2.156a.547.547 0 01-.191-.208.59.59 0 01.191-.768l6.809-4.222a.487.487 0 01.532 0l3.493 2.149a.544.544 0 01.196.205.59.59 0 010 .565.547.547 0 01-.196.206l-6.802 4.229a.522.522 0 01-.532 0zM330.493 377.494l-3.934-2.413a.349.349 0 01-.113-.453.331.331 0 01.113-.122l2.578-1.596a.29.29 0 01.312 0l3.933 2.413a.334.334 0 01.155.288.355.355 0 01-.041.166.324.324 0 01-.114.121l-2.577 1.596a.29.29 0 01-.312 0zM351.992 390.763l-3.813-2.345a.4.4 0 01-.183-.344.42.42 0 01.049-.198.393.393 0 01.134-.146l2.457-1.513a.37.37 0 01.376 0l3.813 2.36a.385.385 0 01.134.146.424.424 0 010 .396.385.385 0 01-.134.146l-2.457 1.513a.37.37 0 01-.376-.015zM338.019 399.266l-3.87-2.368a.381.381 0 01-.123-.5.356.356 0 01.123-.135l2.514-1.558a.342.342 0 01.34 0l3.87 2.383a.381.381 0 010 .635l-2.514 1.551a.322.322 0 01-.34-.008zM342.683 396.368l-3.87-2.383a.383.383 0 01-.168-.317c0-.064.015-.127.045-.183a.356.356 0 01.123-.135l2.521-1.559a.351.351 0 01.341 0l3.869 2.383a.37.37 0 01.124.136.392.392 0 010 .365.375.375 0 01-.124.135l-2.513 1.551a.327.327 0 01-.348.007zM337.23 392.988l-3.869-2.383a.353.353 0 01-.124-.133.38.38 0 010-.362.346.346 0 01.124-.133l2.52-1.559a.313.313 0 01.341 0l3.87 2.383a.36.36 0 01.169.314.36.36 0 01-.169.314l-2.514 1.559a.31.31 0 01-.348 0zM341.896 390.09l-3.869-2.383a.377.377 0 010-.628l2.513-1.528a.313.313 0 01.341 0l3.87 2.383a.36.36 0 01.169.314.36.36 0 01-.169.314l-2.514 1.528a.31.31 0 01-.341 0zM346.553 387.193l-3.87-2.398a.36.36 0 01-.169-.314.36.36 0 01.169-.314l2.514-1.559a.323.323 0 01.348 0l3.869 2.383a.353.353 0 01.124.133.38.38 0 010 .363.35.35 0 01-.124.132l-2.513 1.559a.328.328 0 01-.348.015zM341.172 383.909l-3.87-2.383a.35.35 0 01-.124-.132.383.383 0 010-.363c.03-.055.073-.1.124-.132l2.514-1.559a.313.313 0 01.341 0l3.876 2.383a.345.345 0 01.124.133.38.38 0 010 .362.345.345 0 01-.124.133l-2.52 1.558a.306.306 0 01-.341 0zM335.825 380.573l-3.869-2.376a.359.359 0 01-.124-.135.398.398 0 010-.365.359.359 0 01.124-.135l2.513-1.559a.351.351 0 01.341 0l3.87 2.383a.358.358 0 01.128.134.379.379 0 01-.128.502l-2.521 1.513a.316.316 0 01-.334.038zM347.348 393.463l-3.877-2.375a.364.364 0 01-.123-.135.387.387 0 01.123-.501l2.521-1.558a.34.34 0 01.341 0l3.869 2.383a.377.377 0 010 .628l-2.513 1.558a.306.306 0 01-.341 0zM311.82 388.879l-3.855-2.368a.393.393 0 010-.65l2.499-1.513a.332.332 0 01.355 0l3.848 2.367a.38.38 0 01.174.326c0 .065-.016.13-.046.187a.37.37 0 01-.128.138l-2.492 1.513a.34.34 0 01-.355 0zM316.484 385.982l-3.855-2.368a.393.393 0 010-.651l2.499-1.513a.33.33 0 01.174-.051.33.33 0 01.174.051l3.855 2.368a.378.378 0 01.174.325.378.378 0 01-.174.326l-2.499 1.513a.33.33 0 01-.174.051.33.33 0 01-.174-.051zM321.83 389.25l-3.862-2.375a.364.364 0 01-.128-.136.39.39 0 010-.372.354.354 0 01.128-.135l2.499-1.551a.32.32 0 01.348 0l3.862 2.383a.361.361 0 01.128.135.39.39 0 010 .372.372.372 0 01-.128.136l-2.499 1.513a.354.354 0 01-.17.064.344.344 0 01-.178-.034zM327.199 392.578l-3.855-2.367a.38.38 0 01-.174-.326c0-.065.016-.13.046-.187a.37.37 0 01.128-.138l2.499-1.513a.33.33 0 01.174-.051.33.33 0 01.174.051l3.848 2.338a.39.39 0 01.127.512.36.36 0 01-.127.138l-2.499 1.513a.322.322 0 01-.341.03zM326.489 386.353l-3.855-2.376a.361.361 0 01-.128-.135.39.39 0 010-.372.372.372 0 01.128-.136l2.499-1.513a.328.328 0 01.348 0l3.848 2.33a.391.391 0 01.123.506.362.362 0 01-.123.137l-2.499 1.513a.352.352 0 01-.341.046zM331.161 383.455l-3.855-2.375a.383.383 0 01-.128-.507.35.35 0 01.128-.136l2.499-1.513a.327.327 0 01.348 0l3.855 2.368a.39.39 0 01.127.512.36.36 0 01-.127.138l-2.499 1.513a.337.337 0 01-.348 0zM336.506 386.783l-3.856-2.367a.375.375 0 01-.173-.326.375.375 0 01.173-.325l2.5-1.513a.324.324 0 01.348 0l3.855 2.368a.393.393 0 010 .65l-2.499 1.513a.32.32 0 01-.348 0zM331.842 389.681l-3.856-2.368a.36.36 0 01-.127-.138.402.402 0 010-.374.36.36 0 01.127-.138l2.5-1.514a.322.322 0 01.347 0l3.856 2.368a.367.367 0 01.127.138.397.397 0 010 .375.367.367 0 01-.127.138l-2.499 1.513a.324.324 0 01-.348 0zM321.148 383.084l-3.855-2.368a.39.39 0 01-.127-.512.36.36 0 01.127-.138l2.499-1.513a.33.33 0 01.174-.051.33.33 0 01.174.051l3.855 2.368a.37.37 0 01.128.138.401.401 0 010 .374.37.37 0 01-.128.138l-2.499 1.513a.318.318 0 01-.348 0zM325.778 380.188l-3.848-2.368a.378.378 0 01-.174-.326.378.378 0 01.174-.325l2.492-1.513a.34.34 0 01.355 0l3.884 2.33a.384.384 0 01.173.325.384.384 0 01-.173.326l-2.5 1.513a.341.341 0 01-.383.038zM322.512 395.476l-3.834-2.36a.378.378 0 01-.174-.326.378.378 0 01.174-.325l2.499-1.513a.34.34 0 01.355 0l3.848 2.368a.393.393 0 010 .65l-2.499 1.513a.337.337 0 01-.369-.007zM317.167 392.148l-3.856-2.376a.382.382 0 01-.127-.507.354.354 0 01.127-.136l2.5-1.513a.34.34 0 01.355 0l3.848 2.376a.361.361 0 01.128.135c.03.057.047.121.047.186a.372.372 0 01-.175.322l-2.492 1.513a.34.34 0 01-.355 0zM331.799 369.839l5.282-6.605a.56.56 0 01.334-.199.536.536 0 01.376.071l26.221 16.129a.572.572 0 01.184.176.618.618 0 01.082.507.599.599 0 01-.117.232l-5.283 6.597a.549.549 0 01-.332.205.53.53 0 01-.378-.069l-26.22-16.129a.583.583 0 01-.182-.178.644.644 0 01-.082-.505.616.616 0 01.115-.232z"
                fill="#3A3A3A"
            />
            <path
                d="M311.819 388.402l-3.855-2.375a.382.382 0 01-.128-.507.357.357 0 01.128-.136l2.499-1.513a.34.34 0 01.355 0l3.848 2.375a.372.372 0 01.175.322.39.39 0 01-.047.186.361.361 0 01-.128.135l-2.492 1.513a.33.33 0 01-.355 0z"
                fill="#0EA59D"
            />
            <path
                d="M311.998 388.532a.414.414 0 01-.213-.061l-3.855-2.375a.458.458 0 01-.213-.386.461.461 0 01.056-.228.43.43 0 01.157-.165l2.499-1.513a.425.425 0 01.426 0l3.848 2.375a.42.42 0 01.156.162.477.477 0 01.003.45.437.437 0 01-.152.167l-2.499 1.513a.445.445 0 01-.213.061zm-.142-.197a.276.276 0 00.284 0l2.492-1.551a.284.284 0 00.104-.108.309.309 0 00-.001-.298.289.289 0 00-.103-.108l-3.855-2.368a.264.264 0 00-.277 0l-2.471 1.551a.28.28 0 00-.101.109.323.323 0 00.002.295.3.3 0 00.099.11l3.856 2.368h-.029z"
                fill="#3A3A3A"
            />
            <path
                d="M312.075 386.647c-.33.222-.7.369-1.086.432a1.344 1.344 0 01-.873-.19c-.27-.166-.377-.348-.313-.544.165-.295.414-.525.71-.658a2.74 2.74 0 011.065-.432c.307-.041.619.025.888.189.269.167.369.348.305.545a1.6 1.6 0 01-.696.658zm-1.086.182c.124-.034.245-.08.362-.136.121-.061.263-.136.419-.235.129-.079.255-.165.376-.257a.853.853 0 00.213-.219.227.227 0 000-.197.416.416 0 00-.184-.189.94.94 0 00-.618-.106c-.126.035-.25.081-.369.136a5.744 5.744 0 00-.788.492.676.676 0 00-.213.219.228.228 0 00-.043.197.413.413 0 00.185.189.801.801 0 00.298.106c.12.023.242.023.362 0z"
                fill="#3A3A3A"
            />
            <path
                d="M316.485 385.505l-3.855-2.375a.372.372 0 01-.175-.322.39.39 0 01.047-.186.361.361 0 01.128-.135l2.499-1.513a.32.32 0 01.348 0l3.855 2.307a.383.383 0 01.128.507.357.357 0 01-.128.136l-2.499 1.513a.338.338 0 01-.165.086.319.319 0 01-.183-.018z"
                fill="#0EA59D"
            />
            <path
                d="M316.661 385.626a.393.393 0 01-.213-.053l-3.855-2.375a.433.433 0 01-.144-.162.475.475 0 010-.432.426.426 0 01.144-.162l2.499-1.513a.414.414 0 01.419 0l3.877 2.352a.426.426 0 01.157.161.46.46 0 01.056.225.462.462 0 01-.213.371l-2.492 1.513a.379.379 0 01-.235.075zm-.142-.189a.264.264 0 00.277 0l2.499-1.513a.284.284 0 00.104-.108.309.309 0 000-.298.291.291 0 00-.104-.108l-3.855-2.398a.263.263 0 00-.277 0l-2.499 1.513a.28.28 0 00-.101.109.313.313 0 00-.034.148.29.29 0 00.035.145c.024.044.058.08.1.105l3.855 2.405z"
                fill="#3A3A3A"
            />
            <path
                d="M315.625 384.31l-1.229-.756.235-.144.255.159a.397.397 0 00.426 0l1.3-.756-.469-.295.206-.122c.071.044.144.082.22.114.068.034.139.06.213.076.068.01.138.01.206 0a.61.61 0 00.206-.068l.234.143-2.038 1.226.469.28-.234.143z"
                fill="#3A3A3A"
            />
            <path
                d="M321.831 388.766l-3.862-2.367a.378.378 0 01-.174-.326.378.378 0 01.174-.325l2.499-1.513a.336.336 0 01.348 0l3.855 2.375a.372.372 0 01.175.322.39.39 0 01-.047.186.361.361 0 01-.128.135l-2.499 1.513a.325.325 0 01-.341 0z"
                fill="#0EA59D"
            />
            <path
                d="M322.009 388.895a.414.414 0 01-.213-.061l-3.827-2.368a.437.437 0 01-.156-.166.47.47 0 01-.057-.227.461.461 0 01.056-.228.43.43 0 01.157-.165l2.499-1.514a.403.403 0 01.426 0l3.848 2.368c.06.041.11.096.144.162a.467.467 0 01-.144.595l-2.492 1.513a.463.463 0 01-.241.091zm-1.356-4.668a.31.31 0 00-.142 0l-2.5 1.513a.313.313 0 00-.098.404.29.29 0 00.098.11l3.856 2.368a.263.263 0 00.277 0l2.499-1.513a.297.297 0 00.103-.108.309.309 0 00.001-.298.284.284 0 00-.104-.108l-3.834-2.33a.296.296 0 00-.156-.038z"
                fill="#3A3A3A"
            />
            <path
                d="M321.127 387.684l-1.533-.946.099-.06c.139-.088.3-.13.462-.121H321.078c.281.018.563.018.845 0 .164-.02.323-.074.468-.159.114-.068.171-.151.156-.242-.014-.091-.085-.174-.227-.257a1.734 1.734 0 00-.348-.159 2.612 2.612 0 00-.461-.099.79.79 0 01.71-.075c.134.052.265.116.39.189.235.144.362.287.384.439.021.151-.064.287-.256.401a1.16 1.16 0 01-.277.128.977.977 0 01-.305.068 2.23 2.23 0 01-.327 0H320.19l1.221.757-.284.136z"
                fill="#3A3A3A"
            />
            <path
                d="M327.198 392.102l-3.855-2.376a.354.354 0 01-.128-.135.39.39 0 010-.372.364.364 0 01.128-.136l2.499-1.513a.328.328 0 01.348 0l3.848 2.338a.383.383 0 01.128.507.357.357 0 01-.128.136l-2.499 1.513a.321.321 0 01-.341.038z"
                fill="#0EA59D"
            />
            <path
                d="M327.355 392.231a.414.414 0 01-.213-.061l-3.856-2.375a.442.442 0 01-.144-.162.476.476 0 010-.433.442.442 0 01.144-.162l2.5-1.513a.429.429 0 01.426 0l3.826 2.315c.061.04.11.096.145.162a.475.475 0 010 .433.444.444 0 01-.145.162l-2.492 1.513a.472.472 0 01-.191.121zm-1.356-4.668a.31.31 0 00-.142 0l-2.5 1.551a.313.313 0 00-.098.404.29.29 0 00.098.11l3.841 2.406a.26.26 0 00.277 0l2.5-1.513a.289.289 0 00.103-.108.321.321 0 00.039-.149.344.344 0 00-.04-.148.297.297 0 00-.102-.109l-3.842-2.406a.223.223 0 00-.134-.038z"
                fill="#3A3A3A"
            />
            <path
                d="M327.398 390.233a.292.292 0 01-.043.174.563.563 0 01-.213.19 1.027 1.027 0 01-.333.136c-.126.03-.255.045-.384.045a1.93 1.93 0 01-.426-.068 1.684 1.684 0 01-.39-.181 1.448 1.448 0 01-.327-.258 2.656 2.656 0 01-.206-.242l.32-.196c.054.1.116.197.184.287.14.164.319.285.519.348a.712.712 0 00.269.053c.085.008.171.008.256 0 .082-.025.161-.061.234-.106a.483.483 0 00.164-.151.191.191 0 000-.136.308.308 0 00-.1-.144 1.336 1.336 0 00-.192-.144l-.142-.083.256-.151.107.06c.139.092.297.149.461.167a.632.632 0 00.426-.084.306.306 0 00.107-.113.18.18 0 000-.121.308.308 0 00-.086-.121 1.154 1.154 0 00-.156-.114 1.848 1.848 0 00-.355-.151 2.848 2.848 0 00-.454-.106.823.823 0 01.71-.076c.135.05.266.113.39.19.094.055.182.121.263.196.06.052.106.12.135.197a.309.309 0 010 .212.442.442 0 01-.185.181.829.829 0 01-.461.121 1.16 1.16 0 01-.497-.083c.049.036.09.082.12.136a.4.4 0 01.029.136z"
                fill="#3A3A3A"
            />
            <path
                d="M326.488 385.869l-3.855-2.368a.378.378 0 01-.174-.326.378.378 0 01.174-.325l2.499-1.551a.355.355 0 01.348 0l3.848 2.376a.361.361 0 01.128.135.39.39 0 010 .372.372.372 0 01-.128.136l-2.499 1.513a.333.333 0 01-.166.068.33.33 0 01-.175-.03z"
                fill="#0EA59D"
            />
            <path
                d="M326.667 385.997a.408.408 0 01-.206-.06l-3.855-2.376a.415.415 0 01-.158-.161.456.456 0 01-.055-.224.461.461 0 01.213-.394l2.499-1.513a.39.39 0 01.419 0l3.855 2.368a.463.463 0 010 .757l-2.499 1.55a.411.411 0 01-.213.053zm-1.349-4.667a.31.31 0 00-.142 0l-2.499 1.513a.284.284 0 00-.104.108.309.309 0 000 .298.284.284 0 00.104.108l3.855 2.368a.263.263 0 00.277 0l2.499-1.513a.318.318 0 00.142-.257.306.306 0 00-.038-.149.284.284 0 00-.104-.108l-3.855-2.376a.294.294 0 00-.135.008z"
                fill="#3A3A3A"
            />
            <path
                d="M326.339 384.37c-.113.069-.235.12-.362.152-.13.032-.264.05-.398.053a2.124 2.124 0 01-.426-.061 1.784 1.784 0 01-.724-.431 1.147 1.147 0 01-.199-.234l.32-.197a1.1 1.1 0 00.156.265c.08.093.173.173.277.234a.785.785 0 00.241.106c.093.031.188.048.284.053a.997.997 0 00.256 0c.086-.025.17-.061.249-.106a.46.46 0 00.156-.151.199.199 0 000-.144.302.302 0 00-.114-.166 1.19 1.19 0 00-.227-.174l-.277-.152-.213-.136 1.051-.65a.211.211 0 01.213 0l1.264.756-.27.159-.966-.59a.177.177 0 00-.213 0l-.49.302.142.076.121.068c.105.061.202.135.291.22a.556.556 0 01.149.227.326.326 0 010 .249.718.718 0 01-.291.272z"
                fill="#3A3A3A"
            />
            <path
                d="M331.16 382.972l-3.855-2.368a.378.378 0 01-.174-.326.378.378 0 01.174-.325l2.499-1.513a.336.336 0 01.348 0l3.855 2.376a.361.361 0 01.128.135.39.39 0 010 .372.372.372 0 01-.128.136l-2.499 1.513a.328.328 0 01-.348 0z"
                fill="#0EA59D"
            />
            <path
                d="M331.331 383.1a.445.445 0 01-.213-.061l-3.848-2.375a.405.405 0 01-.157-.161.45.45 0 01-.056-.225.464.464 0 01.056-.228.423.423 0 01.157-.165l2.492-1.513a.394.394 0 01.426 0l3.855 2.368a.46.46 0 01.144.594.433.433 0 01-.144.162l-2.499 1.551a.411.411 0 01-.213.053zm-.135-.197a.263.263 0 00.277 0l2.499-1.513a.31.31 0 00.135-.257.301.301 0 00-.034-.148.28.28 0 00-.101-.109l-3.855-2.376a.272.272 0 00-.139-.039.272.272 0 00-.138.039l-2.499 1.513a.287.287 0 00-.104.109.317.317 0 000 .298.291.291 0 00.104.108l3.855 2.375z"
                fill="#3A3A3A"
            />
            <path
                d="M330.92 381.534c-.22.118-.465.171-.71.152a1.531 1.531 0 01-.774-.235c-.242-.151-.377-.31-.398-.477-.021-.166.071-.31.27-.431a.999.999 0 01.447-.144 1.75 1.75 0 01.554.046.434.434 0 01-.057-.295.397.397 0 01.076-.14.355.355 0 01.123-.095c.194-.108.414-.153.632-.128.249.015.492.09.71.219.22.144.348.288.376.439.029.151-.042.272-.206.378a.966.966 0 01-.397.121 1.333 1.333 0 01-.519 0 .49.49 0 01.107.341c-.021.068-.099.158-.234.249zm-.348-.181a.304.304 0 00.163-.174.372.372 0 00-.012-.133.34.34 0 00-.059-.117l-.092-.136c-.043-.046-.093-.114-.149-.189a1.338 1.338 0 00-.419 0 .987.987 0 00-.377.128c-.137.086-.201.184-.191.295 0 .114.078.212.22.303a.979.979 0 00.476.151.733.733 0 00.44-.128zm1.086-.757a.22.22 0 00.105-.097.243.243 0 00.03-.145.46.46 0 00-.227-.257.988.988 0 00-.405-.136.584.584 0 00-.369.075.268.268 0 00-.128.159.264.264 0 00.043.197l.092.144c.041.061.086.119.135.174.139.023.28.023.419 0 .104-.01.207-.036.305-.076v-.038z"
                fill="#3A3A3A"
            />
            <path
                d="M336.507 386.308l-3.856-2.376a.357.357 0 01-.128-.136.393.393 0 010-.371.372.372 0 01.128-.136l2.5-1.52a.316.316 0 01.347 0l3.856 2.375a.364.364 0 01.128.136.394.394 0 010 .371.357.357 0 01-.128.136l-2.499 1.521a.324.324 0 01-.348 0z"
                fill="#0EA59D"
            />
            <path
                d="M336.678 386.436a.455.455 0 01-.213-.06l-3.849-2.338a.442.442 0 01-.144-.162.475.475 0 010-.433.45.45 0 01.144-.162l2.493-1.513a.429.429 0 01.426 0l3.855 2.27c.06.04.11.096.144.162a.475.475 0 010 .432.433.433 0 01-.144.162l-2.499 1.513a.373.373 0 01-.213.129zm-1.356-4.668a.239.239 0 00-.135 0l-2.5 1.513a.328.328 0 00-.142.258.321.321 0 00.039.149c.025.045.06.082.103.108l3.856 2.375a.263.263 0 00.277 0l2.499-1.513a.28.28 0 00.101-.109.313.313 0 00.034-.148.326.326 0 00-.035-.148.284.284 0 00-.1-.109l-3.855-2.368a.238.238 0 00-.142-.008z"
                fill="#3A3A3A"
            />
            <path
                d="M337.01 384.477a3.386 3.386 0 01-.582.317c-.2.068-.408.112-.618.129a2.415 2.415 0 01-.617-.053 2.045 2.045 0 01-.582-.242l-.142-.099a.57.57 0 01-.1-.09l.291-.182a.701.701 0 00.242.227c.215.133.46.204.71.204.284-.009.563-.087.816-.227a2.11 2.11 0 01-.383-.09 1.528 1.528 0 01-.313-.144 1.304 1.304 0 01-.227-.174.509.509 0 01-.121-.204.307.307 0 01-.013-.141.306.306 0 01.049-.132.766.766 0 01.27-.249c.225-.136.479-.207.738-.205a1.43 1.43 0 01.774.212.792.792 0 01.256.22.37.37 0 01.092.242.475.475 0 01-.121.317 1.653 1.653 0 01-.419.364zm-.241-.235c.121-.066.232-.153.327-.257a.318.318 0 00.085-.22.27.27 0 00-.057-.158.702.702 0 00-.149-.129.948.948 0 00-.483-.129c-.18.01-.355.064-.511.159a.692.692 0 00-.192.174.204.204 0 000 .182.254.254 0 00.092.128.689.689 0 00.164.121.933.933 0 00.277.129c.103.04.21.068.319.083h.064l.064-.083z"
                fill="#3A3A3A"
            />
            <path
                d="M331.843 389.205l-3.856-2.375a.364.364 0 01-.128-.136.395.395 0 010-.371.357.357 0 01.128-.136l2.499-1.513a.324.324 0 01.348 0l3.856 2.375a.372.372 0 01.174.322.4.4 0 01-.046.186.361.361 0 01-.128.135l-2.5 1.513a.316.316 0 01-.347 0z"
                fill="#0EA59D"
            />
            <path
                d="M332.012 389.333a.405.405 0 01-.206-.06l-3.856-2.376a.442.442 0 01-.144-.162.471.471 0 010-.432.442.442 0 01.144-.162l2.5-1.513a.418.418 0 01.419 0l3.855 2.375c.06.04.11.096.144.162a.475.475 0 010 .433.433.433 0 01-.144.162l-2.499 1.513a.416.416 0 01-.213.06zm-.135-.196c.042.025.09.039.138.039a.272.272 0 00.139-.039l2.499-1.513a.306.306 0 000-.515l-3.855-2.368a.266.266 0 00-.277 0l-2.5 1.551a.289.289 0 00-.103.108.321.321 0 00-.039.149.344.344 0 00.04.148c.025.045.06.083.102.11l3.856 2.33z"
                fill="#3A3A3A"
            />
            <path
                d="M331.855 387.661c-.241.14-.513.211-.788.205-.273 0-.541-.073-.781-.212a.944.944 0 01-.248-.22.405.405 0 01-.093-.242.533.533 0 01.135-.332c.121-.143.266-.261.426-.348a2.67 2.67 0 011.214-.417 2.14 2.14 0 01.618.046c.206.055.404.139.589.249l.142.099a.365.365 0 01.093.091l-.284.174a.737.737 0 00-.086-.106l-.156-.121a1.347 1.347 0 00-.71-.197 1.792 1.792 0 00-.774.204c.126.015.249.043.37.083.114.035.224.086.326.152a.98.98 0 01.227.174.414.414 0 01.121.204.353.353 0 010 .265.806.806 0 01-.341.249zm-.319-.189a.466.466 0 00.184-.166.24.24 0 00.019-.091.24.24 0 00-.019-.091.285.285 0 00-.092-.136 1.262 1.262 0 00-.433-.25 3.33 3.33 0 00-.327-.083l-.064.038-.085.045a1.295 1.295 0 00-.326.265.378.378 0 00-.086.22.313.313 0 00.057.151.555.555 0 00.149.129.816.816 0 00.476.128.967.967 0 00.547-.159z"
                fill="#3A3A3A"
            />
            <path
                d="M321.149 382.608l-3.855-2.353a.361.361 0 01-.128-.135.39.39 0 010-.372.372.372 0 01.128-.136l2.499-1.55a.32.32 0 01.348 0l3.855 2.375a.383.383 0 01.128.507.35.35 0 01-.128.136l-2.499 1.513a.326.326 0 01-.172.059.332.332 0 01-.176-.044z"
                fill="#0EA59D"
            />
            <path
                d="M321.32 382.729a.348.348 0 01-.206-.061l-3.855-2.367a.441.441 0 01-.144-.162.475.475 0 010-.433.433.433 0 01.144-.162l2.499-1.513a.423.423 0 01.419 0l3.855 2.376c.066.037.12.093.158.161a.456.456 0 01.055.224.461.461 0 01-.213.394l-2.499 1.513a.348.348 0 01-.213.03zm-1.349-4.66a.23.23 0 00-.142 0l-2.499 1.513a.272.272 0 00-.104.106.305.305 0 000 .295.279.279 0 00.104.106l3.855 2.436a.263.263 0 00.277 0l2.499-1.513a.279.279 0 00.135-.257.302.302 0 00-.135-.258l-3.862-2.39a.234.234 0 00-.128-.038z"
                fill="#3A3A3A"
            />
            <path
                d="M320.809 381.012l-.341-.204-.632.393-.291-.189.639-.393-1.086-.666.106-.068c.156-.097.331-.152.511-.159l1.804-.076c.211-.009.42.046.603.159l-1.377.848.341.211-.277.144zm-.391-.537l1.016-.62-1.896.083.88.537z"
                fill="#3A3A3A"
            />
            <path
                d="M325.779 379.711l-3.848-2.376a.354.354 0 01-.128-.135.39.39 0 010-.372.364.364 0 01.128-.136l2.492-1.551a.339.339 0 01.355 0l3.855 2.368a.367.367 0 01.127.138.397.397 0 010 .375.367.367 0 01-.127.138l-2.499 1.513a.381.381 0 01-.173.065.379.379 0 01-.182-.027z"
                fill="#0EA59D"
            />
            <path
                d="M325.984 379.832a.387.387 0 01-.213-.061l-3.848-2.368a.433.433 0 01-.144-.162.471.471 0 010-.432.433.433 0 01.144-.162l2.492-1.513a.413.413 0 01.426 0l3.855 2.375c.061.04.11.096.145.162a.479.479 0 010 .433.436.436 0 01-.145.162l-2.499 1.513a.355.355 0 01-.213.053zm-.135-.189a.263.263 0 00.277 0l2.499-1.513a.284.284 0 00.099-.11.314.314 0 000-.295.284.284 0 00-.099-.11l-3.855-2.368a.262.262 0 00-.277 0l-2.499 1.513a.306.306 0 00-.103.407c.025.045.06.082.103.108l3.855 2.368z"
                fill="#3A3A3A"
            />
            <path
                d="M326.922 377.479l-2.947.552-.327-.204 3.082-.553-1.292-.756.269-.166 1.548.96-.333.167z"
                fill="#3A3A3A"
            />
            <path
                d="M322.513 395l-3.834-2.375a.364.364 0 01-.128-.136.39.39 0 010-.372.354.354 0 01.128-.135l2.499-1.513a.33.33 0 01.355 0l3.848 2.375a.383.383 0 01.128.507.357.357 0 01-.128.136L322.882 395a.342.342 0 01-.369 0z"
                fill="#0EA59D"
            />
            <path
                d="M322.69 395.129a.411.411 0 01-.213-.061l-3.856-2.375a.434.434 0 01-.155-.163.478.478 0 01-.058-.223.494.494 0 01.058-.227.453.453 0 01.155-.167l2.499-1.513a.415.415 0 01.426 0l3.849 2.376a.434.434 0 01.156.162.489.489 0 01.003.45.445.445 0 01-.152.167l-2.499 1.513a.44.44 0 01-.213.061zm-.142-.197a.274.274 0 00.284 0l2.492-1.551a.288.288 0 00.142-.257.307.307 0 00-.142-.257l-3.856-2.368a.263.263 0 00-.277 0l-2.499 1.513a.313.313 0 00-.098.404.29.29 0 00.098.11l3.856 2.406z"
                fill="#3A3A3A"
            />
            <path
                d="M322.391 393.6l-1.803-1.112.22-.129 1.81 1.112-.227.129zm.639-.393l-1.81-1.112.241-.152 1.811 1.112-.242.152z"
                fill="#3A3A3A"
            />
            <path
                d="M327.81 398.223l-3.5-2.149a.537.537 0 01-.191-.207.594.594 0 01.191-.769l6.809-4.251a.493.493 0 01.532 0l3.493 2.156a.537.537 0 01.196.205.59.59 0 010 .565.547.547 0 01-.196.206l-6.802 4.221a.485.485 0 01-.532.023z"
                fill="#0EA59D"
            />
            <path
                d="M328.071 398.411a.536.536 0 01-.298-.091l-3.5-2.178a.637.637 0 01-.217-.235.686.686 0 01-.005-.641.61.61 0 01.222-.237l6.809-4.183a.546.546 0 01.603 0l3.494 2.148c.092.055.17.135.223.232a.677.677 0 01.002.643.633.633 0 01-.218.238l-6.809 4.221a.556.556 0 01-.306.083zm3.309-7.565a.417.417 0 00-.227.061l-6.795 4.259a.467.467 0 00-.167.177.508.508 0 000 .485c.04.074.098.135.167.177l3.5 2.156a.45.45 0 00.455 0l6.809-4.228a.501.501 0 00.227-.424.496.496 0 00-.06-.242.458.458 0 00-.167-.174l-3.501-2.156a.415.415 0 00-.241-.091z"
                fill="#3A3A3A"
            />
            <path
                d="M330.593 395.211l-.831-.507-.824.507-.255-.159.823-.507-.83-.506.248-.152.831.515.824-.53.255.159-.795.522.831.514-.277.144zM333.354 402.141l-3.87-2.383a.377.377 0 010-.628l2.513-1.558a.31.31 0 01.341 0l3.877 2.352a.36.36 0 01.169.314.376.376 0 01-.045.181.353.353 0 01-.124.133l-2.521 1.559a.31.31 0 01-.34.03z"
                fill="#3A3A3A"
            />
            <path
                d="M333.355 401.657l-3.87-2.376a.387.387 0 01-.123-.5.356.356 0 01.123-.135l2.514-1.559a.348.348 0 01.34 0l3.877 2.383a.36.36 0 01.169.314.376.376 0 01-.045.181.353.353 0 01-.124.133l-2.521 1.559a.313.313 0 01-.34 0z"
                fill="#0EA59D"
            />
            <path
                d="M333.524 401.785a.405.405 0 01-.206-.06l-3.87-2.383a.42.42 0 01-.151-.159.462.462 0 01-.055-.219.465.465 0 01.053-.224.412.412 0 01.153-.162l2.514-1.559a.404.404 0 01.411 0l3.877 2.383a.45.45 0 01.15.165.46.46 0 01.001.44.406.406 0 01-.151.159l-2.513 1.559a.44.44 0 01-.213.06zm-1.356-4.667a.307.307 0 00-.135 0l-2.514 1.596a.278.278 0 00-.099.105.303.303 0 000 .289c.024.044.058.08.099.105l3.87 2.383a.28.28 0 00.27 0l2.52-1.558a.287.287 0 00.093-.108.327.327 0 00.035-.142.287.287 0 00-.135-.249l-3.87-2.383a.21.21 0 00-.134-.038z"
                fill="#3A3A3A"
            />
            <path
                d="M331.87 399.856l-.241-.151 1.541-.946-1.548.341-.142-.091.554-.946-1.541.946-.227-.136 1.789-1.105.326.205-.518.907 1.463-.325.333.204-1.789 1.097zM334.569 400.68l-.66-.408-.654.401-.198-.121.653-.401-.653-.409.191-.113.654.401.653-.401.206.121-.661.408.661.401-.192.121z"
                fill="#3A3A3A"
            />
            <path
                d="M338.019 398.76l-3.87-2.376a.388.388 0 01-.123-.5.356.356 0 01.123-.135l2.514-1.559a.32.32 0 01.17-.048.32.32 0 01.17.048l3.87 2.383a.36.36 0 01.169.314.36.36 0 01-.169.314l-2.514 1.559a.313.313 0 01-.34 0z"
                fill="#0EA59D"
            />
            <path
                d="M338.189 398.888a.4.4 0 01-.206-.061l-3.87-2.383a.425.425 0 01-.154-.158.467.467 0 01-.059-.22c0-.079.02-.156.057-.224a.434.434 0 01.156-.162l2.514-1.558a.407.407 0 01.412 0l3.869 2.383c.065.037.12.093.157.161a.45.45 0 01.056.225.458.458 0 01-.055.218.423.423 0 01-.151.16l-2.52 1.558a.402.402 0 01-.206.061zm-.135-.189a.29.29 0 00.27 0l2.513-1.559a.277.277 0 00.096-.102.29.29 0 00.004-.284.266.266 0 00-.1-.105l-3.869-2.383a.25.25 0 00-.27 0l-2.514 1.558a.285.285 0 00-.099.105.303.303 0 000 .289c.024.044.058.08.099.105l3.87 2.376z"
                fill="#3A3A3A"
            />
            <path
                d="M336.777 397.103l-.234-.144 1.533-.946-1.54.333-.149-.091.553-.945-1.54.945-.22-.113 1.782-1.097.326.197-.511.9 1.456-.325.333.204-1.789 1.082zM338.629 397.413l-.781-.461.22-.137.752.469-.191.129z"
                fill="#3A3A3A"
            />
            <path
                d="M342.683 395.862l-3.87-2.376a.356.356 0 01-.123-.135.387.387 0 01.123-.5l2.521-1.559a.313.313 0 01.341 0l3.869 2.383a.353.353 0 01.124.133.38.38 0 010 .362.353.353 0 01-.124.133l-2.513 1.559a.312.312 0 01-.348 0z"
                fill="#0EA59D"
            />
            <path
                d="M342.855 395.99a.408.408 0 01-.206-.06l-3.877-2.383a.42.42 0 01-.151-.159.462.462 0 01.151-.605l2.521-1.558a.398.398 0 01.412 0l3.869 2.382a.436.436 0 01.149.161.466.466 0 010 .436.433.433 0 01-.149.16l-2.513 1.558a.395.395 0 01-.206.068zm-1.356-4.667a.21.21 0 00-.135.038l-2.514 1.558a.285.285 0 00-.099.105.303.303 0 000 .289c.024.044.058.08.099.105l3.87 2.376a.25.25 0 00.27 0l2.513-1.559a.26.26 0 00.099-.101.284.284 0 00.036-.141.29.29 0 00-.035-.144.266.266 0 00-.1-.105l-3.869-2.383a.214.214 0 00-.135-.038z"
                fill="#3A3A3A"
            />
            <path
                d="M341.001 393.668l-.185-.114 1.2-.756-1.207.257-.121-.045.426-.757-1.199.757-.171-.106 1.42-.855.256.151-.405.711 1.136-.257.263.159-1.413.855zM342.875 393.774l-.057-.06a.426.426 0 00-.085-.061.747.747 0 00-.191-.076h-.242l-.71.454-.192-.158 1.044-.644.171.106-.15.099h.306c.07.017.137.045.199.083h.063l.05.045-.206.212zM343.386 395.007H343.102l-.157-.06-.127-.151a.963.963 0 01-.235-.197.32.32 0 01-.085-.212.378.378 0 01.085-.227.993.993 0 01.27-.227c.109-.073.229-.127.355-.159.104-.031.211-.049.32-.053a1.283 1.283 0 01.88.341.915.915 0 01.156.212l-.22.136a.606.606 0 00-.085-.227.73.73 0 00-.206-.174.835.835 0 00-.22-.099 1.052 1.052 0 00-.263 0 1.382 1.382 0 00-.277.046 1.195 1.195 0 00-.284.136.615.615 0 00-.213.174.404.404 0 00-.071.174.25.25 0 00.057.151.46.46 0 00.149.136c.093.059.194.102.298.129.119.03.24.048.362.053l-.205.098z"
                fill="#3A3A3A"
            />
            <path
                d="M337.23 392.488l-3.869-2.398a.377.377 0 010-.628l2.52-1.558a.31.31 0 01.341 0l3.87 2.383a.358.358 0 01.169.314.36.36 0 01-.169.314l-2.514 1.558a.315.315 0 01-.348.015z"
                fill="#0EA59D"
            />
            <path
                d="M337.401 392.617a.412.412 0 01-.206-.061l-3.877-2.383a.422.422 0 01-.148-.16.461.461 0 010-.436.415.415 0 01.148-.16l2.521-1.597a.372.372 0 01.412 0l3.869 2.383a.43.43 0 01.155.159.463.463 0 01.001.444.423.423 0 01-.156.161l-2.513 1.559a.422.422 0 01-.206.091zm-.135-.197a.25.25 0 00.27 0l2.513-1.574a.28.28 0 00.1-.105.303.303 0 000-.289.288.288 0 00-.1-.105l-3.869-2.383a.269.269 0 00-.27 0l-2.514 1.558a.27.27 0 00-.099.102.284.284 0 00-.035.141c-.002.05.01.101.033.145.024.044.059.08.101.104l3.87 2.406z"
                fill="#3A3A3A"
            />
            <path
                d="M337.188 390.528l-.952-.582.277-.167.952.583-.277.166z"
                fill="#3A3A3A"
            />
            <path
                d="M341.896 389.591l-3.869-2.383a.377.377 0 010-.628l2.52-1.558a.31.31 0 01.341 0l3.87 2.383a.36.36 0 01.169.314.36.36 0 01-.169.314l-2.514 1.558a.31.31 0 01-.348 0z"
                fill="#0EA59D"
            />
            <path
                d="M342.066 389.712a.432.432 0 01-.213-.053l-3.87-2.383a.44.44 0 01-.15-.164.487.487 0 01-.056-.222.47.47 0 01.056-.218.435.435 0 01.15-.16l2.514-1.558a.381.381 0 01.419 0l3.869 2.383a.42.42 0 01.151.159.45.45 0 01.055.219.453.453 0 01-.053.223.414.414 0 01-.153.163l-2.513 1.558a.396.396 0 01-.206.053zm-1.378-4.667a.258.258 0 00-.135 0l-2.52 1.558a.289.289 0 00-.095.107.308.308 0 00-.034.143.3.3 0 00.129.249l3.869 2.383a.25.25 0 00.27 0l2.514-1.558a.285.285 0 00.099-.105.303.303 0 000-.289.278.278 0 00-.099-.105l-3.87-2.383a.277.277 0 00-.128 0z"
                fill="#3A3A3A"
            />
            <path
                d="M341.896 387.956h-.263l-.234-.499-.533.341-.177-.121.553-.326-.873-.143.064-.159.895.159-.263-.553h.263l.234.537.532-.34.199.121-.561.333.881.136-.071.166-.888-.166.242.514z"
                fill="#3A3A3A"
            />
            <path
                d="M346.553 386.693l-3.87-2.383a.358.358 0 01-.169-.314.38.38 0 01.045-.181.35.35 0 01.124-.132l2.514-1.559a.324.324 0 01.348 0l3.869 2.376a.36.36 0 01.124.135.392.392 0 010 .365.375.375 0 01-.124.135l-2.513 1.558a.354.354 0 01-.348 0z"
                fill="#0EA59D"
            />
            <path
                d="M346.723 386.815a.403.403 0 01-.206-.053l-3.87-2.383a.447.447 0 01-.15-.164.462.462 0 01-.001-.441.42.42 0 01.151-.159l2.514-1.559a.39.39 0 01.419 0l3.869 2.383a.448.448 0 01.206.379.47.47 0 01-.206.385l-2.513 1.559a.411.411 0 01-.213.053zm-.128-.189a.25.25 0 00.27 0l2.513-1.559a.28.28 0 00.1-.105.303.303 0 000-.289.28.28 0 00-.1-.105l-3.869-2.383a.279.279 0 00-.135-.034.279.279 0 00-.135.034l-2.521 1.558a.303.303 0 00-.135.25.303.303 0 00.135.25l3.877 2.383z"
                fill="#3A3A3A"
            />
            <path
                d="M348.392 384.295l-3.607.832-.135-.083.774-1.082-.305-.189.177-.106.512.31-.646.893 3.01-.704.22.129z"
                fill="#3A3A3A"
            />
            <path
                d="M341.172 383.41l-3.87-2.398a.36.36 0 01-.169-.314.36.36 0 01.169-.314l2.514-1.558a.306.306 0 01.341 0l3.876 2.383a.336.336 0 01.124.132.38.38 0 010 .363.342.342 0 01-.124.132l-2.52 1.559a.316.316 0 01-.169.059.316.316 0 01-.172-.044z"
                fill="#0EA59D"
            />
            <path
                d="M341.342 383.539a.402.402 0 01-.206-.061l-3.869-2.383a.415.415 0 01-.151-.16.455.455 0 01-.055-.218.435.435 0 01.206-.386l2.513-1.588a.38.38 0 01.412 0l3.876 2.383a.408.408 0 01.152.159.467.467 0 01-.152.605l-2.52 1.558a.413.413 0 01-.206.091zm-1.363-4.675a.28.28 0 00-.135 0l-2.513 1.558a.3.3 0 00-.135.25.28.28 0 00.135.249l3.869 2.383a.25.25 0 00.27 0l2.527-1.535a.3.3 0 00.128-.25.29.29 0 00-.035-.145.266.266 0 00-.1-.105l-3.869-2.368a.277.277 0 00-.142-.037z"
                fill="#3A3A3A"
            />
            <path
                d="M342.109 380.883l-2.904.552-.213-.128 2.904-.552.213.128zm-1.42-.219c-.165.11-.353.175-.547.189a.856.856 0 01-.49-.129c-.156-.098-.227-.204-.213-.31.015-.106.114-.212.306-.333.165-.107.353-.169.546-.181a.827.827 0 01.49.128c.157.091.22.197.206.303-.014.106-.106.219-.298.333zm-.227-.144a.558.558 0 00.248-.219c0-.061 0-.114-.099-.167a.413.413 0 00-.277-.068 1.136 1.136 0 00-.355.189c-.149.091-.234.167-.248.22-.015.053 0 .121.099.174.082.049.176.07.27.06.133-.038.258-.102.369-.189h-.007zm.88 1.589a1.081 1.081 0 01-.539.189.892.892 0 01-.497-.129c-.149-.098-.22-.196-.213-.31.007-.113.12-.212.305-.325.165-.11.353-.175.547-.189a.863.863 0 01.49.128c.156.099.227.197.213.303-.015.106-.107.219-.299.333h-.007zm-.227-.136c.149-.091.234-.167.249-.227.014-.061 0-.114-.093-.167a.416.416 0 00-.277-.06.909.909 0 00-.369.151.602.602 0 00-.248.227c0 .053 0 .113.106.166.08.055.176.076.27.061.131-.026.256-.077.369-.151h-.007z"
                fill="#3A3A3A"
            />
            <path
                d="M335.824 380.074l-3.869-2.383a.345.345 0 01-.124-.133.38.38 0 010-.363.342.342 0 01.124-.132l2.513-1.559a.314.314 0 01.341 0l3.869 2.383a.355.355 0 01.125.133.391.391 0 010 .362.355.355 0 01-.125.133l-2.52 1.559a.32.32 0 01-.167.048.32.32 0 01-.167-.048z"
                fill="#0EA59D"
            />
            <path
                d="M335.996 380.202a.41.41 0 01-.206-.06l-3.869-2.383a.432.432 0 01-.206-.378.454.454 0 01.053-.224.412.412 0 01.153-.162l2.513-1.559a.406.406 0 01.412 0l3.877 2.383a.455.455 0 010 .757l-2.521 1.558a.404.404 0 01-.206.068zm-.135-.196a.252.252 0 00.27 0l2.514-1.559a.28.28 0 00.134-.242.29.29 0 00-.033-.145.266.266 0 00-.101-.104l-3.87-2.383a.25.25 0 00-.27 0l-2.513 1.558a.28.28 0 00-.1.105.303.303 0 00.1.394l3.869 2.376z"
                fill="#3A3A3A"
            />
            <path
                d="M337.138 377.471l-3.401.923-.227-.144 3.394-.923.234.144zM335.719 377.275l-.553-.34-.554.333-.171-.099.554-.34-.525-.356.156-.098.561.34.547-.34.17.106-.554.333.561.348-.192.113zM335.618 379.174l-.61-.393.177-.106.639.386-.206.113z"
                fill="#3A3A3A"
            />
            <path
                d="M330.493 376.821l-3.934-2.42a.331.331 0 01-.113-.122.356.356 0 010-.332.321.321 0 01.113-.121l2.578-1.597a.289.289 0 01.312 0l3.933 2.421c.047.03.087.071.114.122a.352.352 0 010 .331.32.32 0 01-.114.122l-2.577 1.596a.29.29 0 01-.312 0z"
                fill="#0EA59D"
            />
            <path
                d="M330.649 376.942a.355.355 0 01-.192-.053l-3.933-2.421a.391.391 0 01-.142-.149.421.421 0 01-.05-.206c0-.071.017-.141.051-.202a.374.374 0 01.141-.146l2.577-1.596a.349.349 0 01.383 0l3.934 2.413a.412.412 0 01.133.164c.03.067.043.141.037.214a.421.421 0 01-.05.206.391.391 0 01-.141.15l-2.578 1.596a.332.332 0 01-.17.03zm-.121-.189a.229.229 0 00.242 0l2.577-1.596a.26.26 0 00.089-.347.232.232 0 00-.089-.092l-3.934-2.421a.232.232 0 00-.241 0l-2.577 1.596a.262.262 0 00-.114.22.259.259 0 00.028.126c.02.039.05.071.086.093l3.933 2.421z"
                fill="#3A3A3A"
            />
            <path
                d="M329.791 375.64l-.213-.045-.249-.068-.241-.091a2.525 2.525 0 01-.248-.128 1.33 1.33 0 01-.363-.311.5.5 0 01-.127-.332.602.602 0 01.127-.348 1.44 1.44 0 01.419-.348 2.095 2.095 0 011.122-.333 2 2 0 01.554.075c.177.046.347.12.504.22.112.068.217.149.312.242.091.097.17.207.235.325l-.341.212a1.92 1.92 0 00-.156-.363.887.887 0 00-.313-.272 1.16 1.16 0 00-.348-.152 1.135 1.135 0 00-.397-.045 1.87 1.87 0 00-.873.272c-.125.07-.236.165-.327.28a.5.5 0 00-.114.265.403.403 0 00.086.242.962.962 0 00.234.212c.144.087.299.151.461.189.19.045.382.078.575.098l-.319.204z"
                fill="#3A3A3A"
            />
            <path
                d="M351.992 390.089l-3.813-2.345a.393.393 0 01-.134-.146.424.424 0 010-.396.393.393 0 01.134-.146l2.45-1.506a.353.353 0 01.188-.056.35.35 0 01.188.056l3.813 2.345a.397.397 0 01.184.341.413.413 0 01-.049.196.382.382 0 01-.135.144l-2.457 1.513a.363.363 0 01-.369 0z"
                fill="#0EA59D"
            />
            <path
                d="M352.184 390.219a.428.428 0 01-.227-.068l-3.813-2.331a.455.455 0 01-.162-.172.494.494 0 01.162-.645l2.457-1.513a.431.431 0 01.447 0l3.841 2.33a.452.452 0 01.163.173.49.49 0 01.057.236.485.485 0 01-.056.237.442.442 0 01-.164.171l-2.457 1.514a.421.421 0 01-.248.068zm-1.356-4.668a.298.298 0 00-.156.045l-2.457 1.513a.325.325 0 00-.109.115.331.331 0 00.001.318c.026.049.063.09.108.12l3.834 2.36a.301.301 0 00.298 0l2.457-1.513a.329.329 0 00.108-.12.334.334 0 00.001-.318.299.299 0 00-.109-.114l-3.813-2.346a.296.296 0 00-.163-.06z"
                fill="#3A3A3A"
            />
            <path
                d="M350.579 388.267l-.184-.046-.199-.053-.213-.075a1.453 1.453 0 01-.213-.114 1.165 1.165 0 01-.313-.265.439.439 0 01-.113-.287.506.506 0 01.113-.303 1.717 1.717 0 01.838-.514c.16-.048.324-.073.49-.076.161 0 .321.023.476.068.155.039.303.103.44.189.097.056.186.128.263.212.083.082.155.176.213.28l-.299.182a.777.777 0 00-.12-.303.972.972 0 00-.27-.234 1.036 1.036 0 00-.298-.129 1.07 1.07 0 00-.348 0 1.331 1.331 0 00-.376.06 1.717 1.717 0 00-.377.174 1.014 1.014 0 00-.284.243.386.386 0 00-.092.227.304.304 0 00.071.211.82.82 0 00.199.182c.127.073.263.129.404.166.156.04.316.063.476.068l-.284.137zM352.048 389.333l-1.236-.756 1.868-1.15 1.235.756-.22.129-.987-.605-.511.317.987.606-.22.136-.987-.605-.71.423.987.605-.206.144z"
                fill="#3A3A3A"
            />
            <path
                d="M347.349 392.964l-3.877-2.383a.36.36 0 01-.169-.314.36.36 0 01.169-.314l2.521-1.558a.31.31 0 01.341 0l3.869 2.383a.377.377 0 010 .628l-2.513 1.558a.31.31 0 01-.341 0z"
                fill="#0EA59D"
            />
            <path
                d="M347.519 393.116a.41.41 0 01-.206-.06l-3.877-2.383a.427.427 0 01-.151-.159.462.462 0 01.151-.605l2.521-1.559a.406.406 0 01.412 0l3.869 2.383a.454.454 0 01.203.379.46.46 0 01-.054.218.433.433 0 01-.149.16l-2.513 1.558a.395.395 0 01-.206.068zm-.135-.196a.25.25 0 00.27 0l2.513-1.559a.28.28 0 00.135-.249.284.284 0 00-.036-.141.26.26 0 00-.099-.101l-3.869-2.406a.25.25 0 00-.27 0l-2.499 1.558a.3.3 0 00-.128.25.29.29 0 00.035.145c.024.044.058.08.1.105l3.848 2.398z"
                fill="#3A3A3A"
            />
            <path
                d="M346.149 391.429l-.362-.219.412-.258.369.22-.419.257zm1.633-.045l-1.917-1.18.242-.152 1.917 1.18-.242.152zm-.099-.901l-.362-.219.419-.257.362.219-.419.257z"
                fill="#3A3A3A"
            />
            <path
                d="M317.166 391.664l-3.855-2.33a.37.37 0 01-.128-.138.404.404 0 010-.374.37.37 0 01.128-.138l2.499-1.513a.347.347 0 01.355 0l3.848 2.375a.393.393 0 010 .651l-2.492 1.513a.34.34 0 01-.355-.046z"
                fill="#0EA59D"
            />
            <path
                d="M317.344 391.792a.405.405 0 01-.213-.061l-3.856-2.398a.467.467 0 01-.213-.393.461.461 0 01.213-.394l2.5-1.513a.403.403 0 01.426 0l3.848 2.368a.454.454 0 01.19.379.454.454 0 01-.19.378l-2.499 1.513a.475.475 0 01-.206.121zm-1.356-4.668a.31.31 0 00-.142 0l-2.499 1.551a.313.313 0 00-.099.404.284.284 0 00.099.11l3.855 2.414a.262.262 0 00.277 0l2.499-1.513a.289.289 0 00.103-.108.311.311 0 000-.299.289.289 0 00-.103-.108l-3.855-2.413a.283.283 0 00-.135-.038z"
                fill="#3A3A3A"
            />
            <path
                d="M316.549 389.674l-.369-.22.433-.265.362.22-.426.265z"
                fill="#3A3A3A"
            />
            <path
                d="M332.835 369.936l3.081-3.835a.215.215 0 01.277-.053l25.34 15.592a.229.229 0 01.103.16.254.254 0 01-.046.188l-3.088 3.835a.215.215 0 01-.126.079c-.05.01-.101 0-.144-.026l-25.354-15.592a.21.21 0 01-.067-.069.244.244 0 01-.023-.193.233.233 0 01.047-.086z"
                fill="#0EA59D"
            />
            <path
                d="M358.34 385.983a.243.243 0 01-.142-.046l-25.319-15.584a.273.273 0 01-.094-.088.329.329 0 01.016-.381l3.088-3.835a.275.275 0 01.362-.068l25.34 15.591a.34.34 0 01.142.212.299.299 0 01-.009.133.3.3 0 01-.062.117l-3.081 3.843a.294.294 0 01-.109.083.274.274 0 01-.132.023zm-25.461-15.993a.137.137 0 00-.032.056.158.158 0 00-.004.065.183.183 0 00.025.061.141.141 0 00.046.045l25.355 15.592a.141.141 0 00.184 0l3.082-3.843a.15.15 0 000-.121.183.183 0 00-.025-.061.151.151 0 00-.046-.045l-25.305-15.622a.143.143 0 00-.185 0l-3.095 3.873z"
                fill="#3A3A3A"
            />
            <path
                d="M355.719 376.745l.71-.923a.3.3 0 01.18-.11.289.289 0 01.204.042l6.148 3.783a.316.316 0 01.098.098.357.357 0 01.043.274.344.344 0 01-.063.127l-.71.923a.296.296 0 01-.18.107.285.285 0 01-.203-.039l-6.142-3.783a.296.296 0 01-.101-.095.346.346 0 01-.048-.277.332.332 0 01.064-.127z"
                fill="#0EA59D"
            />
            <path
                d="M362.103 381.147a.354.354 0 01-.192-.052l-6.148-3.783a.363.363 0 01-.119-.118.406.406 0 01-.059-.162.394.394 0 01.085-.325l.71-.931a.366.366 0 01.476-.083l6.149 3.783a.402.402 0 01.173.452.427.427 0 01-.074.153l-.71.93a.362.362 0 01-.291.136zm-6.326-4.349a.246.246 0 00-.047.096.246.246 0 00-.003.108.234.234 0 00.114.174l6.141 3.782a.231.231 0 00.158.03.237.237 0 00.14-.083l.71-.923a.255.255 0 00-.056-.378l-6.149-3.782a.212.212 0 00-.155-.031.224.224 0 00-.136.084l-.717.923z"
                fill="#3A3A3A"
            />
            </g>
            <path
            opacity={0.3}
            d="M399.826 112.879l32.435 19.539c.25.133.624.266.873.532 4.99 2.525 13.099 2.525 18.214 0 1.996-1.063 3.243-2.26 3.618-3.589 0-.133 0-.266.124-.399v-.133c.499-2.392-.499-4.918-2.744-6.247l-34.93-20.47-17.59 10.767z"
            fill="url(#paint231_linear_874_76773)"
            />
            <path
            opacity={0.3}
            d="M434.631 118.994l26.322 15.552c.125.133.25.133.374.266 2.246 1.196 5.988 1.196 8.359 0 .873-.399 1.497-1.064 1.621-1.595v-.133c.25-1.064-.249-2.26-1.247-2.792l-27.445-16.083-7.984 4.785z"
            fill="url(#paint232_linear_874_76773)"
            />
            <path
            d="M468.813 112.879l-5.739-13.558v-.93l5.988 14.754-.249-.266z"
            fill="#131A2D"
            />
            <path
            d="M463.075 99.454l-4.865 13.558-.374.133 5.239-14.622v.93zM439.623 120.057c5.988-1.329 12.475.531 14.72 4.386 2.246 3.855-.873 7.975-6.736 9.438-5.988 1.329-12.475-.532-14.721-4.387-2.245-3.855.749-8.108 6.737-9.437z"
            fill="#131A2D"
            />
            <path
            d="M471.433 116.867c0 8.773-14.72 10.501-15.968.399-.374-7.178 15.844-7.443 15.968-.399z"
            fill="#0EA59D"
            />
            <path
            d="M463.324 124.177c-3.618 0-7.236-2.126-7.859-6.911-.125-1.595.623-3.058 2.12-3.988 2.994-1.994 8.109-2.127 11.353-.399 1.621.931 2.619 2.26 2.619 3.988v.531-.132c-.249 4.253-3.992 6.646-7.609 6.911h-.624zm.249-12.361c-2.245 0-4.491.532-5.988 1.595-1.497.93-2.12 2.392-2.12 3.855.623 5.051 4.615 7.044 8.358 6.779 3.742-.266 7.485-2.792 7.485-7.178 0-1.595-.998-2.924-2.62-3.855-1.247-.797-3.119-1.196-5.115-1.196z"
            fill="#131A2D"
            />
            <path
            d="M471.308 116.735c.125 1.861-1.247 3.323-3.243 4.253-2.62 1.197-6.362 1.462-9.232.133a6.153 6.153 0 01-2.869-2.525c-2.869-6.646 13.348-9.836 15.344-1.861z"
            fill="#fff"
            />
            <path
            d="M463.199 122.051c-1.621 0-3.118-.266-4.366-.93-1.247-.665-2.245-1.462-2.994-2.659-.624-1.329-.499-2.525.374-3.589 1.747-2.259 6.113-3.455 9.98-2.658 2.745.665 4.616 2.26 5.115 4.519.125 1.728-1.123 3.323-3.243 4.254-1.373.664-3.119 1.063-4.866 1.063zm.624-9.969c-2.994 0-6.113 1.063-7.36 2.924-.749 1.064-.873 2.26-.374 3.456a6.145 6.145 0 002.869 2.526c2.62 1.196 6.237 1.196 9.107-.133 2.12-.931 3.243-2.526 3.118-4.121-.499-2.259-2.37-3.721-4.99-4.386-.748-.133-1.621-.266-2.37-.266z"
            fill="#000"
            />
            <path
            d="M468.19 119.925c0 .266 0 .664-.125.93-2.62 1.196-6.362 1.462-9.232.133-1.746-3.855 8.234-5.715 9.357-1.063z"
            fill="#131A2D"
            />
            <path
            d="M463.449 118.463c.499 0 .998 0 1.373.133h2.495v1.063c0 .931-1.622 1.861-3.868 1.861-2.245 0-3.742-.93-3.867-1.861v-1.063h2.495c.374 0 .873-.133 1.372-.133z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 121.519c-2.245 0-3.742-.93-3.867-1.86v-1.197h2.495c.374-.133.873-.133 1.372-.133.499 0 .998 0 1.373.133h2.495v1.197c-.125.93-1.747 1.86-3.868 1.86zm-3.867-1.86c0 .797 1.622 1.728 3.743 1.728 2.12 0 3.742-.931 3.742-1.728v-.931h-2.37a9.492 9.492 0 00-2.745 0h-2.37v.931z"
            fill="#131A2D"
            />
            <path
            d="M466.818 120.456c-.125.133-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M466.443 120.722v-2.26h.375v1.861c0 .266-.125.266-.375.399zm.25-1.994v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#131A2D"
            />
            <path
            d="M462.201 118.595v2.791h-.25v-2.658c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M462.325 121.386h-.374v-2.791h.374v2.791zm-.249-.133s.125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#131A2D"
            />
            <path d="M462.701 121.386h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M462.7 121.519h-.374v-2.924h.374v2.924zm-.249-.266c.125 0 .125 0 0 0l.125-2.658h-.125v2.658z"
            fill="#131A2D"
            />
            <path
            d="M460.58 120.854c-.125 0-.125-.133-.25-.133v-1.993h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M460.704 120.988c-.249-.133-.249-.133-.374-.266v-2.127h.374v2.393zm-.249-.399s0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M463.076 121.386h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.2 121.519h-.499v-3.057h.499v3.057zm-.249-.133l.124-2.791h-.124v2.791z"
            fill="#131A2D"
            />
            <path d="M460.207 120.589l-.25-.266v-1.728h.25v1.994z" fill="#0EA59D" />
            <path
            d="M460.206 120.722c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.399c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path
            d="M461.453 121.12c-.125 0-.125 0-.25-.132v-2.393h.25v2.525z"
            fill="#0EA59D"
            />
            <path
            d="M461.452 121.253c-.124 0-.249-.133-.374-.133v-2.525h.374v2.658zm-.249-.265c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path d="M461.828 121.253h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M461.952 121.386c-.124 0-.249 0-.374-.133v-2.658h.374v2.791zm-.249-.266l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M460.955 120.988c-.125 0-.125-.133-.25-.133v-2.26h.25v2.393z"
            fill="#0EA59D"
            />
            <path
            d="M461.079 121.12c-.124-.132-.249-.132-.374-.132v-2.393h.374v2.525zm-.249-.265s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path
            d="M465.57 121.12c-.125 0-.125 0-.25.133v-2.525h.25v2.392z"
            fill="#0EA59D"
            />
            <path
            d="M465.195 121.253v-2.791h.375v2.658c0 .133-.125.133-.375.133zm.25-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M463.949 121.386h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.574 121.519v-3.057h.499v3.057h-.499zm.125-2.924v2.791h.125l-.125-2.791c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path d="M463.449 118.462v2.924h-.25v-2.924h.25z" fill="#0EA59D" />
            <path
            d="M463.449 121.519c-.125 0-.125 0 0 0h-.25v-3.057h.374v3.057h-.124zm-.125-.133l.125-2.791h-.125v2.791z"
            fill="#131A2D"
            />
            <path
            d="M467.191 119.658c0 .133-.125.399-.25.532v-1.595h.25v1.063z"
            fill="#0EA59D"
            />
            <path
            d="M466.941 120.456v-1.861h.375v1.196c0 .133-.125.399-.25.532l-.125.133zm.125-1.728v1.329c.125-.133.125-.266.125-.399l-.125-.93z"
            fill="#131A2D"
            />
            <path
            d="M459.832 120.19c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M459.831 120.323l-.124-.133c-.125-.133-.125-.266-.25-.532V118.462h.374v1.861zm-.249-.665v.266-1.196.93z"
            fill="#131A2D"
            />
            <path
            d="M466.443 120.722c-.125 0-.125.133-.25.133v-2.26h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M466.068 120.988v-2.393h.375v2.26c-.125 0-.125 0-.375.133zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M464.322 121.386h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M464.072 121.519v-3.057h.499v2.924h-.124c-.25.133-.25.133-.375.133zm.125-2.924v2.658h.125l-.125-2.658z"
            fill="#131A2D"
            />
            <path
            d="M465.945 120.988c-.125 0-.125.133-.25.133v-2.393h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M465.695 121.121v-2.659h.375v2.393c-.125.133-.25.266-.375.266zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path d="M465.195 121.253h-.25v-2.658h.25v2.658z" fill="#0EA59D" />
            <path
            d="M464.82 121.386v-2.791h.375v2.791h-.375zm.125-2.658v2.525h.125l-.125-2.525z"
            fill="#131A2D"
            />
            <path d="M464.697 121.386h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M464.447 121.386v-2.924h.375v2.924h-.375zm.125-2.658v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M463.449 116.735c2.246 0 3.868.93 3.868 1.861 0 .93-1.622 1.861-3.868 1.861-2.245 0-3.867-.931-3.867-1.861 0-.931 1.622-1.861 3.867-1.861z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 120.456c-2.245 0-3.867-1.063-3.867-1.994 0-.93 1.622-1.994 3.867-1.994 2.371 0 3.868 1.064 3.868 1.994 0 .931-1.622 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.931-3.742 1.728 0 .798 1.497 1.728 3.742 1.728 2.246 0 3.743-.93 3.743-1.728 0-.797-1.622-1.728-3.743-1.728z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M465.943 119.925c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM463.699 120.456h-.499l-2.745-2.925c.125-.132.25-.132.374-.265l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M464.696 120.19h.25c.125 0 .249-.133.374-.133s.25-.133.374-.133c.125 0 .125 0 .25-.133h.249c.125 0 .25-.133.375-.133.249-.133.499-.266.748-.532a1.556 1.556 0 01-.624.665l-.124.133s-.125.133-.25.133h-.249c-.125 0-.125 0-.25.133l-.249.132h-.25c-.125 0-.249.001-.374.133h-.749c.125 0 .25 0 .375-.133l.124-.132zM462.701 120.323h.998-1.123c-.25 0-.374 0-.624-.133-.125 0-.374-.133-.499-.266h.624c.249.266.499.266.624.399z"
            fill="#fff"
            />
            <path
            d="M463.449 116.734c.499 0 .998 0 1.373.133h2.495v1.063c0 .93-1.622 1.861-3.868 1.861-2.245 0-3.742-.931-3.867-1.861v-1.063h2.495c.374-.133.873-.133 1.372-.133z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 119.791c-2.245 0-3.742-.931-3.867-1.861v-1.196h2.495c.374-.133.873-.133 1.372-.133.499 0 .998 0 1.373.133h2.495v1.196c-.125.93-1.747 1.861-3.868 1.861zm-3.867-1.994c0 .798 1.622 1.728 3.743 1.728 2.12 0 3.742-.93 3.742-1.728v-.93h-2.37a9.492 9.492 0 00-2.745 0h-2.37v.93z"
            fill="#131A2D"
            />
            <path
            d="M466.818 118.595c-.125.132-.125.132-.25.132v-1.993h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M466.443 118.993v-2.259h.375v1.993s-.125.133-.375.266zm.25-2.126v1.86s.125 0 .125-.132l-.125-1.728z"
            fill="#131A2D"
            />
            <path
            d="M462.201 116.866v2.792h-.25v-2.659c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M462.325 119.658h-.374v-2.792h.374v2.792zm-.249-.133s.125 0 0 0l.125-2.526h-.125v2.526z"
            fill="#131A2D"
            />
            <path d="M462.701 119.658h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M462.7 119.658h-.374v-2.924h.374v2.924zm-.249-.133c.125 0 .125 0 0 0l.125-2.658h-.125v2.658z"
            fill="#131A2D"
            />
            <path
            d="M460.58 118.993c-.125 0-.125-.132-.25-.132v-1.994h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M460.704 119.126c-.249-.133-.249-.133-.374-.266v-2.126h.374v2.392zm-.249-.266l.125-1.993h-.125v1.993z"
            fill="#131A2D"
            />
            <path d="M463.076 119.658h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.2 119.791h-.499v-3.057h.499v3.057zm-.249-.266l.124-2.791h-.124v2.791z"
            fill="#131A2D"
            />
            <path d="M460.207 118.727l-.25-.265v-1.728h.25v1.993z" fill="#0EA59D" />
            <path
            d="M460.206 118.993c-.249-.132-.249-.265-.374-.265v-1.861h.374v2.126zm-.249-.398c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path
            d="M461.453 119.392c-.125 0-.125 0-.25-.133v-2.393h.25v2.526z"
            fill="#0EA59D"
            />
            <path
            d="M461.452 119.525c-.124 0-.249-.133-.374-.133v-2.526h.374v2.659zm-.249-.266c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path d="M461.828 119.525h-.25V117h.25v2.525z" fill="#0EA59D" />
            <path
            d="M461.952 119.658c-.124 0-.249 0-.374-.133v-2.658h.374v2.791zm-.249-.266l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M460.955 119.259c-.125 0-.125-.133-.25-.133v-2.26h.25v2.393z"
            fill="#0EA59D"
            />
            <path
            d="M461.079 119.392c-.124-.133-.249-.133-.374-.133v-2.393h.374v2.526zm-.249-.266s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path
            d="M465.57 119.393c-.125 0-.125 0-.25.133V117h.25v2.393z"
            fill="#0EA59D"
            />
            <path
            d="M465.195 119.525v-2.791h.375v2.658s-.125 0-.375.133zm.25-2.658v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M463.949 119.658h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.574 119.791v-3.057h.499v3.057h-.499zm.125-2.924v2.791h.125l-.125-2.791c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path d="M463.449 116.734v2.924h-.25v-2.924h.25z" fill="#0EA59D" />
            <path
            d="M463.449 119.791c-.125 0-.125 0 0 0h-.25v-3.057h.374v3.057h-.124zm-.125-.266l.125-2.791h-.125v2.791z"
            fill="#131A2D"
            />
            <path
            d="M467.191 117.797c0 .133-.125.399-.25.532v-1.595h.25v1.063z"
            fill="#0EA59D"
            />
            <path
            d="M466.941 118.595v-1.861h.375v1.196c0 .133-.125.399-.25.532l-.125.133zm.125-1.728v1.329c.125-.133.125-.266.125-.399l-.125-.93z"
            fill="#131A2D"
            />
            <path
            d="M459.832 118.329c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M459.831 118.595l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.861zm-.249-.798v.266-1.196.93z"
            fill="#131A2D"
            />
            <path
            d="M466.443 118.993c-.125 0-.125.133-.25.133v-2.26h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M466.068 119.259v-2.393h.375v2.26c-.125-.133-.125 0-.375.133zm.125-2.393v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M464.322 119.658h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M464.072 119.658v-3.057h.499v2.924h-.124c-.25.133-.25.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658z"
            fill="#131A2D"
            />
            <path
            d="M465.945 119.126c-.125 0-.125.133-.25.133v-2.392h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M465.695 119.392v-2.658h.375v2.392c-.125.133-.25.133-.375.266zm.125-2.525v2.259h.125l-.125-2.259z"
            fill="#131A2D"
            />
            <path d="M465.195 119.392h-.25v-2.658h.25v2.658z" fill="#0EA59D" />
            <path
            d="M464.82 119.658v-2.791h.375v2.791c-.125-.133-.125-.133-.375 0zm.125-2.791v2.525h.125l-.125-2.525z"
            fill="#131A2D"
            />
            <path d="M464.697 119.525h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M464.447 119.658v-2.924h.375v2.791c-.125.133-.25.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M463.449 114.873c2.246 0 3.868.93 3.868 1.861 0 .93-1.622 1.861-3.868 1.861-2.245 0-3.867-.931-3.867-1.861 0-.798 1.622-1.861 3.867-1.861z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 118.728c-2.245 0-3.867-1.064-3.867-1.994 0-.93 1.622-1.994 3.867-1.994 2.371 0 3.868 1.064 3.868 1.994 0 .93-1.622 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.931-3.742 1.728 0 .798 1.497 1.728 3.742 1.728 2.246 0 3.743-.93 3.743-1.728 0-.797-1.622-1.728-3.743-1.728z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M465.943 118.196c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM463.699 118.595h-.499l-2.745-2.925c.125-.133.25-.133.374-.265l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M464.696 118.462h.25c.125 0 .249-.133.374-.133s.25-.133.374-.133c.125 0 .125 0 .25-.133h.249c.125 0 .25-.133.375-.133.249-.133.499-.265.748-.531a1.553 1.553 0 01-.624.664l-.124.133s-.125.133-.25.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133l.124-.133zM462.701 118.462h.998-1.123c-.25 0-.374 0-.624-.133-.125 0-.374-.133-.499-.266h.624c.249.399.499.399.624.399z"
            fill="#fff"
            />
            <path
            d="M463.449 115.006c.499 0 .998 0 1.373.133h2.495v.93c0 .931-1.622 1.861-3.868 1.861-2.245 0-3.742-.93-3.867-1.861v-1.063h3.867z"
            fill="#fff"
            />
            <path
            d="M463.449 117.93c-2.245 0-3.742-.931-3.867-1.861v-1.197h2.495c.374-.133.873-.132 1.372-.132.499 0 .998-.001 1.373.132h2.495v1.197c-.125.93-1.747 1.861-3.868 1.861zm-3.867-1.861c0 .797 1.622 1.728 3.743 1.728 2.12 0 3.742-.931 3.742-1.728v-.931h-2.37c-.499-.133-.873-.133-1.372-.133-.499 0-.874 0-1.373.133h-2.37v.931z"
            fill="#000"
            />
            <path
            d="M466.818 116.867c-.125.133-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#fff"
            />
            <path
            d="M466.443 117.133v-2.127h.375v1.861c0 .133-.125.133-.375.266zm.25-1.994v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#000"
            />
            <path
            d="M462.201 115.005v2.791h-.25v-2.658c.125-.133.25-.133.25-.133z"
            fill="#fff"
            />
            <path
            d="M462.325 117.929h-.374v-2.791h.374v2.791zm-.249-.266s.125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#000"
            />
            <path d="M462.701 117.797h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M462.7 117.93h-.374v-2.924h.374v2.924zm-.249-.133c.125 0 .125 0 0 0l.125-2.658h-.125v2.658z"
            fill="#000"
            />
            <path
            d="M460.58 117.266c-.125 0-.125-.133-.25-.133v-1.994h.25v2.127z"
            fill="#fff"
            />
            <path
            d="M460.704 117.399c-.249-.133-.249-.133-.374-.266v-2.127h.374v2.393zm-.249-.266l.125-1.994h-.125v1.994z"
            fill="#000"
            />
            <path d="M463.076 117.929h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M463.2 117.929h-.499v-3.057h.499v3.057zm-.249-.132l.124-2.792h-.124v2.792z"
            fill="#000"
            />
            <path d="M460.207 117l-.25-.266v-1.728h.25V117z" fill="#fff" />
            <path
            d="M460.206 117.133c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.399c.125 0 .125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#000"
            />
            <path
            d="M461.453 117.664c-.125 0-.125 0-.25-.133v-2.392h.25v2.525z"
            fill="#fff"
            />
            <path
            d="M461.452 117.665c-.124 0-.249-.133-.374-.133v-2.526h.374v2.659zm-.249-.133c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#000"
            />
            <path d="M461.828 117.664h-.25v-2.525h.25v2.525z" fill="#fff" />
            <path
            d="M461.952 117.797c-.124 0-.249 0-.374-.132v-2.659h.374v2.791zm-.249-.132l.125-2.393h-.125v2.393z"
            fill="#000"
            />
            <path
            d="M460.955 117.531c-.125 0-.125-.132-.25-.132v-2.26h.25v2.392z"
            fill="#fff"
            />
            <path
            d="M461.079 117.532c-.124-.133-.249-.133-.374-.133v-2.393h.374v2.526zm-.249-.266s.125.133 0 0l.125-2.127h-.125v2.127z"
            fill="#000"
            />
            <path
            d="M465.57 117.531c-.125 0-.125 0-.25.132v-2.525h.25v2.393z"
            fill="#fff"
            />
            <path
            d="M465.195 117.664v-2.792h.375v2.659c0 .133-.125.133-.375.133zm.25-2.526v2.393h.125l-.125-2.393z"
            fill="#000"
            />
            <path d="M463.949 117.929h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M463.574 117.929v-3.057h.499v3.057h-.499zm.125-2.924v2.792h.125l-.125-2.792c.125 0 .125 0 0 0z"
            fill="#000"
            />
            <path d="M463.449 115.006v2.924h-.25v-2.924h.25z" fill="#fff" />
            <path
            d="M463.449 117.93h-.25v-3.19h.374v3.057l-.124.133zm-.125-.133l.125-2.792h-.125v2.792z"
            fill="#000"
            />
            <path
            d="M467.191 116.069c0 .133-.125.399-.25.532v-1.595h.25v1.063z"
            fill="#fff"
            />
            <path
            d="M466.941 116.867v-1.861h.375v1.196c0 .133-.125.399-.25.532l-.125.133zm.125-1.728v1.329c.125-.133.125-.266.125-.399v-.93h-.125z"
            fill="#000"
            />
            <path
            d="M459.832 116.601c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#fff"
            />
            <path
            d="M459.831 116.867l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.861zm-.249-.798c0 .133 0 .133.125.266v-1.196h-.125v.93z"
            fill="#000"
            />
            <path
            d="M466.443 117.133c-.125 0-.125.133-.25.133v-2.26h.25v2.127z"
            fill="#fff"
            />
            <path
            d="M466.068 117.399v-2.393h.375v2.26c-.125 0-.125 0-.375.133zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#000"
            />
            <path d="M464.322 117.797h-.25v-2.925h.25v2.925z" fill="#fff" />
            <path
            d="M464.072 117.929v-3.057h.375v2.925c-.25.132-.25.132-.375.132zm.125-2.924v2.659h.125l-.125-2.659z"
            fill="#000"
            />
            <path
            d="M465.945 117.399c-.125 0-.125.132-.25.132v-2.392h.25v2.26z"
            fill="#fff"
            />
            <path
            d="M465.695 117.665v-2.659h.375v2.393c-.125.133-.25.133-.375.266zm.125-2.526v2.26h.125l-.125-2.26z"
            fill="#000"
            />
            <path d="M465.195 117.665h-.25v-2.659h.25v2.659z" fill="#fff" />
            <path
            d="M464.82 117.797v-2.791h.375v2.791h-.375zm.125-2.658v2.526h.125l-.125-2.526z"
            fill="#000"
            />
            <path d="M464.697 117.797h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M464.447 117.93v-2.924h.375v2.791c-.125 0-.25.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#000"
            />
            <path
            d="M463.449 113.145c2.246 0 3.868.93 3.868 1.861 0 .93-1.622 1.861-3.868 1.861-2.245 0-3.867-.931-3.867-1.861 0-.931 1.622-1.861 3.867-1.861z"
            fill="#fff"
            />
            <path
            d="M463.449 117c-2.245 0-3.867-1.064-3.867-1.994 0-.931 1.622-1.994 3.867-1.994 2.246 0 3.868 1.063 3.868 1.994 0 .93-1.622 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.93-3.742 1.728 0 .797 1.497 1.728 3.742 1.728 2.246 0 3.743-.931 3.743-1.728 0-.798-1.497-1.728-3.743-1.728z"
            fill="#000"
            />
            <path
            opacity={0.25}
            d="M465.943 116.335c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM463.699 116.867h-.499l-2.745-2.924c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M464.696 116.734h.25c.125 0 .249-.133.374-.133s.25-.133.374-.133c.125 0 .125 0 .25-.133h.249c.125 0 .25-.133.375-.133.249-.133.499-.266.748-.532a1.556 1.556 0 01-.624.665l-.124.133s-.125.133-.25.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133l.124-.133zM462.701 116.734h.998-1.123c-.25 0-.374 0-.624-.133-.125 0-.374-.133-.499-.266h.624c.249.399.499.399.624.399z"
            fill="#fff"
            />
            <path
            d="M463.449 113.144c.499 0 .998 0 1.373.133h2.495v1.064c0 .93-1.622 1.86-3.868 1.86-2.245 0-3.742-.93-3.867-1.86v-1.064h2.495c.374 0 .873-.133 1.372-.133z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 116.202c-2.245 0-3.742-.931-3.867-1.861v-1.197h2.495a9.492 9.492 0 012.745 0h2.495v1.197c-.125.93-1.747 1.861-3.868 1.861zm-3.867-1.861c0 .797 1.622 1.728 3.743 1.728 2.12 0 3.742-.931 3.742-1.728v-.931h-2.37a9.492 9.492 0 00-2.745 0h-2.37v.931z"
            fill="#131A2D"
            />
            <path
            d="M466.818 115.139c-.125.133-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M466.443 115.405v-2.26h.375v1.861c0 .266-.125.266-.375.399zm.25-1.994v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#131A2D"
            />
            <path
            d="M462.201 113.278v2.791h-.25v-2.658c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M462.325 116.069h-.374v-2.791h.374v2.791zm-.249-.133s.125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#131A2D"
            />
            <path d="M462.701 116.069h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M462.7 116.202h-.374v-2.924h.374v2.924zm-.249-.266c.125 0 .125 0 0 0l.125-2.658h-.125v2.658z"
            fill="#131A2D"
            />
            <path
            d="M460.58 115.538c-.125 0-.125-.133-.25-.133v-1.994h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M460.704 115.671c-.249-.133-.249-.133-.374-.266v-2.127h.374v2.393zm-.249-.399s0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M463.076 116.069h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.2 116.202h-.499v-3.057h.499v3.057zm-.249-.132l.124-2.792h-.124v2.792z"
            fill="#131A2D"
            />
            <path d="M460.207 115.272l-.25-.266v-1.728h.25v1.994z" fill="#0EA59D" />
            <path
            d="M460.206 115.405c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.399c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path
            d="M461.453 115.804c-.125 0-.125 0-.25-.133v-2.393h.25v2.526z"
            fill="#0EA59D"
            />
            <path
            d="M461.452 115.936c-.124 0-.249-.132-.374-.132v-2.526h.374v2.658zm-.249-.265c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path d="M461.828 115.936h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M461.952 116.069c-.124 0-.249 0-.374-.133v-2.658h.374v2.791zm-.249-.265l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M460.955 115.671c-.125 0-.125-.133-.25-.133v-2.26h.25v2.393z"
            fill="#0EA59D"
            />
            <path
            d="M461.079 115.804c-.124-.133-.249-.133-.374-.133v-2.393h.374v2.526zm-.249-.266s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path
            d="M465.57 115.803c-.125 0-.125 0-.25.133v-2.525h.25v2.392z"
            fill="#0EA59D"
            />
            <path
            d="M465.195 115.936v-2.791h.375v2.658c0 .133-.125.133-.375.133zm.25-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M463.949 116.069h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.574 116.202v-3.057h.499v3.057h-.499zm.125-2.924v2.792h.125l-.125-2.792c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path d="M463.449 113.145v2.925h-.25v-2.925h.25z" fill="#0EA59D" />
            <path
            d="M463.449 116.202c-.125 0-.125 0 0 0h-.25v-3.057h.374v3.057h-.124zm-.125-.132l.125-2.792h-.125v2.792z"
            fill="#131A2D"
            />
            <path
            d="M467.191 114.341c0 .133-.125.399-.25.532v-1.595h.25v1.063z"
            fill="#0EA59D"
            />
            <path
            d="M466.941 115.139v-1.861h.375v1.196c0 .133-.125.399-.25.532l-.125.133zm.125-1.728v1.329c.125-.133.125-.266.125-.399l-.125-.93z"
            fill="#131A2D"
            />
            <path
            d="M459.832 114.873c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M459.831 115.006l-.124-.133c-.125-.133-.125-.266-.25-.531v-1.197h.374v1.861zm-.249-.664v.265-1.196.931z"
            fill="#131A2D"
            />
            <path
            d="M466.443 115.405c-.125 0-.125.133-.25.133v-2.26h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M466.068 115.671v-2.393h.375v2.26c-.125 0-.125 0-.375.133zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M464.322 116.07h-.25v-2.925h.25v2.925z" fill="#0EA59D" />
            <path
            d="M464.072 116.202v-3.057h.499v2.925h-.124c-.25.132-.25.132-.375.132zm.125-2.924v2.659h.125l-.125-2.659z"
            fill="#131A2D"
            />
            <path
            d="M465.945 115.671c-.125 0-.125.132-.25.132v-2.392h.25v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M465.695 115.804v-2.659h.375v2.393c-.125.133-.25.266-.375.266zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path d="M465.195 115.936h-.25v-2.658h.25v2.658z" fill="#0EA59D" />
            <path
            d="M464.82 116.069v-2.791h.375v2.791c-.125-.133-.125 0-.375 0zm.125-2.658v2.525h.125l-.125-2.525z"
            fill="#131A2D"
            />
            <path d="M464.697 115.937h-.25v-2.792h.25v2.792z" fill="#0EA59D" />
            <path
            d="M464.447 116.07v-2.925h.375v2.925h-.375zm.125-2.659v2.659h.125l-.125-2.659c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M463.449 111.418c2.246 0 3.868.93 3.868 1.861 0 .93-1.622 1.861-3.868 1.861-2.245 0-3.867-.931-3.867-1.861 0-.931 1.622-1.861 3.867-1.861z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 115.139c-2.245 0-3.867-1.064-3.867-1.994 0-.931 1.622-1.994 3.867-1.994 2.371 0 3.868 1.063 3.868 1.994 0 .93-1.622 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.93-3.742 1.728 0 .797 1.497 1.728 3.742 1.728 2.246 0 3.743-.931 3.743-1.728 0-.798-1.622-1.728-3.743-1.728z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M465.943 114.608c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM463.699 115.139h-.499l-2.745-2.924c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M464.696 114.873h.25c.125 0 .249-.133.374-.133s.25-.133.374-.133c.125 0 .125 0 .25-.133h.249c.125 0 .25-.133.375-.133.249-.133.499-.266.748-.531a1.559 1.559 0 01-.624.664l-.124.133s-.125.133-.25.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133l.124-.133zM462.701 114.873h.998-1.123c-.25 0-.374 0-.624-.133-.125 0-.374-.133-.499-.266h.624c.249.399.499.399.624.399z"
            fill="#fff"
            />
            <path
            d="M463.449 111.417c.499 0 .998 0 1.373.133h2.495v1.063c0 .931-1.622 1.861-3.868 1.861-2.245 0-3.742-.93-3.867-1.861v-1.063h2.495c.374-.133.873-.133 1.372-.133z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 114.474c-2.245 0-3.742-.93-3.867-1.861v-1.196h2.495c.374-.133.873-.133 1.372-.133.499 0 .998 0 1.373.133h2.495v1.196c-.125.931-1.747 1.861-3.868 1.861zm-3.867-1.994c0 .798 1.622 1.728 3.743 1.728 2.12 0 3.742-.93 3.742-1.728v-.93h-2.37a9.492 9.492 0 00-2.745 0h-2.37v.93z"
            fill="#131A2D"
            />
            <path
            d="M466.818 113.278c-.125.133-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M466.443 113.677v-2.26h.375v1.861c0 .133-.125.266-.375.399zm.25-2.127v1.861s.125 0 .125-.133l-.125-1.728z"
            fill="#131A2D"
            />
            <path
            d="M462.201 111.55v2.791h-.25v-2.658c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M462.325 114.341h-.374v-2.791h.374v2.791zm-.249-.133s.125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#131A2D"
            />
            <path d="M462.701 114.341h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M462.7 114.341h-.374v-2.924h.374v2.924zm-.249-.133c.125 0 .125 0 0 0l.125-2.658h-.125v2.658z"
            fill="#131A2D"
            />
            <path
            d="M460.58 113.677c-.125 0-.125-.133-.25-.133v-1.994h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M460.704 113.81c-.249-.133-.249-.133-.374-.266v-2.127h.374v2.393zm-.249-.266l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M463.076 114.341h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.2 114.474h-.499v-3.057h.499v3.057zm-.249-.266l.124-2.791h-.124v2.791z"
            fill="#131A2D"
            />
            <path d="M460.207 113.411l-.25-.266v-1.728h.25v1.994z" fill="#0EA59D" />
            <path
            d="M460.206 113.544c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.266c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path
            d="M461.453 114.075c-.125 0-.125 0-.25-.133v-2.392h.25v2.525z"
            fill="#0EA59D"
            />
            <path
            d="M461.452 114.208c-.124 0-.249-.133-.374-.133v-2.525h.374v2.658zm-.249-.266c.125 0 .125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path d="M461.828 114.208h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M461.952 114.208c-.124 0-.249 0-.374-.133v-2.658h.374v2.791zm-.249-.133l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M460.955 113.942c-.125 0-.125-.133-.25-.133v-2.259h.25v2.392z"
            fill="#0EA59D"
            />
            <path
            d="M461.079 114.075c-.124-.133-.249-.133-.374-.133v-2.392h.374v2.525zm-.249-.266s.125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path
            d="M465.57 113.942c-.125 0-.125 0-.25.133v-2.525h.25v2.392z"
            fill="#0EA59D"
            />
            <path
            d="M465.195 114.208v-2.791h.375v2.658s-.125 0-.375.133zm.25-2.658v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M463.949 114.341h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.574 114.474v-3.057h.499v3.057h-.499zm.125-2.924v2.791h.125l-.125-2.791c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path d="M463.449 111.417v2.924h-.25v-2.924h.25z" fill="#0EA59D" />
            <path
            d="M463.449 114.474h-.25v-3.057h.374v3.057h-.124zm-.125-.266l.125-2.791h-.125v2.791z"
            fill="#131A2D"
            />
            <path
            d="M467.191 112.48c0 .133-.125.399-.25.532v-1.595h.25v1.063z"
            fill="#0EA59D"
            />
            <path
            d="M466.941 113.278v-1.861h.375v1.196c0 .133-.125.399-.25.532l-.125.133zm.125-1.728v1.329c.125-.133.125-.266.125-.399l-.125-.93z"
            fill="#131A2D"
            />
            <path
            d="M459.832 113.012c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M459.831 113.278l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.861zm-.249-.798v.266-1.196.93z"
            fill="#131A2D"
            />
            <path
            d="M466.443 113.677c-.125 0-.125.132-.25.132v-2.259h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M466.068 113.942v-2.392h.375v2.259c-.125-.132-.125 0-.375.133zm.125-2.392v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M464.322 114.341h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M464.072 114.341v-3.057h.499v2.924h-.124c-.25.133-.25.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658z"
            fill="#131A2D"
            />
            <path
            d="M465.945 113.809c-.125 0-.125.133-.25.133v-2.392h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M465.695 114.075v-2.658h.375v2.393c-.125.132-.25.132-.375.265zm.125-2.525v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path d="M465.195 114.075h-.25v-2.658h.25v2.658z" fill="#0EA59D" />
            <path
            d="M464.82 114.341v-2.791h.375v2.791c-.125-.133-.125-.133-.375 0zm.125-2.791v2.525h.125l-.125-2.525z"
            fill="#131A2D"
            />
            <path d="M464.697 114.208h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M464.447 114.341v-2.924h.375v2.791c-.125.133-.25.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M463.449 109.557c2.246 0 3.868.931 3.868 1.861 0 .93-1.622 1.861-3.868 1.861-2.245 0-3.867-.931-3.867-1.861 0-.798 1.622-1.861 3.867-1.861z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 113.412c-2.245 0-3.867-1.064-3.867-1.994 0-.931 1.622-1.994 3.867-1.994 2.371 0 3.868 1.063 3.868 1.994 0 .93-1.622 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.93-3.742 1.728 0 .797 1.497 1.728 3.742 1.728 2.246 0 3.743-.931 3.743-1.728 0-.798-1.622-1.728-3.743-1.728z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M465.943 112.88c-.249.132-.499.265-.873.265l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.191zM463.699 113.279h-.499l-2.745-2.925c.125-.132.25-.132.374-.265l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M464.696 113.145h.25c.125 0 .249-.133.374-.133s.25-.132.374-.132c.125 0 .125 0 .25-.133h.249c.125 0 .25-.133.375-.133.249-.133.499-.266.748-.532a1.556 1.556 0 01-.624.665l-.124.133s-.125.132-.25.132h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133l.124-.133zM462.701 113.146h.998-1.123c-.25 0-.374 0-.624-.133-.125 0-.374-.133-.499-.266h.624c.249.399.499.399.624.399z"
            fill="#fff"
            />
            <path
            d="M463.449 109.557c.499 0 .998 0 1.373.133h2.495v1.063c0 .931-1.622 1.861-3.868 1.861-2.245 0-3.742-.93-3.867-1.861v-1.063h2.495c.374-.133.873-.133 1.372-.133z"
            fill="#fff"
            />
            <path
            d="M463.449 112.614c-2.245 0-3.742-.931-3.867-1.861v-1.196h2.495c.374-.133.873-.133 1.372-.133.499 0 .998 0 1.373.133h2.495v1.196c-.125.93-1.747 1.861-3.868 1.861zm-3.867-1.994c0 .798 1.622 1.728 3.743 1.728 2.12 0 3.742-.93 3.742-1.728v-.93h-2.37c-.499-.133-.873-.133-1.372-.133-.499 0-.874 0-1.373.133h-2.37v.93z"
            fill="#000"
            />
            <path
            d="M466.818 111.418c-.125.132-.125.132-.25.132v-1.993h.25v1.861z"
            fill="#fff"
            />
            <path
            d="M466.443 111.816v-2.127h.375v1.861s-.125.133-.375.266zm.25-1.994v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#000"
            />
            <path
            d="M462.201 109.689v2.792h-.25v-2.659c.125-.133.25-.133.25-.133z"
            fill="#fff"
            />
            <path
            d="M462.325 112.481h-.374v-2.792h.374v2.792zm-.249-.133s.125 0 0 0l.125-2.526h-.125v2.526z"
            fill="#000"
            />
            <path d="M462.701 112.481h-.25v-2.792h.25v2.792z" fill="#fff" />
            <path
            d="M462.7 112.613h-.374v-2.924h.374v2.924zm-.249-.265c.125 0 .125 0 0 0l.125-2.659h-.125v2.659z"
            fill="#000"
            />
            <path
            d="M460.58 111.95c-.125 0-.125-.133-.25-.133v-1.994h.25v2.127z"
            fill="#fff"
            />
            <path
            d="M460.704 112.082c-.249-.133-.249-.133-.374-.266v-2.127h.374v2.393zm-.249-.399s0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#000"
            />
            <path d="M463.076 112.481h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M463.2 112.614h-.499v-3.057h.499v3.057zm-.249-.133l.124-2.791h-.124v2.791z"
            fill="#000"
            />
            <path d="M460.207 111.683l-.25-.266v-1.728h.25v1.994z" fill="#fff" />
            <path
            d="M460.206 111.816c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.399c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#000"
            />
            <path
            d="M461.453 112.215c-.125 0-.125 0-.25-.133v-2.393h.25v2.526z"
            fill="#fff"
            />
            <path
            d="M461.452 112.348c-.124 0-.249-.133-.374-.133v-2.526h.374v2.659zm-.249-.266c.125 0 .125 0 0 0l.125-2.26h-.125v2.26z"
            fill="#000"
            />
            <path d="M461.828 112.348h-.25v-2.525h.25v2.525z" fill="#fff" />
            <path
            d="M461.952 112.481c-.124 0-.249 0-.374-.133v-2.659h.374v2.792zm-.249-.266l.125-2.393h-.125v2.393z"
            fill="#000"
            />
            <path
            d="M460.955 112.082c-.125 0-.125-.133-.25-.133v-2.26h.25v2.393z"
            fill="#fff"
            />
            <path
            d="M461.079 112.215c-.124-.133-.249-.133-.374-.133v-2.393h.374v2.526zm-.249-.266s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#000"
            />
            <path
            d="M465.57 112.216c-.125 0-.125 0-.25.133v-2.526h.25v2.393z"
            fill="#fff"
            />
            <path
            d="M465.195 112.348v-2.791h.375v2.658s-.125.133-.375.133zm.25-2.526v2.393h.125l-.125-2.393z"
            fill="#000"
            />
            <path d="M463.949 112.481h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M463.574 112.614v-3.057h.499v3.057h-.499zm.125-2.924v2.791h.125l-.125-2.791c.125 0 .125 0 0 0z"
            fill="#000"
            />
            <path d="M463.449 109.557v2.924h-.25v-2.924h.25z" fill="#fff" />
            <path
            d="M463.449 112.614c-.125 0-.125 0 0 0h-.25v-3.057h.374v3.057h-.124zm-.125-.133l.125-2.791h-.125v2.791z"
            fill="#000"
            />
            <path
            d="M467.191 110.753c0 .133-.125.399-.25.532v-1.596h.25v1.064z"
            fill="#fff"
            />
            <path
            d="M466.941 111.55v-1.861h.375v1.064c0 .133-.125.399-.25.532l-.125.265zm.125-1.728v1.33c.125-.133.125-.266.125-.399v-.931h-.125z"
            fill="#000"
            />
            <path
            d="M459.832 111.284c-.125-.133-.25-.399-.25-.531v-1.064h.25v1.595z"
            fill="#fff"
            />
            <path
            d="M459.831 111.418l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.861zm-.249-.798c0 .133 0 .133.125.266v-1.196h-.125v.93z"
            fill="#000"
            />
            <path
            d="M466.443 111.816c-.125 0-.125.133-.25.133v-2.26h.25v2.127z"
            fill="#fff"
            />
            <path
            d="M466.068 112.082v-2.393h.375v2.26c-.125 0-.125 0-.375.133zm.125-2.26v1.994h.125l-.125-1.994z"
            fill="#000"
            />
            <path d="M464.322 112.481h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M464.072 112.614v-3.057h.375v2.924c-.25 0-.25.133-.375.133zm.125-2.924v2.658h.125l-.125-2.658z"
            fill="#000"
            />
            <path
            d="M465.945 111.949c-.125 0-.125.133-.25.133v-2.393h.25v2.26z"
            fill="#fff"
            />
            <path
            d="M465.695 112.215v-2.658h.375v2.525c-.125 0-.25.133-.375.133zm.125-2.393v2.26h.125l-.125-2.26z"
            fill="#000"
            />
            <path d="M465.195 112.348h-.25v-2.659h.25v2.659z" fill="#fff" />
            <path
            d="M464.82 112.481v-2.792h.375v2.792c-.125-.133-.125 0-.375 0zm.125-2.659v2.526h.125l-.125-2.526z"
            fill="#000"
            />
            <path d="M464.697 112.348h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M464.447 112.481v-2.924h.375v2.791c-.125.133-.25.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#000"
            />
            <path
            d="M463.449 107.697c2.246 0 3.868.93 3.868 1.86 0 .931-1.622 1.861-3.868 1.861-2.245 0-3.867-.93-3.867-1.861 0-.797 1.622-1.86 3.867-1.86z"
            fill="#fff"
            />
            <path
            d="M463.449 111.55c-2.245 0-3.867-1.063-3.867-1.993 0-.931 1.622-1.994 3.867-1.994 2.246 0 3.868 1.063 3.868 1.994 0 .93-1.622 1.993-3.868 1.993zm0-3.721c-2.245 0-3.742.93-3.742 1.728 0 .797 1.497 1.728 3.742 1.728 2.246 0 3.743-.931 3.743-1.728 0-.798-1.497-1.728-3.743-1.728z"
            fill="#000"
            />
            <path
            opacity={0.25}
            d="M465.943 111.019c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM463.699 111.417h-.499l-2.745-2.924c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M464.696 111.285h.25c.125 0 .249-.133.374-.133s.25-.133.374-.133c.125 0 .125 0 .25-.133h.249c.125 0 .25-.133.375-.133.249-.133.499-.265.748-.531a1.553 1.553 0 01-.624.664l-.124.133s-.125.133-.25.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133l.124-.133zM462.701 111.285h.998-1.123c-.25 0-.374 0-.624-.133-.125 0-.374-.133-.499-.266h.624c.249.399.499.399.624.399z"
            fill="#fff"
            />
            <path
            d="M463.449 107.694c.499 0 .998 0 1.373.133h2.495v1.064c0 .93-1.622 1.861-3.868 1.861-2.245 0-3.742-.931-3.867-1.861v-1.064h2.495c.374 0 .873-.133 1.372-.133z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 110.752c-2.245 0-3.742-.931-3.867-1.861v-1.197h2.495c.374-.132.873-.132 1.372-.132.499 0 .998 0 1.373.132h2.495v1.197c-.125.93-1.747 1.861-3.868 1.861zm-3.867-1.861c0 .797 1.622 1.728 3.743 1.728 2.12 0 3.742-.931 3.742-1.728v-.931h-2.37c-.499-.133-.873-.133-1.372-.133-.499 0-.874 0-1.373.133h-2.37v.931z"
            fill="#131A2D"
            />
            <path
            d="M466.818 109.689c-.125.133-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M466.443 109.955v-2.26h.375v1.861c0 .266-.125.266-.375.399zm.25-1.994v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#131A2D"
            />
            <path
            d="M462.201 107.828v2.791h-.25v-2.658c.125-.133.25-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M462.325 110.752h-.374v-2.791h.374v2.791zm-.249-.266s.125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#131A2D"
            />
            <path d="M462.701 110.619h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M462.7 110.752h-.374v-2.924h.374v2.924zm-.249-.133c.125 0 .125 0 0 0l.125-2.658h-.125v2.658z"
            fill="#131A2D"
            />
            <path
            d="M460.58 110.087c-.125 0-.125-.132-.25-.132v-1.994h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M460.704 110.22c-.249-.132-.249-.132-.374-.265v-2.127h.374v2.392zm-.249-.398c0 .133 0 .133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M463.076 110.619h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.2 110.752h-.499v-3.057h.499v3.057zm-.249-.133l.124-2.791h-.124v2.791z"
            fill="#131A2D"
            />
            <path d="M460.207 109.822l-.25-.266v-1.728h.25v1.994z" fill="#0EA59D" />
            <path
            d="M460.206 109.955c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.399c.125 0 .125 0 0 0l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path
            d="M461.453 110.353c-.125 0-.125 0-.25-.133v-2.392h.25v2.525z"
            fill="#0EA59D"
            />
            <path
            d="M461.452 110.486c-.124 0-.249-.133-.374-.133v-2.525h.374v2.658zm-.249-.266c.125 0 .125.133 0 0l.125-2.259h-.125v2.259z"
            fill="#131A2D"
            />
            <path d="M461.828 110.486h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M461.952 110.619c-.124 0-.249 0-.374-.133v-2.658h.374v2.791zm-.249-.266l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M460.955 110.22c-.125 0-.125-.132-.25-.132v-2.26h.25v2.392z"
            fill="#0EA59D"
            />
            <path
            d="M461.079 110.353c-.124-.133-.249-.133-.374-.133v-2.392h.374v2.525zm-.249-.265s.125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path
            d="M465.57 110.354c-.125 0-.125 0-.25.133v-2.525h.25v2.392z"
            fill="#0EA59D"
            />
            <path
            d="M465.195 110.486v-2.791h.375v2.658c0 .133-.125.133-.375.133zm.25-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M463.949 110.619h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M463.574 110.752v-3.057h.499v3.057h-.499zm.125-2.924v2.791h.125l-.125-2.791c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path d="M463.449 107.695v2.924h-.25v-2.924h.25z" fill="#0EA59D" />
            <path
            d="M463.449 110.752c-.125 0-.125 0 0 0h-.25v-3.057h.374v3.057h-.124zm-.125-.133l.125-2.791h-.125v2.791z"
            fill="#131A2D"
            />
            <path
            d="M467.191 108.891c0 .133-.125.399-.25.532v-1.595h.25v1.063z"
            fill="#0EA59D"
            />
            <path
            d="M466.941 109.689v-1.861h.375v1.196c0 .133-.125.399-.25.532l-.125.133zm.125-1.728v1.329c.125-.133.125-.266.125-.399l-.125-.93z"
            fill="#131A2D"
            />
            <path
            d="M459.832 109.423c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M459.831 109.556l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.861zm-.249-.665v.266-1.196.93z"
            fill="#131A2D"
            />
            <path
            d="M466.443 109.955c-.125 0-.125.133-.25.133v-2.26h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M466.068 110.22v-2.392h.375v2.26c-.125 0-.125 0-.375.132zm.125-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M464.322 110.619h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M464.072 110.752v-3.057h.499v3.057h-.499zm.125-2.924v2.658h.125l-.125-2.658z"
            fill="#131A2D"
            />
            <path
            d="M465.945 110.221c-.125 0-.125.133-.25.133v-2.392h.25v2.259z"
            fill="#0EA59D"
            />
            <path
            d="M465.695 110.353v-2.658h.375v2.393c-.125.265-.25.265-.375.265zm.125-2.392v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path d="M465.195 110.486h-.25v-2.658h.25v2.658z" fill="#0EA59D" />
            <path
            d="M464.82 110.619v-2.791h.375v2.791h-.375zm.125-2.658v2.525h.125l-.125-2.525z"
            fill="#131A2D"
            />
            <path d="M464.697 110.619h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M464.447 110.752v-2.924h.375v2.791c-.125 0-.25 0-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M463.449 105.967c2.246 0 3.868.93 3.868 1.86 0 .931-1.622 1.861-3.868 1.861-2.245 0-3.867-.93-3.867-1.861 0-.93 1.622-1.86 3.867-1.86z"
            fill="#0EA59D"
            />
            <path
            d="M463.449 109.689c-2.245 0-3.867-1.064-3.867-1.994 0-.931 1.622-1.994 3.867-1.994 2.371 0 3.868 1.063 3.868 1.994 0 1.063-1.622 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.93-3.742 1.728 0 .797 1.497 1.728 3.742 1.728 2.246 0 3.743-.931 3.743-1.728 0-.798-1.622-1.728-3.743-1.728z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M465.943 109.157c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM463.699 109.689h-.499l-2.745-2.924c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M464.696 109.423h.25c.125 0 .249-.133.374-.133s.25-.133.374-.133c.125 0 .125 0 .25-.133h.249c.125 0 .25-.133.375-.133.249-.133.499-.266.748-.532-.125.266-.374.399-.624.665l-.124.133s-.125.133-.25.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133l.124-.133zM462.701 109.556h.998-1.123c-.25 0-.374 0-.624-.133-.125 0-.374-.133-.499-.266h.624c.249.266.499.266.624.399z"
            fill="#fff"
            />
            <path
            d="M463.449 105.967c.499 0 .998 0 1.373.133h2.495v1.063c0 .931-1.622 1.861-3.868 1.861-2.245 0-3.742-.93-3.867-1.861V106.1h2.495c.374-.133.873-.133 1.372-.133z"
            fill="#fff"
            />
            <path
            d="M463.449 108.891c-2.245 0-3.742-.93-3.867-1.861v-1.196h2.495c.374-.133.873-.133 1.372-.133.499 0 .998 0 1.373.133h2.495v1.196c-.125.931-1.747 1.861-3.868 1.861zm-3.867-1.861c0 .798 1.622 1.728 3.743 1.728 2.12 0 3.742-.93 3.742-1.728v-.93h-2.37c-.499-.133-.873-.133-1.372-.133-.499 0-.874 0-1.373.133h-2.37v.93z"
            fill="#000"
            />
            <path
            d="M466.818 107.828c-.125.133-.125.133-.25.133v-1.994h.25v1.861z"
            fill="#fff"
            />
            <path
            d="M466.443 108.094v-2.127h.375v1.861c0 .133-.125.133-.375.266zm.25-1.994v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#000"
            />
            <path
            d="M462.201 105.967v2.791h-.25V106.1c.125-.133.25-.133.25-.133z"
            fill="#fff"
            />
            <path
            d="M462.325 108.891h-.374V106.1h.374v2.791zm-.249-.266s.125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#000"
            />
            <path d="M462.701 108.758h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M462.7 108.891h-.374v-2.924h.374v2.924zm-.249-.133c.125 0 .125 0 0 0l.125-2.658h-.125v2.658z"
            fill="#000"
            />
            <path
            d="M460.58 108.226c-.125 0-.125-.133-.25-.133V106.1h.25v2.126z"
            fill="#fff"
            />
            <path
            d="M460.704 108.359c-.249-.133-.249-.133-.374-.265v-2.127h.374v2.392zm-.249-.265l.125-1.994h-.125v1.994z"
            fill="#000"
            />
            <path d="M463.076 108.891h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M463.2 108.891h-.499v-3.057h.499v3.057zm-.249-.133l.124-2.791h-.124v2.791z"
            fill="#000"
            />
            <path d="M460.207 107.961l-.25-.266v-1.728h.25v1.994z" fill="#fff" />
            <path
            d="M460.206 108.094c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.399c.125 0 .125.133 0 0l.125-1.595h-.125v1.595z"
            fill="#000"
            />
            <path
            d="M461.453 108.625c-.125 0-.125 0-.25-.133V106.1h.25v2.525z"
            fill="#fff"
            />
            <path
            d="M461.452 108.625c-.124 0-.249-.133-.374-.133v-2.525h.374v2.658zm-.249-.133c.125 0 .125 0 0 0l.125-2.259h-.125v2.259z"
            fill="#000"
            />
            <path d="M461.828 108.625h-.25V106.1h.25v2.525z" fill="#fff" />
            <path
            d="M461.952 108.758c-.124 0-.249 0-.374-.133v-2.658h.374v2.791zm-.249-.133l.125-2.392h-.125v2.392z"
            fill="#000"
            />
            <path
            d="M460.955 108.492c-.125 0-.125-.133-.25-.133V106.1h.25v2.392z"
            fill="#fff"
            />
            <path
            d="M461.079 108.492c-.124-.133-.249-.133-.374-.133v-2.392h.374v2.525zm-.249-.266s.125.133 0 0l.125-2.126h-.125v2.126z"
            fill="#000"
            />
            <path
            d="M465.57 108.492c-.125 0-.125 0-.25.133V106.1h.25v2.392z"
            fill="#fff"
            />
            <path
            d="M465.195 108.758v-2.791h.375v2.658s-.125 0-.375.133zm.25-2.658v2.392h.125l-.125-2.392z"
            fill="#000"
            />
            <path d="M463.949 108.891h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M463.574 108.891v-3.057h.499v3.057h-.499zm.125-2.924v2.791h.125l-.125-2.791c.125 0 .125 0 0 0z"
            fill="#000"
            />
            <path d="M463.449 105.967v2.924h-.25v-2.924h.25z" fill="#fff" />
            <path
            d="M463.449 108.891h-.25v-3.19h.374v3.057l-.124.133zm-.125-.133l.125-2.791h-.125v2.791z"
            fill="#000"
            />
            <path
            d="M467.191 107.03c0 .133-.125.399-.25.532v-1.595h.25v1.063z"
            fill="#fff"
            />
            <path
            d="M466.941 107.828v-1.861h.375v1.196c0 .133-.125.399-.25.532l-.125.133zm.125-1.728v1.329c.125-.133.125-.266.125-.399v-.93h-.125z"
            fill="#000"
            />
            <path
            d="M459.832 107.562c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#fff"
            />
            <path
            d="M459.831 107.828l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.861zm-.249-.798c0 .133 0 .133.125.266V106.1h-.125v.93z"
            fill="#000"
            />
            <path
            d="M466.443 108.094c-.125 0-.125.132-.25.132v-2.259h.25v2.127z"
            fill="#fff"
            />
            <path
            d="M466.068 108.359v-2.392h.375v2.259c-.125 0-.125 0-.375.133zm.125-2.259v1.994h.125l-.125-1.994z"
            fill="#000"
            />
            <path d="M464.322 108.758h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M464.072 108.891v-3.057h.375v2.924c-.25.133-.25.133-.375.133zm.125-2.924v2.658h.125l-.125-2.658z"
            fill="#000"
            />
            <path
            d="M465.945 108.359c-.125 0-.125.133-.25.133V106.1h.25v2.259z"
            fill="#fff"
            />
            <path
            d="M465.695 108.625v-2.658h.375v2.392c-.125.133-.25.133-.375.266zm.125-2.525v2.259h.125l-.125-2.259z"
            fill="#000"
            />
            <path d="M465.195 108.625h-.25v-2.658h.25v2.658z" fill="#fff" />
            <path
            d="M464.82 108.758v-2.791h.375v2.791h-.375zm.125-2.658v2.525h.125l-.125-2.525z"
            fill="#000"
            />
            <path d="M464.697 108.758h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M464.447 108.891v-2.924h.375v2.791c-.125 0-.25.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#000"
            />
            <path
            d="M463.449 104.106c2.246 0 3.868.931 3.868 1.861 0 .931-1.622 1.861-3.868 1.861-2.245 0-3.867-.93-3.867-1.861 0-.93 1.622-1.861 3.867-1.861z"
            fill="#fff"
            />
            <path
            d="M463.449 107.961c-2.245 0-3.867-1.063-3.867-1.994 0-.93 1.622-1.993 3.867-1.993 2.246 0 3.868 1.063 3.868 1.993 0 .931-1.622 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.931-3.742 1.728 0 .798 1.497 1.728 3.742 1.728 2.246 0 3.743-.93 3.743-1.728 0-.797-1.497-1.728-3.743-1.728z"
            fill="#000"
            />
            <path
            opacity={0.25}
            d="M465.943 107.297c-.249.132-.499.265-.873.265l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.191zM463.699 107.829h-.499l-2.745-2.924c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M464.696 107.695h.25c.125 0 .249-.133.374-.133s.25-.133.374-.133c.125 0 .125 0 .25-.133h.249c.125 0 .25-.132.375-.132.249-.133.499-.266.748-.532a1.548 1.548 0 01-.624.664l-.124.133s-.125.133-.25.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133l.124-.133zM462.701 107.695h.998-1.123c-.25 0-.374 0-.624-.133-.125 0-.374-.133-.499-.266h.624c.249.399.499.399.624.399z"
            fill="#fff"
            />
            <path
            d="M462.95 99.587l-5.489 20.603-.125-.266 5.614-21.533v1.196zM469.686 119.924l-.249.133-6.238-20.47v-1.064.266l6.487 21.135zM431.014 90.947l-5.739-13.425v-.93l6.113 14.621-.374-.266zM425.275 77.655L420.41 91.08l-.25.266 5.115-14.754v1.063z"
            fill="#131A2D"
            />
            <path
            d="M433.758 94.935c0 8.773-14.721 10.501-15.968.399-.375-7.045 15.718-7.444 15.968-.399z"
            fill="#0EA59D"
            />
            <path
            d="M425.525 102.379c-3.618 0-7.235-2.127-7.859-6.912-.125-1.595.624-3.057 2.121-3.988 2.994-1.994 8.108-2.127 11.352-.399 1.621.93 2.619 2.26 2.619 3.988v.399c-.249 4.253-3.992 6.779-7.609 7.045-.25-.133-.375-.133-.624-.133zm.374-12.495c-2.245 0-4.491.532-5.988 1.595-1.497.93-2.12 2.393-2.12 3.855.623 5.051 4.615 7.045 8.358 6.779 3.742-.266 7.485-2.792 7.485-7.178 0-1.595-.998-2.924-2.62-3.855-1.372-.797-3.243-1.196-5.115-1.196z"
            fill="#131A2D"
            />
            <path
            d="M433.51 94.802c.124 1.861-1.248 3.323-3.244 4.254-2.62 1.196-6.362 1.462-9.231.133a6.153 6.153 0 01-2.87-2.526c-2.869-6.646 13.349-9.703 15.345-1.86z"
            fill="#fff"
            />
            <path
            d="M425.525 100.12c-1.621 0-3.118-.266-4.366-.93-1.247-.665-2.245-1.463-2.994-2.66-.624-1.329-.499-2.525.374-3.588 1.747-2.26 6.113-3.456 9.98-2.659 2.745.665 4.616 2.26 5.115 4.52.125 1.728-1.123 3.323-3.243 4.253-1.497.798-3.244 1.064-4.866 1.064zm.499-9.837c-2.994 0-6.112 1.064-7.36 2.925-.748 1.063-.873 2.26-.374 3.456a6.156 6.156 0 002.869 2.525c2.62 1.196 6.238 1.196 9.107-.133 2.121-.93 3.243-2.525 3.119-4.12-.499-2.26-2.371-3.722-4.99-4.387-.749-.266-1.497-.266-2.371-.266z"
            fill="#000"
            />
            <path
            d="M430.514 98.125c0 .266 0 .664-.125.93-2.619 1.196-6.362 1.462-9.231.133-1.747-3.987 8.109-5.716 9.356-1.063z"
            fill="#131A2D"
            />
            <path
            d="M425.65 96.662c.499 0 .998 0 1.373.133h2.495v1.063c0 .93-1.622 1.861-3.868 1.861-2.245 0-3.742-.93-3.867-1.86v-1.064h2.495c.374-.133.873-.133 1.372-.133z"
            fill="#fff"
            />
            <path
            d="M425.65 99.586c-2.245 0-3.742-.93-3.867-1.86v-1.197h2.495c.374-.133.873-.133 1.372-.133.499 0 .998 0 1.373.133h2.495v1.196c-.125 1.064-1.622 1.861-3.868 1.861zm-3.742-1.86c0 .797 1.622 1.727 3.742 1.727 2.121 0 3.743-.93 3.743-1.728v-.93h-2.37c-.499-.133-.874-.133-1.373-.133s-.873 0-1.372.133h-2.37v.93z"
            fill="#000"
            />
            <path
            d="M429.019 98.523c-.125.133-.125.133-.249.133v-1.994h.249v1.86z"
            fill="#fff"
            />
            <path
            d="M428.77 98.922v-2.126h.374v1.86c-.125 0-.25.133-.374.266zm.124-2.126v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#000"
            />
            <path
            d="M424.527 96.662v2.791h-.25v-2.658c.125 0 .125 0 .25-.133z"
            fill="#fff"
            />
            <path
            d="M424.527 99.587h-.375v-2.791h.375v2.791zm-.25-.266c.125 0 .125.133 0 0l.125-2.525h-.125v2.525z"
            fill="#000"
            />
            <path d="M424.902 99.587h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M425.027 99.586h-.375v-2.924h.375v2.924zm-.25-.133l.125-2.658h-.125v2.658z"
            fill="#000"
            />
            <path
            d="M422.906 98.922c-.125 0-.125-.132-.25-.132v-1.994h.25v2.126z"
            fill="#fff"
            />
            <path
            d="M422.906 99.054c-.25-.133-.25-.133-.375-.265v-2.127h.375v2.392zm-.25-.265s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#000"
            />
            <path d="M425.277 99.586h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M425.401 99.586h-.499V96.53h.499v3.057zm-.249-.133s.125 0 0 0l.125-2.791h-.125v2.791z"
            fill="#000"
            />
            <path d="M422.406 98.656l-.25-.266v-1.728h.25v1.994z" fill="#fff" />
            <path
            d="M422.53 98.789c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.4c0 .134 0 .134 0 0l.125-1.594h-.125v1.595z"
            fill="#000"
            />
            <path
            d="M423.654 99.321c-.125 0-.125 0-.25-.133v-2.392h.25v2.525z"
            fill="#fff"
            />
            <path
            d="M423.779 99.454c-.125 0-.25-.133-.375-.133v-2.525h.375v2.658zm-.25-.266l.125-2.26h-.125v2.26z"
            fill="#000"
            />
            <path d="M424.154 99.454h-.25v-2.525h.25v2.525z" fill="#fff" />
            <path
            d="M424.154 99.453c-.125 0-.25 0-.375-.133v-2.658h.375v2.791zm-.25-.133s.125 0 0 0l.125-2.392h-.125v2.392z"
            fill="#000"
            />
            <path
            d="M423.281 99.188c-.125 0-.125-.133-.25-.133v-2.26h.25v2.393z"
            fill="#fff"
            />
            <path
            d="M423.28 99.187c-.124-.133-.249-.133-.374-.133v-2.392h.374v2.525zm-.249-.133c.125 0 .125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#000"
            />
            <path
            d="M427.771 99.188c-.125 0-.125 0-.25.133v-2.525h.25v2.392z"
            fill="#fff"
            />
            <path
            d="M427.521 99.453v-2.791h.375v2.658c-.125 0-.25 0-.375.133zm.125-2.658v2.392h.125l-.125-2.392z"
            fill="#000"
            />
            <path d="M426.15 99.586h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M425.9 99.586V96.53h.499v3.057h-.499zm.125-2.924v2.791h.125l-.125-2.791z"
            fill="#000"
            />
            <path
            d="M425.775 96.662v2.924h-.25v-2.924h.25s-.125 0 0 0z"
            fill="#fff"
            />
            <path
            d="M425.65 99.586h-.25V96.53h.375v3.057h-.125zm-.125-.133l.125-2.791h-.125v2.791z"
            fill="#000"
            />
            <path
            d="M429.517 97.725c0 .133-.125.4-.249.532v-1.595h.249v1.063z"
            fill="#fff"
            />
            <path
            d="M429.143 98.523v-1.861h.374v1.196c0 .133-.125.399-.25.532l-.124.133zm.124-1.728v1.329c.125-.133.125-.266.125-.399v-.93h-.125z"
            fill="#000"
            />
            <path
            d="M422.033 98.257c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#fff"
            />
            <path
            d="M422.032 98.523l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.86zm-.124-.798c0 .133 0 .133.124.266v-1.196h-.124v.93z"
            fill="#000"
            />
            <path
            d="M428.644 98.789c-.125 0-.125.132-.249.132v-2.26h.249v2.128z"
            fill="#fff"
            />
            <path
            d="M428.395 99.054v-2.392h.374v2.26c-.125 0-.25.132-.374.132zm.124-2.26v1.995h.125l-.125-1.994z"
            fill="#000"
            />
            <path d="M426.523 99.453h-.25V96.53h.25v2.924z" fill="#fff" />
            <path
            d="M426.273 99.586V96.53h.375v2.924c-.125.133-.25.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#000"
            />
            <path
            d="M428.271 99.055c-.125 0-.125.133-.25.133v-2.392h.25v2.26z"
            fill="#fff"
            />
            <path
            d="M427.896 99.32v-2.658h.375v2.392c-.125.133-.125.133-.375.266zm.125-2.525v2.26h.125l-.125-2.26z"
            fill="#000"
            />
            <path d="M427.396 99.32h-.25v-2.658h.25v2.658z" fill="#fff" />
            <path
            d="M427.146 99.453v-2.791h.375v2.791h-.375zm.125-2.658v2.525h.125l-.125-2.525z"
            fill="#000"
            />
            <path d="M427.023 99.453h-.25v-2.79h.25v2.79z" fill="#fff" />
            <path
            d="M426.648 99.586v-2.924h.375v2.791c-.125.133-.125.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 .125 0 0 0z"
            fill="#000"
            />
            <path
            d="M425.65 94.802c2.246 0 3.868.93 3.868 1.86s-1.622 1.861-3.868 1.861c-2.245 0-3.867-.93-3.867-1.86 0-.798 1.622-1.861 3.867-1.861z"
            fill="#fff"
            />
            <path
            d="M425.65 98.656c-2.245 0-3.867-1.063-3.867-1.994 0-.93 1.622-1.993 3.867-1.993 2.246 0 3.868 1.063 3.868 1.993 0 .931-1.497 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.931-3.742 1.728 0 .798 1.497 1.728 3.742 1.728 2.246 0 3.743-.93 3.743-1.728 0-.797-1.497-1.728-3.743-1.728z"
            fill="#000"
            />
            <path
            opacity={0.25}
            d="M428.144 98.125c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM426.025 98.523h-.499l-2.745-2.924c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M426.898 98.39h.249c.125 0 .25-.133.374-.133.125 0 .25-.133.375-.133.124 0 .124 0 .249-.132h.25c.124 0 .249-.133.374-.133.249-.133.499-.266.748-.532a1.553 1.553 0 01-.623.665l-.125.132-.125.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM425.027 98.39h.998-1.123c-.249 0-.374 0-.624-.132-.124 0-.374-.133-.499-.266h.624c.25 0 .374.399.624.399z"
            fill="#fff"
            />
            <path
            d="M425.65 94.803c.499 0 .998 0 1.373.133h2.495v1.063c0 .93-1.622 1.86-3.868 1.86-2.245 0-3.742-.93-3.867-1.86v-1.063h2.495c.374 0 .873-.133 1.372-.133z"
            fill="#0EA59D"
            />
            <path
            d="M425.65 97.859c-2.245 0-3.742-.93-3.867-1.86v-1.197h2.495a9.5 9.5 0 012.745 0h2.495v1.329c-.125.798-1.622 1.728-3.868 1.728zm-3.742-1.86c0 .797 1.622 1.727 3.742 1.727 2.121 0 3.743-.93 3.743-1.728v-.93h-2.37a9.5 9.5 0 00-2.745 0h-2.37v.93z"
            fill="#131A2D"
            />
            <path
            d="M429.019 96.797c-.125.133-.125.133-.249.133v-1.994h.249v1.86z"
            fill="#0EA59D"
            />
            <path
            d="M428.77 97.062v-2.26h.374v1.862c-.125.266-.25.266-.374.398zm.124-1.993v1.727s.125 0 .125-.132l-.125-1.595z"
            fill="#131A2D"
            />
            <path
            d="M424.527 94.935v2.792h-.25v-2.659c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M424.527 97.86h-.375v-2.792h.375v2.792zm-.25-.266c.125 0 .125 0 0 0l.125-2.526h-.125v2.526z"
            fill="#131A2D"
            />
            <path d="M424.902 97.727h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M425.026 97.86h-.499v-3.057h.499v3.057zm-.249-.133l.125-2.658h-.125v2.658z"
            fill="#131A2D"
            />
            <path
            d="M422.906 97.195c-.125 0-.125-.133-.25-.133V95.07h.25v2.126z"
            fill="#0EA59D"
            />
            <path
            d="M422.906 97.328c-.25-.133-.25-.133-.375-.266v-2.126h.375v2.392zm-.25-.398c0 .132.125.132 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M425.277 97.727h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M425.401 97.86h-.499v-3.057h.499v3.057zm-.249-.133s.125 0 0 0l.125-2.791h-.125v2.791z"
            fill="#131A2D"
            />
            <path d="M422.406 96.93l-.25-.267v-1.727h.25v1.993z" fill="#0EA59D" />
            <path
            d="M422.53 97.062c-.249-.133-.249-.266-.374-.266v-1.86h.374v2.126zm-.249-.398l.125-1.596h-.125v1.596z"
            fill="#131A2D"
            />
            <path
            d="M423.654 97.461c-.125 0-.125 0-.25-.133v-2.392h.25v2.525z"
            fill="#0EA59D"
            />
            <path
            d="M423.779 97.594c-.125 0-.25-.133-.375-.133v-2.525h.375v2.658zm-.25-.266s0 .133 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path d="M424.154 97.594h-.25v-2.526h.25v2.526z" fill="#0EA59D" />
            <path
            d="M424.154 97.727c-.125 0-.25 0-.375-.133v-2.658h.375v2.79zm-.25-.266s.125 0 0 0l.125-2.392h-.125v2.392z"
            fill="#131A2D"
            />
            <path
            d="M423.281 97.328c-.125 0-.125-.133-.25-.133v-2.26h.25v2.393z"
            fill="#0EA59D"
            />
            <path
            d="M423.28 97.461c-.124-.133-.249-.133-.374-.133v-2.392h.374v2.525zm-.249-.266c.125 0 .125 0 0 0l.125-2.126h-.125v2.126z"
            fill="#131A2D"
            />
            <path
            d="M427.771 97.46c-.125 0-.125 0-.25.134v-2.526h.25v2.393z"
            fill="#0EA59D"
            />
            <path
            d="M427.521 97.594v-2.791h.375v2.658c-.125.133-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392z"
            fill="#131A2D"
            />
            <path d="M426.148 97.727h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M425.898 97.86v-3.057h.499v3.057h-.499zm.125-2.924v2.791h.125l-.125-2.791z"
            fill="#131A2D"
            />
            <path
            d="M425.775 94.803v2.924h-.25v-2.924h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M425.65 97.86c-.125 0 0 0 0 0h-.25v-3.057h.375v3.057h-.125zm-.125-.133c.125 0 .125 0 0 0l.125-2.791h-.125v2.791z"
            fill="#131A2D"
            />
            <path
            d="M429.517 95.999c0 .133-.125.398-.249.531v-1.595h.249V96z"
            fill="#0EA59D"
            />
            <path
            d="M429.143 96.796v-1.86h.374v1.196c0 .133-.125.399-.25.531l-.124.133zm.124-1.728v1.33c.125-.133.125-.266.125-.4l-.125-.93z"
            fill="#131A2D"
            />
            <path
            d="M422.033 96.53c-.125-.132-.25-.398-.25-.531v-1.063h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M422.032 96.664l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.86zm-.124-.665v.266-1.196.93z"
            fill="#131A2D"
            />
            <path
            d="M428.644 97.062c-.125 0-.125.133-.249.133v-2.26h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M428.395 97.328v-2.392h.374v2.26c-.125 0-.25 0-.374.132zm.124-2.26v1.994h.125l-.125-1.993z"
            fill="#131A2D"
            />
            <path d="M426.523 97.727h-.25v-2.924h.25v2.924z" fill="#0EA59D" />
            <path
            d="M426.273 97.86v-3.057h.499v3.057h-.499zm.125-2.924v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M428.269 97.328c-.125 0-.125.133-.249.133v-2.393h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M427.895 97.461v-2.658h.374v2.392c-.125.266-.125.266-.374.266zm.124-2.392v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path d="M427.396 97.594h-.25v-2.658h.25v2.658z" fill="#0EA59D" />
            <path
            d="M427.146 97.727v-2.791h.375v2.79h-.375zm.125-2.659v2.526h.125l-.125-2.525z"
            fill="#131A2D"
            />
            <path d="M427.023 97.727h-.25v-2.791h.25v2.791z" fill="#0EA59D" />
            <path
            d="M426.648 97.86v-3.057h.375v2.791c-.125.133-.125.133-.375.266zm.125-2.791v2.658h.125l-.125-2.658c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M425.65 93.074c2.246 0 3.868.93 3.868 1.86 0 .931-1.622 1.862-3.868 1.862-2.245 0-3.867-.93-3.867-1.861 0-.93 1.622-1.861 3.867-1.861z"
            fill="#0EA59D"
            />
            <path
            d="M425.65 96.796c-2.37 0-3.867-1.063-3.867-1.994 0-.93 1.622-1.993 3.867-1.993 2.246 0 3.868 1.063 3.868 1.993 0 .93-1.497 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.93-3.742 1.728 0 .798 1.497 1.728 3.742 1.728 2.246 0 3.743-.93 3.743-1.728 0-.797-1.497-1.728-3.743-1.728z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M428.144 96.264c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM426.025 96.796h-.499l-2.745-2.924c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M426.898 96.663h.249c.125 0 .25-.133.374-.133.125 0 .25-.133.375-.133.124 0 .124 0 .249-.133h.25c.124 0 .249-.133.374-.133.249-.133.499-.266.748-.531a1.553 1.553 0 01-.623.664l-.125.133-.125.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM425.027 96.663h.998-1.123c-.249 0-.374 0-.624-.132-.124 0-.374-.133-.499-.266h.624c.25.266.374.398.624.398z"
            fill="#fff"
            />
            <path
            d="M425.65 93.074c.499 0 .998 0 1.373.133h2.495v1.064c0 .93-1.622 1.86-3.868 1.86-2.245 0-3.742-.93-3.867-1.86v-1.064h2.495c.374-.133.873-.133 1.372-.133z"
            fill="#fff"
            />
            <path
            d="M425.65 96.132c-2.245 0-3.742-.93-3.867-1.861v-1.197h2.495c.374-.133.873-.133 1.372-.133.499 0 .998 0 1.373.133h2.495v1.197c-.125.93-1.622 1.86-3.868 1.86zm-3.742-1.994c0 .797 1.622 1.728 3.742 1.728 2.121 0 3.743-.93 3.743-1.728v-.93h-2.37c-.499-.134-.874-.134-1.373-.134s-.873 0-1.372.133h-2.37v.93z"
            fill="#000"
            />
            <path
            d="M429.019 94.935c-.125.133-.125.133-.249.133v-1.994h.249v1.861z"
            fill="#fff"
            />
            <path
            d="M428.77 95.334v-2.127h.374v1.86c-.125 0-.25.134-.374.267zm.124-1.994v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#000"
            />
            <path
            d="M424.527 93.207v2.791h-.25V93.34c.125-.133.125-.133.25-.133z"
            fill="#fff"
            />
            <path
            d="M424.527 95.998h-.375v-2.791h.375v2.791zm-.25-.133c.125 0 .125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#000"
            />
            <path d="M424.902 95.998h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M425.027 96.131h-.375v-2.924h.375v2.924zm-.25-.266l.125-2.658h-.125v2.658z"
            fill="#000"
            />
            <path
            d="M422.906 95.466c-.125 0-.125-.133-.25-.133V93.34h.25v2.126z"
            fill="#fff"
            />
            <path
            d="M422.906 95.466c-.25-.132-.25-.132-.375-.265v-2.127h.375v2.392zm-.25-.265s.125 0 0 0l.125-1.994h-.125V95.2z"
            fill="#000"
            />
            <path d="M425.277 95.998h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M425.401 96.131h-.499v-3.057h.499v3.057zm-.249-.132s.125 0 0 0l.125-2.792h-.125V96z"
            fill="#000"
            />
            <path d="M422.406 95.2l-.25-.265v-1.728h.25v1.994z" fill="#fff" />
            <path
            d="M422.53 95.334c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.399l.125-1.595h-.125v1.595z"
            fill="#000"
            />
            <path
            d="M423.654 95.733c-.125 0-.125 0-.25-.133v-2.393h.25v2.526z"
            fill="#fff"
            />
            <path
            d="M423.779 95.865c-.125 0-.25-.132-.375-.132v-2.526h.375v2.658zm-.25-.265l.125-2.26h-.125v2.26z"
            fill="#000"
            />
            <path d="M424.154 95.865h-.25V93.34h.25v2.525z" fill="#fff" />
            <path
            d="M424.154 95.998c-.125 0-.25 0-.375-.133v-2.658h.375v2.791zm-.25-.266s.125 0 0 0l.125-2.392h-.125v2.392z"
            fill="#000"
            />
            <path
            d="M423.281 95.6c-.125 0-.125-.133-.25-.133v-2.26h.25V95.6z"
            fill="#fff"
            />
            <path
            d="M423.28 95.733c-.124-.133-.249-.133-.374-.133v-2.393h.374v2.526zm-.249-.266c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#000"
            />
            <path
            d="M427.771 95.732c-.125 0-.125 0-.25.133V93.34h.25v2.392z"
            fill="#fff"
            />
            <path
            d="M427.521 95.865v-2.791h.375v2.658c-.125 0-.25.133-.375.133zm.125-2.525v2.392h.125l-.125-2.392z"
            fill="#000"
            />
            <path d="M426.148 95.999h-.25v-2.925h.25V96z" fill="#fff" />
            <path
            d="M425.898 96.131v-3.057h.499v3.057h-.499zm.125-2.924V96h.125l-.125-2.792z"
            fill="#000"
            />
            <path
            d="M425.775 93.074v2.924h-.25v-2.924h.25s-.125 0 0 0z"
            fill="#fff"
            />
            <path
            d="M425.65 96.131c-.125 0 0 0 0 0h-.25v-3.057h.375v3.057h-.125zm-.125-.133c.125 0 .125 0 0 0l.125-2.791h-.125v2.791z"
            fill="#000"
            />
            <path
            d="M429.517 94.27c0 .133-.125.4-.249.532v-1.595h.249v1.063z"
            fill="#fff"
            />
            <path
            d="M429.143 95.068v-1.861h.374v1.196c0 .133-.125.4-.25.532l-.124.133zm.124-1.728v1.33c.125-.134.125-.267.125-.4v-.93h-.125z"
            fill="#000"
            />
            <path
            d="M422.033 94.67c-.125-.134-.25-.4-.25-.532v-1.064h.25v1.595z"
            fill="#fff"
            />
            <path
            d="M422.032 94.935l-.124-.133c-.125-.133-.125-.266-.25-.532V93.075h.374v1.861zm-.124-.797c0 .132 0 .132.124.265v-1.196h-.124v.93z"
            fill="#000"
            />
            <path
            d="M428.644 95.334c-.125 0-.125.133-.249.133v-2.26h.249v2.127z"
            fill="#fff"
            />
            <path
            d="M428.395 95.6v-2.393h.374v2.26c-.125 0-.25 0-.374.133zm.124-2.26v1.994h.125l-.125-1.994z"
            fill="#000"
            />
            <path d="M426.523 95.999h-.25v-2.925h.25V96z" fill="#fff" />
            <path
            d="M426.273 96.131v-3.057h.375V96c-.125 0-.25 0-.375.132zm.125-2.924v2.659h.125l-.125-2.659c.125 0 0 0 0 0z"
            fill="#000"
            />
            <path
            d="M428.269 95.467c-.125 0-.125.133-.249.133v-2.393h.249v2.26z"
            fill="#fff"
            />
            <path
            d="M427.895 95.733v-2.659h.374v2.393c-.125.133-.125.133-.374.266zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#000"
            />
            <path d="M427.396 95.865h-.25v-2.658h.25v2.658z" fill="#fff" />
            <path
            d="M427.146 95.998v-2.791h.375v2.791c-.125-.133-.25-.133-.375 0zm.125-2.658v2.525h.125l-.125-2.525z"
            fill="#000"
            />
            <path d="M427.023 95.865h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M426.648 95.999v-2.925h.375v2.792c-.125.133-.125.133-.375.133zm.125-2.792v2.659h.125l-.125-2.659c.125 0 .125 0 0 0z"
            fill="#000"
            />
            <path
            d="M425.65 91.214c2.246 0 3.868.93 3.868 1.86 0 .931-1.622 1.862-3.868 1.862-2.245 0-3.867-.93-3.867-1.861 0-.798 1.622-1.861 3.867-1.861z"
            fill="#fff"
            />
            <path
            d="M425.65 95.068c-2.245 0-3.867-1.064-3.867-1.994 0-.93 1.622-1.994 3.867-1.994 2.246 0 3.868 1.063 3.868 1.994 0 .93-1.497 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.93-3.742 1.728 0 .797 1.497 1.728 3.742 1.728 2.246 0 3.743-.93 3.743-1.728 0-.798-1.497-1.728-3.743-1.728z"
            fill="#000"
            />
            <path
            opacity={0.25}
            d="M428.144 94.537c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM426.025 94.935h-.499l-2.745-2.924c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M426.898 94.803h.249c.125 0 .25-.133.374-.133.125 0 .25-.133.375-.133.124 0 .124 0 .249-.133h.25c.124 0 .249-.133.374-.133.249-.133.499-.266.748-.532a1.554 1.554 0 01-.623.665l-.125.133-.125.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.132h-.749c.125 0 .25 0 .375-.132v-.133zM425.027 94.802h.998-1.123c-.249 0-.374 0-.624-.133-.124 0-.374-.133-.499-.266h.624c.25.4.374.4.624.4z"
            fill="#fff"
            />
            <path
            d="M425.65 91.346c.499 0 .998 0 1.373.133h2.495v1.063c0 .93-1.622 1.86-3.868 1.86-2.245 0-3.742-.93-3.867-1.86v-1.063h2.495c.374-.133.873-.133 1.372-.133z"
            fill="#fff"
            />
            <path
            d="M425.65 94.27c-2.245 0-3.742-.931-3.867-1.862v-1.196h2.495c.374-.133.873-.133 1.372-.133.499 0 .998 0 1.373.133h2.495v1.196c-.125.93-1.622 1.861-3.868 1.861zm-3.742-1.862c0 .798 1.622 1.728 3.742 1.728 2.121 0 3.743-.93 3.743-1.728v-.93h-2.37c-.499-.133-.874-.133-1.373-.133s-.873 0-1.372.133h-2.37v.93z"
            fill="#000"
            />
            <path
            d="M429.019 93.206c-.125.132-.125.132-.249.132v-1.993h.249v1.86z"
            fill="#fff"
            />
            <path
            d="M428.77 93.604v-2.126h.374v1.86c-.125 0-.25.133-.374.266zm.124-2.126v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#000"
            />
            <path
            d="M424.527 91.345v2.791h-.25v-2.658c.125 0 .125-.133.25-.133z"
            fill="#fff"
            />
            <path
            d="M424.527 94.269h-.375v-2.791h.375v2.79zm-.25-.266c.125 0 .125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#000"
            />
            <path d="M424.902 94.269h-.25v-2.791h.25v2.79z" fill="#fff" />
            <path
            d="M425.027 94.269h-.375v-2.924h.375v2.924zm-.25-.133l.125-2.658h-.125v2.658z"
            fill="#000"
            />
            <path
            d="M422.906 93.604c-.125 0-.125-.133-.25-.133v-1.993h.25v2.126z"
            fill="#fff"
            />
            <path
            d="M422.906 93.737c-.25-.133-.25-.133-.375-.265v-2.127h.375v2.392zm-.25-.265s.125 0 0 0l.125-1.994h-.125v1.994z"
            fill="#000"
            />
            <path d="M425.277 94.269h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M425.401 94.27h-.499v-3.058h.499v3.057zm-.249-.134s.125 0 0 0l.125-2.791h-.125v2.791z"
            fill="#000"
            />
            <path d="M422.406 93.338l-.25-.265v-1.728h.25v1.993z" fill="#fff" />
            <path
            d="M422.53 93.472c-.249-.133-.249-.266-.374-.266v-1.861h.374v2.127zm-.249-.4c0 .134 0 .134 0 0l.125-1.594h-.125v1.595z"
            fill="#000"
            />
            <path
            d="M423.654 94.003c-.125 0-.125 0-.25-.133v-2.392h.25v2.525z"
            fill="#fff"
            />
            <path
            d="M423.779 94.003c-.125 0-.25-.133-.375-.133v-2.525h.375v2.658zm-.25-.133l.125-2.26h-.125v2.26z"
            fill="#000"
            />
            <path d="M424.154 94.136h-.25v-2.525h.25v2.525z" fill="#fff" />
            <path
            d="M424.154 94.136c-.125 0-.25 0-.375-.133v-2.658h.375v2.791zm-.25-.133s.125 0 0 0l.125-2.392h-.125v2.392z"
            fill="#000"
            />
            <path
            d="M423.281 93.87c-.125 0-.125-.133-.25-.133v-2.26h.25v2.393z"
            fill="#fff"
            />
            <path
            d="M423.28 93.87c-.124-.133-.249-.133-.374-.133v-2.392h.374v2.525zm-.249-.266c.125.133.125.133 0 0l.125-2.126h-.125v2.126z"
            fill="#000"
            />
            <path
            d="M427.771 93.87c-.125 0-.125 0-.25.133v-2.525h.25v2.392z"
            fill="#fff"
            />
            <path
            d="M427.521 94.136v-2.791h.375v2.658c-.125 0-.25 0-.375.133zm.125-2.658v2.392h.125l-.125-2.392z"
            fill="#000"
            />
            <path d="M426.15 94.269h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M425.9 94.27v-3.058h.499v3.057h-.499zm.125-2.925v2.791h.125l-.125-2.791z"
            fill="#000"
            />
            <path
            d="M425.775 91.345v2.924h-.25v-2.924h.25s-.125 0 0 0z"
            fill="#fff"
            />
            <path
            d="M425.65 94.27h-.25v-3.058h.375v3.057h-.125zm-.125-.134c.125 0 .125 0 0 0l.125-2.791h-.125v2.791z"
            fill="#000"
            />
            <path
            d="M429.517 92.408c0 .133-.125.399-.249.532v-1.595h.249v1.063z"
            fill="#fff"
            />
            <path
            d="M429.143 93.206v-1.861h.374v1.196c0 .133-.125.399-.25.532l-.124.133zm.124-1.728v1.329c.125-.133.125-.266.125-.399v-.93h-.125z"
            fill="#000"
            />
            <path
            d="M422.033 92.94c-.125-.133-.25-.399-.25-.532v-1.063h.25v1.595z"
            fill="#fff"
            />
            <path
            d="M422.032 93.206l-.124-.133c-.125-.133-.125-.266-.25-.532v-1.196h.374v1.86zm-.124-.798c0 .133 0 .133.124.266v-1.196h-.124v.93z"
            fill="#000"
            />
            <path
            d="M428.644 93.472c-.125 0-.125.132-.249.132v-2.26h.249v2.128z"
            fill="#fff"
            />
            <path
            d="M428.395 93.737v-2.392h.374v2.26c-.125 0-.25.132-.374.132zm.124-2.26v1.995h.125l-.125-1.994z"
            fill="#000"
            />
            <path d="M426.523 94.136h-.25v-2.924h.25v2.924z" fill="#fff" />
            <path
            d="M426.273 94.27v-3.058h.375v3.057h-.375zm.125-2.792v2.658h.125l-.125-2.658c.125 0 0 0 0 0z"
            fill="#000"
            />
            <path
            d="M428.271 93.737c-.125 0-.125.133-.25.133v-2.392h.25v2.26z"
            fill="#fff"
            />
            <path
            d="M427.896 94.003v-2.658h.375v2.392c-.125.133-.125.133-.375.266zm.125-2.525v2.26h.125l-.125-2.26z"
            fill="#000"
            />
            <path d="M427.396 94.003h-.25v-2.658h.25v2.658z" fill="#fff" />
            <path
            d="M427.146 94.136v-2.791h.375v2.791h-.375zm.125-2.658v2.525h.125l-.125-2.525z"
            fill="#000"
            />
            <path d="M427.023 94.136h-.25v-2.791h.25v2.791z" fill="#fff" />
            <path
            d="M426.648 94.269v-2.924h.375v2.791c-.125.133-.125.133-.375.133zm.125-2.791v2.658h.125l-.125-2.658c.125 0 .125 0 0 0z"
            fill="#000"
            />
            <path
            d="M425.65 89.484c2.246 0 3.868.93 3.868 1.861 0 .93-1.622 1.861-3.868 1.861-2.245 0-3.867-.93-3.867-1.86 0-.931 1.622-1.862 3.867-1.862z"
            fill="#fff"
            />
            <path
            d="M425.65 93.34c-2.245 0-3.867-1.064-3.867-1.995 0-.93 1.622-1.993 3.867-1.993 2.246 0 3.868 1.063 3.868 1.993 0 .93-1.497 1.994-3.868 1.994zm0-3.723c-2.245 0-3.742.93-3.742 1.728 0 .798 1.497 1.728 3.742 1.728 2.246 0 3.743-.93 3.743-1.728 0-.797-1.497-1.728-3.743-1.728z"
            fill="#000"
            />
            <path
            opacity={0.25}
            d="M428.144 92.808c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM426.025 93.206h-.499l-2.745-2.925c.125-.133.25-.133.374-.265l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M426.898 93.073h.249c.125 0 .25-.132.374-.132.125 0 .25-.133.375-.133.124 0 .124 0 .249-.133h.25c.124 0 .249-.133.374-.133.249-.133.499-.266.748-.532a1.553 1.553 0 01-.623.665l-.125.133-.125.132h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM425.027 93.073h.998-1.123c-.249 0-.374 0-.624-.133-.124 0-.374-.132-.499-.265h.624c.25 0 .374.398.624.398z"
            fill="#fff"
            />
            <path
            d="M425.65 89.484c.499 0 .998 0 1.373.133h2.495v1.064c0 .93-1.622 1.86-3.868 1.86-2.245 0-3.742-.93-3.867-1.86v-1.064h2.495c.374 0 .873-.133 1.372-.133z"
            fill="#0EA59D"
            />
            <path
            d="M425.65 92.542c-2.245 0-3.742-.93-3.867-1.861v-1.197h2.495c.374-.132.873-.132 1.372-.132.499 0 .998 0 1.373.132h2.495v1.197c-.125.93-1.622 1.86-3.868 1.86zm-3.742-1.861c0 .797 1.622 1.728 3.742 1.728 2.121 0 3.743-.93 3.743-1.728v-.93h-2.37c-.499-.134-.874-.134-1.373-.134s-.873 0-1.372.133h-2.37v.93z"
            fill="#131A2D"
            />
            <path
            d="M429.019 91.48c-.125.132-.125.132-.249.132v-1.994h.249v1.861z"
            fill="#0EA59D"
            />
            <path
            d="M428.77 91.745v-2.26h.374v1.861c-.125.266-.25.266-.374.399zm.124-1.994v1.728s.125 0 .125-.133l-.125-1.595z"
            fill="#131A2D"
            />
            <path
            d="M424.527 89.618v2.792h-.25V89.75c.125-.133.125-.133.25-.133z"
            fill="#0EA59D"
            />
            <path
            d="M424.527 92.542h-.375v-2.791h.375v2.791zm-.25-.266c.125 0 .125 0 0 0l.125-2.525h-.125v2.525z"
            fill="#131A2D"
            />
            <path d="M424.902 92.41h-.25v-2.792h.25v2.791z" fill="#0EA59D" />
            <path
            d="M425.027 92.543h-.375v-3.058h.499v3.058h-.124zm-.25-.133l.125-2.659h-.125v2.659z"
            fill="#131A2D"
            />
            <path
            d="M422.906 91.878c-.125 0-.125-.133-.25-.133V89.75h.25v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M422.906 92.01c-.25-.132-.25-.132-.375-.265v-2.127h.375v2.393zm-.25-.398c0 .133.125.133 0 0l.125-1.994h-.125v1.994z"
            fill="#131A2D"
            />
            <path d="M425.277 92.41h-.25v-2.925h.25v2.925z" fill="#0EA59D" />
            <path
            d="M425.401 92.543h-.499v-3.058h.499v3.058zm-.249-.133s.125 0 0 0l.125-2.792h-.125v2.792z"
            fill="#131A2D"
            />
            <path d="M422.406 91.612l-.25-.266v-1.728h.25v1.994z" fill="#0EA59D" />
            <path
            d="M422.53 91.745c-.249-.133-.249-.266-.374-.266v-1.86h.374v2.126zm-.249-.399l.125-1.595h-.125v1.595z"
            fill="#131A2D"
            />
            <path
            d="M423.654 92.144c-.125 0-.125 0-.25-.133v-2.393h.25v2.526z"
            fill="#0EA59D"
            />
            <path
            d="M423.779 92.277c-.125 0-.25-.133-.375-.133v-2.526h.375v2.659zm-.25-.266s0 .133 0 0l.125-2.26h-.125v2.26z"
            fill="#131A2D"
            />
            <path d="M424.154 92.276h-.25v-2.525h.25v2.525z" fill="#0EA59D" />
            <path
            d="M424.154 92.41c-.125 0-.25 0-.375-.133v-2.659h.375v2.791zm-.25-.266s.125 0 0 0l.125-2.393h-.125v2.393z"
            fill="#131A2D"
            />
            <path
            d="M423.281 92.01c-.125 0-.125-.132-.25-.132v-2.26h.25v2.393z"
            fill="#0EA59D"
            />
            <path
            d="M423.28 92.144c-.124-.133-.249-.133-.374-.133v-2.393h.374v2.526zm-.249-.266c.125 0 .125 0 0 0l.125-2.127h-.125v2.127z"
            fill="#131A2D"
            />
            <path
            d="M427.771 92.144c-.125 0-.125 0-.25.133v-2.525h.25v2.392z"
            fill="#0EA59D"
            />
            <path
            d="M427.521 92.277v-2.792h.375v2.659c-.125.133-.25.133-.375.133zm.125-2.526v2.393h.125l-.125-2.393z"
            fill="#131A2D"
            />
            <path d="M426.148 92.41h-.25v-2.925h.25v2.925z" fill="#0EA59D" />
            <path
            d="M425.898 92.543v-3.058h.499v3.058h-.499zm.125-2.925v2.792h.125l-.125-2.792z"
            fill="#131A2D"
            />
            <path
            d="M425.775 89.485v2.925h-.25v-2.925h.25s-.125 0 0 0z"
            fill="#0EA59D"
            />
            <path
            d="M425.65 92.543c-.125 0 0 0 0 0h-.25v-3.058h.375v3.058h-.125zm-.125-.133c.125 0 .125 0 0 0l.125-2.792h-.125v2.792z"
            fill="#131A2D"
            />
            <path
            d="M429.517 90.682c0 .133-.125.398-.249.531v-1.595h.249v1.064z"
            fill="#0EA59D"
            />
            <path
            d="M429.143 91.48v-1.862h.374v1.197c0 .132-.125.398-.25.531l-.124.133zm.124-1.729v1.33c.125-.134.125-.267.125-.4l-.125-.93z"
            fill="#131A2D"
            />
            <path
            d="M422.033 91.213c-.125-.133-.25-.398-.25-.531v-1.064h.25v1.595z"
            fill="#0EA59D"
            />
            <path
            d="M422.032 91.346l-.124-.133c-.125-.133-.125-.265-.25-.531v-1.197h.374v1.861zm-.124-.664v.266-1.197.93z"
            fill="#131A2D"
            />
            <path
            d="M428.644 91.745c-.125 0-.125.133-.249.133v-2.26h.249v2.127z"
            fill="#0EA59D"
            />
            <path
            d="M428.395 92.01v-2.392h.374v2.26c-.125 0-.25 0-.374.133zm.124-2.259v1.994h.125l-.125-1.994z"
            fill="#131A2D"
            />
            <path d="M426.523 92.41h-.25v-2.925h.25v2.925z" fill="#0EA59D" />
            <path
            d="M426.273 92.543v-3.058h.499v2.925h-.124c-.125.133-.25.133-.375.133zm.125-2.925v2.659h.125l-.125-2.659c.125 0 0 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M428.269 92.012c-.125 0-.125.132-.249.132v-2.392h.249v2.26z"
            fill="#0EA59D"
            />
            <path
            d="M427.895 92.144v-2.659h.374v2.393c-.125.266-.125.266-.374.266zm.124-2.393v2.26h.125l-.125-2.26z"
            fill="#131A2D"
            />
            <path d="M427.396 92.277h-.25v-2.659h.25v2.659z" fill="#0EA59D" />
            <path
            d="M427.146 92.41v-2.792h.375v2.791h-.375zm.125-2.659v2.526h.125l-.125-2.526z"
            fill="#131A2D"
            />
            <path d="M427.023 92.41h-.25v-2.792h.25v2.791z" fill="#0EA59D" />
            <path
            d="M426.648 92.543v-3.058h.375v2.792c-.125.133-.125.133-.375.266zm.125-2.792v2.659h.125l-.125-2.659c.125 0 .125 0 0 0z"
            fill="#131A2D"
            />
            <path
            d="M425.65 87.757c2.246 0 3.868.93 3.868 1.86 0 .931-1.622 1.862-3.868 1.862-2.245 0-3.867-.93-3.867-1.861 0-.93 1.622-1.861 3.867-1.861z"
            fill="#0EA59D"
            />
            <path
            d="M425.65 91.479c-2.37 0-3.867-1.064-3.867-1.994 0-.93 1.622-1.994 3.867-1.994 2.246 0 3.868 1.064 3.868 1.994 0 .93-1.497 1.994-3.868 1.994zm0-3.722c-2.245 0-3.742.93-3.742 1.728 0 .797 1.497 1.728 3.742 1.728 2.246 0 3.743-.93 3.743-1.728 0-.797-1.497-1.728-3.743-1.728z"
            fill="#131A2D"
            />
            <path
            opacity={0.25}
            d="M428.144 90.947c-.249.133-.499.266-.873.266l-3.119-3.323c.25 0 .624-.133.998-.133l2.994 3.19zM426.025 91.48h-.499l-2.745-2.925c.125-.133.25-.133.374-.266l2.87 3.19z"
            fill="#fff"
            />
            <path
            opacity={0.25}
            d="M426.898 91.213h.249c.125 0 .25-.133.374-.133.125 0 .25-.133.375-.133.124 0 .124 0 .249-.133h.25c.124 0 .249-.133.374-.133.249-.133.499-.266.748-.532a1.553 1.553 0 01-.623.665l-.125.133-.125.133h-.249c-.125 0-.125 0-.25.133l-.249.133h-.25c-.125 0-.249 0-.374.133h-.749c.125 0 .25 0 .375-.133v-.133zM425.027 91.346h.998-1.123c-.249 0-.374 0-.624-.133-.124 0-.374-.133-.499-.266h.624c.25 0 .374.266.624.399z"
            fill="#fff"
            />
            <path
            d="M425.276 77.655l-5.489 20.603-.25-.133 5.739-21.533v1.063zM431.887 97.992l-.249.266-6.238-20.603v-.93l.125.133 6.362 21.134z"
            fill="#131A2D"
            />
            <path
            d="M441.368 88.29l-17.091-11.963v-1.861l17.091 8.773v5.05z"
            fill="#0EA59D"
            />
            <path
            d="M441.493 88.423l-17.216-12.096v-1.994h.125l17.091 8.773v5.317zm-17.091-12.23l16.966 11.964v-4.785l-16.966-8.64v1.462z"
            fill="#131A2D"
            />
            <path
            d="M443.489 82.44l-2.121.798-17.091-8.773.624-.399 18.588 8.374z"
            fill="#131A2D"
            />
            <path
            d="M439.872 119.925c5.614-1.329 11.851.531 13.847 4.12 2.121 3.589-.748 7.577-6.362 8.906-5.614 1.329-11.851-.532-13.847-4.121-2.121-3.588.748-7.576 6.362-8.905z"
            fill="#0EA59D"
            />
            <path
            d="M443.739 133.483c-4.491 0-8.608-1.728-10.229-4.653-.749-1.329-.874-2.791-.375-4.12.874-2.26 3.369-3.988 6.737-4.785 5.614-1.329 11.851.531 13.972 4.12.748 1.33.873 2.792.374 4.121-.873 2.259-3.368 3.987-6.736 4.785a13.26 13.26 0 01-3.743.532zm-.249-13.824c-1.248 0-2.495.133-3.618.399-3.244.797-5.739 2.525-6.612 4.652-.499 1.329-.374 2.791.374 3.988 1.996 3.588 8.234 5.449 13.723 4.12 3.243-.797 5.738-2.525 6.612-4.652.499-1.329.374-2.791-.375-3.988-1.497-2.791-5.613-4.519-10.104-4.519z"
            fill="#131A2D"
            />
            <path
            d="M438.373 121.254s7.86-1.463 10.23-.133c.249.133.748.797.873 1.329.125 1.063-.374 2.26-1.622 3.057-2.37 1.462-6.237 1.462-8.607 0-1.248-.797-1.872-1.861-1.747-2.791.25-.665.873-1.462.873-1.462z"
            fill="#131A2D"
            />
            <path
            d="M439.622 120.189c2.121-1.329 5.738-1.329 7.859 0 2.246 1.329 2.246 3.589 0 4.918-2.121 1.33-5.738 1.33-7.859 0-2.121-1.462-2.121-3.589 0-4.918z"
            fill="#fff"
            />
            <path
            d="M443.613 126.038c-1.497 0-2.869-.399-3.992-1.063-1.122-.665-1.746-1.595-1.746-2.526 0-.93.624-1.861 1.622-2.525 2.245-1.33 5.738-1.33 7.984 0 1.122.664 1.746 1.595 1.746 2.525 0 .931-.624 1.861-1.622 2.526-1.122.797-2.495 1.063-3.992 1.063zm-3.867-5.848c-.998.664-1.622 1.462-1.622 2.392 0 .931.624 1.728 1.622 2.393 2.121 1.329 5.614 1.329 7.859 0 .998-.665 1.622-1.462 1.622-2.393 0-.93-.624-1.728-1.622-2.392-2.245-1.33-5.738-1.33-7.859 0z"
            fill="#000"
            />
            <path
            d="M445.609 122.317c0 .399-.125.664-.624.93-.748.532-1.996.532-2.744 0-.374-.266-.624-.531-.624-.93V83.371h3.992v38.946z"
            fill="#131A2D"
            />
            <path
            d="M445.235 80.181a4.824 4.824 0 012.37 4.785l-.374 4.254c0 .266-.125.399-.249.532h-.125l-3.368 1.993-3.743-10.9 1.372-.797c1.248-.664 2.87-.664 4.117.133z"
            fill="#131A2D"
            />
            <path
            d="M440.62 81.111l2.121 1.33c.873.531 1.497 1.728 1.372 2.658l-.499 6.247c0 .532-.374.798-.873.4l-2.246-1.33c-.499-.266-.873-.93-.873-1.595l-.499-6.78c0-1.063.624-1.461 1.497-.93z"
            fill="#fff"
            />
            <path
            d="M443.24 92.011c-.125 0-.25 0-.499-.133l-2.246-1.329c-.499-.266-.873-1.063-.998-1.595l-.499-6.779c0-.531.125-.93.374-1.196.25-.133.624-.133 1.123.133l2.121 1.329c.873.532 1.497 1.86 1.497 2.791l-.499 6.248a.74.74 0 01-.374.664c.124-.133 0-.133 0-.133zm-3.244-11.032c-.125 0-.249 0-.374.133-.25.133-.374.532-.374 1.063l.499 6.78c0 .53.374 1.195.873 1.461l2.245 1.33c.25.132.375.132.499.132.125-.132.25-.265.25-.398l.499-6.248c.125-.93-.624-2.126-1.372-2.658l-2.121-1.33c-.25-.265-.499-.265-.624-.265z"
            fill="#000"
            />
            <path
            d="M448.105 85.498l17.59 12.893-.624.4-19.96-13.559c.874-.531 2.121-.398 2.994.266z"
            fill="#131A2D"
            />
            <path
            d="M444.986 85.232l20.085 13.558-.624 1.196-17.839-9.039c-1.123-.531-1.872-1.86-1.747-3.323l.125-2.392z"
            fill="#0EA59D"
            />
            <path
            d="M464.447 99.986l-17.964-9.039c-1.248-.664-1.871-1.993-1.747-3.323l.25-2.525 20.209 13.69-.748 1.197zm-19.336-14.621l-.25 2.26c-.125 1.329.624 2.658 1.747 3.19l17.839 9.038.624-1.063-19.96-13.425z"
            fill="#131A2D"
            />
            <path
            d="M465.695 98.39l-.499 1.064-.749.532.624-1.197.624-.398z"
            fill="#131A2D"
            />
            <path
            d="M27.446 173.491l20.584 12.228c.25.133.374.399.374.532v18.875c0 1.063-.873 1.329-1.372 1.196l-20.21-12.76c-.249-.133-.374-.399-.374-.532l-.499-18.476c0-1.063.998-1.196 1.497-1.063z"
            fill="#4258A7"
            />
            <path
            d="M26.823 173.757l20.708 12.229c.25.133.374.398.374.531v18.875c0 .532-.499.798-.873.532l-20.708-12.229c-.25-.133-.375-.399-.375-.532v-18.874c0-.399.5-.798.873-.532z"
            fill="#fff"
            />
            <path
            d="M47.281 206.322c-.124 0-.25 0-.374-.132l-20.708-12.229a.74.74 0 01-.375-.665v-18.874a.74.74 0 01.374-.665.752.752 0 01.749 0l20.709 12.229c.249.133.374.398.374.664v18.875a.74.74 0 01-.374.665c-.125.132-.25.132-.375.132zm-20.708-32.565c-.125 0-.25 0-.25.133-.125.133-.25.266-.25.532v18.874c0 .266.125.399.25.532l20.709 12.229a.362.362 0 00.499 0c.125-.133.25-.266.25-.532V186.65c0-.266-.125-.399-.25-.531L26.822 173.89c-.124-.133-.124-.133-.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M34.682 196.885l-6.862-4.121v-14.621l6.862 3.988v14.754z"
            fill="#0EA59D"
            />
            <path
            d="M34.806 197.018l-7.11-4.12v-14.755l7.11 4.121v14.754zm-6.986-4.253l6.861 3.987v-14.488l-6.86-3.988v14.489z"
            fill="#131A2D"
            />
            <path
            d="M33.807 184.923l-1.622-.931v-.265l1.622.93v.266zM31.811 183.726l-1.747-.931v-.266l1.747.931v.266zM29.566 182.529l-1.248-.797v-.266l1.248.797v.266zM33.807 185.72l-3.618-2.127v-.266l3.618 2.127v.266zM29.94 183.461l-.749-.399v-.266l.749.399v.266zM28.942 182.928l-.624-.398v-.266l.624.266v.398zM33.807 186.384l-1.497-.798v-.398l1.497.93v.266zM31.81 185.321l-2.869-1.728v-.266l2.87 1.595v.399zM28.693 183.46l-.375-.266v-.266l.375.266v.266zM33.808 187.182l-2.37-1.329v-.266l2.37 1.329v.266zM29.316 184.524l-.998-.532v-.265l.998.531v.266zM31.188 185.587l-1.622-.931v-.265l1.622.93v.266zM33.808 187.846l-.5-.266v-.266l.5.266v.266zM29.69 185.454l-1.372-.797v-.266l1.373.797v.266zM33.058 187.447l-3.119-1.861v-.266l3.12 1.861v.266zM33.809 188.643l-2.994-1.728v-.266l2.994 1.728v.266zM30.564 186.65l-2.246-1.197v-.265l2.246 1.196v.266zM33.808 189.441l-1.123-.664v-.266l1.123.531v.399zM28.942 186.517l-.624-.399v-.265l.624.398v.266zM32.434 188.644l-.498-.399v-.266l.498.399v.266zM31.687 188.112l-2.246-1.33v-.265l2.246 1.329v.266zM33.806 190.106l-1.995-1.197v-.265l1.995 1.196v.266zM29.192 187.447l-.874-.532v-.266l.874.532v.266zM31.563 188.776l-.998-.532v-.398l.997.664v.266zM30.19 187.979l-.624-.399v-.266l.624.399v.266zM33.808 190.904l-1.373-.93v-.266l1.373.798v.398zM28.568 187.846l-.25-.266v-.266l.25.133v.399zM32.187 189.84l-1.372-.798v-.266l1.372.798v.266zM30.688 189.043l-1.747-1.063v-.266l1.747 1.063v.266zM33.807 191.569l-2.745-1.595v-.266l2.745 1.595v.266zM30.813 189.84l-.873-.531v-.266l.873.532v.265zM29.69 189.176l-1.372-.798v-.266l1.373.798v.266zM33.807 192.366l-.873-.532v-.266l.873.532v.266zM28.817 189.441l-.499-.399v-.266l.5.399v.266zM32.809 191.701l-.873-.532v-.266l.873.532v.266zM31.686 191.037l-2.62-1.463v-.265l2.62 1.462v.266zM33.807 193.03l-1.497-.93v-.266l1.497.93v.266zM29.566 190.505l-1.248-.665v-.266l1.248.665v.266zM32.186 192.1l-2.495-1.462v-.266l2.495 1.462v.266zM33.807 193.828l-.998-.665v-.266l.998.665v.266zM32.685 193.163l-1.373-.798v-.265l1.373.797v.266zM31.063 192.233l-2.745-1.728v-.266l2.745 1.728v.266z"
            fill="#fff"
            />
            <path
            d="M43.414 193.296l-.749.532-.25-.399c-.124 0-.374-.133-.623-.266-1.248-.797-2.246-2.525-2.246-3.855v-.398l-.25-.399.75-.532c.124 0 .124-.133.249-.133a1.614 1.614 0 011.497.266c1.247.798 2.245 2.526 2.245 3.855 0 .664-.25 1.063-.623 1.329zM38.799 196.354c0-.532.125-.931.25-1.33l-.125-.266.748-.531h.125c.499-.266 1.247-.266 1.996.133 1.622 1.063 2.994 3.854 2.994 5.715l-.873.532-1.872-1.861.375-.133-3.618-2.259z"
            fill="#131A2D"
            />
            <path
            d="M40.92 188.644c1.247.797 2.245 2.525 2.245 3.855 0 1.462-.998 1.993-2.246 1.196-1.247-.798-2.245-2.526-2.245-3.855 0-1.462.998-1.994 2.245-1.196z"
            fill="#0EA59D"
            />
            <path
            d="M41.917 194.093c-.374 0-.748-.133-1.123-.398-1.247-.798-2.245-2.526-2.245-3.988 0-.665.25-1.196.624-1.462.499-.266 1.122-.266 1.746.133 1.248.797 2.246 2.525 2.246 3.987 0 .665-.25 1.197-.624 1.463-.125.265-.374.265-.624.265zm-1.996-5.715c-.25 0-.374 0-.499.133-.374.266-.624.664-.624 1.329 0 1.329.998 3.057 2.121 3.855.624.398 1.123.398 1.622.133.374-.266.624-.665.624-1.33 0-1.329-.998-3.057-2.121-3.854-.5-.133-.873-.266-1.123-.266z"
            fill="#131A2D"
            />
            <path
            d="M40.92 194.891c1.621 1.063 2.994 3.855 2.994 5.716l-5.988-3.589c0-1.994 1.372-3.19 2.994-2.127z"
            fill="#0EA59D"
            />
            <path
            d="M43.913 200.74l-6.112-3.722c0-1.063.374-1.861.998-2.26.623-.398 1.372-.265 1.996.133 1.871.931 3.118 3.855 3.118 5.849zm-5.987-3.855l5.863 3.589c0-1.728-1.248-4.519-2.994-5.45-.749-.399-1.373-.531-1.872-.133-.623.266-.998 1.064-.998 1.994z"
            fill="#131A2D"
            />
            <path
            d="M26.7 231.976l19.21 12.228 14.347-7.177-24.077-14.755-9.48 9.704z"
            fill="url(#paint233_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M42.293 224l-11.976-7.31c-.374-.266-.749-.266-1.123-.266s-.748.133-1.123.266l-11.976 6.912c-.748.398-1.122 1.329-1.122 2.126 0 .931.499 1.728 1.122 2.127l11.976 7.178c.375.133.749.266 1.123.266s.749-.133 1.123-.266l11.976-6.912c.748-.399 1.123-1.329 1.123-2.127.124-.664-.375-1.462-1.123-1.994z"
            fill="#fff"
            />
            <path
            d="M28.197 216.956l-11.852 6.912c-.25.133-.499.399-.748.665-.25.399-.5.93-.374 1.462 0 .797.623 1.595 1.247 1.994l11.851 7.044c.25.133.5.266.624.266h.374c.375 0 .749-.133 1.123-.266l11.851-6.778c.25-.133.5-.399.624-.532.374-.399.5-1.064.5-1.595 0-.798-.625-1.595-1.248-1.994l-11.727-7.178c-.25-.133-.748-.266-.998-.266h-.374c-.374 0-.624.133-.873.266z"
            fill="#F8F8F9"
            />
            <path
            d="M28.322 217.088L16.47 224c-.25.133-.623.399-.748.665-.374.399-.374.93-.374 1.462 0 .665.748 1.595 1.372 1.861l11.602 6.912c.25.133.499.133.623.266h.375c.25 0 .748-.133.998-.399l11.601-6.646c.25-.133.5-.399.624-.532.374-.399.5-.93.374-1.462 0-.665-.748-1.595-1.247-1.861l-11.477-6.912c-.25-.133-.749-.399-.998-.399h-.374c0-.132-.25 0-.5.133z"
            fill="#F1F1F3"
            />
            <path
            d="M28.446 217.221L16.719 224c-.125.133-.624.399-.748.664-.375.399-.375.931-.25 1.33 0 .664.873 1.462 1.372 1.86l11.353 6.912c.25.133.499.133.623.133h.375c.25 0 .748-.266.998-.398l11.352-6.514c.125-.133.499-.398.624-.531.374-.399.499-.931.374-1.462 0-.665-.873-1.463-1.372-1.728l-11.103-6.779c-.25-.133-.749-.399-.998-.399h-.25c-.25 0-.499 0-.623.133z"
            fill="#EAEBEC"
            />
            <path
            d="M28.446 217.488l-11.602 6.779c-.125.133-.624.399-.748.531-.375.399-.375.931-.25 1.33 0 .531.998 1.462 1.497 1.728l11.228 6.779c.25.132.374.132.623.132h.375c.25 0 .748-.265.998-.398l11.227-6.38c.125-.133.5-.399.624-.532.374-.399.499-.931.25-1.462 0-.532-.999-1.462-1.373-1.595l-10.853-6.646c-.125-.133-.749-.399-.998-.399h-.25c-.25-.133-.499 0-.748.133z"
            fill="#E3E4E6"
            />
            <path
            d="M28.57 217.62l-11.6 6.646c-.126.133-.625.399-.75.532-.374.399-.374.931-.249 1.329 0 .399 1.248 1.33 1.497 1.595l10.978 6.646c.25.133.374.133.624.133h.374c.125 0 .749-.265.998-.398l10.978-6.381c.125 0 .5-.398.624-.398.374-.399.499-.931.25-1.33 0-.398-1.123-1.329-1.373-1.462l-10.604-6.38c-.124-.133-.748-.399-.873-.399l-.25-.133c-.124-.132-.374-.132-.623 0z"
            fill="#DDDDE0"
            />
            <path
            d="M28.696 217.753l-11.477 6.646c-.125 0-.748.399-.748.532-.375.266-.375.93-.125 1.329 0 .266 1.372 1.329 1.622 1.462l10.853 6.513c.25.133.374.133.623.133l.25-.133c.125 0 .748-.399.873-.399l10.853-6.247c.125 0 .5-.399.624-.399.375-.265.5-.93.125-1.329 0-.266-1.247-1.196-1.497-1.329l-10.23-6.247c-.124-.133-.748-.399-.873-.399l-.25-.133c-.249-.133-.498-.133-.623 0z"
            fill="#D6D6DA"
            />
            <path
            d="M28.694 217.886l-11.352 6.646s-.748.399-.748.532c-.375.265-.375.93-.125 1.196 0 .266 1.497 1.196 1.622 1.329l10.603 6.38c.25.133.375.133.624 0l.25-.133c.124 0 .873-.398.873-.398l10.604-6.115.623-.399c.375-.265.5-.93.125-1.329 0-.266-1.372-1.196-1.497-1.196l-9.98-6.114c-.125 0-.748-.399-.873-.399l-.25-.133s-.25.133-.499.133z"
            fill="#CFD0D3"
            />
            <path
            d="M28.82 218.151l-11.228 6.514s-.749.398-.749.531c-.374.266-.374.931 0 1.197 0 .132 1.622 1.196 1.747 1.196l10.354 6.247c.25.133.374.133.624 0l.25-.133.872-.399 10.48-5.981.623-.399c.374-.266.5-.93 0-1.196 0-.133-1.497-1.063-1.622-1.196l-9.605-5.849-.749-.399-.25-.133a.757.757 0 00-.748 0z"
            fill="#C8C9CD"
            />
            <path
            d="M29.568 218.285c-.25-.133-.374-.133-.624 0l-11.976 6.912c-.374.266-.374.931 0 1.196l11.976 7.178c.125.133.374.133.624 0l11.976-6.912c.374-.266.374-.93 0-1.196l-11.976-7.178z"
            fill="#C1C2C7"
            />
            <path
            d="M42.167 224.133h-1.996l-9.605-5.716c-.749-.398-1.497-.398-2.246 0l-9.855 5.716h-1.996v1.728c0 .266.124.532.499.798l11.352 6.646c.748.398 1.497.398 2.245 0l11.103-6.646c.25-.133.374-.399.374-.798v-1.728h.125z"
            fill="#0EA59D"
            />
            <path
            d="M29.568 233.703c-.375 0-.749-.133-1.123-.266l-11.352-6.646c-.25-.133-.5-.398-.5-.797V224h2.122l9.73-5.716a2.502 2.502 0 012.37 0L40.296 224h2.121v1.994c0 .266-.25.532-.499.797l-11.103 6.646c-.374.133-.873.266-1.247.266zm-12.85-7.842c0 .399.125.532.375.665l11.352 6.646a2.033 2.033 0 002.12 0l11.104-6.646a.74.74 0 00.374-.665v-1.595h-1.871l-9.606-5.716a2.033 2.033 0 00-2.121 0l-9.855 5.716h-1.872v1.595z"
            fill="#131A2D"
            />
            <path
            d="M17.093 223.203l11.352-6.646c.749-.399 1.497-.399 2.246 0l11.102 6.646c.624.399.624 1.196 0 1.595l-11.102 6.646c-.749.399-1.497.399-2.246 0l-11.352-6.646c-.624-.266-.624-1.196 0-1.595z"
            fill="#fff"
            />
            <path
            d="M41.795 224.665l-4.117 2.393-6.861 3.987-.125.133c-.748.399-1.497.399-2.245 0l-7.36-4.253-3.244-1.861-.873-.532c-.624-.398-.624-1.196 0-1.595l11.352-6.646c.748-.399 1.497-.399 2.245 0l2.87 1.728 4.241 2.526 3.867 2.259c.874.532.874 1.463.25 1.861z"
            fill="#fff"
            />
            <path
            d="M29.57 231.71c-.375 0-.749-.133-1.123-.266l-11.352-6.646c-.374-.133-.5-.531-.5-.93s.25-.798.5-.931l11.352-6.646a2.496 2.496 0 012.37 0l11.103 6.646c.374.133.499.532.499.931s-.25.797-.499.93l-11.103 6.646c-.374.133-.873.266-1.247.266zm0-15.419c-.375 0-.749.133-.998.266l-11.352 6.646a.74.74 0 00-.375.665c0 .266.125.531.375.664l11.352 6.646a2.028 2.028 0 002.12 0l.125-.133 10.853-6.513a.738.738 0 00.375-.664.74.74 0 00-.375-.665l-11.102-6.646a2.235 2.235 0 00-.998-.266z"
            fill="#000"
            />
            <path
            d="M92.441 406.9l19.212 12.229 14.346-7.178-24.077-14.621-9.48 9.57z"
            fill="url(#paint234_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M108.035 399.058l-11.976-7.311c-.374-.266-.748-.266-1.123-.266-.374 0-.748.133-1.122.266l-11.976 6.912c-.749.399-1.123 1.329-1.123 2.127 0 .93.499 1.728 1.123 2.127l11.976 7.177c.374.133.748.266 1.122.266.375 0 .749-.133 1.123-.266l11.976-6.912c.749-.398 1.123-1.329 1.123-2.126 0-.665-.374-1.595-1.123-1.994z"
            fill="#fff"
            />
            <path
            d="M93.939 391.881l-11.851 6.912c-.25.133-.5.399-.749.665-.25.398-.499.93-.374 1.462 0 .797.624 1.595 1.247 1.993l11.852 7.045c.25.133.499.266.623.266h.375c.374 0 .748-.133 1.122-.266l11.727-6.779c.249-.133.499-.398.624-.531.374-.399.499-1.064.499-1.595 0-.798-.624-1.595-1.248-1.994l-11.726-7.178c-.25-.133-.749-.266-.998-.266h-.375c-.25.133-.499.133-.748.266z"
            fill="#F8F8F9"
            />
            <path
            d="M93.939 392.146l-11.851 6.912c-.25.133-.624.399-.749.664-.374.399-.374.931-.374 1.463 0 .664.748 1.595 1.372 1.86l11.602 6.912c.25.133.499.133.624.266h.374c.25 0 .748-.133.998-.399l11.602-6.646c.249-.133.499-.398.623-.531.375-.399.499-.931.375-1.462 0-.665-.749-1.595-1.248-1.861l-11.477-6.912c-.25-.133-.748-.399-.998-.399h-.374c0-.133-.25 0-.5.133z"
            fill="#F1F1F3"
            />
            <path
            d="M94.063 392.279l-11.727 6.779c-.124.133-.623.399-.748.664-.374.399-.374.931-.25 1.33 0 .664.874 1.462 1.373 1.86l11.352 6.912c.25.133.499.133.623.133h.375c.25 0 .748-.266.998-.399l11.352-6.513c.125-.133.499-.398.624-.531.374-.399.499-.931.374-1.462 0-.665-.873-1.463-1.372-1.728l-11.103-6.779c-.25-.133-.748-.399-.998-.399h-.25c-.124-.133-.374 0-.623.133z"
            fill="#EAEBEC"
            />
            <path
            d="M94.188 392.411l-11.602 6.779c-.124.133-.623.399-.748.532-.374.399-.374.931-.25 1.329 0 .532.998 1.462 1.497 1.728l11.228 6.779c.25.133.374.133.623.133h.375c.25 0 .748-.266.998-.399l11.227-6.38c.125-.133.499-.399.624-.531.374-.399.499-.931.25-1.463 0-.531-.998-1.462-1.373-1.595l-10.853-6.646c-.125-.133-.748-.398-.998-.398h-.25c-.249 0-.499 0-.748.132z"
            fill="#E3E4E6"
            />
            <path
            d="M94.313 392.677l-11.602 6.646c-.124.133-.623.399-.748.532-.374.398-.374.93-.25 1.329 0 .399 1.248 1.329 1.497 1.595l10.978 6.646c.25.133.374.133.624.133h.374c.125 0 .749-.266.998-.399l10.978-6.38c.125 0 .499-.399.624-.399.374-.399.499-.93.25-1.329 0-.399-1.123-1.329-1.373-1.462l-10.603-6.38c-.125-.133-.749-.399-.874-.399 0 0-.25-.133-.25 0-.249-.399-.498-.266-.623-.133z"
            fill="#DDDDE0"
            />
            <path
            d="M94.313 392.811l-11.477 6.646c-.125 0-.748.398-.748.531-.375.266-.375.931-.125 1.33 0 .265 1.372 1.329 1.622 1.462l10.853 6.513c.25.133.374.133.624.133l.25-.133c.124 0 .748-.399.873-.399l10.853-6.247c.124 0 .499-.399.623-.399.375-.266.499-.93.125-1.329 0-.266-1.247-1.197-1.497-1.329l-10.23-6.248c-.124-.133-.748-.398-.873-.398l-.249-.133c-.125-.133-.374-.133-.624 0z"
            fill="#D6D6DA"
            />
            <path
            d="M94.436 392.943l-11.352 6.646s-.748.399-.748.532c-.374.266-.374.931-.125 1.196 0 .266 1.497 1.197 1.622 1.33l10.603 6.38c.25.133.375.133.624 0l.25-.133c.124 0 .873-.399.873-.399l10.604-6.114.624-.399c.374-.266.499-.93.124-1.329 0-.266-1.372-1.196-1.497-1.196l-9.98-6.115c-.125 0-.748-.399-.873-.399l-.25-.132c-.124 0-.249 0-.499.132z"
            fill="#CFD0D3"
            />
            <path
            d="M94.561 393.077L83.21 399.59s-.749.399-.749.531c-.374.266-.374.931 0 1.197 0 .133 1.622 1.196 1.747 1.196l10.354 6.247c.25.133.374.133.624 0l.25-.133.873-.398 10.479-5.982.623-.399c.375-.265.499-.93 0-1.196 0-.133-1.497-1.063-1.621-1.196l-9.606-5.849-.749-.398-.25-.133c-.249-.133-.498 0-.623 0z"
            fill="#C8C9CD"
            />
            <path
            d="M95.185 393.343c-.25-.133-.374-.133-.624 0l-11.976 6.912c-.374.266-.374.93 0 1.196l11.976 7.178c.125.133.375.133.624 0l11.976-6.912c.374-.266.374-.931 0-1.196l-11.976-7.178z"
            fill="#C1C2C7"
            />
            <path
            d="M105.915 399.189l-9.605-5.715c-.749-.399-1.497-.399-2.246 0l-9.855 5.715h-1.996v1.728c0 .266.125.532.499.798l11.352 6.646c.749.399 1.497.399 2.246 0l11.102-6.646c.25-.133.375-.399.375-.798v-1.728h-1.872z"
            fill="#0EA59D"
            />
            <path
            d="M95.312 408.628c-.374 0-.749-.133-1.123-.266l-11.352-6.646c-.25-.133-.5-.399-.5-.798v-1.993h2.122l9.73-5.716a2.496 2.496 0 012.37 0l9.481 5.716h2.121v1.993c0 .266-.249.532-.499.798l-11.103 6.646c-.499.266-.873.266-1.247.266zm-12.85-7.843c0 .399.125.532.375.665l11.352 6.646a2.028 2.028 0 002.12 0l11.104-6.646a.74.74 0 00.374-.665V399.19h-1.871l-9.606-5.715a2.028 2.028 0 00-2.12 0l-9.856 5.715h-1.871v1.595z"
            fill="#131A2D"
            />
            <path
            d="M82.71 398.26l11.352-6.646c.749-.399 1.497-.399 2.246 0l11.103 6.646c.623.398.623 1.196 0 1.595l-11.103 6.646c-.749.398-1.497.398-2.246 0l-11.352-6.646c-.499-.399-.499-1.197 0-1.595z"
            fill="#fff"
            />
            <path
            d="M107.412 399.589l-4.117 2.393-6.86 3.987-.126.133c-.748.399-1.497.399-2.245 0l-7.36-4.253-3.244-1.861-.873-.532c-.624-.399-.624-1.196 0-1.595l11.352-6.646c.749-.399 1.497-.399 2.246 0l2.869 1.728 4.241 2.526 3.868 2.259c.873.665.873 1.595.249 1.861z"
            fill="#fff"
            />
            <path
            d="M95.312 406.634c-.374 0-.749-.133-1.123-.266l-11.352-6.646c-.374-.133-.5-.532-.5-.93 0-.399.25-.798.5-.931l11.352-6.646a2.496 2.496 0 012.37 0l11.103 6.646c.374.133.499.532.499.931 0 .398-.249.797-.499.93l-11.103 6.646c-.499.266-.873.266-1.247.266zm0-15.286c-.374 0-.749.133-.998.266l-11.352 6.646a.74.74 0 00-.375.664.74.74 0 00.375.665l11.352 6.646a2.028 2.028 0 002.12 0l.125-.133 10.854-6.513a.74.74 0 00.374-.665.74.74 0 00-.374-.664l-11.103-6.646c-.374-.266-.624-.266-.998-.266z"
            fill="#000"
            />
            <path
            d="M30.316 199.011l.998.133c-.25-.798.125-.93.125-.93l-.374-.798-.749 1.595z"
            fill="#fff"
            />
            <path
            d="M31.439 199.277l-1.248-.266.749-1.728.499.931h-.125s-.125 0-.125.133c0 .132 0 .398.25.93zm-.998-.399l.748.133a.896.896 0 010-.797c0-.133.125-.133.125-.133l-.25-.532-.623 1.329z"
            fill="#000"
            />
            <path
            d="M36.18 195.556c0-.133-.498.133-.748.399-.374.133-.25-.133-.374-.133-.125 0-.624.266-.624.398-.125.133 0 .665-.25 1.197-.374.531-1.372 1.196-2.37 1.861-.499.265-.25 1.329.5 1.196.623-.133 2.245-2.127 2.494-2.526 0 0 .749-.531.873-.797.125-.266.5-.266.375-.399-.125 0-.374 0-.5.133-.124.133-.124-.266.126-.532.249-.265.623-.664.498-.797z"
            fill="#fff"
            />
            <path
            d="M32.063 200.341c-.374 0-.499-.266-.623-.531-.125-.399 0-.665.25-.798 1.247-.797 2.12-1.462 2.37-1.861.124-.266.124-.664.124-.797v-.266c.125-.133.624-.399.749-.399.124 0 .124 0 .124.133 0 0 .125.133.25 0 0 0 .125 0 .125-.133.374-.266.623-.399.623-.266v.133c0 .133-.124.133-.374.399-.125.133-.374.266-.374.399-.125.133-.125.398-.125.398.5-.132.624-.132.624-.132v.132c0 .133 0 .133-.125.133s-.25.133-.25.266c-.124.133-.748.665-.873.798-.25.531-1.746 2.259-2.495 2.392.125 0 .125 0 0 0zm2.994-4.519c-.124 0-.499.266-.623.266v.266c0 .266 0 .531-.25.93-.374.532-1.497 1.329-2.495 1.861-.25.133-.25.399-.25.665.125.265.25.398.624.398.5-.133 1.622-1.329 2.495-2.525.25-.266.749-.665.749-.798.125-.133.25-.133.25-.265-.125 0-.25 0-.375.132h-.125c-.124-.132 0-.398.125-.531s.25-.266.5-.399c.124 0 .249-.133.249-.266-.125 0-.25.133-.375.266 0 0-.124 0-.124.133-.125.133-.25 0-.375-.133z"
            fill="#000"
            />
            <path
            d="M28.82 209.38s.623 1.728.125 2.924c-.874 1.994-.5 6.38-.624 6.912-.125.532.748 1.063.998 0s1.247-5.45 1.622-6.513c.498-1.063.249-3.057.249-3.057l-2.37-.266z"
            fill="#fff"
            />
            <path
            d="M28.82 219.881c-.126 0 0 0 0 0-.375-.133-.625-.399-.625-.665v-.798c0-1.595 0-4.386.624-5.981.5-1.196-.125-2.924-.125-2.924v-.133l2.62.266c0 .133.125 1.994-.25 3.057-.498 1.063-1.496 5.45-1.621 6.513-.25.665-.5.665-.624.665zm.124-10.368c.125.399.499 1.861.125 2.924-.624 1.595-.624 4.519-.624 5.981v.931c0 .266.125.532.374.532.25 0 .374-.133.5-.532.249-1.063 1.247-5.45 1.62-6.513.375-.931.25-2.659.25-2.924l-2.245-.399z"
            fill="#000"
            />
            <path
            d="M30.568 210.709c.374.93.873 3.456.624 5.184-.25 1.595.25 4.918.25 5.317 0 .531.872.93.872-.133 0-1.064.5-5.184.749-6.38.25-1.197-.25-4.653-.25-4.653s-2.62-.132-2.245.665z"
            fill="#fff"
            />
            <path
            d="M31.939 221.875c-.25 0-.624-.266-.624-.665 0-.133 0-.398-.125-.797-.124-1.196-.374-3.323-.25-4.519.25-1.596-.249-4.254-.623-5.184-.125-.133 0-.266 0-.399.374-.532 2.246-.266 2.495-.266 0 .133.5 3.589.25 4.652-.25 1.196-.749 5.317-.749 6.38.125.798-.25.798-.374.798zM30.69 210.71c.375.93.874 3.456.624 5.184-.125 1.196.125 3.323.25 4.519 0 .399.124.664.124.797 0 .266.25.532.5.532.249 0 .249-.266.374-.532 0-1.063.499-5.184.748-6.38.25-1.063-.125-4.12-.125-4.519-.623-.133-1.996-.133-2.245.266-.374 0-.374 0-.25.133z"
            fill="#000"
            />
            <path
            d="M33.06 222.538c-.623-.398-.498-1.462-.498-1.462-.749 0-1.123-.133-1.123-.133 0 .399-.375.931-.375 1.462 0 .399.375.665.375 1.064h.25l-.125-.931c.498 0 1.122.931 1.746.931.624 0 .873-.266.873-.399 0-.266-.623-.133-1.123-.532zM29.816 220.811c-.623-.399-.499-1.462-.499-1.462-.748 0-1.122-.133-1.122-.133 0 .399-.375.93-.375 1.462 0 .399.375.665.375 1.063h.25l-.126-.93c.5 0 1.123.93 1.747.93.624 0 .873-.266.873-.398.125-.266-.499-.133-1.123-.532zM29.318 203.664s-.25.798-.748 1.595c-.5.798-.998 2.26-.749 3.19.125 1.064-.25 5.051-.499 7.045 0 0 1.747.399 2.37.798 2.246 1.728 4.741.132 4.741.132 0-4.386-1.746-9.969-1.996-12.494l-3.119-.266z"
            fill="#131A2D"
            />
            <path
            d="M32.812 201.272c-.125-.399-.25-.798-.374-1.463-.125-.664-1.123-1.063-2.12-.93-.999.133-1.248 1.728-1.248 2.791 0 .931.124 1.994-.375 3.456 1.123 1.064 2.87 1.595 3.992.931-.124-.931-.623-2.659-.374-3.456 0-.133.749-.532.5-1.329z"
            fill="#0EA59D"
            />
            <path
            d="M31.565 206.323c-.998 0-2.121-.532-2.87-1.197.375-1.329.375-2.259.375-3.057v-.399c0-.93.124-2.658 1.247-2.791.998-.133 1.996.266 2.12.93 0 .133.126.266.126.399.124.399.124.665.25 1.064.249.664-.25 1.063-.375 1.196l-.125.133c-.125.531 0 1.462.25 2.392.124.399.124.665.124.931-.374.399-.748.399-1.122.399zm-2.745-1.197c1.123 1.064 2.87 1.462 3.867.931 0-.266-.124-.532-.124-.931-.125-.93-.375-1.861-.25-2.525 0 0 0-.133.125-.133.25-.266.624-.532.374-1.064-.125-.265-.125-.664-.25-1.063 0-.133-.124-.266-.124-.399-.125-.531-1.123-.93-1.996-.797-.998.133-1.123 1.728-1.123 2.658v.399c-.125.665-.125 1.595-.499 2.924z"
            fill="#131A2D"
            />
            <path
            d="M32.06 196.22v-.531c-.124-.931-1.372-.133-1.87.664-.5.798 1.372 2.26 1.746 1.462.499-.797.25-1.462.25-1.462-.125 0-.125 0-.125-.133z"
            fill="#fff"
            />
            <path
            d="M31.563 198.214c-.499 0-1.122-.532-1.497-1.063a.898.898 0 010-.798c.375-.665 1.248-1.329 1.622-1.196.125 0 .25.133.374.531v.532s0 .133.125.133c0 .133.25.665-.25 1.595 0 .266-.124.266-.374.266zm.125-2.791c-.374 0-1.123.531-1.372 1.063-.125.266 0 .399 0 .665.25.531.873.93 1.372.93.125 0 .25 0 .25-.133.499-.797.249-1.462.249-1.462-.125-.133-.125-.133-.125-.266v-.399c-.124-.265-.124-.398-.374-.398z"
            fill="#000"
            />
            <path
            d="M30.69 194.758c-.998.266-1.372-.398-1.871.931-.499 1.063-1.247 0-1.622 1.196-.499 1.196 0 .798-.623 1.994-.624.93 0 1.861.249 2.525.25.665.624.931.125 1.861 0 0 2.12 0 1.871-1.462-.125-1.462 1.123-.797.998-1.861-.125-.797.873-.531.873-1.063 0-.532.873-.798.25-1.728-.375-.532 1.122-.931.998-1.595.25-.399-.25-1.064-1.248-.798z"
            fill="#131A2D"
            />
            <path
            d="M31.063 196.619c-.124.133 0 .399.125.532s.25.133.125 0c0-.133.125-.266 0-.532 0-.133-.25-.266-.25 0z"
            fill="#fff"
            />
            <path
            d="M31.314 197.284s-.125 0-.125-.133c-.125-.133-.125-.399-.125-.665 0-.132.125-.132.25-.132s.25.132.25.132v.532c-.125.266-.25.266-.25.266zm-.125-.665c-.125 0-.125 0 0 0-.125.133 0 .399 0 .532v-.133-.399c.125 0 0 0 0 0z"
            fill="#000"
            />
            <path
            d="M37.927 196.353c-.124-.133-.623.133-.25 0 .375-.266.5-.532.375-.532-.125.133-.624.399-.748.665-.125.266-.25.797-.375.664-.125-.132-.125-.398-.25-.398-.124 0 .125.133.125.398 0 .133 0 .532.125.798-.125.532-1.123 1.861-1.497 2.393-.25 0-1.372-.133-2.245-.532-1.123-.399-1.747-.133-1.871.133-.25.664.249 1.329 1.247 1.595.998.266 2.37.399 3.618 0h.125c.623-.399 1.497-3.323 1.497-3.456.124-.133.124-.266.249-.532s.624-.531.499-.664c-.374 0-.499-.532-.624-.532z"
            fill="#fff"
            />
            <path
            d="M34.31 201.803c-.624 0-1.373-.133-2.121-.266-.624-.133-.998-.399-1.248-.798a.896.896 0 010-.797c.125-.399.749-.532 1.872-.133.748.266 1.621.399 1.995.531h.25c.125-.265.374-.531.499-.797.374-.532.748-1.196.873-1.462 0-.266-.124-.665-.124-.798s0-.266-.125-.266v-.132h.125c.124 0 .249.265.374.398 0 0 0-.133.124-.266 0-.132.125-.265.125-.398.125-.266.5-.532.749-.665h.249v.133c0 .133-.124.266-.25.399h.25c.125 0 .125.266.25.531 0 .133.124.133.124.133.125.133-.124.266-.249.399l-.25.266c0 .133-.124.133-.124.266s-.125.133-.125.266c-.125.266-.873 3.057-1.497 3.456H34.31zm-2.496-2.127c-.374 0-.623.133-.623.266a.896.896 0 000 .797c.125.399.623.665 1.122.798 1.373.266 2.62.399 3.493 0h.125c.5-.266 1.123-2.26 1.497-3.323 0-.133.125-.133.125-.266s.125-.133.125-.266.25-.266.374-.399c.125-.133.25-.133.25-.266 0 0 0-.132-.125-.132 0-.133-.125-.399-.25-.399h-.499c0-.133 0-.133.125-.133.125-.133.25-.133.25-.266-.25.133-.5.266-.624.532 0 .133-.125.266-.125.398-.125.266-.125.399-.25.399 0 0-.124 0-.124-.133s-.125-.133-.125-.266v.266c0 .133 0 .399.125.798-.125.399-.5 1.063-.998 1.595-.25.266-.5.664-.5.797h-.249c-.499-.133-1.247-.133-1.996-.531-.499-.266-.873-.266-1.122-.266z"
            fill="#000"
            />
            <path
            d="M115.895 365.694l-17.964-10.633c-.374-.266-1.372 0-1.372.797l.499 16.084c0 .265.124.398.25.531l17.589 11.166c.374.265 1.123-.133 1.123-.931v-16.349c.124-.399.124-.665-.125-.665z"
            fill="#131A2D"
            />
            <path
            d="M115.521 365.961l-18.09-10.767c-.373-.266-.872 0-.872.532v16.482c0 .266.124.399.25.532l18.088 10.766c.374.266.873 0 .873-.531v-16.483c.125-.265 0-.398-.249-.531z"
            fill="#0EA59D"
            />
            <path
            d="M115.271 383.639c-.125 0-.249 0-.249-.132l-18.09-10.767c-.249-.133-.373-.399-.373-.532v-16.482c0-.266.124-.399.25-.532.249-.133.373-.133.623 0l18.089 10.767c.249.133.374.399.374.532v16.482c0 .266-.125.399-.25.532-.124.132-.249.132-.374.132zm-18.089-28.445c-.124 0-.124 0-.25.133-.124.133-.249.266-.249.399v16.482c0 .133.125.399.25.399l18.089 10.767a.362.362 0 00.499 0c.124-.133.249-.266.249-.399v-16.482c0-.133-.125-.399-.249-.399l-18.09-10.767c-.124-.133-.124-.133-.249-.133z"
            fill="#131A2D"
            />
            <path
            d="M107.66 373.004l-2.245-3.854 1.871-2.393c-.499-.798-.998-1.462-1.622-1.861-.623-.399-1.247-.399-1.871-.133l-.748.399.124.133c-.374.532-.623 1.196-.623 2.127-.125 2.392 1.122 5.051 2.619 6.114.375.266.749.399 1.123.399l-.125.266.749-.399c.374-.399.624-.532.748-.798z"
            fill="#131A2D"
            />
            <path
            d="M104.791 369.549l2.246 3.855.623-.399-2.245-3.855-.624.399zM106.662 367.023l.624-.399-1.871 2.525-.624.399 1.871-2.525z"
            fill="#131A2D"
            />
            <path
            d="M108.16 367.156l-.623.399v.399l-1.248 1.595 1.497 2.658.125 1.728.624-.399c.374-.531.623-1.196.623-2.127.125-1.462-.374-3.057-.998-4.253z"
            fill="#131A2D"
            />
            <path
            d="M107.036 373.404c-.623.797-1.497 1.063-2.495.398-1.621-.93-2.744-3.721-2.619-6.114.124-2.392 1.497-3.589 3.118-2.658a4.578 4.578 0 011.622 1.861l-1.871 2.392 2.245 4.121z"
            fill="#fff"
            />
            <path
            d="M105.665 374.201c-.374 0-.749-.133-1.123-.399-1.622-.931-2.869-3.722-2.744-6.114.124-1.33.499-2.393 1.247-2.792.624-.266 1.248-.266 1.871.133.624.399 1.248 1.063 1.747 1.861l-1.871 2.393 2.245 3.854c-.374.798-.873 1.064-1.372 1.064zm-1.747-9.305c-.249 0-.499 0-.748.266-.749.399-1.123 1.329-1.248 2.658-.124 2.393.998 5.051 2.62 5.982.873.532 1.747.399 2.37-.399l-2.245-3.855 1.871-2.392c-.499-.798-.998-1.462-1.622-1.861-.374-.266-.748-.399-.998-.399z"
            fill="#131A2D"
            />
            <path
            d="M108.533 371.675c0 .931-.249 1.728-.623 2.127l-2.246-3.855 1.871-2.392c.624 1.196.998 2.791.998 4.12z"
            fill="#0EA59D"
            />
            <path
            d="M107.785 374.068l-2.246-3.988 1.996-2.525v.133c.749 1.329 1.123 2.791.998 4.253 0 .665-.249 1.462-.748 2.127zm-2.121-4.121l2.121 3.722c.374-.532.499-1.196.623-1.994.125-1.329-.249-2.791-.873-3.987l-1.871 2.259z"
            fill="#131A2D"
            />
            <path
            d="M100.176 359.58l1.247.798v-.266l-1.247-.665v.133zM101.674 360.511l.998.532v-.133l-.998-.665v.266zM100.176 359.979l.624.398v-.133l-.624-.398v.133zM101.797 361.042l.873.399v-.133l-.873-.532v.266zM100.924 360.511l.748.399v-.266l-.748-.399v.266zM100.176 360.511l2.495 1.462v-.266l-2.495-1.462v.266zM100.176 360.909l.873.532v-.266l-.873-.531v.265zM101.299 361.574l1.372.798v-.266l-1.372-.797v.265zM100.176 361.308l2.495 1.462v-.133l-2.495-1.462v.133zM100.176 361.707l.624.399v-.266l-.624-.266v.133zM100.924 362.238l.748.399v-.266l-.748-.398v.265zM101.797 362.637l.873.532v-.133l-.873-.532v.133zM100.176 362.238l1.247.665v-.266l-1.247-.664v.265zM101.674 363.036l.998.665v-.266l-.998-.664v.265zM110.156 375.131l1.248.665v-.266l-1.248-.665v.266zM111.527 375.929l1.123.665v-.266l-1.123-.665v.266zM110.156 375.53l.624.398v-.266l-.624-.398v.266zM111.777 376.46l.874.532v-.266l-.874-.532v.266zM110.904 375.93l.749.399v-.133l-.749-.399v.133zM110.156 375.93l2.495 1.462v-.133l-2.495-1.462v.133zM110.156 376.327l.749.532v-.266l-.749-.399v.133zM111.279 376.992l1.373.798v-.133l-1.373-.798v.133zM110.156 376.726l2.495 1.462v-.133l-2.495-1.462v.133zM110.156 377.258l.499.266v-.133l-.499-.399v.266zM110.904 377.656l.749.399v-.133l-.749-.399v.133zM111.654 378.188l.998.531v-.265l-.998-.532v.266zM110.156 377.656l1.248.665v-.133l-1.248-.797v.265zM111.527 378.454l1.123.665v-.266l-1.123-.532v.133zM98.93 371.542c-.125.266-.375.532-.25.664.125.133.624-.132.624-.132.25.265-.624.531-.874.531-.499 0-1.372 3.057-1.372 3.057l-1.123-.531s1.373-2.393 1.498-3.057c0-.266.25-.665.623-.931.125-.133.624.266.749-.266.125-.399.25-.664.374-.664 0 .133-.125 1.063-.25 1.329z"
            fill="#fff"
            />
            <path
            d="M97.058 375.795l-1.248-.531v-.133s1.373-2.393 1.498-3.057c0-.266.249-.665.623-.931h.25c.25 0 .374.133.499-.133.125-.398.25-.664.374-.664h.125l.125.133c.124.133-.125.93-.25 1.196 0 .133-.125.133-.125.266s-.124.266-.124.266c.124 0 .249 0 .374-.133.124 0 .25-.133.25 0 0 0 .124.133 0 .265-.126.266-.75.532-.999.532-.25-.133-.873 1.329-1.372 2.924zm-.998-.664l.998.399c.25-.665.998-3.058 1.497-3.058.25 0 .873-.265.873-.398h-.124c-.125 0-.375.133-.5.133 0 0-.124 0-.124-.133s0-.266.124-.399c0-.133.125-.133.125-.266.125-.266.25-.797.25-1.063 0 .133-.125.266-.25.531-.124.399-.374.266-.624.266h-.124c-.374.266-.5.665-.624.798-.125.797-1.248 2.791-1.497 3.19z"
            fill="#131A2D"
            />
            <path
            d="M91.568 376.594c0 .93.874.93 1.996.797.998-.133 2.37-.399 3.493-1.462.375-.399-.748-1.462-1.122-1.329a9.706 9.706 0 01-2.246.531c-1.372.266-2.12.665-2.12 1.463z"
            fill="#fff"
            />
            <path
            d="M92.94 377.524c-.498 0-.873-.133-1.122-.266a1.052 1.052 0 01-.25-.665c0-.797.624-1.196 2.121-1.462.998-.133 1.622-.398 1.996-.531.125 0 .125 0 .25-.133.25-.133.998.398 1.247.93.125.266.125.399 0 .532-1.123 1.063-2.495 1.329-3.493 1.462-.374.133-.624.133-.748.133zm-1.247-.931c0 .266.125.399.25.532.25.266.873.266 1.746.266.998-.133 2.37-.399 3.368-1.462.125-.133.125-.266 0-.399-.25-.399-.873-.797-.998-.797 0 0-.124 0-.25.132-.373.133-1.122.399-2.12.532-1.372.133-1.996.532-1.996 1.196zM92.192 398.127c-.125.133-.374.93-.25 1.063.125.133.125.133.25.133.873.399 2.245-.931 2.37-1.063.25-.133.374-.665.25-.798 0-.133-2.496.532-2.62.665z"
            fill="#131A2D"
            />
            <path
            d="M93.44 397.462c-.375.133-1.123.665-1.248.798-.125.132-.25.664-.125.797s.25.133.375.266c.374.133 1.621-.399 2.12-.931.25-.132.5-.664.375-.93s-.874-.266-1.498 0z"
            fill="#131A2D"
            />
            <path
            d="M93.064 398.791c.07 0 .125-.059.125-.133 0-.073-.056-.133-.125-.133s-.124.06-.124.133c0 .074.055.133.124.133zM92.19 398.26s-.249.266-.124.798c0 0 .125.133.374.133 0 0 0-.665.125-.798v-.133l-.25-.399-.124.399z"
            fill="#fff"
            />
            <path
            d="M92.191 397.727c0 .133 0 .266-.125.399h.25c.125 0 .125.133.125.266.25 0 .374 0 .623-.133.5-.266.624-.532.624-.665-.25-.266-1.372.266-1.497.133z"
            fill="#fff"
            />
            <path
            d="M92.565 398.524h-.249v-.265h-.125l-.125.132v-.132c0-.133 0-.266.125-.399v-.133h.125s.125 0 .25-.133c.498-.133.997-.266 1.122 0v.266c0 .133-.125.399-.624.531-.124.133-.25.133-.499.133zm0-.133c.125 0 .375 0 .5-.132.374-.133.498-.399.498-.399v-.133c-.124-.266-.748 0-.998.133-.124 0-.25.133-.25.133v.266h.126s.124 0 .124.132z"
            fill="#131A2D"
            />
            <path
            d="M91.694 390.55c-.125.266-.25 1.197-.125 2.26.125 1.063.374 4.785.374 4.785 1.123.399 1.622-.133 1.622-.133s.374-5.184.374-6.779c.125-1.462-1.995-.664-2.245-.133z"
            fill="#131A2D"
            />
            <path
            d="M93.94 382.707c-.749-.664-1.622-.664-1.872-.398-.998.797-.998 2.924-.998 3.589 0 .664.375 3.987.624 4.918.25 1.462 2.246 1.595 2.246.531 0-1.063 1.372-7.31 0-8.64zM94.438 399.322c-.125.133-.374.931-.25 1.197.125.133.125.133.25.133.873.398 2.245-.931 2.37-1.064.25-.133.374-.531.25-.797.124-.266-2.37.398-2.62.531z"
            fill="#131A2D"
            />
            <path
            d="M95.686 398.658c-.375.133-1.123.664-1.248.797s-.25.665-.125.798.25.133.375.266c.374.132 1.621-.399 2.12-.931.25-.133.5-.665.375-.93 0-.266-.874-.266-1.497 0z"
            fill="#131A2D"
            />
            <path
            d="M95.435 399.987c.07 0 .125-.06.125-.133 0-.074-.056-.133-.125-.133s-.124.059-.124.133c0 .073.055.133.124.133zM94.437 399.455s-.25.266-.125.798c0 0 .125.133.374.133 0 0 0-.665.125-.798v-.133l-.25-.266-.124.266z"
            fill="#fff"
            />
            <path
            d="M94.562 398.923c0 .133 0 .266-.124.399h.249c.125 0 .125.133.125.266.25 0 .374 0 .624-.133.498-.266.623-.532.623-.665-.25-.265-1.372.266-1.497.133z"
            fill="#fff"
            />
            <path
            d="M94.936 399.722h-.249v-.266h-.125l-.124.133v-.133c0-.133 0-.266.124-.399v-.133h.125s.125 0 .25-.133c.499-.133.998-.266 1.122 0v.266c0 .133-.124.399-.623.532-.125.133-.375.133-.5.133zm-.124-.133c.124 0 .374 0 .499-.133.374-.133.499-.399.499-.399v-.133c-.125-.266-.749 0-.998.133-.125 0-.25.133-.25.133v.266h.125c.125 0 .125 0 .125.133z"
            fill="#131A2D"
            />
            <path
            d="M93.94 391.746c-.126.266-.126 1.329 0 2.525.124 1.196.374 4.918.374 4.918 1.122.399 1.621-.398 1.621-.398s.374-5.051.374-6.647c0-1.595-2.245-.93-2.37-.398z"
            fill="#131A2D"
            />
            <path
            d="M95.935 383.637c-.749-.664-1.747-.133-1.996.133-.998.798-.873 1.994-.873 2.659 0 .664.623 4.785.748 5.715.25 1.462 2.246 1.595 2.246.532.124-1.063.998-8.108-.125-9.039z"
            fill="#131A2D"
            />
            <path
            d="M96.435 377.922c0-1.861-2.745-2.526-3.493-2.526-1.622 0-1.747 2.26-1.497 3.855.25 1.595-.375 5.45-.375 5.45 1.248 1.462 5.614.532 5.614.532-.499-1.994-.25-5.583-.25-7.311z"
            fill="#0EA59D"
            />
            <path
            d="M93.69 385.632c-1.123 0-2.246-.133-2.745-.798 0 0 .624-3.722.375-5.45-.125-.93-.25-2.658.499-3.456.25-.398.623-.531 1.122-.531.749 0 3.618.664 3.618 2.658v1.462c0 1.861-.125 4.254.25 5.716v.133h-.125c-.125 0-1.622.266-2.994.266zm-2.62-.931c1.123 1.329 4.865.532 5.49.399-.25-1.462-.25-3.988-.126-5.716v-1.462c0-1.861-2.744-2.525-3.493-2.525-.374 0-.748.133-.998.398-.623.798-.499 2.659-.374 3.323.125 1.728-.499 5.184-.499 5.583z"
            fill="#131A2D"
            />
            <path
            d="M95.685 372.738c0-.266-.25 0-.374-.266a.923.923 0 00-.624-.266c-.25 0-.374 0-.499.133-.124.133-.25.266-.25.399-.498.93-.249 1.595-.374 2.658.25.133 1.123.399 1.373.532 0 0-.374-.532-.25-.931.374.133.624-.398.998-1.063.125-.133 0-.532 0-.665-.25-.265 0-.265 0-.531z"
            fill="#fff"
            />
            <path
            d="M94.811 375.928c-.374 0-1.122-.399-1.497-.532v-.93c0-.532 0-1.064.375-1.728.125-.133.125-.266.25-.399.249-.133.374-.133.623-.133.25 0 .499.133.624.266h.124c.125 0 .25 0 .25.133s0 .266-.125.266c0 .133-.125.133 0 .265 0 .133.125.532 0 .665l-.124.133c-.25.532-.5.93-.874.93 0 .266.125.532.25.665.124.266.124.266.124.399zm-1.372-.665c.25.133.874.399 1.123.399-.125-.133-.25-.532-.125-.798v-.132h.125c.25.132.499-.266.749-.798l.124-.133c.125-.133 0-.399 0-.532v-.265-.266h-.124c-.125 0-.125 0-.25-.133s-.374-.133-.499-.266c-.125 0-.374 0-.499.133s-.125.266-.25.266a3.875 3.875 0 00-.374 1.728.895.895 0 010 .797z"
            fill="#131A2D"
            />
            <path
            d="M94.813 371.543c0-.532-1.123-.532-.998.133-.5-.133-1.248.398-.998 1.063-.25.532.25 1.196.374 1.462 0 .133.125.399.125.399s.748.266.998 0c.374-.266.374-.665.499-1.063.125-.665.499-.266.499-.798.25-.133.374.266.374.266.5-1.064-.25-1.728-.873-1.462z"
            fill="#131A2D"
            />
            <path
            d="M94.688 375.397c-.624-.399-.998-.399-1.247-.399-.125 0-.25 0-.25.133l-.125.266 1.996.664c0-.265-.124-.664-.374-.664z"
            fill="#fff"
            />
            <path
            d="M95.187 376.194l-2.246-.797.25-.399c.125-.133.25-.133.25-.133.374 0 .623.133 1.247.399.25.133.499.532.499.93zm-1.996-.93l1.871.665c0-.266-.25-.399-.25-.532-.623-.399-.997-.399-1.247-.399-.125 0-.125 0-.125.133l-.25.133z"
            fill="#131A2D"
            />
            <path
            d="M99.179 383.771c-.25-.133-.374-.133-.374-.265l.374-.399c0-.133-.374 0-.624.266-.125.133-.499 0-.499 0-.748-.266-2.495-1.861-2.495-1.861l-.749 1.063s2.62 1.462 3.12 1.994c.124.133.498.664.623.664s.624-.265.624-.398c.124-.133-.25-.798.124-.266.25.399.624.532.624.399-.125-.399-.499-.931-.748-1.197z"
            fill="#fff"
            />
            <path
            d="M98.555 385.101c-.125 0-.25-.133-.5-.399-.124-.133-.124-.133-.124-.266-.374-.531-3.119-1.994-3.119-1.994h-.124l.748-1.196s1.871 1.595 2.495 1.861h.499c.25-.133.499-.266.624-.266 0 0 .124 0 .124.133s-.124.133-.249.266l-.25.266h.125s.125.133.25.133c.374.265.623.797.748.93v.133c-.125.133-.499-.133-.624-.399v.266c0 .133-.249.133-.498.266 0 .133 0 .266-.125.266zm-3.618-2.792c.374.266 2.62 1.463 2.994 1.994 0 0 .125.133.125.266.124.133.25.399.374.399 0 0 .125 0 .25-.133.124 0 .374-.133.498-.266v-.266-.266s.125 0 .25.133l.374.399c-.125-.266-.374-.664-.624-.797-.124 0-.124-.133-.249-.133s-.125-.133-.125-.133v-.133c0-.133.125-.133.25-.266l.124-.133c-.124 0-.249.133-.498.266-.125.133-.5.133-.624 0-.624-.266-2.246-1.595-2.495-1.861l-.624.93z"
            fill="#131A2D"
            />
            <path
            d="M95.437 376.594c-.748-.266-1.123.664-1.372 1.86-.125 1.064-.25 2.526.374 3.988.25.532 1.497-.399 1.497-.798 0-.398 0-1.196.125-2.525.25-1.462.124-2.393-.624-2.525z"
            fill="#fff"
            />
            <path
            d="M94.813 382.575c-.124 0-.25-.133-.374-.265-.624-1.463-.499-2.925-.374-3.988.124-1.063.374-1.595.748-1.861.25-.133.374-.133.624-.133.749.133.998.931.749 2.659a17.378 17.378 0 00-.125 2.259v.266c0 .266-.624.93-1.123.93 0 .133-.125.133-.125.133zm.5-5.981c-.126 0-.25 0-.375.133-.25.266-.499.797-.624 1.728-.124.93-.25 2.525.375 3.855 0 .132.124.132.374.132.499-.132.998-.664.998-.797v-.266c0-.399 0-1.196.124-2.26.25-1.462 0-2.259-.623-2.392-.125-.133-.25-.133-.25-.133z"
            fill="#131A2D"
            />
            <path
            d="M172.781 279.96l19.96 12.096 14.346-7.178-24.076-14.754-10.23 9.836z"
            fill="url(#paint235_linear_874_76773)"
            opacity={0.3}
            />
            <path
            d="M186.877 270.921l-11.976-7.31c-.374-.266-.749-.266-1.123-.266s-.748.133-1.123.266l-11.976 6.911c-.748.399-1.122 1.33-1.122 2.127 0 .931.499 1.728 1.122 2.127l11.976 7.178c.375.133.749.265 1.123.265s.749-.132 1.123-.265l11.976-6.912c.748-.399 1.123-1.329 1.123-2.127.124-.798-.375-1.595-1.123-1.994z"
            fill="#fff"
            />
            <path
            d="M172.781 263.744l-11.852 6.912c-.249.133-.499.399-.748.665-.25.399-.499.93-.374 1.462 0 .797.623 1.595 1.247 1.994l11.851 7.045c.25.133.499.265.624.265h.374c.375 0 .749-.132 1.123-.265l11.727-6.779c.249-.133.499-.399.623-.532.375-.399.499-1.063.499-1.595 0-.798-.623-1.595-1.247-1.994l-11.727-7.178c-.249-.133-.748-.265-.998-.265h-.374c-.249 0-.499.132-.748.265z"
            fill="#F8F8F9"
            />
            <path
            d="M172.906 263.876l-11.852 6.912c-.249.133-.623.399-.748.665-.374.399-.374.93-.374 1.462 0 .665.748 1.595 1.372 1.861l11.602 6.912c.249.133.499.133.623.266h.375c.249 0 .748-.133.998-.399l11.601-6.646c.25-.133.499-.399.624-.532.374-.399.499-.93.374-1.462 0-.665-.748-1.595-1.247-1.861l-11.477-6.912c-.25-.133-.749-.398-.998-.398h-.374c0-.133-.25 0-.499.132z"
            fill="#F1F1F3"
            />
            <path
            d="M173.03 264.009l-11.727 6.779c-.125.133-.624.399-.748.664-.375.399-.375.931-.25 1.33 0 .664.873 1.462 1.372 1.861l11.353 6.911c.249.133.499.133.623.133h.375c.249 0 .748-.265.998-.398l11.352-6.514c.125-.132.499-.398.624-.531.374-.399.499-.931.374-1.462 0-.665-.873-1.462-1.372-1.728l-11.103-6.779c-.25-.133-.749-.399-.998-.399h-.25c-.249 0-.499 0-.623.133z"
            fill="#EAEBEC"
            />
            <path
            d="M173.03 264.275l-11.602 6.779c-.125.133-.624.399-.748.532-.375.398-.375.93-.25 1.329 0 .531.998 1.462 1.497 1.728l11.228 6.779c.249.133.374.133.623.133h.375c.249 0 .748-.266.998-.399l11.227-6.38c.125-.133.499-.399.624-.532.374-.399.499-.93.249-1.462 0-.532-.998-1.462-1.372-1.595l-10.853-6.646c-.125-.133-.749-.399-.998-.399h-.25c-.249-.133-.499 0-.748.133z"
            fill="#E3E4E6"
            />
            <path
            d="M173.155 264.409l-11.602 6.646c-.125.133-.624.398-.748.531-.375.399-.375.931-.25 1.33 0 .398 1.248 1.329 1.497 1.595l10.978 6.646c.25.133.374.133.624.133h.374c.125 0 .749-.266.998-.399l10.978-6.248c.125 0 .499-.398.624-.398.374-.399.499-.931.249-1.329 0-.399-1.122-1.33-1.372-1.463l-10.604-6.38c-.124-.133-.748-.399-.873-.399 0 0-.249-.132-.249 0-.125-.398-.375-.398-.624-.265z"
            fill="#DDDDE0"
            />
            <path
            d="M173.278 264.541l-11.477 6.646c-.125 0-.748.399-.748.532-.375.266-.375.93-.125 1.329 0 .266 1.372 1.329 1.622 1.462l10.853 6.513c.249.133.374.133.624.133l.249-.133c.125 0 .749-.398.873-.398l10.854-6.248c.124 0 .499-.399.623-.399.375-.265.499-.93.125-1.329 0-.266-1.247-1.196-1.497-1.329l-10.229-6.247c-.125-.133-.749-.399-.874-.399l-.249-.133c-.25-.133-.499-.133-.624 0z"
            fill="#D6D6DA"
            />
            <path
            d="M173.278 264.807l-11.352 6.646s-.748.399-.748.531c-.375.266-.375.931-.125 1.197 0 .266 1.497 1.196 1.622 1.329l10.603 6.38c.25.133.375.133.624 0l.25-.133c.124 0 .873-.399.873-.399l10.604-6.114.623-.399c.375-.265.499-.93.125-1.329 0-.266-1.372-1.196-1.497-1.196l-9.98-6.114c-.125 0-.748-.399-.873-.399l-.25-.133s-.249 0-.499.133z"
            fill="#CFD0D3"
            />
            <path
            d="M173.403 264.94l-11.352 6.513s-.749.398-.749.531c-.374.266-.374.931 0 1.197 0 .133 1.622 1.196 1.747 1.196l10.354 6.247c.249.133.374.133.624 0l.249-.133.873-.399 10.479-5.981.624-.399c.374-.266.499-.93 0-1.196 0-.133-1.497-1.063-1.622-1.196l-9.605-5.849-.749-.399-.249-.132c-.125-.133-.375-.133-.624 0z"
            fill="#C8C9CD"
            />
            <path
            d="M174.152 265.072c-.25-.133-.374-.133-.624 0l-11.976 6.912c-.374.266-.374.931 0 1.196l11.976 7.178c.125.133.374.133.624 0l11.976-6.912c.374-.266.374-.93 0-1.196l-11.976-7.178z"
            fill="#C1C2C7"
            />
            <path
            d="M163.174 270.922l9.855-5.716c.749-.398 1.497-.398 2.246 0l9.605 5.716h1.996v1.728c0 .266-.124.532-.374.797l-11.103 6.646c-.748.399-1.497.399-2.245 0l-11.352-6.646c-.25-.133-.375-.398-.499-.797v-1.728h1.871z"
            fill="#0EA59D"
            />
            <path
            d="M174.152 280.492c-.375 0-.749-.133-1.123-.266l-11.352-6.646c-.25-.133-.499-.398-.499-.797v-1.994h2.12l9.731-5.716a2.501 2.501 0 012.37 0l9.481 5.716h2.121v1.994c0 .266-.25.532-.499.797l-11.103 6.646c-.374.133-.873.266-1.247.266zm-12.85-7.842c0 .399.125.532.375.665l11.352 6.646a2.033 2.033 0 002.121 0l11.102-6.646a.74.74 0 00.375-.665v-1.595h-1.872l-9.605-5.716a2.033 2.033 0 00-2.121 0l-9.855 5.716h-1.872v1.595z"
            fill="#131A2D"
            />
            <path
            d="M161.677 269.992l11.352-6.646c.749-.399 1.497-.399 2.246 0l11.102 6.646c.624.399.624 1.196 0 1.595l-11.102 6.646c-.749.399-1.497.399-2.246 0l-11.352-6.646c-.624-.266-.624-1.196 0-1.595z"
            fill="#fff"
            />
            <path
            d="M186.379 271.453l-4.117 2.393-6.986 4.12c-.748.399-1.497.399-2.245 0l-7.36-4.253-3.244-1.861-.873-.532c-.624-.398-.624-1.196 0-1.595l11.352-6.646c.749-.398 1.497-.398 2.246 0l7.235 4.254 3.867 2.259c.749.532.749 1.463.125 1.861z"
            fill="#fff"
            />
            <path
            d="M174.154 278.498c-.375 0-.749-.133-1.123-.266l-11.352-6.646c-.375-.133-.499-.531-.499-.93s.249-.798.499-.931l11.352-6.646a2.501 2.501 0 012.37 0l11.103 6.646c.374.133.499.532.499.931s-.25.797-.499.93l-11.103 6.646c-.374.133-.873.266-1.247.266zm0-15.419a2.23 2.23 0 00-.998.266l-11.353 6.646a.74.74 0 00-.374.665c0 .266.125.532.374.664l11.353 6.646a2.027 2.027 0 002.12 0l11.103-6.646c.25-.132.374-.398.374-.664s-.124-.532-.374-.665l-11.103-6.646c-.374-.133-.748-.266-1.122-.266z"
            fill="#000"
            />
            <path
            d="M177.895 253.775c.125-.265.624-.531 1.123-.531.25 0 .25.398.624 0 .249-.266.499-.532.624-.399.124.133-.375.797-.624 1.063-.25.266-.624.399-.499.532s.624.133.624.133c.124.266-.749.266-.998.133-.375-.266-2.121 1.994-2.87 1.994-.249 0-.748-.665-.623-.931.499-.93 2.37-1.196 2.619-1.994z"
            fill="#fff"
            />
            <path
            d="M175.774 256.7c-.249 0-.374-.266-.499-.532 0-.133-.125-.399-.125-.532.25-.399.874-.664 1.497-.93.624-.266 1.123-.532 1.248-.798s.624-.664 1.123-.664c.124 0 .249.133.249.133h.125l.125-.133c.249-.266.499-.532.623-.532h.125v.133c0 .266-.499.797-.748 1.063-.125 0-.125.133-.25.133-.125.133-.249.133-.249.266 0 0 .249.133.374.133s.249 0 .249.133v.266c-.249.133-.873.133-1.122 0-.125-.133-.749.398-1.123.797-.624.399-1.248 1.064-1.622 1.064zm3.244-3.323c-.375 0-.874.265-.998.531-.125.399-.749.665-1.373.931-.623.265-1.247.531-1.497.93 0 .133 0 .266.125.399a.96.96 0 00.374.399c.375 0 .998-.665 1.622-1.197.624-.664 1.123-.93 1.248-.93.249.133.873.133.998.133h-.125c-.125 0-.374 0-.499-.133v-.133c0-.133.125-.133.249-.266.125 0 .125-.133.25-.133.249-.133.624-.664.624-.797-.125 0-.25.133-.499.398-.125.133-.125.133-.25.133s-.125 0-.125-.133c0-.132 0-.132-.124-.132z"
            fill="#000"
            />
            <path
            d="M181.888 266.668s1.247 0 1.871-.265c.749-.266.624.398.499.664s-.873.798-1.497.931c-.499.133-.748.797-1.247.664-.624-.133-.499-.531-.624-1.063 0-.532-.374-.665-.374-.665l.998-.797.374.531z"
            fill="#131A2D"
            />
            <path
            d="M179.767 260.687c.499.265.749.398.998 1.993.25 1.595 1.123 3.722 1.123 3.722s-.125.798-1.248.931c0 0-1.247-1.33-1.497-2.393-.374-1.063-.623-2.791-.623-2.924 0-.266.499-1.728 1.247-1.329zM183.509 267.864s1.248.133 1.871-.132c.749-.266.499.398.375.664-.125.266-.874.798-1.497.931-.499.133-.749.664-1.248.664-.624-.133-.499-.531-.499-1.063 0-.532-.249-.665-.249-.665l.998-.664.249.265z"
            fill="#131A2D"
            />
            <path
            d="M181.388 261.75c.499.133.873.399 1.123 1.994.249 1.595.873 3.854.873 3.854s-.249.931-1.247.931c0 0-1.373-1.994-1.747-3.057-.249-1.064-.249-2.127-.249-2.393.249-.532.499-1.595 1.247-1.329zM174.277 261.086c1.123-.133 4.491-.532 5.489-.399.998.133.624 1.595-.623 2.26-.624.265-3.244 1.462-3.743 1.595-.998.265-2.994 0-3.243-1.463-.375-1.329.998-1.86 2.12-1.993z"
            fill="#131A2D"
            />
            <path
            d="M181.513 261.75c.998.133.998 1.861-.374 2.392-.873.266-3.618.931-4.117 1.064-.623.133-2.245.399-3.243-.532-.25-.266-.374-.797.125-1.728 1.122-1.595 6.611-1.329 7.609-1.196z"
            fill="#131A2D"
            />
            <path
            d="M172.781 253.908c.749-.133 3.369 1.063 4.117 2.392.749 1.329 0 4.121.624 5.982 0 0-.624 1.329-2.62 1.329-.748 0-2.245-.399-2.744-1.462 0 0 .249-2.659-.125-4.254-.374-1.462-.624-3.854.748-3.987z"
            fill="#0EA59D"
            />
            <path
            d="M174.902 263.744c-.874 0-2.246-.399-2.745-1.462 0 0 .25-2.659-.125-4.121-.249-1.196-.499-2.924 0-3.722.125-.266.499-.398.749-.398h.125c.873 0 3.368 1.063 4.116 2.525.375.798.375 1.861.375 3.057 0 1.064 0 1.994.249 2.924-.125-.265-.748 1.197-2.744 1.197zm-2.745-1.462c.499.93 1.871 1.329 2.62 1.329 1.746 0 2.37-1.196 2.495-1.329-.25-.931-.25-1.861-.25-2.925 0-1.196 0-2.259-.374-3.057-.748-1.329-3.243-2.525-4.117-2.392a.68.68 0 00-.623.398c-.375.532-.375 1.728 0 3.722.499 1.462.374 3.988.249 4.254z"
            fill="#131A2D"
            />
            <path
            d="M173.03 253.11s.998.133 1.372.266c0 1.063.499 1.063.748 1.329-.748-.266-1.122 0-1.247.133-.873.399-1.622-.133-1.248-.665.499-.398.375-1.063.375-1.063z"
            fill="#fff"
            />
            <path
            d="M173.405 255.104c-.25 0-.499-.133-.749-.266-.125-.133-.125-.399 0-.532.374-.398.25-1.063.25-1.063v-.133h.124s.998.133 1.373.266c0 .797.249.93.499 1.063.124 0 .124.133.249.133l.25.266-.375-.133c-.623-.266-.998 0-1.122.133-.125.266-.375.266-.499.266zm-.25-1.861c0 .266 0 .665-.249 1.063-.125.133-.125.266 0 .399.124.266.623.399 1.122.133.125-.133.375-.266.874-.133-.25-.133-.499-.399-.499-1.063-.375-.266-.998-.399-1.248-.399z"
            fill="#000"
            />
            <path
            d="M174.027 250.319s.499.532.499.665 0 .266.124.399c.125.132.25.132.25.265.125.133.125.532.125.665s.124.532.124.665c0 .265-.998.93-2.245.664 0 0-.374-.531-.873-.93-.499-.133.748-2.924 1.996-2.393z"
            fill="#fff"
            />
            <path
            d="M173.403 253.908h-.374s-.374-.532-.873-.798c-.25-.133-.25-.797 0-1.329.374-.93 1.247-1.728 1.996-1.329.125.133.499.532.499.797v.266s0 .133.125.133l.124.133c0 .133.125.399.125.665 0 .133 0 .133.125.266 0 .132.125.398.125.398 0 .133-.874.798-1.872.798zm-.374-.266c1.248.133 1.996-.532 2.121-.665 0-.133 0-.265-.125-.398 0-.133-.125-.266-.125-.266-.124-.532-.124-.665-.124-.665l-.125-.133c-.125 0-.125-.133-.125-.133v-.398c0-.133-.249-.399-.499-.665-.748-.266-1.372.532-1.746 1.329-.25.532-.25 1.064-.125 1.196.499.266.873.798.873.798z"
            fill="#000"
            />
            <path
            d="M174.278 250.452s0 .532-.125.798.374.664.25.664c-.25.133-.499-.398-.624 0-.125.266.249.665.499.798.249.133 0 .399-.374.531-.25.133-.749.266-.874.266 0 0-.249-.398-.374-.398s-.125-.266-.125-1.197c-.124-1.063 1.747-1.462 1.747-1.462z"
            fill="#131A2D"
            />
            <path
            d="M171.533 251.117c.125-.399.873-.931 1.372-1.197.499-.266.375-.398.499-.531.499-.399 1.123.531.874 1.063-.25.532-1.123.532-.998 1.595.124 1.063-.749.93-.749.93s-.249-.132-.748-.531c-.499-.266-.499-.931-.25-1.329zM179.516 253.642c0-.133.124-.266.124-.532l.125-.132c.374 0 .998.265 1.248.531l.124.133v.665c0 .133-.124.133-.249.133l-1.248-.532c-.124-.133-.124-.266-.124-.266z"
            fill="#131A2D"
            />
            <path
            d="M180.515 251.117s.124 0 0 0v-.133c.124-.399-.125-1.064-.125-1.197 0-.265.125-.398 0-.531 0 0 .249 0 .125.398-.125.399.124-.664.374-.797.249-.133.374-.266.374-.133s-.125.133-.249.399c-.125.133-.125.133-.125.266 0 0 .374-.532.624-.532 0 0 .249.399.124.532-.124.133-.124.265-.124.398 0 1.064-.125.931-.25 1.197-.125.797-.125 2.525-.624 3.589-.124.265-.998-.133-1.122-.399-.125-.798.873-2.526.998-3.057z"
            fill="#fff"
            />
            <path
            d="M180.639 254.572c-.249 0-.873-.266-.998-.531-.249-.532.25-1.463.624-2.26.125-.133.125-.399.25-.532v-.133-.93-.266-.266-.133h.124s.125 0 .125.133c.125-.266.125-.531.25-.531.249-.133.249-.266.374-.266l.125.133h.249c.125 0 .125.265.125.265 0 .133 0 .266-.125.399s-.125.266-.125.399c0 .797-.124.93-.124 1.063 0 0 0 .133-.125.133v.665c-.125.93-.125 2.127-.499 2.924 0-.399-.125-.266-.25-.266zm0-3.456c-.124.266-.124.399-.249.665-.25.665-.749 1.728-.624 2.127.125.133.624.531.873.531h.125c.374-.797.499-1.993.499-2.924v-.665c0-.132.125-.132.125-.265.125-.133.125-.266.125-.931 0-.133 0-.266.124-.399v-.132c0-.133-.124-.266-.124-.266-.125 0-.375.266-.499.531l-.125.266v-.399c0-.132 0-.132.125-.265 0-.133.124-.133.124-.266l.125-.133s-.125.133-.249.133c-.125.133-.25.531-.25.664s0 .266-.125.266c-.124 0-.124-.133 0-.133v-.266.665c0 .399.125.665 0 1.196 0-.133 0-.133 0 0z"
            fill="#000"
            />
            <path
            d="M177.023 255.104c.998-.133 1.621-.266 2.12-.399l.375-1.196c.124-.133 1.247 0 1.372.532 0 .265 0 1.196-.25 1.728 0 .132 0 .132-.124.132-1.248 1.064-2.62 1.33-3.743 1.595-1.247.266-1.871-.265-1.996-1.196-.249-.797.873-1.063 2.246-1.196z"
            fill="#0EA59D"
            />
            <path
            d="M176.273 257.762c-.748 0-1.247-.398-1.497-1.196-.124-.266 0-.532.125-.665.374-.531 1.248-.664 2.246-.797a18.509 18.509 0 001.996-.399c.124-.532.249-.797.374-1.196.125-.133.499-.133.748 0 .25 0 .749.133.874.664 0 .266.124 1.197-.25 1.861 0 .133 0 .133-.125.266-1.122 1.064-2.37 1.329-3.493 1.595h-.249c-.374-.266-.624-.133-.749-.133zm.749-2.658c-.873.133-1.871.266-2.121.665-.125.132-.125.398-.125.531.25.931.874 1.329 1.996 1.064h.25c1.123-.266 2.37-.532 3.493-1.463l.125-.132c.374-.532.374-1.463.249-1.728 0-.266-.374-.399-.499-.399-.374-.133-.748-.133-.748 0-.125.266-.25.664-.375 1.196-.623 0-1.247.133-2.245.266z"
            fill="#131A2D"
            />
            <path
            d="M177.771 267.466c-3.743-1.861-9.855-1.861-13.598.266-3.742 2.126-3.618 5.316.125 7.177 3.742 1.861 9.855 1.861 13.598-.266 3.742-1.993 3.617-5.184-.125-7.177z"
            fill="#fff"
            />
            <path
            d="M177.522 267.599c-3.618-1.861-9.606-1.728-13.224.266-3.618 1.993-3.493 5.183.125 7.044 3.742 1.861 9.606 1.728 13.223-.266 3.618-2.126 3.618-5.183-.124-7.044z"
            fill="#F8F8F9"
            />
            <path
            d="M177.397 267.599c-3.618-1.861-9.356-1.728-12.849.266-3.493 1.993-3.493 5.051.124 6.778 3.618 1.861 9.357 1.728 12.85-.265 3.493-1.861 3.493-4.918-.125-6.779z"
            fill="#F1F1F3"
            />
            <path
            d="M177.271 267.731c-3.493-1.728-9.107-1.728-12.475.133-3.368 1.861-3.368 4.918.125 6.646 3.493 1.728 9.106 1.728 12.475-.133 3.368-1.861 3.368-4.785-.125-6.646z"
            fill="#EAEBEC"
            />
            <path
            d="M177.022 267.864c-3.368-1.728-8.857-1.595-12.225.133-3.369 1.861-3.244 4.785.124 6.513 3.369 1.728 8.858 1.595 12.226-.133 3.368-1.861 3.368-4.785-.125-6.513z"
            fill="#E3E4E6"
            />
            <path
            d="M176.897 267.998c-3.243-1.728-8.607-1.595-11.851.133-3.243 1.728-3.243 4.652.125 6.247 3.243 1.728 8.608 1.595 11.851-.133 3.244-1.861 3.119-4.652-.125-6.247z"
            fill="#DDDDE0"
            />
            <path
            d="M176.773 267.998c-3.243-1.595-8.358-1.596-11.477.132-3.118 1.728-3.118 4.52.125 6.115 3.244 1.595 8.358 1.595 11.477-.133 3.119-1.728 2.994-4.386-.125-6.114z"
            fill="#D6D6DA"
            />
            <path
            d="M176.524 268.131c-3.118-1.595-8.108-1.462-11.102.133-2.994 1.728-2.994 4.386.124 5.848 3.119 1.595 8.109 1.462 11.103-.133 3.119-1.595 2.994-4.253-.125-5.848z"
            fill="#CFD0D3"
            />
            <path
            d="M176.399 268.264c-2.994-1.595-7.86-1.462-10.854.133-2.994 1.595-2.869 4.253.125 5.715 2.994 1.595 7.859 1.462 10.853-.133 2.87-1.595 2.87-4.253-.124-5.715z"
            fill="#C8C9CD"
            />
            <path
            d="M176.274 268.263c-2.869-1.462-7.61-1.462-10.479.133-2.869 1.595-2.869 4.121.125 5.583 2.869 1.462 7.609 1.462 10.479-.133 2.744-1.595 2.744-3.988-.125-5.583z"
            fill="#C1C2C7"
            />
            <path
            d="M180.016 267.466v.665c0 .265-.125.398-.125.531s-.125.266-.125.399 0 .133-.125.266c-.124.266-.124.532-.249.665 0 .132-.125.132-.125.265-.125.133-.125.266-.249.399 0 .133-.125.133-.125.266-.125.133-.25.399-.374.532-.375.531-.749.797-.998 1.063l-.25.266h-.125c-1.372.93-2.994 1.728-4.615 1.861-2.371.266-10.479-.665-9.357-8.773 0-.266.125-.665.125-1.063.125-.399.125-.798.25-1.197.499-2.126 1.247-4.918 2.245-7.177 0-.133.125-.133.125-.266s.125-.133.125-.266c.623-1.196 1.247-2.127 1.871-2.659.374-.265.624-.398.998-.398.499 0 1.123 0 1.497.266 1.871 1.063 1.622 5.449 2.994 7.177.998 1.197 3.243.665 4.491 3.456.249.665 1.746 1.064 1.871 1.728.125.798.374 1.329.25 1.994z"
            fill="#131A2D"
            />
            <path
            d="M179.766 265.605c-.499 0-.873.133-1.497.266-1.622.266-.624-2.26-3.368-2.659-2.745-.398-3.244-1.727-2.994-3.455.249-1.728-.624-2.526-1.622-3.988 0 0-1.871-2.924-3.493-.399a4.626 4.626 0 01-1.247 1.462c-.874 2.127-1.622 4.785-1.996 6.912-.125.399-.125.798-.25 1.196-.125.399-.125.798-.125 1.064-1.122 8.108 6.986 9.038 9.357 8.773 1.621-.133 3.118-.931 4.615-1.861h.125c.125 0 .125-.133.25-.266l.998-1.064c.124-.132.249-.398.374-.531 0 0 .125-.133.125-.266.124-.133.124-.266.249-.399 0-.133.125-.133.125-.266.125-.265.249-.398.249-.664 0-.133 0-.133.125-.266 0-.133.125-.266.125-.399s.125-.399.125-.532v-.265-.399c.124-.798-.125-1.329-.25-1.994z"
            fill="#fff"
            />
            <path
            d="M171.907 274.909c-1.746 0-5.114-.531-7.235-2.791-1.372-1.595-1.871-3.589-1.622-6.247 0-.266.125-.532.125-1.064.125-.398.125-.797.249-1.196.25-1.196.998-4.253 2.121-6.912.374-.399.749-.93 1.123-1.462.499-.797.998-1.063 1.622-1.196 1.122 0 2.12 1.462 2.12 1.462.125.266.25.399.499.664.749 1.064 1.373 1.994 1.123 3.456-.125.931 0 1.595.374 2.127.499.665 1.248 1.064 2.495 1.196 1.622.266 1.996 1.197 2.371 1.861.249.532.374.931.998.798l.374-.133c.374-.133.748-.133.998-.133h.125v.133c0 .133 0 .266.124.399.125.398.125.93.125 1.329v.797c0 .266-.125.399-.125.665 0 .133-.124.266-.124.532 0 .133 0 .133-.125.266-.125.265-.125.531-.25.664 0 .133-.124.133-.124.266-.125.133-.125.266-.25.399 0 .133-.125.133-.125.266-.124.133-.249.398-.374.531-.374.532-.748.931-.998 1.064l-.249.266c-1.747 1.196-3.244 1.727-4.616 1.993h-.749zm-6.112-17.944c-1.123 2.526-1.747 5.583-1.996 6.779-.125.399-.125.798-.25 1.196-.125.399-.125.798-.125 1.064-.374 2.525.125 4.519 1.497 5.981 2.371 2.526 6.487 2.791 7.735 2.658 1.372-.132 2.869-.797 4.491-1.86h.125c.124 0 .124-.133.249-.133.25-.266.624-.532.998-1.064.125-.133.25-.398.374-.531 0-.133.125-.133.125-.133.125-.133.125-.266.25-.399 0-.133.124-.133.124-.266.125-.266.25-.399.25-.665 0-.132 0-.132.125-.265 0-.133.124-.266.124-.399s.125-.399.125-.532v-.266-.398c0-.399 0-.931-.125-1.463v-.265c-.249 0-.623.133-.873.133l-.374.132c-.873.133-1.123-.398-1.372-.93-.375-.665-.624-1.462-2.121-1.728-1.372-.133-2.246-.665-2.745-1.329-.374-.532-.499-1.329-.374-2.26.25-1.329-.374-2.127-1.123-3.19-.124-.133-.249-.399-.499-.665 0 0-.873-1.329-1.871-1.329-.499 0-.998.399-1.372 1.064-.499.133-.873.664-1.372 1.063z"
            fill="#131A2D"
            />
            <path
            d="M388.348 303.221l-50.399-31.503v-25.919l50.399 31.502v25.92z"
            fill="#fff"
            />
            <path
            d="M388.472 303.487l-.249-.133-50.524-31.635V245.4l.25.133 50.523 31.635v26.319zm-50.399-31.901l50.15 31.369v-25.654l-50.15-31.369v25.654z"
            fill="#000"
            />
            <path
            d="M344.187 261.219c-.873-.531-1.497-1.196-2.12-2.126-.499-.931-.874-1.861-.874-2.659 0-.93.25-1.462.874-1.728.499-.266 1.247-.133 2.12.399.499.266.998.665 1.373 1.196.374.532.748 1.064.998 1.595h-.749a2.922 2.922 0 00-.624-1.063 1.951 1.951 0 00-.998-.798c-.623-.398-1.122-.398-1.497-.265-.374.132-.499.531-.499 1.196 0 .664.125 1.196.499 1.861.375.664.874 1.063 1.497 1.462.375.266.624.266.998.266.25 0 .499-.133.624-.266l.749.93c-.25.266-.624.399-.998.399-.499 0-.874-.133-1.373-.399zM350.3 260.687l.873.532v4.253l-.873-.532v-.664c-.374.266-.749.266-1.372-.133-.499-.399-.998-.798-1.373-1.462-.374-.665-.623-1.329-.623-1.994s.249-1.063.623-1.196c.375-.133.874-.133 1.373.265.623.399 1.122.931 1.372 1.596v-.665zm-2.121 1.728c.25.399.499.664.873.93.375.266.624.266.874.133.249-.133.374-.399.374-.797 0-.399-.125-.798-.374-1.197a3.025 3.025 0 00-.874-.93c-.374-.266-.623-.266-.873-.133-.249.133-.374.399-.374.798 0 .398.125.797.374 1.196zM352.92 263.478c0 .133.124.266.249.532l.499.532c.25.133.374.399.624.531.249.266.374.399.499.665s.249.532.249.798c0 .398-.124.664-.499.664-.249 0-.623 0-1.122-.399-.375-.265-.749-.531-.998-.93-.25-.399-.499-.665-.624-1.063h.748c.125.531.375.93.874 1.196.499.266.623.266.623 0 0-.133-.124-.266-.249-.399l-.499-.532c-.25-.132-.374-.398-.624-.531-.249-.266-.374-.399-.499-.665s-.249-.532-.249-.797c0-.399.124-.665.374-.665.249 0 .624 0 .998.266s.624.399.873.797c.25.266.499.665.624 1.064h-.749c-.124-.399-.374-.665-.748-.931-.125-.133-.25-.133-.374-.133.124-.265 0-.265 0 0zM357.91 265.206c.499.266.873.665 1.123 1.197.249.531.374.93.374 1.595v2.658l-.873-.532v-2.525c0-.266-.125-.665-.25-.931a1.559 1.559 0 00-.624-.664c-.249-.133-.499-.266-.748-.133-.125.133-.25.399-.25.797v2.26l-.873-.532v-6.114l.873.532v2.259c.25-.266.624-.266 1.248.133zM366.891 274.777h-.748l-.499-.93c-.499.132-.998-.001-1.497-.399-.624-.399-.998-.798-1.373-1.329a2.672 2.672 0 01-.499-1.596c0-.398.125-.664.25-.797s.374-.266.748-.266c-.249-.399-.374-.797-.374-1.196 0-.532.125-.798.499-.931s.749 0 1.248.266c.374.266.748.532.998.931.249.398.499.797.623 1.329h-.748l-.374-.798c-.125-.265-.375-.398-.624-.531-.25-.133-.374-.133-.499-.133s-.25.133-.25.399c0 .132 0 .265.125.398 0 .133.125.266.125.399s.125.266.249.399l1.373 2.392c.124-.265.249-.531.249-.797l.749.93c-.125.399-.25.798-.499.931l.748 1.329zm-2.744-2.26c.374.266.623.266.873.266l-1.372-2.392c-.375 0-.624.132-.624.664 0 .266.125.532.249.798.25.266.499.531.874.664zM344.187 271.321c-.873-.532-1.497-1.196-2.12-2.127-.499-.93-.874-1.861-.874-2.658 0-.931.25-1.462.874-1.728.499-.266 1.247-.133 2.12.398a3.97 3.97 0 011.373 1.197c.374.531.748 1.063.998 1.595h-.749a2.926 2.926 0 00-.624-1.064 1.954 1.954 0 00-.998-.797c-.623-.399-1.122-.399-1.497-.266-.374.133-.499.532-.499 1.196 0 .665.125 1.197.499 1.861.375.665.874 1.064 1.497 1.462.375.266.624.266.998.266.25 0 .499-.133.624-.266l.749.931c-.25.266-.624.399-.998.399-.499 0-.874-.133-1.373-.399zM348.18 270.124c.249-.399.624-.399 1.247 0v.93c-.374-.265-.623-.265-.873-.265-.249 0-.374.265-.374.664v2.127l-.873-.532v-4.12l.873.531v.665zM350.424 273.315c.125.398.249.664.374 1.063.25.266.499.532.873.797.499.266.749.266.998.133l.749.931c-.374.399-.998.266-1.747-.133-.623-.399-1.122-.931-1.621-1.595-.375-.665-.624-1.329-.624-1.994s.249-1.063.624-1.196c.374-.133.873-.133 1.497.266.623.398.998.93 1.372 1.595.374.664.499 1.329.499 1.86v.399l-2.994-2.126zm0-.665l2.37 1.462c0-.399-.249-.665-.374-1.063-.25-.266-.499-.532-.749-.665-.374-.133-.623-.266-.748-.266-.25 0-.374.266-.499.532zM357.534 273.448l.874.532v5.848l-.874-.531v-.665c-.374.266-.748.266-1.372-.133-.499-.399-.998-.797-1.372-1.462-.374-.664-.624-1.329-.624-1.994 0-.664.25-1.063.624-1.196s.873-.133 1.372.266c.624.399 1.123.93 1.372 1.595v-2.26zm-2.12 3.456c.249.399.498.665.873.931.374.265.624.265.873.133.25-.133.374-.399.374-.798s-.124-.797-.374-1.196a3.015 3.015 0 00-.873-.931c-.375-.266-.624-.266-.873-.133-.25.133-.375.399-.375.798s.125.797.375 1.196zM360.154 275.974h-.374l-.374-.399c-.125-.133-.125-.399-.125-.532s0-.266.125-.266h.374l.374.399c.125.133.125.399.125.532.125.133 0 .266-.125.266zm-.748 4.652v-4.254l.873.532v4.254l-.873-.532zM363.397 279.695l-.998-.665v1.994c0 .133 0 .266.125.399s.125.266.374.266c.125.133.375.266.499.266v.797c-.623-.266-1.122-.664-1.372-1.063-.249-.399-.374-.798-.374-1.462v-1.994l-.749-.399v-.93l.749.399v-.931l.873.266v1.196l.998.665v1.196h-.125zM368.138 286.075a4.472 4.472 0 01-1.497-1.595c-.374-.665-.623-1.33-.623-1.994 0-.665.249-1.064.623-1.197.375-.132.874-.132 1.497.266.375.266.749.532.998.931.375.398.499.797.749 1.196h-.749c-.124-.266-.249-.532-.374-.665-.125-.265-.374-.398-.624-.531-.374-.266-.623-.266-.873-.133a.74.74 0 00-.374.664c0 .266.125.798.374 1.197.25.398.499.664.873.93.25.133.499.266.624.266.25 0 .374-.133.374-.266l.749.931c-.125.265-.374.398-.749.398-.249-.133-.623-.133-.998-.398zM373.628 285.145l.873.532v4.253l-.873-.532v-.664c-.374.266-.748.266-1.372-.133-.499-.399-.998-.798-1.372-1.462-.375-.665-.624-1.329-.624-1.994s.249-1.063.624-1.196c.374-.133.873-.133 1.372.265.624.399 1.123.931 1.372 1.596v-.665zm-2.245 1.728c.249.399.499.664.873.93s.623.266.873.133c.249-.133.374-.399.374-.797 0-.399-.125-.798-.374-1.197a3.034 3.034 0 00-.873-.93c-.374-.266-.624-.266-.873-.133-.25.133-.375.399-.375.798l.375 1.196zM376.248 287.404c.25-.398.624-.398 1.248 0v.931c-.375-.266-.624-.266-.874-.266-.249 0-.374.266-.374.664v2.127l-.873-.531v-4.121l.873.532v.664zM381.112 288.07l.874.531v5.982l-.874-.532v-.665c-.374.266-.748.266-1.372-.133-.499-.398-.998-.797-1.372-1.462-.374-.664-.624-1.329-.624-1.993 0-.665.25-1.064.624-1.197s.873-.133 1.372.266c.624.399 1.123.931 1.372 1.595v-2.392zm-2.12 3.456c.249.398.499.664.873.93s.624.266.873.133c.25-.133.374-.399.374-.798 0-.398-.124-.797-.374-1.196a3 3 0 00-.873-.93c-.374-.266-.624-.266-.873-.133-.25.133-.375.398-.375.797s.125.798.375 1.197zM383.732 292.456c0 .133.125.266.25.532.124.265.374.398.499.531.249.133.374.399.623.532.25.133.375.399.499.665.125.265.25.531.25.797 0 .399-.125.665-.499.665s-.624 0-1.123-.399c-.374-.266-.748-.532-.998-.93-.249-.399-.499-.665-.624-1.064h.749c.125.532.374.931.873 1.196.499.266.624.266.624 0 0-.132-.125-.265-.25-.398l-.499-.532c-.249-.133-.374-.399-.623-.532-.25-.266-.375-.398-.499-.664-.125-.266-.25-.532-.25-.798 0-.399.125-.664.374-.664.25 0 .624 0 .998.265.375.266.624.399.874.798.249.266.499.665.623 1.063h-.748c-.125-.398-.374-.664-.749-.93-.124-.133-.249-.133-.374-.133 0-.133 0-.266 0 0z"
            fill="#000"
            />
        </g>
        <defs>
            <linearGradient
            id="paint0_linear_874_76773"
            x1={418.282}
            y1={400.134}
            x2={435.566}
            y2={414.92}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint1_linear_874_76773"
            x1={439.165}
            y1={338.363}
            x2={455.645}
            y2={350.91}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint2_linear_874_76773"
            x1={451.389}
            y1={297.527}
            x2={468.064}
            y2={310.223}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint3_linear_874_76773"
            x1={420.693}
            y1={161.226}
            x2={444.485}
            y2={183.556}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint4_linear_874_76773"
            x1={113.152}
            y1={200.271}
            x2={136.944}
            y2={222.601}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint5_linear_874_76773"
            x1={179.675}
            y1={386.512}
            x2={203.467}
            y2={408.841}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint6_linear_874_76773"
            x1={72.5991}
            y1={297.896}
            x2={98.9811}
            y2={297.896}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint7_linear_874_76773"
            x1={74.7425}
            y1={322.932}
            x2={110.586}
            y2={322.932}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint8_linear_874_76773"
            x1={36.3485}
            y1={316.91}
            x2={76.589}
            y2={316.91}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint9_linear_874_76773"
            x1={382.544}
            y1={245.982}
            x2={417.931}
            y2={245.982}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint10_linear_874_76773"
            x1={407.634}
            y1={240.239}
            x2={430.636}
            y2={240.239}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint11_linear_874_76773"
            x1={229.571}
            y1={356.734}
            x2={234.442}
            y2={363.708}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint12_linear_874_76773"
            x1={331.03}
            y1={176.608}
            x2={335.428}
            y2={182.905}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint13_linear_874_76773"
            x1={412.38}
            y1={395.876}
            x2={419.74}
            y2={400.385}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#E2E4E9" stopOpacity={0.8} />
            <stop offset={1} stopColor="#E2E4E9" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint14_linear_874_76773"
            x1={403.091}
            y1={390.938}
            x2={403.091}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint15_linear_874_76773"
            x1={403.439}
            y1={390.937}
            x2={403.439}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint16_linear_874_76773"
            x1={403.875}
            y1={390.936}
            x2={403.875}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint17_linear_874_76773"
            x1={404.018}
            y1={390.926}
            x2={404.018}
            y2={389.535}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint18_linear_874_76773"
            x1={404.343}
            y1={390.935}
            x2={404.343}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint19_linear_874_76773"
            x1={404.746}
            y1={390.927}
            x2={404.746}
            y2={389.536}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint20_linear_874_76773"
            x1={405.152}
            y1={390.936}
            x2={405.152}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint21_linear_874_76773"
            x1={405.554}
            y1={390.939}
            x2={405.554}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint22_linear_874_76773"
            x1={405.957}
            y1={390.937}
            x2={405.957}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint23_linear_874_76773"
            x1={406.363}
            y1={390.936}
            x2={406.363}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint24_linear_874_76773"
            x1={406.767}
            y1={390.933}
            x2={406.767}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint25_linear_874_76773"
            x1={407.173}
            y1={390.94}
            x2={407.173}
            y2={389.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint26_linear_874_76773"
            x1={407.576}
            y1={390.939}
            x2={407.576}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint27_linear_874_76773"
            x1={407.947}
            y1={390.94}
            x2={407.947}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint28_linear_874_76773"
            x1={407.543}
            y1={390.937}
            x2={407.543}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint29_linear_874_76773"
            x1={407.139}
            y1={390.935}
            x2={407.139}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint30_linear_874_76773"
            x1={406.733}
            y1={390.935}
            x2={406.733}
            y2={389.538}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint31_linear_874_76773"
            x1={406.329}
            y1={390.939}
            x2={406.329}
            y2={389.543}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint32_linear_874_76773"
            x1={405.926}
            y1={390.932}
            x2={405.926}
            y2={389.538}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint33_linear_874_76773"
            x1={405.521}
            y1={390.935}
            x2={405.521}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint34_linear_874_76773"
            x1={405.118}
            y1={390.933}
            x2={405.118}
            y2={389.537}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint35_linear_874_76773"
            x1={404.712}
            y1={390.941}
            x2={404.712}
            y2={389.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint36_linear_874_76773"
            x1={404.636}
            y1={390.934}
            x2={404.636}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint37_linear_874_76773"
            x1={404.826}
            y1={390.943}
            x2={404.826}
            y2={389.544}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint38_linear_874_76773"
            x1={405.231}
            y1={390.934}
            x2={405.231}
            y2={389.538}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint39_linear_874_76773"
            x1={405.634}
            y1={390.934}
            x2={405.634}
            y2={389.538}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint40_linear_874_76773"
            x1={406.038}
            y1={390.929}
            x2={406.038}
            y2={389.538}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint41_linear_874_76773"
            x1={406.442}
            y1={390.936}
            x2={406.442}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint42_linear_874_76773"
            x1={406.848}
            y1={390.937}
            x2={406.848}
            y2={389.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint43_linear_874_76773"
            x1={407.25}
            y1={390.938}
            x2={407.25}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint44_linear_874_76773"
            x1={407.466}
            y1={390.937}
            x2={407.466}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint45_linear_874_76773"
            x1={407.062}
            y1={390.936}
            x2={407.062}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint46_linear_874_76773"
            x1={406.658}
            y1={390.937}
            x2={406.658}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint47_linear_874_76773"
            x1={406.252}
            y1={390.938}
            x2={406.252}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint48_linear_874_76773"
            x1={405.85}
            y1={390.934}
            x2={405.85}
            y2={389.538}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint49_linear_874_76773"
            x1={405.445}
            y1={390.938}
            x2={405.445}
            y2={389.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint50_linear_874_76773"
            x1={405.041}
            y1={390.938}
            x2={405.041}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint51_linear_874_76773"
            x1={407.87}
            y1={390.937}
            x2={407.87}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint52_linear_874_76773"
            x1={407.655}
            y1={390.936}
            x2={407.655}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint53_linear_874_76773"
            x1={404.424}
            y1={390.936}
            x2={404.424}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint54_linear_874_76773"
            x1={404.866}
            y1={390.945}
            x2={404.866}
            y2={389.546}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint55_linear_874_76773"
            x1={405.272}
            y1={390.939}
            x2={405.272}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint56_linear_874_76773"
            x1={405.674}
            y1={390.926}
            x2={405.674}
            y2={389.534}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint57_linear_874_76773"
            x1={406.08}
            y1={390.941}
            x2={406.08}
            y2={389.544}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint58_linear_874_76773"
            x1={406.483}
            y1={390.95}
            x2={406.483}
            y2={389.547}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint59_linear_874_76773"
            x1={406.888}
            y1={390.935}
            x2={406.888}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint60_linear_874_76773"
            x1={407.29}
            y1={390.932}
            x2={407.29}
            y2={389.538}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint61_linear_874_76773"
            x1={407.697}
            y1={390.935}
            x2={407.697}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint62_linear_874_76773"
            x1={408.099}
            y1={390.938}
            x2={408.099}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint63_linear_874_76773"
            x1={408.504}
            y1={390.935}
            x2={408.504}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint64_linear_874_76773"
            x1={409.312}
            y1={390.936}
            x2={409.312}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint65_linear_874_76773"
            x1={408.909}
            y1={390.939}
            x2={408.909}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint66_linear_874_76773"
            x1={408.35}
            y1={390.937}
            x2={408.35}
            y2={389.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint67_linear_874_76773"
            x1={408.273}
            y1={390.937}
            x2={408.273}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint68_linear_874_76773"
            x1={408.712}
            y1={390.938}
            x2={408.712}
            y2={389.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint69_linear_874_76773"
            x1={408.23}
            y1={390.938}
            x2={408.23}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint70_linear_874_76773"
            x1={407.98}
            y1={390.937}
            x2={407.98}
            y2={389.537}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint71_linear_874_76773"
            x1={407.735}
            y1={390.937}
            x2={407.735}
            y2={389.544}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint72_linear_874_76773"
            x1={407.36}
            y1={390.936}
            x2={407.36}
            y2={389.543}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint73_linear_874_76773"
            x1={406.955}
            y1={390.938}
            x2={406.955}
            y2={389.544}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint74_linear_874_76773"
            x1={406.552}
            y1={390.937}
            x2={406.552}
            y2={389.54}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint75_linear_874_76773"
            x1={406.148}
            y1={390.936}
            x2={406.148}
            y2={389.538}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint76_linear_874_76773"
            x1={404.934}
            y1={390.938}
            x2={404.934}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint77_linear_874_76773"
            x1={403.722}
            y1={390.938}
            x2={403.722}
            y2={389.541}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint78_linear_874_76773"
            x1={403.315}
            y1={390.941}
            x2={403.315}
            y2={389.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint79_linear_874_76773"
            x1={403.697}
            y1={390.939}
            x2={403.697}
            y2={389.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint80_linear_874_76773"
            x1={403.106}
            y1={390.935}
            x2={403.106}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint81_linear_874_76773"
            x1={402.745}
            y1={390.936}
            x2={402.745}
            y2={389.539}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint82_linear_874_76773"
            x1={407.078}
            y1={388.11}
            x2={399.425}
            y2={389.489}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#CACCED" />
            <stop offset={1} stopColor="#fff" />
            </linearGradient>
            <linearGradient
            id="paint83_linear_874_76773"
            x1={90.9174}
            y1={190.082}
            x2={107.838}
            y2={202.964}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint84_linear_874_76773"
            x1={77.968}
            y1={147.035}
            x2={112.381}
            y2={147.035}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#D6D7DB" />
            <stop offset={1} stopColor="#D4D5D8" />
            </linearGradient>
            <linearGradient
            id="paint85_linear_874_76773"
            x1={77.8723}
            y1={146.71}
            x2={112.173}
            y2={146.71}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#DBDCDF" />
            <stop offset={1} stopColor="#D7D8DB" />
            </linearGradient>
            <linearGradient
            id="paint86_linear_874_76773"
            x1={77.7757}
            y1={146.384}
            x2={111.965}
            y2={146.384}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#E0E1E4" />
            <stop offset={1} stopColor="#DADADD" />
            </linearGradient>
            <linearGradient
            id="paint87_linear_874_76773"
            x1={77.679}
            y1={146.058}
            x2={111.757}
            y2={146.058}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#E5E6E8" />
            <stop offset={1} stopColor="#DDDDDF" />
            </linearGradient>
            <linearGradient
            id="paint88_linear_874_76773"
            x1={77.5834}
            y1={145.73}
            x2={111.549}
            y2={145.73}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#EBEBED" />
            <stop offset={1} stopColor="#DFE0E2" />
            </linearGradient>
            <linearGradient
            id="paint89_linear_874_76773"
            x1={77.4869}
            y1={145.406}
            x2={111.341}
            y2={145.406}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#F0F0F1" />
            <stop offset={1} stopColor="#E2E3E4" />
            </linearGradient>
            <linearGradient
            id="paint90_linear_874_76773"
            x1={77.3921}
            y1={145.079}
            x2={111.134}
            y2={145.079}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#F5F5F6" />
            <stop offset={1} stopColor="#E5E5E6" />
            </linearGradient>
            <linearGradient
            id="paint91_linear_874_76773"
            x1={77.2965}
            y1={144.754}
            x2={110.926}
            y2={144.754}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#FAFAFA" />
            <stop offset={1} stopColor="#E8E8E9" />
            </linearGradient>
            <linearGradient
            id="paint92_linear_874_76773"
            x1={77.2}
            y1={144.427}
            x2={110.718}
            y2={144.427}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#EBEBEB" />
            </linearGradient>
            <linearGradient
            id="paint93_linear_874_76773"
            x1={77.968}
            y1={147.035}
            x2={112.381}
            y2={147.035}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#D6D7DB" />
            <stop offset={1} stopColor="#D4D5D8" />
            </linearGradient>
            <linearGradient
            id="paint94_linear_874_76773"
            x1={77.8723}
            y1={146.71}
            x2={112.173}
            y2={146.71}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#DBDCDF" />
            <stop offset={1} stopColor="#D7D8DB" />
            </linearGradient>
            <linearGradient
            id="paint95_linear_874_76773"
            x1={77.7757}
            y1={146.384}
            x2={111.965}
            y2={146.384}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#E0E1E4" />
            <stop offset={1} stopColor="#DADADD" />
            </linearGradient>
            <linearGradient
            id="paint96_linear_874_76773"
            x1={77.679}
            y1={146.058}
            x2={111.757}
            y2={146.058}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#E5E6E8" />
            <stop offset={1} stopColor="#DDDDDF" />
            </linearGradient>
            <linearGradient
            id="paint97_linear_874_76773"
            x1={77.5834}
            y1={145.73}
            x2={111.549}
            y2={145.73}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#EBEBED" />
            <stop offset={1} stopColor="#DFE0E2" />
            </linearGradient>
            <linearGradient
            id="paint98_linear_874_76773"
            x1={77.4869}
            y1={145.406}
            x2={111.341}
            y2={145.406}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#F0F0F1" />
            <stop offset={1} stopColor="#E2E3E4" />
            </linearGradient>
            <linearGradient
            id="paint99_linear_874_76773"
            x1={77.3921}
            y1={145.079}
            x2={111.134}
            y2={145.079}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#F5F5F6" />
            <stop offset={1} stopColor="#E5E5E6" />
            </linearGradient>
            <linearGradient
            id="paint100_linear_874_76773"
            x1={77.2965}
            y1={144.754}
            x2={110.926}
            y2={144.754}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#FAFAFA" />
            <stop offset={1} stopColor="#E8E8E9" />
            </linearGradient>
            <linearGradient
            id="paint101_linear_874_76773"
            x1={77.2}
            y1={144.427}
            x2={110.718}
            y2={144.427}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#EBEBEB" />
            </linearGradient>
            <linearGradient
            id="paint102_linear_874_76773"
            x1={281.919}
            y1={269.579}
            x2={296.227}
            y2={283.497}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint103_linear_874_76773"
            x1={294.726}
            y1={260.951}
            x2={274.733}
            y2={260.951}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint104_linear_874_76773"
            x1={294.726}
            y1={257.006}
            x2={274.733}
            y2={257.006}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint105_linear_874_76773"
            x1={294.726}
            y1={264.907}
            x2={274.733}
            y2={264.907}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint106_linear_874_76773"
            x1={294.726}
            y1={269.244}
            x2={274.733}
            y2={269.244}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint107_linear_874_76773"
            x1={294.726}
            y1={245.404}
            x2={274.733}
            y2={245.404}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint108_linear_874_76773"
            x1={294.726}
            y1={241.46}
            x2={274.733}
            y2={241.46}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint109_linear_874_76773"
            x1={294.726}
            y1={237.705}
            x2={274.733}
            y2={237.705}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint110_linear_874_76773"
            x1={294.726}
            y1={234.077}
            x2={274.733}
            y2={234.077}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint111_linear_874_76773"
            x1={294.726}
            y1={230.289}
            x2={274.733}
            y2={230.289}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint112_linear_874_76773"
            x1={294.726}
            y1={226.504}
            x2={274.733}
            y2={226.504}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint113_linear_874_76773"
            x1={294.726}
            y1={222.719}
            x2={274.733}
            y2={222.719}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint114_linear_874_76773"
            x1={294.726}
            y1={215.148}
            x2={274.733}
            y2={215.148}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint115_linear_874_76773"
            x1={294.726}
            y1={249.36}
            x2={274.733}
            y2={249.36}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint116_linear_874_76773"
            x1={294.726}
            y1={253.316}
            x2={274.733}
            y2={253.316}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint117_linear_874_76773"
            x1={296.652}
            y1={205.721}
            x2={273.716}
            y2={205.721}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint118_linear_874_76773"
            x1={302.456}
            y1={127.752}
            x2={324.272}
            y2={134.812}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#D6E5FB" />
            <stop offset={1} stopColor="#A2BBFC" />
            </linearGradient>
            <linearGradient
            id="paint119_linear_874_76773"
            x1={311.111}
            y1={137.305}
            x2={327.783}
            y2={142.7}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#D6E5FB" />
            <stop offset={1} stopColor="#A2BBFC" />
            </linearGradient>
            <linearGradient
            id="paint120_linear_874_76773"
            x1={302.652}
            y1={92.4736}
            x2={308.274}
            y2={92.4736}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={8e-8} stopColor="#445DCF" />
            <stop offset={1} stopColor="#6A7FFF" />
            </linearGradient>
            <linearGradient
            id="paint121_linear_874_76773"
            x1={301.589}
            y1={102.494}
            x2={302.606}
            y2={102.494}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#CACCED" />
            <stop offset={1} stopColor="#fff" />
            </linearGradient>
            <linearGradient
            id="paint122_linear_874_76773"
            x1={320.497}
            y1={87.384}
            x2={321.513}
            y2={87.384}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#CACCED" />
            <stop offset={1} stopColor="#fff" />
            </linearGradient>
            <linearGradient
            id="paint123_linear_874_76773"
            x1={302.714}
            y1={74.9127}
            x2={303.731}
            y2={74.9127}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#CACCED" />
            <stop offset={1} stopColor="#fff" />
            </linearGradient>
            <linearGradient
            id="paint124_linear_874_76773"
            x1={283.356}
            y1={88.8244}
            x2={284.373}
            y2={88.8244}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#CACCED" />
            <stop offset={1} stopColor="#fff" />
            </linearGradient>
            <linearGradient
            id="paint125_linear_874_76773"
            x1={434.654}
            y1={285.679}
            x2={460.493}
            y2={285.679}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint126_linear_874_76773"
            x1={434.654}
            y1={284.614}
            x2={460.493}
            y2={284.614}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint127_linear_874_76773"
            x1={434.654}
            y1={283.55}
            x2={460.493}
            y2={283.55}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint128_linear_874_76773"
            x1={434.654}
            y1={282.483}
            x2={460.493}
            y2={282.483}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint129_linear_874_76773"
            x1={434.654}
            y1={281.419}
            x2={460.493}
            y2={281.419}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint130_linear_874_76773"
            x1={434.654}
            y1={280.351}
            x2={460.493}
            y2={280.351}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint131_linear_874_76773"
            x1={434.654}
            y1={279.288}
            x2={460.493}
            y2={279.288}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint132_linear_874_76773"
            x1={434.654}
            y1={278.223}
            x2={460.493}
            y2={278.223}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint133_linear_874_76773"
            x1={423.166}
            y1={291.316}
            x2={449.006}
            y2={291.316}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint134_linear_874_76773"
            x1={423.166}
            y1={290.251}
            x2={449.006}
            y2={290.251}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint135_linear_874_76773"
            x1={423.166}
            y1={289.186}
            x2={449.006}
            y2={289.186}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint136_linear_874_76773"
            x1={423.166}
            y1={288.12}
            x2={449.006}
            y2={288.12}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint137_linear_874_76773"
            x1={420.175}
            y1={302.432}
            x2={446.015}
            y2={302.432}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint138_linear_874_76773"
            x1={420.175}
            y1={301.368}
            x2={446.015}
            y2={301.368}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint139_linear_874_76773"
            x1={420.175}
            y1={300.302}
            x2={446.015}
            y2={300.302}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint140_linear_874_76773"
            x1={420.175}
            y1={299.235}
            x2={446.015}
            y2={299.235}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint141_linear_874_76773"
            x1={420.175}
            y1={298.172}
            x2={446.015}
            y2={298.172}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint142_linear_874_76773"
            x1={420.175}
            y1={297.106}
            x2={446.015}
            y2={297.106}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint143_linear_874_76773"
            x1={420.175}
            y1={296.041}
            x2={446.015}
            y2={296.041}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint144_linear_874_76773"
            x1={420.175}
            y1={294.975}
            x2={446.015}
            y2={294.975}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#6A6AE5" />
            <stop offset={1} stopColor="#322C8D" />
            </linearGradient>
            <linearGradient
            id="paint145_linear_874_76773"
            x1={172.69}
            y1={379.26}
            x2={184.399}
            y2={390.649}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint146_linear_874_76773"
            x1={156.868}
            y1={359.729}
            x2={189.704}
            y2={359.729}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint147_linear_874_76773"
            x1={158.395}
            y1={358.06}
            x2={185.484}
            y2={358.06}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#D5DBEB" />
            </linearGradient>
            <linearGradient
            id="paint148_linear_874_76773"
            x1={141.65}
            y1={343.409}
            x2={172.072}
            y2={343.409}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#D6D7DB" />
            <stop offset={1} stopColor="#D4D5D8" />
            </linearGradient>
            <linearGradient
            id="paint149_linear_874_76773"
            x1={141.564}
            y1={343.119}
            x2={171.888}
            y2={343.119}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#DBDCDF" />
            <stop offset={1} stopColor="#D7D8DB" />
            </linearGradient>
            <linearGradient
            id="paint150_linear_874_76773"
            x1={141.48}
            y1={342.83}
            x2={171.704}
            y2={342.83}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#E0E1E4" />
            <stop offset={1} stopColor="#DADADD" />
            </linearGradient>
            <linearGradient
            id="paint151_linear_874_76773"
            x1={141.396}
            y1={342.542}
            x2={171.522}
            y2={342.542}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#E5E6E8" />
            <stop offset={1} stopColor="#DDDDDF" />
            </linearGradient>
            <linearGradient
            id="paint152_linear_874_76773"
            x1={141.311}
            y1={342.256}
            x2={171.338}
            y2={342.256}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#EBEBED" />
            <stop offset={1} stopColor="#DFE0E2" />
            </linearGradient>
            <linearGradient
            id="paint153_linear_874_76773"
            x1={141.226}
            y1={341.968}
            x2={171.154}
            y2={341.968}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#F0F0F1" />
            <stop offset={1} stopColor="#E2E3E4" />
            </linearGradient>
            <linearGradient
            id="paint154_linear_874_76773"
            x1={141.141}
            y1={341.679}
            x2={170.971}
            y2={341.679}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#F5F5F6" />
            <stop offset={1} stopColor="#E5E5E6" />
            </linearGradient>
            <linearGradient
            id="paint155_linear_874_76773"
            x1={141.056}
            y1={341.389}
            x2={170.787}
            y2={341.389}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#FAFAFA" />
            <stop offset={1} stopColor="#E8E8E9" />
            </linearGradient>
            <linearGradient
            id="paint156_linear_874_76773"
            x1={140.971}
            y1={341.103}
            x2={170.601}
            y2={341.103}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#EBEBEB" />
            </linearGradient>
            <linearGradient
            id="paint157_linear_874_76773"
            x1={398.744}
            y1={175.151}
            x2={398.744}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint158_linear_874_76773"
            x1={399.137}
            y1={175.15}
            x2={399.137}
            y2={173.566}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint159_linear_874_76773"
            x1={399.634}
            y1={175.153}
            x2={399.634}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint160_linear_874_76773"
            x1={399.795}
            y1={175.148}
            x2={399.795}
            y2={173.566}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint161_linear_874_76773"
            x1={400.163}
            y1={175.154}
            x2={400.163}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint162_linear_874_76773"
            x1={400.622}
            y1={175.155}
            x2={400.622}
            y2={173.57}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint163_linear_874_76773"
            x1={401.079}
            y1={175.15}
            x2={401.079}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint164_linear_874_76773"
            x1={401.539}
            y1={175.153}
            x2={401.539}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint165_linear_874_76773"
            x1={401.997}
            y1={175.152}
            x2={401.997}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint166_linear_874_76773"
            x1={402.457}
            y1={175.152}
            x2={402.457}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint167_linear_874_76773"
            x1={402.914}
            y1={175.154}
            x2={402.914}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint168_linear_874_76773"
            x1={403.373}
            y1={175.153}
            x2={403.373}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint169_linear_874_76773"
            x1={403.833}
            y1={175.153}
            x2={403.833}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint170_linear_874_76773"
            x1={404.252}
            y1={175.152}
            x2={404.252}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint171_linear_874_76773"
            x1={403.795}
            y1={175.154}
            x2={403.795}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint172_linear_874_76773"
            x1={403.335}
            y1={175.153}
            x2={403.335}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint173_linear_874_76773"
            x1={402.876}
            y1={175.152}
            x2={402.876}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint174_linear_874_76773"
            x1={402.418}
            y1={175.151}
            x2={402.418}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint175_linear_874_76773"
            x1={401.959}
            y1={175.151}
            x2={401.959}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint176_linear_874_76773"
            x1={401.502}
            y1={175.152}
            x2={401.502}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint177_linear_874_76773"
            x1={401.043}
            y1={175.156}
            x2={401.043}
            y2={173.571}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint178_linear_874_76773"
            x1={400.584}
            y1={175.155}
            x2={400.584}
            y2={173.57}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint179_linear_874_76773"
            x1={400.498}
            y1={175.156}
            x2={400.498}
            y2={173.57}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint180_linear_874_76773"
            x1={400.713}
            y1={175.152}
            x2={400.713}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint181_linear_874_76773"
            x1={401.17}
            y1={175.153}
            x2={401.17}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint182_linear_874_76773"
            x1={401.63}
            y1={175.152}
            x2={401.63}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint183_linear_874_76773"
            x1={402.088}
            y1={175.151}
            x2={402.088}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint184_linear_874_76773"
            x1={402.547}
            y1={175.155}
            x2={402.547}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint185_linear_874_76773"
            x1={403.004}
            y1={175.154}
            x2={403.004}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint186_linear_874_76773"
            x1={403.464}
            y1={175.154}
            x2={403.464}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint187_linear_874_76773"
            x1={403.709}
            y1={175.153}
            x2={403.709}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint188_linear_874_76773"
            x1={403.249}
            y1={175.154}
            x2={403.249}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint189_linear_874_76773"
            x1={402.791}
            y1={175.155}
            x2={402.791}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint190_linear_874_76773"
            x1={402.331}
            y1={175.15}
            x2={402.331}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint191_linear_874_76773"
            x1={401.872}
            y1={175.152}
            x2={401.872}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint192_linear_874_76773"
            x1={401.414}
            y1={175.152}
            x2={401.414}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint193_linear_874_76773"
            x1={400.956}
            y1={175.155}
            x2={400.956}
            y2={173.57}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint194_linear_874_76773"
            x1={404.165}
            y1={175.153}
            x2={404.165}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint195_linear_874_76773"
            x1={403.924}
            y1={175.152}
            x2={403.924}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint196_linear_874_76773"
            x1={400.254}
            y1={175.151}
            x2={400.254}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint197_linear_874_76773"
            x1={400.758}
            y1={175.153}
            x2={400.758}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint198_linear_874_76773"
            x1={401.217}
            y1={175.151}
            x2={401.217}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint199_linear_874_76773"
            x1={401.676}
            y1={175.155}
            x2={401.676}
            y2={173.57}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint200_linear_874_76773"
            x1={402.134}
            y1={175.151}
            x2={402.134}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint201_linear_874_76773"
            x1={402.593}
            y1={175.153}
            x2={402.593}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint202_linear_874_76773"
            x1={403.05}
            y1={175.154}
            x2={403.05}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint203_linear_874_76773"
            x1={403.51}
            y1={175.154}
            x2={403.51}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint204_linear_874_76773"
            x1={403.968}
            y1={175.152}
            x2={403.968}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint205_linear_874_76773"
            x1={404.427}
            y1={175.151}
            x2={404.427}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint206_linear_874_76773"
            x1={404.884}
            y1={175.152}
            x2={404.884}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint207_linear_874_76773"
            x1={405.803}
            y1={175.152}
            x2={405.803}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint208_linear_874_76773"
            x1={405.344}
            y1={175.153}
            x2={405.344}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint209_linear_874_76773"
            x1={404.71}
            y1={175.152}
            x2={404.71}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint210_linear_874_76773"
            x1={404.624}
            y1={175.152}
            x2={404.624}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint211_linear_874_76773"
            x1={405.12}
            y1={175.152}
            x2={405.12}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint212_linear_874_76773"
            x1={404.574}
            y1={175.152}
            x2={404.574}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint213_linear_874_76773"
            x1={404.29}
            y1={175.153}
            x2={404.29}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint214_linear_874_76773"
            x1={404.011}
            y1={175.152}
            x2={404.011}
            y2={173.566}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint215_linear_874_76773"
            x1={403.586}
            y1={175.153}
            x2={403.586}
            y2={173.57}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint216_linear_874_76773"
            x1={403.127}
            y1={175.152}
            x2={403.127}
            y2={173.567}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint217_linear_874_76773"
            x1={402.67}
            y1={175.152}
            x2={402.67}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint218_linear_874_76773"
            x1={402.21}
            y1={175.153}
            x2={402.21}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint219_linear_874_76773"
            x1={400.835}
            y1={175.152}
            x2={400.835}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint220_linear_874_76773"
            x1={399.46}
            y1={175.153}
            x2={399.46}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint221_linear_874_76773"
            x1={398.999}
            y1={175.154}
            x2={398.999}
            y2={173.569}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint222_linear_874_76773"
            x1={399.432}
            y1={175.153}
            x2={399.432}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint223_linear_874_76773"
            x1={398.76}
            y1={175.158}
            x2={398.76}
            y2={173.571}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint224_linear_874_76773"
            x1={398.351}
            y1={175.152}
            x2={398.351}
            y2={173.568}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#003286" />
            <stop offset={1} stopColor="#0085F2" />
            </linearGradient>
            <linearGradient
            id="paint225_linear_874_76773"
            x1={403.266}
            y1={171.946}
            x2={394.586}
            y2={173.511}
            gradientUnits="userSpaceOnUse"
            >
            <stop offset={0.000002} stopColor="#CACCED" />
            <stop offset={1} stopColor="#fff" />
            </linearGradient>
            <linearGradient
            id="paint226_linear_874_76773"
            x1={472.118}
            y1={303.883}
            x2={484.835}
            y2={313.565}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint227_linear_874_76773"
            x1={187.172}
            y1={137.204}
            x2={199.948}
            y2={146.931}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint228_linear_874_76773"
            x1={332.043}
            y1={381.557}
            x2={350.666}
            y2={397.488}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint229_linear_874_76773"
            x1={323.194}
            y1={367.395}
            x2={344.001}
            y2={337.32}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#CBCDD1" />
            <stop offset={1} stopColor="#AFAFB5" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint230_linear_874_76773"
            x1={343.514}
            y1={385.331}
            x2={361.702}
            y2={359.054}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#CBCDD1" />
            <stop offset={1} stopColor="#AFAFB5" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint231_linear_874_76773"
            x1={440.098}
            y1={141.502}
            x2={415.435}
            y2={103.78}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint232_linear_874_76773"
            x1={461.982}
            y1={140.774}
            x2={444.173}
            y2={113.537}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint233_linear_874_76773"
            x1={35.8819}
            y1={227.605}
            x2={51.3292}
            y2={239.824}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint234_linear_874_76773"
            x1={101.565}
            y1={402.616}
            x2={117.013}
            y2={414.836}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <linearGradient
            id="paint235_linear_874_76773"
            x1={180.643}
            y1={273.389}
            x2={197.349}
            y2={287.68}
            gradientUnits="userSpaceOnUse"
            >
            <stop stopColor="#3D3D3D" />
            <stop offset={1} stopColor="#696969" stopOpacity={0} />
            </linearGradient>
            <clipPath id="clip0_874_76773">
            <path fill="#fff" d="M0 0H499V452H0z" />
            </clipPath>
            <clipPath id="clip1_874_76773">
            <path
                fill="#fff"
                transform="translate(288.148 325.787)"
                d="M0 0H97.121V81.7024H0z"
            />
            </clipPath>
        </defs>
        </svg>
    )
}

export default SvgComponent
